webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cache_helper = exports.helpers = exports.api_endpoints = undefined;

var _api = __webpack_require__(135);

var _api2 = _interopRequireDefault(_api);

var _helpers = __webpack_require__(42);

var _helpers2 = _interopRequireDefault(_helpers);

var _cache_helper = __webpack_require__(551);

var _cache_helper2 = _interopRequireDefault(_cache_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.api_endpoints = _api2.default;
exports.helpers = _helpers2.default;
exports.cache_helper = _cache_helper2.default;

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(656)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(946),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(921),
  /* scopeId */
  "data-v-105a12c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(922),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(646)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(930),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(696)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(692)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(992),
  /* scopeId */
  "data-v-620e0e8d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(670)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(966),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _api = __webpack_require__(138);

var _api2 = _interopRequireDefault(_api);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    fetchCurrentUser: function fetchCurrentUser() {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_api2.default.my_user_details).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchApplication: function fetchApplication(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_api2.default.applications, id)).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchCountries: function fetchCountries() {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_api2.default.countries).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchOrganisations: function fetchOrganisations(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_api2.default.organisations).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchOrganisationPermissions: function fetchOrganisationPermissions(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_api2.default.my_organisations, id)).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchLicenceClasses: function fetchLicenceClasses() {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_api2.default.licences_class).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchLicenceAvailablePurposes: function fetchLicenceAvailablePurposes(params) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_api2.default.licence_available_purposes, { "params": params }).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchOrganisation: function fetchOrganisation(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_api2.default.organisations, id)).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchCurrentActiveLicenceApplication: function fetchCurrentActiveLicenceApplication(params) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_api2.default.applications + 'active_licence_application', { "params": params }).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    }
};

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(925),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(1063),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _api = __webpack_require__(103);

var _api2 = _interopRequireDefault(_api);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    fetchApplication: function fetchApplication(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_api2.default.applications, id)).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchOrganisations: function fetchOrganisations(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_api2.default.organisations).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchOrganisation: function fetchOrganisation(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_api2.default.organisations, id)).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchOrganisationPermissions: function fetchOrganisationPermissions(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_api2.default.my_organisations, id)).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchOrgRequestPending: function fetchOrgRequestPending(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_hooks.helpers.add_endpoint_join(_api2.default.users, id + '/pending_org_requests')).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchProfile: function fetchProfile(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_api2.default.profiles, id)).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchUsers: function fetchUsers(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_api2.default.users).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchUser: function fetchUser(id) {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_api2.default.users, id)).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchCurrentUser: function fetchCurrentUser() {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_api2.default.my_user_details).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    },
    fetchCountries: function fetchCountries() {
        return new _promise2.default(function (resolve, reject) {
            _vue2.default.http.get(_api2.default.countries).then(function (response) {
                resolve(response.body);
            }, function (error) {
                reject(error);
            });
        });
    }
};

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $) {

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = __webpack_require__(86);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    formatError: function formatError(err) {
        var returnStr = '';

        if ((0, _typeof3.default)(err.body) === 'object' && !err.body.hasOwnProperty('length')) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(err.body)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    returnStr += key + ': ' + err.body[key] + ' <br/>';
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else if ((0, _typeof3.default)(err.body) === 'object') {
            returnStr = err.body[0];
        } else {
            returnStr = err.body;
        }
        return returnStr;
    },

    getPreferredDashboard: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var preference, res, body;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            preference = null;
                            _context.next = 3;
                            return fetch('/api/system_preference/');

                        case 3:
                            res = _context.sent;
                            _context.next = 6;
                            return res.json();

                        case 6:
                            body = _context.sent;

                            if (body && body.system === 'compliance_management') {
                                preference = 'compliance_management';
                            } else {
                                preference = 'wildlife_licensing';
                            }
                            return _context.abrupt('return', preference);

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function getPreferredDashboard() {
            return _ref.apply(this, arguments);
        }

        return getPreferredDashboard;
    }(),
    apiError: function apiError(resp) {
        var error_str = '';
        if (resp.status === 400) {
            try {
                obj = JSON.parse(resp.responseText);
                error_str = obj.non_field_errors[0].replace(/[\[\]"]/g, '');
            } catch (e) {
                error_str = resp.responseText.replace(/[\[\]"]/g, '');
            }
        } else if (resp.status === 404) {
            error_str = 'The resource you are looking for does not exist.';
        } else {
            error_str = resp.responseText.replace(/[\[\]"]/g, '');
        }
        return error_str;
    },
    apiVueResourceError: function apiVueResourceError(resp) {
        var error_str = '';
        var text = null;
        if (resp.status === 400) {
            if (Array.isArray(resp.body)) {
                text = resp.body[0];
            } else if ((0, _typeof3.default)(resp.body) == 'object') {
                text = resp.body;
            } else {
                text = resp.body;
            }

            if ((typeof text === 'undefined' ? 'undefined' : (0, _typeof3.default)(text)) == 'object') {
                if (text.hasOwnProperty('non_field_errors')) {
                    error_str = text.non_field_errors[0].replace(/[\[\]"]/g, '');
                } else {
                    for (var key in text) {
                        var element = text[key];
                        if (Array.isArray(element)) {
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = (0, _getIterator3.default)(element), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var message = _step2.value;

                                    error_str = message;
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        } else {
                            error_str = element;
                        }
                    }
                }
            } else {
                error_str = text.replace(/[\[\]"]/g, '');
                error_str = text.replace(/^['"](.*)['"]$/, '$1');
            }
        } else if (resp.status === 404) {
            error_str = 'The resource you are looking for does not exist.';
        }
        return error_str;
    },

    goBack: function goBack(vm) {
        vm.$router.go(window.history.back());
    },
    copyObject: function copyObject(obj) {
        return JSON.parse((0, _stringify2.default)(obj));
    },
    getCookie: function getCookie(name) {
        var value = null;
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1).trim() === name + '=') {
                    value = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return value;
    },
    namePopover: function namePopover($, vmDataTable) {
        vmDataTable.on('mouseover', '.name_popover', function (e) {
            $(this).popover('show');
            $(this).on('mouseout', function () {
                $(this).popover('hide');
            });
        });
    },
    add_endpoint_join: function add_endpoint_join(api_string, addition) {
        return api_string + addition;
    },
    add_endpoint_json: function add_endpoint_json(api_string, addition) {
        var res = api_string.split(".json");
        return res[0] + addition + '.json';
    },
    dtPopover: function dtPopover(value) {
        var truncate_length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
        var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'hover';

        var ellipsis = '...',
            truncated = _.truncate(value, {
            length: truncate_length,
            omission: ellipsis,
            separator: ' '
        }),
            result = '<span>' + truncated + '</span>',
            popTemplate = _.template('<a href="#" ' + 'role="button" ' + 'data-toggle="popover" ' + 'data-trigger="' + trigger + '" ' + 'data-placement="top auto"' + 'data-html="true" ' + 'data-content="<%= text %>" ' + '>more</a>');
        if (_.endsWith(truncated, ellipsis)) {
            result += popTemplate({
                text: value
            });
        }
        return result;
    },
    dtPopoverCellFn: function dtPopoverCellFn(cell) {
        $(cell).find('[data-toggle="popover"]').popover().on('click', function (e) {
            e.preventDefault();
            return true;
        });
    },
    strToBool: function strToBool(val) {
        return ('' + val).toLowerCase() === 'true';
    },

    splitText: function splitText(aText) {
        var newText = '';
        newText = aText.split("\n");
        return newText;
    },
    datatableExactStringMatch: function datatableExactStringMatch(inputString) {
        var regexSearch = '^' + inputString.replace(/\(/g, '\\(').replace(/\)/g, '\\)') + '$';
        return regexSearch;
    },
    guid: function guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(2)))

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(650)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(940),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(86);

var _typeof3 = _interopRequireDefault(_typeof2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ResponsiveDatatablesHelper(tableSelector, breakpoints, options) {
    if (typeof tableSelector === 'string') {
        this.tableElement = (0, _jquery2.default)(tableSelector);
    } else {
        this.tableElement = tableSelector;
    }

    this.api = this.tableElement.dataTable().api();

    this.columnIndexes = [];
    this.columnsShownIndexes = [];
    this.columnsHiddenIndexes = [];
    this.currentBreakpoint = '';
    this.lastBreakpoint = '';
    this.lastColumnsHiddenIndexes = [];

    var fileName = window.location.pathname.split("/").pop();
    var context = this.api.settings().context[0];

    this.tableId = context.sTableId;
    this.saveState = context.oInit.bStateSave;
    this.cookieName = 'DataTablesResponsiveHelper_' + this.tableId + (fileName ? '_' + fileName : '');
    this.lastStateExists = false;

    this.expandColumn = undefined;

    this.origBreakpointsDefs = undefined;

    this.breakpoints = {};

    this.options = {
        hideEmptyColumnsInRowDetail: false,
        clickOn: 'icon',
        showDetail: null,
        hideDetail: null
    };

    this.expandIconTemplate = '<span class="responsiveExpander"></span>';

    this.rowTemplate = '<tr class="row-detail"><td><ul><!--column item--></ul></td></tr>';
    this.rowLiTemplate = '<li><span class="columnTitle"><!--column title--></span>: <span class="columnValue"><!--column value--></span></li>';

    this.disabled = true;

    this.skipNextWindowsWidthChange = false;

    this.init(breakpoints, options);
}

ResponsiveDatatablesHelper.prototype.init = function (breakpoints, options) {
    this.origBreakpointsDefs = breakpoints;
    this.initBreakpoints();

    this.disable(false);

    _jquery2.default.extend(this.options, options);
};

ResponsiveDatatablesHelper.prototype.initBreakpoints = function () {
    if (this.saveState) {
        this.getState();
    }

    if (!this.lastStateExists) {
        var breakpointsSorted = [];

        for (var prop in this.origBreakpointsDefs) {
            breakpointsSorted.push({
                name: prop,
                upperLimit: this.origBreakpointsDefs[prop],
                columnsToHide: []
            });
        }

        breakpointsSorted.sort(function (a, b) {
            return a.upperLimit - b.upperLimit;
        });

        var lowerLimit = 0;
        for (var i = 0; i < breakpointsSorted.length; i++) {
            breakpointsSorted[i].lowerLimit = lowerLimit;
            lowerLimit = breakpointsSorted[i].upperLimit;
        }

        breakpointsSorted.push({
            name: 'always',
            lowerLimit: lowerLimit,
            upperLimit: Infinity,
            columnsToHide: []
        });

        this.breakpoints = {};
        var i, l;
        for (i = 0, l = breakpointsSorted.length; i < l; i++) {
            this.breakpoints[breakpointsSorted[i].name] = breakpointsSorted[i];
        }

        var columns = this.api.columns().header();
        var visibleColumnsHeadersTds = [];
        for (i = 0, l = columns.length; i < l; i++) {
            if (this.api.column(i).visible()) {
                this.columnIndexes.push(i);
                visibleColumnsHeadersTds.push(columns[i]);
            }
        }

        for (var index = 0; index < visibleColumnsHeadersTds.length; index++) {
            var col = (0, _jquery2.default)(visibleColumnsHeadersTds[index]);

            if (col.attr('data-class') === 'expand') {
                this.expandColumn = this.columnIndexes[index];
            }

            var dataHide = col.attr('data-hide');
            if (dataHide !== undefined) {
                var splitBreakingPoints = dataHide.split(/,\s*/);
                for (var i = 0; i < splitBreakingPoints.length; i++) {
                    var bp = splitBreakingPoints[i];
                    if (bp === 'always') {
                        for (var prop in this.breakpoints) {
                            if (this.breakpoints[prop].name !== 'default') {
                                this.breakpoints[prop].columnsToHide.push(this.columnIndexes[index]);
                            }
                        }
                    } else if (this.breakpoints[bp] !== undefined) {
                        this.breakpoints[bp].columnsToHide.push(this.columnIndexes[index]);
                    }
                }
            }
        }
    }
};

ResponsiveDatatablesHelper.prototype.setWindowsResizeHandler = function (bindFlag) {
    if (bindFlag === undefined) {
        bindFlag = true;
    }

    if (bindFlag) {
        var that = this;
        (0, _jquery2.default)(window).bind("resize", function () {
            that.respond();
        });
    } else {
        (0, _jquery2.default)(window).unbind("resize");
    }
};

ResponsiveDatatablesHelper.prototype.respond = function () {
    if (this.disabled) {
        return;
    }
    var that = this;

    var newWindowWidth = (0, _jquery2.default)(window).width();

    var newColumnsToHide = [];

    for (var prop in this.breakpoints) {
        var element = this.breakpoints[prop];
        if ((!element.lowerLimit || newWindowWidth > element.lowerLimit) && (!element.upperLimit || newWindowWidth <= element.upperLimit)) {
            this.currentBreakpoint = element.name;
            newColumnsToHide = element.columnsToHide;
        }
    }

    var columnShowHide = false;
    if (!this.skipNextWindowsWidthChange) {
        if (this.lastBreakpoint.length === 0 && newColumnsToHide.length) {
            columnShowHide = true;
        } else if (this.lastBreakpoint != this.currentBreakpoint) {
            columnShowHide = true;
        } else if (this.columnsHiddenIndexes.length !== newColumnsToHide.length) {
            columnShowHide = true;
        } else {
            var d1 = this.difference(this.columnsHiddenIndexes, newColumnsToHide).length;
            var d2 = this.difference(newColumnsToHide, this.columnsHiddenIndexes).length;
            columnShowHide = d1 + d2 > 0;
        }
    }

    if (columnShowHide) {
        this.skipNextWindowsWidthChange = true;
        this.columnsHiddenIndexes = newColumnsToHide;
        this.columnsShownIndexes = this.difference(this.columnIndexes, this.columnsHiddenIndexes);
        this.showHideColumns();
        this.lastBreakpoint = this.currentBreakpoint;
        this.setState();
        this.skipNextWindowsWidthChange = false;
    }

    if (this.columnsHiddenIndexes.length) {
        this.tableElement.addClass('has-columns-hidden');

        (0, _jquery2.default)('tr.detail-show', this.tableElement).each(function (index, element) {
            var tr = (0, _jquery2.default)(element);
            if (tr.next('.row-detail').length === 0) {
                ResponsiveDatatablesHelper.prototype.showRowDetail(that, tr);
            }
        });
    } else {
        this.tableElement.removeClass('has-columns-hidden');
        (0, _jquery2.default)('tr.row-detail', this.tableElement).each(function (event) {
            ResponsiveDatatablesHelper.prototype.hideRowDetail(that, (0, _jquery2.default)(this).prev());
        });
    }
};

ResponsiveDatatablesHelper.prototype.showHideColumns = function () {
    for (var i = 0, l = this.columnsShownIndexes.length; i < l; i++) {
        this.api.column(this.columnsShownIndexes[i]).visible(true);
    }

    for (var i = 0, l = this.columnsHiddenIndexes.length; i < l; i++) {
        this.api.column(this.columnsHiddenIndexes[i]).visible(false);
    }

    var that = this;
    (0, _jquery2.default)('tr.row-detail', this.tableElement).each(function () {
        ResponsiveDatatablesHelper.prototype.hideRowDetail(that, (0, _jquery2.default)(this).prev());
    });
    if (this.tableElement.hasClass('has-columns-hidden')) {
        (0, _jquery2.default)('tr.detail-show', this.tableElement).each(function (index, element) {
            ResponsiveDatatablesHelper.prototype.showRowDetail(that, (0, _jquery2.default)(element));
        });
    }
};

ResponsiveDatatablesHelper.prototype.createExpandIcon = function (tr) {
    if (this.disabled) {
        return;
    }

    var tds = (0, _jquery2.default)('td', tr);

    for (var i = 0, l = tds.length; i < l; i++) {
        var td = tds[i];
        var tdIndex = this.api.cell(td).index().column;
        td = (0, _jquery2.default)(td);
        if (tdIndex === this.expandColumn) {
            if ((0, _jquery2.default)('span.responsiveExpander', td).length == 0) {
                td.prepend(this.expandIconTemplate);

                switch (this.options.clickOn) {
                    case 'cell':
                        td.on('click', { responsiveDatatablesHelperInstance: this }, this.showRowDetailEventHandler);
                        break;
                    case 'row':
                        (0, _jquery2.default)(tr).on('click', { responsiveDatatablesHelperInstance: this }, this.showRowDetailEventHandler);
                        break;
                    default:
                        td.on('click', 'span.responsiveExpander', { responsiveDatatablesHelperInstance: this }, this.showRowDetailEventHandler);
                        break;
                }
            }
            break;
        }
    }
};

ResponsiveDatatablesHelper.prototype.showRowDetailEventHandler = function (event) {
    var responsiveDatatablesHelperInstance = event.data.responsiveDatatablesHelperInstance;
    if (responsiveDatatablesHelperInstance.disabled) {
        return;
    }

    var td = (0, _jquery2.default)(this);

    if (!td.closest('table').hasClass('has-columns-hidden')) {
        return;
    }

    var tr = td.closest('tr');

    if (tr.hasClass('detail-show')) {
        ResponsiveDatatablesHelper.prototype.hideRowDetail(responsiveDatatablesHelperInstance, tr);
    } else {
        ResponsiveDatatablesHelper.prototype.showRowDetail(responsiveDatatablesHelperInstance, tr);
    }

    tr.toggleClass('detail-show');

    event.stopPropagation();
};

ResponsiveDatatablesHelper.prototype.showRowDetail = function (responsiveDatatablesHelperInstance, tr) {
    var api = responsiveDatatablesHelperInstance.api;
    var columns = api.columns().header();

    var newTr = (0, _jquery2.default)(responsiveDatatablesHelperInstance.rowTemplate);

    var ul = (0, _jquery2.default)('ul', newTr);

    for (var i = 0; i < responsiveDatatablesHelperInstance.columnsHiddenIndexes.length; i++) {
        var index = responsiveDatatablesHelperInstance.columnsHiddenIndexes[i];

        var rowIndex = api.row(tr).index();
        var td = api.cell(rowIndex, index).node();

        if (!responsiveDatatablesHelperInstance.options.hideEmptyColumnsInRowDetail || td.innerHTML.trim().length) {
            var li = (0, _jquery2.default)(responsiveDatatablesHelperInstance.rowLiTemplate);
            var hiddenColumnName = (0, _jquery2.default)(columns[index]).attr('data-name');

            hiddenColumnName = hiddenColumnName !== undefined ? hiddenColumnName : columns[index].innerHTML;
            (0, _jquery2.default)('.columnTitle', li).html(hiddenColumnName);

            var contents = (0, _jquery2.default)(td).contents();
            var clonedContents = contents.clone();

            for (var n = 0, m = contents.length; n < m; n++) {
                var node = contents[n];
                if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SELECT') {
                    clonedContents[n].selectedIndex = node.selectedIndex;
                }
            }

            (0, _jquery2.default)('.columnValue', li).append(clonedContents).data('originalTdSource', td);

            li.attr('data-column', index);

            var tdClass = (0, _jquery2.default)(td).attr('class');
            if (tdClass !== 'undefined' && tdClass !== false && tdClass !== '') {
                li.addClass(tdClass);
            }

            ul.append(li);
        }
    }

    var colspan = responsiveDatatablesHelperInstance.columnIndexes.length - responsiveDatatablesHelperInstance.columnsHiddenIndexes.length;
    newTr.find('> td').attr('colspan', colspan);

    tr.after(newTr);

    if (responsiveDatatablesHelperInstance.options.showDetail) {
        responsiveDatatablesHelperInstance.options.showDetail(newTr);
    }
};

ResponsiveDatatablesHelper.prototype.hideRowDetail = function (responsiveDatatablesHelperInstance, tr) {
    var rowDetail = tr.next('.row-detail');
    if (responsiveDatatablesHelperInstance.options.hideDetail) {
        responsiveDatatablesHelperInstance.options.hideDetail(rowDetail);
    }
    rowDetail.find('li').each(function () {
        var columnValueContainer = (0, _jquery2.default)(this).find('span.columnValue');
        var tdContents = columnValueContainer.contents();
        var td = columnValueContainer.data('originalTdSource');
        (0, _jquery2.default)(td).empty().append(tdContents);
    });
    rowDetail.remove();
};

ResponsiveDatatablesHelper.prototype.disable = function (disable) {
    this.disabled = disable === undefined || disable;

    if (this.disabled) {
        this.setWindowsResizeHandler(false);

        (0, _jquery2.default)('tbody tr.row-detail', this.tableElement).remove();

        (0, _jquery2.default)('tbody tr', this.tableElement).removeClass('detail-show');

        (0, _jquery2.default)('tbody tr span.responsiveExpander', this.tableElement).remove();

        this.columnsHiddenIndexes = [];
        this.columnsShownIndexes = this.columnIndexes;
        this.showHideColumns();
        this.tableElement.removeClass('has-columns-hidden');

        this.tableElement.off('click', 'span.responsiveExpander', this.showRowDetailEventHandler);
    } else {
        this.setWindowsResizeHandler();
    }
};

ResponsiveDatatablesHelper.prototype.getState = function () {
    if (typeof Storage === 'undefined' ? 'undefined' : (0, _typeof3.default)(Storage)) {
        var value = JSON.parse(localStorage.getItem(this.cookieName));
        if (value) {
            this.columnIndexes = value.columnIndexes;
            this.breakpoints = value.breakpoints;
            this.expandColumn = value.expandColumn;
            this.lastBreakpoint = value.lastBreakpoint;
            this.lastStateExists = true;
        }
    } else {}
};

ResponsiveDatatablesHelper.prototype.setState = function () {
    if (typeof Storage === 'undefined' ? 'undefined' : (0, _typeof3.default)(Storage)) {
        var d1 = this.difference(this.lastColumnsHiddenIndexes, this.columnsHiddenIndexes).length;
        var d2 = this.difference(this.columnsHiddenIndexes, this.lastColumnsHiddenIndexes).length;

        if (d1 + d2 > 0) {
            var tt;
            var value = {
                columnIndexes: this.columnIndexes,
                columnsHiddenIndexes: this.columnsHiddenIndexes,
                breakpoints: this.breakpoints,
                expandColumn: this.expandColumn,
                lastBreakpoint: this.lastBreakpoint };

            localStorage.setItem(this.cookieName, (0, _stringify2.default)(value));
            this.lastColumnsHiddenIndexes = this.columnsHiddenIndexes.slice(0);
        }
    } else {}
};

ResponsiveDatatablesHelper.prototype.difference = function (a, b) {
    var arr = [],
        i,
        hash = {};
    for (i = b.length - 1; i >= 0; i--) {
        hash[b[i]] = true;
    }
    for (i = a.length - 1; i >= 0; i--) {
        if (hash[a[i]] !== true) {
            arr.push(a[i]);
        }
    }
    return arr;
};

module.exports = ResponsiveDatatablesHelper;

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(701)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(625);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(68)("0afee115", content, true);

/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE_APPLICATION = exports.UPDATE_APPLICATION = 'UPDATE_APPLICATION';
var UPDATE_ORIGINAL_APPLICATION = exports.UPDATE_ORIGINAL_APPLICATION = 'UPDATE_ORIGINAL_APPLICATION';
var UPDATE_APPLICATION_ATTRIBUTE = exports.UPDATE_APPLICATION_ATTRIBUTE = 'UPDATE_APPLICATION_ATTRIBUTE';
var UPDATE_APPLICATION_WORKFLOW_STATE = exports.UPDATE_APPLICATION_WORKFLOW_STATE = 'UPDATE_APPLICATION_WORKFLOW_STATE';
var UPDATE_APPLICATION_CHECK_STATUS_ID = exports.UPDATE_APPLICATION_CHECK_STATUS_ID = 'UPDATE_APPLICATION_CHECK_STATUS_ID';
var UPDATE_APPLICATION_CHECK_STATUS_CHARACTER = exports.UPDATE_APPLICATION_CHECK_STATUS_CHARACTER = 'UPDATE_APPLICATION_CHECK_STATUS_CHARACTER';
var UPDATE_APPLICATION_CHECK_STATUS_RETURN = exports.UPDATE_APPLICATION_CHECK_STATUS_RETURN = 'UPDATE_APPLICATION_CHECK_STATUS_RETURN';
var UPDATE_APPLICATION_FEE_STATUS = exports.UPDATE_APPLICATION_FEE_STATUS = 'UPDATE_APPLICATION_FEE_STATUS';
var UPDATE_APPLICATION_ASSESS_STATUS = exports.UPDATE_APPLICATION_ASSESS_STATUS = 'UPDATE_APPLICATION_ASSESS_STATUS';
var UPDATE_ORG_APPLICANT = exports.UPDATE_ORG_APPLICANT = 'UPDATE_ORG_APPLICANT';
var UPDATE_PROXY_APPLICANT = exports.UPDATE_PROXY_APPLICANT = 'UPDATE_PROXY_APPLICANT';
var UPDATE_SELECTED_TAB_ID = exports.UPDATE_SELECTED_TAB_ID = 'UPDATE_SELECTED_TAB_ID';
var UPDATE_SELECTED_TAB_NAME = exports.UPDATE_SELECTED_TAB_NAME = 'UPDATE_SELECTED_TAB_NAME';
var UPDATE_SELECTED_TAB_WORKFLOW_STATE = exports.UPDATE_SELECTED_TAB_WORKFLOW_STATE = 'UPDATE_SELECTED_TAB_WORKFLOW_STATE';
var UPDATE_SELECTED_APPLY_ORG_ID = exports.UPDATE_SELECTED_APPLY_ORG_ID = 'UPDATE_SELECTED_APPLY_ORG_ID';
var UPDATE_SELECTED_APPLY_PROXY_ID = exports.UPDATE_SELECTED_APPLY_PROXY_ID = 'UPDATE_SELECTED_APPLY_PROXY_ID';
var UPDATE_SELECTED_APPLY_LICENCE_SELECT = exports.UPDATE_SELECTED_APPLY_LICENCE_SELECT = 'UPDATE_SELECTED_APPLY_LICENCE_SELECT';
var UPDATE_RECEPTION_METHOD_ID = exports.UPDATE_RECEPTION_METHOD_ID = 'UPDATE_RECEPTION_METHOD_ID';
var UPDATE_RENDERER_TABS = exports.UPDATE_RENDERER_TABS = 'UPDATE_RENDERER_TABS';
var UPDATE_RENDERER_SECTIONS = exports.UPDATE_RENDERER_SECTIONS = 'UPDATE_RENDERER_SECTIONS';
var UPDATE_RETURNS = exports.UPDATE_RETURNS = 'UPDATE_RETURNS';
var UPDATE_RETURNS_ESTIMATE = exports.UPDATE_RETURNS_ESTIMATE = 'UPDATE_RETURNS_ESTIMATE';
var UPDATE_RETURNS_EXTERNAL = exports.UPDATE_RETURNS_EXTERNAL = 'UPDATE_RETURNS_EXTERNAL';
var UPDATE_RETURNS_SELECTED_SPECIES = exports.UPDATE_RETURNS_SELECTED_SPECIES = 'UPDATE_RETURNS_SELECTED_SPECIES';
var UPDATE_RETURNS_SPECIES = exports.UPDATE_RETURNS_SPECIES = 'UPDATE_RETURNS_SPECIES';
var UPDATE_RETURNS_TABS = exports.UPDATE_RETURNS_TABS = 'UPDATE_RETURNS_TABS';
var UPDATE_RETURNS_TRANSFER_SPECIES = exports.UPDATE_RETURNS_TRANSFER_SPECIES = 'UPDATE_RETURNS_TRANSFER_SPECIES';
var UPDATE_VISIBLE_COMPONENT = exports.UPDATE_VISIBLE_COMPONENT = 'UPDATE_VISIBLE_COMPONENT';
var UPDATE_CURRENT_USER = exports.UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER';
var UPDATE_CURRENT_USER_ID = exports.UPDATE_CURRENT_USER_ID = 'UPDATE_CURRENT_USER_ID';
var TOGGLE_FINALISED_TABS = exports.TOGGLE_FINALISED_TABS = 'TOGGLE_FINALISED_TABS';
var UPDATE_FORM_DATA = exports.UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
var UPDATE_FORM_FIELD = exports.UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
var REMOVE_FORM_FIELD = exports.REMOVE_FORM_FIELD = 'REMOVE_FORM_FIELD';

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(693)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(993),
  /* scopeId */
  "data-v-62516f7e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(730)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1048),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(643)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(927),
  /* scopeId */
  "data-v-17ccd146",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(688)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(987),
  /* scopeId */
  "data-v-5d3ab202",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(912),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(708)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  "data-v-7592c40f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(742)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1065),
  /* scopeId */
  "data-v-f4a254ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    organisations: '/api/organisations/',
    my_organisations: '/api/my_organisations/',
    users: '/api/users/',

    countries: '/api/countries',
    my_user_details: '/api/my_user_details/',
    profiles: '/api/profiles/',
    application_assessment: '/api/assessment/'
};

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(711)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(689)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(988),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(968),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(933),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */,
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ans": 351,
	"./ans.json": 351,
	"./data": 352,
	"./data.json": 352,
	"./img/map_icon.png": 56,
	"./img/satellite_icon.jpg": 57,
	"./img/satellite_icon.png": 795,
	"./img/shibaken.jpg": 311,
	"./logo.png": 796,
	"./marker-blue-locked.svg": 797,
	"./marker-gray-locked.svg": 93,
	"./marker-green-locked.svg": 312,
	"./marker-green-unlocked.svg": 798,
	"./marker-orange-locked.svg": 799,
	"./marker-red-locked.svg": 313,
	"./marker-yellow-locked.svg": 314,
	"./marker_shadow.png": 800
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var site_url = location.origin;

module.exports = {
    person_org_lookup: '/api/person_org_lookup',
    allocated_group_members: '/api/allocated_group_members',
    staff_member_lookup: '/api/staff_member_lookup',
    organisations: '/api/organisations/',
    organisations_paginated: '/api/organisations_paginated/',
    organisation_requests: '/api/organisation_requests/',
    organisation_requests_paginated: '/api/organisation_requests_paginated/',
    organisation_contacts: '/api/organisation_contacts/',
    organisation_access_group_members: '/api/organisation_access_group_members/',
    users: '/api/users/',
    users_paginated: '/api/users_paginated/',
    my_user_details: '/api/my_user_details/',
    assessor_group: '/api/assessor_group/',
    emailidentities: '/api/emailidentities/',
    profiles: '/api/profiles/',
    my_profiles: '/api/my_profiles/',
    assessment: '/api/assessment/',
    assessment_paginated: '/api/assessment_paginated/',
    amendment: '/api/amendment/',
    is_new_user: '/api/is_new_user/',
    user_profile_completed: '/api/user_profile_completed/',

    countries: '/api/countries',
    is_compliance_management_callemail_readonly_user: '/api/is_compliance_management_callemail_readonly_user',
    application_type: "/api/application_type/",
    applications: "/api/application/",
    application_selected_activity: "/api/application_selected_activity/",
    applications_paginated: "/api/application_paginated/",
    licences: "/api/licences/",
    licences_paginated: "/api/licences_paginated/",
    returns: "/api/returns/",
    returns_paginated: "/api/returns_paginated/",
    application_standard_conditions: "/api/application_standard_conditions/",
    return_types: "/api/return_types/",
    application_conditions: "/api/application_conditions/",
    discard_application: function discard_application(id) {
        return '/api/application/' + id + '/';
    },
    site_url: site_url,
    system_name: 'Wildlife Licensing System',
    call_email: "/api/call_email/",
    offence: "/api/offence/",
    sanction_outcome: "/api/sanction_outcome/",
    sanction_outcome_paginated: "/api/sanction_outcome_paginated/",
    remediation_action: "/api/remediation_action/",
    classification: "/api/classification/",
    lov_collection: "/api/lov_collection/",

    report_types: "/api/report_types/",
    referrers: "/api/referrers/",
    location: "/api/location/",
    compliancepermissiongroup: '/api/compliancepermissiongroup/',

    regions: '/api/regions/',
    districts: '/api/districts/',
    case_priorities: '/api/case_priorities/',
    inspection_types: '/api/inspection_types/',
    call_email_paginated: '/api/call_email_paginated/',
    inspection: '/api/inspection/',
    temporary_document: '/api/temporary_document/',
    compliance_management_users: '/api/compliance_management_users/',
    legal_case: '/api/legal_case/',
    legal_case_priorities: '/api/legal_case_priorities/',

    document_artifact_types: '/api/document_artifact/document_type_choices/',
    physical_artifact_types: '/api/physical_artifact_types/',
    artifact: '/api/artifact/',
    physical_artifact: '/api/physical_artifact/',
    document_artifact: '/api/document_artifact/',
    department_users: '/api/department_users',
    disposal_methods: '/api/disposal_methods',
    geocoding_address_search_token: '/api/geocoding_address_search_token/',
    geocoding_address_search: 'https://api.mapbox.com/geocoding/v5/mapbox.places/',
    system_preference: '/api/system_preference/',

    schema_masterlist: "/api/schema_masterlist/",
    schema_masterlist_paginated: "/api/schema_masterlist_paginated/",
    schema_purpose: "/api/schema_purpose/",
    schema_purpose_paginated: "/api/schema_purpose_paginated/",
    schema_group: "/api/schema_group/",
    schema_group_paginated: "/api/schema_group_paginated/",
    schema_question: "/api/schema_question/",
    schema_question_paginated: "/api/schema_question_paginated/"
};

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    applications: '/api/application/',
    my_user_details: '/api/my_user_details/',

    countries: '/api/countries',
    organisations: '/api/organisations/',
    my_organisations: '/api/my_organisations/',
    organisation_contacts: '/api/organisation_contacts/',
    licences_class: '/api/licences_class/',
    licence_available_purposes: '/api/licence_available_purposes/'
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var COMMENT_TYPE_OFFICER = exports.COMMENT_TYPE_OFFICER = 'officer_comment';
var COMMENT_TYPE_ASSESSOR = exports.COMMENT_TYPE_ASSESSOR = 'assessor_comment';
var COMMENT_TYPE_DEFICIENCY = exports.COMMENT_TYPE_DEFICIENCY = 'deficiency_value';

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "wildlifecompliance_vue/img/shibaken.c4c9d81.jpg";

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(680)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(978),
  /* scopeId */
  "data-v-55eb2da0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(716)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(729)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(1046),
  /* scopeId */
  "data-v-be634c84",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(652)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(942),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(666)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(960),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(707)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  "data-v-73a8c7ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(687)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(986),
  /* scopeId */
  "data-v-5b86b2f2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(1036),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(917),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(1041),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(928),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(669)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(963),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(664)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(958),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(908),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(690)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(989),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(737)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1055),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(714)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(686)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(985),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(914),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(923),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(667)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(961),
  /* scopeId */
  "data-v-41f9a7d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(718)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1030),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(721)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1034),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(653)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(943),
  /* scopeId */
  "data-v-2a60c1ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(994),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(660)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(952),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(915),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(621);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(68)("2d6ca567", content, true);

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(624);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(68)("f4a08632", content, true);

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(626);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(68)("2442703e", content, true);

/***/ }),
/* 350 */,
/* 351 */
/***/ (function(module, exports) {

module.exports = [{"activity":"yes"},{"project_details":[{"project_application":"","project_title":"rtgrt","project_duration":"rftgstvrg","background_summary":"long text","conservation_outcomes":"","main_objectives":"objecti ve text"}]},{"licences_and_permits":[{"requires_permits":"yes","permits_acknowledgement":"on","permits":"","aec_licence_number":"","aec_name":"","aec_application_and_licence":""}]},{"financial_basis":[{"financial_details_other":"","grant_details":"","financial_basis":"grant","contract_details":""}]},{"personnel_details":[{"qualification_attachment":"","ap_change_acknowledgement":"","authorised_persons":"","authorised_persons_acknowledgement":"","qualifications":"faddsad","ap_unavailable_explanation":""}]},{"project_description":[{"research_fauna_release_quarantine":"","project_description":"research","research_fauna_hold_length":"","monitoring_survey_details":"","monitoring_plan":"","research_animal_husbandry":"","monitoring_conditional_condition":"","research_fauna_activities":"","research_fauna_release_risk_assessment":"","monitoring_plan_acknowledgement":"","monitoring_licence_type":"","research_fauna_release_site":"","survey_survey_details":"","research_lab_details":"","research_details":"","research_fauna_disposal":"","research_lab_other_details":"","research_fauna_final_fate":"","research_fauna_post_release_monitoring":"","survey_num_survey_locations":"","survey_locations_calm_land":"","monitoring_monitoring_plan":"","research_type":"","research_num_research_locations":"","research_fauna_release_site_transportation":"","monitoring_locations_calm_land":"","research_fauna_stored":"","monitoring_num_monitoring_locations":"","research_fauna_retained_specimen":""}]}]

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = [{"children":[{"type":"text","name":"project_title","label":"Project title"},{"type":"text","name":"project_duration","label":"Total duration of the project"},{"type":"file","name":"project_application","label":"Project Application"},{"type":"text_area","name":"background_summary","label":"Background summary"},{"type":"text_area","name":"main_objectives","label":"Main Objectives"},{"type":"text_area","name":"conservation_outcomes","label":"Conservation outcomes"}],"type":"section","name":"project_details","label":"Project Details"},{"children":[{"conditions":{"yes":[{"type":"file","name":"permits","label":"Please provide detail and attach any applications made or permissions granted."},{"type":"declaration","name":"permits_acknowledgement","label":"I acknowledge that should other permissions/licences be required it may affect the processing time for this Regulation 17 licence"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"},{"value":"unsure","label":"Unsure"}],"type":"select","name":"requires_permits","label":"Does this project require any other licences, permits, licences, etc under any other state or federal legislation?"},{"type":"text","name":"aec_name","label":"If activity has been (or is being) assessed by an Animal Ethics Committee (AEC) provide committee name."},{"type":"text","name":"aec_licence_number","label":"Provide AEC licence number."},{"type":"file","name":"aec_application_and_licence","label":"Attach a copy of the AEC project application and licence."}],"type":"section","name":"licences_and_permits","label":"Licences and Permits"},{"children":[{"conditions":{"other":[{"type":"text_area","name":"financial_details_other","label":"Provide details of who is funding the project or how the project is being funded"}],"contract":[{"type":"text_area","name":"contract_details","label":"Provide details of the Client, including name, address and contact details"}],"grant":[{"type":"text_area","name":"grant_details","label":"Provide details of the grant or sponsorship, including name, address and contact details of the organisation funding the project"}]},"options":[{"value":"grant","label":"Grant / Sponsored"},{"value":"contract","label":"Contract / Consulting"},{"value":"other","label":"Other - Please provide details"}],"type":"radiobuttons","name":"financial_basis","label":"How is your project funded?"}],"type":"section","name":"financial_basis","label":"Financial Basis"},{"children":[{"type":"text","name":"qualifications","label":"Provide relevant qualifications and/or experience details specific to this project"},{"type":"file","name":"qualification_attachment","label":"Qualification Attachment(s)"},{"type":"declaration","name":"authorised_persons_acknowledgement","label":"I acknowledge that I am legally responsible for the actions of anyone involved in the take of fauna activities under this licence."},{"name":"authorised_persons","isLicenceField":true,"isRepeatable":true,"label":"Authorised Person","type":"group","children":[{"isLicenceField":true,"type":"text","name":"ap_surname","label":"Surname"},{"isLicenceField":true,"type":"text","name":"ap_given_names","label":"Given name(s)"},{"type":"date","name":"ap_dob","label":"Date of birth"},{"name":"ap_association","type":"select","label":"Association to applicant","conditions":{"other":[{"type":"text","name":"ap_association_other_details","label":"Details"}]},"options":[{"value":"volunteer","label":"Volunteer"},{"value":"contractor","label":"Contractor"},{"value":"staff","label":"Staff / Employee"},{"value":"student","label":"Student"},{"value":"other","label":"Other - Please provide details"}],"defaultBlank":true},{"name":"ap_role","type":"select","label":"Role","conditions":{"handler":[{"type":"label","name":"ap_handler_type","label":"Handler Type"},{"type":"checkbox","name":"ap_biopsy","label":"Biopsy"},{"type":"checkbox","name":"ap_chipping","label":"Chipping"},{"type":"checkbox","name":"ap_collaring","label":"Collaring"},{"type":"checkbox","name":"ap_anasthaesia","label":"Anasthaesia"},{"conditions":{"on":[{"type":"text","name":"ap_handler_other_details","label":"Please provide details"}]},"type":"checkbox","name":"ap_handler_other","label":"Other"}]},"options":[{"value":"handler","label":"Handler"},{"value":"scribe","label":"Scribe"},{"value":"assistant","label":"Assistant"}],"defaultBlank":true},{"type":"file","name":"ap_qualification","label":"Provide relevant qualification / experience (relative to activity)"}]},{"type":"text_area","name":"ap_unavailable_explanation","label":"If a list of authorised persons is not currently available, please explain:"},{"type":"declaration","name":"ap_change_acknowledgement","label":"I acknowledge that I will make changes in this system to authorised persons throughout licence duration if changes are required"}],"type":"section","name":"personnel_details","label":"Personnel Details"},{"children":[{"name":"project_description","type":"select","label":"Which of the following describes your project?","conditions":{"monitoring":[{"conditions":{"yes":[{"type":"text","name":"monitoring_licence_type","label":"Provide licence type and number."}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_conditional_condition","label":"Is the monitoring being done as a conditional condition of an licence?"},{"conditions":{"yes":[{"type":"file","name":"monitoring_plan","label":"Please attach monitoring plan.","isRepeatable":true},{"type":"declaration","name":"monitoring_plan_acknowledgement","label":"I acknowledge that should additional monitoring plans be required it may affect the processing time for this Regulation 17 licence."}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_monitoring_plan","label":"Is there a monitoring plan?"},{"type":"number","name":"monitoring_num_monitoring_locations","label":"How many locations will be monitored?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"},{"value":"unsure","label":"Unsure"}],"type":"radiobuttons","name":"monitoring_locations_calm_land","label":"Are any locations on CALM Act land?"},{"name":"monitoring_survey_details","isRepeatable":true,"help_text":"If multiple monitoring locations; provide details separately for each location and add an additional location after the methods section for the first location.","label":"Monitoring Details","type":"group","children":[{"type":"text_area","name":"monitoring_address","label":"Location / Address"},{"type":"text","name":"monitoring_coordinates","label":"Coordinate / GPS","help_text":"If multiple monitoring locations; provide details separately for each location and add an additional location after the methods section for the first location."},{"children":[{"type":"date","name":"monitoring_field_session_start_date","label":"Start Date"},{"type":"date","name":"monitoring_field_session_end_date","label":"End Date"}],"isRepeatable":true,"type":"group","name":"monitoring_field_session","label":"Field session"},{"type":"text","name":"monitoring_field_dates_unknown","label":"If field dates are unknown, use anticipated field dates in the start and end date above and explain below."},{"name":"monitoring_interval_regularity","type":"select","label":"Interval Regularity","conditions":{"other":[{"type":"text","name":"monitoring_regular_intervals_other","label":"Please Specify"}]},"options":[{"value":"not_regular_intervals","label":"Not regular intervals"},{"value":"weekly","label":"Weekly"},{"value":"fortnightly","label":"Fortnightly"},{"value":"monthly","label":"Monthly"},{"value":"quarterly","label":"Quarterly/Seasonally"},{"value":"biannually","label":"Biannually/Six-monthly"},{"value":"annually","label":"Annually"},{"value":"biennually","label":"Biennially/Every two years"},{"value":"other","label":"Other"}],"defaultBlank":false},{"conditions":{"yes":[{"children":[{"type":"text","name":"monitoring_tft_group_name","label":"Group name"},{"speciesType":"fauna","type":"species","name":"monitoring_tft_scientific_name","label":"Scientific or common name"}],"isRepeatable":true,"type":"group","name":"monitoring_targeted_fauna","label":"Targeted Fauna Type"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_targeting_species_or_fauna","label":"Is the monitoring targeting a species or fauna group?"},{"conditions":{"yes":[{"children":[{"type":"text","name":"monitoring_threatened_group_name","label":"Group name"},{"speciesType":"fauna","type":"species","name":"monitoring_threatened_scientific_name","label":"Scientific or common name"}],"isRepeatable":true,"type":"group","name":"monitoring_threatened_fauna","label":"Threatened Fauna"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"},{"value":"unknown","label":"Unknown"}],"type":"radiobuttons","name":"monitoring_threatened_priority_fauna","label":"Will your activity possibly interact with any threatened or priority fauna (including non-target species)?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_standard_operating_procedures","label":"Will your activities be in accordance with Parks and Wildlife standard operating procedures?"},{"conditions":{"yes":[{"type":"text","name":"monitoring_sops_details","label":"Provide details"},{"type":"file","name":"monitoring_sops_documents","label":"Attach a copy of the relevent document(s)"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_sops","label":"Will your activities be in accordance with any other SOPs, protocols, guidelines or manuals?"},{"conditions":{"capture":[{"conditions":{"net":[{"type":"number","name":"monitoring_num_net_sites","label":"What is the number of sites where nets will be used?"},{"type":"number","name":"monitoring_num_net_days","label":"How many days/nights will nets be used?"},{"type":"number","name":"monitoring_num_net_sessions","label":"How many sessions will nets be used?"},{"type":"number","name":"monitoring_num_nets_per_session","label":"Total number of nets per session?"},{"type":"number","name":"monitoring_max_num_nets_per_session_per_site","label":"Maximum total number of nets per site per session?"},{"type":"text_area","name":"monitoring_different_num_nets_per_session_or_site_explanation","label":"If the number of nets differs between sessions or sites then explain"},{"type":"label","name":"monitoring_nets","label":"Nets"},{"conditions":{"on":[{"type":"text","name":"monitoring_dip_make","label":"Make"},{"type":"text","name":"monitoring_dip_size","label":"Size"},{"type":"number","name":"monitoring_num_dips","label":"Number of nets"},{"type":"text","name":"monitoring_dip_placement","label":"Net Placement"},{"type":"text","name":"monitoring_dip_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_dip_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_dip","label":"Dip"},{"conditions":{"on":[{"type":"text","name":"monitoring_sweep_make","label":"Make"},{"type":"text","name":"monitoring_sweep_size","label":"Size"},{"type":"number","name":"monitoring_num_sweeps","label":"Number of nets"},{"type":"text","name":"monitoring_sweep_placement","label":"Net Placement"},{"type":"text","name":"monitoring_sweep_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_sweep_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_sweep","label":"Sweep"},{"conditions":{"on":[{"type":"text","name":"monitoring_gill_make","label":"Make"},{"type":"text","name":"monitoring_gill_size","label":"Size"},{"type":"number","name":"monitoring_num_gills","label":"Number of nets"},{"type":"text","name":"monitoring_gill_placement","label":"Net Placement"},{"type":"text","name":"monitoring_gill_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_gill_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_gill","label":"Gill"},{"conditions":{"on":[{"type":"text","name":"monitoring_seine_make","label":"Make"},{"type":"text","name":"monitoring_seine_size","label":"Size"},{"type":"number","name":"monitoring_num_seines","label":"Number of nets"},{"type":"text","name":"monitoring_seine_placement","label":"Net Placement"},{"type":"text","name":"monitoring_seine_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_seine_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_seine","label":"Seine"},{"conditions":{"on":[{"type":"text","name":"monitoring_cast_make","label":"Make"},{"type":"text","name":"monitoring_cast_size","label":"Size"},{"type":"number","name":"monitoring_num_casts","label":"Number of nets"},{"type":"text","name":"monitoring_cast_placement","label":"Net Placement"},{"type":"text","name":"monitoring_cast_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_cast_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_cast","label":"Cast"},{"conditions":{"on":[{"type":"text","name":"monitoring_plankton_make","label":"Make"},{"type":"text","name":"monitoring_plankton_size","label":"Size"},{"type":"number","name":"monitoring_num_planktons","label":"Number of nets"},{"type":"text","name":"monitoring_plankton_placement","label":"Net Placement"},{"type":"text","name":"monitoring_plankton_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_plankton_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_plankton","label":"Plankton"},{"conditions":{"on":[{"type":"text","name":"monitoring_mist_make","label":"Make"},{"type":"text","name":"monitoring_mist_size","label":"Size"},{"type":"number","name":"monitoring_num_mists","label":"Number of nets"},{"type":"text","name":"monitoring_mist_placement","label":"Net Placement"},{"type":"text","name":"monitoring_mist_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_mist_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_mist","label":"Mist"},{"conditions":{"on":[{"type":"text","name":"monitoring_harp_make","label":"Make"},{"type":"text","name":"monitoring_harp_size","label":"Size"},{"type":"number","name":"monitoring_num_harps","label":"Number of nets"},{"type":"text","name":"monitoring_harp_placement","label":"Net Placement"},{"type":"text","name":"monitoring_harp_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_harp_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_harp","label":"Harp"},{"conditions":{"on":[{"type":"text","name":"monitoring_cannon_make","label":"Make"},{"type":"text","name":"monitoring_cannon_size","label":"Size"},{"type":"number","name":"monitoring_num_cannons","label":"Number of nets"},{"type":"text","name":"monitoring_cannon_placement","label":"Net Placement"},{"type":"text","name":"monitoring_cannon_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_cannon_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_cannon","label":"Cannon"},{"conditions":{"on":[{"type":"text","name":"monitoring_net_type_other","label":"Enter details"},{"type":"text","name":"monitoring_net_other_make","label":"Make"},{"type":"text","name":"monitoring_net_other_size","label":"Size"},{"type":"number","name":"monitoring_net_other_num_nets","label":"Number of nets"},{"type":"text","name":"monitoring_net_other_placement","label":"Net Placement"},{"type":"text","name":"monitoring_net_other_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_net_other_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_net_other","label":"Other"}],"other":[{"type":"text_area","name":"monitoring_other_capture_methodology","label":"Provide details of your fauna capture methodology if it doesn’t fit within previous questions for trap, net or hand capture techniques."}],"trap":[{"type":"number","name":"monitoring_num_trap_sites","label":"What is the number of trap sites?"},{"type":"number","name":"monitoring_num_traps_open_days","label":"How many days/nights will traps be open?"},{"type":"number","name":"monitoring_num_trap_sessions","label":"How many trapping sessions?"},{"type":"number","name":"monitoring_num_traps_per_session","label":"Total number of traps per session?"},{"type":"number","name":"monitoring_max_num_traps_per_session_per_site","label":"Maximum total number of traps per site per session?"},{"type":"text_area","name":"monitoring_different_num_traps_per_session_or_site_explanation","label":"If the number of traps differs between sessions or sites, enter the highest number in the questions above, and explain differences below."},{"type":"label","name":"monitoring_traps","label":"Traps"},{"conditions":{"on":[{"type":"text","name":"monitoring_cage_make","label":"Make"},{"type":"text","name":"monitoring_cage_size","label":"Size"},{"type":"number","name":"monitoring_num_cages","label":"Number of traps"},{"type":"text","name":"monitoring_cage_placement","label":"Cage Placement"},{"type":"text","name":"monitoring_cage_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_cage_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_cage","label":"Cage"},{"conditions":{"on":[{"type":"text","name":"monitoring_box_make","label":"Make"},{"type":"text","name":"monitoring_box_size","label":"Size"},{"type":"number","name":"monitoring_num_boxs","label":"Number of traps"},{"type":"text","name":"monitoring_box_placement","label":"Box Placement"},{"type":"text","name":"monitoring_box_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_box_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_box","label":"Box"},{"conditions":{"on":[{"type":"text","name":"monitoring_dry_pit_make","label":"Make"},{"type":"text","name":"monitoring_dry_pit_size","label":"Size"},{"type":"number","name":"monitoring_num_dry_pits","label":"Number of traps"},{"type":"text","name":"monitoring_dry_pit_placement","label":"Dry Pit Placement"},{"type":"text","name":"monitoring_dry_pit_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_dry_pit_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_dry_pit","label":"Dry Pit"},{"conditions":{"on":[{"type":"text","name":"monitoring_wet_pit_make","label":"Make"},{"type":"text","name":"monitoring_wet_pit_size","label":"Size"},{"type":"number","name":"monitoring_num_wet_pits","label":"Number of traps"},{"type":"text","name":"monitoring_wet_pit_placement","label":"Wet Pit Placement"},{"type":"text","name":"monitoring_wet_pit_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_wet_pit_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_wet_pit","label":"Wet Pit"},{"conditions":{"on":[{"type":"text","name":"monitoring_funnel_make","label":"Make"},{"type":"text","name":"monitoring_funnel_size","label":"Size"},{"type":"number","name":"monitoring_num_funnels","label":"Number of traps"},{"type":"text","name":"monitoring_funnel_placement","label":"Funnel Placement"},{"type":"text","name":"monitoring_funnel_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_funnel_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_funnel","label":"Funnel"},{"conditions":{"on":[{"type":"text","name":"monitoring_litter_make","label":"Make"},{"type":"text","name":"monitoring_litter_size","label":"Size"},{"type":"number","name":"monitoring_num_litters","label":"Number of traps"},{"type":"text","name":"monitoring_litter_placement","label":"Litter Placement"},{"type":"text","name":"monitoring_litter_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_litter_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_litter","label":"Litter"},{"conditions":{"on":[{"type":"text","name":"monitoring_trap_type_other","label":"Enter details"},{"type":"text","name":"monitoring_trap_other_make","label":"Make"},{"type":"text","name":"monitoring_trap_other_size","label":"Size"},{"type":"number","name":"monitoring_trap_other_num_traps","label":"Number of traps"},{"type":"text","name":"monitoring_trap_other_placement","label":"Trap Placement"},{"type":"text","name":"monitoring_trap_other_setting_times","label":"Setting times"},{"type":"text","name":"monitoring_trap_other_other_details","label":"Other details"}]},"type":"checkbox","name":"monitoring_trap_other","label":"Other"}]},"options":[{"value":"trap","label":"Trap"},{"value":"net","label":"Net"},{"value":"other","label":"Other"}],"type":"radiobuttons","name":"monitoring_capture_method","label":"Capture Method"},{"type":"label","name":"monitoring_fate","label":"What will be the fate(s) of the fauna captured?"},{"conditions":{"on":[{"options":[{"value":"immediately","label":"Immediately after species idenfication"},{"value":"after_transmitter_attachment","label":"After attachment of transmitter"},{"value":"after_morphometrics","label":"After morphometrics and physical condition taken"},{"value":"after_samples","label":"After samples taken"},{"value":"after_marking","label":"After marking"},{"value":"after_temp_holding","label":"After temporary holding (< 24 hours)"}],"type":"select","name":"monitoring_release_schedule","label":"Release Schedule"},{"type":"label","name":"monitoring_pre_release_occurences","label":"Which of the following will occur before release?"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_prerelease_transmitter_type","label":"Transmitter type, make and model, and construction material"},{"type":"text_area","name":"monitoring_prerelease_method_attachment","label":"Method of attachment to animal"},{"type":"text","name":"monitoring_prerelease_transmitter_max_weight","label":"Maximum weight of transmitter and attachment materials"},{"type":"text","name":"monitoring_prerelease_mim_body_weight","label":"Minimum body weight of animal to which transmitter will be attached"},{"type":"text","name":"monitoring_prerelease_transmitter_attachment_length","label":"How long will the transmitter remain attached to the animal?"},{"conditions":{"yes":[{"type":"declaration","name":"monitoring_prerelease_acknowledge","label":"I acknowledge that every attempt will be made to recapture the animal to remove the transmitter, and will notify Wildlife Licensing if this cannot be done."}],"no":[{"type":"text_area","name":"monitoring_prerelease_detach_details","label":"Provide details of how the transmitter will detach from the animal"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_prerelease_recapture_remove","label":"Does the animal need to be recaptured to remove the transmitter?"}]},"type":"checkbox","name":"monitoring_release_transmitter","label":"Attachment of transmitter"},{"conditions":{"on":[{"type":"label","name":"monitoring_mophometrics_recorded","label":"What morphometrics and condition details will be recorded?"},{"type":"checkbox","name":"monitoring_mophometric_length","label":"Length"},{"type":"checkbox","name":"monitoring_mophometric_sex","label":"Sex"},{"type":"checkbox","name":"monitoring_mophometric_age","label":"Age"},{"type":"checkbox","name":"monitoring_mophometric_body_condition","label":"Body condition"},{"type":"checkbox","name":"monitoring_mophometric_reproductive_condition","label":"Reproductive condition"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_mophometric_other_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_mophometric_other","label":"Other"},{"type":"text_area","name":"monitoring_mophometric_other_details","label":"Provide any other details relating to measurements and condition"}]},"type":"checkbox","name":"monitoring_mophometrics","label":"Mophometrics and physical condition analysis"},{"conditions":{"on":[{"type":"label","name":"monitoring_samples","label":"What samples will be taken?"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_tissue_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_tissue","label":"Tissue"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_scale_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_scale","label":"Scale"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_hair_feather_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_hair_feather","label":"Hair / feather"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_blood_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_blood","label":"Blood"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_swabs_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_swabs","label":"Swabs"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_samples_other_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_samples_other","label":"Other"}]},"type":"checkbox","name":"monitoring_sampling","label":"Sampling"},{"conditions":{"on":[{"conditions":{"permanent":[{"conditions":{"on":[{"type":"text_area","name":"monitoring_tags_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_tags","label":"Tags"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_microchips_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_microchips","label":"Microchips / implants"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_bands_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_bands","label":"Bands"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_ear_punching_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_ear_punching","label":"Ear punching"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_marking_other_details","label":"Please provide details"}]},"type":"checkbox","name":"monitoring_marking_other","label":"Other"}]},"options":[{"value":"temporary","label":"Temporary"},{"value":"permanent","label":"Permanent"}],"type":"select","name":"monitoring_marking","label":"What marking will be done and why?"}]},"type":"checkbox","name":"monitoring_marking","label":"Marking"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_why_temporarily_held","label":"Why will/may the fauna be temporarily held?"},{"type":"text_area","name":"monitoring_how_temporarily_held","label":"How will the fauna be held?"},{"type":"text_area","name":"monitoring_where_temporarily_held","label":"Where will the fauna be held?"},{"type":"text_area","name":"monitoring_transported_details","label":"If fauna will be transported, provide details?"},{"conditions":{"other":[{"type":"text_area","name":"monitoring_fauna_release_other_details","label":"Please provide details"}]},"options":[{"value":"at_capture_site","label":"At capture site"},{"value":"near_capture_site","label":"Near capture site into suitable habitat"},{"value":"other","label":"Other"}],"type":"select","name":"monitoring_where_fauna_released","label":"Where will the fauna be released?"}]},"type":"checkbox","name":"monitoring_temporary_holding","label":"Temporary Holding"}]},"type":"checkbox","name":"monitoring_release","label":"Release"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_why_fauna_retained","label":"Why does the fauna need to be retained?"},{"type":"text_area","name":"monitoring_what_fauna_retained","label":"What fauna could be retained?"},{"type":"number","name":"monitoring_num_fauna_retained","label":"If fauna is to be retained, how many animals?"},{"conditions":{"yes":[{"type":"text_area","name":"monitoring_euthanise_method","label":"Method"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_fauna_euthanised","label":"Will fauna be euthanised?"},{"type":"text","name":"monitoring_where_specimen_stored","label":"Where will the specimen(s) be held/lodged/stored?"},{"type":"text_area","name":"monitoring_mesuem_storage_details","label":"If specimen is to be deposited at the WA Museum, will the Museum be contacted prior to the fauna being retained or did the Museum request the specimen?"}]},"type":"checkbox","name":"monitoring_retain","label":"Retain"},{"type":"text_area","name":"monitoring_unforseen_injury_dealings","label":"Describe how unforeseen injuries or other related issues will be dealt with."},{"type":"text_area","name":"monitoring_hygiene_disease_considerations","label":"Provide details of field hygiene and wildlife disease considerations."},{"type":"text_area","name":"monitoring_fauna_capture_other_details","label":"Provide other details relating to fauna capture."}],"other":[{"type":"label","name":"monitoring_non_capture_method","label":"Please select any non-capture survey method you will be using"},{"conditions":{"on":[{"conditions":{"on":[{"type":"text_area","name":"monitoring_transmitter_type","label":"Transmitter type, make and model, and construction material"},{"type":"text","name":"monitoring_transmitter_max_weight","label":"Maximum weight of transmitter and attachment materials"},{"type":"text","name":"monitoring_transmitter_attachment_method","label":"Method of attachment to animal"},{"type":"text","name":"monitoring_transmitter_min_distance","label":"What will be the minimum distance from the animal??"},{"type":"number","name":"monitoring_transmitter_num_attachment_attempts","label":"How many attempts to attach will be made per individual animal?"},{"type":"text","name":"monitoring_transmitter_attachment_length","label":"How long will the transmitter remain attached to the animal?"}]},"type":"checkbox","name":"monitoring_transmitter","label":"Transmitter"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_what_samples","label":"What samples will be collected?"},{"type":"text_area","name":"monitoring_sample_how_collected","label":"How will samples be collected?"},{"type":"text","name":"monitoring_samples_min_distance","label":"What will be the minimum distance from the animal?"},{"type":"number","name":"monitoring_samples_num_attachment_attempts","label":"How many attempts to attach will be made per individual animal?"}]},"type":"checkbox","name":"monitoring_samples","label":"Samples"}]},"type":"checkbox","name":"monitoring_transmitters_samples","label":"Attachment of transmitters and collection of samples from a distance"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_visual_observation_details","label":"Please provide Details"}]},"type":"checkbox","name":"monitoring_visual_observation","label":"Visual observation"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_aural_details","label":"Please provide Details"},{"conditions":{"yes":[{"type":"text_area","name":"monitoring_call_playback_details","label":"Please provide Details"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_call_playback","label":"Will call play-back be used?"}]},"type":"checkbox","name":"monitoring_aural","label":"Aural"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_bird_census_details","label":"Please provide Details"}]},"type":"checkbox","name":"monitoring_bird_census","label":"Bird Census"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_spotlighting_details","label":"Please provide Details"}]},"type":"checkbox","name":"monitoring_spotlighting","label":"Spotlighting / head torching"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_hair_tubes_details","label":"Please provide Details"}]},"type":"checkbox","name":"monitoring_hair_tubes","label":"Hair tubes / sticky wicket"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_secondary_signs_details","label":"Please provide Details"}]},"type":"checkbox","name":"monitoring_secondary_signs","label":"Secondary signs / evidence"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_habitat_assessment_details","label":"Please provide Details"}]},"type":"checkbox","name":"monitoring_habitat_assessment","label":"Habitat Assessment"},{"conditions":{"on":[{"type":"text_area","name":"monitoring_non_capture_other_details","label":"Please provide Details"}]},"type":"checkbox","name":"monitoring_non_capture_other","label":"Other"}],"remote_sensing":[{"type":"label","name":"monitoring_remote_sensing_apparatus","label":"What remote sensing apparatus will you be using?"},{"conditions":{"on":[{"conditions":{"yes":[{"type":"text","name":"monitoring_what_bait","label":"What bait will be used?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_bait_consumable","label":"Will the bait be consumable?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_bait_replenished","label":"Will the bait be replenished?"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"monitoring_camera_baited","label":"Will cameras be baited with an attractant/lure?"},{"children":[{"type":"text","name":"monitoring_camera_make","label":"Make"},{"type":"number","name":"monitoring_num_cameras","label":"Number of devices"},{"type":"text_area","name":"monitoring_camera_placement","label":"Camera Placement"},{"type":"text","name":"monitoring_camera_situ","label":"How long in situ"},{"type":"text","name":"monitoring_camera_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"monitoring_camera_information","label":"Camera Information"}]},"type":"checkbox","name":"monitoring_camera","label":"Camera"},{"conditions":{"on":[{"children":[{"type":"text","name":"monitoring_ubd_make","label":"Make"},{"type":"number","name":"monitoring_num_ubds","label":"Number of devices"},{"type":"text","name":"monitoring_ubd_placement","label":"Ultrasonic bat detector Placement"},{"type":"text","name":"monitoring_ubd_situ","label":"How long in situ"},{"type":"text","name":"monitoring_ubd_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"monitoring_ultrasonic_bat_detector_information","label":"Ultrasonic Bat Detector Information"}]},"type":"checkbox","name":"monitoring_ultrasonic_bat_detector","label":"Ultrasonic bat detector"},{"conditions":{"on":[{"children":[{"type":"text","name":"monitoring_ac_make","label":"Make"},{"type":"number","name":"monitoring_num_acs","label":"Number of devices"},{"type":"text","name":"monitoring_ac_placement","label":"Acoustic recorder Placement"},{"type":"text","name":"monitoring_ac_situ","label":"How long in situ"},{"type":"text","name":"monitoring_ac_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"monitoring_acoustic_call_recorder_information","label":"Acoustic recorder Information"}]},"type":"checkbox","name":"monitoring_acoustic_call_recorder","label":"Acoustic recorder"},{"conditions":{"on":[{"children":[{"type":"text","name":"monitoring_aerial_make","label":"Make"},{"type":"number","name":"monitoring_num_aerials","label":"Number of devices"},{"type":"text","name":"monitoring_aerial_placement","label":"Aerial Placement"},{"type":"text","name":"monitoring_aerial_situ","label":"How long in situ"},{"type":"text","name":"monitoring_aerial_other_details","label":"Other details"}],"type":"group","name":"monitoring_aerial_information","label":"Aerial Information"}]},"type":"checkbox","name":"monitoring_aerial","label":"Aerial"},{"type":"text_area","name":"monitoring_remote_sensing_other_details","label":"Provide any other details relating to remote sensing."}]},"options":[{"value":"capture","label":"Capture"},{"value":"remote_sensing","label":"Remote Sensing"},{"value":"other","label":"Other non-capture"}],"type":"radiobuttons","name":"monitoring_method","label":"What monitoring method will you be using?"}]}],"survey":[{"type":"number","name":"survey_num_survey_locations","label":"How many locations will be surveyed?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"},{"value":"unsure","label":"Unsure"}],"type":"radiobuttons","name":"survey_locations_calm_land","label":"Are any locations on CALM Act land?"},{"name":"survey_survey_details","isRepeatable":true,"help_text":"If multiple survey locations; provide details separately for each location and add an additional location after the methods section for the first location.","label":"Survey Details","type":"group","children":[{"type":"text_area","name":"survey_address","label":"Location / Address"},{"type":"text","name":"survey_coordinates","label":"Coordinate / GPS"},{"children":[{"type":"date","name":"survey_field_session_start_date","label":"Start Date"},{"type":"date","name":"survey_field_session_end_date","label":"End Date"}],"isRepeatable":true,"type":"group","name":"survey_field_session","label":"Field session"},{"type":"text","name":"survey_field_dates_unknown","label":"If field dates are unknown, use anticipated field dates in the start and end date above and explain below."},{"name":"survey_interval_regularity","type":"select","label":"Interval Regularity","conditions":{"other":[{"type":"text","name":"survey_regular_intervals_other","label":"Please Specify"}]},"options":[{"value":"not_regular_intervals","label":"Not regular intervals"},{"value":"weekly","label":"Weekly"},{"value":"fortnightly","label":"Fortnightly"},{"value":"monthly","label":"Monthly"},{"value":"quarterly","label":"Quarterly/Seasonally"},{"value":"biannually","label":"Biannually/Six-monthly"},{"value":"annually","label":"Annually"},{"value":"biennually","label":"Biennially/Every two years"},{"value":"other","label":"Other"}],"defaultBlank":false},{"conditions":{"yes":[{"children":[{"type":"text","name":"survey_tf_group_name","label":"Group name"},{"speciesType":"fauna","type":"species","name":"survey_tf_scientific_name","label":"Scientific or common name"}],"isRepeatable":true,"type":"group","name":"survey_threatened_fauna","label":"Threatened Fauna"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"},{"value":"unknown","label":"Unknown"}],"type":"radiobuttons","name":"survey_threatened_priority_fauna","label":"Will your activity possibly interact with any threatened or priority fauna (including non-target species)?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_standard_operating_procedures","label":"Will your activities be in accordance with Parks and Wildlife standard operating procedures?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_epa_statements","label":"Will your activities be in accordance with EPA Guidance Statements, Position Statements or Technical Reports?"},{"conditions":{"yes":[{"type":"text","name":"survey_sops_details","label":"Provide details"},{"type":"file","name":"survey_sops_documents","label":"Attach a copy of the relevent document(s)"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_sops","label":"Will your activities be in accordance with any other SOPs, protocols, guidelines or manuals?"},{"type":"label","name":"survey_survey_type","label":"What survey type will you be conducting?"},{"conditions":{"on":[{"conditions":{"capture":[{"conditions":{"net":[{"type":"number","name":"survey_level_1_num_net_sites","label":"What is the number of sites where nets will be used?"},{"type":"number","name":"survey_level_1_num_net_days","label":"How many days/nights will nets be used?"},{"type":"number","name":"survey_level_1_num_net_sessions","label":"How many sessions will nets be used?"},{"type":"number","name":"survey_level_1_num_nets_per_session","label":"Total number of nets per session?"},{"type":"number","name":"survey_level_1_max_num_nets_per_session_per_site","label":"Maximum total number of nets per site per session?"},{"type":"text_area","name":"survey_level_1_different_num_nets_per_session_or_site_explanation","label":"If the number of nets differs between sessions or sites then explain"},{"type":"label","name":"survey_level_1_nets","label":"Nets"},{"conditions":{"on":[{"type":"text","name":"survey_level_1_sweep_make","label":"Make"},{"type":"text","name":"survey_level_1_sweep_size","label":"Size"},{"type":"number","name":"survey_level_1_num_sweeps","label":"Number of nets"},{"type":"text","name":"survey_level_1_sweep_placement","label":"Net Placement"},{"type":"text","name":"survey_level_1_sweep_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_1_sweep_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_1_sweep","label":"Sweep"},{"conditions":{"on":[{"type":"text","name":"survey_level_1_mist_make","label":"Make"},{"type":"text","name":"survey_level_1_mist_size","label":"Size"},{"type":"number","name":"survey_level_1_num_mists","label":"Number of nets"},{"type":"text","name":"survey_level_1_mist_placement","label":"Net Placement"},{"type":"text","name":"survey_level_1_mist_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_1_mist_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_1_mist","label":"Mist"},{"conditions":{"on":[{"type":"text","name":"survey_level_1_harp_make","label":"Make"},{"type":"text","name":"survey_level_1_harp_size","label":"Size"},{"type":"number","name":"survey_level_1_num_harps","label":"Number of nets"},{"type":"text","name":"survey_level_1_harp_placement","label":"Net Placement"},{"type":"text","name":"survey_level_1_harp_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_1_harp_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_1_harp","label":"Harp"},{"conditions":{"on":[{"type":"text","name":"survey_level_1_net_type_other","label":"Enter details"},{"type":"text","name":"survey_level_1_net_other_make","label":"Make"},{"type":"text","name":"survey_level_1_net_other_size","label":"Size"},{"type":"number","name":"survey_level_1_net_other_num_nets","label":"Number of nets"},{"type":"text","name":"survey_level_1_net_other_placement","label":"Net Placement"},{"type":"text","name":"survey_level_1_net_other_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_1_net_other_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_1_net_other","label":"Other"}],"other":[{"type":"text_area","name":"survey_level_1_other_capture_methodology","label":"Provide details of your fauna capture methodology if it doesn’t fit within previous questions for trap, net or hand capture techniques."}],"trap":[{"type":"number","name":"survey_level_1_num_trap_sites","label":"What is the number of trap sites?"},{"type":"number","name":"survey_level_1_num_traps_open_days","label":"How many days/nights will traps be open?"},{"type":"number","name":"survey_level_1_num_trap_sessions","label":"How many trapping sessions?"},{"type":"number","name":"survey_level_1_num_traps_per_session","label":"Total number of traps per session?"},{"type":"number","name":"survey_level_1_max_num_traps_per_session_per_site","label":"Maximum total number of traps per site per session?"},{"type":"text_area","name":"survey_level_1_different_num_traps_per_session_or_site_explanation","label":"If the number of traps differs between sessions or sites, enter the highest number in the questions above, and explain differences below."},{"type":"label","name":"survey_level_1_traps","label":"Traps"},{"conditions":{"on":[{"type":"text","name":"survey_level_1_cage_make","label":"Make"},{"type":"text","name":"survey_level_1_cage_size","label":"Size"},{"type":"number","name":"survey_level_1_num_cages","label":"Number of traps"},{"type":"text","name":"survey_level_1_cage_placement","label":"Cage Placement"},{"type":"text","name":"survey_level_1_cage_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_1_cage_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_1_cage","label":"Cage"},{"conditions":{"on":[{"type":"text","name":"survey_level_1_box_make","label":"Make"},{"type":"text","name":"survey_level_1_box_size","label":"Size"},{"type":"number","name":"survey_level_1_num_boxs","label":"Number of traps"},{"type":"text","name":"survey_level_1_box_placement","label":"Box Placement"},{"type":"text","name":"survey_level_1_box_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_1_box_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_1_box","label":"Box"},{"conditions":{"on":[{"type":"text","name":"survey_level_1_dry_pit_make","label":"Make"},{"type":"text","name":"survey_level_1_dry_pit_size","label":"Size"},{"type":"number","name":"survey_level_1_num_dry_pits","label":"Number of traps"},{"type":"text","name":"survey_level_1_dry_pit_placement","label":"Dry Pit Placement"},{"type":"text","name":"survey_level_1_dry_pit_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_1_dry_pit_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_1_dry_pit","label":"Dry Pit"},{"conditions":{"on":[{"type":"text","name":"survey_level_1_funnel_make","label":"Make"},{"type":"text","name":"survey_level_1_funnel_size","label":"Size"},{"type":"number","name":"survey_level_1_num_funnels","label":"Number of traps"},{"type":"text","name":"survey_level_1_funnel_placement","label":"Funnel Placement"},{"type":"text","name":"survey_level_1_funnel_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_1_funnel_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_1_funnel","label":"Funnel"},{"conditions":{"on":[{"type":"text","name":"survey_level_1_trap_type_other","label":"Enter details"},{"type":"text","name":"survey_level_1_trap_other_make","label":"Make"},{"type":"text","name":"survey_level_1_trap_other_size","label":"Size"},{"type":"number","name":"survey_level_1_trap_other_num_traps","label":"Number of traps"},{"type":"text","name":"survey_level_1_trap_other_placement","label":"Trap Placement"},{"type":"text","name":"survey_level_1_trap_other_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_1_trap_other_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_1_trap_other","label":"Other"}],"hand":[{"type":"label","name":"survey_level_1_hand_capture_techniques","label":"What hand capture techniques will you be using?"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_hook_and_bag_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_1_hook_and_bag","label":"Hook and Bag"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_Noose_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_1_noose","label":"Noose"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_foraging_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_1_foraging","label":"Foraging"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_raking_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_1_raking","label":"Raking"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_sieving_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_1_sieving","label":"Sieving"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_excavation_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_1_excavation","label":"Excavation"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_excavation_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_1_other_hand_capture_techniques","label":"Other"}]},"options":[{"value":"trap","label":"Trap"},{"value":"net","label":"Net"},{"value":"hand","label":"Hand"},{"value":"other","label":"Other"}],"type":"radiobuttons","name":"survey_level_1_capture_method","label":"Capture Method"},{"type":"label","name":"survey_level_1_fate","label":"What will be the fate(s) of the fauna captured?"},{"conditions":{"on":[{"options":[{"value":"immediately","label":"Immediately after species idenfication"},{"value":"after_morphometrics","label":"After morphometrics and physical condition taken"},{"value":"after_samples","label":"After samples taken"},{"value":"after_marking","label":"After marking"},{"value":"after_temp_holding","label":"After temporary holding (< 24 hours)"}],"type":"select","name":"survey_level_1_release_schedule","label":"Release Schedule"},{"type":"label","name":"survey_level_1_pre_release_occurences","label":"Which of the following will occur before release?"},{"conditions":{"on":[{"type":"label","name":"survey_level_1_mophometrics_recorded","label":"What morphometrics and condition details will be recorded?"},{"type":"checkbox","name":"survey_level_1_mophometric_length","label":"Length"},{"type":"checkbox","name":"survey_level_1_mophometric_sex","label":"Sex"},{"type":"checkbox","name":"survey_level_1_mophometric_age","label":"Age"},{"type":"checkbox","name":"survey_level_1_mophometric_body_condition","label":"Body condition"},{"type":"checkbox","name":"survey_level_1_mophometric_reproductive_condition","label":"Reproductive condition"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_mophometric_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_mophometric_other","label":"Other"},{"type":"text_area","name":"survey_level_1_mophometric_other_details","label":"Provide any other details relating to measurements and condition"}]},"type":"checkbox","name":"survey_level_1_mophometrics","label":"Mophometrics and physical condition analysis"},{"conditions":{"on":[{"type":"label","name":"survey_level_1_samples","label":"What samples will be taken?"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_tissue_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_tissue","label":"Tissue"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_scale_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_scale","label":"Scale"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_hair_feather_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_hair_feather","label":"Hair / feather"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_blood_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_blood","label":"Blood"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_swabs_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_swabs","label":"Swabs"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_samples_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_samples_other","label":"Other"}]},"type":"checkbox","name":"survey_level_1_sampling","label":"Sampling"},{"conditions":{"on":[{"conditions":{"permanent":[{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_tags_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_tags","label":"Tags"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_microchips_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_microchips","label":"Microchips / implants"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_bands_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_bands","label":"Bands"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_ear_punching_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_ear_punching","label":"Ear punching"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_marking_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_1_marking_other","label":"Other"}]},"options":[{"value":"temporary","label":"Temporary"},{"value":"permanent","label":"Permanent"}],"type":"select","name":"survey_level_1_marking","label":"What marking will be done and why?"}]},"type":"checkbox","name":"survey_level_1_marking","label":"Marking"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_why_temporarily_held","label":"Why will/may the fauna be temporarily held?"},{"type":"text_area","name":"survey_level_1_how_temporarily_held","label":"How will the fauna be held?"},{"type":"text_area","name":"survey_level_1_where_temporarily_held","label":"Where will the fauna be held?"},{"type":"text_area","name":"survey_level_1_transported_details","label":"If fauna will be transported, provide details?"},{"conditions":{"other":[{"type":"text_area","name":"survey_level_1_fauna_release_other_details","label":"Please provide details"}]},"options":[{"value":"at_capture_site","label":"At capture site"},{"value":"near_capture_site","label":"Near capture site into suitable habitat"},{"value":"other","label":"Other"}],"type":"select","name":"survey_level_1_where_fauna_released","label":"Where will the fauna be released?"}]},"type":"checkbox","name":"survey_level_1_temporary_holding","label":"Temporary Holding"}]},"type":"checkbox","name":"survey_level_1_release","label":"Release"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_why_fauna_retained","label":"Why does the fauna need to be retained?"},{"type":"text_area","name":"survey_level_1_what_fauna_retained","label":"What fauna could be retained?"},{"type":"number","name":"survey_level_1_num_fauna_retained","label":"If fauna is to be retained, how many animals?"},{"conditions":{"yes":[{"type":"text_area","name":"survey_level_1_euthanise_method","label":"Method"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_level_1_fauna_euthanised","label":"Will fauna be euthanised?"},{"type":"text","name":"survey_level_1_where_specimen_stored","label":"Where will the specimen(s) be held/lodged/stored?"},{"type":"text_area","name":"survey_level_1_mesuem_storage_details","label":"If specimen is to be deposited at the WA Museum, will the Museum be contacted prior to the fauna being retained or did the Museum request the specimen?"}]},"type":"checkbox","name":"survey_level_1_retain","label":"Retain"},{"type":"text_area","name":"survey_level_1_unforseen_injury_dealings","label":"Describe how unforeseen injuries or other related issues will be dealt with."},{"type":"text_area","name":"survey_level_1_hygiene_disease_considerations","label":"Provide details of field hygiene and wildlife disease considerations."},{"type":"text_area","name":"survey_level_1_fauna_capture_other_details","label":"Provide other details relating to fauna capture."}],"other":[{"type":"label","name":"survey_level_1_non_capture_method","label":"Please select any non-capture survey method you will be using"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_aural_survey_details","label":"Please provide Details"},{"conditions":{"yes":[{"type":"text_area","name":"survey_level_1_call_playback_details","label":"Please provide Details"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_level_1_call_playback","label":"Will call play-back be used?"}]},"type":"checkbox","name":"survey_level_1_aural_survey","label":"Aural survey"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_bird_census_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_1_bird_census","label":"Bird Census"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_spotlighting_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_1_spotlighting","label":"Spotlighting / head torching"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_hair_tubes_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_1_hair_tubes","label":"Hair tubes / sticky wicket"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_secondary_signs_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_1_secondary_signs","label":"Secondary signs / evidence"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_habitat_assessment_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_1_habitat_assessment","label":"Habitat Assessment"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_1_non_capture_other_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_1_non_capture_other","label":"Other"}],"remote_sensing":[{"type":"label","name":"survey_level_1_remote_sensing_apparatus","label":"What remote sensing apparatus will you be using?"},{"conditions":{"on":[{"conditions":{"yes":[{"type":"text","name":"survey_level_1_what_bait","label":"What bait will be used?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_level_1_bait_consumable","label":"Will the bait be consumable?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_level_1_bait_replenished","label":"Will the bait be replenished?"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_level_1_camera_baited","label":"Will cameras be baited with an attractant/lure?"},{"children":[{"type":"text","name":"survey_level_1_camera_make","label":"Make"},{"type":"number","name":"survey_level_1_num_cameras","label":"Number of devices"},{"type":"text_area","name":"survey_level_1_camera_placement","label":"Camera Placement"},{"type":"text","name":"survey_level_1_camera_situ","label":"How long in situ"},{"type":"text","name":"survey_level_1_camera_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_level_1_camera_information","label":"Camera Information"}]},"type":"checkbox","name":"survey_level_1_camera","label":"Camera"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_level_1_ubd_make","label":"Make"},{"type":"number","name":"survey_level_1_num_ubds","label":"Number of devices"},{"type":"text","name":"survey_level_1_ubd_placement","label":"Ultrasonic bat detector Placement"},{"type":"text","name":"survey_level_1_ubd_situ","label":"How long in situ"},{"type":"text","name":"survey_level_1_ubd_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_level_1_ultrasonic_bat_detector_information","label":"Ultrasonic Bat Detector Information"}]},"type":"checkbox","name":"survey_level_1_ultrasonic_bat_detector","label":"Ultrasonic bat detector"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_level_1_acr_make","label":"Make"},{"type":"number","name":"survey_level_1_num_acrs","label":"Number of devices"},{"type":"text","name":"survey_level_1_acr_placement","label":"Acoustic call recorder Placement"},{"type":"text","name":"survey_level_1_acr_situ","label":"How long in situ"},{"type":"text","name":"survey_level_1_acr_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_level_1_acoustic_call_recorder_information","label":"Acoustic call recorder Information"}]},"type":"checkbox","name":"survey_level_1_acoustic_call_recorder","label":"Acoustic call recorder"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_level_1_aerial_make","label":"Make"},{"type":"number","name":"survey_level_1_num_aerials","label":"Number of devices"},{"type":"text","name":"survey_level_1_aerial_placement","label":"Aerial Placement"},{"type":"text","name":"survey_level_1_aerial_situ","label":"How long in situ"},{"type":"text","name":"survey_level_1_aerial_other_details","label":"Other details"}],"type":"group","name":"survey_level_1_aerial_information","label":"Aerial Information"}]},"type":"checkbox","name":"survey_level_1_aerial","label":"Aerial"},{"type":"text_area","name":"survey_level_1_remote_sensing_other_details","label":"Provide any other details relating to remote sensing."}]},"options":[{"value":"capture","label":"Capture"},{"value":"remote_sensing","label":"Remote Sensing"},{"value":"other","label":"Other non-capture"}],"type":"radiobuttons","name":"survey_level_1_survey_method","label":"What survey method will you be using?"}]},"type":"checkbox","name":"survey_level_1_reconnaissance","label":"Level 1 / reconnaissance"},{"conditions":{"on":[{"conditions":{"capture":[{"conditions":{"net":[{"type":"number","name":"survey_level_2_num_net_sites","label":"What is the number of sites where nets will be used?"},{"type":"number","name":"survey_level_2_num_net_days","label":"How many days/nights will nets be used?"},{"type":"number","name":"survey_level_2_num_net_sessions","label":"How many sessions will nets be used?"},{"type":"number","name":"survey_level_2_num_nets_per_session","label":"Total number of nets per session?"},{"type":"number","name":"survey_level_2_max_num_nets_per_session_per_site","label":"Maximum total number of nets per site per session?"},{"type":"text_area","name":"survey_level_2_different_num_nets_per_session_or_site_explanation","label":"If the number of nets differs between sessions or sites then explain"},{"type":"label","name":"survey_level_2_nets","label":"Nets"},{"conditions":{"on":[{"type":"text","name":"survey_level_2_sweep_make","label":"Make"},{"type":"text","name":"survey_level_2_sweep_size","label":"Size"},{"type":"number","name":"survey_level_2_num_sweeps","label":"Number of nets"},{"type":"text","name":"survey_level_2_sweep_placement","label":"Net Placement"},{"type":"text","name":"survey_level_2_sweep_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_2_sweep_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_2_sweep","label":"Sweep"},{"conditions":{"on":[{"type":"text","name":"survey_level_2_mist_make","label":"Make"},{"type":"text","name":"survey_level_2_mist_size","label":"Size"},{"type":"number","name":"survey_level_2_num_mists","label":"Number of nets"},{"type":"text","name":"survey_level_2_mist_placement","label":"Net Placement"},{"type":"text","name":"survey_level_2_mist_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_2_mist_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_2_mist","label":"Mist"},{"conditions":{"on":[{"type":"text","name":"survey_level_2_harp_make","label":"Make"},{"type":"text","name":"survey_level_2_harp_size","label":"Size"},{"type":"number","name":"survey_level_2_num_harps","label":"Number of nets"},{"type":"text","name":"survey_level_2_harp_placement","label":"Net Placement"},{"type":"text","name":"survey_level_2_harp_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_2_harp_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_2_harp","label":"Harp"},{"conditions":{"on":[{"type":"text","name":"survey_level_2_net_type_other","label":"Enter details"},{"type":"text","name":"survey_level_2_net_other_make","label":"Make"},{"type":"text","name":"survey_level_2_net_other_size","label":"Size"},{"type":"number","name":"survey_level_2_net_other_num_nets","label":"Number of nets"},{"type":"text","name":"survey_level_2_net_other_placement","label":"Net Placement"},{"type":"text","name":"survey_level_2_net_other_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_2_net_other_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_2_net_other","label":"Other"}],"other":[{"type":"text_area","name":"survey_level_2_other_capture_methodology","label":"Provide details of your fauna capture methodology if it doesn’t fit within previous questions for trap, net or hand capture techniques."}],"trap":[{"type":"number","name":"survey_level_2_num_trap_sites","label":"What is the number of trap sites?"},{"type":"number","name":"survey_level_2_num_traps_open_days","label":"How many days/nights will traps be open?"},{"type":"number","name":"survey_level_2_num_trap_sessions","label":"How many trapping sessions?"},{"type":"number","name":"survey_level_2_num_traps_per_session","label":"Total number of traps per session?"},{"type":"number","name":"survey_level_2_max_num_traps_per_session_per_site","label":"Maximum total number of traps per site per session?"},{"type":"text_area","name":"survey_level_2_different_num_traps_per_session_or_site_explanation","label":"If the number of traps differs between sessions or sites, enter the highest number in the questions above, and explain differences below."},{"type":"label","name":"survey_level_2_traps","label":"Traps"},{"conditions":{"on":[{"type":"text","name":"survey_level_2_cage_make","label":"Make"},{"type":"text","name":"survey_level_2_cage_size","label":"Size"},{"type":"number","name":"survey_level_2_num_cages","label":"Number of traps"},{"type":"text","name":"survey_level_2_cage_placement","label":"Cage Placement"},{"type":"text","name":"survey_level_2_cage_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_2_cage_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_2_cage","label":"Cage"},{"conditions":{"on":[{"type":"text","name":"survey_level_2_box_make","label":"Make"},{"type":"text","name":"survey_level_2_box_size","label":"Size"},{"type":"number","name":"survey_level_2_num_boxs","label":"Number of traps"},{"type":"text","name":"survey_level_2_box_placement","label":"Box Placement"},{"type":"text","name":"survey_level_2_box_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_2_box_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_2_box","label":"Box"},{"conditions":{"on":[{"type":"text","name":"survey_level_2_dry_pit_make","label":"Make"},{"type":"text","name":"survey_level_2_dry_pit_size","label":"Size"},{"type":"number","name":"survey_level_2_num_dry_pits","label":"Number of traps"},{"type":"text","name":"survey_level_2_dry_pit_placement","label":"Dry Pit Placement"},{"type":"text","name":"survey_level_2_dry_pit_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_2_dry_pit_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_2_dry_pit","label":"Dry Pit"},{"conditions":{"on":[{"type":"text","name":"survey_level_2_funnel_make","label":"Make"},{"type":"text","name":"survey_level_2_funnel_size","label":"Size"},{"type":"number","name":"survey_level_2_num_funnels","label":"Number of traps"},{"type":"text","name":"survey_level_2_funnel_placement","label":"Funnel Placement"},{"type":"text","name":"survey_level_2_funnel_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_2_funnel_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_2_funnel","label":"Funnel"},{"conditions":{"on":[{"type":"text","name":"survey_level_2_trap_type_other","label":"Enter details"},{"type":"text","name":"survey_level_2_trap_other_make","label":"Make"},{"type":"text","name":"survey_level_2_trap_other_size","label":"Size"},{"type":"number","name":"survey_level_2_trap_other_num_traps","label":"Number of traps"},{"type":"text","name":"survey_level_2_trap_other_placement","label":"Trap Placement"},{"type":"text","name":"survey_level_2_trap_other_setting_times","label":"Setting times"},{"type":"text","name":"survey_level_2_trap_other_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_level_2_trap_other","label":"Other"}],"hand":[{"type":"label","name":"survey_level_2_hand_capture_techniques","label":"What hand capture techniques will you be using?"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_hook_and_bag_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_2_hook_and_bag","label":"Hook and Bag"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_Noose_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_2_noose","label":"Noose"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_foraging_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_2_foraging","label":"Foraging"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_raking_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_2_raking","label":"Raking"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_sieving_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_2_sieving","label":"Sieving"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_excavation_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_2_excavation","label":"Excavation"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_excavation_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_level_2_other_hand_capture_techniques","label":"Other"}]},"options":[{"value":"trap","label":"Trap"},{"value":"net","label":"Net"},{"value":"hand","label":"Hand"},{"value":"other","label":"Other"}],"type":"radiobuttons","name":"survey_level_2_capture_method","label":"Capture Method"},{"type":"label","name":"survey_level_2_fate","label":"What will be the fate(s) of the fauna captured?"},{"conditions":{"on":[{"options":[{"value":"immediately","label":"Immediately after species idenfication"},{"value":"after_morphometrics","label":"After morphometrics and physical condition taken"},{"value":"after_samples","label":"After samples taken"},{"value":"after_marking","label":"After marking"},{"value":"after_temp_holding","label":"After temporary holding (< 24 hours)"}],"type":"select","name":"survey_level_2_release_schedule","label":"Release Schedule"},{"type":"label","name":"survey_level_2_pre_release_occurences","label":"Which of the following will occur before release?"},{"conditions":{"on":[{"type":"label","name":"survey_level_2_mophometrics_recorded","label":"What morphometrics and condition details will be recorded?"},{"type":"checkbox","name":"survey_level_2_mophometric_length","label":"Length"},{"type":"checkbox","name":"survey_level_2_mophometric_sex","label":"Sex"},{"type":"checkbox","name":"survey_level_2_mophometric_age","label":"Age"},{"type":"checkbox","name":"survey_level_2_mophometric_body_condition","label":"Body condition"},{"type":"checkbox","name":"survey_level_2_mophometric_reproductive_condition","label":"Reproductive condition"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_mophometric_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_mophometric_other","label":"Other"},{"type":"text_area","name":"survey_level_2_mophometric_other_details","label":"Provide any other details relating to measurements and condition"}]},"type":"checkbox","name":"survey_level_2_mophometrics","label":"Mophometrics and physical condition analysis"},{"conditions":{"on":[{"type":"label","name":"survey_level_2_samples","label":"What samples will be taken?"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_tissue_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_tissue","label":"Tissue"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_scale_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_scale","label":"Scale"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_hair_feather_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_hair_feather","label":"Hair / feather"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_blood_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_blood","label":"Blood"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_swabs_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_swabs","label":"Swabs"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_samples_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_samples_other","label":"Other"}]},"type":"checkbox","name":"survey_level_2_sampling","label":"Sampling"},{"conditions":{"on":[{"conditions":{"permanent":[{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_tags_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_tags","label":"Tags"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_microchips_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_microchips","label":"Microchips / implants"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_bands_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_bands","label":"Bands"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_ear_punching_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_ear_punching","label":"Ear punching"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_marking_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_level_2_marking_other","label":"Other"}]},"options":[{"value":"temporary","label":"Temporary"},{"value":"permanent","label":"Permanent"}],"type":"select","name":"survey_level_2_marking","label":"What marking will be done and why?"}]},"type":"checkbox","name":"survey_level_2_marking","label":"Marking"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_why_temporarily_held","label":"Why will/may the fauna be temporarily held?"},{"type":"text_area","name":"survey_level_2_how_temporarily_held","label":"How will the fauna be held?"},{"type":"text_area","name":"survey_level_2_where_temporarily_held","label":"Where will the fauna be held?"},{"type":"text_area","name":"survey_level_2_transported_details","label":"If fauna will be transported, provide details?"},{"conditions":{"other":[{"type":"text_area","name":"survey_level_2_fauna_release_other_details","label":"Please provide details"}]},"options":[{"value":"at_capture_site","label":"At capture site"},{"value":"near_capture_site","label":"Near capture site into suitable habitat"},{"value":"other","label":"Other"}],"type":"select","name":"survey_level_2_where_fauna_released","label":"Where will the fauna be released?"}]},"type":"checkbox","name":"survey_level_2_temporary_holding","label":"Temporary Holding"}]},"type":"checkbox","name":"survey_level_2_release","label":"Release"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_why_fauna_retained","label":"Why does the fauna need to be retained?"},{"type":"text_area","name":"survey_level_2_what_fauna_retained","label":"What fauna could be retained?"},{"type":"number","name":"survey_level_2_num_fauna_retained","label":"If fauna is to be retained, how many animals?"},{"conditions":{"yes":[{"type":"text_area","name":"survey_level_2_euthanise_method","label":"Method"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_level_2_fauna_euthanised","label":"Will fauna be euthanised?"},{"type":"text","name":"survey_level_2_where_specimen_stored","label":"Where will the specimen(s) be held/lodged/stored?"},{"type":"text_area","name":"survey_level_2_mesuem_storage_details","label":"If specimen is to be deposited at the WA Museum, will the Museum be contacted prior to the fauna being retained or did the Museum request the specimen?"}]},"type":"checkbox","name":"survey_level_2_retain","label":"Retain"},{"type":"text_area","name":"survey_level_2_unforseen_injury_dealings","label":"Describe how unforeseen injuries or other related issues will be dealt with."},{"type":"text_area","name":"survey_level_2_hygiene_disease_considerations","label":"Provide details of field hygiene and wildlife disease considerations."},{"type":"text_area","name":"survey_level_2_fauna_capture_other_details","label":"Provide other details relating to fauna capture."}],"other":[{"type":"label","name":"survey_level_2_non_capture_method","label":"Please select any non-capture survey method you will be using"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_aural_survey_details","label":"Please provide Details"},{"conditions":{"yes":[{"type":"text_area","name":"survey_level_2_call_playback_details","label":"Please provide Details"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_level_2_call_playback","label":"Will call play-back be used?"}]},"type":"checkbox","name":"survey_level_2_aural_survey","label":"Aural survey"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_bird_census_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_2_bird_census","label":"Bird Census"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_spotlighting_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_2_spotlighting","label":"Spotlighting / head torching"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_hair_tubes_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_2_hair_tubes","label":"Hair tubes / sticky wicket"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_secondary_signs_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_2_secondary_signs","label":"Secondary signs / evidence"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_habitat_assessment_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_2_habitat_assessment","label":"Habitat Assessment"},{"conditions":{"on":[{"type":"text_area","name":"survey_level_2_non_capture_other_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_level_2_non_capture_other","label":"Other"}],"remote_sensing":[{"type":"label","name":"survey_level_2_remote_sensing_apparatus","label":"What remote sensing apparatus will you be using?"},{"conditions":{"on":[{"conditions":{"yes":[{"type":"text","name":"survey_level_2_what_bait","label":"What bait will be used?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_level_2_bait_consumable","label":"Will the bait be consumable?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_level_2_bait_replenished","label":"Will the bait be replenished?"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_level_2_camera_baited","label":"Will cameras be baited with an attractant/lure?"},{"children":[{"type":"text","name":"survey_level_2_camera_make","label":"Make"},{"type":"number","name":"survey_level_2_num_cameras","label":"Number of devices"},{"type":"text_area","name":"survey_level_2_camera_placement","label":"Camera Placement"},{"type":"text","name":"survey_level_2_camera_situ","label":"How long in situ"},{"type":"text","name":"survey_level_2_camera_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_level_2_camera_information","label":"Camera Information"}]},"type":"checkbox","name":"survey_level_2_camera","label":"Camera"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_level_2_ubd_make","label":"Make"},{"type":"number","name":"survey_level_2_num_ubds","label":"Number of devices"},{"type":"text","name":"survey_level_2_ubd_placement","label":"Ultrasonic bat detector Placement"},{"type":"text","name":"survey_level_2_ubd_situ","label":"How long in situ"},{"type":"text","name":"survey_level_2_ubd_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_level_2_ultrasonic_bat_detector_information","label":"Ultrasonic Bat Detector Information"}]},"type":"checkbox","name":"survey_level_2_ultrasonic_bat_detector","label":"Ultrasonic bat detector"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_level_2_acr_make","label":"Make"},{"type":"number","name":"survey_level_2_num_acrs","label":"Number of devices"},{"type":"text","name":"survey_level_2_acr_placement","label":"Acoustic call recorder Placement"},{"type":"text","name":"survey_level_2_acr_situ","label":"How long in situ"},{"type":"text","name":"survey_level_2_acr_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_level_2_acoustic_call_recorder_information","label":"Acoustic call recorder Information"}]},"type":"checkbox","name":"survey_level_2_acoustic_call_recorder","label":"Acoustic call recorder"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_level_2_aerial_make","label":"Make"},{"type":"number","name":"survey_level_2_num_aerials","label":"Number of devices"},{"type":"text","name":"survey_level_2_aerial_placement","label":"Aerial Placement"},{"type":"text","name":"survey_level_2_aerial_situ","label":"How long in situ"},{"type":"text","name":"survey_level_2_aerial_other_details","label":"Other details"}],"type":"group","name":"survey_level_2_aerial_information","label":"Aerial Information"}]},"type":"checkbox","name":"survey_level_2_aerial","label":"Aerial"},{"type":"text_area","name":"survey_level_2_remote_sensing_other_details","label":"Provide any other details relating to remote sensing."}]},"options":[{"value":"capture","label":"Capture"},{"value":"remote_sensing","label":"Remote Sensing"},{"value":"other","label":"Other non-capture"}],"type":"radiobuttons","name":"survey_level_2_survey_method","label":"What survey method will you be using?"}]},"type":"checkbox","name":"survey_comprehensive","label":"Level 2 / detailed or comprehensive"},{"conditions":{"on":[{"conditions":{"capture":[{"conditions":{"other":[{"type":"text_area","name":"survey_sre_other_capture_methodology","label":"Provide details of your fauna capture methodology if it doesn’t fit within previous questions for trap, net or hand capture techniques."}],"trap":[{"type":"number","name":"survey_sre_num_trap_sites","label":"What is the number of trap sites?"},{"type":"number","name":"survey_sre_num_traps_open_days","label":"How many days/nights will traps be open?"},{"type":"number","name":"survey_sre_num_trap_sessions","label":"How many trapping sessions?"},{"type":"number","name":"survey_sre_num_traps_per_session","label":"Total number of traps per session?"},{"type":"number","name":"survey_sre_max_num_traps_per_session_per_site","label":"Maximum total number of traps per site per session?"},{"type":"text_area","name":"survey_sre_different_num_traps_per_session_or_site_explanation","label":"If the number of traps differs between sessions or sites, enter the highest number in the questions above, and explain differences below."},{"type":"label","name":"survey_sre_traps","label":"Traps"},{"conditions":{"on":[{"type":"text","name":"survey_sre_dry_pit_make","label":"Make"},{"type":"text","name":"survey_sre_dry_pit_size","label":"Size"},{"type":"number","name":"survey_sre_num_dry_pits","label":"Number of traps"},{"type":"text","name":"survey_sre_dry_pit_placement","label":"Dry Pit Placement"},{"type":"text","name":"survey_sre_dry_pit_setting_times","label":"Setting times"},{"type":"text","name":"survey_sre_dry_pit_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_sre_dry_pit","label":"Dry Pit"},{"conditions":{"on":[{"type":"text","name":"survey_sre_wet_pit_make","label":"Make"},{"type":"text","name":"survey_sre_wet_pit_size","label":"Size"},{"type":"number","name":"survey_sre_num_wet_pits","label":"Number of traps"},{"type":"text","name":"survey_sre_wet_pit_placement","label":"Wet Pit Placement"},{"type":"text","name":"survey_sre_wet_pit_setting_times","label":"Setting times"},{"type":"text","name":"survey_sre_wet_pit_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_sre_wet_pit","label":"Wet pit"}],"hand":[{"type":"label","name":"survey_sre_hand_capture_techniques","label":"What hand capture techniques will you be using?"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_hook_and_bag_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_sre_hook_and_bag","label":"Hook and Bag"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_Noose_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_sre_noose","label":"Noose"}]},"options":[{"value":"trap","label":"Trap"},{"value":"hand","label":"Hand"},{"value":"other","label":"Other"}],"type":"radiobuttons","name":"survey_sre_capture_method","label":"Capture Method"},{"type":"label","name":"survey_sre_fate","label":"What will be the fate(s) of the fauna captured?"},{"conditions":{"on":[{"options":[{"value":"immediately","label":"Immediately after species idenfication"},{"value":"after_morphometrics","label":"After morphometrics and physical condition taken"},{"value":"after_samples","label":"After samples taken"},{"value":"after_marking","label":"After marking"},{"value":"after_temp_holding","label":"After temporary holding (< 24 hours)"}],"type":"select","name":"survey_sre_release_schedule","label":"Release Schedule"},{"type":"label","name":"survey_sre_pre_release_occurences","label":"Which of the following will occur before release?"},{"conditions":{"on":[{"type":"label","name":"survey_sre_mophometrics_recorded","label":"What morphometrics and condition details will be recorded?"},{"type":"checkbox","name":"survey_sre_mophometric_length","label":"Length"},{"type":"checkbox","name":"survey_sre_mophometric_sex","label":"Sex"},{"type":"checkbox","name":"survey_sre_mophometric_age","label":"Age"},{"type":"checkbox","name":"survey_sre_mophometric_body_condition","label":"Body condition"},{"type":"checkbox","name":"survey_sre_mophometric_reproductive_condition","label":"Reproductive condition"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_mophometric_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_mophometric_other","label":"Other"},{"type":"text_area","name":"survey_sre_mophometric_other_details","label":"Provide any other details relating to measurements and condition"}]},"type":"checkbox","name":"survey_sre_mophometrics","label":"Mophometrics and physical condition analysis"},{"conditions":{"on":[{"type":"label","name":"survey_sre_samples","label":"What samples will be taken?"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_tissue_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_tissue","label":"Tissue"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_scale_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_scale","label":"Scale"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_hair_feather_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_hair_feather","label":"Hair / feather"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_blood_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_blood","label":"Blood"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_swabs_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_swabs","label":"Swabs"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_samples_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_samples_other","label":"Other"}]},"type":"checkbox","name":"survey_sre_sampling","label":"Sampling"},{"conditions":{"on":[{"conditions":{"permanent":[{"conditions":{"on":[{"type":"text_area","name":"survey_sre_tags_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_tags","label":"Tags"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_microchips_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_microchips","label":"Microchips / implants"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_bands_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_bands","label":"Bands"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_ear_punching_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_ear_punching","label":"Ear punching"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_marking_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_sre_marking_other","label":"Other"}]},"options":[{"value":"temporary","label":"Temporary"},{"value":"permanent","label":"Permanent"}],"type":"select","name":"survey_sre_marking","label":"What marking will be done and why?"}]},"type":"checkbox","name":"survey_sre_marking","label":"Marking"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_why_temporarily_held","label":"Why will/may the fauna be temporarily held?"},{"type":"text_area","name":"survey_sre_how_temporarily_held","label":"How will the fauna be held?"},{"type":"text_area","name":"survey_sre_where_temporarily_held","label":"Where will the fauna be held?"},{"type":"text_area","name":"survey_sre_transported_details","label":"If fauna will be transported, provide details?"},{"conditions":{"other":[{"type":"text_area","name":"survey_sre_fauna_release_other_details","label":"Please provide details"}]},"options":[{"value":"at_capture_site","label":"At capture site"},{"value":"near_capture_site","label":"Near capture site into suitable habitat"},{"value":"other","label":"Other"}],"type":"select","name":"survey_sre_where_fauna_released","label":"Where will the fauna be released?"}]},"type":"checkbox","name":"survey_sre_temporary_holding","label":"Temporary Holding"}]},"type":"checkbox","name":"survey_sre_release","label":"Release"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_why_fauna_retained","label":"Why does the fauna need to be retained?"},{"type":"text_area","name":"survey_sre_what_fauna_retained","label":"What fauna could be retained?"},{"type":"number","name":"survey_sre_num_fauna_retained","label":"If fauna is to be retained, how many animals?"},{"conditions":{"yes":[{"type":"text_area","name":"survey_sre_euthanise_method","label":"Method"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_sre_fauna_euthanised","label":"Will fauna be euthanised?"},{"type":"text","name":"survey_sre_where_specimen_stored","label":"Where will the specimen(s) be held/lodged/stored?"},{"type":"text_area","name":"survey_sre_mesuem_storage_details","label":"If specimen is to be deposited at the WA Museum, will the Museum be contacted prior to the fauna being retained or did the Museum request the specimen?"}]},"type":"checkbox","name":"survey_sre_retain","label":"Retain"},{"type":"text_area","name":"survey_sre_prevent_vertebre_by_catch","label":"Describe measures that will be used to prevent/minimise vertebrate by-catch"},{"type":"text_area","name":"survey_sre_hygiene_disease_considerations","label":"Provide details of field hygiene and wildlife disease considerations."},{"type":"text_area","name":"survey_sre_fauna_capture_other_details","label":"Provide other details relating to fauna capture."}],"other":[{"type":"label","name":"survey_sre_non_capture_method","label":"Please select any non-capture survey method you will be using"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_secondary_signs_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_sre_secondary_signs","label":"Secondary signs / evidence"},{"conditions":{"on":[{"type":"text_area","name":"survey_sre_habitat_assessment_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_sre_habitat_assessment","label":"Habitat Assessment"}]},"options":[{"value":"capture","label":"Capture"},{"value":"other","label":"Other non-capture"}],"type":"radiobuttons","name":"survey_sre_survey_method","label":"What survey method will you be using?"}]},"type":"checkbox","name":"survey_sre","label":"Short range endemic (SRE)"},{"conditions":{"on":[{"conditions":{"litter_trap":[{"type":"number","name":"survey_subterranean_num_trap_sites","label":"What is the number of trap sites?"},{"type":"number","name":"survey_subterranean_num_trap_bores","label":"What is the number of bores?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_subterranean_trap_bores_existing","label":"Are the bores existing? (yes/no)?"},{"type":"number","name":"survey_subterranean_num_traps_per_bore","label":"How many traps per bore hole?"},{"type":"number","name":"survey_subterranean_max_num_traps_survey","label":"Maximum total number of traps for the survey?"},{"type":"text","name":"survey_subterranean_length_traps_situ","label":"How long will be traps be left in situ (days or weeks)?"},{"type":"text","name":"survey_subterranean_trap_dimensions","label":"Dimensions of trap"},{"type":"text","name":"survey_subterranean_trap_design","label":"Trap construction materials and design"},{"type":"text","name":"survey_subterranean_trap_other_details","label":"Other details"}],"other":[{"type":"text_area","name":"survey_subterranean_other_capture_methodology","label":"Provide details of your fauna capture methodology if it doesn’t fit within previous questions for trap or net."}],"plankton_net":[{"type":"number","name":"survey_subterranean_num_net_sites","label":"What is the number of net sites?"},{"type":"number","name":"survey_subterranean_num_net_bores","label":"What is the number of bores?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_subterranean_net_bores_existing","label":"Are the bores existing? (yes/no)?"},{"type":"number","name":"survey_subterranean_num_nets_per_bore","label":"How many net hauls per bore hole?"},{"type":"number","name":"survey_subterranean_max_num_nets_survey","label":"Maximum total number of net hauls for the survey?"},{"type":"text","name":"survey_subterranean_net_dimensions","label":"Dimensions of net"},{"type":"text","name":"survey_subterranean_net_design","label":"Net construction materials and design"},{"type":"text","name":"survey_subterranean_net_other_details","label":"Other details"}]},"options":[{"value":"litter_trap","label":"Trap (litter)"},{"value":"plankton_net","label":"Net (plankton)"}],"type":"radiobuttons","name":"survey_subterranean_capture_method","label":"Capture Method"},{"type":"label","name":"survey_subterranean_fate","label":"What will be the fate(s) of the fauna captured?"},{"conditions":{"on":[{"options":[{"value":"immediately","label":"Immediately after species idenfication"},{"value":"after_morphometrics","label":"After morphometrics and physical condition taken"},{"value":"after_samples","label":"After samples taken"},{"value":"after_marking","label":"After marking"},{"value":"after_temp_holding","label":"After temporary holding (< 24 hours)"}],"type":"select","name":"survey_subterranean_release_schedule","label":"Release Schedule"},{"type":"label","name":"survey_subterranean_pre_release_occurences","label":"Which of the following will occur before release?"},{"conditions":{"on":[{"type":"label","name":"survey_subterranean_mophometrics_recorded","label":"What morphometrics and condition details will be recorded?"},{"type":"checkbox","name":"survey_subterranean_mophometric_length","label":"Length"},{"type":"checkbox","name":"survey_subterranean_mophometric_sex","label":"Sex"},{"type":"checkbox","name":"survey_subterranean_mophometric_age","label":"Age"},{"type":"checkbox","name":"survey_subterranean_mophometric_body_condition","label":"Body condition"},{"type":"checkbox","name":"survey_subterranean_mophometric_reproductive_condition","label":"Reproductive condition"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_mophometric_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_mophometric_other","label":"Other"},{"type":"text_area","name":"survey_subterranean_mophometric_other_details","label":"Provide any other details relating to measurements and condition"}]},"type":"checkbox","name":"survey_subterranean_mophometrics","label":"Mophometrics and physical condition analysis"},{"conditions":{"on":[{"type":"label","name":"survey_subterranean_samples","label":"What samples will be taken?"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_tissue_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_tissue","label":"Tissue"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_scale_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_scale","label":"Scale"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_hair_feather_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_hair_feather","label":"Hair / feather"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_blood_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_blood","label":"Blood"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_swabs_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_swabs","label":"Swabs"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_samples_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_samples_other","label":"Other"}]},"type":"checkbox","name":"survey_subterranean_sampling","label":"Sampling"},{"conditions":{"on":[{"conditions":{"permanent":[{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_tags_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_tags","label":"Tags"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_microchips_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_microchips","label":"Microchips / implants"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_bands_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_bands","label":"Bands"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_ear_punching_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_ear_punching","label":"Ear punching"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_marking_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_subterranean_marking_other","label":"Other"}]},"options":[{"value":"temporary","label":"Temporary"},{"value":"permanent","label":"Permanent"}],"type":"select","name":"survey_subterranean_marking","label":"What marking will be done and why?"}]},"type":"checkbox","name":"survey_subterranean_marking","label":"Marking"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_why_temporarily_held","label":"Why will/may the fauna be temporarily held?"},{"type":"text_area","name":"survey_subterranean_how_temporarily_held","label":"How will the fauna be held?"},{"type":"text_area","name":"survey_subterranean_where_temporarily_held","label":"Where will the fauna be held?"},{"type":"text_area","name":"survey_subterranean_transported_details","label":"If fauna will be transported, provide details?"},{"conditions":{"other":[{"type":"text_area","name":"survey_subterranean_fauna_release_other_details","label":"Please provide details"}]},"options":[{"value":"at_capture_site","label":"At capture site"},{"value":"near_capture_site","label":"Near capture site into suitable habitat"},{"value":"other","label":"Other"}],"type":"select","name":"survey_subterranean_where_fauna_released","label":"Where will the fauna be released?"}]},"type":"checkbox","name":"survey_subterranean_temporary_holding","label":"Temporary Holding"}]},"type":"checkbox","name":"survey_subterranean_release","label":"Release"},{"conditions":{"on":[{"type":"text_area","name":"survey_subterranean_why_fauna_retained","label":"Why does the fauna need to be retained?"},{"type":"text_area","name":"survey_subterranean_what_fauna_retained","label":"What fauna could be retained?"},{"type":"number","name":"survey_subterranean_num_fauna_retained","label":"If fauna is to be retained, how many animals?"},{"conditions":{"yes":[{"type":"text_area","name":"survey_subterranean_euthanise_method","label":"Method"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_subterranean_fauna_euthanised","label":"Will fauna be euthanised?"},{"type":"text","name":"survey_subterranean_where_specimen_stored","label":"Where will the specimen(s) be held/lodged/stored?"},{"type":"text_area","name":"survey_subterranean_mesuem_storage_details","label":"If specimen is to be deposited at the WA Museum, will the Museum be contacted prior to the fauna being retained or did the Museum request the specimen?"}]},"type":"checkbox","name":"survey_subterranean_retain","label":"Retain"},{"type":"text_area","name":"survey_subterranean_prevent_vertebre_by_catch","label":"Describe measures that will be used to prevent/minimise vertebrate by-catch"},{"type":"text_area","name":"survey_subterranean_hygiene_disease_considerations","label":"Provide details of field hygiene and wildlife disease considerations."},{"type":"text_area","name":"survey_subterranean_fauna_capture_other_details","label":"Provide other details relating to fauna capture."}]},"type":"checkbox","name":"survey_subterranean","label":"Subterranean"},{"conditions":{"on":[{"conditions":{"capture":[{"conditions":{"net":[{"type":"number","name":"survey_aquatic_num_net_sites","label":"What is the number of sites where nets will be used?"},{"type":"number","name":"survey_aquatic_num_net_days","label":"How many days/nights will nets be used?"},{"type":"number","name":"survey_aquatic_num_net_sessions","label":"How many sessions will nets be used?"},{"type":"number","name":"survey_aquatic_num_nets_per_session","label":"Total number of nets per session?"},{"type":"number","name":"survey_aquatic_max_num_nets_per_session_per_site","label":"Maximum total number of nets per site per session?"},{"type":"text_area","name":"survey_aquatic_different_num_nets_per_session_or_site_explanation","label":"If the number of nets differs between sessions or sites then explain"},{"type":"label","name":"survey_aquatic_nets","label":"Nets"},{"conditions":{"on":[{"type":"text","name":"survey_aquatic_dip_make","label":"Make"},{"type":"text","name":"survey_aquatic_dip_size","label":"Size"},{"type":"number","name":"survey_aquatic_num_dips","label":"Number of nets"},{"type":"text","name":"survey_aquatic_dip_placement","label":"Net Placement"},{"type":"text","name":"survey_aquatic_dip_setting_times","label":"Setting times"},{"type":"text","name":"survey_aquatic_dip_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_aquatic_dip","label":"Dip"},{"conditions":{"on":[{"type":"text","name":"survey_aquatic_sweep_make","label":"Make"},{"type":"text","name":"survey_aquatic_sweep_size","label":"Size"},{"type":"number","name":"survey_aquatic_num_sweeps","label":"Number of nets"},{"type":"text","name":"survey_aquatic_sweep_placement","label":"Net Placement"},{"type":"text","name":"survey_aquatic_sweep_setting_times","label":"Setting times"},{"type":"text","name":"survey_aquatic_sweep_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_aquatic_sweep","label":"Sweep"},{"conditions":{"on":[{"type":"text","name":"survey_aquatic_gill_make","label":"Make"},{"type":"text","name":"survey_aquatic_gill_size","label":"Size"},{"type":"number","name":"survey_aquatic_num_gills","label":"Number of nets"},{"type":"text","name":"survey_aquatic_gill_placement","label":"Net Placement"},{"type":"text","name":"survey_aquatic_gill_setting_times","label":"Setting times"},{"type":"text","name":"survey_aquatic_gill_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_aquatic_gill","label":"Gill"},{"conditions":{"on":[{"type":"text","name":"survey_aquatic_seine_make","label":"Make"},{"type":"text","name":"survey_aquatic_seine_size","label":"Size"},{"type":"number","name":"survey_aquatic_num_seines","label":"Number of nets"},{"type":"text","name":"survey_aquatic_seine_placement","label":"Net Placement"},{"type":"text","name":"survey_aquatic_seine_setting_times","label":"Setting times"},{"type":"text","name":"survey_aquatic_seine_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_aquatic_seine","label":"Seine"},{"conditions":{"on":[{"type":"text","name":"survey_aquatic_cast_make","label":"Make"},{"type":"text","name":"survey_aquatic_cast_size","label":"Size"},{"type":"number","name":"survey_aquatic_num_casts","label":"Number of nets"},{"type":"text","name":"survey_aquatic_cast_placement","label":"Net Placement"},{"type":"text","name":"survey_aquatic_cast_setting_times","label":"Setting times"},{"type":"text","name":"survey_aquatic_cast_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_aquatic_cast","label":"Cast"},{"conditions":{"on":[{"type":"text","name":"survey_aquatic_plankton_make","label":"Make"},{"type":"text","name":"survey_aquatic_plankton_size","label":"Size"},{"type":"number","name":"survey_aquatic_num_planktons","label":"Number of nets"},{"type":"text","name":"survey_aquatic_plankton_placement","label":"Net Placement"},{"type":"text","name":"survey_aquatic_plankton_setting_times","label":"Setting times"},{"type":"text","name":"survey_aquatic_plankton_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_aquatic_plankton","label":"Plankton"},{"conditions":{"on":[{"type":"text","name":"survey_aquatic_net_type_other","label":"Enter details"},{"type":"text","name":"survey_aquatic_net_other_make","label":"Make"},{"type":"text","name":"survey_aquatic_net_other_size","label":"Size"},{"type":"number","name":"survey_aquatic_net_other_num_nets","label":"Number of nets"},{"type":"text","name":"survey_aquatic_net_other_placement","label":"Net Placement"},{"type":"text","name":"survey_aquatic_net_other_setting_times","label":"Setting times"},{"type":"text","name":"survey_aquatic_net_other_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_aquatic_net_other","label":"Other"}],"other":[{"type":"text_area","name":"survey_aquatic_other_capture_methodology","label":"Provide details of your fauna capture methodology if it doesn’t fit within previous questions for trap, net or hand capture techniques."}],"trap":[{"type":"number","name":"survey_aquatic_num_trap_sites","label":"What is the number of trap sites?"},{"type":"number","name":"survey_aquatic_num_traps_open_days","label":"How many days/nights will traps be open?"},{"type":"number","name":"survey_aquatic_num_trap_sessions","label":"How many trapping sessions?"},{"type":"number","name":"survey_aquatic_num_traps_per_session","label":"Total number of traps per session?"},{"type":"number","name":"survey_aquatic_max_num_traps_per_session_per_site","label":"Maximum total number of traps per site per session?"},{"type":"text_area","name":"survey_aquatic_different_num_traps_per_session_or_site_explanation","label":"If the number of traps differs between sessions or sites, enter the highest number in the questions above, and explain differences below."},{"type":"label","name":"survey_aquatic_traps","label":"Traps"},{"conditions":{"on":[{"type":"text","name":"survey_aquatic_cage_make","label":"Make"},{"type":"text","name":"survey_aquatic_cage_size","label":"Size"},{"type":"number","name":"survey_aquatic_num_cages","label":"Number of traps"},{"type":"text","name":"survey_aquatic_cage_placement","label":"Cage Placement"},{"type":"text","name":"survey_aquatic_cage_setting_times","label":"Setting times"},{"type":"text","name":"survey_aquatic_cage_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_aquatic_cage","label":"Cage"},{"conditions":{"on":[{"type":"text","name":"survey_aquatic_box_make","label":"Make"},{"type":"text","name":"survey_aquatic_box_size","label":"Size"},{"type":"number","name":"survey_aquatic_num_boxs","label":"Number of traps"},{"type":"text","name":"survey_aquatic_box_placement","label":"Box Placement"},{"type":"text","name":"survey_aquatic_box_setting_times","label":"Setting times"},{"type":"text","name":"survey_aquatic_box_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_aquatic_box","label":"Box"},{"conditions":{"on":[{"type":"text","name":"survey_aquatic_trap_type_other","label":"Enter details"},{"type":"text","name":"survey_aquatic_trap_other_make","label":"Make"},{"type":"text","name":"survey_aquatic_trap_other_size","label":"Size"},{"type":"number","name":"survey_aquatic_trap_other_num_traps","label":"Number of traps"},{"type":"text","name":"survey_aquatic_trap_other_placement","label":"Trap Placement"},{"type":"text","name":"survey_aquatic_trap_other_setting_times","label":"Setting times"},{"type":"text","name":"survey_aquatic_trap_other_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_aquatic_trap_other","label":"Other"}],"hand":[{"type":"label","name":"survey_aquatic_hand_capture_techniques","label":"What hand capture techniques will you be using?"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_foraging_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_aquatic_foraging","label":"Foraging"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_excavation_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_aquatic_excavation","label":"Excavation"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_excavation_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_aquatic_other_hand_capture_techniques","label":"Other"}]},"options":[{"value":"trap","label":"Trap"},{"value":"net","label":"Net"},{"value":"hand","label":"Hand"},{"value":"other","label":"Other"}],"type":"radiobuttons","name":"survey_aquatic_capture_method","label":"Capture Method"},{"type":"label","name":"survey_aquatic_fate","label":"What will be the fate(s) of the fauna captured?"},{"conditions":{"on":[{"options":[{"value":"immediately","label":"Immediately after species idenfication"},{"value":"after_morphometrics","label":"After morphometrics and physical condition taken"},{"value":"after_samples","label":"After samples taken"},{"value":"after_marking","label":"After marking"},{"value":"after_temp_holding","label":"After temporary holding (< 24 hours)"}],"type":"select","name":"survey_aquatic_release_schedule","label":"Release Schedule"},{"type":"label","name":"survey_aquatic_pre_release_occurences","label":"Which of the following will occur before release?"},{"conditions":{"on":[{"type":"label","name":"survey_aquatic_mophometrics_recorded","label":"What morphometrics and condition details will be recorded?"},{"type":"checkbox","name":"survey_aquatic_mophometric_length","label":"Length"},{"type":"checkbox","name":"survey_aquatic_mophometric_sex","label":"Sex"},{"type":"checkbox","name":"survey_aquatic_mophometric_age","label":"Age"},{"type":"checkbox","name":"survey_aquatic_mophometric_body_condition","label":"Body condition"},{"type":"checkbox","name":"survey_aquatic_mophometric_reproductive_condition","label":"Reproductive condition"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_mophometric_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_mophometric_other","label":"Other"},{"type":"text_area","name":"survey_aquatic_mophometric_other_details","label":"Provide any other details relating to measurements and condition"}]},"type":"checkbox","name":"survey_aquatic_mophometrics","label":"Mophometrics and physical condition analysis"},{"conditions":{"on":[{"type":"label","name":"survey_aquatic_samples","label":"What samples will be taken?"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_tissue_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_tissue","label":"Tissue"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_scale_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_scale","label":"Scale"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_hair_feather_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_hair_feather","label":"Hair / feather"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_blood_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_blood","label":"Blood"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_swabs_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_swabs","label":"Swabs"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_samples_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_samples_other","label":"Other"}]},"type":"checkbox","name":"survey_aquatic_sampling","label":"Sampling"},{"conditions":{"on":[{"conditions":{"permanent":[{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_tags_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_tags","label":"Tags"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_microchips_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_microchips","label":"Microchips / implants"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_bands_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_bands","label":"Bands"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_ear_punching_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_ear_punching","label":"Ear punching"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_marking_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_aquatic_marking_other","label":"Other"}]},"options":[{"value":"temporary","label":"Temporary"},{"value":"permanent","label":"Permanent"}],"type":"select","name":"survey_aquatic_marking","label":"What marking will be done and why?"}]},"type":"checkbox","name":"survey_aquatic_marking","label":"Marking"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_why_temporarily_held","label":"Why will/may the fauna be temporarily held?"},{"type":"text_area","name":"survey_aquatic_how_temporarily_held","label":"How will the fauna be held?"},{"type":"text_area","name":"survey_aquatic_where_temporarily_held","label":"Where will the fauna be held?"},{"type":"text_area","name":"survey_aquatic_transported_details","label":"If fauna will be transported, provide details?"},{"conditions":{"other":[{"type":"text_area","name":"survey_aquatic_fauna_release_other_details","label":"Please provide details"}]},"options":[{"value":"at_capture_site","label":"At capture site"},{"value":"near_capture_site","label":"Near capture site into suitable habitat"},{"value":"other","label":"Other"}],"type":"select","name":"survey_aquatic_where_fauna_released","label":"Where will the fauna be released?"}]},"type":"checkbox","name":"survey_aquatic_temporary_holding","label":"Temporary Holding"}]},"type":"checkbox","name":"survey_aquatic_release","label":"Release"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_why_fauna_retained","label":"Why does the fauna need to be retained?"},{"type":"text_area","name":"survey_aquatic_what_fauna_retained","label":"What fauna could be retained?"},{"type":"number","name":"survey_aquatic_num_fauna_retained","label":"If fauna is to be retained, how many animals?"},{"conditions":{"yes":[{"type":"text_area","name":"survey_aquatic_euthanise_method","label":"Method"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_aquatic_fauna_euthanised","label":"Will fauna be euthanised?"},{"type":"text","name":"survey_aquatic_where_specimen_stored","label":"Where will the specimen(s) be held/lodged/stored?"},{"type":"text_area","name":"survey_aquatic_mesuem_storage_details","label":"If specimen is to be deposited at the WA Museum, will the Museum be contacted prior to the fauna being retained or did the Museum request the specimen?"}]},"type":"checkbox","name":"survey_aquatic_retain","label":"Retain"},{"type":"text_area","name":"survey_aquatic_unforseen_injury_dealings","label":"Describe how unforeseen injuries or other related issues will be dealt with."},{"type":"text_area","name":"survey_aquatic_hygiene_disease_considerations","label":"Provide details of field hygiene and wildlife disease considerations."},{"type":"text_area","name":"survey_aquatic_fauna_capture_other_details","label":"Provide other details relating to fauna capture."}],"other":[{"type":"label","name":"survey_aquatic_non_capture_method","label":"Please select any non-capture survey method you will be using"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_secondary_signs_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_aquatic_secondary_signs","label":"Secondary signs / evidence"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_habitat_assessment_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_aquatic_habitat_assessment","label":"Habitat Assessment"},{"conditions":{"on":[{"type":"text_area","name":"survey_aquatic_non_capture_other_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_aquatic_non_capture_other","label":"Other"}],"remote_sensing":[{"type":"label","name":"survey_aquatic_remote_sensing_apparatus","label":"What remote sensing apparatus will you be using?"},{"conditions":{"on":[{"conditions":{"yes":[{"type":"text","name":"survey_aquatic_what_bait","label":"What bait will be used?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_aquatic_bait_consumable","label":"Will the bait be consumable?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_aquatic_bait_replenished","label":"Will the bait be replenished?"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_aquatic_camera_baited","label":"Will cameras be baited with an attractant/lure?"},{"children":[{"type":"text","name":"survey_aquatic_camera_make","label":"Make"},{"type":"number","name":"survey_aquatic_num_cameras","label":"Number of devices"},{"type":"text_area","name":"survey_aquatic_camera_placement","label":"Camera Placement"},{"type":"text","name":"survey_aquatic_camera_situ","label":"How long in situ"},{"type":"text","name":"survey_aquatic_camera_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_aquatic_camera_information","label":"Camera Information"}]},"type":"checkbox","name":"survey_aquatic_camera","label":"Camera"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_aquatic_acr_make","label":"Make"},{"type":"number","name":"survey_aquatic_num_acrs","label":"Number of devices"},{"type":"text","name":"survey_aquatic_acr_placement","label":"Acoustic recorder Placement"},{"type":"text","name":"survey_aquatic_acr_situ","label":"How long in situ"},{"type":"text","name":"survey_aquatic_acr_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_aquatic_acoustic_call_recorder_information","label":"Acoustic recorder Information"}]},"type":"checkbox","name":"survey_aquatic_acoustic_recorder","label":"Acoustic recorder"},{"type":"text_area","name":"survey_aquatic_remote_sensing_other_details","label":"Provide any other details relating to remote sensing."}]},"options":[{"value":"capture","label":"Capture"},{"value":"remote_sensing","label":"Remote Sensing"},{"value":"other","label":"Other non-capture"}],"type":"radiobuttons","name":"survey_aquatic_survey_method","label":"What survey method will you be using?"}]},"type":"checkbox","name":"survey_aquatic","label":"Aquatic (non-marine)"},{"conditions":{"on":[{"conditions":{"capture":[{"conditions":{"net":[{"type":"number","name":"survey_marine_num_net_sites","label":"What is the number of sites where nets will be used?"},{"type":"number","name":"survey_marine_num_net_days","label":"How many days/nights will nets be used?"},{"type":"number","name":"survey_marine_num_net_sessions","label":"How many sessions will nets be used?"},{"type":"number","name":"survey_marine_num_nets_per_session","label":"Total number of nets per session?"},{"type":"number","name":"survey_marine_max_num_nets_per_session_per_site","label":"Maximum total number of nets per site per session?"},{"type":"text_area","name":"survey_marine_different_num_nets_per_session_or_site_explanation","label":"If the number of nets differs between sessions or sites then explain"},{"type":"label","name":"survey_marine_nets","label":"Nets"},{"conditions":{"on":[{"type":"text","name":"survey_marine_dip_make","label":"Make"},{"type":"text","name":"survey_marine_dip_size","label":"Size"},{"type":"number","name":"survey_marine_num_dips","label":"Number of nets"},{"type":"text","name":"survey_marine_dip_placement","label":"Net Placement"},{"type":"text","name":"survey_marine_dip_setting_times","label":"Setting times"},{"type":"text","name":"survey_marine_dip_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_marine_dip","label":"Dip"},{"conditions":{"on":[{"type":"text","name":"survey_marine_sweep_make","label":"Make"},{"type":"text","name":"survey_marine_sweep_size","label":"Size"},{"type":"number","name":"survey_marine_num_sweeps","label":"Number of nets"},{"type":"text","name":"survey_marine_sweep_placement","label":"Net Placement"},{"type":"text","name":"survey_marine_sweep_setting_times","label":"Setting times"},{"type":"text","name":"survey_marine_sweep_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_marine_sweep","label":"Sweep"},{"conditions":{"on":[{"type":"text","name":"survey_marine_gill_make","label":"Make"},{"type":"text","name":"survey_marine_gill_size","label":"Size"},{"type":"number","name":"survey_marine_num_gills","label":"Number of nets"},{"type":"text","name":"survey_marine_gill_placement","label":"Net Placement"},{"type":"text","name":"survey_marine_gill_setting_times","label":"Setting times"},{"type":"text","name":"survey_marine_gill_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_marine_gill","label":"Gill"},{"conditions":{"on":[{"type":"text","name":"survey_marine_seine_make","label":"Make"},{"type":"text","name":"survey_marine_seine_size","label":"Size"},{"type":"number","name":"survey_marine_num_seines","label":"Number of nets"},{"type":"text","name":"survey_marine_seine_placement","label":"Net Placement"},{"type":"text","name":"survey_marine_seine_setting_times","label":"Setting times"},{"type":"text","name":"survey_marine_seine_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_marine_seine","label":"Seine"},{"conditions":{"on":[{"type":"text","name":"survey_marine_cast_make","label":"Make"},{"type":"text","name":"survey_marine_cast_size","label":"Size"},{"type":"number","name":"survey_marine_num_casts","label":"Number of nets"},{"type":"text","name":"survey_marine_cast_placement","label":"Net Placement"},{"type":"text","name":"survey_marine_cast_setting_times","label":"Setting times"},{"type":"text","name":"survey_marine_cast_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_marine_cast","label":"Cast"},{"conditions":{"on":[{"type":"text","name":"survey_marine_plankton_make","label":"Make"},{"type":"text","name":"survey_marine_plankton_size","label":"Size"},{"type":"number","name":"survey_marine_num_planktons","label":"Number of nets"},{"type":"text","name":"survey_marine_plankton_placement","label":"Net Placement"},{"type":"text","name":"survey_marine_plankton_setting_times","label":"Setting times"},{"type":"text","name":"survey_marine_plankton_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_marine_plankton","label":"Plankton"},{"conditions":{"on":[{"type":"text","name":"survey_marine_net_type_other","label":"Enter details"},{"type":"text","name":"survey_marine_net_other_make","label":"Make"},{"type":"text","name":"survey_marine_net_other_size","label":"Size"},{"type":"number","name":"survey_marine_net_other_num_nets","label":"Number of nets"},{"type":"text","name":"survey_marine_net_other_placement","label":"Net Placement"},{"type":"text","name":"survey_marine_net_other_setting_times","label":"Setting times"},{"type":"text","name":"survey_marine_net_other_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_marine_net_other","label":"Other"}],"other":[{"type":"text_area","name":"survey_marine_other_capture_methodology","label":"Provide details of your fauna capture methodology if it doesn’t fit within previous questions for trap, net or hand capture techniques."}],"trap":[{"type":"number","name":"survey_marine_num_trap_sites","label":"What is the number of trap sites?"},{"type":"number","name":"survey_marine_num_traps_open_days","label":"How many days/nights will traps be open?"},{"type":"number","name":"survey_marine_num_trap_sessions","label":"How many trapping sessions?"},{"type":"number","name":"survey_marine_num_traps_per_session","label":"Total number of traps per session?"},{"type":"number","name":"survey_marine_max_num_traps_per_session_per_site","label":"Maximum total number of traps per site per session?"},{"type":"text_area","name":"survey_marine_different_num_traps_per_session_or_site_explanation","label":"If the number of traps differs between sessions or sites, enter the highest number in the questions above, and explain differences below."},{"type":"label","name":"survey_marine_traps","label":"Traps"},{"conditions":{"on":[{"type":"text","name":"survey_marine_cage_make","label":"Make"},{"type":"text","name":"survey_marine_cage_size","label":"Size"},{"type":"number","name":"survey_marine_num_cages","label":"Number of traps"},{"type":"text","name":"survey_marine_cage_placement","label":"Cage Placement"},{"type":"text","name":"survey_marine_cage_setting_times","label":"Setting times"},{"type":"text","name":"survey_marine_cage_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_marine_cage","label":"Cage"},{"conditions":{"on":[{"type":"text","name":"survey_marine_box_make","label":"Make"},{"type":"text","name":"survey_marine_box_size","label":"Size"},{"type":"number","name":"survey_marine_num_boxs","label":"Number of traps"},{"type":"text","name":"survey_marine_box_placement","label":"Box Placement"},{"type":"text","name":"survey_marine_box_setting_times","label":"Setting times"},{"type":"text","name":"survey_marine_box_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_marine_box","label":"Box"},{"conditions":{"on":[{"type":"text","name":"survey_marine_trap_type_other","label":"Enter details"},{"type":"text","name":"survey_marine_trap_other_make","label":"Make"},{"type":"text","name":"survey_marine_trap_other_size","label":"Size"},{"type":"number","name":"survey_marine_trap_other_num_traps","label":"Number of traps"},{"type":"text","name":"survey_marine_trap_other_placement","label":"Trap Placement"},{"type":"text","name":"survey_marine_trap_other_setting_times","label":"Setting times"},{"type":"text","name":"survey_marine_trap_other_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_marine_trap_other","label":"Other"}],"hand":[{"type":"label","name":"survey_marine_hand_capture_techniques","label":"What hand capture techniques will you be using?"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_foraging_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_marine_foraging","label":"Foraging"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_excavation_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_marine_excavation","label":"Excavation"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_excavation_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_marine_other_hand_capture_techniques","label":"Other"}]},"options":[{"value":"trap","label":"Trap"},{"value":"net","label":"Net"},{"value":"hand","label":"Hand"},{"value":"other","label":"Other"}],"type":"radiobuttons","name":"survey_marine_capture_method","label":"Capture Method"},{"type":"label","name":"survey_marine_fate","label":"What will be the fate(s) of the fauna captured?"},{"conditions":{"on":[{"options":[{"value":"immediately","label":"Immediately after species idenfication"},{"value":"after_morphometrics","label":"After morphometrics and physical condition taken"},{"value":"after_samples","label":"After samples taken"},{"value":"after_marking","label":"After marking"},{"value":"after_temp_holding","label":"After temporary holding (< 24 hours)"}],"type":"select","name":"survey_marine_release_schedule","label":"Release Schedule"},{"type":"label","name":"survey_marine_pre_release_occurences","label":"Which of the following will occur before release?"},{"conditions":{"on":[{"type":"label","name":"survey_marine_mophometrics_recorded","label":"What morphometrics and condition details will be recorded?"},{"type":"checkbox","name":"survey_marine_mophometric_length","label":"Length"},{"type":"checkbox","name":"survey_marine_mophometric_sex","label":"Sex"},{"type":"checkbox","name":"survey_marine_mophometric_age","label":"Age"},{"type":"checkbox","name":"survey_marine_mophometric_body_condition","label":"Body condition"},{"type":"checkbox","name":"survey_marine_mophometric_reproductive_condition","label":"Reproductive condition"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_mophometric_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_mophometric_other","label":"Other"},{"type":"text_area","name":"survey_marine_mophometric_other_details","label":"Provide any other details relating to measurements and condition"}]},"type":"checkbox","name":"survey_marine_mophometrics","label":"Mophometrics and physical condition analysis"},{"conditions":{"on":[{"type":"label","name":"survey_marine_samples","label":"What samples will be taken?"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_tissue_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_tissue","label":"Tissue"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_scale_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_scale","label":"Scale"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_hair_feather_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_hair_feather","label":"Hair / feather"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_blood_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_blood","label":"Blood"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_swabs_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_swabs","label":"Swabs"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_samples_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_samples_other","label":"Other"}]},"type":"checkbox","name":"survey_marine_sampling","label":"Sampling"},{"conditions":{"on":[{"conditions":{"permanent":[{"conditions":{"on":[{"type":"text_area","name":"survey_marine_tags_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_tags","label":"Tags"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_microchips_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_microchips","label":"Microchips / implants"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_bands_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_bands","label":"Bands"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_ear_punching_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_ear_punching","label":"Ear punching"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_marking_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_marine_marking_other","label":"Other"}]},"options":[{"value":"temporary","label":"Temporary"},{"value":"permanent","label":"Permanent"}],"type":"select","name":"survey_marine_marking","label":"What marking will be done and why?"}]},"type":"checkbox","name":"survey_marine_marking","label":"Marking"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_why_temporarily_held","label":"Why will/may the fauna be temporarily held?"},{"type":"text_area","name":"survey_marine_how_temporarily_held","label":"How will the fauna be held?"},{"type":"text_area","name":"survey_marine_where_temporarily_held","label":"Where will the fauna be held?"},{"type":"text_area","name":"survey_marine_transported_details","label":"If fauna will be transported, provide details?"},{"conditions":{"other":[{"type":"text_area","name":"survey_marine_fauna_release_other_details","label":"Please provide details"}]},"options":[{"value":"at_capture_site","label":"At capture site"},{"value":"near_capture_site","label":"Near capture site into suitable habitat"},{"value":"other","label":"Other"}],"type":"select","name":"survey_marine_where_fauna_released","label":"Where will the fauna be released?"}]},"type":"checkbox","name":"survey_marine_temporary_holding","label":"Temporary Holding"}]},"type":"checkbox","name":"survey_marine_release","label":"Release"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_why_fauna_retained","label":"Why does the fauna need to be retained?"},{"type":"text_area","name":"survey_marine_what_fauna_retained","label":"What fauna could be retained?"},{"type":"number","name":"survey_marine_num_fauna_retained","label":"If fauna is to be retained, how many animals?"},{"conditions":{"yes":[{"type":"text_area","name":"survey_marine_euthanise_method","label":"Method"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_marine_fauna_euthanised","label":"Will fauna be euthanised?"},{"type":"text","name":"survey_marine_where_specimen_stored","label":"Where will the specimen(s) be held/lodged/stored?"},{"type":"text_area","name":"survey_marine_mesuem_storage_details","label":"If specimen is to be deposited at the WA Museum, will the Museum be contacted prior to the fauna being retained or did the Museum request the specimen?"}]},"type":"checkbox","name":"survey_marine_retain","label":"Retain"},{"type":"text_area","name":"survey_marine_unforseen_injury_dealings","label":"Describe how unforeseen injuries or other related issues will be dealt with."},{"type":"text_area","name":"survey_marine_hygiene_disease_considerations","label":"Provide details of field hygiene and wildlife disease considerations."},{"type":"text_area","name":"survey_marine_fauna_capture_other_details","label":"Provide other details relating to fauna capture."}],"other":[{"type":"label","name":"survey_marine_non_capture_method","label":"Please select any non-capture survey method you will be using"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_secondary_signs_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_marine_secondary_signs","label":"Secondary signs / evidence"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_habitat_assessment_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_marine_habitat_assessment","label":"Habitat Assessment"},{"conditions":{"on":[{"type":"text_area","name":"survey_marine_non_capture_other_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_marine_non_capture_other","label":"Other"}],"remote_sensing":[{"type":"label","name":"survey_marine_remote_sensing_apparatus","label":"What remote sensing apparatus will you be using?"},{"conditions":{"on":[{"conditions":{"yes":[{"type":"text","name":"survey_marine_what_bait","label":"What bait will be used?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_marine_bait_consumable","label":"Will the bait be consumable?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_marine_bait_replenished","label":"Will the bait be replenished?"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_marine_camera_baited","label":"Will cameras be baited with an attractant/lure?"},{"children":[{"type":"text","name":"survey_marine_camera_make","label":"Make"},{"type":"number","name":"survey_marine_num_cameras","label":"Number of devices"},{"type":"text_area","name":"survey_marine_camera_placement","label":"Camera Placement"},{"type":"text","name":"survey_marine_camera_situ","label":"How long in situ"},{"type":"text","name":"survey_marine_camera_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_marine_camera_information","label":"Camera Information"}]},"type":"checkbox","name":"survey_marine_camera","label":"Camera"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_marine_acr_make","label":"Make"},{"type":"number","name":"survey_marine_num_acrs","label":"Number of devices"},{"type":"text","name":"survey_marine_acr_placement","label":"Acoustic recorder Placement"},{"type":"text","name":"survey_marine_acr_situ","label":"How long in situ"},{"type":"text","name":"survey_marine_acr_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_marine_acoustic_call_recorder_information","label":"Acoustic recorder Information"}]},"type":"checkbox","name":"survey_marine_acoustic_recorder","label":"Acoustic recorder"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_marine_aerial_make","label":"Make"},{"type":"number","name":"survey_marine_num_aerials","label":"Number of devices"},{"type":"text","name":"survey_marine_aerial_placement","label":"Aerial Placement"},{"type":"text","name":"survey_marine_aerial_situ","label":"How long in situ"},{"type":"text","name":"survey_marine_aerial_other_details","label":"Other details"}],"type":"group","name":"survey_marine_aerial_information","label":"Aerial Information"}]},"type":"checkbox","name":"survey_marine_aerial","label":"Aerial"},{"type":"text_area","name":"survey_marine_remote_sensing_other_details","label":"Provide any other details relating to remote sensing."}]},"options":[{"value":"capture","label":"Capture"},{"value":"remote_sensing","label":"Remote Sensing"},{"value":"other","label":"Other non-capture"}],"type":"radiobuttons","name":"survey_marine_survey_method","label":"What survey method will you be using?"}]},"type":"checkbox","name":"survey_marine","label":"Marine"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_tft_group_name","label":"Group name"},{"speciesType":"fauna","type":"species","name":"survey_tft_scientific_name","label":"Scientific or common name"},{"type":"text","name":"survey_tft_quantity","label":"Quantity"},{"type":"text","name":"survey_tft_fate","label":"Fate"}],"isRepeatable":true,"type":"group","name":"survey_targeted_fauna","label":"Targeted Fauna Type"},{"conditions":{"capture":[{"conditions":{"net":[{"type":"number","name":"survey_targeted_num_net_sites","label":"What is the number of sites where nets will be used?"},{"type":"number","name":"survey_targeted_num_net_days","label":"How many days/nights will nets be used?"},{"type":"number","name":"survey_targeted_num_net_sessions","label":"How many sessions will nets be used?"},{"type":"number","name":"survey_targeted_num_nets_per_session","label":"Total number of nets per session?"},{"type":"number","name":"survey_targeted_max_num_nets_per_session_per_site","label":"Maximum total number of nets per site per session?"},{"type":"text_area","name":"survey_targeted_different_num_nets_per_session_or_site_explanation","label":"If the number of nets differs between sessions or sites then explain"},{"type":"label","name":"survey_targeted_nets","label":"Nets"},{"conditions":{"on":[{"type":"text","name":"survey_targeted_sweep_make","label":"Make"},{"type":"text","name":"survey_targeted_sweep_size","label":"Size"},{"type":"number","name":"survey_targeted_num_sweeps","label":"Number of nets"},{"type":"text","name":"survey_targeted_sweep_placement","label":"Net Placement"},{"type":"text","name":"survey_targeted_sweep_setting_times","label":"Setting times"},{"type":"text","name":"survey_targeted_sweep_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_targeted_sweep","label":"Sweep"},{"conditions":{"on":[{"type":"text","name":"survey_targeted_mist_make","label":"Make"},{"type":"text","name":"survey_targeted_mist_size","label":"Size"},{"type":"number","name":"survey_targeted_num_mists","label":"Number of nets"},{"type":"text","name":"survey_targeted_mist_placement","label":"Net Placement"},{"type":"text","name":"survey_targeted_mist_setting_times","label":"Setting times"},{"type":"text","name":"survey_targeted_mist_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_targeted_mist","label":"Mist"},{"conditions":{"on":[{"type":"text","name":"survey_targeted_harp_make","label":"Make"},{"type":"text","name":"survey_targeted_harp_size","label":"Size"},{"type":"number","name":"survey_targeted_num_harps","label":"Number of nets"},{"type":"text","name":"survey_targeted_harp_placement","label":"Net Placement"},{"type":"text","name":"survey_targeted_harp_setting_times","label":"Setting times"},{"type":"text","name":"survey_targeted_harp_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_targeted_harp","label":"Harp"},{"conditions":{"on":[{"type":"text","name":"survey_targeted_net_type_other","label":"Enter details"},{"type":"text","name":"survey_targeted_net_other_make","label":"Make"},{"type":"text","name":"survey_targeted_net_other_size","label":"Size"},{"type":"number","name":"survey_targeted_net_other_num_nets","label":"Number of nets"},{"type":"text","name":"survey_targeted_net_other_placement","label":"Net Placement"},{"type":"text","name":"survey_targeted_net_other_setting_times","label":"Setting times"},{"type":"text","name":"survey_targeted_net_other_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_targeted_net_other","label":"Other"}],"other":[{"type":"text_area","name":"survey_targeted_other_capture_methodology","label":"Provide details of your fauna capture methodology if it doesn’t fit within previous questions for trap, net or hand capture techniques."}],"trap":[{"type":"number","name":"survey_targeted_num_trap_sites","label":"What is the number of trap sites?"},{"type":"number","name":"survey_targeted_num_traps_open_days","label":"How many days/nights will traps be open?"},{"type":"number","name":"survey_targeted_num_trap_sessions","label":"How many trapping sessions?"},{"type":"number","name":"survey_targeted_num_traps_per_session","label":"Total number of traps per session?"},{"type":"number","name":"survey_targeted_max_num_traps_per_session_per_site","label":"Maximum total number of traps per site per session?"},{"type":"text_area","name":"survey_targeted_different_num_traps_per_session_or_site_explanation","label":"If the number of traps differs between sessions or sites, enter the highest number in the questions above, and explain differences below."},{"type":"label","name":"survey_targeted_traps","label":"Traps"},{"conditions":{"on":[{"type":"text","name":"survey_targeted_cage_make","label":"Make"},{"type":"text","name":"survey_targeted_cage_size","label":"Size"},{"type":"number","name":"survey_targeted_num_cages","label":"Number of traps"},{"type":"text","name":"survey_targeted_cage_placement","label":"Cage Placement"},{"type":"text","name":"survey_targeted_cage_setting_times","label":"Setting times"},{"type":"text","name":"survey_targeted_cage_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_targeted_cage","label":"Cage"},{"conditions":{"on":[{"type":"text","name":"survey_targeted_box_make","label":"Make"},{"type":"text","name":"survey_targeted_box_size","label":"Size"},{"type":"number","name":"survey_targeted_num_boxs","label":"Number of traps"},{"type":"text","name":"survey_targeted_box_placement","label":"Box Placement"},{"type":"text","name":"survey_targeted_box_setting_times","label":"Setting times"},{"type":"text","name":"survey_targeted_box_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_targeted_box","label":"Box"},{"conditions":{"on":[{"type":"text","name":"survey_targeted_dry_pit_make","label":"Make"},{"type":"text","name":"survey_targeted_dry_pit_size","label":"Size"},{"type":"number","name":"survey_targeted_num_dry_pits","label":"Number of traps"},{"type":"text","name":"survey_targeted_dry_pit_placement","label":"Dry Pit Placement"},{"type":"text","name":"survey_targeted_dry_pit_setting_times","label":"Setting times"},{"type":"text","name":"survey_targeted_dry_pit_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_targeted_dry_pit","label":"Dry Pit"},{"conditions":{"on":[{"type":"text","name":"survey_targeted_funnel_make","label":"Make"},{"type":"text","name":"survey_targeted_funnel_size","label":"Size"},{"type":"number","name":"survey_targeted_num_funnels","label":"Number of traps"},{"type":"text","name":"survey_targeted_funnel_placement","label":"Funnel Placement"},{"type":"text","name":"survey_targeted_funnel_setting_times","label":"Setting times"},{"type":"text","name":"survey_targeted_funnel_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_targeted_funnel","label":"Funnel"},{"conditions":{"on":[{"type":"text","name":"survey_targeted_trap_type_other","label":"Enter details"},{"type":"text","name":"survey_targeted_trap_other_make","label":"Make"},{"type":"text","name":"survey_targeted_trap_other_size","label":"Size"},{"type":"number","name":"survey_targeted_trap_other_num_traps","label":"Number of traps"},{"type":"text","name":"survey_targeted_trap_other_placement","label":"Trap Placement"},{"type":"text","name":"survey_targeted_trap_other_setting_times","label":"Setting times"},{"type":"text","name":"survey_targeted_trap_other_other_details","label":"Other details"}]},"type":"checkbox","name":"survey_targeted_trap_other","label":"Other"}],"hand":[{"type":"label","name":"survey_targeted_hand_capture_techniques","label":"What hand capture techniques will you be using?"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_hook_and_bag_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_targeted_hook_and_bag","label":"Hook and Bag"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_Noose_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_targeted_noose","label":"Noose"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_foraging_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_targeted_foraging","label":"Foraging"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_raking_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_targeted_raking","label":"Raking"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_sieving_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_targeted_sieving","label":"Sieving"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_excavation_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_targeted_excavation","label":"Excavation"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_excavation_details","label":"Please Provide Details"}]},"type":"checkbox","name":"survey_targeted_other_hand_capture_techniques","label":"Other"}]},"options":[{"value":"trap","label":"Trap"},{"value":"net","label":"Net"},{"value":"hand","label":"Hand"},{"value":"other","label":"Other"}],"type":"radiobuttons","name":"survey_targeted_capture_method","label":"Capture Method"},{"type":"label","name":"survey_targeted_fate","label":"What will be the fate(s) of the fauna captured?"},{"conditions":{"on":[{"options":[{"value":"immediately","label":"Immediately after species idenfication"},{"value":"after_morphometrics","label":"After morphometrics and physical condition taken"},{"value":"after_samples","label":"After samples taken"},{"value":"after_marking","label":"After marking"},{"value":"after_temp_holding","label":"After temporary holding (< 24 hours)"}],"type":"select","name":"survey_targeted_release_schedule","label":"Release Schedule"},{"type":"label","name":"survey_targeted_pre_release_occurences","label":"Which of the following will occur before release?"},{"conditions":{"on":[{"type":"label","name":"survey_targeted_mophometrics_recorded","label":"What morphometrics and condition details will be recorded?"},{"type":"checkbox","name":"survey_targeted_mophometric_length","label":"Length"},{"type":"checkbox","name":"survey_targeted_mophometric_sex","label":"Sex"},{"type":"checkbox","name":"survey_targeted_mophometric_age","label":"Age"},{"type":"checkbox","name":"survey_targeted_mophometric_body_condition","label":"Body condition"},{"type":"checkbox","name":"survey_targeted_mophometric_reproductive_condition","label":"Reproductive condition"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_mophometric_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_mophometric_other","label":"Other"},{"type":"text_area","name":"survey_targeted_mophometric_other_details","label":"Provide any other details relating to measurements and condition"}]},"type":"checkbox","name":"survey_targeted_mophometrics","label":"Mophometrics and physical condition analysis"},{"conditions":{"on":[{"type":"label","name":"survey_targeted_samples","label":"What samples will be taken?"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_tissue_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_tissue","label":"Tissue"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_scale_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_scale","label":"Scale"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_hair_feather_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_hair_feather","label":"Hair / feather"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_blood_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_blood","label":"Blood"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_swabs_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_swabs","label":"Swabs"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_samples_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_samples_other","label":"Other"}]},"type":"checkbox","name":"survey_targeted_sampling","label":"Sampling"},{"conditions":{"on":[{"conditions":{"permanent":[{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_tags_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_tags","label":"Tags"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_microchips_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_microchips","label":"Microchips / implants"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_bands_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_bands","label":"Bands"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_ear_punching_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_ear_punching","label":"Ear punching"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_marking_other_details","label":"Please provide details"}]},"type":"checkbox","name":"survey_targeted_marking_other","label":"Other"}]},"options":[{"value":"temporary","label":"Temporary"},{"value":"permanent","label":"Permanent"}],"type":"select","name":"survey_targeted_marking","label":"What marking will be done and why?"}]},"type":"checkbox","name":"survey_targeted_marking","label":"Marking"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_why_temporarily_held","label":"Why will/may the fauna be temporarily held?"},{"type":"text_area","name":"survey_targeted_how_temporarily_held","label":"How will the fauna be held?"},{"type":"text_area","name":"survey_targeted_where_temporarily_held","label":"Where will the fauna be held?"},{"type":"text_area","name":"survey_targeted_transported_details","label":"If fauna will be transported, provide details?"},{"conditions":{"other":[{"type":"text_area","name":"survey_targeted_fauna_release_other_details","label":"Please provide details"}]},"options":[{"value":"at_capture_site","label":"At capture site"},{"value":"near_capture_site","label":"Near capture site into suitable habitat"},{"value":"other","label":"Other"}],"type":"select","name":"survey_targeted_where_fauna_released","label":"Where will the fauna be released?"}]},"type":"checkbox","name":"survey_targeted_temporary_holding","label":"Temporary Holding"}]},"type":"checkbox","name":"survey_targeted_release","label":"Release"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_why_fauna_retained","label":"Why does the fauna need to be retained?"},{"type":"text_area","name":"survey_targeted_what_fauna_retained","label":"What fauna could be retained?"},{"type":"number","name":"survey_targeted_num_fauna_retained","label":"If fauna is to be retained, how many animals?"},{"conditions":{"yes":[{"type":"text_area","name":"survey_targeted_euthanise_method","label":"Method"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_targeted_fauna_euthanised","label":"Will fauna be euthanised?"},{"type":"text","name":"survey_targeted_where_specimen_stored","label":"Where will the specimen(s) be held/lodged/stored?"},{"type":"text_area","name":"survey_targeted_mesuem_storage_details","label":"If specimen is to be deposited at the WA Museum, will the Museum be contacted prior to the fauna being retained or did the Museum request the specimen?"}]},"type":"checkbox","name":"survey_targeted_retain","label":"Retain"},{"type":"text_area","name":"survey_targeted_prevent_vertebre_by_catch","label":"Describe measures that will be used to prevent/minimise vertebrate by-catch"},{"type":"text_area","name":"survey_targeted_hygiene_disease_considerations","label":"Provide details of field hygiene and wildlife disease considerations."},{"type":"text_area","name":"survey_targeted_fauna_capture_other_details","label":"Provide other details relating to fauna capture."}],"other":[{"type":"label","name":"survey_targeted_non_capture_method","label":"Please select any non-capture survey method you will be using"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_aural_survey_details","label":"Please provide Details"},{"conditions":{"yes":[{"type":"text_area","name":"survey_targeted_call_playback_details","label":"Please provide Details"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_targeted_call_playback","label":"Will call play-back be used?"}]},"type":"checkbox","name":"survey_targeted_aural_survey","label":"Aural survey"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_bird_census_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_targeted_bird_census","label":"Bird Census"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_spotlighting_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_targeted_spotlighting","label":"Spotlighting / head torching"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_hair_tubes_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_targeted_hair_tubes","label":"Hair tubes / sticky wicket"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_secondary_signs_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_targeted_secondary_signs","label":"Secondary signs / evidence"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_habitat_assessment_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_targeted_habitat_assessment","label":"Habitat Assessment"},{"conditions":{"on":[{"type":"text_area","name":"survey_targeted_non_capture_other_details","label":"Please provide Details"}]},"type":"checkbox","name":"survey_targeted_non_capture_other","label":"Other"}],"remote_sensing":[{"type":"label","name":"survey_targeted_remote_sensing_apparatus","label":"What remote sensing apparatus will you be using?"},{"conditions":{"on":[{"conditions":{"yes":[{"type":"text","name":"survey_targeted_what_bait","label":"What bait will be used?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_targeted_bait_consumable","label":"Will the bait be consumable?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_targeted_bait_replenished","label":"Will the bait be replenished?"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"survey_targeted_camera_baited","label":"Will cameras be baited with an attractant/lure?"},{"children":[{"type":"text","name":"survey_targeted_camera_make","label":"Make"},{"type":"number","name":"survey_targeted_num_cameras","label":"Number of devices"},{"type":"text_area","name":"survey_targeted_camera_placement","label":"Camera Placement"},{"type":"text","name":"survey_targeted_camera_situ","label":"How long in situ"},{"type":"text","name":"survey_targeted_camera_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_targeted_camera_information","label":"Camera Information"}]},"type":"checkbox","name":"survey_targeted_camera","label":"Camera"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_targeted_ubd_make","label":"Make"},{"type":"number","name":"survey_targeted_num_ubds","label":"Number of devices"},{"type":"text","name":"survey_targeted_ubd_placement","label":"Ultrasonic bat detector Placement"},{"type":"text","name":"survey_targeted_ubd_situ","label":"How long in situ"},{"type":"text","name":"survey_targeted_ubd_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_targeted_ultrasonic_bat_detector_information","label":"Ultrasonic Bat Detector Information"}]},"type":"checkbox","name":"survey_targeted_ultrasonic_bat_detector","label":"Ultrasonic bat detector"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_targeted_acr_make","label":"Make"},{"type":"number","name":"survey_targeted_num_acrs","label":"Number of devices"},{"type":"text","name":"survey_targeted_acr_placement","label":"Acoustic call recorder Placement"},{"type":"text","name":"survey_targeted_acr_situ","label":"How long in situ"},{"type":"text","name":"survey_targeted_acr_other_details","label":"Other details"}],"isRepeatable":true,"type":"group","name":"survey_targeted_acoustic_call_recorder_information","label":"Acoustic call recorder Information"}]},"type":"checkbox","name":"survey_targeted_acoustic_call_recorder","label":"Acoustic call recorder"},{"conditions":{"on":[{"children":[{"type":"text","name":"survey_targeted_aerial_make","label":"Make"},{"type":"number","name":"survey_targeted_num_aerials","label":"Number of devices"},{"type":"text","name":"survey_targeted_aerial_placement","label":"Aerial Placement"},{"type":"text","name":"survey_targeted_aerial_situ","label":"How long in situ"},{"type":"text","name":"survey_targeted_aerial_other_details","label":"Other details"}],"type":"group","name":"survey_targeted_aerial_information","label":"Aerial Information"}]},"type":"checkbox","name":"survey_targeted_aerial","label":"Aerial"},{"type":"text_area","name":"survey_targeted_remote_sensing_other_details","label":"Provide any other details relating to remote sensing."}]},"options":[{"value":"capture","label":"Capture"},{"value":"remote_sensing","label":"Remote Sensing"},{"value":"other","label":"Other non-capture"}],"type":"radiobuttons","name":"survey_targeted_survey_method","label":"What survey method will you be using?"}]},"type":"checkbox","name":"survey_targeted","label":"Targeted"},{"conditions":{"on":[{"type":"text","name":"survey_other_survey_type_details","label":"Provide details"}]},"type":"checkbox","name":"survey_other_survey_type","label":"Other"}]}],"research":[{"type":"label","name":"research_note_1","label":"Note: ‘Research’ as a licence project type should only be select if the proposed activity does not fit within the methodology for research or survey."},{"type":"label","name":"research_note_2","label":"Monitoring should be selected if your study includes capture-mark-recapture or fauna tracking. Usually with field sessions at regular or irregular intervals, and total project duration greater than 12 months."},{"type":"label","name":"research_note_2","label":"Survey should be selected if your study includes capture and release, for one or a few field sessions, and total project duration up to but not greater than 12 months."},{"conditions":{"field_and_laboratory":[{"type":"text_area","name":"research_lab_details","label":"Provide details of laboratory/facility"},{"type":"text_area","name":"research_animal_husbandry","label":"Provide specific details of animal husbandry"},{"type":"text_area","name":"research_fauna_activities","label":"Provide specific details of fauna related activities that are proposed to occur within the laboratory/facility"},{"type":"text_area","name":"research_fauna_hold_length","label":"How long will the fauna be held?"},{"conditions":{"research_release_wild":[{"type":"label","name":"research_fauna_release_details","label":"Provide details for the following"},{"type":"text_area","name":"research_fauna_release_risk_assessment","label":"Risk assessment (release of fauna back to the wild after being held and studied in a laboratory/facility poses a risk of disease/parasite introduction to the wild fauna)"},{"type":"text_area","name":"research_fauna_release_quarantine","label":"Quarantine and health check conditions prior to release"},{"type":"text_area","name":"research_fauna_release_site","label":"Proposed release site"},{"type":"text_area","name":"research_fauna_release_site_transportation","label":"Transportation to release site"},{"type":"text_area","name":"research_fauna_post_release_monitoring","label":"Post release monitoring"}],"research_euthanase":[{"type":"label","name":"research_fauna_euthanasia_details","label":"Method of euthanasia"},{"conditions":{"yes":[{"type":"text_area","name":"research_fauna_stored","label":"Where will the specimen(s) be held/lodged/stored?"}],"no":[{"type":"text_area","name":"research_fauna_disposal","label":"Provide details of disposal"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"research_fauna_retained_specimen","label":"Will the fauna be retained as a specimen?"}]},"options":[{"value":"research_transfer_alive","label":"Transfer alive to another project"},{"value":"research_release_wild","label":"Release to the wild"},{"value":"research_euthanase","label":"Euthanase"}],"type":"radiobuttons","name":"research_fauna_final_fate","label":"What is the final fate of fauna that has been in the laboratory/specialised facility?"},{"type":"text_area","name":"research_lab_other_details","label":"Provide any other details relating to the Laboratory/specialised facility component"}]},"options":[{"value":"field_component_only","label":"Field component only"},{"value":"field_and_laboratory","label":"Field and laboratory/specialised facility components"}],"type":"radiobuttons","name":"research_type","label":"Which of the following describes your research?"},{"type":"number","name":"research_num_research_locations","label":"At how many locations will your research occur?"},{"name":"research_details","isRepeatable":true,"help_text":"If multiple research locations; provide details separately for each location and add an additional location after activity questions.","label":"Monitoring Details","type":"group","children":[{"type":"text_area","name":"research_address","label":"Location / Address"},{"type":"text","name":"research_coordinates","label":"Coordinate / GPS"},{"children":[{"type":"date","name":"research_field_session_start_date","label":"Start Date"},{"type":"date","name":"research_field_session_end_date","label":"End Date"}],"isRepeatable":true,"type":"group","name":"research_field_session","label":"Field session"},{"type":"text","name":"research_field_dates_unknown","label":"If field dates are unknown, use anticipated field dates in the start and end date above and explain below."},{"conditions":{"on":[{"children":[{"type":"text","name":"research_tft_group_name","label":"Group name"},{"speciesType":"fauna","type":"species","name":"research_tft_scientific_name","label":"Scientific or common name"}],"isRepeatable":true,"type":"group","name":"research_targeted_fauna","label":"Targeted Fauna Type"}]},"type":"checkbox","name":"research_targeting_species_or_fauna","label":"Is the research targeting species or fauna group?"},{"conditions":{"yes":[{"children":[{"type":"text","name":"research_threatened_group_name","label":"Group name"},{"speciesType":"fauna","type":"species","name":"research_threatened_scientific_name","label":"Scientific or common name"}],"isRepeatable":true,"type":"group","name":"research_threatened_fauna","label":"Threatened Fauna"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"},{"value":"unknown","label":"Unknown"}],"type":"radiobuttons","name":"research_threatened_priority_fauna","label":"Will your activity possibly interact with any threatened or priority fauna (including non-target species)?"},{"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"research_standard_operating_procedures","label":"Will your activities be in accordance with Parks and Wildlife standard operating procedures?"},{"conditions":{"yes":[{"type":"text","name":"research_sops_details","label":"Provide details"},{"type":"file","name":"research_sops_documents","label":"Attach a copy of the relevent document(s)"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"research_sops","label":"Will your activities be in accordance with any other SOPs, protocols, guidelines or manuals?"},{"type":"label","name":"research_field_component","label":"Field component"},{"conditions":{"on":[{"type":"text","name":"research_non_capture_details","label":"Provide specific details of non-capture methodology"}]},"type":"checkbox","name":"research_non_capture","label":"Non-capture"},{"conditions":{"on":[{"type":"text","name":"research_capture_details","label":"Provide specific details of capture methodology"}]},"type":"checkbox","name":"research_capture","label":"Capture"},{"type":"label","name":"research_fate","label":"What will be the fate(s) of the fauna captured?"},{"conditions":{"on":[{"options":[{"value":"immediately","label":"Immediately after species idenfication"},{"value":"after_transmitter_attachment","label":"After attachment of transmitter"},{"value":"after_morphometrics","label":"After morphometrics and physical condition taken"},{"value":"after_samples","label":"After samples taken"},{"value":"after_marking","label":"After marking"},{"value":"after_temp_holding","label":"After temporary holding (< 24 hours)"}],"type":"select","name":"research_release_schedule","label":"Release Schedule"},{"type":"label","name":"research_pre_release_occurences","label":"Which of the following will occur before release?"},{"conditions":{"on":[{"type":"text_area","name":"research_prerelease_transmitter_type","label":"Transmitter type, make and model, and construction material"},{"type":"text_area","name":"research_prerelease_method_attachment","label":"Method of attachment to animal"},{"type":"text","name":"research_prerelease_transmitter_max_weight","label":"Maximum weight of transmitter and attachment materials"},{"type":"text","name":"research_prerelease_mim_body_weight","label":"Minimum body weight of animal to which transmitter will be attached"},{"type":"text","name":"research_prerelease_transmitter_attachment_length","label":"How long will the transmitter remain attached to the animal?"},{"conditions":{"yes":[{"type":"declaration","name":"research_prerelease_acknowledge","label":"I acknowledge that every attempt will be made to recapture the animal to remove the transmitter, and will notify Wildlife Licensing if this cannot be done."}],"no":[{"type":"text_area","name":"research_prerelease_detach_details","label":"Provide details of how the transmitter will detach from the animal"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"research_prerelease_recapture_remove","label":"Does the animal need to be recaptured to remove the transmitter?"}]},"type":"checkbox","name":"research_release_transmitter","label":"Attachment of transmitter"},{"conditions":{"on":[{"type":"label","name":"research_mophometrics_recorded","label":"What morphometrics and condition details will be recorded?"},{"type":"checkbox","name":"research_mophometric_length","label":"Length"},{"type":"checkbox","name":"research_mophometric_sex","label":"Sex"},{"type":"checkbox","name":"research_mophometric_age","label":"Age"},{"type":"checkbox","name":"research_mophometric_body_condition","label":"Body condition"},{"type":"checkbox","name":"research_mophometric_reproductive_condition","label":"Reproductive condition"},{"conditions":{"on":[{"type":"text_area","name":"research_mophometric_other_details","label":"Please provide details"}]},"type":"checkbox","name":"research_mophometric_other","label":"Other"},{"type":"text_area","name":"research_mophometric_other_details","label":"Provide any other details relating to measurements and condition"}]},"type":"checkbox","name":"research_mophometrics","label":"Mophometrics and physical condition analysis"},{"conditions":{"on":[{"type":"label","name":"research_samples","label":"What samples will be taken?"},{"conditions":{"on":[{"type":"text_area","name":"research_tissue_details","label":"Please provide details"}]},"type":"checkbox","name":"research_tissue","label":"Tissue"},{"conditions":{"on":[{"type":"text_area","name":"research_scale_details","label":"Please provide details"}]},"type":"checkbox","name":"research_scale","label":"Scale"},{"conditions":{"on":[{"type":"text_area","name":"research_hair_feather_details","label":"Please provide details"}]},"type":"checkbox","name":"research_hair_feather","label":"Hair / feather"},{"conditions":{"on":[{"type":"text_area","name":"research_blood_details","label":"Please provide details"}]},"type":"checkbox","name":"research_blood","label":"Blood"},{"conditions":{"on":[{"type":"text_area","name":"research_swabs_details","label":"Please provide details"}]},"type":"checkbox","name":"research_swabs","label":"Swabs"},{"conditions":{"on":[{"type":"text_area","name":"research_samples_other_details","label":"Please provide details"}]},"type":"checkbox","name":"research_samples_other","label":"Other"}]},"type":"checkbox","name":"research_sampling","label":"Sampling"},{"conditions":{"on":[{"conditions":{"permanent":[{"conditions":{"on":[{"type":"text_area","name":"research_tags_details","label":"Please provide details"}]},"type":"checkbox","name":"research_tags","label":"Tags"},{"conditions":{"on":[{"type":"text_area","name":"research_microchips_details","label":"Please provide details"}]},"type":"checkbox","name":"research_microchips","label":"Microchips / implants"},{"conditions":{"on":[{"type":"text_area","name":"research_bands_details","label":"Please provide details"}]},"type":"checkbox","name":"research_bands","label":"Bands"},{"conditions":{"on":[{"type":"text_area","name":"research_ear_punching_details","label":"Please provide details"}]},"type":"checkbox","name":"research_ear_punching","label":"Ear punching"},{"conditions":{"on":[{"type":"text_area","name":"research_marking_other_details","label":"Please provide details"}]},"type":"checkbox","name":"research_marking_other","label":"Other"}]},"options":[{"value":"temporary","label":"Temporary"},{"value":"permanent","label":"Permanent"}],"type":"select","name":"research_marking","label":"What marking will be done and why?"}]},"type":"checkbox","name":"research_marking","label":"Marking"},{"conditions":{"on":[{"type":"text_area","name":"research_why_temporarily_held","label":"Why will/may the fauna be temporarily held?"},{"type":"text_area","name":"research_how_temporarily_held","label":"How will the fauna be held?"},{"type":"text_area","name":"research_where_temporarily_held","label":"Where will the fauna be held?"},{"type":"text_area","name":"research_transported_details","label":"If fauna will be transported, provide details?"},{"conditions":{"other":[{"type":"text_area","name":"research_fauna_release_other_details","label":"Please provide details"},{"conditions":{"yes":[{"type":"text_area","name":"research_transportation_details","label":"Provide details of transportation"}],"no":[{"type":"text_area","name":"research_euthanasia_details","label":"Provide details on euthanasia"}]},"options":[{"value":"yes","label":"Yes"},{"value":"no","label":"No"}],"type":"radiobuttons","name":"research_retained_alived","label":"Will fauna will be retained alive for study in laboratory/specialised facility?"},{"type":"text","name":"research_where_specimen_stored","label":"Where will the specimen(s) be held/lodged/stored?"},{"type":"text_area","name":"research_unforseen_injury_dealings","label":"Describe how unforeseen injuries or other related issues will be dealt with."},{"type":"text_area","name":"research_hygiene_disease_considerations","label":"Provide details of field hygiene and wildlife disease considerations."},{"type":"text_area","name":"research_fauna_capture_other_details","label":"Provide other details relating to fauna capture."}]},"options":[{"value":"at_capture_site","label":"At capture site"},{"value":"near_capture_site","label":"Near capture site into suitable habitat"},{"value":"other","label":"Other"}],"type":"select","name":"research_where_fauna_released","label":"Where will the fauna be released?"}]},"type":"checkbox","name":"research_temporary_holding","label":"Temporary Holding"}]},"type":"checkbox","name":"research_release","label":"Release"},{"conditions":{"on":[{"type":"text_area","name":"research_species_retained","label":"Provide details on what species and how many individuals (per species) are to be retained"}]},"type":"checkbox","name":"research_retain","label":"Retain"}]}]},"options":[{"value":"survey","label":"Survey"},{"value":"monitoring","label":"Monitoring"},{"value":"research","label":"Research"}],"defaultBlank":true}],"type":"section","name":"project_description","label":"Project Description"}]

/***/ }),
/* 353 */,
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment) {

var _momentRange = __webpack_require__(792);

var _jszip = __webpack_require__(774);

var _jszip2 = _interopRequireDefault(_jszip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(79)();
__webpack_require__(166)();
__webpack_require__(748)(window, $);
__webpack_require__(167)(window, $);
__webpack_require__(747)(window, $, _jszip2.default);

__webpack_require__(750);
__webpack_require__(751);

__webpack_require__(629);

__webpack_require__(773);

(0, _momentRange.extendMoment)(moment);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1068);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _manage_my_user_details = __webpack_require__(904);

var _manage_my_user_details2 = _interopRequireDefault(_manage_my_user_details);

var _profile_dashboard = __webpack_require__(906);

var _profile_dashboard2 = _interopRequireDefault(_profile_dashboard);

var _profile_create = __webpack_require__(905);

var _profile_create2 = _interopRequireDefault(_profile_create);

var _profile_manage = __webpack_require__(907);

var _profile_manage2 = _interopRequireDefault(_profile_manage);

var _routes = __webpack_require__(535);

var _routes2 = _interopRequireDefault(_routes);

var _routes3 = __webpack_require__(536);

var _routes4 = _interopRequireDefault(_routes3);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
    mode: 'history',
    routes: [{
        path: '/firsttime',
        name: 'first-time',
        component: _manage_my_user_details2.default
    }, {
        path: '/account',
        name: 'account',
        component: _manage_my_user_details2.default
    }, {
        path: '/profiles',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: '/',
            component: _profile_dashboard2.default,
            name: "profiles-dash"
        }, {
            path: 'create',
            component: _profile_create2.default,
            name: "profile-create"
        }, {
            path: ':profile_id',
            component: _profile_manage2.default,
            name: "profile-detail"
        }]
    }, _routes2.default, _routes4.default]
});
router.beforeEach(function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(to, from, next) {
        var res, isComplianceManagementCallemailReadonlyUser;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return _vue2.default.http.get(_hooks.api_endpoints.is_compliance_management_callemail_readonly_user);

                    case 2:
                        res = _context.sent;
                        isComplianceManagementCallemailReadonlyUser = res.body.compliance_management_callemail_readonly_user;

                        if (!["first-time", "account", "internal-call-email-dash", "view-call-email"].includes(to.name) && isComplianceManagementCallemailReadonlyUser) {
                            next({ name: "internal-call-email-dash" });
                        } else next();

                    case 5:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}());
exports.default = router;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(627);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _vuex2 = _interopRequireDefault(_vuex);

var _application = __webpack_require__(538);

var _user = __webpack_require__(550);

var _renderer = __webpack_require__(546);

var _returns = __webpack_require__(547);

var _returns_renderer = __webpack_require__(548);

var _call_email = __webpack_require__(539);

var _offence = __webpack_require__(543);

var _inspection = __webpack_require__(541);

var _sanction_outcome = __webpack_require__(549);

var _remediation_action = __webpack_require__(545);

var _legal_case = __webpack_require__(542);

var _document_artifact = __webpack_require__(540);

var _physical_artifact = __webpack_require__(544);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
	state: {},
	mutations: {},
	getters: {},
	modules: {
		appStore: _application.applicationStore,
		userStore: _user.userStore,
		rendererStore: _renderer.rendererStore,
		returnsStore: _returns.returnsStore,
		returnsRendererStore: _returns_renderer.returnsRendererStore,
		callemailStore: _call_email.callemailStore,
		offenceStore: _offence.offenceStore,
		inspectionStore: _inspection.inspectionStore,
		sanctionOutcomeStore: _sanction_outcome.sanctionOutcomeStore,
		remediationActionStore: _remediation_action.remediationActionStore,
		legalCaseStore: _legal_case.legalCaseStore,
		documentArtifactStore: _document_artifact.documentArtifactStore,
		physicalArtifactStore: _physical_artifact.physicalArtifactStore
	}
});

/***/ }),
/* 357 */,
/* 358 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(636)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(920),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(949),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(1060),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'app'
};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Add-Comms',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default
    },
    props: {
        url: {
            type: String,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        return {
            isModalOpen: false,
            form: null,
            comms: {},
            state: 'proposed_licence',
            addingComms: false,
            validation_form: null,
            errors: false,
            errorString: '',
            successString: '',
            success: false,
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            files: [{
                'file': null,
                'name': ''
            }]
        };
    },
    computed: {
        showError: function showError() {
            var vm = this;
            return vm.errors;
        },
        title: function title() {
            return this.processing_status.id == 'with_approver' ? 'Issue Comms' : 'Propose to issue licence';
        }
    },
    methods: {
        ok: function ok() {
            var vm = this;
            if ($(vm.form).valid()) {
                vm.sendData();
            }
        },
        uploadFile: function uploadFile(target, file_obj) {
            var vm = this;
            var _file = null;
            var input = $('.' + target)[0];
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = input.files[0];
            }
            file_obj.file = _file;
            file_obj.name = _file.name;
        },
        removeFile: function removeFile(index) {
            var _this = this;

            var length = this.files.length;
            $('.file-row-' + index).remove();
            this.files.splice(index, 1);
            this.$nextTick(function () {
                length == 1 ? _this.attachAnother() : '';
            });
        },
        attachAnother: function attachAnother() {
            this.files.push({
                'file': null,
                'name': ''
            });
        },

        cancel: function cancel() {
            this.close();
        },
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
            this.comms = {};
            this.errors = false;
            $('.has-error').removeClass('has-error');
            this.validation_form.resetForm();
            var file_length = vm.files.length;
            this.files = [];
            for (var i = 0; i < file_length; i++) {
                vm.$nextTick(function () {
                    $('.file-row-' + i).remove();
                });
            }
            this.attachAnother();
        },
        sendData: function sendData() {
            var vm = this;
            vm.errors = false;
            var comms = new FormData(vm.form);
            vm.addingComms = true;
            vm.$http.post(vm.url, comms, {}).then(function (response) {
                vm.addingComms = false;
                vm.close();
            }, function (error) {
                vm.errors = true;
                vm.addingComms = false;
                vm.errorString = _hooks.helpers.apiVueResourceError(error);
            });
        },
        addFormValidations: function addFormValidations() {
            var vm = this;
            vm.validation_form = $(vm.form).validate({
                rules: {
                    to: "required",
                    fromm: "required",
                    type: "required",
                    subject: "required",
                    text: "required"
                },
                messages: {},
                showErrors: function showErrors(errorMap, errorList) {
                    $.each(this.validElements(), function (index, element) {
                        var $element = $(element);
                        $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                    });

                    $("." + this.settings.validClass).tooltip("destroy");

                    for (var i = 0; i < errorList.length; i++) {
                        var error = errorList[i];
                        $(error.element).tooltip({
                            trigger: "focus"
                        }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                    }
                }
            });
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.form = document.forms.commsForm;
        vm.addFormValidations();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Add-Organisation-Contact',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default
    },
    props: {
        org_id: {
            type: Number
        }
    },
    data: function data() {
        var vm = this;
        return {
            isModalOpen: false,
            form: null,
            contact: {},
            errors: false,
            errorString: '',
            successString: '',
            success: false
        };
    },
    computed: {
        showError: function showError() {
            var vm = this;
            return vm.errors;
        }
    },
    methods: {
        ok: function ok() {
            var vm = this;
            if ($(vm.form).valid()) {
                vm.sendData();
            }
        },
        cancel: function cancel() {},
        close: function close() {
            this.isModalOpen = false;
            this.contact = {};
            this.errors = false;
            this.form.reset();
        },
        fetchContact: function fetchContact(id) {
            var vm = this;
            vm.$http.get(_hooks.api_endpoints.contact(id)).then(function (response) {
                vm.contact = response.body;vm.isModalOpen = true;
            }, function (error) {
                console.log(error);
            });
        },
        sendData: function sendData() {
            var vm = this;
            vm.errors = false;

            if (vm.contact.id) {
                var contact = vm.contact;
                vm.$http.put(_hooks.api_endpoints.organisation_contacts(contact.id), (0, _stringify2.default)(contact), {
                    emulateJSON: true
                }).then(function (response) {
                    vm.close();
                }, function (error) {
                    console.log(error);
                    vm.errors = true;
                    vm.errorString = _hooks.helpers.apiVueResourceError(error);
                });
            } else {
                var _contact = JSON.parse((0, _stringify2.default)(vm.contact));
                _contact.organisation = vm.org_id;
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org_id + '/add_nonuser_contact'), (0, _stringify2.default)(_contact), {
                    emulateJSON: true
                }).then(function (response) {
                    vm.close();
                    vm.$parent.addedContact();
                }, function (error) {
                    console.log(error);
                    vm.errors = true;
                    vm.errorString = _hooks.helpers.apiVueResourceError(error);
                });
            }
        },
        addFormValidations: function addFormValidations() {
            var vm = this;
            $(vm.form).validate({
                rules: {
                    arrival: "required",
                    departure: "required",
                    campground: "required",
                    campsite: {
                        required: {
                            depends: function depends(el) {
                                return vm.campsites.length > 0;
                            }
                        }
                    }
                },
                messages: {
                    arrival: "field is required",
                    departure: "field is required",
                    campground: "field is required",
                    campsite: "field is required"
                },
                showErrors: function showErrors(errorMap, errorList) {
                    $.each(this.validElements(), function (index, element) {
                        var $element = $(element);
                        $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                    });

                    $("." + this.settings.validClass).tooltip("destroy");

                    for (var i = 0; i < errorList.length; i++) {
                        var error = errorList[i];
                        $(error.element).tooltip({
                            trigger: "focus"
                        }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                    }
                }
            });
        },
        eventListerners: function eventListerners() {
            var vm = this;
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.form = document.forms.addContactForm;
        vm.addFormValidations();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

__webpack_require__(347);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    name: 'ApplicationTableDash',
    props: {
        level: {
            type: String,
            required: true,
            validator: function validator(val) {
                var options = ['internal', 'external'];
                return options.indexOf(val) != -1 ? true : false;
            }
        },
        url: {
            type: String,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        var internal_application_headers = ["Number", "Category", "Activity", "Type", "Submitter", "Applicant", "Status", "Payment Status", "Lodged on", "Action"];
        var internal_columns = [{
            data: "lodgement_number",
            width: "10%",
            className: "app-row-icon"
        }, {
            data: "category_name",
            width: "10%",
            className: "normal-white-space",
            orderable: false,
            searchable: false }, {
            data: "purpose_string",
            width: "30%",
            mRender: function mRender(data, type, full) {
                var output = data.replace(/(?:\r\n|\r|\n|,)/g, '<br>');
                return output;
            },
            orderable: false,

            name: "licence_purposes__name"
        }, {
            data: "application_type",
            width: "10%",
            mRender: function mRender(data, type, full) {
                return data.name;
            },
            searchable: false
        }, {
            data: "submitter",
            visible: false,
            className: "normal-white-space",
            name: "submitter__first_name, submitter__last_name, submitter__email",
            mRender: function mRender(data, type, full) {
                if (data) {
                    return data.first_name + " " + data.last_name;
                }
                return '';
            }
        }, {
            data: "applicant",
            width: "10%",
            className: "normal-white-space",
            orderable: false,
            searchable: false }, {
            data: "processing_status",
            width: "10%",
            className: "normal-white-space",
            mRender: function mRender(data, type, full) {
                return data.name;
            },
            orderable: false,
            searchable: false }, {
            data: "payment_status",
            visible: false,
            orderable: false,
            searchable: false }, {
            data: "lodgement_date",
            width: "10%",
            mRender: function mRender(data, type, full) {
                return data != '' && data != null ? moment(data).format(vm.dateFormat) : '';
            },
            searchable: false }, {
            width: "10%",
            mRender: function mRender(data, type, full) {
                var links = '';
                if (!vm.is_external) {
                    var finalised = ['approved', 'declined', 'awaiting_payment'].includes(full.processing_status.id);
                    links += full.can_be_processed && full.user_in_officers ? "<a href='/internal/application/" + full.id + "'>Process</a><br/>" : "<a href='/" + (!vm.is_external ? 'internal' : 'external') + "/application/" + full.id + "'>View</a><br/>";
                }
                if (!vm.is_external && vm.canViewPayments && ['paid', 'partially_paid'].includes(full.payment_status)) {
                    links += "<a href='" + full.all_payments_url + "' target='_blank' >View Payment</a><br/>";
                }
                if (!vm.is_external && vm.canViewPayments && full.payment_status == 'under_paid') {
                    links = '';
                    links += "<a href='" + full.all_payments_url + "' target='_blank' >Record Payment</a><br/>";
                }
                if (!vm.is_external && vm.canViewPayments && full.payment_status == 'over_paid') {
                    links += "<a href='" + full.all_payments_url + "' target='_blank' >Refund Payment</a><br/>";
                }
                if (vm.is_external) {
                    if (full.can_current_user_edit) {
                        links += "<a href='/external/application/" + full.id + "'>Continue</a><br/>";
                    }
                    if (vm.canDiscardApplication(full)) {
                        links += "<a href='#" + full.id + "' data-discard-application='" + full.id + "'>Discard</a><br/>";
                    }
                }
                return links;
            },
            orderable: false,
            searchable: false
        }];

        var external_columns = [{
            data: "lodgement_number",
            width: "10%",
            className: "app-row-icon"
        }, {
            data: "category_name",
            width: "10%",
            orderable: false,
            searchable: false }, {
            data: "purpose_string",
            width: "30%",
            mRender: function mRender(data, type, full) {
                var output = data.replace(/(?:\r\n|\r|\n|,)/g, '<br>');
                return output;
            },
            orderable: false,
            searchable: false }, {
            data: "application_type",
            width: "10%",
            mRender: function mRender(data, type, full) {
                return data.name;
            }
        }, {
            data: "submitter",
            visible: false,
            name: "submitter__first_name, submitter__last_name, submitter__email",
            mRender: function mRender(data, type, full) {
                if (data) {
                    return data.first_name + " " + data.last_name;
                }
                return '';
            }
        }, {
            data: "applicant",
            width: "10%",
            className: "normal-white-space",
            orderable: false,
            searchable: false }, {
            data: "customer_status",
            width: "10%",
            mRender: function mRender(data, type, full) {
                return data.name;
            },
            className: "normal-white-space",
            orderable: false,
            searchable: false }, {
            data: "lodgement_date",
            width: "10%",
            mRender: function mRender(data, type, full) {
                return data != '' && data != null ? moment(data).format(vm.dateFormat) : '';
            },
            className: "normal-white-space",
            searchable: false }, {
            width: "10%",
            mRender: function mRender(data, type, full) {
                var links = '';
                if (!vm.is_external) {
                    links += "<a href='/internal/application/" + full.id + "'>View</a><br/>";
                } else {
                    if (full.can_current_user_edit) {
                        links += "<a href='/external/application/" + full.id + "'>Continue</a><br/>";
                    }
                    if (vm.canDiscardApplication(full)) {
                        links += "<a href='#" + full.id + "' data-discard-application='" + full.id + "'>Discard</a><br/>";
                    }
                    if (full.can_user_view) {
                        links += "<a href='/external/application/" + full.id + "'>View</a><br/>";
                    }
                    if (full.can_pay_application) {
                        links += "<a href='#" + full.id + "' data-pay-application-fee='" + full.id + "'>Pay Application Fee</a><br/>";
                    }
                    if (full.can_pay_licence) {
                        links += "<a href='#" + full.id + "' data-pay-application-licence-fee='" + full.id + "' pay-licence-fee-for='" + full.pay_activity_id + "'>Pay Additional Fee</a><br/>";
                    }
                }
                return links;
            },
            orderable: false,
            searchable: false
        }];
        return {
            pBody: 'pBody' + vm._uid,
            datatable_id: 'application-datatable-' + vm._uid,

            filterApplicationLicenceType: 'All',
            filterApplicationStatus: 'All',
            filterApplicationLodgedFrom: '',
            filterApplicationLodgedTo: '',
            filterApplicationSubmitter: 'All',
            filterApplicationActivity: 'All',
            dateFormat: 'DD/MM/YYYY',
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            application_licence_types: [],
            application_submitters: [],

            application_status: [],

            application_ex_headers: ["Number", "Category", "Activity", "Type", "Submitter", "Applicant", "Status", "Lodged on", "Action"],
            application_ex_options: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                autoWidth: false,
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                rowCallback: function rowCallback(row, data) {
                    $(row).addClass('appRecordRow');
                },
                responsive: false,
                ajax: {
                    "url": vm.url,
                    "dataSrc": 'data',

                    "data": function data(d) {
                        d.category_name = vm.filterApplicationLicenceType;
                        d.customer_status = vm.filterApplicationStatus.id;
                        d.submitter = vm.filterApplicationSubmitter;
                        d.date_from = vm.filterApplicationLodgedFrom != '' && vm.filterApplicationLodgedFrom != null ? moment(vm.filterApplicationLodgedFrom, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                        d.date_to = vm.filterApplicationLodgedTo != '' && vm.filterApplicationLodgedTo != null ? moment(vm.filterApplicationLodgedTo, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                        d.activity_purpose = vm.filterApplicationActivity;
                    }
                },
                columns: external_columns,
                processing: true,
                initComplete: function initComplete() {
                    var $searchInput = $('div.dataTables_filter input');
                    $searchInput.unbind('keyup search input');
                    $searchInput.bind('keypress', vm.delay(function (e) {
                        if (e.which == 13) {
                            vm.visibleDatatable.vmDataTable.search(this.value).draw();
                        }
                    }, 0));

                    var submittersColumn = vm.visibleDatatable.vmDataTable.columns(vm.getColumnIndex('submitter'));
                    submittersColumn.data().unique().sort().each(function (d, j) {
                        var submitters = [];
                        $.each(d, function (index, s) {
                            if (!submitters.find(function (submitter) {
                                return submitter.email == s.email;
                            }) || submitters.length == 0) {
                                submitters.push({
                                    'email': s.email,
                                    'search_term': s.first_name + " " + s.last_name + " (" + s.email + ")"
                                });
                            }
                        });
                        vm.application_submitters = submitters;
                    });
                }
            },
            application_headers: internal_application_headers,
            application_options: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                autoWidth: false,
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                rowCallback: function rowCallback(row, data) {
                    $(row).addClass('appRecordRow');
                },
                responsive: false,
                ajax: {
                    "url": vm.url,
                    "dataSrc": 'data',

                    "data": function data(d) {
                        d.category_name = vm.filterApplicationLicenceType;
                        d.processing_status = vm.filterApplicationStatus.id;
                        d.submitter = vm.filterApplicationSubmitter;
                        d.date_from = vm.filterApplicationLodgedFrom != '' && vm.filterApplicationLodgedFrom != null ? moment(vm.filterApplicationLodgedFrom, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                        d.date_to = vm.filterApplicationLodgedTo != '' && vm.filterApplicationLodgedTo != null ? moment(vm.filterApplicationLodgedTo, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                        d.activity_purpose = vm.filterApplicationActivity;
                    }
                },
                columns: internal_columns,
                processing: true,
                initComplete: function initComplete() {
                    var $searchInput = $('div.dataTables_filter input');
                    $searchInput.unbind('keyup search input');
                    $searchInput.bind('keypress', vm.delay(function (e) {
                        if (e.which == 13) {
                            vm.visibleDatatable.vmDataTable.search(this.value).draw();
                        }
                    }, 0));

                    var submittersColumn = vm.visibleDatatable.vmDataTable.columns(vm.getColumnIndex('submitter'));
                    submittersColumn.data().unique().sort().each(function (d, j) {
                        var submitters = [];
                        $.each(d, function (index, submitter) {
                            if (!submitters.find(function (item) {
                                return item.email == submitter.email || submitters.length == 0;
                            })) {
                                submitters.push({
                                    'email': submitter.email,
                                    'search_term': submitter.first_name + " " + submitter.last_name + " (" + submitter.email + ")"
                                });
                            }
                        });
                        vm.application_submitters = submitters;
                    });
                    var statusColumn = vm.visibleDatatable.vmDataTable.columns(vm.getColumnIndex('status'));
                    statusColumn.data().unique().sort().each(function (d, j) {
                        var statusTitles = [];
                        $.each(d, function (index, a) {
                            a != null && !statusTitles.filter(function (status) {
                                return status.id == a.id;
                            }).length ? statusTitles.push(a) : '';
                        });
                    });

                    vm.visibleDatatable.vmDataTable.columns.adjust().responsive.recalc();
                }
            },
            activities: [],
            application_activities: []
        };
    },

    components: {
        datatable: _datatable2.default
    },
    watch: {
        filterApplicationStatus: function filterApplicationStatus() {
            this.visibleDatatable.vmDataTable.draw();
        },
        filterApplicationSubmitter: function filterApplicationSubmitter() {
            this.visibleDatatable.vmDataTable.draw();
        },
        filterApplicationLodgedFrom: function filterApplicationLodgedFrom() {
            this.visibleDatatable.vmDataTable.draw();
        },
        filterApplicationLodgedTo: function filterApplicationLodgedTo() {
            this.visibleDatatable.vmDataTable.draw();
        },
        filterApplicationLicenceType: function filterApplicationLicenceType() {
            this.visibleDatatable.vmDataTable.draw();
        },
        filterApplicationActivity: function filterApplicationActivity() {
            this.visibleDatatable.vmDataTable.draw();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['canViewPayments', 'current_user', 'isIdentifiedUser']), {
        visibleHeaders: function visibleHeaders() {
            return this.is_external ? this.application_ex_headers : this.application_headers;
        },
        visibleDatatable: function visibleDatatable() {
            return this.is_external ? this.$refs.external_application_datatable : this.$refs.application_datatable;
        },
        is_external: function is_external() {
            return this.level == 'external';
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['loadCurrentUser']), {
        canDiscardApplication: function canDiscardApplication(application) {
            return application.processing_status.id === 'draft';
        },
        discardApplication: function discardApplication(application_id) {
            var vm = this;
            swal({
                title: "Discard Application",
                text: "Are you sure you want to discard this application?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: 'Discard Application',
                confirmButtonColor: '#d9534f'
            }).then(function (result) {
                if (result.value) {
                    vm.$http.delete(_hooks.api_endpoints.discard_application(application_id)).then(function (response) {
                        swal('Discarded', 'Your application has been discarded', 'success');
                        vm.visibleDatatable.vmDataTable.ajax.reload();
                    }, function (error) {
                        swal('Discard Error', _hooks.helpers.apiVueResourceError(error), 'error');
                    });
                }
            }, function (error) {});
        },
        delay: function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        },

        payLicenceFee: function payLicenceFee(application_id, activity_id) {
            this.$http.post(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications, application_id + '/licence_fee_checkout/'), {
                application_id: application_id,
                activity_id: activity_id
            }).then(function (res) {
                window.location.href = "/ledger/checkout/checkout/payment-details/";
            }, function (err) {
                swal('Submit Error', _hooks.helpers.apiVueResourceError(err), 'error');
            });
        },
        payApplicationFee: function payApplicationFee(application_id) {
            this.$http.post(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications, application_id + '/application_fee_checkout/'), application_id).then(function (res) {
                window.location.href = "/ledger/checkout/checkout/payment-details/";
            }, function (err) {
                swal('Submit Error', _hooks.helpers.apiVueResourceError(err), 'error');
            });
        },
        getActivities: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(application_id) {
                var _this = this;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.$http.post(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications, application_id + '/get_activities/'), {
                                    application_id: application_id
                                }).then(function (res) {

                                    _this.activities = res.body;
                                }, function (err) {
                                    swal('Get Activity Error', _hooks.helpers.apiVueResourceError(err), 'error');
                                });

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getActivities(_x) {
                return _ref.apply(this, arguments);
            }

            return getActivities;
        }(),
        addEventListeners: function addEventListeners() {
            var vm = this;

            $(vm.$refs.applicationDateToPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.applicationDateToPicker).on('dp.change', function (e) {
                if ($(vm.$refs.applicationDateToPicker).data('DateTimePicker').date()) {
                    vm.filterApplicationLodgedTo = e.date.format('DD/MM/YYYY');
                } else if ($(vm.$refs.applicationDateToPicker).data('date') === "") {
                    vm.filterApplicationLodgedTo = "";
                }
            });
            $(vm.$refs.applicationDateFromPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.applicationDateFromPicker).on('dp.change', function (e) {
                if ($(vm.$refs.applicationDateFromPicker).data('DateTimePicker').date()) {
                    vm.filterApplicationLodgedFrom = e.date.format('DD/MM/YYYY');
                    $(vm.$refs.applicationDateToPicker).data("DateTimePicker").minDate(e.date);
                } else if ($(vm.$refs.applicationDateFromPicker).data('date') === "") {
                    vm.filterApplicationLodgedFrom = "";
                    $(vm.$refs.applicationDateToPicker).data("DateTimePicker").minDate(false);
                }
            });

            vm.visibleDatatable.vmDataTable.on('click', 'a[data-discard-application]', function (e) {
                e.preventDefault();
                var id = $(this).attr('data-discard-application');
                vm.discardApplication(id);
            });

            vm.visibleDatatable.vmDataTable.on('click', 'a[data-pay-application-fee]', function (e) {
                e.preventDefault();
                var id = $(this).attr('data-pay-application-fee');
                vm.payApplicationFee(id);
            });

            vm.visibleDatatable.vmDataTable.on('click', 'a[data-pay-application-licence-fee]', function (e) {
                e.preventDefault();
                var activity_id = $(this).attr('pay-licence-fee-for');
                var application_id = $(this).attr('data-pay-application-licence-fee');
                vm.payLicenceFee(application_id, activity_id);
            });

            vm.visibleDatatable.vmDataTable.on('click', 'tr.appRecordRow', function () {
                var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(e) {
                    var tr, row, child_row, activity_rows, activity_invoice_url;
                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    if (!$(e.target).is('a')) {
                                        _context2.next = 2;
                                        break;
                                    }

                                    return _context2.abrupt("return");

                                case 2:
                                    tr = $(this);
                                    row = vm.visibleDatatable.vmDataTable.row(tr);
                                    _context2.next = 6;
                                    return vm.getActivities(row.data()['id']);

                                case 6:
                                    if (row.child.isShown()) {
                                        row.child.hide();
                                        tr.removeClass('shown');
                                    } else {
                                        child_row = '';
                                        activity_rows = '';
                                        activity_invoice_url = '';

                                        vm.activities.forEach(function (activity) {
                                            activity_rows += "\n                            <tr>\n                                <td>" + activity['activity_name_str'] + "</td>\n                                \n                                <td>" + activity['activity_purpose_names_status']['name_string'].replace(/(?:\r\n|\r|\n|,)/g, '<br>') + "</td>\n                                " + (vm.is_external ? '' : activity['officer_name'] == null ? "<td>&nbsp;</td>" : "<td>" + activity['officer_name'] + "</td>") + "    \n    \n                                " + (vm.is_external ? '' : "<td>" + activity['activity_purpose_names_status']['status_string'].replace(/(?:\r\n|\r|\n|,)/g, '<br>') + "</td>") + "\n\n                                " + (vm.is_external ? '' : "<td>" + (activity['can_pay_licence_fee'] ? "<a pay-licence-fee-for='" + activity['id'] + "' application-id='" + row.data()['id'] + "'>Pay licence fee</a>" : '') + "\n                                </td>") + "\n                            </tr>";
                                            activity_invoice_url = activity['invoice_url'];
                                        });

                                        child_row += "\n                        <table class=\"table table-striped table-bordered child-row-table\">\n                            <tr>\n                                <td class=\"width_20pc\"><strong>Submitter:&nbsp;</strong></td>\n                                <td>&nbsp;&nbsp;" + row.data()['submitter']['first_name'] + "\n                                    " + row.data()['submitter']['last_name'] + "</td>\n                            </tr>";

                                        child_row += "\n                            <tr>\n                                <td><strong>Payment Status:&nbsp;</strong></td>\n                                <td>&nbsp;&nbsp;" + row.data()['payment_status'] + "</td>\n                            </tr>\n                            " + (activity_invoice_url ? "<tr>\n                                <td><strong>Invoice:&nbsp;</strong></td>\n                                <td><a href=\"" + activity_invoice_url + "'\" target=\"_blank\"><i style=\"color:red\" class=\"fa fa-file-pdf-o\"></i></a></td>\n                            </tr>" : ' ') + " ";

                                        child_row += "</table>";
                                        child_row += "\n                        <table class=\"table table-striped table-bordered child-row-table\">\n                            <tr>\n                                <th>Activity</th>\n                                <th class=\"width_55pc\">Purposes</th>\n                                " + (vm.is_external ? '' : '<th class="width_20pc">Assigned Officer</th>') + "                            \n                                " + (vm.is_external ? '' : '<th class="width_10pc">Status</th>') + "\n                                " + (vm.is_external ? '' : '<th class="width_10pc">Action</th>') + "\n                            </tr>\n                            " + activity_rows + "\n                        </table>";

                                        row.child(child_row, 'dark-row').show();
                                        tr.addClass('shown');
                                    }

                                    row.on('click', 'a[pay-licence-fee-for]', function (e) {
                                        e.preventDefault();
                                        var activity_id = $(this).attr('pay-licence-fee-for');
                                        var application_id = $(this).attr('application-id');
                                        vm.payLicenceFee(application_id, activity_id);
                                    });

                                case 8:
                                case "end":
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));

                return function (_x2) {
                    return _ref2.apply(this, arguments);
                };
            }());
        },
        initialiseSearch: function initialiseSearch() {
            this.submitterSearch();
            this.dateSearch();
        },
        submitterSearch: function submitterSearch() {
            var vm = this;
            vm.visibleDatatable.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var filtered_submitter = vm.filterApplicationSubmitter;
                if (filtered_submitter == 'All') {
                    return true;
                }
                return filtered_submitter == original.submitter.email;
            });
        },
        dateSearch: function dateSearch() {
            var vm = this;
            vm.visibleDatatable.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var from = vm.filterApplicationLodgedFrom;
                var to = vm.filterApplicationLodgedTo;
                var val = original.lodgement_date;

                if (from == '' && to == '') {
                    return true;
                } else if (from != '' && to != '') {
                    return val != null && val != '' ? moment().range(moment(from, vm.dateFormat), moment(to, vm.dateFormat)).contains(moment(val)) : false;
                } else if (from == '' && to != '') {
                    if (val != null && val != '') {
                        return moment(to, vm.dateFormat).diff(moment(val)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (to == '' && from != '') {
                    if (val != null && val != '') {
                        return moment(val).diff(moment(from, vm.dateFormat)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            });
        },
        getColumnIndex: function getColumnIndex(column_name) {
            return this.visibleHeaders.map(function (header) {
                return header.toLowerCase();
            }).indexOf(column_name.toLowerCase());
        },
        initialiseSelects: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var _this2 = this;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$http.get(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications, '1/get_application_selects')).then(function (res) {

                                    _this2.application_status = res.body.all_status;
                                    _this2.application_licence_types = res.body.all_category;
                                    _this2.application_activities = res.body.all_activity;
                                }, function (err) {

                                    swal('Get Application Selects Error', _hooks.helpers.apiVueResourceError(err), 'error');
                                });

                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function initialiseSelects() {
                return _ref3.apply(this, arguments);
            }

            return initialiseSelects;
        }()
    }),
    mounted: function mounted() {
        var vm = this;
        vm.loadCurrentUser({ url: "/api/my_user_details" });
        $('a[data-toggle="collapse"]').on('click', function () {
            var chev = $(this).children()[0];
            window.setTimeout(function () {
                $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
            }, 100);
        });
        this.$nextTick(function () {
            vm.initialiseSearch();
            vm.addEventListeners();
            vm.initialiseSelects();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'AssessmentTableDash',
    data: function data() {
        var vm = this;
        return {
            pBody: 'pBody' + vm._uid,
            datatable_id: 'assessment-datatable-' + vm._uid,

            filterApplicationLicenceType: 'All',
            filterApplicationStatus: 'All',
            filterApplicationLodgedFrom: '',
            filterApplicationLodgedTo: '',
            filterApplicationSubmitter: 'All',
            dateFormat: 'DD/MM/YYYY',
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            application_status: [],
            application_licence_types: [],
            application_regions: [],
            application_submitters: [],
            assessment_headers: ["Number", "Licence Category", "Activity", "Type", "Submitter", "Applicant", "Status", "Lodged on", "Action"],
            assessment_options: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                tableID: 'assessment-datatable-' + vm._uid,
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.assessment_paginated, 'datatable_list/?format=datatables'),
                    "dataSrc": "data",

                    "data": function data(d) {
                        d.category_name = vm.filterApplicationLicenceType;
                        d.status = vm.filterApplicationStatus.id;
                        d.submitter = vm.filterApplicationSubmitter;
                        d.date_from = vm.filterApplicationLodgedFrom != '' && vm.filterApplicationLodgedFrom != null ? moment(vm.filterApplicationLodgedFrom, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                        d.date_to = vm.filterApplicationLodgedTo != '' && vm.filterApplicationLodgedTo != null ? moment(vm.filterApplicationLodgedTo, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                    }
                },
                columns: [{
                    data: "application",
                    name: "application__lodgement_number"
                }, {
                    data: "application_category",
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? '' + data : '';
                    },
                    orderable: false,
                    searchable: false }, {
                    data: "licence_activity",
                    mRender: function mRender(data, type, full) {
                        return data.id != '' && data.id != null ? '' + data.name : '';
                    },
                    orderable: false,
                    searchable: false }, {
                    data: "application_type",
                    mRender: function mRender(data, type, full) {
                        return data.name;
                    },
                    orderable: false,
                    searchable: false }, {
                    data: "submitter",
                    name: "application__submitter__first_name, application__submitter__last_name, application__submitter__email",
                    mRender: function mRender(data, type, full) {
                        if (data) {
                            return data.first_name + ' ' + data.last_name;
                        }
                        return '';
                    },
                    orderable: false,
                    searchable: false }, {
                    data: "applicant",
                    orderable: false,
                    searchable: false }, {
                    data: "status",
                    mRender: function mRender(data, type, full) {
                        return data.name;
                    },
                    orderable: false,
                    searchable: false }, {
                    data: "application_lodgement_date",
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format(vm.dateFormat) : '';
                    },
                    orderable: false,
                    searchable: false }, {
                    data: "can_be_processed",
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        links += full.can_be_processed ? '<a href=\'/internal/application/assessment/' + full.application_id + '\'>Process</a><br/>' : '<a href=\'/internal/application/assessment/' + full.application_id + '\'>View</a><br/>';
                        return links;
                    },
                    orderable: false,
                    searchable: false
                }],
                processing: true,
                initComplete: function initComplete() {
                    var titleColumn = vm.$refs.assessment_datatable.vmDataTable.columns(vm.getColumnIndex('licence category'));
                    titleColumn.data().unique().sort().each(function (d, j) {
                        var activityTitles = [];
                        $.each(d, function (index, a) {
                            a != null && activityTitles.indexOf(a) < 0 && a.length ? activityTitles.push(a) : '';
                        });
                        vm.application_licence_types = activityTitles;
                    });

                    var submittersColumn = vm.$refs.assessment_datatable.vmDataTable.columns(vm.getColumnIndex('submitter'));
                    submittersColumn.data().unique().sort().each(function (d, j) {
                        var submitters = [];
                        $.each(d, function (index, submitter) {
                            if (!submitters.find(function (item) {
                                return item.email == submitter.email;
                            }) || submitters.length == 0) {
                                submitters.push({
                                    'email': submitter.email,
                                    'search_term': submitter.first_name + ' ' + submitter.last_name + ' (' + submitter.email + ')'
                                });
                            }
                        });
                        vm.application_submitters = submitters;
                    });

                    var statusColumn = vm.$refs.assessment_datatable.vmDataTable.columns(vm.getColumnIndex('status'));
                    statusColumn.data().unique().sort().each(function (d, j) {
                        var statusTitles = [];
                        $.each(d, function (index, a) {
                            a != null && !statusTitles.filter(function (status) {
                                return status.id == a.id;
                            }).length ? statusTitles.push(a) : '';
                        });
                        vm.application_status = statusTitles;
                    });
                }
            }
        };
    },

    components: {
        datatable: _datatable2.default
    },
    watch: {
        filterApplicationActivity: function filterApplicationActivity() {
            var vm = this;
            if (vm.filterApplicationActivity != 'All') {
                vm.$refs.assessment_datatable.vmDataTable.columns(2).search(vm.filterApplicationActivity).draw();
            } else {
                vm.$refs.assessment_datatable.vmDataTable.columns(2).search('').draw();
            }
        },
        filterApplicationStatus: function filterApplicationStatus() {
            this.filterByColumn('status', this.filterApplicationStatus);
        },
        filterApplicationSubmitter: function filterApplicationSubmitter() {
            this.$refs.assessment_datatable.vmDataTable.draw();
        },
        filterApplicationLodgedFrom: function filterApplicationLodgedFrom() {
            this.$refs.assessment_datatable.vmDataTable.draw();
        },
        filterApplicationLodgedTo: function filterApplicationLodgedTo() {
            this.$refs.assessment_datatable.vmDataTable.draw();
        },
        filterApplicationLicenceType: function filterApplicationLicenceType() {
            this.filterByColumn('licence category', this.filterApplicationLicenceType);
        }
    },
    computed: {},
    methods: {
        addEventListeners: function addEventListeners() {
            var vm = this;

            $(vm.$refs.applicationDateToPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.applicationDateToPicker).on('dp.change', function (e) {
                if ($(vm.$refs.applicationDateToPicker).data('DateTimePicker').date()) {
                    vm.filterApplicationLodgedTo = e.date.format('DD/MM/YYYY');
                } else if ($(vm.$refs.applicationDateToPicker).data('date') === "") {
                    vm.filterapplicationodgedTo = "";
                }
            });
            $(vm.$refs.applicationDateFromPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.applicationDateFromPicker).on('dp.change', function (e) {
                if ($(vm.$refs.applicationDateFromPicker).data('DateTimePicker').date()) {
                    vm.filterApplicationLodgedFrom = e.date.format('DD/MM/YYYY');
                    $(vm.$refs.applicationDateToPicker).data("DateTimePicker").minDate(e.date);
                } else if ($(vm.$refs.applicationDateFromPicker).data('date') === "") {
                    vm.filterApplicationLodgedFrom = "";
                    $(vm.$refs.applicationDateToPicker).data("DateTimePicker").minDate(false);
                }
            });
        },
        initialiseSearch: function initialiseSearch() {
            this.submitterSearch();
            this.dateSearch();
        },
        submitterSearch: function submitterSearch() {
            var vm = this;
            vm.$refs.assessment_datatable.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var filtered_submitter = vm.filterApplicationSubmitter;
                if (filtered_submitter == 'All') {
                    return true;
                }
                return filtered_submitter == original.submitter.email;
            });
        },
        dateSearch: function dateSearch() {
            var vm = this;
            vm.$refs.assessment_datatable.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var from = vm.filterApplicationLodgedFrom;
                var to = vm.filterApplicationLodgedTo;
                var val = original.lodgement_date;
                if (from == '' && to == '') {
                    return true;
                } else if (from != '' && to != '') {
                    return val != null && val != '' ? moment().range(moment(from, vm.dateFormat), moment(to, vm.dateFormat)).contains(moment(val)) : false;
                } else if (from == '' && to != '') {
                    if (val != null && val != '') {
                        return moment(to, vm.dateFormat).diff(moment(val)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (to == '' && from != '') {
                    if (val != null && val != '') {
                        return moment(val).diff(moment(from, vm.dateFormat)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            });
        },
        getColumnIndex: function getColumnIndex(column_name) {
            return this.assessment_headers.map(function (header) {
                return header.toLowerCase();
            }).indexOf(column_name.toLowerCase());
        },
        filterByColumn: function filterByColumn(column, filterAttribute) {
            var column_idx = this.getColumnIndex(column);
            var filterValue = typeof filterAttribute == 'string' ? filterAttribute : filterAttribute.name;
            if (filterValue != 'All') {
                this.$refs.assessment_datatable.vmDataTable.columns(column_idx).search('^' + filterValue + '$', true, false).draw();
            } else {
                this.$refs.assessment_datatable.vmDataTable.columns(column_idx).search('').draw();
            }
        }
    },
    mounted: function mounted() {
        var vm = this;
        $('a[data-toggle="collapse"]').on('click', function () {
            var chev = $(this).children()[0];
            window.setTimeout(function () {
                $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
            }, 100);
        });
        this.$nextTick(function () {
            vm.addEventListeners();
            vm.initialiseSearch();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _add_comm_log = __webpack_require__(803);

var _add_comm_log2 = _interopRequireDefault(_add_comm_log);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'CommsLogSection',
    props: {
        comms_url: {
            type: String,
            required: true
        },
        logs_url: {
            type: String,
            required: true
        },
        comms_add_url: {
            type: String,
            required: true
        },
        disable_add_entry: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        var _actionsDtOptions;

        var vm = this;
        return {
            dateFormat: 'DD/MM/YYYY',
            actionsTable: null,
            popoversInitialised: false,
            actionsDtOptions: (_actionsDtOptions = {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                deferRender: true,
                autowidth: true,
                order: [[2, 'desc']],
                dom: "<'row'<'col-sm-5'l><'col-sm-6'f>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>",
                processing: true,
                ajax: {
                    "url": vm.logs_url,
                    "dataSrc": ''
                }
            }, (0, _defineProperty3.default)(_actionsDtOptions, 'order', []), (0, _defineProperty3.default)(_actionsDtOptions, 'columns', [{
                data: "who",
                orderable: false
            }, {
                data: "what",
                orderable: false
            }, {
                data: "when",
                orderable: false,
                mRender: function mRender(data, type, full) {
                    return moment(data).format(vm.DATE_TIME_FORMAT);
                }
            }]), _actionsDtOptions),
            commsDtOptions: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                deferRender: true,
                autowidth: true,
                order: [[0, 'desc']],
                processing: true,
                ajax: {
                    "url": vm.comms_url,
                    "dataSrc": ''
                },
                columns: [{
                    title: 'Date',
                    data: 'created',
                    render: function render(date) {
                        return moment(date).format(vm.DATE_TIME_FORMAT);
                    }
                }, {
                    title: 'Type',
                    data: 'log_type'
                }, {
                    title: 'Reference',
                    data: 'reference'
                }, {
                    title: 'To',
                    data: 'to',
                    render: vm.commaToNewline
                }, {
                    title: 'CC',
                    data: 'cc',
                    render: vm.commaToNewline
                }, {
                    title: 'From',
                    data: 'fromm',
                    render: vm.commaToNewline
                }, {
                    title: 'Subject/Desc.',
                    data: 'subject'
                }, {
                    title: 'Text',
                    data: 'text',
                    'render': function render(value) {
                        var ellipsis = '...',
                            truncated = _.truncate(value, {
                            length: 100,
                            omission: ellipsis,
                            separator: ' '
                        }),
                            result = '<span>' + truncated + '</span>',
                            popTemplate = _.template('<a href="#" ' + 'role="button" ' + 'data-toggle="popover" ' + 'data-trigger="click" ' + 'data-placement="top auto"' + 'data-html="true" ' + 'data-content="<%= text %>" ' + '>more</a>');
                        if (_.endsWith(truncated, ellipsis)) {
                            result += popTemplate({
                                text: value
                            });
                        }

                        return result;
                    },
                    'createdCell': function createdCell(cell) {
                        $(cell).popover();
                    }
                }, {
                    title: 'Documents',
                    data: 'documents',
                    'render': function render(values) {
                        var result = '';
                        _.forEach(values, function (value) {
                            var docName = '',
                                url = '';
                            if (_.isArray(value) && value.length > 1) {
                                docName = value[0];
                                url = value[1];
                            }
                            if (typeof s === 'string') {
                                url = value;

                                docName = _.last(value.split('/'));
                                docName = _.truncate(docName, {
                                    length: 18,
                                    omission: '...',
                                    separator: ' '
                                });
                            }
                            result += '<a href="' + url + '" target="_blank"><p>' + docName + '</p></a><br>';
                        });
                        return result;
                    }
                }]
            },
            commsTable: null

        };
    },

    components: {
        AddCommLog: _add_comm_log2.default
    },
    watch: {},
    computed: {},
    methods: {
        commaToNewline: function commaToNewline(s) {
            return s.replace(/[,;]/g, '\n');
        },

        initialiseCommLogs: function initialiseCommLogs(vm_uid, ref, datatable_options, table) {
            var vm = this;
            var commsLogId = 'comms-log-table' + vm_uid;
            var contentId = 'comms-log-content' + vm_uid;
            var popover_name = 'popover-' + vm._uid + '-comms';
            $(ref).popover({
                html: true,
                title: 'Communications Log',
                container: 'body',
                placement: 'right',
                trigger: "click",
                template: '<div class="popover ' + popover_name + '" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div id="' + contentId + '" class="popover-content"></div></div>'
            }).on('inserted.bs.popover', function () {
                $('#' + contentId).html('<table id="' + commsLogId + '" class="hover table table-striped table-bordered dt-responsive " cellspacing="0" width="100%"></table>');
                table = $('#' + commsLogId).DataTable(datatable_options);

                table.on('draw.dt', function () {
                    var $tablePopover = $(this).find('[data-toggle="popover"]');
                    if ($tablePopover.length > 0) {
                        $tablePopover.popover();

                        $($tablePopover).on('click', function (e) {
                            e.preventDefault();
                            return true;
                        });
                    }
                });
            }).on('shown.bs.popover', function () {
                var el = ref;
                var popoverheight = parseInt($('.' + popover_name).height());

                var popover_bounding_top = parseInt($('.' + popover_name)[0].getBoundingClientRect().top);
                var popover_bounding_bottom = parseInt($('.' + popover_name)[0].getBoundingClientRect().bottom);

                var el_bounding_top = parseInt($(el)[0].getBoundingClientRect().top);
                var el_bounding_bottom = parseInt($(el)[0].getBoundingClientRect().top);

                var diff = el_bounding_top - popover_bounding_top;

                var position = parseInt($('.' + popover_name).position().top);
                var pos2 = parseInt($(el).position().top) - 5;

                var x = diff + 5;
                $('.' + popover_name).children('.arrow').css('top', x + 'px');
            });
        },
        initialiseActionLogs: function initialiseActionLogs(vm_uid, ref, datatable_options, table) {
            var vm = this;
            var actionLogId = 'actions-log-table' + vm_uid;
            var contentId = 'actions-log-content' + vm_uid;
            var popover_name = 'popover-' + vm._uid + '-logs';
            $(ref).popover({
                html: true,
                title: 'Action Log',
                container: 'body',
                placement: 'right',
                trigger: "click",
                template: '<div class="popover ' + popover_name + '" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div id="' + contentId + '" class="popover-content"></div></div>'
            }).on('inserted.bs.popover', function () {
                $('#' + contentId).html('\n                    <table id="' + actionLogId + '" class="hover table table-striped table-bordered dt-responsive" cellspacing="0" width="100%">\n                        <thead>\n                            <tr>\n                                <th>Who</th>\n                                <th>What</th>\n                                <th>When</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                        </tbody>\n                    </table>');
                table = $('#' + actionLogId).DataTable(datatable_options);
            }).on('shown.bs.popover', function () {
                var el = ref;
                var popoverheight = parseInt($('.' + popover_name).height());

                var popover_bounding_top = parseInt($('.' + popover_name)[0].getBoundingClientRect().top);
                var popover_bounding_bottom = parseInt($('.' + popover_name)[0].getBoundingClientRect().bottom);

                var el_bounding_top = parseInt($(el)[0].getBoundingClientRect().top);
                var el_bounding_bottom = parseInt($(el)[0].getBoundingClientRect().top);

                var diff = el_bounding_top - popover_bounding_top;

                var position = parseInt($('.' + popover_name).position().top);
                var pos2 = parseInt($(el).position().top) - 5;

                var x = diff + 5;
                $('.' + popover_name).children('.arrow').css('top', x + 'px');
            });
        },
        initialisePopovers: function initialisePopovers() {
            if (!this.popoversInitialised) {
                this.initialiseActionLogs(this._uid, this.$refs.showActionBtn, this.actionsDtOptions, this.actionsTable);
                this.initialiseCommLogs('-internal-application-' + this._uid, this.$refs.showCommsBtn, this.commsDtOptions, this.commsTable);
                this.popoversInitialised = true;
            }
        },
        addComm: function addComm() {
            this.$refs.add_comm.isModalOpen = true;
        }
    },
    mounted: function mounted() {
        var vm = this;
        this.$nextTick(function () {
            vm.initialisePopovers();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(31), __webpack_require__(2)))

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _hooks = __webpack_require__(3);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "FileField",
    props: {
        name: String,
        label: String,
        id: String,

        fileTypes: {
            default: function _default() {
                var file_types = "image/*," + "video/*," + "audio/*," + "application/pdf,text/csv,application/msword,application/vnd.ms-excel,application/x-msaccess," + "application/x-7z-compressed,application/x-bzip,application/x-bzip2,application/zip," + ".dbf,.gdb,.gpx,.prj,.shp,.shx," + ".json,.kml,.gpx";
                return file_types;
            }
        },
        isRepeatable: Boolean,
        readonly: Boolean,
        documentActionUrl: String
    },

    data: function data() {
        return {
            repeat: 1,
            files: [],
            show_spinner: false,
            documents: [],
            filename: null,
            help_text_url: '',
            commsLogId: null,
            temporary_document_collection_id: null
        };
    },
    computed: {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie('csrftoken');
        },
        document_action_url: function document_action_url() {
            var url = '';
            if (this.documentActionUrl == 'temporary_document') {
                if (!this.temporary_document_collection_id) {
                    url = _hooks.api_endpoints.temporary_document;
                } else {
                    url = _hooks.api_endpoints.temporary_document + this.temporary_document_collection_id + '/process_temp_comms_log_document/';
                }
            } else {
                url = this.documentActionUrl;
            }
            return url;
        }
    },
    watch: {
        documents: {
            handler: function () {
                var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return this.$emit('update-parent');

                                case 2:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                function handler() {
                    return _ref.apply(this, arguments);
                }

                return handler;
            }(),
            deep: true
        }
    },

    methods: {
        handleChange: function handleChange(e) {
            var _this = this;

            var vm = this;

            if (vm.isRepeatable && e.target.files) {
                var el = $(e.target).attr('data-que');
                var avail = $('input[name=' + e.target.name + ']');

                var avail_map = $('input[name=' + e.target.name + ']');
                avail = [];
                $.map(avail_map, function (val, i) {
                    avail.push($(avail_map[i]).attr('data-que'));
                });

                avail.pop();
                if (vm.repeat == 1) {
                    vm.repeat += 1;
                } else {
                    if (avail.indexOf(el) < 0) {
                        vm.repeat += 1;
                    }
                }
                $(e.target).css({ 'display': 'none' });
            } else {
                vm.files = [];
            }
            vm.files.push(e.target.files[0]);

            if (e.target.files.length > 0) {
                this.$nextTick(function () {
                    _this.save_document(e);
                });
            }
        },

        get_documents: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var formData, res;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.show_spinner = true;

                                if (!this.document_action_url) {
                                    _context2.next = 12;
                                    break;
                                }

                                formData = new FormData();

                                formData.append('action', 'list');
                                if (this.commsLogId) {
                                    formData.append('comms_log_id', this.commsLogId);
                                }
                                formData.append('input_name', this.name);
                                formData.append('csrfmiddlewaretoken', this.csrf_token);
                                _context2.next = 9;
                                return _vue2.default.http.post(this.document_action_url, formData);

                            case 9:
                                res = _context2.sent;

                                this.documents = res.body.filedata;
                                this.commsLogId = res.body.comms_instance_id;

                            case 12:
                                this.show_spinner = false;

                            case 13:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function get_documents() {
                return _ref2.apply(this, arguments);
            }

            return get_documents;
        }(),

        delete_document: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(file) {
                var formData, res;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.show_spinner = true;

                                formData = new FormData();

                                formData.append('action', 'delete');
                                formData.append('input_name', this.name);
                                if (this.commsLogId) {
                                    formData.append('comms_log_id', this.commsLogId);
                                }
                                formData.append('document_id', file.id);
                                formData.append('csrfmiddlewaretoken', this.csrf_token);

                                if (!this.document_action_url) {
                                    _context3.next = 13;
                                    break;
                                }

                                _context3.next = 10;
                                return _vue2.default.http.post(this.document_action_url, formData);

                            case 10:
                                res = _context3.sent;

                                this.documents = res.body.filedata;

                                this.commsLogId = res.body.comms_instance_id;

                            case 13:
                                this.show_spinner = false;

                            case 14:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function delete_document(_x) {
                return _ref3.apply(this, arguments);
            }

            return delete_document;
        }(),
        cancel: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(file) {
                var formData, res;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.show_spinner = true;

                                formData = new FormData();

                                formData.append('action', 'cancel');
                                formData.append('input_name', this.name);
                                if (this.commsLogId) {
                                    formData.append('comms_log_id', this.commsLogId);
                                }
                                formData.append('csrfmiddlewaretoken', this.csrf_token);

                                if (!this.document_action_url) {
                                    _context4.next = 10;
                                    break;
                                }

                                _context4.next = 9;
                                return _vue2.default.http.post(this.document_action_url, formData);

                            case 9:
                                res = _context4.sent;

                            case 10:
                                this.show_spinner = false;

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function cancel(_x2) {
                return _ref4.apply(this, arguments);
            }

            return cancel;
        }(),

        uploadFile: function uploadFile(e) {
            var _file = null;

            if (e.target.files && e.target.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(e.target.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = e.target.files[0];
            }
            return _file;
        },


        handleChangeWrapper: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(e) {
                var _this2 = this;

                var res;
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(this.documentActionUrl === 'temporary_document' && !this.temporary_document_collection_id)) {
                                    _context6.next = 10;
                                    break;
                                }

                                _context6.next = 3;
                                return _vue2.default.http.post(this.document_action_url);

                            case 3:
                                res = _context6.sent;

                                this.temporary_document_collection_id = res.body.id;
                                _context6.next = 7;
                                return this.$emit('update-temp-doc-coll-id', {
                                    "temp_doc_id": this.temporary_document_collection_id,
                                    "input_name": this.name
                                });

                            case 7:
                                this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                                    return _regenerator2.default.wrap(function _callee5$(_context5) {
                                        while (1) {
                                            switch (_context5.prev = _context5.next) {
                                                case 0:
                                                    _this2.handleChange(e);

                                                case 1:
                                                case 'end':
                                                    return _context5.stop();
                                            }
                                        }
                                    }, _callee5, _this2);
                                })));
                                _context6.next = 11;
                                break;

                            case 10:
                                this.handleChange(e);

                            case 11:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function handleChangeWrapper(_x3) {
                return _ref5.apply(this, arguments);
            }

            return handleChangeWrapper;
        }(),

        save_document: function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(e) {
                var formData, res;
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                this.show_spinner = true;

                                if (!this.document_action_url) {
                                    _context7.next = 18;
                                    break;
                                }

                                formData = new FormData();

                                formData.append('action', 'save');
                                if (this.commsLogId) {
                                    formData.append('comms_log_id', this.commsLogId);
                                }
                                if (this.temporary_document_collection_id) {
                                    formData.append('temporary_document_collection_id', this.temporary_document_collection_id);
                                }
                                formData.append('input_name', this.name);
                                formData.append('filename', e.target.files[0].name);
                                formData.append('_file', this.uploadFile(e));
                                formData.append('csrfmiddlewaretoken', this.csrf_token);
                                _context7.next = 12;
                                return _vue2.default.http.post(this.document_action_url, formData);

                            case 12:
                                res = _context7.sent;


                                this.documents = res.body.filedata;
                                this.commsLogId = res.body.comms_instance_id;
                                this.show_spinner = false;
                                _context7.next = 19;
                                break;

                            case 18:
                                console.log("no documentActionUrl");

                            case 19:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function save_document(_x4) {
                return _ref7.apply(this, arguments);
            }

            return save_document;
        }(),

        num_documents: function num_documents() {
            if (this.documents) {
                return this.documents.length;
            }
            return 0;
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        if (this.value) {
            if (Array.isArray(this.value)) {
                this.value;
            } else {
                var file_names = this.value.replace(/ /g, '_').split(",");
                this.files = file_names.map(function (file_name) {
                    return { name: file_name };
                });
            }
        }
        this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            if (!(_this3.documentActionUrl === 'temporary_document' && !_this3.temporary_document_collection_id)) {
                                _context8.next = 3;
                                break;
                            }

                            _context8.next = 5;
                            break;

                        case 3:
                            _context8.next = 5;
                            return _this3.get_documents();

                        case 5:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this3);
        })));
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _helpers = __webpack_require__(42);

var _section = __webpack_require__(338);

var _section2 = _interopRequireDefault(_section);

var _group = __webpack_require__(334);

var _group2 = _interopRequireDefault(_group);

var _radio = __webpack_require__(336);

var _radio2 = _interopRequireDefault(_radio);

var _compliance_conditions = __webpack_require__(828);

var _compliance_conditions2 = _interopRequireDefault(_compliance_conditions);

var _checkbox = __webpack_require__(330);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _declarations = __webpack_require__(332);

var _declarations2 = _interopRequireDefault(_declarations);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _select = __webpack_require__(339);

var _select2 = _interopRequireDefault(_select);

var _dateField = __webpack_require__(331);

var _dateField2 = _interopRequireDefault(_dateField);

var _text = __webpack_require__(342);

var _text2 = _interopRequireDefault(_text);

var _textArea = __webpack_require__(341);

var _textArea2 = _interopRequireDefault(_textArea);

var _label = __webpack_require__(335);

var _label2 = _interopRequireDefault(_label);

var _readonly_text = __webpack_require__(337);

var _readonly_text2 = _interopRequireDefault(_readonly_text);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _table = __webpack_require__(340);

var _table2 = _interopRequireDefault(_table);

var _compliance_expander_table = __webpack_require__(829);

var _compliance_expander_table2 = _interopRequireDefault(_compliance_expander_table);

var _grid = __webpack_require__(333);

var _grid2 = _interopRequireDefault(_grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComplianceRendererBlock = {
    name: 'compliance-renderer-block',
    components: {
        FormSection: _section2.default,
        TextField: _text2.default,
        Group: _group2.default,
        SelectBlock: _select2.default,

        HelpText: _help_text2.default,
        HelpTextUrl: _help_text_url2.default,
        CommentBlock: _comment_block2.default,
        Radio: _radio2.default,
        Conditions: _compliance_conditions2.default,
        Checkbox: _checkbox2.default,
        File: _compliance_file2.default,
        DateField: _dateField2.default,
        TextAreaBlock: _textArea2.default,
        LabelBlock: _label2.default,
        TableBlock: _table2.default,
        ExpanderTable: _compliance_expander_table2.default,
        GridBlock: _grid2.default
    },
    data: function data() {
        return {};
    },
    props: {
        component: {
            type: Object,
            required: true
        },
        instance: {
            type: String,
            default: null
        },
        callingComponent: {
            type: Object
        },
        readonlyForm: {
            type: Boolean
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['renderer_form_data', 'isComponentVisible']), (0, _vuex.mapGetters)('callemailStore', {
        call_email: 'call_email'
    }), (0, _vuex.mapGetters)('inspectionStore', {
        inspection: 'inspection'
    }), (0, _vuex.mapGetters)('physicalArtifactStore', {
        physical_artifact: 'physical_artifact'
    }), {
        parent_id: function parent_id() {
            var parentIdExists = false;
            if (this.call_email && this.call_email.id) {
                parentIdExists = true;
            } else if (this.inspection && this.inspection.id) {
                parentIdExists = true;
            } else if (this.physical_artifact && this.physical_artifact.id) {
                parentIdExists = true;
            }
            return parentIdExists;
        },
        documentActionUrl: function documentActionUrl() {
            var rendererDocumentUrl = '';
            if (this.call_email && this.call_email.id) {
                rendererDocumentUrl = this.call_email.rendererDocumentUrl;
            } else if (this.inspection && this.inspection.id) {
                rendererDocumentUrl = this.inspection.rendererDocumentUrl;
            } else if (this.physical_artifact && this.physical_artifact.id) {
                rendererDocumentUrl = this.physical_artifact.rendererDocumentUrl;
            }
            return rendererDocumentUrl;
        },
        is_readonly: function is_readonly() {
            return this.readonlyForm;
        },

        comment_data: function comment_data() {
            return this.call_email.comment_data;
        },

        can_user_edit: function can_user_edit() {
            return this.call_email.can_user_edit;
        },
        site_url: function site_url() {
            return _hooks.api_endpoints.site_url.endsWith("/") ? _hooks.api_endpoints.site_url : _hooks.api_endpoints.site_url + "/";
        },
        component_name: function component_name() {
            return '' + this.component.name + (this.instance !== null ? '__instance-' + this.instance : '');
        },
        json_data: function json_data() {
            return this.renderer_form_data;
        },
        formDataRecord: function formDataRecord() {
            if (this.json_data[this.component_name] == null) {
                this.setFormValue({
                    key: this.component_name,
                    value: {
                        "value": '',

                        "schema_name": this.component.name,
                        "component_type": this.component.type,
                        "instance_name": this.instance !== null ? this.instance : ''
                    }
                });
            }
            return this.json_data[this.component_name];
        },
        value: {
            get: function get() {
                return this.formDataRecord;
            },
            set: function set(value) {
                this.setFormValue({
                    key: this.component_name,
                    value: { "value": value }
                });
            }
        },
        help_text: function help_text() {
            return this.replaceSitePlaceholders(this.component.help_text);
        },
        help_text_url: function help_text_url() {
            return this.replaceSitePlaceholders(this.component.help_text_url);
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['toggleVisibleComponent', 'setFormValue']), (0, _vuex.mapActions)('physicalArtifactStore', {
        addToTemporaryDocumentCollectionList: 'addToTemporaryDocumentCollectionList'
    }), {

        strToBool: _helpers.strToBool,
        element_id: function element_id() {
            var depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            return 'id_' + this.component_name + (depth ? '_' + depth : '') + (this.instance !== null ? '__instance' + this.instance : '');
        },
        replaceSitePlaceholders: function replaceSitePlaceholders(text_string) {
            if (text_string && text_string.includes("site_url:/")) {
                text_string = text_string.replace('site_url:/', this.site_url);

                if (text_string.includes("anchor=")) {
                    text_string = text_string.replace('anchor=', "#");
                }
            }
            return text_string;
        },
        handleComponentChange: function handleComponentChange(component) {
            var _this = this;

            var assignEventValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            return function (e) {
                for (var condition in component.conditions) {
                    _this.toggleVisibleComponent({
                        'component_id': 'cons_' + _this.component_name + '_' + condition,
                        'visible': false
                    });
                }
                e.target && _this.toggleVisibleComponent({
                    'component_id': 'cons_' + e.target.name + '_' + e.target.value,
                    'visible': e.target.checked
                });
                var value = e.value == null ? e.target.value : e.value;

                if (value === 'on' && !e.target.checked) {
                    value = '';
                }
                if (assignEventValue && value !== null && value !== undefined) {
                    _this.value = value;
                }
            };
        }
    }),
    created: function created() {}
};

exports.default = ComplianceRendererBlock;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _vuex = __webpack_require__(6);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

__webpack_require__(15);

__webpack_require__(37);

var _lodash = __webpack_require__(31);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "CourtDate",
    data: function data() {
        return {
            uuid: 0,
            court_date: null,
            court_time: null,
            court_comments: '',
            court_location: null,
            courts: []
        };
    },
    components: {},
    props: {
        court_datetime: {
            type: Date,
            default: null
        },
        comments: {
            type: String,
            default: ''
        },
        court: {
            type: Object,
            default: null
        },
        court_date_id: {
            type: Number,
            default: null
        },
        return_date_format: {
            type: String,
            default: 'DD/MM/YYYY'
        },
        return_time_format: {
            type: String,
            default: 'HH:mm'
        },
        court_in_future: {
            type: Boolean,
            default: true
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        },
        readonlyForm: function readonlyForm() {
            var readonly = true;
            if (this.legal_case && this.legal_case.id && !this.closedStatus && this.court_in_future) {
                readonly = !this.legal_case.can_user_action;
            }
            return readonly;
        },
        closedStatus: function closedStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'closed') {
                returnStatus = true;
            }
            return returnStatus;
        },
        statusId: function statusId() {
            return this.legal_case.status ? this.legal_case.status.id : '';
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('legalCaseStore', {}), {
        courtOutcomeDocumentUploaded: function courtOutcomeDocumentUploaded() {
            console.log('courtOutcomeDocumentUploaded');
        },
        emitEvent: function emitEvent() {
            var test_m_datetime = (0, _moment2.default)(this.court_date + ' ' + this.court_time, 'DD/MM/YYYY LT');
            this.$emit('data_changed', {
                id: this.court_date_id,
                court_datetime: test_m_datetime,
                comments: this.court_comments,
                court: this.court_location
            });
        },
        addEventListeners: function addEventListeners() {
            var vm = this;
            var el_court_date = $(vm.$refs.courtDatePicker);
            var el_court_time = $(vm.$refs.courtTimePicker);

            el_court_date.datetimepicker({
                format: "DD/MM/YYYY",
                showClear: true,
                date: vm.court_datetime
            });
            el_court_date.on("dp.change", function (e) {
                if (el_court_date.data("DateTimePicker").date()) {
                    vm.court_date = e.date.format('DD/MM/YYYY');
                } else if (el_court_date.data("date") === "") {
                    vm.court_date = null;
                }
                vm.emitEvent();
            });

            el_court_time.datetimepicker({
                format: "LT",
                showClear: true,
                date: vm.court_datetime
            });
            el_court_time.on("dp.change", function (e) {
                if (el_court_time.data("DateTimePicker").date()) {
                    vm.court_time = e.date.format('LT');
                } else if (el_court_time.data("date") === "") {
                    vm.court_time = null;
                }
                vm.emitEvent();
            });

            var el_comments = $(vm.$refs.courtComments);
            el_comments.on('keyup', function (e) {
                try {
                    vm.emitEvent();
                } catch (err) {
                    console.log(err);
                }
            });
        },
        constructOptionsCourt: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var returned;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _hooks.cache_helper.getSetCacheList('CourtProceedings_Courts', '/api/legal_case/court_list');

                            case 2:
                                returned = _context.sent;

                                this.courts = returned;

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function constructOptionsCourt() {
                return _ref.apply(this, arguments);
            }

            return constructOptionsCourt;
        }()
    }),
    created: function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            this.constructOptionsCourt();

                        case 1:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function created() {
            return _ref2.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        var _this = this;

        console.log('mounted');
        this.$nextTick(function () {
            _this.addEventListeners();
        });

        console.log(this.court_datetime);
        if (this.court_datetime) {
            var court_datetime_obj = (0, _moment2.default)(new Date(this.court_datetime.getTime()));

            this.court_date = court_datetime_obj.format('DD/MM/YYYY');

            this.court_time = court_datetime_obj.format('LT');
        }
        this.court_comments = this.comments;
        this.court_location = this.court;
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

__webpack_require__(15);

__webpack_require__(37);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _search_person_or_organisation = __webpack_require__(49);

var _search_person_or_organisation2 = _interopRequireDefault(_search_person_or_organisation);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _related_items = __webpack_require__(58);

var _related_items2 = _interopRequireDefault(_related_items);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "DocumentArtifactComponent",
    data: function data() {
        return {
            uuid: 0,
            newTab: 'newTab' + this._uid,
            existingTab: 'existingTab' + this._uid,
            objectTab: 'objectTab' + this._uid,
            detailsTab: 'detailsTab' + this._uid,
            storageTab: 'storageTab' + this._uid,
            disposalTab: 'disposalTab' + this._uid,
            rTab: 'rTab' + this._uid,
            isModalOpen: false,
            processingDetails: false,
            documentActionUrl: '',
            temporary_document_collection_id: null,
            documentArtifactTypes: [],
            departmentStaffList: [],
            selectedDepartmentStaffMember: {},

            selectedCustodian: {},
            entity: {
                id: null
            },

            statementArtifactTypes: ['record_of_interview', 'witness_statement', 'expert_statement', 'officer_statement'],
            statementVisibility: false,

            dtOptions: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                processing: true,
                ajax: {
                    url: '/api/artifact_paginated/get_paginated_datatable/?format=datatables',
                    dataSrc: 'data',
                    data: function data(d) {
                        d.object_type = 'document_artifact';
                    }
                },
                columns: [{
                    data: 'number',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'artifact_type',
                    searchable: true,
                    orderable: false
                }, {
                    data: 'identifier',
                    searchable: true,
                    orderable: true
                }, {
                    searchable: false,
                    orderable: false,
                    data: 'digital_documents'
                }, {
                    searchable: false,
                    orderable: false,
                    data: 'entity',
                    mRender: function mRender(data, type, full) {
                        var documentArtifactId = data.id;
                        var documentArtifactType = data.artifact_type ? data.artifact_type.replace(/\s/g, '~') : null;
                        var documentArtifactIdentifier = data.identifier ? data.identifier.replace(/\s/g, '~') : null;
                        return "<a data-id=" + documentArtifactId + " data-artifact-type=" + documentArtifactType + " data-data-type=\"document_artifact\" data-identifier=" + documentArtifactIdentifier + " class=\"row_insert\" href=\"#\">Insert</a><br/>";
                    }
                }]
            },
            dtHeaders: ['Number', 'Document Type', 'Identifier', 'Documents', 'Action']

        };
    },
    components: {
        filefield: _compliance_file2.default,
        SearchPersonOrganisation: _search_person_or_organisation2.default,
        FormSection: _section_toggle2.default,
        RelatedItems: _related_items2.default,
        datatable: _datatable2.default
    },
    props: {
        parentModal: {
            type: Boolean,
            required: false,
            default: false
        },
        entityEdit: {
            type: Object,
            required: false
        },
        readonlyForm: {
            type: Boolean,
            required: false
        }
    },
    watch: {
        artifactType: {
            handler: function handler() {
                this.setStatementVisibility();
            },
            deep: true
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('documentArtifactStore', {
        document_artifact: "document_artifact"
    }), (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        componentClass: function componentClass() {
            var componentClass = '';
            if (this.parentModal) {
                componentClass = 'col-sm-12 child-artifact-component';
            }
            return componentClass;
        },

        offenderList: function offenderList() {
            var offenderList = [{
                "id": null,
                "full_name": null,
                "email": null
            }];

            if (this.legalCaseExists && this.document_artifact.offence_id) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.legal_case.offence_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var offence = _step.value;

                        if (this.document_artifact.offence_id === offence.id) {
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = (0, _getIterator3.default)(offence.offenders), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var offender = _step2.value;

                                    var offenderObj = (0, _assign2.default)({}, offender.person);
                                    offenderObj.offender_id = offender.id;
                                    offenderList.push(offenderObj);
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return offenderList;
        },
        personProvidingStatementEntity: function personProvidingStatementEntity() {
            var entity = {};
            if (this.document_artifact && this.document_artifact.person_providing_statement) {
                entity.id = this.document_artifact.person_providing_statement.id;
                entity.data_type = 'individual';
            }
            return entity;
        },
        legalCaseId: function legalCaseId() {
            var ret_val = null;
            if (this.legal_case && this.legal_case.id) {
                ret_val = this.legal_case.id;
            }
            return ret_val;
        },
        legalCaseExists: function legalCaseExists() {
            var caseExists = false;
            if (this.legal_case && this.legal_case.id) {
                caseExists = true;
            }
            return caseExists;
        },
        linkedLegalCase: function linkedLegalCase() {
            var caseExists = false;
            if (this.document_artifact && this.document_artifact.legal_case_id_list && this.document_artifact.legal_case_id_list.length > 0) {
                caseExists = true;
            }
            return caseExists;
        },
        documentArtifactId: function documentArtifactId() {
            var id = null;
            if (this.document_artifact && this.document_artifact.id) {
                id = this.document_artifact.id;
            }
            return id;
        },
        officerInterviewerEmailAddress: function officerInterviewerEmailAddress() {
            var emailAddress = null;
            if (this.document_artifact && this.document_artifact.officer_interviewer) {
                emailAddress = this.document_artifact.officer_interviewer.email;
            }
            return emailAddress;
        },
        documentArtifactIdExists: function documentArtifactIdExists() {
            var recordExists = false;
            if (this.document_artifact && this.document_artifact.id) {
                recordExists = true;
            }
            return recordExists;
        },

        artifactType: function artifactType() {
            console.log("artifact type");
            var aType = '';
            if (this.document_artifact) {
                aType = this.document_artifact.document_type;
            }
            return aType;
        },
        artifactTypeDisplay: function artifactTypeDisplay() {
            var display = '';
            if (this.artifactType) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(this.documentArtifactTypes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var documentArtifactType = _step3.value;

                        if (documentArtifactType.id === this.artifactType) {
                            display = documentArtifactType.display;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            return display;
        },
        offenceExists: function offenceExists() {
            var oExists = false;
            if (this.document_artifact && this.document_artifact.offence) {
                oExists = true;
            }
            return oExists;
        },
        offenceVisibility: function offenceVisibility() {
            var visibility = false;
            if ((this.legalCaseExists || this.offenceExists) && this.artifactType === 'record_of_interview') {
                visibility = true;
            }
            return visibility;
        },
        existingOffenceDisplay: function existingOffenceDisplay() {
            var display = '';
            if (this.offenceExists) {
                display = this.document_artifact.offence.lodgement_number + ": " + this.document_artifact.offence.identifier;
            }
            return display;
        },
        existingOffenderDisplay: function existingOffenderDisplay() {
            var display = '';
            if (this.offenceExists && this.document_artifact.offender && this.document_artifact.offender.person) {
                display = this.document_artifact.offender.person.full_name + ": " + this.document_artifact.offender.person.email;
            }
            return display;
        },
        personProvidingStatementLabel: function personProvidingStatementLabel() {
            var label = '';
            if (this.artifactType === 'witness_statement') {
                label = 'Witness';
            } else if (this.artifactType === 'expert_statement') {
                label = 'Expert';
            }
            return label;
        },
        interviewerLabel: function interviewerLabel() {
            var label = '';
            if (this.artifactType === 'witness_statement') {
                label = 'Officer taking statement';
            } else if (this.artifactType === 'record_of_interview') {
                label = 'Interviewer';
            } else if (this.artifactType === 'officer_statement') {
                label = 'Officer';
            }
            return label;
        },
        personProvidingStatementVisibility: function personProvidingStatementVisibility() {
            var visibility = false;
            if (this.artifactType === 'expert_statement' || this.artifactType === 'witness_statement') {
                visibility = true;
            }
            return visibility;
        },
        interviewerVisibility: function interviewerVisibility() {
            var visibility = false;
            if (this.artifactType !== 'expert_statement' && this.statementArtifactTypes.includes(this.artifactType)) {
                visibility = true;
            }
            return visibility;
        },
        updateSearchPersonOrganisationBindId: function updateSearchPersonOrganisationBindId() {
            this.uuid += 1;
            return "DocumentArtifact_SearchPerson_" + this.uuid.toString();
        },
        relatedItemsBindId: function relatedItemsBindId() {
            var timeNow = Date.now();
            var bindId = null;
            if (this.document_artifact && this.document_artifact.id) {
                bindId = 'document_artifact_' + this.document_artifact.id + '_' + timeNow.toString();
            } else {
                bindId = timeNow.toString();
            }
            return bindId;
        },
        relatedItemsVisibility: function relatedItemsVisibility() {
            var related_items_visibility = false;
            if (this.document_artifact && this.document_artifact.id) {
                related_items_visibility = true;
            }
            return related_items_visibility;
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? (0, _moment2.default)(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('documentArtifactStore', {
        saveDocumentArtifact: 'saveDocumentArtifact',
        loadDocumentArtifact: 'loadDocumentArtifact',
        setDocumentArtifact: 'setDocumentArtifact',
        setRelatedItems: 'setRelatedItems',
        setPersonProvidingStatementId: 'setPersonProvidingStatementId',
        setInterviewerId: 'setInterviewerId',
        setInterviewerEmail: 'setInterviewerEmail',
        setTemporaryDocumentCollectionId: 'setTemporaryDocumentCollectionId',

        setOffenderId: 'setOffenderId',
        setOfficerInterviewer: 'setOfficerInterviewer',
        setOfficerInterviewerId: 'setOfficerInterviewerId'
    }), (0, _vuex.mapActions)('legalCaseStore', {
        loadLegalCase: 'loadLegalCase'
    }), {
        setStatementVisibility: function setStatementVisibility() {
            if ((this.linkedLegalCase || this.legalCaseExists) && this.artifactType && !this.statementArtifactTypes.includes(this.artifactType) || this.document_artifact && this.document_artifact.statement) {
                console.log("statementVisibility true");
                this.statementVisibility = true;
            } else {
                console.log("statementVisibility false");
                this.statementVisibility = false;
            }
        },

        setPersonProvidingStatement: function setPersonProvidingStatement(entity) {
            console.log(entity);

            this.setPersonProvidingStatementId(entity.id);
        },
        save: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var _this = this;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!this.document_artifact.id) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return this.saveDocumentArtifact({ create: false, internal: false, legal_case_id: this.legalCaseId });

                            case 3:
                                _context.next = 8;
                                break;

                            case 5:
                                _context.next = 7;
                                return this.saveDocumentArtifact({ create: true, internal: false, legal_case_id: this.legalCaseId });

                            case 7:
                                this.$nextTick(function () {
                                    _this.$emit('entity-selected', {
                                        id: _this.document_artifact.id,
                                        data_type: 'document_artifact',
                                        identifier: _this.document_artifact.identifier,
                                        artifact_type: _this.artifactType,
                                        display: _this.artifactType
                                    });
                                });

                            case 8:
                                console.log(this.document_artifact.error_message);
                                this.$emit('error-message', {
                                    error_message: this.document_artifact.error_message
                                });

                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function save() {
                return _ref.apply(this, arguments);
            }

            return save;
        }(),

        cancel: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.$refs.default_document) {
                                    _context2.next = 3;
                                    break;
                                }

                                _context2.next = 3;
                                return this.$refs.default_document.cancel();

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function cancel() {
                return _ref2.apply(this, arguments);
            }

            return cancel;
        }(),
        emitDocumentArtifact: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(e) {
                var _this2 = this;

                var documentArtifactId, fetchUrl, payload, documentArtifactType, documentArtifactIdentifier;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                console.log(e);
                                documentArtifactId = e.target.dataset.id;
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.document_artifact, documentArtifactId + '/');
                                payload = {
                                    "legal_case_id": this.legalCaseId
                                };

                                console.log(payload);
                                _context3.next = 7;
                                return _vue2.default.http.put(fetchUrl, payload);

                            case 7:
                                documentArtifactType = e.target.dataset.artifactType.replace(/~/g, ' ');
                                documentArtifactIdentifier = e.target.dataset.identifier.replace(/~/g, ' ').replace('null', '');

                                this.$nextTick(function () {
                                    _this2.$emit('existing-entity-selected', {
                                        id: documentArtifactId,
                                        data_type: 'document_artifact',
                                        identifier: documentArtifactIdentifier,
                                        artifact_type: documentArtifactType,
                                        display: documentArtifactType
                                    });
                                });

                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function emitDocumentArtifact(_x) {
                return _ref3.apply(this, arguments);
            }

            return emitDocumentArtifact;
        }(),
        setOfficerInterviewerWrapper: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(selectedData) {
                var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, officer;

                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _iteratorNormalCompletion4 = true;
                                _didIteratorError4 = false;
                                _iteratorError4 = undefined;
                                _context4.prev = 3;

                                for (_iterator4 = (0, _getIterator3.default)(this.departmentStaffList); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                    officer = _step4.value;

                                    if (officer.email === selectedData) {
                                        this.selectedDepartmentStaffMember = officer;
                                    }
                                }
                                _context4.next = 11;
                                break;

                            case 7:
                                _context4.prev = 7;
                                _context4.t0 = _context4["catch"](3);
                                _didIteratorError4 = true;
                                _iteratorError4 = _context4.t0;

                            case 11:
                                _context4.prev = 11;
                                _context4.prev = 12;

                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }

                            case 14:
                                _context4.prev = 14;

                                if (!_didIteratorError4) {
                                    _context4.next = 17;
                                    break;
                                }

                                throw _iteratorError4;

                            case 17:
                                return _context4.finish(14);

                            case 18:
                                return _context4.finish(11);

                            case 19:
                                _context4.next = 21;
                                return this.setOfficerInterviewer(this.selectedDepartmentStaffMember);

                            case 21:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[3, 7, 11, 19], [12,, 14, 18]]);
            }));

            function setOfficerInterviewerWrapper(_x2) {
                return _ref4.apply(this, arguments);
            }

            return setOfficerInterviewerWrapper;
        }(),

        addEventListeners: function addEventListeners() {
            var _this3 = this;

            var vm = this;
            var el_fr_date = $(vm.$refs.artifactDatePicker);
            var el_fr_time = $(vm.$refs.artifactTimePicker);

            el_fr_date.datetimepicker({
                format: "DD/MM/YYYY",
                maxDate: "now",
                showClear: true
            });
            el_fr_date.on("dp.change", function (e) {
                console.log(e);
                if (el_fr_date.data("DateTimePicker").date()) {
                    vm.document_artifact.artifact_date = e.date.format("DD/MM/YYYY");
                } else if (el_fr_date.data("date") === "") {
                    vm.document_artifact.artifact_date = "";
                }
            });
            el_fr_time.datetimepicker({ format: "LT", showClear: true });
            el_fr_time.on("dp.change", function (e) {
                console.log(e);
                if (el_fr_time.data("DateTimePicker").date()) {
                    vm.document_artifact.artifact_time = e.date.format("LT");
                } else if (el_fr_time.data("date") === "") {
                    vm.document_artifact.artifact_time = "";
                }
            });

            $(vm.$refs.document_artifact_interviewer).select2({
                minimumInputLength: 2,
                "theme": "bootstrap",
                allowClear: true,
                placeholder: "",
                ajax: {
                    url: _hooks.api_endpoints.staff_member_lookup,

                    dataType: 'json',
                    data: function data(params) {
                        console.log(params);
                        var query = {
                            term: params.term,
                            type: 'public'
                        };
                        return query;
                    }
                }
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                var selectedData = selected.val();
                console.log(selectedData);

                vm.setOfficerInterviewerId(selectedData);
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);

                vm.setOfficerInterviewerId(null);
            });

            var existingArtifactTable = $('#existing-artifact-table');
            existingArtifactTable.on('click', '.row_insert', function (e) {
                _this3.emitDocumentArtifact(e);
            });
        },
        compare: function compare(a, b) {
            console.log("compare");
            var nameA = a.name.toLowerCase();
            var nameB = b.name.toLowerCase();

            var comparison = 0;
            if (this.bandA > this.bandB) {
                comparison = 1;
            } else if (this.bandA < this.bandB) {
                comparison = -1;
            }
            return comparison;
        }

    }),
    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _this4.addEventListeners();

                        case 1:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4);
        })));
    },
    beforeDestroy: function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            console.log("beforeDestroy");
                            _context6.next = 3;
                            return this.setDocumentArtifact({});

                        case 3:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function beforeDestroy() {
            return _ref6.apply(this, arguments);
        }

        return beforeDestroy;
    }(),
    created: function () {
        var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
            var returned_document_artifact_types, vm, option;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            console.log("created");

                            if (!this.$route.params.document_artifact_id) {
                                _context7.next = 6;
                                break;
                            }

                            _context7.next = 4;
                            return this.loadDocumentArtifact({ document_artifact_id: this.$route.params.document_artifact_id });

                        case 4:
                            _context7.next = 9;
                            break;

                        case 6:
                            if (!(this.entityEdit && this.entityEdit.id && this.entityEdit.data_type === 'document_artifact')) {
                                _context7.next = 9;
                                break;
                            }

                            _context7.next = 9;
                            return this.loadDocumentArtifact({ document_artifact_id: this.entityEdit.id });

                        case 9:
                            if (!(this.$route.name === 'view-artifact' && this.document_artifact && this.document_artifact.primary_legal_case_id)) {
                                _context7.next = 12;
                                break;
                            }

                            _context7.next = 12;
                            return this.loadLegalCase({ legal_case_id: this.document_artifact.primary_legal_case_id });

                        case 12:
                            this.setStatementVisibility();
                            _context7.next = 15;
                            return _hooks.cache_helper.getSetCacheList('DocumentArtifactTypes', _hooks.api_endpoints.document_artifact_types);

                        case 15:
                            returned_document_artifact_types = _context7.sent;

                            (0, _assign2.default)(this.documentArtifactTypes, returned_document_artifact_types);

                            this.documentArtifactTypes.splice(0, 0, {
                                id: "",
                                artifact_type: "",
                                description: ""
                            });
                            vm = this;

                            if (this.document_artifact.officer_interviewer && this.document_artifact.officer_interviewer.id) {
                                option = new Option(this.document_artifact.officer_interviewer.full_name, this.document_artifact.officer_interviewer.full_name, true, true);

                                $(vm.$refs.document_artifact_interviewer).append(option).trigger('change');
                            }

                        case 20:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function created() {
            return _ref7.apply(this, arguments);
        }

        return created;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'IntelligenceInformation',
    data: function data() {
        var vm = this;
        return {
            intelligenceText: "",
            saving: false
        };
    },

    props: {
        entity_id: {
            type: Number,
            required: true
        },
        entity_type: {
            type: String,
            required: true
        }
    },

    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var _this = this;

        next(function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(vm) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }());
    },

    components: {
        FormSection: _section_toggle2.default,
        filefield: _compliance_file2.default
    },
    computed: {
        documentActionUrl: function documentActionUrl() {
            var url = '';
            if (this.entity_type === 'org') {
                url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.organisations, this.entity_id + "/process_intelligence_document/");
            } else if (this.entity_type === 'person') {
                url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.users, this.entity_id + "/process_intelligence_document/");
            }
            return url;
        },
        saveIntelligenceUrl: function saveIntelligenceUrl() {
            var url = '';
            if (this.entity_type === 'org') {
                url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.organisations, this.entity_id + "/save_intelligence_text/");
            } else if (this.entity_type === 'person') {
                url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.users, this.entity_id + "/save_intelligence_text/");
            }
            return url;
        }

    },
    methods: {
        saveIntelligence: function saveIntelligence() {
            var _this2 = this;

            this.saving = true;
            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _vue2.default.http.post(_this2.saveIntelligenceUrl, { 'intelligence_text': _this2.intelligenceText });

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            })));
            this.saving = false;
        }
    },
    mounted: function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            var _this3 = this;

            var vm;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            vm = this;

                            (0, _jquery2.default)('a[data-toggle="collapse"]').on('click', function () {
                                var chev = (0, _jquery2.default)(this).children()[0];
                                window.setTimeout(function () {
                                    (0, _jquery2.default)(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
                                }, 100);
                            });
                            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                                var url, response;
                                return _regenerator2.default.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                url = '';

                                                if (_this3.entity_type === 'org') {
                                                    url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.organisations, _this3.entity_id + "/get_intelligence_text/");
                                                } else if (_this3.entity_type === 'person') {
                                                    url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.users, _this3.entity_id + "/get_intelligence_text/");
                                                }
                                                console.log(url);
                                                _context3.next = 5;
                                                return _vue2.default.http.get(url);

                                            case 5:
                                                response = _context3.sent;

                                                console.log(response);
                                                _this3.intelligenceText = response.body.intelligence_text;

                                            case 8:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this3);
                            })));

                        case 3:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function mounted() {
            return _ref3.apply(this, arguments);
        }

        return mounted;
    }()
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'LegalCaseTableDash',
    data: function data() {
        var vm = this;
        return {
            filterStatus: 'All',

            filterCaseCreatedFrom: '',
            filterCaseCreatedTo: '',

            statusChoices: [],


            dateFormat: 'DD/MM/YYYY',
            legalCaseInitialised: false,
            createLegalCaseBindId: '',

            dtOptions: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                autoWidth: false,
                rowCallback: function rowCallback(row, data) {
                    (0, _jquery2.default)(row).addClass('appRecordRow');
                },

                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },

                responsive: true,
                processing: true,
                ajax: {
                    'url': '/api/legal_case_paginated/get_person_org_paginated_datatable/?format=datatables',
                    'dataSrc': 'data',
                    'data': function data(d) {
                        d.entity_id = vm.entity_id;
                        d.entity_type = vm.entity_type;
                    }
                },

                columns: [{
                    data: 'number',
                    searchable: false
                }, {
                    data: 'title',
                    searchable: false,
                    orderable: true
                }, {
                    data: 'status.name',
                    searchable: false,
                    orderable: true
                }, {
                    data: 'created_date',
                    searchable: false,
                    orderable: true
                }, {
                    data: "assigned_to",
                    searchable: false,
                    orderable: false,
                    mRender: function mRender(data, type, full) {
                        if (data) {
                            return data.full_name;
                        } else {
                            return '';
                        }
                    }
                }, {
                    data: 'user_action',
                    searchable: false,
                    orderable: false
                }]
            },
            dtHeaders: ['Number', 'Title', 'Status', 'Created Date', 'Assigned to', 'Action']
        };
    },

    props: {
        entity_id: {
            type: Number,
            required: true
        },
        entity_type: {
            type: String,
            required: true
        }
    },

    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var _this = this;

        next(function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(vm) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }());
    },

    watch: {
        filterStatus: function filterStatus() {
            this.$refs.legal_case_table.vmDataTable.draw();
        },
        filterCaseCreatedFrom: function filterCaseCreatedFrom() {
            this.$refs.legal_case_table.vmDataTable.draw();
        },
        filterCaseCreatedTo: function filterCaseCreatedTo() {
            this.$refs.legal_case_table.vmDataTable.draw();
        }
    },
    components: {
        datatable: _datatable2.default,
        FormSection: _section_toggle2.default
    },
    computed: {},
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('legalCaseStore', {
        saveInspection: "saveLegalCase"
    }), {
        createLegalCase: function createLegalCase() {
            var _this2 = this;

            this.setCreateLegalCaseBindId();
            this.legalCaseInitialised = true;
            this.$nextTick(function () {
                _this2.$refs.add_legal_case.isModalOpen = true;
            });
        },
        setCreateLegalCaseBindId: function setCreateLegalCaseBindId() {
            var timeNow = Date.now();
            this.createLegalCaseBindId = 'legal_case' + timeNow.toString();
        },
        createLegalCaseUrl: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var newLegalCaseId;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.saveLegalCase({ create: true });

                            case 2:
                                newLegalCaseId = _context2.sent;


                                this.$router.push({
                                    name: 'view-legal-case',
                                    params: { legal_case_id: newLegalCaseId }
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function createLegalCaseUrl() {
                return _ref2.apply(this, arguments);
            }

            return createLegalCaseUrl;
        }(),
        addEventListeners: function addEventListeners() {
            var vm = this;

            (0, _jquery2.default)(vm.$refs.caseCreatedDateToPicker).datetimepicker(vm.datepickerOptions);
            (0, _jquery2.default)(vm.$refs.caseCreatedDateToPicker).on('dp.change', function (e) {
                if ((0, _jquery2.default)(vm.$refs.caseCreatedDateToPicker).data('DateTimePicker').date()) {
                    vm.filterCaseCreatedTo = e.date.format('DD/MM/YYYY');
                } else if ((0, _jquery2.default)(vm.$refs.plannedDateToPicker).data('date') === "") {
                    vm.filterCaseCreatedTo = "";
                }
            });
            (0, _jquery2.default)(vm.$refs.caseCreatedDateFromPicker).datetimepicker(vm.datepickerOptions);
            (0, _jquery2.default)(vm.$refs.caseCreatedDateFromPicker).on('dp.change', function (e) {
                if ((0, _jquery2.default)(vm.$refs.caseCreatedDateFromPicker).data('DateTimePicker').date()) {
                    vm.filterCaseCreatedFrom = e.date.format('DD/MM/YYYY');
                } else if ((0, _jquery2.default)(vm.$refs.caseCreatedDateFromPicker).data('date') === "") {
                    vm.filterCaseCreatedFrom = "";
                }
            });
        },
        initialiseSearch: function initialiseSearch() {
            this.dateSearch();
        },
        dateSearch: function dateSearch() {
            var vm = this;
            vm.$refs.legal_case_table.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var from = vm.filterCaseCreatedFrom;
                var to = vm.filterCaseCreatedTo;

                var val = original.case_created_date;

                if (from == '' && to == '') {
                    return true;
                } else if (from != '' && to != '') {
                    return val != null && val != '' ? moment().range(moment(from, vm.dateFormat), moment(to, vm.dateFormat)).contains(moment(val)) : false;
                } else if (from == '' && to != '') {
                    if (val != null && val != '') {
                        return moment(to, vm.dateFormat).diff(moment(val)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (to == '' && from != '') {
                    if (val != null && val != '') {
                        return moment(val).diff(moment(from, vm.dateFormat)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            });
        }
    }),
    mounted: function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            var _this3 = this;

            var vm;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            vm = this;

                            (0, _jquery2.default)('a[data-toggle="collapse"]').on('click', function () {
                                var chev = (0, _jquery2.default)(this).children()[0];
                                window.setTimeout(function () {
                                    (0, _jquery2.default)(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
                                }, 100);
                            });
                            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                                return _regenerator2.default.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                _context3.next = 2;
                                                return vm.initialiseSearch();

                                            case 2:
                                                _context3.next = 4;
                                                return vm.addEventListeners();

                                            case 4:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this3);
                            })));

                        case 3:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function mounted() {
            return _ref3.apply(this, arguments);
        }

        return mounted;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'LicenceActionPurposes',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default
    },
    props: {
        licence_id: String,
        licence_activity_purposes: Array,
        action: String
    },
    data: function data() {
        var vm = this;
        return {
            isModalOpen: false,
            form: null,
            action_licence: {
                purpose_ids_list: []
            },
            actioningPurposes: false,
            validation_form: null,
            errors: false,
            errorString: '',
            successString: '',
            success: false,
            checkbox_list: {
                application: 0,
                purpose_ids: []
            },
            selectedActivityId: 0
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application_id']), {
        showError: function showError() {
            var vm = this;
            return vm.errors;
        },
        title: function title() {
            if (this.action == 'cancel') {
                return 'Select purpose(s) to cancel';
            } else if (this.action == 'suspend') {
                return 'Select purpose(s) to suspend';
            } else if (this.action == 'surrender') {
                return 'Select purpose(s) to surrender';
            } else if (this.action == 'reactivate-renew') {
                return 'Select purpose(s) to reactivate renew';
            } else if (this.action == 'reissue') {
                return 'Select purpose(s) to reissue';
            } else if (this.action == 'reinstate') {
                return 'Select purpose(s) to reinstate';
            }
        },
        action_text: function action_text() {
            if (this.action == 'cancel') {
                return 'Cancel';
            } else if (this.action == 'suspend') {
                return 'Suspend';
            } else if (this.action == 'surrender') {
                return 'Surrender';
            } else if (this.action == 'reactivate-renew') {
                return 'Reactivate Renew';
            } else if (this.action == 'reissue') {
                return 'Reissue';
            } else if (this.action == 'reinstate') {
                return 'Reinstate';
            }
        },
        actioning_text: function actioning_text() {
            if (this.action == 'cancel') {
                return 'Cancelling';
            } else if (this.action == 'suspend') {
                return 'Suspending';
            } else if (this.action == 'surrender') {
                return 'Surrendering';
            } else if (this.action == 'reactivate-renew') {
                return 'Reactivating Renew';
            } else if (this.action == 'reissue') {
                return 'Reissue';
            } else if (this.action == 'reinstate') {
                return 'Reinstating';
            }
        },
        actionableLicencePurposesByAppId: function actionableLicencePurposesByAppId(appId) {
            return this.licence_activity_purposes.filter(function (activity) {
                return activity.application === appId;
            });
        },
        actionableLicencePurposes: function actionableLicencePurposes() {
            return this.licence_activity_purposes;
        },
        hasActionableLicencePurposes: function hasActionableLicencePurposes() {
            return this.licence_activity_purposes.length > 0;
        }
    }),
    methods: {
        ok: function ok() {
            var vm = this;
            if ($(vm.form).valid()) {
                vm.sendData();
            }
        },
        cancel: function cancel() {
            this.close();
        },
        close: function close() {
            this.isModalOpen = false;
            this.action_licence = {
                purpose_ids_list: []
            };
            this.errors = false;
            $('.has-error').removeClass('has-error');
            this.validation_form.resetForm();
        },
        close_back_to_application: function close_back_to_application(app_id) {
            this.isModalOpen = false;
            this.action_licence = {
                purpose_ids_list: []
            };
            this.errors = false;
            $('.has-error').removeClass('has-error');
            this.validation_form.resetForm();

            this.$router.push({ name: "internal-application", params: { application_id: app_id } });
        },
        sendData: function sendData() {
            var _this = this;

            var vm = this;
            var data = new FormData();
            vm.errors = false;
            vm.actioningPurposes = true;
            if (vm.action == 'cancel') {
                if (vm.action_licence.purpose_ids_list.length > 0) {
                    data.purpose_ids_list = vm.action_licence.purpose_ids_list;
                    data.selected_activity_id = vm.selectedActivityId;
                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.licence_id + '/cancel_purposes'), (0, _stringify2.default)(data), {
                        emulateJSON: true
                    }).then(function (response) {
                        swal('Cancel Purposes', 'The selected licenced purposes have been Cancelled.', 'success');
                        vm.actioningPurposes = false;
                        vm.close();
                        vm.$emit('refreshFromResponse', response);
                    }, function (error) {
                        vm.errors = true;
                        vm.actioningPurposes = false;
                        vm.errorString = _hooks.helpers.apiVueResourceError(error);
                    });
                } else {
                    vm.actioningPurposes = false;
                    swal('Cancel Purpose', 'Please select at least once licenced purpose to Cancel.', 'error');
                }
            } else if (vm.action == 'suspend') {
                if (vm.action_licence.purpose_ids_list.length > 0) {
                    data.purpose_ids_list = vm.action_licence.purpose_ids_list;
                    data.selected_activity_id = vm.selectedActivityId;
                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.licence_id + '/suspend_purposes'), (0, _stringify2.default)(data), {
                        emulateJSON: true
                    }).then(function (response) {
                        swal('Suspend Purposes', 'The selected licenced purposes have been Suspended.', 'success');
                        vm.actioningPurposes = false;
                        vm.close();
                        vm.$emit('refreshFromResponse', response);
                    }, function (error) {
                        vm.errors = true;
                        vm.actioningPurposes = false;
                        vm.errorString = _hooks.helpers.apiVueResourceError(error);
                    });
                } else {
                    vm.actioningPurposes = false;
                    swal('Suspend Purpose', 'Please select at least once licenced purpose to Suspend.', 'error');
                }
            } else if (vm.action == 'surrender') {
                if (vm.action_licence.purpose_ids_list.length > 0) {
                    data.purpose_ids_list = vm.action_licence.purpose_ids_list;
                    data.selected_activity_id = vm.selectedActivityId;
                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.licence_id + '/surrender_purposes'), (0, _stringify2.default)(data), {
                        emulateJSON: true
                    }).then(function (response) {
                        swal('Surrender Purposes', 'The selected licenced purposes have been Surrendered.', 'success');
                        vm.actioningPurposes = false;
                        vm.close();
                        vm.$emit('refreshFromResponse', response);
                    }, function (error) {
                        vm.errors = true;
                        vm.actioningPurposes = false;
                        vm.errorString = _hooks.helpers.apiVueResourceError(error);
                    });
                } else {
                    vm.actioningPurposes = false;
                    swal('Surrender Purpose', 'Please select at least once licenced purpose to Surrender.', 'error');
                }
            } else if (vm.action == 'reactivate-renew') {
                if (vm.action_licence.purpose_ids_list.length > 0) {
                    data.purpose_ids_list = vm.action_licence.purpose_ids_list;
                    data.selected_activity_id = vm.selectedActivityId;
                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.licence_id + '/reactivate_renew_purposes'), (0, _stringify2.default)(data), {
                        emulateJSON: true
                    }).then(function (response) {
                        swal('Reactivate Renew Purposes', 'Renew for the selected licenced purposes has been Reactivated.', 'success');
                        vm.actioningPurposes = false;
                        vm.close();
                        vm.$emit('refreshFromResponse', response);
                    }, function (error) {
                        vm.errors = true;
                        vm.actioningPurposes = false;
                        vm.errorString = _hooks.helpers.apiVueResourceError(error);
                    });
                } else {
                    vm.actioningPurposes = false;
                    swal('Reactivate Renew Purpose', 'Please select at least once licenced purpose to Reactivate Renew.', 'error');
                }
            } else if (vm.action == 'reissue') {
                if (vm.action_licence.purpose_ids_list.length > 0) {
                    data.purpose_ids_list = vm.action_licence.purpose_ids_list;
                    data.selected_activity_id = vm.selectedActivityId;
                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.licence_id + '/reissue_purposes'), (0, _stringify2.default)(data), {
                        emulateJSON: true
                    }).then(function (response) {
                        vm.actioningPurposes = false;
                        var p1 = _this.licence_activity_purposes.filter(function (pur) {
                            return pur.purpose.id === _this.action_licence.purpose_ids_list[0];
                        });
                        vm.close_back_to_application(p1[0].application);
                        vm.$emit('refreshFromResponse', response);
                    }, function (error) {
                        vm.errors = true;
                        vm.actioningPurposes = false;
                        vm.errorString = _hooks.helpers.apiVueResourceError(error);
                    });
                } else {
                    vm.actioningPurposes = false;
                    swal('Reissue Purpose', 'Please select at least once licenced purpose to Reissue.', 'error');
                }
            } else if (vm.action == 'reinstate') {
                if (vm.action_licence.purpose_ids_list.length > 0) {
                    data.purpose_ids_list = vm.action_licence.purpose_ids_list;
                    data.selected_activity_id = vm.selectedActivityId;
                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.licence_id + '/reinstate_purposes'), (0, _stringify2.default)(data), {
                        emulateJSON: true
                    }).then(function (response) {
                        swal('Reinstate Purposes', 'The selected licenced purposes have been Reinstated.', 'success');
                        vm.actioningPurposes = false;
                        vm.close();
                        vm.$emit('refreshFromResponse', response);
                    }, function (error) {
                        vm.errors = true;
                        vm.actioningPurposes = false;
                        vm.errorString = _hooks.helpers.apiVueResourceError(error);
                    });
                } else {
                    vm.actioningPurposes = false;
                    swal('Reinstate Purpose', 'Please select at least once licenced purpose to Reinstate.', 'error');
                }
            }
        },
        addFormValidations: function addFormValidations() {
            var vm = this;
            vm.validation_form = $(vm.form).validate({
                rules: {
                    licence_details: "required"
                },
                messages: {},
                showErrors: function showErrors(errorMap, errorList) {
                    $.each(this.validElements(), function (index, element) {
                        var $element = $(element);
                        $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                    });

                    $("." + this.settings.validClass).tooltip("destroy");

                    for (var i = 0; i < errorList.length; i++) {
                        var error = errorList[i];
                        $(error.element).tooltip({
                            trigger: "focus"
                        }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                    }
                }
            });
        },
        updateCheckboxList: function updateCheckboxList() {
            var _this2 = this;

            var last_id = this.action_licence.purpose_ids_list.length - 1;
            var p1 = this.licence_activity_purposes.filter(function (pur) {
                return pur.purpose.id === _this2.action_licence.purpose_ids_list[last_id];
            });

            if (p1[0] && this.checkbox_list.application !== p1[0].application) {
                this.checkbox_list.application = p1[0].application;
                this.checkbox_list.purpose_ids = [];

                var _loop = function _loop(i) {
                    var p = _this2.licence_activity_purposes[i];

                    if (p.application === p1[0].application && _this2.action_licence.purpose_ids_list.find(function (id) {
                        return id === p.purpose.id;
                    })) {
                        _this2.checkbox_list.purpose_ids.push(p.purpose.id);
                    }
                };

                for (var i = 0; i < this.licence_activity_purposes.length; i++) {
                    _loop(i);
                }
            } else if (p1[0] && this.checkbox_list.application === p1[0].application) {
                this.checkbox_list.purpose_ids = [];

                var _loop2 = function _loop2(i) {
                    var p = _this2.licence_activity_purposes[i];
                    if (p.application === p1[0].application && _this2.action_licence.purpose_ids_list.find(function (id) {
                        return id === p.purpose.id;
                    })) {
                        _this2.checkbox_list.purpose_ids.push(p.purpose.id);
                    }
                };

                for (var i = 0; i < this.licence_activity_purposes.length; i++) {
                    _loop2(i);
                }
            }
            if (!p1[0]) {
                this.checkbox_list.application = 0;
                this.checkbox_list.purpose_ids = [];
            }
        }
    },
    mounted: function mounted() {
        this.form = document.forms.actionPurposeForm;
        this.addFormValidations();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'LicenceHistoryModal',
    props: {
        licence_id: String
    },
    components: {
        modal: _bootstrapModal2.default,
        datatable: _datatable2.default,
        alert: _alert2.default
    },
    data: function data() {
        var _dtOptionsLicenceHist;

        var vm = this;
        vm.history_url = _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, 'licence_history');
        return {
            isModalOpen: false,
            processingDetails: false,

            licence_history_id: '0',
            historyTable: null,
            popoversInitialised: false,
            dtHeadersLicenceHistory: ["order", "Date", "Licence"],
            dtOptionsLicenceHistory: (_dtOptionsLicenceHist = {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                deferRender: true,
                autowidth: true,
                order: [[2, 'desc']],
                dom: "<'row'<'col-sm-5'l><'col-sm-6'f>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>",
                processing: true,
                ajax: {
                    "url": vm.history_url,
                    type: 'GET',
                    "dataSrc": '',
                    data: function data(_data) {
                        _data.licence_history_id = vm.licence_history_id;
                        return _data;
                    }
                }
            }, (0, _defineProperty3.default)(_dtOptionsLicenceHist, "order", [0]), (0, _defineProperty3.default)(_dtOptionsLicenceHist, "columnDefs", [{ visible: false, targets: [0] }]), (0, _defineProperty3.default)(_dtOptionsLicenceHist, "columns", [{ data: "history_date" }, { data: "history_date" }, {
                data: "history_document_url",
                mRender: function mRender(data, type, full) {
                    return "<a href=\"" + data + "\" target=\"_blank\"><i style=\"color:red\" class=\"fa fa-file-pdf-o\"></i></a>";
                },
                orderable: false
            }]), _dtOptionsLicenceHist)
        };
    },

    watch: {},
    computed: {
        is_external: function is_external() {
            return this.level == 'external';
        },
        showLicenceHistory: function showLicenceHistory() {
            if (this.isModalOpen && !this.processingDetails) {
                this.getHistory();
            }
            return this.isModalOpen;
        }
    },
    methods: {
        cancel: function cancel() {
            this.close();
        },
        close: function close() {
            this.processingDetails = false;
            this.isModalOpen = false;
        },
        getHistory: function getHistory() {
            this.processingDetails = true;
            this.$refs.licence_history_table.vmDataTable.clear().draw();
            this.url = this.$refs.licence_history_table.vmDataTable.ajax.url;
            this.$refs.licence_history_table.vmDataTable.ajax.reload();
        }
    }
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _licence_action_purposes = __webpack_require__(806);

var _licence_action_purposes2 = _interopRequireDefault(_licence_action_purposes);

var _create_inspection_modal = __webpack_require__(83);

var _create_inspection_modal2 = _interopRequireDefault(_create_inspection_modal);

var _licence_history_modal = __webpack_require__(807);

var _licence_history_modal2 = _interopRequireDefault(_licence_history_modal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

__webpack_require__(1069);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'LicenceTableDash',
    props: {
        level: {
            type: String,
            required: true,
            validator: function validator(val) {
                var options = ['internal', 'external'];
                return options.indexOf(val) != -1 ? true : false;
            }
        },
        url: {
            type: String,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        return {
            pBody: 'pBody' + vm._uid,
            datatable_id: 'licence-datatable-' + vm._uid,
            filterLicenceType: 'All',

            filterLicenceIssuedFrom: '',
            filterLicenceIssuedTo: '',
            filterLicenceHolder: 'All',
            action_purpose_list: [],
            selected_licence_id: null,
            licence_action: '',
            dateFormat: 'DD/MM/YYYY',
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            inspection: {
                isModalOpen: false
            },
            licence_history: {
                isModalOpen: false,
                licence_history_id: '409'
            },

            licence_holders: [],
            licence_categories: [],

            licence_headers: ["Number", "Category", "Holder", "Issue Date", "Licence", "Status", "Action"],
            licence_options: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                rowCallback: function rowCallback(row, data) {
                    $(row).addClass('licRecordRow');
                },
                responsive: true,
                ajax: {
                    "url": vm.url,
                    "dataSrc": 'data',

                    "data": function data(d) {
                        d.category_name = vm.filterLicenceType;

                        d.holder = vm.filterLicenceHolder;
                        d.date_from = vm.filterLicenceIssuedFrom != '' && vm.filterLicenceIssuedFrom != null ? moment(vm.filterLicenceIssuedFrom, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                        d.date_to = vm.filterLicenceIssuedTo != '' && vm.filterLicenceIssuedTo != null ? moment(vm.filterLicenceIssuedTo, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                    }
                },
                columns: [{
                    data: "licence_number",
                    className: "licence-row-icon"
                }, {
                    data: "current_application.category_name",
                    orderable: false,
                    searchable: false }, {
                    data: "current_application.applicant",
                    orderable: false,
                    searchable: false }, {
                    data: "last_issue_date",
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format(vm.dateFormat) : '';
                    },
                    orderable: false,
                    searchable: false }, {
                    data: "licence_document",
                    mRender: function mRender(data, type, full) {
                        return '<a href=\'#\' view-licence=\'' + full.id + '\'><i style="color:red" class="fa fa-file-pdf-o"></i></a>';
                    },
                    orderable: false,
                    searchable: false
                }, {
                    data: "status",
                    orderable: false,
                    searchable: false
                }, {
                    data: "current_application",
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        var org_id = full.current_application.org_applicant ? full.current_application.org_applicant.id : '';
                        var proxy_id = full.current_application.proxy_applicant ? full.current_application.proxy_applicant.id : '';
                        var licence_category_id = full.current_application.category_id ? full.current_application.category_id : '';
                        if (full.is_latest_in_category) {
                            if (vm.is_external && full.can_add_purpose) {
                                links += '<a licence-id=\'' + full.id + '\' add-activity-purpose=\'' + full.id + '\' org-id=\'' + org_id + '\' proxy-id=\'' + proxy_id + '\' licence-category-id=\'' + licence_category_id + '\'>Amend</a><br/>';
                            }

                            if (!vm.is_external && full.can_action['can_reactivate_renew']) {
                                links += '<a reactivate-renew-licence=\'' + full.id + '\'>Reactivate Renew</a><br/>';
                            }
                            if (full.can_action['can_surrender']) {
                                links += '<a surrender-licence=\'' + full.id + '\'>Surrender</a><br/>';
                            }
                            if (!vm.is_external && full.can_action['can_cancel']) {
                                links += '<a cancel-licence=\'' + full.id + '\'>Cancel</a><br/>';
                            }
                            if (!vm.is_external && full.can_action['can_suspend']) {
                                links += '<a suspend-licence=\'' + full.id + '\'>Suspend</a><br/>';
                            }
                            if (!vm.is_external && full.can_action['can_reinstate']) {
                                links += '<a reinstate-licence=\'' + full.id + '\'>Reinstate</a><br/>';
                            }
                            if (!vm.is_external && full.can_add_purpose && !full.has_inspection_open) {
                                links += '<a inspection-licence=\'' + full.id + '\'>Request Inspection</a><br/>';
                            }
                        }
                        if (!vm.is_external) {
                            links += '<a licence-history=\'' + full.id + '\'>History</a><br/>';
                        }
                        return links;
                    },
                    orderable: false,
                    searchable: false

                }],
                processing: true,
                initComplete: function initComplete() {

                    var $searchInput = $('div.dataTables_filter input');
                    $searchInput.unbind('keyup search input');
                    $searchInput.bind('keypress', vm.delay(function (e) {
                        if (e.which == 13) {
                            vm.$refs.licence_datatable.vmDataTable.search(this.value).draw();
                        }
                    }, 0));
                    $searchInput.bind('blur', vm.delay(function () {
                        vm.$refs.licence_datatable.vmDataTable.search(this.value).draw();
                    }, 0));

                    var titleColumn = vm.$refs.licence_datatable.vmDataTable.columns(vm.getColumnIndex('category'));
                    titleColumn.data().unique().sort().each(function (d, j) {
                        var categoryTitles = [];
                        $.each(d, function (index, a) {
                            a != null && categoryTitles.indexOf(a) < 0 ? categoryTitles.push(a) : '';
                        });
                        vm.licence_categories = categoryTitles;
                    });

                    var holdersColumn = vm.$refs.licence_datatable.vmDataTable.columns(vm.getColumnIndex('holder'));
                    holdersColumn.data().unique().sort().each(function (d, j) {
                        var holders = [];
                        $.each(d, function (index, holder) {
                            if (!holders.find(function (item) {
                                return item.holder_name == holder;
                            }) || holders.length == 0) {
                                holders.push({
                                    'holder_name': holder
                                });
                            }
                        });
                        vm.licence_holders = holders;
                    });
                }
            }
        };
    },

    components: {
        modal: _bootstrapModal2.default,
        datatable: _datatable2.default,
        LicenceActionPurposes: _licence_action_purposes2.default,
        InspectionRequest: _create_inspection_modal2.default,
        LicenceHistory: _licence_history_modal2.default
    },
    watch: {
        filterLicenceType: function filterLicenceType() {
            this.$refs.licence_datatable.vmDataTable.draw();
        },

        filterLicenceIssuedFrom: function filterLicenceIssuedFrom() {
            this.$refs.licence_datatable.vmDataTable.draw();
        },
        filterLicenceIssuedTo: function filterLicenceIssuedTo() {
            this.$refs.licence_datatable.vmDataTable.draw();
        },
        filterLicenceHolder: function filterLicenceHolder() {
            this.$refs.licence_datatable.vmDataTable.draw();
        }
    },
    computed: {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie('csrftoken');
        },
        is_external: function is_external() {
            return this.level == 'external';
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setApplyOrgId', 'setApplyProxyId', 'setApplyLicenceSelect', 'setApplicationWorkflowState']), {
        addEventListeners: function addEventListeners() {
            var vm = this;

            $(vm.$refs.licenceDateToPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.licenceDateToPicker).on('dp.change', function (e) {
                if ($(vm.$refs.licenceDateToPicker).data('DateTimePicker').date()) {
                    vm.filterLicenceIssuedTo = e.date.format('DD/MM/YYYY');
                } else if ($(vm.$refs.licenceDateToPicker).data('date') === "") {
                    vm.filterLicenceIssuedTo = "";
                }
            });
            $(vm.$refs.licenceDateFromPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.licenceDateFromPicker).on('dp.change', function (e) {
                if ($(vm.$refs.licenceDateFromPicker).data('DateTimePicker').date()) {
                    vm.filterLicenceIssuedFrom = e.date.format('DD/MM/YYYY');
                    $(vm.$refs.licenceDateToPicker).data("DateTimePicker").minDate(e.date);
                } else if ($(vm.$refs.licenceDateFromPicker).data('date') === "") {
                    vm.filterLicenceIssuedFrom = "";
                    $(vm.$refs.licenceDateToPicker).data("DateTimePicker").minDate(false);
                }
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[add-activity-purpose]', function (e) {
                var _this = this;

                e.preventDefault();
                swal({
                    title: "Amend Licence",
                    text: "Are you sure you want to add an activity or purpose to this licence?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.setApplyLicenceSelect({ licence_select: 'new_activity' });
                        var licence_no = $(_this).attr('licence-id');
                        var licence_category_id = $(_this).attr('licence-category-id');
                        var licence_activity_id = null;
                        vm.setApplyProxyId({ id: $(_this).attr('proxy-id') });
                        vm.setApplyOrgId({ id: $(_this).attr('org-id') });
                        vm.routeApplyLicence(licence_no, licence_category_id, licence_activity_id);
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[amend-licence]', function (e) {
                var _this2 = this;

                e.preventDefault();
                swal({
                    title: "Amend Licence",
                    text: "Are you sure you want to amend all current activities and purposes for this licence?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.setApplyLicenceSelect({ licence_select: 'amend_activity' });
                        var licence_no = $(_this2).attr('licence-id');
                        var licence_category_id = $(_this2).attr('licence-category-id');
                        var licence_activity_id = null;
                        vm.setApplyProxyId({ id: $(_this2).attr('proxy-id') });
                        vm.setApplyOrgId({ id: $(_this2).attr('org-id') });
                        vm.routeApplyLicence(licence_no, licence_category_id, licence_activity_id);
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[amend-activity]', function (e) {
                var _this3 = this;

                e.preventDefault();
                swal({
                    title: "Amend Purpose Activity",
                    text: "Are you sure you want to amend this purpose activity?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.setApplyLicenceSelect({ licence_select: 'amend_activity' });
                        var licence_no = $(_this3).attr('licence-id');
                        var licence_category_id = $(_this3).attr('licence-category-id');
                        var licence_activity_id = $(_this3).attr('amend-activity');
                        var select_activity_id = $(_this3).attr('select-activity');
                        var select_purpose_id = $(_this3).attr('select-purpose');
                        var licence_purpose_id = $(_this3).attr('licence-purpose-id');
                        vm.setApplyProxyId({ id: $(_this3).attr('proxy-id') });
                        vm.setApplyOrgId({ id: $(_this3).attr('org-id') });
                        vm.routeApplyLicence(licence_no, licence_category_id, licence_activity_id, select_activity_id, select_purpose_id, licence_purpose_id);
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[renew-licence]', function (e) {
                var _this4 = this;

                e.preventDefault();
                swal({
                    title: "Renew Licence",
                    text: "Are you sure you want to renew all current activities and purposes for this licence?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.setApplyLicenceSelect({ licence_select: 'renew_activity' });
                        var licence_no = $(_this4).attr('licence-id');
                        var licence_category_id = $(_this4).attr('licence-category-id');
                        var licence_activity_id = null;
                        vm.setApplyProxyId({ id: $(_this4).attr('proxy-id') });
                        vm.setApplyOrgId({ id: $(_this4).attr('org-id') });
                        vm.routeApplyLicence(licence_no, licence_category_id, licence_activity_id);
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[renew-activity]', function (e) {
                var _this5 = this;

                e.preventDefault();
                swal({
                    title: "Renew Activity",
                    text: "Are you sure you want to renew this activity?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.setApplyLicenceSelect({ licence_select: 'renew_activity' });
                        var licence_no = $(_this5).attr('licence-id');
                        var licence_category_id = $(_this5).attr('licence-category-id');
                        var licence_activity_id = $(_this5).attr('renew-activity');
                        var select_activity_id = $(_this5).attr('select-activity');
                        var select_purpose_id = $(_this5).attr('select-purpose');
                        var licence_purpose_id = $(_this5).attr('licence-purpose-id');
                        vm.setApplyProxyId({ id: $(_this5).attr('proxy-id') });
                        vm.setApplyOrgId({ id: $(_this5).attr('org-id') });
                        vm.routeApplyLicence(licence_no, licence_category_id, licence_activity_id, select_activity_id, select_purpose_id, licence_purpose_id);
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[reactivate-renew-purposes]', function (e) {
                var _this6 = this;

                e.preventDefault();
                swal({
                    title: "Reactivate Renew for Activity",
                    text: "Are you sure you want to reactivate the renew option for purposes on this activity?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        var licence_activity_id = $(_this6).attr('reactivate-renew-purposes');
                        var licence_id = $(_this6).attr('lic-id');
                        vm.licence_action = 'reactivate-renew';
                        vm.selected_licence_id = licence_id;
                        vm.$http.get(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.licences, licence_id + '/get_latest_purposes_for_licence_activity_and_action/?licence_activity_id=' + licence_activity_id + '&action=' + vm.licence_action)).then(function (res) {
                            if (res.body) {
                                vm.action_purpose_list = res.body;
                                vm.$refs.licence_action_purposes.isModalOpen = true;
                            }
                        }, function (error) {
                            swal('Reactivate Renew Activity Error', _hooks.helpers.apiVueResourceError(error), 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[surrender-licence]', function (e) {
                var _this7 = this;

                e.preventDefault();
                swal({
                    title: "Surrender Licence",
                    text: "Are you sure you want to surrender all current activities and purposes for this licence?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        var licence_id = $(_this7).attr('surrender-licence');
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, licence_id + '/surrender_licence')).then(function (response) {
                            swal('Surrender Licence', 'The selected licence\'s current activities and purposes have been Surrendered.', 'success');
                            vm.refreshFromResponse(response);
                        }, function (error) {
                            swal('Surrender Licence Error', _hooks.helpers.apiVueResourceError(error), 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[surrender-purposes]', function (e) {
                var _this8 = this;

                e.preventDefault();
                swal({
                    title: "Surrender Activity",
                    text: "Are you sure you want to surrender purposes for this activity?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        var licence_activity_id = $(_this8).attr('surrender-purposes');
                        var licence_id = $(_this8).attr('lic-id');
                        vm.licence_action = 'surrender';
                        vm.selected_licence_id = licence_id;
                        var select_activity_id = $(_this8).attr('select-activity');
                        var select_purpose_id = $(_this8).attr('select-purpose');
                        var data = new FormData();

                        data.purpose_ids_list = select_purpose_id;
                        data.selected_activity_id = select_activity_id;
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.selected_licence_id + '/surrender_purposes'), (0, _stringify2.default)(data), {
                            emulateJSON: true
                        }).then(function (response) {
                            vm.$refs.licence_datatable.vmDataTable.ajax.reload();
                            vm.$emit('refreshFromResponse', response);
                        }, function (error) {
                            swal('Surrender Activity Error', _hooks.helpers.apiVueResourceError(error), 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[cancel-licence]', function (e) {
                var _this9 = this;

                e.preventDefault();
                swal({
                    title: "Cancel Licence",
                    text: "Are you sure you want to cancel all current activities and purposes for this licence?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        var licence_id = $(_this9).attr('cancel-licence');
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, licence_id + '/cancel_licence')).then(function (response) {
                            swal('Cancel Licence', 'The selected licence\'s current activities and purposes have been Cancelled.', 'success');
                            vm.refreshFromResponse(response);
                        }, function (error) {
                            swal('Cancel Licence Error', _hooks.helpers.apiVueResourceError(error), 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[cancel-purposes]', function (e) {
                var _this10 = this;

                e.preventDefault();
                swal({
                    title: "Cancel Activity Purposes",
                    text: "Are you sure you want to cancel purposes for this activity?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        var licence_activity_id = $(_this10).attr('cancel-purposes');
                        var licence_id = $(_this10).attr('lic-id');
                        vm.licence_action = 'cancel';
                        vm.selected_licence_id = licence_id;
                        var select_activity_id = $(_this10).attr('select-activity');
                        var select_purpose_id = $(_this10).attr('select-purpose');
                        var data = new FormData();

                        data.purpose_ids_list = select_purpose_id;
                        data.selected_activity_id = select_activity_id;
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.selected_licence_id + '/cancel_purposes'), (0, _stringify2.default)(data), {
                            emulateJSON: true
                        }).then(function (response) {
                            vm.$refs.licence_datatable.vmDataTable.ajax.reload();
                            vm.$emit('refreshFromResponse', response);
                        }, function (error) {
                            swal('Cancel Activity Purposes Error', _hooks.helpers.apiVueResourceError(error), 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[suspend-licence]', function (e) {
                var _this11 = this;

                e.preventDefault();
                swal({
                    title: "Suspend Licence",
                    text: "Are you sure you want to suspend all current activities and purposes for this licence?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        var licence_id = $(_this11).attr('suspend-licence');
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, licence_id + '/suspend_licence')).then(function (response) {
                            swal('Suspend Licence', 'The selected licence\'s current activities and purposes have been Suspended.', 'success');
                            vm.refreshFromResponse(response);
                        }, function (error) {
                            swal('Suspend Licence Error', _hooks.helpers.apiVueResourceError(error), 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[suspend-purposes]', function (e) {
                var _this12 = this;

                e.preventDefault();
                swal({
                    title: "Suspend Activity Purposes",
                    text: "Are you sure you want to suspend purposes for this activity?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        var licence_activity_id = $(_this12).attr('suspend-purposes');
                        var licence_id = $(_this12).attr('lic-id');
                        vm.licence_action = 'suspend';
                        vm.selected_licence_id = licence_id;
                        var select_activity_id = $(_this12).attr('select-activity');
                        var select_purpose_id = $(_this12).attr('select-purpose');
                        var data = new FormData();

                        data.purpose_ids_list = select_purpose_id;
                        data.selected_activity_id = select_activity_id;
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.selected_licence_id + '/suspend_purposes'), (0, _stringify2.default)(data), {
                            emulateJSON: true
                        }).then(function (response) {
                            vm.$refs.licence_datatable.vmDataTable.ajax.reload();
                            vm.$emit('refreshFromResponse', response);
                        }, function (error) {
                            swal('Suspend Activity Purposes Error', _hooks.helpers.apiVueResourceError(error), 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[reissue-licence]', function (e) {
                var _this13 = this;

                e.preventDefault();
                swal({
                    title: "Reissue Licence",
                    text: "Are you sure you want to reissue all current activities and purposes for this licence?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.setApplyLicenceSelect({ licence_select: 'reissue_activity' });
                        var licence_category_id = $(_this13).attr('licence-category-id');
                        var licence_activity_id = null;
                        vm.setApplyProxyId({ id: $(_this13).attr('proxy-id') });
                        vm.setApplyOrgId({ id: $(_this13).attr('org-id') });
                        vm.routeApplyLicence(licence_category_id, licence_activity_id);
                    }
                }, function (error) {});
            });
            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[reissue-activity]', function (e) {
                var _this14 = this;

                e.preventDefault();
                swal({
                    title: "Reissue License",
                    text: "Are you sure you want to reissue this activity purpose?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        var licence_activity_id = $(_this14).attr('reissue-activity');
                        var licence_id = $(_this14).attr('lic-id');
                        vm.licence_action = 'reissue';
                        vm.selected_licence_id = licence_id;
                        var select_activity_id = $(_this14).attr('select-activity');
                        var select_purpose_id = $(_this14).attr('select-purpose');
                        var data = new FormData();

                        data.purpose_ids_list = select_purpose_id;
                        data.selected_activity_id = select_activity_id;
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.selected_licence_id + '/reissue_purposes'), (0, _stringify2.default)(data), {
                            emulateJSON: true
                        }).then(function (response) {
                            var app_id = response.body.current_application.id;
                            vm.$router.push({ name: "internal-application", params: { application_id: app_id } });
                            vm.$emit('refreshFromResponse', response);
                        }, function (error) {
                            swal('Reissue Activity Error', _hooks.helpers.apiVueResourceError(error), 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[reinstate-licence]', function (e) {
                var _this15 = this;

                e.preventDefault();
                swal({
                    title: "Reinstate Licence",
                    text: "Are you sure you want to reinstate all suspended activities and purposes for this licence?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        var licence_id = $(_this15).attr('reinstate-licence');
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, licence_id + '/reinstate_licence')).then(function (response) {
                            swal('Reinstate Licence', 'The selected licence\'s suspended activities and purposes have been Reinstated.', 'success');
                            vm.refreshFromResponse(response);
                        }, function (error) {
                            swal('Reinstate Licence Error', _hooks.helpers.apiVueResourceError(error), 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[reinstate-purposes]', function (e) {
                var _this16 = this;

                e.preventDefault();
                swal({
                    title: "Reinstate Activity",
                    text: "Are you sure you want to reinstate purpose for this activity?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        var licence_activity_id = $(_this16).attr('reinstate-purposes');
                        var licence_id = $(_this16).attr('lic-id');
                        vm.licence_action = 'reinstate';
                        vm.selected_licence_id = licence_id;
                        var select_activity_id = $(_this16).attr('select-activity');
                        var select_purpose_id = $(_this16).attr('select-purpose');
                        var data = new FormData();

                        data.purpose_ids_list = select_purpose_id;
                        data.selected_activity_id = select_activity_id;
                        console.log(licence_id);
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, vm.selected_licence_id + '/reinstate_purposes'), (0, _stringify2.default)(data), {
                            emulateJSON: true
                        }).then(function (response) {
                            vm.$refs.licence_datatable.vmDataTable.ajax.reload();
                            vm.$emit('refreshFromResponse', response);
                        }, function (error) {
                            swal('Reinstate Activity Error', _hooks.helpers.apiVueResourceError(error), 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[licence-history]', function (e) {
                e.preventDefault();
                var licence_id = $(this).attr('licence-history');
                vm.$refs.licence_history.licence_history_id = licence_id;
                vm.$refs.licence_history.isModalOpen = true;
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[inspection-licence]', function (e) {
                e.preventDefault();
                vm.$refs.selected_licence_id = $(this).attr('inspection-licence');
                vm.$refs.inspection.isModalOpen = true;
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'a[view-licence]', function (e) {
                e.preventDefault();
                var licence_id = $(this).attr('view-licence');
                vm.viewLicence(licence_id);
            });

            vm.$refs.licence_datatable.vmDataTable.on('click', 'tr.licRecordRow', function (e) {
                if ($(e.target).is('a')) {
                    return;
                }

                var tr = $(this);
                var row = vm.$refs.licence_datatable.vmDataTable.row(tr);
                var row_data = row.data();
                var licence_id = row_data.id;
                var current_application = row_data.current_application;
                var licence_category_id = current_application.category_id ? current_application.category_id : "";
                var proxy_id = current_application.proxy_applicant ? current_application.proxy_applicant.id : "";
                var org_id = current_application.org_applicant ? current_application.org_applicant.id : "";

                if (row.child.isShown()) {
                    row.child.hide();
                    tr.removeClass('shown');
                } else {
                    var child_row = '';

                    var activity_rows = '';
                    row.data()['latest_activities_merged'].forEach(function (activity) {
                        activity_rows += '\n                            <tr>\n                                <td>' + activity['activity_purpose_no'] + '</td>\n                                <td>' + activity['activity_name_str'] + '</td>\n                                <td>' + activity['activity_purpose_name'] + '</td>\n                                <td>' + activity['expiry_date'].replace(/(?:\r\n|\r|\n|,)/g, '<br>') + '</td>\n                                <td>' + activity['activity_purpose_status'] + '</td>\n                                <td>';
                        if (vm.is_external && activity['can_action']['can_amend']) {
                            activity_rows += '<a licence-id=\'' + licence_id + '\' select-activity=\'' + activity["id"] + '\' amend-activity=\'' + activity["licence_activity_id"] + '\' select-purpose=\'' + activity["activity_purpose_id"] + '\' proxy-id=\'' + proxy_id + '\' org-id=\'' + org_id + '\' licence-purpose-id=\'' + activity["licence_purpose_id"] + '\' licence-category-id=\'' + licence_category_id + '\'>Amend</a></br>';
                        }
                        if (vm.is_external && activity['can_action']['can_renew']) {
                            activity_rows += '<a licence-id=\'' + licence_id + '\' select-activity=\'' + activity["id"] + '\' renew-activity=\'' + activity["licence_activity_id"] + '\' select-purpose=\'' + activity["activity_purpose_id"] + '\' proxy-id=\'' + proxy_id + '\' org-id=\'' + org_id + '\' licence-purpose-id=\'' + activity["licence_purpose_id"] + '\' licence-category-id=\'' + licence_category_id + '\'>Renew</a></br>';
                        }
                        if (!vm.is_external && activity['can_action']['can_reactivate_renew']) {
                            activity_rows += '<a reactivate-renew-purposes=\'' + activity["licence_activity_id"] + '\' select-activity=\'' + activity["id"] + '\' lic-id=\'' + licence_id + '\'>Reactivate Renew</a></br>';
                        }
                        if (activity['can_action']['can_surrender']) {
                            activity_rows += '<a surrender-purposes=\'' + activity["licence_activity_id"] + '\' select-activity=\'' + activity["id"] + '\' select-purpose=\'' + activity["activity_purpose_id"] + '\' lic-id=\'' + licence_id + '\'>Surrender</a></br>';
                        }
                        if (!vm.is_external && activity['can_action']['can_cancel']) {
                            activity_rows += '<a cancel-purposes=\'' + activity["licence_activity_id"] + '\' select-activity=\'' + activity["id"] + '\' select-purpose=\'' + activity["activity_purpose_id"] + '\' lic-id=\'' + licence_id + '\'>Cancel</a></br>';
                        }
                        if (!vm.is_external && activity['can_action']['can_suspend']) {
                            activity_rows += '<a suspend-purposes=\'' + activity["licence_activity_id"] + '\' select-activity=\'' + activity["id"] + '\' select-purpose=\'' + activity["activity_purpose_id"] + '\' lic-id=\'' + licence_id + '\'>Suspend</a></br>';
                        }
                        if (!vm.is_external && activity['can_action']['can_reissue']) {
                            activity_rows += '<a reissue-activity=\'' + activity['licence_activity_id'] + '\' select-activity=\'' + activity["id"] + '\' select-purpose=\'' + activity["activity_purpose_id"] + '\' lic-id=\'' + licence_id + '\' proxy-id=\'' + proxy_id + '\' org-id=\'' + org_id + '\' licence-category-id=\'' + licence_category_id + '\'>Reissue</a></br>';
                        }
                        if (!vm.is_external && activity['can_action']['can_reinstate']) {
                            activity_rows += '<a reinstate-purposes=\'' + activity["licence_activity_id"] + '\' select-activity=\'' + activity["id"] + '\' select-purpose=\'' + activity["activity_purpose_id"] + '\' lic-id=\'' + licence_id + '\'>Reinstate</a></br>';
                        }
                        activity_rows += '</td>\n                            </tr>';
                    });

                    child_row += '\n                        <table class="table table-bordered child-row-table">\n                            ';

                    child_row += '\n                            ' + (row.data()['invoice_url'] ? '<tr>\n                                <td class="width_15pc"><strong>Invoice:&nbsp;</strong></td>\n                                <td><a href="' + row.data()['invoice_url'] + '\'" target="_blank"><i style="color:red" class="fa fa-file-pdf-o"></i></a></td>\n                            </tr>' : ' ') + ' ';

                    child_row += '</table>';
                    child_row += '\n                        <table class="table table-striped table-bordered child-row-table">\n                            <tr>\n                                <th>Number</th>\n                                <th>Activity</th>\n                                <th class="width_50pc">Purpose</th>\n                                <th class="width_10pc">Expiry Date</th>\n                                <th class="width_10pc">Status</th>\n                                <th class="width_10pc">Action</th>\n                            </tr>\n                            ' + activity_rows + '\n                        </table>';

                    row.child(child_row, 'dark-row').show();
                    tr.addClass('shown');
                }
            });
        },
        post_and_redirect: function post_and_redirect(url, postData) {
            var postFormStr = "<form method='POST' target='_blank' name='securebase-view' action='" + url + "'>";

            for (var key in postData) {
                if (postData.hasOwnProperty(key)) {
                    postFormStr += "<input type='hidden' name='" + key + "' value='" + postData[key] + "'>";
                }
            }
            postFormStr += "</form>";
            var formElement = $(postFormStr);
            $('body').append(formElement);
            $(formElement).submit();
            this.spinner = false;
        },
        viewLicence: function viewLicence(licence_id) {
            this.post_and_redirect('/securebase-view/', { 'csrfmiddlewaretoken': this.csrf_token, 'licence_id': licence_id });
        },
        requestedInspection: function requestedInspection(event) {
            var _this17 = this;

            var data = {
                "inspection_id": event.inspection
            };
            var licence_id = this.$refs.selected_licence_id;
            this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.licences, licence_id + '/add_licence_inspection'), (0, _stringify2.default)(data)).then(function (response) {
                swal('Request Licence Inspection', 'The selected licence has an opened Inspection #' + event.inspection, 'success');
                _this17.refreshFromResponse(response);
            }, function (error) {
                swal('Creating Inspection Error', _hooks.helpers.apiVueResourceError(error), 'error');
            });
        },
        refreshFromResponse: function refreshFromResponse(response) {
            this.$refs.licence_datatable.vmDataTable.ajax.reload();
        },
        delay: function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        },

        initialiseSearch: function initialiseSearch() {
            this.dateSearch();
            this.holderSearch();
        },
        holderSearch: function holderSearch() {
            var vm = this;
            vm.$refs.licence_datatable.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var filtered_holder = vm.filterLicenceHolder;
                if (filtered_holder == 'All') {
                    return true;
                }
                return filtered_holder == original.holder;
            });
        },
        dateSearch: function dateSearch() {
            var vm = this;
            vm.$refs.licence_datatable.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var from = vm.filterLicenceIssuedFrom;
                var to = vm.filterLicenceIssuedTo;
                var val = original.last_issue_date;

                if (from == '' && to == '') {
                    return true;
                } else if (from != '' && to != '') {
                    return val != null && val != '' ? moment().range(moment(from, vm.dateFormat), moment(to, vm.dateFormat)).contains(moment(val)) : false;
                } else if (from == '' && to != '') {
                    if (val != null && val != '') {
                        return moment(to, vm.dateFormat).diff(moment(val)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (to == '' && from != '') {
                    if (val != null && val != '') {
                        return moment(val).diff(moment(from, vm.dateFormat)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            });
        },
        getColumnIndex: function getColumnIndex(column_name) {
            return this.licence_headers.map(function (header) {
                return header.toLowerCase();
            }).indexOf(column_name.toLowerCase());
        },
        routeApplyLicence: function routeApplyLicence(licence_no, licence_category_id, licence_activity_id, select_activity_id, select_purpose_id, select_licence_purpose_id) {
            this.setApplicationWorkflowState({ bool: true });
            return this.$router.push({
                name: "apply_application_licence",
                params: {
                    licence_category: licence_category_id,
                    licence_activity: licence_activity_id,
                    licence_no: licence_no,
                    select_activity: select_activity_id,
                    select_purpose: select_purpose_id,
                    select_licence_purpose: select_licence_purpose_id
                }
            });
        },
        close_back_to_application: function close_back_to_application(app_id) {
            this.$router.push({ name: "internal-application", params: { application_id: app_id } });
        }
    }),
    mounted: function mounted() {
        var vm = this;
        $('a[data-toggle="collapse"]').on('click', function () {
            var chev = $(this).children()[0];
            window.setTimeout(function () {
                $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
            }, 100);
        });
        this.$nextTick(function () {
            vm.addEventListeners();
            vm.initialiseSearch();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(10)))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _leaflet = __webpack_require__(54);

var _leaflet2 = _interopRequireDefault(_leaflet);

__webpack_require__(125);

__webpack_require__(66);

var _awesomplete = __webpack_require__(43);

var _awesomplete2 = _interopRequireDefault(_awesomplete);

var _vuex = __webpack_require__(6);

var _helpers = __webpack_require__(42);

__webpack_require__(15);

__webpack_require__(39);

__webpack_require__(65);

__webpack_require__(122);

__webpack_require__(64);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "map-leaflet",
  props: {
    marker_longitude: {
      required: false,
      default: null
    },
    marker_latitude: {
      required: false,
      default: null
    },
    readonly: {
      required: false,
      default: false
    }
  },
  data: function data() {
    var defaultCentre = [13775786.985667605, -2871569.067879858];

    var vm = this;
    var baseDic = {
      shadowUrl: __webpack_require__(46),
      shadowSize: [41, 41],
      shadowAnchor: [12, 41],
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -20]
    };
    vm.icon_default = _leaflet2.default.icon((0, _extends3.default)({
      iconUrl: __webpack_require__(93)
    }, baseDic));
    vm.guid = (0, _helpers.guid)();

    return {
      mapboxAccessToken: null,
      marker_lng: null,
      marker_lat: null,
      defaultCenter: defaultCentre,
      projection: null,
      mainMap: null,
      popup: null,
      element: null,
      base_layer: "osm",
      awe: null,
      suggest_list: [],
      feature_marker: null,
      cursor_location: null,
      idMap: vm.guid + "mapLeaf",
      idSearchInput: vm.guid + "SearchInput",
      idBasemapSat: vm.guid + "BasemapSat",
      idBasemapOsm: vm.guid + "BasemapOsm"
    };
  },
  computed: {},
  watch: {
    marker_latitude: function marker_latitude() {
      this.marker_lat = this.marker_latitude;
    },
    marker_longitude: function marker_longitude() {
      this.marker_lng = this.marker_longitude;
    },
    marker_lat: function marker_lat() {
      if (!isNaN(this.marker_lat) && !isNaN(this.marker_lng)) {
        this.refreshMarkerLocation();
      }
    },
    marker_lng: function marker_lng() {
      if (!isNaN(this.marker_lat) && !isNaN(this.marker_lng)) {
        this.refreshMarkerLocation();
      }
    }
  },
  created: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var temp_token;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.retrieveMapboxAccessToken();

            case 2:
              temp_token = _context.sent;

              this.mapboxAccessToken = temp_token.access_token;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    var vm = this;

    vm.initMap();
    vm.setBaseLayer("osm");
    vm.initAwesomplete();
    if (vm.marker_lat && vm.marker_lng) {
      vm.addMarker([vm.marker_lat, vm.marker_lng]);
    }
  },
  methods: {
    setMarkerCentre: function setMarkerCentre() {
      var z = this.mainMap.getZoom();
      if (!isNaN(this.marker_lat) && !isNaN(this.marker_lng)) {
        var latlng = [this.marker_lat, this.marker_lng];

        this.mainMap.flyTo(latlng, z, {
          animate: true,
          duration: 1.5
        });
      }
    },
    invalidateSize: function invalidateSize() {
      var vm = this;
      setTimeout(function () {
        vm.mainMap.invalidateSize();
      }, 300);
    },
    setMarkerIcon: function setMarkerIcon() {
      var vm = this;
      if (vm.feature_marker) {
        vm.feature_marker.setIcon(vm.icon_default);
      }
    },
    addMarker: function addMarker(latLngArr) {
      var vm = this;
      vm.feature_marker = _leaflet2.default.marker({ lon: latLngArr[1], lat: latLngArr[0] }, { icon: vm.icon_default }).on("click", function (ev) {
        vm.feature_marker.setIcon(myIcon);
      });

      vm.feature_marker.addTo(vm.mainMap);
      vm.setMarkerIcon();
    },

    search: function search(place) {
      var self = this;

      var latlng = this.mainMap.getCenter();
      $.ajax({
        url: _hooks.api_endpoints.geocoding_address_search + encodeURIComponent(place) + ".json?" + $.param({
          country: "au",
          limit: 10,
          proximity: "" + latlng.lng + "," + latlng.lat,
          access_token: self.mapboxAccessToken,
          bbox: "112.920934,-35.191991,129.0019283,-11.9662455",
          types: "region,postcode,district,place,locality,neighborhood,address,poi"
        }),
        dataType: "json",
        success: function success(data, status, xhr) {
          self.suggest_list = [];
          if (data.features && data.features.length > 0) {
            for (var i = 0; i < data.features.length; i++) {
              self.suggest_list.push({
                label: data.features[i].place_name,
                value: data.features[i].place_name,
                feature: data.features[i]
              });
            }
          }

          self.awe.list = self.suggest_list;
          self.awe.evaluate();
        }
      });
    },
    initAwesomplete: function initAwesomplete() {
      var self = this;
      var element_search = document.getElementById(self.idSearchInput);
      this.awe = new _awesomplete2.default(element_search);
      $(element_search).on("keyup", function (ev) {
        var keyCode = ev.keyCode || ev.which;
        if (48 <= keyCode && keyCode <= 90 || 96 <= keyCode && keyCode <= 105 || keyCode == 8 || keyCode == 46) {
          self.search(ev.target.value);
          return false;
        }
      }).on("awesomplete-selectcomplete", function (ev) {
        ev.preventDefault();
        ev.stopPropagation();

        for (var i = 0; i < self.suggest_list.length; i++) {
          if (self.suggest_list[i].value == ev.target.value) {
            var latlng = {
              lat: self.suggest_list[i].feature.geometry.coordinates[1],
              lng: self.suggest_list[i].feature.geometry.coordinates[0]
            };

            self.mainMap.flyTo(latlng, 13, {
              animate: true,
              duration: 1.5
            });

            if (!self.readonly) {
              if (!self.feature_marker) {
                self.addMarker([latlng.lat, latlng.lng]);
              }
              self.marker_lat = latlng.lat;
              self.marker_lng = latlng.lng;
              self.refreshMarkerLocation();
            }
          }
        }
        return false;
      });
    },
    setBaseLayer: function setBaseLayer(selected_layer_name) {
      if (selected_layer_name == "sat") {
        this.mainMap.removeLayer(this.tileLayer);
        this.mainMap.addLayer(this.tileLayerSat);
        $("#" + this.idBasemapSat).hide();
        $("#" + this.idBasemapOsm).show();
      } else {
        this.mainMap.removeLayer(this.tileLayerSat);
        this.mainMap.addLayer(this.tileLayer);
        $("#" + this.idBasemapOsm).hide();
        $("#" + this.idBasemapSat).show();
      }
    },

    refreshMarkerLocation: function refreshMarkerLocation() {
      if (!isNaN(this.marker_lat) && !isNaN(this.marker_lng)) {
        var latlng = [this.marker_lat, this.marker_lng];

        if (!this.feature_marker) {
          this.addMarker(latlng);
        } else {
          this.feature_marker.setLatLng({
            lat: this.marker_lat,
            lng: this.marker_lng
          });
        }

        this.$emit('location-updated', { 'lat': this.marker_lat, 'lng': this.marker_lng });
      }
    },
    initMap: function initMap() {
      this.marker_lat = this.marker_latitude;
      this.marker_lng = this.marker_longitude;

      if (this.marker_lat && this.marker_lng) {
        this.mainMap = _leaflet2.default.map(this.idMap).setView([this.marker_lat, this.marker_lng], 12);
      } else {
        this.mainMap = _leaflet2.default.map(this.idMap).setView([-31.9505, 115.8605], 4);
      }

      this.tileLayer = _leaflet2.default.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, contributiors'
      });

      this.tileLayerSat = _leaflet2.default.tileLayer.wmts("https://kmi.dpaw.wa.gov.au/geoserver/gwc/service/wmts", {
        layer: "public:mapbox-satellite",
        tilematrixSet: "mercator",
        format: "image/png"
      });

      this.mainMap.on("click", this.onClick).on("mousemove", this.onMouseMove).on("mouseout", this.onMouseOut);
      this.setBaseLayer("osm");
      var measureControl = new _leaflet2.default.Control.Measure({
        position: "topleft",
        primaryLengthUnit: "meters",
        activeColor: "#ff7f50",
        completedColor: "#228b22"
      });
      measureControl.addTo(this.mainMap);
      _leaflet2.default.control.locate().addTo(this.mainMap);
    },
    onMouseMove: function onMouseMove(e) {
      var vm = this;
      vm.cursor_location = vm.mainMap.mouseEventToLatLng(e.originalEvent);
    },
    onMouseOut: function onMouseOut(e) {
      this.cursor_location = null;
    },
    onClick: function onClick(e) {
      if (!this.readonly) {
        var self = this;
        var latlng = this.mainMap.mouseEventToLatLng(e.originalEvent);
        if (!self.feature_marker) {
          self.addMarker([latlng.lat, latlng.lng]);
        }

        this.marker_lat = latlng.lat;
        this.marker_lng = latlng.lng;
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _search_person_or_organisation = __webpack_require__(49);

var _search_person_or_organisation2 = _interopRequireDefault(_search_person_or_organisation);

var _document_artifact_component = __webpack_require__(319);

var _document_artifact_component2 = _interopRequireDefault(_document_artifact_component);

var _physical_artifact_component = __webpack_require__(323);

var _physical_artifact_component2 = _interopRequireDefault(_physical_artifact_component);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "PersonOrArtifactModal",
    data: function data() {
        return {
            isModalOpen: false,
            tabSelected: '',
            urlText: '',
            urlProtocol: 'https',
            uuid: 0,
            entity: {},
            pTab: 'pTab' + this._uid,
            aTab: 'aTab' + this._uid,
            uTab: 'uTab' + this._uid,
            componentType: '',
            documentArtifactErrorMessage: ''
        };
    },
    props: {
        readonlyForm: {
            required: false,
            default: true
        },
        rowNumberSelected: {
            type: String,
            required: false
        },
        initialTabSelected: {
            type: String
        },
        entityEdit: {
            type: Object,
            required: false
        }
    },
    components: {
        modal: _bootstrapModal2.default,
        SearchPersonOrganisation: _search_person_or_organisation2.default,
        DocumentArtifact: _document_artifact_component2.default,
        PhysicalArtifact: _physical_artifact_component2.default
    },
    watch: {
        tabSelected: {
            handler: function () {
                var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    this.uuid += 1;

                                case 1:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                function handler() {
                    return _ref.apply(this, arguments);
                }

                return handler;
            }()
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        showDocumentArtifactComponent: function showDocumentArtifactComponent() {
            var showComponent = false;
            if (this.componentType === 'document') {
                showComponent = true;
            }
            return showComponent;
        },
        legalCaseId: function legalCaseId() {
            var legalId = '';
            if (this.legal_case) {
                legalId = this.legal_case.id;
            }
            return legalId;
        },
        legalCaseExists: function legalCaseExists() {
            var exists = false;
            if (this.legal_case && this.legal_case.id) {
                exists = true;
            }
            return exists;
        },
        showPhysicalArtifactComponent: function showPhysicalArtifactComponent() {
            var showComponent = false;
            if (this.componentType === 'physical') {
                showComponent = true;
            }
            return showComponent;
        },
        updateSearchPersonOrganisationBindId: function updateSearchPersonOrganisationBindId() {
            return "PersonOrArtifact_SearchPerson_" + this.uuid.toString();
        },
        updateDocumentArtifactBindId: function updateDocumentArtifactBindId() {
            return "PersonOrArtifact_DocumentArtifact_" + this.uuid.toString();
        },
        updatePhysicalArtifactBindId: function updatePhysicalArtifactBindId() {
            return "PersonOrArtifact_PhysicalArtifact_" + this.uuid.toString();
        },
        updateURLBindId: function updateURLBindId() {
            return "PersonOrArtifact_URL_" + this.uuid.toString();
        },
        personTabSelected: function personTabSelected() {
            var isPersonTab = false;
            if (this.tabSelected === 'pTab') {
                isPersonTab = true;
            }
            return isPersonTab;
        },
        artifactTabSelected: function artifactTabSelected() {
            var isArtifactTab = false;
            if (this.tabSelected === 'aTab') {
                isArtifactTab = true;
            }
            return isArtifactTab;
        },
        urlTabSelected: function urlTabSelected() {
            var isUrlTab = false;
            if (this.tabSelected === 'uTab') {
                isUrlTab = true;
            }
            return isUrlTab;
        },
        personTabClass: function personTabClass() {
            var tabClass = 'tab-pane fade in';
            if (this.personTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        personTabListClass: function personTabListClass() {
            var tabClass = 'nav-item';
            if (this.personTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        artifactTabClass: function artifactTabClass() {
            var tabClass = 'tab-pane fade in';
            if (this.artifactTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        artifactTabListClass: function artifactTabListClass() {
            var tabClass = 'nav-item';
            if (this.artifactTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        urlTabClass: function urlTabClass() {
            var tabClass = 'tab-pane fade in';
            if (this.urlTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        urlTabListClass: function urlTabListClass() {
            var tabClass = 'nav-item';
            if (this.urlTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        }
    }),

    methods: {
        updateTabSelected: function updateTabSelected(tabValue) {
            this.tabSelected = tabValue;
        },
        cancelArtifactComponent: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.artifactTabSelected) {
                                    _context2.next = 9;
                                    break;
                                }

                                if (!this.showDocumentArtifactComponent) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 4;
                                return this.$refs.document_artifact.cancel();

                            case 4:
                                _context2.next = 9;
                                break;

                            case 6:
                                if (!this.showPhysicalArtifactComponent) {
                                    _context2.next = 9;
                                    break;
                                }

                                _context2.next = 9;
                                return this.$refs.physical_artifact.cancel();

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function cancelArtifactComponent() {
                return _ref2.apply(this, arguments);
            }

            return cancelArtifactComponent;
        }(),
        cancel: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.cancelArtifactComponent();
                                if (!(this.entityEdit && this.entityEdit.id)) {
                                    this.$emit('modal-action', {
                                        row_number_selected: this.rowNumberSelected,
                                        action: 'cancel'
                                    });
                                }

                                this.close();

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function cancel() {
                return _ref3.apply(this, arguments);
            }

            return cancel;
        }(),
        emitModalAction: function emitModalAction() {
            var _this = this;

            console.log(this.entity);
            this.$nextTick(function () {
                if ((_this.entity.id || _this.urlTabSelected && _this.urlText) && !(_this.entityEdit && _this.entityEdit.id)) {
                    _this.$emit('modal-action', {
                        entity: _this.entity,
                        row_number_selected: _this.rowNumberSelected,
                        action: 'ok'
                    });
                } else {
                    _this.cancel();
                }

                _this.close();
            });
        },
        setDocumentArtifactErrorMessage: function setDocumentArtifactErrorMessage(errorMessage) {
            console.log(errorMessage);
            this.documentArtifactErrorMessage = errorMessage.error_message;
        },
        ok: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.documentArtifactErrorMessage = '';

                                if (!this.artifactTabSelected) {
                                    _context4.next = 10;
                                    break;
                                }

                                if (!this.showDocumentArtifactComponent) {
                                    _context4.next = 7;
                                    break;
                                }

                                _context4.next = 5;
                                return this.$refs.document_artifact.save();

                            case 5:
                                _context4.next = 10;
                                break;

                            case 7:
                                if (!this.showPhysicalArtifactComponent) {
                                    _context4.next = 10;
                                    break;
                                }

                                _context4.next = 10;
                                return this.$refs.physical_artifact.save();

                            case 10:
                                if (this.urlTabSelected && this.urlText) {
                                    this.submitUrl();
                                }
                                if (!this.documentArtifactErrorMessage) {
                                    this.emitModalAction();
                                }

                                if (this.$parent.$refs.artifact_table) {
                                    this.$parent.$refs.artifact_table.vmDataTable.ajax.reload();
                                }

                            case 13:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function ok() {
                return _ref4.apply(this, arguments);
            }

            return ok;
        }(),
        close: function close() {
            this.isModalOpen = false;
        },
        entitySelected: function entitySelected(entity) {
            console.log(entity);
            (0, _assign2.default)(this.entity, entity);
        },
        existingEntitySelected: function existingEntitySelected(entity) {
            console.log(entity);
            (0, _assign2.default)(this.entity, entity);
            this.emitModalAction();
        },
        submitUrl: function submitUrl() {
            console.log(this.urlText);
            var urlEntity = {
                data_type: 'url',
                url: this.urlText,
                urlProtocol: this.urlProtocol
            };
            (0, _assign2.default)(this.entity, urlEntity);
        }
    },

    created: function () {
        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            console.log(this.entityEdit);

                            if (this.entityEdit && this.entityEdit.data_type) {
                                if (this.entityEdit.data_type === 'physical_artifact') {
                                    this.componentType = 'physical';
                                } else if (this.entityEdit.data_type === 'document_artifact') {
                                    this.componentType = 'document';
                                }
                            }

                            if (this.initialTabSelected === 'person') {
                                this.tabSelected = 'pTab';
                            } else if (this.initialTabSelected === 'artifact') {
                                this.tabSelected = 'aTab';
                            } else if (this.initialTabSelected === 'url') {
                                this.tabSelected = 'uTab';
                            }

                        case 3:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function created() {
            return _ref5.apply(this, arguments);
        }

        return created;
    }()
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

__webpack_require__(15);

__webpack_require__(37);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _search_person_or_organisation = __webpack_require__(49);

var _search_person_or_organisation2 = _interopRequireDefault(_search_person_or_organisation);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _related_items = __webpack_require__(58);

var _related_items2 = _interopRequireDefault(_related_items);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "PhysicalArtifactComponent",
    data: function data() {
        return {
            uuid: 0,
            relatedItemsTab: 'relatedItemsTab' + this._uid,
            newTab: 'newTab' + this._uid,
            existingTab: 'existingTab' + this._uid,
            objectTab: 'objectTab' + this._uid,
            detailsTab: 'detailsTab' + this._uid,
            storageTab: 'storageTab' + this._uid,
            disposalTab: 'disposalTab' + this._uid,
            tabSelected: 'objectTab',
            isModalOpen: false,
            processingDetails: false,
            documentActionUrl: '',

            physicalArtifactTypes: [],
            departmentStaffList: [],
            selectedCustodian: {},
            disposalMethods: [],
            detailsSchema: [],
            storageSchema: [],
            entity: {
                id: null
            },
            statementArtifactTypes: ['record_of_interview', 'witness_statement', 'expert_statement', 'officer_statement'],
            statementVisibility: false,
            dtOptions: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                processing: true,
                ajax: {
                    url: '/api/artifact_paginated/get_paginated_datatable/?format=datatables',
                    dataSrc: 'data',
                    data: function data(d) {
                        d.object_type = 'physical_artifact';
                    }
                },
                columns: [{
                    data: 'number',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'artifact_type',
                    searchable: true,
                    orderable: false
                }, {
                    data: 'identifier',
                    searchable: true,
                    orderable: true
                }, {
                    searchable: false,
                    orderable: false,
                    data: 'digital_documents'
                }, {
                    searchable: false,
                    orderable: false,
                    data: 'entity',
                    mRender: function mRender(data, type, full) {
                        var documentArtifactId = data.id;
                        var documentArtifactType = data.artifact_type ? data.artifact_type.replace(/\s/g, '~') : null;
                        var documentArtifactIdentifier = data.identifier ? data.identifier.replace(/\s/g, '~') : null;
                        return "<a data-id=" + documentArtifactId + " data-artifact-type=" + documentArtifactType + " data-data-type=\"document_artifact\" data-identifier=" + documentArtifactIdentifier + " class=\"row_insert\" href=\"#\">Insert</a><br/>";
                    }
                }]
            },
            dtHeaders: ['Number', 'Document Type', 'Identifier', 'Documents', 'Action']

        };
    },
    components: {
        filefield: _compliance_file2.default,
        SearchPersonOrganisation: _search_person_or_organisation2.default,
        FormSection: _section_toggle2.default,
        RelatedItems: _related_items2.default,
        datatable: _datatable2.default
    },
    props: {
        parentModal: {
            type: Boolean,
            required: false,
            default: false
        },
        entityEdit: {
            type: Object,
            required: false
        },
        readonlyForm: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch: {
        artifactType: {
            handler: function handler(newVal, oldVal) {
                if (this.artifactType === 'found_object') {
                    this.setStatementId(null);
                }
                this.setStatementVisibility();
            }
        },
        selectedStatementArtifact: {
            handler: function handler() {},
            deep: true
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('physicalArtifactStore', {
        physical_artifact: "physical_artifact"
    }), (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), (0, _vuex.mapGetters)({
        renderer_form_data: 'renderer_form_data'
    }), {
        siezureNoticeVisibility: function siezureNoticeVisibility() {
            var visibility = false;

            if (this.artifactType === 'seized_object') {
                visibility = true;
            }
            return visibility;
        },
        legalCaseExists: function legalCaseExists() {
            var exists = false;
            if (this.legal_case && this.legal_case.id) {
                exists = true;
            }
            return exists;
        },
        componentClass: function componentClass() {
            var componentClass = '';
            if (this.parentModal) {
                componentClass = 'col-sm-11 child-artifact-component';
            }
            return componentClass;
        },
        selectedStatementArtifact: function selectedStatementArtifact() {
            var statementArtifact = {};
            if (this.physical_artifact && this.physical_artifact.statement_id) {
                if (this.parentModal && this.legal_case && this.legal_case.statement_artifacts) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = (0, _getIterator3.default)(this.legal_case.statement_artifacts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var artifact = _step.value;

                            if (this.physical_artifact.statement_id === artifact.id) {
                                (0, _assign2.default)(statementArtifact, artifact);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else if (!this.parentModal && this.physical_artifact.available_statement_artifacts) {
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = (0, _getIterator3.default)(this.physical_artifact.available_statement_artifacts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var _artifact = _step2.value;

                            if (this.physical_artifact.statement_id === _artifact.id) {
                                (0, _assign2.default)(statementArtifact, _artifact);
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            }
            return statementArtifact;
        },
        custodianVisibility: function custodianVisibility() {
            var show = false;
            if (this.selectedStatementArtifact && this.selectedStatementArtifact.custodian) {
                show = true;
            }
            return show;
        },
        detailsSchemaVisibility: function detailsSchemaVisibility() {
            console.log("detailsSchemaVisibility");
            if (this.artifactType && this.detailsSchema && this.detailsSchema.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        storageSchemaVisibility: function storageSchemaVisibility() {
            console.log("storageSchemaVisibility");
            if (this.artifactType && this.storageSchema && this.storageSchema.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        legalCaseId: function legalCaseId() {
            var ret_val = null;
            if (this.legal_case && this.legal_case.id) {
                ret_val = this.legal_case.id;
            }
            return ret_val;
        },

        linkedLegalCase: function linkedLegalCase() {
            var caseExists = false;
            if (this.physical_artifact && this.physical_artifact.legal_case_id_list && this.physical_artifact.legal_case_id_list.length > 0) {
                caseExists = true;
            }
            return caseExists;
        },
        canUserAction: function canUserAction() {
            return true;
        },
        officerVisibility: function officerVisibility() {
            var visibility = true;

            return visibility;
        },
        physicalArtifactId: function physicalArtifactId() {
            var id = null;
            if (this.physical_artifact && this.physical_artifact.id) {
                id = this.physical_artifact.id;
            }
            return id;
        },
        physicalArtifactIdExists: function physicalArtifactIdExists() {
            var recordExists = false;
            if (this.physical_artifact && this.physical_artifact.id) {
                recordExists = true;
            }
            return recordExists;
        },
        artifactType: function artifactType() {
            var typeCode = '';
            if (this.artifactTypeId && this.physicalArtifactTypes && this.physicalArtifactTypes.length > 0) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(this.physicalArtifactTypes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var aType = _step3.value;

                        if (aType.id === this.artifactTypeId) {
                            typeCode = aType.artifact_type;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            return typeCode;
        },
        artifactTypeId: function artifactTypeId() {
            var typeId = null;
            if (this.physical_artifact) {
                typeId = this.physical_artifact.physical_artifact_type_id;
            }
            return typeId;
        },
        artifactTypeDisplay: function artifactTypeDisplay() {
            var display = '';
            if (this.artifactType) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = (0, _getIterator3.default)(this.physicalArtifactTypes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var physicalArtifactType = _step4.value;

                        if (physicalArtifactType.artifact_type === this.artifactType) {
                            display = physicalArtifactType.artifact_type_display;
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            return display;
        },

        updateSearchPersonOrganisationBindId: function updateSearchPersonOrganisationBindId() {
            this.uuid += 1;
            return "PhysicalArtifact_SearchPerson_" + this.uuid.toString();
        },
        objectTabSelected: function objectTabSelected() {
            var isTab = false;
            if (this.tabSelected === 'objectTab') {
                isTab = true;
            }
            return isTab;
        },
        detailsTabSelected: function detailsTabSelected() {
            var isTab = false;
            if (this.tabSelected === 'detailsTab') {
                isTab = true;
            }
            return isTab;
        },
        storageTabSelected: function storageTabSelected() {
            var isTab = false;
            if (this.tabSelected === 'storageTab') {
                isTab = true;
            }
            return isTab;
        },
        disposalTabSelected: function disposalTabSelected() {
            var isTab = false;
            if (this.tabSelected === 'disposalTab') {
                isTab = true;
            }
            return isTab;
        },
        relatedItemsTabSelected: function relatedItemsTabSelected() {
            var isTab = false;
            if (this.tabSelected === 'relatedItemsTab') {
                isTab = true;
            }
            return isTab;
        },
        objectTabListClass: function objectTabListClass() {
            var tabClass = 'nav-item';
            if (this.objectTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        objectTabClass: function objectTabClass() {
            var tabClass = 'li-top-buffer tab-pane fade in';
            if (this.objectTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        detailsTabListClass: function detailsTabListClass() {
            var tabClass = 'nav-item';
            if (this.detailsTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        detailsTabClass: function detailsTabClass() {
            var tabClass = 'li-top-buffer tab-pane fade in';
            if (this.detailsTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        storageTabListClass: function storageTabListClass() {
            var tabClass = 'nav-item';
            if (this.storageTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        storageTabClass: function storageTabClass() {
            var tabClass = 'li-top-buffer tab-pane fade in';
            if (this.storageTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        disposalTabListClass: function disposalTabListClass() {
            var tabClass = 'nav-item';
            if (this.disposalTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        disposalTabClass: function disposalTabClass() {
            var tabClass = 'li-top-buffer tab-pane fade in';
            if (this.disposalTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        relatedItemsTabListClass: function relatedItemsTabListClass() {
            var tabClass = 'nav-item';
            if (this.relatedItemsTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        relatedItemsTabClass: function relatedItemsTabClass() {
            var tabClass = 'li-top-buffer tab-pane fade in';
            if (this.relatedItemsTabSelected) {
                tabClass += ' active';
            }
            return tabClass;
        },
        relatedItemsBindId: function relatedItemsBindId() {
            var timeNow = Date.now();
            var bindId = null;
            if (this.physical_artifact && this.physical_artifact.id) {
                bindId = 'physical_artifact_' + this.physical_artifact.id + '_' + timeNow.toString();
            } else {
                bindId = timeNow.toString();
            }
            return bindId;
        },
        relatedItemsVisibility: function relatedItemsVisibility() {
            var related_items_visibility = false;
            if (this.physical_artifact && this.physical_artifact.id) {
                related_items_visibility = true;
            }
            return related_items_visibility;
        },
        disposalTabVisibility: function disposalTabVisibility() {
            var visibility = false;
            if (this.physical_artifact && this.physical_artifact.status === 'waiting_for_disposal') {
                visibility = true;
            }
            return visibility;
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? (0, _moment2.default)(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('physicalArtifactStore', {
        savePhysicalArtifact: 'savePhysicalArtifact',
        loadPhysicalArtifact: 'loadPhysicalArtifact',
        setPhysicalArtifact: 'setPhysicalArtifact',
        setRelatedItems: 'setRelatedItems',
        setOfficerId: 'setOfficerId',
        setCustodianId: 'setCustodianId',

        addToTemporaryDocumentCollectionList: 'addToTemporaryDocumentCollectionList',
        setStatementId: 'setStatementId',
        setUsedWithinCase: 'setUsedWithinCase',
        setSensitiveNonDisclosable: 'setSensitiveNonDisclosable'
    }), {
        setStatementVisibility: function setStatementVisibility() {
            if ((this.linkedLegalCase || this.legalCaseExists) && this.artifactType && ['seized_object', 'surrendered_ object'].includes(this.artifactType) || this.physical_artifact && this.physical_artifact.statement) {
                this.statementVisibility = true;
            } else {
                this.statementVisibility = false;
            }
        },
        updateTabSelected: function updateTabSelected(tabValue) {
            this.tabSelected = tabValue;
        },
        entitySelected: function entitySelected(entity) {
            (0, _assign2.default)(this.entity, entity);
        },
        save: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var _this = this;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!this.physical_artifact.id) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return this.savePhysicalArtifact({ create: false, internal: false, legal_case_id: this.legalCaseId });

                            case 3:
                                _context.next = 8;
                                break;

                            case 5:
                                _context.next = 7;
                                return this.savePhysicalArtifact({ create: true, internal: false, legal_case_id: this.legalCaseId });

                            case 7:
                                this.$nextTick(function () {
                                    _this.$emit('entity-selected', {
                                        id: _this.physical_artifact.id,
                                        data_type: 'physical_artifact',
                                        identifier: _this.physical_artifact.identifier,
                                        artifact_type: _this.artifactType,
                                        display: _this.artifactType
                                    });
                                });

                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function save() {
                return _ref.apply(this, arguments);
            }

            return save;
        }(),
        cancel: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.$refs.default_document) {
                                    _context2.next = 3;
                                    break;
                                }

                                _context2.next = 3;
                                return this.$refs.default_document.cancel();

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function cancel() {
                return _ref2.apply(this, arguments);
            }

            return cancel;
        }(),
        emitPhysicalArtifact: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(e) {
                var _this2 = this;

                var physicalArtifactId, fetchUrl, payload, physicalArtifactType, physicalArtifactIdentifier;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                physicalArtifactId = e.target.dataset.id;
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.physical_artifact, physicalArtifactId + '/');
                                payload = {
                                    "legal_case_id": this.legalCaseId
                                };
                                _context3.next = 5;
                                return _vue2.default.http.put(fetchUrl, payload);

                            case 5:
                                physicalArtifactType = e.target.dataset.artifactType.replace(/~/g, ' ');
                                physicalArtifactIdentifier = e.target.dataset.identifier.replace(/~/g, ' ').replace('null', '');

                                this.$nextTick(function () {
                                    _this2.$emit('existing-entity-selected', {
                                        id: physicalArtifactId,
                                        data_type: 'physical_artifact',
                                        identifier: physicalArtifactIdentifier,
                                        artifact_type: physicalArtifactType,
                                        display: physicalArtifactType
                                    });
                                });

                            case 8:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function emitPhysicalArtifact(_x) {
                return _ref3.apply(this, arguments);
            }

            return emitPhysicalArtifact;
        }(),
        addEventListeners: function addEventListeners() {
            var _this3 = this;

            var vm = this;
            var el_fr_date = $(vm.$refs.artifactDatePicker);
            var el_fr_time = $(vm.$refs.artifactTimePicker);

            el_fr_date.datetimepicker({
                format: "DD/MM/YYYY",
                maxDate: "now",
                showClear: true
            });
            el_fr_date.on("dp.change", function (e) {
                if (el_fr_date.data("DateTimePicker").date()) {
                    vm.physical_artifact.artifact_date = e.date.format("DD/MM/YYYY");
                } else if (el_fr_date.data("date") === "") {
                    vm.physical_artifact.artifact_date = "";
                }
            });
            el_fr_time.datetimepicker({ format: "LT", showClear: true });
            el_fr_time.on("dp.change", function (e) {
                if (el_fr_time.data("DateTimePicker").date()) {
                    vm.physical_artifact.artifact_time = e.date.format("LT");
                } else if (el_fr_time.data("date") === "") {
                    vm.physical_artifact.artifact_time = "";
                }
            });

            $(vm.$refs.physical_artifact_officers).select2({
                minimumInputLength: 2,
                "theme": "bootstrap",
                allowClear: true,
                placeholder: "",
                ajax: {
                    url: _hooks.api_endpoints.staff_member_lookup,

                    dataType: 'json',
                    data: function data(params) {
                        console.log(params);
                        var query = {
                            term: params.term,
                            type: 'public'
                        };
                        return query;
                    }
                }
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                var selectedData = selected.val();
                console.log(selectedData);
                vm.setOfficerId(selectedData);
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                vm.setOfficerId(null);
            });

            $(vm.$refs.physical_artifact_custodians).select2({
                "theme": "bootstrap",
                allowClear: true,
                placeholder: "",
                minimumInputLength: 2,
                ajax: {
                    url: _hooks.api_endpoints.staff_member_lookup,

                    dataType: 'json',
                    data: function data(params) {
                        console.log(params);
                        var query = {
                            term: params.term,
                            type: 'public'
                        };
                        return query;
                    }
                }
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                var selectedData = selected.val();
                vm.setCustodianId(selectedData);
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                vm.setCustodianId(null);
            });

            var existingArtifactTable = $('#existing-artifact-table');
            existingArtifactTable.on('click', '.row_insert', function (e) {
                _this3.emitPhysicalArtifact(e);
            });

            var disposal_date_control = $(vm.$refs.disposalDatePicker);

            disposal_date_control.datetimepicker({
                format: "DD/MM/YYYY",
                maxDate: "now",
                showClear: true
            });
            disposal_date_control.on("dp.change", function (e) {
                if (disposal_date_control.data("DateTimePicker").date()) {
                    vm.physical_artifact.disposal_date = e.date.format("DD/MM/YYYY");
                } else if (disposal_date_control.data("date") === "") {
                    vm.physical_artifact.disposal_date = "";
                }
            });
        },
        compare: function compare(a, b) {
            var nameA = a.name.toLowerCase();
            var nameB = b.name.toLowerCase();

            var comparison = 0;
            if (this.bandA > this.bandB) {
                comparison = 1;
            } else if (this.bandA < this.bandB) {
                comparison = -1;
            }
            return comparison;
        },
        loadSchema: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                var _this4 = this;

                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                                    var url, returnedSchema;
                                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                                        while (1) {
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    if (!_this4.artifactTypeId) {
                                                        _context4.next = 9;
                                                        break;
                                                    }

                                                    console.log("really load schema");
                                                    url = _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.physical_artifact_types, _this4.artifactTypeId + '/get_schema');
                                                    _context4.next = 5;
                                                    return _hooks.cache_helper.getSetCache('PhysicalArtifactTypeSchema', _this4.artifactTypeId.toString(), url);

                                                case 5:
                                                    returnedSchema = _context4.sent;

                                                    if (returnedSchema) {
                                                        (0, _assign2.default)(_this4.detailsSchema, returnedSchema.details_schema);
                                                        (0, _assign2.default)(_this4.storageSchema, returnedSchema.storage_schema);
                                                    }
                                                    _context4.next = 10;
                                                    break;

                                                case 9:
                                                    console.log(" no artifactTypeId");

                                                case 10:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }
                                    }, _callee4, _this4);
                                })));

                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function loadSchema() {
                return _ref4.apply(this, arguments);
            }

            return loadSchema;
        }()

    }),
    mounted: function mounted() {
        var _this5 = this;

        this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _this5.addEventListeners();

                        case 1:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, _this5);
        })));
    },
    beforeDestroy: function () {
        var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.next = 2;
                            return this.setPhysicalArtifact({});

                        case 2:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function beforeDestroy() {
            return _ref7.apply(this, arguments);
        }

        return beforeDestroy;
    }(),

    created: function () {
        var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
            var _this6 = this;

            var returned_physical_artifact_types, returned_disposal_methods, vm, option;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            console.log("created");

                            if (!this.$route.params.physical_artifact_id) {
                                _context9.next = 6;
                                break;
                            }

                            _context9.next = 4;
                            return this.loadPhysicalArtifact({ physical_artifact_id: this.$route.params.physical_artifact_id });

                        case 4:
                            _context9.next = 10;
                            break;

                        case 6:
                            if (!(this.entityEdit && this.entityEdit.id && this.entityEdit.data_type === 'physical_artifact')) {
                                _context9.next = 10;
                                break;
                            }

                            _context9.next = 9;
                            return this.loadPhysicalArtifact({ physical_artifact_id: this.entityEdit.id });

                        case 9:
                            console.log("artifact loaded");

                        case 10:
                            _context9.next = 12;
                            return this.loadSchema();

                        case 12:
                            this.setStatementVisibility();
                            _context9.next = 15;
                            return _hooks.cache_helper.getSetCacheList('PhysicalArtifactTypes', _hooks.api_endpoints.physical_artifact_types);

                        case 15:
                            returned_physical_artifact_types = _context9.sent;

                            (0, _assign2.default)(this.physicalArtifactTypes, returned_physical_artifact_types);

                            this.physicalArtifactTypes.splice(0, 0, {
                                id: "",
                                artifact_type: "",
                                description: ""
                            });
                            _context9.next = 20;
                            return _hooks.cache_helper.getSetCacheList('DisposalMethods', _hooks.api_endpoints.disposal_methods);

                        case 20:
                            returned_disposal_methods = _context9.sent;

                            (0, _assign2.default)(this.disposalMethods, returned_disposal_methods);

                            this.disposalMethods.splice(0, 0, {
                                id: "",
                                disposal_method: "",
                                description: ""
                            });
                            vm = this;

                            if (this.physical_artifact.officer && this.physical_artifact.officer.id) {
                                console.log(this.physical_artifact.officer.id);
                                option = new Option(this.physical_artifact.officer.full_name, this.physical_artifact.officer.full_name, true, true);

                                $(vm.$refs.physical_artifact_officers).append(option).trigger('change');
                            }
                            if (this.physical_artifact.custodian && this.physical_artifact.custodian.id) {
                                option = new Option(this.physical_artifact.custodian.full_name, this.physical_artifact.custodian.full_name, true, true);

                                $(vm.$refs.physical_artifact_custodians).append(option).trigger('change');
                            }

                            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
                                var _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, link;

                                return _regenerator2.default.wrap(function _callee8$(_context8) {
                                    while (1) {
                                        switch (_context8.prev = _context8.next) {
                                            case 0:
                                                if (!(_this6.legalCaseId && _this6.physical_artifact.legal_case_links && _this6.physical_artifact.legal_case_links.length > 0)) {
                                                    _context8.next = 21;
                                                    break;
                                                }

                                                console.log("created links");
                                                _iteratorNormalCompletion5 = true;
                                                _didIteratorError5 = false;
                                                _iteratorError5 = undefined;
                                                _context8.prev = 5;
                                                for (_iterator5 = (0, _getIterator3.default)(_this6.physical_artifact.legal_case_links); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                                    link = _step5.value;

                                                    if (link.legal_case_id === _this6.legalCaseId) {
                                                        _this6.setUsedWithinCase(link.used_within_case);
                                                        _this6.setSensitiveNonDisclosable(link.sensitive_non_disclosable);
                                                    }
                                                }
                                                _context8.next = 13;
                                                break;

                                            case 9:
                                                _context8.prev = 9;
                                                _context8.t0 = _context8["catch"](5);
                                                _didIteratorError5 = true;
                                                _iteratorError5 = _context8.t0;

                                            case 13:
                                                _context8.prev = 13;
                                                _context8.prev = 14;

                                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                    _iterator5.return();
                                                }

                                            case 16:
                                                _context8.prev = 16;

                                                if (!_didIteratorError5) {
                                                    _context8.next = 19;
                                                    break;
                                                }

                                                throw _iteratorError5;

                                            case 19:
                                                return _context8.finish(16);

                                            case 20:
                                                return _context8.finish(13);

                                            case 21:
                                            case "end":
                                                return _context8.stop();
                                        }
                                    }
                                }, _callee8, _this6, [[5, 9, 13, 21], [14,, 16, 20]]);
                            })));

                        case 27:
                        case "end":
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        function created() {
            return _ref8.apply(this, arguments);
        }

        return created;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _vuex = __webpack_require__(6);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(15);

__webpack_require__(37);

var _weak_links = __webpack_require__(813);

var _weak_links2 = _interopRequireDefault(_weak_links);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    name: "RelatedItems",
    props: {
        parent_update_related_items: {
            type: Function
        },
        readonlyForm: {
            type: Boolean,
            default: false
        },
        parentComponentName: {
            type: String
        }
    },

    data: function data() {
        return {
            displayedEntityType: null,
            dtHeadersRelatedItems: ['Number', 'Type', 'Description', 'Comment', 'Action'],
            dtOptionsRelatedItems: {
                columns: [{
                    data: 'identifier'
                }, {
                    data: 'model_name'
                }, {
                    data: 'descriptor'
                }, {
                    data: 'AllFields',
                    mRender: function mRender(data, type, row) {
                        var comment = '';
                        if (row.AllFields.weak_link) {
                            comment = row.AllFields.comment;
                        }
                        return comment;
                    }
                }, {
                    data: 'AllFields',
                    mRender: function mRender(data, type, row) {
                        var links = '';
                        if (row.AllFields.weak_link && row.AllFields.can_user_action) {
                            links += '<a href="#" class="remove_button" second-content-type="' + row.AllFields.second_content_type + '" second-object-id="' + row.AllFields.second_object_id + '">Remove</a><br>';
                        }
                        links += row.AllFields.action_url;
                        return links;
                    }
                }]
            }
        };
    },
    components: {
        datatable: _datatable2.default,
        WeakLinks: _weak_links2.default
    },
    watch: {
        displayedEntityRelatedItems: {
            handler: function handler() {
                var _this = this;

                this.$nextTick(function () {
                    _this.constructRelatedItemsTable();
                });
            },
            deep: true
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('documentArtifactStore', {
        document_artifact: "document_artifact"
    }), (0, _vuex.mapGetters)('physicalArtifactStore', {
        physical_artifact: "physical_artifact"
    }), (0, _vuex.mapGetters)('callemailStore', {
        call_email: "call_email"
    }), (0, _vuex.mapGetters)('inspectionStore', {
        inspection: "inspection"
    }), (0, _vuex.mapGetters)('offenceStore', {
        offence: "offence"
    }), (0, _vuex.mapGetters)('sanctionOutcomeStore', {
        sanction_outcome: "sanction_outcome"
    }), (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        },
        displayedEntity: function displayedEntity() {
            var displayed_entity = null;
            if (this.call_email && this.call_email.id) {
                this.displayedEntityType = 'callemail';
                displayed_entity = this.call_email;
            } else if (this.inspection && this.inspection.id) {
                this.displayedEntityType = 'inspection';
                displayed_entity = this.inspection;
            } else if (this.offence && this.offence.id) {
                this.displayedEntityType = 'offence';
                displayed_entity = this.offence;
            } else if (this.sanction_outcome && this.sanction_outcome.id) {
                this.displayedEntityType = 'sanctionoutcome';
                displayed_entity = this.sanction_outcome;
            } else if (this.legal_case && this.legal_case.id && this.parentComponentName === 'legal_case') {
                this.displayedEntityType = 'legalcase';
                displayed_entity = this.legal_case;
            } else if (this.physical_artifact && this.physical_artifact.id && this.parentComponentName === 'physical_artifact') {
                this.displayedEntityType = 'physicalartifact';
                displayed_entity = this.physical_artifact;
            } else if (this.document_artifact && this.document_artifact.id && this.parentComponentName === 'document_artifact') {
                this.displayedEntityType = 'documentartifact';
                displayed_entity = this.document_artifact;
            }
            return displayed_entity;
        },
        displayedEntityId: function displayedEntityId() {
            var retVal = null;
            if (this.displayedEntity) {
                retVal = this.displayedEntity.id;
            }
            return retVal;
        },
        displayedEntityRelatedItems: function displayedEntityRelatedItems() {
            var retVal = null;
            if (this.displayedEntity && this.displayedEntity.related_items) {
                retVal = this.displayedEntity.related_items;
            }
            return retVal;
        }

    }),
    methods: {
        createWeakLink: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var url, payload, relatedItems;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                url = '/api/create_weak_link/';
                                payload = {
                                    'can_user_action': this.displayedEntity.can_user_action,
                                    'first_content_type': this.displayedEntityType,
                                    'first_object_id': this.displayedEntity.id,
                                    'second_content_type': this.$refs.weak_links_lookup.second_content_type,
                                    'second_object_id': this.$refs.weak_links_lookup.second_object_id,
                                    'comment': this.$refs.weak_links_lookup.comment
                                };
                                _context.next = 4;
                                return _vue2.default.http.post(url, payload);

                            case 4:
                                relatedItems = _context.sent;

                                if (!relatedItems.ok) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 8;
                                return this.parent_update_related_items(relatedItems.body);

                            case 8:
                                return _context.abrupt("return", relatedItems);

                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function createWeakLink() {
                return _ref.apply(this, arguments);
            }

            return createWeakLink;
        }(),
        removeWeakLink: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(e) {
                var secondContentType, secondObjectId, url, payload, relatedItems;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                secondContentType = e.target.getAttribute("second-content-type");
                                secondObjectId = e.target.getAttribute("second-object-id");
                                url = '/api/remove_weak_link/';
                                payload = {
                                    'can_user_action': this.displayedEntity.can_user_action,
                                    'first_content_type': this.displayedEntityType,
                                    'first_object_id': this.displayedEntity.id,
                                    'second_content_type': secondContentType,
                                    'second_object_id': secondObjectId
                                };
                                _context2.next = 6;
                                return _vue2.default.http.post(url, payload);

                            case 6:
                                relatedItems = _context2.sent;

                                if (!relatedItems.ok) {
                                    _context2.next = 10;
                                    break;
                                }

                                _context2.next = 10;
                                return this.parent_update_related_items(relatedItems.body);

                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function removeWeakLink(_x) {
                return _ref2.apply(this, arguments);
            }

            return removeWeakLink;
        }(),

        constructRelatedItemsTable: function constructRelatedItemsTable() {
            this.$refs.related_items_table.vmDataTable.clear().draw();

            if (this.displayedEntity && this.displayedEntity.related_items) {
                for (var i = 0; i < this.displayedEntity.related_items.length; i++) {

                    var allfieldsColumn = new Object();
                    (0, _assign2.default)(allfieldsColumn, this.displayedEntity.related_items[i]);
                    allfieldsColumn.can_user_action = this.displayedEntity.can_user_action;

                    this.$refs.related_items_table.vmDataTable.row.add({
                        'identifier': this.displayedEntity.related_items[i].identifier,
                        'descriptor': this.displayedEntity.related_items[i].descriptor,
                        'model_name': this.displayedEntity.related_items[i].model_name,
                        'AllFields': allfieldsColumn
                    }).draw();
                }
            }
        },
        addEventListeners: function addEventListeners() {
            $('#related-items-table').on('click', '.remove_button', this.removeWeakLink);
        }
    },
    created: function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function created() {
            return _ref3.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            _this2.addEventListeners();
            _this2.constructRelatedItemsTable();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _amendment_request_details = __webpack_require__(131);

var _amendment_request_details2 = _interopRequireDefault(_amendment_request_details);

__webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'renderer-form',
    components: {
        AmendmentRequestDetails: _amendment_request_details2.default
    },
    data: function data() {
        return {
            section_tab_id: 0
        };
    },
    props: {
        withSectionsSelector: {
            type: Boolean,
            default: true
        },
        form_width: {
            type: String,
            default: 'col-md-9'
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application', 'selected_activity_tab_id', 'renderer_tabs', 'unfinishedActivities', 'allCurrentActivities', 'sectionsForTab', 'allCurrentActivitiesWithAssessor']), {
        listVisibleActivities: function listVisibleActivities() {
            if (this.$router.currentRoute.name == 'complete-assessment') {
                return this.allCurrentActivitiesWithAssessor ? this.allCurrentActivitiesWithAssessor : this.allCurrentActivities;
            }
            return this.application.can_user_edit ? this.unfinishedActivities : this.allCurrentActivities;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setRendererTabs', 'setRendererSections', 'setActivityTab']), {
        selectTab: function selectTab(component) {
            this.section_tab_id = component.id;
            this.setActivityTab({ id: component.id, name: component.label });
        },
        getSections: function getSections(tab_id) {
            return tab_id == this.section_tab_id ? this.sectionsForTab(tab_id) : [];
        },
        initRendererTabs: function initRendererTabs() {
            var tabs_list = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.listVisibleActivities.filter(function (activity) {
                    return activity.type == 'tab';
                })), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var component = _step.value;

                    if (!this.selected_activity_tab_id) {
                        this.selectTab(component);
                    }
                    tabs_list.push({ name: component.name,
                        label: component.label,
                        id: component.id
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.setRendererTabs(tabs_list);
        },
        initRendererSections: function initRendererSections() {
            var sections = {};
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.listVisibleActivities.filter(function (activity) {
                    return activity.type == 'tab' && activity.children;
                })), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var component = _step2.value;

                    sections[component.id] = [];
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = (0, _getIterator3.default)(component.children), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var section = _step3.value;

                            sections[component.id].push({
                                name: section.name,
                                label: section.label
                            });
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.setRendererSections(sections);
        },
        sectionClick: function sectionClick(component) {
            if (this.section_tab_id == component.id) {
                this.section_tab_id = 0;
            } else {
                this.section_tab_id = component.id;
            }
        }
    }),
    mounted: function mounted() {
        this.initRendererTabs();
        this.initRendererSections();
    }
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _helpers = __webpack_require__(42);

var _section = __webpack_require__(338);

var _section2 = _interopRequireDefault(_section);

var _group = __webpack_require__(334);

var _group2 = _interopRequireDefault(_group);

var _group3 = __webpack_require__(833);

var _group4 = _interopRequireDefault(_group3);

var _radio = __webpack_require__(336);

var _radio2 = _interopRequireDefault(_radio);

var _conditions = __webpack_require__(830);

var _conditions2 = _interopRequireDefault(_conditions);

var _checkbox = __webpack_require__(330);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _declarations = __webpack_require__(332);

var _declarations2 = _interopRequireDefault(_declarations);

var _file = __webpack_require__(832);

var _file2 = _interopRequireDefault(_file);

var _select = __webpack_require__(339);

var _select2 = _interopRequireDefault(_select);

var _dateField = __webpack_require__(331);

var _dateField2 = _interopRequireDefault(_dateField);

var _text = __webpack_require__(342);

var _text2 = _interopRequireDefault(_text);

var _richtext = __webpack_require__(836);

var _richtext2 = _interopRequireDefault(_richtext);

var _textArea = __webpack_require__(341);

var _textArea2 = _interopRequireDefault(_textArea);

var _label = __webpack_require__(335);

var _label2 = _interopRequireDefault(_label);

var _readonly_text = __webpack_require__(337);

var _readonly_text2 = _interopRequireDefault(_readonly_text);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _table = __webpack_require__(340);

var _table2 = _interopRequireDefault(_table);

var _expander_table = __webpack_require__(831);

var _expander_table2 = _interopRequireDefault(_expander_table);

var _grid = __webpack_require__(333);

var _grid2 = _interopRequireDefault(_grid);

var _select_species = __webpack_require__(838);

var _select_species2 = _interopRequireDefault(_select_species);

var _group_species = __webpack_require__(834);

var _group_species2 = _interopRequireDefault(_group_species);

var _select_filtered = __webpack_require__(837);

var _select_filtered2 = _interopRequireDefault(_select_filtered);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RendererBlock = {
    name: 'renderer-block',
    components: {
        FormSection: _section2.default,
        TextField: _text2.default,
        RichTextField: _richtext2.default,
        Group: _group2.default,
        Group2: _group4.default,
        SelectBlock: _select2.default,
        HelpText: _help_text2.default,
        HelpTextUrl: _help_text_url2.default,
        CommentBlock: _comment_block2.default,
        Radio: _radio2.default,
        Conditions: _conditions2.default,
        Checkbox: _checkbox2.default,
        File: _file2.default,
        DateField: _dateField2.default,
        TextAreaBlock: _textArea2.default,
        LabelBlock: _label2.default,
        TableBlock: _table2.default,
        ExpanderTable: _expander_table2.default,
        GridBlock: _grid2.default,
        Species: _select_species2.default,
        SpeciesGroup: _group_species2.default,
        SpeciesFiltered: _select_filtered2.default
    },
    data: function data() {
        return {};
    },
    props: {
        component: {
            type: Object,
            required: true
        },
        instance: {
            type: String,
            default: null
        },
        isTableField: {
            type: Boolean,
            required: false
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application', 'application_id', 'renderer_form_data', 'isComponentVisible', 'isComponentEditableForOfficer']), {
        can_view_richtext_src: function can_view_richtext_src() {
            return this.application.can_view_richtext_src ? this.application.can_view_richtext_src : false;
        },
        is_readonly: function is_readonly() {
            return this.component.readonly ? this.component.readonly : this.application.readonly ? !this.isComponentEditableForOfficer : this.application.readonly;
        },
        comment_data: function comment_data() {
            return this.application.comment_data;
        },
        documents_url: function documents_url() {
            return this.application.documents_url;
        },
        can_user_edit: function can_user_edit() {
            return this.application.can_user_edit;
        },
        site_url: function site_url() {
            return _hooks.api_endpoints.site_url.endsWith("/") ? _hooks.api_endpoints.site_url : _hooks.api_endpoints.site_url + "/";
        },
        component_name: function component_name() {
            return '' + this.component.name + (this.instance !== null ? '__instance-' + this.instance : '');
        },
        json_data: function json_data() {
            return this.renderer_form_data;
        },
        formDataRecord: function formDataRecord() {
            if (this.json_data[this.component_name] == null) {
                this.setFormValue({
                    key: this.component_name,
                    value: {
                        "value": '',
                        "officer_comment": '',
                        "assessor_comment": '',
                        "deficiency_value": '',
                        "licence_activity_id": this.component.licence_activity_id,
                        "licence_purpose_id": this.component.licence_purpose_id,
                        "schema_name": this.component.name,
                        "component_type": this.component.type,
                        "component_attribute": '',
                        "instance_name": this.instance !== null ? this.instance : ''
                    }
                });
            }
            return this.json_data[this.component_name];
        },
        value: {
            get: function get() {
                return this.formDataRecord;
            },
            set: function set(value) {
                this.setFormValue({
                    key: this.component_name,
                    value: { "value": value }
                });
            }
        },
        help_text: function help_text() {
            return this.replaceSitePlaceholders(this.component.help_text);
        },
        help_text_url: function help_text_url() {
            return this.replaceSitePlaceholders(this.component.help_text_url);
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['toggleVisibleComponent', 'setFormValue', 'refreshApplicationFees']), {
        strToBool: _helpers.strToBool,
        element_id: function element_id() {
            var depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            return 'id_' + this.component_name + (depth ? '_' + depth : '') + (this.instance !== null ? '__instance' + this.instance : '');
        },
        application_url: function application_url(component) {
            if (component.type === 'species-all') {
                return "/api/application/" + this.application_id + "/select_filtered_species/";
            }

            return '';
        },
        replaceSitePlaceholders: function replaceSitePlaceholders(text_string) {
            if (text_string && text_string.includes("site_url:/")) {
                text_string = text_string.replace('site_url:/', this.site_url);
                if (text_string.includes("anchor=")) {
                    text_string = text_string.replace('anchor=', "#");
                }
            }
            return text_string;
        },
        handleComponentChange: function handleComponentChange(component) {
            var _this = this;

            var assignEventValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            return function (e) {
                for (var condition in component.conditions) {
                    _this.toggleVisibleComponent({
                        'component_id': 'cons_' + _this.component_name + '_' + condition,
                        'visible': false
                    });
                }
                var value = e.value == null ? e.target.value : e.value;
                if (e.target) {
                    _this.toggleVisibleComponent({
                        'component_id': 'cons_' + e.target.name + '_' + e.target.value,
                        'visible': e.target.checked
                    });
                } else {
                    _this.toggleVisibleComponent({
                        'component_id': 'cons_' + _this.component_name + '_' + value,
                        'visible': true
                    });
                }

                if (value === 'on' && !e.target.checked) {
                    value = '';
                }
                if (assignEventValue && value !== null && value !== undefined) {
                    _this.value = value;
                }
                if (e.isTrusted) {
                    _this.refreshApplicationFees();
                }
            };
        }
    })
};
exports.default = RendererBlock;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ReturnTableDash',
    props: {
        level: {
            type: String,
            required: true,
            validator: function validator(val) {
                var options = ['internal', 'external'];
                return options.indexOf(val) != -1 ? true : false;
            }
        },
        url: {
            type: String,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        return {
            pBody: 'pBody' + vm._uid,
            datatable_id: 'return-datatable-' + vm._uid,
            filterReturnStatus: 'All',
            filterDueDateFrom: '',
            filterDueDateTo: '',
            dateFormat: 'DD/MM/YYYY',
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            return_statusTitles: [],
            table_headers: ["Number", "Due Date", "Status", "Licence", "Action"],
            table_options: {
                serverSide: true,
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: {
                    "url": vm.url,
                    "dataSrc": 'data',
                    "data": function data(d) {
                        d.status = vm.filterReturnStatus;
                        d.date_from = vm.filterDueDateFrom != '' && vm.filterDueDateFrom != null ? moment(vm.filterDueDateFrom, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                        d.date_to = vm.filterDueDateTo != '' && vm.filterDueDateTo != null ? moment(vm.filterDueDateTo, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                    }
                },
                columns: [{
                    data: "lodgement_number",
                    mRender: function mRender(data, type, full) {
                        return data;
                    }
                }, {
                    data: "due_date",
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format(vm.dateFormat) : '';
                    }
                }, {
                    data: "processing_status",
                    mRender: function mRender(data, type, full) {
                        return vm.is_external ? full.customer_status : full.processing_status;
                    }
                }, {
                    data: "licence",
                    mRender: function mRender(data, type, full) {
                        return full.licence;
                    },
                    searchable: false
                }, {
                    data: "can_be_processed",
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        if (!vm.is_external) {
                            links += full.can_be_processed && full.user_in_officers ? '<a href=\'/internal/return/' + full.id + '\'>Process</a><br/>' : '<a href=\'/internal/return/' + full.id + '\'>View</a><br/>';

                            if (['paid', 'partially_paid'].includes(full.payment_status)) {
                                links += '<a href=\'' + full.all_payments_url + '\' target=\'_blank\' >View Payment</a><br/>';
                            }
                        } else {
                            links += full.can_current_user_edit ? '<a href=\'/external/return/' + full.id + '\'>Continue</a><br/>' : '<a href=\'/external/return/' + full.id + '\'>View</a><br/>';
                        }
                        return links;
                    },
                    searchable: false
                }],
                processing: true,
                initComplete: function initComplete() {
                    var $searchInput = $('div.dataTables_filter input');
                    $searchInput.unbind('keyup search input');
                    $searchInput.bind('keypress', vm.delay(function (e) {
                        if (e.which == 13) {
                            vm.$refs.return_datatable.vmDataTable.search(this.value).draw();
                        }
                    }, 0));

                    var titleColumn = vm.$refs.return_datatable.vmDataTable.columns(2);
                    titleColumn.data().unique().sort().each(function (d, j) {
                        var statusTitles = [];
                        $.each(d, function (index, a) {
                            a != null && statusTitles.indexOf(a) < 0 ? statusTitles.push(a) : '';
                        });
                        vm.return_statusTitles = statusTitles;
                    });
                }
            }
        };
    },

    components: {
        datatable: _datatable2.default
    },
    watch: {
        filterReturnStatus: function filterReturnStatus(value) {
            var table = this.$refs.return_datatable.vmDataTable;
            value = value != 'All' ? value : '';
            table.column(2).search(value).draw();
        },
        filterDueDateFrom: function filterDueDateFrom(value) {
            this.visibleDatatable.vmDataTable.draw();
        },
        filterDueDateTo: function filterDueDateTo(value) {
            this.visibleDatatable.vmDataTable.draw();
        }
    },
    computed: {
        is_external: function is_external() {
            return this.level == 'external';
        },
        visibleDatatable: function visibleDatatable() {
            return this.$refs.return_datatable;
        }
    },
    methods: {
        addEventListeners: function addEventListeners() {
            var vm = this;

            $(vm.$refs.dueDateToPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.dueDateToPicker).on('dp.change', function (e) {
                if ($(vm.$refs.dueDateToPicker).data('DateTimePicker').date()) {
                    vm.filterDueDateTo = e.date.format('DD/MM/YYYY');
                } else if ($(vm.$refs.dueDateToPicker).data('date') === "") {
                    vm.filterDueDateTo = "";
                }
            });
            $(vm.$refs.dueDateFromPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.dueDateFromPicker).on('dp.change', function (e) {
                if ($(vm.$refs.dueDateFromPicker).data('DateTimePicker').date()) {
                    vm.filterDueDateFrom = e.date.format('DD/MM/YYYY');
                    $(vm.$refs.dueDateToPicker).data("DateTimePicker").minDate(e.date);
                } else if ($(vm.$refs.dueDateFromPicker).data('date') === "") {
                    vm.filterDueDateFrom = "";
                }
            });
        },
        delay: function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        },

        initialiseSearch: function initialiseSearch() {
            this.dateSearch();
        },
        dateSearch: function dateSearch() {
            var vm = this;
            vm.$refs.return_datatable.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var from = vm.filterDueDateFrom;
                var to = vm.filterDueDateTo;
                var val = original.due_date;

                if (from == '' && to == '') {
                    return true;
                } else if (from != '' && to != '') {
                    return val != null && val != '' ? moment().range(moment(from, vm.dateFormat), moment(to, vm.dateFormat)).contains(moment(val)) : false;
                } else if (from == '' && to != '') {
                    if (val != null && val != '') {
                        return moment(to, vm.dateFormat).diff(moment(val)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (to == '' && from != '') {
                    if (val != null && val != '') {
                        return moment(val).diff(moment(from, vm.dateFormat)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            });
        }
    },
    mounted: function mounted() {
        var vm = this;
        this.$nextTick(function () {
            vm.addEventListeners();
            vm.initialiseSearch();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _name$props$component;

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _access = __webpack_require__(888);

var _access2 = _interopRequireDefault(_access);

var _vuex = __webpack_require__(6);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

__webpack_require__(67);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_name$props$component = {
  name: 'returns-renderer-form',
  props: {
    level: {
      type: String,
      required: true,
      validator: function validator(val) {
        var options = ['internal', 'external'];
        return options.indexOf(val) != -1 ? true : false;
      }
    }
  },
  components: {
    CommsLogs: _comms_logs2.default,
    MenuAccess: _access2.default
  },
  filters: {
    formatDate: function formatDate(data) {
      return data ? moment(data).format('DD/MM/YYYY HH:mm:ss') : '';
    }
  },
  data: function data() {
    return {
      tabs: {
        0: 'Return',
        1: 'Confirmation'
      },
      returns_tab_id: 0,

      assignTo: false,
      loading: [],
      isLoading: false,

      logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.$route.params.return_id + '/action_log'),
      comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.$route.params.return_id + '/comms_log'),
      comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.$route.params.return_id + '/add_comms_log')
    };
  }
}, (0, _defineProperty3.default)(_name$props$component, 'props', {
  form_width: {
    type: String,
    default: 'col-md-9'
  }
}), (0, _defineProperty3.default)(_name$props$component, 'computed', (0, _extends3.default)({}, (0, _vuex.mapGetters)(['returns', 'returns_tabs', 'selected_returns_tab_id', 'species_list', 'is_external', 'current_user']), {
  is_submitted: function is_submitted() {
    return this.returns.lodgement_date != null ? true : false;
  },
  displayable_number: function displayable_number() {
    return 'Return: ' + this.returns.lodgement_number;
  },
  displayable_tabs: function displayable_tabs() {
    return true;
    if (this.is_external && this.returns.lodgement_date != null) {
      return false;
    }
    return true;
  }
})), (0, _defineProperty3.default)(_name$props$component, 'methods', (0, _extends3.default)({}, (0, _vuex.mapActions)(['setReturnsTabId', 'setReturnsSpecies', 'setReturnsExternal', 'setReturns', 'loadCurrentUser']), {
  selectReturnsTab: function selectReturnsTab(id) {
    this.returns_tab_id = id;
    this.setReturnsTabId({ tab_id: id });
  },
  canAssignToOfficer: function canAssignToOfficer() {
    if (!this.userHasRole('licensing_officer')) {
      return false;
    }
    return this.returns && this.returns.processing_status.id == 'with_curator';
  },
  userIsAssignedOfficer: function userIsAssignedOfficer() {
    return this.current_user.id == this.returns.assigned_to;
  }
})), (0, _defineProperty3.default)(_name$props$component, 'created', function created() {
  this.loadCurrentUser({ url: '/api/my_user_details' });
  if (this.returns.format != 'sheet') {
    var headers = this.returns.table[0]['headers'];
    for (var i = 0; i < headers.length; i++) {
      if (this.is_external) {

        headers[i]['readonly'] = !['Draft', 'Due', 'Overdue'].includes(this.returns.processing_status);
      } else {

        headers[i]['readonly'] = !['With Curator'].includes(this.returns.processing_status);
      }
    }
    this.setReturns(this.returns);
  }
  this.setReturnsSpecies({ species: this.returns.species_list });
}), _name$props$component);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'SanctionOutcomeTableDash',
    props: {
        level: {
            type: String,
            required: true,
            validator: function validator(val) {
                var options = ['internal', 'external'];
                return options.indexOf(val) != -1 ? true : false;
            }
        },
        url: {
            type: String,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        return {
            sanction_outcome_types: [],
            sanction_outcome_statuses: [],
            sanction_outcome_payment_statuses: [],

            pBody: 'pBody' + vm._uid,
            datatable_id: 'return-datatable-' + vm._uid,

            filterType: 'all',
            filterStatus: 'all',
            filterPaymentStatus: 'all',
            filterDateFrom: '',
            filterDateTo: '',

            dateFormat: 'DD/MM/YYYY',
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            table_headers: ["id", "Number", "Type", "Identifier", "Date", "Status", "Payment Status", "Sanction Outcome", "Action", ""],
            table_options: {
                serverSide: true,
                searchDelay: 1000,
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                processing: true,
                ajax: {
                    url: vm.url,
                    dataSrc: 'data',
                    data: function data(d) {
                        d.type = vm.filterType;
                        d.status = vm.filterStatus;
                        d.payment_status = vm.filterPaymentStatus;
                        d.date_from = vm.filterDateFrom;
                        d.date_to = vm.filterDateTo;
                    },
                    complete: function complete(jqXHR, textStatus) {
                        vm.$emit('records_total', jqXHR.responseJSON.recordsTotal);
                    }
                },
                columns: [{
                    data: 'id',
                    visible: false
                }, {
                    data: 'lodgement_number',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'type',
                    searchable: true,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        return data.name;
                    }
                }, {
                    data: 'identifier',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'date_of_issue',
                    searchable: true,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format('DD/MM/YYYY') : '';
                    }
                }, {
                    data: 'status',
                    searchable: true,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        return data.name;
                    }
                }, {
                    data: 'payment_status.name',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'paper_notices',
                    searchable: true,
                    orderable: false,
                    mRender: function mRender(data, type, row) {
                        console.log(row);
                        return data;
                    }
                }, {
                    data: 'user_action',
                    mRender: function mRender(data, type, full) {
                        return data;
                    }
                }, {
                    data: 'remediation_actions',
                    mRender: function mRender(data, type, full) {
                        var html = '';

                        if (full.remediation_actions && full.remediation_actions.length) {
                            var body = '';
                            var td = '<td col="row">';
                            var td_close = '</td>';
                            var th = '<th scope="col">';
                            var th_close = '</th>';

                            for (var i = 0; i < full.remediation_actions.length; i++) {
                                var ra = full.remediation_actions[i];
                                body += '<tr>' + td + moment(ra.due_date).format('DD/MM/YYYY') + td_close + td + ra.status.name + td_close + td + ra.user_action + td_close;
                                '</tr>';
                            }

                            var header = '<thead><tr>' + th + 'Due Date' + th_close + th + 'Status' + th_close + th + 'Action' + th_close + '</tr></thead>';
                            html = '<table class="table">' + header + body + '</table>';
                        }

                        return html;
                    }
                }]
            }
        };
    },

    components: {
        datatable: _datatable2.default
    },
    watch: {
        filterType: function filterType() {
            console.log('filterType');
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        },
        filterStatus: function filterStatus() {
            console.log('filterStatus');
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        },
        filterPaymentStatus: function filterPaymentStatus() {
            console.log('filterPaymentStatus');
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        },
        filterDateFrom: function filterDateFrom() {
            console.log('filterDateFrom');
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        },
        filterDateTo: function filterDateTo() {
            console.log('filterDateTo');
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        }
    },
    computed: {
        is_external: function is_external() {
            return this.level == 'external';
        }
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.constructOptionsType();
                            this.constructOptionsStatus();
                            this.constructOptionsPaymentStatus();

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    methods: {
        addEventListeners: function addEventListeners() {
            this.attachFromDatePicker();
            this.attachToDatePicker();

            var vm = this;

            vm.$refs.sanction_outcome_table.vmDataTable.on('click', 'a[data-pay-infringement-penalty]', function (e) {
                e.preventDefault();
                var id = $(e.target).attr('data-pay-infringement-penalty');
                vm.payInfringementPenalty(id);
            });
        },
        payInfringementPenalty: function payInfringementPenalty(sanction_outcome_id) {
            this.$http.post('/infringement_penalty/' + sanction_outcome_id + '/').then(function (res) {
                window.location.href = "/ledger/checkout/checkout/payment-details/";
            }, function (err) {
                swal('Submit Error', _hooks.helpers.apiVueResourceError(err), 'error');
            });
        },
        attachFromDatePicker: function attachFromDatePicker() {
            var vm = this;
            var el_fr = $(vm.$refs.issueDateFromPicker);
            var el_to = $(vm.$refs.issueDateToPicker);

            el_fr.datetimepicker({ format: 'DD/MM/YYYY', maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_fr.on('dp.change', function (e) {
                if (el_fr.data('DateTimePicker').date()) {
                    vm.filterDateFrom = e.date.format('DD/MM/YYYY');
                    el_to.data('DateTimePicker').minDate(e.date);
                } else if (el_fr.data('date') === "") {
                    vm.filterDateFrom = "";
                }
            });
        },
        attachToDatePicker: function attachToDatePicker() {
            var vm = this;
            var el_fr = $(vm.$refs.issueDateFromPicker);
            var el_to = $(vm.$refs.issueDateToPicker);
            el_to.datetimepicker({ format: 'DD/MM/YYYY', maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_to.on('dp.change', function (e) {
                if (el_to.data('DateTimePicker').date()) {
                    vm.filterDateTo = e.date.format('DD/MM/YYYY');
                    el_fr.data('DateTimePicker').maxDate(e.date);
                } else if (el_to.data('date') === "") {
                    vm.filterDateTo = "";
                }
            });
        },
        constructOptionsType: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var returned;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _hooks.cache_helper.getSetCacheList('SanctionOutcomeTypes', '/api/sanction_outcome/types.json');

                            case 2:
                                returned = _context2.sent;

                                (0, _assign2.default)(this.sanction_outcome_types, returned);
                                this.sanction_outcome_types.splice(0, 0, { id: 'all', display: 'All' });

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function constructOptionsType() {
                return _ref2.apply(this, arguments);
            }

            return constructOptionsType;
        }(),
        constructOptionsStatus: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var returned;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _hooks.cache_helper.getSetCacheList('SanctionOutcomeStatuses', '/api/sanction_outcome/statuses_for_external.json');

                            case 2:
                                returned = _context3.sent;

                                (0, _assign2.default)(this.sanction_outcome_statuses, returned);
                                this.sanction_outcome_statuses.splice(0, 0, { id: 'all', display: 'All' });

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function constructOptionsStatus() {
                return _ref3.apply(this, arguments);
            }

            return constructOptionsStatus;
        }(),
        constructOptionsPaymentStatus: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var returned;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _hooks.cache_helper.getSetCacheList('SanctionOutcomePaymentStatuses', '/api/sanction_outcome/payment_statuses.json');

                            case 2:
                                returned = _context4.sent;

                                (0, _assign2.default)(this.sanction_outcome_payment_statuses, returned);
                                this.sanction_outcome_payment_statuses.splice(0, 0, { id: 'all', display: 'All' });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function constructOptionsPaymentStatus() {
                return _ref4.apply(this, arguments);
            }

            return constructOptionsPaymentStatus;
        }()
    },
    mounted: function mounted() {
        var vm = this;
        this.$nextTick(function () {
            vm.addEventListeners();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'SanctionOutcomePersonOrgTableDash',
    props: {
        level: {
            type: String,
            required: true
        },
        entity_id: {
            type: Number,
            required: true
        },
        entity_type: {
            type: String,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        return {

            pBody: 'pBody' + vm._uid,
            datatable_id: 'return-datatable-' + vm._uid,

            dateFormat: 'DD/MM/YYYY',
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            table_headers: ["id", "Number", "Type", "Identifier", "Date", "Status", "Payment Status", "Sanction Outcome", "Action", ""],
            table_options: {
                serverSide: true,
                searchDelay: 1000,
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                processing: true,
                ajax: {
                    url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.sanction_outcome_paginated, 'person_org_datatable_list/?format=datatables'),
                    dataSrc: 'data',
                    data: function data(d) {
                        d.entity_id = vm.entity_id;
                        d.entity_type = vm.entity_type;
                    },
                    complete: function complete(jqXHR, textStatus) {
                        vm.$emit('records_total', jqXHR.responseJSON.recordsTotal);
                    }
                },
                columns: [{
                    data: 'id',
                    visible: false
                }, {
                    data: 'lodgement_number',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'type',
                    searchable: true,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        return data.name;
                    }
                }, {
                    data: 'identifier',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'date_of_issue',
                    searchable: true,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format('DD/MM/YYYY') : '';
                    }
                }, {
                    data: 'status',
                    searchable: true,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        return data.name;
                    }
                }, {
                    data: 'payment_status.name',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'paper_notices',
                    searchable: true,
                    orderable: false,
                    mRender: function mRender(data, type, row) {
                        console.log(row);
                        return data;
                    }
                }, {
                    data: 'user_action',
                    mRender: function mRender(data, type, full) {
                        return data;
                    }
                }, {
                    data: 'remediation_actions',
                    mRender: function mRender(data, type, full) {
                        var html = '';

                        if (full.remediation_actions && full.remediation_actions.length) {
                            var body = '';
                            var td = '<td col="row">';
                            var td_close = '</td>';
                            var th = '<th scope="col">';
                            var th_close = '</th>';

                            for (var i = 0; i < full.remediation_actions.length; i++) {
                                var ra = full.remediation_actions[i];
                                body += '<tr>' + td + moment(ra.due_date).format('DD/MM/YYYY') + td_close + td + ra.status.name + td_close + td + ra.user_action + td_close;
                                '</tr>';
                            }

                            var header = '<thead><tr>' + th + 'Due Date' + th_close + th + 'Status' + th_close + th + 'Action' + th_close + '</tr></thead>';
                            html = '<table class="table">' + header + body + '</table>';
                        }

                        return html;
                    }
                }]
            }
        };
    },

    components: {
        datatable: _datatable2.default
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _awesomplete = __webpack_require__(43);

var _awesomplete2 = _interopRequireDefault(_awesomplete);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(15);

__webpack_require__(39);

var _update_create_person = __webpack_require__(812);

var _update_create_person2 = _interopRequireDefault(_update_create_person);

var _update_create_organisation = __webpack_require__(811);

var _update_create_organisation2 = _interopRequireDefault(_update_create_organisation);

var _objectHash = __webpack_require__(55);

var _objectHash2 = _interopRequireDefault(_objectHash);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "search-person-organisation",
    data: function data() {
        var vm = this;
        vm.awesomplete_obj = null;
        return {
            entity: {
                id: null,
                data_type: null,
                full_name: null
            },
            displayUpdateCreatePerson: false,
            displayUpdateCreateOrganisation: false,
            searchType: '',
            errorText: '',
            uuid: 0,
            showCreateNewPerson: false,
            showCreateNewOrganisation: false,
            creatingPerson: false,
            creatingOrganisation: false
        };
    },
    components: {
        updateCreatePerson: _update_create_person2.default,
        updateCreateOrganisation: _update_create_organisation2.default
    },
    watch: {
        entity: {
            handler: function handler() {
                if (this.entity.id) {
                    if (this.addFullName) {
                        console.log('here');
                        this.$emit('entity-selected', {
                            id: this.entity.id,
                            data_type: this.entity.data_type,
                            full_name: this.entity.full_name
                        });
                    } else {
                        console.log('there');
                        this.$emit('entity-selected', {
                            id: this.entity.id,
                            data_type: this.entity.data_type });
                    }
                }
                if (this.entity.id && this.entity.data_type === 'individual') {
                    this.displayUpdateCreateOrganisation = false;
                    this.displayUpdateCreatePerson = true;
                    this.creatingPerson = false;
                } else if (this.entity.id && this.entity.data_type === 'organisation') {
                    this.displayUpdateCreatePerson = false;

                    this.displayUpdateCreateOrganisation = false;
                    this.creatingOrganisation = false;
                }
            },
            deep: true
        }
    },
    computed: {
        formChanged: function formChanged() {
            var changed = false;
            if (this.object_hash !== (0, _objectHash2.default)(this.entity)) {
                changed = true;
            }
            return changed;
        },
        elemId: function elemId() {
            this.uuid += 1;
            var domId = this.searchType + this.uuid + 'search';

            if (this.domIdHelper) {
                domId += this.domIdHelper;
            }
            return domId;
        },
        labelTitle: function labelTitle() {
            if (this.searchType) {
                return "Search " + this.searchType;
            }
        },
        updateCreatePersonBindId: function updateCreatePersonBindId() {
            var bindId = 'person';
            if (this.entity.data_type === 'individual' && this.entity.id) {
                bindId += this.entity.id;
            } else {
                bindId += this.uuid;
            }
            return bindId;
        },
        entityIsPerson: function entityIsPerson() {
            var check = false;
            if (this.entity.data_type === 'individual' && this.entity.id || this.creatingPerson) {
                check = true;
            }
            return check;
        },
        entityIsOrganisation: function entityIsOrganisation() {
            var check = false;
            if (this.entity.data_type === 'organisation' && this.entity.id || this.creatingOrganisation) {
                check = true;
            }
            return check;
        }
    },
    props: {
        showClearPerson: {
            required: false,
            default: false
        },
        classNames: {
            required: false,
            default: 'form-control'
        },
        maxItems: {
            required: false,
            default: 10
        },
        initialSearchType: {
            required: false,
            default: 'individual' },
        isEditable: {
            required: false,
            default: true
        },
        excludeStaff: {
            type: Boolean,
            required: false,
            default: false
        },
        departmentalStaff: {
            type: Boolean,
            required: false,
            default: false
        },
        showCreateUpdate: {
            type: Boolean,
            required: false,
            default: false
        },
        parentEntity: {
            type: Object,
            required: false
        },
        domIdHelper: {
            type: String,
            required: false
        },
        componentTitle: {
            type: String,
            required: false
        },
        personOnly: {
            type: Boolean,
            required: false,
            default: false
        },
        addFullName: {
            type: Boolean,
            required: false,
            default: false
        },
        displayTitle: {
            type: Boolean,
            required: false,
            default: true
        },
        entityEdit: {
            type: Object,
            required: false
        }
    },
    methods: {
        parentSave: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var savedEntity;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                savedEntity = null;

                                console.log("parent save");

                                if (!(this.searchType === 'individual')) {
                                    _context.next = 8;
                                    break;
                                }

                                _context.next = 5;
                                return this.$refs.update_create_person.parentSave();

                            case 5:
                                savedEntity = _context.sent;
                                _context.next = 12;
                                break;

                            case 8:
                                if (!(this.searchType === 'organisation')) {
                                    _context.next = 12;
                                    break;
                                }

                                _context.next = 11;
                                return this.$refs.update_create_organisation.parentSave();

                            case 11:
                                savedEntity = _context.sent;

                            case 12:
                                console.log(savedEntity);
                                return _context.abrupt("return", savedEntity);

                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function parentSave() {
                return _ref.apply(this, arguments);
            }

            return parentSave;
        }(),
        clearPerson: function clearPerson() {
            this.$emit('clear-person');
            this.entity = {
                'id': 0,
                'data_type': 'individual',
                'full_name': ''
            };
            var element_search = (0, _jquery2.default)('#' + this.elemId);
            console.log(element_search);
            element_search.val('');
            this.displayUpdateCreatePerson = false;
        },
        createNewPerson: function createNewPerson() {
            var _this = this;

            this.creatingPerson = true;
            this.entity = {
                id: null,
                data_type: null
            }, this.$nextTick(function () {
                _this.displayUpdateCreatePerson = true;
                _this.setInput('');
                if (_this.$refs.update_create_person && _this.$refs.update_create_person.email_user) {
                    _this.$refs.update_create_person.setDefaultPerson();
                    _this.$emit('entity-selected', { data_type: 'individual', id: null });
                }
            });
        },
        createNewOrganisation: function createNewOrganisation() {
            this.creatingOrganisation = true;
        },
        clearInput: function clearInput() {
            document.getElementById(this.elemId).value = "";
        },
        setInput: function setInput(person_org_str) {
            document.getElementById(this.elemId).value = person_org_str;
        },
        markMatchedText: function markMatchedText(original_text, input) {
            var ret_text = original_text.replace(new RegExp(input, "gi"), function (a, b) {
                return "<mark>" + a + "</mark>";
            });
            return ret_text;
        },

        createUpdateOrganisationClicked: function createUpdateOrganisationClicked() {
            this.displayUpdateCreateOrganisation = !this.displayUpdateCreateOrganisation;
        },
        savePerson: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(obj) {
                var full_name, dob, value, errorMessage;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!obj.person) {
                                    _context2.next = 10;
                                    break;
                                }

                                if (obj.updateSearchBox) {
                                    _context2.next = 4;
                                    break;
                                }

                                _context2.next = 4;
                                return this.$emit('entity-selected', { data_type: 'individual', id: obj.person.id });

                            case 4:
                                full_name = [obj.person.first_name, obj.person.last_name].filter(Boolean).join(" ");
                                dob = obj.person.dob ? "DOB:" + obj.person.dob : "DOB: ---";
                                value = [full_name, dob].filter(Boolean).join(", ");

                                this.setInput(value);
                                _context2.next = 14;
                                break;

                            case 10:
                                if (!obj.errorMessage) {
                                    _context2.next = 14;
                                    break;
                                }

                                errorMessage = obj.errorMessage;
                                _context2.next = 14;
                                return swal("Error", errorMessage, "error");

                            case 14:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function savePerson(_x) {
                return _ref2.apply(this, arguments);
            }

            return savePerson;
        }(),
        initAwesomplete: function initAwesomplete() {
            var vm = this;

            var element_search = document.getElementById(vm.elemId);
            vm.awesomplete_obj = new _awesomplete2.default(element_search, {
                maxItems: vm.maxItems,
                sort: false,
                filter: function filter() {
                    return true;
                },
                item: function item(text, input) {
                    var ret = _awesomplete2.default.ITEM(text, "");
                    return ret;
                },
                data: function data(item, input) {
                    if (vm.searchType == "individual") {
                        var f_name = item.first_name ? item.first_name : "";
                        var l_name = item.last_name ? item.last_name : "";

                        var full_name = [f_name, l_name].filter(Boolean).join(" ");

                        var email = item.email ? "E:" + item.email : "";
                        var p_number = item.phone_number ? "P:" + item.phone_number : "";
                        var m_number = item.mobile_number ? "M:" + item.mobile_number : "";
                        var dob = item.dob ? "DOB:" + item.dob : "DOB: ---";

                        var full_name_marked = "<strong>" + vm.markMatchedText(full_name, input) + "</strong>";
                        var email_marked = vm.markMatchedText(email, input);
                        var p_number_marked = vm.markMatchedText(p_number, input);
                        var m_number_marked = vm.markMatchedText(m_number, input);
                        var dob_marked = vm.markMatchedText(dob, input);

                        var myLabel = [full_name_marked, email_marked, p_number_marked, m_number_marked, dob_marked].filter(Boolean).join("<br />");
                        myLabel = "<div data-item-id=" + item.id + ' data-full-name="' + full_name + '" data-type="individual">' + myLabel + "</div>";

                        return {
                            label: myLabel,
                            value: [full_name, dob].filter(Boolean).join(", "),
                            id: item.id
                        };
                    } else {
                        var name = item.name ? item.name : "";
                        var abn = item.abn ? "ABN:" + item.abn : "";

                        var name_marked = "<strong>" + vm.markMatchedText(name, input) + "</strong>";
                        var abn_marked = vm.markMatchedText(abn, input);

                        var _myLabel = [name_marked, abn_marked].filter(Boolean).join("<br />");
                        _myLabel = "<div data-item-id=" + item.id + ' data-type="organisation">' + _myLabel + "</div>";

                        return {
                            label: _myLabel,
                            value: [name, abn].filter(Boolean).join(", "),
                            id: item.id
                        };
                    }
                }
            });
            (0, _jquery2.default)(element_search).on("keyup", function (ev) {
                var keyCode = ev.keyCode || ev.which;
                if (48 <= keyCode && keyCode <= 90 || 96 <= keyCode && keyCode <= 105 || keyCode == 8 || keyCode == 46) {
                    vm.search_person_or_organisation(ev.target.value);
                    return false;
                }
            }).on("awesomplete-selectcomplete", function (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                return false;
            }).on("awesomplete-select", function (ev) {
                var origin = (0, _jquery2.default)(ev.originalEvent.origin);
                console.log('In awesomplete-select');
                console.log(origin);
                var originTagName = origin[0].tagName;
                console.log('originTagName: ' + originTagName);
                switch (originTagName) {
                    case "STRONG":
                        origin = origin.parent();
                        break;
                    case "MARK":
                        origin = origin.parent().parent();
                        break;
                    case "LI":
                        origin = origin.children().first();
                        break;
                }
                var data_item_id = origin[0].getAttribute("data-item-id");
                var data_type = origin[0].getAttribute("data-type");
                var data_full_name = origin[0].getAttribute("data-full-name");

                vm.$nextTick(function () {
                    var data_item_id_int = parseInt(data_item_id);
                    vm.entity = {
                        'id': data_item_id_int,
                        'data_type': data_type,
                        'full_name': data_full_name
                    };
                });
            });
        },
        search_person_or_organisation: function search_person_or_organisation(searchTerm) {
            var vm = this;
            var suggest_list_offender = [];
            suggest_list_offender.length = 0;
            vm.awesomplete_obj.list = [];

            if (vm.ajax_for_offender != null) {
                vm.ajax_for_offender.abort();
                vm.ajax_for_offender = null;
            }

            var search_url = "";
            if (vm.searchType == "individual") {
                search_url = "/api/search_user/?search=";
            } else {
                search_url = "/api/search_organisation/?search=";
            }

            vm.ajax_for_offender = _jquery2.default.ajax({
                type: "GET",
                url: search_url + searchTerm + '&exclude_staff=' + vm.excludeStaff + '&departmental_staff=' + vm.departmentalStaff,
                success: function success(data) {
                    if (data && data.results) {
                        var persons = data.results;
                        var limit = Math.min(vm.maxItems, persons.length);
                        for (var i = 0; i < limit; i++) {
                            suggest_list_offender.push(persons[i]);
                        }
                    }
                    vm.awesomplete_obj.list = suggest_list_offender;
                    vm.awesomplete_obj.evaluate();

                    if (searchTerm.length >= 2 && suggest_list_offender.length > 0) {
                        if (vm.showCreateUpdate && vm.searchType === 'individual') {
                            vm.showCreateNewPerson = true;
                        } else if (vm.showCreateUpdate && vm.searchType === 'organisation') {
                            vm.showCreateNewOrganisation = true;
                        }
                    }
                },
                error: function error(e) {}
            });
        }
    },
    created: function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
            var _this2 = this;

            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.uuid += 1;
                            this.searchType = this.initialSearchType;
                            this.$nextTick(function () {
                                if (_this2.parentEntity) {
                                    (0, _assign2.default)(_this2.entity, _this2.parentEntity);
                                }
                                _this2.initAwesomplete();
                            });
                            if (this.entityEdit) {
                                (0, _assign2.default)(this.entity, this.entityEdit);
                            }
                            this.object_hash = (0, _objectHash2.default)(this.entity);

                        case 5:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function created() {
            return _ref3.apply(this, arguments);
        }

        return created;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "securebase-link",
    props: {
        link_data: {
            type: Object,
            required: true
        },
        link_name: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {};
    },
    computed: {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie('csrftoken');
        }
    },
    methods: {
        post_and_redirect: function post_and_redirect() {
            var postFormStr = "<form method='POST' target='_blank' name='securebase-view' action='/securebase-view/'>";
            postFormStr += "<input type='hidden' name='csrfmiddlewaretoken' value='" + this.csrf_token + "'>";
            var link_data_key = (0, _keys2.default)(this.link_data)[0];
            postFormStr += "<input type='hidden' name='" + link_data_key + "' value='" + this.link_data[link_data_key] + "'>";
            postFormStr += "</form>";
            var formElement = $(postFormStr);
            $('body').append(formElement);
            $(formElement).submit();
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _add_contact = __webpack_require__(129);

var _add_contact2 = _interopRequireDefault(_add_contact);

var _utils = __webpack_require__(33);

var _utils2 = _interopRequireDefault(_utils);

var _api = __webpack_require__(103);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Organisation',
    data: function data() {
        var vm = this;
        return {
            adBody: 'adBody' + vm._uid,
            aBody: 'aBody' + vm._uid,
            pdBody: 'pdBody' + vm._uid,
            pBody: 'pBody' + vm._uid,
            cdBody: 'cdBody' + vm._uid,
            cBody: 'cBody' + vm._uid,
            oBody: 'oBody' + vm._uid,
            dTab: 'dTab' + vm._uid,
            oTab: 'oTab' + vm._uid,
            idBody: 'idBody' + vm._uid,
            organisation: {
                address: {}
            },
            myorgperms: null,

            show_spinner: false,
            countries: []
        };
    },

    components: {
        datatable: _datatable2.default
    },
    computed: {},
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var returned_country_list;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _hooks.cache_helper.getSetCacheList('Countries', _api2.default.countries);

                        case 2:
                            returned_country_list = _context.sent;

                            (0, _assign2.default)(this.countries, returned_country_list);

                            _vue2.default.set(this.organisation.address, 'country', 'AU');

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),

    methods: {
        save: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var post_url, returnedOrganisation;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.show_spinner = true;
                                post_url = '/api/organisations_compliancemanagement/';
                                _context2.next = 4;
                                return _vue2.default.http.post(post_url, (0, _stringify2.default)(this.organisation));

                            case 4:
                                returnedOrganisation = _context2.sent;

                                console.log(returnedOrganisation);
                                if (returnedOrganisation.ok) {}

                                this.show_spinner = false;

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function save() {
                return _ref2.apply(this, arguments);
            }

            return save;
        }()
    },
    mounted: function mounted() {}
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(33);

var _utils2 = _interopRequireDefault(_utils);

__webpack_require__(15);

__webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "update-create-person",

    data: function data() {
        var vm = this;

        return {
            mainElement: null,
            elementId: 'create_new_person_' + vm._uid,

            pdBody: 'pdBody' + vm._uid,
            cdBody: 'cdBody' + vm._uid,
            adBody: 'adBody' + vm._uid,
            errorGivenName: false,
            errorLastName: false,
            errorDob: false,
            objectAlert: false,
            loading: [],
            countries: [],
            saveButtonEnabled: false,

            isPersonalDetailsOpen: null,
            isAddressDetailsOpen: null,
            isContactDetailsOpen: null,

            email_user: {
                id: null,
                first_name: '',
                last_name: '',
                dob: null,
                residential_address: {
                    line1: '',
                    locality: '',
                    state: 'WA',
                    postcode: '',
                    country: 'AU'
                },
                phone_number: '',
                mobile_number: '',
                email: ''
            }
        };
    },
    props: {
        displayComponent: {
            type: Boolean,
            required: true,
            default: false
        },
        displaySaveButton: {
            type: Boolean,
            required: false,
            default: true
        },
        defaultOpenPersonalDetails: {
            type: Boolean,
            required: false,
            default: true
        },
        defaultOpenAddressDetails: {
            type: Boolean,
            required: false,
            default: false
        },
        defaultOpenContactDetails: {
            type: Boolean,
            required: false,
            default: false
        },
        slideDownMiliSecond: {
            type: Number,
            required: false,
            default: 200
        },
        slideUpMiliSecond: {
            type: Number,
            required: false,
            default: 300
        },
        personToUpdate: {
            type: Number,
            required: false
        },
        isEditable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        personId: function personId() {
            return this.email_user.id;
        },
        personalDetailsReadOnly: function personalDetailsReadOnly() {
            if (this.email_user.id) {
                return true;
            }
        },
        computedEmailUser: function computedEmailUser() {
            var computedUser = (0, _assign2.default)({}, this.email_user);
            if (this.email_user && this.email_user.residential_address) {
                (0, _assign2.default)(computedUser.residential_address, this.email_user.residential_address);
            }
            return computedUser;
        },
        saveButtonText: function saveButtonText() {
            var buttonText = '';
            if (this.email_user && this.email_user.id) {
                buttonText = 'Update Person';
            } else {
                buttonText = 'Save New Person';
            }
            return buttonText;
        }

    },
    watch: {
        displayComponent: {
            handler: function handler() {
                this.showHideElement();
            }
        },
        isPersonalDetailsOpen: {
            handler: function handler() {
                var elem = (0, _jquery2.default)('#' + this.pdBody);
                if (this.isPersonalDetailsOpen) {
                    elem.slideDown(this.slideDownMiliSecond);
                } else {
                    elem.slideUp(this.slideUpMiliSecond);
                }
            }
        },
        isAddressDetailsOpen: {
            handler: function handler() {
                var elem = (0, _jquery2.default)('#' + this.adBody);
                if (this.isAddressDetailsOpen) {
                    elem.slideDown(this.slideDownMiliSecond);
                } else {
                    elem.slideUp(this.slideUpMiliSecond);
                }
            }
        },
        isContactDetailsOpen: {
            handler: function handler() {
                var elem = (0, _jquery2.default)('#' + this.cdBody);
                if (this.isContactDetailsOpen) {
                    elem.slideDown(this.slideDownMiliSecond);
                } else {
                    elem.slideUp(this.slideUpMiliSecond);
                }
            }
        },
        computedEmailUser: {
            deep: true,
            handler: function handler(newVal, oldVal) {
                if (oldVal.id && oldVal !== newVal) {
                    this.saveButtonEnabled = true;
                } else if (this.email_user && !this.email_user.id) {
                    this.saveButtonEnabled = true;
                } else {
                    this.saveButtonEnabled = false;
                }
            }
        }

    },
    methods: {
        addEventListeners: function addEventListeners() {
            var _this = this;

            var el_fr_date = (0, _jquery2.default)(this.$refs.dobDatePicker);

            el_fr_date.datetimepicker({
                format: "DD/MM/YYYY",
                maxDate: "now",
                showClear: true
            });
            el_fr_date.on("dp.change", function (e) {
                if (el_fr_date.data("DateTimePicker").date()) {
                    _this.email_user.dob = e.date.format("DD/MM/YYYY");
                } else if (el_fr_date.data("date") === "") {
                    _this.email_user.dob = "";
                }
            });
        },
        setExistingPerson: function setExistingPerson(id) {
            var _this2 = this;

            var initialisers = [_utils2.default.fetchUser(id)];
            _promise2.default.all(initialisers).then(function (data) {
                (0, _assign2.default)(_this2.email_user, data[0]);
                if (!_this2.email_user.residential_address) {
                    _this2.email_user.residential_address = _this2.getDefaultAddress();
                }
                if (_this2.email_user.dob) {
                    _this2.email_user.dob = moment(_this2.email_user.dob, 'YYYY-MM-DD').format('DD/MM/YYYY');
                }
            });
        },
        setPersonId: function setPersonId(id) {
            this.email_user.id = id;
        },
        setDefaultPerson: function setDefaultPerson() {
            var user_data = {
                id: null,
                first_name: '',
                last_name: '',
                dob: null,
                residential_address: {
                    line1: '',
                    locality: '',
                    state: 'WA',
                    postcode: '',
                    country: 'AU'
                },
                phone_number: '',
                mobile_number: '',
                email: ''
            };
            (0, _assign2.default)(this.email_user, user_data);
        },
        getDefaultAddress: function getDefaultAddress() {
            var residential_address_data = {
                line1: '',
                locality: '',
                state: 'WA',
                postcode: '',
                country: 'AU'
            };
            return residential_address_data;
        },
        handleSlideElement: function handleSlideElement(elem_id) {
            var elem = (0, _jquery2.default)('#' + elem_id);
            if (keyword == 'pd') {
                this.isPersonalDetailsOpen = !this.isPersonalDetailsOpen;
            } else if (keyword == 'ad') {
                this.isAddressDetailsOpen = !this.isAddressDetailsOpen;
            } else if (keyword == 'cd') {
                this.isContactDetailsOpen = !this.isContactDetailsOpen;
            }
        },
        loadCountries: function loadCountries() {
            var vm = this;
            var initialisers = [_utils2.default.fetchCountries()];
            _promise2.default.all(initialisers).then(function (data) {
                vm.countries = data[0];
            });
        },
        parentSave: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var savedEmailUser;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                savedEmailUser = null;

                                if (!this.saveButtonEnabled) {
                                    _context.next = 7;
                                    break;
                                }

                                _context.next = 4;
                                return this.saveData('parentSave');

                            case 4:
                                savedEmailUser = _context.sent;
                                _context.next = 8;
                                break;

                            case 7:
                                savedEmailUser = { 'ok': true };

                            case 8:
                                return _context.abrupt('return', savedEmailUser);

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function parentSave() {
                return _ref.apply(this, arguments);
            }

            return parentSave;
        }(),
        saveData: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(parentSave) {
                var savedEmailUser, payload, fetchUrl;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                savedEmailUser = null;
                                _context2.prev = 1;
                                payload = {};

                                (0, _assign2.default)(payload, this.email_user);
                                if (payload.residential_address && !payload.residential_address.line1) {
                                    payload.residential_address = null;
                                }
                                if (payload.dob) {
                                    payload.dob = moment(payload.dob, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                }
                                fetchUrl = '';

                                if (!payload.id) {
                                    _context2.next = 17;
                                    break;
                                }

                                if (payload.email) {
                                    _context2.next = 14;
                                    break;
                                }

                                _context2.next = 11;
                                return swal("Error", "Ensure the email field is not blank", "error");

                            case 11:
                                return _context2.abrupt('return');

                            case 14:
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.compliance_management_users, payload.id + '/update_person/');

                            case 15:
                                _context2.next = 24;
                                break;

                            case 17:
                                if (!(!payload.first_name || !payload.last_name || !payload.dob || !payload.email)) {
                                    _context2.next = 23;
                                    break;
                                }

                                _context2.next = 20;
                                return swal("Error", "Fill out all Personal Details and email fields", "error");

                            case 20:
                                return _context2.abrupt('return');

                            case 23:
                                fetchUrl = _hooks.api_endpoints.compliance_management_users;

                            case 24:
                                _context2.next = 26;
                                return _vue2.default.http.post(fetchUrl, payload);

                            case 26:
                                savedEmailUser = _context2.sent;

                                if (!savedEmailUser.body.residential_address) {
                                    savedEmailUser.body.residential_address = this.getDefaultAddress();
                                }
                                (0, _assign2.default)(this.email_user, savedEmailUser.body);
                                this.email_user.dob = moment(this.email_user.dob, 'YYYY-MM-DD').format('DD/MM/YYYY');

                                if (parentSave === 'parentSave') {
                                    _context2.next = 33;
                                    break;
                                }

                                _context2.next = 33;
                                return swal("Saved", "Person has been saved", "success");

                            case 33:
                                this.$emit('person-saved', { 'person': savedEmailUser.body, 'errorMessage': null });
                                _context2.next = 41;
                                break;

                            case 36:
                                _context2.prev = 36;
                                _context2.t0 = _context2['catch'](1);

                                if (!_context2.t0.bodyText) {
                                    _context2.next = 41;
                                    break;
                                }

                                _context2.next = 41;
                                return swal("Error", _context2.t0.bodyText, "error");

                            case 41:
                                return _context2.abrupt('return', savedEmailUser);

                            case 42:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[1, 36]]);
            }));

            function saveData(_x) {
                return _ref2.apply(this, arguments);
            }

            return saveData;
        }(),
        showHideElement: function showHideElement() {
            if (this.displayComponent) {
                this.mainElement.slideDown(this.slideDownMiliSecond);
            } else {
                this.mainElement.slideUp(this.slideUpMiliSecond);
            }
        }
    },
    mounted: function mounted() {
        var vm = this;
        var elem = document.getElementById(vm.elementId);
        vm.mainElement = (0, _jquery2.default)(elem);
        vm.$nextTick(function () {
            vm.showHideElement();
            vm.loadCountries();

            vm.isPersonalDetailsOpen = vm.defaultOpenPersonalDetails;
            vm.isAddressDetailsOpen = vm.defaultOpenAddressDetails;
            vm.isContactDetailsOpen = vm.defaultOpenContactDetails;
            vm.addEventListeners();
        });
    },
    created: function created() {
        if (this.personToUpdate) {
            this.setExistingPerson(this.personToUpdate);
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(10)))

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'UserDashTable',
    props: {
        level: {
            type: String,
            required: true,
            validator: function validator(val) {
                var options = ['internal'];
                return options.indexOf(val) != -1 ? true : false;
            }
        },
        url: {
            type: String,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        return {
            pBody: 'pBody' + vm._uid,
            datatable_id: 'user-datatable-' + vm._uid,

            filterCharacterFlagged: 'All',
            character_flagged_options: ['True', 'False'],
            filterDateOfBirth: '',
            dateFormat: 'DD/MM/YYYY',
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            user_headers: ["Title", "Given Name(s)", "Last Name", "Date of Birth", "Email", "Phone", "Mobile", "Fax", "Character Flagged", "Character Comments", "Action"],
            user_options: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[4, 'asc']],
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: (0, _defineProperty3.default)({
                    "url": vm.url,
                    "data": 'data'
                }, 'data', function data(d) {
                    d.character_flagged = vm.filterCharacterFlagged;
                    d.dob = vm.filterDateOfBirth != '' && vm.filterDateOfBirth != null ? moment(vm.filterDateOfBirth, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                }),
                columns: [{
                    data: "title",
                    responsivePriority: 10
                }, {
                    data: "first_name",
                    responsivePriority: 20
                }, {
                    data: "last_name",
                    responsivePriority: 30
                }, {
                    data: "dob",
                    responsivePriority: 40,
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format(vm.dateFormat) : '';
                    },
                    searchable: false
                }, { data: "email" }, { data: "phone_number" }, { data: "mobile_number" }, { data: "fax_number" }, {
                    data: "character_flagged",
                    orderable: false,
                    searchable: false,
                    className: "capitalise"
                }, { data: "character_comments" }, {
                    data: "id",
                    responsivePriority: 50,
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        links += "<a href='/internal/users/\__ID__\'> Edit</a><br/>";
                        links += '<a href=\'#' + full.id + '\' apply-on-behalf-of=\'' + full.id + '\'>New Application</a>';

                        return links.replace(/__ID__/g, data);
                    },
                    orderable: false,
                    searchable: false
                }],
                processing: true,
                initComplete: function initComplete() {
                    vm.$refs.user_datatable.vmDataTable.columns.adjust().responsive.recalc();
                }
            }
        };
    },

    components: {
        datatable: _datatable2.default
    },
    watch: {
        filterDateOfBirth: function filterDateOfBirth() {
            this.$refs.user_datatable.vmDataTable.draw();
        },
        filterCharacterFlagged: function filterCharacterFlagged() {
            this.$refs.user_datatable.vmDataTable.draw();
        }
    },
    computed: {
        is_external: function is_external() {
            return this.level == 'external';
        }

    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setApplyProxyId', 'setApplicationWorkflowState', 'setApplyLicenceSelect']), {
        applyOnBehalfOf: function applyOnBehalfOf(user_id) {
            this.setApplyLicenceSelect({ licence_select: 'new_licence' });
            this.setApplyProxyId({ id: user_id });
            this.setApplicationWorkflowState({ bool: true });
            this.$router.push({
                name: "apply_application_licence"
            });
        },
        addEventListeners: function addEventListeners() {
            var vm = this;

            $(vm.$refs.filterDateOfBirthPicker).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.filterDateOfBirthPicker).on('dp.change', function (e) {
                if ($(vm.$refs.filterDateOfBirthPicker).data('DateTimePicker').date()) {
                    vm.filterDateOfBirth = e.date.format('DD/MM/YYYY');
                } else if ($(vm.$refs.filterDateOfBirthPicker).data('date') === "") {
                    vm.filterDateOfBirth = "";
                }
            });

            vm.$refs.user_datatable.vmDataTable.on('click', 'a[apply-on-behalf-of]', function (e) {
                e.preventDefault();
                var id = parseInt($(this).attr('apply-on-behalf-of'));
                vm.applyOnBehalfOf(id);
            });
        }
    }),
    mounted: function mounted() {
        var vm = this;
        this.$nextTick(function () {
            vm.addEventListeners();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _awesomplete = __webpack_require__(43);

var _awesomplete2 = _interopRequireDefault(_awesomplete);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(15);

__webpack_require__(39);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "weak-links",
    data: function data() {
        this.awesomplete_obj = null;
        return {
            elemId: 'create_weak_link_' + this._uid,
            selectedEntity: null,
            second_object_id: null,
            second_content_type: null,
            comment: ''
        };
    },
    props: {
        maxItems: {
            required: false,
            default: 10
        },

        readonlyForm: {
            required: false,
            default: false
        },
        displayedEntityType: {
            type: String
        },
        displayedEntityId: {
            type: Number
        }
    },
    computed: {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        }
    },
    methods: {
        markMatchedText: function markMatchedText(original_text, input) {
            if (original_text) {
                var ret_text = original_text.replace(new RegExp(input, "gi"), function (a, b) {
                    return "<mark>" + a + "</mark>";
                });
                return ret_text;
            } else {
                return '';
            }
        },

        callCreateWeakLink: function callCreateWeakLink() {
            var _this = this;

            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$parent.createWeakLink();

                            case 2:
                                res = _context.sent;

                                if (res.ok) {
                                    _this.selectedEntity = null;
                                    _this.comment = '';
                                    _this.$refs.elemId.value = '';
                                }

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            })));
        },
        initAwesomplete: function initAwesomplete() {
            var _this2 = this;

            var element_search = document.getElementById(this.elemId);
            this.awesomplete_obj = new _awesomplete2.default(element_search, {
                maxItems: this.maxItems,
                sort: false,
                filter: function filter() {
                    return true;
                },
                item: function item(text, input) {
                    var ret = _awesomplete2.default.ITEM(text, "");
                    return ret;
                },
                data: function data(item, input) {
                    var item_identifier_marked = _this2.markMatchedText(item.item_identifier, input);
                    var item_description_marked = _this2.markMatchedText(item.item_description, input);

                    var myLabel = [item_identifier_marked, item_description_marked].filter(Boolean).join("<br />");
                    myLabel = "<div data-item-id=" + item.id + " data-type=" + item.model_name + ">" + myLabel + "</div>";
                    return {
                        label: myLabel,

                        value: [item.item_identifier, item.item_description].filter(Boolean).join(", "),
                        id: item.id
                    };
                }
            });
            (0, _jquery2.default)(element_search).on("keyup", function (ev) {
                var keyCode = ev.keyCode || ev.which;
                if (48 <= keyCode && keyCode <= 90 || 96 <= keyCode && keyCode <= 105 || keyCode == 8 || keyCode == 46) {
                    if (_this2.selectedEntity) {
                        _this2.search_available_object_identifiers(ev.target.value);
                    }
                    return false;
                }
            }).on("awesomplete-selectcomplete", function (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                return false;
            }).on("awesomplete-select", function (ev) {
                var origin = (0, _jquery2.default)(ev.originalEvent.origin);
                var originTagName = origin[0].tagName;
                switch (originTagName) {
                    case "STRONG":
                        origin = origin.parent();
                        break;
                    case "MARK":
                        origin = origin.parent().parent();
                        break;
                    case "LI":
                        origin = origin.children().first();
                        break;
                }
                var data_item_id = origin[0].getAttribute("data-item-id");
                var data_type = origin[0].getAttribute("data-type");

                _this2.$nextTick(function () {
                    _this2.second_object_id = data_item_id;
                    _this2.second_content_type = data_type;
                });
            });
        },
        search_available_object_identifiers: function search_available_object_identifiers(searchText) {
            var _this3 = this;

            var suggested_weak_links = [];
            suggested_weak_links.length = 0;
            this.awesomplete_obj.list = [];

            if (this.ajax_weak_links != null) {
                this.ajax_weak_links.abort();
                this.ajax_weak_links = null;
            }

            var search_url = "/api/search_weak_links/";
            var payload = {
                'csrfmiddlewaretoken': this.csrf_token,
                'selectedEntity': this.selectedEntity,
                'searchText': searchText,
                'displayedEntityType': this.displayedEntityType,
                'displayedEntityId': this.displayedEntityId
            };

            this.ajax_weak_links = _jquery2.default.ajax({
                type: "POST",
                url: search_url,
                dataType: "json",

                data: payload,

                success: function success(data) {
                    if (data) {
                        var limit = Math.min(_this3.maxItems, data.length);
                        for (var i = 0; i < limit; i++) {
                            suggested_weak_links.push(data[i]);
                        }
                    }
                    _this3.awesomplete_obj.list = suggested_weak_links;
                    _this3.awesomplete_obj.evaluate();
                },
                error: function error(e) {}
            });
        }
    },
    created: function created() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.initAwesomplete();
        });
    }
};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _form = __webpack_require__(96);

var _form2 = _interopRequireDefault(_form);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _amendment_request_details = __webpack_require__(131);

var _amendment_request_details2 = _interopRequireDefault(_amendment_request_details);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var vm = this;
    return {
      form: null,
      isProcessing: false,
      tabSelected: false,
      application_customer_status_onload: {},
      missing_fields: [],
      adjusted_application_fee: 0,
      payment_method: null,
      activityTab: 'activityTab' + vm._uid + '_' + 0
    };
  },
  components: {
    Application: _form2.default,
    AmendmentRequestDetails: _amendment_request_details2.default
  },
  props: {
    form_width: {
      type: String,
      default: 'col-md-9'
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application', 'application_readonly', 'renderer_form_data', 'selected_activity_tab_id', 'selected_activity_tab_name', 'isApplicationLoaded', 'unfinishedActivities', 'current_user', 'reception_method_id', 'allCurrentActivities']), {
    csrf_token: function csrf_token() {
      return _hooks.helpers.getCookie('csrftoken');
    },
    activity_discard_url: function activity_discard_url() {
      return this.application ? '/api/application/' + this.application.id + '/discard_activity/' : '';
    },
    application_form_url: function application_form_url() {
      return this.application ? '/api/application/' + this.application.id + '/draft.json' : '';
    },
    application_form_data_url: function application_form_data_url() {
      return this.application ? '/api/application/' + this.application.id + '/form_data.json' : '';
    },
    listVisibleActivities: function listVisibleActivities() {
      return this.application.can_user_edit ? this.unfinishedActivities : this.allCurrentActivities;
    },
    requiresCheckout: function requiresCheckout() {
      return (this.adjusted_application_fee > 0 || this.application.licence_fee > 0) && ['draft', 'awaiting_payment', 'amendment_required', 'partially_approved'].includes(this.application.customer_status.id);
    },
    showCardPayButton: function showCardPayButton() {
      return !this.isProcessing && this.requiresCheckout && !this.showCashPayButton && !this.showNonePayButton;
    },
    showCashPayButton: function showCashPayButton() {
      return !this.isProcessing && this.application.is_reception_paper;
    },
    showNonePayButton: function showNonePayButton() {
      return !this.isProcessing && this.application.is_reception_migrate;
    },
    showSubmitButton: function showSubmitButton() {
      return !this.isProcessing && !this.requiresCheckout && !this.showCardPayButton && !this.showNonePayButton;
    },
    canDiscardActivity: function canDiscardActivity() {
      var _this = this;

      return this.application.activities.find(function (activity) {
        return activity.licence_activity == _this.selected_activity_tab_id && activity.processing_status == 'draft';
      });
    },
    userCanSubmit: function userCanSubmit() {
      return this.application.can_current_user_edit;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    load: 'loadApplication'
  }), (0, _vuex.mapActions)(['setApplication', 'setActivityTab', 'saveFormData', 'refreshApplicationFees']), {
    selectTab: function selectTab(component) {
      this.section_tab_id = component.id;
      this.setActivityTab({ id: component.id, name: component.label });
    },
    eventListeners: function eventListeners() {
      if (!this.tabSelected) {
        $('#tabs-section li:first-child a').click();
        this.tabSelected = true;
      }
    },
    discardActivity: function discardActivity(e) {
      var _this2 = this;

      var swal_title = 'Discard Selected Activity';
      var swal_html = 'Are you sure you want to discard activity: ' + this.selected_activity_tab_name + '?';
      swal({
        title: swal_title,
        html: swal_html,
        type: "question",
        showCancelButton: true,
        confirmButtonText: 'Discard',
        confirmButtonColor: '#d9534f'
      }).then(function (result) {
        _this2.$http.delete(_this2.activity_discard_url, { params: { 'activity_id': _this2.selected_activity_tab_id } }).then(function (res) {
          swal('Activity Discarded', _this2.selected_activity_tab_name + ' has been discarded from this application.', 'success');

          if (res.body.processing_status === 'discarded') {
            _this2.$router.push({
              name: "external-applications-dash"
            });
          } else {
            _this2.load({ url: '/api/application/' + _this2.application.id + '.json' }).then(function () {
              var newTab = _this2.unfinishedActivities[0];
              if (newTab == null) {
                _this2.$router.push({
                  name: "external-applications-dash"
                });
              } else {
                _this2.setActivityTab({ id: newTab.id, name: newTab.label });
              }
            });
          }
        }, function (err) {
          swal('Error', _hooks.helpers.apiVueResourceError(err), 'error');
        });
      }, function (error) {});
    },
    reloadApplication: function reloadApplication(application_id) {
      var _this3 = this;

      if (!application_id && this.application) {
        application_id = this.application.id;
      }
      if (application_id) {
        this.load({ url: '/api/application/' + application_id + '.json' }).then(function () {
          _this3.application_customer_status_onload = _this3.application.customer_status;
        });
      } else {
        this.load({ url: '/api/application.json' });
      }
    },
    saveExit: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(e) {
        var _this4 = this;

        var is_saved;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.save_form();

              case 2:
                is_saved = _context.sent;

                if (is_saved) {
                  swal('Saved', 'Your application has been saved', 'success').then(function (result) {
                    _this4.isProcessing = false;
                    _this4.reloadApplication();
                    window.location.href = "/";
                  });
                }
                this.isProcessing = true;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveExit(_x) {
        return _ref.apply(this, arguments);
      }

      return saveExit;
    }(),
    save_form: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var _this5 = this;

        var is_submitting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var is_saved;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isProcessing = true;
                is_saved = false;


                this.missing_fields.length = 0;
                this.highlight_missing_fields();

                _context2.next = 6;
                return this.saveFormData({ url: this.application_form_data_url, draft: true, submit: is_submitting }).then(function (res) {
                  _this5.isProcessing = false;
                  is_saved = true;
                }, function (err) {
                  if (err.body.hasOwnProperty("missing")) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = (0, _getIterator3.default)(err.body.missing), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var missing_field = _step.value;

                        _this5.missing_fields.push(missing_field);
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    _this5.highlight_missing_fields();
                    var top = ($('#error').offset() || { "top": NaN }).top;
                    $('html, body').animate({
                      scrollTop: top
                    }, 1);
                  }

                  swal('Error', 'There was an error saving your application', 'error').then(function (result) {
                    _this5.isProcessing = false;
                  });
                });

              case 6:
                return _context2.abrupt('return', is_saved);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function save_form() {
        return _ref2.apply(this, arguments);
      }

      return save_form;
    }(),
    save: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(e) {
        var _this6 = this;

        var is_saved;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.save_form();

              case 2:
                is_saved = _context3.sent;

                if (is_saved) {
                  swal('Saved', 'Your application has been saved', 'success').then(function (result) {
                    _this6.isProcessing = false;
                    _this6.reloadApplication();
                  });
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function save(_x3) {
        return _ref3.apply(this, arguments);
      }

      return save;
    }(),
    highlight_missing_fields: function highlight_missing_fields() {
      $('.missing-field').removeClass('missing-field');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.missing_fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var missing_field = _step2.value;

          $('[name=' + missing_field.name).addClass('missing-field');
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var top = ($('#error').offset() || { "top": NaN }).top;
      $('html, body').animate({
        scrollTop: top
      }, 1);
    },
    submit: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        var _this7 = this;

        var vm, swal_title, swal_html;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                vm = this;
                swal_title = 'Submit Application';
                swal_html = 'Are you sure you want to submit this application?';

                swal({
                  title: swal_title,
                  html: swal_html,
                  type: "question",
                  showCancelButton: true,
                  confirmButtonText: 'Submit'

                }).then(function () {
                  var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(result) {
                    var is_submitting, is_saved;
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!result.value) {
                              _context4.next = 8;
                              break;
                            }

                            is_submitting = true;
                            _context4.next = 4;
                            return _this7.save_form(is_submitting);

                          case 4:
                            is_saved = _context4.sent;

                            if (is_saved) {
                              _this7.isProcessing = true;
                              vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/submit'), {}).then(function (res) {

                                _this7.setApplication(res.body);
                                _this7.isProcessing = false;
                                vm.$router.push({
                                  name: 'submit_application',
                                  params: { application: vm.application }
                                });
                              }, function (err) {
                                swal('Submit Error', _hooks.helpers.apiVueResourceError(err), 'error').then(function (result) {
                                  _this7.isProcessing = false;
                                });
                              });
                            }

                            _context4.next = 9;
                            break;

                          case 8:

                            _this7.isProcessing = false;

                          case 9:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this7);
                  }));

                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }(), function (error) {
                  swal('Error', 'There was an error submitting your application', 'error').then(function (result) {
                    _this7.isProcessing = false;
                  });
                });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function submit() {
        return _ref4.apply(this, arguments);
      }

      return submit;
    }(),
    pay_and_submit: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
        var _this8 = this;

        var vm, swal_title, swal_html;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                vm = this;
                swal_title = 'Checkout and Submit Application';
                swal_html = 'Are you sure you want to pay and submit this application?<br><br>';

                swal({
                  title: swal_title,
                  html: swal_html,
                  type: "question",
                  showCancelButton: true,
                  confirmButtonText: 'Submit'

                }).then(function () {
                  var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(result) {
                    var is_submitting, is_saved;
                    return _regenerator2.default.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (!result.value) {
                              _context6.next = 8;
                              break;
                            }

                            is_submitting = true;
                            _context6.next = 4;
                            return vm.save_form(is_submitting);

                          case 4:
                            is_saved = _context6.sent;


                            if (is_saved) {
                              vm.isProcessing = true;
                              if (_this8.adjusted_application_fee > 0 || _this8.application.licence_fee > 0) {

                                vm.$http.post(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications, vm.application.id + '/application_fee_checkout/'), {}).then(function (res) {
                                  window.location.href = "/ledger/checkout/checkout/payment-details/";
                                }, function (err) {
                                  swal('Submit Error', _hooks.helpers.apiVueResourceError(err), 'error').then(function (result) {
                                    _this8.isProcessing = false;
                                  });
                                });
                              } else {
                                vm.isProcessing = false;
                                vm.$router.push({
                                  name: 'submit_application',
                                  params: { application: vm.application }
                                });
                              }
                            }

                            _context6.next = 9;
                            break;

                          case 8:

                            vm.isProcessing = false;

                          case 9:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this8);
                  }));

                  return function (_x5) {
                    return _ref7.apply(this, arguments);
                  };
                }(), function (error) {
                  swal('Error', 'There was an error submitting your application', 'error').then(function (result) {
                    vm.isProcessing = false;
                  });
                });

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function pay_and_submit() {
        return _ref6.apply(this, arguments);
      }

      return pay_and_submit;
    }(),

    submit_and_record: function () {
      var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
        var _this9 = this;

        var vm, swal_title, swal_html;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                vm = this;
                swal_title = 'Submit Application and Record Payment';
                swal_html = 'Are you sure you want to submit this application?';

                swal({
                  title: swal_title,
                  html: swal_html,
                  type: "question",
                  showCancelButton: true,
                  confirmButtonText: 'Submit'
                }).then(function () {
                  var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(result) {
                    var is_submitting, is_saved;
                    return _regenerator2.default.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (!result.value) {
                              _context8.next = 8;
                              break;
                            }

                            is_submitting = true;
                            _context8.next = 4;
                            return _this9.save_form(is_submitting);

                          case 4:
                            is_saved = _context8.sent;


                            if (is_saved) {
                              _this9.isProcessing = true;
                              vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/application_fee_reception'), {
                                emulateJSON: true
                              }).then(function (res) {
                                _this9.setApplication(res.body);
                                _this9.isProcessing = false;
                                vm.$router.push({
                                  name: 'submit_application',
                                  params: { application: vm.application }
                                });
                              }, function (err) {
                                swal('Submit Error', _hooks.helpers.apiVueResourceError(err), 'error').then(function (result) {
                                  _this9.isProcessing = false;
                                });
                              });
                            }

                            _context8.next = 9;
                            break;

                          case 8:

                            _this9.isProcessing = false;

                          case 9:
                          case 'end':
                            return _context8.stop();
                        }
                      }
                    }, _callee8, _this9);
                  }));

                  return function (_x6) {
                    return _ref9.apply(this, arguments);
                  };
                }(), function (error) {
                  swal('Error', 'There was an error submitting your application', 'error').then(function (result) {
                    _this9.isProcessing = false;
                  });
                });

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function submit_and_record() {
        return _ref8.apply(this, arguments);
      }

      return submit_and_record;
    }()

  }),
  mounted: function mounted() {
    this.form = document.forms.new_application;
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.reloadApplication(to.params.application_id);
    });
  },
  updated: function updated() {
    var vm = this;
    this.$nextTick(function () {
      vm.eventListeners();
    });

    this.adjusted_application_fee = this.application.application_fee;
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _utils3 = __webpack_require__(33);

var _utils4 = _interopRequireDefault(_utils3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var vm = this;
        return {
            "application": null,
            agent: {},
            selected_apply_org_id_details: {},
            selected_apply_proxy_id_details: {},
            current_user: {
                wildlifecompliance_organisations: []
            },
            licence_select: null,
            "loading": [],
            form: null,
            pBody: 'pBody' + vm._uid
        };
    },
    components: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['selected_apply_org_id', 'selected_apply_proxy_id', 'application_workflow_state']), {
        isLoading: function isLoading() {
            return this.loading.length > 0;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setApplyLicenceSelect']), {
        submit: function submit() {
            this.setApplyLicenceSelect({ licence_select: this.licence_select });
            this.$router.replace({
                name: "apply_application_licence"
            });
        }
    }),
    mounted: function mounted() {
        var vm = this;
        vm.form = document.forms.new_application;
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            if (!vm.application_workflow_state) {
                return vm.$router.replace({
                    name: "apply_application_organisation"
                });
            }
            var initialisers = [_utils2.default.fetchCurrentUser(), _utils2.default.fetchCurrentActiveLicenceApplication({
                "proxy_id": vm.selected_apply_proxy_id,
                "organisation_id": vm.selected_apply_org_id
            }), vm.selected_apply_org_id ? _utils2.default.fetchOrganisation(vm.selected_apply_org_id) : '', vm.selected_apply_proxy_id ? _utils4.default.fetchUser(vm.selected_apply_proxy_id) : ''];
            _promise2.default.all(initialisers).then(function (data) {
                vm.current_user = data[0];
                if (data[1].application == null) {
                    vm.setApplyLicenceSelect({ licence_select: 'new_licence' });

                    return vm.$router.replace({
                        name: "apply_application_licence"
                    });
                }
                vm.application = data[1].application;
                vm.selected_apply_org_id_details = data[2];
                vm.selected_apply_proxy_id_details = data[3];
            });
        });
    }
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _utils3 = __webpack_require__(33);

var _utils4 = _interopRequireDefault(_utils3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var vm = this;
        return {
            licence_category: this.$route.params.licence_category,
            licence_activity: this.$route.params.licence_activity,
            licence_no: this.$route.params.licence_no,
            select_activity: this.$route.params.select_activity,
            select_purpose: this.$route.params.select_purpose,
            select_licence_purpose: this.$route.params.select_licence_purpose,
            application: null,
            agent: {},
            activity: {
                id: null,
                purpose: []
            },

            radio_selected: [],
            selected_activity: [],
            activity_type_showing: [],
            organisations: null,
            licence_categories: {
                checked: false,
                activity: [{
                    id: null,
                    selected: false,
                    purpose: []
                }]
            },
            "loading": [],
            form: null,
            pBody: 'pBody' + vm._uid,
            application_fee: 0,
            licence_fee: 0,
            selected_apply_org_id_details: {},
            selected_apply_proxy_id_details: {},
            customer_pay_method: 'card',
            spinner: false
        };
    },
    components: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['selected_apply_org_id', 'selected_apply_proxy_id', 'selected_apply_licence_select', 'application_workflow_state', 'reception_method_id', 'current_user']), {
        applicationTitle: function applicationTitle() {
            switch (this.selected_apply_licence_select) {
                case 'new_activity':
                    return 'Apply for a new activity';
                    break;
                case 'amend_activity':
                    return 'Amend one or more licensed activities';
                    break;
                case 'renew_activity':
                    return 'Renew one or more licensed activities';
                    break;
                case 'reissue_activity':
                    return 'Reissue one or more licensed activities';
                    break;
                default:
                    return 'Apply for a new licence';
                    break;
            }
        },
        selectionLabel: function selectionLabel() {
            return this.isAmendment ? 'Select the licence activity and purposes you wish to amend' : this.isRenewal ? 'Select one or more activities and purposes you wish to renew' : this.isReissue ? 'Select one or more activities and purposes you wish to reissue' : 'Select the class of licence you wish to apply for';
        },
        categoryCount: function categoryCount() {
            return this.visibleLicenceCategories.length;
        },
        visibleLicenceCategories: function visibleLicenceCategories() {
            return this.licence_categories;
        },
        isAmendment: function isAmendment() {
            return this.selected_apply_licence_select && this.selected_apply_licence_select === 'amend_activity';
        },
        isRenewal: function isRenewal() {
            return this.selected_apply_licence_select && this.selected_apply_licence_select === 'renew_activity';
        },
        isReissue: function isReissue() {
            return this.selected_apply_licence_select && this.selected_apply_licence_select === 'reissue_activity';
        },
        showSpinner: function showSpinner() {
            return this.spinner;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setApplicationWorkflowState', 'setReceptionMethodId', 'loadCurrentUser']), {
        submit: function submit() {
            var vm = this;
            vm.spinner = true;
            swal({
                title: "Create Application",
                text: "Are you sure you want to create an application?",
                type: "question",
                showCancelButton: true,
                confirmButtonText: 'Accept'
            }).then(function (result) {
                if (result.value) {
                    vm.createApplication();
                }
            }, function (error) {
                vm.spinner = false;
            });
            vm.spinner = false;
        },
        handleRadioChange: function handleRadioChange(e, index) {
            var vm = this;
            for (var i = 0, _len = vm.licence_categories.length; i < _len; i++) {
                if (i === index) {
                    vm.licence_categories[i].checked = true;
                } else {
                    for (var activity_type_index = 0, len1 = vm.licence_categories[i].activity.length; activity_type_index < len1; activity_type_index++) {
                        if (vm.licence_categories[i].activity[activity_type_index].selected) {
                            vm.licence_categories[i].activity[activity_type_index].selected = false;
                            for (var activity_index = 0, len2 = vm.licence_categories[i].activity[activity_type_index].purpose.length; activity_index < len2; activity_index++) {
                                vm.licence_categories[i].activity[activity_type_index].purpose[activity_index].selected = false;
                                vm.application_fee = 0;
                                vm.licence_fee = 0;
                            }
                        }
                    }
                    vm.licence_categories[i].checked = false;
                }
            }
        },
        handleActivityCheckboxChange: function handleActivityCheckboxChange(index, index1) {
            var vm = this;
            var input = $(vm.$refs.selected_activity_type)[0];
            if (vm.licence_categories[index].activity[index1].selected) {
                for (var activity_index = 0, len2 = vm.licence_categories[index].activity[index1].purpose.length; activity_index < len2; activity_index++) {
                    vm.licence_categories[index].activity[index1].purpose[activity_index].selected = this.isAmendment || this.isRenewal;
                    if (this.isAmendment) {
                        this.application_fee = this.application_fee + vm.licence_categories[index].activity[index1].purpose[activity_index].amendment_application_fee;
                        this.licence_fee = this.licence_fee + vm.licence_categories[index].activity[index1].purpose[activity_index].base_licence_fee;
                    }
                    if (this.isRenewal) {
                        this.application_fee = this.application_fee + vm.licence_categories[index].activity[index1].purpose[activity_index].renewal_application_fee;
                        this.licence_fee = this.licence_fee + vm.licence_categories[index].activity[index1].purpose[activity_index].base_licence_fee;
                    }
                }
            }
        },
        handlePurposeCheckboxChange: function handlePurposeCheckboxChange(index, event) {
            var _this = this;

            var purpose_ids = [].concat.apply([], this.licence_categories[index].activity.map(function (activity) {
                return activity.purpose.filter(function (purpose) {
                    return purpose.selected || purpose.id == event.target.id && event.target.checked;
                });
            })).map(function (purpose) {
                return purpose.id;
            });
            this.$http.post('/api/application/estimate_price/', {
                'purpose_ids': purpose_ids,
                'licence_type': this.selected_apply_licence_select
            }).then(function (res) {
                _this.application_fee = res.body.fees.application;
                _this.licence_fee = res.body.fees.licence;
            }, function (err) {
                console.log(err);
            });
        },
        createApplication: function createApplication() {
            var _this2 = this;

            var vm = this;
            vm.spinner = true;
            var licence_purposes = [];
            var count_total_licence_categories = 0;
            var count_total_activities = 0;
            var count_total_purposes = 0;
            var count_selected_purposes_this_loop = 0;
            var data = new FormData();

            for (var i = 0, _len1 = vm.licence_categories.length; i < _len1; i++) {
                if (vm.licence_categories[i].checked) {
                    for (var j = 0, _len2 = vm.licence_categories[i].activity.length; j < _len2; j++) {
                        if (vm.licence_categories[i].activity[j].selected) {
                            count_selected_purposes_this_loop = 0;

                            for (var k = 0, _len3 = vm.licence_categories[i].activity[j].purpose.length; k < _len3; k++) {
                                if (vm.licence_categories[i].activity[j].purpose[k].selected) {
                                    count_selected_purposes_this_loop++;
                                    count_total_purposes++;

                                    licence_purposes.push(vm.licence_categories[i].activity[j].purpose[k].id);
                                }
                            }

                            if (count_selected_purposes_this_loop > 0) {
                                count_total_activities++;
                            }
                        }
                    }

                    count_total_licence_categories++;
                }
            }

            if (count_total_purposes == 0) {
                swal({
                    title: "Create Application",
                    text: "Please ensure at least one licence purpose is selected",
                    type: "error"
                });
            } else {
                data.organisation_id = vm.selected_apply_org_id;
                data.proxy_id = vm.selected_apply_proxy_id;
                data.application_fee = vm.application_fee;
                data.licence_fee = vm.licence_fee;
                data.licence_purposes = licence_purposes;
                data.application_type = vm.selected_apply_licence_select;
                data.customer_method_id = vm.customer_pay_method;
                data.selected_activity = vm.select_activity;
                data.selected_purpose = vm.select_purpose;
                vm.$http.post('/api/application.json', (0, _stringify2.default)(data), { emulateJSON: true }).then(function (res) {
                    vm.setApplicationWorkflowState({ bool: false });
                    vm.setReceptionMethodId({ pay_method: _this2.customer_pay_method });
                    vm.application = res.body;
                    vm.spinner = false;
                    vm.$router.push({
                        name: "draft_application",
                        params: { application_id: vm.application.id }
                    });
                }, function (err) {
                    console.log(err);
                    vm.spinner = false;
                    swal('Application Error', _hooks.helpers.apiVueResourceError(err), 'error');
                });
            }
        },
        createSelectedPurposeApplication: function createSelectedPurposeApplication() {
            var _this3 = this;

            var vm = this;
            vm.spinner = true;
            var licence_purposes = [vm.select_licence_purpose];
            var data = new FormData();
            data.organisation_id = vm.selected_apply_org_id;
            data.proxy_id = vm.selected_apply_proxy_id;
            data.application_fee = vm.application_fee;
            data.licence_fee = vm.licence_fee;
            data.licence_purposes = licence_purposes;
            data.application_type = vm.selected_apply_licence_select;
            data.customer_method_id = vm.customer_pay_method;
            data.selected_activity = vm.select_activity;
            data.selected_purpose = vm.select_purpose;
            vm.$http.post('/api/application.json', (0, _stringify2.default)(data), { emulateJSON: true }).then(function (res) {
                vm.setApplicationWorkflowState({ bool: false });
                vm.setReceptionMethodId({ pay_method: _this3.customer_pay_method });
                vm.application = res.body;
                vm.spinner = false;
                vm.$router.push({
                    name: "draft_application",
                    params: { application_id: vm.application.id }
                });
            }, function (err) {
                console.log(err);
                vm.spinner = false;
                swal('Application Error', _hooks.helpers.apiVueResourceError(err), 'error');
            });
        },
        setupInitialisers: function setupInitialisers() {
            var _this4 = this;

            var initialisers = [_utils2.default.fetchLicenceAvailablePurposes({
                "application_type": this.selected_apply_licence_select,
                "licence_category": this.licence_category,
                "licence_activity": this.licence_activity,
                "proxy_id": this.selected_apply_proxy_id,
                "organisation_id": this.selected_apply_org_id,
                "licence_no": this.licence_no,
                "select_activity": this.select_activity,
                "select_purpose": this.select_purpose
            }), this.selected_apply_org_id ? _utils2.default.fetchOrganisation(this.selected_apply_org_id) : '', this.selected_apply_proxy_id ? _utils4.default.fetchUser(this.selected_apply_proxy_id) : ''];

            _promise2.default.all(initialisers).then(function (data) {
                _this4.licence_categories = data[0];
                _this4.selected_apply_org_id_details = data[1];
                _this4.selected_apply_proxy_id_details = data[2];
            });
        }
    }),
    mounted: function mounted() {
        if (['amend_activity', 'renew_activity'].includes(this.selected_apply_licence_select)) {
            this.createSelectedPurposeApplication();
        } else {
            this.setupInitialisers();
        }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.loadCurrentUser({ url: '/api/my_user_details' });

            if (vm.selected_apply_licence_select == null || !vm.application_workflow_state) {
                return vm.$router.push({
                    name: "apply_application_organisation"
                });
            }
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(2)))

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var vm = this;
        return {
            "application": null,
            agent: {},
            org_applicant: "",
            organisations: null,

            current_user: {
                wildlifecompliance_organisations: []
            },
            "loading": [],
            form: null,
            pBody: 'pBody' + vm._uid
        };
    },
    components: {},
    computed: {
        isLoading: function isLoading() {
            return this.loading.length > 0;
        },
        org: function org() {
            var vm = this;
            if (vm.org_applicant && !isNaN(vm.org_applicant)) {
                return vm.current_user.wildlifecompliance_organisations.find(function (org) {
                    return parseInt(org.id) === parseInt(vm.org_applicant);
                }).name;
            }
            return '';
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setApplyOrgId', 'setApplicationWorkflowState']), {
        submit: function submit() {
            var vm = this;
            vm.setApplyOrgId({ id: vm.org_applicant });
            vm.setApplicationWorkflowState({ bool: true });
            vm.$router.push({
                name: "apply_application"
            });
        },

        fetchOrgContact: function fetchOrgContact() {
            var vm = this;
            vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, 'get_pending_requests')).then(function (response) {
                vm.orgRequest_pending = response.body;
                vm.loading.splice('fetching pending organisation requests', 1);
            }, function (response) {
                vm.loading.splice('fetching pending organisation requests', 1);
            });
        }
    }),

    mounted: function mounted() {
        var vm = this;
        vm.form = document.forms.new_application;
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var initialisers = [_utils2.default.fetchCurrentUser()];
        _promise2.default.all(initialisers).then(function (data) {
            next(function (vm) {
                vm.current_user = data[0];
            });
        });
    }
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var vm = this;
    return {
      "application": {}
    };
  },
  components: {},
  computed: {},
  methods: {},
  filters: {
    formatDate: function formatDate(data) {
      return data ? moment(data).format('DD/MM/YYYY') : '';
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.form = document.forms.new_application;
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.application = to.params.application;
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _applications_dashboard = __webpack_require__(82);

var _applications_dashboard2 = _interopRequireDefault(_applications_dashboard);

var _licences_dashboard = __webpack_require__(94);

var _licences_dashboard2 = _interopRequireDefault(_licences_dashboard);

var _returns_dashboard = __webpack_require__(95);

var _returns_dashboard2 = _interopRequireDefault(_returns_dashboard);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ExternalDashboard',
    data: function data() {
        var vm = this;
        return {
            applications_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications_paginated, 'external_datatable_list/?format=datatables'),
            licences_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.licences_paginated, 'external_datatable_list/?format=datatables'),
            returns_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.returns_paginated, 'external_datatable_list/?format=datatables'),
            empty_list: '/api/empty_list'
        };
    },

    components: {
        ApplicationDashTable: _applications_dashboard2.default,
        LicenceDashTable: _licences_dashboard2.default,
        ReturnDashTable: _returns_dashboard2.default
    },
    watch: {},
    computed: {},
    methods: {},
    mounted: function mounted() {}
};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _sanction_outcomes_dashboard = __webpack_require__(810);

var _sanction_outcomes_dashboard2 = _interopRequireDefault(_sanction_outcomes_dashboard);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ExternalDashboardSanctionOutcome',
    data: function data() {
        var vm = this;
        return {
            sanction_outcome_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.sanction_outcome_paginated, 'external_datatable_list/?format=datatables'),
            empty_list: '/api/empty_list'
        };
    },

    components: {
        SanctionOutcomeDashTable: _sanction_outcomes_dashboard2.default
    },
    watch: {},
    computed: {},
    methods: {},
    mounted: function mounted() {}
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _api = __webpack_require__(138);

var _api2 = _interopRequireDefault(_api);

var _add_contact = __webpack_require__(129);

var _add_contact2 = _interopRequireDefault(_add_contact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Organisation',
    data: function data() {
        var vm = this;
        return {
            adBody: 'adBody' + vm._uid,
            pBody: 'pBody' + vm._uid,
            cBody: 'cBody' + vm._uid,
            oBody: 'oBody' + vm._uid,
            idBody: 'idBody' + vm._uid,

            org: null,
            myorgperms: null,
            contact_user: {
                first_name: null,
                last_name: null,
                email: null,
                mobile_number: null,
                phone_number: null,
                user_role: {}
            },

            loading: [],
            countries: [],
            updatingDetails: false,
            updatingAddress: false,
            updatingContact: false,
            updatingAcceptUser: false,
            uploadingID: false,
            uploadedID: null,
            logsTable: null,
            DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
            logsDtOptions: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                deferRender: true,
                autowidth: true,
                order: [[2, 'desc']],
                dom: "<'row'<'col-sm-5'l><'col-sm-6'f>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>",
                processing: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.$route.params.org_id + '/action_log'),
                    "dataSrc": ''
                },
                columns: [{
                    data: "who"
                }, {
                    data: "what"
                }, {
                    data: "when",
                    mRender: function mRender(data, type, full) {
                        return moment(data).format(vm.DATE_TIME_FORMAT);
                    }
                }]
            },
            commsDtOptions: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                deferRender: true,
                autowidth: true,
                order: [[0, 'desc']],
                processing: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.$route.params.org_id + '/comms_log'),
                    "dataSrc": ''
                },
                columns: [{
                    title: 'Date',
                    data: 'created',
                    render: function render(date) {
                        return moment(date).format(vm.DATE_TIME_FORMAT);
                    }
                }, {
                    title: 'Type',
                    data: 'type'
                }, {
                    title: 'Reference',
                    data: 'reference'
                }, {
                    title: 'To',
                    data: 'to',
                    render: vm.commaToNewline
                }, {
                    title: 'CC',
                    data: 'cc',
                    render: vm.commaToNewline
                }, {
                    title: 'From',
                    data: 'fromm',
                    render: vm.commaToNewline
                }, {
                    title: 'Subject/Desc.',
                    data: 'subject'
                }, {
                    title: 'Text',
                    data: 'text',
                    'render': function render(value) {
                        var ellipsis = '...',
                            truncated = _.truncate(value, {
                            length: 100,
                            omission: ellipsis,
                            separator: ' '
                        }),
                            result = '<span>' + truncated + '</span>',
                            popTemplate = _.template('<a href="#" ' + 'role="button" ' + 'data-toggle="popover" ' + 'data-trigger="click" ' + 'data-placement="top auto"' + 'data-html="true" ' + 'data-content="<%= text %>" ' + '>more</a>');
                        if (_.endsWith(truncated, ellipsis)) {
                            result += popTemplate({
                                text: value
                            });
                        }

                        return result;
                    },
                    'createdCell': function createdCell(cell) {
                        $(cell).popover();
                    }
                }, {
                    title: 'Documents',
                    data: 'documents',
                    'render': function render(values) {
                        var result = '';
                        _.forEach(values, function (value) {
                            var docName = '',
                                url = '';
                            if (_.isArray(value) && value.length > 1) {
                                docName = value[0];
                                url = value[1];
                            }
                            if (typeof s === 'string') {
                                url = value;

                                docName = _.last(value.split('/'));
                                docName = _.truncate(docName, {
                                    length: 18,
                                    omission: '...',
                                    separator: ' '
                                });
                            }
                            result += '<a href="' + url + '" target="_blank"><p>' + docName + '</p></a><br>';
                        });
                        return result;
                    }
                }]
            },
            commsTable: null,

            contacts_headers: ["Name", "Phone", "Mobile", "Fax", "Email", "Action"],
            contacts_options: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.$route.params.org_id + '/contacts'),
                    "dataSrc": ''
                },
                columns: [{
                    data: 'last_name',
                    mRender: function mRender(data, type, full) {
                        return full.first_name + " " + full.last_name;
                    }
                }, { data: 'phone_number' }, { data: 'mobile_number' }, { data: 'fax_number' }, { data: 'email' }, {
                    data: 'user_status',
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        var name = full.first_name + ' ' + full.last_name;
                        if (full.user_status.id == 'draft') {
                            links += '<a data-email=\'' + full.email + '\' data-name=\'' + name + '\' data-id=\'' + full.id + '\' class="remove-contact">Remove</a><br/>';
                        }
                        return links;
                    }
                }],
                processing: true

            },

            contacts_headers_ref: ["Name", "Role", "Email", "Status", "Action"],
            contacts_options_ref: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.$route.params.org_id + '/contacts_exclude'),
                    "dataSrc": ''
                },
                columns: [{
                    data: 'last_name',
                    mRender: function mRender(data, type, full) {
                        return full.first_name + " " + full.last_name;
                    }
                }, {
                    data: 'user_role',
                    mRender: function mRender(data, type, full) {
                        return full.user_role.name;
                    }
                }, { data: 'email' }, {
                    data: 'user_status',
                    mRender: function mRender(data, type, full) {
                        return full.user_status.name;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        if (vm.myorgperms.is_admin) {
                            if (full.user_status.id == 'pending') {
                                links += '<a data-email=\'' + full.email + '\' data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="accept_contact">Accept</a><br/>';
                                links += '<a data-email=\'' + full.email + '\'  data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="decline_contact">Decline</a><br/>';
                            } else if (full.user_status.id == 'suspended') {
                                links += '<a data-email=\'' + full.email + '\' data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="reinstate_contact">Reinstate</a><br/>';
                            } else if (full.user_status.id == 'active') {
                                links += '<a data-email=\'' + full.email + '\' data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="unlink_contact">Unlink</a><br/>';
                                links += '<a data-email=\'' + full.email + '\'  data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="suspend_contact">Suspend</a><br/>';
                                if (full.user_role.id == 'organisation_user') {
                                    links += '<a data-email=\'' + full.email + '\'  data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="make_admin_contact">Make Organisation Admin</a><br/>';
                                    links += '<a data-email=\'' + full.email + '\'  data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="make_consultant">Make Organisation Consultant</a><br/>';
                                } else if (full.user_role.id == 'organisation_admin') {
                                    links += '<a data-email=\'' + full.email + '\'  data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="make_user_contact">Make Organisation User</a><br/>';
                                    links += '<a data-email=\'' + full.email + '\'  data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="make_consultant">Make Organisation Consultant</a><br/>';
                                } else {
                                    links += '<a data-email=\'' + full.email + '\'  data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="make_admin_contact">Make Organisation Admin</a><br/>';
                                    links += '<a data-email=\'' + full.email + '\'  data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="make_user_contact">Make Organisation User</a><br/>';
                                }
                            } else if (full.user_status.id == 'unlinked') {
                                links += '<a data-email=\'' + full.email + '\'  data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="relink_contact">Reinstate</a><br/>';
                            } else if (full.user_status.id == 'declined') {
                                links += '<a data-email=\'' + full.email + '\'  data-firstname=\'' + full.first_name + '\' data-lastname=\'' + full.last_name + '\' data-id=\'' + full.id + '\' data-mobile=\'' + full.mobile_number + '\' data-phone=\'' + full.phone_number + '\' class="accept_declined_contact">Accept (Previously Declined)</a><br/>';
                            }
                        }
                        return links;
                    }
                }],
                processing: true

            }

        };
    },

    components: {
        datatable: _datatable2.default,
        AddContact: _add_contact2.default
    },

    computed: {
        uploadedIDFileName: function uploadedIDFileName() {
            return this.uploadedID != null ? this.uploadedID.name : '';
        }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var initialisers = [_utils2.default.fetchCountries(), _utils2.default.fetchOrganisation(to.params.org_id), _utils2.default.fetchOrganisationPermissions(to.params.org_id)];
        _promise2.default.all(initialisers).then(function (data) {
            next(function (vm) {
                vm.countries = data[0];
                vm.org = data[1];
                vm.myorgperms = data[2];
                vm.org.address = vm.org.address != null ? vm.org.address : {};
                vm.org.pins = vm.org.pins != null ? vm.org.pins : {};
            });
        });
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var initialisers = [_utils2.default.fetchOrganisation(to.params.org_id), _utils2.default.fetchOrganisationPermissions(to.params.org_id)];
        _promise2.default.all(initialisers).then(function (data) {
            next(function (vm) {
                vm.org = data[0];
                vm.myorgperms = data[1];
                vm.org.address = vm.org.address != null ? vm.org.address : {};
                vm.org.pins = vm.org.pins != null ? vm.org.pins : {};
            });
        });
    },
    methods: {
        addContact: function addContact() {
            this.$refs.add_contact.isModalOpen = true;
        },
        readFileID: function readFileID() {
            var vm = this;
            var _file = null;
            var input = $(vm.$refs.uploadedID)[0];
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = input.files[0];
            }
            vm.uploadedID = _file;
        },
        uploadID: function uploadID() {
            var vm = this;
            vm.uploadingID = true;
            var data = new FormData();
            data.append('identification', vm.uploadedID);
            if (vm.uploadedID == null) {
                vm.uploadingID = false;
                swal({
                    title: 'Upload ID',
                    html: 'Please select a file to upload.',
                    type: 'error'
                });
            } else {
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/upload_id'), data, {
                    emulateJSON: true
                }).then(function (response) {
                    vm.uploadingID = false;
                    vm.uploadedID = null;
                    swal({
                        title: 'Upload ID',
                        html: 'The organisation ID has been successfully uploaded.',
                        type: 'success'
                    }).then(function () {
                        window.location.reload(true);
                    });
                }, function (error) {
                    vm.uploadingID = false;
                    var error_msg = '<br/>';
                    for (var key in error.body) {
                        error_msg += key + ': ' + error.body[key] + '<br/>';
                    }
                    swal({
                        title: 'Upload ID',
                        html: 'There was an error uploading the organisation ID.<br/>' + error_msg,
                        type: 'error'
                    });
                });
            }
        },
        filterOrgContactStatus: function filterOrgContactStatus() {

            t;
        },
        eventListeners: function eventListeners() {
            var vm = this;
            vm.$refs.contacts_datatable.vmDataTable.on('click', '.remove-contact', function (e) {
                e.preventDefault();

                var name = $(e.target).data('name');
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                swal({
                    title: "Delete Contact",
                    text: "Are you sure you want to remove " + name + " (" + email + ") as a contact?",
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.deleteContact(id);
                    }
                }, function (error) {});
            });

            vm.$refs.contacts_datatable_user.vmDataTable.on('click', '.accept_contact', function (e) {
                e.preventDefault();

                var firstname = $(e.target).data('firstname');
                var lastname = $(e.target).data('lastname');
                var name = firstname + ' ' + lastname;
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                var mobile = $(e.target).data('mobile');
                var phone = $(e.target).data('phone');

                vm.contact_user.first_name = firstname;
                vm.contact_user.last_name = lastname;
                vm.contact_user.email = email;
                vm.contact_user.mobile_number = mobile;
                vm.contact_user.phone_number = phone;

                swal({
                    title: "Contact Accept",
                    text: "Are you sure you want to accept contact request " + name + " (" + email + ")?",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/accept_user'), (0, _stringify2.default)(vm.contact_user), {
                            emulateJSON: true
                        }).then(function (response) {
                            swal({
                                title: 'Contact Accept',
                                text: 'You have successfully accepted ' + name + '.',
                                type: 'success',
                                confirmButtonText: 'Okay'
                            }).then(function () {
                                vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                            }, function (error) {});
                        }, function (error) {
                            swal('Contact Accept', 'There was an error accepting ' + name + '.', 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.contacts_datatable_user.vmDataTable.on('click', '.accept_declined_contact', function (e) {
                e.preventDefault();

                var firstname = $(e.target).data('firstname');
                var lastname = $(e.target).data('lastname');
                var name = firstname + ' ' + lastname;
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                var mobile = $(e.target).data('mobile');
                var phone = $(e.target).data('phone');

                vm.contact_user.first_name = firstname;
                vm.contact_user.last_name = lastname;
                vm.contact_user.email = email;
                vm.contact_user.mobile_number = mobile;
                vm.contact_user.phone_number = phone;

                swal({
                    title: "Contact Accept (Previously Declined)",
                    text: "Are you sure you want to accept the previously declined contact request for " + name + " (" + email + ")?",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/accept_declined_user'), (0, _stringify2.default)(vm.contact_user), {
                            emulateJSON: true
                        }).then(function (response) {
                            swal({
                                title: 'Contact Accept (Previously Declined)',
                                text: 'You have successfully accepted ' + name + '.',
                                type: 'success',
                                confirmButtonText: 'Okay'
                            }).then(function () {
                                vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                            }, function (error) {});
                        }, function (error) {
                            swal('Contact Accept (Previously Declined)', 'There was an error accepting ' + name + '.', 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.contacts_datatable_user.vmDataTable.on('click', '.decline_contact', function (e) {
                e.preventDefault();

                var firstname = $(e.target).data('firstname');
                var lastname = $(e.target).data('lastname');
                var name = firstname + ' ' + lastname;
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                var mobile = $(e.target).data('mobile');
                var phone = $(e.target).data('phone');

                vm.contact_user.first_name = firstname;
                vm.contact_user.last_name = lastname;
                vm.contact_user.email = email;
                vm.contact_user.mobile_number = mobile;
                vm.contact_user.phone_number = phone;


                swal({
                    title: "Contact Decline",
                    text: "Are you sure you want to decline the contact request for " + name + " (" + email + ")?",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/decline_user'), (0, _stringify2.default)(vm.contact_user), {
                            emulateJSON: true
                        }).then(function (response) {
                            swal({
                                title: 'Contact Decline',
                                text: 'You have successfully declined ' + name + '.',
                                type: 'success',
                                confirmButtonText: 'Okay'
                            }).then(function () {
                                vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                            }, function (error) {});
                        }, function (error) {
                            swal('Contact Decline', 'There was an error declining ' + name + '.', 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.contacts_datatable_user.vmDataTable.on('click', '.unlink_contact', function (e) {
                e.preventDefault();

                var firstname = $(e.target).data('firstname');
                var lastname = $(e.target).data('lastname');
                var name = firstname + ' ' + lastname;
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                var mobile = $(e.target).data('mobile');
                var phone = $(e.target).data('phone');

                vm.contact_user.first_name = firstname;
                vm.contact_user.last_name = lastname;
                vm.contact_user.email = email;
                vm.contact_user.mobile_number = mobile;
                vm.contact_user.phone_number = phone;

                swal({
                    title: "Unlink",
                    text: "Are you sure you want to unlink " + name + " (" + email + ")?",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/unlink_user'), (0, _stringify2.default)(vm.contact_user), {
                            emulateJSON: true
                        }).then(function (response) {
                            swal({
                                title: 'Unlink',
                                text: 'You have successfully unlinked ' + name + '.',
                                type: 'success',
                                confirmButtonText: 'Okay'
                            }).then(function () {
                                vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                            }, function (error) {});
                        }, function (error) {
                            var error_msg = '<br/>';
                            for (var key in error.body) {
                                if (key == 'non_field_errors') {
                                    error_msg += error.body[key] + '<br/>';
                                }
                            }
                            swal('Unlink User', 'There was an error unlinking ' + name + ' from the Organisation.' + error_msg, 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.contacts_datatable_user.vmDataTable.on('click', '.make_admin_contact', function (e) {
                e.preventDefault();

                var firstname = $(e.target).data('firstname');
                var lastname = $(e.target).data('lastname');
                var name = firstname + ' ' + lastname;
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                var mobile = $(e.target).data('mobile');
                var phone = $(e.target).data('phone');

                vm.contact_user.first_name = firstname;
                vm.contact_user.last_name = lastname;
                vm.contact_user.email = email;
                vm.contact_user.mobile_number = mobile;
                vm.contact_user.phone_number = phone;

                swal({
                    title: "Organisation Admin",
                    text: "Are you sure you want to make " + name + " (" + email + ") an Organisation Admin?",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/make_admin_user'), (0, _stringify2.default)(vm.contact_user), {
                            emulateJSON: true
                        }).then(function (response) {
                            swal({
                                title: 'Organisation Admin',
                                text: 'You have successfully made ' + name + ' an Organisation Admin.',
                                type: 'success',
                                confirmButtonText: 'Okay'
                            }).then(function () {
                                vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                            }, function (error) {});
                        }, function (error) {
                            swal('Organisation Admin', 'There was an error making ' + name + ' an Organisation Admin.', 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.contacts_datatable_user.vmDataTable.on('click', '.make_user_contact', function (e) {
                e.preventDefault();

                var firstname = $(e.target).data('firstname');
                var lastname = $(e.target).data('lastname');
                var name = firstname + ' ' + lastname;
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                var mobile = $(e.target).data('mobile');
                var phone = $(e.target).data('phone');

                vm.contact_user.first_name = firstname;
                vm.contact_user.last_name = lastname;
                vm.contact_user.email = email;
                vm.contact_user.mobile_number = mobile;
                vm.contact_user.phone_number = phone;

                swal({
                    title: "Organisation User",
                    text: "Are you sure you want to make " + name + " (" + email + ") an Organisation User?",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/make_user'), (0, _stringify2.default)(vm.contact_user), {
                            emulateJSON: true
                        }).then(function (response) {
                            swal({
                                title: 'Organisation User',
                                text: 'You have successfully made ' + name + ' an Organisation User.',
                                type: 'success',
                                confirmButtonText: 'Okay'
                            }).then(function () {
                                vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                            }, function (error) {});
                        }, function (error) {
                            var error_msg = '<br/>';
                            for (var key in error.body) {
                                if (key == 'non_field_errors') {
                                    error_msg += error.body[key] + '<br/>';
                                }
                            }
                            swal('Organisation User', 'There was an error making ' + name + ' an Organisation User.' + error_msg, 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.contacts_datatable_user.vmDataTable.on('click', '.suspend_contact', function (e) {
                e.preventDefault();

                var firstname = $(e.target).data('firstname');
                var lastname = $(e.target).data('lastname');
                var name = firstname + ' ' + lastname;
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                var mobile = $(e.target).data('mobile');
                var phone = $(e.target).data('phone');

                vm.contact_user.first_name = firstname;
                vm.contact_user.last_name = lastname;
                vm.contact_user.email = email;
                vm.contact_user.mobile_number = mobile;
                vm.contact_user.phone_number = phone;

                swal({
                    title: "Suspend User",
                    text: "Are you sure you want to Suspend  " + name + " (" + email + ")?",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/suspend_user'), (0, _stringify2.default)(vm.contact_user), {
                            emulateJSON: true
                        }).then(function (response) {
                            swal({
                                title: 'Suspend User',
                                text: 'You have successfully suspended ' + name + ' as a User.',
                                type: 'success',
                                confirmButtonText: 'Okay'
                            }).then(function () {
                                vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                            }, function (error) {});
                        }, function (error) {
                            var error_msg = '<br/>';
                            for (var key in error.body) {
                                if (key == 'non_field_errors') {
                                    error_msg += error.body[key] + '<br/>';
                                }
                            }
                            swal('Suspend User', 'There was an error suspending ' + name + ' as a User.' + error_msg, 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.contacts_datatable_user.vmDataTable.on('click', '.reinstate_contact', function (e) {
                e.preventDefault();

                var firstname = $(e.target).data('firstname');
                var lastname = $(e.target).data('lastname');
                var name = firstname + ' ' + lastname;
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                var mobile = $(e.target).data('mobile');
                var phone = $(e.target).data('phone');

                vm.contact_user.first_name = firstname;
                vm.contact_user.last_name = lastname;
                vm.contact_user.email = email;
                vm.contact_user.mobile_number = mobile;
                vm.contact_user.phone_number = phone;

                swal({
                    title: "Reinstate User",
                    text: "Are you sure you want to Reinstate  " + name + " (" + email + ")?",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/reinstate_user'), (0, _stringify2.default)(vm.contact_user), {
                            emulateJSON: true
                        }).then(function (response) {
                            swal({
                                title: 'Reinstate User',
                                text: 'You have successfully reinstated ' + name + '.',
                                type: 'success',
                                confirmButtonText: 'Okay'
                            }).then(function () {
                                vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                            }, function (error) {});
                        }, function (error) {
                            swal('Reinstate User', 'There was an error reinstating ' + name + '.', 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.contacts_datatable_user.vmDataTable.on('click', '.relink_contact', function (e) {
                e.preventDefault();

                var firstname = $(e.target).data('firstname');
                var lastname = $(e.target).data('lastname');
                var name = firstname + ' ' + lastname;
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                var mobile = $(e.target).data('mobile');
                var phone = $(e.target).data('phone');

                vm.contact_user.first_name = firstname;
                vm.contact_user.last_name = lastname;
                vm.contact_user.email = email;
                vm.contact_user.mobile_number = mobile;
                vm.contact_user.phone_number = phone;

                swal({
                    title: "Relink User",
                    text: "Are you sure you want to Relink  " + name + " (" + email + ")?",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/relink_user'), (0, _stringify2.default)(vm.contact_user), {
                            emulateJSON: true
                        }).then(function (response) {
                            swal({
                                title: 'Relink User',
                                text: 'You have successfully relinked ' + name + '.',
                                type: 'success',
                                confirmButtonText: 'Okay'
                            }).then(function () {
                                vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                            }, function (error) {});
                        }, function (error) {
                            swal('Relink User', 'There was an error relink ' + name + '.', 'error');
                        });
                    }
                }, function (error) {});
            });

            vm.$refs.contacts_datatable_user.vmDataTable.on('click', '.make_consultant', function (e) {
                e.preventDefault();

                var firstname = $(e.target).data('firstname');
                var lastname = $(e.target).data('lastname');
                var name = firstname + ' ' + lastname;
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                var mobile = $(e.target).data('mobile');
                var phone = $(e.target).data('phone');
                var role = 'consultant';

                vm.contact_user.first_name = firstname;
                vm.contact_user.last_name = lastname;
                vm.contact_user.email = email;
                vm.contact_user.mobile_number = mobile;
                vm.contact_user.phone_number = phone;
                vm.contact_user.user_role.id = role;

                swal({
                    title: "Organisation Consultant",
                    text: "Are you sure you want to make " + name + " (" + email + ") an Organisation Consultant?",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/make_consultant'), (0, _stringify2.default)(vm.contact_user), {
                            emulateJSON: true
                        }).then(function (response) {
                            swal({
                                title: 'Organisation Consultant',
                                text: 'You have successfully made ' + name + ' an Organisation Consultant.',
                                type: 'success',
                                confirmButtonText: 'Okay'
                            }).then(function () {
                                vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                            }, function (error) {});
                        }, function (error) {
                            var error_msg = '<br/>';
                            for (var key in error.body) {
                                if (key == 'non_field_errors') {
                                    error_msg += error.body[key] + '<br/>';
                                }
                            }
                            swal('Organisation Consultant', 'There was an error making ' + name + ' an Organisation Consultant.' + error_msg, 'error');
                        });
                    }
                }, function (error) {});
            });
        },
        updateDetails: function updateDetails() {
            var vm = this;
            vm.updatingDetails = true;
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/update_details'), (0, _stringify2.default)(vm.org), {
                emulateJSON: true
            }).then(function (response) {
                vm.updatingDetails = false;
                vm.org = response.body;
                if (vm.org.address == null) {
                    vm.org.address = {};
                }
                swal('Saved', 'Organisation details have been saved.', 'success');
            }, function (error) {
                vm.updatingDetails = false;
            });
        },
        addedContact: function addedContact() {
            var vm = this;
            swal('Added', 'The contact has been successfully added.', 'success');
            vm.$refs.contacts_datatable.vmDataTable.ajax.reload();
        },
        deleteContact: function deleteContact(id) {
            var vm = this;

            vm.$http.delete(_hooks.helpers.add_endpoint_json(_api2.default.organisation_contacts, id), {
                emulateJSON: true
            }).then(function (response) {
                swal('Contact Deleted', 'The contact was successfully deleted.', 'success');
                vm.$refs.contacts_datatable.vmDataTable.ajax.reload();
            }, function (error) {
                swal('Contact Deleted', 'The contact could not be deleted because of the following error: ' + error, 'error');
            });
        },
        updateAddress: function updateAddress() {
            var vm = this;
            vm.updatingAddress = true;
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/update_address'), (0, _stringify2.default)(vm.org.address), {
                emulateJSON: true
            }).then(function (response) {
                vm.updatingAddress = false;
                vm.org = response.body;
                swal('Saved', 'Address details have been saved.', 'success');
                if (vm.org.address == null) {
                    vm.org.address = {};
                }
            }, function (error) {
                vm.updatingAddress = false;
            });
        },
        unlinkUser: function unlinkUser(d) {
            var vm = this;
            var org = vm.org;
            var org_name = org.name;
            var person = _hooks.helpers.copyObject(d);
            swal({
                title: "Unlink From Organisation",
                text: "Are you sure you want to unlink " + person.name + " from " + org.name + "?",
                type: "question",
                showCancelButton: true,
                confirmButtonText: 'Accept'
            }).then(function (result) {
                if (result.value) {
                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, org.id + '/unlink_user'), { 'user': person.id }, {
                        emulateJSON: true
                    }).then(function (response) {
                        vm.org = response.body;
                        if (vm.org.address == null) {
                            vm.org.address = {};
                        }
                        swal({
                            title: 'Unlink',
                            text: 'You have successfully unlinked ' + person.name + ' from ' + org_name + '.',
                            type: 'success',
                            confirmButtonText: 'Okay'
                        }).then(function () {
                            vm.$refs.contacts_datatable_user.vmDataTable.ajax.reload();
                        }, function (error) {});
                    }, function (error) {
                        var error_msg = '<br/>';
                        for (var key in error.body) {
                            if (key == 'non_field_errors') {
                                error_msg += error.body[key] + '<br/>';
                            }
                        }
                        swal('Unlink User', 'There was an error unlinking ' + person.name + ' from the Organisation.' + error_msg, 'error');
                    });
                }
            }, function (error) {});
        }
    },
    mounted: function mounted() {
        this.personal_form = document.forms.personal_form;
    },
    updated: function updated() {
        var _this = this;

        var vm = this;
        $('.panelClicker[data-toggle="collapse"]').on('click', function () {
            var chev = $(this).children()[0];
            window.setTimeout(function () {
                $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
            }, 100);
        });
        this.$nextTick(function () {
            _this.eventListeners();
        });
    }

};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(31), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

__webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'RemediationAction',
    data: function data() {

        return {
            reTab: 'reTab' + this._uid,
            coTab: 'coTab' + this._uid
        };
    },

    components: {
        FormSection: _section_toggle2.default,

        filefield: _compliance_file2.default
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            if (!this.$route.params.remediation_action_id) {
                                _context.next = 4;
                                break;
                            }

                            _context.next = 4;
                            return this.loadRemediationAction({ remediation_action_id: this.$route.params.remediation_action_id });

                        case 4:
                            _context.next = 9;
                            break;

                        case 6:
                            _context.prev = 6;
                            _context.t0 = _context["catch"](0);

                            this.processError(_context.t0);

                        case 9:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 6]]);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('remediationActionStore', {
        remediation_action: "remediation_action"
    }), {
        readonlyForm: function readonlyForm() {
            return !this.remediation_action.action_taken_editable;
        },
        canSaveSubmit: function canSaveSubmit() {
            return this.remediation_action.action_taken_editable;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('remediationActionStore', {
        loadRemediationAction: 'loadRemediationAction',
        saveRemediationAction: 'saveRemediationAction',
        submitRemediationAction: 'submitRemediationAction'
    }), {
        remediationActionDocumentUploaded: function remediationActionDocumentUploaded() {
            console.log('remediationActionDocumentUploaded');
        },
        saveExit: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return this.saveRemediationAction();

                            case 3:
                                _context2.next = 5;
                                return swal("Saved", "The record has been saved", "success");

                            case 5:
                                this.$router.push({ name: 'external-sanction-outcome-dash' });
                                _context2.next = 11;
                                break;

                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2["catch"](0);

                                this.processError(_context2.t0);

                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 8]]);
            }));

            function saveExit() {
                return _ref2.apply(this, arguments);
            }

            return saveExit;
        }(),
        save: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return this.saveRemediationAction();

                            case 3:
                                _context3.next = 5;
                                return swal("Saved", "The record has been saved", "success");

                            case 5:
                                _context3.next = 10;
                                break;

                            case 7:
                                _context3.prev = 7;
                                _context3.t0 = _context3["catch"](0);

                                this.processError(_context3.t0);

                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 7]]);
            }));

            function save() {
                return _ref3.apply(this, arguments);
            }

            return save;
        }(),
        submit: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var user_action;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                console.log('submit');
                                _context4.next = 3;
                                return this.submitRemediationAction();

                            case 3:
                                user_action = _context4.sent;

                                this.$router.push({ name: 'external-remediation-action-submit-success', params: { remediation_action_id: this.remediation_action.id, user_action: user_action } });

                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function submit() {
                return _ref4.apply(this, arguments);
            }

            return submit;
        }(),
        processError: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(err) {
                var errorText, i, _i, field_name, j;

                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                errorText = '';

                                if (err.body.non_field_errors) {
                                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                                        errorText += err.body.non_field_errors[i] + '<br />';
                                    }
                                } else if (Array.isArray(err.body)) {
                                    for (_i = 0; _i < err.body.length; _i++) {
                                        errorText += err.body[_i] + '<br />';
                                    }
                                } else {
                                    for (field_name in err.body) {
                                        if (err.body.hasOwnProperty(field_name)) {
                                            errorText += field_name + ':<br />';
                                            for (j = 0; j < err.body[field_name].length; j++) {
                                                errorText += err.body[field_name][j] + '<br />';
                                            }
                                        }
                                    }
                                }
                                _context5.next = 4;
                                return swal("Error", errorText, "error");

                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function processError(_x) {
                return _ref5.apply(this, arguments);
            }

            return processError;
        }()
    })
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

__webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'RemediationActionSubmitSuccess',
    data: function data() {
        return {
            lodgement_date: null
        };
    },

    components: {},
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            try {
                                if (this.$route.params.user_action) {
                                    this.lodgement_date = this.$route.params.user_action.when;
                                }
                            } catch (err) {
                                this.processError(err);
                            }

                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('remediationActionStore', {
        remediation_action: "remediation_action"
    })),
    methods: {
        processError: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(err) {
                var errorText, i, _i, field_name, j;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                errorText = '';

                                if (err.body.non_field_errors) {
                                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                                        errorText += err.body.non_field_errors[i] + '<br />';
                                    }
                                } else if (Array.isArray(err.body)) {
                                    for (_i = 0; _i < err.body.length; _i++) {
                                        errorText += err.body[_i] + '<br />';
                                    }
                                } else {
                                    for (field_name in err.body) {
                                        if (err.body.hasOwnProperty(field_name)) {
                                            errorText += field_name + ':<br />';
                                            for (j = 0; j < err.body[field_name].length; j++) {
                                                errorText += err.body[field_name][j] + '<br />';
                                            }
                                        }
                                    }
                                }
                                _context2.next = 4;
                                return swal("Error", errorText, "error");

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function processError(_x) {
                return _ref2.apply(this, arguments);
            }

            return processError;
        }()
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _return_amendment = __webpack_require__(329);

var _return_amendment2 = _interopRequireDefault(_return_amendment);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var select2 = __webpack_require__(81);
__webpack_require__(20);
__webpack_require__(19);

exports.default = {
  name: 'externalReturn',
  props: ["table", "data", "grid"],
  data: function data() {
    var vm = this;
    return {
      pdBody: 'pdBody' + vm._uid,
      form: null,
      spreadsheet: null,
      returnBtn: 'Submit',
      nilReturn: 'yes',
      spreadsheetReturn: 'no',
      replaceReturn: 'no',
      readonly: false,
      refresh_grid: true
    };
  },

  components: {
    AmendmentRequestDetails: _return_amendment2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isReturnsLoaded', 'returns', 'is_external', 'species_cache']), {
    uploadedFileName: function uploadedFileName() {
      return this.spreadsheet != null ? this.spreadsheet.name : '';
    },
    isReadOnly: function isReadOnly() {
      this.readonly = this.is_external && this.returns.is_draft ? false : true;
      return this.readonly;
    },
    refreshGrid: function refreshGrid() {
      this.setReturnsEstimateFee();

      this.species_cache[this.returns.species] = this.returns.table[0]['data'];
      return this.refresh_grid;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    load: 'loadReturns'
  }), (0, _vuex.mapActions)(['setReturns', 'setReturnsEstimateFee']), {
    uploadFile: function uploadFile(e) {
      var _file = null;
      var input = $(this.$refs.spreadsheet)[0];
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        reader.onload = function (e) {
          _file = e.target.result;
        };
        _file = input.files[0];
      }
      this.spreadsheet = _file;
      this.validate_upload();
    },
    validate_upload: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(e) {
        var _this = this;

        var _data;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.refresh_grid = false;
                _data = new FormData(this.form);

                _data.append('spreadsheet', this.spreadsheet);
                _context.next = 5;
                return this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.returns.id + '/upload_details'), _data, {
                  emulateJSON: true
                }).then(function (response) {
                  if (_this.replaceReturn === 'no') {
                    var idx1 = _this.returns.table[0]['data'].length;
                    for (var idx2 = 0; idx2 < response.body[0]['data'].length; idx2++) {
                      _this.returns.table[0]['data'][idx1++] = response.body[0]['data'][idx2];
                    }
                  }
                  if (_this.replaceReturn === 'yes') {
                    _this.returns.table[0]['data'] = response.body[0]['data'];
                    _this.replaceReturn = 'no';
                  }
                  _this.species_cache[_this.returns.species] = _this.returns.table[0]['data'];
                  _this.nilReturn = 'no';
                  _this.spreadsheetReturn = 'yes';
                  _this.refresh_grid = true;
                }, function (exception) {
                  swal('Error Uploading', exception.body.error, 'error');
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validate_upload(_x) {
        return _ref.apply(this, arguments);
      }

      return validate_upload;
    }(),
    getSpecies: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_id) {
        var _this2 = this;

        var specie_id;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                specie_id = _id;


                if (this.species_cache[this.returns.species] == null) {
                  this.species_cache[this.returns.species] = this.returns.table[0]['data'];
                }

                if (!(this.species_cache[specie_id] != null)) {
                  _context2.next = 7;
                  break;
                }

                this.returns.table[0]['data'] = this.species_cache[specie_id];
                this.setGridDate(specie_id);

                _context2.next = 11;
                break;

              case 7:
                this.refresh_grid = false;
                this.returns.species = specie_id;
                _context2.next = 11;
                return this.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.returns.id + '/species_data_details/?species_id=' + specie_id + '&')).then(function (response) {
                  _this2.returns.table[0]['data'] = response.body[0]['data'];
                }, function (exception) {

                  swal('Error with Species data', exception.body.error, 'error');
                });

              case 11:
                ;
                this.replaceReturn = 'no';
                this.nilReturn = 'no';
                this.spreadsheetReturn = 'no';
                this.returns.species = specie_id;
                this.refresh_grid = true;
                return _context2.abrupt('return');

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSpecies(_x2) {
        return _ref2.apply(this, arguments);
      }

      return getSpecies;
    }(),
    setGridDate: function setGridDate(_id) {
      var specie_id = _id;
      for (var r = 0; r < this.species_cache[specie_id].length; r++) {
        var val = 'date' + '::' + r;
        if ($('[id=\'' + val + '\']')[0]) {
          $('[id=\'' + val + '\']')[0].value = this.species_cache[specie_id][r]['date']['value'];
        } else {
          break;
        }
      }
    },
    initialiseSpeciesSelect: function initialiseSpeciesSelect() {
      var reinit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var vm = this;
      if (reinit) {
        $(vm.$refs.selected_species).data('select2') ? $(vm.$refs.selected_species).select2('destroy') : '';
      }

      $(vm.$refs.selected_species).select2({
        theme: "bootstrap",
        allowClear: true,
        placeholder: "Select..."
      }).on("select2:select", function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var selected = $(e.currentTarget);
        vm.getSpecies(selected.val());
      });
    },
    eventListeners: function eventListeners() {
      var vm = this;
      this.initialiseSpeciesSelect();
      this.getSpecies(this.returns.species);
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.form = document.forms.enter_return;
      _this3.readonly = !_this3.is_external;

      if (_this3.returns.table[0]) {
        _this3.nilReturn = 'no';
        _this3.spreadsheetReturn = 'no';
        _this3.replaceReturn = 'no';
      }

      _this3.eventListeners();
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _return_amendment = __webpack_require__(329);

var _return_amendment2 = _interopRequireDefault(_return_amendment);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'externalReturnQuestion',
  data: function data() {
    var vm = this;
    return {
      pdBody: 'pdBody' + vm._uid
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isReturnsLoaded', 'returns', 'is_external'])),
  components: {
    AmendmentRequestDetails: _return_amendment2.default
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    load: 'loadReturns'
  }), (0, _vuex.mapActions)(['setReturns']))
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(145);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(142);

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _values = __webpack_require__(143);

var _values2 = _interopRequireDefault(_values);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _returns_form = __webpack_require__(132);

var _returns_form2 = _interopRequireDefault(_returns_form);

var _vuex = __webpack_require__(6);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _enter_return_sheet_entry = __webpack_require__(824);

var _enter_return_sheet_entry2 = _interopRequireDefault(_enter_return_sheet_entry);

var _hooks = __webpack_require__(3);

__webpack_require__(349);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'externalReturnSheet',
  props: {
    url: {
      type: String,
      required: false
    }
  },
  data: function data() {
    var vm = this;
    return {
      pdBody: 'pdBody' + vm._uid,
      datatable_id: 'return-datatable',
      form: null,
      filterActivityType: 'All',
      readonly: false,
      isModalOpen: false,
      sheetTitle: null,
      specie_selection: '',
      sheet_total: 0,
      sheet_activity_type: [],
      sheet_headers: ["order", "Entry Date", "Activity", "Date", "Qty", "Total", "Action", "Supplier", "Comments"],
      sheet_options: {
        language: {
          processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
        },
        responsive: true,
        ajax: {
          url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, 'sheet_details'),
          dataSrc: '',
          type: 'GET',
          data: function data(_data) {
            _data.return_id = vm.returns.id;
            _data.species_id = vm.returns.sheet_species;
            return _data;
          }
        },
        columnDefs: [{ visible: false, targets: [0, 7, 8] }],
        columns: [{ data: "date" }, { data: "date",
          className: "pay-row-icon",
          mRender: function mRender(data, type, full) {
            var _date = new Date(parseInt(full.date));
            return _date.toLocaleString("en-GB");
          }
        }, { data: "activity",
          mRender: function mRender(data, type, full) {
            return vm.returns.sheet_activity_list[data]['label'];
          }
        }, { data: "doa" }, { data: "qty" }, { data: "total" }, { data: "transfer",
          mRender: function mRender(data, type, full) {
            if (full.activity && (vm.returns.can_current_user_edit || vm.returns.user_in_officers) && !vm.isTrue(vm.returns.sheet_activity_list[full.activity]['auto']) && (full.transfer === 'Notified' || full.transfer === '')) {
              var column = '<a class="edit-row" data-rowid="__ROWID__">Edit</a><br/>';
              column = column.replace(/__ROWID__/g, full.rowId);
              return column;
            }
            if (full.activity && (full.transfer === 'Accepted' || full.transfer === 'Declined')) {
              return full.transfer;
            }
            if (full.activity && vm.is_external && vm.isTrue(vm.returns.sheet_activity_list[full.activity]['auto']) && full.transfer === 'Notified') {
              var accept = '<a class="accept-row" data-rowid="__ROWID__">Accept</a> or ';
              accept = accept.replace(/__ROWID__/g, full.rowId);
              var decline = '<a class="decline-row" data-rowid="__ROWID__">Decline</a><br/>';
              decline = decline.replace(/__ROWID__/g, full.rowId);
              return accept + decline;
            } else {
              return "";
            }
          }
        }, { data: "supplier" }, { data: "comment" }],
        order: [0, 'desc'],
        rowCallback: function rowCallback(row, data) {
          (0, _jquery2.default)(row).addClass('payRecordRow');
        },
        drawCallback: function drawCallback() {
          if ((vm.specie_selection === '' || null) && (0, _values2.default)(vm.returns.species_saved).length === 0) {
            vm.specie_selection = document.getElementById("species_selector").options[document.getElementById("species_selector").selectedIndex].textContent;
          } else {
            vm.specie_selection = vm.species_list[vm.returns.sheet_species];
          }
          vm.sheetTitle = vm.specie_selection;
        },
        footerCallback: function footerCallback(row, data, start, end, display) {
          var api = this.api(),
              data;
          vm.sheet_total = api.column(5).data()[0];
        },
        processing: true,
        ordering: true,
        rowId: function rowId(_data) {
          return _data.rowId;
        },
        initComplete: function initComplete() {
          if (vm.$refs.return_datatable.vmDataTable.ajax.json().length > 0) {
            vm.species_cache[vm.returns.sheet_species] = vm.$refs.return_datatable.vmDataTable.ajax.json();
          }

          var activityColumn = vm.$refs.return_datatable.vmDataTable.columns(2);
          activityColumn.data().unique().sort().each(function (d, j) {
            var activityTitles = [];
            _jquery2.default.each(d, function (index, a) {
              a != null && activityTitles.indexOf(vm.returns.sheet_activity_list[a]) < 0 ? activityTitles.push(vm.returns.sheet_activity_list[a]) : '';
            });
            vm.sheet_activity_type = activityTitles;
          });
        }
      }
    };
  },

  components: {
    SheetEntry: _enter_return_sheet_entry2.default,
    datatable: _datatable2.default,
    Returns: _returns_form2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isReturnsLoaded', 'returns', 'species_list', 'species_cache', 'is_external', 'species_transfer'])),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setReturns', 'setReturnsSpecies', 'setSpeciesCache']), {
    isTrue: function isTrue(_value) {
      return _value === 'true';
    },
    intVal: function intVal(_value) {
      return typeof _value === 'string' ? _value.replace(/[\$,]/g, '') * 1 : typeof _value === 'number' ? _value : 0;
    },
    addSheetRow: function addSheetRow() {
      if (document.getElementById("species_selector").value === '' || null) {
        swal('Select Specie', 'Please select a specie before adding a new entry.', 'error');
      } else {
        var self = this;
        var rows = self.$refs.return_datatable.vmDataTable;
        self.$refs.sheet_entry.entryActivity = (0, _keys2.default)(self.returns.sheet_activity_list)[0];
        if (rows.data().length < 1) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(self.returns.sheet_activity_list)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                  key = _step$value[0],
                  value = _step$value[1];

              self.$refs.sheet_entry.entryActivity = key === 'stock' ? key : self.$refs.sheet_entry.entryActivity;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        self.$refs.sheet_entry.isAddEntry = true;
        self.$refs.sheet_entry.return_table = rows;
        self.$refs.sheet_entry.row_of_data = rows;
        self.$refs.sheet_entry.activityList = self.returns.sheet_activity_list;
        self.$refs.sheet_entry.speciesType = self.returns.sheet_species;
        self.$refs.sheet_entry.entrySpecies = self.sheetTitle;
        self.$refs.sheet_entry.entryTotal = self.sheet_total;
        self.$refs.sheet_entry.currentStock = self.sheet_total;
        self.$refs.sheet_entry.initialQty = '0';
        self.$refs.sheet_entry.entryQty = '0';
        self.$refs.sheet_entry.entryComment = '';
        self.$refs.sheet_entry.entryLicence = '';
        self.$refs.sheet_entry.entryDateTime = '';
        self.$refs.sheet_entry.entryActivityDate = '';
        self.$refs.sheet_entry.entrySupplier = '';
        self.$refs.sheet_entry.isSubmitable = true;
        self.$refs.sheet_entry.isModalOpen = true;
      }
    },
    addEventListeners: function addEventListeners() {
      var vm = this;

      vm.$refs.return_datatable.vmDataTable.on('click', '.edit-row', function (e) {
        e.preventDefault();
        vm.$refs.sheet_entry.isChangeEntry = true;
        vm.$refs.sheet_entry.activityList = vm.returns.sheet_activity_list;
        vm.$refs.sheet_entry.speciesType = vm.returns.sheet_species;
        vm.$refs.sheet_entry.return_table = vm.$refs.return_datatable.vmDataTable;
        vm.$refs.sheet_entry.row_of_data = vm.$refs.return_datatable.vmDataTable.row('#' + (0, _jquery2.default)(this).attr('data-rowid'));
        vm.$refs.sheet_entry.entrySpecies = vm.sheetTitle;
        vm.$refs.sheet_entry.entryDateTime = vm.$refs.sheet_entry.row_of_data.data().date;
        vm.$refs.sheet_entry.entryActivity = vm.$refs.sheet_entry.row_of_data.data().activity;
        vm.$refs.sheet_entry.entryActivityDate = vm.$refs.sheet_entry.row_of_data.data().doa;
        vm.$refs.sheet_entry.entryQty = vm.$refs.sheet_entry.row_of_data.data().qty;
        vm.$refs.sheet_entry.initialQty = vm.$refs.sheet_entry.row_of_data.data().qty;
        vm.$refs.sheet_entry.entryTotal = vm.$refs.sheet_entry.row_of_data.data().total;
        vm.$refs.sheet_entry.currentStock = vm.$refs.sheet_entry.row_of_data.data().total;
        vm.$refs.sheet_entry.entryComment = vm.$refs.sheet_entry.row_of_data.data().comment;
        vm.$refs.sheet_entry.entryLicence = vm.$refs.sheet_entry.row_of_data.data().licence;
        vm.$refs.sheet_entry.entryTransfer = vm.$refs.sheet_entry.row_of_data.data().transfer;
        vm.$refs.sheet_entry.entrySupplier = vm.$refs.sheet_entry.row_of_data.data().supplier;

        vm.species_cache[vm.returns.sheet_species] = vm.$refs.return_datatable.vmDataTable.data();

        vm.$refs.sheet_entry.isSubmitable = true;
        vm.$refs.sheet_entry.isModalOpen = true;
        vm.$refs.sheet_entry.errors = false;
      });

      vm.$refs.return_datatable.vmDataTable.on('click', '.accept-row', function (e) {
        e.preventDefault();
        var selected = vm.$refs.return_datatable.vmDataTable.row('#' + (0, _jquery2.default)(this).attr('data-rowid'));
        var rows = vm.$refs.return_datatable.vmDataTable.data();
        for (var i = 0; i < rows.length; i++) {
          if (vm.intVal(rows[i].date) >= vm.intVal(selected.data().date)) {
            rows[i].total = vm.intVal(rows[i].total) + vm.intVal(selected.data().qty);
          }
          if (vm.intVal(rows[i].date) == vm.intVal(selected.data().date)) {
            rows[i].transfer = 'Accepted';

            var transfer = {};
            if (vm.returns.sheet_species in vm.species_transfer) {
              transfer = vm.species_transfer[vm.returns.sheet_species];
            }
            transfer[rows[i].date] = (0, _assign2.default)({}, rows[i]);
            transfer[rows[i].date].species_id = vm.returns.sheet_species;
            vm.species_transfer[vm.returns.sheet_species] = transfer;
          }
        }
        vm.species_cache[vm.returns.sheet_species] = vm.$refs.return_datatable.vmDataTable.data();
        vm.$refs.return_datatable.vmDataTable.clear().draw();
        vm.$refs.return_datatable.vmDataTable.rows.add(vm.species_cache[vm.returns.sheet_species]);
        vm.$refs.return_datatable.vmDataTable.draw();
      });

      vm.$refs.return_datatable.vmDataTable.on('click', '.decline-row', function (e) {
        e.preventDefault();
        var selected = vm.$refs.return_datatable.vmDataTable.row('#' + (0, _jquery2.default)(this).attr('data-rowid'));
        var rows = vm.$refs.return_datatable.vmDataTable.data();
        for (var i = 0; i < rows.length; i++) {
          if (vm.intVal(rows[i].date) == vm.intVal(selected.data().date)) {
            rows[i].transfer = 'Declined';

            var transfer = {};
            if (vm.returns.sheet_species in vm.species_transfer) {
              transfer = vm.species_transfer[vm.returns.sheet_species];
            }
            transfer[rows[i].date] = (0, _assign2.default)({}, rows[i]);
            transfer[rows[i].date].species_id = vm.returns.sheet_species;
            vm.species_transfer[vm.returns.sheet_species] = transfer;
          }
        }
        vm.species_cache[vm.returns.sheet_species] = vm.$refs.return_datatable.vmDataTable.data();
        vm.$refs.return_datatable.vmDataTable.clear().draw();
        vm.$refs.return_datatable.vmDataTable.rows.add(vm.species_cache[vm.returns.sheet_species]);
        vm.$refs.return_datatable.vmDataTable.draw();
      });

      vm.$refs.return_datatable.vmDataTable.on('click', 'tr.payRecordRow', function (e) {
        if ((0, _jquery2.default)(e.target).is('a')) {
          return;
        }

        var tr = (0, _jquery2.default)(this);
        var row = vm.$refs.return_datatable.vmDataTable.row(tr);
        var row_data = row.data();
        var return_id = row_data.id;


        if (row.child.isShown()) {
          row.child.hide();
          tr.removeClass('shown');
        } else {
          var child_row = '';

          var activity_rows = '';

          child_row += '\n                  <table class="table table-bordered child-row-table">\n                      ';
          child_row += '<tr>\n                          <td class="width_15pc"><strong>Name of Supplier/Recipient:&nbsp;</strong></td>\n                          <td>' + row.data()['supplier'] + '</td>\n                      </tr>';

          child_row += '<tr>\n                          <td class="width_15pc"><strong>Keeper, Import or Export <br/> Licence number:&nbsp;</strong></td>\n                          <td>' + row.data()['licence'] + '</td>\n                      </tr>';

          child_row += '<tr>\n                          <td class="width_15pc"><strong>Comments:&nbsp;</strong></td>\n                          <td>' + row.data()['comment'] + '</td>\n                      </tr>';

          child_row += '</table>';

          row.child(child_row, 'dark-row').show();
          tr.addClass('shown');
        }
      });

      vm.setSpeciesSelector();
      vm.setActivityFilterSelector();
    },
    setFilterActivityType: function setFilterActivityType(value) {
      var table = this.$refs.return_datatable.vmDataTable;
      value = value != 'All' ? value : '';
      table.column(2).search(value).draw();
    },
    getSheetSpecies: function getSheetSpecies(selected_species) {
      var self = this;
      self.setSheetSpecies(selected_species);
      self.returns.species = selected_species;
      (0, _jquery2.default)(self.$refs.species_selector).val(selected_species);
      (0, _jquery2.default)(self.$refs.species_selector).trigger('change');
    },
    setSheetSpecies: function setSheetSpecies(selected_species) {
      var vm = this;
      var selected_id = selected_species;
      if (vm.species_cache[vm.returns.sheet_species] == null && vm.$refs.return_datatable.vmDataTable.ajax.json().length > 0) {
        vm.species_cache[vm.returns.sheet_species] = vm.$refs.return_datatable.vmDataTable.ajax.json();
      }
      vm.returns.sheet_species = selected_id;
      if (vm.species_cache[selected_id] != null) {
        vm.$refs.return_datatable.vmDataTable.clear().draw();
        vm.$refs.return_datatable.vmDataTable.rows.add(vm.species_cache[selected_id]);
        vm.$refs.return_datatable.vmDataTable.draw();
      } else {
        vm.$refs.return_datatable.vmDataTable.clear().draw();
        vm.$refs.return_datatable.vmDataTable.ajax.url = _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, 'sheet_details');
        vm.$refs.return_datatable.vmDataTable.ajax.reload();
      };
    },
    setSpeciesSelector: function setSpeciesSelector() {
      var vm = this;

      (0, _jquery2.default)(vm.$refs.species_selector).select2({
        "theme": "bootstrap",
        minimumInputLength: 2,
        placeholder: "Select Species..."
      }).on("select2:select", function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var selected = (0, _jquery2.default)(e.currentTarget);
        var selected_species = selected.val();
        vm.setSheetSpecies(selected_species);
      });
    },
    setActivityFilterSelector: function setActivityFilterSelector() {
      var vm = this;

      (0, _jquery2.default)(vm.$refs.activity_filter_selector).select2({
        "theme": "bootstrap"
      }).on("select2:select", function (e) {
        var selected = (0, _jquery2.default)(e.currentTarget);
        var filter = selected.val();
        vm.setFilterActivityType(filter);
      });
    }
  }),
  created: function created() {
    this.form = document.forms.enter_return_sheet;
    this.readonly = !(this.is_external || this.returns.user_in_officers) || !this.returns.is_draft;
    this.select_species_list = this.species_list;
  },
  mounted: function mounted() {
    var vm = this;
    this.$nextTick(function () {
      vm.addEventListeners();
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

__webpack_require__(349);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'externalReturnSheetEntry',
  components: {
    modal: _bootstrapModal2.default,
    alert: _alert2.default
  },
  props: {
    return_id: {
      type: Number
    }
  },
  data: function data() {
    return {
      isModalOpen: false,
      form: null,
      errors: false,
      errorString: '',
      validation_form: null,
      successString: '',
      success: false,
      entrySpecies: '',
      entryDateTime: '',
      entryActivityDate: '',
      entryActivity: '0',
      entryQty: 0,
      entryTotal: 0,
      entryLicence: '',
      entryComment: '',
      entryTransfer: '',
      entrySupplier: '',
      currentStock: 0,
      speciesType: '',
      row_of_data: null,
      return_table: null,
      table: null,
      isAddEntry: false,
      isChangeEntry: false,
      activityList: { '0': { 'label': null, 'licence': false, 'pay': false } },
      initialQty: 0,
      datepickerOptions: {
        format: 'DD/MM/YYYY',
        showClear: true,
        useCurrent: false,
        keepInvalid: true,
        allowInputToggle: true
      },
      missing_fields: [],
      incorrect_entry: []
    };
  },
  watch: {
    entryQty: function entryQty(value) {
      this.addToStock(value);
    },
    entryActivity: function entryActivity(value) {
      this.addToStock(this.entryQty);
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['species_cache', 'returns', 'species_transfer']), {
    showError: function showError() {
      return this.errors;
    },
    title: function title() {
      return this.entrySpecies + '   Current stock: ' + this.entryTotal;
    },
    isLicenceRequired: function isLicenceRequired() {
      return this.returns.sheet_activity_list[this.entryActivity]['licence'] === 'true';
    },
    isPayable: function isPayable() {
      return this.returns.sheet_activity_list[this.entryActivity]['pay'] === 'true';
    },
    isStockEntry: function isStockEntry() {
      return this.entryActivity === 'stock' ? true : false;
    },
    filteredActivityList: function filteredActivityList() {
      var filteredList = (0, _assign2.default)({}, this.activityList);
      if (filteredList['stock'] && !this.isStockEntry) {
        delete filteredList['stock'];
      }

      return filteredList;
    }
  }),
  methods: {
    isOutStock: function isOutStock(activity) {
      return 'outward' in this.returns.sheet_activity_list[activity] ? true : false;
    },
    isInStock: function isInStock(activity) {
      return 'inward' in this.returns.sheet_activity_list[activity] ? true : false;
    },
    isStock: function isStock(activity) {
      return 'initial' in this.returns.sheet_activity_list[activity] ? true : false;
    },
    addToStock: function addToStock(value) {
      this.entryTotal = this.currentStock !== '' ? parseInt(this.currentStock) : 0;
      if (this.isInStock(this.entryActivity)) {
        this.entryTotal = parseInt(this.entryTotal) + parseInt(value) - parseInt(this.initialQty);
      };
      if (this.isStock(this.entryActivity)) {
        this.entryTotal = parseInt(value);
      };
      if (this.isOutStock(this.entryActivity)) {
        this.entryTotal = parseInt(this.entryTotal) - parseInt(value) + parseInt(this.initialQty);
      };
      if (this.isLicenceRequired || this.entryActivity === '0') {
        this.entryTotal = parseInt(this.currentStock);
      };
    },
    addToList: function addToList() {},
    update: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self, is_valid, is_correct, _currentDateTime, newRowId, _data, species_name;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;
                _context.next = 3;
                return this.validateMissingFields();

              case 3:
                is_valid = _context.sent;
                _context.next = 6;
                return this.validateUserEntries();

              case 6:
                is_correct = _context.sent;

                if (!(!is_valid | !is_correct)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return');

              case 9:

                if (self.isAddEntry) {
                  _currentDateTime = new Date();

                  self.entryDateTime = Date.parse(new Date());
                  newRowId = self.row_of_data.data().count() + '';
                  _data = { rowId: newRowId,
                    date: self.entryDateTime,
                    activity: self.entryActivity,
                    qty: self.entryQty,
                    total: self.entryTotal,
                    comment: self.entryComment,
                    licence: self.entryLicence,
                    transfer: self.entryTransfer,
                    supplier: self.entrySupplier,
                    doa: self.entryActivityDate
                  };


                  if (self.isLicenceRequired) {

                    if (self.validateTransfer(_data)) {
                      self.close();
                    }
                  } else {

                    self.row_of_data.row.add(_data).node().id = newRowId;
                    self.row_of_data.draw();
                    self.species_cache[self.returns.sheet_species] = self.return_table.data();
                    species_name = '[NOT SAVED] ' + self.returns.species_list[self.returns.sheet_species];

                    self.returns.species_saved[self.returns.sheet_species] = species_name;
                    self.returns.species = self.returns.sheet_species;

                    self.close();
                  }
                };

                if (self.isChangeEntry) {
                  _data = self.row_of_data.data();

                  _data.activity = self.entryActivity;
                  _data.qty = self.entryQty;
                  _data.total = self.entryTotal;
                  _data.licence = self.entryLicence;
                  _data.comment = self.entryComment;
                  _data.transfer = self.entryTransfer;
                  _data.supplier = self.entrySupplier;
                  _data.doa = self.entryActivityDate;

                  if (self.isLicenceRequired) {

                    if (self.validateTransfer(_data)) {
                      self.close();
                    }
                  } else {

                    self.adjustTotals();
                    self.row_of_data.invalidate().draw();
                    self.species_cache[self.returns.sheet_species] = self.return_table.data();
                    self.close();
                  }
                };

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function update() {
        return _ref.apply(this, arguments);
      }

      return update;
    }(),
    validateMissingFields: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var is_valid, missing_field, _missing_field, top;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                is_valid = true;


                this.missing_fields.length = 0;
                _context2.next = 4;
                return this.highlightMissingFields();

              case 4:

                if (this.entryActivityDate === '') {
                  missing_field = {
                    label: 'Activity Date',
                    name: 'activityDateToPicker'
                  };

                  this.missing_fields.push(missing_field);
                  is_valid = false;
                }
                if (this.entryActivity === '0') {
                  _missing_field = {
                    label: 'Activity'
                  };

                  this.missing_fields.push(_missing_field);
                  is_valid = false;
                }
                this.highlightMissingFields();
                top = ($('#error').offset() || { "top": NaN }).top;

                $('html, body').animate({
                  scrollTop: top
                }, 1);

                return _context2.abrupt('return', is_valid);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function validateMissingFields() {
        return _ref2.apply(this, arguments);
      }

      return validateMissingFields;
    }(),
    highlightMissingFields: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, missing_field, top;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                $('.missing-field').removeClass('missing-field');
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 4;
                for (_iterator = (0, _getIterator3.default)(this.missing_fields); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  missing_field = _step.value;

                  $('[name=' + missing_field.name).addClass('missing-field');
                }

                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 12:
                _context3.prev = 12;
                _context3.prev = 13;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 15:
                _context3.prev = 15;

                if (!_didIteratorError) {
                  _context3.next = 18;
                  break;
                }

                throw _iteratorError;

              case 18:
                return _context3.finish(15);

              case 19:
                return _context3.finish(12);

              case 20:
                top = ($('#error').offset() || { "top": NaN }).top;

                $('html, body').animate({
                  scrollTop: top
                }, 1);

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 8, 12, 20], [13,, 15, 19]]);
      }));

      function highlightMissingFields() {
        return _ref3.apply(this, arguments);
      }

      return highlightMissingFields;
    }(),
    check_and_pay: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var self, data, is_valid_transfer, _currentDateTime, newRowId, _data;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = this;

                self.form = document.forms.external_returns_form;
                data = new FormData(self.form);
                is_valid_transfer = false;

                if (!self.isAddEntry) {
                  _context4.next = 22;
                  break;
                }

                _currentDateTime = new Date();

                self.entryDateTime = Date.parse(new Date());
                newRowId = self.row_of_data.data().count() + '';
                _data = { rowId: newRowId,
                  date: self.entryDateTime,
                  activity: self.entryActivity,
                  qty: self.entryQty,
                  total: self.entryTotal,
                  comment: self.entryComment,
                  licence: self.entryLicence,
                  transfer: self.entryTransfer,
                  supplier: self.entrySupplier
                };

                if (!self.isLicenceRequired) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 12;
                return self.validateTransfer(_data);

              case 12:
                is_valid_transfer = _context4.sent;
                _context4.next = 15;
                return self.payTransfer(_data);

              case 15:
                is_paid = _context4.sent;
                _context4.next = 22;
                break;

              case 18:

                self.row_of_data.row.add(_data).node().id = newRowId;
                self.row_of_data.draw();
                self.species_cache[self.returns.sheet_species] = self.return_table.data();
                self.close();

              case 22:
                ;

              case 23:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function check_and_pay() {
        return _ref4.apply(this, arguments);
      }

      return check_and_pay;
    }(),
    payTransfer: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(_data) {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.returns.id + '/sheet_pay_transfer'), _data, {
                  emulateJSON: true
                }).then(function (response) {
                  window.location.href = "/ledger/checkout/checkout/payment-details/";
                }, function (error) {
                  console.log(error);
                  swal('Error', 'There was an error with transferring.<br/>' + error.body, 'error');
                });

                return _context5.abrupt('return', true);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function payTransfer(_x) {
        return _ref5.apply(this, arguments);
      }

      return payTransfer;
    }(),
    validateTransfer: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(row_data) {
        var self, is_valid, data;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                self = this;

                self.form = document.forms.external_returns_form;
                self.errors = false;
                is_valid = false;
                data = new FormData(self.form);

                row_data['species_id'] = self.returns.sheet_species;
                row_data['transfer'] = 'Notified';
                data.append('transfer', (0, _stringify2.default)(row_data));
                self.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, self.returns.id + '/sheet_check_transfer'), data, {
                  emulateJSON: true
                }).then(function (response) {

                  if (self.isAddEntry) {

                    self.row_of_data.row.add(row_data).node().id = row_data.rowId;
                    self.row_of_data.draw();
                    self.species_cache[self.returns.sheet_species] = self.return_table.data();
                  } else {

                    self.row_of_data.data().activity = self.entryActivity;
                    self.row_of_data.data().qty = self.entryQty;
                    self.row_of_data.data().total = self.entryTotal;
                    self.row_of_data.data().licence = self.entryLicence;
                    self.row_of_data.data().comment = self.entryComment;
                    self.row_of_data.data().transfer = self.entryTransfer;
                    self.row_of_data.data().supplier = self.entrySupplier;
                    self.row_of_data.invalidate().draw();
                    self.species_cache[self.returns.sheet_species] = self.return_table.data();
                  }

                  var transfer = {};
                  if (self.returns.sheet_species in self.species_transfer) {
                    transfer = self.species_transfer[self.returns.sheet_species];
                  }
                  transfer[self.entryDateTime] = row_data;
                  self.species_transfer[self.returns.sheet_species] = transfer;

                  is_valid = true;
                }, function (error) {
                  console.log(error);
                  self.errors = true;

                  self.errorString = 'Error with Validation';
                });
                return _context6.abrupt('return', is_valid);

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function validateTransfer(_x2) {
        return _ref6.apply(this, arguments);
      }

      return validateTransfer;
    }(),
    cancel: function cancel() {
      var self = this;
      self.errors = false;
      self.close();
    },
    adjustTotals: function adjustTotals() {
      var self = this;
      if (parseInt(self.entryQty) === parseInt(self.initialQty)) {
        return true;
      }
      var rows = self.species_cache[self.returns.sheet_species];
      for (var i = 0; i < rows.length; i++) {
        if (parseInt(rows[i].date) > parseInt(self.entryDateTime)) {

          if (this.isStock(self.entryActivity)) {
            rows[i].total = parseInt(rows[i].total) + (parseInt(self.entryQty) - parseInt(self.currentStock));
          } else if (self.entryActivity.includes('in')) {
            rows[i].total = parseInt(rows[i].total) + (parseInt(self.entryQty) - parseInt(self.initialQty));
          } else if (self.entryActivity.includes('out')) {
            rows[i].total = parseInt(rows[i].total) - (parseInt(self.entryQty) - parseInt(self.initialQty));
          }
        }
      }
      self.species_cache[self.returns.sheet_species] = rows;
      self.row_of_data.clear().draw();
      self.row_of_data.rows.add(self.species_cache[self.returns.sheet_species]);
      self.row_of_data.draw();
    },
    close: function close() {
      var self = this;
      if (!self.errors) {
        self.isChangeEntry = false;
        self.isAddEntry = false;
        self.isModalOpen = false;
      }
    },
    addFormValidations: function addFormValidations() {
      var vm = this;
      vm.validation_form = $(vm.form).validate({
        rules: {
          reason: "required"

        },
        messages: {
          reason: "field is required"

        },
        showErrors: function showErrors(errorMap, errorList) {
          $.each(this.validElements(), function (index, element) {
            var $element = $(element);
            $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
          });

          $("." + this.settings.validClass).tooltip("destroy");

          for (var i = 0; i < errorList.length; i++) {
            var error = errorList[i];
            $(error.element).tooltip({
              trigger: "focus"
            }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
          }
        }
      });
    },
    validateUserEntries: function () {
      var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
        var is_correct, incorrect_entry, _incorrect_entry, top;

        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                is_correct = true;


                this.incorrect_entry.length = 0;
                _context7.next = 4;
                return this.highlightMissingFields();

              case 4:

                if (this.entryQty < 0) {
                  incorrect_entry = {
                    label: 'Re-enter Quantity',
                    message: 'Please enter a positive number for Quantity.'
                  };

                  this.incorrect_entry.push(incorrect_entry);
                  is_correct = false;
                }
                if (this.entryActivity.includes('out') && parseInt(this.currentStock) - parseInt(this.entryQty) < 0) {
                  _incorrect_entry = {
                    label: 'Incorrect Quantity',
                    message: 'Please enter Quantity less than or equal to Current Stock.'
                  };

                  this.incorrect_entry.push(_incorrect_entry);
                  is_correct = false;
                }
                this.highlightMissingFields();
                top = ($('#error').offset() || { "top": NaN }).top;

                $('html, body').animate({
                  scrollTop: top
                }, 1);

                return _context7.abrupt('return', is_correct);

              case 10:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function validateUserEntries() {
        return _ref7.apply(this, arguments);
      }

      return validateUserEntries;
    }(),

    initDatePicker: function initDatePicker() {
      var vm = this;
      $(vm.$refs.activityDateToPicker).datetimepicker(vm.datepickerOptions);
      $('#entryActivityDate').blur(function (e) {
        vm.entryActivityDate = $(this).val();
      });
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.form = document.forms.sheetEntryForm;
    vm.addFormValidations();
    vm.initDatePicker();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _returns_form = __webpack_require__(132);

var _returns_form2 = _interopRequireDefault(_returns_form);

var _enter_return_sheet = __webpack_require__(328);

var _enter_return_sheet2 = _interopRequireDefault(_enter_return_sheet);

var _enter_return_question = __webpack_require__(327);

var _enter_return_question2 = _interopRequireDefault(_enter_return_question);

var _enter_return = __webpack_require__(326);

var _enter_return2 = _interopRequireDefault(_enter_return);

var _return_submit = __webpack_require__(826);

var _return_submit2 = _interopRequireDefault(_return_submit);

var _vuex = __webpack_require__(6);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'externalReturn',
  data: function data() {
    return {
      pdBody: 'pdBody' + self._uid,
      estimated_fee: 0,
      spinner_exit: false,
      spinner_submit: false,
      spinner_continue: false,
      disable_submit: false,
      disable_exit: false,
      disable_continue: false,
      panelClickersInitialised: false
    };
  },

  components: {
    Returns: _returns_form2.default,
    ReturnSheet: _enter_return_sheet2.default,
    ReturnQuestion: _enter_return_question2.default,
    ReturnData: _enter_return2.default,
    ReturnSubmit: _return_submit2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isReturnsLoaded', 'returns', 'species_list', 'species_cache', 'species_transfer', 'selected_returns_tab_id', 'returns_estimate_fee']), {
    isSubmittable: function isSubmittable() {
      var submittable = ['Due', 'Overdue'];
      var can_submit = submittable.indexOf(this.returns.processing_status) > -1;

      return can_submit && this.returns.format !== 'sheet' && !this.isPayable;
    },
    isPayable: function isPayable() {
      this.setReturnsEstimateFee();
      return this.returns_estimate_fee > 0;
    },

    requiresCheckout: function requiresCheckout() {
      return this.returns.return_fee > 0 && ['draft', 'awaiting_payment'];
    },
    showButtons: function showButtons() {
      return this.selected_returns_tab_id === 0 && this.returns.is_draft;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    load: 'loadReturns'
  }), (0, _vuex.mapActions)(['setReturns', 'setReturnsExternal', 'setReturnsEstimateFee']), {
    get_table_data: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self, data, speciesID, _speciesJSON, i, speciesJSON, cnt, _loop, _speciesID;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;

                self.is_saving = true;
                self.form = document.forms.external_returns_form;
                data = new FormData(self.form);

                for (speciesID in self.species_cache) {
                  _speciesJSON = [];

                  for (i = 0; i < self.species_cache[speciesID].length; i++) {
                    _speciesJSON[i] = self.species_cache[speciesID][i];
                  }
                  data.append(speciesID, (0, _stringify2.default)(_speciesJSON));
                };
                speciesJSON = [];
                cnt = 0;

                _loop = function _loop(_speciesID) {
                  (0, _keys2.default)(self.species_transfer[_speciesID]).forEach(function (key) {
                    speciesJSON[cnt] = (0, _stringify2.default)(self.species_transfer[_speciesID][key]);
                    cnt++;
                  });
                  data.append('transfer', speciesJSON);
                };

                for (_speciesID in self.species_transfer) {
                  _loop(_speciesID);
                }
                return _context.abrupt('return', data);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get_table_data() {
        return _ref.apply(this, arguments);
      }

      return get_table_data;
    }(),
    save: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(andContinue) {
        var _this = this;

        var self, data, speciesID, _speciesJSON2, i, speciesJSON, cnt, _loop2, _speciesID2;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = this;

                self.is_saving = true;
                self.disable_submit = true;
                self.disable_exit = true;
                self.disable_continue = true;
                self.spinner_exit = !andContinue;
                self.spinner_continue = andContinue;
                self.form = document.forms.external_returns_form;
                data = new FormData(self.form);

                for (speciesID in self.species_cache) {
                  _speciesJSON2 = [];

                  for (i = 0; i < self.species_cache[speciesID].length; i++) {
                    _speciesJSON2[i] = self.species_cache[speciesID][i];
                  }
                  data.append(speciesID, (0, _stringify2.default)(_speciesJSON2));
                };
                speciesJSON = [];
                cnt = 0;

                _loop2 = function _loop2(_speciesID2) {
                  (0, _keys2.default)(self.species_transfer[_speciesID2]).forEach(function (key) {
                    speciesJSON[cnt] = (0, _stringify2.default)(self.species_transfer[_speciesID2][key]);
                    cnt++;
                  });
                  data.append('transfer', speciesJSON);
                };

                for (_speciesID2 in self.species_transfer) {
                  _loop2(_speciesID2);
                }
                _context2.next = 17;
                return self.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, self.returns.id + '/save'), data, {
                  emulateJSON: true
                }).then(function (response) {
                  var species_id = self.returns.sheet_species;
                  self.setReturns(response.body);
                  self.returns.sheet_species = species_id;
                  self.returns.species = species_id;
                  self.is_saving = false;
                  self.disable_submit = false;
                  self.disable_exit = false;
                  self.disable_continue = false;
                  self.spinner_exit = false;
                  self.spinner_continue = false;
                  if (andContinue) {

                    swal('Save', 'Return Details Saved', 'success');
                  } else {

                    _this.$router.push({ name: "external-applications-dash" });
                  }
                }, function (error) {
                  self.is_saving = false;
                  self.disable_submit = false;
                  self.disable_exit = false;
                  self.disable_continue = false;
                  self.spinner_exit = false;
                  self.spinner_continue = false;
                  console.log(error);
                  swal('Error', 'There was an error saving your return details.<br/>' + error.body, 'error');
                });

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function save(_x) {
        return _ref2.apply(this, arguments);
      }

      return save;
    }(),
    save_and_submit: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(e) {
        var _this2 = this;

        var self, data;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = this;

                self.disable_continue = true;
                self.disable_exit = true;
                self.disable_submit = true;
                self.spinner_submit = true;
                _context3.next = 7;
                return self.get_table_data();

              case 7:
                data = _context3.sent;
                _context3.next = 10;
                return self.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, self.returns.id + '/save_and_submit'), data, {
                  emulateJSON: true
                }).then(function (response) {
                  self.disable_submit = false;
                  self.disable_exit = false;
                  self.disable_continue = false;
                  self.spinner_submit = false;
                  _this2.$router.push({ name: "external-applications-dash" });
                }, function (error) {
                  self.disable_exit = false;
                  self.disable_submit = false;
                  self.disable_continue = false;
                  self.spinner_submit = false;
                  console.log(error);
                  swal('Error', 'There was an error saving and submitting your return details.<br/>' + error.body, 'error');
                });

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function save_and_submit(_x2) {
        return _ref3.apply(this, arguments);
      }

      return save_and_submit;
    }(),
    submit: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(e) {
        var _this3 = this;

        var self;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = this;

                self.disable_continue = true;
                self.disable_exit = true;
                self.disable_submit = true;
                self.spinner_exit = true;
                self.spinner_submit = true;
                self.form = document.forms.external_returns_form;
                self.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, self.returns.id + '/submit'), {
                  emulateJSON: true
                }).then(function (response) {
                  var species_id = self.returns.sheet_species;
                  self.setReturns(response.body);
                  self.returns.sheet_species = species_id;
                  self.disable_continue = false;
                  self.disable_exit = false;
                  self.disable_submit = false;
                  self.spinner_exit = false;
                  self.spinner_submit = false;
                  _this3.$router.push({ name: "external-applications-dash" });
                }, function (error) {
                  self.disable_continue = false;
                  self.disable_exit = false;
                  self.disable_submit = false;
                  self.spinner_exit = false;
                  self.spinner_submit = false;
                  console.log(error);
                  swal('Error', 'There was an error submitting your return details.<br/>' + error.body, 'error');
                });

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function submit(_x3) {
        return _ref4.apply(this, arguments);
      }

      return submit;
    }(),
    submit_and_checkout: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(e) {
        var self;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                self = this;

                self.disable_continue = true;
                self.disable_exit = true;
                self.disable_submit = true;
                self.spinner_exit = true;
                self.spinner_submit = true;
                self.form = document.forms.external_returns_form;
                _context5.next = 9;
                return self.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, self.returns.id + '/submit_and_checkout'), {
                  emulateJSON: true
                }).then(function (response) {
                  self.disable_continue = false;
                  self.disable_exit = false;
                  self.disable_submit = false;
                  self.spinner_exit = false;
                  self.spinner_submit = false;

                  window.location.href = "/ledger/checkout/checkout/payment-details/";
                }, function (error) {
                  self.disable_continue = false;
                  self.disable_exit = false;
                  self.disable_submit = false;
                  self.spinner_exit = false;
                  self.spinner_submit = false;
                  console.log(error);
                  swal('Error', 'There was an error submitting your return details.<br/>' + error.body, 'error');
                });

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function submit_and_checkout(_x4) {
        return _ref5.apply(this, arguments);
      }

      return submit_and_checkout;
    }()
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.load({ url: '/api/returns/' + to.params.return_id + '.json' });
      vm.setReturnsExternal({ 'external': true });
    });
  },
  updated: function updated() {
    var self = this;
    if (!self.panelClickersInitialised) {
      $('.panelClicker[data-toggle="collapse"]').on('click', function () {
        var chev = $(this).children()[0];
        window.setTimeout(function () {
          $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
        }, 100);
      });
      self.panelClickersInitialised = true;
    }
  },
  mounted: function mounted() {}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(2)))

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _helpers = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'returns-amendment-details',
  data: function data() {
    var vm = this;
    return {
      returnsAmendBody: 'returnsAmendBody' + vm._uid
    };
  },
  props: {},
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isReturnsLoaded', 'returns']), {
    isVisible: function isVisible() {
      return true;
    },
    visibleRequests: function visibleRequests() {
      return this.returns.amendment_requests;
    }
  }),
  methods: {
    splitText: _helpers.splitText
  }
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ReturnConfirmation',
  data: function data() {
    var vm = this;
    return {
      pdBody: 'pdBody' + vm._uid
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isReturnsLoaded', 'returns'])),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    load: 'loadReturns'
  }), (0, _vuex.mapActions)(['setReturns'])),
  filters: {
    formatDate: function formatDate(data) {
      return data ? moment(data).format('DD/MM/YYYY') : '';
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _bootstrap = __webpack_require__(101);

var _bootstrap2 = _interopRequireDefault(_bootstrap);

__webpack_require__(67);

var _renderer = __webpack_require__(808);

var _renderer2 = _interopRequireDefault(_renderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(15);
__webpack_require__(165);
__webpack_require__(100);
exports.default = {
    components: {
        RendererForm: _renderer2.default
    },
    props: {
        withSectionsSelector: {
            type: Boolean,
            default: true
        },
        form_width: {
            type: String,
            default: 'col-md-9'
        }
    }
};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _helpers = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'amendment-request-details',
    data: function data() {
        return {};
    },
    props: {
        activity_id: {
            type: Number,
            required: true
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application_readonly', 'amendment_requests', 'selected_activity_tab_id', 'isApplicationLoaded']), {
        isVisible: function isVisible() {
            return this.activity_id == this.selected_activity_tab_id;
        },
        visibleRequests: function visibleRequests() {
            var _this = this;

            return this.amendment_requests.filter(function (request) {
                return request.licence_activity.id == _this.activity_id;
            });
        }
    }),
    methods: {
        splitText: _helpers.splitText
    }
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['name', 'label', 'field_data', 'group', 'id', 'help_text', 'help_text_url', 'conditions', "handleChange", "readonly", "isRequired"],
  components: { HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },
  data: function data() {
    var vm = this;
    if (vm.readonly) {
      return { isClickable: "return false;" };
    } else {
      return { isClickable: "return true;" };
    }
  },
  computed: {
    isChecked: function isChecked() {
      return this.value == 'on';
    },
    options: function options() {
      return (0, _stringify2.default)(this.conditions);
    },
    value: function value() {
      return this.field_data.value;
    }
  },
  mounted: function mounted() {
    var vm = this;
    if (vm.isChecked) {
      var input = this.$refs.Checkbox;
      var e = document.createEvent('HTMLEvents');
      e.initEvent('change', true, true);

      if (vm.readonly) {
        vm.isClickable = "return false;";
      } else {
        vm.isClickable = "return true;";
      }
      input.dispatchEvent(e);
    }
  }
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(139);

exports.default = {
    props: {
        "name": {
            type: String
        },
        "question": {
            type: String
        },
        "field_data": {
            type: Object,
            required: true
        },
        "readonly": {
            type: Boolean,
            default: false
        },
        "id": {
            type: String
        },
        "isRequired": {
            type: Boolean,
            default: false
        },
        "commentType": {
            type: String,
            default: _constants.COMMENT_TYPE_OFFICER
        }
    },
    computed: {
        labelText: function labelText() {
            switch (this.commentType) {
                case _constants.COMMENT_TYPE_OFFICER:
                    return 'Officer Comments';
                    break;
                case _constants.COMMENT_TYPE_ASSESSOR:
                    return 'Assessor Comments';
                    break;
                case _constants.COMMENT_TYPE_DEFICIENCY:
                    return 'Deficiency';
                    break;
            }
        },
        value: {
            get: function get() {
                switch (this.commentType) {
                    case _constants.COMMENT_TYPE_OFFICER:
                        return this.field_data.officer_comment;
                        break;
                    case _constants.COMMENT_TYPE_ASSESSOR:
                        return this.field_data.assessor_comment;
                        break;
                    case _constants.COMMENT_TYPE_DEFICIENCY:
                        return this.field_data.deficiency_value;
                        break;
                }
            },
            set: function set(value) {
                switch (this.commentType) {
                    case _constants.COMMENT_TYPE_OFFICER:
                        this.field_data.officer_comment = value;
                        break;
                    case _constants.COMMENT_TYPE_ASSESSOR:
                        this.field_data.assessor_comment = value;
                        break;
                    case _constants.COMMENT_TYPE_DEFICIENCY:
                        this.field_data.deficiency_value = value;
                        break;
                }
            }
        }
    }
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

__webpack_require__(67);

var _constants = __webpack_require__(139);

var _comment = __webpack_require__(827);

var _comment2 = _interopRequireDefault(_comment);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentBlock = {
    props: {
        label: {
            type: String | null,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        field_data: {
            type: Object | null,
            required: true
        }
    },
    components: {
        Comment: _comment2.default
    },
    data: function data() {
        var _showingCommentTypes;

        return {
            showingCommentTypes: (_showingCommentTypes = {}, (0, _defineProperty3.default)(_showingCommentTypes, _constants.COMMENT_TYPE_OFFICER, false), (0, _defineProperty3.default)(_showingCommentTypes, _constants.COMMENT_TYPE_ASSESSOR, false), (0, _defineProperty3.default)(_showingCommentTypes, _constants.COMMENT_TYPE_DEFICIENCY, false), _showingCommentTypes),
            COMMENT_TYPE_OFFICER: _constants.COMMENT_TYPE_OFFICER,
            COMMENT_TYPE_ASSESSOR: _constants.COMMENT_TYPE_ASSESSOR,
            COMMENT_TYPE_DEFICIENCY: _constants.COMMENT_TYPE_DEFICIENCY
        };
    },

    methods: {
        showingComment: function showingComment(comment_type) {
            return this.showingCommentTypes[comment_type];
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['canViewComments', 'canViewDeficiencies', 'canEditDeficiencies', 'selected_activity_tab_id', 'canAssignOfficerFor', 'canAssignAssessorFor']), {
        toggleComment: function toggleComment() {
            var _this = this;

            return function (comment_type) {
                _this.showingCommentTypes[comment_type] = !_this.showingCommentTypes[comment_type];
            };
        },
        canEditOfficerComments: function canEditOfficerComments() {
            return this.canEditDeficiencies;
        },
        canEditAssessorComments: function canEditAssessorComments() {
            return this.canAssignAssessorFor(this.selected_activity_tab_id);
        }
    })
};

exports.default = CommentBlock;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'conditions',
    props: ["conditions", "name", "data", "readonly", "instance"],
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isComponentVisible']), {
        has_conditions: function has_conditions() {
            return this.condition_keys.length;
        },
        condition_keys: function condition_keys() {
            if (this.conditions == null) {
                return [];
            }
            return (0, _keys2.default)(this.conditions);
        }
    }),
    methods: {
        conditionBlocks: function conditionBlocks(key) {
            return this.conditions[key] ? this.conditions[key] : [];
        },
        isVisible: function isVisible(condition) {
            return this.isComponentVisible('cons_' + this.name + '_' + condition);
        }
    }
};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _vuex = __webpack_require__(6);

__webpack_require__(348);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpanderTable = {
    props: {
        name: String,
        label: String,
        id: String,
        isRequired: String,
        help_text: String,
        help_text_url: String,
        component: {
            type: Object | null,
            required: true
        },
        field_data: {
            type: Object | null,
            required: true
        },
        readonly: Boolean
    },
    components: {
        CommentBlock: _comment_block2.default,
        HelpText: _help_text2.default,
        HelpTextUrl: _help_text_url2.default
    },
    data: function data() {
        return {
            expanded: {}
        };
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['removeFormInstance', 'setFormValue', 'refreshApplicationFees']), {
        isExpanded: function isExpanded(tableId) {
            return this.expanded[tableId];
        },
        toggleTableVisibility: function toggleTableVisibility(tableId) {
            if (this.expanded[tableId]) {
                this.$delete(this.expanded, tableId);
            } else {
                this.$set(this.expanded, tableId, true);
            }
        },
        removeTable: function removeTable(tableId) {
            if (this.expanded[tableId]) {
                this.$delete(this.expanded, tableId);
            }
            this.removeFormInstance(this.getInstanceName(tableId));
            this.updateVisibleTables(this.existingTables.filter(function (table) {
                return table != tableId;
            }));
            this.refreshApplicationFees();
        },
        addNewTable: function addNewTable() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var tableId = params.tableId;

            if (!tableId) {
                tableId = this.getTableId(this.lastTableId + 1);
            }
            this.existingTables.push(tableId);
            this.updateVisibleTables(this.existingTables);
            this.refreshApplicationFees();
        },
        updateVisibleTables: function updateVisibleTables(tableList) {
            this.setFormValue({
                key: this.component.name,
                value: {
                    "value": tableList
                }
            });
        },
        getTableId: function getTableId(tableIdx) {
            return this.id + '_table_' + tableIdx;
        },
        getInstanceName: function getInstanceName(tableId) {
            return '__instance-' + tableId;
        },
        removeLabel: function removeLabel(header) {
            var newHeader = (0, _extends3.default)({}, header);
            delete newHeader['label'];
            return newHeader;
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['canViewComments', 'canViewDeficiencies', 'canEditDeficiencies', 'getFormValue']), {
        lastTableId: function lastTableId() {
            if (!this.existingTables.length) {
                return 0;
            }
            var lastId = 0;
            this.existingTables.map(function (tableId) {
                return tableId[tableId.length - 1] > lastId && (lastId = tableId[tableId.length - 1]);
            });
            return parseInt(lastId, 10);
        },
        existingTables: function existingTables() {
            return this.getFormValue(this.component.name) || [];
        },
        expanderTables: function expanderTables() {
            if (!this.existingTables.length) {
                this.addNewTable();
            }
            return this.existingTables;
        },
        value: function value() {
            return this.field_data;
        }
    })
};

exports.default = ExpanderTable;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'conditions',
    props: ["conditions", "name", "data", "readonly", "instance"],
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isComponentVisible']), {
        has_conditions: function has_conditions() {
            return this.condition_keys.length;
        },
        condition_keys: function condition_keys() {
            if (this.conditions == null) {
                return [];
            }
            return (0, _keys2.default)(this.conditions);
        }
    }),
    methods: {
        conditionBlocks: function conditionBlocks(key) {
            return this.conditions[key] ? this.conditions[key] : [];
        },
        isVisible: function isVisible(condition) {
            return this.isComponentVisible('cons_' + this.name + '_' + condition);
        }
    }
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _datetimepicker = __webpack_require__(168);

var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["name", "label", "id", "readonly", "help_text", "field_data", "conditions", "handleChange", "isRequired", "help_text_url", "isTableField"],
    data: function data() {
        return {};
    },

    components: { CommentBlock: _comment_block2.default, HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['canViewComments', 'canViewDeficiencies', 'canEditDeficiencies']), {
        isChecked: function isChecked() {
            return false;
        },
        options: function options() {
            return (0, _stringify2.default)(this.conditions);
        },
        value: {
            get: function get() {
                return this.field_data.value;
            },
            set: function set(value) {
                this.field_data.value = value;
            }
        }
    }),
    methods: {},
    mounted: function mounted() {
        var _this = this;

        $('[name=' + this.name + ']').datetimepicker({
            format: 'DD/MM/YYYY'
        }).off('dp.change').on('dp.change', function (e) {
            if ($('[name=\'' + _this.name + '\']').data('DateTimePicker') && $('[name=\'' + _this.name + '\']').data('DateTimePicker').date()) {
                _this.value = $(e.target).data('DateTimePicker').date().format('DD/MM/YYYY');
            } else if ($('[name=\'' + _this.name + '\']').data('date') === "") {
                _this.value = "";
            } else {
                _this.value = "";
            }
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['name', 'label', 'id', 'help_text', "handleDeclaration", "isRequired", "help_text_url"],
    computed: {
        isChecked: function isChecked() {
            return this.value == 'on';
        }
    },
    mounted: function mounted() {
        var vm = this;
        if (vm.isChecked) {
            var input = this.$refs.Checkbox;
            var e = document.createEvent('HTMLEvents');
            e.initEvent('change', true, true);
            input.dispatchEvent(e);
        }
    }
};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _vuex = __webpack_require__(6);

__webpack_require__(348);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpanderTable = {
    props: {
        name: String,
        label: String,
        id: String,
        isRequired: String,
        help_text: String,
        help_text_url: String,
        component: {
            type: Object | null,
            required: true
        },
        field_data: {
            type: Object | null,
            required: true
        },
        readonly: Boolean
    },
    components: {
        CommentBlock: _comment_block2.default,
        HelpText: _help_text2.default,
        HelpTextUrl: _help_text_url2.default
    },
    data: function data() {
        return {
            expanded: {}
        };
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['removeFormInstance', 'setFormValue', 'refreshApplicationFees']), {
        isExpanded: function isExpanded(tableId) {
            return this.expanded[tableId];
        },
        toggleTableVisibility: function toggleTableVisibility(tableId) {
            if (this.expanded[tableId]) {
                this.$delete(this.expanded, tableId);
            } else {
                this.$set(this.expanded, tableId, true);
            }
        },
        removeTable: function removeTable(tableId) {
            if (this.expanded[tableId]) {
                this.$delete(this.expanded, tableId);
            }
            this.removeFormInstance(this.getInstanceName(tableId));
            this.updateVisibleTables(this.existingTables.filter(function (table) {
                return table != tableId;
            }));
        },
        addNewTable: function addNewTable() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var tableId = params.tableId;

            if (!tableId) {
                tableId = this.getTableId(this.lastTableId + 1);
            }
            this.existingTables.push(tableId);
            this.updateVisibleTables(this.existingTables);
        },
        updateVisibleTables: function updateVisibleTables(tableList) {
            this.setFormValue({
                key: this.component.name,
                value: {
                    "value": tableList
                }
            });
        },
        getTableId: function getTableId(tableIdx) {
            return this.id + '_table_' + tableIdx;
        },
        getInstanceName: function getInstanceName(tableId) {
            return '__instance-' + tableId;
        },
        removeLabel: function removeLabel(header) {
            var newHeader = (0, _extends3.default)({}, header);
            delete newHeader['label'];
            return newHeader;
        },
        getColXSValue: function getColXSValue(colSize) {
            var fixedValue = this.component.header.length > 4 ? 2 : Math.floor(12 / this.component.header.length);
            var hasNullSize = this.component.header.some(function (obj) {
                return obj.colSize ? obj.colSize === null : true;
            });
            if (hasNullSize) {
                return fixedValue;
            }
            return colSize;
        }
    }),
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['canViewComments', 'canViewDeficiencies', 'canEditDeficiencies', 'getFormValue']), {
        lastTableId: function lastTableId() {
            if (!this.existingTables.length) {
                return 0;
            }
            var lastId = 0;
            this.existingTables.map(function (tableId) {
                return tableId[tableId.length - 1] > lastId && (lastId = tableId[tableId.length - 1]);
            });
            return parseInt(lastId, 10);
        },
        existingTables: function existingTables() {
            return this.getFormValue(this.component.name) || [];
        },
        expanderTables: function expanderTables() {
            if (!this.existingTables.length) {
                this.addNewTable();
            }
            return this.existingTables;
        },
        value: function value() {
            return this.field_data;
        },
        showExpanderIcon: function showExpanderIcon() {
            return false;
        },
        tableClass: function tableClass() {
            var class_name = this.component.header.length > 6 ? "horizontal-scrollable" : "no-scroll-background";
            return class_name;
        }
    })
};

exports.default = ExpanderTable;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _hooks = __webpack_require__(3);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        application_id: null,
        name: String,
        label: String,
        id: String,
        isRequired: String,
        help_text: String,
        field_data: Object,
        fileTypes: {
            default: function _default() {
                var file_types = "image/*," + "video/*," + "audio/*," + "application/pdf,text/csv,application/msword,application/vnd.ms-excel,application/x-msaccess," + "application/x-7z-compressed,application/x-bzip,application/x-bzip2,application/zip," + ".dbf,.gdb,.gpx,.prj,.shp,.shx," + ".json,.kml,.gpx";
                return file_types;
            }
        },
        isRepeatable: Boolean,
        readonly: Boolean,
        docsUrl: String,
        help_text_url: String,
        isTableField: Boolean
    },
    components: { CommentBlock: _comment_block2.default, HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },
    data: function data() {
        return {
            repeat: 1,
            files: [],
            show_spinner: false,
            documents: [],
            filename: null
        };
    },
    computed: {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie('csrftoken');
        },
        application_document_action: function application_document_action() {
            return this.application_id ? '/api/application/' + this.application_id + '/process_document/' : '';
        },
        value: function value() {
            return this.field_data.value;
        },
        getClass: function getClass() {
            var file_class = this.isTableField ? "file-class" : "";
            return file_class;
        }
    },

    methods: {
        handleChange: function handleChange(e) {
            var vm = this;

            vm.show_spinner = true;
            if (vm.isRepeatable) {
                var el = $(e.target).attr('data-que');
                var avail = $('input[name=' + e.target.name + ']');

                var avail_map = $('input[name=' + e.target.name + ']');
                avail = [];
                $.map(avail_map, function (val, i) {
                    avail.push($(avail_map[i]).attr('data-que'));
                });

                avail.pop();
                if (vm.repeat == 1) {
                    vm.repeat += 1;
                } else {
                    if (avail.indexOf(el) < 0) {
                        vm.repeat += 1;
                    }
                }
                $(e.target).css({ 'display': 'none' });
            } else {
                vm.files = [];
            }
            vm.files.push(e.target.files[0]);

            if (e.target.files.length > 0) {
                vm.save_document(e);
            }

            vm.show_spinner = false;
        },
        truncatedName: function truncatedName(name) {
            if (name.length > 10) {
                return name.substring(0, 6) + '...';
            } else {
                return name;
            }
        },

        get_documents: function get_documents() {
            var vm = this;

            var formData = new FormData();
            formData.append('action', 'list');
            formData.append('input_name', vm.name);
            formData.append('csrfmiddlewaretoken', vm.csrf_token);
            vm.$http.post(vm.application_document_action, formData).then(function (res) {
                vm.documents = res.body;

                vm.show_spinner = false;
            });
        },

        delete_document: function delete_document(file) {
            var vm = this;
            vm.show_spinner = true;

            var formData = new FormData();
            formData.append('action', 'delete');
            formData.append('document_id', file.id);
            formData.append('csrfmiddlewaretoken', vm.csrf_token);

            vm.$http.post(vm.application_document_action, formData).then(function (res) {
                vm.documents = vm.get_documents();

                vm.show_spinner = false;
            });
        },

        uploadFile: function uploadFile(e) {
            var vm = this;
            var _file = null;

            if (e.target.files && e.target.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(e.target.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = e.target.files[0];
            }
            return _file;
        },


        save_document: function save_document(e) {
            var vm = this;

            var formData = new FormData();
            formData.append('action', 'save');
            formData.append('application_id', vm.application_id);
            formData.append('input_name', vm.name);
            formData.append('filename', e.target.files[0].name);
            formData.append('_file', vm.uploadFile(e));
            formData.append('csrfmiddlewaretoken', vm.csrf_token);

            vm.$http.post(vm.application_document_action, formData).then(function (res) {
                vm.documents = res.body;
            }, function (err) {});
        },

        num_documents: function num_documents() {
            var vm = this;
            if (vm.documents) {
                return vm.documents.length;
            }
            return 0;
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.documents = vm.get_documents();
        if (vm.value) {
            if (Array.isArray(vm.value)) {
                vm.value;
            } else {
                var file_names = vm.value.replace(/ /g, '_').split(",");
                vm.files = file_names.map(function (file_name) {
                    return { name: file_name };
                });
            }
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _datetimepicker = __webpack_require__(168);

var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridBlock = {
  props: ['field_data', 'headers', 'name', 'label', 'id', 'help_text', 'help_text_url', 'readonly', 'isRequired'],
  components: { HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default, CommentBlock: _comment_block2.default },
  data: function data() {
    var grid_item = [{ 'id': 0, 'name': '', 'value': '' }];
    return {
      show_add_row: false
    };
  },
  computed: {
    getDeficiencyField: function getDeficiencyField() {
      var def = this.field_data[0][this.name + '-deficiency-field'];
      if (def == null) {
        return { 'deficiency-value': null };
      }
      return this.field_data[0][this.name + '-deficiency-field'];
    },
    showAddRow: function showAddRow() {
      return this.show_add_row;
    }
  },
  methods: {
    addRow: function addRow(e) {
      var self = this;
      self.grid_item = self._props['field_data'];
      var index = self.grid_item.length;
      var fieldObj = (0, _assign2.default)({}, self.grid_item[0]);

      for (var key in fieldObj) {
        fieldObj[key] = { 'value': '', 'error': '' };
      };
      self.grid_item.push(fieldObj);
    },
    addColumn: function addColumn(e) {},
    addArea: function addArea(e) {},
    setDateValue: function setDateValue(value, row, name, readonly) {
      var self = this;
      if (value !== '') {
        self.field_data[row][name].value = value;
        self.value = value;
      }
      self.show_add_row = !readonly;
      return self.field_data[row][name].value;
    },
    setDatePicker: function setDatePicker() {
      var self = this;

      var _loop = function _loop(row) {
        (0, _keys2.default)(self.field_data[row]).forEach(function (key) {
          if (key.indexOf('date') > -1) {
            var val = key + '::' + row;
            var dateVal = self.field_data[row][key].value != null ? self.field_data[row][key].value : '';
            var parts = dateVal.split('/');
            var newDate = new Date(parts[2], parts[1] - 1, parts[0]);
            $('[id=\'' + val + '\']').datetimepicker({
              format: 'DD/MM/YYYY',
              defaultDate: dateVal != '' ? newDate : null
            }).off('dp.change').on('dp.change', function (e) {
              self.value = $(e.target).data('DateTimePicker').date($(e.target)[0].value).format('DD/MM/YYYY');
              var row_no = e.target.id.split('::')[1];
              var name = e.target.name.split('::')[1];
              self.setDateValue(e.target.value, row_no, name, e.target.disabled);
            });
          }
        });
      };

      for (var row = 0; row < self.field_data.length; row++) {
        _loop(row);
      }
    } },
  updated: function updated() {
    this.setDatePicker();
  },
  mounted: function mounted() {
    this.setDatePicker();
  }
};

exports.default = GridBlock;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "group",
    props: ["label", "name", "id", "help_text", "help_text_url", "isRemovable", "isPreviewMode"],
    data: function data() {
        return {
            isExpanded: true
        };
    },
    components: { HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },
    methods: {
        expand: function expand(e) {
            this.isExpanded = true;
        },
        minimize: function minimize(e) {
            this.isExpanded = false;
        }
    },
    mounted: function mounted() {
        var vm = this;
        $('[data-toggle="tooltip"]').tooltip();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(86);

var _typeof3 = _interopRequireDefault(_typeof2);

var _from = __webpack_require__(104);

var _from2 = _interopRequireDefault(_from);

var _slicedToArray2 = __webpack_require__(145);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(142);

var _entries2 = _interopRequireDefault(_entries);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Group2 = {
    props: {
        name: String,
        label: String,
        id: String,
        isRequired: String,
        help_text: String,
        help_text_url: String,
        component: {
            type: Object | null,
            required: true
        },
        field_data: {
            type: Object | null,
            required: true
        },
        readonly: Boolean
    },
    components: {
        HelpText: _help_text2.default,
        HelpTextUrl: _help_text_url2.default
    },
    data: function data() {
        return {
            expanded: {},
            components: {}
        };
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['removeFormInstance', 'setFormValue', 'refreshApplicationFees']), {
        add_1: function add_1(tableId) {
            return tableId + 1;
        },
        isExpanded: function isExpanded(tableId) {
            return this.expanded[tableId];
        },
        toggleGroupVisibility: function toggleGroupVisibility(tableId) {
            if (this.expanded[tableId]) {
                this.$delete(this.expanded, tableId);
            } else {
                this.$set(this.expanded, tableId, true);
            }
            console.log('toggle: ' + (0, _stringify2.default)(this.expanded));

            return this.expanded[tableId];
        },
        removeGroup: function removeGroup(tableId) {
            if (this.expanded[tableId]) {
                this.$delete(this.expanded, tableId);
            }
            this.removeFormInstance(this.getInstanceName(tableId));
            this.updateVisibleGroups(this.existingGroups.filter(function (table) {
                return table != tableId;
            }));
            delete this.components[tableId];
        },
        addNewGroup: function addNewGroup() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var tableId = params.tableId;

            if (!tableId) {
                tableId = this.getTableId(this.lastTableId + 1);
            }
            this.existingGroups.push(tableId);
            this.updateVisibleGroups(this.existingGroups);
        },
        updateVisibleGroups: function updateVisibleGroups(tableList) {
            this.setFormValue({
                key: this.component.name,
                value: {
                    "value": tableList
                }
            });
        },
        getTableId: function getTableId(tableIdx) {
            return this.id + '_table_' + tableIdx;
        },
        getInstanceName: function getInstanceName(tableId) {
            return '__instance-' + tableId;
        },

        updateComponent: function updateComponent(json_obj, fn) {
            var _this = this;

            var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';

            return Object.fromEntries((0, _entries2.default)(json_obj).map(function (_ref) {
                var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                    k = _ref2[0],
                    v = _ref2[1];

                return [k, Array.isArray(v) ? (0, _from2.default)(v, function (v) {
                    return _this.updateComponent(v, fn);
                }) : v && (typeof v === 'undefined' ? 'undefined' : (0, _typeof3.default)(v)) === 'object' ? _this.updateComponent(v, fn) : k === key ? fn(v) : v];
            }));
        },

        __updateComponent: function __updateComponent(obj, fn) {
            var _this2 = this;

            return Object.fromEntries((0, _entries2.default)(obj).map(function (_ref3) {
                var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
                    k = _ref4[0],
                    v = _ref4[1];

                return [k, v && (typeof v === 'undefined' ? 'undefined' : (0, _typeof3.default)(v)) === 'object' ? _this2.updateComponent(v, fn) : k === 'name' ? fn(v) : v];
            }));
        },

        __updateComponent2: function __updateComponent2(obj, append_str) {
            var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';


            var vm = this;

            (0, _keys2.default)(obj).forEach(function (k) {
                if (obj[k] && (0, _typeof3.default)(obj[k]) === 'object') {
                    return vm.updateComponent2(obj[k], append_str, 'name');
                }
                if (k === key) {
                    obj[k] = obj[k] + '-ridx' + append_str;
                }
            });
        },
        num_groups: function num_groups() {
            return (0, _keys2.default)(this.components).length;
        }

    }),

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['canViewComments', 'canViewDeficiencies', 'canEditDeficiencies', 'getFormValue']), {
        lastTableId: function lastTableId() {
            if (!this.existingGroups.length) {
                return 0;
            }
            var lastId = 0;
            this.existingGroups.map(function (tableId) {
                return tableId[tableId.length - 1] > lastId && (lastId = tableId[tableId.length - 1]);
            });
            return parseInt(lastId, 10);
        },
        existingGroups: function existingGroups() {
            return this.getFormValue(this.component.name) || [];
        },
        repeatableGroups: function repeatableGroups() {
            var vm = this;
            if (!this.existingGroups.length) {
                this.addNewGroup();
            }

            this.existingGroups.forEach(function (group, index) {
                var ridx = group.split('_').slice(-1)[0];
                vm.components[group] = vm.updateComponent(vm.component, function (v) {
                    return v + '-ridx' + ridx;
                });
            });

            return this.existingGroups;
        },
        value: function value() {
            return this.field_data;
        }
    })
};

exports.default = Group2;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "species-group",
    props: ["label", "name", "id", "help_text", "help_text_url", "isRemovable", "isPreviewMode"],
    data: function data() {
        return {
            isExpanded: true
        };
    },
    components: { HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },
    methods: {
        expand: function expand(e) {
            this.isExpanded = true;
        },
        minimize: function minimize(e) {
            this.isExpanded = false;
        }
    },
    mounted: function mounted() {
        var vm = this;
        $('[data-toggle="tooltip"]').tooltip();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _help_text_display = __webpack_require__(835);

var _help_text_display2 = _interopRequireDefault(_help_text_display);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["help_text"],

  components: { HelpTextDisplay: _help_text_display2.default },
  data: function data() {
    return {
      showingHelpText: false,
      pBody: 'pBody'
    };
  },

  methods: {
    toggleHelpText: function toggleHelpText() {
      this.showingHelpText = !this.showingHelpText;
    }
  }
};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ["help_text"]
};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ["help_text_url"]
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["value", "id", "help_text_url"],
    components: { HelpTextUrl: _help_text_url2.default }
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "radiobuttons",
    props: ["value", "label", "id", "name", "isRequired", "handleChange", "conditions", "savedValue", "readonly"],
    computed: {
        isChecked: function isChecked() {
            return this.value == this.savedValue.value;
        },
        options: function options() {
            return (0, _stringify2.default)(this.conditions);
        }
    },
    mounted: function mounted() {
        if (this.value == this.savedValue.value) {
            var input = this.$refs.radioB;
            var e = document.createEvent('HTMLEvents');
            e.initEvent('change', true, true);
            var disabledStatus = input.disabled;
            try {
                if (disabledStatus) {
                    input.disabled = false;
                }
                input.dispatchEvent(e);
            } finally {
                if (disabledStatus) {
                    input.disabled = true;
                }
            }
        }
    }
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ["box_view", "type", "name", "value", "id", "label", "readonly"]
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["type", "name", "id", "field_data", "isRequired", "help_text", "label", "readonly", "help_text_url", "can_view_richtext_src"],
    components: { CommentBlock: _comment_block2.default, HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },
    data: function data() {
        var vm = this;
        if (vm.can_view_richtext_src) {
            var remove_buttons = '';
        } else {
            var remove_buttons = 'Source,About';
        }

        return {
            editorConfig: {
                removeButtons: remove_buttons,

                removePlugins: 'elementspath',
                resize_enabled: false
            }
        };
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setFormValue'])),
    computed: {}
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: "FormSection",
    props: ["label", "Index"],
    data: function data() {
        return {
            title: "Section title",
            eventInitialised: false
        };
    },
    computed: {
        section_id: function section_id() {
            return "section_" + this.Index;
        }
    },
    updated: function updated() {
        var _this = this;

        var vm = this;
        vm.$nextTick(function () {
            if (!vm.eventInitialised) {
                $('.panelClicker[data-toggle="collapse"]').on('click', function () {
                    var chev = $(this).children()[0];
                    window.setTimeout(function () {
                        $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
                    }, 100);
                });
                _this.eventInitialised = true;
            }
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: "FormSection",
    props: ["label", "Index", "formCollapse", "hideHeader", "treeHeight"],
    data: function data() {
        return {
            title: "Section title",
            eventInitialised: false,
            panel_chevron_class: null
        };
    },
    computed: {
        section_id: function section_id() {
            return "section_" + this.Index;
        },
        panel_collapse_class: function panel_collapse_class() {
            if (this.formCollapse) {
                this.panel_chevron_class = "glyphicon glyphicon-chevron-down pull-right";
                return "panel-body collapse";
            } else {
                if (this.treeHeight) {
                    this.panel_chevron_class = "glyphicon glyphicon-chevron-up pull-right";
                    return "panel-body collapse in flex-container";
                } else {
                    this.panel_chevron_class = "glyphicon glyphicon-chevron-up pull-right";
                    return "panel-body collapse in";
                }
            }
        }

    },
    updated: function updated() {
        var _this = this;

        var vm = this;
        vm.$nextTick(function () {
            if (!vm.eventInitialised) {
                $('.panelClicker[data-toggle="collapse"]').on('click', function () {
                    var chev = $(this).children()[0];
                    console.log(chev);
                    window.setTimeout(function () {
                        $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
                    }, 100);
                });
                _this.eventInitialised = true;
            }
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var select2 = __webpack_require__(81);
__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    props: {
        'name': String,
        'label': String,
        'id': String,
        'isRequired': String,
        'help_text': String,
        'help_text_url': String,
        "field_data": Object,
        "options": Array,
        "conditions": Object,
        "handleChange": null,
        "isMultiple": {
            default: function _default() {
                return false;
            }
        },
        'readonly': Boolean
    },
    data: function data() {
        var vm = this;
        return {
            selected: this.isMultiple ? [] : "",
            selectid: "select" + vm._uid,
            multipleSelected: []
        };
    },
    computed: {
        cons: function cons() {
            return (0, _stringify2.default)(this.conditions);
        },
        value: function value() {
            return this.field_data.value;
        }
    },
    components: { CommentBlock: _comment_block2.default, HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },
    methods: {
        multipleSelection: function multipleSelection(val) {
            if (Array.isArray(this.value)) {
                if (this.value.find(function (v) {
                    return v == val;
                })) {
                    return true;
                }
            } else {
                if (this.value == val) {
                    return true;
                }
            }
            return false;
        },
        init: function init() {
            var vm = this;
            setTimeout(function (e) {
                $('#' + vm.selectid).select2({
                    "theme": "bootstrap",
                    allowClear: true,
                    placeholder: "Select..."
                }).on("select2:select", function (e) {
                    var selected = $(e.currentTarget);
                    vm.handleChange(selected[0]);
                    e.preventDefault();
                    if (vm.isMultiple) {
                        vm.field_data.value = vm.multipleSelected = selected.val();
                    }
                }).on("select2:unselect", function (e) {
                    var selected = $(e.currentTarget);
                    vm.handleChange(selected[0]);
                    e.preventDefault();
                    if (vm.isMultiple) {
                        vm.field_data.value = vm.multipleSelected = selected.val();
                    }
                });
                if (vm.value) {
                    vm.handleChange(vm.$refs.selectB);
                }
            }, 100);
        }
    },
    mounted: function mounted() {
        this.init();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set = __webpack_require__(553);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(85);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        "label": {
            type: String
        },
        "name": {
            type: String
        },
        "field_data": {
            type: Object,
            required: true
        },
        "options": {
            type: Array,
            required: true,
            default: function _default() {
                return [];
            }
        },
        "readonly": {
            type: Boolean,
            default: false
        },
        "id": {
            type: String
        },
        "isRequired": {
            type: Boolean,
            default: false
        },
        "help_text": {
            type: String
        },
        "help_text_url": {
            type: String
        },
        "isMultiple": {
            default: function _default() {
                return false;
            }
        },
        "handleChange": null,
        "filtered_list_url": {
            type: String
        }
    },
    data: function data() {
        var vm = this;
        return {
            selected: this.isMultiple ? [] : "",
            selectid: "select" + vm._uid,
            multipleSelected: []
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application_id', 'renderer_form_data']), {
        cons: function cons() {
            return (0, _stringify2.default)(this.field_data);
        },
        value: function value() {
            return this.field_data.value;
        },
        species: function species() {
            var results = [];
            var specie = {};
            if (Array.isArray(this.field_data.value)) {
                for (var i = 0; i < this.field_data.value.length; i++) {
                    specie = {
                        'value': this.field_data.value[i],
                        'label': this.field_data.value[i]
                    };
                    if (this.field_data.value[i] != '') {
                        results[i] = specie;
                    }
                }
            } else {

                specie = {
                    'value': this.field_data.value,
                    'label': this.field_data.value
                };
                if (this.field_data.value != '') {
                    results[0] = specie;
                }
            }
            var unique_results = [].concat((0, _toConsumableArray3.default)(new _set2.default(results)));
            return unique_results;
        }
    }),
    components: { HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default, CommentBlock: _comment_block2.default },
    methods: {
        multipleSelection2: function multipleSelection2(val) {
            if (Array.isArray(this.options)) {
                if (this.species.find(function (v) {
                    return v == val;
                })) {
                    return true;
                }
            } else {
                if (this.species == val) {
                    return true;
                }
            }
            return false;
        },
        multipleSelection: function multipleSelection(val) {
            var _this = this;

            if (Array.isArray(this.field_data.value)) {
                var selected = '0';
                for (var i = 0; i < this.field_data.value.length; i++) {
                    if (this.field_data.value[i] == val) {
                        selected = this.field_data.value[i];
                        break;
                    }
                }
                if (this.species.find(function (v) {
                    return v.value == selected && v.value === val;
                })) {
                    return true;
                }
            } else {
                var species = [this.field_data.value];

                if (species.find(function (v) {
                    return v.value === _this.field_data.value && v.value === val;
                })) {
                    return true;
                }
            }
            return false;
        },
        init: function init() {
            var vm = this;
            vm.multipleSelected = vm.field_data.value;
            var data = '';
            setTimeout(function (e) {
                $('#' + vm.selectid).select2({
                    "theme": "bootstrap",
                    tags: true,

                    placeholder: "Select...",
                    minimumInputLength: 3,
                    type: 'GET',
                    dataType: 'json',
                    ajax: {
                        url: vm.filtered_list_url
                    }
                }).on("select2:select", function (e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    var selected = $(e.currentTarget);

                    vm.field_data.value = vm.multipleSelected = selected.val();
                }).on("select2:unselect", function (e) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    var selected = $(e.currentTarget);
                    vm.handleChange(selected[0]);

                    vm.field_data.value = vm.multipleSelected = selected.val();
                });
                if (vm.value) {
                    vm.handleChange(vm.$refs.selectB);
                }
            }, 100);
        }
    },
    updated: function updated() {
        var _this2 = this;

        this.$nextTick(function () {
            _this2.field_data.value = _this2.multipleSelected[0] ? _this2.multipleSelected : _this2.field_data.value;
        });
    },
    mounted: function mounted() {
        this.init();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var select2 = __webpack_require__(81);
__webpack_require__(20);
__webpack_require__(19);

exports.default = {
    props: {
        "label": {
            type: String
        },
        "name": {
            type: String
        },
        "field_data": {
            type: Object,
            required: true
        },
        "options": {
            type: Array,
            required: true,
            default: function _default() {
                return [];
            }
        },
        "readonly": {
            type: Boolean,
            default: false
        },
        "id": {
            type: String
        },
        "isRequired": {
            type: Boolean,
            default: false
        },
        "help_text": {
            type: String
        },
        "help_text_url": {
            type: String
        },
        "isMultiple": {
            default: function _default() {
                return false;
            }
        },
        "handleChange": null
    },
    data: function data() {
        var vm = this;
        return {
            selected: this.isMultiple ? [] : "",
            selectid: "select" + vm._uid,
            multipleSelected: []
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application_id', 'renderer_form_data']), {
        cons: function cons() {
            return (0, _stringify2.default)(this.field_data);
        },
        value: function value() {
            return this.field_data.value;
        },
        species: function species() {
            var species = this.options;
            if (this.field_data.component_attribute) {
                species = this.field_data.component_attribute;
            } else {
                this.field_data.component_attribute = species;
            }
            return species;
        }
    }),
    components: { HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },
    methods: {
        multipleSelection2: function multipleSelection2(val) {
            if (Array.isArray(this.options)) {
                if (this.species.find(function (v) {
                    return v == val;
                })) {
                    return true;
                }
            } else {
                if (this.species == val) {
                    return true;
                }
            }
            return false;
        },
        multipleSelection: function multipleSelection(val) {
            var _this = this;

            if (Array.isArray(this.field_data.value)) {
                var selected = '0';
                for (var i = 0; i < this.field_data.value.length; i++) {
                    if (this.field_data.value[i] == val) {
                        selected = this.field_data.value[i];
                        break;
                    }
                }
                if (this.species.find(function (v) {
                    return v.value == selected && v.value === val;
                })) {
                    return true;
                }
            } else {
                if (this.species.find(function (v) {
                    return v.value === _this.field_data.value && v.value === val;
                })) {
                    return true;
                }
            }
            return false;
        },
        init: function init() {
            var vm = this;
            vm.multipleSelected = vm.field_data.value;
            setTimeout(function (e) {
                $('#' + vm.selectid).select2({
                    "theme": "bootstrap",
                    allowClear: true,
                    placeholder: "Select..."
                }).on("select2:select", function (e) {
                    var selected = $(e.currentTarget);
                    vm.handleChange(selected[0]);
                    e.preventDefault();
                    if (vm.isMultiple) {
                        vm.field_data.value = vm.multipleSelected = selected.val();
                    }
                }).on("select2:unselect", function (e) {
                    var selected = $(e.currentTarget);
                    vm.handleChange(selected[0]);
                    e.preventDefault();
                    if (vm.isMultiple) {
                        vm.field_data.value = vm.multipleSelected = selected.val();
                    }
                });
                if (vm.value) {
                    vm.handleChange(vm.$refs.selectB);
                }
            }, 100);
        }
    },
    updated: function updated() {
        var _this2 = this;

        this.$nextTick(function () {
            _this2.field_data.value = _this2.multipleSelected[0] ? _this2.multipleSelected : _this2.field_data.value;
        });
    },
    mounted: function mounted() {
        this.init();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: "tabs",

    props: {
        initialTab: String,
        tabs: Array
    },
    data: function data() {
        return {
            activeTab: this.initialTab
        };
    },
    computed: {
        tabPanelSlotName: function tabPanelSlotName() {
            return "tab-panel-" + this.activeTab;
        }
    },
    methods: {
        tabHeadSlotName: function tabHeadSlotName(tabName) {
            return "tab-head-" + tabName;
        },
        switchTab: function switchTab(tabName) {
            this.activeTab = tabName;
        }
    }
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _values = __webpack_require__(143);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableBlock = {
    props: {
        headers: String,
        name: String,
        label: String,
        id: String,
        isRequired: String,
        help_text: String,
        help_text_url: String,
        field_data: Object,
        readonly: Boolean

    },

    components: { CommentBlock: _comment_block2.default, HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },

    data: function data() {
        var vm = this;
        var value = this.field_data.value ? JSON.parse(this.field_data.value) : null;

        var headers = JSON.parse(vm.headers);
        var col_headers = (0, _keys2.default)(headers);
        vm.col_types = (0, _values2.default)(headers);

        var init_row = [];
        for (var i = 0, length = col_headers.length; i < length; i++) {
            init_row.push('');
        }

        if (value == null) {
            vm.table = {
                thead: col_headers,
                tbody: [init_row]
            };
        } else {
            vm.table = {
                thead: value['thead'],
                tbody: value['tbody']
            };
        }

        var data = {};
        if (vm.readonly) {
            data.isClickable = "return false;";
        } else {
            data.isClickable = "return true;";
        }

        return data;
    },

    methods: {
        updateTableJSON: function updateTableJSON() {
            var vm = this;
            vm.tableJSON = (0, _stringify2.default)(vm.table);
            this.field_data.value = vm.tableJSON;
        },

        addRow: function addRow() {
            var vm = this;
            var newRow = [];

            for (var i = 0, length = vm.table.thead.length; i < length; i++) {
                newRow.push('');
            }

            vm.table.tbody.push(newRow);

            vm.updateTableJSON();
        },

        deleteRow: function deleteRow(row) {
            var vm = this;

            vm.table.tbody = vm.table.tbody.filter(function (item) {
                return item !== row;
            });
            vm.updateTableJSON();
        }

    },

    computed: {},

    mounted: function mounted() {
        var vm = this;

        vm.updateTableJSON();

        $('.content-editable-table').on('change', '.tbl_input', function () {
            vm.updateTableJSON();
        });

        $(".content-editable-table").on("click", ".ibtnDel", function (event) {
            $(this).closest("tr").remove();
        });

        if (vm.isChecked) {
            var input = this.$refs.Checkbox;
            var e = document.createEvent('HTMLEvents');
            e.initEvent('change', true, true);

            if (vm.readonly) {
                vm.isClickable = "return false;";
            } else {
                vm.isClickable = "return true;";
            }
            input.dispatchEvent(e);
        }
    }
};

exports.default = TableBlock;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["name", "field_data", "id", "isRequired", "help_text", "label", "readonly", "help_text_url"],
    components: { CommentBlock: _comment_block2.default, HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },
    data: function data() {
        return {};
    },

    methods: {},
    computed: {}
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _comment_block = __webpack_require__(32);

var _comment_block2 = _interopRequireDefault(_comment_block);

var _help_text = __webpack_require__(25);

var _help_text2 = _interopRequireDefault(_help_text);

var _help_text_url = __webpack_require__(23);

var _help_text_url2 = _interopRequireDefault(_help_text_url);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ["type", "name", "id", "field_data", "isRequired", "help_text", "label", "readonly", "help_text_url", "min", "max"],
    components: { CommentBlock: _comment_block2.default, HelpText: _help_text2.default, HelpTextUrl: _help_text_url2.default },
    data: function data() {
        var vm = this;
        return {};
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setFormValue'])),
    computed: {}
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'amendment-request',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default
    },
    props: {},
    data: function data() {
        var vm = this;
        return {
            isModalOpen: false,
            form: null,
            amendment: {
                reason: '',
                amendingApplication: false,
                application: this.$store.getters.application_id,
                text: null,
                activity_list: []
            },
            reason_choices: {},
            errors: false,
            errorString: '',
            validation_form: null
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application_id', 'licenceActivities', 'hasRole', 'canRequestAmendmentFor']), {
        showError: function showError() {
            var vm = this;
            return vm.errors;
        },
        amendableActivities: function amendableActivities() {
            var _this = this;

            return this.licenceActivities(['with_officer', 'with_assessor', 'with_officer_conditions']).filter(function (activity) {
                return _this.canRequestAmendmentFor(activity.id);
            });
        }
    }),
    methods: {
        ok: function ok() {
            var vm = this;
            if ($(vm.form).valid()) {
                vm.sendData();
            }
        },
        cancel: function cancel() {
            this.isModalOpen = false;
            this.amendment = {
                reason: '',
                application: this.application_id,
                text: null,
                licence_activity: null,
                activity_list: []
            };
        },
        close: function close() {
            this.isModalOpen = false;
            this.amendment = {
                reason: '',
                application: this.application_id,
                text: null,
                licence_activity: null,
                activity_list: []
            };
            this.errors = false;
            $(this.$refs.reason).val(null).trigger('change');
            $('.has-error').removeClass('has-error');

            this.validation_form.resetForm();
        },
        fetchAmendmentChoices: function fetchAmendmentChoices() {
            var vm = this;
            vm.$http.get('/api/amendment_request_reason_choices.json').then(function (response) {
                vm.reason_choices = response.body;
            }, function (error) {
                console.log(error);
            });
        },
        sendData: function sendData() {
            var _this2 = this;

            var vm = this;
            vm.errors = false;
            var amendment = JSON.parse((0, _stringify2.default)(vm.amendment));
            vm.$http.post('/api/amendment.json', (0, _stringify2.default)(amendment), {
                emulateJSON: true
            }).then(function (response) {
                swal({
                    title: 'Sent',
                    text: 'An email has been sent to applicant with the request to amend this Application',
                    type: 'question',
                    showCancelButton: false,
                    confirmButtonText: 'Ok'

                }).then(function (result) {

                    vm.amendingApplication = true;
                    vm.close();
                    _this2.$router.push({ name: "internal-dash" });
                });
            }, function (error) {
                console.log(error);
                vm.errors = true;
                vm.errorString = _hooks.helpers.apiVueResourceError(error);
                vm.amendingApplication = true;
            });
        },
        addFormValidations: function addFormValidations() {
            var vm = this;
            vm.validation_form = $(vm.form).validate({
                rules: {
                    reason: "required"

                },
                messages: {
                    reason: "field is required"

                },
                showErrors: function showErrors(errorMap, errorList) {
                    $.each(this.validElements(), function (index, element) {
                        var $element = $(element);
                        $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                    });

                    $("." + this.settings.validClass).tooltip("destroy");

                    for (var i = 0; i < errorList.length; i++) {
                        var error = errorList[i];
                        $(error.element).tooltip({
                            trigger: "focus"
                        }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                    }
                }
            });
        },
        eventListerners: function eventListerners() {
            var vm = this;

            $(vm.$refs.reason).select2({
                "theme": "bootstrap",
                allowClear: true,
                placeholder: "Select Reason"
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                vm.amendment.reason = selected.val();
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                vm.amendment.reason = selected.val();
            });
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.form = document.forms.amendForm;
        vm.fetchAmendmentChoices();
        vm.addFormValidations();
        this.$nextTick(function () {
            vm.eventListerners();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _form = __webpack_require__(96);

var _form2 = _interopRequireDefault(_form);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _application_proposed_decline = __webpack_require__(845);

var _application_proposed_decline2 = _interopRequireDefault(_application_proposed_decline);

var _amendment_request = __webpack_require__(840);

var _amendment_request2 = _interopRequireDefault(_amendment_request);

var _application_assessments = __webpack_require__(343);

var _application_assessments2 = _interopRequireDefault(_application_assessments);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _proposed_issuance = __webpack_require__(848);

var _proposed_issuance2 = _interopRequireDefault(_proposed_issuance);

var _application_issuance = __webpack_require__(844);

var _application_issuance2 = _interopRequireDefault(_application_issuance);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _amendment_request_details = __webpack_require__(131);

var _amendment_request_details2 = _interopRequireDefault(_amendment_request_details);

var _securebase_link = __webpack_require__(130);

var _securebase_link2 = _interopRequireDefault(_securebase_link);

var _responsive_datatable_helper = __webpack_require__(50);

var _responsive_datatable_helper2 = _interopRequireDefault(_responsive_datatable_helper);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'InternalApplication',
    data: function data() {
        var vm = this;
        return {
            applicantTab: 'applicantTab' + vm._uid,
            applicationTab: 'applicationTab' + vm._uid,
            activityTab: 'activityTab' + vm._uid + '_' + 0,
            detailsBody: 'detailsBody' + vm._uid,
            identificationBody: 'identificationBody' + vm._uid,
            addressBody: 'addressBody' + vm._uid,
            contactsBody: 'contactsBody' + vm._uid,
            checksBody: 'checksBody' + vm._uid,
            decisionBody: 'decisionBody' + vm._uid,
            isSendingToAssessor: false,
            notOfficerWorkflow: false,
            assessorGroup: {},
            "selectedAssessor": {},
            "loading": [],
            form: null,

            contacts_table_initialised: false,
            initialisedSelects: false,
            showingApplication: true,
            showingApplicant: false,
            showingConditions: false,
            isofficerfinalisation: false,
            approvingApplication: false,
            contacts_table_id: vm._uid + 'contacts-table',
            application_assessor_datatable: vm._uid + 'assessment-table',
            spinner: false,
            request_spinner: false,
            condition_spinner: false,
            contacts_options: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: {
                    "url": vm.contactsURL,
                    "dataSrc": ''
                },
                columns: [{
                    title: 'Name',
                    data: 'last_name',
                    mRender: function mRender(data, type, full) {
                        return full.first_name + " " + full.last_name;
                    }
                }, {
                    title: 'Phone',
                    data: 'phone_number'
                }, {
                    title: 'Mobile',
                    data: 'mobile_number'
                }, {
                    title: 'Fax',
                    data: 'fax_number'
                }, {
                    title: 'Email',
                    data: 'email'
                }],
                processing: true
            },
            contacts_table: null,
            assessors_headers: ["Assessor Group", "Date Sent", "Status", "Action"],
            assessors_options: {},
            DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.$route.params.application_id + '/comms_log'),
            comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.$route.params.application_id + '/add_comms_log'),
            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.$route.params.application_id + '/action_log'),
            panelClickersInitialised: false,
            hasActionedConditionLink: false,
            hasActionedApplicationLink: false,
            hasActionedActivityTab: false,
            missing_fields: []
        };
    },
    components: {
        Application: _form2.default,
        datatable: _datatable2.default,
        ProposedDecline: _application_proposed_decline2.default,
        AmendmentRequest: _amendment_request2.default,
        ApplicationAssessments: _application_assessments2.default,
        ProposedLicence: _proposed_issuance2.default,
        IssueLicence: _application_issuance2.default,
        CommsLogs: _comms_logs2.default,
        AmendmentRequestDetails: _amendment_request_details2.default,
        SecureBaseLink: _securebase_link2.default
    },
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format('DD/MM/YYYY HH:mm:ss') : '';
        },
        formatDateNoTime: function formatDateNoTime(data) {
            return data ? moment(data).format('DD/MM/YYYY') : '';
        }
    },
    watch: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application', 'original_application', 'licence_type_data', 'selected_activity_tab_id', 'selected_activity_tab_name', 'hasRole', 'visibleConditionsFor', 'checkActivityStatus', 'isPartiallyFinalised', 'isFinalised', 'licenceActivities', 'isApplicationLoaded', 'isApplicationActivityVisible', 'unfinishedActivities', 'current_user', 'canAssignApproverFor', 'canEditAssessmentFor', 'canRequestAmendmentFor', 'canAssignOfficerFor', 'canAssignAssessorFor', 'id_check_status', 'character_check_status', 'return_check_status', 'hasCurrentLicence', 'allCurrentActivities', 'selected_activity_tab_workflow_state', 'application_workflow_state']), {
        applicationDetailsVisible: function applicationDetailsVisible() {

            return !this.isSendingToAssessor && !this.isofficerfinalisation && this.unfinishedActivities.length && !this.showingConditions;
        },
        applicationIsDraft: function applicationIsDraft() {
            return this.application.processing_status.id == 'draft';
        },
        selectedActivity: function selectedActivity() {
            var _this = this;

            if (this.selected_activity_tab_id == null || this.selected_activity_tab_id < 1) {

                this.initFirstTab();
            }
            var selected = this.application.activities.find(function (activity) {

                return activity.licence_activity === _this.selected_activity_tab_id;
            });
            return selected;
        },
        canIssueDecline: function canIssueDecline() {
            if (this.showingApplicant) {
                return false;
            }

            if (this.selectedActivity.processing_status.id == 'awaiting_licence_fee_payment') {
                return false;
            }

            if (!this.canAssignApproverFor(this.selected_activity_tab_id)) {
                return false;
            };

            if (this.selectedActivity.assigned_approver != null && parseInt(this.selectedActivity.assigned_approver) !== parseInt(this.current_user.id)) {
                return false;
            };

            if (this.selectedActivity.processing_status.id == 'with_officer_finalisation') {
                this.approvingApplication = true;
                this.showingConditions = !this.showingApplication && !this.isofficerfinalisation;
            }
            return true;
        },
        canSaveApplication: function canSaveApplication() {
            if (this.selected_activity_tab_id && this.userHasRole('assessor', this.selected_activity_tab_id) && this.selectedActivity.processing_status.id == 'with_assessor') {
                return true;
            }
            var workflow = ['with_officer'].includes(this.selectedActivity.processing_status.id);
            if (!workflow || !this.selectedActivity) {
                return false;
            }

            return this.canRequestAmendment;
        },
        canRequestAmendment: function canRequestAmendment() {
            if (this.selectedActivity.assigned_officer != null && this.selectedActivity.assigned_officer !== this.current_user.id) {
                return false;
            }

            if (this.selectedActivity.decision_action === 'reissue') {
                return false;
            }

            return this.canRequestAmendmentFor(this.selected_activity_tab_id);
        },
        canReturnToConditions: function canReturnToConditions() {
            var can_return = this.canIssueDecline;

            if (!this.showingApplication && this.showingConditions) {
                can_return = false;
            }

            return can_return;
        },
        canProposeIssueOrDecline: function canProposeIssueOrDecline() {
            var _this2 = this;

            var auth_activity = this.canAssignOfficerFor(this.selected_activity_tab_id);

            if (auth_activity && auth_activity.assigned_officer != null && auth_activity.assigned_officer !== this.current_user.id) {
                return false;
            }

            var proposal = auth_activity && auth_activity.is_with_officer && this.licence_type_data.activity.find(function (activity) {
                return activity.id === _this2.selected_activity_tab_id && activity.processing_status.name.match(/with officer/gi);
            });
            if (this.selected_activity_tab_workflow_state[this.selected_activity_tab_id]) {
                proposal = false;
            }

            return proposal ? proposal.processing_status.id = 'with_officer_conditions' : false;
        },
        canProposeToOnlyDecline: function canProposeToOnlyDecline() {
            var decline_proposal = !this.hasCurrentLicence || this.selected_activity_tab_workflow_state[this.selected_activity_tab_id];

            if (this.selectedActivity.processing_status.id === 'declined') {
                return false;
            }
            if (this.selectedActivity.processing_status.id === 'with_assessor') {
                return false;
            }
            if (this.selectedActivity.processing_status.id === 'draft') {
                return false;
            }

            if (this.canProposeIssueOrDecline) {
                decline_proposal = false;
            }
            return decline_proposal;
        },
        contactsURL: function contactsURL() {
            return this.application != null ? _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, this.application.org_applicant.id + '/contacts') : '';
        },
        applicantType: function applicantType() {
            return this.$store.getters.applicant_type;
        },
        isLoading: function isLoading() {
            return this.loading.length > 0;
        },
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie('csrftoken');
        },
        application_form_url: function application_form_url() {
            return this.application ? '/api/application/' + this.application.id + '/application_officer_save.json' : '';
        },
        isIdCheckAccepted: function isIdCheckAccepted() {
            return this.id_check_status === 'accepted';
        },
        isIdNotChecked: function isIdNotChecked() {
            return this.id_check_status === 'not_checked';
        },
        isIdCheckRequested: function isIdCheckRequested() {
            return this.id_check_status === 'awaiting_update';
        },
        isIdCheckUpdated: function isIdCheckUpdated() {
            return this.id_check_status === 'updated';
        },
        isCharacterCheckAccepted: function isCharacterCheckAccepted() {
            return this.character_check_status === 'accepted';
        },
        userIsAssignedOfficer: function userIsAssignedOfficer() {
            return this.current_user.id == this.selectedActivity.assigned_officer;
        },
        form_data_comments_url: function form_data_comments_url() {
            return this.application ? '/api/application/' + this.application.id + '/officer_comments.json' : '';
        },
        form_data_application_url: function form_data_application_url() {
            return this.application ? '/api/application/' + this.application.id + '/form_data.json' : '';
        },
        headerLabel: function headerLabel() {
            switch (this.application.application_type.id) {
                case 'amend_activity':
                    return 'Application - Activity Amendment';
                    break;
                case 'renew_activity':
                    return 'Application - Activity Renewal';
                    break;
                default:
                    return 'Application';
                    break;
            }
        },
        updatedFee: function updatedFee() {
            return this.application.application_fee !== 0 || this.application.licence_fee !== 0 ? true : false;
        },
        showNavBarBottom: function showNavBarBottom() {
            var show = !this.applicationIsDraft && this.canSaveApplication;
            return show;
        },
        showAssignToOfficer: function showAssignToOfficer() {
            if (this.showingApplicant) {
                return false;
            }

            var workflow_officer = ['with_officer', 'with_officer_conditions'].includes(this.selectedActivity.processing_status.id);
            if (!workflow_officer) {
                return false;
            }

            return this.isSendingToAssessor || this.showingConditions || this.showingApplication;
        },
        showAssignToApprover: function showAssignToApprover() {
            var show = !this.showingApplication && this.canAssignApproverFor(this.selectedActivity.licence_activity);

            if (this.showingApplication || this.showingConditions) {
                return false;
            }

            return show;
        },
        showAssessmentConditionButton: function showAssessmentConditionButton() {
            if (this.showingApplicant) {
                return false;
            }
            var workflow_officer = ['with_officer', 'with_officer_conditions'].includes(this.selectedActivity.processing_status.id);
            var workflow_assessor = ['with_assessor'].includes(this.selectedActivity.processing_status.id);
            if (!workflow_officer && !workflow_assessor) {
                return false;
            }
            if (workflow_officer && !this.canAssignOfficerFor(this.selectedActivity.licence_activity)) {
                return false;
            }
            if (workflow_assessor) {
                return false;
            }

            return this.showingApplication && !this.applicationIsDraft;
        },
        showIssueDeclineButton: function showIssueDeclineButton() {

            if (this.showingApplicant) {
                return false;
            }

            if (this.selectedActivity.processing_status.id == 'awaiting_licence_fee_payment') {
                return false;
            }

            if (!this.canAssignApproverFor(this.selected_activity_tab_id)) {
                return false;
            };

            if (this.selectedActivity.assigned_approver != null && this.selectedActivity.assigned_approver !== this.current_user.id) {
                return false;
            };

            if (this.approvingApplication) {
                return false;
            }

            return true;
        },
        showFinalDecisionOriginal: function showFinalDecisionOriginal() {
            var show_final = (!this.showingApplication || !this.unfinishedActivities.length) && !this.isSendingToAssessor && !this.canIssueDecline && !this.showingConditions;
            if (['awaiting_payment'].includes(this.application.processing_status.id)) {
                this.toggleApplication({ show: false });
                this.isSendingToAssessor = false;
            }
            if (show_final) {
                this.showingApplication = false;
            }
            return show_final;
        },
        showFinalDecision: function showFinalDecision() {
            var show_final = false;

            if (!this.unfinishedActivities.length) {
                show_final = (!this.showingApplication || !this.unfinishedActivities.length) && !this.isSendingToAssessor && !this.canIssueDecline && !this.showingConditions;
            }
            if (['awaiting_payment'].includes(this.application.processing_status.id)) {
                this.toggleApplication({ show: false });
                this.isSendingToAssessor = false;
            }
            if (show_final) {
                this.showingApplication = false;
            }
            return show_final;
        },
        showSpinner: function showSpinner() {
            return this.spinner;
        },
        showRequestSpinner: function showRequestSpinner() {
            return this.request_spinner;
        },
        showConditionSpinner: function showConditionSpinner() {
            return this.condition_spinner;
        },
        showReturnCheckButton: function showReturnCheckButton() {
            return this.return_check_status !== 'accepted';
        },
        showBackToProcessingButton: function showBackToProcessingButton() {
            var show = this.isSendingToAssessor || this.showingConditions;
            if (this.selectedActivity.processing_status.id === 'declined') {
                return false;
            }
            if (this.selectedActivity.processing_status.id === 'with_officer_finalisation') {
                return false;
            }
            if (this.selectedActivity.processing_status.id === 'accepted') {
                return false;
            }
            if (this.selectedActivity.processing_status.id === 'with_assessor') {
                return false;
            }
            if (this.selectedActivity.processing_status.id === 'draft') {
                return false;
            }

            return show;
        },
        showRequestAmendmentButton: function showRequestAmendmentButton() {
            var show = !this.applicationIsDraft && this.canRequestAmendment;

            if (this.selectedActivity.processing_status.id !== 'with_officer') {
                return false;
            }

            if (this.showingApplicant) {
                return false;
            }

            return show;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        load: 'loadApplication',
        revert: 'revertApplication'
    }), (0, _vuex.mapActions)(['setOriginalApplication', 'setApplication', 'setActivityTab', 'loadCurrentUser', 'toggleFinalisedTabs', 'saveFormData', 'assessmentData', 'setIdCheckStatus', 'setCharacterCheckStatus', 'setReturnCheckStatus', 'resetUpdateFeeStatus', 'setAssessStatus', 'setLicenceTypeData', 'setActivityTabWorkflowState']), {
        selectTab: function selectTab(component) {
            this.section_tab_id = component.id;
            this.setActivityTab({ id: component.id, name: component.label });
            this.showingApplicant = false;
            this.setActivityTabWorkflowState({ tab_id: component.id, bool: !this.selectedActivity.can_propose_purposes });
            this.actionActivityTab(this.selectedActivity);
        },
        selectApplicantTab: function selectApplicantTab() {
            this.showingApplicant = true;
        },
        userHasRole: function userHasRole(role, activity_id) {
            return this.hasRole(role, activity_id);
        },
        getVisibleConditionsFor: function getVisibleConditionsFor(for_role, processing_status, tab_id) {
            return this.visibleConditionsFor(for_role, processing_status, tab_id);
        },
        initFirstTab: function initFirstTab(force) {
            var _this3 = this;

            if (this.selected_activity_tab_id && !force) {
                return;
            }

            var tab = $('#tabs-main li');
            if (tab.length > 0) {

                var tabno = 0;
                for (var i = 0; i < tab.length; i++) {
                    if (tab[i].innerText === this.selected_activity_tab_name) {
                        tabno = i;
                    }
                }
                var selected = $('#tabs-main li a')[tabno];

                if (this.showingApplicant) {
                    selected = $('#tabs-main li a')[0];
                }

                if (selected) {
                    selected.click();
                }
            } else {
                this.licenceActivities().filter(function (activity) {
                    _this3.setActivityTab({
                        id: activity.id,
                        name: activity.name
                    });
                });
            }
        },
        initialiseOrgContactTable: function initialiseOrgContactTable() {
            var vm = this;
            if (vm.application && vm.applicantType == 'org' && !vm.contacts_table_initialised) {
                vm.contacts_options.ajax.url = _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.application.org_applicant.id + '/contacts');
                vm.contacts_table = $('#' + vm.contacts_table_id).DataTable(vm.contacts_options);
                vm.contacts_table_initialised = true;
            }
        },
        commaToNewline: function commaToNewline(s) {
            return s.replace(/[,;]/g, '\n');
        },

        proposedDecline: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$refs.proposed_decline.noActiveLicense = !this.hasCurrentLicence;
                                this.$refs.proposed_decline.isModalOpen = true;

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function proposedDecline() {
                return _ref.apply(this, arguments);
            }

            return proposedDecline;
        }(),
        isActivityVisible: function isActivityVisible(activity_id) {
            return this.isApplicationActivityVisible({ activity_id: activity_id });
        },
        hasActivityStatus: function hasActivityStatus(status_list) {
            var status_count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var required_role = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return this.checkActivityStatus(status_list, status_count, required_role);
        },
        proposedLicence: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var activity_name, selectedTabTitle;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                activity_name = [];
                                selectedTabTitle = $("#tabs-main li.active");

                                this.$refs.proposed_licence.propose_issue.licence_activity_id = this.selected_activity_tab_id;
                                this.$refs.proposed_licence.propose_issue.licence_activity_name = selectedTabTitle.text();
                                this.$refs.proposed_licence.isModalOpen = true;
                                this.$refs.proposed_licence.preloadLastActivity();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function proposedLicence() {
                return _ref2.apply(this, arguments);
            }

            return proposedLicence;
        }(),
        toggleIssue: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var _this4 = this;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.showingApplication = false;

                                if (this.selectedActivity.processing_status.id === 'with_assessor') {

                                    this.approvingApplication = false;
                                    this.isofficerfinalisation = false;

                                    this.showingConditions = true;
                                    this.notOfficerWorkflow = true;
                                    this.isSendingToAssessor = true;
                                } else {

                                    this.approvingApplication = true;
                                    this.isofficerfinalisation = true;

                                    this.showingConditions = false;
                                    this.notOfficerWorkflow = false;
                                    this.isSendingToAssessor = false;
                                }

                                setTimeout(function () {
                                    var main_tabs = $('#tabs-main li');
                                    var tabno = 0;
                                    for (var i = 0; i < main_tabs.length; i++) {
                                        if (main_tabs[i].innerText === _this4.selected_activity_tab_name) {
                                            tabno = i;
                                        }
                                    }
                                    var selected = $('#tabs-main li a')[tabno];
                                    if (selected != null) {
                                        selected.click();
                                    }
                                    _this4.initFirstTab();
                                }, 50);

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function toggleIssue() {
                return _ref3.apply(this, arguments);
            }

            return toggleIssue;
        }(),
        acceptIdRequest: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                var _this5 = this;

                var vm;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                vm = this;

                                swal({
                                    title: "Accept ID Check",
                                    text: "Are you sure you want to accept this ID Check?",
                                    type: "question",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept'
                                }).then(function () {
                                    var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(result) {
                                        return _regenerator2.default.wrap(function _callee4$(_context4) {
                                            while (1) {
                                                switch (_context4.prev = _context4.next) {
                                                    case 0:
                                                        if (!result.value) {
                                                            _context4.next = 3;
                                                            break;
                                                        }

                                                        _context4.next = 3;
                                                        return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/accept_id_check')).then(function (response) {
                                                            vm.setIdCheckStatus(response.body.id_check_status);
                                                        }, function (error) {
                                                            console.log(error);
                                                        });

                                                    case 3:
                                                    case 'end':
                                                        return _context4.stop();
                                                }
                                            }
                                        }, _callee4, _this5);
                                    }));

                                    return function (_x3) {
                                        return _ref5.apply(this, arguments);
                                    };
                                }(), function (error) {});

                            case 2:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function acceptIdRequest() {
                return _ref4.apply(this, arguments);
            }

            return acceptIdRequest;
        }(),
        resetIdRequest: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
                var _this6 = this;

                var vm;
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                vm = this;

                                swal({
                                    title: "Reset ID Check",
                                    text: "Are you sure you want to reset this ID Check?",
                                    type: "question",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept'
                                }).then(function () {
                                    var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(result) {
                                        return _regenerator2.default.wrap(function _callee6$(_context6) {
                                            while (1) {
                                                switch (_context6.prev = _context6.next) {
                                                    case 0:
                                                        if (!result.value) {
                                                            _context6.next = 3;
                                                            break;
                                                        }

                                                        _context6.next = 3;
                                                        return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/reset_id_check')).then(function (response) {
                                                            vm.setIdCheckStatus(response.body.id_check_status);
                                                        }, function (error) {
                                                            console.log(error);
                                                        });

                                                    case 3:
                                                    case 'end':
                                                        return _context6.stop();
                                                }
                                            }
                                        }, _callee6, _this6);
                                    }));

                                    return function (_x4) {
                                        return _ref7.apply(this, arguments);
                                    };
                                }(), function (error) {});

                            case 2:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function resetIdRequest() {
                return _ref6.apply(this, arguments);
            }

            return resetIdRequest;
        }(),
        updateIdRequest: function () {
            var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
                var _this7 = this;

                var vm;
                return _regenerator2.default.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                vm = this;

                                swal({
                                    title: "Request Update ID Check",
                                    text: "Are you sure you want to request this ID Check update?",
                                    type: "question",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept'
                                }).then(function () {
                                    var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(result) {
                                        return _regenerator2.default.wrap(function _callee8$(_context8) {
                                            while (1) {
                                                switch (_context8.prev = _context8.next) {
                                                    case 0:
                                                        if (!result.value) {
                                                            _context8.next = 3;
                                                            break;
                                                        }

                                                        _context8.next = 3;
                                                        return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/request_id_check')).then(function (response) {
                                                            vm.setIdCheckStatus(response.body.id_check_status);
                                                        }, function (error) {
                                                            console.log(error);
                                                        });

                                                    case 3:
                                                    case 'end':
                                                        return _context8.stop();
                                                }
                                            }
                                        }, _callee8, _this7);
                                    }));

                                    return function (_x5) {
                                        return _ref9.apply(this, arguments);
                                    };
                                }(), function (error) {});

                            case 2:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function updateIdRequest() {
                return _ref8.apply(this, arguments);
            }

            return updateIdRequest;
        }(),
        acceptCharacterRequest: function () {
            var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
                var _this8 = this;

                var vm;
                return _regenerator2.default.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                vm = this;

                                swal({
                                    title: "Accept Character Check",
                                    text: "Are you sure you want to accept this Character Check?",
                                    type: "question",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept'
                                }).then(function () {
                                    var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(result) {
                                        return _regenerator2.default.wrap(function _callee10$(_context10) {
                                            while (1) {
                                                switch (_context10.prev = _context10.next) {
                                                    case 0:
                                                        if (!result.value) {
                                                            _context10.next = 3;
                                                            break;
                                                        }

                                                        _context10.next = 3;
                                                        return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/accept_character_check')).then(function (response) {
                                                            vm.setCharacterCheckStatus(response.body.character_check_status);
                                                        }, function (error) {
                                                            console.log(error);
                                                        });

                                                    case 3:
                                                    case 'end':
                                                        return _context10.stop();
                                                }
                                            }
                                        }, _callee10, _this8);
                                    }));

                                    return function (_x6) {
                                        return _ref11.apply(this, arguments);
                                    };
                                }(), function (error) {});

                            case 2:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function acceptCharacterRequest() {
                return _ref10.apply(this, arguments);
            }

            return acceptCharacterRequest;
        }(),
        resetCharacterRequest: function () {
            var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
                var _this9 = this;

                var vm;
                return _regenerator2.default.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                vm = this;

                                swal({
                                    title: "Reset Character Check",
                                    text: "Are you sure you want to reset this Character Check?",
                                    type: "question",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept'
                                }).then(function () {
                                    var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(result) {
                                        return _regenerator2.default.wrap(function _callee12$(_context12) {
                                            while (1) {
                                                switch (_context12.prev = _context12.next) {
                                                    case 0:
                                                        if (!result.value) {
                                                            _context12.next = 3;
                                                            break;
                                                        }

                                                        _context12.next = 3;
                                                        return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/reset_character_check')).then(function (response) {
                                                            vm.setCharacterCheckStatus(response.body.character_check_status);
                                                        }, function (error) {
                                                            console.log(error);
                                                        });

                                                    case 3:
                                                    case 'end':
                                                        return _context12.stop();
                                                }
                                            }
                                        }, _callee12, _this9);
                                    }));

                                    return function (_x7) {
                                        return _ref13.apply(this, arguments);
                                    };
                                }(), function (error) {});

                            case 2:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function resetCharacterRequest() {
                return _ref12.apply(this, arguments);
            }

            return resetCharacterRequest;
        }(),
        acceptReturnRequest: function () {
            var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
                var _this10 = this;

                var vm;
                return _regenerator2.default.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                vm = this;

                                swal({
                                    title: "Accept Return Check",
                                    text: "Are you sure you want to accept this Return Check?",
                                    type: "question",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept'
                                }).then(function () {
                                    var _ref15 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(result) {
                                        return _regenerator2.default.wrap(function _callee14$(_context14) {
                                            while (1) {
                                                switch (_context14.prev = _context14.next) {
                                                    case 0:
                                                        if (!result.value) {
                                                            _context14.next = 3;
                                                            break;
                                                        }

                                                        _context14.next = 3;
                                                        return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/accept_return_check')).then(function (response) {
                                                            vm.setReturnCheckStatus(response.body.return_check_status);
                                                        }, function (error) {
                                                            console.log(error);
                                                        });

                                                    case 3:
                                                    case 'end':
                                                        return _context14.stop();
                                                }
                                            }
                                        }, _callee14, _this10);
                                    }));

                                    return function (_x8) {
                                        return _ref15.apply(this, arguments);
                                    };
                                }(), function (error) {});

                            case 2:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function acceptReturnRequest() {
                return _ref14.apply(this, arguments);
            }

            return acceptReturnRequest;
        }(),
        resetReturnRequest: function () {
            var _ref16 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee17() {
                var _this11 = this;

                var vm;
                return _regenerator2.default.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                vm = this;

                                swal({
                                    title: "Reset Return Check",
                                    text: "Are you sure you want to reset this Return Check?",
                                    type: "question",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept'
                                }).then(function () {
                                    var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee16(result) {
                                        return _regenerator2.default.wrap(function _callee16$(_context16) {
                                            while (1) {
                                                switch (_context16.prev = _context16.next) {
                                                    case 0:
                                                        if (!result.value) {
                                                            _context16.next = 3;
                                                            break;
                                                        }

                                                        _context16.next = 3;
                                                        return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/reset_return_check')).then(function (response) {
                                                            vm.setReturnCheckStatus(response.body.return_check_status);
                                                        }, function (error) {
                                                            console.log(error);
                                                        });

                                                    case 3:
                                                    case 'end':
                                                        return _context16.stop();
                                                }
                                            }
                                        }, _callee16, _this11);
                                    }));

                                    return function (_x9) {
                                        return _ref17.apply(this, arguments);
                                    };
                                }(), function (error) {});

                            case 2:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function resetReturnRequest() {
                return _ref16.apply(this, arguments);
            }

            return resetReturnRequest;
        }(),
        save: function () {
            var _ref18 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee18() {
                var _this12 = this;

                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { showNotification: true };
                var showNotification;
                return _regenerator2.default.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                this.spinner = true;
                                showNotification = props.showNotification;


                                this.missing_fields.length = 0;
                                this.highlight_missing_fields();

                                _context18.next = 6;
                                return this.saveFormData({ url: this.form_data_application_url }).then(function (response) {
                                    _this12.resetUpdateFeeStatus();
                                    showNotification && swal('Saved', 'Your application has been saved', 'success');
                                }, function (error) {

                                    if (error.body.hasOwnProperty("missing")) {
                                        var _iteratorNormalCompletion = true;
                                        var _didIteratorError = false;
                                        var _iteratorError = undefined;

                                        try {

                                            for (var _iterator = (0, _getIterator3.default)(error.body.missing), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                                var missing_field = _step.value;

                                                _this12.missing_fields.push(missing_field);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return) {
                                                    _iterator.return();
                                                }
                                            } finally {
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }

                                        _this12.highlight_missing_fields();
                                        var top = ($('#error').offset() || { "top": NaN }).top;
                                        $('html, body').animate({
                                            scrollTop: top
                                        }, 1);
                                        return false;
                                    }
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 6:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function save() {
                return _ref18.apply(this, arguments);
            }

            return save;
        }(),
        highlight_missing_fields: function highlight_missing_fields() {
            $('.missing-field').removeClass('missing-field');
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.missing_fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var missing_field = _step2.value;

                    $('[name=' + missing_field.name).addClass('missing-field');
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var top = ($('#error').offset() || { "top": NaN }).top;
            $('html, body').animate({
                scrollTop: top
            }, 1);
        },
        save_button: function () {
            var _ref19 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee19() {
                return _regenerator2.default.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                _context19.next = 2;
                                return this.save();

                            case 2:
                                this.spinner = false;

                            case 3:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, this);
            }));

            function save_button() {
                return _ref19.apply(this, arguments);
            }

            return save_button;
        }(),
        save_wo: function () {
            var _ref20 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee20() {
                return _regenerator2.default.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                _context20.next = 2;
                                return this.save({ showNotification: false });

                            case 2:
                                return _context20.abrupt('return', true);

                            case 3:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, this);
            }));

            function save_wo() {
                return _ref20.apply(this, arguments);
            }

            return save_wo;
        }(),
        toggleApplicant: function toggleApplicant() {
            var show_final = ['approved', 'declined', 'partially_approved', 'awaiting_payment'].includes(this.application.processing_status.id) && !this.unfinishedActivities.length;
            if (!this.showingApplication && show_final) {
                this.toggleApplication({ show: true, showFinalised: true });
            }
            this.showingApplicant = true;
            this.showingApplication = true;

            setTimeout(function () {
                var selected = $('#tabs-main li a')[0];
                if (selected != null) {
                    selected.click();
                }
            }, 50);
        },
        toggleApplication: function toggleApplication(_ref21) {
            var _this13 = this;

            var _ref21$show = _ref21.show,
                show = _ref21$show === undefined ? false : _ref21$show,
                _ref21$showFinalised = _ref21.showFinalised,
                showFinalised = _ref21$showFinalised === undefined ? false : _ref21$showFinalised;

            this.showingApplication = show;
            if (this.isSendingToAssessor) {
                this.isSendingToAssessor = !show;
            }
            if (this.showingConditions) {

                this.showingConditions = !show;

                if (this.selectedActivity.processing_status.id === 'with_assessor') {

                    this.notOfficerWorkflow = true;
                }
            }
            if (this.isofficerfinalisation) {
                this.approvingApplication = true;
            }
            this.toggleFinalisedTabs(showFinalised);
            setTimeout(function () {
                var main_tabs = $('#tabs-main li');
                var tabno = 0;
                for (var i = 0; i < main_tabs.length; i++) {
                    if (main_tabs[i].innerText === _this13.selected_activity_tab_name) {
                        tabno = i;
                    }
                }
                var selected = $('#tabs-main li a')[tabno];
                if (selected != null) {
                    selected.click();
                }
                _this13.initFirstTab();
            }, 50);
            !showFinalised && this.load({ url: '/api/application/' + this.application.id + '/internal_application.json' });
        },
        toggleConditions: function () {
            var _ref23 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee22(_ref22) {
                var _this14 = this;

                var _ref22$show = _ref22.show,
                    show = _ref22$show === undefined ? false : _ref22$show,
                    _ref22$showFinalised = _ref22.showFinalised,
                    showFinalised = _ref22$showFinalised === undefined ? false : _ref22$showFinalised;
                return _regenerator2.default.wrap(function _callee22$(_context22) {
                    while (1) {
                        switch (_context22.prev = _context22.next) {
                            case 0:
                                this.showingConditions = show;

                                if (!showFinalised) {
                                    _context22.next = 4;
                                    break;
                                }

                                this.toggleApplication({ show: false, showFinalised: showFinalised });
                                return _context22.abrupt('return');

                            case 4:
                                if (!this.showingConditions) {
                                    _context22.next = 11;
                                    break;
                                }

                                this.toggleApplication({ show: false });
                                this.condition_spinner = true;
                                _context22.next = 9;
                                return this.assessmentData({ url: '/api/application/' + this.application.id + '/assessment_data.json' }).then(function () {
                                    var _ref24 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee21(response) {
                                        return _regenerator2.default.wrap(function _callee21$(_context21) {
                                            while (1) {
                                                switch (_context21.prev = _context21.next) {
                                                    case 0:

                                                        _this14.condition_spinner = false;
                                                        _this14.spinner = false;
                                                        _this14.setAssessStatus(false);

                                                    case 3:
                                                    case 'end':
                                                        return _context21.stop();
                                                }
                                            }
                                        }, _callee21, _this14);
                                    }));

                                    return function (_x12) {
                                        return _ref24.apply(this, arguments);
                                    };
                                }(), function (error) {

                                    _this14.condition_spinner = false;
                                    _this14.spinner = false;
                                    console.log(error);
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 9:
                                _context22.next = 12;
                                break;

                            case 11:
                                this.toggleApplication({ show: true, showFinalised: true });

                            case 12:
                            case 'end':
                                return _context22.stop();
                        }
                    }
                }, _callee22, this);
            }));

            function toggleConditions(_x11) {
                return _ref23.apply(this, arguments);
            }

            return toggleConditions;
        }(),
        toggleOfficerConditions: function () {
            var _ref25 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee24() {
                var _this15 = this;

                return _regenerator2.default.wrap(function _callee24$(_context24) {
                    while (1) {
                        switch (_context24.prev = _context24.next) {
                            case 0:
                                this.isSendingToAssessor = !this.isSendingToAssessor;

                                this.approvingApplication = false;
                                this.isofficerfinalisation = false;

                                this.showingApplication = false;

                                this.condition_spinner = true;

                                if (!(!this.hasActionedConditionLink && !this.hasActionedApplicationLink)) {
                                    _context24.next = 8;
                                    break;
                                }

                                _context24.next = 8;
                                return this.assessmentData({ url: '/api/application/' + this.application.id + '/assessment_data.json' }).then(function () {
                                    var _ref26 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee23(response) {
                                        return _regenerator2.default.wrap(function _callee23$(_context23) {
                                            while (1) {
                                                switch (_context23.prev = _context23.next) {
                                                    case 0:

                                                        _this15.condition_spinner = false;
                                                        _this15.spinner = false;
                                                        _this15.setAssessStatus(false);

                                                    case 3:
                                                    case 'end':
                                                        return _context23.stop();
                                                }
                                            }
                                        }, _callee23, _this15);
                                    }));

                                    return function (_x13) {
                                        return _ref26.apply(this, arguments);
                                    };
                                }(), function (error) {

                                    _this15.condition_spinner = false;
                                    _this15.spinner = false;
                                    console.log(error);
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 8:

                                this.showingConditions = true;

                            case 9:
                            case 'end':
                                return _context24.stop();
                        }
                    }
                }, _callee24, this);
            }));

            function toggleOfficerConditions() {
                return _ref25.apply(this, arguments);
            }

            return toggleOfficerConditions;
        }(),
        updateAssignedOfficerSelect: function updateAssignedOfficerSelect() {
            var vm = this;
            $(vm.$refs.assigned_officer).val(vm.selectedActivity.assigned_officer);
            $(vm.$refs.assigned_officer).trigger('change');
        },
        assignToMe: function () {
            var _ref27 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee25() {
                var vm, data;
                return _regenerator2.default.wrap(function _callee25$(_context25) {
                    while (1) {
                        switch (_context25.prev = _context25.next) {
                            case 0:
                                vm = this;

                                vm.selectedActivity.assigned_officer = vm.current_user.id;
                                $(vm.$refs.assigned_officer).val(vm.current_user.id);
                                $(vm.$refs.assigned_offcier).trigger('change');
                                data = {
                                    "activity_id": this.selectedActivity.licence_activity
                                };
                                _context25.next = 7;
                                return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/assign_to_me'), (0, _stringify2.default)(data), {
                                    emulateJSON: true

                                }).then(function (response) {}, function (error) {
                                    vm.revert();
                                    vm.updateAssignedOfficerSelect();
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 7:
                            case 'end':
                                return _context25.stop();
                        }
                    }
                }, _callee25, this);
            }));

            function assignToMe() {
                return _ref27.apply(this, arguments);
            }

            return assignToMe;
        }(),
        updateAssignedApproverSelect: function updateAssignedApproverSelect() {
            var vm = this;
            $(vm.$refs.assigned_approver).val(vm.selectedActivity.assigned_approver);
            $(vm.$refs.assigned_approver).trigger('change');
        },
        refreshFromResponse: function refreshFromResponse(response) {
            var _this16 = this;

            this.setOriginalApplication(response.body);
            this.setApplication(response.body);
            this.$nextTick(function () {
                _this16.initialiseAssignedOfficerSelect(true);
                _this16.updateAssignedOfficerSelect();
            });
        },
        assignOfficer: function () {
            var _ref28 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee26() {
                var _this17 = this;

                var vm, unassign, data;
                return _regenerator2.default.wrap(function _callee26$(_context26) {
                    while (1) {
                        switch (_context26.prev = _context26.next) {
                            case 0:
                                vm = this;
                                unassign = true;
                                data = {};

                                unassign = vm.selectedActivity.assigned_officer != null && vm.selectedActivity.assigned_officer != 'undefined' ? false : true;
                                data = {
                                    'officer_id': vm.selectedActivity.assigned_officer,
                                    "activity_id": this.selectedActivity.licence_activity
                                };

                                if (unassign) {
                                    _context26.next = 10;
                                    break;
                                }

                                _context26.next = 8;
                                return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/assign_officer'), (0, _stringify2.default)(data), {
                                    emulateJSON: true
                                }).then(function (response) {}, function (error) {
                                    _this17.revert();
                                    _this17.updateAssignedOfficerSelect();
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 8:
                                _context26.next = 12;
                                break;

                            case 10:
                                _context26.next = 12;
                                return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/unassign_officer'), (0, _stringify2.default)(data), {
                                    emulateJSON: true
                                }).then(function (response) {}, function (error) {
                                    _this17.revert();
                                    _this17.updateAssignedOfficerSelect();
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 12:
                            case 'end':
                                return _context26.stop();
                        }
                    }
                }, _callee26, this);
            }));

            function assignOfficer() {
                return _ref28.apply(this, arguments);
            }

            return assignOfficer;
        }(),
        assignApprover: function () {
            var _ref29 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee27() {
                var _this18 = this;

                var vm, unassign, data;
                return _regenerator2.default.wrap(function _callee27$(_context27) {
                    while (1) {
                        switch (_context27.prev = _context27.next) {
                            case 0:
                                vm = this;
                                unassign = true;

                                unassign = vm.selectedActivity.assigned_approver == null ? true : false;

                                data = {
                                    "activity_id": this.selectedActivity.licence_activity,
                                    "approver_id": this.selectedActivity.assigned_approver
                                };

                                if (unassign) {
                                    _context27.next = 9;
                                    break;
                                }

                                _context27.next = 7;
                                return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/assign_activity_approver'), (0, _stringify2.default)(data), {
                                    emulateJSON: true
                                }).then(function (response) {}, function (error) {
                                    _this18.revert();
                                    _this18.updateAssignedApproverSelect();
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 7:
                                _context27.next = 11;
                                break;

                            case 9:
                                _context27.next = 11;
                                return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/unassign_activity_approver'), (0, _stringify2.default)(data), {
                                    emulateJSON: true
                                }).then(function (response) {}, function (error) {
                                    _this18.revert();
                                    _this18.updateAssignedOfficerSelect();
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 11:
                            case 'end':
                                return _context27.stop();
                        }
                    }
                }, _callee27, this);
            }));

            function assignApprover() {
                return _ref29.apply(this, arguments);
            }

            return assignApprover;
        }(),
        makeMeApprover: function () {
            var _ref30 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee28() {
                var _this19 = this;

                var vm, data;
                return _regenerator2.default.wrap(function _callee28$(_context28) {
                    while (1) {
                        switch (_context28.prev = _context28.next) {
                            case 0:
                                vm = this;

                                vm.selectedActivity.assigned_approver = vm.current_user.id;
                                $(vm.$refs.assigned_approver).val(vm.current_user.id);
                                $(vm.$refs.assigned_approver).trigger('change');
                                data = {
                                    "activity_id": this.selectedActivity.licence_activity
                                };
                                _context28.next = 7;
                                return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/make_me_activity_approver'), (0, _stringify2.default)(data), {
                                    emulateJSON: true

                                }).then(function (response) {}, function (error) {
                                    _this19.revert();
                                    _this19.updateAssignedApproverSelect();
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 7:
                            case 'end':
                                return _context28.stop();
                        }
                    }
                }, _callee28, this);
            }));

            function makeMeApprover() {
                return _ref30.apply(this, arguments);
            }

            return makeMeApprover;
        }(),
        updateActivityStatus: function () {
            var _ref31 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee29(activity_id, status) {
                var _this20 = this;

                var vm, data;
                return _regenerator2.default.wrap(function _callee29$(_context29) {
                    while (1) {
                        switch (_context29.prev = _context29.next) {
                            case 0:
                                vm = this;
                                data = {
                                    'activity_id': activity_id,
                                    'status': status
                                };
                                _context29.next = 4;
                                return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/update_activity_status'), (0, _stringify2.default)(data), {
                                    emulateJSON: true
                                }).then(function (response) {
                                    _this20.refreshFromResponse(response);
                                }, function (error) {
                                    _this20.revert();
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 4:
                            case 'end':
                                return _context29.stop();
                        }
                    }
                }, _callee29, this);
            }));

            function updateActivityStatus(_x14, _x15) {
                return _ref31.apply(this, arguments);
            }

            return updateActivityStatus;
        }(),
        initialiseAssignedOfficerSelect: function initialiseAssignedOfficerSelect() {
            var reinit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var vm = this;
            if (reinit) {
                $(vm.$refs.assigned_officer).data('select2') ? $(vm.$refs.assigned_officer).select2('destroy') : '';
            }

            $(vm.$refs.assigned_officer).select2({
                "theme": "bootstrap",
                allowClear: true,
                placeholder: "Select Officer"
            }).on("select2:select", function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var selected = $(e.currentTarget);
                vm.selectedActivity.assigned_officer = selected.val();
                vm.assignOfficer();
            }).on("select2:unselecting", function (e) {
                var self = $(this);
                setTimeout(function () {
                    self.select2('close');
                }, 0);
            }).on("select2:unselect", function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var selected = $(e.currentTarget);
                vm.selectedActivity.assigned_officer = null;
                vm.assignOfficer();
            });
        },
        initialiseAssignedApproverSelect: function initialiseAssignedApproverSelect() {
            var reinit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var vm = this;
            if (reinit) {
                $(vm.$refs.assigned_approver).data('select2') ? $(vm.$refs.assigned_approver).select2('destroy') : '';
            }

            $(vm.$refs.assigned_approver).select2({
                theme: "bootstrap",
                allowClear: true,
                placeholder: "Select Approver"
            }).on("select2:select", function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var selected = $(e.currentTarget);
                vm.selectedActivity.assigned_approver = selected.val();
                vm.assignApprover();
            }).on("select2:unselecting", function (e) {
                var self = $(this);
                setTimeout(function () {
                    self.select2('close');
                }, 0);
            }).on("select2:unselect", function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var selected = $(e.currentTarget);
                vm.selectedActivity.assigned_approver = null;
                vm.assignApprover();
            });
        },
        initialiseSelects: function initialiseSelects() {
            if (!this.initialisedSelects) {
                this.initialisedSelects = true;
                this.initMainTab();
            }
            this.initialiseAssignedOfficerSelect();
            this.initialiseAssignedApproverSelect();
        },
        initMainTab: function initMainTab() {
            if (!this.$refs.applicantTab) {
                return;
            }
            this.$refs.applicantTab.click();
            this.initFirstTab(true);
        },
        actionConditionLink: function actionConditionLink() {
            this.hasActionedConditionLink = !this.hasActionedConditionLink;
            this.showingConditions = this.hasActionedConditionLink;

            this.hasActionedActivityTab = false;
            this.hasActionedApplicationLink = false;

            if (this.hasActionedConditionLink) {

                this.isofficerfinalisation = false;
                this.toggleOfficerConditions();
            } else if (this.selectedActivity.processing_status.id === 'with_officer_finalisation') {

                this.toggleIssue();
            } else {

                this.showingConditions = false;
                this.notOfficerWorkflow = false;
                this.toggleApplication({ show: true });
            }
        },
        actionConditionButton: function () {
            var _ref32 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee31() {
                var _this21 = this;

                var is_saved, authorised, workflow;
                return _regenerator2.default.wrap(function _callee31$(_context31) {
                    while (1) {
                        switch (_context31.prev = _context31.next) {
                            case 0:
                                this.approvingApplication = false;
                                this.isofficerfinalisation = false;

                                this.condition_spinner = true;
                                this.spinner = true;
                                is_saved = false;

                                if (this.canRequestAmendment) {
                                    _context31.next = 15;
                                    break;
                                }

                                authorised = this.canAssignOfficerFor(this.selectedActivity.licence_activity);
                                workflow = ['with_officer'].includes(this.selectedActivity.processing_status.id);

                                if (authorised && workflow) {
                                    this.setLicenceTypeData({ 'licence_activity_id': this.selectedActivity.licence_activity, 'workflow': 'assess' });
                                }
                                this.condition_spinner = false;
                                $('#tabs-main li').removeClass('active');
                                this.isSendingToAssessor = !this.isSendingToAssessor;
                                this.showingApplication = false;
                                _context31.next = 17;
                                break;

                            case 15:
                                _context31.next = 17;
                                return this.assessmentData({ url: '/api/application/' + this.application.id + '/assessment_data_and_save.json' }).then(function () {
                                    var _ref33 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee30(response) {
                                        return _regenerator2.default.wrap(function _callee30$(_context30) {
                                            while (1) {
                                                switch (_context30.prev = _context30.next) {
                                                    case 0:
                                                        _this21.condition_spinner = false;
                                                        _this21.spinner = false;

                                                        _this21.setAssessStatus(false);
                                                        _this21.isSendingToAssessor = !_this21.isSendingToAssessor;
                                                        _this21.showingApplication = false;

                                                    case 5:
                                                    case 'end':
                                                        return _context30.stop();
                                                }
                                            }
                                        }, _callee30, _this21);
                                    }));

                                    return function (_x18) {
                                        return _ref33.apply(this, arguments);
                                    };
                                }(), function (error) {

                                    console.log(error);
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 17:
                            case 'end':
                                return _context31.stop();
                        }
                    }
                }, _callee31, this);
            }));

            function actionConditionButton() {
                return _ref32.apply(this, arguments);
            }

            return actionConditionButton;
        }(),
        actionApplicationButton: function () {
            var _ref34 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee32() {
                var authorised, workflow;
                return _regenerator2.default.wrap(function _callee32$(_context32) {
                    while (1) {
                        switch (_context32.prev = _context32.next) {
                            case 0:
                                authorised = this.canAssignOfficerFor(this.selectedActivity.licence_activity);
                                workflow = ['with_officer', 'with_officer_conditions'].includes(this.selectedActivity.processing_status.id);

                                if (!(authorised && workflow)) {
                                    _context32.next = 5;
                                    break;
                                }

                                _context32.next = 5;
                                return this.setLicenceTypeData({ 'licence_activity_id': this.selectedActivity.licence_activity, 'workflow': 'process' });

                            case 5:
                                this.toggleApplication({ show: true });

                            case 6:
                            case 'end':
                                return _context32.stop();
                        }
                    }
                }, _callee32, this);
            }));

            function actionApplicationButton() {
                return _ref34.apply(this, arguments);
            }

            return actionApplicationButton;
        }(),
        actionApplicationLink: function actionApplicationLink() {
            this.hasActionedApplicationLink = !this.hasActionedApplicationLink;

            if (!this.showingApplication && this.hasActionedApplicationLink) {

                this.isofficerfinalisation = false;
                this.toggleApplication({ show: true, showFinalised: false });
            } else if (this.selectedActivity.processing_status.id === 'with_officer_finalisation') {

                this.toggleIssue();
            } else if (this.selectedActivity.processing_status.id === 'with_assessor') {

                this.toggleOfficerConditions();
            } else if (this.selectedActivity.processing_status.id === 'accepted') {

                this.toggleOfficerConditions();
            } else {

                this.toggleApplication({ show: false });
            }
        },
        actionOfficerReturnButton: function () {
            var _ref35 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee34() {
                var _this22 = this;

                return _regenerator2.default.wrap(function _callee34$(_context34) {
                    while (1) {
                        switch (_context34.prev = _context34.next) {
                            case 0:
                                swal({
                                    title: 'Return to Officer - Conditions',
                                    html: '\n                    Please provide the\xA0reason for\xA0returning this licensed activity back to officer for review.\n                    <br>This will be emailed to the licensing officer.\n                ',
                                    input: 'text',
                                    inputAttributes: {
                                        autocapitalize: 'off'
                                    },
                                    showCancelButton: true,
                                    confirmButtonText: 'Return'
                                }).then(function () {
                                    var _ref36 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee33(result) {
                                        var text, data;
                                        return _regenerator2.default.wrap(function _callee33$(_context33) {
                                            while (1) {
                                                switch (_context33.prev = _context33.next) {
                                                    case 0:
                                                        if (result.value) {
                                                            _context33.next = 2;
                                                            break;
                                                        }

                                                        return _context33.abrupt('return');

                                                    case 2:
                                                        text = result.value;
                                                        data = {
                                                            "activity_id": _this22.selectedActivity.licence_activity,
                                                            "text": text
                                                        };
                                                        _context33.next = 6;
                                                        return _this22.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, _this22.application.id + '/return_to_officer'), (0, _stringify2.default)(data)).then(function (response) {

                                                            _this22.$router.push({ name: "internal-dash" });
                                                        }, function (error) {
                                                            _this22.revert();
                                                            swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                                        });

                                                    case 6:
                                                    case 'end':
                                                        return _context33.stop();
                                                }
                                            }
                                        }, _callee33, _this22);
                                    }));

                                    return function (_x19) {
                                        return _ref36.apply(this, arguments);
                                    };
                                }());

                            case 1:
                            case 'end':
                                return _context34.stop();
                        }
                    }
                }, _callee34, this);
            }));

            function actionOfficerReturnButton() {
                return _ref35.apply(this, arguments);
            }

            return actionOfficerReturnButton;
        }(),
        actionApplicantReturnButton: function () {
            var _ref37 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee35() {
                var is_saved;
                return _regenerator2.default.wrap(function _callee35$(_context35) {
                    while (1) {
                        switch (_context35.prev = _context35.next) {
                            case 0:
                                _context35.next = 2;
                                return this.save_wo();

                            case 2:
                                is_saved = _context35.sent;

                                this.spinner = false;

                                if (is_saved) {

                                    this.$refs.amendment_request.amendment.text = '';
                                    this.$refs.amendment_request.isModalOpen = true;
                                }

                            case 5:
                            case 'end':
                                return _context35.stop();
                        }
                    }
                }, _callee35, this);
            }));

            function actionApplicantReturnButton() {
                return _ref37.apply(this, arguments);
            }

            return actionApplicantReturnButton;
        }(),
        actionActivityTab: function actionActivityTab(workflow) {
            var self = this;
            $("[data-target!=''][data-target]").off("click").on("click", function (e) {
                self.setActivityTab({
                    id: parseInt($(this).data('target').replace('#', ''), 10),
                    name: $(this).text()
                });
            });

            this.notOfficerWorkflow = false;

            if (['Applicant', 'IssueApplicant'].includes(workflow)) {

                if (!this.showingApplicant) {

                    this.approvingApplication = false;
                    this.isofficerfinalisation = false;
                    this.isSendingToAssessor = false;
                    this.showingConditions = false;

                    this.toggleApplicant();
                }
            } else {

                this.showingApplicant = false;

                if (this.isFinalised) {

                    return;
                }

                if (workflow.processing_status.name === 'Accepted') {

                    this.notOfficerWorkflow = true;
                    this.approvingApplication = false;
                    this.isofficerfinalisation = false;

                    if (this.showingConditions) {

                        this.showingApplication = false;
                        this.isSendingToAssessor = true;
                    } else if (!this.showingApplication) {

                        this.toggleApplication({ show: true });
                        this.isSendingToAssessor = false;
                    }
                }
                if (workflow.processing_status.name === 'With Officer-Conditions') {

                    if (this.approvingApplication && (this.hasActionedConditionLink || this.hasActionedApplicationLink)) {

                        this.approvingApplication = false;
                        this.isofficerfinalisation = false;
                        this.isSendingToAssessor = false;
                        this.showingConditions = false;
                    }
                    if (!self.isSendingToAssessor) {

                        self.toggleOfficerConditions();
                    }
                }
                if (workflow.processing_status.name === 'With Approver') {

                    if (!this.isofficerfinalisation && !this.hasActionedConditionLink && !this.hasActionedApplicationLink) {
                        if (this.showIssueDeclineButton) {
                            this.toggleIssue();
                        } else {
                            this.approvingApplication = false;
                            this.isofficerfinalisation = false;

                            if (this.showingConditions) {

                                this.showingApplication = false;
                            } else if (!this.showingApplication) {

                                this.toggleApplication({ show: true });
                                this.isSendingToAssessor = true;
                            }
                        }
                    }
                    return;
                }
                if (workflow.processing_status.name === 'With Officer') {

                    if (this.approvingApplication) {

                        this.approvingApplication = false;
                        this.isofficerfinalisation = false;
                        this.isSendingToAssessor = false;
                        this.showingConditions = false;
                    }
                    if (!this.showingApplication) {

                        this.toggleApplication({ show: true });
                    }
                }
                if (workflow.processing_status.name === 'With Assessor') {

                    this.notOfficerWorkflow = true;
                    this.approvingApplication = false;
                    this.isofficerfinalisation = false;

                    if (this.showingConditions) {

                        this.showingApplication = false;
                        this.isSendingToAssessor = true;
                    } else if (!this.showingApplication) {

                        this.toggleApplication({ show: true });
                        this.isSendingToAssessor = false;
                    }
                }
            }
            this.initFirstTab();
            this.hasActionedActivityTab = true;
            this.hasActionedConditionLink = false;
            this.hasActionedApplicationLink = false;
        },
        actionTabListener: function actionTabListener(e) {
            this.actionActivityTab(e.tab);
        }
    }),
    updated: function updated() {
        var vm = this;
        if (!vm.panelClickersInitialised) {
            $('.panelClicker[data-toggle="collapse"]').on('click', function () {
                var chev = $(this).children()[0];
                window.setTimeout(function () {
                    $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
                }, 100);
            });
            vm.panelClickersInitialised = true;
        }
        this.$nextTick(function () {
            vm.initialiseOrgContactTable();
            vm.initialiseSelects();
            vm.form = document.forms.new_application;
        });
    },
    mounted: function mounted() {
        this.showingApplicant = true;
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.load({ url: '/api/application/' + to.params.application_id + '/internal_application.json' }).then(function () {});
            vm.loadCurrentUser({ url: '/api/my_user_details' });
        });
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        next(function (vm) {
            vm.load({ url: '/api/application/' + to.params.application_id + '.json' }).then(function () {});
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var select2 = __webpack_require__(81);
__webpack_require__(20);
__webpack_require__(19);

exports.default = {
    name: 'Condition-Detail',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default
    },
    props: {
        application_id: {
            type: Number,
            required: true
        },
        condition: {
            type: Object,
            required: true
        },
        conditions: {
            type: Array,
            required: true
        },
        licence_activity_tab: {
            type: Number,
            required: true
        },
        purposes: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        return {
            isModalOpen: false,
            form: null,
            return_types: [],
            addingCondition: false,
            updatingCondition: false,
            validation_form: null,
            type: '1',
            errors: false,
            errorString: '',
            successString: '',
            success: false,
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            validDate: false,
            showDueDate: false
        };
    },
    computed: {
        showError: function showError() {
            var vm = this;
            return vm.errors;
        },
        due_date: {
            cache: false,
            get: function get() {
                if (this.condition.due_date == null) {
                    return '';
                } else {
                    return this.condition.due_date;
                }
            }
        }
    },
    watch: {
        due_date: function due_date() {
            this.validDate = moment(this.condition.due_date, 'DD/MM/YYYY').isValid();
        }
    },
    methods: {
        ok: function ok() {
            var vm = this;
            if ($(vm.form).valid()) {
                vm.sendData();
            }
        },
        setShowDueDate: function setShowDueDate(val) {
            var condition = this.conditions.filter(function (e) {
                return e.id == val;
            });
            this.showDueDate = condition[0].require_return;
        },
        cancel: function cancel() {
            this.close();
        },
        close: function close() {
            this.isModalOpen = false;
            $(this.$refs.standard_req).val(null).trigger('change');
            this.errors = false;
            $('.has-error').removeClass('has-error');
            var datePicker = $(this.$refs.due_date).data('DateTimePicker');
            if (datePicker) {
                datePicker.clear();
            }
            this.showDueDate = false;
            this.validation_form.resetForm();
        },
        fetchContact: function fetchContact(id) {
            var vm = this;
            vm.$http.get(_hooks.api_endpoints.contact(id)).then(function (response) {
                vm.contact = response.body;vm.isModalOpen = true;
            }, function (error) {
                console.log(error);
            });
        },
        fetchReturnTypes: function fetchReturnTypes() {
            var _this = this;

            this.$http.get(_hooks.api_endpoints.return_types).then(function (response) {
                _this.return_types = response.body;
            }, function (error) {
                console.log(error);
            });
        },

        sendData: function sendData() {
            var vm = this;
            vm.errors = false;
            vm.condition.licence_activity = vm.licence_activity_tab;
            var condition = JSON.parse((0, _stringify2.default)(vm.condition));
            if (condition.standard) {
                condition.free_condition = '';
            } else {
                condition.standard_condition = '';
                $(this.$refs.standard_req).val(null).trigger('change');
            }
            if (!condition.due_date) {
                condition.due_date = null;
                condition.return_type = null;
                condition.recurrence = false;
                delete condition.recurrence_pattern;
                condition.recurrence_schedule ? delete condition.recurrence_schedule : '';
            }
            if (vm.condition.id) {
                vm.updatingCondition = true;
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.application_conditions, condition.id + '/update_condition'), (0, _stringify2.default)(condition), {
                    emulateJSON: true
                }).then(function (response) {
                    vm.updatingCondition = false;
                    vm.$parent.updatedConditions();
                    vm.close();
                }, function (error) {
                    vm.errors = true;
                    vm.errorString = _hooks.helpers.apiVueResourceError(error);
                    vm.updatingCondition = false;
                });
            } else {
                vm.addingCondition = true;
                vm.$http.post(_hooks.api_endpoints.application_conditions, (0, _stringify2.default)(condition), {
                    emulateJSON: true
                }).then(function (response) {
                    vm.addingCondition = false;
                    vm.close();
                    vm.$parent.updatedConditions();
                }, function (error) {
                    vm.errors = true;
                    vm.addingCondition = false;
                    vm.errorString = _hooks.helpers.apiVueResourceError(error);
                });
            }
        },
        addFormValidations: function addFormValidations() {
            var vm = this;
            vm.validation_form = $(vm.form).validate({
                rules: {
                    standard_condition: {
                        required: {
                            depends: function depends(el) {
                                return vm.condition.standard;
                            }
                        }
                    },
                    free_condition: {
                        required: {
                            depends: function depends(el) {
                                return !vm.condition.standard;
                            }
                        }
                    },
                    schedule: {
                        required: {
                            depends: function depends(el) {
                                return vm.condition.recurrence;
                            }
                        }
                    }
                },
                messages: {
                    arrival: "field is required",
                    departure: "field is required",
                    campground: "field is required",
                    campsite: "field is required"
                },
                showErrors: function showErrors(errorMap, errorList) {
                    $.each(this.validElements(), function (index, element) {
                        var $element = $(element);
                        $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                    });

                    $("." + this.settings.validClass).tooltip("destroy");

                    for (var i = 0; i < errorList.length; i++) {
                        var error = errorList[i];
                        $(error.element).tooltip({
                            trigger: "focus"
                        }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                    }
                }
            });
        },
        setConditionSelector: function setConditionSelector() {
            var vm = this;

            $(vm.$refs.standard_req).select2({
                "theme": "bootstrap",
                allowClear: true,
                minimumInputLength: 2,
                placeholder: "Select Condition..."
            }).on("select2:selecting", function (e) {
                var selected = $(e.currentTarget);
                vm.showDueDate = false;
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                vm.condition.standard_condition = selected.val();
                vm.setShowDueDate(selected.val());
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                vm.condition.standard_condition = selected.val();
            });
        },
        setPurposeSelector: function setPurposeSelector() {
            var vm = this;

            $(vm.$refs.select_purpose).select2({
                "theme": "bootstrap",
                allowClear: true,
                placeholder: "Select Purpose..."
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                vm.condition.licence_purpose = selected.val();
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                vm.condition.licence_purpose = selected.val();
            });
        },
        eventListeners: function eventListeners() {
            var vm = this;
            vm.setConditionSelector();
            vm.setPurposeSelector();
        }
    },
    updated: function updated() {
        var vm = this;
        vm.setPurposeSelector();
        vm.setConditionSelector();
        if (vm.condition.free_condition || vm.condition.due_date) {
            vm.showDueDate = true;
        }

        if (!vm.condition.standard || vm.showDueDate) {
            $(vm.$refs.due_date).datetimepicker(vm.datepickerOptions);
            $(vm.$refs.due_date).on('dp.change', function (e) {
                if ($(vm.$refs.due_date).data('DateTimePicker').date()) {
                    vm.condition.due_date = e.date.format('DD/MM/YYYY');
                } else if ($(vm.$refs.due_date).data('date') === "") {
                    vm.condition.due_date = "";
                }
            });
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.form = document.forms.conditionForm;
        vm.addFormValidations();
        vm.fetchReturnTypes();
        this.$nextTick(function () {
            vm.eventListeners();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, swal, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _form = __webpack_require__(96);

var _form2 = _interopRequireDefault(_form);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _vuex = __webpack_require__(6);

var _application_conditions = __webpack_require__(843);

var _application_conditions2 = _interopRequireDefault(_application_conditions);

var _application_send_assessor = __webpack_require__(846);

var _application_send_assessor2 = _interopRequireDefault(_application_send_assessor);

var _responsive_datatable_helper = __webpack_require__(50);

var _responsive_datatable_helper2 = _interopRequireDefault(_responsive_datatable_helper);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ApplicationAssessments',
    data: function data() {
        var vm = this.$parent;
        return {
            assessment: {
                id: "",
                comment: ""
            },
            datepickerInitialised: false,
            isModalOpen: false,
            assessorsBody: 'assessorsBody' + vm._uid,
            assessorGroup: [],
            panelBody: 'assessment-details-' + vm._uid,
            "selectedAssessor": {},
            application_assessor_datatable: vm._uid + 'assessment-table',
            assessors_headers: ["Assessor Group", "Date Sent", "Status", "Final Comments", "Action"],
            assessors_options: {},
            DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
            viewingAssessmentId: null,
            savingAssessment: false,
            showSendToAssessorButton: true
        };
    },
    components: {
        datatable: _datatable2.default,
        modal: _bootstrapModal2.default,
        Application: _form2.default,
        Conditions: _application_conditions2.default,
        SendToAssessor: _application_send_assessor2.default
    },
    props: {
        final_view_conditions: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format('DD/MM/YYYY HH:mm:ss') : '';
        }
    },
    watch: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application', 'original_application', 'licence_type_data', 'selected_activity_tab_id', 'selected_activity_tab_name', 'hasRole', 'visibleConditionsFor', 'licenceActivities', 'checkActivityStatus', 'isPartiallyFinalised', 'isFinalised', 'isApplicationLoaded', 'isApplicationActivityVisible', 'unfinishedActivities', 'current_user', 'sendToAssessorActivities', 'canAssignOfficerFor', 'allCurrentActivities', 'allCurrentActivitiesWithAssessor']), {
        applicationDetailsVisible: function applicationDetailsVisible() {
            var _this = this;

            this.$nextTick(function () {
                _this.eventListeners();
            });
            return true;
        },
        isCompleteAssessmentAction: function isCompleteAssessmentAction() {
            return this.$router.currentRoute.name === 'complete-assessment';
        },
        applicationActivities: function applicationActivities() {

            if (this.isCompleteAssessmentAction) {
                return this.allCurrentActivitiesWithAssessor;
            }
            return this.licenceActivities();
        },
        selectedActivity: function selectedActivity() {
            var activities_list = this.licence_type_data.activity;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(activities_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var activity = _step.value;

                    if (activity.id == this.selected_activity_tab_id) {
                        return activity;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return null;
        },
        isLicensingOfficer: function isLicensingOfficer() {
            var has_role = this.userHasRole('licensing_officer', this.selected_activity_tab_id);
            var workflow = this.selectedActivity.processing_status.id === 'with_officer_conditions';
            return has_role && workflow;
        },
        canCompleteAssessment: function canCompleteAssessment() {
            if (!this.userHasRole('assessor', this.selected_activity_tab_id)) {
                return false;
            }
            if (this.assessment.status && this.assessment.status.id != 'awaiting_assessment') {
                return false;
            }
            return this.selected_activity_tab_id && this.selectedActivity.processing_status.id == 'with_assessor' ? true : false;
        },
        canSendToAssessor: function canSendToAssessor() {
            var _this2 = this;

            this.showSendToAssessorButton = false;
            if (this.$router.currentRoute.name == 'complete-assessment') {
                return null;
            }
            if (!this.canAssignOfficerFor(this.selected_activity_tab_id)) {
                return null;
            }

            var selectedActivity = this.application.activities.find(function (activity) {
                return activity.licence_activity === _this2.selected_activity_tab_id;
            });
            if (selectedActivity.assigned_officer != null && selectedActivity.assigned_officer !== this.current_user.id) {
                return false;
            };

            if (selectedActivity.processing_status.id !== 'with_officer_conditions') {
                return false;
            }

            return this.sendToAssessorActivities.filter(function (visible_activity) {
                if (visible_activity.id != _this2.selected_activity_tab_id) {
                    return false;
                }
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)(_this2.assessorGroup), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var assessor = _step2.value;

                        if (assessor.licence_activities && assessor.licence_activities.filter(function (activity) {
                            if (activity.id === visible_activity.id) {

                                return true;
                            }
                            return false;
                        }).length) {
                            if (!_this2.isAssessorAssigned(assessor, visible_activity.id)) {

                                if (_this2.selectedAssessor.id == null || !_this2.assessorInGroup(_this2.selectedAssessor.id)) {
                                    _this2.selectedAssessor = assessor;
                                }
                                _this2.showSendToAssessorButton = true;
                                return true;
                            };
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return false;
            }).length;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        load: 'loadApplication',
        revert: 'revertApplication'
    }), (0, _vuex.mapActions)(['setApplication', 'setActivityTab']), {
        close: function close() {
            this.isModalOpen = false;
        },
        openAssessmentModal: function openAssessmentModal(assessment_id) {
            var _this3 = this;

            this.isModalOpen = true;
            this.viewingAssessmentId = assessment_id;
            this.$http.get('' + _hooks.api_endpoints.assessment + this.viewingAssessmentId).then(function (response) {
                _this3.assessment = response.body;
            }, function (error) {
                console.log(error);
            });
        },
        saveAssessmentData: function saveAssessmentData(e) {
            var _this4 = this;

            return new _promise2.default(function (resolve, reject) {
                var formData = new FormData(_this4.form);
                formData.append('final_comment', _this4.assessment.final_comment);
                _this4.$http.put(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.assessment, _this4.assessment.id + '/update_assessment'), formData, {
                    emulateJSON: true
                }).then(function (res) {
                    resolve(res);
                }, function (err) {
                    reject(err);
                });
            });
        },
        saveAssessment: function saveAssessment(e) {
            var _this5 = this;

            this.savingAssessment = true;
            this.saveAssessmentData().then(function () {
                swal('Save Assessment', 'Your assessment has been saved.', 'success').then(function (result) {
                    _this5.savingAssessment = false;
                });
            }, function (error) {
                swal('Error', 'There was an error saving your assessment', 'error').then(function (result) {
                    _this5.savingAssessment = false;
                });
            });
        },
        canEditAssessment: function canEditAssessment(assessment) {
            return assessment.assigned_assessor && assessment.assigned_assessor.id === this.current_user.id;
        },
        userHasRole: function userHasRole(role, activity_id) {
            var _this6 = this;

            var selectedActivity = this.application.activities.find(function (activity) {
                return activity.licence_activity === _this6.selected_activity_tab_id;
            });
            if (selectedActivity.assigned_officer != null && selectedActivity.assigned_officer !== this.current_user.id) {
                return false;
            };

            return this.hasRole(role, activity_id);
        },
        getVisibleConditionsFor: function getVisibleConditionsFor(for_role, processing_status, tab_id) {
            return this.visibleConditionsFor(for_role, processing_status, tab_id);
        },
        initFirstTab: function initFirstTab(force) {
            var _this7 = this;

            if (this.selected_activity_tab_id && !force) {

                var tabs = $('#tabs-main li');
                for (var i = 0; i < tabs.length; i++) {

                    if (tabs[i].innerText === this.selected_activity_tab_name) {
                        tab = $('#tabs-main li a')[i];
                    }
                }
                if (tab) {

                    tab.click();
                }
                return;
            }
            var tab = null;
            var first_tab = null;
            if (this.isCompleteAssessmentAction) {
                first_tab = this.selected_activity_tab_id;

                var _tabs = $('#tabs-main li');
                for (var _i = 0; _i < _tabs.length; _i++) {

                    if (_tabs[_i].innerText === this.selected_activity_tab_name) {
                        tab = $('#tabs-main li a')[_i];
                    }
                }
            } else {

                first_tab = this.applicationActivities[0].id;
            }
            if (tab) {

                tab.click();
            } else {

                this.licenceActivities().filter(function (activity) {
                    if (activity.id == first_tab) {

                        _this7.setActivityTab({ id: activity.id, name: activity.name });
                    }
                });
            }
        },
        assessorInGroup: function assessorInGroup(assessor_id) {
            return this.assessorGroup.filter(function (assessor) {
                return assessor.id == assessor_id;
            }).length;
        },
        isActivityVisible: function isActivityVisible(activity_id) {
            return 1;
        },
        isAssessorRelevant: function isAssessorRelevant(assessor, activity_id) {
            if (!activity_id) {
                activity_id = this.selected_activity_tab_id;
            }
            if (!assessor.licence_activities) {
                return false;
            }
            var isForActivity = assessor.licence_activities.find(function (activity) {

                return activity.id === activity_id;
            });

            return isForActivity && !this.isAssessorAssigned(assessor, activity_id);
        },
        isAssessorAssigned: function isAssessorAssigned(assessor, activity_id) {
            return this.application.assessments.find(function (assessment) {

                return assessment.assessor_group.id === assessor.id && assessment.licence_activity === activity_id;
            });
        },

        sendtoAssessor: function sendtoAssessor(item1) {
            var vm = this;
            this.$refs.send_to_assessor.assessment.licence_activity = item1;
            this.$refs.send_to_assessor.assessment.assessor_group = this.selectedAssessor.id;
            this.$refs.send_to_assessor.assessment.assessor_group_name = this.selectedAssessor.display_name;
            this.$refs.send_to_assessor.assessment.licence_activity = this.selected_activity_tab_id;
            this.$refs.send_to_assessor.assessment.text = '';
            if (this.selectedAssessor.id == null || this.selectedAssessor.display_name == null) {
                swal('Error', 'Please select an Assessor Group to send the request to.', 'error');
            } else {
                this.$refs.send_to_assessor.isModalOpen = true;
            }
        },
        selectApplicantTab: function selectApplicantTab() {
            this.$emit('action-tab', { tab: 'Applicant' });
        },
        clearSendToAssessorForm: function clearSendToAssessorForm(item) {
            if (this.$refs.send_to_assessor) {

                this.$refs.send_to_assessor.assessment.text = '';
            }
            this.selectedAssessor = {};
            this.$emit('action-tab', { tab: item });
        },

        hasActivityStatus: function hasActivityStatus(status_list) {
            var status_count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var required_role = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return this.checkActivityStatus(status_list, status_count, required_role);
        },
        setAssessorTab: function setAssessorTab(_index) {
            return _index === 0 ? 'active' : '';
        },

        refreshAssessorDatatables: function refreshAssessorDatatables() {
            this.$refs.assessorDatatable.vmDataTable.ajax.reload();
        },
        completeAssessment: function completeAssessment() {
            var _this8 = this;

            this.saveAssessmentData().then(function () {
                var data = new FormData();

                data.selected_assessment_tab = _this8.selected_activity_tab_id;
                data.application_id = _this8.application.id;

                _this8.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, _this8.application.id + '/complete_assessment'), {
                    "selected_assessment_tab": _this8.selected_activity_tab_id,
                    "application_id": _this8.application_id,
                    "assessment_id": _this8.viewingAssessmentId
                }).then(function (response) {
                    _this8.refreshAssessorDatatables();
                    _this8.close();
                    swal('Complete Assessment', 'The assessment has been successfully completed', 'success');
                }, function (error) {
                    _this8.revert();
                    swal('Error', _hooks.helpers.apiVueResourceError(error), 'error');
                });
            }, function (error) {
                swal('Error', _hooks.helpers.apiVueResourceError(error), 'error');
            });
        },
        refreshFromResponse: function refreshFromResponse(response) {
            this.$parent.refreshFromResponse(response);
            this.fetchAssessorGroup();
            this.refreshAssessorDatatables();
        },
        fetchAssessorGroup: function fetchAssessorGroup() {
            var _this9 = this;

            var data = { 'application_id': this.application.id };
            this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.assessor_group, 'user_list'), (0, _stringify2.default)(data), {
                emulateJSON: true
            }).then(function (response) {
                _this9.assessorGroup = response.body;
            }, function (error) {
                console.log(error);
            });
        },
        initialiseAssessmentOptions: function initialiseAssessmentOptions() {
            if (!this.isApplicationLoaded) {
                return false;
            }
            var vm = this;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(this.licence_type_data.activity), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var activity = _step3.value;

                    if (this.assessors_options[activity.id] != null) {
                        continue;
                    }
                    this.assessors_options[activity.id] = {
                        language: {
                            processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                        },
                        responsive: true,
                        ajax: {
                            "url": _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications, this.application.id + '/assessment_details/?licence_activity=' + activity.id),
                            "dataSrc": ''
                        },
                        columns: [{ data: 'assessor_group.display_name' }, { data: 'date_last_reminded' }, { data: 'status.name' }, { data: 'final_comment' }, {
                            data: "id",
                            mRender: function mRender(data, type, full) {
                                var links = '';
                                var pending = full.status.id === 'awaiting_assessment';
                                if (['completed', 'recalled'].includes(full.status.id) && vm.userHasRole('licensing_officer', vm.selected_activity_tab_id)) {
                                    links += '\n                                        <a data-assessmentid=\'' + full.id + '\' class="assessment-action assessment_resend">Resend</a>\n                                    ';
                                } else if (pending && vm.userHasRole('licensing_officer', vm.selected_activity_tab_id)) {
                                    links += '\n                                        <a data-assessmentid=\'' + full.id + '\' class="assessment-action assessment_remind">Remind</a>\n                                        <a data-assessmentid=\'' + full.id + '\' class="assessment-action assessment_recall">Recall</a>\n                                    ';
                                }
                                if (!vm.isCompleteAssessmentAction) {
                                    links += '\n                                        <a data-assessmentid=\'' + full.id + '\' class="assessment-action assessment_view">' + (pending && vm.canEditAssessment(full) ? 'Edit' : 'View') + '</a>\n                                    ';
                                }

                                return links;
                            } }],
                        processing: true
                    };
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return true;
        },
        optionsLoadedForActivity: function optionsLoadedForActivity(activity) {
            return this.assessors_options[activity.id] != null;
        },

        readFileInspectionReport: function readFileInspectionReport() {
            var _file = null;
            var input = $(this.$refs.inspection_report)[0];
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = input.files[0];
            }
            this.assessment.inspection_report = _file;
        },
        eventListeners: function eventListeners() {
            var _this10 = this;

            var vm = this;
            this.initFirstTab();

            if (!this.$refs.assessorDatatable) {
                return false;
            }

            this.$refs.assessorDatatable.vmDataTable.on('click', '.assessment_remind', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();

                var assessment_id = $(e.target).data('assessmentid');
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.assessment, assessment_id + '/remind_assessment')).then(function (response) {
                    swal('Sent', 'An email has been sent to assessor with the request to assess this Application', 'success');
                    vm.refreshAssessorDatatables();
                }, function (error) {
                    console.log(error);
                    vm.errors = true;
                    vm.errorString = _hooks.helpers.apiVueResourceError(error);
                });
            });

            this.$refs.assessorDatatable.vmDataTable.on('click', '.assessment_resend', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();

                var assessment_id = $(e.target).data('assessmentid');
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.assessment, assessment_id + '/resend_assessment')).then(function (response) {
                    swal('Sent', 'An email has been sent to assessor with the request to re-assess this Application', 'success');
                    vm.refreshAssessorDatatables();
                    vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/internal_application')).then(function (res) {
                        vm.refreshFromResponse(res);
                    });
                }, function (error) {
                    console.log(error);
                    vm.errors = true;
                    vm.errorString = _hooks.helpers.apiVueResourceError(error);
                });
            });

            this.$refs.assessorDatatable.vmDataTable.on('click', '.assessment_recall', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();

                var assessment_id = $(e.target).data('assessmentid');
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.assessment, assessment_id + '/recall_assessment')).then(function (response) {
                    swal('Success', 'An assessment for this Application has been recalled', 'success');
                    vm.refreshAssessorDatatables();
                    vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/internal_application')).then(function (res) {
                        vm.refreshFromResponse(res);
                    });
                }, function (error) {
                    console.log(error);
                    vm.errors = true;
                    vm.errorString = _hooks.helpers.apiVueResourceError(error);
                });
            });

            this.$refs.assessorDatatable.vmDataTable.on('click', '.assessment_view', function (e) {
                var assessment_id = $(e.target).data('assessmentid');
                _this10.openAssessmentModal(assessment_id);
                e.preventDefault();
            });
        }
    }),
    mounted: function mounted() {
        this.fetchAssessorGroup();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(2)))

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _hooks = __webpack_require__(3);

__webpack_require__(347);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _application_add_condition = __webpack_require__(842);

var _application_add_condition2 = _interopRequireDefault(_application_add_condition);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'InternalApplicationConditions',
    props: {
        activity: {
            type: Object | null,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        return {
            form: null,
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                allowInputToggle: true
            },
            panelBody: "application-conditions-" + vm._uid,
            viewedCondition: {},
            conditions: [],
            purposes: [],
            condition_headers: ["Condition", "Purpose", "Source", "Due Date", "Recurrence", "Action", "Order"],
            condition_options: {
                autoWidth: false,
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications, this.$store.getters.application.id + '/conditions/?licence_activity=' + this.$store.getters.selected_activity_tab_id),
                    "dataSrc": ''
                },
                order: [],
                columns: [{
                    data: "condition",
                    mRender: function mRender(data, type, full) {
                        return data ? data.substring(0, 80) : '';
                    },
                    orderable: false
                }, {
                    data: "purpose_name",
                    orderable: false
                }, {
                    data: "source_name",
                    orderable: false
                }, {
                    data: "due_date",
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format('DD/MM/YYYY') : '';
                    },
                    orderable: false
                }, {
                    data: "recurrence",
                    mRender: function mRender(data, type, full) {
                        if (full.recurrence) {
                            switch (full.recurrence_pattern) {
                                case 1:
                                case "weekly":
                                    return 'Once per ' + full.recurrence_schedule + ' week(s)';
                                case 2:
                                case "monthly":
                                    return 'Once per ' + full.recurrence_schedule + ' month(s)';
                                case 3:
                                case "yearly":
                                    return 'Once per ' + full.recurrence_schedule + ' year(s)';
                                default:
                                    return '';
                            }
                        }
                        return '';
                    },
                    orderable: false
                }, {
                    data: "source_group",
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        if (full.source_group && vm.activity.processing_status.id !== 'with_officer_finalisation') {
                            links = '\n                                    <a href=\'#\' class="editCondition" data-id="' + full.id + '">Edit</a><br/>\n                                    <a href=\'#\' class="deleteCondition" data-id="' + full.id + '">Delete</a><br/>\n                                ';
                        }
                        if (!full.source_group && vm.canEditConditions) {
                            links = '\n                                    <a href=\'#\' class="editCondition" data-id="' + full.id + '">Edit</a><br/>\n                                    <a href=\'#\' class="deleteCondition" data-id="' + full.id + '">Delete</a><br/>\n                                ';
                        }
                        return links;
                    },
                    orderable: false
                }, {
                    data: "id",
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        if (vm.canEditConditions) {
                            links += '<a class="dtMoveUp" data-id="' + full.id + '" href=\'#\'><i class="fa fa-angle-up"></i></a><br/>';
                            links += '<a class="dtMoveDown" data-id="' + full.id + '" href=\'#\'><i class="fa fa-angle-down"></i></a><br/>';
                        }
                        return links;
                    },
                    orderable: false
                }],
                processing: true,
                rowCallback: function rowCallback(row, data, index) {
                    if (data.return_type && !data.due_date) {
                        $('td', row).css('background-color', 'Red');
                        vm.setActivityTabWorkflowState({ tab_id: vm.selected_activity_tab_id, bool: true });
                    }
                },
                drawCallback: function drawCallback(settings) {
                    if (vm.$refs.conditions_datatable) {
                        $(vm.$refs.conditions_datatable.table).find('tr:last .dtMoveDown').remove();
                        $(vm.$refs.conditions_datatable.table).children('tbody').find('tr:first .dtMoveUp').remove();
                    }

                    $('.dtMoveUp').unbind('click');
                    $('.dtMoveDown').unbind('click');

                    $('.dtMoveUp').click(vm.moveUp);
                    $('.dtMoveDown').click(vm.moveDown);
                },
                preDrawCallback: function preDrawCallback(settings) {
                    vm.setActivityTabWorkflowState({ tab_id: vm.selected_activity_tab_id, bool: false });
                }
            }
        };
    },
    watch: {},
    components: {
        datatable: _datatable2.default,
        ConditionDetail: _application_add_condition2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application', 'selected_activity_tab_id', 'hasRole', 'sendToAssessorActivities', 'canEditAssessmentFor', 'current_user', 'canAssignOfficerFor']), {
        canAddConditions: function canAddConditions() {
            var _this = this;

            if (!this.selected_activity_tab_id || this.activity == null) {
                return false;
            }

            var selectedActivity = this.application.activities.find(function (activity) {
                return activity.licence_activity === _this.selected_activity_tab_id;
            });

            var required_role = false;
            if (this.activity.processing_status.id === 'with_assessor') {
                var assessment = this.canEditAssessmentFor(this.selected_activity_tab_id);
                required_role = assessment && assessment.assessors.find(function (assessor) {
                    return assessor.id === _this.current_user.id;
                }) ? 'assessor' : false;
            } else if (this.activity.processing_status.id === 'with_officer') {
                required_role = this.canAssignOfficerFor(this.selected_activity_tab_id) ? 'licensing_officer' : false;
                if (selectedActivity.assigned_officer != null && selectedActivity.assigned_officer !== this.current_user.id) {
                    required_role = false;
                };
            } else if (this.activity.processing_status.id === 'with_officer_conditions') {
                required_role = this.canAssignOfficerFor(this.selected_activity_tab_id) ? 'licensing_officer' : false;
                if (selectedActivity.assigned_officer != null && selectedActivity.assigned_officer !== this.current_user.id) {
                    required_role = false;
                };
            }

            if (required_role && !['with_assessor', 'with_officer_conditions'].includes(selectedActivity.processing_status.id)) {
                required_role = false;
            }

            return required_role && this.hasRole(required_role, this.selected_activity_tab_id);
        },
        canEditConditions: function canEditConditions() {
            var _this2 = this;

            if (!this.selected_activity_tab_id || this.activity == null) {
                return false;
            }

            var selectedActivity = this.application.activities.find(function (activity) {
                return activity.licence_activity === _this2.selected_activity_tab_id;
            });
            if (selectedActivity.assigned_officer != null && selectedActivity.assigned_officer !== this.current_user.id) {
                return false;
            };

            var required_role = false;
            switch (this.activity.processing_status.id) {
                case 'with_assessor':
                    required_role = false;
                    break;
                case 'with_officer_conditions':
                    required_role = this.canAssignOfficerFor(this.selected_activity_tab_id) ? 'licensing_officer' : false;
                    break;
            }

            if (selectedActivity.processing_status.id !== 'with_officer_conditions') {
                required_role = false;
            }

            return required_role && this.hasRole(required_role, this.selected_activity_tab_id);
        },
        isLicensingOfficer: function isLicensingOfficer() {
            return this.hasRole('licensing_officer', this.selected_activity_tab_id);
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setActivityTabWorkflowState']), {
        addCondition: function addCondition(preloadedCondition) {
            var showDueDate = false;
            if (preloadedCondition) {
                this.viewedCondition = preloadedCondition;
                this.viewedCondition.due_date = preloadedCondition.due_date != null ? moment(preloadedCondition.due_date).format('DD/MM/YYYY') : '';
                showDueDate = this.viewedCondition.require_return;
            } else {
                this.viewedCondition = {
                    standard: true,
                    recurrence: false,
                    due_date: '',
                    free_condition: '',
                    recurrence_pattern: 'weekly',
                    application: this.application.id
                };
            }
            this.$refs.condition_detail.showDueDate = showDueDate;
            this.$refs.condition_detail.licence_activity = this.selected_activity_tab_id;
            this.$refs.condition_detail.isModalOpen = true;
        },
        removeCondition: function removeCondition(_id) {
            var vm = this;
            swal({
                title: "Remove Condition",
                text: "Are you sure you want to remove this condition?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: 'Remove Condition',
                confirmButtonColor: '#d9534f'
            }).then(function (result) {
                if (result.value) {
                    vm.$http.delete(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.application_conditions, _id + '/delete')).then(function (response) {
                        vm.$refs.conditions_datatable.vmDataTable.ajax.reload();
                    }, function (error) {
                        console.log(error);
                    });
                }
            }, function (error) {});
        },
        fetchConditions: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var vm;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = this;
                                _context.next = 3;
                                return vm.$http.get(_hooks.api_endpoints.application_standard_conditions).then(function (response) {
                                    vm.conditions = response.body;
                                }, function (error) {
                                    console.log(error);
                                });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchConditions() {
                return _ref.apply(this, arguments);
            }

            return fetchConditions;
        }(),
        fetchPurposes: function fetchPurposes() {
            var _this3 = this;

            this.purposes = [];
            var selectedActivity = this.application.activities.find(function (activity) {
                return activity.licence_activity === _this3.selected_activity_tab_id;
            });
            this.purposes = selectedActivity.purposes;
        },
        editCondition: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_id) {
                var _this4 = this;

                var vm;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                vm = this;
                                _context2.next = 3;
                                return vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.application_conditions, _id)).then(function (response) {
                                    response.body.standard ? $(_this4.$refs.condition_detail.$refs.standard_req).val(response.body.standard_condition).trigger('change') : '';
                                    _this4.addCondition(response.body);
                                }, function (error) {
                                    console.log(error);
                                });

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function editCondition(_x) {
                return _ref2.apply(this, arguments);
            }

            return editCondition;
        }(),
        updatedConditions: function updatedConditions() {
            if (this.$refs.conditions_datatable.vmDataTable) {
                this.$refs.conditions_datatable.vmDataTable.ajax.reload();
            }
        },
        eventListeners: function eventListeners() {
            var vm = this;
            if (vm.$refs.conditions_datatable == null) {
                return;
            }
            vm.$refs.conditions_datatable.vmDataTable.on('click', '.deleteCondition', function (e) {
                e.preventDefault();
                var id = $(this).attr('data-id');
                vm.removeCondition(id);
            });
            vm.$refs.conditions_datatable.vmDataTable.on('click', '.editCondition', function (e) {
                e.preventDefault();
                var id = $(this).attr('data-id');
                vm.editCondition(id);
            });
            vm.$refs.conditions_datatable.vmDataTable.on('click', '.dtMoveUp', function (e) {
                e.preventDefault();
                var id = $(this).attr('data-id');
                vm.moveUp(e);
            });
            vm.$refs.conditions_datatable.vmDataTable.on('click', '.dtMoveDown', function (e) {
                e.preventDefault();
                var id = $(this).attr('data-id');
                vm.moveDown(e);
            });
        },
        sendDirection: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(req, direction) {
                var movement;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                movement = direction == 'down' ? 'move_down' : 'move_up';
                                _context3.next = 3;
                                return this.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.application_conditions, req + '/' + movement)).then(function (response) {}, function (error) {
                                    console.log(error);
                                });

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function sendDirection(_x2, _x3) {
                return _ref3.apply(this, arguments);
            }

            return sendDirection;
        }(),
        moveUp: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(e) {
                var vm, tr;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                vm = this;

                                e.preventDefault();
                                tr = $(e.target).parents('tr');
                                _context4.next = 5;
                                return vm.moveRow(tr, 'up', $(e.target).parent().data('id'));

                            case 5:
                                if (!_context4.sent) {
                                    _context4.next = 8;
                                    break;
                                }

                                _context4.next = 8;
                                return vm.sendDirection($(e.target).parent().data('id'), 'up');

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function moveUp(_x4) {
                return _ref4.apply(this, arguments);
            }

            return moveUp;
        }(),
        moveDown: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(e) {
                var vm, tr;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                e.preventDefault();
                                vm = this;
                                tr = $(e.target).parents('tr');
                                _context5.next = 5;
                                return vm.moveRow(tr, 'down', $(e.target).parent().data('id'));

                            case 5:
                                if (!_context5.sent) {
                                    _context5.next = 8;
                                    break;
                                }

                                _context5.next = 8;
                                return vm.sendDirection($(e.target).parent().data('id'), 'down');

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function moveDown(_x5) {
                return _ref5.apply(this, arguments);
            }

            return moveDown;
        }(),
        moveRow: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(row, direction, id) {
                var table, data, index, i, order, new_index, selected, replaced, old_data, new_data, _i;

                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                table = this.$refs.conditions_datatable.vmDataTable;
                                data = table.data();
                                index = -1;
                                i = 0;

                            case 4:
                                if (!(i < data.length)) {
                                    _context6.next = 13;
                                    break;
                                }

                                if (!(data[i].id == id)) {
                                    _context6.next = 10;
                                    break;
                                }

                                if (!(direction === 'down' && i + 1 === table.data().length || direction === 'up' && i === 0)) {
                                    _context6.next = 8;
                                    break;
                                }

                                return _context6.abrupt('return', false);

                            case 8:
                                index = i;
                                return _context6.abrupt('break', 13);

                            case 10:
                                i++;
                                _context6.next = 4;
                                break;

                            case 13:
                                order = -1;

                                if (direction === 'down') {
                                    order = 1;
                                }
                                new_index = index + order;

                                if (new_index < 0) {
                                    new_index = 1;
                                }
                                if (new_index > table.data().length - 1) {
                                    new_index = table.data().length - 2;
                                }
                                selected = table.rows(index).data();
                                replaced = table.rows(new_index).data();

                                order = selected.order;
                                selected.order = replaced.order;
                                replaced.order = order;
                                old_data = table.data();
                                new_data = table.data();
                                _i = 0;

                            case 26:
                                if (!(_i < old_data.length)) {
                                    _context6.next = 37;
                                    break;
                                }

                                if (!(_i === new_index)) {
                                    _context6.next = 30;
                                    break;
                                }

                                new_data[_i] = selected[0];
                                return _context6.abrupt('continue', 34);

                            case 30:
                                if (!(_i === index)) {
                                    _context6.next = 33;
                                    break;
                                }

                                new_data[_i] = replaced[0];
                                return _context6.abrupt('continue', 34);

                            case 33:
                                new_data[_i] = old_data[_i];

                            case 34:
                                _i++;
                                _context6.next = 26;
                                break;

                            case 37:
                                table.clear();
                                table.rows.add(new_data);
                                table.draw();
                                return _context6.abrupt('return', true);

                            case 41:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function moveRow(_x6, _x7, _x8) {
                return _ref6.apply(this, arguments);
            }

            return moveRow;
        }()
    }),
    mounted: function mounted() {
        var _this5 = this;

        this.fetchConditions();
        this.fetchPurposes();
        this.$nextTick(function () {
            _this5.eventListeners();
            _this5.form = document.forms.assessment_form;
        });
    },
    updated: function updated() {
        var _this6 = this;

        this.$nextTick(function () {
            _this6.updatedConditions();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'InternalApplicationIssuance',
    components: {
        filefield: _compliance_file2.default
    },
    props: {
        application: Object,
        licence_activity_tab: Number,
        applicantType: String,
        final_view_conditions: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        var vm = this;
        if (vm.application.can_view_richtext_src) {
            var toolbar_options = [['Source'], ['-', 'Bold', 'Italic'], ['Format'], ['NumberedList', 'BulletedList'], ['Table']];
        } else {
            var toolbar_options = [['-', 'Bold', 'Italic'], ['Format'], ['NumberedList', 'BulletedList'], ['Table']];
        }

        return {
            panelBody: "application-issuance-" + vm._uid,
            issuePanelBody: "app-issuance-check-" + vm._uid,
            emailPanelBody: "app-issuance-email-" + vm._uid,
            purposeBody: 'purposeBody' + vm._uid,
            proposed_licence: {},
            licence: {
                activity: [],
                checked_items: [{
                    id: null,
                    isChecked: false
                }],

                current_application: vm.application.id,
                purposes: [],
                selected_purpose_ids: []
            },
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            pickedPurposes: [],
            spinner: false,

            editorConfig: {
                toolbar: toolbar_options,
                format_tags: 'p;h1;h2;h3;h4;h5;h6;div',

                removePlugins: 'elementspath',
                resize_enabled: false
            }
        };
    },
    watch: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['selected_activity_tab_id', 'licenceActivities', 'filterActivityList', 'isApplicationActivityVisible', 'application_workflow_state']), {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie('csrftoken');
        },
        applicationIssuanceDocumentUrl: function applicationIssuanceDocumentUrl() {
            var url = '';
            if (this.selectedApplicationActivityId) {
                url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.application_selected_activity, this.selectedApplicationActivityId + "/process_issuance_document/");
            }
            return url;
        },
        applicationSelectedActivitiesForPurposes: function applicationSelectedActivitiesForPurposes() {
            var proposed = this.selectedApplicationActivity.proposed_purposes.filter(function (purpose) {
                if (purpose.processing_status === 'reissue') {
                    purpose.proposed_start_date = purpose.start_date;
                    purpose.proposed_end_date = purpose.expiry_date;
                }
                return ['reissue', 'propose', 'selected'].includes(purpose.processing_status);
            });
            return proposed;
        },
        canIssueOrDecline: function canIssueOrDecline() {

            var is_checked = this.getCheckedItem('id_check').isChecked && this.getCheckedItem('character_check').isChecked && this.getCheckedItem('return_check').isChecked;
            var is_accepted = this.isIdCheckAccepted && this.isCharacterCheckAccepted && this.isReturnCheckAccepted;
            return (this.allActivitiesDeclined || is_checked || is_accepted) && this.visibleLicenceActivities.length;
        },
        selectedActivity: function selectedActivity() {
            var _this = this;

            return this.visibleLicenceActivities.filter(function (activity) {
                return activity.id == _this.selected_activity_tab_id;
            });
        },
        visibleLicenceActivities: function visibleLicenceActivities() {

            return this.licenceActivities();
        },
        isActivityVisible: function isActivityVisible(activity_id) {
            return this.isApplicationActivityVisible({ activity_id: activity_id });
        },
        selectedApplicationActivity: function selectedApplicationActivity() {
            var _this2 = this;

            var selected_activity = this.application.activities.find(function (activity) {
                return activity.licence_activity == _this2.selected_activity_tab_id;
            });
            return selected_activity;
        },
        selectedApplicationActivityId: function selectedApplicationActivityId() {
            var activity_id = null;
            if (this.selectedApplicationActivity) {
                activity_id = this.selectedApplicationActivity.id;
            }
            return activity_id;
        },
        isIdCheckAccepted: function isIdCheckAccepted() {
            return this.application.id_check_status.id == 'accepted';
        },
        isIdCheckAwaitingUpdate: function isIdCheckAwaitingUpdate() {
            return this.application.id_check_status.id == 'awaiting_update';
        },
        isIdNotChecked: function isIdNotChecked() {
            return this.application.id_check_status.id == 'not_checked' || this.application.id_check_status.id == 'updated';
        },
        isCharacterCheckAccepted: function isCharacterCheckAccepted() {
            return this.application.character_check_status.id == 'accepted';
        },
        isCharacterNotChecked: function isCharacterNotChecked() {
            return this.application.character_check_status.id == 'not_checked';
        },
        isReturnCheckAccepted: function isReturnCheckAccepted() {
            return this.application.return_check_status.id == 'accepted';
        },
        isReturnCheckAwaitingReturns: function isReturnCheckAwaitingReturns() {
            return this.application.return_check_status.id == 'awaiting_returns';
        },
        isReturnNotChecked: function isReturnNotChecked() {
            return this.application.return_check_status.id == 'not_checked' || this.application.return_check_status.id == 'updated';
        },
        finalStatus: function finalStatus() {
            var _this3 = this;

            return function (id) {
                return _this3.getActivity(id).final_status;
            };
        },
        allActivitiesDeclined: function allActivitiesDeclined() {
            return this.licence && !this.licence.activity.filter(function (activity) {
                return activity.final_status !== 'declined';
            }).length;
        },
        canSubmit: function canSubmit() {
            var _this4 = this;

            var required_confirmations = this.application.activities.find(function (activity) {

                return activity.licence_activity === _this4.selected_activity_tab_id;
            });
            var confirmations = this.licence.activity.filter(function (activity) {

                return activity.id === required_confirmations.licence_activity && activity.confirmed;
            }).length;

            return confirmations;
        },
        canEditLicenceDates: function canEditLicenceDates() {
            return this.application.application_type && this.application.application_type.id !== 'amend_activity';
        },
        showSpinner: function showSpinner() {
            return this.spinner;
        },
        preview_licence_url: function preview_licence_url() {
            this.initialiseLicenceDetails();
            return this.application.id ? '/preview/licence-pdf/' + this.application.id : '';
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        load: 'loadApplication',
        revert: 'revertApplication'
    }), (0, _vuex.mapActions)(['setActivityTab', 'finalDecisionData', 'setApplicationWorkflowState']), {
        selectTab: function selectTab(component) {
            this.setActivityTab({ id: component.id, name: component.name });
            this.$emit('action-tab', { tab: component });
        },
        selectApplicantTab: function selectApplicantTab() {
            this.$emit('action-tab', { tab: 'IssueApplicant' });
        },
        preview: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var _this5 = this;

                var vm, selected, activity_pickedPurposes, confirmations, _loop, a, licence;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = this;


                                this.setApplicationWorkflowState({ bool: true });

                                this.spinner = true;
                                selected = [];
                                activity_pickedPurposes = [];
                                confirmations = [];

                                _loop = function _loop(a) {
                                    var activity = _this5.application.activities[a];

                                    if (activity.licence_activity === _this5.selected_activity_tab_id) {

                                        var confirmation = _this5.licence.activity.filter(function (a) {

                                            return a.id === activity.licence_activity;
                                        })[0];
                                        confirmation.confirmed = true;
                                        confirmations.push(confirmation);

                                        var proposed = activity.proposed_purposes;

                                        var _loop2 = function _loop2(p) {
                                            var purpose = proposed[p];
                                            if (['reissue', 'propose', 'selected'].includes(purpose.processing_status)) {
                                                selected.push(purpose);

                                                var picked_purpose = _this5.pickedPurposes.filter(function (picked) {
                                                    return picked.id === purpose.purpose.id;
                                                })[0];
                                                activity_pickedPurposes.push(picked_purpose);
                                            }
                                        };

                                        for (var p = 0; p < proposed.length; p++) {
                                            _loop2(p);
                                        }
                                    }
                                };

                                for (a = 0; a < this.application.activities.length; a++) {
                                    _loop(a);
                                }

                                vm.licence.purposes = selected;
                                vm.licence.activity = confirmations;
                                vm.licence.selected_purpose_ids = activity_pickedPurposes;
                                licence = JSON.parse((0, _stringify2.default)(vm.licence));

                                licence.purposes = vm.licence.purposes.map(function (purpose) {
                                    var date_formats = ["DD/MM/YYYY", "YYYY-MM-DD"];
                                    return (0, _extends3.default)({}, purpose, {
                                        proposed_start_date: purpose.proposed_start_date ? moment(purpose.proposed_start_date, date_formats).format('YYYY-MM-DD') : null,
                                        proposed_end_date: purpose.proposed_end_date ? moment(purpose.proposed_end_date, date_formats).format('YYYY-MM-DD') : null
                                    });
                                });

                                vm.post_and_redirect(vm.preview_licence_url, { 'csrfmiddlewaretoken': vm.csrf_token, 'formData': (0, _stringify2.default)(licence) });

                                this.setApplicationWorkflowState({ bool: false });

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function preview() {
                return _ref.apply(this, arguments);
            }

            return preview;
        }(),

        post_and_redirect: function post_and_redirect(url, postData) {
            var postFormStr = "<form method='POST' target='_blank' name='Preview Licence' action='" + url + "'>";

            for (var key in postData) {
                if (postData.hasOwnProperty(key)) {
                    postFormStr += "<input type='hidden' name='" + key + "' value='" + postData[key] + "'>";
                }
            }
            postFormStr += "</form>";
            var formElement = $(postFormStr);
            $('body').append(formElement);
            $(formElement).submit();
            this.spinner = false;
        },

        ok: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var _this6 = this;

                var vm, selected, activity_pickedPurposes, confirmations, _loop3, a, licence, applicantHasAddress;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                vm = this;
                                selected = [];
                                activity_pickedPurposes = [];
                                confirmations = [];

                                _loop3 = function _loop3(a) {
                                    var activity = _this6.application.activities[a];

                                    if (activity.licence_activity === _this6.selected_activity_tab_id) {

                                        var confirmation = _this6.licence.activity.filter(function (a) {

                                            return a.id === activity.licence_activity;
                                        })[0];
                                        confirmation.confirmed = true;
                                        confirmations.push(confirmation);

                                        var proposed = activity.proposed_purposes;

                                        var _loop4 = function _loop4(p) {
                                            var purpose = proposed[p];
                                            if (['reissue', 'propose', 'selected'].includes(purpose.processing_status)) {
                                                selected.push(purpose);

                                                var picked_purpose = _this6.pickedPurposes.filter(function (picked) {
                                                    return picked.id === purpose.purpose.id;
                                                })[0];
                                                activity_pickedPurposes.push(picked_purpose);
                                            }
                                        };

                                        for (var p = 0; p < proposed.length; p++) {
                                            _loop4(p);
                                        }
                                    }
                                };

                                for (a = 0; a < this.application.activities.length; a++) {
                                    _loop3(a);
                                }

                                vm.licence.purposes = selected;
                                vm.licence.activity = confirmations;
                                vm.licence.selected_purpose_ids = activity_pickedPurposes;

                                licence = JSON.parse((0, _stringify2.default)(vm.licence));

                                licence.purposes = vm.licence.purposes.map(function (purpose) {
                                    var date_formats = ["DD/MM/YYYY", "YYYY-MM-DD"];
                                    return (0, _extends3.default)({}, purpose, {
                                        proposed_start_date: purpose.proposed_start_date ? moment(purpose.proposed_start_date, date_formats).format('YYYY-MM-DD') : null,
                                        proposed_end_date: purpose.proposed_end_date ? moment(purpose.proposed_end_date, date_formats).format('YYYY-MM-DD') : null
                                    });
                                });

                                applicantHasAddress = false;

                                if (vm.applicantType == 'org') {
                                    if (vm.application.org_applicant.address) {
                                        applicantHasAddress = true;
                                    }
                                } else if (vm.applicantType == 'proxy') {
                                    if (vm.application.proxy_applicant.residential_address) {
                                        applicantHasAddress = true;
                                    }
                                } else if (vm.applicantType == 'submitter') {
                                    if (vm.application.submitter.residential_address) {
                                        applicantHasAddress = true;
                                    }
                                } else {
                                    swal({
                                        text: 'Unable to determine application type.',
                                        title: 'Application type missing',
                                        type: 'error'
                                    });
                                }

                                if (!applicantHasAddress) {
                                    _context3.next = 20;
                                    break;
                                }

                                this.spinner = true;
                                this.setApplicationWorkflowState({ bool: true });
                                _context3.next = 18;
                                return this.finalDecisionData({ url: '/api/application/' + this.application.id + '/final_decision_data.json' }).then(function () {
                                    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(response) {
                                        return _regenerator2.default.wrap(function _callee2$(_context2) {
                                            while (1) {
                                                switch (_context2.prev = _context2.next) {
                                                    case 0:
                                                        _context2.next = 2;
                                                        return vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/final_decision'), (0, _stringify2.default)(licence), {
                                                            emulateJSON: true

                                                        }).then(function (response) {
                                                            _this6.spinner = false;
                                                            _this6.setApplicationWorkflowState({ bool: false });
                                                            vm.$router.push({ name: "internal-dash" });
                                                        }, function (error) {
                                                            _this6.spinner = false;
                                                            _this6.setApplicationWorkflowState({ bool: false });
                                                            swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                                        });

                                                    case 2:
                                                    case 'end':
                                                        return _context2.stop();
                                                }
                                            }
                                        }, _callee2, _this6);
                                    }));

                                    return function (_x) {
                                        return _ref3.apply(this, arguments);
                                    };
                                }(), function (error) {
                                    _this6.spinner = false;
                                    _this6.setApplicationWorkflowState({ bool: false });
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 18:
                                _context3.next = 21;
                                break;

                            case 20:
                                swal({
                                    text: 'Applicant address missing, please ensure the applicant organisation/submitter address details are set.',
                                    title: 'Applicant address missing',
                                    type: 'error'
                                });

                            case 21:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function ok() {
                return _ref2.apply(this, arguments);
            }

            return ok;
        }(),
        getActivity: function getActivity(id) {
            var activity = this.licence.activity.find(function (activity) {
                return activity.id == id;
            });
            return activity ? activity : {};
        },
        getPickedPurpose: function getPickedPurpose(_id) {
            var picked = this.pickedPurposes.find(function (p) {
                return p.id === _id;
            });
            if (!picked) {
                picked = { id: _id, isProposed: true };
                this.pickedPurposes.push(picked);
            }
            return picked;
        },
        getCheckedItem: function getCheckedItem(_id) {
            var checked = this.licence.checked_items.find(function (c) {
                return c.id === _id;
            });
            if (!checked) {
                checked = {
                    id: _id,
                    isChecked: false
                };
                this.licence.checked_items.push(checked);
            }
            return checked;
        },
        initialiseLicenceDetails: function initialiseLicenceDetails() {
            var _this7 = this;

            var final_status = null;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.proposed_licence), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var proposal = _step.value;

                    if (proposal.proposed_action.id == 'propose_issue') {
                        final_status = "issued";
                    }
                    if (proposal.proposed_action.id == 'propose_decline') {
                        final_status = "declined";
                    }
                    var processing_status = proposal.processing_status;
                    if (!['with_officer_finalisation', 'awaiting_licence_fee_payment'].includes(processing_status)) {
                        continue;
                    }
                    var activity_id = proposal.licence_activity.id;
                    this.licence.activity.push({
                        id: activity_id,
                        name: proposal.licence_activity.name,
                        start_date: proposal.proposed_start_date,
                        end_date: proposal.proposed_end_date,
                        reason: proposal.reason,
                        cc_email: proposal.cc_email,
                        final_status: final_status,
                        confirmed: false,
                        purposes: proposal.issued_purposes_id
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.application.id_check_status.id == 'accepted') {
                this.licence.id_check = true;
            }
            if (this.application.id_check_status.id == 'not_checked') {
                this.licence.id_check = false;
            }
            if (this.application.character_check_status.id == 'accepted') {
                this.licence.character_check = true;
            }
            if (this.application.character_check_status.id == 'not_checked') {
                this.licence.character_check = false;
            }
            if (this.application.return_check_status.id == 'accepted') {
                this.licence.return_check = true;
            }
            if (this.application.return_check_status.id == 'not_checked') {
                this.licence.return_check = false;
            }

            for (var a = 0; a < this.application.activities.length; a++) {
                var _activity = this.application.activities[a];

                var _loop5 = function _loop5(p) {
                    var purpose = _activity.proposed_purposes[p];
                    var picked = _this7.pickedPurposes.find(function (p) {
                        return p.id === purpose.purpose.id;
                    });
                    if (picked == null) {
                        picked = { id: purpose.purpose.id, isProposed: false };
                        _this7.pickedPurposes.push(picked);
                    }
                    if (['reissue', 'propose'].includes(purpose.processing_status)) {
                        picked.isProposed = true;
                    } else {
                        picked.isProposed = false;
                    }
                    if (purpose.proposed_start_date != null && purpose.proposed_start_date.charAt(2) === '/') {
                        return 'continue';
                    }
                    var date1 = moment(purpose.proposed_start_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
                    var date2 = moment(purpose.proposed_end_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
                    if (purpose.proposed_start_date == null) {
                        date1 = '';
                        date2 = '';
                    }
                    purpose.proposed_start_date = date1;
                    purpose.proposed_end_date = date2;
                };

                for (var p = 0; p < _activity.proposed_purposes.length; p++) {
                    var _ret5 = _loop5(p);

                    if (_ret5 === 'continue') continue;
                }
            }
        },
        fetchProposeIssue: function fetchProposeIssue() {
            var _this8 = this;

            var vm = this;

            vm.$http.get(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications, vm.application.id + '/get_proposed_decisions/')).then(function (response) {
                vm.proposed_licence = response.body;
                _this8.initialiseLicenceDetails();
            }, function (error) {

                swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
            });
        },
        eventListeners: function eventListeners() {
            this.initDatePicker();
        },


        initFirstTab: function initFirstTab(force) {
            var _this9 = this;

            var tab = $('#tabs-main li:first-child a')[0];
            var first_tab = this.application.activities[0].licence_activity;

            if (tab) {
                tab.click();
            } else {
                this.licenceActivities().filter(function (activity) {
                    if (activity.id == first_tab) {

                        _this9.setActivityTab({ id: activity.id, name: activity.name });
                    }
                });
            }
        },

        setTemporaryDocumentCollectionId: function setTemporaryDocumentCollectionId(val) {
            this.temporary_document_collection_id = val;
        },

        userHasRole: function userHasRole(role, activity_id) {
            return this.application.user_roles.filter(function (role_record) {
                return role_record.role == role && (!activity_id || activity_id == role_record.activity_id);
            }).length;
        },

        initDatePicker: function initDatePicker() {
            var _this10 = this;

            for (var a = 0; a < this.application.activities.length; a++) {
                var _activity2 = this.application.activities[a];

                var _loop6 = function _loop6(p) {
                    var purpose = _activity2.proposed_purposes[p];
                    var start_date = 'start_date_' + purpose.id;
                    $('[name=\'' + start_date + '\']').datetimepicker(_this10.datepickerOptions);
                    $('[name=\'' + start_date + '\']').on('dp.change', function (e) {
                        if ($('[name=\'' + start_date + '\']').data('DateTimePicker') && $('[name=\'' + start_date + '\']').data('DateTimePicker').date()) {
                            purpose.proposed_start_date = e.date.format('DD/MM/YYYY');
                        } else if ($('[name=\'' + start_date + '\']').data('date') === "") {
                            purpose.proposed_start_date = "";
                        } else {
                            purpose.proposed_start_date = "";
                        }
                    });
                    var end_date = 'end_date_' + purpose.id;
                    $('[name=\'' + end_date + '\']').datetimepicker(_this10.datepickerOptions);
                    $('[name=\'' + end_date + '\']').on('dp.change', function (e) {
                        if ($('[name=\'' + end_date + '\']').data('DateTimePicker') && $('[name=\'' + end_date + '\']').data('DateTimePicker').date()) {
                            purpose.proposed_end_date = e.date.format('DD/MM/YYYY');
                        } else if ($('[name=\'' + end_date + '\']').data('date') === "") {
                            purpose.proposed_end_date = "";
                        } else {
                            purpose.proposed_end_date = "";
                        }
                    });
                };

                for (var p = 0; p < _activity2.proposed_purposes.length; p++) {
                    _loop6(p);
                }
            }
        }
    }),
    updated: function updated() {
        this.eventListeners();
    },
    mounted: function mounted() {
        var vm = this;
        this.fetchProposeIssue();

        this.$nextTick(function () {
            vm.eventListeners();
        });
    }

};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ProposedDecline',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default
    },
    props: {},
    data: function data() {
        var vm = this;
        return {
            isModalOpen: false,
            noActiveLicense: false,
            form: null,
            propose_decline: {
                activity: [],
                cc_email: null,
                reason: null
            },
            selected_activity: null,
            decliningApplication: false,
            errors: false,
            validation_form: null,
            errorString: '',
            successString: '',
            success: false
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application_id', 'licence_type_data', 'hasRole', 'licenceActivities', 'canAssignOfficerFor', 'selected_activity_tab_id', 'selected_activity_tab_name']), {
        showError: function showError() {
            var vm = this;
            return vm.errors;
        },
        title: function title() {
            return 'Propose to decline activity ' + this.selected_activity_tab_name;
        }
    }),
    methods: {
        visibleLicenceActivities: function visibleLicenceActivities() {
            var _this = this;

            var visible_ids = [];
            this.licenceActivities(['with_officer_conditions', 'licensing_officer']).filter(function (activity) {
                var ok = activity.id === _this.selected_activity_tab_id;
                if (ok) {
                    visible_ids.push(activity.id);
                }
                return _this.canAssignOfficerFor(activity.id) && ok;
            });
            return visible_ids;
        },
        ok: function ok() {
            var vm = this;
            if ($(vm.form).valid()) {
                vm.sendData();
            }
        },
        cancel: function cancel() {
            this.close();
        },
        close: function close() {
            this.isModalOpen = false;
            this.propose_decline = {
                activity: [],
                cc_email: null,
                reason: null
            };
            this.errors = false;
            $('.has-error').removeClass('has-error');
            this.validation_form.resetForm();
        },
        sendData: function sendData() {
            var vm = this;
            vm.errors = false;
            vm.propose_decline.activity = vm.visibleLicenceActivities();
            var propose_decline = JSON.parse((0, _stringify2.default)(vm.propose_decline));
            vm.decliningApplication = true;
            if (propose_decline.activity.length > 0) {
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, this.application_id + '/proposed_decline'), (0, _stringify2.default)(propose_decline), {
                    emulateJSON: true
                }).then(function (response) {
                    vm.$router.push({
                        name: "internal-dash"
                    });
                }, function (error) {
                    vm.errors = true;
                    vm.decliningApplication = false;
                    vm.errorString = _hooks.helpers.apiVueResourceError(error);
                });
            } else {
                vm.decliningApplication = false;
                swal('Propose Decline', 'Please select at least once licenced activity to Propose Decline.', 'error');
            }
        },
        addFormValidations: function addFormValidations() {
            var vm = this;
            vm.validation_form = $(vm.form).validate({
                rules: {
                    reason: "required"
                },
                messages: {},
                showErrors: function showErrors(errorMap, errorList) {
                    $.each(this.validElements(), function (index, element) {
                        var $element = $(element);
                        $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                    });

                    $("." + this.settings.validClass).tooltip("destroy");

                    for (var i = 0; i < errorList.length; i++) {
                        var error = errorList[i];
                        $(error.element).tooltip({
                            trigger: "focus"
                        }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                    }
                }
            });
        },
        eventListerners: function eventListerners() {
            var vm = this;
        },
        userHasRole: function userHasRole(role, activity_id) {
            return this.hasRole(role, activity_id);
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.form = document.forms.declineForm;
        vm.addFormValidations();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Send-to-Assessor',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default
    },
    props: {},
    data: function data() {
        var vm = this;
        return {
            isModalOpen: false,
            form: null,
            assessment: {
                assessor_group_name: null,
                assessor_group: null,
                application: this.$store.getters.application_id,
                licence_activity: null
            },
            assessor_group: null,
            assessingApplication: false,
            errors: false,
            errorString: '',
            successString: '',
            success: false
        };
    },
    computed: {
        showError: function showError() {
            var vm = this;
            return vm.errors;
        }
    },
    methods: {
        ok: function ok() {
            var vm = this;

            vm.sendData();
        },
        cancel: function cancel() {},
        close: function close() {
            this.isModalOpen = false;
            this.contact = {};
        },
        sendData: function sendData() {
            var vm = this;
            vm.errors = false;
            var assessment = JSON.parse((0, _stringify2.default)(vm.assessment));
            vm.$http.post('/api/assessment.json', (0, _stringify2.default)(assessment), {
                emulateJSON: true
            }).then(function (response) {
                swal('Send to Assessor', 'This application has been sent to the selected group for assessment.', 'success');
                vm.assessingApplication = true;

                for (var i = 0; i < vm.$parent.$refs.assessorDatatable.length; i++) {
                    vm.$parent.$refs.assessorDatatable[i].vmDataTable.ajax.reload();
                }
                vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, assessment.application + '/internal_application')).then(function (res) {
                    vm.$emit('refreshFromResponse', res);
                });
                vm.close();
            }, function (error) {
                console.log(error);
                vm.errors = true;
                vm.errorString = _hooks.helpers.apiVueResourceError(error);
                vm.amendingProposal = true;
            });
        },

        addFormValidations: function addFormValidations() {
            var vm = this;
            $(vm.form).validate({
                rules: {
                    arrival: "required",
                    departure: "required",
                    campground: "required",
                    campsite: {
                        required: {
                            depends: function depends(el) {
                                return vm.campsites.length > 0;
                            }
                        }
                    }
                },
                messages: {
                    arrival: "field is required",
                    departure: "field is required",
                    campground: "field is required",
                    campsite: "field is required"
                },
                showErrors: function showErrors(errorMap, errorList) {
                    $.each(this.validElements(), function (index, element) {
                        var $element = $(element);
                        $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                    });

                    $("." + this.settings.validClass).tooltip("destroy");

                    for (var i = 0; i < errorList.length; i++) {
                        var error = errorList[i];
                        $(error.element).tooltip({
                            trigger: "focus"
                        }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                    }
                }
            });
        },
        eventListerners: function eventListerners() {
            var vm = this;
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.form = document.forms.addContactForm;
        vm.addFormValidations();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(2)))

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _form = __webpack_require__(96);

var _form2 = _interopRequireDefault(_form);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _application_assessments = __webpack_require__(343);

var _application_assessments2 = _interopRequireDefault(_application_assessments);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _responsive_datatable_helper = __webpack_require__(50);

var _responsive_datatable_helper2 = _interopRequireDefault(_responsive_datatable_helper);

var _create_inspection_modal = __webpack_require__(83);

var _create_inspection_modal2 = _interopRequireDefault(_create_inspection_modal);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'InternalApplicationAssessment',
    data: function data() {
        var vm = this;
        return {
            applicantTab: 'applicantTab' + vm._uid,
            applicationTab: 'applicationTab' + vm._uid,
            activityTab: 'activityTab' + vm._uid + '_' + 0,
            detailsBody: 'detailsBody' + vm._uid,
            identificationBody: 'identificationBody' + vm._uid,
            addressBody: 'addressBody' + vm._uid,
            checksBody: 'checksBody' + vm._uid,
            isSendingToAssessor: false,
            assessorGroup: {},
            "selectedAssessor": {},
            "loading": [],
            form: null,
            initialisedSelects: false,
            showingApplication: false,
            isOfficerConditions: false,
            isofficerfinalisation: false,
            application_assessor_datatable: vm._uid + 'assessment-table',
            assessors_headers: ["Assessor Group", "Date Sent", "Status", "Action"],
            assessors_options: {},
            DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.$route.params.application_id + '/comms_log'),
            comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.$route.params.application_id + '/add_comms_log'),
            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.$route.params.application_id + '/action_log'),
            panelClickersInitialised: false,
            isModalOpen: false,
            assessment: {
                id: "",
                comment: ""
            },
            savingAssessment: false,
            checkedActivities: [],
            final_comment: "",
            isRequestingInspection: false,
            inspection: {
                isModalOpen: false
            }
        };
    },
    components: {
        Application: _form2.default,
        datatable: _datatable2.default,
        ApplicationAssessments: _application_assessments2.default,
        CommsLogs: _comms_logs2.default,
        modal: _bootstrapModal2.default,
        InspectionRequest: _create_inspection_modal2.default
    },
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format('DD/MM/YYYY HH:mm:ss') : '';
        }
    },
    watch: {},
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application', 'original_application', 'licence_type_data', 'selected_activity_tab_id', 'selected_activity_tab_name', 'hasRole', 'visibleConditionsFor', 'checkActivityStatus', 'isPartiallyFinalised', 'isFinalised', 'licenceActivities', 'isApplicationLoaded', 'isApplicationActivityVisible', 'unfinishedActivities', 'current_user', 'canEditAssessmentFor', 'canAssignAssessorFor', 'allCurrentActivities']), {
        activitiesWithAssessment: function activitiesWithAssessment() {
            var _this = this;

            var vm = this;
            if (!vm.panelClickersInitialised) {
                $('.panelClicker[data-toggle="collapse"]').on('click', function () {
                    var chev = $(this).children()[0];
                    window.setTimeout(function () {
                        $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
                    }, 100);
                });
                vm.panelClickersInitialised = true;
            }
            this.$nextTick(function () {
                vm.initialiseSelects();
                vm.form = document.forms.new_application;
                vm.eventListeners();
            });

            var activities = this.application.activities.filter(function (activity) {

                return _this.canEditAssessmentFor(activity.licence_activity) && _this.canAssignAssessorFor(activity.licence_activity);
            });

            return activities;
        },
        applicationDetailsVisible: function applicationDetailsVisible() {
            return this.showingApplication;
        },
        applicationIsDraft: function applicationIsDraft() {
            return this.application.processing_status.id == 'draft';
        },
        selectedActivity: function selectedActivity() {
            var _this2 = this;

            if (this.selected_activity_tab_id == null || this.selected_activity_tab_id < 1) {
                this.initTabsAssessor();
            }
            return this.application.activities.find(function (activity) {

                return activity.licence_activity === _this2.selected_activity_tab_id;
            });
        },
        applicantType: function applicantType() {
            return this.$store.getters.applicant_type;
        },
        isLoading: function isLoading() {
            return this.loading.length > 0;
        },
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie('csrftoken');
        },
        application_form_url: function application_form_url() {
            return this.application ? '/api/application/' + this.application.id + '/application_officer_save.json' : '';
        },
        userIsAssignedOfficer: function userIsAssignedOfficer() {
            return this.current_user.id == this.selectedActivity.assigned_officer;
        },
        form_data_comments_url: function form_data_comments_url() {
            return this.application ? '/api/application/' + this.application.id + '/officer_comments.json' : '';
        },
        headerLabel: function headerLabel() {
            switch (this.application.application_type.id) {
                case 'amend_activity':
                    return 'Application - Activity Amendment';
                    break;
                case 'renew_activity':
                    return 'Application - Activity Renewal';
                    break;
                default:
                    return 'Application';
                    break;
            }
        },
        showNavBarBottom: function showNavBarBottom() {
            var can_save = false;
            if (this.selectedActivity.processing_status.id === 'with_assessor') {
                can_save = true;
            }
            return can_save;
        },
        showCompleteAssessmentsButton: function showCompleteAssessmentsButton() {
            var _this3 = this;

            return this.isWithAssessor && this.activeAssessments.find(function (assessment) {
                return !assessment.assigned_assessor || assessment.assigned_assessor && assessment.assigned_assessor.id === _this3.current_user.id;
            });
        },
        showRequestInspectionButton: function showRequestInspectionButton() {
            var promptInspection = this.selectedActivity.is_inspection_required && !this.selectedActivity.has_inspection;
            return promptInspection && this.showCompleteAssessmentsButton;
        },
        showAssignToAssessor: function showAssignToAssessor() {
            return !this.showingApplication && this.canAssignAssessorFor(this.selectedActivity.licence_activity);
        },
        showAssessmentConditionButton: function showAssessmentConditionButton() {
            var show = this.selectedActivity.processing_status.id !== 'with_assessor';
            return show;
        },
        isWithAssessor: function isWithAssessor() {
            return this.selectedActivity.processing_status.id === 'with_assessor';
        },
        activeAssessments: function activeAssessments() {
            var _this4 = this;

            return this.application.assessments.filter(function (assessment) {

                return assessment.status.id !== 'completed' && assessment.licence_activity === _this4.selected_activity_tab_id && assessment.assessors.find(function (assessor) {
                    return assessor.id === _this4.current_user.id;
                });
            });
        },
        form_data_application_url: function form_data_application_url() {
            return this.application ? '/api/application/' + this.application.id + '/form_data.json' : '';
        },
        showBackToProcessingButton: function showBackToProcessingButton() {
            var show = this.selectedActivity.processing_status.id !== 'with_assessor';
            return show;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        load: 'loadApplication',
        revert: 'revertApplication'
    }), (0, _vuex.mapActions)(['setOriginalApplication', 'setApplication', 'setActivityTab', 'loadCurrentUser', 'toggleFinalisedTabs', 'saveFormData']), {
        selectTab: function selectTab(component) {
            this.section_tab_id = component.id;
            this.setActivityTab({ id: component.id, name: component.label });
            this.showingApplicant = false;
        },
        eventListeners: function eventListeners() {
            var vm = this;
            var application_tabs = $('#tabs-section li a')[0];
            if (application_tabs == null) {
                $("[data-target!=''][data-target]").off("click").on("click", function (e) {
                    vm.setActivityTab({
                        id: parseInt($(this).data('target').replace('#', ''), 10),
                        name: $(this).text()
                    });
                });
            }
            this.initTabsAssessor();
        },
        userHasRole: function userHasRole(role, activity_id) {
            return this.hasRole(role, activity_id);
        },
        initTabsAssessor: function initTabsAssessor(force) {
            var _this5 = this;

            if (this.selected_activity_tab_id && !force) {
                var application_tabs = $('#tabs-section li a');
                var tab_id = this.selected_activity_tab_id;
                var tab_name = this.selected_activity_tab_name;
                if (application_tabs) {
                    for (var i = 0; i < application_tabs.length; i++) {

                        if (application_tabs[i].innerText === this.selected_activity_tab_name) {
                            tab = $('#tabs-section li a')[i].click();
                        }
                    }
                }
                return;
            }

            var first_tab = this.application.assessments.find(function (assessment) {
                return assessment.status.id === 'awaiting_assessment';
            });
            if (first_tab) {
                this.licenceActivities().filter(function (activity) {
                    if (activity.id == first_tab.licence_activity) {

                        _this5.setActivityTab({ id: activity.id, name: activity.name });
                    }
                });
            } else {
                var activity = this.licenceActivities();
                this.setActivityTab({ id: activity[0].id, name: activity[0].name });
            }
        },
        close: function close() {
            this.isModalOpen = false;
        },
        save: function save() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { showNotification: true };
            var showNotification = props.showNotification;


            this.saveFormData({ url: this.form_data_application_url }).then(function (response) {
                showNotification && swal('Saved', 'Your application has been saved', 'success');
            }, function (error) {
                console.log('Failed to save Application: ', error);
                swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
            });
        },
        save_wo: function save_wo() {
            return this.save({ showNotification: false });
        },
        canCompleteAssessment: function canCompleteAssessment() {
            if (!this.userHasRole('assessor', this.selected_activity_tab_id)) {
                return false;
            }
            if (this.assessment.status && this.assessment.status.id != 'awaiting_assessment') {
                return false;
            }
            return this.selected_activity_tab_id && this.selectedActivity.processing_status.id == 'with_assessor' ? true : false;
        },
        toggleAssessments: function toggleAssessments() {
            this.save_wo();
            $('#tabs-main li').removeClass('active');
            this.isSendingToAssessor = !this.isSendingToAssessor;
            this.showingApplication = false;
        },
        toggleApplication: function toggleApplication(_ref) {
            var _this6 = this;

            var _ref$show = _ref.show,
                show = _ref$show === undefined ? false : _ref$show,
                _ref$showFinalised = _ref.showFinalised,
                showFinalised = _ref$showFinalised === undefined ? false : _ref$showFinalised;

            this.showingApplication = show;
            if (this.isSendingToAssessor) {
                this.isSendingToAssessor = !show;
            }
            if (this.isOfficerConditions) {
                this.isOfficerConditions = !show;
            }
            if (this.isofficerfinalisation) {
                this.approvingApplication = true;
                this.isofficerfinalisation = !show;
            }
            this.toggleFinalisedTabs(showFinalised);
            setTimeout(function () {
                var main_tabs = $('#tabs-main li');
                var tabno = 0;
                for (var i = 0; i < main_tabs.length; i++) {
                    if (main_tabs[i].innerText === _this6.selected_activity_tab_name) {
                        tabno = i;
                    }
                }
                var selected = $('#tabs-main li a')[tabno];
                if (selected != null) {
                    selected.click();
                }
                _this6.initFirstTab();
            }, 50);
            !showFinalised && this.load({ url: '/api/application/' + this.application.id + '/internal_application.json' });
        },
        toggleRequestInspection: function toggleRequestInspection() {
            var _this7 = this;

            this.isRequestingInspection = !this.isRequestingInspection;
            this.$nextTick(function () {
                _this7.$refs.inspection.isModalOpen = true;
            });
        },
        requestedInspection: function requestedInspection(event) {
            var _this8 = this;

            var data = {
                "licence_activity_id": this.selected_activity_tab_id,
                "inspection_id": event.inspection
            };
            this.setOriginalApplication(this.application);
            this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, this.application.id + '/add_assessment_inspection'), (0, _stringify2.default)(data)).then(function (response) {
                _this8.setApplication(response.body);
            }, function (error) {
                _this8.revert();
                swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
            });
        },
        makeMeAssessor: function makeMeAssessor(assessment) {
            var _this9 = this;

            var vm = this;
            var data = {
                "assessment_id": assessment.id,
                "assessor_id": this.current_user.id
            };
            this.setOriginalApplication(this.application);
            this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, this.application.id + '/assign_application_assessment'), (0, _stringify2.default)(data)).then(function (response) {
                _this9.setApplication(response.body);
            }, function (error) {
                _this9.revert();
                swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
            });
        },
        onChangeAssessor: function onChangeAssessor(assessment) {
            var _this10 = this;

            var data = {
                "assessment_id": assessment.id,
                "assessor_id": assessment.assigned_assessor == null ? assessment.assigned_assessor_id : assessment.assigned_assessor
            };
            this.setOriginalApplication(this.application);
            this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, this.application.id + '/assign_application_assessment'), (0, _stringify2.default)(data)).then(function (response) {
                _this10.setApplication(response.body);
            }, function (error) {
                _this10.revert();
                swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
            });
        },
        updateAssignedAssessorSelect: function updateAssignedAssessorSelect(assessment) {
            var vm = this;
            $(vm.$refs.assigned_assessor).val(assessment.assigned_assessor);
            $(vm.$refs.assigned_assessor).trigger('change');
        },
        completeAssessmentsToMe: function completeAssessmentsToMe() {
            var _this11 = this;

            var vm = this;
            var data = {
                "activity_id": this.checkedActivities,
                "final_comment": this.final_comment
            };
            this.setOriginalApplication(this.application);
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application.id + '/complete_application_assessments'), (0, _stringify2.default)(data)).then(function (response) {
                _this11.setApplication(response.body);
                _this11.$router.push({ name: "internal-dash" });
            }, function (error) {
                _this11.revert();
                var error_msg = '<br/>';
                for (var key in error.body) {
                    error_msg += error.body[key] + '<br/>';
                }
                swal({
                    title: 'Assessment Error',
                    html: 'There was an error completing assessment.<br/>' + error_msg,
                    type: 'error'
                });
            });
        },
        canSaveApplication: function canSaveApplication() {
            return true;
        },
        backToProcessing: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.toggleApplication({ show: true });

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function backToProcessing() {
                return _ref2.apply(this, arguments);
            }

            return backToProcessing;
        }(),
        initialiseAssignedAssessorSelect: function initialiseAssignedAssessorSelect() {
            var reinit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var vm = this;
            if (reinit) {
                $(vm.$refs.assigned_assessor).data('select2') ? $(vm.$refs.assigned_assessor).select2('destroy') : '';
            }
            $(vm.$refs.assigned_assessor).select2({
                theme: "bootstrap",
                allowClear: true,
                placeholder: "Select Assessor"
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);

                var assessment = vm.activeAssessments[0];
                assessment.assigned_assessor = selected.val();
                vm.onChangeAssessor(assessment);
            }).on("select2:unselecting", function (e) {
                var self = $(this);
                setTimeout(function () {
                    self.select2('close');
                }, 0);
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);

                var assessment = vm.activeAssessments[0];
                assessment.assigned_assessor = null;
                assessment.assigned_assessor_id = null;
                vm.onChangeAssessor(assessment);
            });
        },
        initialiseSelects: function initialiseSelects() {
            if (!this.initialisedSelects) {
                this.initialisedSelects = true;
                this.initMainTab();
            }
            this.initialiseAssignedAssessorSelect();
        },
        initFirstTab: function initFirstTab(force) {
            var _this12 = this;

            if (this.selected_activity_tab_id && !force) {
                return;
            }
            var tab = $('#tabs-section li:first-child a')[0];
            if (tab) {
                tab.click();
            } else {
                this.licenceActivities().filter(function (activity) {
                    _this12.setActivityTab({
                        id: activity.id,
                        name: activity.name
                    });
                });
            }
        },
        initMainTab: function initMainTab() {
            if (!this.$refs.applicationTab) {
                return;
            }
            this.$refs.applicationTab.click();
        },
        openAssessmentModal: function openAssessmentModal() {
            this.isModalOpen = true;
        }
    }),
    updated: function updated() {},
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.load({ url: '/api/application/' + to.params.application_id + '/internal_application.json' }).then(function () {});
            vm.loadCurrentUser({ url: '/api/my_user_details' });
        });
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        next(function (vm) {
            vm.load({ url: '/api/application/' + to.params.application_id + '.json' }).then(function () {});
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Proposed-Licence',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default,
        filefield: _compliance_file2.default
    },
    props: {
        can_view_richtext_src: Boolean
    },
    data: function data() {
        var vm = this;
        if (vm.can_view_richtext_src) {
            var toolbar_options = [['-', 'Bold', 'Italic'], ['Format'], ['NumberedList', 'BulletedList'], ['Table'], ['Source']];
        } else {
            var toolbar_options = [['-', 'Bold', 'Italic'], ['Format'], ['NumberedList', 'BulletedList'], ['Table']];
        }

        return {
            purposeBody: 'purposeBody' + vm._uid,
            isModalOpen: false,
            form: null,
            propose_issue: {
                activity: [],
                purposes: [],
                cc_email: null,
                reason: null,
                approver_detail: null,
                temporary_document_email_id: null,
                activities: null
            },
            issuingLicence: false,
            validation_form: null,
            errors: false,
            errorString: '',
            successString: '',
            success: false,
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            pickedPurposes: [],
            checkedActivities: [],
            additionalFees: [],
            editorConfig: {
                toolbar: toolbar_options,
                format_tags: 'p;h1;h2;h3;h4;h5;h6;div',

                removePlugins: 'elementspath',
                resize_enabled: false
            }
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['application', 'application_id', 'licence_type_data', 'hasRole', 'licenceActivities', 'canAssignOfficerFor', 'selected_activity_tab_id', 'selected_activity_tab_name']), {
        canEditLicenceDates: function canEditLicenceDates() {
            return this.application.application_type && this.application.application_type.id !== 'amend_activity';
        },
        showError: function showError() {
            var vm = this;
            return vm.errors;
        },
        title: function title() {
            return 'Propose to issue activity ' + this.selected_activity_tab_name;
        },
        applicationSelectedActivitiesForPurposes: function applicationSelectedActivitiesForPurposes() {
            var _this = this;

            var selected_activity = this.application.activities.filter(function (activity) {
                return activity.processing_status.id === 'with_officer_conditions' && activity.licence_activity === _this.selected_activity_tab_id;
            });
            if (selected_activity[0]) {
                this.checkedActivities = [selected_activity[0].id];
            }
            return selected_activity;
        }
    }),
    methods: {
        ok: function ok() {
            var vm = this;
            if ($(vm.form).valid()) {
                vm.sendData();
            }
        },
        cancel: function cancel() {
            this.close();
        },
        close: function close() {
            this.isModalOpen = false;
            this.propose_issue = {
                activity: [],
                cc_email: null,
                reason: null,
                purposes: []
            };
            this.errors = false;
            $('.has-error').removeClass('has-error');
            this.validation_form.resetForm();

            this.checkedActivities = [];
            this.pickedPurposes = [];
        },
        fetchContact: function fetchContact(id) {
            var vm = this;
            vm.$http.get(_hooks.api_endpoints.contact(id)).then(function (response) {
                vm.contact = response.body;vm.isModalOpen = true;
            }, function (error) {
                console.log(error);
            });
        },
        getCheckedActivity: function getCheckedActivity(_id) {
            return this.applicationSelectedActivitiesForPurposes.find(function (a) {
                return a.id === _id;
            });
        },
        getPickedPurpose: function getPickedPurpose(_id) {
            var picked = this.pickedPurposes.find(function (p) {
                return p.id === _id;
            });
            if (!picked) {
                picked = {
                    id: _id,
                    isProposed: true,
                    additional_fee: 0,
                    additional_fee_text: '',
                    species_header: '',
                    species_text: ''
                };
                this.pickedPurposes.push(picked);
            }
            return picked;
        },
        isPickedPurpose: function isPickedPurpose(_id) {
            var _this2 = this;

            var activities = this.applicationSelectedActivitiesForPurposes.filter(function (a) {
                return _this2.checkedActivities.includes(a.id);
            });
            return activities.find(function (a) {
                return a.purposes.find(function (p) {
                    return p.id === _id;
                });
            });
        },
        setTemporaryIssuanceDocumentsCollectionId: function setTemporaryIssuanceDocumentsCollectionId(val) {
            this.propose_issue.issuance_documents_id = val;
        },
        setTemporaryEmailCollectionId: function setTemporaryEmailCollectionId(val) {
            this.propose_issue.email_attachments_id = val;
        },
        sendData: function sendData() {
            var _this3 = this;

            var vm = this;
            vm.errors = false;
            vm.propose_issue.purposes = vm.pickedPurposes.filter(function (p) {
                return _this3.isPickedPurpose(p.id);
            });
            vm.propose_issue.activity = vm.checkedActivities;
            vm.propose_issue.activities = vm.applicationSelectedActivitiesForPurposes.filter(function (a) {
                return vm.checkedActivities.includes(a.id);
            });
            var propose_issue = JSON.parse((0, _stringify2.default)(vm.propose_issue));
            vm.issuingLicence = true;
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.applications, vm.application_id + '/proposed_licence'), (0, _stringify2.default)(vm.propose_issue), {
                emulateJSON: true
            }).then(function (response) {

                vm.$router.push({ name: "internal-dash" });
            }, function (error) {
                vm.errors = true;
                vm.issuingLicence = false;
                vm.errorString = _hooks.helpers.apiVueResourceError(error);
            });
        },
        addFormValidations: function addFormValidations() {
            var vm = this;
            vm.validation_form = $(vm.form).validate({
                rules: {
                    start_date: { required: this.canEditLicenceDates },
                    due_date: { required: this.canEditLicenceDates },
                    licence_details: "required",
                    licence_activity: { required: true }
                },
                messages: {},
                showErrors: function showErrors(errorMap, errorList) {
                    $.each(this.validElements(), function (index, element) {
                        var $element = $(element);
                        $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                    });

                    $("." + this.settings.validClass).tooltip("destroy");

                    for (var i = 0; i < errorList.length; i++) {
                        var error = errorList[i];
                        $(error.element).tooltip({
                            trigger: "focus"
                        }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                    }
                }
            });
        },

        eventListeners: function eventListeners() {
            var vm = this;

            for (var i = 0; i < vm.applicationSelectedActivitiesForPurposes.length; i++) {
                var act = vm.applicationSelectedActivitiesForPurposes[i];

                var _loop = function _loop(p) {
                    var purpose = act.proposed_purposes[p];
                    var start_date = 'start_date_' + purpose.id;
                    $('[name=\'' + start_date + '\']').datetimepicker(vm.datepickerOptions);
                    $('[name=\'' + start_date + '\']').on('dp.change', function (e) {
                        if ($('[name=\'' + start_date + '\']').data('DateTimePicker') && $('[name=\'' + start_date + '\']').data('DateTimePicker').date()) {
                            purpose.proposed_start_date = e.date.format('DD/MM/YYYY');
                        } else if ($('[name=\'' + start_date + '\']').data('date') === "") {
                            purpose.proposed_start_date = "";
                        }
                    });
                    var end_date = 'end_date_' + purpose.id;
                    $('[name=\'' + end_date + '\']').datetimepicker(vm.datepickerOptions);
                    $('[name=\'' + end_date + '\']').on('dp.change', function (e) {
                        if ($('[name=\'' + end_date + '\']').data('DateTimePicker') && $('[name=\'' + end_date + '\']').data('DateTimePicker').date()) {
                            purpose.proposed_end_date = e.date.format('DD/MM/YYYY');
                        } else if ($('[name=\'' + end_date + '\']').data('date') === "") {
                            purpose.proposed_end_date = "";
                        }
                    });
                };

                for (var p = 0; p < act.proposed_purposes.length; p++) {
                    _loop(p);
                }
            }
        },
        preloadProposedPurpose: function preloadProposedPurpose() {
            for (var i = 0; i < this.applicationSelectedActivitiesForPurposes.length; i++) {
                var act = this.applicationSelectedActivitiesForPurposes[i];
                for (var p = 0; p < act.proposed_purposes.length; p++) {
                    var proposed = act.proposed_purposes[p];
                    proposed.species_header_1 = proposed.purpose.species_header_1;
                    proposed.species_header_2 = proposed.purpose.species_header_2;
                    proposed.species_header_3 = proposed.purpose.species_header_3;
                    proposed.species_header_4 = proposed.purpose.species_header_4;
                    proposed.species_header_5 = proposed.purpose.species_header_5;
                    proposed.species_header_6 = proposed.purpose.species_header_6;
                    proposed.species_text_1 = proposed.purpose.species_text_1;
                    proposed.species_text_2 = proposed.purpose.species_text_2;
                    proposed.species_text_3 = proposed.purpose.species_text_3;
                    proposed.species_text_4 = proposed.purpose.species_text_4;
                    proposed.species_text_5 = proposed.purpose.species_text_5;
                    proposed.species_text_6 = proposed.purpose.species_text_6;
                }
            }
        },
        preloadLastActivity: function preloadLastActivity() {
            var activities = this.applicationSelectedActivitiesForPurposes;
            for (var a = 0; a < activities.length; a++) {
                var activity = activities[a];

                for (var p = 0; p < activity.proposed_purposes.length; p++) {
                    var _purpose = activity.proposed_purposes[p];
                    if (_purpose.proposed_start_date == null || _purpose.proposed_start_date.charAt(2) === '/') {
                        continue;
                    }
                    var date1 = moment(_purpose.proposed_start_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
                    var date2 = moment(_purpose.proposed_end_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
                    _purpose.proposed_start_date = date1;
                    _purpose.proposed_end_date = date2;
                }
            }
        }
    },
    updated: function updated() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.eventListeners();
        });
    },
    mounted: function mounted() {
        var _this5 = this;

        this.form = document.forms.licenceForm;
        this.addFormValidations();
        this.$nextTick(function () {
            _this5.eventListeners();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _vuex = __webpack_require__(6);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(15);

__webpack_require__(37);

var _objectHash = __webpack_require__(55);

var _objectHash2 = _interopRequireDefault(_objectHash);

var _lodash = __webpack_require__(31);

var _lodash2 = _interopRequireDefault(_lodash);

var _document_artifact_component = __webpack_require__(319);

var _document_artifact_component2 = _interopRequireDefault(_document_artifact_component);

var _physical_artifact_component = __webpack_require__(323);

var _physical_artifact_component2 = _interopRequireDefault(_physical_artifact_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    name: "ViewArtifact",
    data: function data() {
        return {
            uuid: 0,

            showSpinner: false,
            showExit: false,
            rowNumberSelected: '',
            tabSelected: '',
            objectHash: null,
            oTab: 'runTab' + this._uid,
            rTab: 'rTab' + this._uid,

            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.artifact, this.$route.params.artifact_id + "/comms_log"),
            comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.artifact, this.$route.params.artifact_id + "/add_comms_log"),
            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.artifact, this.$route.params.artifact_id + "/action_log"),
            baseArtifact: {}
        };
    },

    components: {
        CommsLogs: _comms_logs2.default,
        FormSection: _section_toggle2.default,
        DocumentArtifact: _document_artifact_component2.default,
        PhysicalArtifact: _physical_artifact_component2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('documentArtifactStore', {
        document_artifact: "document_artifact"
    }), (0, _vuex.mapGetters)('physicalArtifactStore', {
        physical_artifact: "physical_artifact"
    }), {
        componentType: function componentType() {
            var returnType = '';
            if (this.document_artifact && this.document_artifact.id) {
                returnType = 'document';
            } else if (this.physical_artifact && this.physical_artifact.id) {
                returnType = 'physical';
            }
            return returnType;
        },
        artifactComponent: function artifactComponent() {
            var component = null;
            if (this.document_artifact && this.document_artifact.id) {
                component = this.document_artifact;
            } else if (this.physical_artifact && this.physical_artifact.id) {
                component = this.physical_artifact;
            }
            return component;
        },
        artifactComponentNumber: function artifactComponentNumber() {
            var artifactNumber = null;
            if (this.artifactComponent) {
                artifactNumber = this.artifactComponent.number;
            }
            return artifactNumber;
        }

    }, (0, _vuex.mapGetters)({
        current_user: 'current_user'
    }), {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        },

        artifactStatusDisplay: function artifactStatusDisplay() {
            if (this.componentType === 'document') {
                return this.document_artifact.status ? this.document_artifact.status.name : '';
            } else if (this.componentType === 'physical') {
                return this.physical_artifact.status ? this.physical_artifact.status.name : '';
            }
        },

        canUserAction: function canUserAction() {
            var return_val = true;
            if (this.artifactComponent && this.artifactComponent.status && this.artifactComponent.status.id === 'closed') {
                return_val = false;
            }
            return return_val;
        },
        updateDocumentArtifactBindId: function updateDocumentArtifactBindId() {
            return "PersonOrArtifact_DocumentArtifact_" + this.uuid.toString();
        },
        updatePhysicalArtifactBindId: function updatePhysicalArtifactBindId() {
            return "PersonOrArtifact_PhysicalArtifact_" + this.uuid.toString();
        },
        showDocumentArtifactComponent: function showDocumentArtifactComponent() {
            var showComponent = false;
            if (this.componentType === 'document') {
                showComponent = true;
            }
            return showComponent;
        },
        showPhysicalArtifactComponent: function showPhysicalArtifactComponent() {
            var showComponent = false;
            if (this.componentType === 'physical') {
                showComponent = true;
            }
            return showComponent;
        },
        relatedItemsBindId: function relatedItemsBindId() {
            var timeNow = Date.now();
            var bindId = null;
            if (this.artifactComponent && this.artifactComponent.id) {
                bindId = 'artifact_' + this.artifactComponent.id + '_' + this._uid;
            } else {
                bindId = timeNow.toString();
            }
            return bindId;
        },
        relatedItemsVisibility: function relatedItemsVisibility() {
            var related_items_visibility = false;
            if (this.artifactComponent && this.artifactComponent.id) {
                related_items_visibility = true;
            }
            return related_items_visibility;
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? (0, _moment2.default)(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('documentArtifactStore', {
        saveDocumentArtifact: 'saveDocumentArtifact',
        loadDocumentArtifact: 'loadDocumentArtifact',
        setDocumentArtifact: 'setDocumentArtifact'
    }), (0, _vuex.mapActions)('physicalArtifactStore', {
        savePhysicalArtifact: 'savePhysicalArtifact',
        loadPhysicalArtifact: 'loadPhysicalArtifact',
        setPhysicalArtifact: 'setPhysicalArtifact'
    }), (0, _vuex.mapActions)({
        loadCurrentUser: 'loadCurrentUser'
    }), {
        saveExit: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.save({ "returnToDash": true });

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function saveExit() {
                return _ref.apply(this, arguments);
            }

            return saveExit;
        }(),
        save: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    _ref3$returnToDash = _ref3.returnToDash,
                    returnToDash = _ref3$returnToDash === undefined ? false : _ref3$returnToDash;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.showSpinner = true;
                                if (returnToDash) {
                                    this.showExit = true;
                                }

                                if (!(this.componentType === 'document')) {
                                    _context2.next = 7;
                                    break;
                                }

                                _context2.next = 5;
                                return this.$refs.document_artifact.save();

                            case 5:
                                _context2.next = 10;
                                break;

                            case 7:
                                if (!(this.componentType === 'physical')) {
                                    _context2.next = 10;
                                    break;
                                }

                                _context2.next = 10;
                                return this.$refs.physical_artifact.save();

                            case 10:

                                if (returnToDash) {
                                    window.removeEventListener('beforeunload', this.leaving);
                                    window.removeEventListener('onblur', this.leaving);

                                    this.$router.push({ name: 'internal-artifact-dash' });
                                } else {
                                    this.runningSheetEntriesUpdated = [];
                                }
                                this.showSpinner = false;
                                this.showExit = false;

                            case 13:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function save() {
                return _ref2.apply(this, arguments);
            }

            return save;
        }(),

        updateAssignedToId: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(user) {
                var url, payload, res;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, this.legal_case.id + '/update_assigned_to_id/');
                                payload = null;

                                if (user === 'current_user' && this.legal_case.user_in_group) {
                                    payload = { 'current_user': true };
                                } else if (user === 'blank') {
                                    payload = { 'blank': true };
                                } else {
                                    payload = { 'assigned_to_id': this.legal_case.assigned_to_id };
                                }
                                _context3.next = 5;
                                return _vue2.default.http.post(url, payload);

                            case 5:
                                res = _context3.sent;
                                _context3.next = 8;
                                return this.setLegalCase(res.body);

                            case 8:
                                this.constructRunningSheetTableWrapper();

                            case 9:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function updateAssignedToId(_x2) {
                return _ref4.apply(this, arguments);
            }

            return updateAssignedToId;
        }()
    }),
    created: function () {
        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            var returnedArtifact, artifactId, artifactObjectType;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (!this.$route.params.artifact_id) {
                                _context4.next = 17;
                                break;
                            }

                            _context4.next = 3;
                            return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.artifact, this.$route.params.artifact_id));

                        case 3:
                            returnedArtifact = _context4.sent;
                            artifactId = returnedArtifact.body.id;
                            artifactObjectType = returnedArtifact.body.artifact_object_type;

                            this.baseArtifact = _lodash2.default.cloneDeep(returnedArtifact.body);

                            console.log(artifactId);
                            console.log(artifactObjectType);

                            if (!(artifactId && artifactObjectType === 'document')) {
                                _context4.next = 14;
                                break;
                            }

                            _context4.next = 12;
                            return this.loadDocumentArtifact({ document_artifact_id: artifactId });

                        case 12:
                            _context4.next = 17;
                            break;

                        case 14:
                            if (!(artifactId && artifactObjectType === 'physical')) {
                                _context4.next = 17;
                                break;
                            }

                            _context4.next = 17;
                            return this.loadPhysicalArtifact({ physical_artifact_id: artifactId });

                        case 17:
                            _context4.next = 19;
                            return this.loadCurrentUser({ url: "/api/my_compliance_user_details" });

                        case 19:
                            console.log(this);

                        case 20:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function created() {
            return _ref5.apply(this, arguments);
        }

        return created;
    }(),

    mounted: function mounted() {
        this.$nextTick(function () {});
    }
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _hooks = __webpack_require__(3);

var _person_or_artifact_modal = __webpack_require__(322);

var _person_or_artifact_modal2 = _interopRequireDefault(_person_or_artifact_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ArtifactTableDash',
    data: function data() {
        var vm = this;
        return {
            artifact_types: [],
            artifact_statuses: [],

            filterType: 'all',
            filterStatus: 'all',
            filterDateFromPicker: '',
            filterDateToPicker: '',
            createArtifactInitialised: false,
            createArtifactBindId: '',

            dtOptions: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                processing: true,
                ajax: {
                    url: '/api/artifact_paginated/get_paginated_datatable/?format=datatables',
                    dataSrc: 'data',
                    data: function data(d) {
                        d.type = vm.filterType;
                        d.artifact_status = vm.filterStatus;
                        d.date_from = vm.filterDateFromPicker;
                        d.date_to = vm.filterDateToPicker;
                    }
                },
                columns: [{
                    data: 'number',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'artifact_type_display',
                    searchable: true,
                    orderable: false
                }, {
                    data: 'identifier',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'artifact_date',
                    searchable: false,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format('DD/MM/YYYY') : '';
                    }
                }, {
                    data: 'number',
                    searchable: false,
                    orderable: false,
                    mRender: function mRender(data, type, full) {
                        return '---';
                    }
                }, {
                    searchable: false,
                    orderable: false,
                    data: 'status'
                }, {
                    searchable: false,
                    orderable: false,
                    data: 'digital_documents'
                }, {
                    searchable: false,
                    orderable: false,
                    data: 'user_action'
                }]
            },
            dtHeaders: ['Number', 'Type', 'Identifier', 'Date', 'Custodian', 'Status', 'Documents', 'Action']
        };
    },

    computed: {
        readonlyForm: function readonlyForm() {
            return false;
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.$nextTick(function () {
            vm.addEventListeners();
        });
    },

    watch: {
        filterType: function filterType() {
            this.$refs.artifact_table.vmDataTable.draw();
        },
        filterStatus: function filterStatus() {
            this.$refs.artifact_table.vmDataTable.draw();
        },
        filterDateFromPicker: function filterDateFromPicker() {
            this.$refs.artifact_table.vmDataTable.draw();
        },
        filterDateToPicker: function filterDateToPicker() {
            this.$refs.artifact_table.vmDataTable.draw();
        }
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.constructOptionsType();
                            this.constructOptionsStatus();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    methods: {
        createArtifact: function createArtifact() {
            var _this = this;

            console.log("create artifact");
            this.setCreateArtifactBindId();
            this.createArtifactInitialised = true;
            this.$nextTick(function () {
                _this.$refs.create_artifact.isModalOpen = true;
            });
        },
        setCreateArtifactBindId: function setCreateArtifactBindId() {
            var timeNow = Date.now();
            this.createArtifactBindId = 'artifact' + timeNow.toString();
        },
        addEventListeners: function addEventListeners() {
            console.log('addEventLinsterners');

            var vm = this;
            this.attachFromDatePicker();
            this.attachToDatePicker();
        },
        attachFromDatePicker: function attachFromDatePicker() {
            var vm = this;
            var el_fr = (0, _jquery2.default)(vm.$refs.issueDateFromPicker);
            var el_to = (0, _jquery2.default)(vm.$refs.issueDateToPicker);

            el_fr.datetimepicker({ format: 'DD/MM/YYYY', maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_fr.on('dp.change', function (e) {
                if (el_fr.data('DateTimePicker').date()) {
                    vm.filterDateFromPicker = e.date.format('DD/MM/YYYY');
                    el_to.data('DateTimePicker').minDate(e.date);
                } else if (el_fr.data('date') === "") {
                    vm.filterDateFromPicker = "";
                }
            });
        },
        attachToDatePicker: function attachToDatePicker() {
            var vm = this;
            var el_fr = (0, _jquery2.default)(vm.$refs.issueDateFromPicker);
            var el_to = (0, _jquery2.default)(vm.$refs.issueDateToPicker);
            el_to.datetimepicker({ format: 'DD/MM/YYYY', maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_to.on('dp.change', function (e) {
                if (el_to.data('DateTimePicker').date()) {
                    vm.filterDateToPicker = e.date.format('DD/MM/YYYY');
                    el_fr.data('DateTimePicker').maxDate(e.date);
                } else if (el_to.data('date') === "") {
                    vm.filterDateToPicker = "";
                }
            });
        },
        constructOptionsType: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var returned;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _hooks.cache_helper.getSetCacheList('ArtifactTypes', '/api/artifact/types.json');

                            case 2:
                                returned = _context2.sent;

                                (0, _assign2.default)(this.artifact_types, returned);
                                this.artifact_types.splice(0, 0, { id: 'all', display: 'All' });

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function constructOptionsType() {
                return _ref2.apply(this, arguments);
            }

            return constructOptionsType;
        }(),
        constructOptionsStatus: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var returned;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _hooks.cache_helper.getSetCacheList('ArtifactStatuses', '/api/artifact/statuses.json');

                            case 2:
                                returned = _context3.sent;

                                (0, _assign2.default)(this.artifact_statuses, returned);
                                this.artifact_statuses.splice(0, 0, { id: 'all', display: 'All' });

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function constructOptionsStatus() {
                return _ref3.apply(this, arguments);
            }

            return constructOptionsStatus;
        }()
    },
    components: {
        datatable: _datatable2.default,
        FormSection: _section_toggle2.default,
        CreateArtifact: _person_or_artifact_modal2.default
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Assignment',
    props: {
        user_in_group: {
            type: Boolean,
            required: true
        },
        user_is_assignee: {
            type: Boolean,
            required: true
        },
        assigned_to_id: {
            type: String,
            required: false
        },
        allowed_group_ids: {
            type: Array,
            required: false
        },
        assign_url: {
            type: String,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        return {
            allowed_groups: this.getAllocatedGroup(this.allowed_group_ids)
        };
    },
    components: {},
    computed: {},
    methods: {
        updateAssignedToId: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(user) {
                var url, payload, res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                url = this.assign_url;
                                payload = null;

                                if (user === 'current_user' && this.user_in_group) {
                                    payload = { 'current_user': true };
                                } else if (user === 'blank') {
                                    payload = { 'blank': true };
                                } else {
                                    payload = { 'assigned_to_id': this.assigned_to_id };
                                }
                                _context.next = 5;
                                return _vue2.default.http.post(url, payload);

                            case 5:
                                res = _context.sent;

                                this.$emit('update-assigned-to-id', res.body);

                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function updateAssignedToId(_x) {
                return _ref.apply(this, arguments);
            }

            return updateAssignedToId;
        }(),
        getAllocatedGroup: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(id_list) {
                var allocatedGroupResponse;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (this.allowed_groups == null) {
                                    _vue2.default.set(this, 'allowed_groups', []);
                                }
                                _context2.next = 3;
                                return _vue2.default.http.post(_hooks.api_endpoints.allocated_group_members, {
                                    'id_list': id_list
                                });

                            case 3:
                                allocatedGroupResponse = _context2.sent;

                                if (allocatedGroupResponse.ok) {
                                    _vue2.default.set(this, 'allowed_groups', allocatedGroupResponse.body);
                                }

                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getAllocatedGroup(_x2) {
                return _ref2.apply(this, arguments);
            }

            return getAllocatedGroup;
        }()
    },
    watch: {
        allowed_group_ids: function allowed_group_ids(after, before) {
            if (before === undefined && after !== undefined) {
                this.getAllocatedGroup(this.allowed_group_ids);
            }
        }
    }
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _getOwnPropertyNames = __webpack_require__(70);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _map_location = __webpack_require__(853);

var _map_location2 = _interopRequireDefault(_map_location);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

var _search_person_or_organisation = __webpack_require__(49);

var _search_person_or_organisation2 = _interopRequireDefault(_search_person_or_organisation);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _vuex = __webpack_require__(6);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _call_email_workflow = __webpack_require__(852);

var _call_email_workflow2 = _interopRequireDefault(_call_email_workflow);

var _offence_modal = __webpack_require__(98);

var _offence_modal2 = _interopRequireDefault(_offence_modal);

var _sanction_outcome_modal = __webpack_require__(99);

var _sanction_outcome_modal2 = _interopRequireDefault(_sanction_outcome_modal);

__webpack_require__(15);

__webpack_require__(37);

var _create_inspection_modal = __webpack_require__(83);

var _create_inspection_modal2 = _interopRequireDefault(_create_inspection_modal);

var _related_items = __webpack_require__(58);

var _related_items2 = _interopRequireDefault(_related_items);

var _objectHash = __webpack_require__(55);

var _objectHash2 = _interopRequireDefault(_objectHash);

var _create_legal_case_modal = __webpack_require__(345);

var _create_legal_case_modal2 = _interopRequireDefault(_create_legal_case_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    name: "ViewCallEmail",
    data: function data() {
        return {
            objectHash: null,
            uuid: 0,
            cTab: 'cTab' + this._uid,
            rTab: 'rTab' + this._uid,
            sanctionOutcomeKey: 'sanctionOutcome' + this._uid,
            dtHeadersRelatedItems: ['Number', 'Type', 'Description', 'Action'],
            dtOptionsRelatedItems: {
                columns: [{
                    data: 'identifier'
                }, {
                    data: 'model_name'
                }, {
                    data: 'descriptor'
                }, {
                    data: 'Action',
                    mRender: function mRender(data, type, row) {
                        return '<a href="#">View (not implemented)</a>';
                    }
                }]
            },
            disabledDates: {
                from: new Date()
            },
            workflow_type: '',
            lovCollection: {},

            classification_types: [],
            call_types: [],
            wildcare_species_types: [],
            filter_wildcare_species_types: [],
            wildcare_species_sub_types: [],
            filter_wildcare_species_sub_types: [],

            speciesSubTypeDisabled: false,
            isFemalePinkyJoey: false,
            entangled_choices: [],
            gender_choices: [],
            baby_kangaroo_choices: [],
            age_choices: [],
            report_types: [],
            referrers: [],
            referrersSelected: [],

            current_schema: [],

            reportAdviceUrl: '',
            sectionLabel: "Details",
            sectionIndex: 1,
            pBody: "pBody" + this._uid,
            loading: [],
            renderer_form: null,
            callemailTab: "callemailTab" + this._uid,
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.call_email, this.$route.params.call_email_id + "/comms_log"),
            comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.call_email, this.$route.params.call_email_id + "/add_comms_log"),
            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.call_email, this.$route.params.call_email_id + "/action_log"),
            workflowBindId: '',
            sanctionOutcomeInitialised: false,
            offenceInitialised: false,
            inspectionInitialised: false,
            legalCaseInitialised: false,
            hashAttributeWhitelist: ["allocated_group_id", "location", "location_id", "classification", "classification_id", "call_type", "call_type_id", "lodgement_date", "number", "caller", "report_type_id", "caller_phone_number", "anonymous_call", "caller_wishes_to_remain_anonymous", "occurrence_from_to", "occurrence_date_from", "occurrence_time_start", "occurrence_date_to", "occurrence_time_end", "date_of_call", "time_of_call", "advice_given", "advice_details", "region_id", "district_id", "case_priority_id", "dead", "euthanise", "number_of_animals", "brief_nature_of_call"]
        };
    },
    components: {
        CommsLogs: _comms_logs2.default,
        FormSection: _section_toggle2.default,
        MapLocation: _map_location2.default,
        SearchPersonOrganisation: _search_person_or_organisation2.default,
        CallWorkflow: _call_email_workflow2.default,
        Offence: _offence_modal2.default,

        RelatedItems: _related_items2.default,
        SanctionOutcome: _sanction_outcome_modal2.default,
        Inspection: _create_inspection_modal2.default,
        CreateLegalCaseModal: _create_legal_case_modal2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('callemailStore', {
        call_email: "call_email"
    }), (0, _vuex.mapGetters)({
        renderer_form_data: 'renderer_form_data'
    }), {
        locationExists: function locationExists() {
            if (this.call_email && this.call_email.location && this.call_email.location.geometry && this.call_email.location.geometry.coordinates.length > 0) {
                return true;
            }
        },
        assignToVisible: function assignToVisible() {
            var visible = false;
            if (this.call_email && this.call_email.allocated_group && this.call_email.can_user_action && this.statusId === 'open') {
                visible = true;
            }
            return visible;
        },
        personSearchVisibility: function personSearchVisibility() {
            var visible = false;
            if (this.statusId === 'open') {
                visible = true;
            }
            return visible;
        },
        closeButtonVisibility: function closeButtonVisibility() {
            var visibility = true;
            if (['closed', 'pending_closure'].includes(this.statusId)) {
                visibility = false;
            }
            return visibility;
        },
        updateSearchPersonOrganisationBindId: function updateSearchPersonOrganisationBindId() {
            var bindId = 'individual';
            if (this.call_email.email_user && this.call_email.email_user.id) {
                bindId += this.call_email.email_user.id;
            } else {
                bindId += '0';
            }
            return bindId;
        },
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        },
        callerEntity: function callerEntity() {
            var entity = {};
            if (this.call_email.email_user && this.call_email.email_user.id) {
                entity.id = this.call_email.email_user.id;
                entity.data_type = 'individual';
            }
            return entity;
        },
        occurrenceDateLabel: function occurrenceDateLabel() {
            if (this.call_email.occurrence_from_to) {
                return "Occurrence date from";
            } else {
                return "Occurrence date";
            }
        },
        occurrenceTimeLabel: function occurrenceTimeLabel() {
            if (this.call_email.occurrence_from_to) {
                return "Occurrence time from";
            } else {
                return "Occurrence time";
            }
        },
        readonlyForm: function readonlyForm() {
            if (this.call_email.id) {
                return !this.call_email.can_user_edit_form;
            } else {
                return true;
            }
        },
        canUserAction: function canUserAction() {
            return this.call_email.can_user_action;
        },
        statusDisplay: function statusDisplay() {
            return this.call_email.status ? this.call_email.status.name : '';
        },
        statusId: function statusId() {
            return this.call_email.status ? this.call_email.status.id : '';
        },
        offenceExists: function offenceExists() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.call_email.related_items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.model_name.toLowerCase() === "offence") {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return false;
        },
        relatedItemsBindId: function relatedItemsBindId() {
            var timeNow = Date.now();
            if (this.call_email && this.call_email.id) {
                return 'call_email_' + this.call_email.id + '_' + this._uid;
            } else {
                return timeNow.toString();
            }
        },
        relatedItemsVisibility: function relatedItemsVisibility() {
            if (this.call_email && this.call_email.id) {
                return true;
            } else {
                return false;
            }
        },
        rendererVisibility: function rendererVisibility() {
            if (this.call_email.id && this.current_schema && this.current_schema.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        offenceBindId: function offenceBindId() {
            return 'offence' + this.uuid;
        },
        isEntangledOther: function isEntangledOther() {
            var entangled_other_checked = false;
            if (this.call_email && this.call_email.entangled) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)(this.call_email.entangled), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var choice = _step2.value;

                        if (choice === "other") entangled_other_checked = true;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            } else {
                entangled_other_checked = false;
            }
            if (entangled_other_checked === false) {
                this.call_email.entangled_other = null;
            }
            return entangled_other_checked;
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? (0, _moment2.default)(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('callemailStore', {
        loadCallEmail: 'loadCallEmail',
        saveCallEmail: 'saveCallEmail',
        setCallEmail: 'setCallEmail',
        setRegionId: 'setRegionId',
        setAllocatedGroupList: 'setAllocatedGroupList',
        setOccurrenceTimeStart: 'setOccurrenceTimeStart',
        setOccurrenceTimeEnd: 'setOccurrenceTimeEnd',
        setTimeOfCall: 'setTimeOfCall',
        setDateOfCall: 'setDateOfCall',
        setRelatedItems: 'setRelatedItems',
        setCaller: 'setCaller'
    }), (0, _vuex.mapActions)({
        saveFormData: 'saveFormData'
    }), {
        updateUuid: function updateUuid() {
            this.uuid += 1;
        },
        entitySelected: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(para) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.setCaller(para);

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function entitySelected(_x) {
                return _ref.apply(this, arguments);
            }

            return entitySelected;
        }(),
        loadReportAdviceUrl: function loadReportAdviceUrl(url) {
            if (!this.reportAdviceUrl && this.call_email && this.call_email.report_type) {
                this.reportAdviceUrl = url;
            }
        },

        formChanged: function formChanged() {
            var _this = this;

            var changed = false;
            var copiedCallEmail = {};
            (0, _getOwnPropertyNames2.default)(this.call_email).forEach(function (val, idx, array) {
                if (_this.hashAttributeWhitelist.includes(val)) {
                    copiedCallEmail[val] = _this.call_email[val];
                }
            });
            this.addHashAttributes(copiedCallEmail);
            if (this.objectHash !== (0, _objectHash2.default)(copiedCallEmail)) {
                changed = true;
            }
            return changed;
        },
        calculateHash: function calculateHash() {
            var _this2 = this;

            var copiedCallEmail = {};
            (0, _getOwnPropertyNames2.default)(this.call_email).forEach(function (val, idx, array) {
                if (_this2.hashAttributeWhitelist.includes(val)) {
                    copiedCallEmail[val] = _this2.call_email[val];
                }
            });
            this.addHashAttributes(copiedCallEmail);
            this.objectHash = (0, _objectHash2.default)(copiedCallEmail);
        },
        addHashAttributes: function addHashAttributes(obj) {
            var copiedRendererFormData = (0, _assign2.default)({}, this.renderer_form_data);
            obj.renderer_form_data = copiedRendererFormData;
            var copiedCallerEntity = (0, _assign2.default)({}, this.callerEntity);
            obj.callerEntity = copiedCallerEntity;
        },
        updateWorkflowBindId: function updateWorkflowBindId() {
            var timeNow = Date.now();
            if (this.workflow_type) {
                this.workflowBindId = this.workflow_type + '_' + timeNow.toString();
            } else {
                this.workflowBindId = timeNow.toString();
            }
        },
        addWorkflow: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(workflow_type) {
                var _this3 = this;

                var res;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (this.locationExists) {
                                    _context2.next = 5;
                                    break;
                                }

                                _context2.next = 3;
                                return swal({
                                    title: 'Mandatory Field',
                                    html: "Location must be specified",
                                    type: "error"
                                });

                            case 3:
                                _context2.next = 14;
                                break;

                            case 5:
                                _context2.prev = 5;
                                _context2.next = 8;
                                return this.saveCallEmail({ crud: 'forward', internal: true });

                            case 8:
                                res = _context2.sent;

                                if (res.ok) {
                                    this.workflow_type = workflow_type;
                                    this.updateWorkflowBindId();
                                    this.$nextTick(function () {
                                        _this3.$refs.add_workflow.isModalOpen = true;
                                    });
                                }
                                _context2.next = 14;
                                break;

                            case 12:
                                _context2.prev = 12;
                                _context2.t0 = _context2["catch"](5);

                            case 14:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[5, 12]]);
            }));

            function addWorkflow(_x2) {
                return _ref2.apply(this, arguments);
            }

            return addWorkflow;
        }(),
        openSanctionOutcome: function openSanctionOutcome() {
            var _this4 = this;

            this.sanctionOutcomeInitialised = true;
            this.$nextTick(function () {
                _this4.$refs.sanction_outcome.isModalOpen = true;
            });
        },
        openOffence: function openOffence() {
            this.offenceInitialised = true;
            this.$refs.offence.isModalOpen = true;
        },
        allocateForInspection: function allocateForInspection() {
            var _this5 = this;

            this.inspectionInitialised = true;
            this.$nextTick(function () {
                _this5.$refs.inspection.isModalOpen = true;
            });
        },
        allocateForLegalCase: function allocateForLegalCase() {
            var _this6 = this;

            this.legalCaseInitialised = true;
            this.$nextTick(function () {
                _this6.$refs.legal_case.isModalOpen = true;
            });
        },

        filterWildcareSpeciesType: function filterWildcareSpeciesType(event, all_wildcare_species) {
            var _this7 = this;

            this.$nextTick(function () {
                if (event) {
                    _this7.call_email.species_name = null;
                    _this7.call_email.wildcare_species_type_id = null;
                }
                _this7.filter_wildcare_species_types = [];
                _this7.filter_wildcare_species_types = [{
                    id: null,
                    display: "",
                    call_type_id: null,
                    check_pinky_joey: false,
                    show_species_name_textbox: false
                }];
                _this7.filter_wildcare_species_sub_types = [];

                if (all_wildcare_species === false) {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = (0, _getIterator3.default)(_this7.wildcare_species_types), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var choice = _step3.value;

                            if (choice.call_type_id === _this7.call_email.call_type_id || choice.call_type_id === null) {
                                _this7.filter_wildcare_species_types.push(choice);
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                } else {
                    _this7.filter_wildcare_species_types = _this7.wildcare_species_types;
                }

                _this7.checkFemalePinkyJoey();
            });
        },
        filterWildcareSpeciesSubType: function filterWildcareSpeciesSubType(event) {
            var _this8 = this;

            this.$nextTick(function () {
                if (event) {
                    _this8.call_email.species_name = null;
                    _this8.call_email.wildcare_species_sub_type_id = null;
                }
                _this8.filter_wildcare_species_sub_types = [{
                    id: null,
                    display: "",
                    wildcare_species_type_id: null
                }];

                _this8.speciesSubTypeDisabled = false;
                if (_this8.readonlyForm) {
                    _this8.speciesSubTypeDisabled = true;
                } else if (_this8.call_email.wildcare_species_type_id) {
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = (0, _getIterator3.default)(_this8.filter_wildcare_species_types), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var choice = _step4.value;

                            if (choice.id === _this8.call_email.wildcare_species_type_id && choice.show_species_name_textbox === true) {
                                _this8.speciesSubTypeDisabled = true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = (0, _getIterator3.default)(_this8.wildcare_species_sub_types), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var _choice = _step5.value;

                        if (_choice.wildcare_species_type_id === _this8.call_email.wildcare_species_type_id) {
                            _this8.filter_wildcare_species_sub_types.push(_choice);
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                _this8.checkFemalePinkyJoey();
            });
        },
        checkFemalePinkyJoey: function checkFemalePinkyJoey() {
            this.isFemalePinkyJoey = false;
            if (this.call_email && this.call_email.gender.includes("female") && this.call_email.wildcare_species_type_id) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = (0, _getIterator3.default)(this.filter_wildcare_species_types), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var choice = _step6.value;

                        if (choice.id === this.call_email.wildcare_species_type_id && choice.check_pinky_joey === true) {
                            this.isFemalePinkyJoey = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }

            if (!this.isFemalePinkyJoey) {
                this.call_email.baby_kangaroo = [];
            }
        },

        save: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(returnToDash) {
                var savedCallEmail, savedPerson;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                savedCallEmail = null;
                                savedPerson = null;

                                if (!this.call_email.id) {
                                    _context3.next = 18;
                                    break;
                                }

                                if (!(this.$refs.search_person_organisation && this.$refs.search_person_organisation.entityIsPerson)) {
                                    _context3.next = 13;
                                    break;
                                }

                                _context3.next = 6;
                                return this.$refs.search_person_organisation.parentSave();

                            case 6:
                                savedPerson = _context3.sent;

                                if (!(savedPerson && savedPerson.ok)) {
                                    _context3.next = 11;
                                    break;
                                }

                                _context3.next = 10;
                                return this.saveCallEmail({ crud: 'save' });

                            case 10:
                                savedCallEmail = _context3.sent;

                            case 11:
                                _context3.next = 16;
                                break;

                            case 13:
                                _context3.next = 15;
                                return this.saveCallEmail({ crud: 'save' });

                            case 15:
                                savedCallEmail = _context3.sent;

                            case 16:
                                _context3.next = 21;
                                break;

                            case 18:
                                _context3.next = 20;
                                return this.saveCallEmail({ crud: 'create' });

                            case 20:
                                savedCallEmail = _context3.sent;

                            case 21:
                                this.calculateHash();
                                if (savedCallEmail && savedCallEmail.ok && returnToDash === 'exit') {
                                    window.removeEventListener('beforeunload', this.leaving);
                                    window.removeEventListener('onblur', this.leaving);

                                    this.$router.push({ name: 'internal-call-email-dash' });
                                }

                            case 23:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function save(_x3) {
                return _ref3.apply(this, arguments);
            }

            return save;
        }(),
        duplicate: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.saveCallEmail({ route: false, crud: 'duplicate' });

                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function duplicate() {
                return _ref4.apply(this, arguments);
            }

            return duplicate;
        }(),
        loadSchema: function loadSchema() {
            if (this.call_email.report_type_id) {
                this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                    var url, returnedData, returnedSchema, returnedAdviceUrl;
                    return _regenerator2.default.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                                case 0:
                                    url = _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.report_types, this.call_email.report_type_id + '/get_schema');
                                    _context5.next = 3;
                                    return _vue2.default.http.get(url);

                                case 3:
                                    returnedData = _context5.sent;
                                    returnedSchema = returnedData.body.schema;
                                    returnedAdviceUrl = returnedData.body.adviceurl;

                                    if (returnedSchema) {
                                        this.current_schema = returnedSchema;
                                    }
                                    if (returnedAdviceUrl) {
                                        this.reportAdviceUrl = returnedAdviceUrl;
                                    }

                                case 8:
                                case "end":
                                    return _context5.stop();
                            }
                        }
                    }, _callee5, this);
                })));
            } else {
                this.current_schema = [];
            }
        },
        updateAssignedToId: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(user) {
                var url, payload, res;
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.call_email, this.call_email.id + '/update_assigned_to_id/');
                                payload = null;

                                if (user === 'current_user' && this.call_email.user_in_group) {
                                    payload = { 'current_user': true };
                                } else if (user === 'blank') {
                                    payload = { 'blank': true };
                                } else {
                                    payload = { 'assigned_to_id': this.call_email.assigned_to_id };
                                }
                                _context6.next = 5;
                                return _vue2.default.http.post(url, payload);

                            case 5:
                                res = _context6.sent;
                                _context6.next = 8;
                                return this.setCallEmail(res.body);

                            case 8:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function updateAssignedToId(_x4) {
                return _ref6.apply(this, arguments);
            }

            return updateAssignedToId;
        }(),
        addEventListeners: function addEventListeners() {
            var vm = this;
            var el_fr_date = $(vm.$refs.occurrenceDateFromPicker);
            var el_fr_time = $(vm.$refs.occurrenceTimeFromPicker);
            var el_to_date = $(vm.$refs.occurrenceDateToPicker);
            var el_to_time = $(vm.$refs.occurrenceTimeToPicker);
            var el_date_of_call = $(vm.$refs.dateOfCallPicker);
            var el_time_of_call = $(vm.$refs.timeOfCallPicker);

            el_fr_date.datetimepicker({
                format: "DD/MM/YYYY",
                maxDate: "now",
                showClear: true
            });
            el_fr_date.on("dp.change", function (e) {
                if (el_fr_date.data("DateTimePicker").date()) {
                    vm.call_email.occurrence_date_from = e.date.format("DD/MM/YYYY");
                } else if (el_fr_date.data("date") === "") {
                    vm.call_email.occurrence_date_from = "";
                }
            });
            el_fr_time.datetimepicker({ format: "LT", showClear: true });
            el_fr_time.on("dp.change", function (e) {
                if (el_fr_time.data("DateTimePicker").date()) {
                    vm.call_email.occurrence_time_from = e.date.format("LT");
                } else if (el_fr_time.data("date") === "") {
                    vm.call_email.occurrence_time_from = "";
                }
            });

            el_to_date.datetimepicker({
                format: "DD/MM/YYYY",
                maxDate: "now",
                showClear: true
            });
            el_to_date.on("dp.change", function (e) {
                if (el_to_date.data("DateTimePicker").date()) {
                    vm.call_email.occurrence_date_to = e.date.format("DD/MM/YYYY");
                } else if (el_to_date.data("date") === "") {
                    vm.call_email.occurrence_date_to = "";
                }
            });
            el_to_time.datetimepicker({ format: "LT", showClear: true });
            el_to_time.on("dp.change", function (e) {
                if (el_to_time.data("DateTimePicker").date()) {
                    vm.call_email.occurrence_time_to = e.date.format("LT");
                } else if (el_to_time.data("date") === "") {
                    vm.call_email.occurrence_time_to = "";
                }
            });

            el_date_of_call.datetimepicker({
                format: "DD/MM/YYYY",
                maxDate: "now"
            });
            el_date_of_call.on("dp.change", function (e) {
                if (el_date_of_call.data("DateTimePicker").date()) {
                    vm.call_email.date_of_call = e.date.format("DD/MM/YYYY");
                } else if (el_date_of_call.data("date") === "") {
                    vm.call_email.date_of_call = "";
                }
            });
            el_time_of_call.datetimepicker({ format: "LT", showClear: true });
            el_time_of_call.on("dp.change", function (e) {
                if (el_time_of_call.data("DateTimePicker").date()) {
                    vm.call_email.time_of_call = e.date.format("LT");
                } else if (el_time_of_call.data("date") === "") {
                    vm.call_email.time_of_call = "";
                }
            });
            window.addEventListener('beforeunload', this.leaving);
            window.addEventListener('onblur', this.leaving);
        },
        leaving: function leaving(e) {
            var dialogText = 'You have some unsaved changes.';
            if (this.formChanged()) {
                e.returnValue = dialogText;
                return dialogText;
            }
        }
    }),
    destroyed: function destroyed() {
        window.removeEventListener('beforeunload', this.leaving);
        window.removeEventListener('onblur', this.leaving);
    },
    created: function () {
        var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
            var lovResponse, returned_report_types, returned_referrers, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, referrer_id;

            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            if (!this.$route.params.call_email_id) {
                                _context7.next = 3;
                                break;
                            }

                            _context7.next = 3;
                            return this.loadCallEmail({ call_email_id: this.$route.params.call_email_id });

                        case 3:
                            _context7.next = 5;
                            return _vue2.default.http.get('/api/lov_collection/lov_collection_choices/');

                        case 5:
                            lovResponse = _context7.sent;

                            this.lovCollection = lovResponse.body;

                            (0, _assign2.default)(this.classification_types, this.lovCollection.classification_types);

                            (0, _assign2.default)(this.call_types, this.lovCollection.call_type_choices);

                            (0, _assign2.default)(this.wildcare_species_types, this.lovCollection.wildcare_species_types);

                            (0, _assign2.default)(this.wildcare_species_sub_types, this.lovCollection.wildcare_species_sub_types);

                            (0, _assign2.default)(this.entangled_choices, this.lovCollection.entangled_choices);

                            (0, _assign2.default)(this.gender_choices, this.lovCollection.gender_choices);

                            (0, _assign2.default)(this.baby_kangaroo_choices, this.lovCollection.baby_kangaroo_choices);

                            (0, _assign2.default)(this.age_choices, this.lovCollection.age_choices);
                            _context7.next = 17;
                            return _hooks.cache_helper.getSetCacheList('CallEmail_ReportTypes', _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.report_types, 'get_distinct_queryset'));

                        case 17:
                            returned_report_types = _context7.sent;

                            (0, _assign2.default)(this.report_types, returned_report_types);

                            this.report_types.splice(0, 0, {
                                id: "",
                                name: ""
                            });
                            _context7.next = 22;
                            return _hooks.cache_helper.getSetCacheList('CallEmail_Referrers', '/api/referrers.json');

                        case 22:
                            returned_referrers = _context7.sent;

                            (0, _assign2.default)(this.referrers, returned_referrers);

                            this.referrers.splice(0, 0, {
                                id: "",
                                name: ""
                            });

                            _iteratorNormalCompletion7 = true;
                            _didIteratorError7 = false;
                            _iteratorError7 = undefined;
                            _context7.prev = 28;

                            for (_iterator7 = (0, _getIterator3.default)(this.call_email.selected_referrers); !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                referrer_id = _step7.value;

                                this.referrersSelected.push(referrer_id);
                            }
                            _context7.next = 36;
                            break;

                        case 32:
                            _context7.prev = 32;
                            _context7.t0 = _context7["catch"](28);
                            _didIteratorError7 = true;
                            _iteratorError7 = _context7.t0;

                        case 36:
                            _context7.prev = 36;
                            _context7.prev = 37;

                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }

                        case 39:
                            _context7.prev = 39;

                            if (!_didIteratorError7) {
                                _context7.next = 42;
                                break;
                            }

                            throw _iteratorError7;

                        case 42:
                            return _context7.finish(39);

                        case 43:
                            return _context7.finish(36);

                        case 44:
                            if (!(this.call_email && this.call_email.report_type_id)) {
                                _context7.next = 47;
                                break;
                            }

                            _context7.next = 47;
                            return this.loadSchema();

                        case 47:
                            if (this.call_email && this.call_email.report_type && this.call_email.report_type.advice_url) {
                                this.loadReportAdviceUrl(this.call_email.report_type.advice_url);
                            }

                            if (!this.call_email.date_of_call && this.call_email.can_user_edit_form) {
                                this.setDateOfCall((0, _moment2.default)().format('DD/MM/YYYY'));
                            }
                            if (!this.call_email.time_of_call && this.call_email.can_user_edit_form) {
                                this.setTimeOfCall((0, _moment2.default)().format('LT'));
                            }
                            this.calculateHash();
                            this.filterWildcareSpeciesType();
                            this.$nextTick(function () {
                                this.filterWildcareSpeciesSubType();
                                this.checkFemalePinkyJoey();
                            });

                        case 53:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, this, [[28, 32, 36, 44], [37,, 39, 43]]);
        }));

        function created() {
            return _ref7.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        var vm = this;
        $('a[data-toggle="collapse"]').on('click', function () {
            var chev = $(this).children()[0];
            window.setTimeout(function () {
                $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
            }, 100);
        });

        $('#occurrenceTimeStartPicker').datetimepicker({
            format: 'LT'
        });
        $('#occurrenceTimeEndPicker').datetimepicker({
            format: 'LT'
        });
        $('#occurrenceTimeStartPicker').on('dp.change', function (e) {
            vm.setOccurrenceTimeStart(e.date.format('LT'));
        });
        $('#occurrenceTimeEndPicker').on('dp.change', function (e) {
            vm.setOccurrenceTimeEnd(e.date.format('LT'));
        });
        $('#timeOfCallPicker').datetimepicker({
            format: 'LT'
        });
        $('#timeOfCallPicker').on('dp.change', function (e) {
            vm.setTimeOfCall(e.date.format('LT'));
        });
        vm.$nextTick(function () {
            vm.addEventListeners();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(2)))

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _map_locations = __webpack_require__(854);

var _map_locations2 = _interopRequireDefault(_map_locations);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'CallEmailDashTable',
    data: function data() {
        var vm = this;
        return {
            complianceUser: {
                is_volunteer: false
            },
            classification_types: [],

            report_types: [],

            filterStatus: 'All',
            filterClassification: 'All',

            status_choices: [],
            filterLodgedFrom: '',
            filterLodgedTo: '',
            dateFormat: 'DD/MM/YYYY',
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            dtOptions: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                autoWidth: false,
                rowCallback: function rowCallback(row, data) {
                    (0, _jquery2.default)(row).addClass('appRecordRow');
                },

                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },

                responsive: true,
                processing: true,
                ajax: {
                    "url": "/api/call_email_paginated/get_paginated_datatable/?format=datatables",
                    "dataSrc": 'data',
                    "data": function data(d) {
                        d.status_description = vm.filterStatus;
                        d.classification_description = vm.filterClassification;
                        d.date_from = vm.filterLodgedFrom != '' && vm.filterLodgedFrom != null ? moment(vm.filterLodgedFrom, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                        d.date_to = vm.filterLodgedTo != '' && vm.filterLodgedTo != null ? moment(vm.filterLodgedTo, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                    }
                },
                dom: 'lBfrtip',
                buttons: ['excel', 'csv'],
                columns: [{
                    data: "number",
                    searchable: false
                }, {
                    data: "status.name",
                    searchable: false
                }, {
                    data: "species_sub_type",
                    searchable: false,
                    visible: false
                }, {
                    data: "classification",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        if (data) {
                            return full.species_sub_type ? data.classification_display + ': ' + full.species_sub_type : data.classification_display;
                        }
                        return '';
                    }
                }, {
                    data: "lodged_on",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format(vm.dateFormat) : '';
                    }
                }, {
                    data: "caller",
                    searchable: false
                }, {
                    data: "assigned_to",
                    searchable: false,
                    orderable: false,
                    mRender: function mRender(data, type, full) {
                        if (data) {
                            return data.full_name;
                        } else {
                            return '';
                        }
                    }
                }, {
                    data: "user_action",
                    searchable: false,
                    orderable: false
                }]
            },
            dtHeaders: ["Number", "Status", "SubSpecies", "Classification", "Lodged on", "Caller", "Assigned to", "Action"]
        };
    },

    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var returnedComplianceUserData, returned_classification_types, returned_status_choices;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _vue2.default.http.get('/api/my_compliance_user_details/');

                        case 2:
                            returnedComplianceUserData = _context.sent;

                            (0, _assign2.default)(this.complianceUser, returnedComplianceUserData.body);
                            _context.next = 6;
                            return _vue2.default.http.get('/api/classification/classification_choices/');

                        case 6:
                            returned_classification_types = _context.sent;

                            (0, _assign2.default)(this.classification_types, returned_classification_types.body);
                            this.classification_types.splice(0, 0, { id: 'all', display: 'All' });

                            _context.next = 11;
                            return _hooks.cache_helper.getSetCacheList('CallEmail_StatusChoices', '/api/call_email/status_choices');

                        case 11:
                            returned_status_choices = _context.sent;

                            (0, _assign2.default)(this.status_choices, returned_status_choices);
                            this.status_choices.splice(0, 0, { id: 'all', display: 'All' });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    watch: {
        filterStatus: function filterStatus() {
            this.$refs.call_email_table.vmDataTable.draw();
        },
        filterClassification: function filterClassification() {
            this.$refs.call_email_table.vmDataTable.draw();
        },
        filterLodgedFrom: function filterLodgedFrom() {
            this.$refs.call_email_table.vmDataTable.draw();
        },
        filterLodgedTo: function filterLodgedTo() {
            this.$refs.call_email_table.vmDataTable.draw();
        }
    },
    components: {
        datatable: _datatable2.default,
        FormSection: _section_toggle2.default,
        MapLocations: _map_locations2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('callemailStore', {}), {
        newCallEmailVisibility: function newCallEmailVisibility() {
            var visibility = false;
            if (this.complianceUser && this.complianceUser.is_volunteer) {
                visibility = true;
            }
            return visibility;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('callemailStore', {
        saveCallEmail: "saveCallEmail"
    }), {
        createCallEmailUrl: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var newCallId, savedCallEmail;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                newCallId = null;
                                _context2.next = 3;
                                return this.saveCallEmail({ route: false, crud: 'create' });

                            case 3:
                                savedCallEmail = _context2.sent;

                                if (savedCallEmail) {
                                    newCallId = savedCallEmail.body.id;
                                }

                                _context2.next = 7;
                                return this.$router.push({
                                    name: 'view-call-email',
                                    params: { call_email_id: newCallId }
                                });

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function createCallEmailUrl() {
                return _ref2.apply(this, arguments);
            }

            return createCallEmailUrl;
        }(),
        addEventListeners: function addEventListeners() {
            var vm = this;

            (0, _jquery2.default)(vm.$refs.lodgementDateToPicker).datetimepicker(vm.datepickerOptions);
            (0, _jquery2.default)(vm.$refs.lodgementDateToPicker).on('dp.change', function (e) {
                if ((0, _jquery2.default)(vm.$refs.lodgementDateToPicker).data('DateTimePicker').date()) {
                    vm.filterLodgedTo = e.date.format('DD/MM/YYYY');
                } else if ((0, _jquery2.default)(vm.$refs.lodgementDateToPicker).data('date') === "") {
                    vm.filterLodgedTo = "";
                }
            });
            (0, _jquery2.default)(vm.$refs.lodgementDateFromPicker).datetimepicker(vm.datepickerOptions);
            (0, _jquery2.default)(vm.$refs.lodgementDateFromPicker).on('dp.change', function (e) {
                if ((0, _jquery2.default)(vm.$refs.lodgementDateFromPicker).data('DateTimePicker').date()) {
                    vm.filterLodgedFrom = e.date.format('DD/MM/YYYY');
                } else if ((0, _jquery2.default)(vm.$refs.lodgementDateFromPicker).data('date') === "") {
                    vm.filterLodgedFrom = "";
                }
            });
        },
        initialiseSearch: function initialiseSearch() {
            this.dateSearch();
        },
        dateSearch: function dateSearch() {
            var vm = this;
            vm.$refs.call_email_table.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var from = vm.filterLodgedFrom;
                var to = vm.filterLodgedTo;
                var val = original.lodgement_date;

                if (from == '' && to == '') {
                    return true;
                } else if (from != '' && to != '') {
                    return val != null && val != '' ? moment().range(moment(from, vm.dateFormat), moment(to, vm.dateFormat)).contains(moment(val)) : false;
                } else if (from == '' && to != '') {
                    if (val != null && val != '') {
                        return moment(to, vm.dateFormat).diff(moment(val)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (to == '' && from != '') {
                    if (val != null && val != '') {
                        return moment(val).diff(moment(from, vm.dateFormat)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            });
        }
    }),
    mounted: function () {
        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            var _this = this;

            var vm;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            vm = this;

                            (0, _jquery2.default)('a[data-toggle="collapse"]').on('click', function () {
                                var chev = (0, _jquery2.default)(this).children()[0];
                                window.setTimeout(function () {
                                    (0, _jquery2.default)(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
                                }, 100);
                            });
                            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                                return _regenerator2.default.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                _context3.next = 2;
                                                return vm.initialiseSearch();

                                            case 2:
                                                _context3.next = 4;
                                                return vm.addEventListeners();

                                            case 4:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this);
                            })));

                        case 3:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function mounted() {
            return _ref3.apply(this, arguments);
        }

        return mounted;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _validators = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    name: "CallEmailWorking",
    data: function data() {
        return {
            officers: [],
            isModalOpen: false,
            processingDetails: false,
            form: null,
            regions: [],

            externalOrganisations: [],
            referrers: [],
            referrersSelected: [],
            workflowDetails: '',
            errorResponse: "",
            regionId: null,
            districtId: null,
            assigned_to_id: null,
            inspection_type_id: null,
            case_priority_id: null,
            advice_details: "",
            allocatedGroup: [],
            allocated_group_id: null,
            files: [{
                'file': null,
                'name': ''
            }]
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        filefield: _compliance_file2.default
    },
    validations: function validations() {
        if (this.workflow_type === 'allocate_for_follow_up') {
            return {
                regionId: {
                    required: _validators.required
                },
                assigned_to_id: {
                    required: _validators.required
                }
            };
        } else if (this.workflow_type === 'close') {
            return {};
        } else {
            return {
                regionId: {
                    required: _validators.required
                }
            };
        }
    },
    props: {
        workflow_type: {
            type: String,
            default: ''
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('callemailStore', {
        call_email: "call_email"
    }), {
        regionVisibility: function regionVisibility() {
            if (!(this.workflow_type === 'forward_to_wildlife_protection_branch' || this.workflow_type === 'close')) {
                return true;
            } else {
                return false;
            }
        },
        allocateToVisibility: function allocateToVisibility() {
            if (this.workflow_type.startsWith('allocate')) {
                return true;
            } else {
                return false;
            }
        },
        groupPermission: function groupPermission() {
            if (this.workflow_type === 'forward_to_regions') {
                return 'triage_call_email';
            } else if (this.workflow_type === 'forward_to_wildlife_protection_branch') {
                return 'triage_call_email';
            } else if (this.workflow_type === 'allocate_for_follow_up') {
                return 'officer';
            } else if (this.workflow_type === 'allocate_for_inspection') {
                return 'officer';
            } else if (this.workflow_type === 'allocate_for_case') {
                return 'officer';
            } else if (this.workflow_type === 'close') {
                return "";
            }
        },
        modalTitle: function modalTitle() {
            if (this.workflow_type === 'forward_to_regions') {
                return "Forward to Regions";
            } else if (this.workflow_type === 'forward_to_wildlife_protection_branch') {
                return "Forward to Wildlife Protection Branch";
            } else if (this.workflow_type === 'allocate_for_follow_up') {
                return "Allocate for Follow Up";
            } else if (this.workflow_type === 'allocate_for_inspection') {
                return "Allocate for Inspection";
            } else if (this.workflow_type === 'allocate_for_case') {
                return "Allocate for Case";
            } else if (this.workflow_type === 'close') {
                return "Close Call/Email";
            }
        },
        selectedRegion: function selectedRegion() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.regions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var region = _step.value;

                    if (region.id === this.regionId) {
                        return region;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        availableDistricts: function availableDistricts() {
            if (this.selectedRegion) {
                return this.selectedRegion.districts;
            }
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('callemailStore', {
        saveCallEmail: 'saveCallEmail'
    }), (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup'
    }), {
        updateDistricts: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.districtId = "";
                                _context.next = 3;
                                return this.updateAllocatedGroup();

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function updateDistricts() {
                return _ref.apply(this, arguments);
            }

            return updateDistricts;
        }(),
        updateAllocatedGroup: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var allocatedGroupResponse;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.errorResponse = "";
                                _vue2.default.set(this, 'allocatedGroup', []);

                                if (!(this.groupPermission && this.regionId)) {
                                    _context2.next = 15;
                                    break;
                                }

                                _context2.prev = 3;
                                _context2.next = 6;
                                return this.loadAllocatedGroup({
                                    workflow_type: this.workflow_type,
                                    region_id: this.regionId,
                                    district_id: this.districtId ? this.districtId : null
                                });

                            case 6:
                                allocatedGroupResponse = _context2.sent;

                                _vue2.default.set(this, 'allocatedGroup', allocatedGroupResponse.body);
                                this.allocated_group_id = allocatedGroupResponse.body.group_id;
                                _context2.next = 14;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2["catch"](3);

                                this.errorResponse = _context2.t0.body[0];

                            case 14:
                                if (!this.errorResponse && this.allocatedGroup && this.allocatedGroup.length <= 1) {
                                    this.errorResponse = 'This group has no members';
                                }

                            case 15:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[3, 11]]);
            }));

            function updateAllocatedGroup() {
                return _ref2.apply(this, arguments);
            }

            return updateAllocatedGroup;
        }(),

        ok: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var response;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.sendData();

                            case 2:
                                response = _context3.sent;

                                if (response === 'ok') {
                                    this.close();
                                }

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function ok() {
                return _ref3.apply(this, arguments);
            }

            return ok;
        }(),
        cancel: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.$refs.comms_log_file.cancel();

                            case 2:
                                this.isModalOpen = false;
                                this.close();

                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function cancel() {
                return _ref4.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
            var file_length = vm.files.length;
            this.files = [];
            for (var i = 0; i < file_length; i++) {
                vm.$nextTick(function () {
                    $('.file-row-' + i).remove();
                });
            }
            this.attachAnother();
        },
        sendData: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                var post_url, payload, res;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                post_url = '/api/call_email/' + this.call_email.id + '/workflow_action/';
                                payload = new FormData(this.form);

                                this.call_email.id ? payload.append('call_email_id', this.call_email.id) : null;
                                this.workflowDetails ? payload.append('details', this.workflowDetails) : null;
                                this.advice_details ? payload.append('advice_details', this.advice_details) : null;
                                this.$refs.comms_log_file.commsLogId ? payload.append('call_email_comms_log_id', this.$refs.comms_log_file.commsLogId) : null;
                                this.workflow_type ? payload.append('workflow_type', this.workflow_type) : null;
                                this.modalTitle ? payload.append('email_subject', this.modalTitle) : null;
                                this.referrersSelected ? payload.append('referrers_selected', this.referrersSelected) : null;
                                this.districtId ? payload.append('district_id', this.districtId) : null;
                                this.assigned_to_id ? payload.append('assigned_to_id', this.assigned_to_id) : null;
                                this.inspection_type_id ? payload.append('inspection_type_id', this.inspection_type_id) : null;
                                this.case_priority_id ? payload.append('case_priority_id', this.case_priority_id) : null;
                                this.regionId ? payload.append('region_id', this.regionId) : null;
                                _context5.prev = 14;
                                _context5.next = 17;
                                return _vue2.default.http.post(post_url, payload);

                            case 17:
                                res = _context5.sent;

                                if (res.ok) {
                                    this.$router.push({ name: 'internal-call-email-dash' });
                                }
                                _context5.next = 26;
                                break;

                            case 21:
                                _context5.prev = 21;
                                _context5.t0 = _context5["catch"](14);

                                this.errorResponse = 'Error:' + _context5.t0.statusText;
                                _context5.next = 26;
                                return swal({
                                    title: 'Mandatory Field',
                                    html: _hooks.helpers.formatError(_context5.t0),
                                    type: "error"
                                });

                            case 26:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[14, 21]]);
            }));

            function sendData() {
                return _ref5.apply(this, arguments);
            }

            return sendData;
        }(),
        uploadFile: function uploadFile(target, file_obj) {
            var vm = this;
            var _file = null;
            var file_input = $('.' + target)[0];

            if (file_input.files && file_input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(file_input.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = file_input.files[0];
            }
            file_obj.file = _file;
            file_obj.name = _file.name;
        },
        removeFile: function removeFile(index) {
            var _this = this;

            var length = this.files.length;
            $('.file-row-' + index).remove();
            this.files.splice(index, 1);
            this.$nextTick(function () {
                length == 1 ? _this.attachAnother() : '';
            });
        },
        attachAnother: function attachAnother() {
            this.files.push({
                'file': null,
                'name': ''
            });
        },

        addEventListeners: function addEventListeners() {
            var vm = this;

            $(document).ready(function () {
                $(vm.$refs.referrerList).select2({
                    "theme": "bootstrap",
                    allowClear: true,
                    placeholder: "Select Referrer"
                }).on("select2:select", function (e) {
                    var selected = $(e.currentTarget);
                    vm.referrersSelected = selected.val();
                }).on("select2:unselect", function (e) {
                    var selected = $(e.currentTarget);
                    vm.referrersSelected = selected.val();
                });
            });
        }
    }),
    created: function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
            var _this2 = this;

            var returned_regions, region, district, returned_referrers;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            _context7.next = 2;
                            return _hooks.cache_helper.getSetCacheList('Regions', '/api/regions/');

                        case 2:
                            returned_regions = _context7.sent;

                            (0, _assign2.default)(this.regions, returned_regions);

                            this.regions.splice(0, 0, {
                                id: "",
                                name: "",
                                districts: []
                            });

                            if (this.call_email && this.call_email.region_gis) {
                                region = this.regions.find(function (obj) {
                                    return obj.name === _this2.call_email.region_gis;
                                });

                                if (region) {
                                    this.regionId = region.id;
                                    if (this.call_email.district_gis) {
                                        district = region.districts.find(function (obj) {
                                            return obj.district_name === _this2.call_email.district_gis;
                                        });

                                        if (district) {
                                            this.districtId = district.district_id;
                                        }
                                    }
                                }
                            }

                            _context7.next = 8;
                            return _hooks.cache_helper.getSetCacheList('CallEmail_Referrers', '/api/referrers.json');

                        case 8:
                            returned_referrers = _context7.sent;

                            (0, _assign2.default)(this.referrers, returned_referrers);

                            this.referrers.splice(0, 0, {
                                id: "",
                                name: ""
                            });
                            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
                                return _regenerator2.default.wrap(function _callee6$(_context6) {
                                    while (1) {
                                        switch (_context6.prev = _context6.next) {
                                            case 0:
                                                _this2.addEventListeners();
                                                _context6.next = 3;
                                                return _this2.updateAllocatedGroup();

                                            case 3:
                                            case "end":
                                                return _context6.stop();
                                        }
                                    }
                                }, _callee6, _this2);
                            })));

                        case 12:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function created() {
            return _ref6.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        this.form = document.forms.forwardForm;
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _leaflet = __webpack_require__(54);

var _leaflet2 = _interopRequireDefault(_leaflet);

__webpack_require__(125);

__webpack_require__(66);

var _awesomplete = __webpack_require__(43);

var _awesomplete2 = _interopRequireDefault(_awesomplete);

var _vuex = __webpack_require__(6);

var _helpers = __webpack_require__(42);

__webpack_require__(15);

__webpack_require__(39);

__webpack_require__(65);

__webpack_require__(122);

__webpack_require__(64);

var _hooks = __webpack_require__(3);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "map-leaflet",
    data: function data() {
        var defaultCentre = [13775786.985667605, -2871569.067879858];

        var vm = this;
        var baseDic = { shadowUrl: __webpack_require__(46), shadowSize: [41, 41], shadowAnchor: [12, 41], iconSize: [32, 32], iconAnchor: [16, 32], popupAnchor: [0, -20] };
        vm.icon_default = _leaflet2.default.icon((0, _extends3.default)({ iconUrl: __webpack_require__(93) }, baseDic));
        vm.icon_enquiery = _leaflet2.default.icon((0, _extends3.default)({ iconUrl: __webpack_require__(312) }, baseDic));
        vm.icon_complaint = _leaflet2.default.icon((0, _extends3.default)({ iconUrl: __webpack_require__(313) }, baseDic));
        vm.icon_incident = _leaflet2.default.icon((0, _extends3.default)({ iconUrl: __webpack_require__(314) }, baseDic));
        vm.guid = (0, _helpers.guid)();

        return {
            defaultCenter: defaultCentre,
            projection: null,
            map: null,
            popup: null,
            element: null,
            base_layer: 'osm',
            awe: null,
            suggest_list: [],
            feature_marker: null,
            cursor_location: null,
            idMap: vm.guid + 'mapLeaf',
            idLocationFieldsAddress: vm.guid + 'LocationFieldsAddress',
            idLocationFieldsDetails: vm.guid + 'LocationFieldsDetails',
            idSearchInput: vm.guid + 'SearchInput',
            idBasemapSat: vm.guid + 'BasemapSat',
            idBasemapOsm: vm.guid + 'BasemapOsm',
            mapboxAccessToken: ''
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('callemailStore', {
        call_email: 'call_email',
        call_latitude: 'call_latitude',
        call_longitude: 'call_longitude'
    })),
    props: {
        isReadonly: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        call_email: {
            handler: function handler() {
                this.setMarkerIcon();
            },
            deep: true
        },
        call_latitude: {
            handler: function handler() {
                this.setMarkerLocation();
            }
        },
        call_longitude: {
            handler: function handler() {
                this.setMarkerLocation();
            }
        }
    },
    mounted: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.$nextTick(function () {
                                this.initMap();
                                this.setBaseLayer('osm');
                                this.initAwesomplete();

                                if (this.call_email.location && this.call_email.location && this.call_email.location.geometry && this.call_email.location.geometry.coordinates && this.call_email.location.geometry.coordinates.length > 0) {
                                    this.addMarker([this.call_email.location.geometry.coordinates[1], this.call_email.location.geometry.coordinates[0]]);
                                    this.refreshMarkerLocation();
                                }
                                if (this.call_email.location.properties.country) {
                                    this.showHideAddressDetailsFields(true, false);
                                } else {
                                    this.showHideAddressDetailsFields(false, true);
                                }
                            });

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }(),
    created: function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var temp_token;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return this.retrieveMapboxAccessToken();

                        case 2:
                            temp_token = _context2.sent;

                            this.mapboxAccessToken = temp_token.access_token;

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function created() {
            return _ref2.apply(this, arguments);
        }

        return created;
    }(),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('callemailStore', {
        setLocationPoint: 'setLocationPoint',
        setLocationAddress: 'setLocationAddress',
        setLocationAddressEmpty: 'setLocationAddressEmpty',
        setLocationDetailsFieldEmpty: 'setLocationDetailsFieldEmpty'
    }), {
        setMarkerCentre: function setMarkerCentre() {
            var vm = this;
            var lat = vm.call_email.location.geometry.coordinates[1];
            var lng = vm.call_email.location.geometry.coordinates[0];
            vm.map.flyTo({ lat: lat, lng: lng }, 12, { animate: true, duration: 1.5 });
        },
        setMarkerLocation: function setMarkerLocation() {
            var vm = this;
            if (!vm.isReadonly) {
                var lat = vm.call_email.location.geometry.coordinates[1];
                var lng = vm.call_email.location.geometry.coordinates[0];
                if (-90 < lat && lat < 90) {
                    if (-180 < lng < 180) {
                        var lnglat = [lng, lat];
                        this.feature_marker.setLatLng({ lat: lat, lng: lng });
                        vm.map.flyTo({ lat: lat, lng: lng }, 12, {
                            animate: true,
                            duration: 1.5
                        });

                        vm.reverseGeocoding(lnglat);
                    }
                }
            }
        },
        setMarkerIcon: function setMarkerIcon() {
            var vm = this;
            if (vm.feature_marker) {
                if (vm.call_email.classification_id) {
                    if (vm.call_email.classification_id == 1) {
                        vm.feature_marker.setIcon(vm.icon_incident);
                    } else if (vm.call_email.classification_id == 2) {
                        vm.feature_marker.setIcon(vm.icon_enquiery);
                    } else if (vm.call_email.classification_id == 3) {
                        vm.feature_marker.setIcon(vm.icon_complaint);
                    }
                } else {
                    vm.feature_marker.setIcon(vm.icon_default);
                }
            }
        },
        addMarker: function addMarker(latLngArr) {
            var vm = this;
            vm.feature_marker = _leaflet2.default.marker({ lon: latLngArr[1], lat: latLngArr[0] }, { icon: vm.icon_default }).on('click', function (ev) {
                vm.feature_marker.setIcon(myIcon);
            });

            vm.feature_marker.addTo(vm.map);
            vm.setMarkerIcon();
        },

        reverseGeocoding: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(coordinates_4326) {
                var self;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                self = this;

                                $.ajax({
                                    url: _hooks.api_endpoints.geocoding_address_search + coordinates_4326[0] + ',' + coordinates_4326[1] + '.json?' + $.param({
                                        limit: 1,
                                        types: 'address',
                                        access_token: self.mapboxAccessToken
                                    }),
                                    dataType: 'json',

                                    success: function success(data, status, xhr) {
                                        var address_found = false;
                                        if (data.features && data.features.length > 0) {
                                            for (var i = 0; i < data.features.length; i++) {
                                                if (data.features[i].place_type.includes('address')) {
                                                    self.updateAddressFields(data.features[i]);
                                                    address_found = true;
                                                }
                                            }
                                        }
                                        if (address_found) {
                                            self.showHideAddressDetailsFields(true, false);
                                            self.setLocationDetailsFieldEmpty();
                                        } else {
                                            self.showHideAddressDetailsFields(false, true);
                                            self.setLocationAddressEmpty();
                                        }
                                    }
                                });

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function reverseGeocoding(_x) {
                return _ref3.apply(this, arguments);
            }

            return reverseGeocoding;
        }(),
        search: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(place) {
                var self, latlng;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                self = this;
                                latlng = this.map.getCenter();

                                $.ajax({
                                    url: _hooks.api_endpoints.geocoding_address_search + encodeURIComponent(place) + '.json?' + $.param({
                                        country: 'au',
                                        limit: 10,
                                        proximity: '' + latlng.lng + ',' + latlng.lat,

                                        bbox: '112.920934,-35.191991,129.0019283,-11.9662455',
                                        types: 'region,postcode,district,place,locality,neighborhood,address,poi',
                                        access_token: self.mapboxAccessToken
                                    }),
                                    dataType: 'json',
                                    success: function success(data, status, xhr) {
                                        self.suggest_list = [];
                                        if (data.features && data.features.length > 0) {
                                            for (var i = 0; i < data.features.length; i++) {
                                                self.suggest_list.push({ label: data.features[i].place_name,
                                                    value: data.features[i].place_name,
                                                    feature: data.features[i]
                                                });
                                            }
                                        }

                                        self.awe.list = self.suggest_list;
                                        self.awe.evaluate();
                                    }
                                });

                            case 3:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function search(_x2) {
                return _ref4.apply(this, arguments);
            }

            return search;
        }(),
        initAwesomplete: function initAwesomplete() {
            var self = this;
            var element_search = document.getElementById(self.idSearchInput);
            this.awe = new _awesomplete2.default(element_search);
            $(element_search).on('keyup', function (ev) {
                var keyCode = ev.keyCode || ev.which;
                if (48 <= keyCode && keyCode <= 90 || 96 <= keyCode && keyCode <= 105 || keyCode == 8 || keyCode == 46) {
                    self.search(ev.target.value);
                    return false;
                }
            }).on('awesomplete-selectcomplete', function (ev) {
                ev.preventDefault();
                ev.stopPropagation();

                for (var i = 0; i < self.suggest_list.length; i++) {
                    if (self.suggest_list[i].value == ev.target.value) {
                        var latlng = { lat: self.suggest_list[i].feature.geometry.coordinates[1], lng: self.suggest_list[i].feature.geometry.coordinates[0] };

                        self.map.flyTo(latlng, 13, {
                            animate: true,
                            duration: 1.5
                        });

                        if (!self.isReadonly) {
                            if (!self.feature_marker) {
                                self.addMarker([latlng.lat, latlng.lng]);
                            }

                            self.relocateMarker(latlng);
                            if (self.suggest_list[i].feature.place_type.includes('address')) {
                                self.showHideAddressDetailsFields(true, false);
                                self.updateAddressFields(self.suggest_list[i].feature);
                                self.setLocationDetailsFieldEmpty();
                            } else {
                                self.showHideAddressDetailsFields(false, true);
                                self.setLocationAddressEmpty();
                            }
                        }
                    }
                }
                return false;
            });
        },
        updateAddressFields: function updateAddressFields(feature) {
            if (!this.isReadonly) {
                var properties_for_update = new Object();
                var state_abbr_list = {
                    "New South Wales": "NSW",
                    "Queensland": "QLD",
                    "South Australia": "SA",
                    "Tasmania": "TAS",
                    "Victoria": "VIC",
                    "Western Australia": "WA",
                    "Northern Territory": "NT",
                    "Australian Capital Territory": "ACT"
                };
                var address_arr = feature.place_name.split(',');

                properties_for_update.street = address_arr[0];

                var reg = /^([a-zA-Z0-9\s]*)\s(New South Wales|Queensland|South Australia|Tasmania|Victoria|Western Australia|Northern Territory|Australian Capital Territory){1}\s+(\d{4})$/gi;
                var result = reg.exec(address_arr[1]);

                properties_for_update.town_suburb = result[1].trim();

                var state_abbr = state_abbr_list[result[2].trim()];
                properties_for_update.state = state_abbr;

                properties_for_update.postcode = result[3].trim();

                properties_for_update.country = 'Australia';

                this.setLocationAddress(properties_for_update);
            }
        },

        setBaseLayer: function setBaseLayer(selected_layer_name) {
            if (selected_layer_name == 'sat') {
                this.map.removeLayer(this.tileLayer);
                this.map.addLayer(this.tileLayerSat);
                $('#' + this.idBasemapSat).hide();
                $('#' + this.idBasemapOsm).show();
            } else {
                this.map.removeLayer(this.tileLayerSat);
                this.map.addLayer(this.tileLayer);
                $('#' + this.idBasemapOsm).hide();
                $('#' + this.idBasemapSat).show();
            }
        },
        showHideAddressDetailsFields: function showHideAddressDetailsFields(showAddressFields, showDetailsFields) {
            if (showAddressFields) {
                $("#" + this.idLocationFieldsAddress).fadeIn();
            } else {
                $("#" + this.idLocationFieldsAddress).fadeOut();
            }
            if (showDetailsFields) {
                $("#" + this.idLocationFieldsDetails).fadeIn();
            } else {
                $("#" + this.idLocationFieldsDetails).fadeOut();
            }
        },

        refreshMarkerLocation: function refreshMarkerLocation() {
            if (!this.isReadonly) {
                if (this.call_email.location.geometry) {
                    this.feature_marker.setLatLng({ lat: this.call_email.location.geometry.coordinates[1], lng: this.call_email.location.geometry.coordinates[0] });
                    if (this.call_email.location.geometry) {
                        this.reverseGeocoding(this.call_email.location.geometry.coordinates);
                    }
                }
            }
        },
        initMap: function initMap() {
            this.map = _leaflet2.default.map(this.idMap).setView([-31.9505, 115.8605], 4);
            this.tileLayer = _leaflet2.default.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, contributiors'
            });

            this.tileLayerSat = _leaflet2.default.tileLayer.wmts('https://kmi.dpaw.wa.gov.au/geoserver/gwc/service/wmts', {
                layer: 'public:mapbox-satellite',
                tilematrixSet: 'mercator',
                format: 'image/png'
            });

            this.map.on('click', this.onClick).on('mousemove', this.onMouseMove).on('mouseout', this.onMouseOut);
            this.setBaseLayer('osm');
            var measureControl = new _leaflet2.default.Control.Measure({
                position: 'topleft',
                primaryLengthUnit: 'meters',
                activeColor: '#ff7f50',
                completedColor: '#228b22'
            });
            measureControl.addTo(this.map);
            _leaflet2.default.control.locate().addTo(this.map);
        },

        relocateMarker: function relocateMarker(latlng) {
            if (!this.isReadonly) {
                var lnglat = [latlng.lng, latlng.lat];
                this.setLocationPoint(lnglat);
                this.refreshMarkerLocation();
                this.reverseGeocoding(lnglat);
            }
        },
        onMouseMove: function onMouseMove(e) {
            var vm = this;
            vm.cursor_location = vm.map.mouseEventToLatLng(e.originalEvent);
        },
        onMouseOut: function onMouseOut(e) {
            this.cursor_location = null;
        },
        onClick: function onClick(e) {
            var self = this;
            if (!self.isReadonly) {
                var latlng = this.map.mouseEventToLatLng(e.originalEvent);
                if (!self.feature_marker) {
                    self.addMarker([latlng.lat, latlng.lng]);
                }

                this.relocateMarker(latlng);
            }
        }
    })
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _leaflet = __webpack_require__(54);

var _leaflet2 = _interopRequireDefault(_leaflet);

__webpack_require__(126);

__webpack_require__(66);

var _awesomplete = __webpack_require__(43);

var _awesomplete2 = _interopRequireDefault(_awesomplete);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

__webpack_require__(65);

__webpack_require__(124);

__webpack_require__(123);

__webpack_require__(64);

__webpack_require__(15);

__webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_leaflet2.default.TileLayer.WMTS = _leaflet2.default.TileLayer.extend({
    defaultWmtsParams: {
        service: 'WMTS',
        request: 'GetTile',
        version: '1.0.0',
        layers: '',
        styles: '',
        tilematrixSet: '',
        format: 'image/jpeg'
    },

    initialize: function initialize(url, options) {
        this._url = url;
        var wmtsParams = _leaflet2.default.extend({}, this.defaultWmtsParams);
        var tileSize = options.tileSize || this.options.tileSize;
        if (options.detectRetina && _leaflet2.default.Browser.retina) {
            wmtsParams.width = wmtsParams.height = tileSize * 2;
        } else {
            wmtsParams.width = wmtsParams.height = tileSize;
        }
        for (var i in options) {
            if (!this.options.hasOwnProperty(i) && i != "matrixIds") {
                wmtsParams[i] = options[i];
            }
        }
        this.wmtsParams = wmtsParams;
        this.matrixIds = options.matrixIds || this.getDefaultMatrix();
        _leaflet2.default.setOptions(this, options);
    },

    onAdd: function onAdd(map) {
        this._crs = this.options.crs || map.options.crs;
        _leaflet2.default.TileLayer.prototype.onAdd.call(this, map);
    },

    getTileUrl: function getTileUrl(coords) {
        var tileSize = this.options.tileSize;
        var nwPoint = coords.multiplyBy(tileSize);
        nwPoint.x += 1;
        nwPoint.y -= 1;
        var sePoint = nwPoint.add(new _leaflet2.default.Point(tileSize, tileSize));
        var zoom = this._tileZoom;
        var nw = this._crs.project(this._map.unproject(nwPoint, zoom));
        var se = this._crs.project(this._map.unproject(sePoint, zoom));
        var tilewidth = se.x - nw.x;

        var ident = this.matrixIds[zoom].identifier;
        var tilematrix = this.wmtsParams.tilematrixSet + ":" + ident;
        var X0 = this.matrixIds[zoom].topLeftCorner.lng;
        var Y0 = this.matrixIds[zoom].topLeftCorner.lat;
        var tilecol = Math.floor((nw.x - X0) / tilewidth);
        var tilerow = -Math.floor((nw.y - Y0) / tilewidth);
        var url = _leaflet2.default.Util.template(this._url, { s: this._getSubdomain(coords) });
        return url + _leaflet2.default.Util.getParamString(this.wmtsParams, url) + "&tilematrix=" + tilematrix + "&tilerow=" + tilerow + "&tilecol=" + tilecol;
    },

    setParams: function setParams(params, noRedraw) {
        _leaflet2.default.extend(this.wmtsParams, params);
        if (!noRedraw) {
            this.redraw();
        }
        return this;
    },

    getDefaultMatrix: function getDefaultMatrix() {
        var matrixIds3857 = new Array(22);
        for (var i = 0; i < 22; i++) {
            matrixIds3857[i] = {
                identifier: "" + i,
                topLeftCorner: new _leaflet2.default.LatLng(20037508.3428, -20037508.3428)
            };
        }
        return matrixIds3857;
    }
});
_leaflet2.default.tileLayer.wmts = function (url, options) {
    return new _leaflet2.default.TileLayer.WMTS(url, options);
};

delete _leaflet2.default.Icon.Default.prototype._getIconUrl;
_leaflet2.default.Icon.Default.mergeOptions({
    iconRetinaUrl: __webpack_require__(127),
    iconUrl: __webpack_require__(128),
    shadowUrl: __webpack_require__(46)
});


module.exports = {
    data: function data() {
        var vm = this;
        vm.layers = [];
        vm.mcg = _leaflet2.default.markerClusterGroup();
        vm.datetime_pattern = /^\d{2}\/\d{2}\/\d{4}$/gi;
        vm.ajax_for_location = null;

        return {
            map: null,
            tileLayer: null,
            tileLayerSat: null,
            popup: null,
            opt_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.call_email, "optimised"),

            filterStatus: 'all',
            filterClassification: 'all',
            filterLodgedFrom: '',
            filterLodgedTo: '',

            classification_types: [],
            status_choices: [],
            cursor_location: null,
            mapboxAccessToken: null
        };
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var returned_classification_types, returned_status_choices, temp_token;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _hooks.cache_helper.getSetCacheList('CallEmail_ClassificationTypes', '/api/classification.json');

                        case 2:
                            returned_classification_types = _context.sent;

                            (0, _assign2.default)(this.classification_types, returned_classification_types);
                            this.classification_types.splice(0, 0, { id: 'all', name: 'All' });

                            _context.next = 7;
                            return _hooks.cache_helper.getSetCacheList('CallEmail_StatusChoices', '/api/call_email/status_choices');

                        case 7:
                            returned_status_choices = _context.sent;

                            (0, _assign2.default)(this.status_choices, returned_status_choices);
                            this.status_choices.splice(0, 0, { id: 'all', display: 'All' });

                            _context.next = 12;
                            return this.retrieveMapboxAccessToken();

                        case 12:
                            temp_token = _context.sent;

                            this.mapboxAccessToken = temp_token.access_token;

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        var vm = this;
        vm.initMap();
        vm.loadLocations();
        vm.initAwesomplete();
        vm.$nextTick(function () {
            vm.addEventListeners();
        });
    },

    watch: {
        filterStatus: function filterStatus() {
            this.loadLocations();
        },
        filterClassification: function filterClassification() {
            this.loadLocations();
        },
        filterLodgedFrom: function filterLodgedFrom() {
            if (!this.filterLodgedFrom) {
                this.loadLocations();
            } else {
                var result = this.datetime_pattern.exec(this.filterLodgedFrom);
                if (result) {
                    this.loadLocations();
                }
            }
        },
        filterLodgedTo: function filterLodgedTo() {
            if (!this.filterLodgedTo) {
                this.loadLocations();
            } else {
                var result = this.datetime_pattern.exec(this.filterLodgedTo);
                if (result) {
                    this.loadLocations();
                }
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('callemailStore', {})),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('callemailStore', {}), {
        addEventListeners: function addEventListeners() {
            var vm = this;
            var el_fr = $(vm.$refs.lodgementDateFromPicker);
            var el_to = $(vm.$refs.lodgementDateToPicker);

            el_fr.datetimepicker({ format: 'DD/MM/YYYY', maxDate: 'now', showClear: true });
            el_fr.on('dp.change', function (e) {
                if (el_fr.data('DateTimePicker').date()) {
                    vm.filterLodgedFrom = e.date.format('DD/MM/YYYY');
                    el_to.data('DateTimePicker').minDate(e.date);
                } else if (el_fr.data('date') === "") {
                    vm.filterLodgedFrom = "";
                }
            });

            el_to.datetimepicker({ format: 'DD/MM/YYYY', maxDate: 'now', showClear: true });
            el_to.on('dp.change', function (e) {
                if (el_to.data('DateTimePicker').date()) {
                    vm.filterLodgedTo = e.date.format('DD/MM/YYYY');
                    el_fr.data('DateTimePicker').maxDate(e.date);
                } else if (el_to.data('date') === "") {
                    vm.filterLodgedTo = "";
                }
            });
        },
        initAwesomplete: function initAwesomplete() {
            var self = this;
            var element_search = document.getElementById('search-input');
            this.awe = new _awesomplete2.default(element_search);
            $(element_search).on('keyup', function (ev) {
                var keyCode = ev.keyCode || ev.which;
                if (48 <= keyCode && keyCode <= 90 || 96 <= keyCode && keyCode <= 105) {
                    self.search(ev.target.value);
                    return false;
                }
            }).on('awesomplete-selectcomplete', function (ev) {
                ev.preventDefault();
                ev.stopPropagation();

                for (var i = 0; i < self.suggest_list.length; i++) {
                    if (self.suggest_list[i].value == ev.target.value) {
                        var latlng = { lat: self.suggest_list[i].feature.geometry.coordinates[1], lng: self.suggest_list[i].feature.geometry.coordinates[0] };

                        self.map.flyTo(latlng, 13, {
                            animate: true,
                            duration: 1.5
                        });
                    }
                }
                return false;
            });
        },
        search: function search(place) {
            var self = this;

            var latlng = this.map.getCenter();
            $.ajax({
                url: _hooks.api_endpoints.geocoding_address_search + encodeURIComponent(place) + '.json?' + $.param({
                    access_token: self.mapboxAccessToken,
                    country: 'au',
                    limit: 10,
                    proximity: '' + latlng.lng + ',' + latlng.lat,

                    bbox: '112.920934,-35.191991,129.0019283,-11.9662455',
                    types: 'region,postcode,district,place,locality,neighborhood,address,poi'
                }),
                dataType: 'json',
                success: function success(data, status, xhr) {
                    self.suggest_list = [];
                    if (data.features && data.features.length > 0) {
                        for (var i = 0; i < data.features.length; i++) {
                            self.suggest_list.push({ label: data.features[i].place_name,
                                value: data.features[i].place_name,
                                feature: data.features[i]
                            });
                        }
                    }

                    self.awe.list = self.suggest_list;
                    self.awe.evaluate();
                }
            });
        },
        setBaseLayer: function setBaseLayer(selected_layer_name) {
            if (selected_layer_name == 'sat') {
                this.map.removeLayer(this.tileLayer);
                this.map.addLayer(this.tileLayerSat);
                $('#basemap_sat').hide();
                $('#basemap_osm').show();
            } else {
                this.map.removeLayer(this.tileLayerSat);
                this.map.addLayer(this.tileLayer);
                $('#basemap_osm').hide();
                $('#basemap_sat').show();
            }
        },
        onClick: function onClick(e) {},

        onMouseMove: function onMouseMove(e) {
            this.cursor_location = this.map.mouseEventToLatLng(e.originalEvent);
        },
        onMouseOut: function onMouseOut(e) {
            this.cursor_location = null;
        },
        initMap: function initMap() {

            this.map = _leaflet2.default.map('mapLeaf').setView([-24.9505, 122.8605], 5);
            this.tileLayer = _leaflet2.default.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, contributiors'
            });

            this.tileLayerSat = _leaflet2.default.tileLayer.wmts('https://kmi.dpaw.wa.gov.au/geoserver/gwc/service/wmts', {
                layer: 'public:mapbox-satellite',
                tilematrixSet: 'mercator',
                format: 'image/png'
            });

            this.popup = _leaflet2.default.popup();
            this.map.on('click', this.onClick).on('mousemove', this.onMouseMove).on('mouseout', this.onMouseOut);
            this.setBaseLayer('osm');
            this.addOtherLayers();
            this.map.addLayer(this.mcg);
            _leaflet2.default.control.locate().addTo(this.map);
        },
        addOtherLayers: function addOtherLayers() {
            var _this = this;

            var overlayMaps = {};

            this.$http.get('/api/map_layers/').then(function (response) {
                var layers = response.body.results;
                for (var i = 0; i < layers.length; i++) {
                    var l = _leaflet2.default.tileLayer.wmts('https://kmi.dpaw.wa.gov.au/geoserver/gwc/service/wmts', {
                        layer: layers[i].layer_name.trim(),
                        tilematrixSet: 'mercator',
                        format: 'image/png'
                    });
                    overlayMaps[layers[i].display_name] = l;
                }
                _leaflet2.default.control.layers(null, overlayMaps, { position: 'topleft' }).addTo(_this.map);
            });
        },
        loadLocations: function loadLocations() {
            var vm = this;

            if (vm.ajax_for_location != null) {
                vm.ajax_for_location.abort();
                vm.ajax_for_location = null;
            }
            var myData = {
                "status": vm.filterStatus,
                "classification": vm.filterClassification,
                "lodged_from": vm.filterLodgedFrom,
                "lodged_to": vm.filterLodgedTo
            };

            vm.ajax_for_location = $.ajax({
                type: 'GET',
                data: myData,
                url: vm.opt_url,
                success: function success(data) {
                    vm.addMarkers(data);
                },
                error: function error(e) {}
            });
        },
        addMarkers: function addMarkers(call_emails) {
            var self = this;
            self.mcg.clearLayers();

            if (call_emails && call_emails.length > 0) {
                for (var i = 0; i < call_emails.length; i++) {
                    if (call_emails[i].location) {
                        (function () {
                            var call_email = call_emails[i];
                            var coords = call_email.location.geometry.coordinates;

                            var filename = 'marker-gray-locked.svg';
                            if (call_email.classification) {
                                if (call_email.classification.id == 1) {
                                    filename = 'marker-yellow-locked.svg';
                                } else if (call_email.classification.id == 2) {
                                    filename = 'marker-green-locked.svg';
                                } else if (call_email.classification.id == 3) {
                                    filename = 'marker-red-locked.svg';
                                }
                            }

                            var myIcon = _leaflet2.default.icon({
                                iconUrl: __webpack_require__(134)("./" + filename),
                                shadowUrl: __webpack_require__(46),
                                shadowSize: [41, 41],
                                shadowAnchor: [12, 41],
                                iconSize: [32, 32],
                                iconAnchor: [16, 32],
                                popupAnchor: [0, -20]
                            });
                            var myMarker = _leaflet2.default.marker([coords[1], coords[0]], { icon: myIcon });
                            var myPopup = _leaflet2.default.popup();
                            myMarker.bindPopup(myPopup);
                            self.mcg.addLayer(myMarker);

                            myMarker.on('click', function (ev) {
                                var popup = ev.target.getPopup();
                                self.$http.get('/api/call_email/' + call_email.id).then(function (response) {
                                    var call_email = response.body;
                                    popup.setContent(self.construct_content(call_email, coords));
                                });
                            });
                        })();
                    }
                }
            }
        },

        construct_content: function construct_content(call_email, coords) {
            var classification_str = call_email.classification ? call_email.classification.name : '';
            var status_str = call_email.status ? call_email.status.name : '';
            var identifier_str = call_email.identifier ? call_email.identifier : '';

            var content = '<div class="popup-title-main">' + call_email.number + '</div>';

            content += '<div class="popup-title">Identifier</div>' + '<div class="popup-address">' + call_email.identifier + '</div>';

            content += '<div class="popup-title">Classification</div>' + '<div class="popup-address">' + classification_str + '</div>';

            content += '<div class="popup-title">Status</div>' + '<div class="popup-address">' + status_str + '</div>';

            if (call_email.location.properties.street) {
                var str_street = call_email.location.properties.street ? call_email.location.properties.street : '';
                var str_town_suburb = call_email.location.properties.town_suburt ? call_email.location.properties.town_suburt : '';
                var str_state = call_email.location.properties.state ? call_email.location.properties.state : '';
                var str_postcode = call_email.location.properties.postcode ? call_email.location.properties.postcode : '';
                content += '<div class="popup-title">Address</div>' + '<div class="popup-address">' + str_street + '<br />' + str_town_suburb + '<br />' + str_state + '<br />' + str_postcode + '</div>';
            } else {
                content += '<div class="popup-title">Details</div>' + '<div class="popup-address">' + call_email.location.properties.details.substring(0, 10) + '</div>';
            }

            content += '<div class="popup-link">' + '<a href="/internal/call_email/' + call_email.id + '">View</a>' + '</div>';

            return content;
        }
    })
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _applications_dashboard = __webpack_require__(82);

var _applications_dashboard2 = _interopRequireDefault(_applications_dashboard);

var _assessments_dashboard = __webpack_require__(318);

var _assessments_dashboard2 = _interopRequireDefault(_assessments_dashboard);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'InternalDashboard',
    data: function data() {
        var vm = this;
        return {
            applications_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications_paginated, 'internal_datatable_list/?format=datatables')
        };
    },

    watch: {},
    components: {
        ApplicationDashTable: _applications_dashboard2.default,
        AssessmentDashTable: _assessments_dashboard2.default
    },
    computed: {},
    methods: {},
    mounted: function mounted() {}
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _applications_dashboard = __webpack_require__(82);

var _applications_dashboard2 = _interopRequireDefault(_applications_dashboard);

var _assessments_dashboard = __webpack_require__(318);

var _assessments_dashboard2 = _interopRequireDefault(_assessments_dashboard);

var _call_email_dashboard = __webpack_require__(344);

var _call_email_dashboard2 = _interopRequireDefault(_call_email_dashboard);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'InternalDashboard',
    data: function data() {
        var vm = this;
        return {
            applications_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.applications_paginated, 'internal_datatable_list/?format=datatables'),
            preferredDashboard: null
        };
    },

    watch: {},
    components: {
        ApplicationDashTable: _applications_dashboard2.default,
        AssessmentDashTable: _assessments_dashboard2.default,
        CallEmailDashTable: _call_email_dashboard2.default
    },
    computed: {
        showComplianceManagement: function showComplianceManagement() {
            var systemPreference = false;
            if (this.preferredDashboard === 'compliance_management') {
                systemPreference = true;
            }
            return systemPreference;
        },
        showWildlifeLicensing: function showWildlifeLicensing() {
            var systemPreference = false;
            if (this.preferredDashboard === 'wildlife_licensing') {
                systemPreference = true;
            }
            return systemPreference;
        }

    },
    methods: {},
    mounted: function mounted() {},
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _hooks.helpers.getPreferredDashboard();

                        case 2:
                            this.preferredDashboard = _context.sent;

                            console.log(this.preferredDashboard);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }()

};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _validators = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "CreateInspection",
    data: function data() {
        return {
            officers: [],
            isModalOpen: false,
            processingDetails: false,
            form: null,
            regions: [],
            availableDistricts: [],
            casePriorities: [],
            inspectionTypes: [],
            externalOrganisations: [],
            inspectionDetails: '',
            errorResponse: "",
            region_id: null,
            district_id: null,
            assigned_to_id: null,
            inspection_type_id: null,
            advice_details: "",
            allocatedGroup: [],
            allocated_group_id: null,
            documentActionUrl: '',
            temporary_document_collection_id: null
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        filefield: _compliance_file2.default
    },
    validations: {
        region_id: {
            required: _validators.required
        },
        assigned_to_id: {
            required: _validators.required
        },
        inspection_type_id: {
            required: _validators.required
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('inspectionStore', {
        inspection: "inspection"
    }), (0, _vuex.mapGetters)('callemailStore', {
        call_email: "call_email"
    }), (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        parent_legal_case: function parent_legal_case() {
            if (this.legal_case && this.legal_case.id) {
                return true;
            }
        },
        parent_call_email: function parent_call_email() {
            if (this.call_email && this.call_email.id) {
                return true;
            }
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('inspectionStore', {
        saveInspection: 'saveInspection',
        loadInspection: 'loadInspection',
        setInspection: 'setInspection'
    }), (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup'
    }), (0, _vuex.mapActions)('callemailStore', {
        loadCallEmail: 'loadCallEmail'
    }), (0, _vuex.mapActions)('legalCaseStore', {
        loadLegalCase: 'loadLegalCase'
    }), {
        setTemporaryDocumentCollectionId: function setTemporaryDocumentCollectionId(val) {
            this.temporary_document_collection_id = val;
        },
        updateDistricts: function updateDistricts() {
            this.availableDistricts = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.regions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var region = _step.value;

                    if (this.region_id === region.id) {
                        this.availableDistricts = region.districts;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.availableDistricts.splice(0, 0, {
                district_id: "",
                district_name: "",
                district: "",
                districts: [],
                region: null
            });

            this.updateAllocatedGroup();
        },
        updateAllocatedGroup: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var allocatedGroupResponse;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.errorResponse = "";
                                _vue2.default.set(this, 'allocatedGroup', []);

                                if (!this.region_id) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 5;
                                return this.loadAllocatedGroup({
                                    workflow_type: 'allocate_for_inspection',
                                    region_id: this.region_id,
                                    district_id: this.district_id ? this.district_id : null
                                });

                            case 5:
                                allocatedGroupResponse = _context.sent;

                                if (allocatedGroupResponse.ok) {
                                    _vue2.default.set(this, 'allocatedGroup', allocatedGroupResponse.body);
                                    this.allocated_group_id = allocatedGroupResponse.body.group_id;
                                } else {
                                    this.errorResponse = allocatedGroupResponse.statusText;
                                }

                                if (!this.errorResponse && this.allocatedGroup && this.allocatedGroup.length < 1) {
                                    this.errorResponse = 'This group has no members';
                                }
                                _context.next = 11;
                                break;

                            case 10:
                                this.allocatedGroup = [];

                            case 11:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function updateAllocatedGroup() {
                return _ref.apply(this, arguments);
            }

            return updateAllocatedGroup;
        }(),

        ok: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var is_valid_form, response, returnedInspection, parent_update_function_payload;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                is_valid_form = this.isValidForm();

                                if (!is_valid_form) {
                                    _context2.next = 20;
                                    break;
                                }

                                _context2.next = 4;
                                return this.sendData();

                            case 4:
                                response = _context2.sent;

                                if (!response.ok) {
                                    _context2.next = 20;
                                    break;
                                }

                                returnedInspection = response.body;

                                if (this.$parent.$refs.inspection_table) {
                                    this.$parent.$refs.inspection_table.vmDataTable.ajax.reload();
                                }
                                parent_update_function_payload = null;

                                if (!this.parent_call_email) {
                                    _context2.next = 14;
                                    break;
                                }

                                _context2.next = 12;
                                return this.loadCallEmail({
                                    call_email_id: this.call_email.id
                                });

                            case 12:
                                _context2.next = 17;
                                break;

                            case 14:
                                if (!this.parent_legal_case) {
                                    _context2.next = 17;
                                    break;
                                }

                                _context2.next = 17;
                                return this.loadLegalCase({
                                    legal_case_id: this.legal_case.id
                                });

                            case 17:
                                if (this.$parent.$refs.related_items_table) {
                                    this.$parent.constructRelatedItemsTable();
                                }
                                if (returnedInspection && returnedInspection.id) {
                                    this.$emit('inspection-created', {
                                        'inspection': returnedInspection.id
                                    });
                                }
                                this.close();

                            case 20:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function ok() {
                return _ref2.apply(this, arguments);
            }

            return ok;
        }(),
        isValidForm: function isValidForm() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.errorResponse = 'Invalid form:\n';
                if (this.$v.region_id.$invalid) {
                    this.errorResponse += 'Region is required\n';
                }
                if (this.$v.assigned_to_id.$invalid) {
                    this.errorResponse += 'Officer must be assigned\n';
                }
                if (this.$v.inspection_type_id.$invalid) {
                    this.errorResponse += 'Choose Inspection Type\n';
                }
                return false;
            } else {
                return true;
            }
        },
        cancel: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$refs.comms_log_file.cancel();

                            case 2:
                                this.isModalOpen = false;
                                this.close();

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function cancel() {
                return _ref3.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
        },
        sendData: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var post_url, payload, res;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                post_url = '';

                                if (!this.inspection.id) {
                                    post_url = '/api/inspection/';
                                } else {
                                    post_url = '/api/inspection/' + this.inspection.id + '/workflow_action/';
                                }

                                payload = new FormData();

                                payload.append('details', this.inspectionDetails);
                                this.$refs.comms_log_file.commsLogId ? payload.append('inspection_comms_log_id', this.$refs.comms_log_file.commsLogId) : null;
                                this.parent_call_email ? payload.append('call_email_id', this.call_email.id) : null;
                                this.parent_legal_case ? payload.append('legal_case_id', this.legal_case.id) : null;
                                this.district_id ? payload.append('district_id', this.district_id) : null;
                                this.assigned_to_id ? payload.append('assigned_to_id', this.assigned_to_id) : null;
                                this.inspection_type_id ? payload.append('inspection_type_id', this.inspection_type_id) : null;
                                this.region_id ? payload.append('region_id', this.region_id) : null;
                                this.allocated_group_id ? payload.append('allocated_group_id', this.allocated_group_id) : null;
                                this.temporary_document_collection_id ? payload.append('temporary_document_collection_id', this.temporary_document_collection_id.temp_doc_id) : null;

                                this.workflow_type ? payload.append('workflow_type', this.workflow_type) : null;
                                !payload.has('allocated_group') ? payload.append('allocated_group', this.allocatedGroup) : null;

                                _context4.prev = 15;
                                _context4.next = 18;
                                return _vue2.default.http.post(post_url, payload);

                            case 18:
                                res = _context4.sent;

                                if (!res.ok) {
                                    _context4.next = 21;
                                    break;
                                }

                                return _context4.abrupt("return", res);

                            case 21:
                                _context4.next = 26;
                                break;

                            case 23:
                                _context4.prev = 23;
                                _context4.t0 = _context4["catch"](15);

                                this.errorResponse = 'Error:' + _context4.t0.bodyText;

                            case 26:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[15, 23]]);
            }));

            function sendData() {
                return _ref4.apply(this, arguments);
            }

            return sendData;
        }(),
        createDocumentActionUrl: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(done) {
                var returned_inspection;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (this.inspection.id) {
                                    _context5.next = 6;
                                    break;
                                }

                                _context5.next = 3;
                                return this.saveInspection({ create: true, internal: true });

                            case 3:
                                returned_inspection = _context5.sent;
                                _context5.next = 6;
                                return this.loadInspection({ inspection_id: returned_inspection.body.id });

                            case 6:
                                this.$refs.comms_log_file.document_action_url = this.inspection.createInspectionProcessCommsLogsDocumentUrl;
                                return _context5.abrupt("return", done(true));

                            case 8:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createDocumentActionUrl(_x) {
                return _ref5.apply(this, arguments);
            }

            return createDocumentActionUrl;
        }()

    }),
    created: function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
            var _this = this;

            var returned_regions, returned_inspection_types, region, district;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return _hooks.cache_helper.getSetCacheList('Regions', '/api/regions/');

                        case 2:
                            returned_regions = _context6.sent;

                            (0, _assign2.default)(this.regions, returned_regions);

                            this.regions.splice(0, 0, {
                                id: "",
                                display_name: "",
                                district: "",
                                districts: [],
                                region: null
                            });

                            _context6.next = 7;
                            return _hooks.cache_helper.getSetCacheList('InspectionTypes', _hooks.api_endpoints.inspection_types);

                        case 7:
                            returned_inspection_types = _context6.sent;

                            (0, _assign2.default)(this.inspectionTypes, returned_inspection_types);

                            this.inspectionTypes.splice(0, 0, {
                                id: "",
                                description: ""
                            });

                            if (this.parent_call_email) {
                                if (this.call_email && this.call_email.region_gis) {
                                    region = this.regions.find(function (obj) {
                                        return obj.name === _this.call_email.region_gis;
                                    });

                                    if (region) {
                                        this.region_id = region.id;
                                        if (this.call_email.district_gis) {
                                            district = region.districts.find(function (obj) {
                                                return obj.district_name === _this.call_email.district_gis;
                                            });

                                            if (district) {
                                                this.district_id = district.district_id;
                                            }
                                        }
                                    }
                                }
                            }

                            this.updateDistricts();

                        case 12:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function created() {
            return _ref6.apply(this, arguments);
        }

        return created;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getOwnPropertyNames = __webpack_require__(70);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _search_person_or_organisation = __webpack_require__(49);

var _search_person_or_organisation2 = _interopRequireDefault(_search_person_or_organisation);

var _assignment = __webpack_require__(97);

var _assignment2 = _interopRequireDefault(_assignment);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _vuex = __webpack_require__(6);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(15);

__webpack_require__(37);

var _offence_modal = __webpack_require__(98);

var _offence_modal2 = _interopRequireDefault(_offence_modal);

var _sanction_outcome_modal = __webpack_require__(99);

var _sanction_outcome_modal2 = _interopRequireDefault(_sanction_outcome_modal);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _inspection_workflow = __webpack_require__(860);

var _inspection_workflow2 = _interopRequireDefault(_inspection_workflow);

var _related_items = __webpack_require__(58);

var _related_items2 = _interopRequireDefault(_related_items);

var _map_location = __webpack_require__(321);

var _map_location2 = _interopRequireDefault(_map_location);

var _objectHash = __webpack_require__(55);

var _objectHash2 = _interopRequireDefault(_objectHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    name: "ViewInspection",
    data: function data() {
        return {
            mapboxAccessToken: null,
            uuid: 0,
            objectHash: null,
            iTab: 'iTab' + this._uid,
            rTab: 'rTab' + this._uid,
            oTab: 'oTab' + this._uid,
            cTab: 'cTab' + this._uid,
            lTab: 'lTab' + this._uid,
            current_schema: [],

            workflowBindId: '',

            idLocationFieldsAddress: this.guid + "LocationFieldsAddress",
            idLocationFieldsDetails: this.guid + "LocationFieldsDetails",
            dtHeadersInspectionTeam: ['Name', 'Role', 'Action'],
            dtOptionsInspectionTeam: {
                columns: [{
                    data: 'full_name'
                }, {
                    data: 'member_role'
                }, {
                    data: 'Action',
                    mRender: function mRender(data, type, row) {
                        var links = '';
                        console.log("row.Action");
                        console.log(row.Action);
                        if (!row.Action.readonlyForm) {
                            if (row.Action.action === 'Member') {
                                links = '<a href="#" class="make_team_lead" data-member-id="' + row.Action.id + '">Make Team Lead</a><br>';
                            }
                            if (row.Action.can_remove) {
                                links += '<a href="#" class="remove_button" data-member-id="' + row.Action.id + '">Remove</a>';
                            }
                            return links;
                        } else {
                            return '';
                        }
                    }
                }]
            },
            workflow_type: '',

            sectionLabel: "Details",
            sectionIndex: 1,
            pBody: "pBody" + this._uid,
            loading: [],
            inspectionTypes: [],
            teamMemberSelected: null,
            displayCreateNewPerson: false,
            newPersonBeingCreated: false,
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.inspection, this.$route.params.inspection_id + "/comms_log"),
            comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.inspection, this.$route.params.inspection_id + "/add_comms_log"),
            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.inspection, this.$route.params.inspection_id + "/action_log"),
            assign_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.inspection, this.$route.params.inspection_id + '/update_assigned_to_id/'),
            assignmentKey: 0,
            sanctionOutcomeInitialised: false,
            offenceInitialised: false,
            hashAttributeWhitelist: ["allocated_group_id", "details", "district_id", "individual_inspected_id", "inform_party_being_inspected", "inspection_type_id", "location", "organisation_inspected_id", "party_inspected", "planned_for_date", "planned_for_time", "region_id", "title"]
        };
    },
    components: {
        CommsLogs: _comms_logs2.default,
        FormSection: _section_toggle2.default,
        datatable: _datatable2.default,
        SearchPersonOrganisation: _search_person_or_organisation2.default,

        Offence: _offence_modal2.default,
        SanctionOutcome: _sanction_outcome_modal2.default,
        filefield: _compliance_file2.default,
        InspectionWorkflow: _inspection_workflow2.default,
        RelatedItems: _related_items2.default,
        MapLocation: _map_location2.default,
        Assignment: _assignment2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('inspectionStore', {
        inspection: "inspection"
    }), (0, _vuex.mapGetters)({
        renderer_form_data: 'renderer_form_data'
    }), {
        updateSearchPersonOrganisationBindId: function updateSearchPersonOrganisationBindId() {
            if (this.inspectedEntity.data_type && this.inspectedEntity.id) {
                return this.inspectedEntity.data_type + '_' + this.inspectedEntity.id;
            }
        },
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        },
        statusDisplay: function statusDisplay() {
            return this.inspection.status ? this.inspection.status.name : '';
        },
        statusId: function statusId() {
            return this.inspection.status ? this.inspection.status.id : '';
        },
        readonlyForm: function readonlyForm() {
            var readonly = true;
            if (this.inspection.status && this.inspection.status.id === 'await_endorsement') {} else if (this.inspection.id) {
                readonly = !this.inspection.can_user_action;
            } else {}
            console.log(readonly);
            return readonly;
        },
        canUserAction: function canUserAction() {
            return this.inspection.can_user_action;
        },
        inspectionReportExists: function inspectionReportExists() {
            return this.inspection.inspection_report.length > 0 ? true : false;
        },
        offenceExists: function offenceExists() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.inspection.related_items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.model_name.toLowerCase() === 'offence') {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return false;
        },
        sendToManagerVisibility: function sendToManagerVisibility() {
            if (this.inspection.status && this.inspection.can_user_action && this.inspectionReportExists) {
                if (this.inspection.status.id === 'open') {
                    return true;
                }
            } else {
                return false;
            }
        },
        endorseVisibility: function endorseVisibility() {
            if (this.inspection.status && this.inspection.can_user_action) {
                return this.inspection.status.id === 'await_endorsement' ? true : false;
            } else {
                return false;
            }
        },
        requestAmendmentVisibility: function requestAmendmentVisibility() {
            if (this.inspection.status && this.inspection.can_user_action) {
                return this.inspection.status.id === 'await_endorsement' ? true : false;
            } else {
                return false;
            }
        },
        offenceVisibility: function offenceVisibility() {
            if (this.inspection.status && this.inspection.can_user_action) {
                return this.inspection.status.id === 'open' ? true : false;
            } else {
                return false;
            }
        },
        sanctionOutcomeVisibility: function sanctionOutcomeVisibility() {
            if (this.inspection.status && this.offenceExists && this.inspection.can_user_action) {
                return this.inspection.status.id === 'open' ? true : false;
            } else {
                return false;
            }
        },
        relatedItemsBindId: function relatedItemsBindId() {
            var timeNow = Date.now();
            if (this.inspection && this.inspection.id) {
                return 'inspection_' + this.inspection.id + '_' + this._uid;
            } else {
                return timeNow.toString();
            }
        },
        relatedItemsVisibility: function relatedItemsVisibility() {
            if (this.inspection && this.inspection.id) {
                return true;
            } else {
                return false;
            }
        },
        rendererVisibility: function rendererVisibility() {
            console.log("rendererVisibility");
            if (this.inspection.id && this.current_schema && this.current_schema.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        inspectedEntity: function inspectedEntity() {
            var entity = {};
            if (this.inspection.individual_inspected) {
                entity.id = this.inspection.individual_inspected.id;
                entity.data_type = 'individual';
            } else if (this.inspection.organisation_inspected) {
                entity.id = this.inspection.organisation_inspected.id;
                entity.data_type = 'organisation';
            }
            return entity;
        },
        offenceBindId: function offenceBindId() {
            var offence_bind_id = '';

            offence_bind_id = 'offence' + parseInt(this.uuid);
            return offence_bind_id;
        },
        inspectionTeam: function inspectionTeam() {
            return this.inspection.inspection_team;
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? (0, _moment2.default)(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    watch: {
        inspectionTeam: {
            handler: function handler() {
                this.constructInspectionTeamTable();
            },
            deep: true
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('inspectionStore', {
        loadInspection: 'loadInspection',
        saveInspection: 'saveInspection',
        setInspection: 'setInspection',
        setPlannedForTime: 'setPlannedForTime',

        setPartyInspected: 'setPartyInspected',
        setRelatedItems: 'setRelatedItems'
    }), {
        mapTabClicked: function mapTabClicked() {
            if (this.$refs.mapLocationComponent) {
                this.$refs.mapLocationComponent.invalidateSize();
            }
        },
        locationUpdated: function locationUpdated(latlng) {
            this.inspection.location.geometry.coordinates[1] = latlng.lat;
            this.inspection.location.geometry.coordinates[0] = latlng.lng;

            this.reverseGeocoding(latlng);
        },
        reverseGeocoding: function reverseGeocoding(coordinates_4326) {
            var self = this;

            $.ajax({
                url: _hooks.api_endpoints.geocoding_address_search + coordinates_4326.lng + "," + coordinates_4326.lat + ".json?" + $.param({
                    access_token: self.mapboxAccessToken,
                    limit: 1,
                    types: "address"
                }),
                dataType: "json",
                success: function success(data, status, xhr) {
                    var address_found = false;
                    if (data.features && data.features.length > 0) {
                        for (var i = 0; i < data.features.length; i++) {
                            if (data.features[i].place_type.includes("address")) {
                                self.setAddressFields(data.features[i]);
                                address_found = true;
                            }
                        }
                    }
                    if (address_found) {
                        self.showHideAddressDetailsFields(true, false);
                        self.setLocationDetailsFieldEmpty();
                    } else {
                        self.showHideAddressDetailsFields(false, true);
                        self.setLocationAddressEmpty();
                    }
                }
            });
        },
        setAddressFields: function setAddressFields(feature) {
            if (this.inspection.location) {
                var state_abbr_list = {
                    "New South Wales": "NSW",
                    Queensland: "QLD",
                    "South Australia": "SA",
                    Tasmania: "TAS",
                    Victoria: "VIC",
                    "Western Australia": "WA",
                    "Northern Territory": "NT",
                    "Australian Capital Territory": "ACT"
                };
                var address_arr = feature.place_name.split(",");

                this.inspection.location.properties.street = address_arr[0];

                var reg = /^([a-zA-Z0-9\s]*)\s(New South Wales|Queensland|South Australia|Tasmania|Victoria|Western Australia|Northern Territory|Australian Capital Territory){1}\s+(\d{4})$/gi;
                var result = reg.exec(address_arr[1]);

                this.inspection.location.properties.town_suburb = result[1].trim();

                var state_abbr = state_abbr_list[result[2].trim()];
                this.inspection.location.properties.state = state_abbr;

                this.inspection.location.properties.postcode = result[3].trim();

                this.inspection.location.properties.country = "Australia";
            }
        },

        showHideAddressDetailsFields: function showHideAddressDetailsFields(showAddressFields, showDetailsFields) {
            if (showAddressFields) {
                $("#" + this.idLocationFieldsAddress).fadeIn();
            } else {
                $("#" + this.idLocationFieldsAddress).fadeOut();
            }
            if (showDetailsFields) {
                $("#" + this.idLocationFieldsDetails).fadeIn();
            } else {
                $("#" + this.idLocationFieldsDetails).fadeOut();
            }
        },
        setLocationAddressEmpty: function setLocationAddressEmpty() {
            if (this.inspection.location) {
                this.inspection.location.properties.town_suburb = "";
                this.inspection.location.properties.street = "";
                this.inspection.location.properties.state = "";
                this.inspection.location.properties.postcode = "";
                this.inspection.location.properties.country = "";
            }
        },
        setLocationDetailsFieldEmpty: function setLocationDetailsFieldEmpty() {
            if (this.inspection.location) {
                this.inspection.location.properties.details = "";
            }
        },

        constructInspectionTeamTable: function constructInspectionTeamTable() {
            this.$refs.inspection_team_table.vmDataTable.clear().draw();

            if (this.inspection.inspection_team) {
                for (var i = 0; i < this.inspection.inspection_team.length; i++) {

                    var actionColumn = new Object();
                    (0, _assign2.default)(actionColumn, this.inspection.inspection_team[i]);

                    actionColumn.readonlyForm = this.readonlyForm;

                    if (this.inspection.inspection_team.length > 2) {
                        actionColumn.can_remove = true;
                    }

                    if (this.inspection.inspection_team[i].id) {
                        this.$refs.inspection_team_table.vmDataTable.row.add({
                            'full_name': this.inspection.inspection_team[i].full_name,
                            'member_role': this.inspection.inspection_team[i].member_role,
                            'Action': actionColumn
                        }).draw();
                    }
                }
            }
        },
        modifyInspectionTeam: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref) {
                var _this = this;

                var user_id = _ref.user_id,
                    action = _ref.action;
                var inspectionTeamUrl, payload, inspectionTeamResponse;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                inspectionTeamUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.inspection, this.inspection.id + '/modify_inspection_team/');
                                payload = {
                                    'user_id': user_id,
                                    'action': action
                                };
                                _context.next = 4;
                                return _vue2.default.http.post(inspectionTeamUrl, payload);

                            case 4:
                                inspectionTeamResponse = _context.sent;
                                _context.next = 7;
                                return this.setInspection(inspectionTeamResponse.body);

                            case 7:
                                this.$nextTick(function () {
                                    _this.constructInspectionTeamTable();
                                });

                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function modifyInspectionTeam(_x) {
                return _ref2.apply(this, arguments);
            }

            return modifyInspectionTeam;
        }(),
        newPersonCreated: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(obj) {
                var full_name, dob, value;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                console.log(obj);

                                if (!obj.person) {
                                    _context2.next = 10;
                                    break;
                                }

                                _context2.next = 4;
                                return this.setPartyInspected({ data_type: 'individual', id: obj.person.id });

                            case 4:
                                full_name = [obj.person.first_name, obj.person.last_name].filter(Boolean).join(" ");
                                dob = obj.person.dob ? "DOB:" + obj.person.dob : "DOB: ---";
                                value = [full_name, dob].filter(Boolean).join(", ");

                                this.$refs.search_person.setInput(value);
                                _context2.next = 11;
                                break;

                            case 10:
                                if (obj.err) {
                                    console.log(err);
                                } else {}

                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function newPersonCreated(_x2) {
                return _ref3.apply(this, arguments);
            }

            return newPersonCreated;
        }(),
        loadInspectionReport: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                console.log("loadInspectionReport");
                                _context3.next = 3;
                                return this.loadInspection({ inspection_id: this.inspection.id });

                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function loadInspectionReport() {
                return _ref4.apply(this, arguments);
            }

            return loadInspectionReport;
        }(),

        loadSchema: function loadSchema() {
            if (this.inspection.inspection_type_id) {
                this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                    var url, returned_schema;
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    url = _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.inspection_types, this.inspection.inspection_type_id + '/get_schema');
                                    _context4.next = 3;
                                    return _hooks.cache_helper.getSetCache('InspectionTypeSchema', this.inspection.id.toString(), url);

                                case 3:
                                    returned_schema = _context4.sent;

                                    if (returned_schema) {
                                        this.current_schema = returned_schema.schema;
                                    }

                                case 5:
                                case "end":
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, this);
                })));
            }
        },

        open_sanction_outcome: function open_sanction_outcome() {
            var _this2 = this;

            this.sanctionOutcomeInitialised = true;
            this.$nextTick(function () {
                _this2.$refs.sanction_outcome.isModalOpen = true;
            });
        },
        open_offence: function open_offence() {
            var _this3 = this;

            this.uuid += 1;
            this.offenceInitialised = true;
            this.$nextTick(function () {
                _this3.$refs.offence.isModalOpen = true;
            });
        },

        createNewPersonClicked: function createNewPersonClicked() {
            this.newPersonBeingCreated = true;
            this.displayCreateNewPerson = !this.displayCreateNewPerson;
        },
        addTeamMember: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.modifyInspectionTeam({
                                    user_id: this.teamMemberSelected,
                                    action: 'add'
                                });

                            case 2:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function addTeamMember() {
                return _ref6.apply(this, arguments);
            }

            return addTeamMember;
        }(),
        removeTeamMember: function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(e) {
                var memberId;
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                memberId = e.target.getAttribute("data-member-id");
                                _context6.next = 3;
                                return this.modifyInspectionTeam({
                                    user_id: memberId,
                                    action: 'remove'
                                });

                            case 3:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function removeTeamMember(_x3) {
                return _ref7.apply(this, arguments);
            }

            return removeTeamMember;
        }(),
        makeTeamLead: function () {
            var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(e) {
                var memberId;
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                memberId = e.target.getAttribute("data-member-id");
                                _context7.next = 3;
                                return this.modifyInspectionTeam({
                                    user_id: memberId,
                                    action: 'make_team_lead'
                                });

                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function makeTeamLead(_x4) {
                return _ref8.apply(this, arguments);
            }

            return makeTeamLead;
        }(),
        entitySelected: function () {
            var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(para) {
                return _regenerator2.default.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                console.log(para);
                                _context8.next = 3;
                                return this.setPartyInspected(para);

                            case 3:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function entitySelected(_x5) {
                return _ref9.apply(this, arguments);
            }

            return entitySelected;
        }(),
        updateWorkflowBindId: function updateWorkflowBindId() {
            var timeNow = Date.now();
            if (this.workflow_type) {
                this.workflowBindId = this.workflow_type + '_' + timeNow.toString();
            } else {
                this.workflowBindId = timeNow.toString();
            }
        },
        addWorkflow: function addWorkflow(workflow_type) {
            var _this4 = this;

            this.workflow_type = workflow_type;
            this.updateWorkflowBindId();
            this.$nextTick(function () {
                _this4.$refs.inspection_workflow.isModalOpen = true;
            });
        },

        save: function () {
            var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(returnToDash) {
                var savedInspection, savedPerson;
                return _regenerator2.default.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                console.log(returnToDash);
                                savedInspection = null;
                                savedPerson = null;

                                if (!this.inspection.id) {
                                    _context9.next = 21;
                                    break;
                                }

                                if (!(this.$refs.search_person_organisation && this.$refs.search_person_organisation.entityIsPerson)) {
                                    _context9.next = 15;
                                    break;
                                }

                                console.log("savePerson");
                                _context9.next = 8;
                                return this.$refs.search_person_organisation.parentSave();

                            case 8:
                                savedPerson = _context9.sent;

                                if (!(savedPerson && savedPerson.ok)) {
                                    _context9.next = 13;
                                    break;
                                }

                                _context9.next = 12;
                                return this.saveInspection({ create: false, internal: false });

                            case 12:
                                savedInspection = _context9.sent;

                            case 13:
                                _context9.next = 19;
                                break;

                            case 15:
                                console.log("no savePerson");
                                _context9.next = 18;
                                return this.saveInspection({ create: false, internal: false });

                            case 18:
                                savedInspection = _context9.sent;

                            case 19:
                                _context9.next = 24;
                                break;

                            case 21:
                                _context9.next = 23;
                                return this.saveInspection({ create: true, internal: false });

                            case 23:
                                savedInspection = _context9.sent;

                            case 24:
                                this.calculateHash();

                                if (savedInspection && savedInspection.ok && returnToDash === 'exit') {
                                    window.removeEventListener('beforeunload', this.leaving);
                                    window.removeEventListener('onblur', this.leaving);

                                    this.$router.push({ name: 'internal-inspection-dash' });
                                }

                            case 26:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function save(_x6) {
                return _ref10.apply(this, arguments);
            }

            return save;
        }(),
        addEventListeners: function addEventListeners() {
            var vm = this;
            var el_fr_date = $(vm.$refs.plannedForDatePicker);
            var el_fr_time = $(vm.$refs.plannedForTimePicker);

            el_fr_date.datetimepicker({
                format: "DD/MM/YYYY",
                minDate: "now",
                showClear: true
            });
            el_fr_date.on("dp.change", function (e) {
                if (el_fr_date.data("DateTimePicker").date()) {
                    vm.inspection.planned_for_date = e.date.format("DD/MM/YYYY");
                } else if (el_fr_date.data("date") === "") {
                    vm.inspection.planned_for_date = "";
                }
            });
            el_fr_time.datetimepicker({ format: "LT", showClear: true });
            el_fr_time.on("dp.change", function (e) {
                if (el_fr_time.data("DateTimePicker").date()) {
                    vm.inspection.planned_for_time = e.date.format("LT");
                } else if (el_fr_time.data("date") === "") {
                    vm.inspection.planned_for_time = "";
                }
            });
            $('#inspection-team-table').on('click', '.remove_button', vm.removeTeamMember);
            $('#inspection-team-table').on('click', '.make_team_lead', vm.makeTeamLead);
            window.addEventListener('beforeunload', this.leaving);
            window.addEventListener('onblur', this.leaving);
        },
        leaving: function leaving(e) {
            var vm = this;
            var dialogText = '';
            if (this.formChanged()) {
                e.returnValue = dialogText;
                return dialogText;
            }
        },
        formChanged: function formChanged() {
            var _this5 = this;

            var changed = false;
            var copiedInspection = {};
            (0, _getOwnPropertyNames2.default)(this.inspection).forEach(function (val, idx, array) {
                if (_this5.hashAttributeWhitelist.includes(val)) {
                    copiedInspection[val] = _this5.inspection[val];
                }
            });
            this.addHashAttributes(copiedInspection);
            if (this.objectHash !== (0, _objectHash2.default)(copiedInspection)) {
                changed = true;
            }
            return changed;
        },
        calculateHash: function calculateHash() {
            var _this6 = this;

            var copiedInspection = {};
            (0, _getOwnPropertyNames2.default)(this.inspection).forEach(function (val, idx, array) {
                if (_this6.hashAttributeWhitelist.includes(val)) {
                    copiedInspection[val] = _this6.inspection[val];
                }
            });
            this.addHashAttributes(copiedInspection);
            this.objectHash = (0, _objectHash2.default)(copiedInspection);
        },
        addHashAttributes: function addHashAttributes(obj) {
            var copiedRendererFormData = (0, _assign2.default)({}, this.renderer_form_data);
            obj.renderer_form_data = copiedRendererFormData;
            return obj;
        },
        updateAssignedToId: function () {
            var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(body) {
                var _this7 = this;

                return _regenerator2.default.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.setInspection(body);

                            case 2:
                                this.$nextTick(function () {
                                    _this7.constructInspectionTeamTable();
                                });
                                this.assignmentKey += 1;

                            case 4:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function updateAssignedToId(_x7) {
                return _ref11.apply(this, arguments);
            }

            return updateAssignedToId;
        }()
    }),
    created: function () {
        var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12() {
            var _this8 = this;

            var temp_token, returned_inspection_types;
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            _context12.next = 2;
                            return this.retrieveMapboxAccessToken();

                        case 2:
                            temp_token = _context12.sent;

                            this.mapboxAccessToken = temp_token.access_token;

                            if (!this.$route.params.inspection_id) {
                                _context12.next = 7;
                                break;
                            }

                            _context12.next = 7;
                            return this.loadInspection({ inspection_id: this.$route.params.inspection_id });

                        case 7:
                            console.log(this);

                            _context12.next = 10;
                            return _hooks.cache_helper.getSetCacheList('InspectionTypes', _hooks.api_endpoints.inspection_types);

                        case 10:
                            returned_inspection_types = _context12.sent;

                            (0, _assign2.default)(this.inspectionTypes, returned_inspection_types);

                            this.inspectionTypes.splice(0, 0, {
                                id: null,
                                description: ""
                            });

                            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
                                return _regenerator2.default.wrap(function _callee11$(_context11) {
                                    while (1) {
                                        switch (_context11.prev = _context11.next) {
                                            case 0:
                                                if (!_this8.inspection.inspection_type_id) {
                                                    _context11.next = 3;
                                                    break;
                                                }

                                                _context11.next = 3;
                                                return _this8.loadSchema();

                                            case 3:
                                            case "end":
                                                return _context11.stop();
                                        }
                                    }
                                }, _callee11, _this8);
                            })));

                            this.calculateHash();

                        case 15:
                        case "end":
                            return _context12.stop();
                    }
                }
            }, _callee12, this);
        }));

        function created() {
            return _ref12.apply(this, arguments);
        }

        return created;
    }(),
    destroyed: function destroyed() {
        window.removeEventListener('beforeunload', this.leaving);
        window.removeEventListener('onblur', this.leaving);
    },

    mounted: function mounted() {
        var _this9 = this;

        var vm = this;

        $('#plannedForTimePicker').datetimepicker({
            format: 'LT'
        });
        $('#plannedForTimePicker').on('dp.change', function (e) {
            vm.setPlannedForTime(e.date.format('LT'));
        });

        $(vm.$refs.inspectionteam).select2({
            "theme": "bootstrap",
            allowClear: true,
            placeholder: "Select Team Member"
        }).on("select2:select", function (e) {
            var selected = $(e.currentTarget);
            vm.teamMemberSelected = selected.val();
        }).on("select2:unselect", function (e) {
            var selected = $(e.currentTarget);
            vm.teamMemberSelected = selected.val();
        });

        this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13() {
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            _this9.addEventListeners();
                            _this9.constructInspectionTeamTable();

                        case 2:
                        case "end":
                            return _context13.stop();
                    }
                }
            }, _callee13, _this9);
        })));
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _create_inspection_modal = __webpack_require__(83);

var _create_inspection_modal2 = _interopRequireDefault(_create_inspection_modal);

var _inspection_locations = __webpack_require__(859);

var _inspection_locations2 = _interopRequireDefault(_inspection_locations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'InspectionTableDash',
    data: function data() {
        var vm = this;
        return {
            classification_types: [],

            report_types: [],

            filterStatus: 'All',
            filterInspectionType: 'All',
            filterTeamLead: 'All',

            filterPlannedFrom: '',
            filterPlannedTo: '',

            statusChoices: [],
            inspectionTypes: [],

            dateFormat: 'DD/MM/YYYY',
            inspectionInitialised: false,

            canUserCreateNewInspection: false,

            createInspectionBindId: '',

            dtOptions: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                autoWidth: false,
                rowCallback: function rowCallback(row, data) {
                    (0, _jquery2.default)(row).addClass('appRecordRow');
                },

                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },

                responsive: true,
                processing: true,
                ajax: {
                    'url': '/api/inspection_paginated/get_paginated_datatable/?format=datatables',

                    'dataSrc': 'data',
                    'data': function data(d) {
                        d.status_description = vm.filterStatus;
                        d.inspection_description = vm.filterInspectionType;
                        d.date_from = vm.filterPlannedFrom != '' && vm.filterPlannedFrom != null ? moment(vm.filterPlannedFrom, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                        d.date_to = vm.filterPlannedTo != '' && vm.filterPlannedTo != null ? moment(vm.filterPlannedTo, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                    }
                },
                dom: 'lBfrtip',
                buttons: ['excel', 'csv'],
                columns: [{
                    data: 'number',
                    searchable: false
                }, {
                    data: 'title',
                    searchable: false,
                    orderable: true
                }, {
                    data: 'inspection_type',
                    searchable: false,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        if (data) {
                            return data.inspection_type;
                        } else {
                            return '';
                        }
                    }
                }, {
                    data: 'status.name',
                    searchable: false,
                    orderable: true
                }, {
                    data: 'planned_for',
                    searchable: false,
                    orderable: true
                }, {
                    data: 'inspection_team_lead',
                    searchable: false,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        if (data) {
                            return data.full_name;
                        } else {
                            return '';
                        }
                    }
                }, {
                    data: "assigned_to",
                    searchable: false,
                    orderable: false,
                    mRender: function mRender(data, type, full) {
                        if (data) {
                            return data.full_name;
                        } else {
                            return '';
                        }
                    }
                }, {
                    data: 'user_action',
                    searchable: false,
                    orderable: false
                }]
            },
            dtHeaders: ['Number', 'Title', 'Inspection Type', 'Status', 'Planned for', 'Team Lead', 'Assigned To', 'Action']
        };
    },


    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var _this = this;

        next(function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(vm) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }());
    },

    created: function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var returned_status_choices, returned_inspection_types;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            this.getUserCanCreate();
                            _context2.next = 3;
                            return _hooks.cache_helper.getSetCacheList('Inspection_StatusChoices', '/api/inspection/status_choices');

                        case 3:
                            returned_status_choices = _context2.sent;


                            (0, _assign2.default)(this.statusChoices, returned_status_choices);
                            this.statusChoices.splice(0, 0, { id: 'all', display: 'All' });

                            _context2.next = 8;
                            return _hooks.cache_helper.getSetCacheList('InspectionTypes', _hooks.api_endpoints.inspection_types);

                        case 8:
                            returned_inspection_types = _context2.sent;

                            (0, _assign2.default)(this.inspectionTypes, returned_inspection_types);

                            this.inspectionTypes.splice(0, 0, {
                                id: "all",
                                description: "All",
                                inspection_type: "All"
                            });

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function created() {
            return _ref2.apply(this, arguments);
        }

        return created;
    }(),
    watch: {
        filterStatus: function filterStatus() {
            this.$refs.inspection_table.vmDataTable.draw();
        },
        filterInspectionType: function filterInspectionType() {
            this.$refs.inspection_table.vmDataTable.draw();
        },
        filterTeamLead: function filterTeamLead() {
            this.$refs.inspection_table.vmDataTable.draw();
        },
        filterPlannedFrom: function filterPlannedFrom() {
            this.$refs.inspection_table.vmDataTable.draw();
        },
        filterPlannedTo: function filterPlannedTo() {
            this.$refs.inspection_table.vmDataTable.draw();
        }
    },
    components: {
        datatable: _datatable2.default,
        FormSection: _section_toggle2.default,
        InspectionModal: _create_inspection_modal2.default,
        MapLocations: _inspection_locations2.default
    },
    computed: {
        visibilityCreateNewButton: function visibilityCreateNewButton() {
            return this.canUserCreateNewInspection;
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('inspectionStore', {
        saveInspection: "saveInspection"
    }), {
        createInspection: function createInspection() {
            var _this2 = this;

            this.setCreateInspectionBindId();
            this.inspectionInitialised = true;
            this.$nextTick(function () {
                _this2.$refs.add_inspection.isModalOpen = true;
            });
        },
        setCreateInspectionBindId: function setCreateInspectionBindId() {
            var timeNow = Date.now();
            this.createInspectionBindId = 'inspection' + timeNow.toString();
        },
        getUserCanCreate: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var url, res;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.inspection, 'can_user_create/');
                                _context3.next = 3;
                                return _vue2.default.http.get(url);

                            case 3:
                                res = _context3.sent;

                                this.canUserCreateNewInspection = res.body;

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getUserCanCreate() {
                return _ref3.apply(this, arguments);
            }

            return getUserCanCreate;
        }(),
        createInspectionUrl: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var newInspectionId;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.saveInspection({ create: true });

                            case 2:
                                newInspectionId = _context4.sent;


                                this.$router.push({
                                    name: 'view-inspection',
                                    params: { inspection_id: newInspectionId }
                                });

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function createInspectionUrl() {
                return _ref4.apply(this, arguments);
            }

            return createInspectionUrl;
        }(),
        addEventListeners: function addEventListeners() {
            var vm = this;

            (0, _jquery2.default)(vm.$refs.plannedDateToPicker).datetimepicker(vm.datepickerOptions);
            (0, _jquery2.default)(vm.$refs.plannedDateFromPicker).datetimepicker(vm.datepickerOptions);

            (0, _jquery2.default)(vm.$refs.plannedDateToPicker).on('dp.change', function (e) {
                if ((0, _jquery2.default)(vm.$refs.plannedDateToPicker).data('DateTimePicker').date()) {
                    (0, _jquery2.default)(vm.$refs.plannedDateFromPicker).data("DateTimePicker").maxDate(e.date);
                    vm.filterPlannedTo = e.date.format('DD/MM/YYYY');
                } else if ((0, _jquery2.default)(vm.$refs.plannedDateToPicker).data('date') === "") {
                    vm.filterPlannedTo = "";
                }
            });
            (0, _jquery2.default)(vm.$refs.plannedDateFromPicker).on('dp.change', function (e) {
                if ((0, _jquery2.default)(vm.$refs.plannedDateFromPicker).data('DateTimePicker').date()) {
                    (0, _jquery2.default)(vm.$refs.plannedDateToPicker).data("DateTimePicker").minDate(e.date);
                    vm.filterPlannedFrom = e.date.format('DD/MM/YYYY');
                } else if ((0, _jquery2.default)(vm.$refs.plannedDateFromPicker).data('date') === "") {
                    vm.filterPlannedFrom = "";
                }
            });
        },
        initialiseSearch: function initialiseSearch() {
            this.dateSearch();
        },
        dateSearch: function dateSearch() {
            var vm = this;
            vm.$refs.inspection_table.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var from = vm.filterPlannedFrom;
                var to = vm.filterPlannedTo;
                var val = original.planned_for_date;

                if (from == '' && to == '') {
                    return true;
                } else if (from != '' && to != '') {
                    return val != null && val != '' ? moment().range(moment(from, vm.dateFormat), moment(to, vm.dateFormat)).contains(moment(val)) : false;
                } else if (from == '' && to != '') {
                    if (val != null && val != '') {
                        return moment(to, vm.dateFormat).diff(moment(val)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (to == '' && from != '') {
                    if (val != null && val != '') {
                        return moment(val).diff(moment(from, vm.dateFormat)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            });
        }
    }),
    mounted: function () {
        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
            var _this3 = this;

            var vm;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            vm = this;

                            (0, _jquery2.default)('a[data-toggle="collapse"]').on('click', function () {
                                var chev = (0, _jquery2.default)(this).children()[0];
                                window.setTimeout(function () {
                                    (0, _jquery2.default)(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
                                }, 100);
                            });
                            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                                return _regenerator2.default.wrap(function _callee5$(_context5) {
                                    while (1) {
                                        switch (_context5.prev = _context5.next) {
                                            case 0:
                                                _context5.next = 2;
                                                return vm.initialiseSearch();

                                            case 2:
                                                _context5.next = 4;
                                                return vm.addEventListeners();

                                            case 4:
                                            case 'end':
                                                return _context5.stop();
                                        }
                                    }
                                }, _callee5, _this3);
                            })));

                        case 3:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function mounted() {
            return _ref5.apply(this, arguments);
        }

        return mounted;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment) {

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _leaflet = __webpack_require__(54);

var _leaflet2 = _interopRequireDefault(_leaflet);

__webpack_require__(126);

__webpack_require__(66);

var _awesomplete = __webpack_require__(43);

var _awesomplete2 = _interopRequireDefault(_awesomplete);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

__webpack_require__(65);

__webpack_require__(124);

__webpack_require__(123);

__webpack_require__(64);

__webpack_require__(15);

__webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_leaflet2.default.TileLayer.WMTS = _leaflet2.default.TileLayer.extend({
    defaultWmtsParams: {
        service: 'WMTS',
        request: 'GetTile',
        version: '1.0.0',
        layers: '',
        styles: '',
        tilematrixSet: '',
        format: 'image/jpeg'
    },

    initialize: function initialize(url, options) {
        this._url = url;
        var wmtsParams = _leaflet2.default.extend({}, this.defaultWmtsParams);
        var tileSize = options.tileSize || this.options.tileSize;
        if (options.detectRetina && _leaflet2.default.Browser.retina) {
            wmtsParams.width = wmtsParams.height = tileSize * 2;
        } else {
            wmtsParams.width = wmtsParams.height = tileSize;
        }
        for (var i in options) {
            if (!this.options.hasOwnProperty(i) && i != "matrixIds") {
                wmtsParams[i] = options[i];
            }
        }
        this.wmtsParams = wmtsParams;
        this.matrixIds = options.matrixIds || this.getDefaultMatrix();
        _leaflet2.default.setOptions(this, options);
    },

    onAdd: function onAdd(map) {
        this._crs = this.options.crs || map.options.crs;
        _leaflet2.default.TileLayer.prototype.onAdd.call(this, map);
    },

    getTileUrl: function getTileUrl(coords) {
        var tileSize = this.options.tileSize;
        var nwPoint = coords.multiplyBy(tileSize);
        nwPoint.x += 1;
        nwPoint.y -= 1;
        var sePoint = nwPoint.add(new _leaflet2.default.Point(tileSize, tileSize));
        var zoom = this._tileZoom;
        var nw = this._crs.project(this._map.unproject(nwPoint, zoom));
        var se = this._crs.project(this._map.unproject(sePoint, zoom));
        var tilewidth = se.x - nw.x;

        var ident = this.matrixIds[zoom].identifier;
        var tilematrix = this.wmtsParams.tilematrixSet + ":" + ident;
        var X0 = this.matrixIds[zoom].topLeftCorner.lng;
        var Y0 = this.matrixIds[zoom].topLeftCorner.lat;
        var tilecol = Math.floor((nw.x - X0) / tilewidth);
        var tilerow = -Math.floor((nw.y - Y0) / tilewidth);
        var url = _leaflet2.default.Util.template(this._url, { s: this._getSubdomain(coords) });
        return url + _leaflet2.default.Util.getParamString(this.wmtsParams, url) + "&tilematrix=" + tilematrix + "&tilerow=" + tilerow + "&tilecol=" + tilecol;
    },

    setParams: function setParams(params, noRedraw) {
        _leaflet2.default.extend(this.wmtsParams, params);
        if (!noRedraw) {
            this.redraw();
        }
        return this;
    },

    getDefaultMatrix: function getDefaultMatrix() {
        var matrixIds3857 = new Array(22);
        for (var i = 0; i < 22; i++) {
            matrixIds3857[i] = {
                identifier: "" + i,
                topLeftCorner: new _leaflet2.default.LatLng(20037508.3428, -20037508.3428)
            };
        }
        return matrixIds3857;
    }
});
_leaflet2.default.tileLayer.wmts = function (url, options) {
    return new _leaflet2.default.TileLayer.WMTS(url, options);
};

delete _leaflet2.default.Icon.Default.prototype._getIconUrl;
_leaflet2.default.Icon.Default.mergeOptions({
    iconRetinaUrl: __webpack_require__(127),
    iconUrl: __webpack_require__(128),
    shadowUrl: __webpack_require__(46)
});


module.exports = {
    data: function data() {
        var vm = this;
        vm.layers = [];
        vm.mcg = _leaflet2.default.markerClusterGroup();
        vm.datetime_pattern = /^\d{2}\/\d{2}\/\d{4}$/gi;
        vm.ajax_for_location = null;

        return {
            mapboxAccessToken: null,
            map: null,
            tileLayer: null,
            tileLayerSat: null,
            popup: null,
            opt_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.inspection, "optimised"),

            filterInspectionType: 'all',
            filterStatus: 'all',
            filterDateFrom: '',
            filterDateTo: '',

            status_choices: [],
            type_choices: [],
            cursor_location: null
        };
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var returned_status_choices, returned_inspection_types, temp_token;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _hooks.cache_helper.getSetCacheList('Inspection_StatusChoices', '/api/inspection/status_choices');

                        case 2:
                            returned_status_choices = _context.sent;

                            (0, _assign2.default)(this.status_choices, returned_status_choices);
                            this.status_choices.splice(0, 0, { id: 'all', display: 'All' });

                            _context.next = 7;
                            return _hooks.cache_helper.getSetCacheList('InspectionTypes', _hooks.api_endpoints.inspection_types);

                        case 7:
                            returned_inspection_types = _context.sent;

                            (0, _assign2.default)(this.type_choices, returned_inspection_types);
                            this.type_choices.splice(0, 0, { id: 'all', inspection_type: 'All' });

                            _context.next = 12;
                            return this.retrieveMapboxAccessToken();

                        case 12:
                            temp_token = _context.sent;

                            this.mapboxAccessToken = temp_token.access_token;

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        var vm = this;
        vm.initMap();
        vm.loadLocations();
        vm.initAwesomplete();
        vm.$nextTick(function () {
            vm.addEventListeners();
        });
    },

    watch: {
        filterStatus: function filterStatus() {
            this.loadLocations();
        },
        filterInspectionType: function filterInspectionType() {
            this.loadLocations();
        },
        filterDateFrom: function filterDateFrom() {
            if (!this.filterDateFrom) {
                this.loadLocations();
            } else {
                var result = this.filterDateFrom.match(this.datetime_pattern);

                if (result) {
                    this.loadLocations();
                }
            }
        },
        filterDateTo: function filterDateTo() {
            if (!this.filterDateTo) {
                this.loadLocations();
            } else {
                var result = this.datetime_pattern.exec(this.filterDateTo);
                if (result) {
                    this.loadLocations();
                }
            }
        }
    },
    computed: {},
    methods: {
        addEventListeners: function addEventListeners() {
            var vm = this;
            var el_fr = $(vm.$refs.lodgementDateFromPicker);
            var el_to = $(vm.$refs.lodgementDateToPicker);

            el_fr.datetimepicker({ format: 'DD/MM/YYYY', minDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_fr.on('dp.change', function (e) {
                if (el_fr.data('DateTimePicker').date()) {
                    vm.filterDateFrom = e.date.format('DD/MM/YYYY');
                } else if (el_fr.data('date') === "") {
                    vm.filterDateFrom = "";
                }
            });

            el_to.datetimepicker({ format: 'DD/MM/YYYY', minDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_to.on('dp.change', function (e) {
                if (el_to.data('DateTimePicker').date()) {
                    vm.filterDateTo = e.date.format('DD/MM/YYYY');
                    el_fr.data('DateTimePicker').maxDate(e.date);
                } else if (el_to.data('date') === "") {
                    vm.filterDateTo = "";
                }
            });
        },
        initAwesomplete: function initAwesomplete() {
            var self = this;
            var element_search = document.getElementById('search-input');
            this.awe = new _awesomplete2.default(element_search);
            $(element_search).on('keyup', function (ev) {
                var keyCode = ev.keyCode || ev.which;
                if (48 <= keyCode && keyCode <= 90 || 96 <= keyCode && keyCode <= 105) {
                    self.search(ev.target.value);
                    return false;
                }
            }).on('awesomplete-selectcomplete', function (ev) {
                ev.preventDefault();
                ev.stopPropagation();

                for (var i = 0; i < self.suggest_list.length; i++) {
                    if (self.suggest_list[i].value == ev.target.value) {
                        var latlng = { lat: self.suggest_list[i].feature.geometry.coordinates[1], lng: self.suggest_list[i].feature.geometry.coordinates[0] };

                        self.map.flyTo(latlng, 13, {
                            animate: true,
                            duration: 1.5
                        });
                    }
                }
                return false;
            });
        },
        search: function search(place) {
            var self = this;

            var latlng = this.map.getCenter();
            $.ajax({
                url: _hooks.api_endpoints.geocoding_address_search + encodeURIComponent(place) + '.json?' + $.param({
                    access_token: self.mapboxAccessToken,
                    country: 'au',
                    limit: 10,
                    proximity: '' + latlng.lng + ',' + latlng.lat,

                    bbox: '112.920934,-35.191991,129.0019283,-11.9662455',
                    types: 'region,postcode,district,place,locality,neighborhood,address,poi'
                }),
                dataType: 'json',
                success: function success(data, status, xhr) {
                    self.suggest_list = [];
                    if (data.features && data.features.length > 0) {
                        for (var i = 0; i < data.features.length; i++) {
                            self.suggest_list.push({ label: data.features[i].place_name,
                                value: data.features[i].place_name,
                                feature: data.features[i]
                            });
                        }
                    }

                    self.awe.list = self.suggest_list;
                    self.awe.evaluate();
                }
            });
        },
        setBaseLayer: function setBaseLayer(selected_layer_name) {
            if (selected_layer_name == 'sat') {
                this.map.removeLayer(this.tileLayer);
                this.map.addLayer(this.tileLayerSat);
                $('#basemap_sat').hide();
                $('#basemap_osm').show();
            } else {
                this.map.removeLayer(this.tileLayerSat);
                this.map.addLayer(this.tileLayer);
                $('#basemap_osm').hide();
                $('#basemap_sat').show();
            }
        },
        onClick: function onClick(e) {
            console.log(e.latlng.toString());
        },

        onMouseMove: function onMouseMove(e) {
            this.cursor_location = this.map.mouseEventToLatLng(e.originalEvent);
        },
        onMouseOut: function onMouseOut(e) {
            this.cursor_location = null;
        },
        initMap: function initMap() {
            this.map = _leaflet2.default.map('mapLeaf').setView([-24.9505, 122.8605], 5);
            this.tileLayer = _leaflet2.default.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, contributiors'
            });

            this.tileLayerSat = _leaflet2.default.tileLayer.wmts('https://kmi.dpaw.wa.gov.au/geoserver/gwc/service/wmts', {
                layer: 'public:mapbox-satellite',
                tilematrixSet: 'mercator',
                format: 'image/png'
            });

            this.popup = _leaflet2.default.popup();
            this.map.on('click', this.onClick).on('mousemove', this.onMouseMove).on('mouseout', this.onMouseOut);
            this.setBaseLayer('osm');
            this.addOtherLayers();
            this.map.addLayer(this.mcg);
            _leaflet2.default.control.locate().addTo(this.map);
        },
        addOtherLayers: function addOtherLayers() {
            var _this = this;

            var overlayMaps = {};

            this.$http.get('/api/map_layers/').then(function (response) {
                var layers = response.body.results;
                for (var i = 0; i < layers.length; i++) {
                    var l = _leaflet2.default.tileLayer.wmts('https://kmi.dpaw.wa.gov.au/geoserver/gwc/service/wmts', {
                        layer: layers[i].layer_name.trim(),
                        tilematrixSet: 'mercator',
                        format: 'image/png'
                    });
                    overlayMaps[layers[i].display_name] = l;
                }
                _leaflet2.default.control.layers(null, overlayMaps, { position: 'topleft' }).addTo(_this.map);
            });
        },
        loadLocations: function loadLocations() {
            var vm = this;

            if (vm.ajax_for_location != null) {
                vm.ajax_for_location.abort();
                vm.ajax_for_location = null;
            }
            var myData = {
                "status": vm.filterStatus,
                "inspection_type": vm.filterInspectionType,
                "date_from": vm.filterDateFrom,
                "date_to": vm.filterDateTo
            };

            vm.ajax_for_location = $.ajax({
                type: 'GET',
                data: myData,
                url: vm.opt_url,
                success: function success(data) {
                    vm.addMarkers(data);
                },
                error: function error(e) {
                    console.log(e);
                }
            });
        },
        addMarkers: function addMarkers(inspections) {
            var self = this;
            self.mcg.clearLayers();

            if (inspections && inspections.length > 0) {
                for (var i = 0; i < inspections.length; i++) {
                    if (inspections[i].location) {
                        (function () {
                            var inspection = inspections[i];
                            var coords = inspection.location.geometry.coordinates;

                            var filename = 'marker-gray-locked.svg';
                            if (inspection.status) {
                                if (inspection.status == 'open') {
                                    filename = 'marker-green-locked.svg';
                                } else if (inspection.status == 'await_endorsement') {
                                    filename = 'marker-blue-locked.svg';
                                } else if (inspection.status == 'discarded') {
                                    filename = 'marker-yellow-locked.svg';
                                } else if (inspection.status == 'closed') {
                                    filename = 'marker-red-locked.svg';
                                } else if (inspection.status == 'pending_closure') {
                                    filename = 'marker-orange-locked.svg';
                                }
                            }

                            var myIcon = _leaflet2.default.icon({
                                iconUrl: __webpack_require__(134)("./" + filename),
                                shadowUrl: __webpack_require__(46),
                                shadowSize: [41, 41],
                                shadowAnchor: [12, 41],
                                iconSize: [32, 32],
                                iconAnchor: [16, 32],
                                popupAnchor: [0, -20]
                            });
                            var myMarker = _leaflet2.default.marker([coords[1], coords[0]], { icon: myIcon });
                            var myPopup = _leaflet2.default.popup();
                            myMarker.bindPopup(myPopup);
                            self.mcg.addLayer(myMarker);

                            myMarker.on('click', function (ev) {
                                var popup = ev.target.getPopup();
                                self.$http.get('/api/inspection/' + inspection.id).then(function (response) {
                                    var inspection = response.body;
                                    popup.setContent(self.construct_content(inspection, coords));
                                });
                            });
                        })();
                    }
                }
            }
        },

        construct_content: function construct_content(inspection, coords) {
            var classification_str = '---';
            if (inspection.classification) {
                classification_str = inspection.classification.name;
            }

            var report_type_str = '---';
            if (inspection.report_type) {
                report_type_str = inspection.report_type.report_type;
            }

            var content = '<div class="popup-title-main">' + inspection.number + '</div>';
            content += '<div class="popup-title">Classification</div>' + '<div class="popup-coords">' + classification_str + '</div>';

            content += '<div class="popup-title">Report Type</div>' + '<div class="popup-address">' + report_type_str + '</div>';

            if (inspection.location.properties.street) {
                content += '<div class="popup-title">Address</div>' + '<div class="popup-address">' + inspection.location.properties.street + '<br />' + inspection.location.properties.town_suburb + '<br />' + inspection.location.properties.state + '<br />' + inspection.location.properties.postcode + '</div>';
            } else {
                content += '<div class="popup-title">Details</div>' + '<div class="popup-address">' + inspection.location.properties.details.substring(0, 10) + '</div>';
            }

            content += '<div class="popup-link">' + '<a href="/internal/inspection/' + inspection.id + '">View</a>' + '</div>';

            return content;
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "InspectionWorking",
    data: function data() {
        return {
            officers: [],
            isModalOpen: false,
            processingDetails: false,
            form: null,
            workflowDetails: '',
            errorResponse: "",
            documentActionUrl: '',

            allocated_group_id: null
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        filefield: _compliance_file2.default
    },
    props: {
        workflow_type: {
            type: String,
            default: ''
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('inspectionStore', {
        inspection: "inspection"
    }), {
        regionDistrictId: function regionDistrictId() {
            if (this.district_id || this.region_id) {
                return this.district_id ? this.district_id : this.region_id;
            } else {
                return null;
            }
        },
        modalTitle: function modalTitle() {
            if (this.workflow_type === 'send_to_manager') {
                return "Send to Manager";
            } else if (this.workflow_type === 'request_amendment') {
                return "Request Amendment";
            } else if (this.workflow_type === 'close') {
                return "Close Inspection";
            } else if (this.workflow_type === 'endorse') {
                return "Endorse and Close Inspection";
            }
        },
        groupPermission: function groupPermission() {
            if (this.workflow_type === 'send_to_manager') {
                return "manager";
            } else if (this.workflow_type === 'request_amendment') {
                return "officer";
            } else {
                return null;
            }
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('inspectionStore', {
        saveInspection: 'saveInspection',
        loadInspection: 'loadInspection',
        setInspection: 'setInspection'
    }), (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup'
    }), {
        updateAllocatedGroupId: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var allocated_group_id, allocatedGroupResponse;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log("updateAllocatedGroup");
                                allocated_group_id = null;

                                this.errorResponse = "";

                                if (!(this.regionDistrictId && this.groupPermission)) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 6;
                                return this.loadAllocatedGroup({
                                    region_district_id: this.regionDistrictId,
                                    group_permission: this.groupPermission
                                });

                            case 6:
                                allocatedGroupResponse = _context.sent;

                                if (allocatedGroupResponse.ok) {
                                    this.allocated_group_id = allocatedGroupResponse.body.group_id;
                                } else {
                                    this.errorResponse = allocatedGroupResponse.statusText;
                                }
                                _context.next = 10;
                                break;

                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function updateAllocatedGroupId() {
                return _ref.apply(this, arguments);
            }

            return updateAllocatedGroupId;
        }(),
        ok: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var response;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.sendData();

                            case 2:
                                response = _context2.sent;

                                console.log(response);
                                if (response.ok) {
                                    this.close();
                                    this.$router.push({ name: 'internal-inspection-dash' });
                                }

                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function ok() {
                return _ref2.apply(this, arguments);
            }

            return ok;
        }(),
        cancel: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$refs.comms_log_file.cancel();

                            case 2:
                                this.isModalOpen = false;
                                this.close();

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function cancel() {
                return _ref3.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
        },
        sendData: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var post_url, payload, inspectionRes, res;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                post_url = '/api/inspection/' + this.inspection.id + '/workflow_action/';
                                payload = new FormData();

                                payload.append('details', this.workflowDetails);
                                this.$refs.comms_log_file.commsLogId ? payload.append('inspection_comms_log_id', this.$refs.comms_log_file.commsLogId) : null;
                                this.workflow_type ? payload.append('workflow_type', this.workflow_type) : null;
                                this.allocated_group_id ? payload.append('allocated_group_id', this.allocated_group_id) : null;

                                _context4.next = 8;
                                return this.saveInspection({ create: false, internal: true });

                            case 8:
                                inspectionRes = _context4.sent;

                                if (!inspectionRes.ok) {
                                    _context4.next = 22;
                                    break;
                                }

                                _context4.prev = 10;
                                _context4.next = 13;
                                return _vue2.default.http.post(post_url, payload);

                            case 13:
                                res = _context4.sent;

                                console.log(res);

                                if (!res.ok) {
                                    _context4.next = 17;
                                    break;
                                }

                                return _context4.abrupt("return", res);

                            case 17:
                                _context4.next = 22;
                                break;

                            case 19:
                                _context4.prev = 19;
                                _context4.t0 = _context4["catch"](10);

                                this.errorResponse = _context4.t0.statusText;

                            case 22:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[10, 19]]);
            }));

            function sendData() {
                return _ref4.apply(this, arguments);
            }

            return sendData;
        }(),
        createDocumentActionUrl: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(done) {
                var returned_inspection;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (this.inspection.id) {
                                    _context5.next = 6;
                                    break;
                                }

                                _context5.next = 3;
                                return this.saveInspection({ create: true, internal: true });

                            case 3:
                                returned_inspection = _context5.sent;
                                _context5.next = 6;
                                return this.loadInspection({ inspection_id: returned_inspection.body.id });

                            case 6:
                                this.$refs.comms_log_file.document_action_url = this.inspection.createInspectionProcessCommsLogsDocumentUrl;
                                return _context5.abrupt("return", done(true));

                            case 8:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createDocumentActionUrl(_x) {
                return _ref5.apply(this, arguments);
            }

            return createDocumentActionUrl;
        }()

    }),
    mounted: function () {
        var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
            var _this = this;

            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            this.$nextTick(function () {
                                console.log("update group id");
                                _this.updateAllocatedGroupId();
                            });

                        case 1:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function mounted() {
            return _ref6.apply(this, arguments);
        }

        return mounted;
    }(),
    created: function created() {
        if (this.inspection && this.inspection.id) {
            this.region_id = this.inspection.region_id;
            this.district_id = this.inspection.district_id;
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _vuex = __webpack_require__(6);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(15);

__webpack_require__(37);

var _lodash = __webpack_require__(31);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueTreeselect = __webpack_require__(102);

var _vueTreeselect2 = _interopRequireDefault(_vueTreeselect);

__webpack_require__(121);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    name: "ViewBriefOfEvidence",
    data: function data() {
        return {
            uuid: 0
        };
    },
    components: {
        FormSection: _section_toggle2.default,
        TreeSelect: _vueTreeselect2.default,
        filefield: _compliance_file2.default
    },
    props: {
        readonly: {
            type: Boolean,
            default: true
        }
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        },
        briefOfEvidence: function briefOfEvidence() {
            if (this.legal_case && this.legal_case.brief_of_evidence) {
                return this.legal_case.brief_of_evidence;
            } else {
                return {};
            }
        },
        physicalArtifactsUsed: function physicalArtifactsUsed() {
            var options = [];
            if (this.legal_case && this.legal_case.boe_physical_artifacts_used) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.legal_case.boe_physical_artifacts_used), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var option = _step.value;

                        options.push(option);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return options;
        },
        physicalArtifactsUsedVisibility: function physicalArtifactsUsedVisibility() {
            var visible = false;
            if (this.physicalArtifactsUsed && this.physicalArtifactsUsed.length > 0) {
                visible = true;
            }
            return visible;
        },
        physicalArtifactsSensitiveUnused: function physicalArtifactsSensitiveUnused() {
            var options = [];
            if (this.legal_case && this.legal_case.boe_physical_artifacts_sensitive_unused) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)(this.legal_case.boe_physical_artifacts_sensitive_unused), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var option = _step2.value;

                        options.push(option);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            return options;
        },
        physicalArtifactsSensitiveUnusedVisibility: function physicalArtifactsSensitiveUnusedVisibility() {
            var visible = false;
            if (this.physicalArtifactsSensitiveUnused && this.physicalArtifactsSensitiveUnused.length > 0) {
                visible = true;
            }
            return visible;
        },
        physicalArtifactsNonSensitiveUnused: function physicalArtifactsNonSensitiveUnused() {
            var options = [];
            if (this.legal_case && this.legal_case.boe_physical_artifacts_non_sensitive_unused) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(this.legal_case.boe_physical_artifacts_non_sensitive_unused), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var option = _step3.value;

                        options.push(option);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            return options;
        },
        physicalArtifactsNonSensitiveUnusedVisibility: function physicalArtifactsNonSensitiveUnusedVisibility() {
            var visible = false;
            if (this.physicalArtifactsNonSensitiveUnused && this.physicalArtifactsNonSensitiveUnused.length > 0) {
                visible = true;
            }
            return visible;
        },
        documentArtifactsVisibility: function documentArtifactsVisibility() {
            var visible = false;
            if (this.documentArtifacts && this.documentArtifacts.length > 0) {
                visible = true;
            }
            return visible;
        },
        readonlyForm: function readonlyForm() {
            var readonly = true;
            if (this.legal_case && this.legal_case.id && !this.readonly) {
                readonly = !this.legal_case.can_user_action;
            }
            return readonly;
        },
        canUserAction: function canUserAction() {
            var return_val = false;
            if (this.legal_case && this.legal_case.id) {
                return_val = this.legal_case.can_user_action;
            }
            return return_val;
        },
        boeRoiTicked: function boeRoiTicked() {
            var ticked = [];
            if (this.legal_case && this.legal_case.boe_roi_ticked) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = (0, _getIterator3.default)(this.legal_case.boe_roi_ticked), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var id = _step4.value;

                        ticked.push(id);
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            return ticked;
        },
        boeOtherStatementsTicked: function boeOtherStatementsTicked() {
            var ticked = [];
            if (this.legal_case && this.legal_case.boe_other_statements_ticked) {
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = (0, _getIterator3.default)(this.legal_case.boe_other_statements_ticked), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var id = _step5.value;

                        ticked.push(id);
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            }
            return ticked;
        },
        boeOtherStatementsOptions: function boeOtherStatementsOptions() {
            var options = [];
            if (this.legal_case && this.legal_case.boe_other_statements_options) {
                options = this.legal_case.boe_other_statements_options;
            }
            return options;
        },
        boeOtherStatementsExist: function boeOtherStatementsExist() {
            var visibility = false;
            if (this.boeOtherStatementsOptions && this.boeOtherStatementsOptions.length > 0) {
                visibility = true;
            }
            return visibility;
        },
        boeOtherStatementsVisibility: function boeOtherStatementsVisibility() {
            var visibility = false;
            if (!this.readonlyForm && this.boeOtherStatementsExist) {
                visibility = true;
            }
            return visibility;
        },
        boeRoiOptions: function boeRoiOptions() {
            var options = [];
            if (this.legal_case && this.legal_case.boe_roi_options) {
                options = this.legal_case.boe_roi_options;
            }
            return options;
        },
        boeRoiExist: function boeRoiExist() {
            var visibility = false;
            if (this.boeRoiOptions && this.boeRoiOptions.length > 0) {
                visibility = true;
            }
            return visibility;
        },
        boeRoiVisibility: function boeRoiVisibility() {
            var visibility = false;
            if (!this.readonlyForm && this.boeRoiExist) {
                visibility = true;
            }
            return visibility;
        },
        documentArtifacts: function documentArtifacts() {
            var options = [];
            if (this.legal_case && this.legal_case.boe_document_artifacts) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = (0, _getIterator3.default)(this.legal_case.boe_document_artifacts), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var option = _step6.value;

                        options.push(option);
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }
            return options;
        }

    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? (0, _moment2.default)(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('legalCaseStore', {
        loadLegalCase: 'loadLegalCase',
        saveLegalCase: 'saveLegalCase',
        setLegalCase: 'setLegalCase',
        setBoeRoiTicked: 'setBoeRoiTicked',
        setBoeOtherStatementsTicked: 'setBoeOtherStatementsTicked',
        setBoePhysicalArtifactsTicked: 'setBoePhysicalArtifactsTicked',
        setBoeDocumentArtifactsTicked: 'setBoeDocumentArtifactsTicked'
    })),
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        this.$nextTick(function () {
            $('.vue-treeselect__control').css("display", "none");
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _vuex = __webpack_require__(6);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

__webpack_require__(15);

__webpack_require__(37);

var _lodash = __webpack_require__(31);

var _lodash2 = _interopRequireDefault(_lodash);

var _journal_history = __webpack_require__(864);

var _journal_history2 = _interopRequireDefault(_journal_history);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _court_date = __webpack_require__(804);

var _court_date2 = _interopRequireDefault(_court_date);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "ViewCourtProceedings",
    data: function data() {
        return {
            uuid: 0,
            court_outcome_types: [],
            courtProceedingsEntriesUpdated: [],
            courtProceedingsEntriesUrl: [],
            courtProceedingsHistoryEntryBindId: '',
            journalHistoryEntryInstance: '',
            dtHeadersCourtProceedings: ["id", "Number", "Date", "Time", "User", "Description", "deleted", "Action"],
            dtOptionsCourtProceedings: {
                order: [[0, 'desc']],
                columns: [{
                    visible: false,
                    mRender: function mRender(data, type, row) {
                        return row.id;
                    }
                }, {
                    mRender: function mRender(data, type, row) {
                        var retStr = row.number;
                        return retStr;
                    }
                }, {
                    mRender: function mRender(data, type, row) {
                        var retStr = row.date_mod;
                        return retStr;
                    }
                }, {
                    mRender: function mRender(data, type, row) {
                        var retStr = row.time_mod;
                        return retStr;
                    }
                }, {
                    mRender: function mRender(data, type, row) {
                        var retStr = row.user_full_name;
                        return retStr;
                    }
                }, {
                    mRender: function mRender(data, type, row) {
                        var retStr = '';
                        retStr = "<div id=" + row.number + " style=\"min-height:20px\" contenteditable=\"true\">" + row.description + "</div>";
                        if (row.deleted) {
                            retStr = '<strike>' + ("<div id=" + row.number + " style=\"min-height:20px\" contenteditable=\"false\">" + row.description + "</div>");
                            '</strike>';
                        } else if (!row.action) {
                            retStr = "<div id=" + row.number + " style=\"min-height:20px\" contenteditable=\"false\">" + row.description + "</div>";
                        }
                        return retStr;
                    }
                }, {
                    visible: false,
                    mRender: function mRender(data, type, row) {
                        return row.deleted;
                    }
                }, {
                    mRender: function mRender(data, type, row) {
                        var retStr = '';
                        var rowIdDel = row.number.replace('-', 'D');
                        var rowIdHist = row.number.replace('-', 'H');
                        var rowIdReinstate = row.number.replace('-', 'R');
                        if (row.action) {
                            retStr += "<a id=" + rowIdHist + " class=\"row_history\" href=\"#\">History</a><br/><br/>";
                            if (!row.deleted) {
                                retStr += "<a id=" + rowIdDel + " class=\"row_delete\" href=\"#\">Delete</a><br/>";
                            } else {
                                retStr += "<a id=" + rowIdReinstate + " class=\"row_reinstate\" href=\"#\">Reinstate</a><br/>";
                            }
                        }
                        return retStr;
                    }
                }]
            }
        };
    },
    components: {
        datatable: _datatable2.default,
        FormSection: _section_toggle2.default,
        JournalHistory: _journal_history2.default,
        filefield: _compliance_file2.default,
        CourtDate: _court_date2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        readonlyForm: function readonlyForm() {
            var readonly = true;
            if (this.legal_case && this.legal_case.id && !this.closedStatus) {
                readonly = !this.legal_case.can_user_action;
            }
            console.log('=== readonlyForm ===');
            console.log(readonly);
            return readonly;
        },
        closedStatus: function closedStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'closed') {
                returnStatus = true;
            }
            return returnStatus;
        },
        statusId: function statusId() {
            return this.legal_case.status ? this.legal_case.status.id : '';
        }
    }, (0, _vuex.mapGetters)({
        current_user: 'current_user'
    }), {

        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        },
        canUserAction: function canUserAction() {
            var return_val = false;
            if (this.legal_case && this.legal_case.id) {
                return_val = this.legal_case.can_user_action;
            }
            return return_val;
        },
        hasCourtProceedings: function hasCourtProceedings() {
            return this.legal_case.court_proceedings ? true : false;
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? (0, _moment2.default)(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('legalCaseStore', {
        setCourtProceedingsJournalEntry: 'setCourtProceedingsJournalEntry',
        setAddCourtProceedingsEntry: 'setAddCourtProceedingsEntry',
        setCourtProceedingsTransform: 'setCourtProceedingsTransform',
        setCourtProceedingsDate: 'setCourtProceedingsDate'
    }), {
        dataChanged: function dataChanged(court_data_obj) {
            console.log('*** in dataChanged() ***');
            console.log(court_data_obj);
            try {
                if (court_data_obj.court_datetime.isValid()) {
                    court_data_obj.court_datetime = court_data_obj.court_datetime.toDate().toISOString();
                } else {
                    court_data_obj.court_datetime = null;
                }
                this.setCourtProceedingsDate(court_data_obj);
            } catch (err) {}
        },
        courtOutcomeDocumentUploaded: function courtOutcomeDocumentUploaded() {
            console.log('courtOutcomeDocumentUploaded');
        },
        setCourtProceedingsHistoryEntryBindId: function setCourtProceedingsHistoryEntryBindId() {
            console.log('Inside setCourtProceedingsHistoryEntryBindId');
            if (this.journalHistoryEntryInstance) {
                this.uuid += 1;
                this.courtProceedingsHistoryEntryBindId = this.journalHistoryEntryInstance + '_' + this.uuid;
            }
        },
        generateDocument: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(doc_type) {
                var payload, post_url, res, buffer, file, fileURL, elementId, generatedDocument;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                payload = {};

                                payload.document_type = doc_type;
                                payload.court_date_id = '';
                                if (this.legal_case.court_proceedings.court_dates.length > 0) {
                                    payload.court_date_id = this.legal_case.court_proceedings.court_dates[0].id;
                                }

                                post_url = '/api/legal_case/' + this.legal_case.id + '/generate_document/';
                                _context.next = 8;
                                return fetch(post_url, {
                                    method: 'POST',
                                    body: (0, _stringify2.default)(payload),
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-CSRFToken': this.csrf_token
                                    }
                                });

                            case 8:
                                res = _context.sent;

                                console.log('generateDocument()');
                                _context.next = 12;
                                return res.arrayBuffer();

                            case 12:
                                buffer = _context.sent;
                                file = new Blob([buffer], { type: 'application/pdf' });
                                fileURL = window.URL.createObjectURL(file);
                                elementId = 'generated-document-' + this.legal_case.id;
                                generatedDocument = document.createElement('a');

                                generatedDocument.style.display = 'none';
                                generatedDocument.href = fileURL;
                                generatedDocument.download = payload.document_type + '_' + this.legal_case.number + '.pdf';
                                document.body.appendChild(generatedDocument);
                                generatedDocument.click();
                                window.URL.revokeObjectURL(fileURL);
                                return _context.abrupt("return", true);

                            case 26:
                                _context.prev = 26;
                                _context.t0 = _context["catch"](0);

                                this.errorResponse = _context.t0.statusText;

                            case 29:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 26]]);
            }));

            function generateDocument(_x) {
                return _ref.apply(this, arguments);
            }

            return generateDocument;
        }(),
        addEventListeners: function addEventListeners() {
            var _this = this;

            var vm = this;

            var prosecutionNoticeIcon = $('#prosecution-notice-icon');
            var courtHearingNoticeIcon = $('#court-hearing-notice-icon');
            var courtProceedingsTable = $('#court-proceedings-table');

            prosecutionNoticeIcon.on('click', function (e) {
                console.log(e);
                _this.generateDocument('prosecution_notice');
            });
            courtHearingNoticeIcon.on('click', function (e) {
                console.log(e);
                _this.generateDocument('court_hearing_notice');
            });

            courtProceedingsTable.on('keyup', function (e) {
                _this.courtProceedingsKeyup(e);
            });
            courtProceedingsTable.on('click', '.row_delete', function (e) {
                _this.courtProceedingsRowDelete(e);
            });
            courtProceedingsTable.on('click', '.row_history', function (e) {
                _this.courtProceedingsRowHistory(e);
            });
            courtProceedingsTable.on('click', '.row_reinstate', function (e) {
                _this.courtProceedingsRowReinstate(e);
            });
            courtProceedingsTable.on('paste', function (e) {
                console.log("plain text only");

                e.preventDefault();

                var text = (e.originalEvent || e).clipboardData.getData('text/plain');
                var transformedText = text.replace(/\n/g, '<br/>');

                document.execCommand("insertHTML", false, transformedText);
            });
            this.preventDecimalPlaces();
        },
        preventDecimalPlaces: function preventDecimalPlaces() {
            $(".currency").change(function () {
                $(this).val(parseFloat($(this).val()).toFixed(2));
            });
        },
        courtProceedingsRowDelete: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(e) {
                var rowNumber, journal_entry_id, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _r, returnedEntry, i, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, r;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.showSpinner = true;
                                rowNumber = e.target.id.replace('D', '-');
                                journal_entry_id = null;
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context2.prev = 6;

                                for (_iterator = (0, _getIterator3.default)(this.legal_case.court_proceedings.journal_entries); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    _r = _step.value;

                                    if (_r.number === rowNumber) {
                                        journal_entry_id = _r.id;
                                    }
                                }
                                _context2.next = 14;
                                break;

                            case 10:
                                _context2.prev = 10;
                                _context2.t0 = _context2["catch"](6);
                                _didIteratorError = true;
                                _iteratorError = _context2.t0;

                            case 14:
                                _context2.prev = 14;
                                _context2.prev = 15;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 17:
                                _context2.prev = 17;

                                if (!_didIteratorError) {
                                    _context2.next = 20;
                                    break;
                                }

                                throw _iteratorError;

                            case 20:
                                return _context2.finish(17);

                            case 21:
                                return _context2.finish(14);

                            case 22:
                                _context2.next = 24;
                                return _vue2.default.http.post(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, this.legal_case.id + '/delete_reinstate_journal_entry/'), {
                                    "journal_entry_id": journal_entry_id,
                                    "deleted": true
                                });

                            case 24:
                                returnedEntry = _context2.sent;

                                if (!returnedEntry.ok) {
                                    _context2.next = 49;
                                    break;
                                }

                                _context2.next = 28;
                                return this.setCourtProceedingsJournalEntry(returnedEntry.body);

                            case 28:
                                i = 0;
                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context2.prev = 32;

                                for (_iterator2 = (0, _getIterator3.default)(this.courtProceedingsEntriesUrl); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    r = _step2.value;

                                    if (r.number === rowNumber) {
                                        this.courtProceedingsEntriesUrl[i] = returnedEntry.body;
                                    }
                                    i++;
                                }
                                _context2.next = 40;
                                break;

                            case 36:
                                _context2.prev = 36;
                                _context2.t1 = _context2["catch"](32);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context2.t1;

                            case 40:
                                _context2.prev = 40;
                                _context2.prev = 41;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 43:
                                _context2.prev = 43;

                                if (!_didIteratorError2) {
                                    _context2.next = 46;
                                    break;
                                }

                                throw _iteratorError2;

                            case 46:
                                return _context2.finish(43);

                            case 47:
                                return _context2.finish(40);

                            case 48:
                                this.constructCourtProceedingsTableEntry(rowNumber);

                            case 49:
                                this.showSpinner = false;

                            case 50:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[6, 10, 14, 22], [15,, 17, 21], [32, 36, 40, 48], [41,, 43, 47]]);
            }));

            function courtProceedingsRowDelete(_x2) {
                return _ref2.apply(this, arguments);
            }

            return courtProceedingsRowDelete;
        }(),
        courtProceedingsRowHistory: function courtProceedingsRowHistory(e) {
            var _this2 = this;

            console.log(e);
            var rowNumber = e.target.id.replace('H', '-');
            console.log(rowNumber);
            console.log("journalEntryRowHistory");
            this.journalHistoryEntryInstance = rowNumber;
            this.setCourtProceedingsHistoryEntryBindId();
            this.$nextTick(function () {
                _this2.$refs.journal_history.isModalOpen = true;
            });
        },
        courtProceedingsRowReinstate: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(e) {
                var rowNumber, journal_entry_id, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _r2, returnedEntry, i, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, r;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.showSpinner = true;
                                rowNumber = e.target.id.replace('R', '-');
                                journal_entry_id = null;
                                _iteratorNormalCompletion3 = true;
                                _didIteratorError3 = false;
                                _iteratorError3 = undefined;
                                _context3.prev = 6;

                                for (_iterator3 = (0, _getIterator3.default)(this.legal_case.court_proceedings.journal_entries); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    _r2 = _step3.value;

                                    if (_r2.number === rowNumber) {
                                        journal_entry_id = _r2.id;
                                    }
                                }
                                _context3.next = 14;
                                break;

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3["catch"](6);
                                _didIteratorError3 = true;
                                _iteratorError3 = _context3.t0;

                            case 14:
                                _context3.prev = 14;
                                _context3.prev = 15;

                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }

                            case 17:
                                _context3.prev = 17;

                                if (!_didIteratorError3) {
                                    _context3.next = 20;
                                    break;
                                }

                                throw _iteratorError3;

                            case 20:
                                return _context3.finish(17);

                            case 21:
                                return _context3.finish(14);

                            case 22:
                                _context3.next = 24;
                                return _vue2.default.http.post(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, this.legal_case.id + '/delete_reinstate_journal_entry/'), {
                                    "journal_entry_id": journal_entry_id,
                                    "deleted": false
                                });

                            case 24:
                                returnedEntry = _context3.sent;

                                if (!returnedEntry.ok) {
                                    _context3.next = 49;
                                    break;
                                }

                                _context3.next = 28;
                                return this.setCourtProceedingsJournalEntry(returnedEntry.body);

                            case 28:
                                i = 0;
                                _iteratorNormalCompletion4 = true;
                                _didIteratorError4 = false;
                                _iteratorError4 = undefined;
                                _context3.prev = 32;

                                for (_iterator4 = (0, _getIterator3.default)(this.courtProceedingsEntriesUrl); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                    r = _step4.value;

                                    if (r.number === rowNumber) {
                                        console.log('update: ' + rowNumber);

                                        this.courtProceedingsEntriesUrl[i] = returnedEntry.body;
                                    }
                                    i++;
                                }
                                _context3.next = 40;
                                break;

                            case 36:
                                _context3.prev = 36;
                                _context3.t1 = _context3["catch"](32);
                                _didIteratorError4 = true;
                                _iteratorError4 = _context3.t1;

                            case 40:
                                _context3.prev = 40;
                                _context3.prev = 41;

                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }

                            case 43:
                                _context3.prev = 43;

                                if (!_didIteratorError4) {
                                    _context3.next = 46;
                                    break;
                                }

                                throw _iteratorError4;

                            case 46:
                                return _context3.finish(43);

                            case 47:
                                return _context3.finish(40);

                            case 48:
                                this.constructCourtProceedingsTableEntry(rowNumber);

                            case 49:
                                this.showSpinner = false;

                            case 50:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[6, 10, 14, 22], [15,, 17, 21], [32, 36, 40, 48], [41,, 43, 47]]);
            }));

            function courtProceedingsRowReinstate(_x3) {
                return _ref3.apply(this, arguments);
            }

            return courtProceedingsRowReinstate;
        }(),
        courtProceedingsKeyup: function courtProceedingsKeyup(e) {
            console.log('courtProceedingsKeyup');
            var rowObj = {};
            var recordNumber = e.target.id;
            var recordDescriptionText = e.target.textContent;
            var recordDescriptionHtml = e.target.innerHTML.replace(/\&nbsp\;/g, ' ');
            console.log('recordNumber: ' + recordNumber);
            console.log(recordDescriptionHtml);

            if (!this.courtProceedingsEntriesUpdated.includes(recordNumber)) {
                this.courtProceedingsEntriesUpdated.push(recordNumber);
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = (0, _getIterator3.default)(this.courtProceedingsEntriesUrl), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var r = _step5.value;

                    if (r.number === recordNumber) {
                        this.updateCourtProceedingsUrlEntry({
                            "recordNumber": recordNumber,
                            "recordDescription": recordDescriptionHtml,
                            "redraw": false
                        });
                        console.log('r');
                        console.log(r);
                        this.setCourtProceedingsTransform(r);
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        },
        updateCourtProceedingsUrlEntry: function updateCourtProceedingsUrlEntry(_ref4) {
            var recordNumber = _ref4.recordNumber,
                recordDescription = _ref4.recordDescription,
                redraw = _ref4.redraw;

            console.log("updateCourtProceedingsUrl");

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = (0, _getIterator3.default)(this.courtProceedingsEntriesUrl), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var r = _step6.value;

                    if (r.number === recordNumber) {
                        r.description = recordDescription;
                        if (redraw) {
                            this.constructCourtProceedingsTableEntry(recordNumber);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }
        },
        createNewCourtProceedingsEntry: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var payload, fetchUrl, updatedCourtProceedings, returnPayload;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                console.log('aho');
                                payload = {
                                    "court_proceedings_id": this.legal_case.court_proceedings.id,
                                    "user_id": this.current_user.id
                                };
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, this.legal_case.id + '/create_journal_entry/');
                                _context4.next = 5;
                                return _vue2.default.http.post(fetchUrl, payload);

                            case 5:
                                updatedCourtProceedings = _context4.sent;

                                console.log(updatedCourtProceedings);

                                if (!updatedCourtProceedings.ok) {
                                    _context4.next = 13;
                                    break;
                                }

                                _context4.next = 10;
                                return this.setAddCourtProceedingsEntry(updatedCourtProceedings.body);

                            case 10:
                                returnPayload = _lodash2.default.cloneDeep(updatedCourtProceedings.body);

                                this.courtProceedingsEntriesUrl.push(returnPayload);
                                this.constructCourtProceedingsTable(returnPayload.id);

                            case 13:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function createNewCourtProceedingsEntry() {
                return _ref5.apply(this, arguments);
            }

            return createNewCourtProceedingsEntry;
        }(),
        constructCourtProceedingsTableEntry: function constructCourtProceedingsTableEntry(rowNumber) {
            var _this3 = this;

            console.log('rowNumber');
            console.log(rowNumber);

            var actionColumn = !this.readonlyForm;
            if (this.$refs.court_proceedings_table && this.$refs.court_proceedings_table.vmDataTable) {
                console.log("constructCourtProceedingsTableEntry");
                this.$refs.court_proceedings_table.vmDataTable.rows().every(function (rowIdx, tableLoop, rowLoop) {
                    var rowData = _this3.$refs.court_proceedings_table.vmDataTable.row(rowIdx).data();

                    if (rowData.number === rowNumber) {
                        var i = 0;
                        var _iteratorNormalCompletion7 = true;
                        var _didIteratorError7 = false;
                        var _iteratorError7 = undefined;

                        try {
                            for (var _iterator7 = (0, _getIterator3.default)(_this3.courtProceedingsEntriesUrl), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                var r = _step7.value;

                                if (r.number === rowNumber) {
                                    rowData.date_mod = _this3.courtProceedingsEntriesUrl[rowIdx].date_mod;
                                    rowData.time_mod = _this3.courtProceedingsEntriesUrl[rowIdx].time_mod;
                                    rowData.user_full_name = _this3.courtProceedingsEntriesUrl[rowIdx].user_full_name;
                                    rowData.description = _this3.courtProceedingsEntriesUrl[rowIdx].description;
                                    rowData.deleted = _this3.courtProceedingsEntriesUrl[rowIdx].deleted;
                                    rowData.action = actionColumn;
                                    _this3.$refs.court_proceedings_table.vmDataTable.row(rowIdx).invalidate().draw();
                                }
                                i += 1;
                            }
                        } catch (err) {
                            _didIteratorError7 = true;
                            _iteratorError7 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                    _iterator7.return();
                                }
                            } finally {
                                if (_didIteratorError7) {
                                    throw _iteratorError7;
                                }
                            }
                        }
                    }
                });
            }
        },
        constructCourtProceedingsTableWrapper: function constructCourtProceedingsTableWrapper() {
            var _this4 = this;

            this.courtProceedingsEntriesUrl = _lodash2.default.cloneDeep(this.legal_case.court_proceedings.journal_entries);

            this.$nextTick(function () {
                _this4.constructCourtProceedingsTable();
            });
        },
        constructCourtProceedingsTable: function constructCourtProceedingsTable(pk) {
            console.log("constructCourtProceedingsTable");

            if (this.hasCourtProceedings) {
                if (!pk) {
                    this.$refs.court_proceedings_table.vmDataTable.clear().draw();
                }

                var actionColumn = !this.readonlyForm;

                for (var i = 0; i < this.courtProceedingsEntriesUrl.length; i++) {
                    if (!pk || this.courtProceedingsEntriesUrl[i].id === pk) {
                        this.$refs.court_proceedings_table.vmDataTable.row.add({
                            "id": this.courtProceedingsEntriesUrl[i].id,
                            "number": this.courtProceedingsEntriesUrl[i].number,
                            "date_mod": this.courtProceedingsEntriesUrl[i].date_mod,
                            "time_mod": this.courtProceedingsEntriesUrl[i].time_mod,
                            "user_full_name": this.courtProceedingsEntriesUrl[i].user_full_name,
                            "description": this.courtProceedingsEntriesUrl[i].description,
                            "deleted": this.courtProceedingsEntriesUrl[i].deleted,
                            "action": actionColumn
                        }).draw();
                    }
                }
            }
            console.log("constructCourtProceedingsTable - end");
        },
        constructOptionsCourtOutcomeType: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                var returned;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _hooks.cache_helper.getSetCacheList('CourtProceedings_CourtOutcomeTypes', '/api/legal_case/court_outcome_type_list');

                            case 2:
                                returned = _context5.sent;

                                this.court_outcome_types = returned;

                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function constructOptionsCourtOutcomeType() {
                return _ref6.apply(this, arguments);
            }

            return constructOptionsCourtOutcomeType;
        }()
    }),
    created: function () {
        var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            this.constructOptionsCourtOutcomeType();

                        case 1:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function created() {
            return _ref7.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        var _this5 = this;

        this.$nextTick(function () {
            _this5.addEventListeners();
            $('.vue-treeselect__control').css("display", "none");
            _this5.constructCourtProceedingsTableWrapper();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _validators = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "CreateInspection",
    data: function data() {
        return {
            officers: [],
            isModalOpen: false,
            processingDetails: false,
            form: null,
            regions: [],

            availableDistricts: [],
            legalCasePriorities: [],
            externalOrganisations: [],
            legalCaseDetails: '',
            legalCaseTitle: '',
            errorResponse: "",
            region_id: null,
            district_id: null,
            assigned_to_id: null,
            advice_details: "",
            allocatedGroup: [],
            allocated_group_id: null,
            documentActionUrl: '',
            temporary_document_collection_id: null,
            legal_case_priority_id: null
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        filefield: _compliance_file2.default
    },
    validations: {
        region_id: {
            required: _validators.required
        },
        assigned_to_id: {
            required: _validators.required
        },
        legal_case_priority_id: {
            required: _validators.required
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), (0, _vuex.mapGetters)('callemailStore', {
        call_email: "call_email"
    }), {
        parent_call_email: function parent_call_email() {
            if (this.call_email && this.call_email.id) {
                return true;
            }
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('legalCaseStore', {
        saveInspection: 'saveLegalCase',
        loadInspection: 'loadLegalCase',
        setInspection: 'setLegalCase'
    }), (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup'
    }), (0, _vuex.mapActions)('callemailStore', {
        loadCallEmail: 'loadCallEmail'
    }), {
        setTemporaryDocumentCollectionId: function setTemporaryDocumentCollectionId(val) {
            this.temporary_document_collection_id = val;
        },
        updateDistricts: function updateDistricts() {
            this.district_id = null;
            this.availableDistricts = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.regions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var region = _step.value;

                    if (this.region_id === region.id) {
                        this.availableDistricts = region.districts;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.availableDistricts.splice(0, 0, {
                id: "",
                display_name: "",
                district: "",
                districts: [],
                region: null
            });

            this.updateAllocatedGroup();
        },
        updateAllocatedGroup: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var allocatedGroupResponse;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.errorResponse = "";

                                if (!this.region_id) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 4;
                                return this.loadAllocatedGroup({
                                    workflow_type: 'allocate_for_case',
                                    region_id: this.region_id,
                                    district_id: this.district_id ? this.district_id : null
                                });

                            case 4:
                                allocatedGroupResponse = _context.sent;

                                if (allocatedGroupResponse.ok) {
                                    _vue2.default.set(this, 'allocatedGroup', allocatedGroupResponse.body);
                                    this.allocated_group_id = allocatedGroupResponse.body.group_id;
                                } else {
                                    this.errorResponse = allocatedGroupResponse.statusText;
                                }

                                if (!this.errorResponse && this.allocatedGroup && this.allocatedGroup.length <= 1) {
                                    this.errorResponse = 'This group has no members';
                                }
                                _context.next = 10;
                                break;

                            case 9:
                                this.allocatedGroup = [];

                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function updateAllocatedGroup() {
                return _ref.apply(this, arguments);
            }

            return updateAllocatedGroup;
        }(),

        ok: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var is_valid_form, response;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                is_valid_form = this.isValidForm();

                                if (!is_valid_form) {
                                    _context2.next = 12;
                                    break;
                                }

                                _context2.next = 4;
                                return this.sendData();

                            case 4:
                                response = _context2.sent;

                                if (!response.ok) {
                                    _context2.next = 12;
                                    break;
                                }

                                if (this.$parent.$refs.legal_case_table) {
                                    this.$parent.$refs.legal_case_table.vmDataTable.ajax.reload();
                                }

                                if (!this.parent_call_email) {
                                    _context2.next = 10;
                                    break;
                                }

                                _context2.next = 10;
                                return this.loadCallEmail({
                                    call_email_id: this.call_email.id
                                });

                            case 10:
                                if (this.$parent.$refs.related_items_table) {
                                    this.$parent.constructRelatedItemsTable();
                                }
                                this.close();

                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function ok() {
                return _ref2.apply(this, arguments);
            }

            return ok;
        }(),
        isValidForm: function isValidForm() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.errorResponse = 'Invalid form:\n';
                if (this.$v.region_id.$invalid) {
                    this.errorResponse += 'Region is required\n';
                }
                if (this.$v.assigned_to_id.$invalid) {
                    this.errorResponse += 'Officer must be assigned\n';
                }
                if (this.$v.legal_case_priority_id.$invalid) {
                    this.errorResponse += 'Choose Case Priority\n';
                }
                return false;
            } else {
                return true;
            }
        },
        cancel: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$refs.comms_log_file.cancel();

                            case 2:
                                this.isModalOpen = false;
                                this.close();

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function cancel() {
                return _ref3.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            this.isModalOpen = false;
        },
        sendData: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var post_url, payload, res;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                post_url = '/api/legal_case/';
                                payload = new FormData();

                                payload.append('details', this.legalCaseDetails);
                                payload.append('title', this.legalCaseTitle);
                                this.$refs.comms_log_file.commsLogId ? payload.append('legal_case_comms_log_id', this.$refs.comms_log_file.commsLogId) : null;
                                this.parent_call_email ? payload.append('call_email_id', this.call_email.id) : null;
                                this.district_id ? payload.append('district_id', this.district_id) : null;
                                this.assigned_to_id ? payload.append('assigned_to_id', this.assigned_to_id) : null;
                                this.inspection_type_id ? payload.append('legal_case_priority_id', this.legal_case_priority_id) : null;
                                this.region_id ? payload.append('region_id', this.region_id) : null;
                                this.allocated_group_id ? payload.append('allocated_group_id', this.allocated_group_id) : null;
                                this.temporary_document_collection_id ? payload.append('temporary_document_collection_id', this.temporary_document_collection_id.temp_doc_id) : null;

                                _context4.prev = 12;
                                _context4.next = 15;
                                return _vue2.default.http.post(post_url, payload);

                            case 15:
                                res = _context4.sent;

                                console.log(res);

                                if (!res.ok) {
                                    _context4.next = 19;
                                    break;
                                }

                                return _context4.abrupt("return", res);

                            case 19:
                                _context4.next = 25;
                                break;

                            case 21:
                                _context4.prev = 21;
                                _context4.t0 = _context4["catch"](12);

                                console.log(_context4.t0);
                                this.errorResponse = 'Error:' + _context4.t0.bodyText;

                            case 25:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[12, 21]]);
            }));

            function sendData() {
                return _ref4.apply(this, arguments);
            }

            return sendData;
        }()
    }),
    created: function () {
        var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
            var _this = this;

            var returned_regions, returned_legal_case_priorities, region, district;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return _hooks.cache_helper.getSetCacheList('Regions', '/api/regions/');

                        case 2:
                            returned_regions = _context5.sent;

                            (0, _assign2.default)(this.regions, returned_regions);

                            this.regions.splice(0, 0, {
                                id: "",
                                display_name: "",
                                district: "",
                                districts: [],
                                region: null
                            });
                            _context5.next = 7;
                            return _hooks.cache_helper.getSetCacheList('LegalCasePriorities', _hooks.api_endpoints.legal_case_priorities);

                        case 7:
                            returned_legal_case_priorities = _context5.sent;

                            (0, _assign2.default)(this.legalCasePriorities, returned_legal_case_priorities);

                            this.legalCasePriorities.splice(0, 0, {
                                id: "",
                                description: ""
                            });

                            if (this.parent_call_email) {
                                if (this.call_email && this.call_email.region_gis) {
                                    region = this.regions.find(function (obj) {
                                        return obj.name === _this.call_email.region_gis;
                                    });

                                    if (region) {
                                        this.region_id = region.id;
                                        if (this.call_email.district_gis) {
                                            district = region.districts.find(function (obj) {
                                                return obj.district_name === _this.call_email.district_gis;
                                            });

                                            if (district) {
                                                this.district_id = district.district_id;
                                            }
                                        }
                                    }
                                }
                            }

                            this.updateDistricts();
                            _context5.next = 14;
                            return this.updateAllocatedGroup();

                        case 14:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function created() {
            return _ref5.apply(this, arguments);
        }

        return created;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "GenerateDocument",
    data: function data() {
        return {
            isModalOpen: false,
            form: null,
            errorResponse: "",
            selectAll: false,
            includeStatementOfFacts: false,
            includeCaseInformationForm: false,
            includeOffencesOffendersRoi: false,
            includeWitnessOfficerOtherStatements: false,
            includePhysicalArtifacts: false,
            includeDocumentArtifacts: false,
            payload: {}
        };
    },
    components: {
        modal: _bootstrapModal2.default
    },
    props: {
        document_type: {
            type: String,
            default: ''
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        },
        modalTitle: function modalTitle() {
            var title = '';
            if (this.document_type === 'brief_of_evidence') {
                title = "Print Brief of Evidence";
            } else if (this.document_type === 'prosecution_brief') {
                title = "Print Prosecution Brief";
            }
            return title;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('legalCaseStore', {
        saveLegalCase: 'saveLegalCase',
        loadLegalCase: 'loadLegalCase',
        setLegalCase: 'setLegalCase'
    }), {
        setSelectAll: function setSelectAll() {
            if (this.selectAll) {
                this.includeStatementOfFacts = true;
                this.includeCaseInformationForm = true;
                this.includeOffencesOffendersRoi = true;
                this.includeWitnessOfficerOtherStatements = true;
                this.includePhysicalArtifacts = true;
                this.includeDocumentArtifacts = true;
            } else {
                this.includeStatementOfFacts = false;
                this.includeCaseInformationForm = false;
                this.includeOffencesOffendersRoi = false;
                this.includeWitnessOfficerOtherStatements = false;
                this.includePhysicalArtifacts = false;
                this.includeDocumentArtifacts = false;
            }
        },
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.sendData();

                            case 2:
                                res = _context.sent;

                                if (res) {
                                    this.close();
                                }

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        cancel: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.$refs.comms_log_file) {
                                    _context2.next = 3;
                                    break;
                                }

                                _context2.next = 3;
                                return this.$refs.comms_log_file.cancel();

                            case 3:
                                this.isModalOpen = false;
                                this.close();

                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function cancel() {
                return _ref2.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
        },
        sendData: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var post_url, res, buffer, file, fileURL, elementId, generatedDocument;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;

                                this.payload.document_type = this.document_type;
                                this.payload.legal_case_id = this.legal_case.id;
                                if (this.includeStatementOfFacts) {
                                    this.payload.include_statement_of_facts = this.includeStatementOfFacts;
                                }
                                if (this.includeCaseInformationForm) {
                                    this.payload.include_case_information_form = this.includeCaseInformationForm;
                                }
                                if (this.includeOffencesOffendersRoi) {
                                    this.payload.include_offences_offenders_roi = this.includeOffencesOffendersRoi;
                                }
                                if (this.includeWitnessOfficerOtherStatements) {
                                    this.payload.include_witness_officer_other_statements = this.includeWitnessOfficerOtherStatements;
                                }
                                if (this.includePhysicalArtifacts) {
                                    this.payload.include_physical_artifacts = this.includePhysicalArtifacts;
                                }
                                if (this.includeDocumentArtifacts) {
                                    this.payload.include_document_artifacts = this.includeDocumentArtifacts;
                                }
                                post_url = '/api/legal_case/' + this.legal_case.id + '/generate_document/';
                                _context3.next = 12;
                                return fetch(post_url, {
                                    method: 'POST',
                                    body: (0, _stringify2.default)(this.payload),
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-CSRFToken': this.csrf_token
                                    }
                                });

                            case 12:
                                res = _context3.sent;
                                _context3.next = 15;
                                return res.arrayBuffer();

                            case 15:
                                buffer = _context3.sent;
                                file = new Blob([buffer], { type: 'application/pdf' });
                                fileURL = window.URL.createObjectURL(file);
                                elementId = 'generated-document-' + this.legal_case.id;
                                generatedDocument = document.createElement('a');

                                generatedDocument.style.display = 'none';
                                generatedDocument.href = fileURL;
                                generatedDocument.download = this.document_type + '_' + this.legal_case.number + '.pdf';
                                document.body.appendChild(generatedDocument);
                                generatedDocument.click();
                                window.URL.revokeObjectURL(fileURL);
                                return _context3.abrupt("return", true);

                            case 29:
                                _context3.prev = 29;
                                _context3.t0 = _context3["catch"](0);

                                this.errorResponse = _context3.t0.statusText;

                            case 32:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 29]]);
            }));

            function sendData() {
                return _ref3.apply(this, arguments);
            }

            return sendData;
        }()

    }),
    mounted: function () {
        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            this.$nextTick(function () {});

                        case 1:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function mounted() {
            return _ref4.apply(this, arguments);
        }

        return mounted;
    }(),
    created: function created() {}
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(85);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _validators = __webpack_require__(84);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "CourtProceedingsJournalEntryHistory",
    data: function data() {
        return {
            isModalOpen: false,
            processingDetails: false,
            errorResponse: "",
            journalHist: [],
            dtHeadersRunningSheetHistory: ["date_modified", "Date", "Time", "User", "Description", "deleted"],
            dtOptionsRunningSheetHistory: {
                order: [[1, 'desc']],

                columns: [{
                    visible: false,
                    mRender: function mRender(data, type, row) {
                        return row.date_modified;
                    }
                }, {
                    mRender: function mRender(data, type, row) {
                        var retStr = row.date_mod;
                        return retStr;
                    }
                }, {
                    mRender: function mRender(data, type, row) {
                        var retStr = row.time_mod;
                        return retStr;
                    }
                }, {
                    mRender: function mRender(data, type, row) {
                        var retStr = row.user_full_name;
                        return retStr;
                    }
                }, {
                    mRender: function mRender(data, type, row) {
                        var retStr = '';
                        retStr = "<div id=" + row.number + " style=\"min-height:20px\" contenteditable=\"false\">" + row.description + "</div>";
                        if (row.deleted) {
                            retStr = '<strike>' + retStr + '</strike>';
                        }
                        return retStr;
                    }
                }, {
                    visible: false,
                    mRender: function mRender(data, type, row) {
                        return row.deleted;
                    }
                }]
            }
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        datatable: _datatable2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        modalTitle: function modalTitle() {
            return "Running Sheet History - " + this.journalHistoryEntryInstance;
        }
    }),
    props: {
        journalHistoryEntryInstance: {
            required: true
        }
    },
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: {
        tokenToUrl: function tokenToUrl(description) {
            console.log("tokenToUrl");
            var parsedText = description;
            var personTokenRegex = /\{\{ \"person\_id\"\: \"\d+\"\, \"full\_name\"\: \"\w+(\s\w+)*\" \}\}/g;
            var personIdRegex = /\{\{ \"person\_id\"\: \"\d+/g;
            var personNameRegex = /\"full\_name\"\: \"\w+ \w+/g;
            var personTokenArray = [].concat((0, _toConsumableArray3.default)(description.matchAll(personTokenRegex)));
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(personTokenArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var personToken = _step.value;

                    console.log(personToken);
                    var idArray = [].concat((0, _toConsumableArray3.default)(personToken[0].matchAll(personIdRegex)));
                    console.log(idArray);
                    var idStr = idArray[0][0];
                    var id = idStr.substring(17);
                    console.log(id);
                    var nameArray = [].concat((0, _toConsumableArray3.default)(personToken[0].matchAll(personNameRegex)));
                    console.log(nameArray);
                    var nameStr = nameArray[0][0];
                    var fullName = nameStr.substring(14);
                    console.log(id);
                    parsedText = parsedText.replace(personToken[0], "<a contenteditable=\"false\" target=\"_blank\" href=\"/internal/users/" + id + "\">" + fullName + "</a>");
                    console.log(parsedText);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return parsedText;
        },
        constructRunningSheetTable: function constructRunningSheetTable() {
            console.log("constructInstanceRunningSheetTable");
            this.$refs.running_sheet_hist_instance.vmDataTable.clear().draw();
            var actionColumn = !this.readonlyForm;
            if (this.journalHist) {
                for (var i = 0; i < this.journalHist.length; i++) {
                    this.$refs.running_sheet_hist_instance.vmDataTable.row.add({
                        "id": this.journalHist[i].id,
                        "number": this.journalHist[i].number,
                        "date_modified": this.journalHist[i].date_modified,
                        "date_mod": this.journalHist[i].date_mod,
                        "time_mod": this.journalHist[i].time_mod,
                        "user_full_name": this.journalHist[i].user_full_name,
                        "description": this.journalHist[i].description,
                        "deleted": this.journalHist[i].deleted,
                        "action": actionColumn
                    }).draw();
                }
            }
            console.log("constructRunningSheetTable - end");
        },
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.close();

                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        cancel: function cancel() {
            this.isModalOpen = false;
            this.close();
        },
        close: function close() {
            this.isModalOpen = false;
        }
    },
    created: function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var _this = this;

            var fetchUrl, payload, returnedJournalHist, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, v, entryVersion;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, this.legal_case.id + "/journal_entry_history/");
                            payload = { "journal_entry_number": this.journalHistoryEntryInstance };
                            _context2.next = 4;
                            return _vue2.default.http.post(fetchUrl, payload);

                        case 4:
                            returnedJournalHist = _context2.sent;

                            if (!(returnedJournalHist && returnedJournalHist.body)) {
                                _context2.next = 25;
                                break;
                            }

                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context2.prev = 9;

                            for (_iterator2 = (0, _getIterator3.default)(returnedJournalHist.body.versions); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                v = _step2.value;
                                entryVersion = _.cloneDeep(v.entry_fields);

                                this.journalHist.push(entryVersion);
                            }
                            _context2.next = 17;
                            break;

                        case 13:
                            _context2.prev = 13;
                            _context2.t0 = _context2["catch"](9);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context2.t0;

                        case 17:
                            _context2.prev = 17;
                            _context2.prev = 18;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 20:
                            _context2.prev = 20;

                            if (!_didIteratorError2) {
                                _context2.next = 23;
                                break;
                            }

                            throw _iteratorError2;

                        case 23:
                            return _context2.finish(20);

                        case 24:
                            return _context2.finish(17);

                        case 25:
                            this.$nextTick(function () {
                                _this.constructRunningSheetTable();
                            });

                        case 26:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[9, 13, 17, 25], [18,, 20, 24]]);
        }));

        function created() {
            return _ref2.apply(this, arguments);
        }

        return created;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(31)))

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _getOwnPropertyNames = __webpack_require__(70);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _toConsumableArray2 = __webpack_require__(85);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _assignment = __webpack_require__(97);

var _assignment2 = _interopRequireDefault(_assignment);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _vuex = __webpack_require__(6);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(15);

__webpack_require__(37);

var _offence_modal = __webpack_require__(98);

var _offence_modal2 = _interopRequireDefault(_offence_modal);

var _sanction_outcome_modal = __webpack_require__(99);

var _sanction_outcome_modal2 = _interopRequireDefault(_sanction_outcome_modal);

var _create_inspection_modal = __webpack_require__(83);

var _create_inspection_modal2 = _interopRequireDefault(_create_inspection_modal);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _related_items = __webpack_require__(58);

var _related_items2 = _interopRequireDefault(_related_items);

var _objectHash = __webpack_require__(55);

var _objectHash2 = _interopRequireDefault(_objectHash);

var _magic = __webpack_require__(868);

var _magic2 = _interopRequireDefault(_magic);

var _person_or_artifact_modal = __webpack_require__(322);

var _person_or_artifact_modal2 = _interopRequireDefault(_person_or_artifact_modal);

var _lodash = __webpack_require__(31);

var _lodash2 = _interopRequireDefault(_lodash);

var _running_sheet_history = __webpack_require__(870);

var _running_sheet_history2 = _interopRequireDefault(_running_sheet_history);

var _legal_case_workflow = __webpack_require__(867);

var _legal_case_workflow2 = _interopRequireDefault(_legal_case_workflow);

var _vueTreeselect = __webpack_require__(102);

var _vueTreeselect2 = _interopRequireDefault(_vueTreeselect);

__webpack_require__(121);

var _brief_of_evidence = __webpack_require__(861);

var _brief_of_evidence2 = _interopRequireDefault(_brief_of_evidence);

var _prosecution_brief = __webpack_require__(869);

var _prosecution_brief2 = _interopRequireDefault(_prosecution_brief);

var _court_proceedings = __webpack_require__(862);

var _court_proceedings2 = _interopRequireDefault(_court_proceedings);

var _generate_document = __webpack_require__(863);

var _generate_document2 = _interopRequireDefault(_generate_document);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    name: "ViewLegalCase",
    data: function data() {
        return {
            documentTypeToGenerate: '',
            entityEdit: {},
            uuid: 0,
            showSpinner: false,
            showExit: false,
            rowNumberSelected: '',
            tabSelected: '',
            runningSheetUrl: [],
            runningSheetEntriesUpdated: [],
            runningSheetHistoryEntryBindId: '',
            legalCaseWorkflowBindId: '',
            generateDocumentBindId: '',
            runningSheetHistoryEntryInstance: '',

            objectHash: null,
            runTab: 'runTab' + this._uid,
            rTab: 'rTab' + this._uid,

            cTab: 'cTab' + this._uid,
            cpTab: 'cpTab' + this._uid,
            bTab: 'bTab' + this._uid,
            pTab: 'pTab' + this._uid,
            current_schema: [],

            workflow_type: '',
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.legal_case, this.$route.params.legal_case_id + "/comms_log"),
            comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.legal_case, this.$route.params.legal_case_id + "/add_comms_log"),
            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.legal_case, this.$route.params.legal_case_id + "/action_log"),
            assign_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, this.$route.params.legal_case_id + '/update_assigned_to_id/'),
            assignmentKey: 0,
            sanctionOutcomeInitialised: false,
            personOrArtifactInitialised: false,

            offenceInitialised: false,
            inspectionInitialised: false,
            hashAttributeWhitelist: ['allocated_group_id', 'case_created_date', 'case_created_time', 'details', 'title', 'legal_case_priority_id', 'region_id', 'district_id'],
            searchPersonKeyPressed: false,
            searchArtifactKeyPressed: false,
            insertUrlKeyPressed: false,

            magic: true,
            dtHeadersRunningSheet: ["id", "Number", "Date", "Time", "User", "Description", "deleted", "Action"],
            dtOptionsRunningSheet: {
                order: [[0, 'desc']],
                columns: [{
                    data: 'id',
                    visible: false,
                    mRender: function mRender(data, type, row) {
                        return row.id;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, row) {
                        var retStr = row.number;
                        return retStr;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, row) {
                        var retStr = row.date_mod;
                        return retStr;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, row) {
                        var retStr = row.time_mod;
                        return retStr;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, row) {
                        var retStr = row.user_full_name;
                        return retStr;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, row) {
                        var retStr = '';
                        retStr = "<div id=" + row.number + " style=\"min-height:20px\" contenteditable=\"true\">" + row.description + "</div>";
                        if (row.deleted) {
                            retStr = '<strike>' + ("<div id=" + row.number + " style=\"min-height:20px\" contenteditable=\"false\">" + row.description + "</div>");
                            '</strike>';
                        } else if (!row.action) {
                            retStr = "<div id=" + row.number + " style=\"min-height:20px\" contenteditable=\"false\">" + row.description + "</div>";
                        }
                        return retStr;
                    }
                }, {
                    data: 'id',
                    visible: false,
                    mRender: function mRender(data, type, row) {
                        return row.deleted;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, row) {
                        var retStr = '';
                        var rowIdDel = row.number.replace('-', 'D');
                        var rowIdHist = row.number.replace('-', 'H');
                        var rowIdReinstate = row.number.replace('-', 'R');
                        retStr += "<a id=" + rowIdHist + " class=\"row_history\" href=\"#\">History</a><br/><br/>";
                        if (row.action) {
                            if (!row.deleted) {
                                retStr += "<a id=" + rowIdDel + " class=\"row_delete\" href=\"#\">Delete</a><br/>";
                            } else {
                                retStr += "<a id=" + rowIdReinstate + " class=\"row_reinstate\" href=\"#\">Reinstate</a><br/>";
                            }
                        }
                        return retStr;
                    }
                }]
            }
        };
    },
    components: {
        CommsLogs: _comms_logs2.default,
        FormSection: _section_toggle2.default,
        datatable: _datatable2.default,
        Offence: _offence_modal2.default,
        SanctionOutcome: _sanction_outcome_modal2.default,
        filefield: _compliance_file2.default,
        RelatedItems: _related_items2.default,
        Inspection: _create_inspection_modal2.default,
        Magic: _magic2.default,
        PersonOrArtifactModal: _person_or_artifact_modal2.default,
        RunningSheetHistory: _running_sheet_history2.default,
        LegalCaseWorkflow: _legal_case_workflow2.default,
        TreeSelect: _vueTreeselect2.default,
        BriefOfEvidence: _brief_of_evidence2.default,
        CourtProceedings: _court_proceedings2.default,
        ProsecutionBrief: _prosecution_brief2.default,
        GenerateDocument: _generate_document2.default,
        Assignment: _assignment2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), (0, _vuex.mapGetters)({
        current_user: 'current_user'
    }), {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        },
        statusDisplay: function statusDisplay() {
            return this.legal_case.status ? this.legal_case.status.name : '';
        },
        statusId: function statusId() {
            return this.legal_case.status ? this.legal_case.status.id : '';
        },
        readonlyForm: function readonlyForm() {
            var readonly = true;
            if (this.legal_case && this.legal_case.id && !this.closedStatus) {
                readonly = !this.legal_case.can_user_action;
            }
            return readonly;
        },
        readonlyRunningSheet: function readonlyRunningSheet() {
            var readonly = true;
            if (this.legal_case && this.legal_case.id && this.legal_case.can_user_action && this.openStatus) {
                readonly = false;
            }
            return readonly;
        },
        backToOfficerVisibility: function backToOfficerVisibility() {
            var visibility = false;
            if (this.canUserAction && (this.withProsecutionCoordinatorStatus || this.withProsecutionCoordinatorProsecutionBriefStatus || this.withManagerStatus)) {
                    visibility = true;
                }
            return visibility;
        },
        closedStatus: function closedStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'closed') {
                returnStatus = true;
            }
            return returnStatus;
        },
        withProsecutionCoordinatorCourtStatus: function withProsecutionCoordinatorCourtStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'with_prosecution_coordinator_court') {
                returnStatus = true;
            }
            return returnStatus;
        },
        withProsecutionManagerStatus: function withProsecutionManagerStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'with_prosecution_manager') {
                returnStatus = true;
            }
            return returnStatus;
        },
        withProsecutionCouncilStatus: function withProsecutionCouncilStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'with_prosecution_council') {
                returnStatus = true;
            }
            return returnStatus;
        },
        withProsecutionCoordinatorProsecutionBriefStatus: function withProsecutionCoordinatorProsecutionBriefStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'with_prosecution_coordinator_prosecution_brief') {
                returnStatus = true;
            }
            return returnStatus;
        },
        withProsecutionCoordinatorStatus: function withProsecutionCoordinatorStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'with_prosecution_coordinator') {
                returnStatus = true;
            }
            return returnStatus;
        },
        withManagerStatus: function withManagerStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'with_manager') {
                returnStatus = true;
            }
            return returnStatus;
        },
        briefOfEvidenceStatus: function briefOfEvidenceStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'brief_of_evidence') {
                returnStatus = true;
            }
            return returnStatus;
        },
        prosecutionBriefStatus: function prosecutionBriefStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'prosecution_brief') {
                returnStatus = true;
            }
            return returnStatus;
        },
        openStatus: function openStatus() {
            var returnStatus = false;
            if (this.legal_case && this.statusId === 'open') {
                returnStatus = true;
            }
            return returnStatus;
        },
        runningSheetTabListClass: function runningSheetTabListClass() {
            var tabClass = 'nav-item';
            if (this.openStatus) {
                tabClass += ' active';
            }
            return tabClass;
        },
        briefOfEvidenceTabListClass: function briefOfEvidenceTabListClass() {
            var tabClass = 'nav-item';
            if (this.briefOfEvidenceStatus) {
                tabClass += ' active';
            }
            return tabClass;
        },
        prosecutionBriefTabListClass: function prosecutionBriefTabListClass() {
            var tabClass = 'nav-item';
            if (this.prosecutionBriefStatus) {
                tabClass += ' active';
            }
            return tabClass;
        },
        runningSheetTabClass: function runningSheetTabClass() {
            var tabClass = 'tab-pane fade in';
            if (this.openStatus) {
                tabClass += ' active';
            }
            return tabClass;
        },
        briefOfEvidenceTabClass: function briefOfEvidenceTabClass() {
            var tabClass = 'tab-pane fade in';
            if (this.briefOfEvidenceStatus) {
                tabClass += ' active';
            }
            return tabClass;
        },
        prosecutionBriefTabClass: function prosecutionBriefTabClass() {
            var tabClass = 'tab-pane fade in';
            if (this.prosecutionBriefStatus) {
                tabClass += ' active';
            }
            return tabClass;
        },
        readonlyBriefOfEvidence: function readonlyBriefOfEvidence() {
            var readonly = true;
            if (this.legal_case && this.legal_case.id) {
                readonly = !this.legal_case.can_user_action;
            }
            return readonly;
        },
        canUserAction: function canUserAction() {
            var return_val = false;
            if (this.legal_case && this.legal_case.id) {
                return_val = this.legal_case.can_user_action;
            }
            return return_val;
        },
        offenceExists: function offenceExists() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.legal_case.related_items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.model_name.toLowerCase() === 'offence') {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return false;
        },
        sanctionOutcomeVisibility: function sanctionOutcomeVisibility() {
            var sanction_outcome_visibility = false;
            if (this.legal_case.status && this.offenceExists && this.legal_case.can_user_action) {
                sanction_outcome_visibility = this.legal_case.status.id === 'open' ? true : false;
            }
            return sanction_outcome_visibility;
        },
        relatedItemsBindId: function relatedItemsBindId() {
            var timeNow = Date.now();
            var bindId = null;
            if (this.legal_case && this.legal_case.id) {
                bindId = 'legal_case_' + this.legal_case.id + '_' + this.uuid;
            } else {
                bindId = timeNow.toString();
            }
            return bindId;
        },
        relatedItemsVisibility: function relatedItemsVisibility() {
            var related_items_visibility = false;
            if (this.legal_case && this.legal_case.id) {
                related_items_visibility = true;
            }
            return related_items_visibility;
        },
        personOrArtifactBindId: function personOrArtifactBindId() {
            var person_or_artifact_id = '';
            person_or_artifact_id = this.tabSelected + parseInt(this.uuid);
            return person_or_artifact_id;
        },
        offenceBindId: function offenceBindId() {
            var offence_bind_id = '';
            offence_bind_id = 'offence' + parseInt(this.uuid);
            return offence_bind_id;
        },
        briefOfEvidenceVisibility: function briefOfEvidenceVisibility() {
            var visible = false;
            if (this.legal_case && this.legal_case.id && this.legal_case.brief_of_evidence && !this.openStatus) {
                visible = true;
            }
            return visible;
        },
        briefOfEvidenceReadonly: function briefOfEvidenceReadonly() {
            var readonly = true;
            if (this.briefOfEvidenceStatus) {
                readonly = false;
            }
            return readonly;
        },
        prosecutionBriefReadonly: function prosecutionBriefReadonly() {
            var readonly = true;
            if (this.withProsecutionCoordinatorProsecutionBriefStatus) {
                readonly = false;
            }
            return readonly;
        },
        prosecutionBriefVisibility: function prosecutionBriefVisibility() {
            var visible = false;
            if (this.legal_case && this.legal_case.id && this.legal_case.brief_of_evidence && this.legal_case.prosecution_brief && !['open', 'brief_of_evidence', 'with_manager', 'with_prosecution_coordinator'].includes(this.statusId)) {
                visible = true;
            }
            return visible;
        },
        courtProceedingsVisibility: function courtProceedingsVisibility() {
            var visible = false;
            if (this.legal_case && this.legal_case.id && this.legal_case.brief_of_evidence && this.legal_case.prosecution_brief && this.legal_case.court_proceedings && ['with_prosecution_coordinator_court', 'closed'].includes(this.statusId)) {
                visible = true;
            }
            return visible;
        },
        sanctionOutcomeBindId: function sanctionOutcomeBindId() {
            var sanction_outcome_bind_id = '';
            sanction_outcome_bind_id = 'sanction_outcome' + parseInt(this.uuid);
            return sanction_outcome_bind_id;
        },
        inspectionBindId: function inspectionBindId() {
            var inspection_bind_id = '';
            inspection_bind_id = 'inspection' + parseInt(this.uuid);
            return inspection_bind_id;
        },
        tabSelectedKeyCombination: function tabSelectedKeyCombination() {
            var keyCombination = '';
            if (this.tabSelected === 'person') {
                keyCombination = '@@';
            } else if (this.tabSelected === 'artifact') {
                keyCombination = '!!';
            } else if (this.tabSelected === 'url') {
                keyCombination = '^^';
            }
            return keyCombination;
        }
    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? (0, _moment2.default)(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('legalCaseStore', {
        loadLegalCase: 'loadLegalCase',
        loadLegalCaseNoRunningSheet: 'loadLegalCaseNoRunningSheet',
        saveLegalCase: 'saveLegalCase',
        setLegalCase: 'setLegalCase',
        setRelatedItems: 'setRelatedItems',
        setRunningSheetEntries: 'setRunningSheetEntries',
        setRunningSheetEntryDescription: 'setRunningSheetEntryDescription',
        setRunningSheetTransform: 'setRunningSheetTransform',
        setAddRunningSheetEntry: 'setAddRunningSheetEntry',
        setRunningSheetEntry: 'setRunningSheetEntry',
        addToRunningSheetPersonList: 'addToRunningSheetPersonList',
        setBriefOfEvidence: 'setBriefOfEvidence',
        setProsecutionBrief: 'setProsecutionBrief'
    }), (0, _vuex.mapActions)({
        loadCurrentUser: 'loadCurrentUser'
    }), {
        setRunningSheetHistoryEntryBindId: function setRunningSheetHistoryEntryBindId() {
            if (this.runningSheetHistoryEntryInstance) {
                this.uuid += 1;
                this.runningSheetHistoryEntryBindId = this.runningSheetHistoryEntryInstance + '_' + this.uuid;
            }
        },
        setLegalCaseWorkflowBindId: function setLegalCaseWorkflowBindId() {
            this.uuid += 1;
            this.legalCaseWorkflowBindId = 'legal_case_workflow_' + this.uuid;
        },
        setGenerateDocumentBindId: function setGenerateDocumentBindId() {
            this.uuid += 1;
            this.generateDocumentBindId = 'generate_document_' + this.uuid;
        },

        runningSheetTransformWrapper: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var runningSheet, i, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, r;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                runningSheet = [];
                                i = 0;
                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context.prev = 5;

                                for (_iterator2 = (0, _getIterator3.default)(this.runningSheetUrl); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    r = _step2.value;

                                    if (this.runningSheetEntriesUpdated.includes(r.number)) {
                                        r.description = this.htmlToToken(r.description);
                                        r.user_id = this.current_user.id;
                                        runningSheet.push(r);
                                    }
                                    i += 1;
                                }
                                _context.next = 13;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](5);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context.t0;

                            case 13:
                                _context.prev = 13;
                                _context.prev = 14;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 16:
                                _context.prev = 16;

                                if (!_didIteratorError2) {
                                    _context.next = 19;
                                    break;
                                }

                                throw _iteratorError2;

                            case 19:
                                return _context.finish(16);

                            case 20:
                                return _context.finish(13);

                            case 21:
                                _context.next = 23;
                                return this.setRunningSheetTransform(runningSheet);

                            case 23:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[5, 9, 13, 21], [14,, 16, 20]]);
            }));

            function runningSheetTransformWrapper() {
                return _ref.apply(this, arguments);
            }

            return runningSheetTransformWrapper;
        }(),
        receivePersonOrArtifactEntity: function receivePersonOrArtifactEntity(_ref2) {
            var row_number_selected = _ref2["row_number_selected"],
                entity = _ref2["entity"],
                action = _ref2["action"];

            this.personOrArtifactInitialised = false;
            console.log(row_number_selected);
            console.log(entity);
            console.log(action);
            var recordNumber = row_number_selected;
            var recordNumberElement = $('#' + recordNumber);
            var recordDescriptionHtml = '';
            if (action === 'cancel') {
                recordDescriptionHtml = this.cancelModalUrl(recordNumberElement);
            } else if (entity && entity.data_type === 'individual' && action === 'ok') {
                recordDescriptionHtml = this.insertPersonModalUrl({ "entity": entity, "recordNumberElement": recordNumberElement });
            } else if (entity && entity.artifact_type && action === 'ok') {
                recordDescriptionHtml = this.insertArtifactModalUrl({ "entity": entity, "recordNumberElement": recordNumberElement });
            } else if (entity && entity.data_type === 'url' && action === 'ok') {
                recordDescriptionHtml = this.insertModalUrl({ "entity": entity, "recordNumberElement": recordNumberElement });
            }
            if (recordNumber) {
                this.updateRunningSheetUrlEntry({
                    "recordNumber": recordNumber,
                    "recordDescription": recordDescriptionHtml,
                    "redraw": true
                });
            }
        },
        insertPersonModalUrl: function insertPersonModalUrl(_ref3) {
            var entity = _ref3["entity"],
                recordNumberElement = _ref3["recordNumberElement"];

            console.log(entity);
            console.log(recordNumberElement);
            var replacementVal = '';
            var urlId = entity.data_type + "-" + entity.id;
            if (entity.full_name) {
                replacementVal = "<span contenteditable=\"false\" id=\"" + urlId + "\" class=\"entity_edit\">" + entity.full_name + "</span>";

                this.addToRunningSheetPersonList(entity);
            }

            var recordDescriptionHtml = recordNumberElement[0].innerHTML.replace(this.tabSelectedKeyCombination, replacementVal);
            return recordDescriptionHtml;
        },
        insertArtifactModalUrl: function insertArtifactModalUrl(_ref4) {
            var entity = _ref4["entity"],
                recordNumberElement = _ref4["recordNumberElement"];

            console.log(entity);
            var replacementVal = '';
            var urlDescription = entity.identifier ? entity.identifier : entity.display;
            var urlId = entity.data_type + "-" + entity.id;

            if (urlDescription) {
                replacementVal = "<span contenteditable=\"false\" id=\"" + urlId + "\" class=\"entity_edit\">" + urlDescription + "</span>";
            }

            var recordDescriptionHtml = recordNumberElement[0].innerHTML.replace(this.tabSelectedKeyCombination, replacementVal);
            console.log(recordDescriptionHtml);
            return recordDescriptionHtml;
        },
        cancelModalUrl: function cancelModalUrl(recordNumberElement) {
            console.log(recordNumberElement);
            var replacementVal = '';

            var recordDescriptionHtml = recordNumberElement[0].innerHTML.replace(this.tabSelectedKeyCombination, replacementVal);
            return recordDescriptionHtml;
        },
        insertModalUrl: function insertModalUrl(_ref5) {
            var entity = _ref5["entity"],
                recordNumberElement = _ref5["recordNumberElement"];

            console.log(entity);
            var replacementVal = '';


            if (entity.url) {
                var fullUrl = entity.urlProtocol + "://" + entity.url.trim();
                replacementVal = "<a contenteditable=\"false\" target=\"_blank\" href=" + fullUrl + ">" + entity.url + "</a>";
            }

            var recordDescriptionHtml = recordNumberElement[0].innerHTML.replace(this.tabSelectedKeyCombination, replacementVal);

            return recordDescriptionHtml;
        },
        constructRunningSheetTable: function constructRunningSheetTable(pk) {
            console.log("constructRunningSheetTable");
            if (!pk) {
                this.$refs.running_sheet_table.vmDataTable.clear().draw();
            }

            var actionColumn = !this.readonlyRunningSheet;
            if (this.runningSheetUrl) {
                for (var i = 0; i < this.runningSheetUrl.length; i++) {
                    if (!pk || this.runningSheetUrl[i].id === pk) {
                        this.$refs.running_sheet_table.vmDataTable.row.add({
                            "id": this.runningSheetUrl[i].id,
                            "number": this.runningSheetUrl[i].number,
                            "date_mod": this.runningSheetUrl[i].date_mod,
                            "time_mod": this.runningSheetUrl[i].time_mod,
                            "user_full_name": this.runningSheetUrl[i].user_full_name,
                            "description": this.runningSheetUrl[i].description,
                            "deleted": this.runningSheetUrl[i].deleted,
                            "action": actionColumn
                        }).draw();
                    }
                }
            }
            console.log("constructRunningSheetTable - end");
        },
        constructRunningSheetTableEntry: function constructRunningSheetTableEntry(rowNumber) {
            var _this = this;

            console.log('rowNumber');
            console.log(rowNumber);

            var actionColumn = !this.readonlyForm;
            if (this.$refs.running_sheet_table && this.$refs.running_sheet_table.vmDataTable) {
                console.log("constructRunningSheetTableEntry");
                this.$refs.running_sheet_table.vmDataTable.rows().every(function (rowIdx, tableLoop, rowLoop) {
                    var rowData = _this.$refs.running_sheet_table.vmDataTable.row(rowIdx).data();

                    if (rowData.number === rowNumber) {
                        var i = 0;
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = (0, _getIterator3.default)(_this.runningSheetUrl), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var r = _step3.value;

                                if (r.number === rowNumber) {
                                    rowData.date_mod = _this.runningSheetUrl[rowIdx].date_mod;
                                    rowData.time_mod = _this.runningSheetUrl[rowIdx].time_mod;
                                    rowData.user_full_name = _this.runningSheetUrl[rowIdx].user_full_name;
                                    rowData.description = _this.runningSheetUrl[rowIdx].description;
                                    rowData.deleted = _this.runningSheetUrl[rowIdx].deleted;
                                    rowData.action = actionColumn;
                                    _this.$refs.running_sheet_table.vmDataTable.row(rowIdx).invalidate().draw();
                                }
                                i += 1;
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                });
            }
        },
        createNewRunningSheetEntry: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var payload, fetchUrl, updatedRunningSheet, returnPayload;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                payload = {
                                    "legal_case_id": this.legal_case.id,
                                    "user_id": this.current_user.id
                                };
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, this.legal_case.id + '/create_running_sheet_entry/');
                                _context2.next = 4;
                                return _vue2.default.http.post(fetchUrl, payload);

                            case 4:
                                updatedRunningSheet = _context2.sent;

                                console.log(updatedRunningSheet);

                                if (!updatedRunningSheet.ok) {
                                    _context2.next = 13;
                                    break;
                                }

                                _context2.next = 9;
                                return this.setAddRunningSheetEntry(updatedRunningSheet.body);

                            case 9:
                                returnPayload = _lodash2.default.cloneDeep(updatedRunningSheet.body);

                                returnPayload.description = this.tokenToHtml(returnPayload.description);
                                this.runningSheetUrl.push(returnPayload);
                                this.constructRunningSheetTable(returnPayload.id);

                            case 13:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function createNewRunningSheetEntry() {
                return _ref6.apply(this, arguments);
            }

            return createNewRunningSheetEntry;
        }(),
        openInspection: function openInspection() {
            var _this2 = this;

            this.uuid += 1;
            this.inspectionInitialised = true;
            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this2.save({ internalFlag: true });

                            case 2:
                                _this2.$refs.inspection.isModalOpen = true;

                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            })));
        },
        openSanctionOutcome: function openSanctionOutcome() {
            var _this3 = this;

            this.uuid += 1;
            this.sanctionOutcomeInitialised = true;
            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this3.save({ internalFlag: true });

                            case 2:
                                _this3.$refs.sanction_outcome.isModalOpen = true;

                            case 3:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this3);
            })));
        },
        openOffence: function openOffence() {
            var _this4 = this;

            this.uuid += 1;
            this.offenceInitialised = true;
            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this4.save({ internalFlag: true });

                            case 2:
                                _this4.$refs.offence.isModalOpen = true;

                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this4);
            })));
        },
        openPersonOrArtifact: function openPersonOrArtifact() {
            var _this5 = this;

            this.uuid += 1;

            this.personOrArtifactInitialised = true;

            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return _this5.loadLegalCaseNoRunningSheet({ legal_case_id: _this5.legal_case.id });

                            case 2:
                                _this5.$refs.person_or_artifact_modal.isModalOpen = true;

                            case 3:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this5);
            })));
        },

        addWorkflow: function addWorkflow(workflow_type) {
            var _this6 = this;

            console.log(workflow_type);

            this.workflow_type = workflow_type;
            this.setLegalCaseWorkflowBindId();

            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return _this6.save({ internalFlag: true });

                            case 2:
                                _this6.$refs.legal_case_workflow.isModalOpen = true;

                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this6);
            })));
        },
        printDocument: function printDocument(documentType) {
            var _this7 = this;

            this.documentTypeToGenerate = documentType;
            this.setGenerateDocumentBindId();
            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
                return _regenerator2.default.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return _this7.save({ internalFlag: true });

                            case 2:
                                _this7.$refs.generate_document.isModalOpen = true;

                            case 3:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this7);
            })));
        },

        saveExit: function () {
            var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
                return _regenerator2.default.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.save({ "returnToDash": true });

                            case 2:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function saveExit() {
                return _ref13.apply(this, arguments);
            }

            return saveExit;
        }(),
        save: function () {
            var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
                var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    _ref15$returnToDash = _ref15.returnToDash,
                    returnToDash = _ref15$returnToDash === undefined ? false : _ref15$returnToDash,
                    _ref15$createBriefOfE = _ref15.createBriefOfEvidence,
                    createBriefOfEvidence = _ref15$createBriefOfE === undefined ? false : _ref15$createBriefOfE,
                    _ref15$createProsecut = _ref15.createProsecutionBrief,
                    createProsecutionBrief = _ref15$createProsecut === undefined ? false : _ref15$createProsecut,
                    _ref15$fullHttpRespon = _ref15.fullHttpResponse,
                    fullHttpResponse = _ref15$fullHttpRespon === undefined ? false : _ref15$fullHttpRespon,
                    _ref15$internalFlag = _ref15.internalFlag,
                    internalFlag = _ref15$internalFlag === undefined ? false : _ref15$internalFlag;

                return _regenerator2.default.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                this.showSpinner = true;
                                if (returnToDash) {
                                    this.showExit = true;
                                }
                                _context10.next = 4;
                                return this.runningSheetTransformWrapper();

                            case 4:
                                if (!this.$refs.brief_of_evidence) {
                                    _context10.next = 7;
                                    break;
                                }

                                _context10.next = 7;
                                return this.setBriefOfEvidence(this.$refs.brief_of_evidence.briefOfEvidence);

                            case 7:
                                if (!this.$refs.prosecution_brief) {
                                    _context10.next = 10;
                                    break;
                                }

                                _context10.next = 10;
                                return this.setProsecutionBrief(this.$refs.prosecution_brief.prosecutionBrief);

                            case 10:
                                _context10.next = 12;
                                return this.saveLegalCase({
                                    internal: internalFlag,
                                    createBriefOfEvidence: createBriefOfEvidence,
                                    createProsecutionBrief: createProsecutionBrief,
                                    fullHttpResponse: fullHttpResponse
                                });

                            case 12:
                                if (returnToDash) {
                                    window.removeEventListener('beforeunload', this.leaving);
                                    window.removeEventListener('onblur', this.leaving);

                                    this.$router.push({ name: 'internal-legal-case-dash' });
                                } else {
                                    this.calculateHash();
                                    this.runningSheetEntriesUpdated = [];
                                }
                                this.showSpinner = false;
                                this.showExit = false;

                            case 15:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function save() {
                return _ref14.apply(this, arguments);
            }

            return save;
        }(),
        magicMethod: function magicMethod() {
            console.log("magic method");
            this.$refs.magic.isModalOpen = true;
            this.magic = false;
        },
        updateRunningSheetUrlEntry: function updateRunningSheetUrlEntry(_ref16) {
            var recordNumber = _ref16.recordNumber,
                recordDescription = _ref16.recordDescription,
                redraw = _ref16.redraw;

            console.log("updateRunningSheetUrl");
            if (this.magic && recordDescription && recordDescription.toLowerCase().includes('shibaken')) {
                this.magicMethod();
            }

            var i = 0;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(this.runningSheetUrl), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var r = _step4.value;

                    if (r.number === recordNumber) {
                        r.description = recordDescription;

                        if (redraw) {
                            this.constructRunningSheetTableEntry(recordNumber);
                        }
                    }
                    i += 1;
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        },
        runningSheetKeyup: function runningSheetKeyup(e) {
            var rowObj = {};
            var recordNumber = e.target.id;
            var recordDescriptionText = e.target.textContent;
            var recordDescriptionHtml = e.target.innerHTML.replace(/\&nbsp\;/g, ' ');

            if (!this.runningSheetEntriesUpdated.includes(recordNumber)) {
                this.runningSheetEntriesUpdated.push(recordNumber);
            }

            var ignoreArray = [];
            if (ignoreArray.includes(e.which)) {} else {
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = (0, _getIterator3.default)(this.runningSheetUrl), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var r = _step5.value;

                        if (r.number === recordNumber) {
                            this.updateRunningSheetUrlEntry({
                                "recordNumber": recordNumber,
                                "recordDescription": recordDescriptionHtml,
                                "redraw": false
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            }
        },
        runningSheetKeydown: function () {
            var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11(e) {
                return _regenerator2.default.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                console.log(e);
                                if (e.key === '!' && e.shiftKey && this.searchArtifactKeyPressed) {
                                    this.entityEdit = {};
                                    this.rowNumberSelected = e.target.id;
                                    this.tabSelected = 'artifact';
                                    this.openPersonOrArtifact();

                                    this.searchArtifactKeyPressed = false;
                                } else if (e.key === '!' && e.shiftKey) {
                                    this.searchArtifactKeyPressed = true;
                                    this.searchPersonKeyPressed = false;
                                    this.insertUrlKeyPressed = false;
                                } else if (e.key === '@' && e.shiftKey && this.searchPersonKeyPressed) {
                                    this.entityEdit = {};
                                    this.rowNumberSelected = e.target.id;
                                    this.tabSelected = 'person';
                                    this.openPersonOrArtifact();
                                    this.searchPersonKeyPressed = false;
                                } else if (e.key === '@' && e.shiftKey) {
                                    this.searchPersonKeyPressed = true;
                                    this.searchArtifactKeyPressed = false;
                                    this.insertUrlKeyPressed = false;
                                } else if (e.key === '^' && e.shiftKey && this.insertUrlKeyPressed) {
                                    this.rowNumberSelected = e.target.id;
                                    this.tabSelected = 'url';

                                    this.openPersonOrArtifact();

                                    this.insertUrlKeyPressed = false;
                                } else if (e.key === '^' && e.shiftKey) {
                                    this.insertUrlKeyPressed = true;
                                    this.searchPersonKeyPressed = false;
                                    this.searchArtifactKeyPressed = false;
                                } else if (e.key === 'Shift' && e.shiftKey) {} else {
                                    this.searchPersonKeyPressed = false;
                                    this.searchArtifactKeyPressed = false;
                                    this.insertUrlKeyPressed = false;
                                }

                            case 2:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function runningSheetKeydown(_x2) {
                return _ref17.apply(this, arguments);
            }

            return runningSheetKeydown;
        }(),
        htmlToToken: function htmlToToken(description) {
            var parsedText = description;

            var personUrlRegex = /<span contenteditable\=\"false\" id=\"individual-\d+\"\ class=\"entity_edit\">\w+(\s\w+)*\<\/span\>/g;

            var personIdRegex = /id=\"individual\-\d+/g;

            var personNameRegex = /class=\"entity_edit\"\>\w+(\s\w+)*/g;
            var personUrlArray = [].concat((0, _toConsumableArray3.default)(description.matchAll(personUrlRegex)));
            if (personUrlArray && personUrlArray.length > 0) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = (0, _getIterator3.default)(personUrlArray), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var personUrl = _step6.value;

                        var personIdArray = [].concat((0, _toConsumableArray3.default)(personUrl[0].matchAll(personIdRegex)));
                        var personIdStr = personIdArray[0][0];
                        var personId = personIdStr.substring(15);
                        var personArray = [].concat((0, _toConsumableArray3.default)(personUrl[0].matchAll(personNameRegex)));
                        var personFound = personArray[0][0];

                        var person = personFound.replace(/class=\"entity_edit\"\>/g, String(''));
                        var replacementVal = "{{ \"person_id\": \"" + personId + "\", \"full_name\": \"" + person + "\" }}";
                        parsedText = parsedText.replace(personUrl[0], replacementVal).replace(/\&nbsp\;/g, ' ');
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }

            var artifactUrlRegex = /\<span contenteditable\=\"false\" id=\"\w+\_artifact\-\d+\" class=\"entity_edit\"\>\w+(\s\w+)*\<\/span\>/g;
            var artifactIdRegex = /id=\"\w+\_\w+\-\d+/g;

            var artifactIdentifierRegex = /class=\"entity_edit\"\>\w+(\s\w+)*/g;
            var artifactUrlArray = [].concat((0, _toConsumableArray3.default)(description.matchAll(artifactUrlRegex)));
            if (artifactUrlArray && artifactUrlArray.length > 0) {
                var _iteratorNormalCompletion7 = true;
                var _didIteratorError7 = false;
                var _iteratorError7 = undefined;

                try {
                    for (var _iterator7 = (0, _getIterator3.default)(artifactUrlArray), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                        var artifactUrl = _step7.value;

                        var artifactIdArray = [].concat((0, _toConsumableArray3.default)(artifactUrl[0].matchAll(artifactIdRegex)));
                        var artifactIdStr = artifactIdArray[0][0];
                        var artifactTypeIncludingId = artifactIdStr.split("-")[0];
                        var artifactType = artifactTypeIncludingId.substring(4);
                        var artifactId = artifactIdStr.split("-")[1];

                        var identifierArray = [].concat((0, _toConsumableArray3.default)(artifactUrl[0].matchAll(artifactIdentifierRegex)));
                        var identifierFound = identifierArray[0][0];
                        var identifier = identifierFound.replace(/class=\"entity_edit\"\>/g, String(''));
                        var _replacementVal = "{{ \"" + artifactType + "_id\": \"" + artifactId + "\", \"identifier\": \"" + identifier + "\" }}";
                        parsedText = parsedText.replace(artifactUrl[0], _replacementVal).replace(/\&nbsp\;/g, ' ');
                    }
                } catch (err) {
                    _didIteratorError7 = true;
                    _iteratorError7 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                            _iterator7.return();
                        }
                    } finally {
                        if (_didIteratorError7) {
                            throw _iteratorError7;
                        }
                    }
                }
            }
            return parsedText;
        },
        tokenToHtml: function tokenToHtml(description) {
            var parsedText = description;

            var personTokenRegex = /\{\{ \"person\_id\"\: \"\d+\"\, \"full\_name\"\: \"\w+(\s\w+)*\" \}\}/g;
            var personIdRegex = /\{\{ \"person\_id\"\: \"\d+/g;

            var personNameRegex = /\"full\_name\"\: \"\w+(\s\w+)*/g;
            var personTokenArray = [].concat((0, _toConsumableArray3.default)(description.matchAll(personTokenRegex)));
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = (0, _getIterator3.default)(personTokenArray), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var personToken = _step8.value;

                    var personIdArray = [].concat((0, _toConsumableArray3.default)(personToken[0].matchAll(personIdRegex)));
                    var personIdStr = personIdArray[0][0];
                    var personId = personIdStr.substring(17);
                    var nameArray = [].concat((0, _toConsumableArray3.default)(personToken[0].matchAll(personNameRegex)));
                    if (nameArray && nameArray.length > 0) {
                        var nameStr = nameArray[0][0];
                        var fullName = nameStr.substring(14);
                        parsedText = parsedText.replace(personToken[0], "<span contenteditable=\"false\" id=\"individual-" + personId + "\" class=\"entity_edit\">" + fullName + "</span>");
                    }
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            var artifactTokenRegex = /\{\{ \"\w+\_artifact\_id\"\: \"\d+\"\, \"identifier\"\: \"\w+(\s\w+)*\" \}\}/g;
            var artifactIdRegex = /\w+\_artifact\_id\"\: \"\d+/g;

            var artifactIdentifierRegex = /\"identifier\"\: \"\w+(\s\w+)*/g;
            var artifactTokenArray = [].concat((0, _toConsumableArray3.default)(description.matchAll(artifactTokenRegex)));
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = (0, _getIterator3.default)(artifactTokenArray), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var artifactToken = _step9.value;

                    var artifactIdArray = [].concat((0, _toConsumableArray3.default)(artifactToken[0].matchAll(artifactIdRegex)));
                    var artifactIdStr = artifactIdArray[0][0];
                    var artifactType = artifactIdStr.split("_")[0] + "_artifact";
                    var artifactIdStrTrunc = artifactIdStr.split("_")[2];
                    var artifactId = artifactIdStrTrunc.substring(6);
                    var identifierArray = [].concat((0, _toConsumableArray3.default)(artifactToken[0].matchAll(artifactIdentifierRegex)));
                    if (identifierArray && identifierArray.length > 0) {
                        var identifierStr = identifierArray[0][0];
                        var identifier = identifierStr.substr(15);
                        var elemId = artifactType + "-" + artifactId;
                        parsedText = parsedText.replace(artifactToken[0], "<span contenteditable=\"false\" id=\"" + elemId + "\" class=\"entity_edit\">" + identifier + "</span>");
                    }
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            return parsedText;
        },
        openModalEntityEdit: function openModalEntityEdit(e) {
            console.log(e);
            var entityDataType = e.target.id.split("-")[0];
            var entityId = e.target.id.split("-")[1];

            console.log(entityDataType);
            console.log(entityId);
            if (entityId) {
                entityId = parseInt(entityId, 10);
            }
            this.entityEdit = {
                "data_type": entityDataType,
                "id": entityId
            };
            if (['physical_artifact', 'document_artifact'].includes(entityDataType)) {
                this.tabSelected = 'artifact';
            } else if (entityDataType === 'individual') {
                this.tabSelected = 'person';
            }

            this.openPersonOrArtifact();
        },
        addEventListeners: function addEventListeners() {
            var _this8 = this;

            var vm = this;
            var runningSheetTable = $('#running-sheet-table');
            console.log(runningSheetTable);
            runningSheetTable.on('keydown', function (e) {
                _this8.runningSheetKeydown(e);
            });
            runningSheetTable.on('keyup', function (e) {
                _this8.runningSheetKeyup(e);
            });
            runningSheetTable.on('click', '.row_delete', function (e) {
                _this8.runningSheetRowDelete(e);
            });
            runningSheetTable.on('click', '.entity_edit', function (e) {
                _this8.openModalEntityEdit(e);
            });

            runningSheetTable.on('click', '.row_history', function (e) {
                _this8.runningSheetRowHistory(e);
            });
            runningSheetTable.on('click', '.row_reinstate', function (e) {
                _this8.runningSheetRowReinstate(e);
            });

            runningSheetTable.on('paste', function (e) {
                console.log("plain text only");

                e.preventDefault();

                var text = (e.originalEvent || e).clipboardData.getData('text/plain');
                var transformedText = text.replace(/\n/g, '<br/>');

                document.execCommand("insertHTML", false, transformedText);
            });

            window.addEventListener('beforeunload', this.leaving);
            window.addEventListener('onblur', this.leaving);
        },
        runningSheetRowDelete: function () {
            var _ref18 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee12(e) {
                var rowNumber, running_sheet_id, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, _r, returnedEntry, i, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, r;

                return _regenerator2.default.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                this.showSpinner = true;
                                console.log(e);
                                rowNumber = e.target.id.replace('D', '-');

                                console.log(rowNumber);
                                console.log("runningSheetRowDelete");
                                running_sheet_id = null;
                                _iteratorNormalCompletion10 = true;
                                _didIteratorError10 = false;
                                _iteratorError10 = undefined;
                                _context12.prev = 9;

                                for (_iterator10 = (0, _getIterator3.default)(this.legal_case.running_sheet_entries); !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                                    _r = _step10.value;

                                    if (_r.number === rowNumber) {
                                        running_sheet_id = _r.id;
                                    }
                                }
                                _context12.next = 17;
                                break;

                            case 13:
                                _context12.prev = 13;
                                _context12.t0 = _context12["catch"](9);
                                _didIteratorError10 = true;
                                _iteratorError10 = _context12.t0;

                            case 17:
                                _context12.prev = 17;
                                _context12.prev = 18;

                                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                    _iterator10.return();
                                }

                            case 20:
                                _context12.prev = 20;

                                if (!_didIteratorError10) {
                                    _context12.next = 23;
                                    break;
                                }

                                throw _iteratorError10;

                            case 23:
                                return _context12.finish(20);

                            case 24:
                                return _context12.finish(17);

                            case 25:
                                _context12.next = 27;
                                return _vue2.default.http.post(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, this.legal_case.id + '/delete_reinstate_running_sheet_entry/'), {
                                    "running_sheet_id": running_sheet_id,
                                    "deleted": true
                                });

                            case 27:
                                returnedEntry = _context12.sent;

                                if (!returnedEntry.ok) {
                                    _context12.next = 52;
                                    break;
                                }

                                _context12.next = 31;
                                return this.setRunningSheetEntry(returnedEntry.body);

                            case 31:
                                i = 0;
                                _iteratorNormalCompletion11 = true;
                                _didIteratorError11 = false;
                                _iteratorError11 = undefined;
                                _context12.prev = 35;

                                for (_iterator11 = (0, _getIterator3.default)(this.runningSheetUrl); !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                    r = _step11.value;

                                    if (r.number === rowNumber) {
                                        this.runningSheetUrl.splice(i, 1, returnedEntry.body);
                                        this.runningSheetUrl[i].description = this.tokenToHtml(this.runningSheetUrl[i].description);
                                    }
                                    i += 1;
                                }
                                _context12.next = 43;
                                break;

                            case 39:
                                _context12.prev = 39;
                                _context12.t1 = _context12["catch"](35);
                                _didIteratorError11 = true;
                                _iteratorError11 = _context12.t1;

                            case 43:
                                _context12.prev = 43;
                                _context12.prev = 44;

                                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                    _iterator11.return();
                                }

                            case 46:
                                _context12.prev = 46;

                                if (!_didIteratorError11) {
                                    _context12.next = 49;
                                    break;
                                }

                                throw _iteratorError11;

                            case 49:
                                return _context12.finish(46);

                            case 50:
                                return _context12.finish(43);

                            case 51:
                                this.constructRunningSheetTableEntry(rowNumber);

                            case 52:
                                this.showSpinner = false;

                            case 53:
                            case "end":
                                return _context12.stop();
                        }
                    }
                }, _callee12, this, [[9, 13, 17, 25], [18,, 20, 24], [35, 39, 43, 51], [44,, 46, 50]]);
            }));

            function runningSheetRowDelete(_x3) {
                return _ref18.apply(this, arguments);
            }

            return runningSheetRowDelete;
        }(),
        runningSheetRowReinstate: function () {
            var _ref19 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee13(e) {
                var rowNumber, running_sheet_id, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _r2, returnedEntry, i, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, r;

                return _regenerator2.default.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                this.showSpinner = true;
                                console.log(e);
                                rowNumber = e.target.id.replace('R', '-');

                                console.log(rowNumber);
                                console.log("runningSheetRowReinstate");
                                running_sheet_id = null;
                                _iteratorNormalCompletion12 = true;
                                _didIteratorError12 = false;
                                _iteratorError12 = undefined;
                                _context13.prev = 9;

                                for (_iterator12 = (0, _getIterator3.default)(this.legal_case.running_sheet_entries); !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                                    _r2 = _step12.value;

                                    if (_r2.number === rowNumber) {
                                        running_sheet_id = _r2.id;
                                    }
                                }
                                _context13.next = 17;
                                break;

                            case 13:
                                _context13.prev = 13;
                                _context13.t0 = _context13["catch"](9);
                                _didIteratorError12 = true;
                                _iteratorError12 = _context13.t0;

                            case 17:
                                _context13.prev = 17;
                                _context13.prev = 18;

                                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                    _iterator12.return();
                                }

                            case 20:
                                _context13.prev = 20;

                                if (!_didIteratorError12) {
                                    _context13.next = 23;
                                    break;
                                }

                                throw _iteratorError12;

                            case 23:
                                return _context13.finish(20);

                            case 24:
                                return _context13.finish(17);

                            case 25:
                                _context13.next = 27;
                                return _vue2.default.http.post(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, this.legal_case.id + '/delete_reinstate_running_sheet_entry/'), {
                                    "running_sheet_id": running_sheet_id,
                                    "deleted": false
                                });

                            case 27:
                                returnedEntry = _context13.sent;

                                if (!returnedEntry.ok) {
                                    _context13.next = 52;
                                    break;
                                }

                                _context13.next = 31;
                                return this.setRunningSheetEntry(returnedEntry.body);

                            case 31:
                                i = 0;
                                _iteratorNormalCompletion13 = true;
                                _didIteratorError13 = false;
                                _iteratorError13 = undefined;
                                _context13.prev = 35;

                                for (_iterator13 = (0, _getIterator3.default)(this.runningSheetUrl); !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                                    r = _step13.value;

                                    if (r.number === rowNumber) {
                                        this.runningSheetUrl.splice(i, 1, returnedEntry.body);
                                        this.runningSheetUrl[i].description = this.tokenToHtml(this.runningSheetUrl[i].description);
                                    }
                                    i += 1;
                                }
                                _context13.next = 43;
                                break;

                            case 39:
                                _context13.prev = 39;
                                _context13.t1 = _context13["catch"](35);
                                _didIteratorError13 = true;
                                _iteratorError13 = _context13.t1;

                            case 43:
                                _context13.prev = 43;
                                _context13.prev = 44;

                                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                                    _iterator13.return();
                                }

                            case 46:
                                _context13.prev = 46;

                                if (!_didIteratorError13) {
                                    _context13.next = 49;
                                    break;
                                }

                                throw _iteratorError13;

                            case 49:
                                return _context13.finish(46);

                            case 50:
                                return _context13.finish(43);

                            case 51:
                                this.constructRunningSheetTableEntry(rowNumber);

                            case 52:
                                this.showSpinner = false;

                            case 53:
                            case "end":
                                return _context13.stop();
                        }
                    }
                }, _callee13, this, [[9, 13, 17, 25], [18,, 20, 24], [35, 39, 43, 51], [44,, 46, 50]]);
            }));

            function runningSheetRowReinstate(_x4) {
                return _ref19.apply(this, arguments);
            }

            return runningSheetRowReinstate;
        }(),
        runningSheetRowHistory: function runningSheetRowHistory(e) {
            var _this9 = this;

            console.log(e);
            var rowNumber = e.target.id.replace('H', '-');
            console.log(rowNumber);
            console.log("runningSheetRowHistory");
            this.runningSheetHistoryEntryInstance = rowNumber;
            this.setRunningSheetHistoryEntryBindId();
            this.$nextTick(function () {
                _this9.$refs.running_sheet_history.isModalOpen = true;
            });
        },
        leaving: function leaving(e) {
            var vm = this;
            var dialogText = '';
            if (this.formChanged()) {
                e.returnValue = dialogText;
                return dialogText;
            }
        },
        formChanged: function formChanged() {
            var _this10 = this;

            var changed = false;
            var copiedLegalCase = {};
            (0, _getOwnPropertyNames2.default)(this.legal_case).forEach(function (val, idx, array) {
                if (_this10.hashAttributeWhitelist.includes(val)) {
                    copiedLegalCase[val] = _this10.legal_case[val];
                }
            });
            this.addHashAttributes(copiedLegalCase);
            if (this.objectHash !== (0, _objectHash2.default)(copiedLegalCase)) {
                changed = true;
            }
            if (this.runningSheetEntriesUpdated.length > 0) {
                changed = true;
            }
            return changed;
        },
        calculateHash: function calculateHash() {
            var _this11 = this;

            var copiedLegalCase = {};
            (0, _getOwnPropertyNames2.default)(this.legal_case).forEach(function (val, idx, array) {
                if (_this11.hashAttributeWhitelist.includes(val)) {
                    copiedLegalCase[val] = _this11.legal_case[val];
                }
            });
            this.addHashAttributes(copiedLegalCase);
            this.objectHash = (0, _objectHash2.default)(copiedLegalCase);
        },
        addHashAttributes: function addHashAttributes(obj) {
            var copiedRendererFormData = (0, _assign2.default)({}, this.renderer_form_data);
            obj.renderer_form_data = copiedRendererFormData;
            return obj;
        },
        updateAssignedToId: function () {
            var _ref20 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee14(body) {
                return _regenerator2.default.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.setLegalCase(body);

                            case 2:
                                this.constructRunningSheetTableWrapper();
                                this.assignmentKey += 1;

                            case 4:
                            case "end":
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function updateAssignedToId(_x5) {
                return _ref20.apply(this, arguments);
            }

            return updateAssignedToId;
        }(),
        constructRunningSheetTableWrapper: function constructRunningSheetTableWrapper() {
            var _this12 = this;

            this.runningSheetUrl = _lodash2.default.cloneDeep(this.legal_case.running_sheet_entries);
            console.log('this.runningSheetUrl');
            console.log(this.runningSheetUrl);
            var i = 0;
            var _iteratorNormalCompletion14 = true;
            var _didIteratorError14 = false;
            var _iteratorError14 = undefined;

            try {
                for (var _iterator14 = (0, _getIterator3.default)(this.legal_case.running_sheet_entries), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                    var r = _step14.value;

                    var description = this.tokenToHtml(r.description);
                    this.runningSheetUrl[i].description = description;
                    i += 1;
                }
            } catch (err) {
                _didIteratorError14 = true;
                _iteratorError14 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                    }
                } finally {
                    if (_didIteratorError14) {
                        throw _iteratorError14;
                    }
                }
            }

            this.$nextTick(function () {
                _this12.constructRunningSheetTable();
            });
        }
    }),
    created: function () {
        var _ref21 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee15() {
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            if (!this.$route.params.legal_case_id) {
                                _context15.next = 3;
                                break;
                            }

                            _context15.next = 3;
                            return this.loadLegalCase({ legal_case_id: this.$route.params.legal_case_id });

                        case 3:
                            _context15.next = 5;
                            return this.loadCurrentUser({ url: "/api/my_compliance_user_details" });

                        case 5:

                            this.calculateHash();
                            this.constructRunningSheetTableWrapper();

                        case 7:
                        case "end":
                            return _context15.stop();
                    }
                }
            }, _callee15, this);
        }));

        function created() {
            return _ref21.apply(this, arguments);
        }

        return created;
    }(),
    destroyed: function destroyed() {
        window.removeEventListener('beforeunload', this.leaving);
        window.removeEventListener('onblur', this.leaving);
    },

    mounted: function mounted() {
        var _this13 = this;

        this.$nextTick(function () {
            _this13.addEventListeners();

            $('.vue-treeselect__control').css("display", "none");
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _create_legal_case_modal = __webpack_require__(345);

var _create_legal_case_modal2 = _interopRequireDefault(_create_legal_case_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'LegalCaseTableDash',
    data: function data() {
        var vm = this;
        return {
            filterStatus: 'All',

            filterCaseCreatedFrom: '',
            filterCaseCreatedTo: '',

            statusChoices: [],


            dateFormat: 'DD/MM/YYYY',
            legalCaseInitialised: false,
            createLegalCaseBindId: '',

            dtOptions: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                autoWidth: false,
                rowCallback: function rowCallback(row, data) {
                    (0, _jquery2.default)(row).addClass('appRecordRow');
                },

                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },

                responsive: true,
                processing: true,
                ajax: {
                    'url': '/api/legal_case_paginated/get_paginated_datatable/?format=datatables',
                    'dataSrc': 'data',
                    'data': function data(d) {
                        d.status_description = vm.filterStatus;
                        d.date_from = vm.filterPlannedFrom != '' && vm.filterPlannedFrom != null ? moment(vm.filterPlannedFrom, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                        d.date_to = vm.filterPlannedTo != '' && vm.filterPlannedTo != null ? moment(vm.filterPlannedTo, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
                    }
                },

                columns: [{
                    data: 'number',
                    searchable: false
                }, {
                    data: 'title',
                    searchable: false,
                    orderable: true
                }, {
                    data: 'status.name',
                    searchable: false,
                    orderable: true
                }, {
                    data: 'created_date',
                    searchable: false,
                    orderable: true
                }, {
                    data: "assigned_to",
                    searchable: false,
                    orderable: false,
                    mRender: function mRender(data, type, full) {
                        if (data) {
                            return data.full_name;
                        } else {
                            return '';
                        }
                    }
                }, {
                    data: 'user_action',
                    searchable: false,
                    orderable: false
                }]
            },
            dtHeaders: ['Number', 'Title', 'Status', 'Created Date', 'Assigned to', 'Action']
        };
    },


    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var _this = this;

        next(function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(vm) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }());
    },

    created: function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var returned_status_choices;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _hooks.cache_helper.getSetCacheList('LegalCase_StatusChoices', '/api/legal_case/status_choices');

                        case 2:
                            returned_status_choices = _context2.sent;


                            (0, _assign2.default)(this.statusChoices, returned_status_choices);
                            this.statusChoices.splice(0, 0, { id: 'all', display: 'All' });

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function created() {
            return _ref2.apply(this, arguments);
        }

        return created;
    }(),
    watch: {
        filterStatus: function filterStatus() {
            this.$refs.legal_case_table.vmDataTable.draw();
        },
        filterCaseCreatedFrom: function filterCaseCreatedFrom() {
            this.$refs.legal_case_table.vmDataTable.draw();
        },
        filterCaseCreatedTo: function filterCaseCreatedTo() {
            this.$refs.legal_case_table.vmDataTable.draw();
        }
    },
    components: {
        datatable: _datatable2.default,
        FormSection: _section_toggle2.default,
        CreateLegalCaseModal: _create_legal_case_modal2.default
    },
    computed: {},
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('legalCaseStore', {
        saveInspection: "saveLegalCase"
    }), {
        createLegalCase: function createLegalCase() {
            var _this2 = this;

            this.setCreateLegalCaseBindId();
            this.legalCaseInitialised = true;
            this.$nextTick(function () {
                _this2.$refs.add_legal_case.isModalOpen = true;
            });
        },
        setCreateLegalCaseBindId: function setCreateLegalCaseBindId() {
            var timeNow = Date.now();
            this.createLegalCaseBindId = 'legal_case' + timeNow.toString();
        },
        createLegalCaseUrl: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var newLegalCaseId;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.saveLegalCase({ create: true });

                            case 2:
                                newLegalCaseId = _context3.sent;


                                this.$router.push({
                                    name: 'view-legal-case',
                                    params: { legal_case_id: newLegalCaseId }
                                });

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function createLegalCaseUrl() {
                return _ref3.apply(this, arguments);
            }

            return createLegalCaseUrl;
        }(),
        addEventListeners: function addEventListeners() {
            var vm = this;

            (0, _jquery2.default)(vm.$refs.caseCreatedDateToPicker).datetimepicker(vm.datepickerOptions);
            (0, _jquery2.default)(vm.$refs.caseCreatedDateToPicker).on('dp.change', function (e) {
                if ((0, _jquery2.default)(vm.$refs.caseCreatedDateToPicker).data('DateTimePicker').date()) {
                    vm.filterCaseCreatedTo = e.date.format('DD/MM/YYYY');
                } else if ((0, _jquery2.default)(vm.$refs.plannedDateToPicker).data('date') === "") {
                    vm.filterCaseCreatedTo = "";
                }
            });
            (0, _jquery2.default)(vm.$refs.caseCreatedDateFromPicker).datetimepicker(vm.datepickerOptions);
            (0, _jquery2.default)(vm.$refs.caseCreatedDateFromPicker).on('dp.change', function (e) {
                if ((0, _jquery2.default)(vm.$refs.caseCreatedDateFromPicker).data('DateTimePicker').date()) {
                    vm.filterCaseCreatedFrom = e.date.format('DD/MM/YYYY');
                } else if ((0, _jquery2.default)(vm.$refs.caseCreatedDateFromPicker).data('date') === "") {
                    vm.filterCaseCreatedFrom = "";
                }
            });
        },
        initialiseSearch: function initialiseSearch() {
            this.dateSearch();
        },
        dateSearch: function dateSearch() {
            var vm = this;
            vm.$refs.legal_case_table.table.dataTableExt.afnFiltering.push(function (settings, data, dataIndex, original) {
                var from = vm.filterCaseCreatedFrom;
                var to = vm.filterCaseCreatedTo;

                var val = original.case_created_date;

                if (from == '' && to == '') {
                    return true;
                } else if (from != '' && to != '') {
                    return val != null && val != '' ? moment().range(moment(from, vm.dateFormat), moment(to, vm.dateFormat)).contains(moment(val)) : false;
                } else if (from == '' && to != '') {
                    if (val != null && val != '') {
                        return moment(to, vm.dateFormat).diff(moment(val)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else if (to == '' && from != '') {
                    if (val != null && val != '') {
                        return moment(val).diff(moment(from, vm.dateFormat)) >= 0 ? true : false;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            });
        }
    }),
    mounted: function () {
        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
            var _this3 = this;

            var vm;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            vm = this;

                            (0, _jquery2.default)('a[data-toggle="collapse"]').on('click', function () {
                                var chev = (0, _jquery2.default)(this).children()[0];
                                window.setTimeout(function () {
                                    (0, _jquery2.default)(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
                                }, 100);
                            });
                            this.$nextTick((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                                return _regenerator2.default.wrap(function _callee4$(_context4) {
                                    while (1) {
                                        switch (_context4.prev = _context4.next) {
                                            case 0:
                                                _context4.next = 2;
                                                return vm.initialiseSearch();

                                            case 2:
                                                _context4.next = 4;
                                                return vm.addEventListeners();

                                            case 4:
                                            case 'end':
                                                return _context4.stop();
                                        }
                                    }
                                }, _callee4, _this3);
                            })));

                        case 3:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function mounted() {
            return _ref4.apply(this, arguments);
        }

        return mounted;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "LegalCaseWorking",
    data: function data() {
        return {
            officers: [],
            isModalOpen: false,
            processingDetails: false,
            form: null,
            workflowDetails: '',
            errorResponse: "",
            documentActionUrl: '',

            allocated_group_id: null,
            saveAndExit: false,
            modalTitle: ''
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        filefield: _compliance_file2.default
    },
    props: {
        workflow_type: {
            type: String,
            default: ''
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    })),
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('legalCaseStore', {
        saveLegalCase: 'saveLegalCase',
        loadLegalCase: 'loadLegalCase',
        setLegalCase: 'setLegalCase'
    }), {
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.sendData();

                            case 2:
                                response = _context.sent;

                                console.log(response);
                                if (response.ok) {
                                    this.close();
                                    if (this.saveAndExit) {
                                        this.$router.push({ name: 'internal-legal-case-dash' });
                                    } else {
                                        this.$router.go();
                                    }
                                }

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        cancel: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.$refs.comms_log_file) {
                                    _context2.next = 3;
                                    break;
                                }

                                _context2.next = 3;
                                return this.$refs.comms_log_file.cancel();

                            case 3:
                                this.isModalOpen = false;
                                this.close();

                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function cancel() {
                return _ref2.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
        },
        sendData: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var post_url, payload, res;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                post_url = '/api/legal_case/' + this.legal_case.id + '/workflow_action/';
                                payload = new FormData();

                                payload.append('details', this.workflowDetails);
                                if (this.$refs.comms_log) {
                                    this.$refs.comms_log_file.commsLogId ? payload.append('legal_case_comms_log_id', this.$refs.comms_log_file.commsLogId) : null;
                                }
                                this.workflow_type ? payload.append('workflow_type', this.workflow_type) : null;

                                if (!this.$parent) {
                                    _context3.next = 8;
                                    break;
                                }

                                _context3.next = 8;
                                return this.$parent.save({ internalFlag: true });

                            case 8:
                                _context3.prev = 8;
                                _context3.next = 11;
                                return _vue2.default.http.post(post_url, payload);

                            case 11:
                                res = _context3.sent;

                                console.log(res);

                                if (!res.ok) {
                                    _context3.next = 15;
                                    break;
                                }

                                return _context3.abrupt("return", res);

                            case 15:
                                _context3.next = 20;
                                break;

                            case 17:
                                _context3.prev = 17;
                                _context3.t0 = _context3["catch"](8);

                                this.errorResponse = _context3.t0.statusText;

                            case 20:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[8, 17]]);
            }));

            function sendData() {
                return _ref3.apply(this, arguments);
            }

            return sendData;
        }()
    }),
    mounted: function () {
        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            this.$nextTick(function () {});

                        case 1:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function mounted() {
            return _ref4.apply(this, arguments);
        }

        return mounted;
    }(),
    created: function created() {
        if (this.workflow_type === 'close') {
            this.modalTitle = "Close Legal Case";
            this.saveAndExit = true;
        } else if (this.workflow_type === 'brief_of_evidence') {
            this.modalTitle = "Generate the Brief of Evidence";
        } else if (this.workflow_type === 'prosecution_brief') {
            this.modalTitle = "Generate the Prosecution Brief";
        } else if (this.workflow_type === 'send_to_manager') {
            this.modalTitle = "Send to Manager for approval";
            this.saveAndExit = true;
        } else if (this.workflow_type === 'back_to_case') {
            this.modalTitle = "Re-open the Case";
        } else if (this.workflow_type === 'back_to_officer') {
            this.modalTitle = "Return to Officer";
            this.saveAndExit = true;
        } else if (this.workflow_type === 'approve_brief_of_evidence') {
            this.modalTitle = "Approve the Brief of Evidence";
            this.saveAndExit = true;
        } else if (this.workflow_type === 'send_to_prosecution_council') {
            this.modalTitle = "Send To Prosecution Council";
            this.saveAndExit = true;
        } else if (this.workflow_type === 'back_to_prosecution_coordinator') {
            this.modalTitle = "Back to Prosecution Coordinator";
            this.saveAndExit = true;
        } else if (this.workflow_type === 'endorse_prosecution_brief') {
            this.modalTitle = "Endorse Prosecution Brief";
            this.saveAndExit = true;
        } else if (this.workflow_type === 'approve_for_court') {
            this.modalTitle = "Approve for Court";
            this.saveAndExit = true;
        } else if (this.workflow_type === 'back_to_prosecution_council') {
            this.modalTitle = "Back to Prosecution Council";
            this.saveAndExit = true;
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "Magic",
    data: function data() {
        return {
            isModalOpen: false
        };
    },
    components: {
        modal: _bootstrapModal2.default
    },
    methods: {
        cancel: function cancel() {
            this.isModalOpen = false;
        },
        ok: function ok() {
            this.isModalOpen = false;
        },
        close: function close() {
            this.isModalOpen = false;
        }
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }()
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _vuex = __webpack_require__(6);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(15);

__webpack_require__(37);

var _lodash = __webpack_require__(31);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueTreeselect = __webpack_require__(102);

var _vueTreeselect2 = _interopRequireDefault(_vueTreeselect);

__webpack_require__(121);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    name: "ViewProsecutionBrief",
    data: function data() {
        return {
            uuid: 0
        };
    },
    components: {
        FormSection: _section_toggle2.default,
        TreeSelect: _vueTreeselect2.default,
        filefield: _compliance_file2.default
    },

    props: {
        readonly: {
            type: Boolean,
            default: true
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        csrf_token: function csrf_token() {
            return _hooks.helpers.getCookie("csrftoken");
        },
        prosecutionBrief: function prosecutionBrief() {
            if (this.legal_case && this.legal_case.prosecution_brief) {
                return this.legal_case.prosecution_brief;
            } else {
                return {};
            }
        },
        physicalArtifactsUsed: function physicalArtifactsUsed() {
            var options = [];
            if (this.legal_case && this.legal_case.pb_physical_artifacts_used) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.legal_case.pb_physical_artifacts_used), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var option = _step.value;

                        options.push(option);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return options;
        },
        physicalArtifactsUsedVisibility: function physicalArtifactsUsedVisibility() {
            var visible = false;
            if (this.physicalArtifactsUsed && this.physicalArtifactsUsed.length > 0) {
                visible = true;
            }
            return visible;
        },
        physicalArtifactsSensitiveUnused: function physicalArtifactsSensitiveUnused() {
            var options = [];
            if (this.legal_case && this.legal_case.pb_physical_artifacts_sensitive_unused) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)(this.legal_case.pb_physical_artifacts_sensitive_unused), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var option = _step2.value;

                        options.push(option);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            return options;
        },
        physicalArtifactsSensitiveUnusedVisibility: function physicalArtifactsSensitiveUnusedVisibility() {
            var visible = false;
            if (this.physicalArtifactsSensitiveUnused && this.physicalArtifactsSensitiveUnused.length > 0) {
                visible = true;
            }
            return visible;
        },
        physicalArtifactsNonSensitiveUnused: function physicalArtifactsNonSensitiveUnused() {
            var options = [];
            if (this.legal_case && this.legal_case.pb_physical_artifacts_non_sensitive_unused) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(this.legal_case.pb_physical_artifacts_non_sensitive_unused), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var option = _step3.value;

                        options.push(option);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            return options;
        },
        physicalArtifactsNonSensitiveUnusedVisibility: function physicalArtifactsNonSensitiveUnusedVisibility() {
            var visible = false;
            if (this.physicalArtifactsNonSensitiveUnused && this.physicalArtifactsNonSensitiveUnused.length > 0) {
                visible = true;
            }
            return visible;
        },
        readonlyForm: function readonlyForm() {
            var readonly = true;
            if (this.legal_case && this.legal_case.id && !this.readonly) {
                readonly = !this.legal_case.can_user_action;
            }
            return readonly;
        },
        readonlyProsecutionBrief: function readonlyProsecutionBrief() {
            var readonly = true;
            if (this.legal_case && this.legal_case.id) {
                readonly = !this.legal_case.can_user_action;
            }
            return readonly;
        },
        canUserAction: function canUserAction() {
            var return_val = false;
            if (this.legal_case && this.legal_case.id) {
                return_val = this.legal_case.can_user_action;
            }
            return return_val;
        },
        pbRoiTicked: function pbRoiTicked() {
            var ticked = [];
            if (this.legal_case && this.legal_case.pb_roi_ticked) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = (0, _getIterator3.default)(this.legal_case.pb_roi_ticked), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var id = _step4.value;

                        ticked.push(id);
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            return ticked;
        },
        pbOtherStatementsTicked: function pbOtherStatementsTicked() {
            var ticked = [];
            if (this.legal_case && this.legal_case.pb_other_statements_ticked) {
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = (0, _getIterator3.default)(this.legal_case.pb_other_statements_ticked), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var id = _step5.value;

                        ticked.push(id);
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            }
            return ticked;
        },
        pbOtherStatementsOptions: function pbOtherStatementsOptions() {
            var options = [];
            if (this.legal_case && this.legal_case.pb_other_statements_options) {
                options = this.legal_case.pb_other_statements_options;
            }
            return options;
        },
        pbOtherStatementsExist: function pbOtherStatementsExist() {
            var visibility = false;
            if (this.pbOtherStatementsOptions && this.pbOtherStatementsOptions.length > 0) {
                visibility = true;
            }
            return visibility;
        },
        pbOtherStatementsVisibility: function pbOtherStatementsVisibility() {
            var visibility = false;
            if (!this.readonlyForm && this.pbOtherStatementsExist) {
                visibility = true;
            }
            return visibility;
        },
        pbRoiOptions: function pbRoiOptions() {
            var options = [];
            if (this.legal_case && this.legal_case.pb_roi_options) {
                options = this.legal_case.pb_roi_options;
            }
            return options;
        },
        pbRoiExist: function pbRoiExist() {
            var visibility = false;
            if (this.pbRoiOptions && this.pbRoiOptions.length > 0) {
                visibility = true;
            }
            return visibility;
        },
        pbRoiVisibility: function pbRoiVisibility() {
            var visibility = false;
            if (!this.readonlyForm && this.pbRoiExist) {
                visibility = true;
            }
            return visibility;
        },
        documentArtifacts: function documentArtifacts() {
            var options = [];
            if (this.legal_case && this.legal_case.pb_document_artifacts) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = (0, _getIterator3.default)(this.legal_case.pb_document_artifacts), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var option = _step6.value;

                        options.push(option);
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }
            return options;
        },
        documentArtifactsVisibility: function documentArtifactsVisibility() {
            var visible = false;
            if (this.documentArtifacts && this.documentArtifacts.length > 0) {
                visible = true;
            }
            return visible;
        }

    }),
    filters: {
        formatDate: function formatDate(data) {
            return data ? (0, _moment2.default)(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('legalCaseStore', {
        loadLegalCase: 'loadLegalCase',
        saveLegalCase: 'saveLegalCase',
        setLegalCase: 'setLegalCase',
        setPbRoiTicked: 'setBoeRoiTicked',
        setPbOtherStatementsTicked: 'setPbOtherStatementsTicked',
        setPbPhysicalArtifactsTicked: 'setPbPhysicalArtifactsTicked',
        setPbDocumentArtifactsTicked: 'setPbDocumentArtifactsTicked'
    })),
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        this.$nextTick(function () {
            $('.vue-treeselect__control').css("display", "none");
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(85);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _validators = __webpack_require__(84);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "RunningSheetHistory",
    data: function data() {
        return {
            isModalOpen: false,
            processingDetails: false,
            errorResponse: "",
            runningSheetHist: [],
            dtHeadersRunningSheetHistory: ["date_modified", "Date", "Time", "User", "Description", "deleted"],
            dtOptionsRunningSheetHistory: {
                order: [[1, 'desc']],

                columns: [{
                    data: 'id',
                    visible: false,
                    mRender: function mRender(data, type, row) {
                        return row.date_modified;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, row) {
                        var retStr = row.date_mod;
                        return retStr;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, row) {
                        var retStr = row.time_mod;
                        return retStr;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, row) {
                        var retStr = row.user_full_name;
                        return retStr;
                    }
                }, {
                    data: 'id',
                    mRender: function mRender(data, type, row) {
                        var retStr = '';
                        retStr = "<div id=" + row.number + " style=\"min-height:20px\" contenteditable=\"false\">" + row.description + "</div>";
                        if (row.deleted) {
                            retStr = '<strike>' + retStr + '</strike>';
                        }
                        return retStr;
                    }
                }, {
                    data: 'id',
                    visible: false,
                    mRender: function mRender(data, type, row) {
                        return row.deleted;
                    }
                }]
            }
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        datatable: _datatable2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('legalCaseStore', {
        legal_case: "legal_case"
    }), {
        modalTitle: function modalTitle() {
            return "Running Sheet History - " + this.runningSheetHistoryEntryInstance;
        }
    }),
    props: {
        runningSheetHistoryEntryInstance: {
            required: true
        }
    },
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format("DD/MM/YYYY HH:mm:ss") : "";
        }
    },
    methods: {
        tokenToHtml: function tokenToHtml(description) {
            var parsedText = description;

            var personTokenRegex = /\{\{ \"person\_id\"\: \"\d+\"\, \"full\_name\"\: \"\w+(\s\w+)*\" \}\}/g;
            var personIdRegex = /\{\{ \"person\_id\"\: \"\d+/g;

            var personNameRegex = /\"full\_name\"\: \"\w+(\s\w+)*/g;
            var personTokenArray = [].concat((0, _toConsumableArray3.default)(description.matchAll(personTokenRegex)));
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(personTokenArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var personToken = _step.value;

                    var personIdArray = [].concat((0, _toConsumableArray3.default)(personToken[0].matchAll(personIdRegex)));
                    var personIdStr = personIdArray[0][0];
                    var personId = personIdStr.substring(17);
                    var nameArray = [].concat((0, _toConsumableArray3.default)(personToken[0].matchAll(personNameRegex)));
                    if (nameArray && nameArray.length > 0) {
                        var nameStr = nameArray[0][0];
                        var fullName = nameStr.substring(14);
                        parsedText = parsedText.replace(personToken[0], "<span contenteditable=\"false\" id=\"individual-" + personId + "\" class=\"entity_edit\">" + fullName + "</span>");
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var artifactTokenRegex = /\{\{ \"\w+\_artifact\_id\"\: \"\d+\"\, \"identifier\"\: \"\w+(\s\w+)*\" \}\}/g;
            var artifactIdRegex = /\w+\_artifact\_id\"\: \"\d+/g;

            var artifactIdentifierRegex = /\"identifier\"\: \"\w+(\s\w+)*/g;
            var artifactTokenArray = [].concat((0, _toConsumableArray3.default)(description.matchAll(artifactTokenRegex)));
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(artifactTokenArray), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var artifactToken = _step2.value;

                    var artifactIdArray = [].concat((0, _toConsumableArray3.default)(artifactToken[0].matchAll(artifactIdRegex)));
                    var artifactIdStr = artifactIdArray[0][0];
                    var artifactType = artifactIdStr.split("_")[0] + "_artifact";
                    var artifactIdStrTrunc = artifactIdStr.split("_")[2];
                    var artifactId = artifactIdStrTrunc.substring(6);
                    var identifierArray = [].concat((0, _toConsumableArray3.default)(artifactToken[0].matchAll(artifactIdentifierRegex)));
                    if (identifierArray && identifierArray.length > 0) {
                        var identifierStr = identifierArray[0][0];
                        var identifier = identifierStr.substr(15);
                        var elemId = artifactType + "-" + artifactId;
                        parsedText = parsedText.replace(artifactToken[0], "<span contenteditable=\"false\" id=\"" + elemId + "\" class=\"entity_edit\">" + identifier + "</span>");
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return parsedText;
        },

        constructRunningSheetTable: function constructRunningSheetTable() {
            console.log("constructInstanceRunningSheetTable");
            this.$refs.running_sheet_hist_instance.vmDataTable.clear().draw();
            var actionColumn = !this.readonlyForm;
            if (this.runningSheetHist) {
                for (var i = 0; i < this.runningSheetHist.length; i++) {
                    this.$refs.running_sheet_hist_instance.vmDataTable.row.add({
                        "id": this.runningSheetHist[i].id,
                        "number": this.runningSheetHist[i].number,
                        "date_modified": this.runningSheetHist[i].date_modified,
                        "date_mod": this.runningSheetHist[i].date_mod,
                        "time_mod": this.runningSheetHist[i].time_mod,
                        "user_full_name": this.runningSheetHist[i].user_full_name,
                        "description": this.runningSheetHist[i].description,
                        "deleted": this.runningSheetHist[i].deleted,
                        "action": actionColumn
                    }).draw();
                }
            }
            console.log("constructRunningSheetTable - end");
        },
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.close();

                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        cancel: function cancel() {
            this.isModalOpen = false;
            this.close();
        },
        close: function close() {
            this.isModalOpen = false;
        }
    },
    created: function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var _this = this;

            var fetchUrl, returnedRunningSheetHist, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, v, entryVersion;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, this.legal_case.id + "/running_sheet_history/");
                            _context2.next = 3;
                            return _vue2.default.http.post(fetchUrl, { "running_sheet_entry_number": this.runningSheetHistoryEntryInstance });

                        case 3:
                            returnedRunningSheetHist = _context2.sent;

                            if (!(returnedRunningSheetHist && returnedRunningSheetHist.body)) {
                                _context2.next = 24;
                                break;
                            }

                            _iteratorNormalCompletion3 = true;
                            _didIteratorError3 = false;
                            _iteratorError3 = undefined;
                            _context2.prev = 8;

                            for (_iterator3 = (0, _getIterator3.default)(returnedRunningSheetHist.body.versions); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                v = _step3.value;
                                entryVersion = _.cloneDeep(v.entry_fields);

                                entryVersion.description = this.tokenToHtml(entryVersion.description);
                                this.runningSheetHist.push(entryVersion);
                            }
                            _context2.next = 16;
                            break;

                        case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2["catch"](8);
                            _didIteratorError3 = true;
                            _iteratorError3 = _context2.t0;

                        case 16:
                            _context2.prev = 16;
                            _context2.prev = 17;

                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }

                        case 19:
                            _context2.prev = 19;

                            if (!_didIteratorError3) {
                                _context2.next = 22;
                                break;
                            }

                            throw _iteratorError3;

                        case 22:
                            return _context2.finish(19);

                        case 23:
                            return _context2.finish(16);

                        case 24:
                            this.$nextTick(function () {
                                _this.constructRunningSheetTable();
                            });

                        case 25:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[8, 12, 16, 24], [17,, 19, 23]]);
        }));

        function created() {
            return _ref2.apply(this, arguments);
        }

        return created;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(31)))

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _licences_dashboard = __webpack_require__(94);

var _licences_dashboard2 = _interopRequireDefault(_licences_dashboard);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'InternalLicenceDashboard',
    data: function data() {
        var vm = this;
        return {
            licences_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.licences_paginated, 'internal_datatable_list/?format=datatables')
        };
    },

    watch: {},
    components: {
        LicenceDashTable: _licences_dashboard2.default
    },
    computed: {},
    methods: {},
    mounted: function mounted() {}
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: "schema-add-expander",
    props: {
        addedExpanders: Array,
        answerTypes: Array
    },
    data: function data() {
        var vm = this;
        return {
            pExpanderBody: 'pExpanderBody' + vm._uid,
            addedExpander: {
                label: '',
                value: '',
                conditions: null
            }
        };
    },
    computed: {},
    methods: {
        addExpander: function addExpander() {
            var newExpander = Object();
            newExpander.label = '';
            newExpander.value = '';
            newExpander.conditions = null;
            this.addedExpanders.push(newExpander);
        },
        removeExpander: function removeExpander() {
            var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            this.addedExpanders.splice(id, 1);
        }
    }
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = __webpack_require__(104);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "schema-add-header",
    props: {
        addedHeaders: Array,
        answerTypes: Array
    },
    data: function data() {
        var vm = this;
        return {
            pHeaderBody: 'pHeaderBody' + vm._uid,
            addedHeader: {
                label: '',
                value: '',
                colSize: ''
            },
            colSizeValues: (0, _from2.default)({ length: 13 }, function (_, index) {
                return index === 0 ? null : index;
            }),
            colSizeInfoMsg: "When entering values for all headers, make sure the total sum is 12. You have two options for each header: either select a custom size or leave it blank. If you select a custom size, ensure that all headers have a value, and the sum of all selected values equals 12. If you want equal column sizes, leave all headers blank."
        };
    },
    computed: {},
    methods: {
        addHeader: function addHeader() {
            var newHeader = Object();
            newHeader.label = '';
            newHeader.value = '';
            newHeader.colSize = '';
            this.addedHeaders.push(newHeader);
        },
        removeHeader: function removeHeader() {
            var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            this.addedHeaders.splice(id, 1);
        }
    }
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "schema-add-option",
    props: {
        addedOptions: Array,
        canAddMore: Boolean
    },
    data: function data() {
        var vm = this;
        return {
            pOptionBody: 'pOptionBody' + vm._uid,
            addedOption: {
                id: '',
                label: '',
                value: '',
                conditions: null
            },
            checkedConditions: [{
                id: null,
                value: null,
                addedOption: null,
                isChecked: false,
                isDisplay: false
            }]
        };
    },
    computed: {},
    methods: {
        addOption: function addOption() {
            this.addedOptions.push((0, _assign2.default)({}, this.addedOption));
        },
        getCheckedConditions: function getCheckedConditions(o, c) {
            var checked = this.checkedConditions.find(function (ch) {
                return ch.id === c.label && ch.value === c.value && ch.addedOption == o;
            });
            if (checked) {

                var is_display = checked.isChecked && typeof c.value !== 'boolean' ? true : false;
                checked.isDisplay = is_display;
                if (typeof c.value === 'boolean') {
                    c.value = checked.isChecked ? true : false;
                    checked.value = checked.isChecked ? true : false;
                }
            } else {

                var is_checked = c.value ? true : false;
                var _is_display = is_checked && typeof c.value !== 'boolean' ? true : false;
                checked = {
                    id: c.label,
                    value: c.value,
                    addedOption: o,
                    isChecked: is_checked,
                    isDisplay: _is_display
                };
                this.checkedConditions.push(checked);
            }
            return checked;
        },
        removeOption: function removeOption() {
            var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            this.addedOptions.splice(id, 1);
        }
    }
};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'schema-group',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default,
        datatable: _datatable2.default
    },
    props: {},
    watch: {
        filterTablePurpose: function filterTablePurpose() {
            this.$refs.schema_group_table.vmDataTable.draw();
        },
        filterTableSection: function filterTableSection() {
            this.$refs.schema_group_table.vmDataTable.draw();
        },
        filterGroupSection: function filterGroupSection() {
            var _this = this;

            this.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_group, '1/get_group_sections'), {
                params: { licence_purpose_id: this.filterGroupSection }
            }).then(function (res) {
                _this.schemaSections = res.body.group_sections;
            }, function (err) {});
        }
    },
    data: function data() {
        var vm = this;
        vm.schema_group_url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.schema_group_paginated, 'schema_group_datatable_list/?format=datatables');
        return {
            schema_group_id: 'schema-group-datatable-' + vm._uid,
            pGroupBody: 'pGroupBody' + vm._uid,
            isModalOpen: false,
            missing_fields: [],
            filterTablePurpose: 'All',
            filterTableSection: 'All',
            filterGroupSection: 'All',
            dtHeadersSchemaGroup: ["ID", "Licence Purpose", "Section Label", "Group Label", "Action"],
            dtOptionsSchemaGroup: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                searchDelay: 1000,
                responsive: true,
                serverSide: true,
                autowidth: false,
                processing: true,
                ajax: {
                    "url": vm.schema_group_url,
                    "dataSrc": 'data',
                    "data": function data(d) {
                        d.licence_purpose_id = vm.filterTablePurpose;
                        d.section_id = vm.filterTableSection;
                    }
                },
                columnDefs: [{ visible: false, targets: [0] }],
                columns: [{
                    data: "id",
                    width: "10%",
                    searchable: false
                }, {
                    data: "licence_purpose",
                    width: "20%",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        return data.name;
                    }
                }, {
                    data: "section",
                    width: "20%",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        return data.section_label;
                    }
                }, {
                    data: "group_label",
                    width: "60%",
                    searchable: false
                }, {
                    data: "id",
                    width: "10%",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        var column = '<a class="edit-row" data-rowid="__ROWID__">Edit</a><br/>';
                        column += '<a class="delete-row" data-rowid="__ROWID__">Delete</a><br/>';
                        return column.replace(/__ROWID__/g, full.id);
                    }
                }],
                rowId: function rowId(_data) {
                    return _data.id;
                },
                initComplete: function initComplete() {
                    var $searchInput = $('div.dataTables_filter input');
                    $searchInput.unbind('keyup search input');
                    $searchInput.bind('keypress', vm.delay(function (e) {
                        if (e.which == 13) {
                            vm.$refs.schema_group_table.vmDataTable.search(this.value).draw();
                        }
                    }, 0));
                }
            },
            licence_purpose: '',
            schemaPurposes: [],
            schemaSections: [],
            sectionGroup: {
                id: '',
                group_name: '',
                group_label: '',
                section: 'All',
                repeatable: false
            },
            checkedRepeatable: [{
                id: null,
                isChecked: false
            }]
        };
    },
    computed: {},
    methods: {
        getCheckedRepeatable: function getCheckedRepeatable(anID) {
            var set_checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var checked = this.checkedRepeatable.find(function (r) {
                return r.id == anID;
            });
            if (!checked) {
                checked = {
                    id: anID,
                    isChecked: set_checked
                };
                if (['isRepeatable'].includes(anID)) {
                    this.checkedRepeatable.push(checked);
                }
            }
            return checked;
        },
        delay: function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        },

        close: function close() {
            var self = this;

            if (!self.errors) {

                self.isModalOpen = false;
            }
        },
        saveGroup: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var self, data;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = this;
                                data = self.sectionGroup;


                                data.repeatable = false;
                                if (self.checkedRepeatable.length > 0) {
                                    self.checkedRepeatable.filter(function (r) {
                                        if (r.isChecked) {
                                            data.repeatable = true;
                                        }
                                        return;
                                    });
                                }

                                if (!(data.id === '')) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 7;
                                return self.$http.post(_hooks.api_endpoints.schema_group, (0, _stringify2.default)(data), {
                                    emulateJSON: true

                                }).then(function (response) {

                                    self.$refs.schema_group_table.vmDataTable.ajax.reload();
                                    self.close();
                                }, function (error) {
                                    swal('Save Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 7:
                                _context.next = 11;
                                break;

                            case 9:
                                _context.next = 11;
                                return self.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_group, data.id + '/save_group'), (0, _stringify2.default)(data), {
                                    emulateJSON: true

                                }).then(function (response) {

                                    self.$refs.schema_group_table.vmDataTable.ajax.reload();
                                    self.close();
                                }, function (error) {
                                    swal('Save Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function saveGroup() {
                return _ref.apply(this, arguments);
            }

            return saveGroup;
        }(),
        cancel: function cancel() {
            var self = this;
            self.isModalOpen = false;
        },
        addTableEntry: function addTableEntry() {
            this.licence_purpose = '';

            this.sectionGroup.id = '';
            this.sectionGroup.group_name = '';
            this.sectionGroup.group_label = '';
            this.sectionGroup.section = 'All';
            this.sectionGroup.repeatable = false;
            this.checkedRepeatable = [];

            this.isModalOpen = true;
        },
        initEventListeners: function initEventListeners() {
            var self = this;

            self.$refs.schema_group_table.vmDataTable.on('click', '.edit-row', function (e) {
                e.preventDefault();
                self.$refs.schema_group_table.row_of_data = self.$refs.schema_group_table.vmDataTable.row('#' + $(this).attr('data-rowid'));

                self.sectionGroup.id = self.$refs.schema_group_table.row_of_data.data().id;
                self.sectionGroup.section = self.$refs.schema_group_table.row_of_data.data().section.id;
                self.sectionGroup.group_label = self.$refs.schema_group_table.row_of_data.data().group_label;
                self.filterGroupSection = self.$refs.schema_group_table.row_of_data.data().licence_purpose.id;

                self.sectionGroup.repeatable = self.$refs.schema_group_table.row_of_data.data().repeatable;
                self.checkedRepeatable = [];
                self.getCheckedRepeatable('isRepeatable', self.sectionGroup.repeatable);

                self.isModalOpen = true;
            });

            self.$refs.schema_group_table.vmDataTable.on('click', '.delete-row', function (e) {
                var _this2 = this;

                e.preventDefault();
                self.$refs.schema_group_table.row_of_data = self.$refs.schema_group_table.vmDataTable.row('#' + $(this).attr('data-rowid'));
                self.sectionGroup.id = self.$refs.schema_group_table.row_of_data.data().id;

                swal({
                    title: "Delete Section Group",
                    text: "Are you sure you want to delete?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'

                }).then(function () {
                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(result) {
                        return _regenerator2.default.wrap(function _callee2$(_context2) {
                            while (1) {
                                switch (_context2.prev = _context2.next) {
                                    case 0:
                                        if (!result.value) {
                                            _context2.next = 3;
                                            break;
                                        }

                                        _context2.next = 3;
                                        return self.$http.delete(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_group, self.sectionGroup.id + '/delete_group')).then(function (response) {

                                            self.$refs.schema_group_table.vmDataTable.ajax.reload();
                                        }, function (error) {});

                                    case 3:
                                    case 'end':
                                        return _context2.stop();
                                }
                            }
                        }, _callee2, _this2);
                    }));

                    return function (_x2) {
                        return _ref2.apply(this, arguments);
                    };
                }(), function (error) {});
            });
        },
        initSelects: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var _this3 = this;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$http.get(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.schema_group, '1/get_group_selects')).then(function (res) {

                                    _this3.schemaPurposes = res.body.all_purpose;
                                    _this3.schemaSections = res.body.all_section;
                                }, function (err) {

                                    swal('Get Application Selects Error', _hooks.helpers.apiVueResourceError(err), 'error');
                                });

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function initSelects() {
                return _ref3.apply(this, arguments);
            }

            return initSelects;
        }()
    },
    mounted: function mounted() {
        var _this4 = this;

        this.form = document.forms.schema_group;
        this.$nextTick(function () {
            _this4.initEventListeners();
            _this4.initSelects();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tab = __webpack_require__(839);

var _tab2 = _interopRequireDefault(_tab);

var _schema_question = __webpack_require__(878);

var _schema_question2 = _interopRequireDefault(_schema_question);

var _schema_masterlist = __webpack_require__(876);

var _schema_masterlist2 = _interopRequireDefault(_schema_masterlist);

var _schema_purpose = __webpack_require__(877);

var _schema_purpose2 = _interopRequireDefault(_schema_purpose);

var _schema_group = __webpack_require__(874);

var _schema_group2 = _interopRequireDefault(_schema_group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'schema-manager',
    components: {
        SchemaTabs: _tab2.default,
        SchemaQuestion: _schema_question2.default,
        SchemaMasterlist: _schema_masterlist2.default,
        SchemaPurpose: _schema_purpose2.default,
        SchemaGroup: _schema_group2.default
    },
    data: function data() {
        return {
            initialTab: 'masterlist',
            tabs: [{ 'masterlist': 'Schema Masterlist' }, { 'purpose': 'Purpose Sections' }, { 'group': 'Section Groups' }, { 'question': 'Section Questions' }]
        };
    }
};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _schema_add_option = __webpack_require__(346);

var _schema_add_option2 = _interopRequireDefault(_schema_add_option);

var _schema_add_header = __webpack_require__(873);

var _schema_add_header2 = _interopRequireDefault(_schema_add_header);

var _schema_add_expander = __webpack_require__(872);

var _schema_add_expander2 = _interopRequireDefault(_schema_add_expander);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'schemaMasterlistModal',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default,
        datatable: _datatable2.default,
        SchemaOption: _schema_add_option2.default,
        SchemaHeader: _schema_add_header2.default,
        SchemaExpander: _schema_add_expander2.default
    },
    props: {},
    data: function data() {
        var vm = this;
        vm.schema_masterlist_url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.schema_masterlist_paginated, 'schema_masterlist_datatable_list/?format=datatables');
        return {
            schema_masterlist_id: 'schema-materlist-datatable-' + vm._uid,
            pMasterListBody: 'pMasterListBody' + vm._uid,
            pOptionBody: 'pOptionBody' + vm._uid,
            pHeaderBody: 'pHeaderBody' + vm._uid,
            pExpanderBody: 'pOptionBody' + vm._uid,
            filterOptions: '',
            isModalOpen: false,
            missing_fields: [],

            dtHeadersSchemaMasterlist: ["ID", "QuestionOP", "QuestionHD", "QuestionEX", "Question", "Answer Type", "Action"],
            dtOptionsSchemaMasterlist: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                serverSide: true,
                autowidth: false,
                processing: true,
                ajax: {
                    "url": vm.schema_masterlist_url
                },
                columnDefs: [{ visible: false, targets: [0, 1, 2, 3] }],
                columns: [{
                    data: "id"
                }, {
                    data: "options"
                }, {
                    data: "headers"
                }, {
                    data: "expanders"
                }, {
                    data: "question",
                    width: "80%",
                    mRender: function mRender(data, type, full) {
                        var ellipsis = '...',
                            truncated = _.truncate(data, {
                            length: 100,
                            omission: ellipsis,
                            separator: ' '
                        }),
                            result = '<span>' + truncated + '</span>',
                            popTemplate = _.template('<a href="#" ' + 'role="button" ' + 'data-toggle="popover" ' + 'data-trigger="click" ' + 'data-placement="top auto"' + 'data-html="true" ' + 'data-content="<%= text %>" ' + '>more</a>');
                        if (_.endsWith(truncated, ellipsis)) {
                            result += popTemplate({
                                text: data
                            });
                        }

                        return result;
                    },
                    'createdCell': _hooks.helpers.dtPopoverCellFn
                }, {
                    data: "answer_type",
                    width: "10%"
                }, {
                    data: "id",
                    width: "10%",
                    mRender: function mRender(data, type, full) {
                        var column = '<a class="edit-row" data-rowid="__ROWID__">Edit</a><br/>';
                        column += '<a class="delete-row" data-rowid="__ROWID__">Delete</a><br/>';
                        return column.replace(/__ROWID__/g, full.id);
                    }
                }],
                rowId: function rowId(_data) {
                    return _data.id;
                },
                initComplete: function initComplete() {
                    var $searchInput = $('div.dataTables_filter input');
                    $searchInput.unbind('keyup search input');
                    $searchInput.bind('keypress', vm.delay(function (e) {
                        if (e.which == 13) {
                            vm.$refs.schema_masterlist_table.vmDataTable.search(this.value).draw();
                        }
                    }, 0));
                }
            },
            masterlist: {
                id: '',
                name: '',
                question: '',
                answer_type: '',
                options: null,
                headers: null,
                expanders: null,
                help_text_url: ''
            },
            answerTypes: [],
            addedHeaders: [],
            addedHeader: {
                label: '',
                value: '',
                colSize: ''
            },
            addedExpanders: [],
            addedExpander: {
                label: '',
                value: ''
            },
            showOptions: false,
            showTables: false,
            addedOptions: [],
            addedOption: {
                id: '',
                label: '',
                value: ''
            },
            isNewEntry: false
        };
    },
    watch: {},
    computed: {},
    methods: {
        delay: function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        },

        setShowAdditional: function setShowAdditional(selected_id) {
            var table = ['expander_table'];
            var option = ['radiobuttons', 'checkbox', 'select', 'multi-select'];
            var q_type = this.answerTypes.find(function (t) {
                return t.value === selected_id && (table.includes(t.value) || option.includes(t.value));
            });

            this.showOptions = q_type && option.includes(q_type.value) ? true : false;
            this.showTables = q_type && table.includes(q_type.value) ? true : false;

            if (this.showOptions) {
                if (this.isNewEntry) {
                    this.addedOption.id = '';
                    this.addedOption.label = '';
                    this.addedOption.value = '';
                    var newOption = (0, _assign2.default)(this.addedOption);
                    this.addedOptions.push(newOption);
                } else {
                    if (this.addedOptions.length == 0) {
                        this.addedOption.id = '';
                        this.addedOption.label = '';
                        this.addedOption.value = '';
                        var _newOption = (0, _assign2.default)(this.addedOption);
                        this.addedOptions.push(_newOption);
                    }
                }
            }

            if (this.showTables && this.isNewEntry) {
                var newHeader = (0, _assign2.default)(this.addedHeader);
                this.addedHeaders.push(newHeader);
                var newExpander = (0, _assign2.default)(this.addedExpander);
                this.addedExpanders.push(newExpander);
            }
        },
        addOption: function addOption() {
            this.addedOptions.push((0, _assign2.default)(this.addedOption));
        },
        addHeader: function addHeader() {
            this.addedHeaders.push((0, _assign2.default)(this.addedHeader));
        },
        addExpander: function addExpander() {
            this.addedExpanders.push((0, _assign2.default)(this.addedExpander));
        },
        close: function close() {
            var self = this;

            if (!self.errors) {
                $(this.$refs.select_answer_type).val(null).trigger('change');
                $('.has-error').removeClass('has-error');
                var header_name = 'header-answer-type-0';
                $('[name=\'' + header_name + ']').removeClass('header-answer-type-0');
                self.addedOptions = [];
                self.addedHeaders = [];
                self.addedExpanders = [];

                self.showOptions = false;
                self.showTables = false;
                self.isModalOpen = false;
            }
        },
        saveMasterlist: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var self, data;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = this;
                                data = self.masterlist;

                                data.options = this.addedOptions;
                                data.headers = this.addedHeaders;
                                data.expanders = this.addedExpanders;

                                if (!(data.id === '')) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 8;
                                return self.$http.post(_hooks.api_endpoints.schema_masterlist, (0, _stringify2.default)(data), {
                                    emulateJSON: true
                                }).then(function (response) {
                                    self.$refs.schema_masterlist_table.vmDataTable.ajax.reload();
                                    self.close();
                                }, function (error) {
                                    swal('Save Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 8:
                                _context.next = 12;
                                break;

                            case 10:
                                _context.next = 12;
                                return self.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_masterlist, data.id + '/save_masterlist'), (0, _stringify2.default)(data), {
                                    emulateJSON: true
                                }).then(function (response) {
                                    self.$refs.schema_masterlist_table.vmDataTable.ajax.reload();
                                    self.close();
                                }, function (error) {
                                    swal('Save Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 12:
                                this.isNewEntry = false;

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function saveMasterlist() {
                return _ref.apply(this, arguments);
            }

            return saveMasterlist;
        }(),
        addTableEntry: function addTableEntry() {
            this.isNewEntry = true;
            this.masterlist.answer_type = '';
            this.masterlist.question = '';
            this.masterlist.id = '';
            this.addedOptions = [];
            this.addedHeaders = [];
            this.addedExpanders = [];
            this.masterlist.help_text_url = '';
            this.showOptions = false;
            this.isModalOpen = true;
        },
        initEventListeners: function initEventListeners() {
            var self = this;

            self.$refs.schema_masterlist_table.vmDataTable.on('click', '.edit-row', function (e) {
                e.preventDefault();
                self.isNewEntry = false;
                self.$refs.schema_masterlist_table.row_of_data = self.$refs.schema_masterlist_table.vmDataTable.row('#' + $(this).attr('data-rowid'));

                self.masterlist.id = self.$refs.schema_masterlist_table.row_of_data.data().id;
                self.masterlist.answer_type = self.$refs.schema_masterlist_table.row_of_data.data().answer_type;
                self.masterlist.question = self.$refs.schema_masterlist_table.row_of_data.data().question;
                self.addedOptions = self.$refs.schema_masterlist_table.row_of_data.data().options;
                self.addedHeaders = self.$refs.schema_masterlist_table.row_of_data.data().headers;
                self.addedExpanders = self.$refs.schema_masterlist_table.row_of_data.data().expanders;
                self.masterlist.help_text_url = self.$refs.schema_masterlist_table.row_of_data.data().help_text_url;

                $(self.$refs.select_answer_type).val(self.masterlist.answer_type).trigger('change');
                self.setShowAdditional(self.masterlist.answer_type);
                self.isModalOpen = true;
            });

            self.$refs.schema_masterlist_table.vmDataTable.on('click', '.delete-row', function (e) {
                var _this = this;

                e.preventDefault();
                self.$refs.schema_masterlist_table.row_of_data = self.$refs.schema_masterlist_table.vmDataTable.row('#' + $(this).attr('data-rowid'));
                self.masterlist.id = self.$refs.schema_masterlist_table.row_of_data.data().id;

                swal({
                    title: "Delete Masterlist",
                    text: "Are you sure you want to delete?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'

                }).then(function () {
                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(result) {
                        return _regenerator2.default.wrap(function _callee2$(_context2) {
                            while (1) {
                                switch (_context2.prev = _context2.next) {
                                    case 0:
                                        if (!result.value) {
                                            _context2.next = 3;
                                            break;
                                        }

                                        _context2.next = 3;
                                        return self.$http.delete(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_masterlist, self.masterlist.id + '/delete_masterlist')).then(function (response) {
                                            self.$refs.schema_masterlist_table.vmDataTable.ajax.reload();
                                        }, function (error) {
                                            swal('Delete Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                        });

                                    case 3:
                                    case 'end':
                                        return _context2.stop();
                                }
                            }
                        }, _callee2, _this);
                    }));

                    return function (_x) {
                        return _ref2.apply(this, arguments);
                    };
                }(), function (error) {});
            });
        },
        initAnswerTypeSelector: function initAnswerTypeSelector() {
            var self = this;
            $(self.$refs.select_answer_type).select2({
                "theme": "bootstrap",
                placeholder: "Select Answer Type..."
            }).on("select2:selecting", function (e) {
                var selected = $(e.currentTarget);
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                self.masterlist.answer_type = selected.val();
                self.setShowAdditional(selected.val());
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                self.masterlist.answer_type = selected.val();
            });
        },
        initHeaderAnswerTypeSelector: function initHeaderAnswerTypeSelector(index) {
            var self = this;
            var header_name = 'header-answer-type-' + index;
            $('[name=\'' + header_name + ']').select2({
                "theme": "bootstrap",
                placeholder: "Select Answer Type..."
            }).on("select2:selecting", function (e) {
                var selected = $(e.currentTarget);
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                self.masterlist.answer_type = selected.val();
            });
        },
        initSelects: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var _this2 = this;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$http.get(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.schema_masterlist, '1/get_masterlist_selects')).then(function (res) {

                                    _this2.answerTypes = res.body.all_answer_types;
                                }, function (err) {
                                    swal('Get Application Selects Error', _hooks.helpers.apiVueResourceError(err), 'error');
                                });

                            case 2:
                                this.initAnswerTypeSelector();

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function initSelects() {
                return _ref3.apply(this, arguments);
            }

            return initSelects;
        }()
    },
    mounted: function mounted() {
        var _this3 = this;

        this.form = document.forms.schema_masterlist;
        this.$nextTick(function () {
            _this3.initEventListeners();
            _this3.initSelects();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'schema-purpose',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default,
        datatable: _datatable2.default
    },
    props: {},
    watch: {
        filterTablePurpose: function filterTablePurpose() {
            this.$refs.schema_purpose_table.vmDataTable.draw();
        }
    },
    data: function data() {
        var vm = this;
        vm.schema_purpose_url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.schema_purpose_paginated, 'schema_purpose_datatable_list/?format=datatables');
        return {
            schema_purpose_id: 'schema-purpose-datatable-' + vm._uid,
            pPurposeBody: 'pPurposeBody' + vm._uid,
            isModalOpen: false,
            missing_fields: [],
            filterTablePurpose: 'All',
            filterPurposeSection: 'All',

            dtHeadersSchemaPurpose: ["ID", "Licence Purpose", "Section Label", "Index", "Action"],
            dtOptionsSchemaPurpose: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                searchDelay: 1000,
                responsive: true,
                serverSide: true,
                autowidth: false,
                processing: true,
                ajax: {
                    "url": vm.schema_purpose_url,
                    "dataSrc": 'data',
                    "data": function data(d) {
                        d.licence_purpose_id = vm.filterTablePurpose;
                    }
                },
                columnDefs: [{ visible: false, targets: [0] }],
                columns: [{
                    data: "id",
                    width: "10%",
                    searchable: false
                }, {
                    data: "licence_purpose",
                    width: "20%",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        return data.name;
                    }
                }, {
                    data: "section_label",
                    width: "50%",
                    searchable: false
                }, {
                    data: "index",
                    width: "10%",
                    searchable: false
                }, {
                    data: "id",
                    width: "10%",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        var column = '<a class="edit-row" data-rowid="__ROWID__">Edit</a><br/>';
                        column += '<a class="delete-row" data-rowid="__ROWID__">Delete</a><br/>';
                        return column.replace(/__ROWID__/g, full.id);
                    }
                }],
                rowId: function rowId(_data) {
                    return _data.id;
                },
                initComplete: function initComplete() {
                    var $searchInput = $('div.dataTables_filter input');
                    $searchInput.unbind('keyup search input');
                    $searchInput.bind('keypress', vm.delay(function (e) {
                        if (e.which == 13) {
                            vm.$refs.schema_purpose_table.vmDataTable.search(this.value).draw();
                        }
                    }, 0));
                }
            },
            section_label: '',
            licence_purpose: '',
            schemaPurposes: [],
            sectionPurpose: {
                id: '',
                section_name: '',
                section_label: '',
                index: '',
                licence_purpose: ''
            }
        };
    },
    computed: {},
    methods: {
        delay: function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        },

        close: function close() {
            var self = this;

            if (!self.errors) {

                self.isModalOpen = false;
            }
        },
        savePurpose: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var self, data;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = this;
                                data = self.sectionPurpose;

                                if (!(data.id === '')) {
                                    _context.next = 7;
                                    break;
                                }

                                _context.next = 5;
                                return self.$http.post(_hooks.api_endpoints.schema_purpose, (0, _stringify2.default)(data), {
                                    emulateJSON: true

                                }).then(function (response) {

                                    self.$refs.schema_purpose_table.vmDataTable.ajax.reload();
                                    self.close();
                                }, function (error) {
                                    swal('Save Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 5:
                                _context.next = 9;
                                break;

                            case 7:
                                _context.next = 9;
                                return self.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_purpose, data.id + '/save_purpose'), (0, _stringify2.default)(data), {
                                    emulateJSON: true

                                }).then(function (response) {

                                    self.$refs.schema_purpose_table.vmDataTable.ajax.reload();
                                    self.close();
                                }, function (error) {
                                    swal('Save Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function savePurpose() {
                return _ref.apply(this, arguments);
            }

            return savePurpose;
        }(),
        cancel: function cancel() {
            var self = this;
            self.isModalOpen = false;
        },
        addTableEntry: function addTableEntry() {
            this.sectionPurpose.id = '';
            this.sectionPurpose.section_label = '';
            this.sectionPurpose.index = '';
            this.sectionPurpose.licence_purpose = '';
            this.isModalOpen = true;
        },
        addEventListeners: function addEventListeners() {
            var self = this;

            self.$refs.schema_purpose_table.vmDataTable.on('click', '.edit-row', function (e) {
                e.preventDefault();
                self.$refs.schema_purpose_table.row_of_data = self.$refs.schema_purpose_table.vmDataTable.row('#' + $(this).attr('data-rowid'));

                self.sectionPurpose.id = self.$refs.schema_purpose_table.row_of_data.data().id;
                self.sectionPurpose.section_label = self.$refs.schema_purpose_table.row_of_data.data().section_label;
                self.sectionPurpose.index = self.$refs.schema_purpose_table.row_of_data.data().index;
                self.sectionPurpose.licence_purpose = self.$refs.schema_purpose_table.row_of_data.data().licence_purpose.id;

                self.isModalOpen = true;
            });

            self.$refs.schema_purpose_table.vmDataTable.on('click', '.delete-row', function (e) {
                var _this = this;

                e.preventDefault();
                self.$refs.schema_purpose_table.row_of_data = self.$refs.schema_purpose_table.vmDataTable.row('#' + $(this).attr('data-rowid'));
                self.sectionPurpose.id = self.$refs.schema_purpose_table.row_of_data.data().id;

                swal({
                    title: "Delete Purpose Section",
                    text: "Are you sure you want to delete?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'

                }).then(function () {
                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(result) {
                        return _regenerator2.default.wrap(function _callee2$(_context2) {
                            while (1) {
                                switch (_context2.prev = _context2.next) {
                                    case 0:
                                        if (!result.value) {
                                            _context2.next = 3;
                                            break;
                                        }

                                        _context2.next = 3;
                                        return self.$http.delete(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_purpose, self.sectionPurpose.id + '/delete_purpose')).then(function (response) {

                                            self.$refs.schema_purpose_table.vmDataTable.ajax.reload();
                                        }, function (error) {});

                                    case 3:
                                    case 'end':
                                        return _context2.stop();
                                }
                            }
                        }, _callee2, _this);
                    }));

                    return function (_x) {
                        return _ref2.apply(this, arguments);
                    };
                }(), function (error) {});
            });
        },
        initSelects: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var _this2 = this;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$http.get(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.schema_purpose, '1/get_purpose_selects')).then(function (res) {

                                    _this2.schemaPurposes = res.body.all_purpose;
                                }, function (err) {

                                    swal('Get Application Selects Error', _hooks.helpers.apiVueResourceError(err), 'error');
                                });

                            case 2:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function initSelects() {
                return _ref3.apply(this, arguments);
            }

            return initSelects;
        }()
    },
    mounted: function mounted() {
        var _this3 = this;

        this.form = document.forms.schema_purpose;
        this.$nextTick(function () {
            _this3.addEventListeners();
            _this3.initSelects();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _schema_add_option = __webpack_require__(346);

var _schema_add_option2 = _interopRequireDefault(_schema_add_option);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var select2 = __webpack_require__(81);
__webpack_require__(20);
__webpack_require__(19);

exports.default = {
    name: 'schema-question',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default,
        datatable: _datatable2.default,
        SchemaOption: _schema_add_option2.default
    },
    props: {},
    data: function data() {
        var vm = this;
        vm.schema_question_url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.schema_question_paginated, 'schema_question_datatable_list/?format=datatables');

        return {
            schema_question_id: 'schema-question-datatable-' + vm._uid,
            pOptionsBody: 'pOptionsBody' + vm._uid,
            pQuestionBody: 'pQuestionBody' + vm._uid,
            isModalOpen: false,
            isNewEntry: false,
            missing_fields: [],
            filterTablePurpose: 'All',
            filterParentQuestion: 'All',
            filterTableSection: 'All',
            filterQuestionSection: 'All',
            filterQuestionPurpose: 'All',
            filterTableGroup: 'All',
            dtHeadersSchemaQuestion: ["ID", "SectionID", "OptionID", "Licence Purpose", "Section", "Group", "Question", "Index", "Action"],
            dtOptionsSchemaQuestion: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                serverSide: true,
                autowidth: false,
                processing: true,
                searchDelay: 1000,
                ajax: {
                    "url": vm.schema_question_url,
                    "dataSrc": 'data',
                    "data": function data(d) {
                        d.licence_purpose_id = vm.filterTablePurpose;
                        d.section_id = vm.filterTableSection;
                        d.group_id = vm.filterTableGroup;
                    }
                },
                columnDefs: [{ visible: false, targets: [0, 1, 2] }],
                columns: [{
                    data: "id",
                    searchable: false
                }, {
                    data: "section",
                    searchable: false
                }, {
                    data: "options",
                    searchable: false
                }, {
                    data: "licence_purpose",
                    searchable: false
                }, {
                    data: "section",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        return data.section_label;
                    }
                }, {
                    data: "section_group",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        var label = data ? data.group_label : '';
                        return label;
                    }
                }, {
                    data: "question",
                    width: "80%",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        var ellipsis = '...',
                            truncated = _.truncate(data, {
                            length: 40,
                            omission: ellipsis,
                            separator: ' '
                        }),
                            result = '<span>' + truncated + '</span>',
                            popTemplate = _.template('<a href="#" ' + 'role="button" ' + 'data-toggle="popover" ' + 'data-trigger="click" ' + 'data-placement="top auto"' + 'data-html="true" ' + 'data-content="<%= text %>" ' + '>more</a>');
                        if (_.endsWith(truncated, ellipsis)) {
                            result += popTemplate({
                                text: data
                            });
                        }

                        return result;
                    },
                    'createdCell': _hooks.helpers.dtPopoverCellFn
                }, {
                    data: "order",
                    searchable: false
                }, {
                    data: "id",
                    searchable: false,
                    mRender: function mRender(data, type, full) {
                        var column = '<a class="edit-row" data-rowid="__ROWID__">Edit</a><br/>';
                        column += '<a class="delete-row" data-rowid="__ROWID__">Delete</a><br/>';
                        return column.replace(/__ROWID__/g, full.id);
                    }
                }],
                rowId: function rowId(_data) {
                    return _data.id;
                },
                initComplete: function initComplete() {
                    var $searchInput = $('div.dataTables_filter input');
                    $searchInput.unbind('keyup search input');
                    $searchInput.bind('keypress', vm.delay(function (e) {
                        if (e.which == 13) {
                            vm.$refs.schema_question_table.vmDataTable.search(this.value).draw();
                        }
                    }, 0));
                }
            },
            sectionQuestion: {
                id: '',
                section: '',
                question: '',
                section_group: '',
                order: '0',
                conditions: '',
                purpose_id: '',
                parent_question: null,
                parent_answer: null,
                tag: []
            },
            masterlist: null,
            checked: false,
            selectedType: '',
            showOptions: false,
            optionList: [],
            addedOptions: [],
            addedOption: {
                label: '',
                value: '',
                conditions: ''
            },
            defaultOptions: [],
            schemaPurposes: [],
            schemaSections: [],
            schemaGroups: [],
            parentList: [],
            answerList: [],
            checkedTag: [{
                tag: null,
                isChecked: false
            }]
        };
    },
    watch: {
        filterTablePurpose: function filterTablePurpose() {
            this.$refs.schema_question_table.vmDataTable.draw();
        },
        filterTableSection: function filterTableSection() {
            this.$refs.schema_question_table.vmDataTable.draw();
        },
        filterTableGroup: function filterTableGroup() {
            this.$refs.schema_question_table.vmDataTable.draw();
        },
        filterQuestionPurpose: function filterQuestionPurpose() {
            var _this = this;

            if (this.filterQuestionPurpose === 'All') {
                return true;
            }
            this.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_question, '1/get_question_sections'), {
                params: { licence_purpose_id: this.filterQuestionPurpose }
            }).then(function (res) {
                _this.schemaGroups = res.body.question_groups;
                _this.schemaSections = res.body.question_sections;
            }, function (err) {});
        },
        filterQuestionSection: function filterQuestionSection() {
            var _this2 = this;

            if (this.filterQuestionSection === 'All') {
                return true;
            }
            this.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_question, '1/get_question_parents'), {
                params: { section_id: this.filterQuestionSection }
            }).then(function (res) {
                _this2.sectionQuestion.section = _this2.filterQuestionSection;
                _this2.parentList = res.body.question_parents;
            }, function (err) {});
        }
    },
    computed: {},
    methods: {
        delay: function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        },

        filterQuestionGroup: function filterQuestionGroup(g_id) {
            if (!this.isModalOpen || g_id == '' || g_id == null) {
                return true;
            }

            return true;
        },
        filterQuestionParent: function filterQuestionParent(q_id) {
            if (q_id == '' || q_id == null || !this.masterlist) {
                return true;
            }
            var master = this.masterlist.find(function (m) {
                return m.id == q_id;
            });
            if (master) {
                this.sectionQuestion.parent_question = q_id;
                this.answerList = master.options;
                var parent = this.parentList.find(function (q) {
                    return q.value == q_id;
                });
                if (parent) {
                    if (parent.group) {
                        this.sectionQuestion.section_group = parent.group;
                    }
                }
            } else {
                this.sectionQuestion.parent_question = '';
            }
            return true;
        },
        getCheckedTag: function getCheckedTag(atag) {
            var set_checked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var checked = this.checkedTag.find(function (ch) {
                return ch.tag === atag;
            });

            if (!checked) {
                checked = {
                    tag: atag,
                    isChecked: set_checked
                };
                if (['isRepeatable', 'isRequired'].includes(atag)) {
                    this.checkedTag.push(checked);
                }
            }
            return checked;
        },
        close: function close() {
            var self = this;

            if (!self.errors) {
                $(this.$refs.select_question).val(null).trigger('change');
                $('.has-error').removeClass('has-error');
                self.addedOptions = [];
                self.showOptions = false;
                self.isModalOpen = false;
            }
        },
        setShowOptions: function setShowOptions(selected_id) {
            var show = this.masterlist.filter(function (m) {
                return m.id == selected_id && ['checkbox', 'radiobuttons'].includes(m.answer_type);
            })[0];
            if (show && this.isNewEntry) {
                var newOption = (0, _assign2.default)(show);
                this.addedOptions.push(newOption);
                this.addedOptions = show.options;
            }

            this.showOptions = show ? true : false;
        },
        saveQuestion: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var self, data;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = this;
                                data = self.sectionQuestion;

                                data.options = self.addedOptions;

                                if (self.checkedTag.length > 0) {
                                    data.tag = [];
                                    self.checkedTag.filter(function (t) {
                                        if (t.isChecked) {
                                            data.tag.push(t.tag);
                                        }
                                        return;
                                    });
                                }

                                if (!(data.id === '')) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 7;
                                return self.$http.post(_hooks.api_endpoints.schema_question, (0, _stringify2.default)(data), {
                                    emulateJSON: true

                                }).then(function (response) {

                                    self.$refs.schema_question_table.vmDataTable.ajax.reload();
                                    self.close();
                                }, function (error) {

                                    swal('Save Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 7:
                                _context.next = 11;
                                break;

                            case 9:
                                _context.next = 11;
                                return self.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_question, data.id + '/save_question'), (0, _stringify2.default)(data), {
                                    emulateJSON: true

                                }).then(function (response) {

                                    self.$refs.schema_question_table.vmDataTable.ajax.reload();
                                    self.close();
                                }, function (error) {
                                    'Save Error', _hooks.helpers.apiVueResourceError(error), 'error';
                                });

                            case 11:
                                this.isNewEntry = false;

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function saveQuestion() {
                return _ref.apply(this, arguments);
            }

            return saveQuestion;
        }(),
        addTableEntry: function addTableEntry() {
            var _this3 = this;

            this.isNewEntry = true;
            this.sectionQuestion.id = '';
            this.sectionQuestion.section = '';
            this.sectionQuestion.question = '';
            this.sectionQuestion.section_group = '';
            this.sectionQuestion.order = 0;
            this.sectionQuestion.parent_question = null;
            this.sectionQuestion.parent_answer = null;
            this.sectionQuestion.tag = [];

            this.filterQuestionSection = 'All';
            this.filterQuestionPurpose = 'All';

            this.checkedTag = [];
            $(this.$refs.select_parent).val(this.sectionQuestion.parent_question).trigger('change');
            this.sectionQuestion.tag.filter(function (t) {
                _this3.getCheckedTag(t, true);return;
            });

            this.isModalOpen = true;
        },
        initEventListeners: function initEventListeners() {
            var self = this;

            self.$refs.schema_question_table.vmDataTable.on('click', '.edit-row', function (e) {
                e.preventDefault();
                self.isNewEntry = false;
                self.$refs.schema_question_table.row_of_data = self.$refs.schema_question_table.vmDataTable.row('#' + $(this).attr('data-rowid'));

                self.sectionQuestion.id = self.$refs.schema_question_table.row_of_data.data().id;
                self.sectionQuestion.section = self.$refs.schema_question_table.row_of_data.data().section.id;
                self.filterQuestionSection = self.$refs.schema_question_table.row_of_data.data().section.id;
                self.filterQuestionPurpose = self.$refs.schema_question_table.row_of_data.data().section.licence_purpose;

                self.sectionQuestion.question = self.$refs.schema_question_table.row_of_data.data().question_id;
                self.sectionQuestion.order = self.$refs.schema_question_table.row_of_data.data().order;

                self.sectionQuestion.section_group = self.$refs.schema_question_table.row_of_data.data().section_group ? self.$refs.schema_question_table.row_of_data.data().section_group.id : '';


                self.sectionQuestion.parent_question = self.$refs.schema_question_table.row_of_data.data().parent_question;
                self.sectionQuestion.parent_answer = self.$refs.schema_question_table.row_of_data.data().parent_answer;
                $(self.$refs.select_parent).val(self.sectionQuestion.parent_question).trigger('change');
                if (self.masterlist) {
                    var master = self.masterlist.find(function (m) {
                        return m.id == self.sectionQuestion.parent_question;
                    });
                    if (master) {
                        self.answerList = master.options;
                    }
                }

                self.checkedTag = [];
                self.sectionQuestion.tag = self.$refs.schema_question_table.row_of_data.data().tag;
                self.sectionQuestion.tag.filter(function (t) {
                    self.getCheckedTag(t, true);return;
                });

                self.addedOptions = (0, _assign2.default)(self.$refs.schema_question_table.row_of_data.data().options);
                $(self.$refs.select_question).val(self.sectionQuestion.question).trigger('change');
                self.setShowOptions(self.sectionQuestion.question);

                self.isModalOpen = true;
            });

            self.$refs.schema_question_table.vmDataTable.on('click', '.delete-row', function (e) {
                var _this4 = this;

                e.preventDefault();
                self.$refs.schema_question_table.row_of_data = self.$refs.schema_question_table.vmDataTable.row('#' + $(this).attr('data-rowid'));
                self.sectionQuestion.id = self.$refs.schema_question_table.row_of_data.data().id;

                swal({
                    title: "Delete Section Question",
                    text: "Are you sure you want to delete?",
                    type: "question",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'

                }).then(function () {
                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(result) {
                        return _regenerator2.default.wrap(function _callee2$(_context2) {
                            while (1) {
                                switch (_context2.prev = _context2.next) {
                                    case 0:
                                        if (!result.value) {
                                            _context2.next = 3;
                                            break;
                                        }

                                        _context2.next = 3;
                                        return self.$http.delete(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.schema_question, self.sectionQuestion.id + '/delete_question')).then(function (response) {

                                            self.$refs.schema_question_table.vmDataTable.ajax.reload();
                                        }, function (error) {});

                                    case 3:
                                    case 'end':
                                        return _context2.stop();
                                }
                            }
                        }, _callee2, _this4);
                    }));

                    return function (_x2) {
                        return _ref2.apply(this, arguments);
                    };
                }(), function (error) {});
            });
        },
        initQuestionSelector: function initQuestionSelector() {
            var self = this;
            $(self.$refs.select_question).select2({
                "theme": "bootstrap",
                allowClear: true,
                minimumInputLength: 2,
                placeholder: "Select Question..."
            }).on("select2:selecting", function (e) {
                var selected = $(e.currentTarget);
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                self.sectionQuestion.question = selected.val();
                self.setShowOptions(selected.val());
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                self.sectionQuestion.question = selected.val();
            });
        },
        initParentSelector: function initParentSelector() {
            var self = this;
            $(self.$refs.select_parent).select2({
                "theme": "bootstrap",
                allowClear: true,
                minimumInputLength: 2,
                placeholder: "Select Parent Question..."
            }).on("select2:selecting", function (e) {
                var selected = $(e.currentTarget);
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                self.sectionQuestion.parent_question = selected.val();
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                self.sectionQuestion.parent_question = selected.val();
            });
        },

        initGroupSelector: function initGroupSelector() {
            var self = this;
            $(self.$refs.select_group).select2({
                "theme": "bootstrap",
                allowClear: true,
                minimumInputLength: 2,
                placeholder: "Select Section Group..."
            }).on("select2:selecting", function (e) {
                var selected = $(e.currentTarget);
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                self.sectionQuestion.section_group = selected.val();
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                self.sectionQuestion.section_group = selected.val();
            });
        },
        initSelects: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var _this5 = this;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$http.get(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.schema_question, '1/get_question_selects')).then(function (res) {

                                    _this5.masterlist = res.body.all_masterlist;
                                    _this5.schemaPurposes = res.body.all_purpose;
                                    _this5.schemaSections = res.body.all_section;
                                    _this5.schemaGroups = res.body.all_group;
                                }, function (err) {
                                    swal('Get Application Selects Error', _hooks.helpers.apiVueResourceError(err), 'error');
                                });

                            case 2:
                                this.initQuestionSelector();
                                this.initParentSelector();

                                this.initGroupSelector();

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function initSelects() {
                return _ref3.apply(this, arguments);
            }

            return initSelects;
        }()
    },
    mounted: function mounted() {
        var _this6 = this;

        this.form = document.forms.schema_question;
        this.$nextTick(function () {
            _this6.initEventListeners();
            _this6.initSelects();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _leaflet = __webpack_require__(54);

var _leaflet2 = _interopRequireDefault(_leaflet);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

__webpack_require__(125);

__webpack_require__(66);

var _awesomplete = __webpack_require__(43);

var _awesomplete2 = _interopRequireDefault(_awesomplete);

var _vuex = __webpack_require__(6);

var _helpers = __webpack_require__(42);

var _hooks = __webpack_require__(3);

__webpack_require__(15);

__webpack_require__(39);

__webpack_require__(65);

__webpack_require__(122);

__webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "map-leaflet",
  data: function data() {
    var defaultCentre = [13775786.985667605, -2871569.067879858];

    var vm = this;
    var baseDic = {
      shadowUrl: __webpack_require__(46),
      shadowSize: [41, 41],
      shadowAnchor: [12, 41],
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -20]
    };
    vm.icon_default = _leaflet2.default.icon((0, _extends3.default)({
      iconUrl: __webpack_require__(93)
    }, baseDic));

    vm.guid = (0, _helpers.guid)();

    return {
      mapboxAccessToken: null,
      defaultCenter: defaultCentre,
      projection: null,
      mapOffence: null,
      popup: null,
      element: null,
      base_layer: "osm",
      awe: null,
      suggest_list: [],
      feature_marker: null,
      cursor_location: null,
      idMap: vm.guid + "mapLeaf",
      idLocationFieldsAddress: vm.guid + "LocationFieldsAddress",
      idLocationFieldsDetails: vm.guid + "LocationFieldsDetails",
      idSearchInput: vm.guid + "SearchInput",
      idBasemapSat: vm.guid + "BasemapSat",
      idBasemapOsm: vm.guid + "BasemapOsm"
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)("callemailStore", {
    call_email: "call_email"
  }), (0, _vuex.mapGetters)("offenceStore", {
    offence: "offence",
    offence_latitude: "offence_latitude",
    offence_longitude: "offence_longitude"
  })),
  watch: {
    call_email: {
      handler: function handler() {
        this.setMarkerIcon();
      },
      deep: true
    },
    offence_latitude: {
      handler: function handler() {
        this.setMarkerLocation();
      }
    },
    offence_longitude: {
      handler: function handler() {
        this.setMarkerLocation();
      }
    }
  },
  mounted: function mounted() {
    var vm = this;

    vm.$nextTick(function () {
      vm.initMap();
      vm.setBaseLayer("osm");
      vm.initAwesomplete();
      if (vm.offence.location && vm.offence.location && vm.offence.location.geometry && vm.offence.location.geometry.coordinates && vm.offence.location.geometry.coordinates.length > 0) {
        vm.addMarker([vm.offence.location.geometry.coordinates[1], vm.offence.location.geometry.coordinates[0]]);
        vm.refreshMarkerLocation();
      }

      if (this.offence.location.properties.country) {
        this.showHideAddressDetailsFields(true, false);
      } else {
        this.showHideAddressDetailsFields(false, true);
      }
    });
  },
  created: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var temp_token;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.retrieveMapboxAccessToken();

            case 2:
              temp_token = _context.sent;

              this.mapboxAccessToken = temp_token.access_token;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)("offenceStore", {
    setLocationPoint: "setLocationPoint",
    setLocationAddress: "setLocationAddress",
    setLocationAddressEmpty: "setLocationAddressEmpty",
    setLocationDetailsFieldEmpty: "setLocationDetailsFieldEmpty"
  }), {
    setMarkerCentre: function setMarkerCentre() {
      var vm = this;
      var lat = vm.offence.location.geometry.coordinates[1];
      var lng = vm.offence.location.geometry.coordinates[0];
      vm.mapOffence.flyTo({ lat: lat, lng: lng }, 12, {
        animate: true,
        duration: 1.5
      });
    },
    mapTabClicked: function mapTabClicked() {
      var vm = this;
      setTimeout(function () {
        vm.mapOffence.invalidateSize();
      }, 300);
    },
    setMarkerLocation: function setMarkerLocation() {
      var vm = this;
      var lat = vm.offence.location.geometry.coordinates[1];
      var lng = vm.offence.location.geometry.coordinates[0];
      if (-90 < lat && lat < 90) {
        if (-180 < lng < 180) {
          var lnglat = [lng, lat];
          vm.feature_marker.setLatLng({ lat: lat, lng: lng });
          vm.mapOffence.flyTo({ lat: lat, lng: lng }, 12, {
            animate: true,
            duration: 1.5
          });
          vm.reverseGeocoding(lnglat);
        }
      }
    },
    setMarkerIcon: function setMarkerIcon() {
      var vm = this;
      if (vm.feature_marker) {
        vm.feature_marker.setIcon(vm.icon_default);
      }
    },
    addMarker: function addMarker(latLngArr) {
      var vm = this;
      vm.feature_marker = _leaflet2.default.marker({ lon: latLngArr[1], lat: latLngArr[0] }, { icon: vm.icon_default }).on("click", function (ev) {});

      vm.feature_marker.addTo(vm.mapOffence);
      vm.setMarkerIcon();
    },

    reverseGeocoding: function reverseGeocoding(coordinates_4326) {
      var self = this;
      console.log('reverseGeocoding');
      console.log('coordinates_4326');
      console.log(coordinates_4326);

      $.ajax({
        url: _hooks.api_endpoints.geocoding_address_search + coordinates_4326[0] + "," + coordinates_4326[1] + ".json?" + $.param({
          limit: 1,
          types: "address",
          access_token: self.mapboxAccessToken
        }),
        dataType: "json",
        success: function success(data, status, xhr) {
          var address_found = false;
          if (data.features && data.features.length > 0) {
            for (var i = 0; i < data.features.length; i++) {
              if (data.features[i].place_type.includes("address")) {
                self.updateAddressFields(data.features[i]);
                address_found = true;
              }
            }
          }
          if (address_found) {
            self.showHideAddressDetailsFields(true, false);
            self.setLocationDetailsFieldEmpty();
          } else {
            self.showHideAddressDetailsFields(false, true);
            self.setLocationAddressEmpty();
          }
        }
      });
    },
    search: function search(place) {
      var self = this;

      var latlng = this.mapOffence.getCenter();
      $.ajax({
        url: _hooks.api_endpoints.geocoding_address_search + encodeURIComponent(place) + ".json?" + $.param({
          country: "au",
          access_token: self.mapboxAccessToken,
          limit: 10,
          proximity: "" + latlng.lng + "," + latlng.lat,

          bbox: "112.920934,-35.191991,129.0019283,-11.9662455",
          types: "region,postcode,district,place,locality,neighborhood,address,poi"
        }),
        dataType: "json",
        success: function success(data, status, xhr) {
          self.suggest_list = [];
          if (data.features && data.features.length > 0) {
            for (var i = 0; i < data.features.length; i++) {
              self.suggest_list.push({
                label: data.features[i].place_name,
                value: data.features[i].place_name,
                feature: data.features[i]
              });
            }
          }

          self.awe.list = self.suggest_list;
          self.awe.evaluate();
        }
      });
    },
    initAwesomplete: function initAwesomplete() {
      var self = this;
      var element_search = document.getElementById(self.idSearchInput);
      this.awe = new _awesomplete2.default(element_search);
      $(element_search).on("keyup", function (ev) {
        var keyCode = ev.keyCode || ev.which;
        if (48 <= keyCode && keyCode <= 90 || 96 <= keyCode && keyCode <= 105 || keyCode == 8 || keyCode == 46) {
          self.search(ev.target.value);
          return false;
        }
      }).on("awesomplete-selectcomplete", function (ev) {
        ev.preventDefault();
        ev.stopPropagation();

        for (var i = 0; i < self.suggest_list.length; i++) {
          if (self.suggest_list[i].value == ev.target.value) {
            var latlng = {
              lat: self.suggest_list[i].feature.geometry.coordinates[1],
              lng: self.suggest_list[i].feature.geometry.coordinates[0]
            };

            self.mapOffence.flyTo(latlng, 13, {
              animate: true,
              duration: 1.5
            });

            if (!self.feature_marker) {
              self.addMarker([latlng.lat, latlng.lng]);
            }

            self.relocateMarker(latlng);
            if (self.suggest_list[i].feature.place_type.includes("address")) {
              self.showHideAddressDetailsFields(true, false);
              self.updateAddressFields(self.suggest_list[i].feature);
              self.setLocationDetailsFieldEmpty();
            } else {
              self.showHideAddressDetailsFields(false, true);
              self.setLocationAddressEmpty();
            }
          }
        }
        return false;
      });
    },
    updateAddressFields: function updateAddressFields(feature) {
      var properties_for_update = new Object();
      var state_abbr_list = {
        "New South Wales": "NSW",
        Queensland: "QLD",
        "South Australia": "SA",
        Tasmania: "TAS",
        Victoria: "VIC",
        "Western Australia": "WA",
        "Northern Territory": "NT",
        "Australian Capital Territory": "ACT"
      };
      var address_arr = feature.place_name.split(",");

      properties_for_update.street = address_arr[0];

      var reg = /^([a-zA-Z0-9\s]*)\s(New South Wales|Queensland|South Australia|Tasmania|Victoria|Western Australia|Northern Territory|Australian Capital Territory){1}\s+(\d{4})$/gi;
      var result = reg.exec(address_arr[1]);

      properties_for_update.town_suburb = result[1].trim();

      var state_abbr = state_abbr_list[result[2].trim()];
      properties_for_update.state = state_abbr;

      properties_for_update.postcode = result[3].trim();

      properties_for_update.country = "Australia";

      this.setLocationAddress(properties_for_update);
    },

    setBaseLayer: function setBaseLayer(selected_layer_name) {
      if (selected_layer_name == "sat") {
        this.mapOffence.removeLayer(this.tileLayer);
        this.mapOffence.addLayer(this.tileLayerSat);
        $("#" + this.idBasemapSat).hide();
        $("#" + this.idBasemapOsm).show();
      } else {
        this.mapOffence.removeLayer(this.tileLayerSat);
        this.mapOffence.addLayer(this.tileLayer);
        $("#" + this.idBasemapOsm).hide();
        $("#" + this.idBasemapSat).show();
      }
    },
    showHideAddressDetailsFields: function showHideAddressDetailsFields(showAddressFields, showDetailsFields) {
      if (showAddressFields) {
        $("#" + this.idLocationFieldsAddress).fadeIn();
      } else {
        $("#" + this.idLocationFieldsAddress).fadeOut();
      }
      if (showDetailsFields) {
        $("#" + this.idLocationFieldsDetails).fadeIn();
      } else {
        $("#" + this.idLocationFieldsDetails).fadeOut();
      }
    },

    refreshMarkerLocation: function refreshMarkerLocation() {
      if (this.offence.location.geometry) {
        this.feature_marker.setLatLng({
          lat: this.offence.location.geometry.coordinates[1],
          lng: this.offence.location.geometry.coordinates[0]
        });
        if (this.offence.location.geometry) {
          this.reverseGeocoding(this.offence.location.geometry.coordinates);
        }
      }
    },
    initMap: function initMap() {
      this.mapOffence = _leaflet2.default.map(this.idMap).setView([-31.9505, 115.8605], 4);
      this.tileLayer = _leaflet2.default.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, contributiors'
      });

      this.tileLayerSat = _leaflet2.default.tileLayer.wmts("https://kmi.dpaw.wa.gov.au/geoserver/gwc/service/wmts", {
        layer: "public:mapbox-satellite",
        tilematrixSet: "mercator",
        format: "image/png"
      });

      this.mapOffence.on("click", this.onClick).on("mousemove", this.onMouseMove).on("mouseout", this.onMouseOut);
      this.setBaseLayer("osm");
      var measureControl = new _leaflet2.default.Control.Measure({
        position: "topleft",
        primaryLengthUnit: "meters",
        activeColor: "#ff7f50",
        completedColor: "#228b22"
      });
      measureControl.addTo(this.mapOffence);
      _leaflet2.default.control.locate().addTo(this.mapOffence);
    },

    relocateMarker: function relocateMarker(latlng) {
      var lnglat = [latlng.lng, latlng.lat];
      this.setLocationPoint(lnglat);
      this.refreshMarkerLocation();
      this.reverseGeocoding(lnglat);
    },
    onMouseMove: function onMouseMove(e) {
      var vm = this;
      vm.cursor_location = vm.mapOffence.mouseEventToLatLng(e.originalEvent);
    },
    onMouseOut: function onMouseOut(e) {
      this.cursor_location = null;
    },
    onClick: function onClick(e) {
      var self = this;
      var latlng = this.mapOffence.mouseEventToLatLng(e.originalEvent);
      if (!self.feature_marker) {
        self.addMarker([latlng.lat, latlng.lng]);
      }

      this.relocateMarker(latlng);
    }
  })
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _getOwnPropertyNames = __webpack_require__(70);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _assignment = __webpack_require__(97);

var _assignment2 = _interopRequireDefault(_assignment);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _utils = __webpack_require__(33);

var _utils2 = _interopRequireDefault(_utils);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _offence_workflow = __webpack_require__(883);

var _offence_workflow2 = _interopRequireDefault(_offence_workflow);

var _search_person_or_organisation = __webpack_require__(49);

var _search_person_or_organisation2 = _interopRequireDefault(_search_person_or_organisation);

var _map_location = __webpack_require__(321);

var _map_location2 = _interopRequireDefault(_map_location);

var _sanction_outcome_modal = __webpack_require__(99);

var _sanction_outcome_modal2 = _interopRequireDefault(_sanction_outcome_modal);

__webpack_require__(15);

__webpack_require__(39);

var _related_items = __webpack_require__(58);

var _related_items2 = _interopRequireDefault(_related_items);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _uuid = __webpack_require__(315);

var _uuid2 = _interopRequireDefault(_uuid);

var _objectHash = __webpack_require__(55);

var _objectHash2 = _interopRequireDefault(_objectHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ViewOffence',
    data: function data() {
        var vm = this;
        vm.STATUS_DRAFT = 'draft';
        vm.STATUS_CLOSING = 'closing';
        vm.STATUS_CLOSED = 'closed';
        vm.STATUS_OPEN = 'open';
        vm.STATUS_DISCARDED = 'discarded';

        vm.max_items = 20;
        vm.ajax_for_alleged_offence = null;
        vm.ajax_for_offender = null;
        vm.suggest_list = [];
        vm.suggest_list_offender = [];
        vm.awe = null;

        return {
            mapboxAccessToken: null,
            uuid: 0,
            workflow_type: '',
            workflowBindId: '',
            offender_search_type: "individual",
            offenceTab: 'offenceTab' + vm._uid,
            detailsTab: 'detailsTab' + vm._uid,
            documentTab: 'documentTab' + vm._uid,
            offenderTab: 'offenderTab' + vm._uid,
            locationTab: 'locationTab' + vm._uid,
            relatedItemsTab: 'relatedItemsTab' + vm._uid,
            displayCreateNewPerson: false,
            idLocationFieldsAddress: vm.guid + "LocationFieldsAddress",
            idLocationFieldsDetails: vm.guid + "LocationFieldsDetails",
            sanctionOutcomeInitialised: false,
            objectHash: null,
            date_from: null,
            time_from: null,
            date_to: null,
            time_to: null,
            hashAttributeWhiteDict: {
                'alleged_offences': ['id', 'reason_for_removal', 'removed', 'removed_by_id', 'section_regulation'],
                'allocated_group_id': '__all__',
                'date_of_issue': '__all__',
                'details': '__all__',
                'district_id': '__all__',
                'identifier': '__all__',
                'location': '__all__',
                'lodgement_number': '__all__',
                'occurrence_date_from': '__all__',
                'occurrence_date_to': '__all__',
                'occurrence_time_from': '__all__',
                'occurrence_time_to': '__all__',
                'occurrence_from_to': '__all__',
                'offenders': ['id', 'organisation', 'person', 'reason_for_removal', 'removed',,],
                'region_id': '__all__'
            },

            current_alleged_offence: {
                id: null,
                act: "",
                name: "",
                offence_text: ""
            },
            current_offender: null,

            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.offence, this.$route.params.offence_id + "/comms_log"),
            comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.offence, this.$route.params.offence_id + "/add_comms_log"),
            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.offence, this.$route.params.offence_id + "/action_log"),
            assign_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.offence, this.$route.params.offence_id + '/update_assigned_to_id/'),
            assignmentKey: 0,
            dtHeadersOffender: ["id", "Individual/Organisation", "Details", "Action", "Reason for removal"],
            dtHeadersAllegedOffence: ["id", "Act", "Section/Regulation", "Alleged Offence", "Action", "Reason for removal"],
            dtOptionsOffender: {
                columns: [{
                    visible: false,
                    data: 'offender',
                    render: function render(data, type, row) {
                        return row.offender.id;
                    }
                }, {
                    data: 'offender',
                    render: function render(data, type, row) {
                        var data_type = '';
                        if (row.offender.person) {
                            data_type = 'individual';
                        } else {
                            data_type = 'organisation';
                        }
                        if (row.offender.removed) {
                            data_type = '<strike>' + data_type + '</strike>';
                        }
                        return data_type;
                    }
                }, {
                    data: 'offender',
                    render: function render(data, type, row) {
                        if (row.offender.person) {
                            var full_name = [row.offender.person.first_name, row.offender.person.last_name].filter(Boolean).join(" ");
                            var email = row.offender.person.email ? "E:" + row.offender.person.email : "";
                            var p_number = row.offender.person.phone_number ? "P:" + row.offender.person.phone_number : "";
                            var m_number = row.offender.person.mobile_number ? "M:" + row.offender.person.mobile_number : "";
                            var dob = row.offender.person.dob ? "DOB:" + row.offender.person.dob : "DOB: ---";
                            var myLabel = ["<strong>" + full_name + "</strong>", email, p_number, m_number, dob].filter(Boolean).join("<br />");
                            if (row.offender.removed) {
                                myLabel = '<strike>' + myLabel + '</strike>';
                            }
                            return myLabel;
                        } else if (row.offender.organisation) {
                            var name = row.offender.organisation.name ? row.offender.organisation.name : "";
                            var abn = row.offender.organisation.abn ? "ABN:" + row.offender.organisation.abn : "";
                            var _myLabel = ["<strong>" + name + "</strong>", abn].filter(Boolean).join("<br />");
                            if (row.offender.removed) {
                                _myLabel = '<strike>' + _myLabel + '</strike>';
                            }
                            return _myLabel;
                        }
                    }
                }, {
                    data: 'offender',
                    render: function render(data, type, row) {
                        var ret_str = '';
                        if (row.offence.in_editable_status && row.offence.can_user_action) {
                            if (row.offender.removed) {
                                ret_str = ret_str + '<a href="#" class="restore_button" data-offender-uuid="' + row.offender.uuid + '">Restore</a>';
                            } else {
                                if (!row.offender.number_linked_sanction_outcomes_active) {
                                    ret_str = ret_str + '<a href="#" class="remove_button" data-offender-uuid="' + row.offender.uuid + '">Remove</a>';
                                }
                            }
                        }
                        return ret_str;
                    }
                }, {
                    data: 'offender',
                    render: function render(data, type, row) {
                        var ret_str = '';
                        if (row.offender.removed) {
                            if (row.offender.reason_for_removal) {
                                ret_str = ret_str + row.offender.reason_for_removal;
                            } else {
                                ret_str = ret_str + '<textarea class="reason_element" data-offender-uuid="' + row.offender.uuid + '">' + row.offender.reason_for_removal + '</textarea>';
                            }
                        }
                        return ret_str;
                    }
                }]
            },
            dtOptionsAllegedOffence: {
                columns: [{
                    visible: false,
                    data: 'allegedOffence',
                    render: function render(data, type, row) {
                        return row.allegedOffence.id;
                    }
                }, {
                    data: 'allegedOffence',
                    render: function render(data, type, row) {
                        var ret_str = row.allegedOffence.section_regulation.act;
                        if (row.allegedOffence.removed) {
                            ret_str = '<strike>' + ret_str + '</strike>';
                        }
                        return ret_str;
                    }
                }, {
                    data: 'allegedOffence',
                    render: function render(data, type, row) {
                        var ret_str = row.allegedOffence.section_regulation.name;
                        if (row.allegedOffence.removed) {
                            ret_str = '<strike>' + ret_str + '</strike>';
                        }
                        return ret_str;
                    }
                }, {
                    data: 'allegedOffence',
                    render: function render(data, type, row) {
                        var ret_str = row.allegedOffence.section_regulation.offence_text;
                        if (row.allegedOffence.removed) {
                            ret_str = '<strike>' + ret_str + '</strike>';
                        }
                        return ret_str;
                    }
                }, {
                    data: 'allegedOffence',
                    render: function render(data, type, row) {
                        var ret_str = '';
                        if (row.offence.in_editable_status && row.offence.can_user_action) {
                            if (row.allegedOffence.removed) {
                                ret_str = ret_str + '<a href="#" class="restore_button" data-alleged-offence-uuid="' + row.allegedOffence.uuid + '">Restore</a>';
                            } else {
                                if (!row.allegedOffence.number_linked_sanction_outcomes_active) {
                                    ret_str = ret_str + '<a href="#" class="remove_button" data-alleged-offence-uuid="' + row.allegedOffence.uuid + '">Remove</a>';
                                }
                            }
                        }
                        return ret_str;
                    }
                }, {
                    data: 'allegedOffence',
                    render: function render(data, type, row) {
                        var ret_str = '';

                        var num_chars = 1000;
                        if (row.allegedOffence.removed) {
                            if (row.allegedOffence.reason_for_removal) {
                                var name = row.allegedOffence.reason_for_removal;
                                var shortText = name.length > num_chars ? '<span title="' + name + '">' + $.trim(name).substring(0, num_chars).split(" ").slice(0, -1).join(" ") + '...</span>' : name;
                                ret_str = ret_str + shortText;
                            } else {
                                ret_str = ret_str + '<textarea class="reason_element" data-alleged-offence-uuid="' + row.allegedOffence.uuid + '">' + row.allegedOffence.reason_for_removal + '</textarea>';
                            }
                        }
                        return ret_str;
                    }
                }]
            }
        };
    },

    components: {
        FormSection: _section_toggle2.default,
        OffenceWorkflow: _offence_workflow2.default,
        CommsLogs: _comms_logs2.default,
        datatable: _datatable2.default,
        SearchPersonOrganisation: _search_person_or_organisation2.default,
        MapLocation: _map_location2.default,

        RelatedItems: _related_items2.default,
        SanctionOutcome: _sanction_outcome_modal2.default,
        FileField: _compliance_file2.default,
        Assignment: _assignment2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('offenceStore', {
        offence: "offence"
    }), {
        readonlyForm: function readonlyForm() {
            return !this.canUserEdit;
        },
        canUserEdit: function canUserEdit() {
            var visibility = false;
            if (this.canUserAction) {
                if (this.offence.status.id === this.STATUS_DRAFT || this.offence.status.id === this.STATUS_OPEN) {
                    visibility = true;
                }
            }
            return visibility;
        },
        updateSearchPersonOrganisationBindId: function updateSearchPersonOrganisationBindId() {
            this.uuid += 1;
            return 'offender' + this.uuid;
        },
        occurrenceDateLabel: function occurrenceDateLabel() {
            if (this.offence.occurrence_from_to) {
                return "Occurrence date from";
            } else {
                return "Occurrence date";
            }
        },
        occurrenceTimeLabel: function occurrenceTimeLabel() {
            if (this.offence.occurrence_from_to) {
                return "Occurrence time from";
            } else {
                return "Occurrence time";
            }
        },
        statusDisplay: function statusDisplay() {
            var ret = '';
            if (this.offence) {
                if (this.offence.status) {
                    ret = this.offence.status.name;
                }
            }
            return ret;
        },
        displayLodgementNumber: function displayLodgementNumber() {
            var ret = '';
            if (this.offence) {
                ret = this.offence.lodgement_number;
            }
            return ret;
        },
        canUserAction: function canUserAction() {
            return this.offence.can_user_action;
        },
        visibilitySaveButton: function visibilitySaveButton() {
            var visibility = false;
            if (this.canUserAction) {
                if (this.offence.status.id === this.STATUS_DRAFT || this.offence.status.id === this.STATUS_OPEN) {
                    visibility = true;
                }
            }
            return visibility;
        },
        visibilitySanctionOutcomeButton: function visibilitySanctionOutcomeButton() {
            var visibility = false;
            var num_offenders = 0;
            if (this.offence.offenders && this.offence.offenders.length) {
                num_offenders = this.offence.offenders.length;
            }
            if (this.canUserAction) {
                if (this.offence.status.id === this.STATUS_OPEN) {
                    for (var i = 0; i < this.offence.alleged_offences.length; i++) {
                        var alleged_offence = this.offence.alleged_offences[i];

                        visibility = true;
                        break;
                    }
                }
            }
            return visibility;
        },
        visibilityCloseButton: function visibilityCloseButton() {
            var visibility = false;
            if (this.canUserAction) {
                if (this.offence.status.id === this.STATUS_OPEN) {
                    visibility = true;
                }
            }
            return visibility;
        },
        relatedItemsBindId: function relatedItemsBindId() {
            var timeNow = Date.now();
            if (this.offence && this.offence.id) {
                return 'offence_' + this.offence.id + '_' + this._uid;
            } else {
                return timeNow.toString();
            }
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('offenceStore', {
        loadOffenceVuex: 'loadOffence',
        saveOffence: 'saveOffence',
        setOffence: 'setOffence',
        setAssignedToId: 'setAssignedToId',
        setCanUserAction: 'setCanUserAction',
        setRelatedItems: 'setRelatedItems'
    }), {
        setTemporaryDocumentCollectionId: function setTemporaryDocumentCollectionId(val) {
            this.temporary_document_collection_id = val;
        },
        constructOffenceDedicatedPage: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log('constructOffenceDedicatedPage');
                                _context.next = 3;
                                return this.loadOffenceVuex({ offence_id: this.$route.params.offence_id });

                            case 3:
                                if (this.offence.occurrence_datetime_from) {
                                    this.date_from = (0, _moment2.default)(this.offence.occurrence_datetime_from).format("DD/MM/YYYY");
                                    this.time_from = (0, _moment2.default)(this.offence.occurrence_datetime_from).format("LT");
                                    console.log('date_from and time_from has been set');
                                }
                                if (this.offence.occurrence_datetime_to) {
                                    this.date_to = (0, _moment2.default)(this.offence.occurrence_datetime_to).format("DD/MM/YYYY");
                                    this.time_to = (0, _moment2.default)(this.offence.occurrence_datetime_to).format("LT");
                                    console.log('date_to and time_to has been set');
                                }
                                this.constructAllegedOffencesTable();
                                this.constructOffendersTable();
                                this.updateObjectHash();

                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function constructOffenceDedicatedPage() {
                return _ref.apply(this, arguments);
            }

            return constructOffenceDedicatedPage;
        }(),
        updateObjectHash: function updateObjectHash() {
            this.objectHash = this.calculateHash();
        },
        calculateHash: function calculateHash() {
            var _this = this;

            console.log('calculateHash()');
            console.log(this.offence);

            var copiedObject = {};
            (0, _getOwnPropertyNames2.default)(this.offence).forEach(function (val, idx, array) {
                if (val in _this.hashAttributeWhiteDict) {
                    var attributes = _this.hashAttributeWhiteDict[val];
                    var target_obj = _this.offence[val];

                    if (attributes == '__all__') {
                        copiedObject[val] = target_obj;
                    } else if (Array.isArray(target_obj)) {
                        for (var j = 0; j < target_obj.length; j++) {
                            var target = target_obj[j];
                            for (var i = 0; i < attributes.length; i++) {
                                copiedObject[val + j.toString() + i.toString()] = target[attributes[i]];
                            }
                        }
                    } else {
                        for (var _i = 0; _i < attributes.length; _i++) {
                            copiedObject[val + _i.toString()] = target_obj[attributes[_i]];
                        }
                    }
                }
            });
            var hashedValue = (0, _objectHash2.default)(copiedObject);
            console.log(hashedValue);
            return hashedValue;
        },
        formChanged: function formChanged() {
            var changed = false;
            if (!this.readonlyForm) {
                if (this.objectHash !== this.calculateHash()) {
                    changed = true;
                }
            }
            return changed;
        },
        save: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;

                                console.log('aho');
                                console.log($(this.$refs.occurrenceDateFromPicker).data('DateTimePicker').date());
                                _context2.next = 5;
                                return this.saveOffence({ 'fr_date': this.date_from, 'fr_time': this.time_from, 'to_date': this.date_to, 'to_time': this.time_to });

                            case 5:
                                _context2.next = 7;
                                return swal("Saved", "The record has been saved", "success");

                            case 7:

                                this.constructOffendersTable();
                                this.constructAllegedOffencesTable();
                                this.updateObjectHash();
                                _context2.next = 16;
                                break;

                            case 12:
                                _context2.prev = 12;
                                _context2.t0 = _context2["catch"](0);

                                console.log('aho');
                                this.processError(_context2.t0);

                            case 16:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 12]]);
            }));

            function save() {
                return _ref2.apply(this, arguments);
            }

            return save;
        }(),
        leaving: function leaving(e) {
            var dialogText = 'You have some unsaved changes.';
            if (this.formChanged()) {
                e.returnValue = dialogText;
                return dialogText;
            }
        },
        destroyed: function destroyed() {
            window.removeEventListener('beforeunload', this.leaving);
            window.removeEventListener('onblur', this.leaving);
        },
        saveExit: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return this.saveOffence({ 'fr_date': this.date_from, 'fr_time': this.time_from, 'to_date': this.date_to, 'to_time': this.time_to });

                            case 3:
                                _context3.next = 5;
                                return swal("Saved", "The record has been saved", "success");

                            case 5:
                                window.removeEventListener('beforeunload', this.leaving);
                                window.removeEventListener('onblur', this.leaving);

                                this.$router.push({ name: 'internal-offence-dash' });
                                _context3.next = 13;
                                break;

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3["catch"](0);

                                this.processError(_context3.t0);

                            case 13:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 10]]);
            }));

            function saveExit() {
                return _ref3.apply(this, arguments);
            }

            return saveExit;
        }(),
        processError: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(err) {
                var errorText, i, _i2, field_name, j;

                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                errorText = '';

                                if (err.body) {
                                    if (err.body.non_field_errors) {
                                        for (i = 0; i < err.body.non_field_errors.length; i++) {
                                            errorText += err.body.non_field_errors[i] + '<br />';
                                        }
                                    } else if (Array.isArray(err.body)) {
                                        for (_i2 = 0; _i2 < err.body.length; _i2++) {
                                            errorText += err.body[_i2] + '<br />';
                                        }
                                    } else {
                                        for (field_name in err.body) {
                                            if (err.body.hasOwnProperty(field_name)) {
                                                errorText += field_name + ':<br />';
                                                for (j = 0; j < err.body[field_name].length; j++) {
                                                    errorText += err.body[field_name][j] + '<br />';
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    errorText += err.message;
                                }
                                _context4.next = 4;
                                return swal("Error", errorText, "error");

                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function processError(_x) {
                return _ref4.apply(this, arguments);
            }

            return processError;
        }(),
        updateAssignedToId: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(body) {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this.setOffence(body);
                                this.constructOffendersTable();
                                this.constructAllegedOffencesTable();
                                this.updateObjectHash();
                                this.assignmentKey += 1;

                            case 5:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function updateAssignedToId(_x2) {
                return _ref5.apply(this, arguments);
            }

            return updateAssignedToId;
        }(),
        openSanctionOutcome: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
                var _this2 = this;

                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.prev = 0;

                                if (!this.formChanged()) {
                                    _context6.next = 5;
                                    break;
                                }

                                _context6.next = 4;
                                return this.saveOffence({ 'fr_date': this.date_from, 'fr_time': this.time_from, 'to_date': this.date_to, 'to_time': this.time_to });

                            case 4:
                                this.updateObjectHash();

                            case 5:
                                this.sanctionOutcomeInitialised = true;
                                this.$nextTick(function () {
                                    _this2.$refs.sanction_outcome.isModalOpen = true;
                                });
                                _context6.next = 12;
                                break;

                            case 9:
                                _context6.prev = 9;
                                _context6.t0 = _context6["catch"](0);

                                this.processError(_context6.t0);

                            case 12:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this, [[0, 9]]);
            }));

            function openSanctionOutcome() {
                return _ref6.apply(this, arguments);
            }

            return openSanctionOutcome;
        }(),
        updateWorkflowBindId: function updateWorkflowBindId() {
            var timeNow = Date.now();
            if (this.workflow_type) {
                this.workflowBindId = this.workflow_type + '_' + timeNow.toString();
            } else {
                this.workflowBindId = timeNow.toString();
            }
        },
        addWorkflow: function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(workflow_type) {
                var _this3 = this;

                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.prev = 0;

                                if (!this.formChanged()) {
                                    _context7.next = 5;
                                    break;
                                }

                                _context7.next = 4;
                                return this.saveOffence({ 'fr_date': this.date_from, 'fr_time': this.time_from, 'to_date': this.date_to, 'to_time': this.time_to });

                            case 4:
                                this.updateObjectHash();

                            case 5:
                                this.workflow_type = workflow_type;
                                this.updateWorkflowBindId();
                                this.$nextTick(function () {
                                    _this3.$refs.add_workflow.isModalOpen = true;
                                });
                                _context7.next = 13;
                                break;

                            case 10:
                                _context7.prev = 10;
                                _context7.t0 = _context7["catch"](0);

                                this.processError(_context7.t0);

                            case 13:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this, [[0, 10]]);
            }));

            function addWorkflow(_x3) {
                return _ref7.apply(this, arguments);
            }

            return addWorkflow;
        }(),
        showHideAddressDetailsFields: function showHideAddressDetailsFields(showAddressFields, showDetailsFields) {
            if (showAddressFields) {
                $("#" + this.idLocationFieldsAddress).fadeIn();
            } else {
                $("#" + this.idLocationFieldsAddress).fadeOut();
            }
            if (showDetailsFields) {
                $("#" + this.idLocationFieldsDetails).fadeIn();
            } else {
                $("#" + this.idLocationFieldsDetails).fadeOut();
            }
        },
        reverseGeocoding: function reverseGeocoding(coordinates_4326) {
            var self = this;

            $.ajax({
                url: _hooks.api_endpoints.geocoding_address_search + coordinates_4326.lng + "," + coordinates_4326.lat + ".json?" + $.param({
                    access_token: self.mapboxAccessToken,
                    limit: 1,
                    types: "address"
                }),
                dataType: "json",
                success: function success(data, status, xhr) {
                    var address_found = false;
                    if (data.features && data.features.length > 0) {
                        for (var i = 0; i < data.features.length; i++) {
                            if (data.features[i].place_type.includes("address")) {
                                self.setAddressFields(data.features[i]);
                                address_found = true;
                            }
                        }
                    }
                    if (address_found) {
                        self.showHideAddressDetailsFields(true, false);
                        self.setLocationDetailsFieldEmpty();
                    } else {
                        self.showHideAddressDetailsFields(false, true);
                        self.setLocationAddressEmpty();
                    }
                }
            });
        },
        setAddressFields: function setAddressFields(feature) {
            if (this.offence.location) {
                var state_abbr_list = {
                    "New South Wales": "NSW",
                    Queensland: "QLD",
                    "South Australia": "SA",
                    Tasmania: "TAS",
                    Victoria: "VIC",
                    "Western Australia": "WA",
                    "Northern Territory": "NT",
                    "Australian Capital Territory": "ACT"
                };
                var address_arr = feature.place_name.split(",");

                this.offence.location.properties.street = address_arr[0];

                var reg = /^([a-zA-Z0-9\s]*)\s(New South Wales|Queensland|South Australia|Tasmania|Victoria|Western Australia|Northern Territory|Australian Capital Territory){1}\s+(\d{4})$/gi;
                var result = reg.exec(address_arr[1]);

                this.offence.location.properties.town_suburb = result[1].trim();

                var state_abbr = state_abbr_list[result[2].trim()];
                this.offence.location.properties.state = state_abbr;

                this.offence.location.properties.postcode = result[3].trim();


                this.offence.location.properties.country = "Australia";
            }
        },
        setLocationAddressEmpty: function setLocationAddressEmpty() {
            if (this.offence.location) {
                this.offence.location.properties.town_suburb = "";
                this.offence.location.properties.street = "";
                this.offence.location.properties.state = "";
                this.offence.location.properties.postcode = "";
                this.offence.location.properties.country = "";
            }
        },
        setLocationDetailsFieldEmpty: function setLocationDetailsFieldEmpty() {
            if (this.offence.location) {
                this.offence.location.properties.details = "";
            }
        },

        locationUpdated: function locationUpdated(latlng) {
            this.offence.location.geometry.coordinates[1] = latlng.lat;
            this.offence.location.geometry.coordinates[0] = latlng.lng;

            this.reverseGeocoding(latlng);
        },
        mapOffenceClicked: function mapOffenceClicked() {
            if (this.$refs.mapLocationComponent) {
                this.$refs.mapLocationComponent.invalidateSize();
            }
        },

        personSelected: function personSelected(para) {
            var vm = this;
            vm.setCurrentOffender(para.data_type, para.id);
        },
        createNewPersonClicked: function createNewPersonClicked() {
            var vm = this;
            vm.newPersonBeingCreated = true;
            vm.displayCreateNewPerson = !vm.displayCreateNewPerson;
        },
        cancelCreateNewPersonClicked: function cancelCreateNewPersonClicked() {
            var vm = this;
            vm.newPersonBeingCreated = false;
        },
        saveNewPersonClicked: function saveNewPersonClicked() {
            var vm = this;
            vm.newPersonBeingCreated = false;
        },

        reasonOffenderLostFocus: function reasonOffenderLostFocus(e) {
            var offender_uuid = e.target.getAttribute("data-offender-uuid");

            for (var i = 0; i < this.offence.offenders.length; i++) {
                var offender = this.offence.offenders[i];
                if (offender.uuid == offender_uuid) {
                    offender.reason_for_removal = e.target.value;
                }
            }
        },
        reasonAllegedOffenceLostFocus: function reasonAllegedOffenceLostFocus(e) {
            var alleged_offence_uuid = e.target.getAttribute("data-alleged-offence-uuid");

            for (var i = 0; i < this.offence.alleged_offences.length; i++) {
                var alleged_offence = this.offence.alleged_offences[i];
                if (alleged_offence.uuid == alleged_offence_uuid) {
                    alleged_offence.reason_for_removal = e.target.value;
                }
            }
        },
        removeOffenderClicked: function removeOffenderClicked(e) {
            var offender_uuid = e.target.getAttribute("data-offender-uuid");

            for (var i = 0; i < this.offence.offenders.length; i++) {
                var offender = this.offence.offenders[i];
                if (offender.uuid == offender_uuid) {
                    if (offender.id) {
                        offender.removed = true;
                    } else {
                        this.offence.offenders.splice(i, 1);
                    }
                }
            }
            this.constructOffendersTable();
        },
        restoreOffenderClicked: function restoreOffenderClicked(e) {
            var offender_uuid = e.target.getAttribute("data-offender-uuid");

            for (var i = 0; i < this.offence.offenders.length; i++) {
                var offender = this.offence.offenders[i];
                if (offender.uuid == offender_uuid) {
                    if (offender.id) {
                        offender.removed = false;
                    } else {}
                }
            }
            this.constructOffendersTable();
        },
        restoreAllegedOffenceClicked: function restoreAllegedOffenceClicked(e) {
            var alleged_offence_uuid = e.target.getAttribute("data-alleged-offence-uuid");

            for (var i = 0; i < this.offence.alleged_offences.length; i++) {
                var alleged_offence = this.offence.alleged_offences[i];
                if (alleged_offence.uuid == alleged_offence_uuid) {
                    if (alleged_offence.id) {
                        alleged_offence.removed = false;
                    } else {}
                }
            }
            this.constructAllegedOffencesTable();
        },
        removeAllegedOffenceClicked: function removeAllegedOffenceClicked(e) {
            var alleged_offence_uuid = e.target.getAttribute("data-alleged-offence-uuid");

            for (var i = 0; i < this.offence.alleged_offences.length; i++) {
                var alleged_offence = this.offence.alleged_offences[i];
                if (alleged_offence.uuid == alleged_offence_uuid) {
                    if (alleged_offence.id) {
                        alleged_offence.removed = true;
                    } else {
                        this.offence.alleged_offences.splice(i, 1);
                    }
                }
            }
            this.constructAllegedOffencesTable();
        },
        addOffenderClicked: function () {
            var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
                var already_exists, i, offender, offender_obj;
                return _regenerator2.default.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!(this.current_offender && this.current_offender.id && this.current_offender.data_type)) {
                                    _context8.next = 6;
                                    break;
                                }

                                _context8.next = 3;
                                return this.$refs.search_offender.parentSave();

                            case 3:
                                already_exists = false;

                                for (i = 0; i < this.offence.offenders.length; i++) {
                                    offender = this.offence.offenders[i];

                                    if (this.current_offender.data_type == 'individual') {
                                        if (offender.person) {
                                            if (!offender.removed && offender.person.id == this.current_offender.id) {
                                                already_exists = true;
                                            }
                                        }
                                    } else if (this.current_offender.data_type == 'organisation') {
                                        if (offender.organisation) {
                                            if (!offender.removed && offender.organisation.id == this.current_offender.id) {
                                                already_exists = true;
                                            }
                                        }
                                    }
                                }

                                if (!already_exists) {
                                    offender_obj = {
                                        id: '',
                                        can_user_action: true,
                                        removed: false,
                                        reason_for_removal: '',
                                        person: null,
                                        organisation: null,
                                        number_linked_sanction_outcomes_total: 0,
                                        number_linked_sanction_outcomes_active: 0,
                                        uuid: (0, _uuid2.default)()
                                    };

                                    if (this.current_offender.data_type == 'individual') {
                                        offender_obj['person'] = this.current_offender;
                                    } else if (this.current_offender.data_type == 'organisation') {
                                        offender_obj['organisation'] = this.current_offender;
                                    }
                                    this.offence.offenders.push(offender_obj);
                                }

                            case 6:
                                this.constructOffendersTable();
                                this.setCurrentOffenderEmpty();

                            case 8:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function addOffenderClicked() {
                return _ref8.apply(this, arguments);
            }

            return addOffenderClicked;
        }(),
        addAllegedOffenceClicked: function addAllegedOffenceClicked() {
            if (this.current_alleged_offence && this.current_alleged_offence.id) {
                var already_exists = false;
                for (var i = 0; i < this.offence.alleged_offences.length; i++) {
                    var alleged_offence = this.offence.alleged_offences[i];
                    if (alleged_offence.section_regulation.id == this.current_alleged_offence.id) {
                        already_exists = true;
                    }
                }

                if (!already_exists) {
                    var alleged_offence_obj = {
                        id: '',
                        removed: false,
                        reason_for_removal: '',
                        removed_by_id: null,
                        section_regulation: this.current_alleged_offence,
                        number_linked_sanction_outcomes_total: 0,
                        number_linked_sanction_outcomes_active: 0,
                        uuid: (0, _uuid2.default)()
                    };
                    this.offence.alleged_offences.push(alleged_offence_obj);
                }
            }

            this.constructAllegedOffencesTable();
            this.setCurrentAllegedOffenceEmpty();
        },
        constructAllegedOffencesTable: function constructAllegedOffencesTable() {
            this.$refs.alleged_offence_table.vmDataTable.clear().draw();
            if (this.offence.alleged_offences) {
                for (var i = 0; i < this.offence.alleged_offences.length; i++) {
                    this.addAllegedOffenceToTable(this.offence.alleged_offences[i]);
                }
            }
        },
        addAllegedOffenceToTable: function addAllegedOffenceToTable(allegedOffence) {
            allegedOffence.uuid = (0, _uuid2.default)();
            this.$refs.alleged_offence_table.vmDataTable.row.add({ allegedOffence: allegedOffence, offence: this.offence }).draw();
        },
        constructOffendersTable: function constructOffendersTable() {
            this.$refs.offender_table.vmDataTable.clear().draw();
            if (this.offence.offenders) {
                for (var i = 0; i < this.offence.offenders.length; i++) {
                    this.addOffenderToTable(this.offence.offenders[i]);
                }
            }
        },
        addOffenderToTable: function addOffenderToTable(offender) {
            offender.uuid = (0, _uuid2.default)();
            this.$refs.offender_table.vmDataTable.row.add({ offender: offender, offence: this.offence }).draw();
        },
        markMatchedText: function markMatchedText(original_text, input) {
            var ret_text = original_text.replace(new RegExp(input, "gi"), function (a, b) {
                return "<mark>" + a + "</mark>";
            });
            return ret_text;
        },

        initAwesompleteAllegedOffence: function initAwesompleteAllegedOffence() {
            var self = this;

            var element_search = document.getElementById("alleged-offence");
            self.awe = new Awesomplete(element_search, {
                maxItems: self.max_items,
                sort: false,
                filter: function filter() {
                    return true;
                },
                item: function item(text, input) {
                    var ret = Awesomplete.ITEM(text, "");
                    return ret;
                },
                data: function data(item, input) {
                    var act = item.act ? item.act : "";
                    var name = item.name ? item.name : "";
                    var offence_text = item.offence_text ? item.offence_text : "";

                    var act_marked = self.markMatchedText(act, input);
                    var name_marked = self.markMatchedText(name, input);
                    var offence_text_marked = self.markMatchedText(offence_text, input);

                    var myLabel = ["<strong>" + act_marked + ", " + name_marked + "</strong>", offence_text_marked].filter(Boolean).join("<br />");
                    myLabel = '<div data-item-id="' + item.id + '">' + myLabel + "</div>";

                    return {
                        label: myLabel,
                        value: [act, name, offence_text].filter(Boolean).join(", "),
                        id: item.id
                    };
                }
            });
            $(element_search).on("keyup", function (ev) {
                var keyCode = ev.keyCode || ev.which;
                if (48 <= keyCode && keyCode <= 90 || 96 <= keyCode && keyCode <= 105 || keyCode == 8 || keyCode == 46) {
                    self.search(ev.target.value);
                    return false;
                }
            }).on("awesomplete-selectcomplete", function (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                return false;
            }).on("awesomplete-select", function (ev) {
                var origin = $(ev.originalEvent.origin);
                var originTagName = origin[0].tagName;
                switch (originTagName) {
                    case "STRONG":
                        origin = origin.parent();
                        break;
                    case "MARK":
                        origin = origin.parent().parent();
                        break;
                    case "LI":
                        origin = origin.children().first();
                        break;
                }
                var elem_id = origin[0].getAttribute("data-item-id");
                for (var i = 0; i < self.suggest_list.length; i++) {
                    if (self.suggest_list[i].id == parseInt(elem_id)) {
                        self.setCurrentOffenceSelected(self.suggest_list[i]);
                        break;
                    }
                }
            });
        },
        search: function search(searchTerm) {
            var vm = this;
            vm.suggest_list = [];
            vm.suggest_list.length = 0;
            vm.awe.list = [];

            if (vm.ajax_for_alleged_offence != null) {
                vm.ajax_for_alleged_offence.abort();
                vm.ajax_for_alleged_offence = null;
            }

            vm.ajax_for_alleged_offence = $.ajax({
                type: "GET",
                url: "/api/search_alleged_offences/?search=" + searchTerm,
                success: function success(data) {
                    if (data && data.results) {
                        var persons = data.results;
                        var limit = Math.min(vm.max_items, persons.length);
                        for (var i = 0; i < limit; i++) {
                            vm.suggest_list.push(persons[i]);
                        }
                    }
                    vm.awe.list = vm.suggest_list;
                    vm.awe.evaluate();
                },
                error: function error(e) {}
            });
        },
        searchOrganisation: function searchOrganisation(id) {
            return new _promise2.default(function (resolve, reject) {
                _vue2.default.http.get("/api/search_organisation/" + id).then(function (response) {
                    resolve(response.body);
                }, function (error) {
                    reject(error);
                });
            });
        },
        setCurrentOffender: function setCurrentOffender(data_type, id) {
            var vm = this;
            if (!id) {
                this.current_offender = null;
            } else if (data_type == "individual") {
                var initialisers = [_utils2.default.fetchUser(id)];
                _promise2.default.all(initialisers).then(function (data) {
                    vm.current_offender = data[0];
                    vm.current_offender.data_type = "individual";
                });
            } else if (data_type == "organisation") {
                var _initialisers = [vm.searchOrganisation(id)];
                _promise2.default.all(_initialisers).then(function (data) {
                    vm.current_offender = data[0];
                    vm.current_offender.data_type = "organisation";
                });
            }
        },
        setCurrentOffenceSelected: function setCurrentOffenceSelected(offence) {
            var vm = this;

            if (offence.id) {
                vm.current_alleged_offence.id = offence.id;
                vm.current_alleged_offence.act = offence.act;
                vm.current_alleged_offence.name = offence.name;
                vm.current_alleged_offence.offence_text = offence.offence_text;
            } else {
                vm.setCurrentAllegedOffenceEmpty();
            }
        },
        setCurrentOffenderEmpty: function setCurrentOffenderEmpty() {
            this.current_offender = {};
            $("#offender_input").val("");
            this.$refs.search_offender.clearInput();
        },
        setCurrentAllegedOffenceEmpty: function setCurrentAllegedOffenceEmpty() {
            this.current_alleged_offence = {};
            $("#alleged-offence").val("");
        },
        addEventListeners: function addEventListeners() {
            console.log('addEventListeners');
            var vm = this;
            var el_fr_date = $(vm.$refs.occurrenceDateFromPicker);
            var el_fr_time = $(vm.$refs.occurrenceTimeFromPicker);
            var el_to_date = $(vm.$refs.occurrenceDateToPicker);
            var el_to_time = $(vm.$refs.occurrenceTimeToPicker);

            el_fr_date.datetimepicker({
                format: "DD/MM/YYYY",
                maxDate: (0, _moment2.default)().millisecond(0).second(0).minute(0).hour(0),
                showClear: true,
                date: vm.offence.occurrence_datetime_from
            });
            el_fr_date.on("dp.change", function (e) {
                if (el_fr_date.data("DateTimePicker").date()) {
                    vm.date_from = e.date.format('DD/MM/YYYY');
                    el_to_date.data("DateTimePicker").minDate(e.date);
                } else if (el_fr_date.data("date") === "") {
                    vm.date_from = null;
                }
            });

            el_fr_time.datetimepicker({
                format: "LT",
                showClear: true,
                date: vm.offence.occurrence_datetime_from
            });
            el_fr_time.on("dp.change", function (e) {
                if (el_fr_time.data("DateTimePicker").date()) {
                    vm.time_from = e.date.format('LT');
                } else if (el_fr_time.data("date") === "") {
                    vm.time_from = null;
                }
            });

            console.log('to date');
            console.log(vm.offence.occurrence_datetime_from);

            el_to_date.datetimepicker({
                format: "DD/MM/YYYY",
                maxDate: (0, _moment2.default)().millisecond(0).second(0).minute(0).hour(0),
                minDate: vm.offence.occurrence_datetime_from,
                showClear: true,
                date: vm.offence.occurrence_datetime_to
            });
            el_to_date.on("dp.change", function (e) {
                if (el_to_date.data("DateTimePicker").date()) {
                    vm.date_to = e.date.format('DD/MM/YYYY');
                } else if (el_to_date.data("date") === "") {
                    vm.date_to = null;
                }
            });

            el_to_time.datetimepicker({
                format: "LT",
                showClear: true,
                date: vm.offence.occurrence_datetime_to
            });
            el_to_time.on("dp.change", function (e) {
                if (el_to_time.data("DateTimePicker").date()) {
                    vm.time_to = e.date.format('LT');
                } else if (el_to_time.data("date") === "") {
                    vm.time_to = null;
                }
            });

            $("#alleged-offence-table").on("click", ".remove_button", vm.removeAllegedOffenceClicked);
            $("#alleged-offence-table").on("click", ".restore_button", vm.restoreAllegedOffenceClicked);
            $("#alleged-offence-table").on("blur", ".reason_element", vm.reasonAllegedOffenceLostFocus);

            $("#offender-table").on("click", ".remove_button", vm.removeOffenderClicked);
            $("#offender-table").on("click", ".restore_button", vm.restoreOffenderClicked);
            $("#offender-table").on("blur", ".reason_element", vm.reasonOffenderLostFocus);

            window.addEventListener('beforeunload', this.leaving);
            window.addEventListener('onblur', this.leaving);
        }
    }),
    created: function () {
        var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9() {
            var temp_token;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.next = 2;
                            return this.retrieveMapboxAccessToken();

                        case 2:
                            temp_token = _context9.sent;

                            this.mapboxAccessToken = temp_token.access_token;

                            if (!this.$route.params.offence_id) {
                                _context9.next = 7;
                                break;
                            }

                            _context9.next = 7;
                            return this.constructOffenceDedicatedPage();

                        case 7:
                            this.$nextTick(function () {
                                this.initAwesompleteAllegedOffence();
                            });

                        case 8:
                        case "end":
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        function created() {
            return _ref9.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function () {
        var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
            var vm;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            console.log('mounted');
                            vm = this;


                            vm.$nextTick(function () {
                                vm.addEventListeners();
                            });

                        case 3:
                        case "end":
                            return _context10.stop();
                    }
                }
            }, _callee10, this);
        }));

        function mounted() {
            return _ref10.apply(this, arguments);
        }

        return mounted;
    }()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _hooks = __webpack_require__(3);

var _offence_modal = __webpack_require__(98);

var _offence_modal2 = _interopRequireDefault(_offence_modal);

var _offence_locations = __webpack_require__(882);

var _offence_locations2 = _interopRequireDefault(_offence_locations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'OffenceTableDash',
    data: function data() {
        var vm = this;
        return {
            uuid: 0,
            offence_types: [],
            offence_statuses: [],

            filterType: 'all',
            filterStatus: 'all',
            filterDateFromPicker: '',
            filterDateToPicker: '',
            offenceInitialised: false,
            canUserCreateNewOffence: false,

            dtOptions: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                processing: true,
                ajax: {
                    url: '/api/offence_paginated/get_paginated_datatable/?format=datatables',
                    dataSrc: 'data',
                    data: function data(d) {
                        d.type = vm.filterType;
                        d.status = vm.filterStatus;
                        d.date_from = vm.filterDateFromPicker;
                        d.date_to = vm.filterDateToPicker;
                    }
                },
                columns: [{
                    data: 'lodgement_number',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'identifier',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'occurrence_datetime_from',
                    searchable: true,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format('DD/MM/YYYY') : '';
                    }
                }, {
                    data: 'offenders',
                    searchable: true,
                    orderable: false,
                    mRender: function mRender(data, type, row) {
                        var ret = '';
                        for (var i = 0; i < data.length; i++) {
                            var name = '';
                            var num_chars = 30;
                            if (data && data[i].person) {
                                name = data[i].person.first_name + ' ' + data[i].person.last_name;
                            } else if (data[i] && data[i].organisation) {
                                name = data[i].organisation.name;
                            }

                            var temp = name.length > num_chars ? '<span title="' + name + '">' + _jquery2.default.trim(name).substring(0, num_chars).split(" ").slice(0, -1).join(" ") + '...</span>' : name;
                            ret = ret + temp + '<br />';
                        }
                        return ret;
                    }
                }, {
                    data: 'status.name',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'documents',
                    searchable: false,
                    orderable: false,
                    mRender: function mRender(data, type, row) {
                        console.log(row);
                        return row.documents;
                    }
                }, {
                    data: 'user_action',
                    searchable: false,
                    orderable: false,
                    mRender: function mRender(data, type, row) {
                        if (data) {
                            return data;
                        } else {
                            return '---';
                        }
                    }
                }]
            },
            dtHeaders: ['Number', 'Identifier', 'Date', 'Offender(s)', 'Status', 'Document', 'Action']
        };
    },

    computed: {
        offenceBindId: function offenceBindId() {
            var offence_bind_id = '';
            offence_bind_id = 'offence' + parseInt(this.uuid);
            return offence_bind_id;
        },
        visibilityCreateNewButton: function visibilityCreateNewButton() {
            return this.canUserCreateNewOffence;
        }
    },
    watch: {
        filterType: function filterType() {
            this.$refs.offence_table.vmDataTable.draw();
        },
        filterStatus: function filterStatus() {
            this.$refs.offence_table.vmDataTable.draw();
        },
        filterPaymentStatus: function filterPaymentStatus() {
            this.$refs.offence_table.vmDataTable.draw();
        },
        filterDateFromPicker: function filterDateFromPicker() {
            this.$refs.offence_table.vmDataTable.draw();
        },
        filterDateToPicker: function filterDateToPicker() {
            this.$refs.offence_table.vmDataTable.draw();
        },
        filterRegionId: function filterRegionId() {
            this.$refs.offence_table.vmDataTable.draw();
        },
        filterDistrictId: function filterDistrictId() {
            this.$refs.offence_table.vmDataTable.draw();
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.$nextTick(function () {
            vm.addEventListeners();
        });
    },

    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.constructOptionsType();
                            this.constructOptionsStatus();
                            this.getUserCanCreate();

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    methods: {
        getUserCanCreate: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var url, res;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                url = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.offence, 'can_user_create/');
                                _context2.next = 3;
                                return _vue2.default.http.get(url);

                            case 3:
                                res = _context2.sent;

                                this.canUserCreateNewOffence = res.body;

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getUserCanCreate() {
                return _ref2.apply(this, arguments);
            }

            return getUserCanCreate;
        }(),
        createOffence: function createOffence() {
            var _this = this;

            this.uuid += 1;
            this.offenceInitialised = true;
            this.$nextTick(function () {
                _this.$refs.add_offence.isModalOpen = true;
            });
        },

        addEventListeners: function addEventListeners() {
            this.attachFromDatePicker();
            this.attachToDatePicker();
        },
        attachFromDatePicker: function attachFromDatePicker() {
            var vm = this;
            var el_fr = (0, _jquery2.default)(vm.$refs.issueDateFromPicker);
            var el_to = (0, _jquery2.default)(vm.$refs.issueDateToPicker);

            el_fr.datetimepicker({ format: 'DD/MM/YYYY', maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_fr.on('dp.change', function (e) {
                if (el_fr.data('DateTimePicker').date()) {
                    vm.filterDateFromPicker = e.date.format('DD/MM/YYYY');
                    el_to.data('DateTimePicker').minDate(e.date);
                } else if (el_fr.data('date') === "") {
                    vm.filterDateFromPicker = "";
                }
            });
        },
        attachToDatePicker: function attachToDatePicker() {
            var vm = this;
            var el_fr = (0, _jquery2.default)(vm.$refs.issueDateFromPicker);
            var el_to = (0, _jquery2.default)(vm.$refs.issueDateToPicker);
            el_to.datetimepicker({ format: 'DD/MM/YYYY', maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_to.on('dp.change', function (e) {
                if (el_to.data('DateTimePicker').date()) {
                    vm.filterDateToPicker = e.date.format('DD/MM/YYYY');
                    el_fr.data('DateTimePicker').maxDate(e.date);
                } else if (el_to.data('date') === "") {
                    vm.filterDateToPicker = "";
                }
            });
        },
        constructOptionsType: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var returned;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                console.log('constructOptionsType');
                                _context3.next = 3;
                                return _hooks.cache_helper.getSetCacheList('SanctionOutcome_TypeChoices', '/api/sanction_outcome/types');

                            case 3:
                                returned = _context3.sent;

                                (0, _assign2.default)(this.offence_types, returned);
                                this.offence_types.splice(0, 0, { id: 'all', display: 'All' });

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function constructOptionsType() {
                return _ref3.apply(this, arguments);
            }

            return constructOptionsType;
        }(),
        constructOptionsStatus: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var returned;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                console.log('constructOptionsStatus');
                                _context4.next = 3;
                                return _hooks.cache_helper.getSetCacheList('OffenceStatuses', '/api/offence/statuses.json');

                            case 3:
                                returned = _context4.sent;

                                (0, _assign2.default)(this.offence_statuses, returned);
                                this.offence_statuses.splice(0, 0, { id: 'all', display: 'All' });

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function constructOptionsStatus() {
                return _ref4.apply(this, arguments);
            }

            return constructOptionsStatus;
        }()
    },
    components: {
        datatable: _datatable2.default,
        FormSection: _section_toggle2.default,
        OffenceModal: _offence_modal2.default,
        MapLocations: _offence_locations2.default
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment) {

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _leaflet = __webpack_require__(54);

var _leaflet2 = _interopRequireDefault(_leaflet);

__webpack_require__(126);

__webpack_require__(66);

var _awesomplete = __webpack_require__(43);

var _awesomplete2 = _interopRequireDefault(_awesomplete);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

__webpack_require__(65);

__webpack_require__(124);

__webpack_require__(123);

__webpack_require__(64);

__webpack_require__(15);

__webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_leaflet2.default.TileLayer.WMTS = _leaflet2.default.TileLayer.extend({
    defaultWmtsParams: {
        service: 'WMTS',
        request: 'GetTile',
        version: '1.0.0',
        layers: '',
        styles: '',
        tilematrixSet: '',
        format: 'image/jpeg'
    },

    initialize: function initialize(url, options) {
        this._url = url;
        var wmtsParams = _leaflet2.default.extend({}, this.defaultWmtsParams);
        var tileSize = options.tileSize || this.options.tileSize;
        if (options.detectRetina && _leaflet2.default.Browser.retina) {
            wmtsParams.width = wmtsParams.height = tileSize * 2;
        } else {
            wmtsParams.width = wmtsParams.height = tileSize;
        }
        for (var i in options) {
            if (!this.options.hasOwnProperty(i) && i != "matrixIds") {
                wmtsParams[i] = options[i];
            }
        }
        this.wmtsParams = wmtsParams;
        this.matrixIds = options.matrixIds || this.getDefaultMatrix();
        _leaflet2.default.setOptions(this, options);
    },

    onAdd: function onAdd(map) {
        this._crs = this.options.crs || map.options.crs;
        _leaflet2.default.TileLayer.prototype.onAdd.call(this, map);
    },

    getTileUrl: function getTileUrl(coords) {
        var tileSize = this.options.tileSize;
        var nwPoint = coords.multiplyBy(tileSize);
        nwPoint.x += 1;
        nwPoint.y -= 1;
        var sePoint = nwPoint.add(new _leaflet2.default.Point(tileSize, tileSize));
        var zoom = this._tileZoom;
        var nw = this._crs.project(this._map.unproject(nwPoint, zoom));
        var se = this._crs.project(this._map.unproject(sePoint, zoom));
        var tilewidth = se.x - nw.x;

        var ident = this.matrixIds[zoom].identifier;
        var tilematrix = this.wmtsParams.tilematrixSet + ":" + ident;
        var X0 = this.matrixIds[zoom].topLeftCorner.lng;
        var Y0 = this.matrixIds[zoom].topLeftCorner.lat;
        var tilecol = Math.floor((nw.x - X0) / tilewidth);
        var tilerow = -Math.floor((nw.y - Y0) / tilewidth);
        var url = _leaflet2.default.Util.template(this._url, { s: this._getSubdomain(coords) });
        return url + _leaflet2.default.Util.getParamString(this.wmtsParams, url) + "&tilematrix=" + tilematrix + "&tilerow=" + tilerow + "&tilecol=" + tilecol;
    },

    setParams: function setParams(params, noRedraw) {
        _leaflet2.default.extend(this.wmtsParams, params);
        if (!noRedraw) {
            this.redraw();
        }
        return this;
    },

    getDefaultMatrix: function getDefaultMatrix() {
        var matrixIds3857 = new Array(22);
        for (var i = 0; i < 22; i++) {
            matrixIds3857[i] = {
                identifier: "" + i,
                topLeftCorner: new _leaflet2.default.LatLng(20037508.3428, -20037508.3428)
            };
        }
        return matrixIds3857;
    }
});
_leaflet2.default.tileLayer.wmts = function (url, options) {
    return new _leaflet2.default.TileLayer.WMTS(url, options);
};

delete _leaflet2.default.Icon.Default.prototype._getIconUrl;
_leaflet2.default.Icon.Default.mergeOptions({
    iconRetinaUrl: __webpack_require__(127),
    iconUrl: __webpack_require__(128),
    shadowUrl: __webpack_require__(46)
});


module.exports = {
    data: function data() {
        var vm = this;
        vm.layers = [];
        vm.mcg = _leaflet2.default.markerClusterGroup();
        vm.datetime_pattern = /^\d{2}\/\d{2}\/\d{4}$/gi;
        vm.ajax_for_location = null;

        return {
            mapboxAccessToken: null,
            map: null,
            tileLayer: null,
            tileLayerSat: null,
            popup: null,
            opt_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.offence, "optimised"),

            filterStatus: 'all',
            filterDateFrom: '',
            filterDateTo: '',
            filterSanctionOutcomeType: 'all',

            status_choices: [],
            sanction_outcome_type_choices: [],
            cursor_location: null
        };
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var temp_token, returned_status_choices, returned_choices;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return this.retrieveMapboxAccessToken();

                        case 2:
                            temp_token = _context.sent;

                            this.mapboxAccessToken = temp_token.access_token;

                            _context.next = 6;
                            return _hooks.cache_helper.getSetCacheList('Offence_StatusChoices', '/api/offence/status_choices');

                        case 6:
                            returned_status_choices = _context.sent;

                            (0, _assign2.default)(this.status_choices, returned_status_choices);
                            this.status_choices.splice(0, 0, { id: 'all', display: 'All' });

                            _context.next = 11;
                            return _hooks.cache_helper.getSetCacheList('SanctionOutcome_TypeChoices', '/api/sanction_outcome/types');

                        case 11:
                            returned_choices = _context.sent;

                            (0, _assign2.default)(this.sanction_outcome_type_choices, returned_choices);
                            this.sanction_outcome_type_choices.splice(0, 0, { id: 'all', display: 'All' });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        var vm = this;
        vm.initMap();
        vm.loadLocations();
        vm.initAwesomplete();
        vm.$nextTick(function () {
            vm.addEventListeners();
        });
    },

    watch: {
        filterStatus: function filterStatus() {
            this.loadLocations();
        },
        filterSanctionOutcomeType: function filterSanctionOutcomeType() {
            this.loadLocations();
        },
        filterDateFrom: function filterDateFrom() {
            if (!this.filterDateFrom) {
                this.loadLocations();
            } else {
                var result = this.datetime_pattern.exec(this.filterDateFrom);
                if (result) {
                    this.loadLocations();
                }
            }
        },
        filterDateTo: function filterDateTo() {
            if (!this.filterDateTo) {
                this.loadLocations();
            } else {
                var result = this.datetime_pattern.exec(this.filterDateTo);
                if (result) {
                    this.loadLocations();
                }
            }
        }
    },
    computed: {},
    methods: {
        addEventListeners: function addEventListeners() {
            var vm = this;
            var el_fr = $(vm.$refs.lodgementDateFromPicker);
            var el_to = $(vm.$refs.lodgementDateToPicker);

            el_fr.datetimepicker({ format: 'DD/MM/YYYY', maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_fr.on('dp.change', function (e) {
                if (el_fr.data('DateTimePicker').date()) {
                    vm.filterDateFrom = e.date.format('DD/MM/YYYY');
                    el_to.data('DateTimePicker').minDate(e.date);
                } else if (el_fr.data('date') === "") {
                    vm.filterDateFrom = "";
                }
            });

            el_to.datetimepicker({ format: 'DD/MM/YYYY', maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_to.on('dp.change', function (e) {
                if (el_to.data('DateTimePicker').date()) {
                    vm.filterDateTo = e.date.format('DD/MM/YYYY');
                    el_fr.data('DateTimePicker').maxDate(e.date);
                } else if (el_to.data('date') === "") {
                    vm.filterDateTo = "";
                }
            });
        },
        initAwesomplete: function initAwesomplete() {
            var self = this;
            var element_search = document.getElementById('search-input');
            this.awe = new _awesomplete2.default(element_search);
            $(element_search).on('keyup', function (ev) {
                var keyCode = ev.keyCode || ev.which;
                if (48 <= keyCode && keyCode <= 90 || 96 <= keyCode && keyCode <= 105) {
                    self.search(ev.target.value);
                    return false;
                }
            }).on('awesomplete-selectcomplete', function (ev) {
                ev.preventDefault();
                ev.stopPropagation();

                for (var i = 0; i < self.suggest_list.length; i++) {
                    if (self.suggest_list[i].value == ev.target.value) {
                        var latlng = { lat: self.suggest_list[i].feature.geometry.coordinates[1], lng: self.suggest_list[i].feature.geometry.coordinates[0] };

                        self.map.flyTo(latlng, 13, {
                            animate: true,
                            duration: 1.5
                        });
                    }
                }
                return false;
            });
        },
        search: function search(place) {
            var self = this;

            var latlng = this.map.getCenter();
            $.ajax({
                url: _hooks.api_endpoints.geocoding_address_search + encodeURIComponent(place) + '.json?' + $.param({
                    access_token: self.mapboxAccessToken,
                    country: 'au',
                    limit: 10,
                    proximity: '' + latlng.lng + ',' + latlng.lat,
                    bbox: '112.920934,-35.191991,129.0019283,-11.9662455',
                    types: 'region,postcode,district,place,locality,neighborhood,address,poi'
                }),
                dataType: 'json',
                success: function success(data, status, xhr) {
                    self.suggest_list = [];
                    if (data.features && data.features.length > 0) {
                        for (var i = 0; i < data.features.length; i++) {
                            self.suggest_list.push({ label: data.features[i].place_name,
                                value: data.features[i].place_name,
                                feature: data.features[i]
                            });
                        }
                    }

                    self.awe.list = self.suggest_list;
                    self.awe.evaluate();
                }
            });
        },
        setBaseLayer: function setBaseLayer(selected_layer_name) {
            if (selected_layer_name == 'sat') {
                this.map.removeLayer(this.tileLayer);
                this.map.addLayer(this.tileLayerSat);
                $('#basemap_sat').hide();
                $('#basemap_osm').show();
            } else {
                this.map.removeLayer(this.tileLayerSat);
                this.map.addLayer(this.tileLayer);
                $('#basemap_osm').hide();
                $('#basemap_sat').show();
            }
        },
        onClick: function onClick(e) {
            console.log(e.latlng.toString());
        },

        onMouseMove: function onMouseMove(e) {
            this.cursor_location = this.map.mouseEventToLatLng(e.originalEvent);
        },
        onMouseOut: function onMouseOut(e) {
            this.cursor_location = null;
        },
        initMap: function initMap() {
            console.log('Start initMap()');

            this.map = _leaflet2.default.map('mapLeaf').setView([-24.9505, 122.8605], 5);
            this.tileLayer = _leaflet2.default.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, contributiors'
            });

            this.tileLayerSat = _leaflet2.default.tileLayer.wmts('https://kmi.dpaw.wa.gov.au/geoserver/gwc/service/wmts', {
                layer: 'public:mapbox-satellite',
                tilematrixSet: 'mercator',
                format: 'image/png'
            });

            this.popup = _leaflet2.default.popup();
            this.map.on('click', this.onClick).on('mousemove', this.onMouseMove).on('mouseout', this.onMouseOut);
            this.setBaseLayer('osm');
            this.addOtherLayers();
            this.map.addLayer(this.mcg);
            _leaflet2.default.control.locate().addTo(this.map);
        },
        addOtherLayers: function addOtherLayers() {
            var _this = this;

            var overlayMaps = {};

            this.$http.get('/api/map_layers/').then(function (response) {
                var layers = response.body.results;
                for (var i = 0; i < layers.length; i++) {
                    var l = _leaflet2.default.tileLayer.wmts('https://kmi.dpaw.wa.gov.au/geoserver/gwc/service/wmts', {
                        layer: layers[i].layer_name.trim(),
                        tilematrixSet: 'mercator',
                        format: 'image/png'
                    });
                    overlayMaps[layers[i].display_name] = l;
                }
                _leaflet2.default.control.layers(null, overlayMaps, { position: 'topleft' }).addTo(_this.map);
            });
        },
        loadLocations: function loadLocations() {
            var vm = this;

            if (vm.ajax_for_location != null) {
                vm.ajax_for_location.abort();
                vm.ajax_for_location = null;
            }
            var myData = {
                "status": vm.filterStatus,
                "date_from": vm.filterDateFrom,
                "date_to": vm.filterDateTo,
                "sanction_outcome_type": vm.filterSanctionOutcomeType
            };

            vm.ajax_for_location = $.ajax({
                type: 'GET',
                data: myData,
                url: vm.opt_url,
                success: function success(data) {
                    vm.addMarkers(data);
                },
                error: function error(e) {
                    console.log(e);
                }
            });
        },
        addMarkers: function addMarkers(offences) {
            var self = this;
            self.mcg.clearLayers();

            if (offences && offences.length > 0) {
                for (var i = 0; i < offences.length; i++) {
                    if (offences[i].location) {
                        (function () {
                            var offence = offences[i];
                            var coords = offence.location.geometry.coordinates;

                            var filename = 'marker-gray-locked.svg';
                            if (offence.status) {
                                if (offence.status == 'open') {
                                    filename = 'marker-green-locked.svg';
                                } else if (offence.status == 'discarded') {
                                    filename = 'marker-blue-locked.svg';
                                } else if (offence.status == 'closing') {
                                    filename = 'marker-orange-locked.svg';
                                } else if (offence.status == 'closed') {
                                    filename = 'marker-red-locked.svg';
                                }
                            }

                            var myIcon = _leaflet2.default.icon({
                                iconUrl: __webpack_require__(134)("./" + filename),
                                shadowUrl: __webpack_require__(46),
                                shadowSize: [41, 41],
                                shadowAnchor: [12, 41],
                                iconSize: [32, 32],
                                iconAnchor: [16, 32],
                                popupAnchor: [0, -20]
                            });
                            var myMarker = _leaflet2.default.marker([coords[1], coords[0]], { icon: myIcon });
                            var myPopup = _leaflet2.default.popup();
                            myMarker.bindPopup(myPopup);
                            self.mcg.addLayer(myMarker);

                            myMarker.on('click', function (ev) {
                                var popup = ev.target.getPopup();
                                self.$http.get('/api/offence/' + offence.id).then(function (response) {
                                    var offence = response.body;
                                    popup.setContent(self.construct_content(offence, coords));
                                });
                            });
                        })();
                    }
                }
            }
        },

        construct_content: function construct_content(offence, coords) {
            console.log('offence clicked');
            console.log(offence);
            var offenders_str = '';
            for (var i = 0; i < offence.offenders.length; i++) {
                var offender = offence.offenders[i].person;
                if (offender) {
                    offenders_str += '<div>' + offender.full_name + '</div>';
                }
            }
            var status_str = offence.status ? offence.status.name : '';
            var identifier_str = offence.identifier ? offence.identifier : '';

            var content = '<div class="popup-title-main">' + offence.lodgement_number + '</div>';

            content += '<div class="popup-title">Identifier</div>' + '<div class="popup-address">' + identifier_str + '</div>';

            content += '<div class="popup-title">Offender(s)</div>' + '<div class="popup-address">' + offenders_str + '</div>';

            content += '<div class="popup-title">Status</div>' + '<div class="popup-address">' + status_str + '</div>';

            if (offence.location.properties.street) {
                var str_street = offence.location.properties.street ? offence.location.properties.street : '';
                var str_town_suburb = offence.location.properties.town_suburt ? offence.location.properties.town_suburt : '';
                var str_state = offence.location.properties.state ? offence.location.properties.state : '';
                var str_postcode = offence.location.properties.postcode ? offence.location.properties.postcode : '';
                content += '<div class="popup-title">Address</div>' + '<div class="popup-address">' + str_street + '<br />' + str_town_suburb + '<br />' + str_state + '<br />' + str_postcode + '</div>';
            } else {
                content += '<div class="popup-title">Details</div>' + '<div class="popup-address">' + offence.location.properties.details.substring(0, 10) + '</div>';
            }

            content += '<div class="popup-link">' + offence.user_action + '</div>';

            return content;
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(0)))

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _awesomplete = __webpack_require__(43);

var _awesomplete2 = _interopRequireDefault(_awesomplete);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _map_location_offence = __webpack_require__(879);

var _map_location_offence2 = _interopRequireDefault(_map_location_offence);

var _search_person_or_organisation = __webpack_require__(49);

var _search_person_or_organisation2 = _interopRequireDefault(_search_person_or_organisation);

var _utils = __webpack_require__(33);

var _utils2 = _interopRequireDefault(_utils);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(15);

__webpack_require__(39);

var _uuid = __webpack_require__(315);

var _uuid2 = _interopRequireDefault(_uuid);

__webpack_require__(80);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Offence",
  data: function data() {
    var vm = this;

    vm.max_items = 20;
    vm.ajax_for_alleged_offence = null;
    vm.ajax_for_offender = null;
    vm.suggest_list = [];
    vm.suggest_list_offender = [];
    vm.awe = null;

    return {
      uuid: 0,
      displayCreateNewPerson: false,
      updatingContact: false,
      newPersonBeingCreated: false,
      officers: [],
      isModalOpen: false,
      processingDetails: false,
      current_alleged_offence: {
        id: null,
        act: "",
        section_regulation: "",
        offence_text: ""
      },
      current_offender: null,
      offender_search_type: "individual",
      oTab: "oTab" + vm._uid,
      dTab: "dTab" + vm._uid,
      pTab: "pTab" + vm._uid,
      lTab: "lTab" + vm._uid,
      documentTab: 'documentTab' + vm._uid,
      errorResponse: '',

      temporary_document_collection_id: null,

      regions: [],
      availableDistricts: [],

      dtHeadersOffender: ["id", "Individual/Organisation", "Details", "Action"],
      dtHeadersAllegedOffence: ["id", "Act", "Section/Regulation", "Alleged Offence", "Action"],
      dtOptionsOffender: {
        columns: [{
          data: "id",
          visible: false
        }, {
          data: "data_type",
          visible: true
        }, {
          data: "data_type",
          render: function render(data, type, row) {
            if (row.data_type == "individual") {
              var full_name = [row.first_name, row.last_name].filter(Boolean).join(" ");
              var email = row.email ? "E:" + row.email : "";
              var p_number = row.phone_number ? "P:" + row.phone_number : "";
              var m_number = row.mobile_number ? "M:" + row.mobile_number : "";
              var dob = row.dob ? "DOB:" + row.dob : "DOB: ---";
              var myLabel = ["<strong>" + full_name + "</strong>", email, p_number, m_number, dob].filter(Boolean).join("<br />");

              return myLabel;
            } else if (row.data_type == "organisation") {
              var name = row.name ? row.name : "";
              var abn = row.abn ? "ABN:" + row.abn : "";
              var _myLabel = ["<strong>" + name + "</strong>", abn].filter(Boolean).join("<br />");

              return _myLabel;
            }
          }
        }, {
          data: "id",
          render: function render(data, type, row) {
            return '<a href="#" class="remove_button" data-offender-id="' + row.id + '">Remove</a>';
          }
        }]
      },
      dtOptionsAllegedOffence: {
        columns: [{
          visible: false,
          data: 'allegedOffence',
          render: function render(data, type, row) {
            return row.allegedOffence.id;
          }
        }, {
          data: 'allegedOffence',
          render: function render(data, type, row) {
            var ret_str = row.allegedOffence.section_regulation.act;
            return ret_str;
          }
        }, {
          data: 'allegedOffence',
          render: function render(data, type, row) {
            var ret_str = row.allegedOffence.section_regulation.name;
            return ret_str;
          }
        }, {
          data: 'allegedOffence',
          render: function render(data, type, row) {
            var ret_str = row.allegedOffence.section_regulation.offence_text;
            return ret_str;
          }
        }, {
          data: 'allegedOffence',
          render: function render(data, type, row) {
            var ret_str = '<a href="#" class="remove_button" data-alleged-offence-uuid="' + row.allegedOffence.uuid + '">Remove</a>';
            return ret_str;
          }
        }]
      }
    };
  },
  components: {
    modal: _bootstrapModal2.default,
    datatable: _datatable2.default,
    MapLocationOffence: _map_location_offence2.default,
    SearchPersonOrganisation: _search_person_or_organisation2.default,
    FileField: _compliance_file2.default
  },
  props: {
    region_id: {
      required: false,
      default: null
    },
    district_id: {
      required: false,
      default: null
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)("offenceStore", {
    offence: "offence"
  }), (0, _vuex.mapGetters)('inspectionStore', {
    inspection: "inspection"
  }), (0, _vuex.mapGetters)('legalCaseStore', {
    legal_case: "legal_case"
  }), (0, _vuex.mapGetters)('callemailStore', {
    call_email: "call_email"
  }), {
    parent_legal_case: function parent_legal_case() {
      if (this.legal_case && this.legal_case.id) {
        return true;
      }
    },
    parent_call_email: function parent_call_email() {
      if (this.call_email && this.call_email.id) {
        return true;
      }
    },
    parent_inspection: function parent_inspection() {
      if (this.inspection && this.inspection.id) {
        return true;
      }
    },

    modalTitle: function modalTitle() {
      return "Identify Offence";
    },
    occurrenceDateLabel: function occurrenceDateLabel() {
      if (this.offence.occurrence_from_to) {
        return "Occurrence date from";
      } else {
        return "Occurrence date";
      }
    },
    occurrenceTimeLabel: function occurrenceTimeLabel() {
      if (this.offence.occurrence_from_to) {
        return "Occurrence time from";
      } else {
        return "Occurrence time";
      }
    },
    updateSearchPersonOrganisationBindId: function updateSearchPersonOrganisationBindId() {
      this.uuid += 1;
      return 'offender' + this.uuid;
    },
    parentEntity: function parentEntity() {
      return { 'id': 1, 'data_type': 'individual' };
    }
  }),
  filters: {
    formatDate: function formatDate(data) {
      return data ? moment(data).format("DD/MM/YYYY HH:mm:ss") : "";
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)("offenceStore", {
    setAllegedOffenceIds: "setAllegedOffenceIds",
    setOffenders: "setOffenders",
    setCallEmailId: "setCallEmailId",
    setRegionId: "setRegionId",
    setDistrictId: "setDistrictId",

    setInspectionId: "setInspectionId",
    setLegalCaseId: "setLegalCaseId",
    createOffence: "createOffence",
    setOffenceEmpty: "setOffenceEmpty",
    setTempDocumentCollectionId: "setTempDocumentCollectionId"
  }), (0, _vuex.mapActions)('inspectionStore', {
    loadInspection: "loadInspection"
  }), (0, _vuex.mapActions)('callemailStore', {
    loadCallEmail: "loadCallEmail"
  }), (0, _vuex.mapActions)('legalCaseStore', {
    loadLegalCase: "loadLegalCase"
  }), {
    setTemporaryDocumentCollectionId: function setTemporaryDocumentCollectionId(val) {
      this.temporary_document_collection_id = val;
    },
    makeModalsDraggable: function makeModalsDraggable() {
      this.elem_modal = (0, _jquery2.default)('.modal > .modal-dialog');
      for (var i = 0; i < this.elem_modal.length; i++) {}
    },
    constructRegionsAndDistricts: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var returned_regions;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _hooks.cache_helper.getSetCacheList("Regions", "/api/regions/");

              case 2:
                returned_regions = _context.sent;

                (0, _assign2.default)(this.regions, returned_regions);
                this.regions.splice(0, 0, {
                  id: "",
                  name: "",
                  district: "",
                  districts: [],
                  region: null
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function constructRegionsAndDistricts() {
        return _ref.apply(this, arguments);
      }

      return constructRegionsAndDistricts;
    }(),
    newPersonCreated: function newPersonCreated(obj) {
      if (obj.person) {
        this.setCurrentOffender('individual', obj.person.id);

        var full_name = [obj.person.first_name, obj.person.last_name].filter(Boolean).join(" ");
        var dob = obj.person.dob ? "DOB:" + obj.person.dob : "DOB: ---";
        var value = [full_name, dob].filter(Boolean).join(", ");
        this.$refs.person_search.setInput(value);
      } else if (obj.err) {} else {}
    },
    personSelected: function personSelected(para) {
      var vm = this;
      vm.setCurrentOffender(para.data_type, para.id);
    },
    removeOffenderClicked: function removeOffenderClicked(e) {
      var vm = this;

      var offenderId = parseInt(e.target.getAttribute("data-offender-id"));
      vm.$refs.offender_table.vmDataTable.rows(function (idx, data, node) {
        if (data.id === offenderId) {
          vm.$refs.offender_table.vmDataTable.row(idx).remove().draw();
        }
      });
    },
    removeClicked: function removeClicked(e) {
      var alleged_offence_uuid = e.target.getAttribute("data-alleged-offence-uuid");

      for (var i = 0; i < this.offence.alleged_offences.length; i++) {
        var alleged_offence = this.offence.alleged_offences[i];
        if (alleged_offence.uuid == alleged_offence_uuid) {
          if (alleged_offence.id) {
            alleged_offence.removed = true;
          } else {
            this.offence.alleged_offences.splice(i, 1);
          }
        }
      }
      this.constructAllegedOffencesTable();
    },
    createNewPersonClicked: function createNewPersonClicked() {
      var vm = this;
      vm.newPersonBeingCreated = true;
      vm.displayCreateNewPerson = !vm.displayCreateNewPerson;
    },
    cancelCreateNewPersonClicked: function cancelCreateNewPersonClicked() {
      var vm = this;
      vm.newPersonBeingCreated = false;
    },
    saveNewPersonClicked: function saveNewPersonClicked() {
      var vm = this;
      vm.newPersonBeingCreated = false;
    },
    addOffenderClicked: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var vm, already_exists, ids, data_types, i;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                vm = this;

                if (!(vm.current_offender && vm.current_offender.id && vm.current_offender.data_type)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 4;
                return this.$refs.search_offender.parentSave();

              case 4:
                already_exists = false;
                ids = vm.$refs.offender_table.vmDataTable.columns(0).data()[0];
                data_types = vm.$refs.offender_table.vmDataTable.columns(1).data()[0];
                i = 0;

              case 8:
                if (!(i < ids.length)) {
                  _context2.next = 15;
                  break;
                }

                if (!(ids[i] == vm.current_offender.id && data_types[i] == vm.current_offender.data_type)) {
                  _context2.next = 12;
                  break;
                }

                already_exists = true;
                return _context2.abrupt("break", 15);

              case 12:
                i++;
                _context2.next = 8;
                break;

              case 15:

                if (!already_exists) {
                  if (vm.current_offender.data_type == "individual") {
                    vm.$refs.offender_table.vmDataTable.row.add({
                      data_type: vm.current_offender.data_type,
                      id: vm.current_offender.id,
                      first_name: vm.current_offender.first_name,
                      last_name: vm.current_offender.last_name,
                      email: vm.current_offender.email,
                      p_number: vm.current_offender.p_number,
                      m_number: vm.current_offender.m_numberum,
                      dob: vm.current_offender.dob
                    }).draw();
                  } else if (vm.current_offender.data_type == "organisation") {
                    vm.$refs.offender_table.vmDataTable.row.add({
                      data_type: vm.current_offender.data_type,
                      id: vm.current_offender.id,
                      name: vm.current_offender.name,
                      abn: vm.current_offender.abn
                    }).draw();
                  }
                }

              case 16:

                vm.setCurrentOffenderEmpty();

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addOffenderClicked() {
        return _ref2.apply(this, arguments);
      }

      return addOffenderClicked;
    }(),
    addAllegedOffenceClicked: function addAllegedOffenceClicked() {
      if (this.current_alleged_offence && this.current_alleged_offence.id) {
        var already_exists = false;
        for (var i = 0; i < this.offence.alleged_offences.length; i++) {
          var alleged_offence = this.offence.alleged_offences[i];
          if (alleged_offence.section_regulation.id == this.current_alleged_offence.id) {
            already_exists = true;
          }
        }

        if (!already_exists) {
          var alleged_offence_obj = {
            id: '',
            removed: false,
            reason_for_removal: '',
            removed_by_id: null,
            section_regulation: {},
            number_linked_sanction_outcomes_total: 0,
            number_linked_sanction_outcomes_active: 0,
            uuid: (0, _uuid2.default)()
          };
          (0, _assign2.default)(alleged_offence_obj.section_regulation, this.current_alleged_offence);
          this.offence.alleged_offences.push(alleged_offence_obj);
        }
      }
      this.setCurrentAllegedOffenceEmpty();
      this.constructAllegedOffencesTable();
    },
    constructAllegedOffencesTable: function constructAllegedOffencesTable() {
      this.$refs.alleged_offence_table.vmDataTable.clear().draw();
      if (this.offence.alleged_offences) {
        for (var i = 0; i < this.offence.alleged_offences.length; i++) {
          this.addAllegedOffenceToTable(this.offence.alleged_offences[i]);
        }
      }
    },
    addAllegedOffenceToTable: function addAllegedOffenceToTable(allegedOffence) {
      allegedOffence.uuid = (0, _uuid2.default)();
      this.$refs.alleged_offence_table.vmDataTable.row.add({ "allegedOffence": allegedOffence, "offence": this.offence }).draw();
    },
    ok: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var response;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.processingDetails = true;
                _context3.next = 4;
                return this.sendData();

              case 4:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 20;
                  break;
                }

                if (this.$parent.$refs.offence_table) {
                  this.$parent.$refs.offence_table.vmDataTable.ajax.reload();
                }

                if (!this.parent_call_email) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 10;
                return this.loadCallEmail({
                  call_email_id: this.call_email.id
                });

              case 10:
                _context3.next = 20;
                break;

              case 12:
                if (!this.parent_legal_case) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 15;
                return this.loadLegalCase({
                  legal_case_id: this.legal_case.id
                });

              case 15:
                _context3.next = 20;
                break;

              case 17:
                if (!this.parent_inspection) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 20;
                return this.loadInspection({
                  inspection_id: this.inspection.id
                });

              case 20:

                if (this.$parent.$refs.related_items_table) {
                  this.$parent.constructRelatedItemsTable();
                }

                this.setOffenceEmpty();
                this.close();
                _context3.next = 28;
                break;

              case 25:
                _context3.prev = 25;
                _context3.t0 = _context3["catch"](0);

                this.processError(_context3.t0);

              case 28:
                _context3.prev = 28;

                this.processingDetails = false;
                return _context3.finish(28);

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 25, 28, 31]]);
      }));

      function ok() {
        return _ref3.apply(this, arguments);
      }

      return ok;
    }(),
    processError: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(err) {
        var errorText, i, _i, field_name, j;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                errorText = '';

                if (err.body) {
                  if (err.body.non_field_errors) {
                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                      errorText += err.body.non_field_errors[i] + '<br />';
                    }
                  } else if (Array.isArray(err.body)) {
                    for (_i = 0; _i < err.body.length; _i++) {
                      errorText += err.body[_i] + '<br />';
                    }
                  } else {
                    for (field_name in err.body) {
                      if (err.body.hasOwnProperty(field_name)) {
                        errorText += field_name + ': ';
                        for (j = 0; j < err.body[field_name].length; j++) {
                          errorText += err.body[field_name][j] + '<br />';
                        }
                      }
                    }
                  }
                } else {
                  errorText += err.message;
                }
                this.errorResponse = errorText;

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function processError(_x) {
        return _ref4.apply(this, arguments);
      }

      return processError;
    }(),
    cancel: function cancel() {
      if (this.$parent.call_email) {
        this.$parent.updateUuid();
      }

      this.processingDetails = false;
      this.close();
    },
    close: function close() {
      this.processingDetails = false;
      this.isModalOpen = false;
    },
    mapOffenceClicked: function mapOffenceClicked() {
      this.$refs.mapOffenceComponent.mapTabClicked();
    },
    sendData: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        var vm, offenders, res;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                vm = this;

                if (this.$parent.call_email && this.$parent.call_email.id) {
                  vm.setCallEmailId(this.$parent.call_email.id);
                }

                if (this.$parent.inspection && this.$parent.inspection.id) {
                  vm.setInspectionId(this.$parent.inspection.id);
                }

                if (this.$parent.legal_case && this.$parent.legal_case.id) {
                  vm.setLegalCaseId(this.$parent.legal_case.id);
                }

                if (this.temporary_document_collection_id) {
                  vm.setTempDocumentCollectionId(this.temporary_document_collection_id);
                }

                offenders = vm.$refs.offender_table.vmDataTable.rows().data().toArray();

                vm.setOffenders(offenders);

                _context5.next = 9;
                return vm.createOffence();

              case 9:
                res = _context5.sent;
                ;
                return _context5.abrupt("return", res);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function sendData() {
        return _ref5.apply(this, arguments);
      }

      return sendData;
    }(),
    addEventListeners: function addEventListeners() {
      var vm = this;
      var el_fr_date = (0, _jquery2.default)(vm.$refs.occurrenceDateFromPicker);
      var el_fr_time = (0, _jquery2.default)(vm.$refs.occurrenceTimeFromPicker);
      var el_to_date = (0, _jquery2.default)(vm.$refs.occurrenceDateToPicker);
      var el_to_time = (0, _jquery2.default)(vm.$refs.occurrenceTimeToPicker);

      el_fr_date.datetimepicker({ format: "DD/MM/YYYY", maxDate: "now", showClear: true });
      el_fr_date.on("dp.change", function (e) {
        if (el_fr_date.data("DateTimePicker").date()) {
          vm.offence.occurrence_date_from = e.date.format("DD/MM/YYYY");
          el_to_date.data('DateTimePicker').minDate(e.date);
        } else if (el_fr_date.data("date") === "") {
          vm.offence.occurrence_date_from = null;
        }
      });

      el_fr_time.datetimepicker({ format: "LT", showClear: true });
      el_fr_time.on("dp.change", function (e) {
        if (el_fr_time.data("DateTimePicker").date()) {
          vm.offence.occurrence_time_from = e.date.format("LT");
        } else if (el_fr_time.data("date") === "") {
          vm.offence.occurrence_time_from = null;
        }
      });

      el_to_date.datetimepicker({ format: "DD/MM/YYYY", maxDate: "now", showClear: true });
      el_to_date.on("dp.change", function (e) {
        if (el_to_date.data("DateTimePicker").date()) {
          vm.offence.occurrence_date_to = e.date.format("DD/MM/YYYY");
          el_fr_date.data('DateTimePicker').maxDate(e.date);
        } else if (el_to_date.data("date") === "") {
          vm.offence.occurrence_date_to = null;
        }
      });

      el_to_time.datetimepicker({ format: "LT", showClear: true });
      el_to_time.on("dp.change", function (e) {
        if (el_to_time.data("DateTimePicker").date()) {
          vm.offence.occurrence_time_to = e.date.format("LT");
        } else if (el_to_time.data("date") === "") {
          vm.offence.occurrence_time_to = null;
        }
      });

      (0, _jquery2.default)("#alleged-offence-table").on("click", ".remove_button", vm.removeClicked);
      (0, _jquery2.default)("#offender-table").on("click", ".remove_button", vm.removeOffenderClicked);
    },
    search: function search(searchTerm) {
      var vm = this;
      vm.suggest_list = [];
      vm.suggest_list.length = 0;
      vm.awe.list = [];

      if (vm.ajax_for_alleged_offence != null) {
        vm.ajax_for_alleged_offence.abort();
        vm.ajax_for_alleged_offence = null;
      }

      vm.ajax_for_alleged_offence = _jquery2.default.ajax({
        type: "GET",
        url: "/api/search_alleged_offences/?search=" + searchTerm,
        success: function success(data) {
          if (data && data.results) {
            var persons = data.results;
            var limit = Math.min(vm.max_items, persons.length);
            for (var i = 0; i < limit; i++) {
              vm.suggest_list.push(persons[i]);
            }
          }

          vm.awe.list = vm.suggest_list;
          vm.awe.evaluate();
        },
        error: function error(e) {}
      });
    },
    markMatchedText: function markMatchedText(original_text, input) {
      var ret_text = original_text.replace(new RegExp(input, "gi"), function (a, b) {
        return "<mark>" + a + "</mark>";
      });
      return ret_text;
    },

    initAwesompleteAllegedOffence: function initAwesompleteAllegedOffence() {
      var self = this;

      var element_search = document.getElementById("alleged-offence");
      self.awe = new _awesomplete2.default(element_search, {
        maxItems: self.max_items,
        sort: false,
        filter: function filter() {
          return true;
        },
        item: function item(text, input) {
          var ret = _awesomplete2.default.ITEM(text, "");
          return ret;
        },
        data: function data(item, input) {
          var act = item.act ? item.act : "";
          var name = item.name ? item.name : "";
          var offence_text = item.offence_text ? item.offence_text : "";

          var act_marked = self.markMatchedText(act, input);
          var name_marked = self.markMatchedText(name, input);
          var offence_text_marked = self.markMatchedText(offence_text, input);

          var myLabel = ["<strong>" + act_marked + ", " + name_marked + "</strong>", offence_text_marked].filter(Boolean).join("<br />");
          myLabel = '<div data-item-id="' + item.id + '">' + myLabel + "</div>";

          return {
            label: myLabel,
            value: [act, name, offence_text].filter(Boolean).join(", "),
            id: item.id
          };
        }
      });
      (0, _jquery2.default)(element_search).on("keyup", function (ev) {
        var keyCode = ev.keyCode || ev.which;
        if (48 <= keyCode && keyCode <= 90 || 96 <= keyCode && keyCode <= 105 || keyCode == 8 || keyCode == 46) {
          self.search(ev.target.value);
          return false;
        }
      }).on("awesomplete-selectcomplete", function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        return false;
      }).on("awesomplete-select", function (ev) {
        var origin = (0, _jquery2.default)(ev.originalEvent.origin);
        var originTagName = origin[0].tagName;
        switch (originTagName) {
          case "STRONG":
            origin = origin.parent();
            break;
          case "MARK":
            origin = origin.parent().parent();
            break;
          case "LI":
            origin = origin.children().first();
            break;
        }
        var elem_id = origin[0].getAttribute("data-item-id");
        for (var i = 0; i < self.suggest_list.length; i++) {
          if (self.suggest_list[i].id == parseInt(elem_id)) {
            self.setCurrentOffenceSelected(self.suggest_list[i]);
            break;
          }
        }
      });
    },
    searchOrganisation: function searchOrganisation(id) {
      return new _promise2.default(function (resolve, reject) {
        _vue2.default.http.get("/api/search_organisation/" + id).then(function (response) {
          resolve(response.body);
        }, function (error) {
          reject(error);
        });
      });
    },
    setCurrentOffender: function setCurrentOffender(data_type, id) {
      var vm = this;
      if (!id) {
        this.current_offender = null;
      } else if (data_type == "individual") {
        var initialisers = [_utils2.default.fetchUser(id)];
        _promise2.default.all(initialisers).then(function (data) {
          vm.current_offender = data[0];
          vm.current_offender.data_type = "individual";
        });
      } else if (data_type == "organisation") {
        var _initialisers = [vm.searchOrganisation(id)];
        _promise2.default.all(_initialisers).then(function (data) {
          vm.current_offender = data[0];
          vm.current_offender.data_type = "organisation";
        });
      }
    },
    setCurrentOffenceSelected: function setCurrentOffenceSelected(offence) {
      var vm = this;

      if (offence.id) {
        vm.current_alleged_offence.id = offence.id;
        vm.current_alleged_offence.act = offence.act;
        vm.current_alleged_offence.name = offence.name;
        vm.current_alleged_offence.offence_text = offence.offence_text;
      } else {
        vm.setCurrentAllegedOffenceEmpty();
      }
    },
    setCurrentOffenderEmpty: function setCurrentOffenderEmpty() {
      var vm = this;

      vm.current_offender = null;

      (0, _jquery2.default)("#offender_input").val("");
      vm.$refs.search_offender.clearInput();
    },
    setCurrentAllegedOffenceEmpty: function setCurrentAllegedOffenceEmpty() {
      var vm = this;

      vm.current_alleged_offence.id = null;
      vm.current_alleged_offence.act = "";
      vm.current_alleged_offence.name = "";
      vm.current_alleged_offence.offence_text = "";

      (0, _jquery2.default)("#alleged-offence").val("");
    },
    currentRegionIdChanged: function currentRegionIdChanged() {
      this.updateDistricts();
    },
    updateDistricts: function updateDistricts(updateFromUI) {
      if (updateFromUI) {
        this.offence.district_id = null;
      }

      this.availableDistricts = [];var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.regions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var region = _step.value;

          if (region.id == this.offence.region_id) {
            this.availableDistricts = region.districts;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.availableDistricts.splice(0, 0, {
        district_id: "",
        district_name: "",
        district: "",
        districts: [],
        region: null
      });
    }
  }),
  created: function () {
    var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
      var self;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              self = this;

              self.setOffenceEmpty();
              self.$nextTick(function () {
                self.initAwesompleteAllegedOffence();
              });
              _context6.next = 5;
              return this.constructRegionsAndDistricts();

            case 5:
              this.setRegionId(this.region_id);
              this.setDistrictId(this.district_id);

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function created() {
      return _ref6.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.addEventListeners();
      _this.makeModalsDraggable();
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);

exports.default = {
    name: "OffenceWorkflow",
    data: function data() {
        return {
            isModalOpen: false,
            files: [{
                'file': null,
                'name': ''
            }],
            workflowDetails: '',
            errorResponse: '',

            allocatedGroup: [],
            allocated_group_id: null
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        filefield: _compliance_file2.default
    },
    props: {
        workflow_type: {
            type: String,
            default: ''
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('offenceStore', {
        offence: "offence"
    }), {
        modalTitle: function modalTitle() {
            switch (this.workflow_type) {
                case 'close':
                    return "Close";
                    break;
                default:
                    return "---";
            }
        },
        regionDistrictId: function regionDistrictId() {
            if (this.offence.district || this.offence.region) {
                return this.offence.district ? this.offence.district : this.offence.region;
            } else {
                return null;
            }
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup' }), {
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.sendData();

                            case 2:
                                response = _context.sent;

                                if (response.ok) {
                                    this.close();
                                    this.$router.push({ name: 'internal-offence-dash' });
                                }

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        cancel: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.$refs.comms_log_file.cancel();

                            case 2:
                                this.isModalOpen = false;
                                this.close();

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function cancel() {
                return _ref2.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
            var file_length = vm.files.length;
            this.files = [];
            for (var i = 0; i < file_length; i++) {
                vm.$nextTick(function () {
                    $('.file-row-' + i).remove();
                });
            }
            this.attachAnother();
        },
        sendData: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var post_url, payload, res;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                post_url = '/api/offence/' + this.offence.id + '/workflow_action/';
                                payload = new FormData();

                                payload.append('details', this.workflowDetails);
                                this.$refs.comms_log_file.commsLogId ? payload.append('comms_log_id', this.$refs.comms_log_file.commsLogId) : null;
                                this.workflow_type ? payload.append('workflow_type', this.workflow_type) : null;

                                console.log('payload');
                                console.log(payload);

                                _context3.prev = 7;
                                _context3.next = 10;
                                return _vue2.default.http.post(post_url, payload);

                            case 10:
                                res = _context3.sent;

                                console.log(res);

                                if (!res.ok) {
                                    _context3.next = 14;
                                    break;
                                }

                                return _context3.abrupt("return", res);

                            case 14:
                                _context3.next = 19;
                                break;

                            case 16:
                                _context3.prev = 16;
                                _context3.t0 = _context3["catch"](7);

                                this.errorResponse = _context3.t0.statusText;

                            case 19:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[7, 16]]);
            }));

            function sendData() {
                return _ref3.apply(this, arguments);
            }

            return sendData;
        }(),
        uploadFile: function uploadFile(target, file_obj) {
            var vm = this;
            var _file = null;
            var file_input = $('.' + target)[0];

            if (file_input.files && file_input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(file_input.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = file_input.files[0];
            }
            file_obj.file = _file;
            file_obj.name = _file.name;
        },
        removeFile: function removeFile(index) {
            var _this = this;

            var length = this.files.length;
            $('.file-row-' + index).remove();
            this.files.splice(index, 1);
            this.$nextTick(function () {
                length == 1 ? _this.attachAnother() : '';
            });
        },
        attachAnother: function attachAnother() {
            this.files.push({
                'file': null,
                'name': ''
            });
        }
    })
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _, $, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _responsive_datatable_helper = __webpack_require__(50);

var _responsive_datatable_helper2 = _interopRequireDefault(_responsive_datatable_helper);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'OrganisationAccess',
    data: function data() {
        var vm = this;
        return {
            loading: [],
            access: {
                requester: {},
                status: {}
            },
            initialisedSelects: false,
            DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
            organisation_access_group_members: [],

            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, vm.$route.params.access_id + '/action_log'),
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, vm.$route.params.access_id + '/comms_log'),
            actionDtOptions: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                deferRender: true,
                autowidth: true,
                order: [[2, 'desc']],
                dom: "<'row'<'col-sm-5'l><'col-sm-6'f>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>",
                processing: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, vm.$route.params.access_id + '/action_log'),
                    "dataSrc": ''
                },
                columns: [{
                    data: "who"
                }, {
                    data: "what"
                }, {
                    data: "when",
                    mRender: function mRender(data, type, full) {
                        return moment(data).format(vm.DATE_TIME_FORMAT);
                    }
                }]
            },
            dtHeaders: ["Who", "What", "When"],
            actionsTable: null,
            commsDtOptions: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                deferRender: true,
                autowidth: true,
                order: [[0, 'desc']],
                processing: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, vm.$route.params.access_id + '/comms_log'),
                    "dataSrc": ''
                },
                columns: [{
                    title: 'Date',
                    data: 'created',
                    render: function render(date) {
                        return moment(date).format(vm.DATE_TIME_FORMAT);
                    }
                }, {
                    title: 'Type',
                    data: 'type'
                }, {
                    title: 'Reference',
                    data: 'reference'
                }, {
                    title: 'To',
                    data: 'to',
                    render: vm.commaToNewline
                }, {
                    title: 'CC',
                    data: 'cc',
                    render: vm.commaToNewline
                }, {
                    title: 'From',
                    data: 'fromm',
                    render: vm.commaToNewline
                }, {
                    title: 'Subject/Desc.',
                    data: 'subject'
                }, {
                    title: 'Text',
                    data: 'text',
                    'render': function render(value) {
                        var ellipsis = '...',
                            truncated = _.truncate(value, {
                            length: 100,
                            omission: ellipsis,
                            separator: ' '
                        }),
                            result = '<span>' + truncated + '</span>',
                            popTemplate = _.template('<a href="#" ' + 'role="button" ' + 'data-toggle="popover" ' + 'data-trigger="click" ' + 'data-placement="top auto"' + 'data-html="true" ' + 'data-content="<%= text %>" ' + '>more</a>');
                        if (_.endsWith(truncated, ellipsis)) {
                            result += popTemplate({
                                text: value
                            });
                        }

                        return result;
                    },
                    'createdCell': function createdCell(cell) {
                        $(cell).popover();
                    }
                }, {
                    title: 'Documents',
                    data: 'documents',
                    'render': function render(values) {
                        var result = '';
                        _.forEach(values, function (value) {
                            var docName = '',
                                url = '';
                            if (_.isArray(value) && value.length > 1) {
                                docName = value[0];
                                url = value[1];
                            }
                            if (typeof s === 'string') {
                                url = value;

                                docName = _.last(value.split('/'));
                                docName = _.truncate(docName, {
                                    length: 18,
                                    omission: '...',
                                    separator: ' '
                                });
                            }
                            result += '<a href="' + url + '" target="_blank"><p>' + docName + '</p></a><br>';
                        });
                        return result;
                    }
                }]
            },
            commsTable: null,
            requestType: null
        };
    },

    watch: {},
    filters: {
        formatDate: function formatDate(data) {
            return moment(data).format('DD/MM/YYYY HH:mm:ss');
        }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, to.params.access_id)).then(function (response) {
            next(function (vm) {
                vm.access = response.body;
                vm.requestType = vm.access.role == 'employee' ? '(Administrator)' : '(Consultant)';
            });
        }, function (error) {
            console.log(error);
        });
    },
    components: {
        datatable: _datatable2.default,
        CommsLogs: _comms_logs2.default
    },
    computed: {
        isLoading: function isLoading() {
            return this.loading.length > 0;
        },
        isFinalised: function isFinalised() {
            return this.access.status.id == 'approved' || this.access.status.id == 'declined';
        },
        isAmendmentRequested: function isAmendmentRequested() {
            return this.access.status.id == 'amendment_requested';
        },
        officerCanProcess: function officerCanProcess() {
            return this.access && this.access.can_be_processed && !this.isFinalised && this.access.user_can_process_org_access_requests ? true : false;
        }
    },
    methods: {
        commaToNewline: function commaToNewline(s) {
            return s.replace(/[,;]/g, '\n');
        },

        fetchAccessGroupMembers: function fetchAccessGroupMembers() {
            var vm = this;
            vm.loading.push('Loading Access Group Members');
            vm.$http.get(_hooks.api_endpoints.organisation_access_group_members).then(function (response) {
                vm.organisation_access_group_members = response.body;
                vm.loading.splice('Loading Access Group Members', 1);
            }, function (error) {
                console.log(error);
                vm.loading.splice('Loading Access Group Members', 1);
            });
        },
        assignToMe: function assignToMe() {
            var vm = this;
            vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, vm.access.id + '/assign_to_me')).then(function (response) {
                vm.access = response.body;
                vm.updateAssignedOfficerSelect();
            }, function (error) {
                vm.updateAssignedOfficerSelect();
                swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
            });
        },
        assignOfficer: function assignOfficer() {
            var vm = this;
            var unassign = true;
            var data = {};
            unassign = vm.access.assigned_officer != null && vm.access.assigned_officer != 'undefined' ? false : true;
            data = { 'officer_id': vm.access.assigned_officer };
            if (!unassign) {
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, vm.access.id + '/assign_officer'), (0, _stringify2.default)(data), {
                    emulateJSON: true
                }).then(function (response) {
                    vm.access = response.body;
                    vm.updateAssignedOfficerSelect();
                }, function (error) {
                    vm.updateAssignedOfficerSelect();
                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                });
            } else {
                vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, vm.access.id + '/unassign_officer')).then(function (response) {
                    vm.access = response.body;
                    vm.updateAssignedOfficerSelect();
                }, function (error) {
                    vm.updateAssignedOfficerSelect();
                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                });
            }
        },
        updateAssignedOfficerSelect: function updateAssignedOfficerSelect() {
            var vm = this;
            $(vm.$refs.assigned_officer).val(vm.access.assigned_officer);
            $(vm.$refs.assigned_officer).trigger('change');
        },
        acceptRequest: function acceptRequest() {
            var vm = this;
            swal({
                title: "Accept Organisation Request",
                text: "Are you sure you want to accept this organisation request?",
                type: "question",
                showCancelButton: true,
                confirmButtonText: 'Accept'
            }).then(function (result) {
                if (result.value) {
                    vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, vm.access.id + '/accept')).then(function (response) {
                        swal({
                            title: "Accept Organisation Request",
                            text: "The organisation access request has been accepted.",
                            type: "success" });
                        vm.access = response.body;
                    }, function (error) {
                        swal({
                            title: "Accept Organisation Request",
                            text: "There was an error accepting the organisation access request.",
                            type: "error" });
                        console.log(error);
                    });
                }
            }, function (error) {});
        },
        amendmentRequest: function amendmentRequest() {
            var vm = this;
            swal({
                title: "Amendment Request",
                text: "Request a new letter from the user.",
                type: "question",
                input: "textarea",
                inputPlaceholder: 'Type your reason for your amendment request here',
                showCancelButton: true,
                confirmButtonText: 'Send Request'
            }).then(function (result) {
                if (result.value) {
                    vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, vm.access.id + '/amendment_request/?reason=' + result.value)).then(function (response) {
                        swal({
                            title: "Amendment Request",
                            text: "A new letter has been requested.",
                            type: "success" });
                        vm.access = response.body;
                    }, function (error) {
                        swal({
                            title: "Amendment Request",
                            text: "There was an error sending the amendment request request.",
                            type: "error" });
                        console.log(error);
                    });
                }
            }, function (error) {});
        },
        declineRequest: function declineRequest() {
            var vm = this;
            swal({
                title: "Decline Organisation Request",
                text: "Are you sure you want to decline this organisation request?",
                type: "question",
                showCancelButton: true,
                confirmButtonText: 'Accept'
            }).then(function (result) {
                if (result.value) {
                    vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, vm.access.id + '/decline')).then(function (response) {
                        swal({
                            title: "Decline Organisation Request",
                            text: "The organisation access request has been declined.",
                            type: "success" });
                        vm.access = response.body;
                    }, function (error) {
                        swal({
                            title: "Decline Organisation Request",
                            text: "There was an error declining the organisation access request.",
                            type: "error" });
                    });
                }
            }, function (error) {});
        },
        initialiseAssignedOfficerSelect: function initialiseAssignedOfficerSelect() {
            var reinit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var vm = this;
            if (reinit) {
                $(vm.$refs.assigned_officer).data('select2') ? $(vm.$refs.assigned_officer).select2('destroy') : '';
            }

            $(vm.$refs.assigned_officer).select2({
                "theme": "bootstrap",
                allowClear: true,
                placeholder: "Select Officer"
            }).on("select2:select", function (e) {
                var selected = $(e.currentTarget);
                vm.access.assigned_officer = selected.val();
                vm.assignOfficer();
            }).on("select2:unselecting", function (e) {
                var self = $(this);
                setTimeout(function () {
                    self.select2('close');
                }, 0);
            }).on("select2:unselect", function (e) {
                var selected = $(e.currentTarget);
                vm.access.assigned_officer = null;
                vm.assignOfficer();
            });
        },
        initialiseSelects: function initialiseSelects() {
            var vm = this;
            if (!vm.initialisedSelects) {
                vm.initialiseAssignedOfficerSelect();
                vm.initialisedSelects = true;
            }
        }
    },
    mounted: function mounted() {
        var vm = this;
        this.fetchAccessGroupMembers();
    },
    updated: function updated() {
        var vm = this;
        this.$nextTick(function () {
            vm.initialiseSelects();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(31), __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'OrganisationAccessDashboard',
    data: function data() {
        var vm = this;
        return {
            filterOrganisation: 'All',
            filterApplicant: 'All',
            filterRole: 'All',
            filterStatus: 'All',
            organisationChoices: [],
            applicantChoices: [],
            roleChoices: [],
            statusChoices: [],
            org_access_request_headers: ["Request Number", "Organisation", "Applicant", "Role", "Status", "Lodged on", "Assigned To", "Action"],
            org_access_request_options: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                processing: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.organisation_requests_paginated, 'datatable_list/?format=datatables'),
                    "dataSrc": 'data',
                    "data": function data(d) {
                        d.organisation = vm.filterOrganisation, d.applicant = vm.filterApplicant, d.role = vm.filterRole, d.status = vm.filterStatus;
                    }
                },
                columns: [{
                    data: "lodgement_number"
                }, {
                    data: "name"
                }, {
                    data: "requester",
                    searchable: false
                }, {
                    data: "role",
                    searchable: false
                }, {
                    data: "status.name",
                    searchable: false
                }, {
                    data: "lodgement_date",
                    mRender: function mRender(data, type, full) {
                        return moment(data).format('DD/MM/YYYY');
                    }
                }, {
                    data: "assigned_officer",
                    searchable: false
                }, {
                    data: "id",
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        links += full.can_be_processed && full.user_can_process_org_access_requests ? '<a href=\'/internal/organisations/access/' + full.id + '\'>Process</a><br/>' : '<a href=\'/internal/organisations/access/' + full.id + '\'>View</a><br/>';
                        return links;
                    }
                }],
                initComplete: function initComplete() {
                    var organisationColumn = vm.$refs.org_access_table.vmDataTable.columns(1);
                    organisationColumn.data().unique().sort().each(function (d, j) {
                        var organisationChoices = [];
                        _jquery2.default.each(d, function (index, a) {
                            a != null && organisationChoices.indexOf(a) < 0 ? organisationChoices.push(a) : '';
                        });
                        vm.organisationChoices = organisationChoices;
                    });

                    var applicantColumn = vm.$refs.org_access_table.vmDataTable.columns(2);
                    applicantColumn.data().unique().sort().each(function (d, j) {
                        var applicationChoices = [];
                        _jquery2.default.each(d, function (index, a) {
                            a != null && applicationChoices.indexOf(a) < 0 ? applicationChoices.push(a) : '';
                        });
                        vm.applicantChoices = applicationChoices;
                    });

                    var roleColumn = vm.$refs.org_access_table.vmDataTable.columns(3);
                    roleColumn.data().unique().sort().each(function (d, j) {
                        var roleChoices = [];
                        _jquery2.default.each(d, function (index, a) {
                            a != null && roleChoices.indexOf(a) < 0 ? roleChoices.push(a) : '';
                        });
                        vm.roleChoices = roleChoices;
                    });

                    var statusColumn = vm.$refs.org_access_table.vmDataTable.columns(4);
                    statusColumn.data().unique().sort().each(function (d, j) {
                        var statusChoices = [];
                        _jquery2.default.each(d, function (index, a) {
                            a != null && statusChoices.indexOf(a) < 0 ? statusChoices.push(a) : '';
                        });
                        vm.statusChoices = statusChoices;
                    });
                }
            }
        };
    },

    watch: {
        filterOrganisation: function filterOrganisation() {
            var vm = this;
            if (vm.filterOrganisation != 'All') {
                vm.$refs.org_access_table.vmDataTable.columns(1).search(vm.filterOrganisation).draw();
            } else {
                vm.$refs.org_access_table.vmDataTable.columns(1).search('').draw();
            }
        },
        filterApplicant: function filterApplicant() {
            var vm = this;
            if (vm.filterApplicant != 'All') {
                vm.$refs.org_access_table.vmDataTable.columns(2).search(vm.filterApplicant).draw();
            } else {
                vm.$refs.org_access_table.vmDataTable.columns(2).search('').draw();
            }
        },
        filterRole: function filterRole() {
            var vm = this;
            if (vm.filterRole != 'All') {
                vm.$refs.org_access_table.vmDataTable.columns(3).search(vm.filterRole).draw();
            } else {
                vm.$refs.org_access_table.vmDataTable.columns(3).search('').draw();
            }
        },
        filterStatus: function filterStatus() {
            var vm = this;
            if (vm.filterStatus != 'All') {
                vm.$refs.org_access_table.vmDataTable.columns(4).search(vm.filterStatus).draw();
            } else {
                vm.$refs.org_access_table.vmDataTable.columns(4).search('').draw();
            }
        }
    },
    components: {
        datatable: _datatable2.default
    },
    computed: {
        isLoading: function isLoading() {
            return this.loading.length == 0;
        }
    },
    methods: {},
    mounted: function mounted() {}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _add_contact = __webpack_require__(129);

var _add_contact2 = _interopRequireDefault(_add_contact);

var _applications_dashboard = __webpack_require__(82);

var _applications_dashboard2 = _interopRequireDefault(_applications_dashboard);

var _licences_dashboard = __webpack_require__(94);

var _licences_dashboard2 = _interopRequireDefault(_licences_dashboard);

var _returns_dashboard = __webpack_require__(95);

var _returns_dashboard2 = _interopRequireDefault(_returns_dashboard);

var _sanction_outcomes_person_org_dashboard = __webpack_require__(324);

var _sanction_outcomes_person_org_dashboard2 = _interopRequireDefault(_sanction_outcomes_person_org_dashboard);

var _intelligence_information = __webpack_require__(320);

var _intelligence_information2 = _interopRequireDefault(_intelligence_information);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _utils = __webpack_require__(33);

var _utils2 = _interopRequireDefault(_utils);

var _api = __webpack_require__(103);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Organisation',
    data: function data() {
        var vm = this;
        return {
            adBody: 'adBody' + vm._uid,
            aBody: 'aBody' + vm._uid,
            pdBody: 'pdBody' + vm._uid,
            pBody: 'pBody' + vm._uid,
            cdBody: 'cdBody' + vm._uid,
            cBody: 'cBody' + vm._uid,
            oBody: 'oBody' + vm._uid,
            dTab: 'dTab' + vm._uid,
            oTab: 'oTab' + vm._uid,
            idBody: 'idBody' + vm._uid,
            org: {
                address: {}
            },
            myorgperms: null,
            loading: [],
            countries: [],
            updatingDetails: false,
            updatingAddress: false,
            updatingContact: false,
            uploadingID: false,
            uploadedID: null,
            empty_list: '/api/empty_list',
            logsTable: null,
            DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
            activate_tables: false,
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.$route.params.org_id + '/comms_log'),
            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.$route.params.org_id + '/action_log'),
            contacts_headers: ["Name", "Phone", "Mobile", "Fax", "Email", "Action"],
            contacts_headers_ref: ["Name", "Role", "Email", "Status"],
            applications_url: _hooks.api_endpoints.applications_paginated + 'internal_datatable_list?org_id=' + vm.$route.params.org_id,
            licences_url: _hooks.api_endpoints.licences_paginated + 'internal_datatable_list?org_id=' + vm.$route.params.org_id,
            returns_url: _hooks.api_endpoints.returns_paginated + 'user_datatable_list?org_id=' + vm.$route.params.org_id,
            contacts_options: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.$route.params.org_id + '/contacts'),
                    "dataSrc": ''
                },
                columns: [{
                    data: 'last_name',
                    mRender: function mRender(data, type, full) {
                        return full.first_name + " " + full.last_name;
                    }
                }, { data: 'phone_number' }, { data: 'mobile_number' }, { data: 'fax_number' }, { data: 'email' }, {
                    data: 'user_status',
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        var name = full.first_name + ' ' + full.last_name;
                        if (full.user_status.id == 'draft') {
                            links += '<a data-email=\'' + full.email + '\' data-name=\'' + name + '\' data-id=\'' + full.id + '\' class="remove-contact">Remove</a><br/>';
                        }
                        return links;
                    }
                }],
                processing: true
            },

            contacts_options_ref: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.$route.params.org_id + '/contacts_exclude'),
                    "dataSrc": ''
                },
                columns: [{
                    data: 'last_name',
                    mRender: function mRender(data, type, full) {
                        return full.first_name + " " + full.last_name;
                    }
                }, {
                    data: 'user_role',
                    mRender: function mRender(data, type, full) {
                        return full.user_role.name;
                    }
                }, { data: 'email' }, {
                    data: 'user_status',
                    mRender: function mRender(data, type, full) {
                        return full.user_status.name;
                    }
                }],
                processing: true

            }

        };
    },

    components: {
        datatable: _datatable2.default,
        ApplicationDashTable: _applications_dashboard2.default,
        LicenceDashTable: _licences_dashboard2.default,
        ReturnDashTable: _returns_dashboard2.default,
        SanctionOutcomePersonOrgDashTable: _sanction_outcomes_person_org_dashboard2.default,
        AddContact: _add_contact2.default,
        CommsLogs: _comms_logs2.default,
        IntelligenceInformation: _intelligence_information2.default
    },
    computed: {
        isLoading: function isLoading() {
            return this.loading.length == 0;
        },
        uploadedIDFileName: function uploadedIDFileName() {
            return this.uploadedID != null ? this.uploadedID.name : '';
        }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var initialisers = [_utils2.default.fetchCountries(), _utils2.default.fetchOrganisation(to.params.org_id), _utils2.default.fetchOrganisationPermissions(to.params.org_id)];
        _promise2.default.all(initialisers).then(function (data) {
            next(function (vm) {
                vm.countries = data[0];
                vm.org = data[1];
                vm.myorgperms = data[2];
                vm.org.address = vm.org.address != null ? vm.org.address : {};
                vm.org.pins = vm.org.pins != null ? vm.org.pins : {};
            });
        });
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var initialisers = [_utils2.default.fetchOrganisation(to.params.org_id), _utils2.default.fetchOrganisationPermissions(to.params.org_id)];
        _promise2.default.all(initialisers).then(function (data) {
            next(function (vm) {
                vm.org = data[0];
                vm.myorgperms = data[1];
                vm.org.address = vm.org.address != null ? vm.org.address : {};
                vm.org.pins = vm.org.pins != null ? vm.org.pins : {};
            });
        });
    },
    methods: {
        set_tabs: function set_tabs() {
            var vm = this;

            $('#pills-tab a[href="#pills-details"]').tab('show');
        },

        addContact: function addContact() {
            this.$refs.add_contact.isModalOpen = true;
        },
        eventListeners: function eventListeners() {
            var vm = this;
            vm.$refs.contacts_datatable.vmDataTable.on('click', '.remove-contact', function (e) {
                e.preventDefault();

                var name = $(e.target).data('name');
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                swal({
                    title: "Delete Contact",
                    text: "Are you sure you want to remove " + name + "(" + email + ") as a contact  ?",
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: 'Accept'
                }).then(function (result) {
                    if (result.value) {
                        vm.deleteContact(id);
                    }
                }, function (error) {});
            });

            $('a[href="#' + vm.oTab + '"]').on('shown.bs.tab', function (e) {
                vm.$refs.applications_table.$refs.application_datatable.vmDataTable.columns.adjust().responsive.recalc();
            });
        },
        updateDetails: function updateDetails() {
            var vm = this;
            vm.updatingDetails = true;
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/update_details'), (0, _stringify2.default)(vm.org), {
                emulateJSON: true
            }).then(function (response) {
                vm.updatingDetails = false;
                vm.org = response.body;
                if (vm.org.address == null) {
                    vm.org.address = {};
                }
                swal('Saved', 'Organisation details have been saved', 'success');
            }, function (error) {
                console.log(error);
                vm.updatingDetails = false;
            });
        },
        addedContact: function addedContact() {
            var vm = this;
            swal('Added', 'The contact has been successfully added.', 'success');
            vm.$refs.contacts_datatable.vmDataTable.ajax.reload();
        },
        deleteContact: function deleteContact(id) {
            var vm = this;

            vm.$http.delete(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_contacts, id), {
                emulateJSON: true
            }).then(function (response) {
                swal('Contact Deleted', 'The contact was successfully deleted', 'success');
                vm.$refs.contacts_datatable.vmDataTable.ajax.reload();
            }, function (error) {
                console.log(error);
                swal('Contact Deleted', 'The contact could not be deleted because of the following error ' + error, 'error');
            });
        },
        updateAddress: function updateAddress() {
            var vm = this;
            vm.updatingAddress = true;
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/update_address'), (0, _stringify2.default)(vm.org.address), {
                emulateJSON: true
            }).then(function (response) {
                vm.updatingAddress = false;
                vm.org = response.body;
                swal('Saved', 'Address details have been saved', 'success');
                if (vm.org.address == null) {
                    vm.org.address = {};
                }
            }, function (error) {
                console.log(error);
                vm.updatingAddress = false;
            });
        },
        readFileID: function readFileID() {
            var vm = this;
            var _file = null;
            var input = $(vm.$refs.uploadedID)[0];
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = input.files[0];
            }
            vm.uploadedID = _file;
        },
        uploadID: function uploadID() {
            var vm = this;
            vm.uploadingID = true;
            var data = new FormData();
            data.append('identification', vm.uploadedID);
            if (vm.uploadedID == null) {
                vm.uploadingID = false;
                swal({
                    title: 'Upload ID',
                    html: 'Please select a file to upload.',
                    type: 'error'
                });
            } else {
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.org.id + '/upload_id'), data, {
                    emulateJSON: true
                }).then(function (response) {
                    vm.uploadingID = false;
                    vm.uploadedID = null;
                    swal({
                        title: 'Upload ID',
                        html: 'The organisation ID has been successfully uploaded.',
                        type: 'success'
                    }).then(function () {
                        window.location.reload(true);
                    });
                }, function (error) {
                    console.log(error);
                    vm.uploadingID = false;
                    var error_msg = '<br/>';
                    for (var key in error.body) {
                        error_msg += key + ': ' + error.body[key] + '<br/>';
                    }
                    swal({
                        title: 'Upload ID',
                        html: 'There was an error uploading the organisation ID.<br/>' + error_msg,
                        type: 'error'
                    });
                });
            }
        }
    },
    mounted: function mounted() {
        var vm = this;
        this.set_tabs();
        this.personal_form = document.forms.personal_form;
        this.eventListeners();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'OrganisationDashTable',
    data: function data() {
        var vm = this;
        return {
            oBody: 'oBody' + vm._uid,
            datatable_id: 'organisation-datatable-' + vm._uid,
            organisation_headers: ["Name", "ABN", "Address", "Action"],
            organisation_options: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'asc']],
                tableID: 'organisation-datatable-' + vm._uid,
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: {
                    "url": _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.organisations_paginated, 'datatable_list/?format=datatables'),
                    "dataSrc": "data"
                },
                columns: [{
                    data: "name",
                    name: "organisation__name"
                }, {
                    data: "abn",
                    name: "organisation__abn"
                }, {
                    data: "address_string",
                    mRender: function mRender(data, type, full) {
                        if (data) {
                            return data;
                        }
                        return '';
                    },
                    orderable: false,
                    searchable: false }, {
                    data: "id",
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        links += '<a href=\'/internal/organisations/' + full.id + '\'>View</a><br/>';
                        return links;
                    },
                    orderable: false,
                    searchable: false
                }],
                processing: true,
                initComplete: function initComplete() {}
            }
        };
    },

    components: {
        datatable: _datatable2.default
    },
    watch: {},
    computed: {},
    methods: {},
    mounted: function mounted() {
        var vm = this;
        $('a[data-toggle="collapse"]').on('click', function () {
            var chev = $(this).children()[0];
            window.setTimeout(function () {
                $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
            }, 100);
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _amendment_request = __webpack_require__(889);

var _amendment_request2 = _interopRequireDefault(_amendment_request);

var _responsive_datatable_helper = __webpack_require__(50);

var _responsive_datatable_helper2 = _interopRequireDefault(_responsive_datatable_helper);

__webpack_require__(67);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ReturnAccess',
    components: {
        CommsLogs: _comms_logs2.default,
        AmendmentRequest: _amendment_request2.default
    },
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format('DD/MM/YYYY HH:mm:ss') : '';
        }
    },
    data: function data() {
        var vm = this;
        return {
            spinner: false,

            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, vm.$route.params.return_id + '/action_log'),
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, vm.$route.params.return_id + '/comms_log'),
            comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, vm.$route.params.return_id + '/add_comms_log')

        };
    },

    props: {
        form_width: {
            type: String,
            default: 'col-md-9'
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['returns', 'returns_tabs', 'selected_returns_tab_id', 'species_list', 'is_external', 'current_user', 'canAssignOfficerFor']), {
        showActionButtons: function showActionButtons() {
            return this.returns.can_be_processed && this.returns.user_in_officers;
        },
        showAssignToList: function showAssignToList() {
            if (this.returns.condition == null) {
                return false;
            }
            return this.canAssignOfficerFor(this.returns.condition.licence_activity_id) && !this.returns.is_accepted && !this.returns.is_draft;
        },
        showSubmitter: function showSubmitter() {
            var submitter = '';
            if (this.returns.submitter != null) {
                submitter = this.returns.submitter.first_name + ' ' + this.returns.submitter.last_name;
            }
            return submitter;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setReturnsTabId', 'setReturnsSpecies', 'setReturnsExternal', 'setReturns', 'loadCurrentUser']), {
        eventListeners: function eventListeners() {},
        initMainTab: function initMainTab() {},
        initSelects: function initSelects() {
            var vm = this;
            if (!vm.initSelects) {
                vm.initSelects = true;
                vm.initMainTab();
            }
            vm.initAssignedOfficerSelect();
        },
        initAssignedOfficerSelect: function initAssignedOfficerSelect() {
            var reinit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var vm = this;
            if (reinit) {
                (0, _jquery2.default)(vm.$refs.assigned_to).data('select2') ? (0, _jquery2.default)(vm.$refs.assigned_to).select2('destroy') : '';
            }

            (0, _jquery2.default)(vm.$refs.assigned_to).select2({
                "theme": "bootstrap",
                allowClear: true,
                placeholder: "Select Officer"
            }).on("select2:select", function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var selected = (0, _jquery2.default)(e.currentTarget);
                vm.returns.assigned_to = selected.val();
                vm.assignOfficer();
            }).on("select2:unselecting", function (e) {
                var vm = (0, _jquery2.default)(this);
                setTimeout(function () {
                    vm.select2('close');
                }, 0);
            }).on("select2:unselect", function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var selected = (0, _jquery2.default)(e.currentTarget);
                vm.returns.assigned_to = null;
                vm.assignOfficer();
            });
        },
        refreshFromResponse: function refreshFromResponse(response) {
            var _this = this;

            this.setReturns(response.body);
            this.$nextTick(function () {
                _this.initAssignedOfficerSelect(true);
                _this.updateAssignedOfficerSelect();
            });
        },
        updateAssignedOfficerSelect: function updateAssignedOfficerSelect() {
            (0, _jquery2.default)(this.$refs.assigned_to).val(this.returns.assigned_to);
            (0, _jquery2.default)(this.$refs.assigned_to).trigger('change');
        },
        assignToMe: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var _this2 = this;

                var data;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.save_wo();

                            case 2:
                                data = {};

                                this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.returns.id + '/assign_to_me'), (0, _stringify2.default)(data), {
                                    emulateJSON: true

                                }).then(function (response) {
                                    _this2.refreshFromResponse(response);
                                    _this2.updateAssignedOfficerSelect();
                                }, function (error) {
                                    console.log(error);
                                    swal('Application Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function assignToMe() {
                return _ref.apply(this, arguments);
            }

            return assignToMe;
        }(),
        assignOfficer: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var _this3 = this;

                var unassign, data;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.save_wo();

                            case 2:
                                unassign = true;
                                data = {};

                                unassign = this.returns.assigned_to == null ? true : false;
                                data = {
                                    'officer_id': this.returns.assigned_to
                                };
                                if (!unassign) {
                                    this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.returns.id + '/assign_officer'), (0, _stringify2.default)(data), {
                                        emulateJSON: true

                                    }).then(function (response) {
                                        _this3.refreshFromResponse(response);
                                        _this3.updateAssignedOfficerSelect();
                                    }, function (error) {
                                        console.log(error);
                                        swal('Returns Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                    });
                                } else {
                                    this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.returns.id + '/unassign_officer'), (0, _stringify2.default)(data), {
                                        emulateJSON: true

                                    }).then(function (response) {
                                        _this3.refreshFromResponse(response);
                                        _this3.updateAssignedOfficerSelect();
                                    }, function (error) {
                                        console.log(error);

                                        swal('Returns Error', _hooks.helpers.apiVueResourceError(error), 'error');
                                    });
                                }

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function assignOfficer() {
                return _ref2.apply(this, arguments);
            }

            return assignOfficer;
        }(),
        save_wo: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { showNotification: true };
                var showNotification, data;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                showNotification = props.showNotification;

                                this.form = document.forms.internal_returns_form;
                                data = new FormData(this.form);


                                this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.returns.id + '/officer_comments'), data, {
                                    emulateJSON: true

                                }).then(function (response) {

                                    return true;
                                }, function (error) {
                                    console.log(error);
                                    swal('Error', 'There was an error saving your return details.<br/>' + error.body, 'error');
                                });

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function save_wo() {
                return _ref3.apply(this, arguments);
            }

            return save_wo;
        }(),
        amendmentRequest: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.save_wo();

                            case 2:
                                this.$refs.amendment_request.amendment.text = '';
                                this.$refs.amendment_request.isModalOpen = true;

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function amendmentRequest() {
                return _ref4.apply(this, arguments);
            }

            return amendmentRequest;
        }(),
        acceptReturn: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                var _this4 = this;

                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.save_wo();

                            case 2:
                                this.form = document.forms.internal_returns_form;

                                this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.returns.id + '/accept'), {
                                    emulateJSON: true

                                }).then(function (response) {
                                    _this4.$router.push({ name: "internal-dash" });
                                }, function (error) {
                                    console.log(error);
                                    swal('Error', 'There was an error accepting the return.<br/>' + error.body, 'error');
                                });

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function acceptReturn() {
                return _ref5.apply(this, arguments);
            }

            return acceptReturn;
        }()
    }),
    updated: function updated() {
        var _this5 = this;

        this.$nextTick(function () {
            _this5.form = document.forms.internal_returns_form;
            _this5.initSelects();
            _this5.eventListeners();
        });
    },
    created: function created() {},
    mounted: function mounted() {}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(10)))

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'amendment-request',
    components: {
        modal: _bootstrapModal2.default,
        alert: _alert2.default
    },
    props: {},
    data: function data() {
        var vm = this;
        return {
            isModalOpen: false,
            form: null,
            amendment: {
                reason: '',
                amendingReturn: false,
                a_return: null,
                text: null,
                activity_list: []
            },
            reason_choices: {},
            errors: false,
            errorString: '',
            validation_form: null
        };
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isReturnsLoaded', 'returns', 'is_external']), {
        showError: function showError() {
            var vm = this;
            return vm.errors;
        },
        amendableActivities: function amendableActivities() {
            var _this = this;

            return this.licenceActivities(['with_officer', 'with_assessor', 'with_officer_conditions']).filter(function (activity) {
                return _this.hasRole('licensing_officer', activity.id);
            });
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setReturns']), {
        ok: function ok() {
            var vm = this;
            if ($(vm.form).valid()) {
                vm.sendData();
            }
        },
        cancel: function cancel() {
            this.isModalOpen = false;
            this.amendment = {
                reason: '',
                a_return: this.returns.id,
                text: null,
                licence_activity: null,
                activity_list: []
            };
        },
        close: function close() {
            this.isModalOpen = false;
            this.amendment = {
                reason: '',
                application: this.application_id,
                text: null,
                licence_activity: null,
                activity_list: []
            };
            this.errors = false;
            $(this.$refs.reason).val(null).trigger('change');
            $('.has-error').removeClass('has-error');

            this.validation_form.resetForm();
        },
        fetchAmendmentChoices: function fetchAmendmentChoices() {
            var vm = this;
            vm.$http.get('/api/return_amendment_request_reason_choices.json').then(function (response) {
                vm.reason_choices = response.body;
            }, function (error) {
                console.log(error);
            });
        },
        sendData: function sendData() {
            var _this2 = this;

            var self = this;
            self.errors = false;
            self.amendment.a_return = this.returns;
            var amendment = JSON.parse((0, _stringify2.default)(self.amendment));

            self.$http.post('/api/returns_amendment.json', (0, _stringify2.default)(amendment), {
                emulateJSON: true
            }).then(function (response) {
                var species_id = _this2.returns.sheet_species;
                _this2.setReturns(response.body);
                _this2.returns.sheet_species = species_id;
                swal('Sent', 'An email has been sent to the Licensee with the request to amend this Return.', 'success');

                _this2.$router.push({ name: "internal-dash" });
            }, function (error) {
                console.log(error);
                vm.errors = true;
                vm.errorString = _hooks.helpers.apiVueResourceError(error);
            });
        },
        addFormValidations: function addFormValidations() {
            var vm = this;
            vm.validation_form = $(vm.form).validate({
                rules: {
                    reason: "required"

                },
                messages: {
                    reason: "field is required"

                },
                showErrors: function showErrors(errorMap, errorList) {
                    $.each(this.validElements(), function (index, element) {
                        var $element = $(element);
                        $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                    });

                    $("." + this.settings.validClass).tooltip("destroy");

                    for (var i = 0; i < errorList.length; i++) {
                        var error = errorList[i];
                        $(error.element).tooltip({
                            trigger: "focus"
                        }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                    }
                }
            });
        },
        eventListerners: function eventListerners() {
            var vm = this;
        }
    }),
    mounted: function mounted() {
        var vm = this;
        vm.form = document.forms.amendForm;
        vm.fetchAmendmentChoices();
        vm.addFormValidations();
        this.$nextTick(function () {
            vm.eventListerners();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _returns_dashboard = __webpack_require__(95);

var _returns_dashboard2 = _interopRequireDefault(_returns_dashboard);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'InternalReturnsDashboard',
    data: function data() {
        var vm = this;
        return {
            returns_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.returns_paginated, 'user_datatable_list/?format=datatables')
        };
    },

    watch: {},
    components: {
        ReturnDashTable: _returns_dashboard2.default
    },
    computed: {},
    methods: {},
    mounted: function mounted() {}
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, swal, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _returns_form = __webpack_require__(132);

var _returns_form2 = _interopRequireDefault(_returns_form);

var _enter_return_question = __webpack_require__(327);

var _enter_return_question2 = _interopRequireDefault(_enter_return_question);

var _enter_return_sheet = __webpack_require__(328);

var _enter_return_sheet2 = _interopRequireDefault(_enter_return_sheet);

var _enter_return = __webpack_require__(326);

var _enter_return2 = _interopRequireDefault(_enter_return);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _responsive_datatable_helper = __webpack_require__(50);

var _responsive_datatable_helper2 = _interopRequireDefault(_responsive_datatable_helper);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'internal-returns',
    filters: {
        formatDate: function formatDate(data) {
            return data ? moment(data).format('DD/MM/YYYY HH:mm:ss') : '';
        }
    },
    data: function data() {
        var vm = this;
        return {
            pdBody: 'pdBody' + vm._uid,
            panelClickersInitialised: false,

            assignTo: false,
            loading: [],
            spinner: false,
            spinner_exit: false,
            spinner_continue: false,
            disable_exit: false,
            disable_continue: false,

            DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
            members: [],

            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, vm.$route.params.return_id + '/action_log'),
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, vm.$route.params.return_id + '/comms_log'),
            comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, vm.$route.params.return_id + '/add_comms_log')

        };
    },

    components: {
        Returns: _returns_form2.default,
        CommsLogs: _comms_logs2.default,
        ReturnQuestion: _enter_return_question2.default,
        ReturnSheet: _enter_return_sheet2.default,
        ReturnData: _enter_return2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isReturnsLoaded', 'returns', 'is_external', 'species_cache']), {
        showSpinner: function showSpinner() {
            return this.spinner;
        },
        showSaveButton: function showSaveButton() {
            return !this.returns.is_draft && this.returns.can_be_processed && this.returns.user_in_officers;
        },
        showSaveAndContinueButton: function showSaveAndContinueButton() {
            return this.returns.is_draft && this.returns.user_in_officers;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        load: 'loadReturns'
    }), (0, _vuex.mapActions)(['setReturns']), {
        save: function save() {
            var _this = this;

            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { showNotification: true };

            this.spinner = true;
            var showNotification = props.showNotification;

            this.form = document.forms.internal_returns_form;
            var data = new FormData(this.form);

            this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.returns.id + '/officer_comments'), data, {
                emulateJSON: true

            }).then(function (response) {
                _this.spinner = false;
                var species_id = _this.returns.sheet_species;
                _this.setReturns(response.body);
                _this.returns.sheet_species = species_id;

                swal('Save', 'Return Details Saved', 'success');
            }, function (error) {
                _this.spinner = false;
                console.log(error);
                swal('Error', 'There was an error saving your return details.<br/>' + error.body, 'error');
            });
        },
        saveandcontinue: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(andContinue) {
                var _this2 = this;

                var data, speciesID, _speciesJSON, i, speciesJSON, cnt, _loop, _speciesID;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.is_saving = true;
                                this.disable_submit = true;
                                this.disable_exit = true;
                                this.disable_continue = true;
                                this.spinner_exit = !andContinue;
                                this.spinner_continue = andContinue;
                                this.form = document.forms.internal_returns_form;
                                data = new FormData(this.form);

                                for (speciesID in this.species_cache) {
                                    _speciesJSON = [];

                                    for (i = 0; i < this.species_cache[speciesID].length; i++) {
                                        _speciesJSON[i] = this.species_cache[speciesID][i];
                                    }
                                    data.append(speciesID, (0, _stringify2.default)(_speciesJSON));
                                };
                                speciesJSON = [];
                                cnt = 0;

                                _loop = function _loop(_speciesID) {
                                    (0, _keys2.default)(_this2.species_transfer[_speciesID]).forEach(function (key) {
                                        speciesJSON[cnt] = (0, _stringify2.default)(this.species_transfer[_speciesID][key]);
                                        cnt++;
                                    });
                                    data.append('transfer', speciesJSON);
                                };

                                for (_speciesID in this.species_transfer) {
                                    _loop(_speciesID);
                                }
                                _context.next = 16;
                                return this.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.returns, this.returns.id + '/save'), data, {
                                    emulateJSON: true
                                }).then(function (response) {
                                    var species_id = _this2.returns.sheet_species;
                                    _this2.setReturns(response.body);
                                    _this2.returns.sheet_species = species_id;
                                    _this2.returns.species = species_id;
                                    _this2.is_saving = false;
                                    _this2.disable_submit = false;
                                    _this2.disable_exit = false;
                                    _this2.disable_continue = false;
                                    _this2.spinner_exit = false;
                                    _this2.spinner_continue = false;
                                    if (andContinue) {

                                        swal('Save', 'Return Details Saved', 'success');
                                    } else {

                                        _this2.$router.push({ name: "internal-returns-dash" });
                                    }
                                }, function (error) {
                                    _this2.is_saving = false;
                                    _this2.disable_submit = false;
                                    _this2.disable_exit = false;
                                    _this2.disable_continue = false;
                                    _this2.spinner_exit = false;
                                    _this2.spinner_continue = false;
                                    console.log(error);
                                    swal('Error', 'There was an error saving your return details.<br/>' + error.body, 'error');
                                });

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function saveandcontinue(_x2) {
                return _ref.apply(this, arguments);
            }

            return saveandcontinue;
        }()
    }),
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (vm) {
            vm.load({ url: '/api/returns/' + to.params.return_id + '.json' });
        });
    },
    updated: function updated() {
        var self = this;
        if (!self.panelClickersInitialised) {
            $('.panelClicker[data-toggle="collapse"]').on('click', function () {
                var chev = $(this).children()[0];
                window.setTimeout(function () {
                    $(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
                }, 100);
            });
            self.panelClickersInitialised = true;
        }
    },
    mounted: function mounted() {}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(2)))

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);

exports.default = {
    name: "AcceptRemediationAction",
    data: function data() {
        return {
            processingDetails: false,
            isModalOpen: false,
            errorResponse: '',

            allocatedGroup: [],
            allocated_group_id: null
        };
    },
    components: {
        modal: _bootstrapModal2.default
    },
    props: {
        remediation_action_id: {
            type: Number,
            default: 0
        }
    },
    computed: {
        modalTitle: function modalTitle() {
            return 'Accept Remediation Action';
        },
        fieldsFilled: function fieldsFilled() {
            var filled = true;

            return filled;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.addEventListeners();
        });
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup' }), {
        addEventListeners: function addEventListeners() {},
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.processingDetails = true;
                                _context.next = 4;
                                return this.sendData();

                            case 4:
                                response = _context.sent;

                                this.close();
                                this.$emit('remediation_action_accepted', this.remediation_action_id);
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](0);

                                this.processError(_context.t0);

                            case 12:
                                _context.prev = 12;

                                this.processingDetails = false;
                                return _context.finish(12);

                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 9, 12, 15]]);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        processError: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(err) {
                var errorText, i, _i, field_name, j;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                errorText = '';

                                if (err.body.non_field_errors) {
                                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                                        errorText += err.body.non_field_errors[i] + '<br />';
                                    }
                                } else if (Array.isArray(err.body)) {
                                    for (_i = 0; _i < err.body.length; _i++) {
                                        errorText += err.body[_i] + '<br />';
                                    }
                                } else {
                                    for (field_name in err.body) {
                                        if (err.body.hasOwnProperty(field_name)) {
                                            errorText += field_name + ': ';
                                            for (j = 0; j < err.body[field_name].length; j++) {
                                                errorText += err.body[field_name][j] + '<br />';
                                            }
                                        }
                                    }
                                }
                                this.errorResponse = errorText;

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function processError(_x) {
                return _ref2.apply(this, arguments);
            }

            return processError;
        }(),
        cancel: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.isModalOpen = false;
                                this.close();

                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function cancel() {
                return _ref3.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
        },
        sendData: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var get_url, res;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                get_url = '/api/remediation_action/' + this.remediation_action_id + '/accept/';
                                _context4.next = 3;
                                return _vue2.default.http.get(get_url, {});

                            case 3:
                                res = _context4.sent;
                                return _context4.abrupt("return", res);

                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function sendData() {
                return _ref4.apply(this, arguments);
            }

            return sendData;
        }()
    })
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

__webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);

exports.default = {
    name: "ExtendPaymentDueDate",
    data: function data() {
        return {
            processingDetails: false,
            isModalOpen: false,
            files: [{
                'file': null,
                'name': ''
            }],
            reasonForExtension: '',
            errorResponse: '',

            allocatedGroup: [],
            allocated_group_id: null,

            new_due_date: null
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        filefield: _compliance_file2.default
    },
    props: {
        due_date_1st: {
            type: String,
            default: ''
        },
        due_date_2nd: {
            type: String,
            default: ''
        },
        due_date_max: {
            type: String,
            default: ''
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('sanctionOutcomeStore', {
        sanction_outcome: "sanction_outcome"
    }), {
        modalTitle: function modalTitle() {
            return 'Extend payment due date';
        },
        extendMinDateDisplay: function extendMinDateDisplay() {
            console.log('*** in extendMinDateDisplay ***');
            if (this.comingDueDate) {
                var due_date_plus_1 = moment(this.comingDueDate).add(1, 'days');
                return due_date_plus_1.format('DD/MM/YYYY');
            } else {
                return '';
            }
        },
        extendMaxDateDisplay: function extendMaxDateDisplay() {
            if (this.extendMaxDate) {
                var extend_max_date = moment(this.extendMaxDate);
                return extend_max_date.format('DD/MM/YYYY');
            } else {
                return '';
            }
        },
        extendMaxDate: function extendMaxDate() {
            return new Date(this.due_date_max);
        },
        comingDueDateDisplay: function comingDueDateDisplay() {
            if (this.comingDueDate) {
                var due_date = moment(this.comingDueDate);
                return due_date.format('DD/MM/YYYY');
            } else {
                return '';
            }
        },
        comingDueDate: function comingDueDate() {
            if (this.due_date_1st && this.due_date_2nd) {
                var now = new Date();
                var due_1st = new Date(this.due_date_1st);
                var due_2nd = new Date(this.due_date_2nd);

                if (now <= due_1st) {
                    return due_1st;
                } else if (now <= due_2nd) {
                    return due_2nd;
                } else {
                    console.warn('This infringement notice is already overdue');
                    return null;
                }
            } else {
                return null;
            }
        }
    }),
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.addEventListeners();
            _this.makeModalsDraggable();
        });
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup' }), {
        makeModalsDraggable: function makeModalsDraggable() {
            this.elem_modal = $('.modal > .modal-dialog');
            for (var i = 0; i < this.elem_modal.length; i++) {
                $(this.elem_modal[i]).draggable();
            }
        },
        addEventListeners: function addEventListeners() {
            console.log('in addEventListeners');

            var vm = this;
            var el_fr_date = $(vm.$refs.newDueDatePicker);
            var options = { format: "DD/MM/YYYY" };

            if (vm.due_date_max) {
                options['maxDate'] = vm.extendMaxDate;
            }

            console.log(vm.comingDueDate);

            if (vm.comingDueDate) {
                var coming_due_date = new Date(vm.comingDueDate.getTime());

                coming_due_date.setDate(coming_due_date.getDate() + 1);
                options['minDate'] = coming_due_date;

                vm.new_due_date = coming_due_date.getDate() + '/' + (coming_due_date.getMonth() + 1) + '/' + coming_due_date.getFullYear();
            }

            el_fr_date.datetimepicker(options);

            el_fr_date.on("dp.change", function (e) {
                if (el_fr_date.data("DateTimePicker").date()) {
                    vm.new_due_date = e.date.format("DD/MM/YYYY");
                } else if (el_fr_date.data("date") === "") {
                    vm.new_due_date = null;
                }
            });
        },
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.processingDetails = true;
                                _context.next = 4;
                                return this.sendData();

                            case 4:
                                response = _context.sent;

                                this.close();
                                this.$parent.loadSanctionOutcome({ sanction_outcome_id: this.$parent.sanction_outcome.id });
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](0);

                                this.processError(_context.t0);

                            case 12:
                                _context.prev = 12;

                                this.processingDetails = false;
                                return _context.finish(12);

                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 9, 12, 15]]);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        processError: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(err) {
                var errorText, i, _i, field_name, j;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                errorText = '';

                                if (err.body.non_field_errors) {
                                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                                        errorText += err.body.non_field_errors[i] + '<br />';
                                    }
                                } else if (Array.isArray(err.body)) {
                                    for (_i = 0; _i < err.body.length; _i++) {
                                        errorText += err.body[_i] + '<br />';
                                    }
                                } else {
                                    for (field_name in err.body) {
                                        if (err.body.hasOwnProperty(field_name)) {
                                            errorText += field_name + ': ';
                                            for (j = 0; j < err.body[field_name].length; j++) {
                                                errorText += err.body[field_name][j] + '<br />';
                                            }
                                        }
                                    }
                                }
                                this.errorResponse = errorText;

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function processError(_x) {
                return _ref2.apply(this, arguments);
            }

            return processError;
        }(),
        cancel: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$refs.comms_log_file.cancel();

                            case 2:
                                this.isModalOpen = false;
                                this.close();

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function cancel() {
                return _ref3.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
            var file_length = vm.files.length;
            this.files = [];
            for (var i = 0; i < file_length; i++) {
                vm.$nextTick(function () {
                    $('.file-row-' + i).remove();
                });
            }
            this.attachAnother();
        },
        sendData: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var post_url, payload, res;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                post_url = '/api/sanction_outcome/' + this.sanction_outcome.id + '/extend_due_date/';
                                payload = new FormData();

                                payload.append('reason', this.reasonForExtension);
                                this.$refs.comms_log_file.commsLogId ? payload.append('comms_log_id', this.$refs.comms_log_file.commsLogId) : null;
                                this.new_due_date ? payload.append('new_due_date', this.new_due_date) : null;

                                _context4.next = 7;
                                return _vue2.default.http.post(post_url, payload);

                            case 7:
                                res = _context4.sent;
                                return _context4.abrupt("return", res);

                            case 9:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function sendData() {
                return _ref4.apply(this, arguments);
            }

            return sendData;
        }(),
        uploadFile: function uploadFile(target, file_obj) {
            var vm = this;
            var _file = null;
            var file_input = $('.' + target)[0];

            if (file_input.files && file_input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(file_input.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = file_input.files[0];
            }
            file_obj.file = _file;
            file_obj.name = _file.name;
        },
        removeFile: function removeFile(index) {
            var _this2 = this;

            var length = this.files.length;
            $('.file-row-' + index).remove();
            this.files.splice(index, 1);
            this.$nextTick(function () {
                length == 1 ? _this2.attachAnother() : '';
            });
        },
        attachAnother: function attachAnother() {
            this.files.push({
                'file': null,
                'name': ''
            });
        }
    })
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(2)))

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);

exports.default = {
    name: "RecordFERCaseNumber",
    data: function data() {
        return {
            processingDetails: false,
            isModalOpen: false,
            ferCaseNumber1st: '',
            ferCaseNumber2nd: '',
            errorResponse: '',

            allocatedGroup: [],
            allocated_group_id: null,

            new_due_date: null
        };
    },
    components: {
        modal: _bootstrapModal2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('sanctionOutcomeStore', {
        sanction_outcome: "sanction_outcome"
    }), {
        modalTitle: function modalTitle() {
            return 'Record FER Case number';
        },
        fieldsFilled: function fieldsFilled() {
            var filled = false;
            if (this.ferCaseNumber1st && this.ferCaseNumber2nd) {
                filled = true;
            }

            return filled;
        }
    }),
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.addEventListeners();
        });
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup' }), {
        addEventListeners: function addEventListeners() {},
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.processingDetails = true;
                                _context.next = 4;
                                return this.sendData();

                            case 4:
                                response = _context.sent;

                                this.close();
                                this.$router.push({ name: 'internal-sanction-outcome-dash' });
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](0);

                                this.processError(_context.t0);

                            case 12:
                                _context.prev = 12;

                                this.processingDetails = false;
                                return _context.finish(12);

                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 9, 12, 15]]);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        processError: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(err) {
                var errorText, i, _i, field_name, j;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                errorText = '';

                                if (err.body.non_field_errors) {
                                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                                        errorText += err.body.non_field_errors[i] + '<br />';
                                    }
                                } else if (Array.isArray(err.body)) {
                                    for (_i = 0; _i < err.body.length; _i++) {
                                        errorText += err.body[_i] + '<br />';
                                    }
                                } else {
                                    for (field_name in err.body) {
                                        if (err.body.hasOwnProperty(field_name)) {
                                            errorText += field_name + ': ';
                                            for (j = 0; j < err.body[field_name].length; j++) {
                                                errorText += err.body[field_name][j] + '<br />';
                                            }
                                        }
                                    }
                                }
                                this.errorResponse = errorText;

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function processError(_x) {
                return _ref2.apply(this, arguments);
            }

            return processError;
        }(),
        cancel: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.isModalOpen = false;
                                this.close();

                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function cancel() {
                return _ref3.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
        },
        sendData: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var post_url, payload, res;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                post_url = '/api/sanction_outcome/' + this.sanction_outcome.id + '/record_fer_case_number/';
                                payload = new FormData();

                                payload.append('fer_case_number_1st', this.ferCaseNumber1st);
                                payload.append('fer_case_number_2nd', this.ferCaseNumber2nd);
                                _context4.next = 6;
                                return _vue2.default.http.post(post_url, payload);

                            case 6:
                                res = _context4.sent;
                                return _context4.abrupt("return", res);

                            case 8:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function sendData() {
                return _ref4.apply(this, arguments);
            }

            return sendData;
        }()
    })
};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);

exports.default = {
    name: "AmendmentRequestRemediationAction",
    data: function data() {
        return {
            processingDetails: false,
            isModalOpen: false,
            errorResponse: '',
            amendment_request_reason: '',
            amendment_request_reasons: [],
            details: ''
        };
    },
    components: {
        modal: _bootstrapModal2.default
    },
    props: {
        remediation_action_id: {
            type: Number,
            default: 0
        }
    },
    computed: {
        modalTitle: function modalTitle() {
            return 'Request Amendment';
        },
        fieldsFilled: function fieldsFilled() {
            var filled = true;

            return filled;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.addEventListeners();
        });
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.constructOptionsReasons();

                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup' }), {
        addEventListeners: function addEventListeners() {},
        constructOptionsReasons: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var get_url, res;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                get_url = '/api/sanction_outcome/reasons/';
                                _context2.next = 3;
                                return _vue2.default.http.get(get_url, {});

                            case 3:
                                res = _context2.sent;

                                console.log('res.body');
                                console.log(res.body);
                                this.amendment_request_reasons = res.body;

                            case 7:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function constructOptionsReasons() {
                return _ref2.apply(this, arguments);
            }

            return constructOptionsReasons;
        }(),
        ok: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var res;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;

                                console.log('ok');
                                this.processingDetails = true;
                                _context3.next = 5;
                                return this.sendData();

                            case 5:
                                res = _context3.sent;

                                this.$emit('remediation_action_updated', this.remediation_action_id);
                                this.close();
                                _context3.next = 13;
                                break;

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3["catch"](0);

                                this.processError(_context3.t0);

                            case 13:
                                _context3.prev = 13;

                                this.processingDetails = false;
                                return _context3.finish(13);

                            case 16:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 10, 13, 16]]);
            }));

            function ok() {
                return _ref3.apply(this, arguments);
            }

            return ok;
        }(),
        processError: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(err) {
                var errorText, i, _i, field_name, j;

                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                errorText = '';

                                if (err.body.non_field_errors) {
                                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                                        errorText += err.body.non_field_errors[i] + '<br />';
                                    }
                                } else if (Array.isArray(err.body)) {
                                    for (_i = 0; _i < err.body.length; _i++) {
                                        errorText += err.body[_i] + '<br />';
                                    }
                                } else {
                                    for (field_name in err.body) {
                                        if (err.body.hasOwnProperty(field_name)) {
                                            errorText += field_name + ': ';
                                            for (j = 0; j < err.body[field_name].length; j++) {
                                                errorText += err.body[field_name][j] + '<br />';
                                            }
                                        }
                                    }
                                }
                                this.errorResponse = errorText;

                            case 3:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function processError(_x) {
                return _ref4.apply(this, arguments);
            }

            return processError;
        }(),
        cancel: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this.isModalOpen = false;
                                this.close();

                            case 2:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function cancel() {
                return _ref5.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
        },
        sendData: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
                var get_url, payload, res;
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                console.log('sendData');
                                get_url = '/api/remediation_action/' + this.remediation_action_id + '/request_amendment/';
                                payload = {
                                    'reason': this.amendment_request_reason,
                                    'details': this.details,
                                    'remediation_action_id': this.remediation_action_id
                                };

                                console.log(payload);
                                _context6.next = 6;
                                return _vue2.default.http.post(get_url, payload);

                            case 6:
                                res = _context6.sent;
                                return _context6.abrupt("return", res);

                            case 8:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function sendData() {
                return _ref6.apply(this, arguments);
            }

            return sendData;
        }()
    })
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _, swal, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getOwnPropertyNames = __webpack_require__(70);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _utils = __webpack_require__(26);

var _utils2 = _interopRequireDefault(_utils);

var _hooks = __webpack_require__(3);

var _vuex = __webpack_require__(6);

var _assignment = __webpack_require__(97);

var _assignment2 = _interopRequireDefault(_assignment);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _sanction_outcome_workflow = __webpack_require__(898);

var _sanction_outcome_workflow2 = _interopRequireDefault(_sanction_outcome_workflow);

var _extend_payment_due_date = __webpack_require__(893);

var _extend_payment_due_date2 = _interopRequireDefault(_extend_payment_due_date);

var _record_fer_case_number = __webpack_require__(894);

var _record_fer_case_number2 = _interopRequireDefault(_record_fer_case_number);

var _send_parking_infringement = __webpack_require__(899);

var _send_parking_infringement2 = _interopRequireDefault(_send_parking_infringement);

var _accept_remediation_action = __webpack_require__(892);

var _accept_remediation_action2 = _interopRequireDefault(_accept_remediation_action);

var _request_amendment_remediation_action = __webpack_require__(895);

var _request_amendment_remediation_action2 = _interopRequireDefault(_request_amendment_remediation_action);

__webpack_require__(15);

var _objectHash = __webpack_require__(55);

var _objectHash2 = _interopRequireDefault(_objectHash);

var _related_items = __webpack_require__(58);

var _related_items2 = _interopRequireDefault(_related_items);

var _search_person_or_organisation = __webpack_require__(49);

var _search_person_or_organisation2 = _interopRequireDefault(_search_person_or_organisation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ViewSanctionOutcome',
    data: function data() {
        var vm = this;
        vm.STATUS_DRAFT = 'draft';
        vm.STATUS_AWAITING_ENDORSEMENT = 'awaiting_endorsement';
        vm.STATUS_AWAITING_PRINT_AND_POST = 'awaiting_print_and_post';
        vm.STATUS_AWAITING_REVIEW = 'awaiting_review';
        vm.STATUS_AWAITING_AMENDMENT = 'awaiting_amendment';
        vm.STATUS_AWAITING_PAYMENT = 'awaiting_payment';
        vm.STATUS_WITH_DOT = 'with_dot';
        vm.STATUS_AWAITING_ISSUANCE = 'awaiting_issuance';
        vm.STATUS_DECLINED = 'declined';
        vm.STATUS_OVERDUE = 'overdue';
        vm.STATUS_ESCALATED_FOR_WITHDRAWAL = 'escalated_for_withdrawal';
        vm.STATUS_AWAITING_REMEDIATION_ACTIONS = 'awaiting_remediation_actions';
        vm.STATUS_WITHDRAWN = 'withdrawn';

        return {
            registrationHolderId: 0,
            driverId: 0,
            bindId: 0,
            sendParkingInfringementId: 0,
            ferCaseNumberId: 0,
            extendDueDateId: 0,
            temporary_document_collection_id: null,
            workflow_type: '',
            workflowBindId: '',
            remediation_action_id: 0,
            soTab: 'soTab' + this._uid,
            raTab: 'raTab' + this._uid,
            deTab: 'deTab' + this._uid,
            reTab: 'reTab' + this._uid,
            objectHash: null,
            extendPaymentDueDateInitialized: false,
            recordFerCaseNumberInitialized: false,
            sendParkingInfringementInitialized: false,
            acceptRemediationActionInitialized: false,
            requestAmendmentRemediationAction: false,
            hashAttributeWhitelist: ['alleged_committed_offences', 'allocated_group_id', 'date_of_issue', 'description', 'district_id', 'identifier', 'issued_on_paper', 'offence', 'offender', 'paper_id', 'paper_notices', 'region_id', 'time_of_issue', 'type', 'driver_id', 'registration_holder_id'],
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.sanction_outcome, this.$route.params.sanction_outcome_id + "/comms_log"),
            comms_add_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.sanction_outcome, this.$route.params.sanction_outcome_id + "/add_comms_log"),
            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.sanction_outcome, this.$route.params.sanction_outcome_id + "/action_log"),
            assign_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.sanction_outcome, this.$route.params.sanction_outcome_id + '/update_assigned_to_id/'),
            assignmentKey: 0,
            dtHeadersRemediationActions: ["id", "Due Date", "Action Desc", "Status", "Action Taken", "Action"],
            dtOptionsRemediationActions: {
                columns: [{
                    data: 'id',
                    visible: false,
                    mRender: function mRender(data, type, row) {
                        return data;
                    }
                }, {
                    data: 'due_date',
                    mRender: function mRender(data, type, row) {
                        return moment(data).format("YYYY/MM/DD");
                    }
                }, {
                    data: 'action',
                    mRender: function mRender(data, type, row) {
                        return data;
                    }
                }, {
                    data: 'status.name'
                }, {
                    data: 'action_taken',
                    mRender: function mRender(data, type, ra) {
                        var html = '';

                        var body = '';
                        var td = '<td col="row" class="action-taken-cell">';
                        var td_close = '</td>';
                        var th = '<th scope="col">';
                        var th_close = '</th>';

                        body += '<tr>' + td + ra.action_taken + td_close + td + ra.documents + td_close + '</tr>';

                        var header = '<thead><tr>' + th + 'Action Taken' + th_close + th + 'Attachment' + th_close + '</tr></thead>';
                        html = '<table class="table">' + header + body + '</table>';

                        return html;
                    }
                }, {
                    data: 'user_action',
                    mRender: function mRender(data, type, row) {
                        return data;
                    }
                }]
            },
            dtHeadersAllegedOffence: ["id", "Act", "Section/Regulation", "Alleged Offence", "Action"],
            dtOptionsAllegedOffence: {
                columns: [{
                    data: "id",
                    visible: false
                }, {
                    data: "Act",
                    mRender: function mRender(data, type, row) {
                        var ret = data.alleged_offence.section_regulation.act;
                        if (!data.included) {
                            ret = '<strike>' + ret + '</strike>';
                        }
                        return ret;
                    }
                }, {
                    data: "Section/Regulation",
                    mRender: function mRender(data, type, row) {
                        var ret = data.alleged_offence.section_regulation.name;
                        if (!data.included) {
                            ret = '<strike>' + ret + '</strike>';
                        }
                        return ret;
                    }
                }, {
                    data: "Alleged Offence",
                    mRender: function mRender(data, type, row) {
                        var ret = data.alleged_offence.section_regulation.offence_text;
                        if (!data.included) {
                            ret = '<strike>' + ret + '</strike>';
                        }
                        return ret;
                    }
                }, {
                    data: "Action",
                    mRender: function mRender(data, type, row) {
                        var ret = '';
                        if (!vm.readonlyForm && data.in_editable_status) {
                            var checked_str = '';
                            var type_str = '';
                            var name_str = '';
                            var action_name = '';

                            if (vm.sanction_outcome.type.id == 'infringement_notice') {
                                type_str = 'radio';
                                name_str = ' name="aco_radio_group" ';
                                if (data.included) {
                                    checked_str = 'checked="checked"';
                                    action_name = '';
                                } else {
                                    checked_str = '';
                                    action_name = 'Restore';
                                }
                            } else {
                                type_str = 'checkbox';
                                name_str = '';
                                if (data.included) {
                                    checked_str = 'checked="checked"';
                                    action_name = 'Remove';
                                } else {
                                    checked_str = '';
                                    action_name = 'Restore';
                                }
                            }

                            ret = '<a><span class="include_alleged_committed_offence" data-alleged-committed-offence-id="' + data.id + '"/>' + action_name + '</span></a>';
                        }
                        return ret;
                    }
                }]
            }
        };
    },

    components: {
        FormSection: _section_toggle2.default,
        SanctionOutcomeWorkflow: _sanction_outcome_workflow2.default,
        CommsLogs: _comms_logs2.default,
        datatable: _datatable2.default,
        filefield: _compliance_file2.default,
        RelatedItems: _related_items2.default,
        ExtendPaymentDueDate: _extend_payment_due_date2.default,
        RecordFerCaseNumber: _record_fer_case_number2.default,
        SendParkingInfringement: _send_parking_infringement2.default,
        RegistrationHolder: _search_person_or_organisation2.default,
        AcceptRemediationAction: _accept_remediation_action2.default,
        RequestAmendmentRemediationAction: _request_amendment_remediation_action2.default,
        Driver: _search_person_or_organisation2.default,
        Assignment: _assignment2.default
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!this.$route.params.sanction_outcome_id) {
                                _context.next = 7;
                                break;
                            }

                            _context.next = 3;
                            return this.loadSanctionOutcome({ sanction_outcome_id: this.$route.params.sanction_outcome_id });

                        case 3:
                            this.createStorageAllegedCommittedOffences();
                            this.constructAllegedCommittedOffencesTable();
                            this.constructRemediationActionsTable();
                            this.updateObjectHash();

                        case 7:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.addEventListeners();
        });
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('sanctionOutcomeStore', {
        sanction_outcome: "sanction_outcome"
    }), {
        acceptRemediationActionBindId: function acceptRemediationActionBindId() {
            return 'acceptRemediationActionBindId' + this.bindId;
        },
        requestAmendmentRemediationActionBindId: function requestAmendmentRemediationActionBindId() {
            return 'requestAmendmentRemediationActionBindId' + this.bindId;
        },
        displayRemediationActions: function displayRemediationActions() {
            if (this.sanction_outcome && this.sanction_outcome.type) {
                return this.sanction_outcome.type.id == "remediation_notice" ? true : false;
            }
            return false;
        },
        registrationHolder: function registrationHolder() {
            var entity = {};
            if (this.sanction_outcome.registration_holder) {
                entity.id = this.sanction_outcome.registration_holder.id;
                entity.data_type = 'individual';
            }
            return entity;
        },
        driver: function driver() {
            var entity = {};
            if (this.sanction_outcome.driver) {
                entity.id = this.sanction_outcome.driver.id;
                entity.data_type = 'individual';
            }
            return entity;
        },
        registrationHolderBindId: function registrationHolderBindId() {
            this.registrationHolderId += 1;
            return 'resigtrationHolderBindId' + this.registrationHolderId;
        },
        updateDriverBindId: function updateDriverBindId() {
            this.driverId += 1;
            return 'driverBindId' + this.driverId;
        },
        last_due_date_1st: function last_due_date_1st() {
            var ret_value = null;
            if (this.sanction_outcome && this.sanction_outcome.due_dates && this.sanction_outcome.due_dates.length) {
                ret_value = this.sanction_outcome.due_dates[this.sanction_outcome.due_dates.length - 1].due_date_1st;
            }
            return ret_value;
        },
        last_due_date_2nd: function last_due_date_2nd() {
            var ret_value = null;
            if (this.sanction_outcome && this.sanction_outcome.due_dates && this.sanction_outcome.due_dates.length) {
                ret_value = this.sanction_outcome.due_dates[this.sanction_outcome.due_dates.length - 1].due_date_2nd;
            }
            return ret_value;
        },
        recordFerCaseNumberBindId: function recordFerCaseNumberBindId() {
            return 'record_fer_case_number_' + this.ferCaseNumberId;
        },
        sendParkingInfringementBindId: function sendParkingInfringementBindId() {
            return 'send_parking_infringement_' + this.sendParkingInfringementId;
        },
        extendDueDateBindId: function extendDueDateBindId() {
            return 'extend_due_date_' + this.extendDueDateId;
        },
        relatedItemsBindId: function relatedItemsBindId() {
            var timeNow = Date.now();
            if (this.sanction_outcome && this.sanction_outcome.id) {
                return 'sanction_outcome_' + this.sanction_outcome.id + '_' + this._uid;
            } else {
                return timeNow.toString();
            }
        },
        readonlyForm: function readonlyForm() {
            return !this.canUserEditForm;
        },
        canUserEditForm: function canUserEditForm() {
            var canUserEdit = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.status.id === this.STATUS_AWAITING_AMENDMENT || this.sanction_outcome.status.id === this.STATUS_DRAFT) {
                    canUserEdit = true;
                }
            }
            return canUserEdit;
        },
        canUserEditParkingDetails: function canUserEditParkingDetails() {
            var canUserEdit = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.type.id === 'infringement_notice') {
                    if (this.sanction_outcome.status.id === this.STATUS_WITH_DOT || this.sanction_outcome.status.id === this.STATUS_AWAITING_ISSUANCE || this.sanction_outcome.status.id === this.STATUS_AWAITING_PAYMENT) {
                        if (!this.sanction_outcome.offender) {
                            canUserEdit = true;
                        }
                    }
                }
            }
            return canUserEdit;
        },
        statusDisplay: function statusDisplay() {
            var ret = '';
            if (this.sanction_outcome) {
                if (this.sanction_outcome.status) {
                    ret = this.sanction_outcome.status.name;
                }
            }
            return ret;
        },
        typeDisplay: function typeDisplay() {
            var ret = '';
            if (this.sanction_outcome) {
                if (this.sanction_outcome.type) {
                    ret = this.sanction_outcome.type.name;
                }
            }
            return ret;
        },
        displayOffence: function displayOffence() {
            var ret = '';
            if (this.sanction_outcome) {
                if (this.sanction_outcome.offence) {
                    ret = this.sanction_outcome.offence.lodgement_number;
                }
            }
            return ret;
        },
        displayOffender: function displayOffender() {
            var ret = '';
            if (this.sanction_outcome) {
                if (this.sanction_outcome.offender) {
                    if (this.sanction_outcome.offender.person) {
                        ret = [this.sanction_outcome.offender.person.first_name, this.sanction_outcome.offender.person.last_name].filter(Boolean).join(" ");
                    } else if (this.sanction_outcome.offender.organisation) {
                        ret = [this.sanction_outcome.offender.organisation.name, this.sanction_outcome.offender.organisation.abn].filter(Boolean).join(" ");
                    }
                }
            }
            return ret;
        },
        displayLodgementNumber: function displayLodgementNumber() {
            var ret = '';
            if (this.sanction_outcome) {
                ret = this.sanction_outcome.lodgement_number;
            }
            return ret;
        },
        visibilitySendParkingInfringementButton: function visibilitySendParkingInfringementButton() {
            var visibility = false;

            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.type.id == 'infringement_notice' && this.sanction_outcome.is_parking_offence) {
                    if (this.sanction_outcome.status.id === this.STATUS_AWAITING_ISSUANCE || this.sanction_outcome.status.id === this.STATUS_AWAITING_PAYMENT) {
                        if (this.sanction_outcome.registration_holder_id || this.sanction_outcome.driver_id) {
                            visibility = true;
                        }
                    }
                }
            }

            return visibility;
        },
        visibilityReturnToInfringementNoticeCoordinatorButton: function visibilityReturnToInfringementNoticeCoordinatorButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.status.id === this.STATUS_ESCALATED_FOR_WITHDRAWAL) {
                    visibility = true;
                }
            }
            return visibility;
        },
        visibilityWithdrawByBranchManagerButton: function visibilityWithdrawByBranchManagerButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.status.id === this.STATUS_ESCALATED_FOR_WITHDRAWAL) {
                    visibility = true;
                }
            }
            return visibility;
        },
        visibilityRecordFerCaseNumberButton: function visibilityRecordFerCaseNumberButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.status.id === this.STATUS_OVERDUE) {
                    visibility = true;
                }
            }
            return visibility;
        },
        visibilitySaveButton: function visibilitySaveButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.status.id === this.STATUS_DRAFT || this.sanction_outcome.status.id === this.STATUS_AWAITING_AMENDMENT) {
                    visibility = true;
                }
                if (this.canUserEditParkingDetails) {
                    visibility = true;
                }
            }
            return visibility;
        },
        visibilityWithdrawButtonForManager: function visibilityWithdrawButtonForManager() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.type.id == 'infringement_notice') {
                    if (this.sanction_outcome.status.id === this.STATUS_AWAITING_ENDORSEMENT && this.sanction_outcome.issued_on_paper) {
                        visibility = true;
                    }
                }
            }
            return visibility;
        },
        visibilityExtendDueDateButton: function visibilityExtendDueDateButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.type.id == 'infringement_notice') {
                    if (this.sanction_outcome.status.id === this.STATUS_AWAITING_PAYMENT) {
                        visibility = true;
                    }
                }
            }
            return visibility;
        },

        visibilityParkingInfringementSection: function visibilityParkingInfringementSection() {
            var visibility = false;
            if (this.sanction_outcome.is_parking_offence) {
                visibility = true;
            }
            return visibility;
        },
        visibilityEscalateForWithdrawalButton: function visibilityEscalateForWithdrawalButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.type.id == 'infringement_notice') {
                    if (this.sanction_outcome.status.id === this.STATUS_AWAITING_PAYMENT) {
                        visibility = true;
                    }
                }
            }
            return visibility;
        },
        visibilitySendToManagerButton: function visibilitySendToManagerButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.status.id === this.STATUS_DRAFT || this.sanction_outcome.status.id === this.STATUS_AWAITING_AMENDMENT) {
                    visibility = true;
                }
            }
            return visibility;
        },
        visibilityMarkDocumentPostedButton: function visibilityMarkDocumentPostedButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.status.id === this.STATUS_AWAITING_PRINT_AND_POST) {
                    visibility = true;
                }
            }
            return visibility;
        },
        visibilityEndorseButton: function visibilityEndorseButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.status.id === this.STATUS_AWAITING_ENDORSEMENT || this.sanction_outcome.status.id === this.STATUS_AWAITING_REVIEW) {
                    visibility = true;
                }
            }
            return visibility;
        },
        visibilityDeclineButton: function visibilityDeclineButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.status.id === this.STATUS_AWAITING_ENDORSEMENT || this.sanction_outcome.status.id === this.STATUS_AWAITING_REVIEW) {
                    if (!this.sanction_outcome.issued_on_paper) {
                        visibility = true;
                    }
                }
            }
            return visibility;
        },
        visibilityReturnToOfficerButton: function visibilityReturnToOfficerButton() {
            var visibility = false;
            if (this.sanction_outcome.can_user_action) {
                if (this.sanction_outcome.status.id === this.STATUS_AWAITING_REVIEW) {
                    visibility = true;
                }
            }
            return visibility;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('sanctionOutcomeStore', {
        loadSanctionOutcome: 'loadSanctionOutcome',
        saveSanctionOutcome: 'saveSanctionOutcome',
        setSanctionOutcome: 'setSanctionOutcome',
        setAssignedToId: 'setAssignedToId',
        setCanUserAction: 'setCanUserAction',
        setRelatedItems: 'setRelatedItems',
        setRegistrationHolder: 'setRegistrationHolder',
        setDriver: 'setDriver',
        loadRemediationAction: 'loadRemediationAction'
    }), {
        clearRegistrationHolder: function clearRegistrationHolder() {
            console.log('clearRegistrationHolder');
            this.setRegistrationHolder({ data_type: 'individual', id: null });
        },
        clearDriver: function clearDriver() {
            console.log('clearDriver');
            this.setDriver({ data_type: 'individual', id: null });
        },
        onRemediationActionUpdated: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(remediation_action_id) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _;
                                console.log('onRemediationActionUpdated');
                                console.log(remediation_action_id);
                                _context2.next = 5;
                                return this.loadRemediationAction({ remediation_action_id: remediation_action_id });

                            case 5:
                                this.constructRemediationActionsTable();

                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function onRemediationActionUpdated(_x) {
                return _ref2.apply(this, arguments);
            }

            return onRemediationActionUpdated;
        }(),
        formatDate: function formatDate(d) {
            console.log('formatDate');
            if (d === 'overdue') {
                return 'Overdue';
            }
            return moment(d).format("DD/MM/YYYY");
        },
        sendParkingInfringement: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var _this2 = this;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                console.log('sendParkingInfringement()1');

                                if (!this.formChanged()) {
                                    _context3.next = 6;
                                    break;
                                }

                                console.log('sendParkingInfringement()2');
                                _context3.next = 5;
                                return this.saveSanctionOutcome();

                            case 5:
                                this.updateObjectHash();

                            case 6:
                                console.log('sendParkingInfringement()3');
                                this.sendParkingInfringementId += 1;
                                this.sendParkingInfringementInitialized = true;
                                this.$nextTick(function () {
                                    _this2.$refs.send_parking_infringement.isModalOpen = true;
                                });

                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function sendParkingInfringement() {
                return _ref3.apply(this, arguments);
            }

            return sendParkingInfringement;
        }(),
        markDocumentPosted: function markDocumentPosted() {
            console.log('in markDocumentPosted');
        },
        driverSelected: function driverSelected(data) {
            console.log(data);
            this.setDriver(data);
        },
        registrationHolderSelected: function registrationHolderSelected(data) {
            console.log(data);
            this.setRegistrationHolder(data);
        },
        updateObjectHash: function updateObjectHash() {
            this.objectHash = this.calculateHash();
        },
        calculateHash: function calculateHash() {
            var _this3 = this;

            var copiedObject = {};
            (0, _getOwnPropertyNames2.default)(this.sanction_outcome).forEach(function (val, idx, array) {
                if (_this3.hashAttributeWhitelist.includes(val)) {
                    copiedObject[val] = _this3.sanction_outcome[val];
                }
            });
            return (0, _objectHash2.default)(copiedObject);
        },
        formChanged: function formChanged() {
            var changed = false;

            if (this.objectHash !== this.calculateHash()) {
                changed = true;
            }

            return changed;
        },
        sanctionOutcomeDocumentUploaded: function sanctionOutcomeDocumentUploaded() {
            console.log('sanctionOutcomeDocumentUploaded');
        },
        createStorageAllegedCommittedOffences: function createStorageAllegedCommittedOffences() {
            if (this.sanction_outcome && this.sanction_outcome.alleged_committed_offences) {
                for (var i = 0; i < this.sanction_outcome.alleged_committed_offences.length; i++) {
                    this.sanction_outcome.alleged_committed_offences[i].already_included = this.sanction_outcome.alleged_committed_offences[i].included;
                }
            }
        },
        save: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var returned_so;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;

                                console.log('save()');
                                _context4.next = 4;
                                return this.saveSanctionOutcome();

                            case 4:
                                returned_so = _context4.sent;
                                _context4.next = 7;
                                return swal("Saved", "The record has been saved", "success");

                            case 7:

                                this.constructAllegedCommittedOffencesTable();
                                this.updateObjectHash();
                                _context4.next = 14;
                                break;

                            case 11:
                                _context4.prev = 11;
                                _context4.t0 = _context4["catch"](0);

                                this.processError(_context4.t0);

                            case 14:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[0, 11]]);
            }));

            function save() {
                return _ref4.apply(this, arguments);
            }

            return save;
        }(),
        saveExit: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.prev = 0;
                                _context5.next = 3;
                                return this.saveSanctionOutcome();

                            case 3:
                                _context5.next = 5;
                                return swal("Saved", "The record has been saved", "success");

                            case 5:
                                window.removeEventListener('beforeunload', this.leaving);
                                window.removeEventListener('onblur', this.leaving);

                                this.$router.push({ name: 'internal-offence-dash' });
                                _context5.next = 13;
                                break;

                            case 10:
                                _context5.prev = 10;
                                _context5.t0 = _context5["catch"](0);

                                this.processError(_context5.t0);

                            case 13:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[0, 10]]);
            }));

            function saveExit() {
                return _ref5.apply(this, arguments);
            }

            return saveExit;
        }(),
        processError: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(err) {
                var errorText, i, _i, field_name, j;

                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                errorText = '';

                                if (err.body.non_field_errors) {
                                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                                        errorText += err.body.non_field_errors[i] + '<br />';
                                    }
                                } else if (Array.isArray(err.body)) {
                                    for (_i = 0; _i < err.body.length; _i++) {
                                        errorText += err.body[_i] + '<br />';
                                    }
                                } else {
                                    for (field_name in err.body) {
                                        if (err.body.hasOwnProperty(field_name)) {
                                            errorText += field_name + ':<br />';
                                            for (j = 0; j < err.body[field_name].length; j++) {
                                                errorText += err.body[field_name][j] + '<br />';
                                            }
                                        }
                                    }
                                }
                                _context6.next = 4;
                                return swal("Error", errorText, "error");

                            case 4:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function processError(_x2) {
                return _ref6.apply(this, arguments);
            }

            return processError;
        }(),
        destroyed: function destroyed() {
            window.removeEventListener('beforeunload', this.leaving);
            window.removeEventListener('onblur', this.leaving);
        },
        setUpDateTimePicker: function setUpDateTimePicker() {
            var vm = this;
            var el_issue_date = $(vm.$refs.dateOfIssuePicker);
            var el_issue_time = $(vm.$refs.timeOfIssuePicker);

            el_issue_date.datetimepicker({ format: "DD/MM/YYYY", maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_issue_date.on("dp.change", function (e) {
                if (el_issue_date.data("DateTimePicker").date()) {
                    vm.sanction_outcome.date_of_issue = e.date.format("DD/MM/YYYY");
                } else if (el_issue_date.data("date") === "") {
                    vm.sanction_outcome.date_of_issue = null;
                }
            });

            el_issue_time.datetimepicker({ format: "LT", showClear: true });
            el_issue_time.on("dp.change", function (e) {
                if (el_issue_time.data("DateTimePicker").date()) {
                    vm.sanction_outcome.time_of_issue = e.date.format("LT");
                } else if (el_issue_time.data("date") === "") {
                    vm.sanction_outcome.time_of_issue = null;
                }
            });
        },
        addEventListeners: function addEventListeners() {
            this.setUpDateTimePicker();
            $("#alleged-committed-offence-table").on("click", ".remove_alleged_committed_offence", this.removeAllegedOffenceClicked);
            $("#alleged-committed-offence-table").on("click", ".restore_alleged_committed_offence", this.restoreAllegedOffenceClicked);
            $("#alleged-committed-offence-table").on("click", ".include_alleged_committed_offence", this.includeAllegedOffenceClicked);
            $("#tbl_remediation_actions").on("click", ".accept_remediation_action", this.acceptRemediationActionClicked);
            $("#tbl_remediation_actions").on("click", ".request_amendment_remediation_action", this.requestAmendmentRemediationActionClicked);

            window.addEventListener('beforeunload', this.leaving);
            window.addEventListener('onblur', this.leaving);
        },
        acceptRemediationActionClicked: function acceptRemediationActionClicked(e) {
            var _this4 = this;

            var remediationActionId = parseInt(e.target.getAttribute("data-id"));
            this.remediation_action_id = remediationActionId;
            this.bindId += 1;
            this.acceptRemediationActionInitialized = true;
            this.$nextTick(function () {
                _this4.$refs.accept_remediation_action.isModalOpen = true;
            });
        },
        requestAmendmentRemediationActionClicked: function requestAmendmentRemediationActionClicked(e) {
            var _this5 = this;

            var remediationActionId = parseInt(e.target.getAttribute("data-id"));
            this.remediation_action_id = remediationActionId;
            this.bindId += 1;
            this.requestAmendmentRemediationAction = true;
            this.$nextTick(function () {
                _this5.$refs.request_amendment_remediation_action.isModalOpen = true;
            });
        },
        leaving: function leaving(e) {
            console.log('leaving');
            var vm = this;
            var dialogText = 'You have some unsaved changes.';
            if (vm.formChanged()) {
                e.returnValue = dialogText;
                return dialogText;
            }
        },
        removeAllegedOffenceClicked: function removeAllegedOffenceClicked(e) {
            var acoId = parseInt(e.target.getAttribute("data-alleged-committed-offence-id"));
            for (var i = 0; i < this.sanction_outcome.alleged_committed_offences.length; i++) {
                if (acoId == this.sanction_outcome.alleged_committed_offences[i].id) {
                    this.sanction_outcome.alleged_committed_offences[i].included = false;
                }
            }
            this.constructAllegedCommittedOffencesTable();
        },
        includeAllegedOffenceClicked: function includeAllegedOffenceClicked(e) {
            var acoId = parseInt(e.target.getAttribute("data-alleged-committed-offence-id"));
            if (this.sanction_outcome.type.id == 'infringement_notice') {
                for (var i = 0; i < this.sanction_outcome.alleged_committed_offences.length; i++) {
                    this.sanction_outcome.alleged_committed_offences[i].included = false;
                }

                for (var _i2 = 0; _i2 < this.sanction_outcome.alleged_committed_offences.length; _i2++) {
                    if (acoId == this.sanction_outcome.alleged_committed_offences[_i2].id) {
                        this.sanction_outcome.alleged_committed_offences[_i2].included = true;
                    }
                }
            } else {
                for (var _i3 = 0; _i3 < this.sanction_outcome.alleged_committed_offences.length; _i3++) {
                    if (acoId == this.sanction_outcome.alleged_committed_offences[_i3].id) {
                        this.sanction_outcome.alleged_committed_offences[_i3].included = !this.sanction_outcome.alleged_committed_offences[_i3].included;
                    }
                }
            }
            this.constructAllegedCommittedOffencesTable();
        },
        restoreAllegedOffenceClicked: function restoreAllegedOffenceClicked(e) {
            var acoId = parseInt(e.target.getAttribute("data-alleged-committed-offence-id"));
            for (var i = 0; i < this.sanction_outcome.alleged_committed_offences.length; i++) {
                if (acoId == this.sanction_outcome.alleged_committed_offences[i].id) {
                    this.sanction_outcome.alleged_committed_offences[i].included = true;
                }
            }
            this.constructAllegedCommittedOffencesTable();
        },
        constructRemediationActionsTable: function constructRemediationActionsTable() {
            this.$refs.tbl_remediation_actions.vmDataTable.clear().draw();
            if (this.sanction_outcome.remediation_actions) {
                for (var i = 0; i < this.sanction_outcome.remediation_actions.length; i++) {
                    var ra = this.sanction_outcome.remediation_actions[i];
                    this.addRemediationActionToTable(ra);
                }
            }
        },
        constructAllegedCommittedOffencesTable: function constructAllegedCommittedOffencesTable() {
            this.$refs.alleged_committed_offence_table.vmDataTable.clear().draw();
            if (this.sanction_outcome.alleged_committed_offences) {
                for (var i = 0; i < this.sanction_outcome.alleged_committed_offences.length; i++) {
                    this.addAllegedOffenceToTable(this.sanction_outcome.alleged_committed_offences[i]);
                }
            }
        },
        addRemediationActionToTable: function addRemediationActionToTable(remediation_action) {
            this.$refs.tbl_remediation_actions.vmDataTable.row.add(remediation_action).draw();
        },
        addAllegedOffenceToTable: function addAllegedOffenceToTable(allegedCommittedOffence) {
            this.$refs.alleged_committed_offence_table.vmDataTable.row.add({
                id: allegedCommittedOffence,
                Act: allegedCommittedOffence,
                "Section/Regulation": allegedCommittedOffence,
                "Alleged Offence": allegedCommittedOffence,
                Action: allegedCommittedOffence
            }).draw();
        },
        addWorkflow: function addWorkflow(workflow_type) {
            var _this6 = this;

            this.workflow_type = workflow_type;
            this.updateWorkflowBindId();
            this.$nextTick(function () {
                _this6.$refs.add_workflow.isModalOpen = true;
            });
        },
        recordFerCaseNumber: function recordFerCaseNumber() {
            var _this7 = this;

            this.ferCaseNumberId += 1;
            this.recordFerCaseNumberInitialized = true;
            this.$nextTick(function () {
                _this7.$refs.record_fer_case_number.isModalOpen = true;
            });
        },
        extendDueDate: function extendDueDate() {
            var _this8 = this;

            this.extendDueDateId += 1;
            this.extendPaymentDueDateInitialized = true;
            this.$nextTick(function () {
                _this8.$refs.extend_payment_due_date.isModalOpen = true;
            });
        },

        updateWorkflowBindId: function updateWorkflowBindId() {
            var timeNow = Date.now();
            if (this.workflow_type) {
                this.workflowBindId = this.workflow_type + '_' + timeNow.toString();
            } else {
                this.workflowBindId = timeNow.toString();
            }
        },
        updateAssignedToId: function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(body) {
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                this.setSanctionOutcome(body);

                                this.updateObjectHash();
                                this.assignmentKey += 1;

                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function updateAssignedToId(_x3) {
                return _ref7.apply(this, arguments);
            }

            return updateAssignedToId;
        }()
    })
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(31), __webpack_require__(10), __webpack_require__(2)))

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _section_toggle = __webpack_require__(21);

var _section_toggle2 = _interopRequireDefault(_section_toggle);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'SanctionOutcomeTableDash',
    data: function data() {
        var vm = this;
        return {
            sanction_outcome_types: [],
            sanction_outcome_statuses: [],
            sanction_outcome_payment_statuses: [],
            sanction_outcome_regions: [],
            sanction_outcome_availableDistricts: [],

            filterType: 'all',
            filterStatus: 'all',
            filterPaymentStatus: 'all',
            filterDateFromPicker: '',
            filterDateToPicker: '',
            filterRegionId: 'all',
            filterDistrictId: 'all',

            dtOptions: {
                serverSide: true,
                searchDelay: 1000,
                lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
                order: [[0, 'desc']],
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                processing: true,
                ajax: {
                    url: '/api/sanction_outcome_paginated/get_paginated_datatable/?format=datatables',
                    dataSrc: 'data',
                    data: function data(d) {
                        d.type = vm.filterType;
                        d.status = vm.filterStatus;
                        d.payment_status = vm.filterPaymentStatus;
                        d.date_from = vm.filterDateFromPicker;
                        d.date_to = vm.filterDateToPicker;
                        d.region_id = vm.filterRegionId;
                        d.district_id = vm.filterDistrictId;
                    }
                },
                columns: [{
                    data: 'lodgement_number',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'remediation_actions',
                    visible: false
                }, {
                    data: 'type',
                    searchable: false,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        return data.name;
                    }
                }, {
                    data: 'identifier',
                    searchable: true,
                    orderable: true
                }, {
                    data: 'date_of_issue',
                    searchable: true,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format('DD/MM/YYYY') : '';
                    }
                }, {
                    data: 'coming_due_date',
                    searchable: false,
                    orderable: false,
                    mRender: function mRender(data, type, full) {
                        return data != '' && data != null ? moment(data).format('DD/MM/YYYY') : '';
                    }
                }, {
                    data: 'offender',
                    searchable: true,
                    orderable: true,
                    mRender: function mRender(data, type, row) {
                        var name = '';
                        var num_chars = 30;
                        if (data && data.person) {
                            name = data.person.first_name + ' ' + data.person.last_name;
                        } else if (data && data.organisation) {
                            name = data.organisation.name;
                        } else if (data) {
                            name = data.first_name + ' ' + data.last_name;
                        }

                        var shortText = name.length > num_chars ? '<span title="' + name + '">' + _jquery2.default.trim(name).substring(0, num_chars).split(" ").slice(0, -1).join(" ") + '...</span>' : name;
                        return shortText;
                    }
                }, {
                    data: 'status.name',
                    searchable: true,
                    orderable: true,
                    mRender: function mRender(data, type, full) {
                        console.log(full);
                        if (full.type.id == 'remediation_notice') {
                            console.log(full);
                            var num_total = 0;
                            var num_open = 0;
                            var num_overdue = 0;
                            var num_submitted = 0;
                            var num_accepted = 0;
                            for (var i = 0; i < full.remediation_actions.length; i++) {
                                if (full.remediation_actions[i].status.id == 'open') {
                                    num_open++;
                                }
                                if (full.remediation_actions[i].status.id == 'overdue') {
                                    num_overdue++;
                                }
                                if (full.remediation_actions[i].status.id == 'submitted') {
                                    num_submitted++;
                                }
                                if (full.remediation_actions[i].status.id == 'accepted') {
                                    num_accepted++;
                                }
                                num_total++;
                            }
                            data = data + ('<br />(Open: ' + num_open + ', Submitted: ' + num_submitted + ', Accepted: ' + num_accepted + ', Overdue: ' + num_overdue + ')');
                            return data;
                        }
                        return data;
                    }
                }, {
                    data: 'payment_status.name',
                    searchable: true,
                    orderable: false
                }, {
                    data: 'paper_notices',
                    searchable: true,
                    orderable: false,
                    mRender: function mRender(data, type, row) {
                        var ret_str = '';
                        return data;
                    }
                }, {
                    data: 'user_action',
                    searchable: false,
                    orderable: false,
                    mRender: function mRender(data, type, row) {
                        if (data) {
                            return data;
                        } else {
                            return '---';
                        }
                    }
                }]
            },
            dtHeaders: ['Number', 'RemediationActions', 'Type', 'Identifier', 'Issue Date', 'Due Date', 'Offender', 'Status', 'Payment Status', 'Sanction Outcome', 'Action']
        };
    },
    mounted: function mounted() {
        var vm = this;
        vm.$nextTick(function () {
            vm.addEventListeners();
        });
    },

    watch: {

        filterType: function filterType() {
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        },
        filterStatus: function filterStatus() {
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        },
        filterPaymentStatus: function filterPaymentStatus() {
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        },
        filterDateFromPicker: function filterDateFromPicker() {
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        },
        filterDateToPicker: function filterDateToPicker() {
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        },
        filterRegionId: function filterRegionId() {
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        },
        filterDistrictId: function filterDistrictId() {
            this.$refs.sanction_outcome_table.vmDataTable.draw();
        }
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.constructOptionsType();
                            this.constructOptionsStatus();
                            this.constructOptionsPaymentStatus();
                            this.constructOptionsRegion();

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    methods: {
        updateDistricts: function updateDistricts(updateFromUI) {
            this.sanction_outcome_availableDistricts = [];var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.sanction_outcome_regions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var region = _step.value;

                    if (region.id == this.filterRegionId) {
                        this.sanction_outcome_availableDistricts = region.districts;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.sanction_outcome_availableDistricts.splice(0, 0, {
                district_id: "all",
                district_name: "All",
                district: "",
                districts: [],
                region: null
            });

            this.filterDistrictId = 'all';
        },
        addEventListeners: function addEventListeners() {
            var vm = this;
            this.attachFromDatePicker();
            this.attachToDatePicker();

            vm.$refs.sanction_outcome_table.vmDataTable.on('click', 'a[data-pay-infringement-penalty]', function (e) {
                e.preventDefault();
                var id = (0, _jquery2.default)(e.target).attr('data-pay-infringement-penalty');
                vm.payInfringementPenalty(id);
            });
        },
        payInfringementPenalty: function payInfringementPenalty(sanction_outcome_id) {
            this.$http.post('/infringement_penalty/' + sanction_outcome_id + '/').then(function (res) {
                window.location.href = "/ledger/checkout/checkout/payment-details/";
            }, function (err) {
                swal('Submit Error', _hooks.helpers.apiVueResourceError(err), 'error');
            });
        },
        attachFromDatePicker: function attachFromDatePicker() {
            var vm = this;
            var el_fr = (0, _jquery2.default)(vm.$refs.issueDateFromPicker);
            var el_to = (0, _jquery2.default)(vm.$refs.issueDateToPicker);

            el_fr.datetimepicker({ format: 'DD/MM/YYYY', maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_fr.on('dp.change', function (e) {
                if (el_fr.data('DateTimePicker').date()) {
                    vm.filterDateFromPicker = e.date.format('DD/MM/YYYY');
                    el_to.data('DateTimePicker').minDate(e.date);
                } else if (el_fr.data('date') === "") {
                    vm.filterDateFromPicker = "";
                }
            });
        },
        attachToDatePicker: function attachToDatePicker() {
            var vm = this;
            var el_fr = (0, _jquery2.default)(vm.$refs.issueDateFromPicker);
            var el_to = (0, _jquery2.default)(vm.$refs.issueDateToPicker);
            el_to.datetimepicker({ format: 'DD/MM/YYYY', maxDate: moment().millisecond(0).second(0).minute(0).hour(0), showClear: true });
            el_to.on('dp.change', function (e) {
                if (el_to.data('DateTimePicker').date()) {
                    vm.filterDateToPicker = e.date.format('DD/MM/YYYY');
                    el_fr.data('DateTimePicker').maxDate(e.date);
                } else if (el_to.data('date') === "") {
                    vm.filterDateToPicker = "";
                }
            });
        },
        constructOptionsType: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var returned;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _hooks.cache_helper.getSetCacheList('SanctionOutcomeTypes', '/api/sanction_outcome/types.json');

                            case 2:
                                returned = _context2.sent;

                                (0, _assign2.default)(this.sanction_outcome_types, returned);
                                this.sanction_outcome_types.splice(0, 0, { id: 'all', display: 'All' });

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function constructOptionsType() {
                return _ref2.apply(this, arguments);
            }

            return constructOptionsType;
        }(),
        constructOptionsStatus: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var returned;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _hooks.cache_helper.getSetCacheList('SanctionOutcomeStatuses', '/api/sanction_outcome/statuses.json');

                            case 2:
                                returned = _context3.sent;

                                (0, _assign2.default)(this.sanction_outcome_statuses, returned);
                                this.sanction_outcome_statuses.splice(0, 0, { id: 'all', display: 'All' });

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function constructOptionsStatus() {
                return _ref3.apply(this, arguments);
            }

            return constructOptionsStatus;
        }(),
        constructOptionsPaymentStatus: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var returned;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _hooks.cache_helper.getSetCacheList('SanctionOutcomePaymentStatuses', '/api/sanction_outcome/payment_statuses.json');

                            case 2:
                                returned = _context4.sent;

                                (0, _assign2.default)(this.sanction_outcome_payment_statuses, returned);
                                this.sanction_outcome_payment_statuses.splice(0, 0, { id: 'all', display: 'All' });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function constructOptionsPaymentStatus() {
                return _ref4.apply(this, arguments);
            }

            return constructOptionsPaymentStatus;
        }(),
        constructOptionsRegion: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                var returned_regions;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _hooks.cache_helper.getSetCacheList("Regions", "/api/regions/");

                            case 2:
                                returned_regions = _context5.sent;

                                (0, _assign2.default)(this.sanction_outcome_regions, returned_regions);
                                this.sanction_outcome_regions.splice(0, 0, {
                                    id: "all",
                                    name: "All"
                                });

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function constructOptionsRegion() {
                return _ref5.apply(this, arguments);
            }

            return constructOptionsRegion;
        }()
    },
    components: {
        datatable: _datatable2.default,
        FormSection: _section_toggle2.default
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(10)))

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(33);

var _utils2 = _interopRequireDefault(_utils);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(80);

__webpack_require__(15);

__webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "SanctionOutcome",
    data: function data() {
        var vm = this;

        return {
            temporary_document_collection_id: null,
            nTab: "nTab" + vm._uid,
            aTab: "aTab" + vm._uid,
            dTab: "dTab" + vm._uid,
            isModalOpen: false,
            processingDetails: false,

            regions: [],
            availableDistricts: [],
            documentActionUrl: null,
            elem_paper_id_notice: null,
            errorResponse: "",
            offenceReadonly: false,

            aco_ids_included: [],
            aco_ids_excluded: [],
            is_parking_offence: false,

            sanction_outcome: {
                type: "",
                region_id: null,
                district_id: null,
                identifier: "",
                current_offence: {},
                current_offender: {},
                issued_on_paper: false,
                paper_id: "",
                description: "",
                date_of_issue: null,
                time_of_issue: null,
                remediation_actions: []
            },
            current_remediation_action: {
                action: "",
                due_date: null
            },

            act_name_of_selected_ao: '',
            options_for_types: [],
            options_for_offences: [],

            dtHeadersAllegedOffence: ["id", "Act", "Section/Regulation", "Alleged Offence", "Include"],
            dtOptionsAllegedOffence: {
                columns: [{
                    visible: false,
                    data: 'id',
                    name: 'id',
                    render: function render(data, type, full) {
                        return full.id;
                    }
                }, {
                    data: 'id',
                    name: 'id',
                    render: function render(data, type, full) {
                        var ret = full.section_regulation.act;
                        if (full.removed) {
                            ret = '<strike>' + ret + '</strike>';
                        }
                        return ret;
                    }
                }, {
                    data: 'id',
                    name: 'id',
                    render: function render(data, type, full) {
                        var ret = full.section_regulation.name;
                        if (full.removed) {
                            ret = '<strike>' + ret + '</strike>';
                        }
                        return ret;
                    }
                }, {
                    data: 'id',
                    name: 'id',
                    render: function render(data, type, full) {
                        var ret = full.section_regulation.offence_text;
                        if (full.removed) {
                            ret = '<strike>' + ret + '</strike>';
                        }
                        return ret;
                    }
                }, {
                    data: 'id',
                    name: 'id',
                    render: function render(data, type, full) {
                        console.log('full: ');
                        console.log(full);
                        var ret_line = '';

                        var current_offender_has_connection = false;

                        var unselectable = true;
                        if (vm.sanction_outcome.type == 'infringement_notice') {
                            unselectable = false;
                        } else if (!vm.act_name_of_selected_ao || vm.act_name_of_selected_ao == full.section_regulation.act) {
                            unselectable = false;
                        }
                        var selected_str = '';
                        if (vm.aco_ids_included.includes(full.id.toString())) {
                            selected_str = 'checked="checked"';
                        }

                        if (full.connected || full.removed || unselectable) {
                            if (vm.sanction_outcome.type == 'infringement_notice') {
                                ret_line += '<input type="radio" name="infringement_radio_button" class="alleged_offence_include" value="' + full.id + '" disabled></input>';
                            } else if (vm.sanction_outcome.type == '' || vm.sanction_outcome.type == null) {
                                ret_line += '';
                            } else {
                                ret_line += '<input type="checkbox" class="alleged_offence_include" value="' + full.id + '" disabled></input>';
                            }
                        } else {
                            if (vm.sanction_outcome.type == 'infringement_notice') {
                                ret_line += '<input type="radio" name="infringement_radio_button" class="alleged_offence_include" value="' + full.id + '"' + selected_str + '></input>';
                            } else if (vm.sanction_outcome.type == '' || vm.sanction_outcome.type == null) {
                                ret_line += '';
                            } else {
                                var disabled_str = '';
                                if (full.section_regulation.is_parking_offence) {
                                    disabled_str = ' disabled ';
                                    selected_str = '';
                                }

                                ret_line += '<input type="checkbox" class="alleged_offence_include" value="' + full.id + '"' + selected_str + disabled_str + '></input>';
                            }
                        }

                        return ret_line;
                    }
                }]
            },
            dtHeadersRemediationActions: ["id", "Due Date", "Action", "Action"],
            dtOptionsRemediationActions: {
                columns: [{
                    data: "id",
                    name: 'id',
                    visible: false
                }, {
                    data: "due_date",
                    name: 'id'
                }, {
                    data: "action_text",
                    name: 'id'
                }, {
                    data: "id",
                    name: 'id',
                    render: function render(data, type, row) {
                        return '<a href="#" class="remove_button" data-remediation-action-id="' + row.id + '">Remove</a>';
                    }
                }]
            }
        };
    },
    props: {
        workflow_type: {
            type: String,
            default: 'send_to_manager'
        }
    },
    components: {
        modal: _bootstrapModal2.default,
        datatable: _datatable2.default,
        filefield: _compliance_file2.default
    },
    watch: {
        issued_on_paper: {
            handler: function handler() {
                var vm = this;
                if (!vm.sanction_outcome.issued_on_paper) {
                    vm.sanction_outcome.date_of_issue = null;
                    vm.sanction_outcome.time_of_issue = null;
                    vm.elem_paper_id_notice.slideUp(500);
                } else {
                    vm.elem_paper_id_notice.slideDown(500);
                }
            }
        },

        current_region_id: {
            handler: function handler() {
                this.currentRegionIdChanged();
            }
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)("offenceStore", {
        offence: "offence"
    }), {
        enableAddActionButton: function enableAddActionButton() {
            var enabled = false;
            if (this.current_remediation_action.action && this.current_remediation_action.due_date) {
                enabled = true;
            }
            return enabled;
        },
        issued_on_paper: function issued_on_paper() {
            return this.sanction_outcome.issued_on_paper;
        },

        current_region_id: function current_region_id() {
            return this.sanction_outcome.region_id;
        },

        modalTitle: function modalTitle() {
            return "Identify Sanction Outcome";
        },
        firstTabTitle: function firstTabTitle() {
            for (var i = 0; i < this.options_for_types.length; i++) {
                if (this.options_for_types[i]["id"] == this.sanction_outcome.type) {
                    return this.options_for_types[i]["display"];
                }
            }
            return "";
        },
        displayTabs: function displayTabs() {
            return this.sanction_outcome.type == "" ? false : true;
        },
        displaySendToManagerButton: function displaySendToManagerButton() {
            var retValue = false;

            if (!this.processingDetails && this.sanction_outcome.type) {
                if (this.regionDistrictId) {
                    if (this.sanction_outcome.issued_on_paper && this.sanction_outcome.date_of_issue || !this.sanction_outcome.issued_on_paper) {
                        retValue = true;
                    }
                }
            }
            return retValue;
        },
        displayRemediationActions: function displayRemediationActions() {
            return this.sanction_outcome.type == "remediation_notice" ? true : false;
        },
        regionDistrictId: function regionDistrictId() {
            if (this.sanction_outcome.district_id || this.sanction_outcome.region_id) {
                return this.sanction_outcome.district_id ? this.sanction_outcome.district_id : this.sanction_outcome.region_id;
            } else {
                return null;
            }
        },
        groupPermission: function groupPermission() {
            return "manager";
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('offenceStore', {
        loadOffence: 'loadOffence'
    }), {
        aco_include_clicked: function aco_include_clicked() {
            console.log('in aco_include_clicked');
            var vm = this;
            vm.aco_ids_included = [];
            vm.aco_ids_excluded = [];
            var checkboxes = (0, _jquery2.default)(".alleged_offence_include");
            console.log(checkboxes);
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked) {
                    vm.aco_ids_included.push(checkboxes[i].value);
                } else {
                    vm.aco_ids_excluded.push(checkboxes[i].value);
                }
            }
            if (vm.aco_ids_included.length) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(vm.sanction_outcome.current_offence.alleged_offences), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var alleged_offence = _step.value;

                        if (alleged_offence.id == vm.aco_ids_included[0]) {
                            vm.act_name_of_selected_ao = alleged_offence.section_regulation.act;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else {
                vm.act_name_of_selected_ao = '';
            }
            console.log('act_name_of_selected_ao: ' + vm.act_name_of_selected_ao);
            vm.check_if_is_parking_offence();
            vm.constructAllegedOffencesTable();
        },
        check_if_is_parking_offence: function check_if_is_parking_offence() {
            this.is_parking_offence = false;
            if (this.sanction_outcome.type == 'infringement_notice' && this.aco_ids_included.length == 1) {
                for (var i = 0; i < this.sanction_outcome.current_offence.alleged_offences.length; i++) {

                    console.log(this.sanction_outcome.current_offence.alleged_offences[i]);

                    if (this.sanction_outcome.current_offence.alleged_offences[i].id == this.aco_ids_included[0]) {
                        if (this.sanction_outcome.current_offence.alleged_offences[i].section_regulation.is_parking_offence) {
                            this.is_parking_offence = true;
                        }
                    }
                }
            }
        },
        setTemporaryDocumentCollectionId: function setTemporaryDocumentCollectionId(val) {
            this.temporary_document_collection_id = val;
        },
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.processingDetails = true;
                                _context.next = 4;
                                return this.sendData();

                            case 4:
                                response = _context.sent;

                                if (!response.ok) {
                                    _context.next = 9;
                                    break;
                                }

                                if (!(this.$parent.offence && this.offence.id)) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 9;
                                return this.loadOffence({
                                    offence_id: this.offence.id
                                });

                            case 9:

                                this.close();
                                this.processingDetails = false;
                                this.$emit('sanction_outcome_created');
                                _context.next = 18;
                                break;

                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context["catch"](0);

                                this.processError(_context.t0);
                                this.processingDetails = false;

                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 14]]);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        processError: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(err) {
                var errorText, i, _i, field_name, j;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                errorText = '';

                                if (err.body.non_field_errors) {
                                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                                        errorText += err.body.non_field_errors[i] + '<br />';
                                    }
                                } else if (Array.isArray(err.body)) {
                                    for (_i = 0; _i < err.body.length; _i++) {
                                        errorText += err.body[_i] + '<br />';
                                    }
                                } else {
                                    for (field_name in err.body) {
                                        if (err.body.hasOwnProperty(field_name)) {
                                            errorText += field_name + ': ';
                                            for (j = 0; j < err.body[field_name].length; j++) {
                                                errorText += err.body[field_name][j] + '<br />';
                                            }
                                        }
                                    }
                                }
                                this.errorResponse = errorText;

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function processError(_x) {
                return _ref2.apply(this, arguments);
            }

            return processError;
        }()
    }, (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup' }), {
        cancel: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!this.$refs.sanction_outcome_file) {
                                    _context3.next = 3;
                                    break;
                                }

                                _context3.next = 3;
                                return this.$refs.sanction_outcome_file.cancel();

                            case 3:
                                this.close();

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function cancel() {
                return _ref3.apply(this, arguments);
            }

            return cancel;
        }(),
        typeChanged: function typeChanged() {
            console.log('typeChanged');
            this.constructAllegedOffencesTable();
            this.check_if_is_parking_offence();
        },
        makeModalsDraggable: function makeModalsDraggable() {
            this.elem_modal = (0, _jquery2.default)('.modal > .modal-dialog');
            for (var i = 0; i < this.elem_modal.length; i++) {
                (0, _jquery2.default)(this.elem_modal[i]).draggable();
            }
        },
        close: function close() {
            this.$parent.sanctionOutcomeInitialised = false;
            this.isModalOpen = false;
        },
        loadDefaultData: function loadDefaultData() {
            if (this.$parent.call_email) {
                this.sanction_outcome.region_id = this.$parent.call_email.region_id;
                this.sanction_outcome.district_id = this.$parent.call_email.district_id;
            }

            if (this.$parent.inspection) {
                this.sanction_outcome.region_id = this.$parent.inspection.region_id;
                this.sanction_outcome.district_id = this.$parent.inspection.district_id;
            }

            if (this.$parent.offence) {
                this.sanction_outcome.region_id = this.$parent.offence.region_id;
                this.sanction_outcome.district_id = this.$parent.offence.district_id;
                for (var i = 0; i < this.options_for_offences.length; i++) {
                    if (this.options_for_offences[i].id == this.$parent.offence.id) {
                        this.sanction_outcome.current_offence = this.options_for_offences[i];
                        this.offenceReadonly = true;
                    }
                }
            }

            this.clearTableRemediationActions();
        },
        currentRegionIdChanged: function currentRegionIdChanged() {
            this.updateDistricts();
        },
        addRemediationActionClicked: function addRemediationActionClicked() {
            var vm = this;
            if (vm.current_remediation_action) {
                vm.$refs.tbl_remediation_actions.vmDataTable.row.add({
                    id: _hooks.helpers.guid(),
                    due_date: moment(vm.current_remediation_action.due_date, "DD/MM/YYYY").format("DD/MM/YYYY"),
                    action_text: vm.current_remediation_action.action
                }).draw();
                vm.current_remediation_action.action = "";
                vm.current_remediation_action.due_date = null;
            }
        },
        updateDistricts: function updateDistricts(updateFromUI) {
            if (updateFromUI) {
                this.sanction_outcome.district_id = null;
            }

            this.availableDistricts = [];var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.regions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var region = _step2.value;

                    if (region.id == this.offence.region_id) {
                        this.availableDistricts = region.districts;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.availableDistricts.splice(0, 0, {
                district_id: "",
                district_name: "",
                district: "",
                districts: [],
                region: null
            });
        },
        addEventListeners: function addEventListeners() {
            var vm = this;
            var el_issue_date = (0, _jquery2.default)(vm.$refs.dateOfIssuePicker);
            var el_issue_time = (0, _jquery2.default)(vm.$refs.timeOfIssuePicker);
            var el_due_date = (0, _jquery2.default)(vm.$refs.dueDatePicker);

            el_issue_date.datetimepicker({
                format: "DD/MM/YYYY",
                maxDate: "now",
                showClear: true
            });
            el_issue_date.on("dp.change", function (e) {
                if (el_issue_date.data("DateTimePicker").date()) {
                    vm.sanction_outcome.date_of_issue = e.date.format("DD/MM/YYYY");
                } else if (el_issue_date.data("date") === "") {
                    vm.sanction_outcome.date_of_issue = null;
                }
            });

            el_issue_time.datetimepicker({ format: "LT", showClear: true });
            el_issue_time.on("dp.change", function (e) {
                if (el_issue_time.data("DateTimePicker").date()) {
                    vm.sanction_outcome.time_of_issue = e.date.format("LT");
                } else if (el_issue_time.data("date") === "") {
                    vm.sanction_outcome.time_of_issue = null;
                }
            });

            el_due_date.datetimepicker({
                minDate: moment().millisecond(0).second(0).minute(0).hour(0),
                format: "DD/MM/YYYY",
                showClear: true
            });
            el_due_date.on("dp.change", function (e) {
                if (el_due_date.data("DateTimePicker").date()) {
                    vm.current_remediation_action.due_date = e.date.format("DD/MM/YYYY");
                } else if (el_due_date.data("date") === "") {
                    vm.current_remediation_action.due_date = null;
                }
            });

            (0, _jquery2.default)("#tbl_remediation_actions").on("click", ".remove_button", vm.removeClicked);
            (0, _jquery2.default)("#tbl_alleged_offence").on("click", ".alleged_offence_include", vm.aco_include_clicked);
        },
        removeClicked: function removeClicked(e) {
            var vm = this;
            var remediationActionId = e.target.getAttribute("data-remediation-action-id");
            vm.$refs.tbl_remediation_actions.vmDataTable.rows(function (idx, data, node) {
                if (data.id == remediationActionId) {
                    vm.$refs.tbl_remediation_actions.vmDataTable.row(idx).remove().draw();
                }
            });
        },
        offenceSelected: function offenceSelected(e) {
            var vm = this;
            var offence_id = parseInt(e.target.value);
            for (var i = 0; i < vm.options_for_offences.length; i++) {
                if (vm.options_for_offences[i].id == offence_id) {
                    vm.sanction_outcome.current_offence = vm.options_for_offences[i];
                    return;
                }
            }

            vm.sanction_outcome.current_offence = {};
        },
        offenderSelected: function offenderSelected(e) {
            var vm = this;
            var offender_id = parseInt(e.target.value);
            for (var i = 0; i < vm.sanction_outcome.current_offence.offenders.length; i++) {
                if (vm.sanction_outcome.current_offence.offenders[i].id == offender_id) {
                    vm.sanction_outcome.current_offender = vm.sanction_outcome.current_offence.offenders[i];
                    return;
                }
            }

            vm.sanction_outcome.current_offender = {};
        },
        constructRegionsAndDistricts: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var returned_regions;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _hooks.cache_helper.getSetCacheList("Regions", "/api/regions/");

                            case 2:
                                returned_regions = _context4.sent;

                                (0, _assign2.default)(this.regions, returned_regions);

                                this.regions.splice(0, 0, {
                                    id: "",
                                    name: "",
                                    district: "",
                                    districts: [],
                                    region: null
                                });

                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function constructRegionsAndDistricts() {
                return _ref4.apply(this, arguments);
            }

            return constructRegionsAndDistricts;
        }(),
        sendData: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                var vm, alleged_offence_ids_included, alleged_offence_ids_excluded, checkboxes, i, postUrl, payload, remediation_actions_rows, remediation_actions_data, remediation_actions, _i2, savedObj;

                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                vm = this;
                                alleged_offence_ids_included = [];
                                alleged_offence_ids_excluded = [];
                                checkboxes = (0, _jquery2.default)(".alleged_offence_include");

                                for (i = 0; i < checkboxes.length; i++) {
                                    if (checkboxes[i].checked) {
                                        alleged_offence_ids_included.push(checkboxes[i].value);
                                    } else {
                                        alleged_offence_ids_excluded.push(checkboxes[i].value);
                                    }
                                }

                                postUrl = _hooks.api_endpoints.sanction_outcome;
                                payload = new Object();

                                (0, _assign2.default)(payload, vm.sanction_outcome);
                                if (payload.date_of_issue) {
                                    payload.date_of_issue = moment(payload.date_of_issue, "DD/MM/YYYY").format("YYYY-MM-DD");
                                    payload.time_of_issue = moment(payload.time_of_issue, 'LT').format('HH:mm');
                                }
                                payload.alleged_offence_ids_included = alleged_offence_ids_included;
                                payload.alleged_offence_ids_excluded = alleged_offence_ids_excluded;

                                if (this.temporary_document_collection_id) {
                                    payload.temporary_document_collection_id = this.temporary_document_collection_id.temp_doc_id;
                                } else {
                                    payload.temporary_document_collection_id = null;
                                }

                                remediation_actions_rows = vm.$refs.tbl_remediation_actions.vmDataTable.rows();
                                remediation_actions_data = remediation_actions_rows.data();
                                remediation_actions = remediation_actions_data.toArray();

                                payload.remediation_actions = remediation_actions;
                                for (_i2 = 0; _i2 < payload.remediation_actions.length; _i2++) {
                                    payload.remediation_actions[_i2].due_date = moment(payload.remediation_actions[_i2].due_date, "DD/MM/YYYY").format("YYYY-MM-DD");
                                }

                                payload.call_email_id = this.$parent.call_email ? this.$parent.call_email.id : null;
                                payload.inspection_id = this.$parent.inspection ? this.$parent.inspection.id : null;
                                payload.workflow_type = 'send_to_manager';_context5.next = 22;
                                return _vue2.default.http.post(postUrl, payload);

                            case 22:
                                savedObj = _context5.sent;
                                return _context5.abrupt("return", savedObj);

                            case 24:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function sendData() {
                return _ref5.apply(this, arguments);
            }

            return sendData;
        }(),
        currentOffenderChanged: function currentOffenderChanged() {
            console.log('*** currentOffenderChanged ***');
            this.constructAllegedOffencesTable();
        },
        clearTableAllegedOffence: function clearTableAllegedOffence() {
            this.$refs.tbl_alleged_offence.vmDataTable.rows().remove().draw();
        },
        clearTableRemediationActions: function clearTableRemediationActions() {
            this.$refs.tbl_remediation_actions.vmDataTable.rows().remove().draw();
        },
        currentOffenceChanged: function currentOffenceChanged() {
            this.sanction_outcome.current_offender = {};

            this.constructAllegedOffencesTable();
        },
        constructAllegedOffencesTable: function constructAllegedOffencesTable() {
            console.log('*** constructAllegedOffencesTable ***');
            var current_offender_id = 0;
            if (this.sanction_outcome.current_offender.person) {
                current_offender_id = this.sanction_outcome.current_offender.person.id;
            }

            this.clearTableAllegedOffence();

            if (this.sanction_outcome.current_offence && this.sanction_outcome.current_offence.alleged_offences) {
                for (var j = 0; j < this.sanction_outcome.current_offence.alleged_offences.length; j++) {
                    var alleged_offence = this.sanction_outcome.current_offence.alleged_offences[j];

                    var connected = false;
                    for (var i = 0; i < alleged_offence.connected_offenders.length; i++) {
                        if (alleged_offence.connected_offenders[i].id == current_offender_id) {
                            connected = true;
                        }
                    }
                    alleged_offence.connected = connected;

                    this.$refs.tbl_alleged_offence.vmDataTable.row.add(alleged_offence).draw();
                }
            }
        },
        updateOptionsForOffences: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
                var returned;
                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                returned = null;

                                if (!(this.$parent.call_email && this.$parent.call_email.id)) {
                                    _context6.next = 8;
                                    break;
                                }

                                _context6.next = 4;
                                return _vue2.default.http.get("/api/offence/filter_by_call_email.json", {
                                    params: { call_email_id: this.$parent.call_email.id }
                                });

                            case 4:
                                returned = _context6.sent;

                                this.options_for_offences = returned.body;
                                _context6.next = 24;
                                break;

                            case 8:
                                if (!(this.$parent.inspection && this.$parent.inspection.id)) {
                                    _context6.next = 15;
                                    break;
                                }

                                _context6.next = 11;
                                return _vue2.default.http.get("/api/offence/filter_by_inspection.json", {
                                    params: { inspection_id: this.$parent.inspection.id }
                                });

                            case 11:
                                returned = _context6.sent;

                                this.options_for_offences = returned.body;
                                _context6.next = 24;
                                break;

                            case 15:
                                if (!(this.$parent.offence && this.$parent.offence.id)) {
                                    _context6.next = 19;
                                    break;
                                }

                                this.options_for_offences = [this.$parent.offence];
                                _context6.next = 24;
                                break;

                            case 19:
                                if (!(this.$parent.legal_case && this.$parent.legal_case.id)) {
                                    _context6.next = 24;
                                    break;
                                }

                                _context6.next = 22;
                                return _vue2.default.http.get("/api/offence/filter_by_legal_case.json", {
                                    params: { legal_case_id: this.$parent.legal_case.id }
                                });

                            case 22:
                                returned = _context6.sent;

                                this.options_for_offences = returned.body;

                            case 24:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function updateOptionsForOffences() {
                return _ref6.apply(this, arguments);
            }

            return updateOptionsForOffences;
        }(),
        createDocumentActionUrl: function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
                var returned_sanction_outcome;
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return _vue2.default.http.post(_hooks.api_endpoints.sanction_outcome);

                            case 2:
                                returned_sanction_outcome = _context7.sent;

                                this.sanction_outcome.id = returned_sanction_outcome.body.id;

                                return _context7.abrupt("return", _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.sanction_outcome, this.sanction_outcome.id + "/process_default_document/"));

                            case 5:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createDocumentActionUrl() {
                return _ref7.apply(this, arguments);
            }

            return createDocumentActionUrl;
        }()
    }),
    created: function () {
        var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
            var options_for_types, i;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return _hooks.cache_helper.getSetCacheList("SanctionOutcome_Types", "/api/sanction_outcome/types.json");

                        case 2:
                            options_for_types = _context8.sent;

                            this.options_for_types.push({ id: "", display: "" });
                            for (i = 0; i < options_for_types.length; i++) {
                                this.options_for_types.push(options_for_types[i]);
                            }
                            _context8.next = 7;
                            return this.updateOptionsForOffences();

                        case 7:
                            _context8.next = 9;
                            return this.constructRegionsAndDistricts();

                        case 9:
                            this.loadDefaultData();

                        case 10:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function created() {
            return _ref8.apply(this, arguments);
        }

        return created;
    }(),
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.addEventListeners();
            _this.elem_paper_id_notice = (0, _jquery2.default)('#paper_id_notice');
            _this.makeModalsDraggable();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

__webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);

exports.default = {
    name: "SanctionOutcomeWorkflow",
    data: function data() {
        return {
            processingDetails: false,
            isModalOpen: false,
            files: [{
                'file': null,
                'name': ''
            }],
            workflowDetails: '',
            errorResponse: '',

            allocatedGroup: [],
            allocated_group_id: null
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        filefield: _compliance_file2.default
    },
    props: {
        workflow_type: {
            type: String,
            default: ''
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('sanctionOutcomeStore', {
        sanction_outcome: "sanction_outcome"
    }), {
        modalTitle: function modalTitle() {
            switch (this.workflow_type) {
                case 'withdraw_by_manager':
                    return "Withdraw";
                    break;
                case 'escalate_for_withdrawal':
                    return "Escalate for Withdrawal";
                    break;
                case 'send_to_manager':
                    return "Send to Manager";
                    break;
                case 'endorse':
                    return "Endorse";
                    break;
                case 'decline':
                    return "Decline";
                    break;
                case 'return_to_officer':
                    return "Return to Officer";
                    break;
                case 'return_to_infringement_notice_coordinator':
                    return "Return to Infringement Notice Coordinator";
                    break;
                case 'withdraw_by_branch_manager':
                    return "Withdraw";
                    break;
                case 'mark_document_posted':
                    return "Mark Document Posted";
                    break;
                default:
                    return "---";
            }
        },
        regionDistrictId: function regionDistrictId() {
            if (this.sanction_outcome.district || this.sanction_outcome.region) {
                return this.sanction_outcome.district ? this.sanction_outcome.district : this.sanction_outcome.region;
            } else {
                return null;
            }
        }
    }),
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.makeModalsDraggable();
        });
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup' }), {
        makeModalsDraggable: function makeModalsDraggable() {
            this.elem_modal = $('.modal > .modal-dialog');
            for (var i = 0; i < this.elem_modal.length; i++) {
                $(this.elem_modal[i]).draggable();
            }
        },
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.processingDetails = true;
                                _context.next = 4;
                                return this.sendData();

                            case 4:
                                response = _context.sent;

                                this.close();
                                this.$router.push({ name: 'internal-sanction-outcome-dash' });
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](0);

                                this.processError(_context.t0);

                            case 12:
                                _context.prev = 12;

                                this.processingDetails = false;
                                return _context.finish(12);

                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 9, 12, 15]]);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        processError: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(err) {
                var errorText, i, _i, field_name, j;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                errorText = '';

                                if (err.body.non_field_errors) {
                                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                                        errorText += err.body.non_field_errors[i] + '<br />';
                                    }
                                } else if (Array.isArray(err.body)) {
                                    for (_i = 0; _i < err.body.length; _i++) {
                                        errorText += err.body[_i] + '<br />';
                                    }
                                } else {
                                    for (field_name in err.body) {
                                        if (err.body.hasOwnProperty(field_name)) {
                                            errorText += field_name + ': ';
                                            for (j = 0; j < err.body[field_name].length; j++) {
                                                errorText += err.body[field_name][j] + '<br />';
                                            }
                                        }
                                    }
                                }
                                this.errorResponse = errorText;

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function processError(_x) {
                return _ref2.apply(this, arguments);
            }

            return processError;
        }(),
        cancel: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$refs.comms_log_file.cancel();

                            case 2:
                                this.isModalOpen = false;
                                this.close();

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function cancel() {
                return _ref3.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
            var file_length = vm.files.length;
            this.files = [];
            for (var i = 0; i < file_length; i++) {
                vm.$nextTick(function () {
                    $('.file-row-' + i).remove();
                });
            }
            this.attachAnother();
        },
        sendData: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var post_url, payload, res;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                post_url = '/api/sanction_outcome/' + this.sanction_outcome.id + '/workflow_action/';
                                payload = new FormData();

                                payload.append('details', this.workflowDetails);
                                this.$refs.comms_log_file.commsLogId ? payload.append('comms_log_id', this.$refs.comms_log_file.commsLogId) : null;
                                this.workflow_type ? payload.append('workflow_type', this.workflow_type) : null;

                                _context4.next = 7;
                                return _vue2.default.http.post(post_url, payload);

                            case 7:
                                res = _context4.sent;
                                return _context4.abrupt("return", res);

                            case 9:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function sendData() {
                return _ref4.apply(this, arguments);
            }

            return sendData;
        }(),
        uploadFile: function uploadFile(target, file_obj) {
            var vm = this;
            var _file = null;
            var file_input = $('.' + target)[0];

            if (file_input.files && file_input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(file_input.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = file_input.files[0];
            }
            file_obj.file = _file;
            file_obj.name = _file.name;
        },
        removeFile: function removeFile(index) {
            var _this2 = this;

            var length = this.files.length;
            $('.file-row-' + index).remove();
            this.files.splice(index, 1);
            this.$nextTick(function () {
                length == 1 ? _this2.attachAnother() : '';
            });
        },
        attachAnother: function attachAnother() {
            this.files.push({
                'file': null,
                'name': ''
            });
        }
    })
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapModal = __webpack_require__(13);

var _bootstrapModal2 = _interopRequireDefault(_bootstrapModal);

var _compliance_file = __webpack_require__(16);

var _compliance_file2 = _interopRequireDefault(_compliance_file);

var _vuex = __webpack_require__(6);

var _hooks = __webpack_require__(3);

__webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);
__webpack_require__(19);
exports.default = {
    name: "SendParkingInfringement",
    data: function data() {
        return {
            processingDetails: false,
            isModalOpen: false,
            errorResponse: '',

            allocatedGroup: [],
            allocated_group_id: null,
            details: ''
        };
    },
    components: {
        modal: _bootstrapModal2.default,
        filefield: _compliance_file2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('sanctionOutcomeStore', {
        sanction_outcome: "sanction_outcome"
    }), {
        modalTitle: function modalTitle() {
            return 'Send Parking Infringement';
        },
        fieldsFilled: function fieldsFilled() {
            var filled = true;

            return filled;
        },
        recipient_details: function recipient_details() {
            var details = '';
            if (this.sanction_outcome) {
                if (this.sanction_outcome.driver) {
                    details = 'Driver: ' + this.sanction_outcome.driver.email;
                } else if (this.sanction_outcome.registration_holder) {
                    details = 'Registration holder: ' + this.sanction_outcome.registration_holder.email;
                } else if (this.sanction_outcome.offender) {
                    details = this.sanction_outcome.offender.person.email;
                }
            }
            return details;
        }
    }),
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.addEventListeners();
            _this.makeModalsDraggable();
        });
    },
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        loadAllocatedGroup: 'loadAllocatedGroup' }), {
        addEventListeners: function addEventListeners() {},
        makeModalsDraggable: function makeModalsDraggable() {
            this.elem_modal = $('.modal > .modal-dialog');
            for (var i = 0; i < this.elem_modal.length; i++) {
                $(this.elem_modal[i]).draggable();
            }
        },
        ok: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.processingDetails = true;
                                _context.next = 4;
                                return this.sendData();

                            case 4:
                                response = _context.sent;

                                this.close();

                                this.$router.push({ name: 'internal-sanction-outcome-dash' });
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](0);

                                this.processError(_context.t0);

                            case 12:
                                _context.prev = 12;

                                this.processingDetails = false;
                                return _context.finish(12);

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 9, 12, 15]]);
            }));

            function ok() {
                return _ref.apply(this, arguments);
            }

            return ok;
        }(),
        processError: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(err) {
                var errorText, i, _i, field_name, j;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                errorText = '';

                                if (err.body.non_field_errors) {
                                    for (i = 0; i < err.body.non_field_errors.length; i++) {
                                        errorText += err.body.non_field_errors[i] + '<br />';
                                    }
                                } else if (Array.isArray(err.body)) {
                                    for (_i = 0; _i < err.body.length; _i++) {
                                        errorText += err.body[_i] + '<br />';
                                    }
                                } else {
                                    for (field_name in err.body) {
                                        if (err.body.hasOwnProperty(field_name)) {
                                            errorText += field_name + ': ';
                                            for (j = 0; j < err.body[field_name].length; j++) {
                                                errorText += err.body[field_name][j] + '<br />';
                                            }
                                        }
                                    }
                                }
                                this.errorResponse = errorText;

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function processError(_x) {
                return _ref2.apply(this, arguments);
            }

            return processError;
        }(),
        cancel: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.$refs.comms_log_file.cancel();

                            case 2:
                                this.isModalOpen = false;
                                this.close();

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function cancel() {
                return _ref3.apply(this, arguments);
            }

            return cancel;
        }(),
        close: function close() {
            var vm = this;
            this.isModalOpen = false;
        },
        sendData: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var post_url, payload, res;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                post_url = '/api/sanction_outcome/' + this.sanction_outcome.id + '/send_parking_infringement/';
                                payload = new FormData();

                                payload.append('details', this.details);
                                this.$refs.comms_log_file.commsLogId ? payload.append('comms_log_id', this.$refs.comms_log_file.commsLogId) : null;
                                _context4.next = 6;
                                return _vue2.default.http.post(post_url, payload);

                            case 6:
                                res = _context4.sent;
                                return _context4.abrupt('return', res);

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function sendData() {
                return _ref4.apply(this, arguments);
            }

            return sendData;
        }()
    })
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _alert = __webpack_require__(28);

var _alert2 = _interopRequireDefault(_alert);

var _users_dashboard = __webpack_require__(325);

var _users_dashboard2 = _interopRequireDefault(_users_dashboard);

var _organisations_dashboard = __webpack_require__(887);

var _organisations_dashboard2 = _interopRequireDefault(_organisations_dashboard);

__webpack_require__(1070);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(33);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'SearchDashboard',
    data: function data() {
        var vm = this;
        return {
            personOrgEntity: {},
            preferredSystem: null,
            showSpinner: false,
            users_url: _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.users_paginated, 'datatable_list/?format=datatables'),
            rBody: 'rBody' + vm._uid,
            oBody: 'oBody' + vm._uid,
            cBody: 'cBody' + vm._uid,
            kBody: 'kBody' + vm._uid,
            loading: [],
            search_option: "starts_with",
            searchKeywords: [],
            hasSearchKeywords: false,
            selected_organisation: '',
            organisations: null,
            searchApplication: true,
            searchLicence: false,
            searchReturn: false,
            referenceWord: '',
            keyWord: null,
            searching: false,
            results: [],
            errors: false,
            errorString: '',
            datatable_id: 'keyword-search-datatable-' + vm._uid,
            keyword_search_headers: ["Number", "Type", "Applicant", "Text Found", "Action"],
            keyword_search_options: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                data: vm.results,
                columns: [{ data: "number" }, { data: "record_type" }, { data: "applicant" }, {
                    data: "text",
                    className: "normal-white-space",
                    mRender: function mRender(data, type, full) {
                        if (data.value) {
                            return data.value;
                        } else {
                            return data;
                        }
                    }
                }, { data: "record_id",
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        if (full.type == 'Application') {
                            links += '<a href=\'/internal/application/' + full.id + '\'>View</a><br/>';
                        }
                        if (full.type == 'Licence') {
                            links += '<a href="' + full.licence_document + '" target="_blank">View</a>';
                        }
                        if (full.type == 'Return') {
                            links += '<a href=\'/internal/return/' + full.id + '\'>View</a><br/>';
                        }
                        return links;
                    }
                }],
                processing: true
            }
        };
    },

    watch: {
        searchKeywords: function searchKeywords() {
            if (this.searchKeywords.length > 0) {
                this.hasSearchKeywords = true;
            } else {
                this.hasSearchKeywords = false;
            };
        }
    },
    components: {
        alert: _alert2.default,
        datatable: _datatable2.default,
        UserDashTable: _users_dashboard2.default,
        OrganisationDashTable: _organisations_dashboard2.default
    },

    computed: {
        isLoading: function isLoading() {
            return this.loading.length == 0;
        },
        showError: function showError() {
            return this.errors;
        },
        showSearchKeywords: function showSearchKeywords() {
            var show = true;
            if (this.preferredSystem === 'compliance_management') {
                show = false;
            }
            return show;
        }
    },
    methods: {
        personOrganisationSearch: function personOrganisationSearch() {
            var _this = this;

            this.$nextTick(function () {
                if (_this.personOrgEntity && _this.personOrgEntity.entity_type === 'user') {
                    window.location.replace("/internal/users/" + _this.personOrgEntity.id);
                } else if (_this.personOrgEntity && _this.personOrgEntity.entity_type === 'org') {
                    window.location.replace("/internal/organisations/" + _this.personOrgEntity.id);
                }
            });
        },
        initialisePersonLookup: function initialisePersonLookup() {
            var vm = this;
            (0, _jquery2.default)(vm.$refs.person_lookup).select2({
                minimumInputLength: 2,
                "theme": "bootstrap",
                allowClear: true,
                placeholder: "Select Person",
                ajax: {
                    url: _hooks.api_endpoints.person_org_lookup,

                    dataType: 'json',
                    data: function data(params) {
                        console.log(params);
                        var query = {
                            term: params.term,
                            option: vm.search_option,
                            type: 'public'
                        };
                        return query;
                    }
                }
            }).on("select2:select", function (e) {
                var selected = (0, _jquery2.default)(e.currentTarget);
                vm.personOrgEntity = (0, _assign2.default)({}, e.params.data);
            }).on("select2:unselect", function (e) {
                var selected = (0, _jquery2.default)(e.currentTarget);
                vm.personOrgEntity = {};
            }).on("select2:open", function (e) {
                var searchField = (0, _jquery2.default)('[aria-controls="select2-person_lookup-results"]');

                searchField[0].focus();
            });
        },

        addListeners: function addListeners() {
            var vm = this;

            (0, _jquery2.default)(vm.$refs.searchOrg).select2({
                "theme": "bootstrap",
                allowClear: true,
                placeholder: "Select Organisation"
            }).on("select2:select", function (e) {
                var selected = (0, _jquery2.default)(e.currentTarget);
                vm.selected_organisation = selected.val();
            }).on("select2:unselect", function (e) {
                var selected = (0, _jquery2.default)(e.currentTarget);
                vm.selected_organisation = selected.val();
            });
        },
        search_reference: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var vm, res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = this;

                                if (!vm.referenceWord) {
                                    _context.next = 18;
                                    break;
                                }

                                vm.showSpinner = true;
                                vm.errors = false;
                                vm.errorString = '';
                                _context.prev = 5;
                                _context.next = 8;
                                return vm.$http.post('/api/search_reference.json', { "reference_number": vm.referenceWord });

                            case 8:
                                res = _context.sent;

                                console.log(res);
                                if (res.body.url_string) {
                                    window.location.href = res.body.url_string;
                                } else if (res.body.error) {
                                    console.log(res.body.error);
                                    vm.errors = true;
                                    vm.errorString = res.body.error;
                                }
                                _context.next = 17;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](5);

                                vm.errors = true;
                                vm.errorString = _hooks.helpers.apiVueResourceError(_context.t0);

                            case 17:
                                vm.showSpinner = false;

                            case 18:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[5, 13]]);
            }));

            function search_reference() {
                return _ref.apply(this, arguments);
            }

            return search_reference;
        }(),
        addKeyword: function addKeyword() {
            var vm = this;
            if (vm.keyWord != null) {
                vm.searchKeywords.push(vm.keyWord);
            }
        },
        removeKeyword: function removeKeyword(index) {
            var vm = this;
            if (index > -1) {
                vm.searchKeywords.splice(index, 1);
            }
        },
        clearKeywordSearch: function clearKeywordSearch() {
            var vm = this;
            if (vm.keyWord != null) {
                vm.searchKeywords = [];
            }
            vm.keyWord = null;
            vm.results = [];
            vm.$refs.keyword_search_datatable.vmDataTable.clear();
            vm.$refs.keyword_search_datatable.vmDataTable.draw();
        },
        searchKeyword: function searchKeyword() {
            var vm = this;
            if (this.searchKeywords.length > 0) {
                vm.searching = true;
                vm.$http.post('/api/search_keywords.json', {
                    searchKeywords: vm.searchKeywords,
                    searchApplication: vm.searchApplication,
                    searchLicence: vm.searchLicence,
                    searchReturn: vm.searchReturn,
                    is_internal: true
                }).then(function (res) {
                    vm.results = res.body;
                    vm.$refs.keyword_search_datatable.vmDataTable.clear();
                    vm.$refs.keyword_search_datatable.vmDataTable.rows.add(vm.results);
                    vm.$refs.keyword_search_datatable.vmDataTable.draw();
                    vm.searching = false;
                }, function (err) {
                    console.log(err);
                    vm.searching = false;
                });
            }
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.keyword_search_options.data = vm.results;
        vm.$refs.keyword_search_datatable.vmDataTable.draw();
        (0, _jquery2.default)('a[data-toggle="collapse"]').on('click', function () {
            var chev = (0, _jquery2.default)(this).children()[0];
            window.setTimeout(function () {
                (0, _jquery2.default)(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
            }, 100);
        });
        this.initialisePersonLookup();
    },
    created: function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _hooks.helpers.getPreferredDashboard();

                        case 2:
                            this.preferredSystem = _context2.sent;

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function created() {
            return _ref2.apply(this, arguments);
        }

        return created;
    }(),
    updated: function updated() {
        var vm = this;
        this.$nextTick(function () {
            vm.addListeners();
        });
    }
};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _users_dashboard = __webpack_require__(325);

var _users_dashboard2 = _interopRequireDefault(_users_dashboard);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'InternalUserDashboard',
    data: function data() {
        var vm = this;
        return {
            users_url: _hooks.api_endpoints.users
        };
    },

    watch: {},
    components: {
        UserDashTable: _users_dashboard2.default
    },
    computed: {},
    methods: {},
    mounted: function mounted() {}
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _hooks = __webpack_require__(3);

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _applications_dashboard = __webpack_require__(82);

var _applications_dashboard2 = _interopRequireDefault(_applications_dashboard);

var _licences_dashboard = __webpack_require__(94);

var _licences_dashboard2 = _interopRequireDefault(_licences_dashboard);

var _returns_dashboard = __webpack_require__(95);

var _returns_dashboard2 = _interopRequireDefault(_returns_dashboard);

var _sanction_outcomes_person_org_dashboard = __webpack_require__(324);

var _sanction_outcomes_person_org_dashboard2 = _interopRequireDefault(_sanction_outcomes_person_org_dashboard);

var _legal_case_person_org_dashboard = __webpack_require__(805);

var _legal_case_person_org_dashboard2 = _interopRequireDefault(_legal_case_person_org_dashboard);

var _comms_logs = __webpack_require__(24);

var _comms_logs2 = _interopRequireDefault(_comms_logs);

var _intelligence_information = __webpack_require__(320);

var _intelligence_information2 = _interopRequireDefault(_intelligence_information);

var _securebase_link = __webpack_require__(130);

var _securebase_link2 = _interopRequireDefault(_securebase_link);

var _utils = __webpack_require__(33);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'User',
    data: function data() {
        var vm = this;
        return {
            adBody: 'adBody' + vm._uid,
            pdBody: 'pdBody' + vm._uid,
            cdBody: 'cdBody' + vm._uid,
            odBody: 'odBody' + vm._uid,
            idBody: 'idBody' + vm._uid,
            dTab: 'dTab' + vm._uid,
            oTab: 'oTab' + vm._uid,
            user: {
                residential_address: {},
                wildlifecompliance_organisations: []
            },
            loading: [],
            countries: [],
            updatingPersonal: false,
            updatingAddress: false,
            updatingContact: false,
            uploadingID: false,
            uploadedID: null,
            empty_list: '/api/empty_list',
            logsTable: null,
            DATE_TIME_FORMAT: 'DD/MM/YYYY HH:mm:ss',
            activate_tables: false,
            comms_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.$route.params.user_id + '/comms_log'),
            logs_url: _hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.$route.params.user_id + '/action_log'),
            applications_url: _hooks.api_endpoints.applications_paginated + 'internal_datatable_list?format=datatables&user_id=' + vm.$route.params.user_id,
            licences_url: _hooks.api_endpoints.licences_paginated + 'internal_datatable_list?format=datatables&user_id=' + vm.$route.params.user_id,
            returns_url: _hooks.api_endpoints.returns_paginated + 'user_datatable_list?format=datatables&user_id=' + vm.$route.params.user_id,
            orgRequest_pending: [],
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            }
        };
    },

    components: {
        datatable: _datatable2.default,
        ApplicationDashTable: _applications_dashboard2.default,
        LicenceDashTable: _licences_dashboard2.default,
        ReturnDashTable: _returns_dashboard2.default,
        SanctionOutcomePersonOrgDashTable: _sanction_outcomes_person_org_dashboard2.default,
        LegalCasePersonOrgDashTable: _legal_case_person_org_dashboard2.default,
        CommsLogs: _comms_logs2.default,
        SecureBaseLink: _securebase_link2.default,
        IntelligenceInformation: _intelligence_information2.default
    },
    computed: {
        isLoading: function isLoading() {
            return this.loading.length == 0;
        },
        uploadedIDFileName: function uploadedIDFileName() {
            return this.uploadedID != null ? this.uploadedID.name : '';
        }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var initialisers = [_utils2.default.fetchCountries(), _utils2.default.fetchUser(to.params.user_id), _utils2.default.fetchOrgRequestPending(to.params.user_id)];
        _promise2.default.all(initialisers).then(function (data) {
            next(function (vm) {
                vm.countries = data[0];
                vm.user = data[1];
                vm.user.residential_address = vm.user.residential_address != null ? vm.user.residential_address : {};
                vm.orgRequest_pending = data[2];

                vm.uploadedID = vm.user.identification2;
            });
        });
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        var initialisers = [_utils2.default.fetchUser(to.params.user_id)];
        _promise2.default.all(initialisers).then(function (data) {
            next(function (vm) {
                vm.user = data[0];
                vm.user.residential_address = vm.user.residential_address != null ? vm.user.residential_address : {};
            });
        });
    },
    methods: (0, _defineProperty3.default)({
        set_tabs: function set_tabs() {
            var vm = this;

            $('#pills-tab a[href="#pills-details"]').tab('show');
        },

        eventListeners: function eventListeners() {
            var vm = this;

            $('a[href="#' + vm.oTab + '"]').on('shown.bs.tab', function (e) {
                vm.$refs.applications_table.$refs.application_datatable.vmDataTable.columns.adjust().responsive.recalc();
                vm.$refs.licences_table.$refs.licence_datatable.vmDataTable.columns.adjust().responsive.recalc();
                vm.$refs.returns_table.$refs.return_datatable.vmDataTable.columns.adjust().responsive.recalc();
            });
        },
        updatePersonal: function updatePersonal() {
            var vm = this;
            vm.updatingPersonal = true;
            if (vm.user.residential_address == null) {
                vm.user.residential_address = {};
            }
            var params = '?';
            params += '&first_name=' + vm.user.first_name;
            params += '&last_name=' + vm.user.last_name;
            params += '&dob=' + vm.user.dob;
            if (vm.user.first_name == '' || vm.user.last_name == '' || vm.user.dob == null || vm.user.dob == '') {
                var _error_msg = 'Please ensure all fields are filled in.';
                swal({
                    title: 'Update Personal Details',
                    html: 'There was an error updating the user personal details.<br/>' + _error_msg,
                    type: 'error'
                }).then(function () {
                    vm.updatingPersonal = false;
                });
                return;
            }
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.user.id + '/update_personal'), (0, _stringify2.default)(vm.user), {
                emulateJSON: true
            }).then(function (response) {
                swal({
                    title: 'Update Personal Details',
                    html: 'User personal details has been successfully updated.',
                    type: 'success'
                }).then(function () {
                    vm.updatingPersonal = false;
                });
            }, function (error) {
                vm.updatingPersonal = false;
                details_msg = '<br/>';
                for (var key in error.body) {
                    if (key === 'dob') {
                        error_msg += 'dob: Please enter a valid date.<br/>';
                    } else {
                        error_msg += key + ': ' + error.body[key] + '<br/>';
                    }
                }
                swal({
                    title: 'Update Personal Details',
                    html: 'There was an error updating the user personal details.<br/>' + error_msg,
                    type: 'error'
                });
            });
        },
        updateContact: function updateContact() {
            var vm = this;
            vm.updatingContact = true;
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.user.id + '/update_contact'), (0, _stringify2.default)(vm.user), {
                emulateJSON: true
            }).then(function (response) {
                vm.updatingContact = false;
                vm.user = response.body;
                if (vm.user.residential_address == null) {
                    vm.user.residential_address = {};
                }
                swal({
                    title: 'Update Contact Details',
                    html: 'User contact details has been successfully updated.',
                    type: 'success'
                });
            }, function (error) {
                vm.updatingContact = false;
                var error_msg = '<br/>';
                for (var key in error.body) {
                    error_msg += key + ': ' + error.body[key] + '<br/>';
                }
                swal({
                    title: 'Update Contact Details',
                    html: 'There was an error updating the user contact details.<br/>' + error_msg,
                    type: 'error'
                });
            });
        },
        updateAddress: function updateAddress() {
            var vm = this;
            vm.updatingAddress = true;
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.user.id + '/update_address'), (0, _stringify2.default)(vm.user.residential_address), {
                emulateJSON: true
            }).then(function (response) {
                vm.updatingAddress = false;
                vm.user = response.body;
                if (vm.user.residential_address == null) {
                    vm.user.residential_address = {};
                }
                swal({
                    title: 'Update Address Details',
                    html: 'User address details has been successfully updated.',
                    type: 'success'
                });
            }, function (error) {
                vm.updatingAddress = false;
                var error_msg = '<br/>';
                for (var key in error.body) {
                    error_msg += key + ': ' + error.body[key] + '<br/>';
                }
                swal({
                    title: 'Update Address Details',
                    html: 'There was an error updating the user address details.<br/>' + error_msg,
                    type: 'error'
                });
            });
        },
        unlinkUser: function unlinkUser(org) {
            var vm = this;
            var org_name = org.name;
            swal({
                title: "Unlink From Organisation",
                text: "Are you sure you want to unlink this user from " + org.name + " ?",
                type: "question",
                showCancelButton: true,
                confirmButtonText: 'Accept'
            }).then(function (result) {
                if (result.value) {
                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, org.id + '/unlink_user'), (0, _stringify2.default)(vm.user), {
                        emulateJSON: true
                    }).then(function (response) {
                        vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.user.id)).then(function (response) {
                            vm.user = response.body;
                            if (vm.user.residential_address == null) {
                                vm.user.residential_address = {};
                            }
                            if (vm.user.wildlifecompliance_organisations && vm.user.wildlifecompliance_organisations.length > 0) {
                                vm.managesOrg = 'Yes';
                            }
                            swal('Unlink', 'The user has been successfully unlinked from ' + org_name + '.', 'success');
                        }, function (error) {});
                    }, function (error) {
                        swal('Unlink', 'There was an error unlinking the user from ' + org_name + '.', 'error');
                    });
                }
            }, function (error) {});
        },
        readFileID: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var vm, _file, input, reader;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = this;
                                _file = null;
                                input = $(vm.$refs.uploadedID)[0];

                                if (input.files && input.files[0]) {
                                    reader = new FileReader();

                                    reader.readAsDataURL(input.files[0]);
                                    reader.onload = function (e) {
                                        _file = e.target.result;
                                    };
                                    _file = input.files[0];
                                }
                                vm.uploadedID = _file;
                                _context.next = 7;
                                return vm.uploadID();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function readFileID() {
                return _ref.apply(this, arguments);
            }

            return readFileID;
        }(),
        removeID: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.uploadedID = null;

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function removeID() {
                return _ref2.apply(this, arguments);
            }

            return removeID;
        }(),
        uploadID: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var vm, data;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                vm = this;

                                vm.uploadingID = true;
                                data = new FormData();

                                data.append('identification2', vm.uploadedID);
                                if (vm.uploadedID == null) {
                                    vm.uploadingID = false;
                                    swal({
                                        title: 'Upload ID',
                                        html: 'Please select a file to upload.',
                                        type: 'error'
                                    });
                                } else {
                                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.user.id + '/upload_id'), data, {
                                        emulateJSON: true
                                    }).then(function (response) {
                                        vm.uploadingID = false;
                                        vm.uploadedID = null;

                                        vm.uploadedID = response.body.identification2;
                                        vm.user.identification2 = response.body.identification2;
                                    }, function (error) {
                                        console.log(error);
                                        vm.uploadingID = false;
                                        vm.uploadedID = null;
                                        var error_msg = '<br/>';
                                        for (var key in error.body) {
                                            error_msg += key + ': ' + error.body[key] + '<br/>';
                                        }
                                        swal({
                                            title: 'Upload ID',
                                            html: 'There was an error uploading your ID.<br/>' + error_msg,
                                            type: 'error'
                                        });
                                    });
                                }

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function uploadID() {
                return _ref3.apply(this, arguments);
            }

            return uploadID;
        }()
    }, 'eventListeners', function eventListeners() {
        var self = this;
        var _dob = 'dob';
        $('[name=\'' + _dob + '\']').datetimepicker(self.datepickerOptions);
        $('[name=\'' + _dob + '\']').on('dp.change', function (e) {
            if ($('[name=\'' + _dob + '\']').data('DateTimePicker').date()) {
                self.user.dob = e.date.format('DD/MM/YYYY');
            } else if ($('[name=\'' + _dob + '\']').data('date') === "") {
                self.user.dob = "";
            }
        });
    }),
    mounted: function mounted() {
        var vm = this;
        vm.set_tabs();
        this.personal_form = document.forms.personal_form;
        this.eventListeners();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "reports",
    data: function data() {
        var vm = this;
        return {
            form: null,
            refund_form: null,
            oracle_form: null,
            oracleDatePicker: null,
            booking_settlements_form: null,
            bookings_form: null,
            bookingSettlementsDatePicker: null,
            bookingsDatePicker: null,
            accountsDateStartPicker: null,
            accountsDateEndPicker: null,
            flatDateStartPicker: null,
            flatDateEndPicker: null,
            refundsStartPicker: null,
            refundsEndPicker: null,
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false
            },
            regions: [],
            region: '',
            district: '',
            selected_region: {
                code: '',
                name: '',
                districts: []
            },
            oracle_override: false
        };
    },
    watch: {
        region: function region() {
            var vm = this;
            vm.district = '';
            if (vm.region) {
                vm.selected_region = vm.regions.find(function (r) {
                    return r.code == vm.region;
                });
            } else {
                vm.selected_region = {
                    code: '',
                    name: '',
                    districts: []
                };
            }
        }
    },
    methods: (_methods = {
        addEventListeners: function addEventListeners() {
            var vm = this;
            vm.form = $('#payments-form');
            vm.refund_form = $('#refund_form');
            vm.oracle_form = $(vm.$refs.oracle_form);
            vm.booking_settlements_form = $(vm.$refs.booking_settlements_form);
            vm.bookings_form = $(vm.$refs.bookings_form);
            vm.accountsDateStartPicker = $('#accountsDateStartPicker').datetimepicker(vm.datepickerOptions);
            vm.accountsDateEndPicker = $('#accountsDateEndPicker').datetimepicker(vm.datepickerOptions);
            vm.flatDateStartPicker = $('#flatDateStartPicker').datetimepicker(vm.datepickerOptions);
            vm.flatDateEndPicker = $('#flatDateEndPicker').datetimepicker(vm.datepickerOptions);
            vm.refundsStartPicker = $('#refundsStartPicker').datetimepicker(vm.datepickerOptions);
            vm.refundsEndPicker = $('#refundsEndPicker').datetimepicker(vm.datepickerOptions);
            vm.oracleDatePicker = $(vm.$refs.oracleDatePicker).datetimepicker(vm.datepickerOptions);
            vm.bookingSettlementsDatePicker = $(vm.$refs.bookingSettlementsDatePicker).datetimepicker(vm.datepickerOptions);
            vm.bookingsDatePicker = $(vm.$refs.bookingsDatePicker).datetimepicker(vm.datepickerOptions);

            vm.flatDateStartPicker.on('dp.hide', function (e) {
                vm.flatDateEndPicker.data("DateTimePicker").date(null);
                vm.flatDateEndPicker.data("DateTimePicker").minDate(e.date);
            });
            vm.accountsDateStartPicker.on('dp.hide', function (e) {
                vm.accountsDateEndPicker.data("DateTimePicker").date(null);
                vm.accountsDateEndPicker.data("DateTimePicker").minDate(e.date);
            });
            vm.refundsStartPicker.on('dp.hide', function (e) {
                vm.refundsEndPicker.data("DateTimePicker").date(null);
                vm.refundsEndPicker.data("DateTimePicker").minDate(e.date);
            });
            vm.addFormValidations();
            vm.fetchRegions();
        },
        runOracleJob: function runOracleJob() {
            var vm = this;

            if (vm.oracle_form.valid()) {
                var data = vm.oracleDatePicker.data("DateTimePicker").date().format('DD/MM/YYYY');
                var override = vm.oracle_override ? 'true' : 'false';
                vm.$http.get('/api/oracle_job?date=' + data + '&override=' + override).then(function (response) {
                    swal({
                        type: 'success',
                        title: 'Job Success',
                        text: 'The oracle job was completed successfully'
                    });
                }, function (error) {
                    swal({
                        type: 'error',
                        title: 'Oracle Job Error',
                        text: _hooks.helpers.apiVueResourceError(error)
                    });
                });
            }
        },

        fetchRegions: function fetchRegions() {
            var vm = this;
            $.get('/ledger/payments/api/regions?format=json', function (data) {
                vm.regions = data;
            });
        }
    }, (0, _defineProperty3.default)(_methods, "fetchRegions", function fetchRegions() {
        var vm = this;
        $.get('/ledger/payments/api/regions?format=json', function (data) {
            vm.regions = data;
        });
    }), (0, _defineProperty3.default)(_methods, "generateFlatReport", function generateFlatReport() {
        var vm = this;
        var values = vm.generateValues();
        if (values) {
            values.flat = false;
            vm.getReport(values);
        }
    }), (0, _defineProperty3.default)(_methods, "generateValues", function generateValues() {
        console.log('generateValues');
        var vm = this;
        if (vm.form.valid()) {
            var values = {
                "system": "S566",
                "start": vm.region ? vm.flatDateStartPicker.data("DateTimePicker").date().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DD H:mm:ss') : vm.accountsDateStartPicker.data("DateTimePicker").date().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DD H:mm:ss'),
                "end": vm.region ? vm.flatDateEndPicker.data("DateTimePicker").date().set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).format('YYYY-MM-DD H:mm:ss') : vm.accountsDateEndPicker.data("DateTimePicker").date().set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).format('YYYY-MM-DD H:mm:ss'),
                "banked_start": vm.flatDateStartPicker.data("DateTimePicker").date().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DD H:mm:ss'),
                "banked_end": vm.flatDateEndPicker.data("DateTimePicker").date().set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).format('YYYY-MM-DD H:mm:ss')
            };

            return values;
        }
        return false;
    }), (0, _defineProperty3.default)(_methods, "generateByAccount", function generateByAccount() {
        console.log('generateByAccount');
        var vm = this;
        var values = vm.generateValues();
        if (values) {
            values.items = true;
            vm.getReport(values);
        }
    }), (0, _defineProperty3.default)(_methods, "generateRefundReport", function generateRefundReport() {
        var vm = this;

        if (vm.refund_form.valid()) {
            var values = {
                "start": vm.refundsStartPicker.data("DateTimePicker").date().format('DD/MM/YYYY'),
                "end": vm.refundsEndPicker.data("DateTimePicker").date().format('DD/MM/YYYY')
            };
            var url = _hooks.api_endpoints.booking_refunds + "?" + $.param(values);
            window.location.assign(url);
        } else {
            console.log("invalid form");
        }
    }), (0, _defineProperty3.default)(_methods, "getReport", function getReport(values) {
        console.log('getReport');
        var vm = this;

        var url = "/ledger/payments/api/report?" + $.param(values);
        window.location.assign(url);
    }), (0, _defineProperty3.default)(_methods, "addFormValidations", function addFormValidations() {
        var vm = this;
        vm.form.validate({
            rules: {
                start: {
                    required: function required() {
                        return vm.region.length == 0;
                    }
                },
                end: {
                    required: function required() {
                        return vm.region.length == 0;
                    }
                },
                banked_start: "required",
                banked_end: "required"
            },
            messages: {
                start: "Field is required",
                end: "Field is required",
                banked_end: "Field is required",
                banked_start: "Field is required"
            },
            showErrors: function showErrors(errorMap, errorList) {
                $.each(this.validElements(), function (index, element) {
                    var $element = $(element);

                    $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                });

                $("." + this.settings.validClass).tooltip("destroy");

                for (var i = 0; i < errorList.length; i++) {
                    var error = errorList[i];
                    $(error.element).tooltip({
                        trigger: "focus"
                    }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                }
            }
        });
        vm.refund_form.validate({
            rules: {
                refund_start_date: {
                    required: function required() {
                        return vm.region.length == 0;
                    }
                },
                refund_end_date: {
                    required: function required() {
                        return vm.region.length == 0;
                    }
                }
            },
            messages: {
                refund_start_date: "Field is required",
                refund_end_date: "Field is required"
            },
            showErrors: function showErrors(errorMap, errorList) {
                $.each(this.validElements(), function (index, element) {
                    var $element = $(element);

                    $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                });

                $("." + this.settings.validClass).tooltip("destroy");

                for (var i = 0; i < errorList.length; i++) {
                    var error = errorList[i];
                    $(error.element).tooltip({
                        trigger: "focus"
                    }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                }
            }
        });
        vm.oracle_form.validate({
            rules: {
                oracle_date: 'required'
            },
            messages: {
                oracle_date: "Field is required"
            },
            showErrors: function showErrors(errorMap, errorList) {
                $.each(this.validElements(), function (index, element) {
                    var $element = $(element);

                    $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                });

                $("." + this.settings.validClass).tooltip("destroy");

                for (var i = 0; i < errorList.length; i++) {
                    var error = errorList[i];
                    $(error.element).tooltip({
                        trigger: "focus"
                    }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                }
            }
        });
        vm.booking_settlements_form.validate({
            rules: {
                booking_settlement_date: 'required'
            },
            messages: {
                booking_settlement_date: "Field is required"
            },
            showErrors: function showErrors(errorMap, errorList) {
                $.each(this.validElements(), function (index, element) {
                    var $element = $(element);

                    $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                });

                $("." + this.settings.validClass).tooltip("destroy");

                for (var i = 0; i < errorList.length; i++) {
                    var error = errorList[i];
                    $(error.element).tooltip({
                        trigger: "focus"
                    }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                }
            }
        });
        vm.bookings_form.validate({
            rules: {
                bookings_date: 'required'
            },
            messages: {
                bookings_date: "Field is required"
            },
            showErrors: function showErrors(errorMap, errorList) {
                $.each(this.validElements(), function (index, element) {
                    var $element = $(element);

                    $element.attr("data-original-title", "").parents('.form-group').removeClass('has-error');
                });

                $("." + this.settings.validClass).tooltip("destroy");

                for (var i = 0; i < errorList.length; i++) {
                    var error = errorList[i];
                    $(error.element).tooltip({
                        trigger: "focus"
                    }).attr("data-original-title", error.message).parents('.form-group').addClass('has-error');
                }
            }
        });
    }), _methods),
    mounted: function mounted() {
        var vm = this;
        vm.addEventListeners();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(10)))

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _bootstrap = __webpack_require__(101);

var _bootstrap2 = _interopRequireDefault(_bootstrap);

__webpack_require__(67);

var _returns_renderer = __webpack_require__(809);

var _returns_renderer2 = _interopRequireDefault(_returns_renderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(15);
__webpack_require__(165);
__webpack_require__(100);
exports.default = {
    components: {
        ReturnsRendererForm: _returns_renderer2.default
    },
    props: {
        form_width: {
            type: String,
            default: 'col-md-8'
        }
    }
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _hooks = __webpack_require__(3);

var _securebase_link = __webpack_require__(130);

var _securebase_link2 = _interopRequireDefault(_securebase_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'MyUserDetails',
    components: {
        SecureBaseLink: _securebase_link2.default
    },
    data: function data() {
        var vm = this;
        return {
            adBody: 'adBody' + vm._uid,
            pBody: 'pBody' + vm._uid,
            idBody: 'idBody' + vm._uid,
            cBody: 'cBody' + vm._uid,
            oBody: 'oBody' + vm._uid,
            current_user: {
                first_name: '',
                last_name: '',
                dob: '',
                legal_first_name: '',
                legal_last_name: '',
                legal_dob: '',
                wildlifecompliance_organisations: [],
                residential_address: {}
            },

            newOrg: {
                'name': '',
                'abn': '',
                'detailsChecked': false,
                'exists': false
            },
            countries: [],
            loading: [],
            registeringOrg: false,
            validatingPins: false,
            uploadingID: false,
            checkingDetails: false,
            addingCompany: false,
            managesOrg: 'No',
            managesOrgConsultant: 'No',
            uploadedFile: null,
            uploadedID: null,
            updatingPersonal: false,
            updatingAddress: false,
            updatingContact: false,
            role: null,
            orgRequest_pending: [],
            orgRequest_amendment_requested: [],
            new_user: false,
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            showCompleteMsg: false
        };
    },

    watch: {
        managesOrg: function managesOrg() {
            if (this.managesOrg == 'Yes') {
                this.newOrg.detailsChecked = false;
                this.role = 'employee';
            } else if (this.managesOrg == 'Consultant') {
                this.newOrg.detailsChecked = false;
                this.role = 'consultant';
            } else {
                this.role = null;
                this.newOrg.detailsChecked = false;
            }

            if (this.managesOrg == 'Yes' && !this.hasOrgs && this.newOrg) {
                this.addCompany();
            } else if (this.managesOrg == 'No' && this.newOrg) {
                this.resetNewOrg();
                this.uploadedFile = null;
                this.addingCompany = false;
            } else if (this.managesOrg == 'Consultant' && this.newOrg) {
                this.addCompany();
            } else {
                this.addCompany();
                this.addingCompany = false;
            }
        }

    },
    computed: {
        current_url: function current_url() {
            return window.location.href;
        },
        canUpdateDOB: function canUpdateDOB() {
            return this.current_user.legal_dob === null || this.current_user.legal_dob === "";
        },
        hasOrgs: function hasOrgs() {
            return this.current_user.wildlifecompliance_organisations && this.current_user.wildlifecompliance_organisations.length > 0 ? true : false;
        },
        uploadedFileName: function uploadedFileName() {
            return this.uploadedFile != null ? this.uploadedFile.name : '';
        },
        showCompletion: function showCompletion() {
            return this.$route.name == 'first-time';
        },
        approvedExternalUser: function approvedExternalUser() {
            if (this.current_user.is_compliance_management_approved_external_user) {
                return true;
            }
        },
        completedProfile: function completedProfile() {
            if (this.current_user.is_compliance_management_approved_external_user) {
                return this.current_user.contact_details && this.current_user.personal_details && this.current_user.address_details;
            } else {
                return this.current_user.contact_details && this.current_user.personal_details && this.current_user.address_details;
            }
        }
    },
    methods: {
        readFile: function readFile() {
            var vm = this;
            var _file = null;
            var input = (0, _jquery2.default)(vm.$refs.uploadedFile)[0];
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                reader.onload = function (e) {
                    _file = e.target.result;
                };
                _file = input.files[0];
            }
            vm.uploadedFile = _file;
        },
        readFileID: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var vm, _file, input, reader;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = this;
                                _file = null;
                                input = (0, _jquery2.default)(vm.$refs.uploadedID)[0];

                                if (input.files && input.files[0]) {
                                    reader = new FileReader();

                                    reader.readAsDataURL(input.files[0]);
                                    reader.onload = function (e) {
                                        _file = e.target.result;
                                    };
                                    _file = input.files[0];
                                }
                                vm.uploadedID = _file;
                                _context.next = 7;
                                return vm.uploadID();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function readFileID() {
                return _ref.apply(this, arguments);
            }

            return readFileID;
        }(),
        addCompany: function addCompany() {
            this.newOrg.push = {
                'name': '',
                'abn': ''
            };
            this.addingCompany = true;
        },
        resetNewOrg: function resetNewOrg() {
            this.newOrg = {
                'detailsChecked': false,
                'exists': false
            };
        },
        deleteUserLogout: function deleteUserLogout() {
            var vm = this;
            vm.$http.delete(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.current_user.id)).then(function (response) {
                window.location.href = '/ledger/logout';
            }, function (error) {});
        },
        updatePersonal: function updatePersonal() {
            var vm = this;
            vm.updatingPersonal = true;
            console.log(vm.current_user.residential_address);
            if (vm.current_user.residential_address == null) {
                vm.current_user.residential_address = {};
            }
            var params = '?';
            params += '&first_name=' + vm.current_user.first_name;
            params += '&last_name=' + vm.current_user.last_name;
            params += '&dob=' + vm.current_user.dob;
            if (vm.current_user.first_name == '' || vm.current_user.last_name == '' || vm.current_user.dob == null || vm.current_user.dob == '') {
                var error_msg = 'Please ensure all fields are filled in.';
                swal({
                    title: 'Update Personal Details',
                    html: 'There was an error updating your personal details.<br/>' + error_msg,
                    type: 'error'
                }).then(function () {
                    vm.updatingPersonal = false;
                    vm.current_user.personal_details = false;
                });
                return;
            }
            if (vm.new_user == 'True') {
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.current_user.id + '/update_personal'), (0, _stringify2.default)(vm.current_user), {
                    emulateJSON: true
                }).then(function (response) {
                    swal({
                        title: 'Update Personal Details',
                        html: 'Your personal details has been successfully updated.',
                        type: 'success'
                    }).then(function () {
                        vm.updatingPersonal = false;
                        vm.current_user.personal_details = true;
                        if (vm.completedProfile) {
                            vm.$http.get(_hooks.api_endpoints.user_profile_completed).then(function (response) {}, function (error) {});
                        }
                    });
                }, function (error) {
                    vm.updatingPersonal = false;
                    vm.current_user.personal_details = false;
                    var error_msg = '<br/>';
                    for (var key in error.body) {
                        if (key === 'dob') {
                            error_msg += 'dob: Please enter a valid date.<br/>';
                        } else {
                            error_msg += key + ': ' + error.body[key] + '<br/>';
                        }
                    }
                    swal({
                        title: 'Update Personal Details',
                        html: 'There was an error updating your personal details.<br/>' + error_msg,
                        type: 'error'
                    });
                });
            } else {
                vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.current_user.id + '/update_personal'), (0, _stringify2.default)(vm.current_user), {
                    emulateJSON: true
                }).then(function (response) {
                    swal({
                        title: 'Update Personal Details',
                        html: 'Your personal details has been successfully updated.',
                        type: 'success'
                    }).then(function () {
                        vm.updatingPersonal = false;
                        vm.current_user.personal_details = true;
                        vm.current_user.personal_details = true;
                        if (vm.completedProfile) {
                            vm.$http.get(_hooks.api_endpoints.user_profile_completed).then(function (response) {}, function (error) {});
                        }
                    });
                }, function (error) {
                    vm.updatingPersonal = false;
                    vm.current_user.personal_details = false;
                    var error_msg = '<br/>';
                    for (var key in error.body) {
                        if (key === 'dob') {
                            error_msg += 'dob: Please enter a valid date.<br/>';
                        } else {
                            error_msg += key + ': ' + error.body[key] + '<br/>';
                        }
                    }
                    swal({
                        title: 'Update Personal Details',
                        html: 'There was an error updating your personal details.<br/>' + error_msg,
                        type: 'error'
                    });
                });
            }
        },
        updateContact: function updateContact() {
            var vm = this;
            vm.updatingContact = true;
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.current_user.id + '/update_contact'), (0, _stringify2.default)(vm.current_user), {
                emulateJSON: true
            }).then(function (response) {
                vm.updatingContact = false;
                vm.current_user = response.body;
                if (vm.current_user.residential_address == null) {
                    vm.current_user.residential_address = {};
                }
                swal({
                    title: 'Update Contact Details',
                    html: 'Your contact details has been successfully updated.',
                    type: 'success'
                });
                if (vm.completedProfile) {
                    vm.$http.get(_hooks.api_endpoints.user_profile_completed).then(function (response) {}, function (error) {});
                }
            }, function (error) {
                vm.updatingContact = false;
                vm.current_user.contact_details = false;
                var error_msg = '<br/>';
                for (var key in error.body) {
                    error_msg += key + ': ' + error.body[key] + '<br/>';
                }
                swal({
                    title: 'Update Contact Details',
                    html: 'There was an error updating your contact details.<br/>' + error_msg,
                    type: 'error'
                });
            });
        },
        updateAddress: function updateAddress() {
            var vm = this;
            vm.updatingAddress = true;
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.current_user.id + '/update_address'), (0, _stringify2.default)(vm.current_user.residential_address), {
                emulateJSON: true
            }).then(function (response) {
                vm.updatingAddress = false;
                vm.current_user = response.body;
                if (vm.current_user.residential_address == null) {
                    vm.current_user.residential_address = {};
                }
                swal({
                    title: 'Update Address Details',
                    html: 'Your address details has been successfully updated.',
                    type: 'success'
                });
            }, function (error) {
                vm.updatingAddress = false;
                vm.current_user.address_details = false;
                var error_msg = '<br/>';
                for (var key in error.body) {
                    error_msg += key + ': ' + error.body[key] + '<br/>';
                }
                swal({
                    title: 'Update Address Details',
                    html: 'There was an error updating your address details.<br/>' + error_msg,
                    type: 'error'
                });
                if (vm.completedProfile) {
                    vm.$http.get(_hooks.api_endpoints.user_profile_completed).then(function (response) {}, function (error) {});
                }
            });
        },
        checkOrganisation: function checkOrganisation() {
            var _this = this;

            console.log('Entered CheckOrg');
            var vm = this;
            var new_organisation = vm.newOrg;
            for (var organisation in vm.current_user.wildlifecompliance_organisations) {
                if (new_organisation.abn && vm.current_user.wildlifecompliance_organisations[organisation].abn == new_organisation.abn) {
                    swal({
                        title: 'Checking Organisation',
                        html: 'You are already associated with this organisation.',
                        type: 'info'
                    });
                    vm.registeringOrg = false;
                    vm.uploadedFile = null;
                    vm.addingCompany = false;
                    vm.resetNewOrg();
                    return;
                }
            }
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, 'existence'), (0, _stringify2.default)(this.newOrg), {
                emulateJSON: true
            }).then(function (response) {
                _this.newOrg.exists = response.body.exists;
                _this.newOrg.id = response.body.id;
                _this.newOrg.detailsChecked = false;
                if (response.body.first_five) {
                    _this.newOrg.first_five = response.body.first_five;
                    _this.newOrg.detailsChecked = true;
                }
                _this.newOrg.detailsChecked = _this.newOrg.exists ? _this.newOrg.detailsChecked : true;
            }, function (error) {
                _this.newOrg.detailsChecked = false;
                var error_msg = '<br/>';
                for (var key in error.body) {
                    if (key === 'non_field_errors') {
                        error_msg += error.body[key] + '<br/>';
                    } else {
                        error_msg += key + ': ' + error.body[key] + '<br/>';
                    }
                }
                swal({
                    title: 'Checking Organisation',
                    html: 'There was an error checking this organisation.<br/>' + error_msg,
                    type: 'error'
                });
            });
        },
        validatePins: function validatePins() {
            var vm = this;
            vm.validatingPins = true;
            vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, vm.newOrg.id + '/validate_pins'), (0, _stringify2.default)(this.newOrg), {
                emulateJSON: true
            }).then(function (response) {
                if (response.body.valid) {
                    swal('Validate Pins', 'The pins you entered have been validated and your request will be processed by Organisation Administrator.', 'success');
                    vm.registeringOrg = false;
                    vm.uploadedFile = null;
                    vm.addingCompany = false;
                    vm.resetNewOrg();
                    _vue2.default.http.get(_hooks.api_endpoints.my_user_details).then(function (response) {
                        vm.current_user = response.body;
                        if (vm.current_user.residential_address == null) {
                            vm.current_user.residential_address = {};
                        }
                        if (vm.current_user.wildlifecompliance_organisations && vm.current_user.wildlifecompliance_organisations.length > 0) {
                            vm.managesOrg = 'Yes';
                        }
                    }, function (error) {});
                } else {
                    swal('Validate Pins', 'The pins you entered were incorrect', 'error');
                }
                vm.validatingPins = false;
            }, function (error) {
                vm.validatingPins = false;
            });
        },
        removeID: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.uploadedID = null;

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function removeID() {
                return _ref2.apply(this, arguments);
            }

            return removeID;
        }(),
        uploadID: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var vm, data;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                vm = this;

                                vm.uploadingID = true;
                                data = new FormData();

                                data.append('identification2', vm.uploadedID);
                                if (vm.uploadedID == null) {
                                    vm.uploadingID = false;
                                    swal({
                                        title: 'Upload ID',
                                        html: 'Please select a file to upload.',
                                        type: 'error'
                                    });
                                } else {
                                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.users, vm.current_user.id + '/upload_id'), data, {
                                        emulateJSON: true
                                    }).then(function (response) {
                                        vm.uploadingID = false;
                                        vm.uploadedID = null;
                                        vm.uploadedID = response.body.identification2;
                                        vm.current_user.identification2 = response.body.identification2;
                                    }, function (error) {
                                        console.log(error);
                                        vm.uploadingID = false;
                                        vm.uploadedID = null;
                                        var error_msg = '<br/>';
                                        for (var key in error.body) {
                                            error_msg += key + ': ' + error.body[key] + '<br/>';
                                        }
                                        swal({
                                            title: 'Upload ID',
                                            html: 'There was an error uploading your ID.<br/>' + error_msg,
                                            type: 'error'
                                        });
                                    });
                                }

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function uploadID() {
                return _ref3.apply(this, arguments);
            }

            return uploadID;
        }(),
        orgRequest: function orgRequest() {
            var _this2 = this;

            var vm = this;
            vm.registeringOrg = true;
            var data = new FormData();
            data.append('name', vm.newOrg.name);
            data.append('abn', vm.newOrg.abn);
            data.append('identification', vm.uploadedFile);
            data.append('role', vm.role);
            vm.newOrg.name = vm.newOrg.name == null ? '' : vm.newOrg.name;
            vm.newOrg.abn = vm.newOrg.abn == null ? '' : vm.newOrg.abn;
            if (vm.newOrg.name == '' || vm.newOrg.abn == '' || vm.uploadedFile == null) {
                vm.registeringOrg = false;
                swal('Error submitting organisation request', 'Please enter the organisation details and attach a file before submitting your request.', 'error');
            } else {
                vm.$http.post(_hooks.api_endpoints.organisation_requests, data, {
                    emulateJSON: true
                }).then(function (response) {
                    vm.registeringOrg = false;
                    vm.uploadedFile = null;
                    vm.addingCompany = false;
                    vm.resetNewOrg();
                    swal({
                        title: 'Sent',
                        html: 'Your organisation request has been successfully submitted.',
                        type: 'success'
                    }).then(function () {
                        if (_this2.$route.name == 'account') {
                            window.location.reload(true);
                        }
                    });
                }, function (error) {
                    vm.registeringOrg = false;
                    var error_msg = '<br/>';
                    for (var key in error.body) {
                        if (key === 'non_field_errors') {
                            error_msg += error.body[key] + '<br/>';
                        } else {
                            error_msg += key + ': ' + error.body[key] + '<br/>';
                        }
                    }
                    swal('Error submitting organisation request', error_msg, 'error');
                });
            }
        },
        orgConsultRequest: function orgConsultRequest() {
            var _this3 = this;

            var vm = this;
            vm.registeringOrg = true;
            var data = new FormData();
            var new_organisation = vm.newOrg;
            for (var organisation in vm.current_user.wildlifecompliance_organisations) {
                if (new_organisation.abn && vm.current_user.wildlifecompliance_organisations[organisation].abn == new_organisation.abn) {
                    swal({
                        title: 'Checking Organisation',
                        html: 'You are already associated with this organisation.',
                        type: 'info'
                    });
                    vm.registeringOrg = false;
                    vm.uploadedFile = null;
                    vm.addingCompany = false;
                    vm.resetNewOrg();
                    return;
                }
            }
            data.append('name', vm.newOrg.name);
            data.append('abn', vm.newOrg.abn);
            data.append('identification', vm.uploadedFile);
            data.append('role', vm.role);
            vm.newOrg.name = vm.newOrg.name == null ? '' : vm.newOrg.name;
            vm.newOrg.abn = vm.newOrg.abn == null ? '' : vm.newOrg.abn;
            if (vm.newOrg.name == '' || vm.newOrg.abn == '' || vm.uploadedFile == null) {
                vm.registeringOrg = false;
                swal('Error submitting organisation request', 'Please enter the organisation details and attach a file before submitting your request.', 'error');
            } else {
                vm.$http.post(_hooks.api_endpoints.organisation_requests, data, {
                    emulateJSON: true
                }).then(function (response) {
                    vm.registeringOrg = false;
                    vm.uploadedFile = null;
                    vm.addingCompany = false;
                    vm.resetNewOrg();
                    swal({
                        title: 'Sent',
                        html: 'Your organisation request has been successfully submitted.',
                        type: 'success'
                    }).then(function () {
                        if (_this3.$route.name == 'account') {
                            window.location.reload(true);
                        }
                    });
                }, function (error) {
                    vm.registeringOrg = false;
                    var error_msg = '<br/>';
                    for (var key in error.body) {
                        if (key === 'non_field_errors') {
                            error_msg += error.body[key] + '<br/>';
                        } else {
                            error_msg += key + ': ' + error.body[key] + '<br/>';
                        }
                    }
                    swal('Error submitting organisation request', error_msg, 'error');
                });
            }
        },
        uploadNewFileUpdateOrgRequest: function uploadNewFileUpdateOrgRequest(orgReq) {
            var vm = this;
            vm.readFile();
            var data = new FormData();
            data.append('identification', vm.uploadedFile);
            vm.$http.put(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, orgReq.id + '/reupload_identification_amendment_request'), data, {
                emulateJSON: true
            }).then(function (response) {
                vm.uploadedFile = null;
                vm.resetNewOrg();
                swal({
                    title: 'Sent',
                    html: 'Your organisation request has been successfully submitted.',
                    type: 'success'
                }).then(function () {
                    window.location.reload(true);
                });
            }, function (error) {
                console.log(error);
                vm.registeringOrg = false;
                var error_msg = '<br/>';
                for (var key in error.body) {
                    error_msg += key + ': ' + error.body[key] + '<br/>';
                }
                swal('Error submitting organisation request', error_msg, 'error');
            });
        },
        toggleSection: function toggleSection(e) {
            var el = e.target;
            var chev = null;
            (0, _jquery2.default)(el).on('click', function (event) {
                chev = (0, _jquery2.default)(this);
                (0, _jquery2.default)(chev).toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
            });
        },
        fetchCountries: function fetchCountries() {
            var vm = this;
            vm.loading.push('fetching countries');
            vm.$http.get(_hooks.api_endpoints.countries).then(function (response) {
                vm.countries = response.body;
                vm.loading.splice('fetching countries', 1);
            }, function (response) {
                vm.loading.splice('fetching countries', 1);
            });
        },
        fetchOrgRequestPending: function fetchOrgRequestPending() {
            var vm = this;
            vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, 'get_pending_requests')).then(function (response) {
                vm.orgRequest_pending = response.body;
                vm.loading.splice('fetching pending organisation requests', 1);
            }, function (response) {
                vm.loading.splice('fetching pending organisation requests', 1);
            });
        },
        fetchOrgRequestAmendmentRequested: function fetchOrgRequestAmendmentRequested() {
            var vm = this;
            vm.$http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisation_requests, 'get_amendment_requested_requests')).then(function (response) {
                vm.orgRequest_amendment_requested = response.body;
                vm.loading.splice('fetching amendment requested organisation requests', 1);
            }, function (response) {
                vm.loading.splice('fetching amendment requested organisation requests', 1);
            });
        },
        unlinkUser: function unlinkUser(org) {
            var vm = this;
            var org_name = org.name;

            swal({
                title: "Unlink From Organisation",
                text: "Are you sure you want to be unlinked from " + org.name + " ?",
                type: "question",
                showCancelButton: true,
                confirmButtonText: 'Accept'
            }).then(function (result) {
                if (result.value) {
                    vm.$http.post(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.organisations, org.id + '/unlink_user'), (0, _stringify2.default)(vm.current_user), {
                        emulateJSON: true
                    }).then(function (response) {
                        _vue2.default.http.get(_hooks.api_endpoints.my_user_details).then(function (response) {
                            vm.current_user = response.body;
                            if (vm.current_user.residential_address == null) {
                                vm.current_user.residential_address = {};
                            }
                            if (vm.current_user.wildlifecompliance_organisations && vm.current_user.wildlifecompliance_organisations.length > 0) {
                                vm.managesOrg = 'Yes';
                            }
                        }, function (error) {});
                        swal('Unlink', 'You have been successfully unlinked from ' + org_name + '.', 'success');
                    }, function (error) {
                        var error_msg = '<br/>';
                        for (var key in error.body) {
                            if (key == 'non_field_errors') {
                                error_msg += error.body[key] + '<br/>';
                            }
                        }
                        swal('Unlink', 'There was an error unlinking you from ' + org_name + '.' + error_msg, 'error');
                    });
                }
            }, function (error) {});
        },
        userProfileCompleted: function userProfileCompleted() {
            var vm = this;
            vm.$http.get(_hooks.api_endpoints.user_profile_completed).then(function (response) {
                window.location.href = '/';
            }, function (error) {});
        },
        eventListeners: function eventListeners() {
            var self = this;
            var _dob = 'dob';
            (0, _jquery2.default)('[name=\'' + _dob + '\']').datetimepicker(self.datepickerOptions);
            (0, _jquery2.default)('[name=\'' + _dob + '\']').on('dp.change', function (e) {
                if ((0, _jquery2.default)('[name=\'' + _dob + '\']').data('DateTimePicker').date()) {
                    self.current_user.dob = e.date.format('DD/MM/YYYY');
                } else if ((0, _jquery2.default)('[name=\'' + _dob + '\']').data('date') === "") {
                    self.current_user.dob = "";
                }
            });
        }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        _vue2.default.http.get(_hooks.api_endpoints.my_user_details).then(function (response) {
            if (to.name == 'first-time' && response.body.address_details && response.body.personal_details && response.body.contact_details && response.body.has_complete_first_time) {
                window.location.href = '/';
            } else {
                next(function (vm) {
                    vm.current_user = response.body;
                    if (vm.current_user.residential_address == null) {
                        vm.current_user.residential_address = {};
                    }
                    if (vm.current_user.wildlifecompliance_organisations && vm.current_user.wildlifecompliance_organisations.length > 0) {
                        vm.managesOrg = 'Yes';
                    }
                    if (vm.current_user.identification2) {
                        vm.uploadedID = vm.current_user.identification2;
                    }
                });
            }
        }, function (error) {});
    },
    mounted: function mounted() {
        var _this4 = this;

        this.fetchCountries();
        this.fetchOrgRequestPending();
        this.fetchOrgRequestAmendmentRequested();
        this.personal_form = document.forms.personal_form;
        (0, _jquery2.default)('.panelClicker[data-toggle="collapse"]').on('click', function () {
            var chev = (0, _jquery2.default)(this).children()[0];
            window.setTimeout(function () {
                (0, _jquery2.default)(chev).toggleClass("glyphicon-chevron-down glyphicon-chevron-up");
            }, 100);
        });
        _vue2.default.http.get(_hooks.api_endpoints.is_new_user).then(function (response) {
            _this4.new_user = response.body;
        });
        this.$nextTick(function () {
            _this4.eventListeners();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(33);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'CreateProfile',
    data: function data() {
        var vm = this;
        return {
            pBody: 'pBody' + vm._uid,
            current_user: {},
            profile: {
                postal_address: {}
            },
            countries: [],
            loading: [],
            creatingProfile: false,
            role: null
        };
    },

    watch: {},
    computed: {},
    methods: {
        createProfile: function createProfile() {
            var vm = this;
            vm.creatingProfile = true;
            vm.profile.user = vm.current_user.id;
            vm.profile.auth_identity = true;
            var params = '?email=' + encodeURIComponent(vm.profile.email) + '&exclude_user=' + vm.current_user.id;
            vm.$http.get(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.emailidentities, params), (0, _stringify2.default)(vm.profile), {
                emulateJSON: true
            }).then(function (response) {
                console.log(response);
                if (response.body.length > 0) {
                    vm.creatingProfile = false;
                    swal({
                        title: 'Create Profile',
                        html: 'This email address is already associated with an existing account or profile.',
                        type: 'error'
                    });
                    return;
                }
                vm.$http.post(_hooks.api_endpoints.my_profiles + '/', (0, _stringify2.default)(vm.profile), {
                    emulateJSON: true
                }).then(function (response) {
                    vm.creatingProfile = false;
                    vm.profile = response.body;
                    if (vm.profile.postal_address == null) {
                        vm.profile.postal_address = {};
                    }
                    swal({
                        title: 'Create Profile',
                        html: 'Your profile has been successfully created.<br/><br/>' + vm.profile.name + '<br/>' + vm.profile.email,
                        type: 'success',
                        onClose: vm.$router.push('/profiles')
                    });
                }, function (error) {
                    vm.creatingProfile = false;
                    var error_msg = '<br/>';
                    for (var key in error.body) {
                        if (key === 'postal_address') {
                            for (var pkey in error.body[key]) {
                                error_msg += pkey + ': ' + error.body[key][pkey] + '<br/>';
                            }
                        } else {
                            error_msg += key + ': ' + error.body[key] + '<br/>';
                        }
                    }
                    swal({
                        title: 'Create Profile',
                        html: 'There was an error creating the profile.<br/>' + error_msg,
                        type: 'error'
                    });
                });
            }, function (error) {
                vm.creatingProfile = false;
                swal({
                    title: 'Create Profile',
                    html: 'There was an error creating the profile.',
                    type: 'error'
                });
            });
        }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        var initialisers = [_utils2.default.fetchCountries(), _utils2.default.fetchCurrentUser()];
        _promise2.default.all(initialisers).then(function (data) {
            next(function (vm) {
                vm.countries = data[0];
                vm.current_user = data[1];
            });
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _datatable = __webpack_require__(9);

var _datatable2 = _interopRequireDefault(_datatable);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'ProfileDashTable',
    props: {
        level: {
            type: String,
            required: true,
            validator: function validator(val) {
                var options = ['internal'];
                return options.indexOf(val) != -1 ? true : false;
            }
        },
        url: {
            type: String,
            required: true
        }
    },
    data: function data() {
        var vm = this;
        return {
            pBody: 'pBody' + vm._uid,
            datatable_id: 'profile-datatable-' + vm._uid,

            dateFormat: 'DD/MM/YYYY',
            datepickerOptions: {
                format: 'DD/MM/YYYY',
                showClear: true,
                useCurrent: false,
                keepInvalid: true,
                allowInputToggle: true
            },
            profile_headers: ["Profile Name", "Email", "Institution", "Postal Address", "Actions"],
            profile_options: {
                language: {
                    processing: "<i class='fa fa-4x fa-spinner fa-spin'></i>"
                },
                responsive: true,
                ajax: {
                    "url": _hooks.api_endpoints.my_profiles,
                    "dataSrc": ''
                },
                columns: [{ data: "name" }, { data: "email" }, { data: "institution" }, {
                    mRender: function mRender(data, type, full) {
                        return full.postal_address.line1 + " " + full.postal_address.line2 + " " + full.postal_address.line3 + " " + full.postal_address.locality + " " + full.postal_address.state + " " + full.postal_address.country + " " + full.postal_address.postcode;
                    }
                }, {
                    mRender: function mRender(data, type, full) {
                        var links = '';
                        links += '<a href=\'/profiles/' + full.id + '\' class="editProfile">Edit</a><br/>';
                        links += '<a data-name=\'' + full.name + '\' data-email=\'' + full.email + '\' data-id=\'' + full.id + '\' class="delete_profile">Delete</a><br/>';
                        return links;
                    },
                    orderable: false
                }],
                processing: true,
                initComplete: function initComplete() {
                    vm.$refs.profile_datatable.vmDataTable.columns.adjust().responsive.recalc();
                }
            }
        };
    },

    components: {
        datatable: _datatable2.default
    },
    watch: {},
    computed: {
        status: function status() {
            return [];
        },
        is_external: function is_external() {
            return this.level == 'external';
        }
    },
    methods: {
        deleteProfile: function deleteProfile(id, name, email) {
            var vm = this;
            vm.$http.delete(_hooks.api_endpoints.profiles + "/" + id + '/').then(function (response) {
                swal('Delete Profile', 'Your profile, ' + name + ' (' + email + ') has been successfully deleted.', 'success');
                vm.$refs.profile_datatable.vmDataTable.ajax.reload();
            }, function (error) {
                console.log(error);
                swal('Delete Profile', 'There was an error deleting the profile, ' + name + ' (' + email + ').', 'error');
            });
        },
        eventListeners: function eventListeners() {
            var vm = this;
            vm.$refs.profile_datatable.vmDataTable.on('click', '.delete_profile', function (e) {
                e.preventDefault();
                var name = $(e.target).data('name');
                var email = $(e.target).data('email');
                var id = $(e.target).data('id');
                swal({
                    title: "Delete Profile",
                    text: 'Are you sure you want to delete this profile, ' + name + ' (' + email + ')?',
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    focusCancel: true
                }).then(function (result) {
                    if (result.value) {
                        vm.deleteProfile(id, name, email);
                    } else if (result.dismiss === swal.DismissReason.cancel) {
                        return;
                    }
                }, function (error) {
                    console.log(error);
                });
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        var vm = this;
        this.$nextTick(function () {
            _this.eventListeners();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(2)))

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(12);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _hooks = __webpack_require__(3);

var _utils = __webpack_require__(33);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'EditProfile',
  data: function data() {
    var vm = this;
    return {
      adBody: 'adBody' + vm._uid,
      current_user: {},
      profile: {
        postal_address: {}
      },
      countries: [],
      loading: [],
      uploadedFile: null,
      updatingProfile: false
    };
  },

  watch: {},
  computed: {},
  methods: {
    updateProfile: function updateProfile() {
      var vm = this;
      vm.updatingProfile = true;
      var params = '?email=' + vm.profile.email + '&exclude_user=' + vm.current_user.id;
      vm.$http.get(_hooks.helpers.add_endpoint_join(_hooks.api_endpoints.users, params), (0, _stringify2.default)(vm.profile), {
        emulateJSON: true
      }).then(function (response) {
        if (response.body.length > 0) {
          vm.updatingProfile = false;
          swal({
            title: 'Update Profile',
            html: 'This email address is already associated with an existing account or profile.',
            type: 'error'
          });
          return;
        }
        vm.$http.put(_hooks.api_endpoints.profiles + '/' + vm.profile.id + '/', (0, _stringify2.default)(vm.profile), {
          emulateJSON: true
        }).then(function (response) {
          vm.updatingProfile = false;
          vm.profile = response.body;
          if (vm.profile.postal_address == null) {
            vm.profile.postal_address = {};
          }
          swal('Update Profile', 'Your profile has been successfully updated.', 'success');
        }, function (error) {
          vm.updatingProfile = false;
          var error_msg = '<br/>';
          for (var key in error.body) {
            if (key === 'postal_address') {
              for (var pkey in error.body[key]) {
                error_msg += pkey + ': ' + error.body[key][pkey] + '<br/>';
              }
            } else {
              error_msg += key + ': ' + error.body[key] + '<br/>';
            }
          }
          swal({
            title: 'Update Profile',
            html: 'There was an error updating the profile.<br/>' + error_msg,
            type: 'error'
          });
        });
      }, function (error) {
        vm.updatingProfile = false;
        swal({
          title: 'Update Profile',
          html: 'There was an error updating the profile.',
          type: 'error'
        });
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var initialisers = [_utils2.default.fetchCountries(), _utils2.default.fetchProfile(to.params.profile_id), _utils2.default.fetchCurrentUser()];
    _promise2.default.all(initialisers).then(function (data) {
      next(function (vm) {
        vm.countries = data[0];
        vm.profile = data[1];
        vm.current_user = data[2];
      });
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var initialisers = [_utils2.default.fetchProfile(to.params.profile_id)];
    _promise2.default.all(initialisers).then(function (data) {
      next(function (vm) {
        vm.org = data[0];
        vm.org.address = vm.org.address != null ? vm.org.address : {};
        vm.org.pins = vm.org.pins != null ? vm.org.pins : {};
      });
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    type: {
      type: String
    },
    dismissable: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    },
    duration: {
      type: Number,
      default: 0
    },
    width: {
      type: String
    },
    placement: {
      type: String
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (this._timeout) clearTimeout(this._timeout);
      if (val && Boolean(this.duration)) {
        this._timeout = setTimeout(function () {
          _this.show = false;
        }, this.duration);
      }
    }
  }
};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        title: {
            type: String,
            default: 'Modal'
        },
        small: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        },
        full: {
            type: Boolean,
            default: false
        },
        force: {
            type: Boolean,
            default: false
        },
        showOk: {
            type: Boolean,
            default: true
        },
        transition: {
            type: String,
            default: 'modal'
        },
        okText: {
            type: String,
            default: 'OK'
        },
        cancelText: {
            type: String,
            default: 'Cancel'
        },
        okClass: {
            type: String,
            default: 'btn btn-default'
        },
        cancelClass: {
            type: String,
            default: 'btn btn-default'
        },
        closeWhenOK: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            duration: null
        };
    },

    computed: {
        modalClass: function modalClass() {
            return {
                'modal-lg': this.large,
                'modal-sm': this.small,
                'modal-full': this.full
            };
        },

        show: function show() {
            return this.$parent.isModalOpen;
        }
    },
    created: function created() {
        if (this.show) {
            document.body.className += ' modal-open';
        }
    },
    beforeDestroy: function beforeDestroy() {
        document.body.className = document.body.className.replace(/\s?modal-open/, '');
    },

    watch: {
        show: function show(value) {
            if (value) {
                document.body.className += ' modal-open';
            } else {

                window.setTimeout(function () {
                    document.body.className = document.body.className.replace(/\s?modal-open/, '');
                }, this.duration || 0);
            }
        }
    },
    methods: {
        ok: function ok() {
            this.$emit('ok');
            if (this.closeWhenOK) {
                this.show = false;
            }
        },
        cancel: function cancel() {
            this.$emit('cancel');
            this.$parent.close();
        },
        clickMask: function clickMask() {
            if (!this.force) {
                this.cancel();
            }
        }
    }
};

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _responsive_datatable_helper = __webpack_require__(50);

var _responsive_datatable_helper2 = _interopRequireDefault(_responsive_datatable_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    name: 'DataTable',
    props: {
        dtHeaders: {
            type: Array,
            required: true
        },
        dtOptions: {
            type: Object,
            required: true
        },
        id: {
            required: true
        },
        onMount: {
            type: Function,
            default: function _default() {}
        },

        parentStyle: {
            type: String
        }
    },
    data: function data() {
        return {
            table: null,
            vmDataTable: null
        };
    },
    computed: {
        stylingClass: function stylingClass() {
            if (!this.parentStyle) {
                return 'compact hover table table-striped table-bordered dt-responsive parentClass nowrap';
            } else {
                return 'compact hover table table-striped table-bordered dt-responsive parentClass' + this.parentStyle;
            }
        }
    },
    methods: {
        initEvents: function initEvents() {
            var vm = this;
            var responsiveHelper;
            var breakpointDefinition = {
                tablet: 992,
                phone: 768
            };
            var responsiveOptions = {
                autoWidth: false,
                preDrawCallback: function preDrawCallback() {
                    if (!responsiveHelper) {
                        responsiveHelper = new _responsive_datatable_helper2.default(vm.table, breakpointDefinition);
                    }
                },
                rowCallback: function rowCallback(nRow) {
                    responsiveHelper.createExpandIcon(nRow);
                },
                drawCallback: function drawCallback(oSettings) {
                    responsiveHelper.respond();
                }
            };

            var options = (0, _assign2.default)(vm.dtOptions);
            vm.vmDataTable = $(vm.table).DataTable(options);
            $(vm.table).on('page.dt', function () {
                vm.vmDataTable.columns.adjust().responsive.recalc();
            });
        }
    },
    mounted: function mounted() {
        this.table = $('#' + this.id);
        $.fn.dataTable.ext.errMode = 'throw';
        this.initEvents();
        this.onMount();
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dashboard = __webpack_require__(819);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _dashboard_sanction_outcome = __webpack_require__(820);

var _dashboard_sanction_outcome2 = _interopRequireDefault(_dashboard_sanction_outcome);

var _application = __webpack_require__(814);

var _application2 = _interopRequireDefault(_application);

var _application_apply = __webpack_require__(815);

var _application_apply2 = _interopRequireDefault(_application_apply);

var _application_apply_organisation = __webpack_require__(817);

var _application_apply_organisation2 = _interopRequireDefault(_application_apply_organisation);

var _application_apply_licence = __webpack_require__(816);

var _application_apply_licence2 = _interopRequireDefault(_application_apply_licence);

var _application_submit = __webpack_require__(818);

var _application_submit2 = _interopRequireDefault(_application_submit);

var _manage = __webpack_require__(821);

var _manage2 = _interopRequireDefault(_manage);

var _return = __webpack_require__(825);

var _return2 = _interopRequireDefault(_return);

var _remediation_action = __webpack_require__(822);

var _remediation_action2 = _interopRequireDefault(_remediation_action);

var _remediation_action_submit_success = __webpack_require__(823);

var _remediation_action_submit_success2 = _interopRequireDefault(_remediation_action_submit_success);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    path: '/external',
    component: {
        render: function render(c) {
            return c('router-view');
        }
    },
    children: [{
        path: '/',
        component: _dashboard2.default,
        name: 'external-applications-dash'
    }, {
        path: 'sanction_outcome',
        component: _dashboard_sanction_outcome2.default,
        name: 'external-sanction-outcome-dash'
    }, {
        path: 'remediation_action/:remediation_action_id',
        component: _remediation_action2.default,
        name: 'external-remediation-action-detail'
    }, {
        path: 'remediation_action/:remediation_action_id/submit_success',
        component: _remediation_action_submit_success2.default,
        name: 'external-remediation-action-submit-success'
    }, {
        path: 'organisations/manage/:org_id',
        component: _manage2.default
    }, {
        path: 'return/:return_id',
        component: _return2.default
    }, {
        path: 'application',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: '/',
            component: _application_apply2.default,
            name: "apply_application"
        }, {
            path: 'org_select',
            component: _application_apply_organisation2.default,
            name: "apply_application_organisation"
        }, {
            path: 'licence_select',
            component: _application_apply_licence2.default,
            name: "apply_application_licence"
        }, {
            path: 'submit',
            component: _application_submit2.default,
            name: "submit_application"
        }, {
            path: ':application_id',
            component: _application2.default,
            name: "draft_application"
        }]
    }]
};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dashboard = __webpack_require__(855);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _search = __webpack_require__(900);

var _search2 = _interopRequireDefault(_search);

var _access_dashboard = __webpack_require__(885);

var _access_dashboard2 = _interopRequireDefault(_access_dashboard);

var _access = __webpack_require__(884);

var _access2 = _interopRequireDefault(_access);

var _manage = __webpack_require__(886);

var _manage2 = _interopRequireDefault(_manage);

var _dashboard3 = __webpack_require__(901);

var _dashboard4 = _interopRequireDefault(_dashboard3);

var _manage3 = __webpack_require__(902);

var _manage4 = _interopRequireDefault(_manage3);

var _application = __webpack_require__(841);

var _application2 = _interopRequireDefault(_application);

var _complete_assessment = __webpack_require__(847);

var _complete_assessment2 = _interopRequireDefault(_complete_assessment);

var _dashboard5 = __webpack_require__(871);

var _dashboard6 = _interopRequireDefault(_dashboard5);

var _call_email_dashboard = __webpack_require__(344);

var _call_email_dashboard2 = _interopRequireDefault(_call_email_dashboard);

var _call_email = __webpack_require__(851);

var _call_email2 = _interopRequireDefault(_call_email);

var _dashboard7 = __webpack_require__(890);

var _dashboard8 = _interopRequireDefault(_dashboard7);

var _return = __webpack_require__(891);

var _return2 = _interopRequireDefault(_return);

var _inspection_dashboard = __webpack_require__(858);

var _inspection_dashboard2 = _interopRequireDefault(_inspection_dashboard);

var _legal_case_dashboard = __webpack_require__(866);

var _legal_case_dashboard2 = _interopRequireDefault(_legal_case_dashboard);

var _legal_case = __webpack_require__(865);

var _legal_case2 = _interopRequireDefault(_legal_case);

var _inspection = __webpack_require__(857);

var _inspection2 = _interopRequireDefault(_inspection);

var _artifact_dashboard = __webpack_require__(850);

var _artifact_dashboard2 = _interopRequireDefault(_artifact_dashboard);

var _artifact = __webpack_require__(849);

var _artifact2 = _interopRequireDefault(_artifact);

var _sanction_outcome_dashboard = __webpack_require__(897);

var _sanction_outcome_dashboard2 = _interopRequireDefault(_sanction_outcome_dashboard);

var _sanction_outcome = __webpack_require__(896);

var _sanction_outcome2 = _interopRequireDefault(_sanction_outcome);

var _offence_dashboard = __webpack_require__(881);

var _offence_dashboard2 = _interopRequireDefault(_offence_dashboard);

var _offence = __webpack_require__(880);

var _offence2 = _interopRequireDefault(_offence);

var _dashboard_switcher = __webpack_require__(856);

var _dashboard_switcher2 = _interopRequireDefault(_dashboard_switcher);

var _reports = __webpack_require__(903);

var _reports2 = _interopRequireDefault(_reports);

var _schema_manager = __webpack_require__(875);

var _schema_manager2 = _interopRequireDefault(_schema_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    path: '/internal',
    component: {
        render: function render(c) {
            return c('router-view');
        }
    },
    children: [{
        path: '/',
        component: _dashboard_switcher2.default,
        name: 'internal-dash'
    }, {
        path: 'licences',
        component: _dashboard6.default,
        name: "internal-licences-dash"
    }, {
        path: 'inspection',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: '/',
            component: _inspection_dashboard2.default,
            name: "internal-inspection-dash"
        }, {
            path: ':inspection_id',
            component: _inspection2.default,
            name: "view-inspection"
        }]
    }, {
        path: 'legal_case',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: '/',
            component: _legal_case_dashboard2.default,
            name: "internal-legal-case-dash"
        }, {
            path: ':legal_case_id',
            component: _legal_case2.default,
            name: "view-legal-case"
        }]
    }, {
        path: 'object',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: '/',
            component: _artifact_dashboard2.default,
            name: "internal-artifact-dash"
        }, {
            path: ':artifact_id',
            component: _artifact2.default,
            name: "view-artifact"
        }]
    }, {
        path: 'offence',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: '/',
            component: _offence_dashboard2.default,
            name: "internal-offence-dash"
        }, {
            path: ':offence_id',
            component: _offence2.default,
            name: "view-offence"
        }]
    }, {
        path: 'reports',
        name: 'reports',
        component: _reports2.default
    }, {
        path: 'sanction_outcome',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: '/',
            component: _sanction_outcome_dashboard2.default,
            name: "internal-sanction-outcome-dash"
        }, {
            path: ':sanction_outcome_id',
            component: _sanction_outcome2.default,
            name: "view-sanction-outcome"
        }]
    }, {
        path: 'call_email',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: '/',
            component: _call_email_dashboard2.default,
            name: "internal-call-email-dash"
        }, {
            path: ':call_email_id',
            component: _call_email2.default,
            name: "view-call-email"
        }]
    }, {
        path: 'returns',
        component: _dashboard8.default,
        name: "internal-returns-dash"
    }, {
        path: 'search',
        component: _search2.default,
        name: "internal-search"
    }, {
        path: 'return/:return_id',
        component: _return2.default
    }, {
        path: 'users',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: '/',
            component: _dashboard4.default,
            name: "internal-users-dash"
        }, {
            path: ':user_id',
            component: _manage4.default,
            name: "internal-user-detail"
        }]
    }, {
        path: 'organisations',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },
        children: [{
            path: 'access',
            component: _access_dashboard2.default,
            name: "org-access-dash"
        }, {
            path: 'access/:access_id',
            component: _access2.default,
            name: "org-access"
        }, {
            path: ':org_id',
            component: _manage2.default,
            name: "internal-org-detail"
        }]
    }, {
        path: 'application',
        component: {
            render: function render(c) {
                return c('router-view');
            }
        },

        children: [{
            path: ':application_id',
            component: {
                render: function render(c) {
                    return c('router-view');
                }
            },
            children: [{
                path: '/',
                component: _application2.default,
                name: "internal-application"
            }]
        }, {
            path: 'assessment/:application_id',
            component: _complete_assessment2.default,
            name: "complete-assessment"
        }]
    }, {
        path: 'schema',
        component: _schema_manager2.default,
        name: "schema-manager"
    }]
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _vueResource = __webpack_require__(361);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _App = __webpack_require__(358);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(355);

var _router2 = _interopRequireDefault(_router);

var _bootstrap = __webpack_require__(101);

var _bootstrap2 = _interopRequireDefault(_bootstrap);

var _helpers = __webpack_require__(42);

var _helpers2 = _interopRequireDefault(_helpers);

var _packages = __webpack_require__(354);

var _packages2 = _interopRequireDefault(_packages);

var _api = __webpack_require__(135);

var _api2 = _interopRequireDefault(_api);

var _store = __webpack_require__(356);

var _store2 = _interopRequireDefault(_store);

var _renderer_block = __webpack_require__(360);

var _renderer_block2 = _interopRequireDefault(_renderer_block);

var _compliance_renderer_block = __webpack_require__(359);

var _compliance_renderer_block2 = _interopRequireDefault(_compliance_renderer_block);

var _vueScrollto = __webpack_require__(362);

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

var _vueAffix = __webpack_require__(357);

var _vueAffix2 = _interopRequireDefault(_vueAffix);

var _vuelidate = __webpack_require__(363);

var _vuelidate2 = _interopRequireDefault(_vuelidate);

var _ckeditor4Vue = __webpack_require__(353);

var _ckeditor4Vue2 = _interopRequireDefault(_ckeditor4Vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(15);

__webpack_require__(100);

_vue2.default.config.productionTip = false;
_vue2.default.use(_vueResource2.default);
_vue2.default.use(_vueScrollto2.default);
_vue2.default.use(_vueAffix2.default);
_vue2.default.use(_vuelidate2.default);
_vue2.default.component('renderer-block', _renderer_block2.default);
_vue2.default.component('compliance-renderer-block', _compliance_renderer_block2.default);

_vue2.default.use(_ckeditor4Vue2.default);

_vue2.default.http.interceptors.push(function (request, next) {
    if (request.url != _api2.default.countries) {
        request.headers.set('X-CSRFToken', _helpers2.default.getCookie('csrftoken'));
    }

    next();
});

_vue2.default.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

var mapbox_access_token = '';

_vue2.default.mixin({
    methods: {
        retrieveMapboxAccessToken: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var ret_val;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return $.ajax('/api/geocoding_address_search_token');

                            case 2:
                                ret_val = _context.sent;
                                return _context.abrupt('return', ret_val);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function retrieveMapboxAccessToken() {
                return _ref.apply(this, arguments);
            }

            return retrieveMapboxAccessToken;
        }()
    }
});

_vue2.default.prototype.current_tab = '';
window.vue = new _vue2.default({
    el: '#app',
    store: _store2.default,
    router: _router2.default,
    template: '<App/>',
    components: {
        App: _App2.default
    }
});

_vue2.default.config.devtools = true;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applicationStore = undefined;

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _mutations;

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _mutationTypes = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applicationStore = exports.applicationStore = {
    state: {
        original_application: {},
        application: {
            "schema": [],
            "licence_type_data": {
                "activity": []
            }
        },
        id_check_status: null,
        character_check_status: null,
        return_check_status: null
    },
    getters: {
        application: function application(state) {
            return state.application;
        },
        original_application: function original_application(state) {
            return state.original_application;
        },
        amendment_requests: function amendment_requests(state) {
            return state.application.amendment_requests;
        },
        application_id: function application_id(state) {
            return state.application.id;
        },
        licence_type_data: function licence_type_data(state) {
            return state.application.licence_type_data;
        },
        org_address: function org_address(state) {
            return state.application.org_applicant != null && state.application.org_applicant.address != null ? state.application.org_applicant.address : {};
        },
        proxy_address: function proxy_address(state) {
            return state.application.proxy_applicant != null && state.application.proxy_applicant.address != null ? state.application.proxy_applicant.address : {};
        },
        application_readonly: function application_readonly(state) {
            return state.application.readonly;
        },
        id_check_status: function id_check_status(state) {
            return state.id_check_status;
        },
        character_check_status: function character_check_status(state) {
            return state.character_check_status;
        },
        return_check_status: function return_check_status(state) {
            return state.return_check_status;
        },
        applicant_type: function applicant_type(state) {
            if (state.application.org_applicant) {
                return 'org';
            } else if (state.application.proxy_applicant) {
                return 'proxy';
            }
            return 'submitter';
        },
        checkActivityStatus: function checkActivityStatus(state, getters, rootState, rootGetters) {
            return function (status_list) {
                var status_count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                var required_role = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                if (status_list.constructor !== Array) {
                    status_list = [status_list];
                }
                var activities_list = getters.licence_type_data.activity;
                return activities_list.filter(function (activity) {
                    return status_list.includes(activity.processing_status.id) && (required_role === null || rootGetters.hasRole(required_role, activity.id));
                }).length >= status_count;
            };
        },
        isFinalised: function isFinalised(state, getters) {
            return getters.checkActivityStatus(['declined', 'accepted'], getters.licence_type_data.activity.length);
        },
        isPartiallyFinalised: function isPartiallyFinalised(state, getters) {
            var final_statuses = ['declined', 'accepted'];
            var activity_count = getters.licence_type_data.activity.length;
            return getters.checkActivityStatus(final_statuses) && !getters.checkActivityStatus(final_statuses, activity_count);
        },
        isApplicationLoaded: function isApplicationLoaded(state) {
            return (0, _keys2.default)(state.application).length && state.application.licence_type_data.activity.length;
        },
        isApplicationActivityVisible: function isApplicationActivityVisible(state, getters, rootState, rootGetters) {
            return function (_ref) {
                var activity_id = _ref.activity_id,
                    exclude_statuses = _ref.exclude_statuses,
                    exclude_processing_statuses = _ref.exclude_processing_statuses,
                    for_user_role = _ref.for_user_role,
                    only_processing_statuses = _ref.only_processing_statuses;

                if (!state.application.activities) {
                    return 0;
                }
                return getters.filterActivityList({
                    activity_list: state.application.activities,
                    activity_id: activity_id,
                    only_processing_statuses: only_processing_statuses,
                    exclude_statuses: exclude_statuses,
                    exclude_processing_statuses: exclude_processing_statuses,
                    for_user_role: for_user_role,
                    licence_activity_id_key: 'licence_activity'
                }).length;
            };
        },
        licenceActivities: function licenceActivities(state, getters) {
            return function (activity_status, for_user_role) {
                return getters.filterActivityList({
                    activity_list: getters.licence_type_data.activity,
                    only_processing_statuses: activity_status,
                    for_user_role: for_user_role
                });
            };
        },
        filterActivityList: function filterActivityList(state, getters, rootState, rootGetters) {
            return function (_ref2) {
                var activity_list = _ref2.activity_list,
                    activity_id = _ref2.activity_id,
                    exclude_statuses = _ref2.exclude_statuses,
                    only_processing_statuses = _ref2.only_processing_statuses,
                    exclude_processing_statuses = _ref2.exclude_processing_statuses,
                    for_user_role = _ref2.for_user_role,
                    _ref2$licence_activit = _ref2.licence_activity_id_key,
                    licence_activity_id_key = _ref2$licence_activit === undefined ? 'licence_activity' : _ref2$licence_activit;


                if (!activity_list.length) {
                    return [];
                }
                return activity_list.filter(function (activity) {
                    return (!activity_id || activity[licence_activity_id_key] == activity_id) && (!exclude_statuses || !(exclude_statuses.constructor === Array ? exclude_statuses : [exclude_statuses]).includes(activity.decision_action)) && (!only_processing_statuses || (only_processing_statuses.constructor === Array ? only_processing_statuses : [only_processing_statuses]).includes(activity.processing_status.id ? activity.processing_status.id : activity.processing_status)) && (!exclude_processing_statuses || !(exclude_processing_statuses.constructor === Array ? exclude_processing_statuses : [exclude_processing_statuses]).includes(activity.processing_status.id ? activity.processing_status.id : activity.processing_status)) && (!for_user_role || rootGetters.hasRole(for_user_role, activity[licence_activity_id_key]));
                });
            };
        },
        sendToAssessorActivities: function sendToAssessorActivities(state, getters) {
            return getters.licenceActivities(['with_officer', 'with_officer_conditions', 'with_assessor'], 'licensing_officer');
        }
    },
    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_APPLICATION, function (state, application) {
        _vue2.default.set(state, 'application', (0, _extends3.default)({}, application));
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_ORIGINAL_APPLICATION, function (state, application) {
        _vue2.default.set(state, 'original_application', (0, _extends3.default)({}, application));
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_ORG_APPLICANT, function (state, _ref3) {
        var key = _ref3.key,
            value = _ref3.value;

        if (state.application.org_applicant == null) {
            _vue2.default.set(state.application, "org_applicant", {});
        }
        _vue2.default.set(state.application.org_applicant, key, value);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_PROXY_APPLICANT, function (state, _ref4) {
        var key = _ref4.key,
            value = _ref4.value;

        if (state.application.proxy_applicant == null) {
            _vue2.default.set(state.application, "proxy_applicant", {});
        }
        _vue2.default.set(state.application.proxy_applicant, key, value);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_APPLICATION_CHECK_STATUS_ID, function (state, id_status) {
        _vue2.default.set(state, 'id_check_status', id_status);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_APPLICATION_CHECK_STATUS_CHARACTER, function (state, character_status) {
        _vue2.default.set(state, 'character_check_status', character_status);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_APPLICATION_CHECK_STATUS_RETURN, function (state, return_status) {
        _vue2.default.set(state, 'return_check_status', return_status);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_APPLICATION_FEE_STATUS, function (state, fee_status) {
        _vue2.default.set(state.application, 'update_fee', fee_status);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_APPLICATION_ASSESS_STATUS, function (state, assess_status) {
        _vue2.default.set(state.application, 'assess', assess_status);
    }), _mutations),
    actions: {
        refreshAddresses: function refreshAddresses(_ref5) {
            var commit = _ref5.commit,
                state = _ref5.state,
                getters = _ref5.getters;

            if (getters.applicant_type === 'org') {
                commit(_mutationTypes.UPDATE_ORG_APPLICANT, { key: 'address', value: state.org_address });
            };
            if (getters.applicant_type === 'proxy') {
                commit(_mutationTypes.UPDATE_PROXY_APPLICANT, { key: 'address', value: state.proxy_address });
            };
        },
        loadApplication: function loadApplication(_ref6, _ref7) {
            var dispatch = _ref6.dispatch,
                state = _ref6.state,
                commit = _ref6.commit;
            var url = _ref7.url;

            return new _promise2.default(function (resolve, reject) {
                _vue2.default.http.get(url).then(function (res) {
                    dispatch('setOriginalApplication', res.body);
                    dispatch('setApplication', res.body);
                    dispatch('setApplication', (0, _extends3.default)({}, state.application, {
                        application_fee: res.body.adjusted_paid_amount.application_fee,
                        licence_fee: res.body.adjusted_paid_amount.licence_fee,
                        update_fee: false,
                        assess: false
                    }));
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = (0, _getIterator3.default)(res.body.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var form_data_record = _step.value;

                            dispatch('setFormValue', {
                                key: form_data_record.field_name,
                                value: {
                                    "value": form_data_record.value,
                                    "officer_comment": form_data_record.officer_comment,
                                    "assessor_comment": form_data_record.assessor_comment,
                                    "deficiency_value": form_data_record.deficiency,
                                    "schema_name": form_data_record.schema_name,
                                    "component_type": form_data_record.component_type,
                                    "instance_name": form_data_record.instance_name,
                                    "licence_activity_id": form_data_record.licence_activity_id,
                                    "licence_purpose_id": form_data_record.licence_purpose_id,
                                    "component_attribute": form_data_record.component_attribute
                                }
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    dispatch('setIdCheckStatus', res.body.id_check_status.id);
                    dispatch('setCharacterCheckStatus', res.body.character_check_status.id);
                    dispatch('setReturnCheckStatus', res.body.return_check_status.id);
                    resolve();
                }, function (err) {
                    console.log(err);
                    reject();
                });
            });
        },
        revertApplication: function revertApplication(_ref8) {
            var dispatch = _ref8.dispatch,
                commit = _ref8.commit,
                state = _ref8.state;

            commit(_mutationTypes.UPDATE_APPLICATION, state.original_application);
        },
        setOriginalApplication: function setOriginalApplication(_ref9, application) {
            var commit = _ref9.commit;

            commit(_mutationTypes.UPDATE_ORIGINAL_APPLICATION, application);
        },
        setApplication: function setApplication(_ref10, application) {
            var dispatch = _ref10.dispatch,
                commit = _ref10.commit;

            commit(_mutationTypes.UPDATE_APPLICATION, application);
        },
        refreshApplicationFees: function refreshApplicationFees(_ref11) {
            var dispatch = _ref11.dispatch,
                state = _ref11.state,
                getters = _ref11.getters,
                rootGetters = _ref11.rootGetters;

            _vue2.default.http.post('/api/application/estimate_price/', {
                'application_id': getters.application_id,
                'field_data': rootGetters.renderer_form_data
            }).then(function (res) {
                dispatch('setApplication', (0, _extends3.default)({}, state.application, {
                    application_fee: res.body.fees.application,
                    licence_fee: res.body.fees.licence,
                    update_fee: true,
                    assess: true
                }));
            }, function (err) {
                console.log(err);
            });
        },
        setIdCheckStatus: function setIdCheckStatus(_ref12, id_status) {
            var commit = _ref12.commit;

            commit(_mutationTypes.UPDATE_APPLICATION_CHECK_STATUS_ID, id_status);
        },
        setCharacterCheckStatus: function setCharacterCheckStatus(_ref13, character_status) {
            var commit = _ref13.commit;

            commit(_mutationTypes.UPDATE_APPLICATION_CHECK_STATUS_CHARACTER, character_status);
        },
        setReturnCheckStatus: function setReturnCheckStatus(_ref14, return_status) {
            var commit = _ref14.commit;

            commit(_mutationTypes.UPDATE_APPLICATION_CHECK_STATUS_RETURN, return_status);
        },
        setAssessStatus: function setAssessStatus(_ref15, assess_status) {
            var commit = _ref15.commit;

            commit(_mutationTypes.UPDATE_APPLICATION_ASSESS_STATUS, assess_status);
        },
        resetUpdateFeeStatus: function resetUpdateFeeStatus(_ref16) {
            var commit = _ref16.commit;

            commit(_mutationTypes.UPDATE_APPLICATION_FEE_STATUS, false);
        },
        setLicenceTypeData: function setLicenceTypeData(_ref17, activity_data) {
            var dispatch = _ref17.dispatch,
                state = _ref17.state,
                getters = _ref17.getters,
                rootGetters = _ref17.rootGetters;

            return new _promise2.default(function (resolve, reject) {
                _vue2.default.http.post('/api/application/' + getters.application_id + '/update_licence_type_data/', {
                    'application_id': getters.application_id,
                    'licence_activity_id': activity_data.licence_activity_id,
                    'licence_activity_workflow': activity_data.workflow
                }).then(function (res) {
                    dispatch('setApplication', res.body);
                    dispatch('setApplication', (0, _extends3.default)({}, state.application, {
                        application_fee: res.body.adjusted_paid_amount.application_fee,
                        licence_fee: res.body.adjusted_paid_amount.licence_fee,
                        update_fee: false,
                        assess: false
                    }));
                    resolve();
                }, function (err) {
                    console.log(err);
                    reject();
                });
            });
        }
    }
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.callemailStore = undefined;

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var callemailStore = exports.callemailStore = {
    namespaced: true,
    state: {
        call_email: {
            schema: [],
            classification: {
                id: null
            },
            location: {
                type: "Feature",
                properties: {
                    town_suburb: null,
                    street: null,
                    state: 'WA',
                    postcode: null,
                    country: 'Australia',
                    details: ''
                },
                geometry: {
                    "type": "Point",
                    "coordinates": []
                }
            },
            call_type: {
                id: null
            },
            report_type: {
                id: null
            },

            allocated_group: [],
            volunteer_list: []
        },
        classification_types: [],
        call_types: [],
        report_types: [],
        referrers: [],
        status_choices: []
    },
    getters: {
        call_email: function call_email(state) {
            return state.call_email;
        },
        classification_types: function classification_types(state) {
            return state.classification_types;
        },
        report_types: function report_types(state) {
            return state.report_types;
        },
        status_choices: function status_choices(state) {
            return state.status_choices;
        },
        referrers: function referrers(state) {
            return state.referrers;
        },
        call_latitude: function call_latitude(state) {
            if (state.call_email.location) {
                if (state.call_email.location.geometry) {
                    if (state.call_email.location.geometry.coordinates.length > 0) {
                        return state.call_email.location.geometry.coordinates[1];
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },
        call_longitude: function call_longitude(state) {
            if (state.call_email.location) {
                if (state.call_email.location.geometry) {
                    if (state.call_email.location.geometry.coordinates.length > 0) {
                        return state.call_email.location.geometry.coordinates[0];
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }
            } else {
                return "";
            }
        }
    },
    mutations: {
        updateStatusChoices: function updateStatusChoices(state, choices) {
            for (var i = 0; i < choices.length; i++) {
                state.status_choices.push(choices[i]);
            }
        },
        updateClassificationChoices: function updateClassificationChoices(state, choices) {
            for (var i = 0; i < choices.length; i++) {
                state.classification_types.push(choices[i]);
            }
        },
        updateCallEmail: function updateCallEmail(state, call_email) {
            if (!call_email.location) {
                call_email.location = {
                    "type": "Feature",
                    properties: {
                        town_suburb: null,
                        street: null,
                        state: null,
                        postcode: null,
                        country: null
                    },
                    id: null,
                    geometry: {
                        "type": "Point",
                        "coordinates": []
                    }
                };
            }
            if (!call_email.email_user) {
                call_email.email_user = {
                    first_name: '',
                    last_name: '',
                    dob: null,
                    residential_address: {
                        line1: '',
                        locality: '',
                        state: 'WA',
                        postcode: '',
                        country: 'AU'
                    }
                };
            } else if (!call_email.email_user.residential_address) {
                call_email.email_user.residential_address = {
                    line1: '',
                    locality: '',
                    state: 'WA',
                    postcode: '',
                    country: 'AU'
                };
            }
            _vue2.default.set(state, 'call_email', (0, _extends3.default)({}, call_email));
            if (state.call_email.occurrence_date_from) {
                state.call_email.occurrence_date_from = (0, _moment2.default)(state.call_email.occurrence_date_from, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
            if (state.call_email.occurrence_time_start) {
                state.call_email.occurrence_time_start = (0, _moment2.default)(state.call_email.occurrence_time_start, 'HH:mm').format('hh:mm A');
            } else if (state.call_email.occurrence_time_start === '') {
                state.call_email.occurrence_time_start = null;
            }
            if (state.call_email.occurrence_date_to) {
                state.call_email.occurrence_date_to = (0, _moment2.default)(state.call_email.occurrence_date_to, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
            if (state.call_email.occurrence_time_end) {
                state.call_email.occurrence_time_end = (0, _moment2.default)(state.call_email.occurrence_time_end, 'HH:mm').format('hh:mm A');
            } else if (state.call_email.occurrence_time_end === '') {
                state.call_email.occurrence_time_end = null;
            }
            if (state.call_email.date_of_call) {
                state.call_email.date_of_call = (0, _moment2.default)(state.call_email.date_of_call, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
            if (state.call_email.time_of_call) {
                state.call_email.time_of_call = (0, _moment2.default)(state.call_email.time_of_call, 'HH:mm').format('hh:mm A');
            } else if (state.call_email.time_of_call === '') {
                state.call_email.time_of_call = null;
            }
            if (!state.call_email.volunteer_id) {
                state.call_email.volunteer_id = state.call_email.current_user_id;
            }
            var rendererDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.call_email, state.call_email.id + "/process_renderer_document/");
            _vue2.default.set(state.call_email, 'rendererDocumentUrl', rendererDocumentUrl);
            var commsLogsDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.call_email, state.call_email.id + "/process_comms_log_document/");
            _vue2.default.set(state.call_email, 'commsLogsDocumentUrl', commsLogsDocumentUrl);
        },
        updateSchema: function updateSchema(state, schema) {
            _vue2.default.set(state.call_email, 'schema', schema);
        },
        updateClassificationTypes: function updateClassificationTypes(state, classification_entry) {
            if (classification_entry) {
                state.classification_types.push(classification_entry);
            } else {
                state.classification_types = [];
            }
        },
        updateReferrers: function updateReferrers(state, referrer_entry) {
            if (referrer_entry) {
                state.referrers.push(referrer_entry);
            } else {
                state.referrers = [];
            }
        },
        updateReportTypes: function updateReportTypes(state, report_type_entry) {
            if (report_type_entry) {
                state.report_types.push(report_type_entry);
            } else {
                state.report_types = [];
            }
        },
        updateClassification: function updateClassification(state, classification) {
            if (classification) {
                _vue2.default.set(state.call_email, 'classification', classification);
            }
        },
        updateReportType: function updateReportType(state, report_type) {
            if (report_type) {
                _vue2.default.set(state.call_email, 'report_type', report_type);
            }
        },
        updateEmailUser: function updateEmailUser(state, email_user) {
            if (email_user) {
                _vue2.default.set(state.call_email, 'email_user', email_user);
            }
        },
        updateEmailUserEmpty: function updateEmailUserEmpty(state) {
            var email_user_empty = {
                first_name: '',
                last_name: '',
                dob: null,
                residential_address: {
                    line1: '',
                    locality: '',
                    state: 'WA',
                    postcode: '',
                    country: 'AU'
                }
            };
            _vue2.default.set(state.call_email, 'email_user', email_user_empty);
        },
        updateResidentialAddress: function updateResidentialAddress(state, address) {
            _vue2.default.set(state.call_email.email_user, 'residential_address', address);
        },
        updateLocation: function updateLocation(state, location) {
            _vue2.default.set(state.call_email, 'location', location);
        },
        updateLocationPoint: function updateLocationPoint(state, point) {
            state.call_email.location.geometry.coordinates = point;
        },
        updateLocationAddress: function updateLocationAddress(state, location_properties) {
            state.call_email.location.properties = location_properties;
        },
        updateLocationAddressEmpty: function updateLocationAddressEmpty(state) {
            state.call_email.location.properties.town_suburb = "";
            state.call_email.location.properties.street = "";
            state.call_email.location.properties.state = "";
            state.call_email.location.properties.postcode = "";
            state.call_email.location.properties.country = "";
        },
        updateLocationDetailsFieldEmpty: function updateLocationDetailsFieldEmpty(state) {
            state.call_email.location.properties.details = "";
        },
        updateAllocatedGroupList: function updateAllocatedGroupList(state, members) {
            _vue2.default.set(state.call_email, 'allocated_group', {});
            _vue2.default.set(state.call_email, 'allocated_group', members);
        },
        updateAllocatedGroupId: function updateAllocatedGroupId(state, id) {
            state.call_email.allocated_group_id = id;
        },
        updateRegionId: function updateRegionId(state, id) {
            state.call_email.region_id = id;
        },
        updateOccurrenceTimeStart: function updateOccurrenceTimeStart(state, time) {
            _vue2.default.set(state.call_email, 'occurrence_time_start', time);
        },
        updateOccurrenceTimeEnd: function updateOccurrenceTimeEnd(state, time) {
            _vue2.default.set(state.call_email, 'occurrence_time_end', time);
        },
        updateTimeOfCall: function updateTimeOfCall(state, time) {
            _vue2.default.set(state.call_email, 'time_of_call', time);
        },
        updateDateOfCall: function updateDateOfCall(state, date) {
            _vue2.default.set(state.call_email, 'date_of_call', date);
        },
        updateRelatedItems: function updateRelatedItems(state, related_items) {
            _vue2.default.set(state.call_email, 'related_items', related_items);
        },
        updateCaller: function updateCaller(state, data) {
            if (data.data_type === 'individual') {
                _vue2.default.set(state.call_email, 'email_user_id', data.id);
            }
        }
    },
    actions: {
        loadCallEmail: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref, _ref2) {
                var dispatch = _ref.dispatch,
                    commit = _ref.commit;
                var call_email_id = _ref2.call_email_id;

                var returnedCallEmail, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form_data_record;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.call_email, call_email_id));

                            case 3:
                                returnedCallEmail = _context.sent;
                                _context.next = 6;
                                return dispatch("setCallEmail", returnedCallEmail.body);

                            case 6:
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 9;
                                _iterator = (0, _getIterator3.default)(returnedCallEmail.body.data);

                            case 11:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context.next = 18;
                                    break;
                                }

                                form_data_record = _step.value;
                                _context.next = 15;
                                return dispatch("setFormValue", {
                                    key: form_data_record.field_name,
                                    value: {
                                        "value": form_data_record.value,
                                        "comment_value": form_data_record.comment,
                                        "deficiency_value": form_data_record.deficiency
                                    }
                                }, {
                                    root: true
                                });

                            case 15:
                                _iteratorNormalCompletion = true;
                                _context.next = 11;
                                break;

                            case 18:
                                _context.next = 24;
                                break;

                            case 20:
                                _context.prev = 20;
                                _context.t0 = _context['catch'](9);
                                _didIteratorError = true;
                                _iteratorError = _context.t0;

                            case 24:
                                _context.prev = 24;
                                _context.prev = 25;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 27:
                                _context.prev = 27;

                                if (!_didIteratorError) {
                                    _context.next = 30;
                                    break;
                                }

                                throw _iteratorError;

                            case 30:
                                return _context.finish(27);

                            case 31:
                                return _context.finish(24);

                            case 32:
                                _context.next = 36;
                                break;

                            case 34:
                                _context.prev = 34;
                                _context.t1 = _context['catch'](0);

                            case 36:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 34], [9, 20, 24, 32], [25,, 27, 31]]);
            }));

            function loadCallEmail(_x, _x2) {
                return _ref3.apply(this, arguments);
            }

            return loadCallEmail;
        }(),
        saveCallEmailPerson: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref4) {
                var dispatch = _ref4.dispatch,
                    state = _ref4.state;
                var fetchUrl, savedEmailUser;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.call_email, state.call_email.id + "/call_email_save_person/");
                                _context2.next = 4;
                                return _vue2.default.http.post(fetchUrl, state.call_email);

                            case 4:
                                savedEmailUser = _context2.sent;
                                _context2.next = 7;
                                return dispatch("setEmailUser", savedEmailUser.body);

                            case 7:
                                _context2.next = 9;
                                return swal("Saved", "The record has been saved", "success");

                            case 9:
                                _context2.next = 20;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2['catch'](0);

                                if (!_context2.t0.body.non_field_errors) {
                                    _context2.next = 18;
                                    break;
                                }

                                _context2.next = 16;
                                return swal("Error", _context2.t0.body.non_field_errors[0], "error");

                            case 16:
                                _context2.next = 20;
                                break;

                            case 18:
                                _context2.next = 20;
                                return swal("Error", "There was an error saving the record", "error");

                            case 20:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 11]]);
            }));

            function saveCallEmailPerson(_x3) {
                return _ref5.apply(this, arguments);
            }

            return saveCallEmailPerson;
        }(),
        saveCallEmail: function () {
            var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref6, _ref7) {
                var dispatch = _ref6.dispatch,
                    state = _ref6.state,
                    rootGetters = _ref6.rootGetters;
                var crud = _ref7.crud,
                    internal = _ref7.internal;

                var callId, savedCallEmail, payload, createUrl, _createUrl, draftUrl, fetchUrl;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                callId = null;
                                savedCallEmail = null;
                                _context3.prev = 2;
                                payload = new Object();

                                (0, _assign2.default)(payload, state.call_email);
                                if (payload.occurrence_date_from) {
                                    payload.occurrence_date_from = (0, _moment2.default)(payload.occurrence_date_from, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                } else if (payload.occurrence_date_from === '') {
                                    payload.occurrence_date_from = null;
                                }
                                if (payload.occurrence_time_start) {
                                    payload.occurrence_time_start = (0, _moment2.default)(payload.occurrence_time_start, 'hh:mm A').format('HH:mm');
                                } else if (payload.occurrence_time_start === '') {
                                    payload.occurrence_time_start = null;
                                }
                                if (payload.occurrence_date_to) {
                                    payload.occurrence_date_to = (0, _moment2.default)(payload.occurrence_date_to, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                } else if (payload.occurrence_date_to === '') {
                                    payload.occurrence_date_to = null;
                                }
                                if (payload.occurrence_time_end) {
                                    payload.occurrence_time_end = (0, _moment2.default)(payload.occurrence_time_end, 'hh:mm A').format('HH:mm');
                                } else if (payload.occurrence_time_end === '') {
                                    payload.occurrence_time_end = null;
                                }
                                if (payload.date_of_call) {
                                    payload.date_of_call = (0, _moment2.default)(payload.date_of_call, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                } else if (payload.date_of_call === '') {
                                    payload.date_of_call = null;
                                }
                                if (payload.time_of_call) {
                                    payload.time_of_call = (0, _moment2.default)(payload.time_of_call, 'hh:mm A').format('HH:mm');
                                } else if (payload.time_of_call === '') {
                                    payload.time_of_call = null;
                                }
                                if (crud == 'duplicate') {
                                    payload.id = null;
                                    payload.location_id = null;
                                    if (payload.location) {
                                        payload.location.id = null;
                                    }
                                }

                                if (state.call_email.schema) {
                                    if (state.call_email.schema.length > 0) {
                                        payload.renderer_data = rootGetters.renderer_form_data;
                                    }
                                }

                                if (!(crud === 'create')) {
                                    _context3.next = 20;
                                    break;
                                }

                                createUrl = _hooks.api_endpoints.call_email;
                                _context3.next = 17;
                                return _vue2.default.http.post(createUrl, {});

                            case 17:
                                savedCallEmail = _context3.sent;
                                _context3.next = 52;
                                break;

                            case 20:
                                if (!(crud === 'duplicate')) {
                                    _context3.next = 27;
                                    break;
                                }

                                _createUrl = _hooks.api_endpoints.call_email;
                                _context3.next = 24;
                                return _vue2.default.http.post(_createUrl, payload);

                            case 24:
                                savedCallEmail = _context3.sent;
                                _context3.next = 52;
                                break;

                            case 27:
                                if (!(crud === 'save')) {
                                    _context3.next = 41;
                                    break;
                                }

                                draftUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.call_email, state.call_email.id + "/draft/");
                                _context3.prev = 29;
                                _context3.next = 32;
                                return _vue2.default.http.post(draftUrl, payload);

                            case 32:
                                savedCallEmail = _context3.sent;
                                _context3.next = 39;
                                break;

                            case 35:
                                _context3.prev = 35;
                                _context3.t0 = _context3['catch'](29);
                                _context3.next = 39;
                                return swal({
                                    title: 'Error',
                                    html: _hooks.helpers.formatError(_context3.t0),
                                    type: "error"
                                });

                            case 39:
                                _context3.next = 52;
                                break;

                            case 41:
                                _context3.prev = 41;
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.call_email, state.call_email.id + "/");
                                _context3.next = 45;
                                return _vue2.default.http.put(fetchUrl, payload);

                            case 45:
                                savedCallEmail = _context3.sent;
                                _context3.next = 52;
                                break;

                            case 48:
                                _context3.prev = 48;
                                _context3.t1 = _context3['catch'](41);
                                _context3.next = 52;
                                return swal({
                                    title: 'Mandatory Field',
                                    html: _hooks.helpers.formatError(_context3.t1),
                                    type: "error"
                                });

                            case 52:
                                _context3.next = 54;
                                return dispatch("setCallEmail", savedCallEmail.body);

                            case 54:
                                callId = savedCallEmail.body.id;

                                _context3.next = 65;
                                break;

                            case 57:
                                _context3.prev = 57;
                                _context3.t2 = _context3['catch'](2);

                                if (!internal) {
                                    _context3.next = 63;
                                    break;
                                }

                                return _context3.abrupt('return', _context3.t2);

                            case 63:
                                _context3.next = 65;
                                return swal("Error", "There was an error saving the record", "error");

                            case 65:
                                if (!(crud === 'duplicate')) {
                                    _context3.next = 70;
                                    break;
                                }

                                console.log("hello???");
                                return _context3.abrupt('return', window.location.href = "/internal/call_email/" + callId);

                            case 70:
                                if (!(crud !== 'create')) {
                                    _context3.next = 77;
                                    break;
                                }

                                if (internal) {
                                    _context3.next = 76;
                                    break;
                                }

                                _context3.next = 74;
                                return swal("Saved", "The record has been saved", "success");

                            case 74:
                                _context3.next = 77;
                                break;

                            case 76:
                                return _context3.abrupt('return', savedCallEmail);

                            case 77:
                                return _context3.abrupt('return', savedCallEmail);

                            case 78:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[2, 57], [29, 35], [41, 48]]);
            }));

            function saveCallEmail(_x4, _x5) {
                return _ref8.apply(this, arguments);
            }

            return saveCallEmail;
        }(),
        setAllocatedGroupList: function setAllocatedGroupList(_ref9, data) {
            var commit = _ref9.commit;

            commit('updateAllocatedGroupList', data);
        },
        setRegionId: function setRegionId(_ref10, id) {
            var commit = _ref10.commit;

            commit('updateRegionId', id);
        },
        setAllocatedGroupId: function setAllocatedGroupId(_ref11, id) {
            var commit = _ref11.commit;

            commit("updateAllocatedGroupId", id);
        },
        setCallID: function setCallID(_ref12, id) {
            var commit = _ref12.commit;

            commit("updateCallID", id);
        },
        setSchema: function setSchema(_ref13, schema) {
            var commit = _ref13.commit;

            commit("updateSchema", schema);
        },
        setEmailUser: function setEmailUser(_ref14, email_user) {
            var commit = _ref14.commit;

            commit("updateEmailUser", email_user);
        },
        setEmailUserEmpty: function setEmailUserEmpty(_ref15) {
            var commit = _ref15.commit;

            commit("updateEmailUserEmpty");
        },
        setResidentialAddress: function setResidentialAddress(_ref16, address) {
            var commit = _ref16.commit;

            commit("updateResidentialAddress", address);
        },
        setLocation: function setLocation(_ref17, location) {
            var commit = _ref17.commit;

            commit("updateLocation", location);
        },
        setLocationAddress: function setLocationAddress(_ref18, location_properties) {
            var commit = _ref18.commit;

            commit("updateLocationAddress", location_properties);
        },
        setLocationAddressEmpty: function setLocationAddressEmpty(_ref19) {
            var commit = _ref19.commit;

            commit("updateLocationAddressEmpty");
        },
        setLocationDetailsFieldEmpty: function setLocationDetailsFieldEmpty(_ref20) {
            var commit = _ref20.commit;

            commit("updateLocationDetailsFieldEmpty");
        },
        setLocationPoint: function setLocationPoint(_ref21, point) {
            var commit = _ref21.commit;

            commit("updateLocationPoint", point);
        },
        setClassificationEntry: function setClassificationEntry(_ref22, classification_entry) {
            var commit = _ref22.commit;

            commit("updateClassificationTypes", classification_entry);
        },
        setReferrerEntry: function setReferrerEntry(_ref23, referrer_entry) {
            var commit = _ref23.commit;

            commit("updateReferrers", referrer_entry);
        },
        setReportTypeEntry: function setReportTypeEntry(_ref24, report_type_entry) {
            var commit = _ref24.commit;

            commit("updateReportTypes", report_type_entry);
        },
        setCallEmail: function setCallEmail(_ref25, call_email) {
            var commit = _ref25.commit;

            commit("updateCallEmail", call_email);
        },
        setReportType: function setReportType(_ref26, report_type) {
            var commit = _ref26.commit;

            commit("updateReportType", report_type);
        },
        setClassification: function setClassification(_ref27, classification) {
            var commit = _ref27.commit;

            commit("updateClassification", classification);
        },
        setOccurrenceTimeStart: function setOccurrenceTimeStart(_ref28, time) {
            var commit = _ref28.commit;

            commit("updateOccurrenceTimeStart", time);
        },
        setOccurrenceTimeEnd: function setOccurrenceTimeEnd(_ref29, time) {
            var commit = _ref29.commit;

            commit("updateOccurrenceTimeEnd", time);
        },
        setTimeOfCall: function setTimeOfCall(_ref30, time) {
            var commit = _ref30.commit;

            commit("updateTimeOfCall", time);
        },
        setDateOfCall: function setDateOfCall(_ref31, date) {
            var commit = _ref31.commit;

            commit("updateDateOfCall", date);
        },
        setRelatedItems: function setRelatedItems(_ref32, related_items) {
            var commit = _ref32.commit;

            commit("updateRelatedItems", related_items);
        },
        setCaller: function setCaller(_ref33, data) {
            var commit = _ref33.commit;

            commit("updateCaller", data);
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.documentArtifactStore = undefined;

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var documentArtifactStore = exports.documentArtifactStore = {
    namespaced: true,
    state: {
        document_artifact: {}

    },
    getters: {
        document_artifact: function document_artifact(state) {
            return state.document_artifact;
        }
    },
    mutations: {
        updateDocumentArtifact: function updateDocumentArtifact(state, document_artifact) {
            _vue2.default.set(state, 'document_artifact', (0, _extends3.default)({}, document_artifact));

            if (state.document_artifact.artifact_date) {
                state.document_artifact.artifact_date = (0, _moment2.default)(state.document_artifact.artifact_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }

            if (state.document_artifact.artifact_time) {
                state.document_artifact.artifact_time = (0, _moment2.default)(state.document_artifact.artifact_time, 'HH:mm').format('hh:mm A');
            } else if (state.document_artifact.artifact_time === '') {
                state.document_artifact.artifact_time = null;
            }

            var defaultDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.artifact, state.document_artifact.id + "/process_default_document/");
            _vue2.default.set(state.document_artifact, 'defaultDocumentUrl', defaultDocumentUrl);

            var commsLogsDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.artifact, state.document_artifact.id + "/process_comms_log_document/");
            _vue2.default.set(state.document_artifact, 'commsLogsDocumentUrl', commsLogsDocumentUrl);
        },
        updateRelatedItems: function updateRelatedItems(state, related_items) {
            _vue2.default.set(state.document_artifact, 'related_items', related_items);
        },
        updatePersonProvidingStatementId: function updatePersonProvidingStatementId(state, person_providing_statement_id) {
            _vue2.default.set(state.document_artifact, 'person_providing_statement_id', person_providing_statement_id);
        },
        updateInterviewerEmail: function updateInterviewerEmail(state, email) {
            _vue2.default.set(state.document_artifact, 'interviewer_email', email);
        },
        updateTemporaryDocumentCollectionId: function updateTemporaryDocumentCollectionId(state, temp_doc_id) {
            _vue2.default.set(state.document_artifact, 'temporary_document_collection_id', temp_doc_id);
        },
        updateOffenderId: function updateOffenderId(state, offender_id) {
            _vue2.default.set(state.document_artifact, 'offender_id', offender_id);
        },
        updateOfficerInterviewer: function updateOfficerInterviewer(state, officer_interviewer) {
            console.log(officer_interviewer);
            var officerInterviewerConcise = {};
            officerInterviewerConcise.email = officer_interviewer.email;
            officerInterviewerConcise.given_name = officer_interviewer.given_name;
            officerInterviewerConcise.surname = officer_interviewer.surname;
            _vue2.default.set(state.document_artifact, 'officer_interviewer', officerInterviewerConcise);
        },
        updateOfficerInterviewerId: function updateOfficerInterviewerId(state, officer_interviewer_id) {
            _vue2.default.set(state.document_artifact, 'officer_interviewer_id', officer_interviewer_id);
        },
        updateErrorMessage: function updateErrorMessage(state, errorMessage) {
            _vue2.default.set(state.document_artifact, 'error_message', errorMessage);
        }
    },
    actions: {
        loadDocumentArtifact: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref, _ref2) {
                var dispatch = _ref.dispatch,
                    commit = _ref.commit;
                var document_artifact_id = _ref2.document_artifact_id;
                var returnedDocumentArtifact;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.document_artifact, document_artifact_id));

                            case 3:
                                returnedDocumentArtifact = _context.sent;


                                console.log(returnedDocumentArtifact);
                                commit("updateDocumentArtifact", returnedDocumentArtifact.body);

                                _context.next = 11;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](0);

                                console.log(_context.t0);

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 8]]);
            }));

            function loadDocumentArtifact(_x, _x2) {
                return _ref3.apply(this, arguments);
            }

            return loadDocumentArtifact;
        }(),
        saveDocumentArtifact: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref4, _ref5) {
                var commit = _ref4.commit,
                    dispatch = _ref4.dispatch,
                    state = _ref4.state,
                    rootGetters = _ref4.rootGetters;
                var create = _ref5.create,
                    internal = _ref5.internal,
                    legal_case_id = _ref5.legal_case_id;
                var documentArtifactId, savedDocumentArtifact, payload, fetchUrl, errorMessage;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                commit("updateErrorMessage", "");
                                documentArtifactId = null;
                                savedDocumentArtifact = null;
                                _context2.prev = 3;
                                payload = new Object();

                                (0, _assign2.default)(payload, state.document_artifact);
                                console.log(payload);

                                if (payload.artifact_date) {
                                    payload.artifact_date = (0, _moment2.default)(payload.artifact_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                } else if (payload.artifact_date === '') {
                                    payload.artifact_date = null;
                                }

                                if (payload.artifact_time) {
                                    payload.artifact_time = (0, _moment2.default)(payload.artifact_time, 'hh:mm A').format('HH:mm');
                                } else if (payload.artifact_time === '') {
                                    payload.artifact_time = null;
                                }

                                if (legal_case_id) {
                                    payload.legal_case_id = legal_case_id;
                                }

                                fetchUrl = null;

                                if (!create) {
                                    _context2.next = 18;
                                    break;
                                }

                                fetchUrl = _hooks.api_endpoints.document_artifact;
                                _context2.next = 15;
                                return _vue2.default.http.post(fetchUrl, payload);

                            case 15:
                                savedDocumentArtifact = _context2.sent;
                                _context2.next = 22;
                                break;

                            case 18:
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.document_artifact, state.document_artifact.id + '/');
                                _context2.next = 21;
                                return _vue2.default.http.put(fetchUrl, payload);

                            case 21:
                                savedDocumentArtifact = _context2.sent;

                            case 22:
                                _context2.next = 24;
                                return dispatch("setDocumentArtifact", savedDocumentArtifact.body);

                            case 24:
                                documentArtifactId = savedDocumentArtifact.body.id;

                                _context2.next = 39;
                                break;

                            case 27:
                                _context2.prev = 27;
                                _context2.t0 = _context2['catch'](3);

                                console.log(_context2.t0);

                                if (!internal) {
                                    _context2.next = 34;
                                    break;
                                }

                                return _context2.abrupt('return', _context2.t0);

                            case 34:
                                errorMessage = '';

                                if (_context2.t0.statusText && _context2.t0.data && _context2.t0.data.non_field_errors && _context2.t0.data.non_field_errors.length > 0) {
                                    errorMessage = _context2.t0.data.non_field_errors[0];
                                } else if (_context2.t0.bodyText) {
                                    errorMessage = _context2.t0.bodyText;
                                } else {
                                    errorMessage = "There was an error saving the record";
                                }
                                commit("updateErrorMessage", errorMessage);
                                _context2.next = 39;
                                return swal("Error", errorMessage, "error");

                            case 39:
                                if (!internal) {
                                    _context2.next = 42;
                                    break;
                                }

                                _context2.next = 45;
                                break;

                            case 42:
                                if (!(!create && !state.document_artifact.error_message)) {
                                    _context2.next = 45;
                                    break;
                                }

                                _context2.next = 45;
                                return swal("Saved", "The record has been saved", "success");

                            case 45:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[3, 27]]);
            }));

            function saveDocumentArtifact(_x3, _x4) {
                return _ref6.apply(this, arguments);
            }

            return saveDocumentArtifact;
        }(),
        setDocumentArtifact: function setDocumentArtifact(_ref7, document_artifact) {
            var commit = _ref7.commit;

            commit("updateDocumentArtifact", document_artifact);
        },
        setRelatedItems: function setRelatedItems(_ref8, related_items) {
            var commit = _ref8.commit;

            commit("updateRelatedItems", related_items);
        },
        setPersonProvidingStatementId: function setPersonProvidingStatementId(_ref9, person_providing_statement_id) {
            var commit = _ref9.commit;

            commit("updatePersonProvidingStatementId", person_providing_statement_id);
        },
        setInterviewerEmail: function setInterviewerEmail(_ref10, email) {
            var commit = _ref10.commit;

            commit("updateInterviewerEmail", email);
        },
        setTemporaryDocumentCollectionId: function setTemporaryDocumentCollectionId(_ref11, temp_doc_id) {
            var commit = _ref11.commit;

            commit("updateTemporaryDocumentCollectionId", temp_doc_id);
        },
        setOffenderId: function setOffenderId(_ref12, offender_id) {
            var commit = _ref12.commit;

            commit("updateOffenderId", offender_id);
        },
        setOfficerInterviewer: function setOfficerInterviewer(_ref13, officer_interviewer) {
            var commit = _ref13.commit;

            console.log(officer_interviewer);
            commit("updateOfficerInterviewer", officer_interviewer);
        },
        setOfficerInterviewerId: function setOfficerInterviewerId(_ref14, officer_interviewer_id) {
            var commit = _ref14.commit;

            commit("updateOfficerInterviewerId", officer_interviewer_id);
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.inspectionStore = undefined;

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inspectionStore = exports.inspectionStore = {
    namespaced: true,
    state: {
        inspection: {}

    },
    getters: {
        inspection: function inspection(state) {
            return state.inspection;
        },
        inspection_latitude: function inspection_latitude(state) {
            if (state.inspection.location) {
                if (state.inspection.location.geometry) {
                    if (state.inspection.location.geometry.coordinates.length > 0) {
                        return state.inspection.location.geometry.coordinates[1];
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },
        inspection_longitude: function inspection_longitude(state) {
            if (state.inspection.location) {
                if (state.inspection.location.geometry) {
                    if (state.inspection.location.geometry.coordinates.length > 0) {
                        return state.inspection.location.geometry.coordinates[0];
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }
            } else {
                return "";
            }
        }
    },
    mutations: {
        updateInspection: function updateInspection(state, inspection) {
            _vue2.default.set(state, 'inspection', (0, _extends3.default)({}, inspection));
            console.log('updateInspection');
            if (!inspection.location) {
                _vue2.default.set(state.inspection, 'location', {
                    "type": "Feature",
                    properties: {
                        town_suburb: null,
                        street: null,
                        state: null,
                        postcode: null,
                        country: null
                    },
                    id: null,
                    geometry: {
                        "type": "Point",
                        "coordinates": []
                    }
                });
            }
            if (state.inspection.planned_for_date) {
                state.inspection.planned_for_date = (0, _moment2.default)(state.inspection.planned_for_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }

            if (state.inspection.planned_for_time) {
                state.inspection.planned_for_time = (0, _moment2.default)(state.inspection.planned_for_time, 'HH:mm').format('hh:mm A');
            } else if (state.inspection.planned_for_time === '') {
                state.inspection.planned_for_time = null;
            }

            var inspectionReportDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.inspection, state.inspection.id + "/process_inspection_report_document/");
            _vue2.default.set(state.inspection, 'inspectionReportDocumentUrl', inspectionReportDocumentUrl);
            var rendererDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.inspection, state.inspection.id + "/process_renderer_document/");
            _vue2.default.set(state.inspection, 'rendererDocumentUrl', rendererDocumentUrl);
            var commsLogsDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.inspection, state.inspection.id + "/process_comms_log_document/");
            _vue2.default.set(state.inspection, 'commsLogsDocumentUrl', commsLogsDocumentUrl);
            var createInspectionProcessCommsLogsDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.inspection, state.inspection.id + "/create_inspection_process_comms_log_document/");
            _vue2.default.set(state.inspection, 'createInspectionProcessCommsLogsDocumentUrl', createInspectionProcessCommsLogsDocumentUrl);
        },
        updatePlannedForTime: function updatePlannedForTime(state, time) {
            _vue2.default.set(state.inspection, 'planned_for_time', time);
        },
        updatePartyInspected: function updatePartyInspected(state, data) {
            if (data.data_type === 'individual') {
                _vue2.default.set(state.inspection, 'party_inspected', data.data_type);
                _vue2.default.set(state.inspection, 'individual_inspected_id', data.id);
                if (state.inspection.organisation_inspected_id) {
                    state.inspection.organisation_inspected_id = null;
                }
            }
            if (data.data_type === 'organisation') {
                _vue2.default.set(state.inspection, 'party_inspected', data.data_type);
                _vue2.default.set(state.inspection, 'organisation_inspected_id', data.id);
                if (state.inspection.individual_inspected_id) {
                    state.inspection.individual_inspected_id = null;
                }
            }
        },
        updateRelatedItems: function updateRelatedItems(state, related_items) {
            _vue2.default.set(state.inspection, 'related_items', related_items);
        },
        updateLocationPoint: function updateLocationPoint(state, point) {
            state.inspection.location.geometry.coordinates = point;
        },
        updateLocationAddress: function updateLocationAddress(state, location_properties) {
            state.inspection.location.properties = location_properties;
        },
        updateLocationAddressEmpty: function updateLocationAddressEmpty(state) {
            state.inspection.location.properties.town_suburb = "";
            state.inspection.location.properties.street = "";
            state.inspection.location.properties.state = "";
            state.inspection.location.properties.postcode = "";
            state.inspection.location.properties.country = "";
        },
        updateLocationDetailsFieldEmpty: function updateLocationDetailsFieldEmpty(state) {
            state.inspection.location.properties.details = "";
        }
    },
    actions: {
        loadInspection: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref, _ref2) {
                var dispatch = _ref.dispatch,
                    commit = _ref.commit;
                var inspection_id = _ref2.inspection_id;

                var returnedInspection, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form_data_record;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.inspection, inspection_id));

                            case 3:
                                returnedInspection = _context.sent;
                                _context.next = 6;
                                return dispatch("setInspection", returnedInspection.body);

                            case 6:
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 9;
                                _iterator = (0, _getIterator3.default)(returnedInspection.body.data);

                            case 11:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context.next = 18;
                                    break;
                                }

                                form_data_record = _step.value;
                                _context.next = 15;
                                return dispatch("setFormValue", {
                                    key: form_data_record.field_name,
                                    value: {
                                        "value": form_data_record.value,
                                        "comment_value": form_data_record.comment,
                                        "deficiency_value": form_data_record.deficiency
                                    }
                                }, {
                                    root: true
                                });

                            case 15:
                                _iteratorNormalCompletion = true;
                                _context.next = 11;
                                break;

                            case 18:
                                _context.next = 24;
                                break;

                            case 20:
                                _context.prev = 20;
                                _context.t0 = _context['catch'](9);
                                _didIteratorError = true;
                                _iteratorError = _context.t0;

                            case 24:
                                _context.prev = 24;
                                _context.prev = 25;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 27:
                                _context.prev = 27;

                                if (!_didIteratorError) {
                                    _context.next = 30;
                                    break;
                                }

                                throw _iteratorError;

                            case 30:
                                return _context.finish(27);

                            case 31:
                                return _context.finish(24);

                            case 32:
                                _context.next = 37;
                                break;

                            case 34:
                                _context.prev = 34;
                                _context.t1 = _context['catch'](0);

                                console.log(_context.t1);

                            case 37:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 34], [9, 20, 24, 32], [25,, 27, 31]]);
            }));

            function loadInspection(_x, _x2) {
                return _ref3.apply(this, arguments);
            }

            return loadInspection;
        }(),
        saveInspection: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref4, _ref5) {
                var dispatch = _ref4.dispatch,
                    state = _ref4.state,
                    rootGetters = _ref4.rootGetters;
                var create = _ref5.create,
                    internal = _ref5.internal;
                var inspectionId, savedInspection, error, payload, fetchUrl;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                inspectionId = null;
                                savedInspection = null;
                                error = false;
                                _context2.prev = 3;
                                payload = new Object();

                                (0, _assign2.default)(payload, state.inspection);
                                console.log(payload);
                                if (payload.planned_for_date) {
                                    payload.planned_for_date = (0, _moment2.default)(payload.planned_for_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                } else if (payload.planned_for_date === '') {
                                    payload.planned_for_date = null;
                                }
                                if (payload.planned_for_time) {
                                    payload.planned_for_time = (0, _moment2.default)(payload.planned_for_time, 'hh:mm A').format('HH:mm');
                                } else if (payload.planned_for_time === '') {
                                    payload.planned_for_time = null;
                                }

                                if (state.inspection.schema) {
                                    if (state.inspection.schema.length > 0) {
                                        payload.renderer_data = rootGetters.renderer_form_data;
                                    }
                                }

                                fetchUrl = null;

                                if (!create) {
                                    _context2.next = 18;
                                    break;
                                }

                                fetchUrl = _hooks.api_endpoints.inspection;
                                _context2.next = 15;
                                return _vue2.default.http.post(fetchUrl, payload);

                            case 15:
                                savedInspection = _context2.sent;
                                _context2.next = 22;
                                break;

                            case 18:
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.inspection, state.inspection.id + '/');
                                _context2.next = 21;
                                return _vue2.default.http.put(fetchUrl, payload);

                            case 21:
                                savedInspection = _context2.sent;

                            case 22:
                                _context2.next = 24;
                                return dispatch("setInspection", savedInspection.body);

                            case 24:
                                inspectionId = savedInspection.body.id;

                                _context2.next = 37;
                                break;

                            case 27:
                                _context2.prev = 27;
                                _context2.t0 = _context2['catch'](3);

                                error = true;
                                console.log(_context2.t0);

                                if (!internal) {
                                    _context2.next = 35;
                                    break;
                                }

                                return _context2.abrupt('return', _context2.t0);

                            case 35:
                                _context2.next = 37;
                                return swal("Error", "There was an error saving the record", "error");

                            case 37:
                                _context2.prev = 37;

                                if (!(internal && !error)) {
                                    _context2.next = 42;
                                    break;
                                }

                                console.log("modal file create");
                                _context2.next = 45;
                                break;

                            case 42:
                                if (!(!create && !error)) {
                                    _context2.next = 45;
                                    break;
                                }

                                _context2.next = 45;
                                return swal("Saved", "The record has been saved", "success");

                            case 45:
                                return _context2.abrupt('return', savedInspection);

                            case 47:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[3, 27, 37, 47]]);
            }));

            function saveInspection(_x3, _x4) {
                return _ref6.apply(this, arguments);
            }

            return saveInspection;
        }(),
        setInspection: function setInspection(_ref7, inspection) {
            var commit = _ref7.commit;

            commit("updateInspection", inspection);
        },
        setPlannedForTime: function setPlannedForTime(_ref8, time) {
            var commit = _ref8.commit;

            commit("updatePlannedForTime", time);
        },
        setPartyInspected: function setPartyInspected(_ref9, data) {
            var commit = _ref9.commit;

            commit("updatePartyInspected", data);
        },
        setRelatedItems: function setRelatedItems(_ref10, related_items) {
            var commit = _ref10.commit;

            commit("updateRelatedItems", related_items);
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.legalCaseStore = undefined;

var _create = __webpack_require__(140);

var _create2 = _interopRequireDefault(_create);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var legalCaseStore = exports.legalCaseStore = {
    namespaced: true,
    state: {
        legal_case: {
            running_sheet_entries: []
        }

    },
    getters: {
        legal_case: function legal_case(state) {
            return state.legal_case;
        },
        running_sheet_set: function running_sheet_set(state) {
            return state.legal_case.running_sheet_list.map(function (number) {
                return state.legal_case.running_sheet_entries[number];
            });
        }
    },
    mutations: {
        updateLegalCase: function updateLegalCase(state, legal_case) {
            _vue2.default.set(state, 'legal_case', (0, _extends3.default)({}, legal_case));
            console.log('updateLegalCase');
            if (state.legal_case.case_created_date) {
                state.legal_case.case_created_date = (0, _moment2.default)(state.legal_case.case_created_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }

            var defaultDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, state.legal_case.id + "/process_default_document/");
            _vue2.default.set(state.legal_case, 'defaultDocumentUrl', defaultDocumentUrl);

            var prosecutionNoticeDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, state.legal_case.id + "/process_prosecution_notice_document/");
            _vue2.default.set(state.legal_case, 'prosecutionNoticeDocumentUrl', prosecutionNoticeDocumentUrl);

            var courtHearingNoticeDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, state.legal_case.id + "/process_court_hearing_notice_document/");
            _vue2.default.set(state.legal_case, 'courtHearingNoticeDocumentUrl', courtHearingNoticeDocumentUrl);

            var briefOfEvidenceDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, state.legal_case.id + "/process_brief_of_evidence_document/");
            _vue2.default.set(state.legal_case, 'briefOfEvidenceDocumentUrl', briefOfEvidenceDocumentUrl);

            var prosecutionBriefDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, state.legal_case.id + "/process_prosecution_brief_document/");
            _vue2.default.set(state.legal_case, 'prosecutionBriefDocumentUrl', prosecutionBriefDocumentUrl);

            var commsLogsDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, state.legal_case.id + "/process_comms_log_document/");
            _vue2.default.set(state.legal_case, 'commsLogsDocumentUrl', commsLogsDocumentUrl);

            var createLegalCaseProcessCommsLogsDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, state.legal_case.id + "/create_legal_case_process_comms_log_document/");
            _vue2.default.set(state.legal_case, 'createLegalCaseProcessCommsLogsDocumentUrl', createLegalCaseProcessCommsLogsDocumentUrl);
            var courtOutcomeDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, state.legal_case.id + "/process_court_outcome_document/");
            _vue2.default.set(state.legal_case, 'processCourtOutcomeDocumentUrl', courtOutcomeDocumentUrl);
        },
        updateLegalCaseNoRunningSheet: function updateLegalCaseNoRunningSheet(state, legal_case) {
            _vue2.default.set(state.legal_case, 'related_items', legal_case.related_items);
            _vue2.default.set(state.legal_case, 'statement_artifacts', legal_case.statement_artifacts);
        },
        updateRelatedItems: function updateRelatedItems(state, related_items) {
            _vue2.default.set(state.legal_case, 'related_items', related_items);
        },
        updateRunningSheetEntries: function updateRunningSheetEntries(state, running_sheet_entries) {
            _vue2.default.set(state.legal_case, 'running_sheet_entries', running_sheet_entries);
        },
        updateCourtProceedingsJournalEntry: function updateCourtProceedingsJournalEntry(state, journal_entry) {
            var i = 0;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(state.legal_case.court_proceedings.journal_entries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var r = _step.value;

                    if (r.number === journal_entry.number) {
                        state.legal_case.court_proceedings.journal_entries.splice(i++, 1, journal_entry);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        updateRunningSheetEntry: function updateRunningSheetEntry(state, running_sheet_entry) {
            console.log(running_sheet_entry);
            var i = 0;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(state.legal_case.running_sheet_entries), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var r = _step2.value;

                    if (r.number === running_sheet_entry.number) {
                        state.legal_case.running_sheet_entries.splice(i, 1, running_sheet_entry);
                    }
                    i += 1;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        updateAddRunningSheetEntry: function updateAddRunningSheetEntry(state, running_sheet_entry) {
            state.legal_case.running_sheet_entries.push(running_sheet_entry);
        },
        updateAddCourtProceedingsEntry: function updateAddCourtProceedingsEntry(state, court_proceedings_entry) {
            state.legal_case.court_proceedings.journal_entries.push(court_proceedings_entry);
        },
        updateRunningSheetTransform: function updateRunningSheetTransform(state, running_sheet_transform) {
            _vue2.default.set(state.legal_case, 'running_sheet_transform', running_sheet_transform);
        },
        updateCourtProceedingsTransform: function updateCourtProceedingsTransform(state, journal_entry_transform) {
            if (!state.legal_case.court_proceedings.hasOwnProperty('journal_entries_transform')) {
                state.legal_case.court_proceedings.journal_entries_transform = {};
            }
            state.legal_case.court_proceedings.journal_entries_transform[journal_entry_transform.number] = journal_entry_transform;
        },
        updateCourtProceedingsDate: function updateCourtProceedingsDate(state, date_entry) {
            console.log('*** in updateCourtProceedingsDate() ***');
            console.log(date_entry);
            if (!state.legal_case.court_proceedings.hasOwnProperty('date_entries_updated')) {
                state.legal_case.court_proceedings.date_entries_updated = {};
            }
            state.legal_case.court_proceedings.date_entries_updated[date_entry.id] = date_entry;
        },
        updateBriefOfEvidence: function updateBriefOfEvidence(state, brief_of_evidence) {
            _vue2.default.set(state.legal_case, 'brief_of_evidence', brief_of_evidence);
        },
        updateProsecutionBrief: function updateProsecutionBrief(state, prosecution_brief) {
            _vue2.default.set(state.legal_case, 'prosecution_brief', prosecution_brief);
        },
        updateRunningSheetEntryDescription: function updateRunningSheetEntryDescription(state, _ref) {
            var recordNumber = _ref.recordNumber,
                description = _ref.description,
                userId = _ref.userId;

            console.log(recordNumber);
            console.log(description);
            if (state.legal_case.running_sheet_entries && state.legal_case.running_sheet_entries.length > 0) {
                var i = 0;
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(state.legal_case.running_sheet_entries), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var r = _step3.value;

                        if (r.number === recordNumber) {
                            state.legal_case.running_sheet_entries[i].description = description;
                            state.legal_case.running_sheet_entries[i].user_id = userId;
                        }
                        i += 1;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        },
        updateRunningSheetPersonList: function updateRunningSheetPersonList(state, entity) {
            if (!state.legal_case.running_sheet_person_list) {
                _vue2.default.set(state.legal_case, 'running_sheet_person_list', []);
            }
            state.legal_case.running_sheet_person_list.push(entity);
        },
        updateBoeRoiTicked: function updateBoeRoiTicked(state, boeRoiTicked) {
            _vue2.default.set(state.legal_case, 'boe_roi_ticked', []);
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(boeRoiTicked), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var r = _step4.value;

                    state.legal_case.boe_roi_ticked.push(r);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        },
        updateBoeOtherStatementsTicked: function updateBoeOtherStatementsTicked(state, boeOtherStatementsTicked) {
            _vue2.default.set(state.legal_case, 'boe_other_statements_ticked', []);
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = (0, _getIterator3.default)(boeOtherStatementsTicked), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var r = _step5.value;

                    state.legal_case.boe_other_statements_ticked.push(r);
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        },
        updateBoePhysicalArtifactsTicked: function updateBoePhysicalArtifactsTicked(state, boePhysicalArtifactsTicked) {
            _vue2.default.set(state.legal_case, 'boe_physical_artifacts_ticked', []);
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = (0, _getIterator3.default)(boePhysicalArtifactsTicked), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var r = _step6.value;

                    state.legal_case.boe_physical_artifacts_ticked.push(r);
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }
        },
        updateBoeDocumentArtifactsTicked: function updateBoeDocumentArtifactsTicked(state, boeDocumentArtifactsTicked) {
            _vue2.default.set(state.legal_case, 'boe_document_artifacts_ticked', []);
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = (0, _getIterator3.default)(boeDocumentArtifactsTicked), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var r = _step7.value;

                    state.legal_case.boe_document_artifacts_ticked.push(r);
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }
        },
        updatePbRoiTicked: function updatePbRoiTicked(state, pbRoiTicked) {
            _vue2.default.set(state.legal_case, 'pb_roi_ticked', []);
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = (0, _getIterator3.default)(pbRoiTicked), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var r = _step8.value;

                    state.legal_case.pb_roi_ticked.push(r);
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }
        },
        updatePbOtherStatementsTicked: function updatePbOtherStatementsTicked(state, pbOtherStatementsTicked) {
            _vue2.default.set(state.legal_case, 'pb_other_statements_ticked', []);
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = (0, _getIterator3.default)(pbOtherStatementsTicked), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var r = _step9.value;

                    state.legal_case.pb_other_statements_ticked.push(r);
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }
        },
        updatePbPhysicalArtifactsTicked: function updatePbPhysicalArtifactsTicked(state, pbPhysicalArtifactsTicked) {
            _vue2.default.set(state.legal_case, 'pb_physical_artifacts_ticked', []);
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
                for (var _iterator10 = (0, _getIterator3.default)(pbPhysicalArtifactsTicked), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var r = _step10.value;

                    state.legal_case.pb_physical_artifacts_ticked.push(r);
                }
            } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                        _iterator10.return();
                    }
                } finally {
                    if (_didIteratorError10) {
                        throw _iteratorError10;
                    }
                }
            }
        },
        updatePbDocumentArtifactsTicked: function updatePbDocumentArtifactsTicked(state, pbDocumentArtifactsTicked) {
            _vue2.default.set(state.legal_case, 'pb_document_artifacts_ticked', []);
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
                for (var _iterator11 = (0, _getIterator3.default)(pbDocumentArtifactsTicked), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                    var r = _step11.value;

                    state.legal_case.pb_document_artifacts_ticked.push(r);
                }
            } catch (err) {
                _didIteratorError11 = true;
                _iteratorError11 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                        _iterator11.return();
                    }
                } finally {
                    if (_didIteratorError11) {
                        throw _iteratorError11;
                    }
                }
            }
        }
    },
    actions: {
        loadLegalCase: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref2, _ref3) {
                var dispatch = _ref2.dispatch,
                    commit = _ref2.commit;
                var legal_case_id = _ref3.legal_case_id;
                var returnedLegalCase;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.legal_case, legal_case_id));

                            case 3:
                                returnedLegalCase = _context.sent;

                                console.log('*** in loadLegalCase ***');
                                console.log(returnedLegalCase);
                                commit("updateLegalCase", returnedLegalCase.body);

                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](0);

                                console.log(_context.t0);

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 9]]);
            }));

            function loadLegalCase(_x, _x2) {
                return _ref4.apply(this, arguments);
            }

            return loadLegalCase;
        }(),
        loadLegalCaseNoRunningSheet: function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref5, _ref6) {
                var dispatch = _ref5.dispatch,
                    commit = _ref5.commit;
                var legal_case_id = _ref6.legal_case_id;
                var returnedLegalCase;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.legal_case, legal_case_id + '/no_running_sheet'));

                            case 3:
                                returnedLegalCase = _context2.sent;

                                console.log('*** in loadLegalCase ***');
                                console.log(returnedLegalCase);
                                commit("updateLegalCaseNoRunningSheet", returnedLegalCase.body);

                                _context2.next = 12;
                                break;

                            case 9:
                                _context2.prev = 9;
                                _context2.t0 = _context2['catch'](0);

                                console.log(_context2.t0);

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 9]]);
            }));

            function loadLegalCaseNoRunningSheet(_x3, _x4) {
                return _ref7.apply(this, arguments);
            }

            return loadLegalCaseNoRunningSheet;
        }(),
        saveLegalCase: function () {
            var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref8, _ref9) {
                var dispatch = _ref8.dispatch,
                    state = _ref8.state,
                    rootGetters = _ref8.rootGetters;
                var create = _ref9.create,
                    internal = _ref9.internal,
                    createBriefOfEvidence = _ref9.createBriefOfEvidence,
                    createProsecutionBrief = _ref9.createProsecutionBrief,
                    fullHttpResponse = _ref9.fullHttpResponse;
                var legalCaseId, savedLegalCase, error, payload, temp_journal_entries, temp_court_dates, fetchUrl;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                legalCaseId = null;
                                savedLegalCase = null;
                                error = false;
                                _context3.prev = 3;
                                payload = new Object();

                                (0, _assign2.default)(payload, state.legal_case);
                                delete payload.running_sheet_entries;

                                temp_journal_entries = (0, _create2.default)(state.legal_case.court_proceedings.journal_entries);

                                delete payload.court_proceedings.journal_entries;
                                state.legal_case.court_proceedings.journal_entries = temp_journal_entries;

                                temp_court_dates = (0, _create2.default)(state.legal_case.court_proceedings.court_dates);

                                delete payload.court_proceedings.court_dates;
                                state.legal_case.court_proceedings.court_dates = temp_court_dates;

                                if (payload.case_created_date) {
                                    payload.case_created_date = (0, _moment2.default)(payload.planned_for_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                } else if (payload.case_created_date === '') {
                                    payload.case_created_date = null;
                                }

                                fetchUrl = null;

                                if (!create) {
                                    _context3.next = 22;
                                    break;
                                }

                                fetchUrl = _hooks.api_endpoints.legal_case;
                                _context3.next = 19;
                                return _vue2.default.http.post(fetchUrl, payload);

                            case 19:
                                savedLegalCase = _context3.sent;
                                _context3.next = 30;
                                break;

                            case 22:
                                if (createBriefOfEvidence) {
                                    payload.create_brief_of_evidence = true;
                                }
                                if (createProsecutionBrief) {
                                    payload.create_prosecution_brief = true;
                                }
                                if (fullHttpResponse) {
                                    payload.full_http_response = true;
                                }

                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.legal_case, state.legal_case.id + '/');
                                console.log(payload);
                                _context3.next = 29;
                                return _vue2.default.http.put(fetchUrl, payload);

                            case 29:
                                savedLegalCase = _context3.sent;

                            case 30:
                                if (!(fullHttpResponse && savedLegalCase.ok)) {
                                    _context3.next = 34;
                                    break;
                                }

                                console.log(savedLegalCase);
                                _context3.next = 34;
                                return dispatch("setLegalCase", savedLegalCase.body);

                            case 34:
                                legalCaseId = savedLegalCase.body.id;

                                delete state.legal_case.court_proceedings.date_entries_updated;
                                delete state.legal_case.court_proceedings.journal_entries_transform;

                                _context3.next = 49;
                                break;

                            case 39:
                                _context3.prev = 39;
                                _context3.t0 = _context3['catch'](3);

                                error = true;
                                console.log(_context3.t0);

                                if (!internal) {
                                    _context3.next = 47;
                                    break;
                                }

                                return _context3.abrupt('return', _context3.t0);

                            case 47:
                                _context3.next = 49;
                                return swal("Error", "There was an error saving the record", "error");

                            case 49:
                                _context3.prev = 49;

                                if (!internal) {
                                    _context3.next = 53;
                                    break;
                                }

                                _context3.next = 56;
                                break;

                            case 53:
                                if (!(!create && !internal && !error)) {
                                    _context3.next = 56;
                                    break;
                                }

                                _context3.next = 56;
                                return swal("Saved", "The record has been saved", "success");

                            case 56:
                                return _context3.finish(49);

                            case 57:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[3, 39, 49, 57]]);
            }));

            function saveLegalCase(_x5, _x6) {
                return _ref10.apply(this, arguments);
            }

            return saveLegalCase;
        }(),
        setLegalCase: function setLegalCase(_ref11, legal_case) {
            var commit = _ref11.commit;

            commit("updateLegalCase", legal_case);
        },
        setLegalCaseNoRunningSheet: function setLegalCaseNoRunningSheet(_ref12, legal_case) {
            var commit = _ref12.commit;

            commit("updateLegalCaseNoRunningSheet", legal_case);
        },
        setRelatedItems: function setRelatedItems(_ref13, related_items) {
            var commit = _ref13.commit;

            commit("updateRelatedItems", related_items);
        },
        setRunningSheetEntries: function setRunningSheetEntries(_ref14, running_sheet_entries) {
            var commit = _ref14.commit;

            commit("updateRunningSheetEntries", running_sheet_entries);
        },
        setRunningSheetEntry: function setRunningSheetEntry(_ref15, running_sheet_entry) {
            var commit = _ref15.commit;

            commit("updateRunningSheetEntry", running_sheet_entry);
        },
        setCourtProceedingsJournalEntry: function setCourtProceedingsJournalEntry(_ref16, journal_entry) {
            var commit = _ref16.commit;

            commit("updateCourtProceedingsJournalEntry", journal_entry);
        },
        setAddRunningSheetEntry: function setAddRunningSheetEntry(_ref17, running_sheet_entry) {
            var commit = _ref17.commit;

            commit("updateAddRunningSheetEntry", running_sheet_entry);
        },
        setAddCourtProceedingsEntry: function setAddCourtProceedingsEntry(_ref18, court_proceedings_entry) {
            var commit = _ref18.commit;

            commit("updateAddCourtProceedingsEntry", court_proceedings_entry);
        },
        setRunningSheetTransform: function setRunningSheetTransform(_ref19, running_sheet_transform) {
            var commit = _ref19.commit;

            commit("updateRunningSheetTransform", running_sheet_transform);
        },
        setCourtProceedingsTransform: function setCourtProceedingsTransform(_ref20, journal_entry_transform) {
            var commit = _ref20.commit;

            commit("updateCourtProceedingsTransform", journal_entry_transform);
        },
        setCourtProceedingsDate: function setCourtProceedingsDate(_ref21, date_entry) {
            var commit = _ref21.commit;

            console.log('*** in setCourtProceedingsDate() ***');
            commit("updateCourtProceedingsDate", date_entry);
        },
        setBriefOfEvidence: function setBriefOfEvidence(_ref22, brief_of_evidence) {
            var commit = _ref22.commit;

            commit("updateBriefOfEvidence", brief_of_evidence);
        },
        setProsecutionBrief: function setProsecutionBrief(_ref23, prosecution_brief) {
            var commit = _ref23.commit;

            commit("updateProsecutionBrief", prosecution_brief);
        },
        setRunningSheetEntryDescription: function setRunningSheetEntryDescription(_ref24, _ref25) {
            var commit = _ref24.commit;
            var recordNumber = _ref25.recordNumber,
                description = _ref25.description,
                userId = _ref25.userId;

            commit("updateRunningSheetEntryDescription", { recordNumber: recordNumber, description: description, userId: userId });
        },
        addToRunningSheetPersonList: function addToRunningSheetPersonList(_ref26, entity) {
            var commit = _ref26.commit;

            commit("updateRunningSheetPersonList", entity);
        },
        setBoeRoiTicked: function setBoeRoiTicked(_ref27, boeRoiTicked) {
            var commit = _ref27.commit;

            commit("updateBoeRoiTicked", boeRoiTicked);
        },
        setBoeOtherStatementsTicked: function setBoeOtherStatementsTicked(_ref28, boeOtherStatementsTicked) {
            var commit = _ref28.commit;

            commit("updateBoeOtherStatementsTicked", boeOtherStatementsTicked);
        },
        setBoePhysicalArtifactsTicked: function setBoePhysicalArtifactsTicked(_ref29, boePhysicalArtifactsTicked) {
            var commit = _ref29.commit;

            commit("updateBoePhysicalArtifactsTicked", boePhysicalArtifactsTicked);
        },
        setBoeDocumentArtifactsTicked: function setBoeDocumentArtifactsTicked(_ref30, boeDocumentArtifactsTicked) {
            var commit = _ref30.commit;

            commit("updateBoeDocumentArtifactsTicked", boeDocumentArtifactsTicked);
        },
        setPbRoiTicked: function setPbRoiTicked(_ref31, pbRoiTicked) {
            var commit = _ref31.commit;

            commit("updatePbRoiTicked", pbRoiTicked);
        },
        setPbOtherStatementsTicked: function setPbOtherStatementsTicked(_ref32, pbOtherStatementsTicked) {
            var commit = _ref32.commit;

            commit("updatePbOtherStatementsTicked", pbOtherStatementsTicked);
        },
        setPbPhysicalArtifactsTicked: function setPbPhysicalArtifactsTicked(_ref33, pbPhysicalArtifactsTicked) {
            var commit = _ref33.commit;

            commit("updatePbPhysicalArtifactsTicked", pbPhysicalArtifactsTicked);
        },
        setPbDocumentArtifactsTicked: function setPbDocumentArtifactsTicked(_ref34, pbDocumentArtifactsTicked) {
            var commit = _ref34.commit;

            commit("updatePbDocumentArtifactsTicked", pbDocumentArtifactsTicked);
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.offenceStore = undefined;

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var offenceStore = exports.offenceStore = {
    namespaced: true,
    state: {
        offence: {}
    },
    getters: {
        offence: function offence(state) {
            return state.offence;
        },
        offence_latitude: function offence_latitude(state) {
            if (state.offence.location) {
                if (state.offence.location.geometry) {
                    if (state.offence.location.geometry.coordinates.length > 0) {
                        return state.offence.location.geometry.coordinates[1];
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },
        offence_longitude: function offence_longitude(state) {
            if (state.offence.location) {
                if (state.offence.location.geometry) {
                    if (state.offence.location.geometry.coordinates.length > 0) {
                        return state.offence.location.geometry.coordinates[0];
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }
            } else {
                return "";
            }
        }
    },
    mutations: {
        updateAllegedOffenceIds: function updateAllegedOffenceIds(state, ids) {
            _vue2.default.set(state.offence, 'alleged_offences', ids);
        },
        updateOffenders: function updateOffenders(state, offenders) {
            _vue2.default.set(state.offence, 'offenders', offenders);
        },
        updateTemporaryDocumentCollectionId: function updateTemporaryDocumentCollectionId(state, id) {
            state.offence.temporary_document_collection_id = id;
        },
        updateCallEmailId: function updateCallEmailId(state, id) {
            state.offence.call_email_id = id;
        },
        updateLegalCaseId: function updateLegalCaseId(state, id) {
            state.offence.legal_case_id = id;
        },
        updateRegionId: function updateRegionId(state, id) {
            state.offence.region_id = id;
        },
        updateDistrictId: function updateDistrictId(state, id) {
            state.offence.district_id = id;
        },
        updateAllocatedGroupId: function updateAllocatedGroupId(state, id) {
            state.offence.allocated_group_id = id;
        },
        updateInspectionId: function updateInspectionId(state, id) {
            state.offence.inspection_id = id;
        },
        updateOffence: function updateOffence(state, offence) {
            if (!offence.location) {
                offence.location = {
                    "type": "Feature",
                    properties: {
                        town_suburb: null,
                        street: null,
                        state: null,
                        postcode: null,
                        country: null
                    },
                    id: null,
                    geometry: {
                        "type": "Point",
                        "coordinates": []
                    }
                };
            }
            if (offence.occurrence_date_from) {
                offence.occurrence_date_from = (0, _moment2.default)(offence.occurrence_date_from, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
            if (offence.occurrence_date_to) {
                offence.occurrence_date_to = (0, _moment2.default)(offence.occurrence_date_to, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
            if (offence.occurrence_time_from) {
                offence.occurrence_time_from = (0, _moment2.default)(offence.occurrence_time_from, 'HH:mm:ss').format('LT');
            }
            if (offence.occurrence_time_to) {
                offence.occurrence_time_to = (0, _moment2.default)(offence.occurrence_time_to, 'HH:mm:ss').format('LT');
            }
            _vue2.default.set(state, 'offence', offence);
        },
        updateOffenceEmpty: function updateOffenceEmpty(state) {
            var offence = {
                id: null,
                call_email_id: null,
                inspection_id: null,
                identifier: '',
                status: 'draft',
                offenders: [],
                alleged_offences: [],
                location: {
                    type: 'Feature',
                    properties: {
                        town_suburb: null,
                        street: null,
                        state: 'WA',
                        postcode: null,
                        country: 'Australia',
                        details: ''
                    },
                    geometry: {
                        'type': 'Point',
                        'coordinates': []
                    }
                },
                occurrence_from_to: true,
                occurrence_date_from: null,
                occurrence_date_to: null,
                occurrence_time_from: null,
                occurrence_time_to: null,
                details: '',
                region_id: null,
                district_id: null,
                assigned_to_id: null,
                allocated_group: [],
                allocated_group_id: null,
                lodgement_number: ''
            };
            _vue2.default.set(state, 'offence', offence);
        },
        updateLocationPoint: function updateLocationPoint(state, point) {
            state.offence.location.geometry.coordinates = point;
        },
        updateLocationAddress: function updateLocationAddress(state, location_properties) {
            state.offence.location.properties = location_properties;
        },
        updateLocationAddressEmpty: function updateLocationAddressEmpty(state) {
            state.offence.location.properties.town_suburb = "";
            state.offence.location.properties.street = "";
            state.offence.location.properties.state = "";
            state.offence.location.properties.postcode = "";
            state.offence.location.properties.country = "";
        },
        updateLocationDetailsFieldEmpty: function updateLocationDetailsFieldEmpty(state) {
            state.offence.location.properties.details = "";
        },
        updateAssignedToId: function updateAssignedToId(state, assigned_to_id) {
            _vue2.default.set(state.offence, 'assigned_to_id', assigned_to_id);
        },
        updateCanUserAction: function updateCanUserAction(state, can_user_action) {
            _vue2.default.set(state.offence, 'can_user_action', can_user_action);
        },
        updateRelatedItems: function updateRelatedItems(state, related_items) {
            _vue2.default.set(state.offence, 'related_items', related_items);
        }
    },
    actions: {
        loadOffence: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref, _ref2) {
                var dispatch = _ref.dispatch;
                var offence_id = _ref2.offence_id;
                var returnedOffence;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log('*** loadOffende ***');
                                _context.prev = 1;

                                if (!offence_id) {
                                    _context.next = 12;
                                    break;
                                }

                                _context.next = 5;
                                return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.offence, offence_id));

                            case 5:
                                returnedOffence = _context.sent;

                                console.log('*** returnedOffence.body ***');
                                console.log('returnedOffence.body');
                                _context.next = 10;
                                return dispatch("setOffence", returnedOffence.body);

                            case 10:
                                _context.next = 13;
                                break;

                            case 12:
                                dispatch("setOffenceEmpty");

                            case 13:
                                _context.next = 18;
                                break;

                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context['catch'](1);

                                console.log(_context.t0);

                            case 18:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 15]]);
            }));

            function loadOffence(_x, _x2) {
                return _ref3.apply(this, arguments);
            }

            return loadOffence;
        }(),
        saveOffence: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref4, params) {
                var dispatch = _ref4.dispatch,
                    state = _ref4.state,
                    commit = _ref4.commit;
                var fetchUrl, payload, occurrence_datetime_from, occurrence_datetime_to, savedOffence;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                console.log('params');
                                console.log(params);
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.offence, state.offence.id + '/');
                                payload = new Object();

                                (0, _assign2.default)(payload, state.offence);

                                if (!(params.fr_date && params.fr_time)) {
                                    _context2.next = 10;
                                    break;
                                }

                                occurrence_datetime_from = (0, _moment2.default)(params.fr_date + ' ' + params.fr_time, 'DD/MM/YYYY LT');

                                payload.occurrence_datetime_from = occurrence_datetime_from.toDate().toISOString();
                                _context2.next = 11;
                                break;

                            case 10:
                                throw new Error('Occurrence date-from and time-from cannot be empty');

                            case 11:
                                if (!payload.occurrence_from_to) {
                                    _context2.next = 18;
                                    break;
                                }

                                if (!(params.to_date && params.to_time)) {
                                    _context2.next = 17;
                                    break;
                                }

                                occurrence_datetime_to = (0, _moment2.default)(params.to_date + ' ' + params.to_time, 'DD/MM/YYYY LT');

                                payload.occurrence_datetime_to = occurrence_datetime_to.toDate().toISOString();
                                _context2.next = 18;
                                break;

                            case 17:
                                throw new Error('Occurrence date-to and time-to cannot be empty');

                            case 18:

                                console.log('payload offence');
                                console.log(payload);

                                payload.status = 'open';

                                _context2.next = 23;
                                return _vue2.default.http.put(fetchUrl, payload);

                            case 23:
                                savedOffence = _context2.sent;

                                commit("updateOffence", savedOffence.body);

                                return _context2.abrupt('return', savedOffence);

                            case 26:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function saveOffence(_x3, _x4) {
                return _ref5.apply(this, arguments);
            }

            return saveOffence;
        }(),
        createOffence: function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref6) {
                var dispatch = _ref6.dispatch,
                    state = _ref6.state;
                var fetchUrl, payload, occurrence_datetime_from, occurrence_datetime_to, savedOffence;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                console.log('createOffence');
                                fetchUrl = '/api/offence/';


                                console.log('this: ');
                                console.log(this);

                                payload = new Object();

                                (0, _assign2.default)(payload, state.offence);

                                if (!(payload.occurrence_date_from && payload.occurrence_time_from)) {
                                    _context3.next = 11;
                                    break;
                                }

                                occurrence_datetime_from = (0, _moment2.default)(payload.occurrence_date_from + ' ' + payload.occurrence_time_from, 'DD/MM/YYYY LT');

                                payload.occurrence_datetime_from = occurrence_datetime_from.toDate().toISOString();
                                _context3.next = 12;
                                break;

                            case 11:
                                throw new Error('Occurrence date-from and time-from cannot be empty');

                            case 12:
                                if (!payload.occurrence_from_to) {
                                    _context3.next = 19;
                                    break;
                                }

                                if (!(payload.occurrence_date_to && payload.occurrence_time_to)) {
                                    _context3.next = 18;
                                    break;
                                }

                                occurrence_datetime_to = (0, _moment2.default)(payload.occurrence_date_to + ' ' + payload.occurrence_time_to, 'DD/MM/YYYY LT');

                                payload.occurrence_datetime_to = occurrence_datetime_to.toDate().toISOString();
                                _context3.next = 19;
                                break;

                            case 18:
                                throw new Error('Occurrence date-to and time-to cannot be empty');

                            case 19:

                                console.log('payload');
                                console.log(payload);

                                _context3.next = 23;
                                return _vue2.default.http.post(fetchUrl, payload);

                            case 23:
                                savedOffence = _context3.sent;
                                _context3.next = 26;
                                return dispatch("setOffence", savedOffence.body);

                            case 26:
                                return _context3.abrupt('return', savedOffence);

                            case 27:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function createOffence(_x5) {
                return _ref7.apply(this, arguments);
            }

            return createOffence;
        }(),
        setOffence: function setOffence(_ref8, offence) {
            var commit = _ref8.commit;

            commit("updateOffence", offence);
        },
        setOffenceEmpty: function setOffenceEmpty(_ref9) {
            var commit = _ref9.commit;

            commit("updateOffenceEmpty");
        },
        setLocationPoint: function setLocationPoint(_ref10, point) {
            var commit = _ref10.commit;

            commit("updateLocationPoint", point);
        },
        setLocationAddress: function setLocationAddress(_ref11, location_properties) {
            var commit = _ref11.commit;

            commit("updateLocationAddress", location_properties);
        },
        setLocationAddressEmpty: function setLocationAddressEmpty(_ref12) {
            var commit = _ref12.commit;

            commit("updateLocationAddressEmpty");
        },
        setLocationDetailsFieldEmpty: function setLocationDetailsFieldEmpty(_ref13) {
            var commit = _ref13.commit;

            commit("updateLocationDetailsFieldEmpty");
        },
        setAllegedOffenceIds: function setAllegedOffenceIds(_ref14, ids) {
            var commit = _ref14.commit;

            commit("updateAllegedOffenceIds", ids);
        },
        setOffenders: function setOffenders(_ref15, offenders) {
            var commit = _ref15.commit;

            commit("updateOffenders", offenders);
        },
        setCallEmailId: function setCallEmailId(_ref16, id) {
            var commit = _ref16.commit;

            commit("updateCallEmailId", id);
        },
        setTempDocumentCollectionId: function setTempDocumentCollectionId(_ref17, id) {
            var commit = _ref17.commit;

            commit("updateTemporaryDocumentCollectionId", id);
        },
        setLegalCaseId: function setLegalCaseId(_ref18, id) {
            var commit = _ref18.commit;

            commit("updateLegalCaseId", id);
        },
        setRegionId: function setRegionId(_ref19, id) {
            var commit = _ref19.commit;

            commit("updateRegionId", id);
        },
        setDistrictId: function setDistrictId(_ref20, id) {
            var commit = _ref20.commit;

            commit("updateDistrictId", id);
        },
        setAllocatedGroupId: function setAllocatedGroupId(_ref21, id) {
            var commit = _ref21.commit;

            commit("updateAllocatedGroupId", id);
        },
        setInspectionId: function setInspectionId(_ref22, id) {
            var commit = _ref22.commit;

            commit("updateInspectionId", id);
        },
        setAssignedToId: function setAssignedToId(_ref23, assigned_to_id) {
            var commit = _ref23.commit;

            commit("updateAssignedToId", assigned_to_id);
        },
        setCanUserAction: function setCanUserAction(_ref24, can_user_action) {
            var commit = _ref24.commit;

            commit("updateCanUserAction", can_user_action);
        },
        setRelatedItems: function setRelatedItems(_ref25, related_items) {
            var commit = _ref25.commit;

            commit("updateRelatedItems", related_items);
        }
    }
};

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(swal) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.physicalArtifactStore = undefined;

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var physicalArtifactStore = exports.physicalArtifactStore = {
    namespaced: true,
    state: {
        physical_artifact: {}

    },
    getters: {
        physical_artifact: function physical_artifact(state) {
            return state.physical_artifact;
        }
    },
    mutations: {
        updatePhysicalArtifact: function updatePhysicalArtifact(state, physical_artifact) {
            _vue2.default.set(state, 'physical_artifact', (0, _extends3.default)({}, physical_artifact));
            console.log('updatePhysicalArtifact');

            if (state.physical_artifact.artifact_date) {
                state.physical_artifact.artifact_date = (0, _moment2.default)(state.physical_artifact.artifact_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }

            if (state.physical_artifact.artifact_time) {
                state.physical_artifact.artifact_time = (0, _moment2.default)(state.physical_artifact.artifact_time, 'HH:mm').format('hh:mm A');
            } else if (state.physical_artifact.artifact_time === '') {
                state.physical_artifact.artifact_time = null;
            }

            if (state.physical_artifact.disposal_date) {
                state.physical_artifact.disposal_date = (0, _moment2.default)(state.physical_artifact.disposal_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }

            var defaultDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.artifact, state.physical_artifact.id + "/process_default_document/");
            _vue2.default.set(state.physical_artifact, 'defaultDocumentUrl', defaultDocumentUrl);

            var commsLogsDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.artifact, state.physical_artifact.id + "/process_comms_log_document/");
            _vue2.default.set(state.physical_artifact, 'commsLogsDocumentUrl', commsLogsDocumentUrl);

            var rendererDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.physical_artifact, state.physical_artifact.id + "/process_renderer_document/");
            _vue2.default.set(state.physical_artifact, 'rendererDocumentUrl', rendererDocumentUrl);
        },
        updateRelatedItems: function updateRelatedItems(state, related_items) {
            _vue2.default.set(state.physical_artifact, 'related_items', related_items);
        },
        updateOfficerId: function updateOfficerId(state, id) {
            _vue2.default.set(state.physical_artifact, 'officer_id', id);
        },
        updateCustodianId: function updateCustodianId(state, id) {
            _vue2.default.set(state.physical_artifact, 'custodian_id', id);
        },
        updateTemporaryDocumentCollectionList: function updateTemporaryDocumentCollectionList(state, _ref) {
            var temp_doc_id = _ref.temp_doc_id,
                input_name = _ref.input_name;

            if (!state.physical_artifact.temporary_document_collection_list) {
                _vue2.default.set(state.physical_artifact, 'temporary_document_collection_list', []);
            }
            state.physical_artifact.temporary_document_collection_list.push({ "temp_doc_id": temp_doc_id,
                "input_name": input_name
            });
        },
        updateStatementId: function updateStatementId(state, statement_id) {
            console.log(statement_id);
            _vue2.default.set(state.physical_artifact, 'statement_id', statement_id);
        },
        updateUsedWithinCase: function updateUsedWithinCase(state, used_within_case) {
            _vue2.default.set(state.physical_artifact, 'used_within_case', used_within_case);
        },
        updateSensitiveNonDisclosable: function updateSensitiveNonDisclosable(state, sensitive_non_disclosable) {
            _vue2.default.set(state.physical_artifact, 'sensitive_non_disclosable', sensitive_non_disclosable);
        }
    },
    actions: {
        loadPhysicalArtifact: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref2, _ref3) {
                var dispatch = _ref2.dispatch,
                    commit = _ref2.commit;
                var physical_artifact_id = _ref3.physical_artifact_id;

                var returnedPhysicalArtifact, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form_data_record;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.physical_artifact, physical_artifact_id));

                            case 3:
                                returnedPhysicalArtifact = _context.sent;


                                console.log(returnedPhysicalArtifact);
                                commit("updatePhysicalArtifact", returnedPhysicalArtifact.body);

                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 9;
                                _iterator = (0, _getIterator3.default)(returnedPhysicalArtifact.body.data);

                            case 11:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context.next = 18;
                                    break;
                                }

                                form_data_record = _step.value;
                                _context.next = 15;
                                return dispatch("setFormValue", {
                                    key: form_data_record.field_name,
                                    value: {
                                        "value": form_data_record.value,
                                        "comment_value": form_data_record.comment,
                                        "deficiency_value": form_data_record.deficiency
                                    }
                                }, {
                                    root: true
                                });

                            case 15:
                                _iteratorNormalCompletion = true;
                                _context.next = 11;
                                break;

                            case 18:
                                _context.next = 24;
                                break;

                            case 20:
                                _context.prev = 20;
                                _context.t0 = _context['catch'](9);
                                _didIteratorError = true;
                                _iteratorError = _context.t0;

                            case 24:
                                _context.prev = 24;
                                _context.prev = 25;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 27:
                                _context.prev = 27;

                                if (!_didIteratorError) {
                                    _context.next = 30;
                                    break;
                                }

                                throw _iteratorError;

                            case 30:
                                return _context.finish(27);

                            case 31:
                                return _context.finish(24);

                            case 32:
                                _context.next = 37;
                                break;

                            case 34:
                                _context.prev = 34;
                                _context.t1 = _context['catch'](0);

                                console.log(_context.t1);

                            case 37:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 34], [9, 20, 24, 32], [25,, 27, 31]]);
            }));

            function loadPhysicalArtifact(_x, _x2) {
                return _ref4.apply(this, arguments);
            }

            return loadPhysicalArtifact;
        }(),
        savePhysicalArtifact: function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref5, _ref6) {
                var dispatch = _ref5.dispatch,
                    state = _ref5.state,
                    rootGetters = _ref5.rootGetters;
                var create = _ref6.create,
                    internal = _ref6.internal,
                    legal_case_id = _ref6.legal_case_id;
                var physicalArtifactId, savedPhysicalArtifact, payload, fetchUrl;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                physicalArtifactId = null;
                                savedPhysicalArtifact = null;
                                _context2.prev = 2;
                                payload = new Object();

                                (0, _assign2.default)(payload, state.physical_artifact);
                                console.log(payload);

                                if (payload.artifact_date) {
                                    payload.artifact_date = (0, _moment2.default)(payload.artifact_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                } else if (payload.artifact_date === '') {
                                    payload.artifact_date = null;
                                }

                                if (payload.artifact_time) {
                                    payload.artifact_time = (0, _moment2.default)(payload.artifact_time, 'hh:mm A').format('HH:mm');
                                } else if (payload.artifact_time === '') {
                                    payload.artifact_time = null;
                                }

                                if (payload.disposal_date) {
                                    payload.disposal_date = (0, _moment2.default)(payload.disposal_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                } else if (payload.disposal_date === '') {
                                    payload.disposal_date = null;
                                }
                                if (legal_case_id) {
                                    payload.legal_case_id = legal_case_id;
                                }

                                payload.renderer_data = rootGetters.renderer_form_data;
                                console.log(payload);

                                fetchUrl = null;

                                if (!create) {
                                    _context2.next = 20;
                                    break;
                                }

                                fetchUrl = _hooks.api_endpoints.physical_artifact;
                                _context2.next = 17;
                                return _vue2.default.http.post(fetchUrl, payload);

                            case 17:
                                savedPhysicalArtifact = _context2.sent;
                                _context2.next = 25;
                                break;

                            case 20:
                                fetchUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.physical_artifact, state.physical_artifact.id + '/');
                                console.log(payload);
                                _context2.next = 24;
                                return _vue2.default.http.put(fetchUrl, payload);

                            case 24:
                                savedPhysicalArtifact = _context2.sent;

                            case 25:
                                _context2.next = 27;
                                return dispatch("setPhysicalArtifact", savedPhysicalArtifact.body);

                            case 27:
                                physicalArtifactId = savedPhysicalArtifact.body.id;

                                _context2.next = 39;
                                break;

                            case 30:
                                _context2.prev = 30;
                                _context2.t0 = _context2['catch'](2);

                                console.log(_context2.t0);

                                if (!internal) {
                                    _context2.next = 37;
                                    break;
                                }

                                return _context2.abrupt('return', _context2.t0);

                            case 37:
                                _context2.next = 39;
                                return swal("Error", "There was an error saving the record", "error");

                            case 39:
                                if (!internal) {
                                    _context2.next = 42;
                                    break;
                                }

                                _context2.next = 45;
                                break;

                            case 42:
                                if (create) {
                                    _context2.next = 45;
                                    break;
                                }

                                _context2.next = 45;
                                return swal("Saved", "The record has been saved", "success");

                            case 45:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[2, 30]]);
            }));

            function savePhysicalArtifact(_x3, _x4) {
                return _ref7.apply(this, arguments);
            }

            return savePhysicalArtifact;
        }(),
        setPhysicalArtifact: function setPhysicalArtifact(_ref8, physical_artifact) {
            var commit = _ref8.commit;

            commit("updatePhysicalArtifact", physical_artifact);
        },
        setRelatedItems: function setRelatedItems(_ref9, related_items) {
            var commit = _ref9.commit;

            commit("updateRelatedItems", related_items);
        },
        setOfficerId: function setOfficerId(_ref10, id) {
            var commit = _ref10.commit;

            commit("updateOfficerId", id);
        },
        setCustodianId: function setCustodianId(_ref11, id) {
            var commit = _ref11.commit;

            commit("updateCustodianId", id);
        },
        addToTemporaryDocumentCollectionList: function addToTemporaryDocumentCollectionList(_ref12, _ref13) {
            var commit = _ref12.commit;
            var temp_doc_id = _ref13.temp_doc_id,
                input_name = _ref13.input_name;

            commit("updateTemporaryDocumentCollectionList", { temp_doc_id: temp_doc_id, input_name: input_name });
        },
        setStatementId: function setStatementId(_ref14, statement_id) {
            var commit = _ref14.commit;

            commit("updateStatementId", statement_id);
        },
        setUsedWithinCase: function setUsedWithinCase(_ref15, used_within_case) {
            var commit = _ref15.commit;

            commit("updateUsedWithinCase", used_within_case);
        },
        setSensitiveNonDisclosable: function setSensitiveNonDisclosable(_ref16, sensitive_non_disclosable) {
            var commit = _ref16.commit;

            commit("updateSensitiveNonDisclosable", sensitive_non_disclosable);
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.remediationActionStore = undefined;

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var remediationActionStore = exports.remediationActionStore = {
    namespaced: true,
    state: {
        remediation_action: {}
    },
    getters: {
        remediation_action: function remediation_action(state) {
            return state.remediation_action;
        }
    },
    mutations: {
        updateRemediationAction: function updateRemediationAction(state, remediation_action) {
            console.log('updateRemediationAction');
            _vue2.default.set(state, 'remediation_action', (0, _extends3.default)({}, remediation_action));
            if (state.remediation_action.due_date) {
                state.remediation_action.due_date = moment(state.remediation_action.due_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }

            var remediationActionDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.remediation_action, state.remediation_action.id + "/process_default_document/");
            console.log(remediationActionDocumentUrl);
            _vue2.default.set(state.remediation_action, 'remediationActionDocumentUrl', remediationActionDocumentUrl);

            var commsLogsDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.remediation_action, state.remediation_action.id + "/process_comms_log_document/");
            _vue2.default.set(state.remediation_action, 'commsLogsDocumentUrl', commsLogsDocumentUrl);
        },
        updateCanUserAction: function updateCanUserAction(state, can_user_action) {
            _vue2.default.set(state.remediation_action, 'can_user_action', can_user_action);
        }
    },
    actions: {
        loadRemediationAction: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref, _ref2) {
                var dispatch = _ref.dispatch;
                var remediation_action_id = _ref2.remediation_action_id;
                var returnedRemediationAction;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.remediation_action, remediation_action_id));

                            case 2:
                                returnedRemediationAction = _context.sent;
                                _context.next = 5;
                                return dispatch("setRemediationAction", returnedRemediationAction.body);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function loadRemediationAction(_x, _x2) {
                return _ref3.apply(this, arguments);
            }

            return loadRemediationAction;
        }(),
        saveRemediationAction: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref4) {
                var dispatch = _ref4.dispatch,
                    state = _ref4.state;
                var putUrl, payload, savedRemediationAction;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                putUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.remediation_action, state.remediation_action.id + '/');
                                payload = {};

                                (0, _assign2.default)(payload, state.remediation_action);

                                _context2.next = 5;
                                return _vue2.default.http.put(putUrl, payload);

                            case 5:
                                savedRemediationAction = _context2.sent;

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function saveRemediationAction(_x3) {
                return _ref5.apply(this, arguments);
            }

            return saveRemediationAction;
        }(),
        submitRemediationAction: function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref6) {
                var dispatch = _ref6.dispatch,
                    state = _ref6.state;
                var submitUrl, payload, ret;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                submitUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.remediation_action, state.remediation_action.id + '/submit/');
                                payload = {};

                                (0, _assign2.default)(payload, state.remediation_action);

                                _context3.next = 5;
                                return _vue2.default.http.post(submitUrl, payload);

                            case 5:
                                ret = _context3.sent;
                                return _context3.abrupt('return', ret.body);

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function submitRemediationAction(_x4) {
                return _ref7.apply(this, arguments);
            }

            return submitRemediationAction;
        }(),
        setRemediationAction: function setRemediationAction(_ref8, remediation_action) {
            var commit = _ref8.commit;

            commit("updateRemediationAction", remediation_action);
        },
        setCanUserAction: function setCanUserAction(_ref9, can_user_action) {
            var commit = _ref9.commit;

            commit("updateCanUserAction", can_user_action);
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rendererStore = undefined;

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _mutations;

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _mutationTypes = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rendererStore = exports.rendererStore = {
    state: {
        tabs: [],
        sections: {},
        visible_components: [],
        visibility: {
            'exclude_decisions': ['issued', 'declined', 'issue_refund'],
            'exclude_processing_status': ['None']
        },
        form_data: {}
    },
    getters: {
        renderer_tabs: function renderer_tabs(state) {
            return state.tabs;
        },
        renderer_form_data: function renderer_form_data(state) {
            return state.form_data;
        },
        visibleActivities: function visibleActivities(state, getters, rootState, rootGetters) {
            return function (hide_decisions, hide_processing_statuses, for_user_role) {
                return rootGetters.application.schema.filter(function (activity) {
                    return getters.isActivityVisible(activity.id, hide_decisions, hide_processing_statuses, for_user_role);
                });
            };
        },
        isActivityVisible: function isActivityVisible(state, getters, rootState, rootGetters) {
            return function (activity_id, hide_decisions, hide_processing_statuses, for_user_role) {
                return rootGetters.isApplicationActivityVisible({
                    activity_id: activity_id,
                    exclude_statuses: hide_decisions,
                    exclude_processing_statuses: hide_processing_statuses,
                    for_user_role: for_user_role
                });
            };
        },
        unfinishedActivities: function unfinishedActivities(state, getters, rootState, rootGetters) {
            return getters.visibleActivities(state.visibility.exclude_decisions, state.visibility.exclude_processing_status).filter(function (activity) {
                return !rootGetters.application.has_amendment || rootGetters.application.amendment_requests.find(function (request) {
                    return request.licence_activity.id == activity.id;
                });
            });
        },
        allCurrentActivities: function allCurrentActivities(state, getters, rootState, rootGetters) {
            return getters.visibleActivities([], state.visibility.exclude_processing_status);
        },
        isComponentVisible: function isComponentVisible(state) {
            return function (key) {
                return state.visible_components[key] ? true : false;
            };
        },
        sectionsForTab: function sectionsForTab(state) {
            return function (tab_id) {
                return state.sections[tab_id] ? state.sections[tab_id] : [];
            };
        },
        getFormValue: function getFormValue(state) {
            return function (component_name) {
                return state.form_data[component_name] ? state.form_data[component_name].value : null;
            };
        },
        isComponentEditableForOfficer: function isComponentEditableForOfficer(state, getters, rootState, rootGetters) {
            var activity = rootGetters.application.activities.filter(function (activity) {
                return activity.licence_activity === rootGetters.selected_activity_tab_id;
            })[0];
            var is_assigned = activity.assigned_officer == null ? false : activity.assigned_officer === getters.current_user.id ? false : true;

            if (!['with_officer'].includes(activity.processing_status.id)) {
                return false;
            }
            if (activity.decision_action === 'reissue') {
                return false;
            }
            return !is_assigned && rootGetters.canAssignOfficerFor(rootGetters.selected_activity_tab_id);
        },
        allCurrentActivitiesWithAssessor: function allCurrentActivitiesWithAssessor(state, getters, rootState, rootGetters) {
            return rootGetters.application.schema.filter(function (activity) {
                return rootGetters.canAssignAssessorFor(activity.licence_activity_id);
            });
        }

    },
    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RENDERER_TABS, function (state, tabs) {
        _vue2.default.set(state, 'tabs', tabs);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RENDERER_SECTIONS, function (state, sections) {
        _vue2.default.set(state, 'sections', (0, _extends3.default)({}, sections));
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_VISIBLE_COMPONENT, function (state, _ref) {
        var key = _ref.key,
            value = _ref.value;

        _vue2.default.set(state.visible_components, key, value);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.TOGGLE_FINALISED_TABS, function (state, visible) {
        _vue2.default.set(state.visibility, 'exclude_decisions', visible ? [] : ['issued', 'declined']);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_FORM_DATA, function (state, form_data) {
        if (form_data == null) {
            _vue2.default.set(state, 'form_data', {});
        } else {
            _vue2.default.set(state, 'form_data', (0, _extends3.default)({}, form_data));
        }
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_FORM_FIELD, function (state, _ref2) {
        var key = _ref2.key,
            value = _ref2.value;

        var currentValue = state.form_data[key] ? (0, _extends3.default)({}, state.form_data[key]) : {};
        for (var idx in value) {
            currentValue[idx] = value[idx];
        }
        _vue2.default.set(state.form_data, key, currentValue);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.REMOVE_FORM_FIELD, function (state, key) {
        _vue2.default.delete(state.form_data, key);
    }), _mutations),
    actions: {
        setRendererTabs: function setRendererTabs(_ref3, tabs) {
            var commit = _ref3.commit;

            commit(_mutationTypes.UPDATE_RENDERER_TABS, tabs);
        },
        setRendererSections: function setRendererSections(_ref4, sections) {
            var commit = _ref4.commit;

            commit(_mutationTypes.UPDATE_RENDERER_SECTIONS, sections);
        },
        toggleVisibleComponent: function toggleVisibleComponent(_ref5, _ref6) {
            var commit = _ref5.commit,
                getters = _ref5.getters;
            var component_id = _ref6.component_id,
                visible = _ref6.visible;

            commit(_mutationTypes.UPDATE_VISIBLE_COMPONENT, { key: component_id, value: visible });
        },
        toggleFinalisedTabs: function toggleFinalisedTabs(_ref7, visible) {
            var commit = _ref7.commit;

            commit(_mutationTypes.TOGGLE_FINALISED_TABS, visible);
        },
        setFormData: function setFormData(_ref8, form_data) {
            var commit = _ref8.commit;

            commit(_mutationTypes.UPDATE_FORM_DATA, form_data);
        },
        setFormValue: function setFormValue(_ref9, params) {
            var commit = _ref9.commit;

            commit(_mutationTypes.UPDATE_FORM_FIELD, params);
        },
        removeFormInstance: function removeFormInstance(_ref10, instanceId) {
            var state = _ref10.state,
                commit = _ref10.commit;

            for (var key in state.form_data) {
                if (!key.includes(instanceId)) {
                    continue;
                }
                commit(_mutationTypes.REMOVE_FORM_FIELD, key);
            }
        },
        saveFormData: function saveFormData(_ref11, _ref12) {
            var dispatch = _ref11.dispatch,
                commit = _ref11.commit,
                getters = _ref11.getters,
                rootGetters = _ref11.rootGetters;
            var url = _ref12.url,
                draft = _ref12.draft,
                submit = _ref12.submit;

            return new _promise2.default(function (resolve, reject) {
                var post_data = (0, _assign2.default)({ '__draft': draft, '__update_fee': rootGetters.application.update_fee, '__submit': submit }, getters.renderer_form_data);
                _vue2.default.http.post(url, post_data).then(function (res) {
                    resolve(res);
                }, function (err) {
                    console.log(err);
                    reject(err);
                });
            });
        },
        finalDecisionData: function finalDecisionData(_ref13, _ref14) {
            var dispatch = _ref13.dispatch,
                commit = _ref13.commit,
                getters = _ref13.getters;
            var url = _ref14.url,
                draft = _ref14.draft;

            return new _promise2.default(function (resolve, reject) {
                var post_data = (0, _assign2.default)({ '__draft': draft }, getters.renderer_form_data);
                _vue2.default.http.post(url, post_data).then(function (res) {
                    resolve(res);
                }, function (err) {
                    console.log(err);
                    reject(err);
                });
            });
        },
        assessmentData: function assessmentData(_ref15, _ref16) {
            var dispatch = _ref15.dispatch,
                commit = _ref15.commit,
                getters = _ref15.getters,
                rootGetters = _ref15.rootGetters;
            var url = _ref16.url,
                draft = _ref16.draft;

            return new _promise2.default(function (resolve, reject) {
                var post_data = (0, _assign2.default)({ '__draft': draft, '__update_fee': rootGetters.application.update_fee, '__assess': rootGetters.application.assess, '__licence_activity': rootGetters.selected_activity_tab_id }, getters.renderer_form_data);
                _vue2.default.http.post(url, post_data).then(function (res) {
                    resolve(res);
                    dispatch('setApplication', res.body);
                    dispatch('setApplication', (0, _extends3.default)({}, rootGetters.application, {
                        application_fee: res.body.adjusted_paid_amount.application_fee,
                        licence_fee: res.body.adjusted_paid_amount.licence_fee,
                        update_fee: false,
                        assess: false
                    }));
                }, function (err) {
                    console.log(err);
                    reject(err);
                });
            });
        }
    }
};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.returnsStore = undefined;

var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(34);

var _keys2 = _interopRequireDefault(_keys);

var _mutations;

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _mutationTypes = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var returnsStore = exports.returnsStore = {
    state: {
        returns: {
            submitter: '',
            processing_status: ''
        },
        returns_estimate_fee: 0
    },
    getters: {
        return_id: function return_id(state) {
            return state.returns.id;
        },
        returns: function returns(state) {
            return state.returns;
        },
        isReturnsLoaded: function isReturnsLoaded(state) {
            return (0, _keys2.default)(state.returns).length && state.returns.table != null;
        },
        returns_estimate_fee: function returns_estimate_fee(state) {
            return state.returns_estimate_fee;
        }
    },
    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RETURNS, function (state, returns) {
        _vue2.default.set(state, 'returns', (0, _extends3.default)({}, returns));
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RETURNS_ESTIMATE, function (state, estimate) {
        _vue2.default.set(state, 'returns_estimate_fee', estimate);
    }), _mutations),
    actions: {
        loadReturns: function loadReturns(_ref, _ref2) {
            var dispatch = _ref.dispatch,
                commit = _ref.commit;
            var url = _ref2.url;

            return new _promise2.default(function (resolve, reject) {
                _vue2.default.http.get(url).then(function (res) {

                    if (res.body.format !== 'sheet') {
                        var obj = res.body.table[0]['data'][0];
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(obj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var form_data_record = _step.value;

                                var deficiency_key = form_data_record + '-deficiency-field';
                                dispatch('setFormValue', {
                                    key: form_data_record,
                                    value: {
                                        "value": obj[form_data_record],
                                        "deficiency_value": obj[deficiency_key]
                                    }
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }

                    dispatch('setReturns', res.body);
                    resolve();
                }, function (err) {
                    console.log(err);
                    reject();
                });
            });
        },
        setReturns: function setReturns(_ref3, returns) {
            var dispatch = _ref3.dispatch,
                commit = _ref3.commit;

            commit(_mutationTypes.UPDATE_RETURNS, returns);
        },
        setReturnsEstimateFee: function setReturnsEstimateFee(_ref4) {
            var dispatch = _ref4.dispatch,
                getters = _ref4.getters,
                commit = _ref4.commit;

            var estimate = 0;
            if (getters.returns.has_data) {
                var rows = getters.returns.table[0]['data'];
                var qty = 0;
                if (getters.returns.apply_fee_field) {

                    for (var i = 0; i < rows.length; i++) {
                        qty += parseInt(rows[i][getters.returns.apply_fee_field]['value']);
                    }
                }
                var _estimate = qty * getters.returns.base_fee;
            }

            estimate = estimate - getters.returns.total_paid_amount > 0 ? estimate - getters.returns.total_paid_amount : 0;
            commit(_mutationTypes.UPDATE_RETURNS_ESTIMATE, estimate);
        }
    }
};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.returnsRendererStore = undefined;

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _mutationTypes = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var returnsRendererStore = exports.returnsRendererStore = {
    state: {
        tabs: [],
        external_user: false,
        selected_returns_tab_id: 0,
        species: {},
        selected_species: {},
        transfer_species: {}
    },
    getters: {
        returns_tabs: function returns_tabs(state) {
            return state.tabs;
        },
        selected_returns_tab_id: function selected_returns_tab_id(state) {
            return state.selected_returns_tab_id;
        },
        species_list: function species_list(state) {
            return state.species;
        },
        returns_access: function returns_access(state) {
            return state.access;
        },
        species_cache: function species_cache(state) {
            return state.selected_species;
        },
        is_external: function is_external(state) {
            return state.external_user;
        },
        species_transfer: function species_transfer(state) {
            return state.transfer_species;
        }
    },
    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RETURNS_TABS, function (state, tabs) {
        _vue2.default.set(state, 'tabs', tabs);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SELECTED_TAB_ID, function (state, tab_id) {
        state.selected_returns_tab_id = tab_id;
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RETURNS_SPECIES, function (state, species) {
        _vue2.default.set(state, 'species', species);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RETURNS_EXTERNAL, function (state, external) {
        _vue2.default.set(state, 'external_user', external);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RETURNS_SELECTED_SPECIES, function (state, selected_species) {
        _vue2.default.set(state, 'selected_species', selected_species);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RETURNS_TRANSFER_SPECIES, function (state, transfer_species) {
        _vue2.default.set(state, 'transfer_species', transfer_species);
    }), _mutations),
    actions: {
        setReturnsTabs: function setReturnsTabs(_ref, _ref2) {
            var commit = _ref.commit;
            var tabs = _ref2.tabs;

            commit(_mutationTypes.UPDATE_RETURNS_TABS, tabs);
        },
        setReturnsTabId: function setReturnsTabId(_ref3, _ref4) {
            var commit = _ref3.commit;
            var tab_id = _ref4.tab_id;

            commit(_mutationTypes.UPDATE_SELECTED_TAB_ID, tab_id);
        },
        setReturnsSpecies: function setReturnsSpecies(_ref5, _ref6) {
            var commit = _ref5.commit;
            var species = _ref6.species;

            commit(_mutationTypes.UPDATE_RETURNS_SPECIES, species);
        },
        setReturnsExternal: function setReturnsExternal(_ref7, _ref8) {
            var commit = _ref7.commit;
            var external = _ref8.external;

            commit(_mutationTypes.UPDATE_RETURNS_EXTERNAL, external);
        },
        setSpeciesCache: function setSpeciesCache(_ref9, _ref10) {
            var commit = _ref9.commit;
            var species_cache = _ref10.species_cache;

            commit(_mutationTypes.UPDATE_RETURNS_SELECTED_SPECIES, species_cache);
        },
        setSpeciesTransfer: function setSpeciesTransfer(_ref11, _ref12) {
            var commit = _ref11.commit;
            var species_transfer = _ref12.species_transfer;

            commit(_mutationTypes.UPDATE_RETURNS_TRANSFER_SPECIES, species_transfer);
        }
    }
};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sanctionOutcomeStore = undefined;

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sanctionOutcomeStore = exports.sanctionOutcomeStore = {
    namespaced: true,
    state: {
        sanction_outcome: {}
    },
    getters: {
        sanction_outcome: function sanction_outcome(state) {
            return state.sanction_outcome;
        }
    },
    mutations: {
        updateRemediationAction: function updateRemediationAction(state, remediation_action) {
            console.log('updateRemediationAction');
            for (var i = 0; i < state.sanction_outcome.remediation_actions.length; i++) {
                if (state.sanction_outcome.remediation_actions[i].id == remediation_action.id) {
                    state.sanction_outcome.remediation_actions[i] = remediation_action;
                }
            }
        },
        updateSanctionOutcome: function updateSanctionOutcome(state, sanction_outcome) {
            _vue2.default.set(state, 'sanction_outcome', (0, _extends3.default)({}, sanction_outcome));
            if (state.sanction_outcome.date_of_issue) {
                state.sanction_outcome.date_of_issue = moment(state.sanction_outcome.date_of_issue, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
            if (state.sanction_outcome.time_of_issue) {
                state.sanction_outcome.time_of_issue = moment(state.sanction_outcome.time_of_issue, 'HH:mm:ss').format('LT');
            }
            var sanctionOutcomeDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.sanction_outcome, state.sanction_outcome.id + "/process_default_document/");
            _vue2.default.set(state.sanction_outcome, 'sanctionOutcomeDocumentUrl', sanctionOutcomeDocumentUrl);

            var commsLogsDocumentUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.sanction_outcome, state.sanction_outcome.id + "/process_comms_log_document/");
            _vue2.default.set(state.sanction_outcome, 'commsLogsDocumentUrl', commsLogsDocumentUrl);
        },
        updateAssignedToId: function updateAssignedToId(state, assigned_to_id) {
            _vue2.default.set(state.sanction_outcome, 'assigned_to_id', assigned_to_id);
        },
        updateCanUserAction: function updateCanUserAction(state, can_user_action) {
            _vue2.default.set(state.sanction_outcome, 'can_user_action', can_user_action);
        },
        updateRelatedItems: function updateRelatedItems(state, related_items) {
            _vue2.default.set(state.sanction_outcome, 'related_items', related_items);
        },
        updateRegistrationHolder: function updateRegistrationHolder(state, data) {
            if (data.data_type === 'individual') {
                _vue2.default.set(state.sanction_outcome, 'registration_holder_id', data.id);
            }
        },
        updateDriver: function updateDriver(state, data) {
            if (data.data_type === 'individual') {
                _vue2.default.set(state.sanction_outcome, 'driver_id', data.id);
            }
        }
    },
    actions: {
        loadRemediationAction: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref, _ref2) {
                var dispatch = _ref.dispatch;
                var remediation_action_id = _ref2.remediation_action_id;
                var returned;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.remediation_action, remediation_action_id));

                            case 2:
                                returned = _context.sent;

                                console.log('returned.body');
                                console.log(returned.body);

                                _context.next = 7;
                                return dispatch("setRemediationAction", returned.body);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function loadRemediationAction(_x, _x2) {
                return _ref3.apply(this, arguments);
            }

            return loadRemediationAction;
        }(),
        loadSanctionOutcome: function () {
            var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref4, _ref5) {
                var dispatch = _ref4.dispatch;
                var sanction_outcome_id = _ref5.sanction_outcome_id;
                var returnedSanctionOutcome;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return _vue2.default.http.get(_hooks.helpers.add_endpoint_json(_hooks.api_endpoints.sanction_outcome, sanction_outcome_id));

                            case 3:
                                returnedSanctionOutcome = _context2.sent;

                                console.log('loadSanctionOutcome');
                                console.log(returnedSanctionOutcome.body);

                                _context2.next = 8;
                                return dispatch("setSanctionOutcome", returnedSanctionOutcome.body);

                            case 8:
                                _context2.next = 13;
                                break;

                            case 10:
                                _context2.prev = 10;
                                _context2.t0 = _context2['catch'](0);

                                console.log(_context2.t0);

                            case 13:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 10]]);
            }));

            function loadSanctionOutcome(_x3, _x4) {
                return _ref6.apply(this, arguments);
            }

            return loadSanctionOutcome;
        }(),
        setRegistrationHolder: function setRegistrationHolder(_ref7, data) {
            var commit = _ref7.commit;

            commit("updateRegistrationHolder", data);
        },
        setDriver: function setDriver(_ref8, data) {
            var commit = _ref8.commit;

            commit("updateDriver", data);
        },
        saveSanctionOutcome: function () {
            var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref9) {
                var dispatch = _ref9.dispatch,
                    state = _ref9.state;
                var putUrl, payload, savedSanctionOutcome;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                console.log('saveSanctionOutcome');
                                putUrl = _hooks.helpers.add_endpoint_join(_hooks.api_endpoints.sanction_outcome, state.sanction_outcome.id + '/');
                                payload = {};

                                (0, _assign2.default)(payload, state.sanction_outcome);

                                if (payload.date_of_issue) {
                                    payload.date_of_issue = moment(payload.date_of_issue, "DD/MM/YYYY").format("YYYY-MM-DD");
                                }
                                if (payload.time_of_issue) {
                                    payload.time_of_issue = moment(payload.time_of_issue, "LT").format("HH:mm");
                                }

                                payload.type = payload.type.id;

                                console.log('payload');
                                console.log(payload);
                                _context3.next = 11;
                                return _vue2.default.http.put(putUrl, payload);

                            case 11:
                                savedSanctionOutcome = _context3.sent;
                                _context3.next = 14;
                                return dispatch("setSanctionOutcome", savedSanctionOutcome.body);

                            case 14:
                                return _context3.abrupt('return', savedSanctionOutcome);

                            case 15:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function saveSanctionOutcome(_x5) {
                return _ref10.apply(this, arguments);
            }

            return saveSanctionOutcome;
        }(),
        setSanctionOutcome: function setSanctionOutcome(_ref11, sanction_outcome) {
            var commit = _ref11.commit;

            commit("updateSanctionOutcome", sanction_outcome);
        },
        setRemediationAction: function setRemediationAction(_ref12, remediation_action) {
            var commit = _ref12.commit;

            commit("updateRemediationAction", remediation_action);
        },
        setAssignedToId: function setAssignedToId(_ref13, assigned_to_id) {
            var commit = _ref13.commit;

            commit("updateAssignedToId", assigned_to_id);
        },
        setCanUserAction: function setCanUserAction(_ref14, can_user_action) {
            var commit = _ref14.commit;

            commit("updateCanUserAction", can_user_action);
        },
        setRelatedItems: function setRelatedItems(_ref15, related_items) {
            var commit = _ref15.commit;

            commit("updateRelatedItems", related_items);
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userStore = undefined;

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _objectDestructuringEmpty2 = __webpack_require__(556);

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(22);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(35);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _mutations;

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _hooks = __webpack_require__(3);

var _mutationTypes = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userStore = exports.userStore = {
    state: {
        selected_activity_tab_id: 0,
        selected_activity_tab_name: '',
        selected_activity_tab_workflow_state: [],
        selected_apply_org_id: null,
        selected_apply_proxy_id: null,
        selected_apply_licence_select: null,
        application_workflow_state: false,
        current_user: {},
        reception_method_id: null,
        current_user_id: true

    },
    getters: {
        current_user: function current_user(state) {
            return state.current_user;
        },
        current_user_id: function current_user_id(state) {
            return state.current_user_id;
        },
        compliance_allocated_group: function compliance_allocated_group(state) {
            return state.compliance_allocated_group;
        },
        selected_activity_tab_id: function selected_activity_tab_id(state) {
            return state.selected_activity_tab_id;
        },
        selected_activity_tab_name: function selected_activity_tab_name(state) {
            return state.selected_activity_tab_name;
        },
        selected_activity_tab_workflow_state: function selected_activity_tab_workflow_state(state) {
            return state.selected_activity_tab_workflow_state;
        },
        selected_apply_org_id: function selected_apply_org_id(state) {
            return state.selected_apply_org_id;
        },
        selected_apply_proxy_id: function selected_apply_proxy_id(state) {
            return state.selected_apply_proxy_id;
        },
        selected_apply_licence_select: function selected_apply_licence_select(state) {
            return state.selected_apply_licence_select;
        },
        application_workflow_state: function application_workflow_state(state) {
            return state.application_workflow_state;
        },
        reception_method_id: function reception_method_id(state) {
            return state.reception_method_id;
        },
        hasRole: function hasRole(state, getters, rootState, rootGetters) {
            return function (role, activity_id) {
                if (rootGetters.application.user_roles == null) {
                    return false;
                }
                return rootGetters.application.user_roles.find(function (role_record) {
                    return (role.constructor === Array ? role : [role]).includes(role_record.role) && (!activity_id || activity_id == role_record.activity_id);
                });
            };
        },
        visibleConditionsFor: function visibleConditionsFor(state, getters, rootState, rootGetters) {
            return function (for_role, processing_status, tab_id) {
                return rootGetters.licence_type_data.activity.filter(function (activity) {
                    return activity.name && activity.processing_status.id == processing_status && getters.hasRole(for_role, activity.id) && (!tab_id || tab_id == activity.id);
                });
            };
        },
        canViewDeficiencies: function canViewDeficiencies(state, getters) {
            if (getters.isApplicationLoaded) {

                return getters.hasRole('licensing_officer') || getters.application.can_current_user_edit;
            }
            if (getters.isReturnsLoaded) {

                return getters.returns.activity_curators.find(function (curator) {
                    return curator.id === getters.current_user.id;
                }) || getters.returns.submitter.id === getters.current_user.id;
            }
            return false;
        },
        canEditDeficiencies: function canEditDeficiencies(state, getters) {
            if (getters.isApplicationLoaded) {

                return getters.application.activities.find(function (activity) {

                    return activity.licence_activity === getters.selected_activity_tab_id && getters.hasRole('licensing_officer', activity.licence_activity) && ['with_officer', 'with_officer_conditions'].includes(activity.processing_status.id) && (!activity.assigned_officer || activity.assigned_officer === getters.current_user.id);
                });
            }
            if (getters.isReturnsLoaded) {

                return getters.returns.activity_curators.find(function (curator) {
                    return curator.id === getters.current_user.id;
                });
            }
            return false;
        },
        canViewComments: function canViewComments(state, getters) {
            return getters.hasRole('licensing_officer') || getters.hasRole('assessor');
        },
        canViewPayments: function canViewPayments(state, getters) {
            return getters.current_user.is_payment_officer;
        },
        canAssignApproverFor: function canAssignApproverFor(state, getters, rootState, rootGetters) {
            return function (activity_id) {
                return rootGetters.application.activities.find(function (activity) {

                    return activity.licence_activity === activity_id && ['with_officer_finalisation', 'awaiting_licence_fee_payment'].includes(activity.processing_status.id) && getters.hasRole('issuing_officer', activity_id) && activity.issuing_officers.find(function (officer) {
                        return officer.id === getters.current_user.id;
                    });
                });
            };
        },
        canEditAssessmentFor: function canEditAssessmentFor(state, getters, rootState, rootGetters) {
            return function (activity_id) {
                return rootGetters.application.assessments.find(function (assessment) {

                    return assessment.licence_activity === activity_id && getters.hasRole('assessor', assessment.licence_activity) && (!assessment.assigned_assessor || assessment.assigned_assessor.id === getters.current_user.id);
                });
            };
        },
        canRequestAmendmentFor: function canRequestAmendmentFor(state, getters, rootState, rootGetters) {
            return function (activity_id) {
                return rootGetters.application.activities.find(function (activity) {

                    return activity.licence_activity === activity_id && getters.hasRole('licensing_officer', activity_id) && ['with_officer', 'with_officer_conditions'].includes(activity.processing_status.id) && activity.licensing_officers.find(function (officer) {
                        return officer.id === getters.current_user.id;
                    });
                });
            };
        },
        canAssignOfficerFor: function canAssignOfficerFor(state, getters, rootState, rootGetters) {
            return function (activity_id) {
                if (getters.isApplicationLoaded) {

                    return rootGetters.application.activities.find(function (activity) {

                        return activity.licence_activity === activity_id && getters.hasRole('licensing_officer', activity_id) && ['with_officer', 'with_officer_conditions'].includes(activity.processing_status.id) && activity.licensing_officers.find(function (officer) {
                            return officer.id === getters.current_user.id;
                        });
                    });
                }
                if (getters.isReturnsLoaded) {

                    return getters.returns.activity_curators.find(function (curator) {
                        return getters.returns.activity_curators.find(function (officer) {
                            return officer.id === getters.current_user.id;
                        });
                    });
                }
            };
        },
        canAssignAssessorFor: function canAssignAssessorFor(state, getters, rootState, rootGetters) {
            return function (activity_id) {
                return rootGetters.application.activities.find(function (activity) {

                    return activity.licence_activity === activity_id && getters.hasRole('assessor', activity_id) && ['with_assessor'].includes(activity.processing_status.id) && rootGetters.application.assessments.find(function (assessment) {

                        return assessment.licence_activity === activity_id && assessment.assessors.find(function (assessor) {
                            return assessor.id === getters.current_user.id;
                        });
                    });
                });
            };
        },
        isIdentifiedUser: function isIdentifiedUser(state, getters) {
            return getters.current_user_id;
        },
        hasCurrentLicence: function hasCurrentLicence(state, getters, rootState, rootGetters) {
            return rootGetters.application.on_active_licence;
        }
    },
    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SELECTED_TAB_ID, function (state, tab_id) {
        state.selected_activity_tab_id = tab_id;
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SELECTED_TAB_NAME, function (state, tab_name) {
        state.selected_activity_tab_name = tab_name;
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SELECTED_TAB_WORKFLOW_STATE, function (state, _ref) {
        var key = _ref.key,
            value = _ref.value;

        _vue2.default.set(state.selected_activity_tab_workflow_state, key, value);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_CURRENT_USER, function (state, user) {
        _vue2.default.set(state, 'current_user', (0, _extends3.default)({}, user));
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_CURRENT_USER_ID, function (state, bool) {
        state.current_user_id = bool;
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SELECTED_APPLY_ORG_ID, function (state, org_id) {
        state.selected_apply_org_id = org_id;
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SELECTED_APPLY_PROXY_ID, function (state, proxy_id) {
        state.selected_apply_proxy_id = proxy_id;
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SELECTED_APPLY_LICENCE_SELECT, function (state, licence_select) {
        state.selected_apply_licence_select = licence_select;
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_APPLICATION_WORKFLOW_STATE, function (state, bool) {
        state.application_workflow_state = bool;
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RECEPTION_METHOD_ID, function (state, pay_method) {
        state.reception_method_id = pay_method;
    }), _mutations),
    actions: {
        setActivityTab: function setActivityTab(_ref2, _ref3) {
            var commit = _ref2.commit;
            var id = _ref3.id,
                name = _ref3.name;

            commit(_mutationTypes.UPDATE_SELECTED_TAB_ID, id);
            commit(_mutationTypes.UPDATE_SELECTED_TAB_NAME, name);
        },
        setActivityTabWorkflowState: function setActivityTabWorkflowState(_ref4, _ref5) {
            var commit = _ref4.commit;
            var tab_id = _ref5.tab_id,
                bool = _ref5.bool;

            commit(_mutationTypes.UPDATE_SELECTED_TAB_WORKFLOW_STATE, { key: tab_id, value: bool });
        },
        setApplyOrgId: function setApplyOrgId(_ref6, _ref7) {
            var commit = _ref6.commit;
            var id = _ref7.id;

            commit(_mutationTypes.UPDATE_SELECTED_APPLY_ORG_ID, id);
        },
        setApplyProxyId: function setApplyProxyId(_ref8, _ref9) {
            var commit = _ref8.commit;
            var id = _ref9.id;

            commit(_mutationTypes.UPDATE_SELECTED_APPLY_PROXY_ID, id);
        },
        setApplyLicenceSelect: function setApplyLicenceSelect(_ref10, _ref11) {
            var commit = _ref10.commit;
            var licence_select = _ref11.licence_select;

            commit(_mutationTypes.UPDATE_SELECTED_APPLY_LICENCE_SELECT, licence_select);
        },
        setApplicationWorkflowState: function setApplicationWorkflowState(_ref12, _ref13) {
            var commit = _ref12.commit;
            var bool = _ref13.bool;

            commit(_mutationTypes.UPDATE_APPLICATION_WORKFLOW_STATE, bool);
        },
        setReceptionMethodId: function setReceptionMethodId(_ref14, _ref15) {
            var commit = _ref14.commit;
            var pay_method = _ref15.pay_method;

            commit(_mutationTypes.UPDATE_RECEPTION_METHOD_ID, pay_method);
        },
        loadCurrentUser: function loadCurrentUser(_ref16, _ref17) {
            var dispatch = _ref16.dispatch,
                commit = _ref16.commit;
            var url = _ref17.url;

            return new _promise2.default(function (resolve, reject) {
                _vue2.default.http.get(url).then(function (res) {
                    dispatch('setCurrentUser', res.body);
                    dispatch('setCurrentUserId', res.body.identification ? true : res.body.is_internal ? true : false);
                    resolve();
                }, function (err) {
                    console.log(err);
                    reject();
                });
            });
        },
        setCurrentUserId: function setCurrentUserId(_ref18, bool) {
            var dispatch = _ref18.dispatch,
                commit = _ref18.commit;

            commit(_mutationTypes.UPDATE_CURRENT_USER_ID, bool);
        },
        setCurrentUser: function setCurrentUser(_ref19, user) {
            var dispatch = _ref19.dispatch,
                commit = _ref19.commit;

            commit(_mutationTypes.UPDATE_CURRENT_USER, user);
        },
        loadAllocatedGroup: function () {
            var _ref22 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref20, _ref21) {
                var workflow_type = _ref21.workflow_type,
                    region_id = _ref21.region_id,
                    district_id = _ref21.district_id;
                var returned;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                (0, _objectDestructuringEmpty3.default)(_ref20);
                                _context.next = 3;
                                return _vue2.default.http.post(_hooks.api_endpoints.allocated_group_members, {
                                    'workflow_type': workflow_type,
                                    'region_id': region_id,
                                    'district_id': district_id
                                });

                            case 3:
                                returned = _context.sent;
                                return _context.abrupt('return', returned);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function loadAllocatedGroup(_x, _x2) {
                return _ref22.apply(this, arguments);
            }

            return loadAllocatedGroup;
        }()
    }
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getIterator2 = __webpack_require__(14);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(8);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(7);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _localforage = __webpack_require__(775);

var _localforage2 = _interopRequireDefault(_localforage);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    getSetCache: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(store_name, key, url, expiry) {
            var returnedFromUrl;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _vue2.default.http.get(url);

                        case 2:
                            returnedFromUrl = _context.sent;
                            return _context.abrupt('return', returnedFromUrl.body);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        function getSetCache(_x, _x2, _x3, _x4) {
            return _ref.apply(this, arguments);
        }

        return getSetCache;
    }(),
    getSetCacheList: function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(store_name, url, expiry) {
            var returned_list, returnedFromUrl, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, record, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _record, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _record2;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            returned_list = [];
                            _context2.next = 3;
                            return _vue2.default.http.get(url);

                        case 3:
                            returnedFromUrl = _context2.sent;

                            if (!returnedFromUrl.body.results) {
                                _context2.next = 26;
                                break;
                            }

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 8;

                            for (_iterator = (0, _getIterator3.default)(returnedFromUrl.body.results); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                record = _step.value;

                                returned_list.push(record);
                            }
                            _context2.next = 16;
                            break;

                        case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2['catch'](8);
                            _didIteratorError = true;
                            _iteratorError = _context2.t0;

                        case 16:
                            _context2.prev = 16;
                            _context2.prev = 17;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 19:
                            _context2.prev = 19;

                            if (!_didIteratorError) {
                                _context2.next = 22;
                                break;
                            }

                            throw _iteratorError;

                        case 22:
                            return _context2.finish(19);

                        case 23:
                            return _context2.finish(16);

                        case 24:
                            _context2.next = 68;
                            break;

                        case 26:
                            if (!(returnedFromUrl && returnedFromUrl.body && returnedFromUrl.body[0] && returnedFromUrl.body[0].id)) {
                                _context2.next = 48;
                                break;
                            }

                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context2.prev = 30;

                            for (_iterator2 = (0, _getIterator3.default)(returnedFromUrl.body); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                _record = _step2.value;

                                returned_list.push(_record);
                            }
                            _context2.next = 38;
                            break;

                        case 34:
                            _context2.prev = 34;
                            _context2.t1 = _context2['catch'](30);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context2.t1;

                        case 38:
                            _context2.prev = 38;
                            _context2.prev = 39;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 41:
                            _context2.prev = 41;

                            if (!_didIteratorError2) {
                                _context2.next = 44;
                                break;
                            }

                            throw _iteratorError2;

                        case 44:
                            return _context2.finish(41);

                        case 45:
                            return _context2.finish(38);

                        case 46:
                            _context2.next = 68;
                            break;

                        case 48:
                            if (!(returnedFromUrl.body[0] && returnedFromUrl.body[0].pk)) {
                                _context2.next = 68;
                                break;
                            }

                            _iteratorNormalCompletion3 = true;
                            _didIteratorError3 = false;
                            _iteratorError3 = undefined;
                            _context2.prev = 52;

                            for (_iterator3 = (0, _getIterator3.default)(returnedFromUrl.body); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                _record2 = _step3.value;

                                returned_list.push(_record2);
                            }
                            _context2.next = 60;
                            break;

                        case 56:
                            _context2.prev = 56;
                            _context2.t2 = _context2['catch'](52);
                            _didIteratorError3 = true;
                            _iteratorError3 = _context2.t2;

                        case 60:
                            _context2.prev = 60;
                            _context2.prev = 61;

                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }

                        case 63:
                            _context2.prev = 63;

                            if (!_didIteratorError3) {
                                _context2.next = 66;
                                break;
                            }

                            throw _iteratorError3;

                        case 66:
                            return _context2.finish(63);

                        case 67:
                            return _context2.finish(60);

                        case 68:
                            return _context2.abrupt('return', returned_list);

                        case 69:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[8, 12, 16, 24], [17,, 19, 23], [30, 34, 38, 46], [39,, 41, 45], [52, 56, 60, 68], [61,, 63, 67]]);
        }));

        function getSetCacheList(_x5, _x6, _x7) {
            return _ref2.apply(this, arguments);
        }

        return getSetCacheList;
    }()
};

/***/ }),
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(false);
// imports


// module
exports.push([module.i, "td.normal-white-space{white-space:normal !important}td.app-row-icon::before{top:5px;left:4px;height:14px;width:14px;border-radius:14px;line-height:14px;border:2px solid white;line-height:14px;content:'+';color:white;background-color:#337ab7;display:inline-block;box-shadow:0px 0px 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier monospace;margin:5px}tr:not(.child){cursor:pointer}tr.dark-row{background-color:#eeeeee}tr.appRecordRow.shown td.app-row-icon::before{top:5px;left:4px;height:14px;width:14px;border-radius:14px;line-height:14px;border:2px solid white;line-height:14px;content:'-';color:white;background-color:#d33333;display:inline-block;box-shadow:0px 0px 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier monospace;margin:5px}table.child-row-table{width:90%;float:right}.assessment-button{margin-top:10px;margin-left:20px}.assessment-action{display:block;padding:0px;margin:0px;cursor:pointer}.conditions-table{margin-top:20px}.width_0pc{width:0% !important}.width_5pc{width:5% !important}.width_10pc{width:10% !important}.width_15pc{width:15% !important}.width_20pc{width:20% !important}.width_25pc{width:25% !important}.width_30pc{width:30% !important}.width_35pc{width:35% !important}.width_40pc{width:40% !important}.width_45pc{width:45% !important}.width_50pc{width:50% !important}.width_55pc{width:55% !important}.width_60pc{width:60% !important}.width_65pc{width:65% !important}.width_70pc{width:70% !important}.width_75pc{width:75% !important}.width_80pc{width:80% !important}.width_85pc{width:85% !important}.width_90pc{width:90% !important}.width_95pc{width:95% !important}.width_100pc{width:100% !important}\n", ""]);

// exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(false);
// imports


// module
exports.push([module.i, "td.normal-white-space{white-space:normal !important}td.licence-row-icon::before{top:5px;left:4px;height:14px;width:14px;border-radius:14px;line-height:14px;border:2px solid white;line-height:14px;content:'+';color:white;background-color:#337ab7;display:inline-block;box-shadow:0px 0px 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier monospace;margin:5px}tr:not(.child){cursor:pointer}tr.dark-row{background-color:#eeeeee}tr.licRecordRow.shown td.licence-row-icon::before{top:5px;left:4px;height:14px;width:14px;border-radius:14px;line-height:14px;border:2px solid white;line-height:14px;content:'-';color:white;background-color:#d33333;display:inline-block;box-shadow:0px 0px 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier monospace;margin:5px}table.child-row-table{width:90%;float:right}.assessment-button{margin-top:10px;margin-left:20px}.assessment-action{display:block;padding:0px;margin:0px;cursor:pointer}.conditions-table{margin-top:20px}.width_0pc{width:0% !important}.width_5pc{width:5% !important}.width_10pc{width:10% !important}.width_15pc{width:15% !important}.width_20pc{width:20% !important}.width_25pc{width:25% !important}.width_30pc{width:30% !important}.width_35pc{width:35% !important}.width_40pc{width:40% !important}.width_45pc{width:45% !important}.width_50pc{width:50% !important}.width_55pc{width:55% !important}.width_60pc{width:60% !important}.width_65pc{width:65% !important}.width_70pc{width:70% !important}.width_75pc{width:75% !important}.width_80pc{width:80% !important}.width_85pc{width:85% !important}.width_90pc{width:90% !important}.width_95pc{width:95% !important}.width_100pc{width:100% !important}\n", ""]);

// exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(false);
// imports


// module
exports.push([module.i, "td.capitalise,td [data-dt-column=\"8\"] .dtr-data{text-transform:capitalize}td.normal-white-space{white-space:normal !important}\n", ""]);

// exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(false);
// imports


// module
exports.push([module.i, ".expander-label{margin-bottom:10px}.header-titles-row{padding-left:15px;padding-right:15px;font-weight:600}.header-titles-row div{padding-top:8px;padding-bottom:8px}.header-row{padding-left:10px;padding-right:10px;padding-top:15px;width:100%}.header-row .expand-icon{display:inline-block;cursor:pointer;width:10%;padding-right:16px;margin-left:-7px}.header-row .expand-icon:before{height:14px;width:14px;display:block;color:white;border:2px solid white;border-radius:14px;box-shadow:0 0 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier, monospace;line-height:14px;content:'+';background-color:#337ab7}.header-row .expand-icon.collapse:before{background-color:#d33333;content:'-'}.header-row .delete-icon{cursor:pointer;color:red;width:5%;display:inline-block;padding-left:5px}.expander-row{padding-left:20px;padding-right:20px;background:#dddddd;margin-left:0px;margin-right:0px}.header-contents{width:100%;display:inline-block}.add-new-button{float:left;margin-left:15px;margin-top:10px}.form-value,.hidden{display:none}.truncate-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\n", ""]);

// exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(false);
// imports


// module
exports.push([module.i, ".amendment-highlight{color:red !important}.amendment-highlight:after{font-family:\"FontAwesome\";content:\"\\F06A\";margin-left:5px}.sections-menu{width:249px}@media only screen and (max-width: 991px){.sections-dropdown{display:none}}.sections-dropdown a{color:#000;cursor:pointer}.sections-dropdown .section-list .menu-row{text-transform:capitalize;padding-left:20px;padding-top:4px;padding-bottom:4px;cursor:pointer}.sections-dropdown .section-list .menu-row:hover,.sections-dropdown .section-list .menu-row :focus{color:#262626;text-decoration:none;background-color:#f5f5f5}.sections-dropdown .section-list .menu-row div{display:grid;grid-template-columns:10px auto;grid-column-gap:5px}.sections-dropdown .section-list .menu-row i{font-size:6px;margin-top:6px}.sections-dropdown .section-list .menu-row span{padding-right:5px}.sections-dropdown .dropdown-panel{max-height:calc(100vh - 150px);overflow-y:auto}.nav-tabs{cursor:pointer;padding-bottom:5px}.missing-field{background-color:rgba(255,0,0,0.1) !important}.inline-block{display:inline-block}.nav-item{background-color:rgba(200,200,200,0.8) !important;cursor:pointer}.nav-item>li>a{background-color:yellow !important;color:#fff}.nav-item>li.active>a,.nav-item>li.active>a:hover,.nav-item>li.active>a:focus{color:white;background-color:blue;border:1px solid #888888}\n", ""]);

// exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(false);
// imports


// module
exports.push([module.i, "td.normal-white-space{white-space:normal !important}td.pay-row-icon::before{top:5px;left:4px;height:14px;width:14px;border-radius:14px;line-height:14px;border:2px solid white;line-height:14px;content:'+';color:white;background-color:#337ab7;display:inline-block;box-shadow:0px 0px 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier monospace;margin:5px}tr:not(.child){cursor:pointer}tr.dark-row{background-color:#eeeeee}tr.payRecordRow.shown td.pay-row-icon::before{top:5px;left:4px;height:14px;width:14px;border-radius:14px;line-height:14px;border:2px solid white;line-height:14px;content:'-';color:white;background-color:#d33333;display:inline-block;box-shadow:0px 0px 3px #444;box-sizing:content-box;text-align:center;text-indent:0 !important;font-family:'Courier New', Courier monospace;margin:5px}table.child-row-table{width:90%;float:right}\n", ""]);

// exports


/***/ }),
/* 627 */,
/* 628 */,
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
var define = false;
var jquery = jquery;
var $ = jquery;

// removed by extract-text-webpack-plugin


/***/ }),
/* 751 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
var define = false;
var jquery = jquery;
var $ = jquery;

// removed by extract-text-webpack-plugin


/***/ }),
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 174,
	"./af.js": 174,
	"./ar": 181,
	"./ar-dz": 175,
	"./ar-dz.js": 175,
	"./ar-kw": 176,
	"./ar-kw.js": 176,
	"./ar-ly": 177,
	"./ar-ly.js": 177,
	"./ar-ma": 178,
	"./ar-ma.js": 178,
	"./ar-sa": 179,
	"./ar-sa.js": 179,
	"./ar-tn": 180,
	"./ar-tn.js": 180,
	"./ar.js": 181,
	"./az": 182,
	"./az.js": 182,
	"./be": 183,
	"./be.js": 183,
	"./bg": 184,
	"./bg.js": 184,
	"./bm": 185,
	"./bm.js": 185,
	"./bn": 187,
	"./bn-bd": 186,
	"./bn-bd.js": 186,
	"./bn.js": 187,
	"./bo": 188,
	"./bo.js": 188,
	"./br": 189,
	"./br.js": 189,
	"./bs": 190,
	"./bs.js": 190,
	"./ca": 191,
	"./ca.js": 191,
	"./cs": 192,
	"./cs.js": 192,
	"./cv": 193,
	"./cv.js": 193,
	"./cy": 194,
	"./cy.js": 194,
	"./da": 195,
	"./da.js": 195,
	"./de": 198,
	"./de-at": 196,
	"./de-at.js": 196,
	"./de-ch": 197,
	"./de-ch.js": 197,
	"./de.js": 198,
	"./dv": 199,
	"./dv.js": 199,
	"./el": 200,
	"./el.js": 200,
	"./en-au": 201,
	"./en-au.js": 201,
	"./en-ca": 202,
	"./en-ca.js": 202,
	"./en-gb": 203,
	"./en-gb.js": 203,
	"./en-ie": 204,
	"./en-ie.js": 204,
	"./en-il": 205,
	"./en-il.js": 205,
	"./en-in": 206,
	"./en-in.js": 206,
	"./en-nz": 207,
	"./en-nz.js": 207,
	"./en-sg": 208,
	"./en-sg.js": 208,
	"./eo": 209,
	"./eo.js": 209,
	"./es": 213,
	"./es-do": 210,
	"./es-do.js": 210,
	"./es-mx": 211,
	"./es-mx.js": 211,
	"./es-us": 212,
	"./es-us.js": 212,
	"./es.js": 213,
	"./et": 214,
	"./et.js": 214,
	"./eu": 215,
	"./eu.js": 215,
	"./fa": 216,
	"./fa.js": 216,
	"./fi": 217,
	"./fi.js": 217,
	"./fil": 218,
	"./fil.js": 218,
	"./fo": 219,
	"./fo.js": 219,
	"./fr": 222,
	"./fr-ca": 220,
	"./fr-ca.js": 220,
	"./fr-ch": 221,
	"./fr-ch.js": 221,
	"./fr.js": 222,
	"./fy": 223,
	"./fy.js": 223,
	"./ga": 224,
	"./ga.js": 224,
	"./gd": 225,
	"./gd.js": 225,
	"./gl": 226,
	"./gl.js": 226,
	"./gom-deva": 227,
	"./gom-deva.js": 227,
	"./gom-latn": 228,
	"./gom-latn.js": 228,
	"./gu": 229,
	"./gu.js": 229,
	"./he": 230,
	"./he.js": 230,
	"./hi": 231,
	"./hi.js": 231,
	"./hr": 232,
	"./hr.js": 232,
	"./hu": 233,
	"./hu.js": 233,
	"./hy-am": 234,
	"./hy-am.js": 234,
	"./id": 235,
	"./id.js": 235,
	"./is": 236,
	"./is.js": 236,
	"./it": 238,
	"./it-ch": 237,
	"./it-ch.js": 237,
	"./it.js": 238,
	"./ja": 239,
	"./ja.js": 239,
	"./jv": 240,
	"./jv.js": 240,
	"./ka": 241,
	"./ka.js": 241,
	"./kk": 242,
	"./kk.js": 242,
	"./km": 243,
	"./km.js": 243,
	"./kn": 244,
	"./kn.js": 244,
	"./ko": 245,
	"./ko.js": 245,
	"./ku": 246,
	"./ku.js": 246,
	"./ky": 247,
	"./ky.js": 247,
	"./lb": 248,
	"./lb.js": 248,
	"./lo": 249,
	"./lo.js": 249,
	"./lt": 250,
	"./lt.js": 250,
	"./lv": 251,
	"./lv.js": 251,
	"./me": 252,
	"./me.js": 252,
	"./mi": 253,
	"./mi.js": 253,
	"./mk": 254,
	"./mk.js": 254,
	"./ml": 255,
	"./ml.js": 255,
	"./mn": 256,
	"./mn.js": 256,
	"./mr": 257,
	"./mr.js": 257,
	"./ms": 259,
	"./ms-my": 258,
	"./ms-my.js": 258,
	"./ms.js": 259,
	"./mt": 260,
	"./mt.js": 260,
	"./my": 261,
	"./my.js": 261,
	"./nb": 262,
	"./nb.js": 262,
	"./ne": 263,
	"./ne.js": 263,
	"./nl": 265,
	"./nl-be": 264,
	"./nl-be.js": 264,
	"./nl.js": 265,
	"./nn": 266,
	"./nn.js": 266,
	"./oc-lnc": 267,
	"./oc-lnc.js": 267,
	"./pa-in": 268,
	"./pa-in.js": 268,
	"./pl": 269,
	"./pl.js": 269,
	"./pt": 271,
	"./pt-br": 270,
	"./pt-br.js": 270,
	"./pt.js": 271,
	"./ro": 272,
	"./ro.js": 272,
	"./ru": 273,
	"./ru.js": 273,
	"./sd": 274,
	"./sd.js": 274,
	"./se": 275,
	"./se.js": 275,
	"./si": 276,
	"./si.js": 276,
	"./sk": 277,
	"./sk.js": 277,
	"./sl": 278,
	"./sl.js": 278,
	"./sq": 279,
	"./sq.js": 279,
	"./sr": 281,
	"./sr-cyrl": 280,
	"./sr-cyrl.js": 280,
	"./sr.js": 281,
	"./ss": 282,
	"./ss.js": 282,
	"./sv": 283,
	"./sv.js": 283,
	"./sw": 284,
	"./sw.js": 284,
	"./ta": 285,
	"./ta.js": 285,
	"./te": 286,
	"./te.js": 286,
	"./tet": 287,
	"./tet.js": 287,
	"./tg": 288,
	"./tg.js": 288,
	"./th": 289,
	"./th.js": 289,
	"./tk": 290,
	"./tk.js": 290,
	"./tl-ph": 291,
	"./tl-ph.js": 291,
	"./tlh": 292,
	"./tlh.js": 292,
	"./tr": 293,
	"./tr.js": 293,
	"./tzl": 294,
	"./tzl.js": 294,
	"./tzm": 296,
	"./tzm-latn": 295,
	"./tzm-latn.js": 295,
	"./tzm.js": 296,
	"./ug-cn": 297,
	"./ug-cn.js": 297,
	"./uk": 298,
	"./uk.js": 298,
	"./ur": 299,
	"./ur.js": 299,
	"./uz": 301,
	"./uz-latn": 300,
	"./uz-latn.js": 300,
	"./uz.js": 301,
	"./vi": 302,
	"./vi.js": 302,
	"./x-pseudo": 303,
	"./x-pseudo.js": 303,
	"./yo": 304,
	"./yo.js": 304,
	"./zh-cn": 305,
	"./zh-cn.js": 305,
	"./zh-hk": 306,
	"./zh-hk.js": 306,
	"./zh-mo": 307,
	"./zh-mo.js": 307,
	"./zh-tw": 308,
	"./zh-tw.js": 308
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 793;

/***/ }),
/* 794 */,
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "wildlifecompliance_vue/img/satellite_icon.34f7eba.png";

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 801 */,
/* 802 */,
/* 803 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(679)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(976),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(704)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(909),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(733)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(1051),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(1039),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(661)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(953),
  /* scopeId */
  "data-v-34451c48",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(710)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  "data-v-79bdd94d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(651)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(941),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(663)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(957),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(924),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(744)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(1067),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(913),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(695)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(724)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(1038),
  /* scopeId */
  "data-v-ab3debe6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(939),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(974),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(731)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(1049),
  /* scopeId */
  "data-v-c63e97fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(722)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(1035),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(694)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(1064),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(916),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(964),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(683)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(982),
  /* scopeId */
  "data-v-56cf3761",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(938),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(965),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(932),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(676)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(972),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(712)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(728)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1045),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(713)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(657)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(947),
  /* scopeId */
  "data-v-2d1dc0f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(677)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(973),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(671)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(967),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(674)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(970),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1062),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(743)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1066),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(673)
__webpack_require__(672)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(969),
  /* scopeId */
  "data-v-46163050",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(715)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(631)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(910),
  /* scopeId */
  "data-v-02253e2f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(678)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(975),
  /* scopeId */
  "data-v-520803dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(725)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(1040),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(727)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1043),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(699)
__webpack_require__(698)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  "data-v-6976b7e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(658)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(948),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(642)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(926),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(645)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(929),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(659)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(950),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(691)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(723)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1037),
  /* scopeId */
  "data-v-a7db42f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(675)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(971),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(911),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(655)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(945),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(955),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(919),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(684)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(983),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(681)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(980),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(706)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(717)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(665)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(959),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(709)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(735)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(1053),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(740)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1059),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(705)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(734)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1052),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(951),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(979),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(936),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1056),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(977),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(739)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(1058),
  /* scopeId */
  "data-v-da47f9f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(685)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(984),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(634)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(918),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(720)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1032),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(654)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(944),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(700)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  "data-v-69a025ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1047),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(668)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(962),
  /* scopeId */
  "data-v-425d254f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(741)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1061),
  /* scopeId */
  "data-v-e5a60298",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(956),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(719)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(702)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(726)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1042),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(662)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(954),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(647)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(931),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(703)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(738)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1057),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(732)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1050),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(682)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(981),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1033),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(935),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(697)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  "data-v-66bc6a80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(736)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1054),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(648)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(934),
  /* scopeId */
  "data-v-1f0988cd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(991),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(649)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(937),
  /* scopeId */
  "data-v-1fb57170",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1044),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    attrs: {
      "id": _vm.id,
      "required": _vm.isRequired
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), (_vm.help_text_url) ? [_c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.getDeficiencyField
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', _vm._l((_vm.headers), function(header) {
    return (_vm.headers) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (header.label),
        expression: "header.label"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": "disabled"
      },
      domProps: {
        "value": (header.label)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(header, "label", $event.target.value)
        }
      }
    }), _vm._v(" "), _vm._l((_vm.field_data), function(field, row_no) {
      return _c('div', {
        staticClass: "grid-item"
      }, _vm._l((field), function(title, key) {
        return (key == header.name) ? _c('div', {
          key: ("f_" + key),
          attrs: {
            "id": "header.name",
            "name": (_vm.name + "::" + (header.name))
          }
        }, [(header.type === 'date') ? _c('div', [_c('input', {
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "id": header.name + '::' + row_no,
            "disabled": header.readonly,
            "name": _vm.name + '::' + header.name,
            "placeholder": "DD/MM/YYYY",
            "v-model": _vm.setDateValue(title.value, row_no, header.name, header.readonly),
            "required": _vm.isRequired
          }
        })]) : _vm._e(), _vm._v(" "), (header.type === 'string') ? _c('div', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (title.value),
            expression: "title.value"
          }],
          staticClass: "form-control",
          attrs: {
            "disabled": header.readonly,
            "type": "text",
            "id": header.name + '::' + row_no,
            "name": _vm.name + '::' + header.name,
            "required": _vm.isRequired
          },
          domProps: {
            "value": (title.value)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(title, "value", $event.target.value)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (header.type === 'number') ? _c('div', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (title.value),
            expression: "title.value"
          }],
          staticClass: "form-control",
          attrs: {
            "disabled": header.readonly,
            "id": header.name + '::' + row_no,
            "type": "text",
            "name": _vm.name + '::' + header.name,
            "required": _vm.isRequired
          },
          domProps: {
            "value": (title.value)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(title, "value", $event.target.value)
            }
          }
        })]) : _vm._e()]) : _vm._e()
      }), 0)
    })], 2) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddRow),
      expression: "showAddRow"
    }],
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addRow()
      }
    }
  }, [_vm._v("Add Row")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "legalCasePersonOrgDash"
    }
  }, [_c('FormSection', {
    attrs: {
      "label": "Case",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "legal_case_table",
    attrs: {
      "id": "legal-case-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isLicensingOfficer ? 'col-md-12 conditions-table' : 'col-md-12'
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Proposed Conditions\n                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.panelBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.panelBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.panelBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.canAddConditions) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addCondition()
      }
    }
  }, [_vm._v("Add Condition")]) : _vm._e()]), _vm._v(" "), _c('datatable', {
    ref: "conditions_datatable",
    attrs: {
      "id": 'conditions-datatable-' + _vm._uid,
      "dtOptions": _vm.condition_options,
      "dtHeaders": _vm.condition_headers
    }
  })], 1)])])]), _vm._v(" "), _c('ConditionDetail', {
    ref: "condition_detail",
    attrs: {
      "application_id": _vm.application.id,
      "conditions": _vm.conditions,
      "licence_activity_tab": _vm.selected_activity_tab_id,
      "condition": _vm.viewedCondition,
      "purposes": _vm.purposes
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showComplianceManagement) ? _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalDash"
    }
  }, [_c('CallEmailDashTable')], 1) : (_vm.showWildlifeLicensing) ? _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalDash"
    }
  }, [_c('ApplicationDashTable', {
    attrs: {
      "level": "internal",
      "url": _vm.applications_url
    }
  }), _vm._v(" "), _c('AssessmentDashTable')], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('RendererForm', {
    attrs: {
      "withSectionsSelector": _vm.withSectionsSelector,
      "form_width": _vm.form_width
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.applicationTitle) + " for\n                        "), (_vm.selected_apply_org_id) ? _c('span', [_vm._v(_vm._s(_vm.selected_apply_org_id_details.name) + " (" + _vm._s(_vm.selected_apply_org_id_details.abn) + ")")]) : _vm._e(), _vm._v(" "), (_vm.selected_apply_proxy_id) ? _c('span', [_vm._v(_vm._s(_vm.selected_apply_proxy_id_details.first_name) + " " + _vm._s(_vm.selected_apply_proxy_id_details.last_name) + " (" + _vm._s(_vm.selected_apply_proxy_id_details.email) + ")")]) : _vm._e(), _vm._v(" "), (!_vm.selected_apply_org_id && !_vm.selected_apply_proxy_id) ? _c('span', [_vm._v("yourself")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [(_vm.categoryCount) ? _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "personal_form",
      "method": "post"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_user.is_reception),
      expression: "current_user.is_reception"
    }],
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("\n                                    Payment method for customer:\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer_pay_method),
      expression: "customer_pay_method"
    }],
    attrs: {
      "type": "radio",
      "checked": "checked",
      "name": "reception",
      "value": "card"
    },
    domProps: {
      "checked": _vm._q(_vm.customer_pay_method, "card")
    },
    on: {
      "change": function($event) {
        _vm.customer_pay_method = "card"
      }
    }
  }), _vm._v(" Credit Card   "), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer_pay_method),
      expression: "customer_pay_method"
    }],
    attrs: {
      "type": "radio",
      "name": "reception",
      "id": "cash",
      "value": "cash"
    },
    domProps: {
      "checked": _vm._q(_vm.customer_pay_method, "cash")
    },
    on: {
      "change": function($event) {
        _vm.customer_pay_method = "cash"
      }
    }
  }), _vm._v(" Cash   "), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer_pay_method),
      expression: "customer_pay_method"
    }],
    attrs: {
      "type": "radio",
      "name": "reception",
      "id": "none",
      "value": "none"
    },
    domProps: {
      "checked": _vm._q(_vm.customer_pay_method, "none")
    },
    on: {
      "change": function($event) {
        _vm.customer_pay_method = "none"
      }
    }
  }), _vm._v(" No Payment   ")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-6"
  }, [_vm._v("\n                                    " + _vm._s(_vm.selectionLabel) + ":\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-left-20"
  }, _vm._l((_vm.visibleLicenceCategories), function(category, index) {
    return _c('div', {
      staticClass: "radio"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.licence_categories.id),
        expression: "licence_categories.id"
      }],
      attrs: {
        "type": "radio",
        "id": category.id,
        "name": "licence_category"
      },
      domProps: {
        "value": category.id,
        "checked": _vm._q(_vm.licence_categories.id, category.id)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.licence_categories, "id", category.id)
        }, function($event) {
          return _vm.handleRadioChange($event, index)
        }]
      }
    }), _vm._v(" " + _vm._s(category.short_name) + "\n                                         \n                                        "), _c('div', {
      staticClass: "row"
    }, [(category.checked) ? _c('div', {
      staticClass: "col-sm-9"
    }, _vm._l((category.activity), function(type, index1) {
      return (!(_vm.selected_apply_org_id != '' && type.not_for_organisation == true)) ? _c('div', {
        staticClass: "checkbox margin-left-20"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (category.activity[index1].selected),
          expression: "category.activity[index1].selected"
        }],
        ref: "selected_activity_type",
        refInFor: true,
        attrs: {
          "type": "checkbox",
          "name": "activity",
          "id": type.id
        },
        domProps: {
          "value": type.id,
          "checked": Array.isArray(category.activity[index1].selected) ? _vm._i(category.activity[index1].selected, type.id) > -1 : (category.activity[index1].selected)
        },
        on: {
          "change": [function($event) {
            var $$a = category.activity[index1].selected,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = type.id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(category.activity[index1], "selected", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(category.activity[index1], "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(category.activity[index1], "selected", $$c)
            }
          }, function($event) {
            return _vm.handleActivityCheckboxChange(index, index1)
          }]
        }
      }), _vm._v(" " + _vm._s(type.short_name) + "\n\n                                                    "), (type.selected) ? _c('div', _vm._l((type.purpose), function(purpose, index2) {
        return _c('div', {
          staticClass: "checkbox purpose-clear-left"
        }, [(purpose.is_valid_age) ? _c('div', {
          staticClass: "col-sm-12"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (type.purpose[index2].selected),
            expression: "type.purpose[index2].selected"
          }],
          attrs: {
            "type": "checkbox",
            "id": purpose.id
          },
          domProps: {
            "value": purpose.id,
            "checked": Array.isArray(type.purpose[index2].selected) ? _vm._i(type.purpose[index2].selected, purpose.id) > -1 : (type.purpose[index2].selected)
          },
          on: {
            "change": [function($event) {
              var $$a = type.purpose[index2].selected,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = purpose.id,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(type.purpose[index2], "selected", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(type.purpose[index2], "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(type.purpose[index2], "selected", $$c)
              }
            }, function($event) {
              return _vm.handlePurposeCheckboxChange(index, $event)
            }]
          }
        }), _vm._v("\n                                                                        " + _vm._s(purpose.name) + "\n                                                                        "), _c('span', [_vm._v(" (" + _vm._s(_vm._f("toCurrency")(parseFloat(purpose.base_application_fee))) + " + " + _vm._s(_vm._f("toCurrency")(parseFloat(purpose.base_licence_fee))) + ")")])]) : _c('div', {
          staticClass: "col-sm-12"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (type.purpose[index2].selected),
            expression: "type.purpose[index2].selected"
          }],
          attrs: {
            "type": "checkbox",
            "disabled": "",
            "id": purpose.id
          },
          domProps: {
            "value": purpose.id,
            "checked": Array.isArray(type.purpose[index2].selected) ? _vm._i(type.purpose[index2].selected, purpose.id) > -1 : (type.purpose[index2].selected)
          },
          on: {
            "change": function($event) {
              var $$a = type.purpose[index2].selected,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = purpose.id,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(type.purpose[index2], "selected", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(type.purpose[index2], "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(type.purpose[index2], "selected", $$c)
              }
            }
          }
        }), _vm._v("\n                                                                " + _vm._s(purpose.name) + "\n                                                                "), _c('span', [_vm._v(" (Minimum age " + _vm._s(purpose.minimum_age) + " years)")])])])
      }), 0) : _vm._e()]) : _vm._e()
    }), 0) : _c('div', {
      staticClass: "col-sm-4"
    })])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Continue")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('strong', [_vm._v("Estimated application fee: " + _vm._s(_vm._f("toCurrency")(_vm.application_fee)))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Estimated licence fee: " + _vm._s(_vm._f("toCurrency")(_vm.licence_fee)))]), _c('br')])])]) : (!_vm.categoryCount && (_vm.isAmendment || _vm.isRenewal)) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('center', [_c('i', {
    staticClass: "fa fa-4x fa-spinner fa-spin"
  })]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')], 1)])]) : _c('div', [_vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label')])])
}]}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.label) + "\n        "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.section_id,
      "data-toggle": "collapse",
      "expanded": "true",
      "aria-controls": _vm.section_id
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.section_id
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-primary"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Options\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": "#" + _vm.pOptionBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pOptionBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": "" + _vm.pOptionBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.addedOptions), function(a, aidx) {
    return _c('div', {
      key: ("a_" + aidx)
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [(aidx === 0) ? _c('label', {
      staticClass: "control-label pull-left"
    }, [_vm._v("Add Options")]) : _vm._e()]), _vm._v(" "), (_vm.canAddMore) ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (a.label),
        expression: "a.label"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (a.label)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(a, "label", $event.target.value)
        }
      }
    })]) : _c('div', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v(_vm._s(a.label))])]), _vm._v(" "), (_vm.canAddMore) ? _c('div', {
      staticClass: "col-md-6"
    }, [(aidx !== 0) ? _c('a', {
      staticClass: "delete-icon fa fa-trash-o",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Delete row"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeOption(aidx)
        }
      }
    }) : _vm._e(), _vm._v(" "), (aidx === 0) ? _c('button', {
      staticClass: "btn btn-link pull-right",
      attrs: {
        "name": "select_option_link_1"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addOption()
        }
      }
    }, [_vm._v("[ Add Another ]")]) : _vm._e()]) : _c('div', {
      staticClass: "col-md-6"
    }, _vm._l((a.conditions), function(c, cid) {
      return _c('div', {
        key: ("condition_" + cid)
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getCheckedConditions(a, c).isChecked),
          expression: "getCheckedConditions(a,c).isChecked"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": true,
          "checked": Array.isArray(_vm.getCheckedConditions(a, c).isChecked) ? _vm._i(_vm.getCheckedConditions(a, c).isChecked, true) > -1 : (_vm.getCheckedConditions(a, c).isChecked)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.getCheckedConditions(a, c).isChecked,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = true,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.getCheckedConditions(a, c), "isChecked", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.getCheckedConditions(a, c), "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.getCheckedConditions(a, c), "isChecked", $$c)
            }
          }
        }
      }), _vm._v("  "), _c('label', [_vm._v(_vm._s(c.label))]), (_vm.getCheckedConditions(a, c).isDisplay) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (c.value),
          expression: "c.value"
        }],
        staticClass: "pull-right",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (c.value)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(c, "value", $event.target.value)
          }
        }
      }) : _vm._e()])
    }), 0)])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "method": "POST",
      "name": "external_returns_form",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "externalReturn"
    }
  }, [(_vm.isReturnsLoaded) ? _c('Returns', [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.selected_returns_tab_id === 0 && _vm.returns.format === 'sheet') ? _c('ReturnSheet') : _vm._e(), _vm._v(" "), (_vm.selected_returns_tab_id === 0 && _vm.returns.format === 'question') ? _c('ReturnQuestion') : _vm._e(), _vm._v(" "), (_vm.selected_returns_tab_id === 0 && _vm.returns.format === 'data') ? _c('ReturnData') : _vm._e(), _vm._v(" "), (_vm.selected_returns_tab_id === 1 && _vm.returns.lodgement_date != null) ? _c('ReturnSubmit') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showButtons),
      expression: "showButtons"
    }],
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.isPayable) ? _c('strong', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Return submission fee: " + _vm._s(_vm._f("toCurrency")(_vm.returns_estimate_fee)))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.spinner_exit) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Saving")]) : (!_vm.spinner_exit && _vm.disable_exit) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": "",
      "name": "save_exit"
    }
  }, [_vm._v("Save and Exit")]) : _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "name": "save_exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save(false)
      }
    }
  }, [_vm._v("Save and Exit")]), _vm._v(" "), (_vm.spinner_continue) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Saving")]) : (!_vm.spinner_continue && _vm.disable_continue) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": "",
      "name": "save_continue"
    }
  }, [_vm._v("Save and Continue")]) : _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "name": "save_continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save(true)
      }
    }
  }, [_vm._v("Save and Continue")]), _vm._v(" "), (_vm.spinner_submit) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Submitting")]) : _vm._e(), _vm._v(" "), (!_vm.spinner_submit && !_vm.isPayable && _vm.isSubmittable && !_vm.disable_submit) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "name": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save_and_submit()
      }
    }
  }, [_vm._v("Submit")]) : (!_vm.spinner_submit && _vm.disable_submit && !_vm.isPayable && _vm.isSubmittable) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": "",
      "name": "submit"
    }
  }, [_vm._v("Submit")]) : (!_vm.spinner_submit && !_vm.disable_submit && _vm.isPayable && _vm.isSubmittable) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "name": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit_and_checkout()
      }
    }
  }, [_vm._v("Pay and Submit")]) : (_vm.isPayable && _vm.isSubmittable && _vm.disable_submit) ? _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "disabled": "",
      "name": "submit"
    }
  }, [_vm._v("Pay and Submit")]) : _vm._e()])])])])])], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.sheetTitle) + "\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Species Available:")]), _vm._v(" "), (_vm.returns.species) ? _c('select', {
    ref: "species_selector",
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "species_selector",
      "id": "species_selector"
    }
  }, [(Object.values(_vm.returns.species_saved).length === 0) ? _c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.returns.species_list), function(specie, s_idx) {
    return _c('option', {
      key: ("specie_" + s_idx),
      staticClass: "change-species",
      attrs: {
        "species_id": s_idx
      },
      domProps: {
        "value": s_idx,
        "selected": s_idx === _vm.specie_selection
      }
    }, [_vm._v(_vm._s(specie))])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(!_vm.readonly) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "name": "sheet_entry"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSheetRow()
      }
    }
  }, [_vm._v("New Entry")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Species already added for this Return:")]), _vm._v(" "), _vm._l((_vm.returns.species_saved), function(specie, a_idx) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }],
      key: ("selected_" + a_idx)
    }, [(a_idx === _vm.returns.species) ? _c('span', [_vm._v("   " + _vm._s(specie))]) : _c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "name": ("specie_link_" + a_idx)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getSheetSpecies(a_idx)
        }
      }
    }, [_vm._v(_vm._s(specie))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Activity Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterActivityType),
      expression: "filterActivityType"
    }],
    ref: "activity_filter_selector",
    staticClass: "form-control",
    attrs: {
      "name": "activity_filter_selector"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterActivityType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.sheet_activity_type), function(sa, sa_idx) {
    return _c('option', {
      key: ("sa_type_" + sa_idx),
      domProps: {
        "value": sa['label']
      }
    }, [_vm._v(_vm._s(sa['label']))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "return_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.sheet_options,
      "dtHeaders": _vm.sheet_headers
    }
  })], 1)])])]), _vm._v(" "), _c('SheetEntry', {
    ref: "sheet_entry"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalOffenceDash"
    }
  }, [_c('FormSection', {
    attrs: {
      "label": "Offence",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Sanction Outcome Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterType),
      expression: "filterType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.offence_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                        " + _vm._s(option.display) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Offence Status:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.offence_statuses), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                        " + _vm._s(option.display) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Date from:")]), _vm._v(" "), _c('div', {
    ref: "issueDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateFromPicker),
      expression: "filterDateFromPicker"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateFromPicker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateFromPicker = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Date to:")]), _vm._v(" "), _c('div', {
    ref: "issueDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateToPicker),
      expression: "filterDateToPicker"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateToPicker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateToPicker = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 pull-right"
  }, [(_vm.visibilityCreateNewButton) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createOffence($event)
      }
    }
  }, [_vm._v("New Offence")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "offence_table",
    attrs: {
      "id": "offence-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "label": "Location",
      "Index": "1"
    }
  }, [_c('MapLocations')], 1), _vm._v(" "), (_vm.offenceInitialised) ? _c('div', [_c('OffenceModal', {
    key: _vm.offenceBindId,
    ref: "add_offence"
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    attrs: {
      "id": "map-filter"
    }
  }, [_c('div', [_c('label', {}, [_vm._v("Inspection Types")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterInspectionType),
      expression: "filterInspectionType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterInspectionType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.type_choices), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.inspection_type) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', [_c('label', {}, [_vm._v("Inspection Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.status_choices), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.display) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', [_c('label', {}, [_vm._v("Planned Date From")]), _vm._v(" "), _c('div', {
    ref: "lodgementDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateFrom),
      expression: "filterDateFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', [_c('label', {}, [_vm._v("Planned Date To")]), _vm._v(" "), _c('div', {
    ref: "lodgementDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateTo),
      expression: "filterDateTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateTo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "map-wrapper"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapLeaf"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "basemap-button"
    }
  }, [_c('img', {
    attrs: {
      "id": "basemap_sat",
      "src": __webpack_require__(57)
    },
    on: {
      "click": function($event) {
        return _vm.setBaseLayer('sat')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "id": "basemap_osm",
      "src": __webpack_require__(56)
    },
    on: {
      "click": function($event) {
        return _vm.setBaseLayer('osm')
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cursor-location"
    }
  }, [(_vm.cursor_location) ? _c('div', [_c('span', {
    attrs: {
      "id": "cursor-location-lat"
    }
  }, [_vm._v(_vm._s(_vm.cursor_location.lat.toFixed(5)) + ", " + _vm._s(_vm.cursor_location.lng.toFixed(5)))])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search-box"
    }
  }, [_c('input', {
    attrs: {
      "id": "search-input"
    }
  })])
}]}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "transition": _vm.transition
    }
  }, [_c('div', {
    staticClass: "modal",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.clickMask($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: _vm.modalClass,
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._t("header", [_c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._t("title", [_vm._v("\n                                " + _vm._s(_vm.title) + "\n                            ")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [(_vm.showOk) ? _c('button', {
    class: _vm.okClass,
    attrs: {
      "id": "okBtn",
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okText))]) : _vm._e(), _vm._v(" "), _c('button', {
    class: _vm.cancelClass,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])])], 2)], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-backdrop in"
  })])
},staticRenderFns: []}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.id,
      "num_files": _vm.num_documents()
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.files) ? _c('div', [_vm._l((_vm.documents), function(v) {
    return _c('div', [_c('p', [_vm._v("\n                File: "), _c('a', {
      attrs: {
        "href": v.file,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(v.name))]), _vm._v("  \n                "), (!_vm.readonly) ? _c('span', [_c('a', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Remove file",
        "filename": v.name
      },
      on: {
        "click": function($event) {
          return _vm.delete_document(v)
        }
      }
    })]) : _vm._e()])])
  }), _vm._v(" "), (_vm.show_spinner) ? _c('div', [_c('i', {
    staticClass: "fa fa-2x fa-spinner fa-spin"
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.repeat), function(n) {
    return (!_vm.readonly) ? _c('div', [(_vm.isRepeatable || (!_vm.isRepeatable && _vm.num_documents() == 0)) ? _c('div', [_c('input', {
      attrs: {
        "name": _vm.name,
        "type": "file",
        "data-que": n,
        "accept": _vm.fileTypes
      },
      on: {
        "change": _vm.handleChangeWrapper
      }
    })]) : _vm._e()]) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), (_vm.readonly) ? [(!_vm.isMultiple) ? _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "id": _vm.selectid,
      "name": _vm.name,
      "data-conditions": _vm.cons
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.options), function(op) {
    return _c('option', {
      domProps: {
        "value": op.value,
        "selected": op.value == _vm.value
      },
      on: {
        "change": _vm.handleChange
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2) : _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "id": _vm.selectid,
      "multiple": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.options), function(op) {
    return _c('option', {
      domProps: {
        "value": op.value,
        "selected": _vm.multipleSelection(op.value)
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2), _vm._v(" "), (_vm.isMultiple) ? _vm._l((_vm.value), function(v) {
    return _c('input', {
      attrs: {
        "input": "",
        "type": "hidden",
        "name": _vm.name,
        "required": _vm.isRequired
      },
      domProps: {
        "value": v
      }
    })
  }) : [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name,
      "required": _vm.isRequired
    },
    domProps: {
      "value": _vm.value
    }
  })]] : [(!_vm.isMultiple) ? _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.selectid,
      "name": _vm.name,
      "data-conditions": _vm.cons,
      "required": _vm.isRequired
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.options), function(op) {
    return _c('option', {
      domProps: {
        "value": op.value,
        "selected": op.value == _vm.value
      },
      on: {
        "change": _vm.handleChange
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2) : _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.selectid,
      "name": _vm.name,
      "multiple": "",
      "required": _vm.isRequired
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.options), function(op) {
    return _c('option', {
      domProps: {
        "value": op.value,
        "selected": _vm.multipleSelection(op.value)
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2)]], 2)])
},staticRenderFns: []}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form', {
    attrs: {
      "action": _vm.application_form_url,
      "method": "post",
      "name": "new_application",
      "enctype": "multipart/form-data"
    }
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                    " + _vm._s(error.label) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isApplicationLoaded) ? _c('Application', [_c('div', {
    class: ("" + (_vm.form_width ? _vm.form_width : 'col-md-9')),
    attrs: {
      "id": "tabs"
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tabs-section",
      "data-tabs": "tabs"
    }
  }, _vm._l((_vm.listVisibleActivities), function(activity, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [_c('a', {
      class: {
        'nav-link amendment-highlight': _vm.application.has_amendment
      },
      attrs: {
        "data-toggle": "pill"
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(activity)
        }
      }
    }, [_vm._v(_vm._s(activity.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._l((_vm.allCurrentActivities), function(activity, index) {
    return _c('div', [_c('AmendmentRequestDetails', {
      attrs: {
        "activity_id": activity.id
      }
    }), _vm._v(" "), (activity.id == _vm.selected_activity_tab_id) ? _c('renderer-block', {
      key: ("renderer_block_" + index),
      attrs: {
        "component": activity
      }
    }) : _vm._e()], 1)
  }), _vm._v("\n                    " + _vm._s(this.$slots.default) + "\n                ")], 2)]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "csrfmiddlewaretoken"
    },
    domProps: {
      "value": _vm.csrf_token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "schema"
    },
    domProps: {
      "value": JSON.stringify(_vm.application)
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "application_id"
    },
    domProps: {
      "value": 1
    }
  }), _vm._v(" "), (!_vm.application.readonly && _vm.userCanSubmit) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.showCardPayButton || _vm.showCashPayButton) ? _c('span', {
    staticStyle: {
      "margin-right": "5px",
      "font-size": "18px",
      "display": "block"
    }
  }, [_c('strong', [_vm._v("Estimated application fee: " + _vm._s(_vm._f("toCurrency")(_vm.adjusted_application_fee)))]), _vm._v(" "), _c('strong', [_vm._v("Estimated licence fee: " + _vm._s(_vm._f("toCurrency")(_vm.application.licence_fee)))])]) : _vm._e(), _vm._v(" "), (!_vm.isProcessing && _vm.canDiscardActivity) ? _c('input', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "value": "Discard Activity"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardActivity($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isProcessing) ? _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isProcessing) ? _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubmitButton),
      expression: "showSubmitButton"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCardPayButton),
      expression: "showCardPayButton"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Pay and Submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pay_and_submit($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCashPayButton),
      expression: "showCashPayButton"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Submit and Record"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit_and_record($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNonePayButton),
      expression: "showNonePayButton"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Migrate"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit_and_record($event)
      }
    }
  }), _vm._v(" "), (_vm.isProcessing) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Processing")]) : _vm._e()])])])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.isProcessing) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Processing")]) : _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'external-applications-dash'
      }
    }
  }, [_vm._v("Back to Dashboard")])], 1)])])])])]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: {
      'alert': true,
      'alert-success': (_vm.type == 'success'),
      'alert-warning': (_vm.type == 'warning'),
      'alert-info': (_vm.type == 'info'),
      'alert-danger': (_vm.type == 'danger'),
      'top': (_vm.placement === 'top'),
      'top-right': (_vm.placement === 'top-right')
    },
    style: ({
      width: _vm.width
    }),
    attrs: {
      "transition": "fade",
      "role": "alert"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dismissable),
      expression: "dismissable"
    }],
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Object: " + _vm._s(_vm.artifactComponentNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Workflow\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.artifactStatusDisplay)), _c('br')])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.showDocumentArtifactComponent) ? _c('div', {
    staticClass: "row"
  }, [_c('DocumentArtifact', {
    key: _vm.updateDocumentArtifactBindId,
    ref: "document_artifact",
    attrs: {
      "readonlyForm": !_vm.canUserAction
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPhysicalArtifactComponent) ? _c('div', {
    staticClass: "row"
  }, [_c('PhysicalArtifact', {
    key: _vm.updatePhysicalArtifactBindId,
    ref: "physical_artifact",
    attrs: {
      "readonlyForm": !_vm.canUserAction
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), (_vm.canUserAction) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.showSpinner && _vm.showExit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('exit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Saving")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit()
      }
    }
  }, [_vm._v("Save and Exit")]), _vm._v(" "), (_vm.showSpinner && !_vm.showExit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('noexit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Saving")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save and Continue")])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Licences "), (_vm.is_external) ? _c('small', [_vm._v("View existing licences and amend or renew them")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLicenceType),
      expression: "filterLicenceType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterLicenceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.licence_categories), function(l) {
    return _c('option', {
      key: ("cat_" + l),
      domProps: {
        "value": l
      }
    }, [_vm._v(_vm._s(l))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Holder")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLicenceHolder),
      expression: "filterLicenceHolder"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterLicenceHolder = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.licence_holders), function(holder) {
    return _c('option', {
      key: ("licence_holder_" + (holder.holder_name)),
      domProps: {
        "value": holder.holder_name
      }
    }, [_vm._v(_vm._s(holder.holder_name))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Issued From")]), _vm._v(" "), _c('div', {
    ref: "licenceDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLicenceIssuedFrom),
      expression: "filterLicenceIssuedFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterLicenceIssuedFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterLicenceIssuedFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Issued To")]), _vm._v(" "), _c('div', {
    ref: "licenceDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLicenceIssuedTo),
      expression: "filterLicenceIssuedTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterLicenceIssuedTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterLicenceIssuedTo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "licence_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.licence_options,
      "dtHeaders": _vm.licence_headers
    }
  })], 1)])])])]), _vm._v(" "), _c('LicenceActionPurposes', {
    ref: "licence_action_purposes",
    attrs: {
      "licence_activity_purposes": _vm.action_purpose_list,
      "licence_id": _vm.selected_licence_id,
      "action": _vm.licence_action
    },
    on: {
      "refreshFromResponse": _vm.refreshFromResponse
    }
  }), _vm._v(" "), _c('InspectionRequest', {
    ref: "inspection",
    on: {
      "inspection-created": _vm.requestedInspection
    }
  }), _vm._v(" "), _c('LicenceHistory', {
    ref: "licence_history"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br')])
}]}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    attrs: {
      "id": _vm.id
    }
  }), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    ref: "Checkbox",
    class: _vm.group,
    attrs: {
      "onclick": _vm.isClickable,
      "name": _vm.name,
      "type": "checkbox",
      "data-parsley-required": "",
      "data-conditions": _vm.options,
      "required": _vm.isRequired
    },
    domProps: {
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('input', {
    ref: "Checkbox",
    class: _vm.group,
    attrs: {
      "disabled": "",
      "onclick": _vm.isClickable,
      "name": _vm.name,
      "type": "checkbox",
      "data-parsley-required": "",
      "data-conditions": _vm.options,
      "required": _vm.isRequired
    },
    domProps: {
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleChange
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.label) + "\n            "), (_vm.help_text_url) ? [_c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })] : _vm._e(), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalSanctionOutcomeDash"
    }
  }, [_c('FormSection', {
    attrs: {
      "label": "Object",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterType),
      expression: "filterType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.artifact_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.display) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Status:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.artifact_statuses), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.display) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Date from:")]), _vm._v(" "), _c('div', {
    ref: "issueDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateFromPicker),
      expression: "filterDateFromPicker"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateFromPicker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateFromPicker = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Date to:")]), _vm._v(" "), _c('div', {
    ref: "issueDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateToPicker),
      expression: "filterDateToPicker"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateToPicker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateToPicker = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createArtifact($event)
      }
    }
  }, [_vm._v("New Object")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "artifact_table",
    attrs: {
      "id": "artifact-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])]), _vm._v(" "), (_vm.createArtifactInitialised) ? _c('div', [_c('CreateArtifact', {
    key: _vm.createArtifactBindId,
    ref: "create_artifact",
    attrs: {
      "readonlyForm": _vm.readonlyForm,
      "initialTabSelected": "artifact"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [(!_vm.hideHeader) ? _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.label) + " \n        "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.section_id,
      "data-toggle": "collapse",
      "expanded": "true",
      "aria-controls": _vm.section_id
    }
  }, [_c('span', {
    class: _vm.panel_chevron_class
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.panel_collapse_class,
    attrs: {
      "id": _vm.section_id
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.amendment_request_reasons) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amendment_request_reason),
      expression: "amendment_request_reason"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.amendment_request_reason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.amendment_request_reasons), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.reason
      }
    }, [_vm._v("\n                                " + _vm._s(item.reason) + "\n                            ")])
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details),
      expression: "details"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add reason",
      "id": "reason"
    },
    domProps: {
      "value": (_vm.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorResponse)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processingDetails) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : (_vm.fieldsFilled) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', _vm._l((_vm.condition_keys), function(condition) {
    return _c('div', [_c('div', {
      class: {
        'hidden': !_vm.isVisible(condition)
      },
      attrs: {
        "id": 'cons_' + _vm.name + '_' + condition
      }
    }, _vm._l((_vm.conditionBlocks(condition)), function(subcomponent, index) {
      return _c('renderer-block', {
        key: ("condition_" + condition + "_" + index),
        attrs: {
          "component": subcomponent,
          "json_data": _vm.data,
          "instance": _vm.instance
        }
      })
    }), 1)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ReturnsRendererForm', {
    attrs: {
      "form_width": _vm.form_width
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "userInfo"
    }
  }, [(_vm.showCompletion) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "well well-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', [_vm._v("\n                            We have detected that this may be the first time you have logged into the system.Please take a moment to provide us with your details\n                            (personal details, address details, contact details, and whether you are managing licences for an organisation).\n                            Once completed, click Continue to start using the system.\n                        ")]), _vm._v(" "), (_vm.completedProfile) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.userProfileCompleted()
      }
    }
  }, [_vm._v("Continue")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Complete profile to continue")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Personal Details "), _c('small', [_vm._v("Provide your personal details")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "personal_form",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b', [_vm._v("To update your account name please "), _c('a', {
    attrs: {
      "href": _vm.current_user.sso_setting_url + '/sso/setting?back=' + _vm.current_url
    }
  }, [_vm._v("click here")]), _vm._v(":")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Given name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.first_name),
      expression: "current_user.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Surname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.last_name),
      expression: "current_user.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    ref: "dob",
    staticClass: "input-group date",
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.canUpdateDOB) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.legal_dob),
      expression: "current_user.legal_dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "dob",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.current_user.legal_dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "legal_dob", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.dob),
      expression: "current_user.dob"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "dob",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.current_user.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "dob", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verified Given name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.legal_first_name),
      expression: "current_user.legal_first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "legal_first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.legal_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "legal_first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verified Surname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.legal_last_name),
      expression: "current_user.legal_last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "legal_last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.legal_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "legal_last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.canUpdateDOB) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingPersonal) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatePersonal()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])]) : _vm._e()])])])])])]), _vm._v(" "), (!_vm.approvedExternalUser) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.showCompletion && _vm.uploadedID) ? _c('i', {
    staticClass: "fa fa-check fa-2x pull-left",
    staticStyle: {
      "color": "green"
    }
  }) : (!_vm.uploadedID && !_vm.current_user.has_complete_first_time) ? _c('i', {
    staticClass: "fa fa-times fa-2x pull-left",
    staticStyle: {
      "color": "red"
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Identification "), _c('small', [_vm._v("Upload your photo ID")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.idBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.idBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.idBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "id_form",
      "method": "post"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.uploadedID) ? _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_c('SecureBaseLink', {
    attrs: {
      "link_name": "Uploaded Photo ID",
      "link_data": {
        'user_id': _vm.current_user.id
      }
    }
  })], 1) : (!_vm.uploadedID) ? _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_vm._v("Attach Photo ID"), _c('input', {
    ref: "uploadedID",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.readFileID()
      }
    }
  })]) : _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_vm._v(" Uploading...")]), _vm._v(" "), (_vm.uploadedID) ? _c('span', {
    staticClass: "btn btn-link btn-file pull-left"
  }, [_c('a', {
    staticClass: "fa fa-trash-o",
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    attrs: {
      "title": "Remove file"
    },
    on: {
      "click": function($event) {
        return _vm.removeID()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.showCompletion && _vm.current_user.address_details) ? _c('i', {
    staticClass: "fa fa-check fa-2x pull-left",
    staticStyle: {
      "color": "green"
    }
  }) : (_vm.showCompletion && !_vm.current_user.address_details) ? _c('i', {
    staticClass: "fa fa-times fa-2x pull-left",
    staticStyle: {
      "color": "red"
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Address Details "), _c('small', [_vm._v("Provide your address details")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.adBody,
      "data-toggle": "collapse",
      "expanded": "false",
      "data-parent": "#userInfo",
      "aria-controls": _vm.adBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), (_vm.loading.length == 0) ? _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.adBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.residential_address.line1),
      expression: "current_user.residential_address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.residential_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user.residential_address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.residential_address.locality),
      expression: "current_user.residential_address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.residential_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user.residential_address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.residential_address.state),
      expression: "current_user.residential_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.residential_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user.residential_address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.residential_address.postcode),
      expression: "current_user.residential_address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.residential_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user.residential_address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.residential_address.country),
      expression: "current_user.residential_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current_user.residential_address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(c) {
    return _c('option', {
      key: c.code,
      domProps: {
        "value": c.code
      }
    }, [_vm._v(_vm._s(c.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingAddress) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateAddress()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.showCompletion && _vm.current_user.contact_details) ? _c('i', {
    staticClass: "fa fa-check fa-2x pull-left",
    staticStyle: {
      "color": "green"
    }
  }) : (_vm.showCompletion && !_vm.current_user.contact_details) ? _c('i', {
    staticClass: "fa fa-times fa-2x pull-left",
    staticStyle: {
      "color": "red"
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Contact Details "), _c('small', [_vm._v("Provide your contact details")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.cBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.cBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.cBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.phone_number),
      expression: "current_user.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.mobile_number),
      expression: "current_user.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "mobile",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "mobile_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.email),
      expression: "current_user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "email",
      "name": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingContact) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateContact()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])])])])]), _vm._v(" "), (!_vm.approvedExternalUser) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Organisations "), _c('small', [_vm._v("Link to the Organisations you are an employee of and for which you are managing licences")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.oBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.oBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.oBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "orgForm",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Do you manage licences on behalf of an organisation?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.managesOrg),
      expression: "managesOrg"
    }],
    attrs: {
      "disabled": _vm.hasOrgs,
      "type": "radio",
      "name": "behalf_of_org",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.managesOrg, "No")
    },
    on: {
      "change": function($event) {
        _vm.managesOrg = "No"
      }
    }
  }), _vm._v(" No\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.managesOrg),
      expression: "managesOrg"
    }],
    attrs: {
      "type": "radio",
      "name": "behalf_of_org",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.managesOrg, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.managesOrg = "Yes"
      }
    }
  }), _vm._v(" Yes\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.managesOrg),
      expression: "managesOrg"
    }],
    attrs: {
      "type": "radio",
      "name": "behalf_of_org",
      "value": "Consultant"
    },
    domProps: {
      "checked": _vm._q(_vm.managesOrg, "Consultant")
    },
    on: {
      "change": function($event) {
        _vm.managesOrg = "Consultant"
      }
    }
  }), _vm._v(" Yes, as a consultant\n                            ")])]), _vm._v(" "), (_vm.managesOrg == 'Yes') ? _c('div', [_c('div', {
    staticClass: "col-sm-3"
  }, [(_vm.hasOrgs && !_vm.addingCompany) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addCompany()
      }
    }
  }, [_vm._v("Add Another Organisation")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.current_user.wildlifecompliance_organisations), function(org) {
    return _c('div', {
      key: org.id
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (org.name),
        expression: "org.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (org.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(org, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "col-sm-1 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (org.abn),
        expression: "org.abn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (org.abn)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(org, "abn", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.unlinkUser(org)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chain-broken fa-2x"
    }), _vm._v(" Unlink")])])])
  }), _vm._v(" "), _vm._l((_vm.orgRequest_pending), function(orgReq) {
    return _c('div', {
      key: orgReq.id
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.name),
        expression: "orgReq.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "col-sm-1 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.abn),
        expression: "orgReq.abn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.abn)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "abn", $event.target.value)
        }
      }
    })]), _vm._v(" "), _vm._m(5, true)])])
  }), _vm._v(" "), _vm._l((_vm.orgRequest_amendment_requested), function(orgReq) {
    return _c('div', {
      key: orgReq.id
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.name),
        expression: "orgReq.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "col-sm-1 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.abn),
        expression: "orgReq.abn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.abn)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "abn", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "btn btn-info btn-file pull-left"
    }, [_vm._v("\n                                    Upload New File "), _c('input', {
      ref: "uploadedFile",
      refInFor: true,
      attrs: {
        "type": "file"
      },
      on: {
        "change": function($event) {
          return _vm.uploadNewFileUpdateOrgRequest(orgReq)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "pull-left",
      staticStyle: {
        "margin-left": "10px",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(_vm.uploadedFileName))])])])
  }), _vm._v(" "), (_vm.managesOrg == 'Consultant' && _vm.addingCompany) ? _c('div', [_c('h3', [_vm._v("New Organisation (as consultant)")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.name),
      expression: "newOrg.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "organisation",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.abn),
      expression: "newOrg.abn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "abn",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.abn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "abn", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [(_vm.newOrg.detailsChecked) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.checkOrganisation()
      }
    }
  }, [_vm._v("Check Details")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                  Please upload a letter with an organisation letterhead stating that you are a consultant for the organisation.\n                                    "), _c('span', {
    staticClass: "btn btn-info btn-file"
  }, [_vm._v("\n                                        Atttach File "), _c('input', {
    ref: "uploadedFile",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.readFile()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.uploadedFileName))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10 control-label",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("You will be notified by email once the Department has checked the organisation details.\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.registeringOrg) ? _c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.orgConsultRequest()
      }
    }
  }, [_vm._v("Submit")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Submitting")])])])]) : _vm._e(), _vm._v(" "), (_vm.managesOrg == 'Yes' && _vm.addingCompany) ? _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('h3', [_vm._v("New Organisation")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.name),
      expression: "newOrg.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "organisation",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.abn),
      expression: "newOrg.abn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "abn",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.abn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "abn", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.checkOrganisation()
      }
    }
  }, [_vm._v("Check Details")])])]), _vm._v(" "), (_vm.newOrg.exists && _vm.newOrg.detailsChecked) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n                                This organisation has already been registered with the system. Please enter the two pin codes below."), _c('br'), _vm._v("\n                                These pin codes can be retrieved from one of the following people:"), _c('br'), _vm._v(" " + _vm._s(_vm.newOrg.first_five) + "\n                              ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pin 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.pin1),
      expression: "newOrg.pin1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "abn",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.pin1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "pin1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pin 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.pin2),
      expression: "newOrg.pin2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "abn",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.pin2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "pin2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [(!_vm.validatingPins) ? _c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.validatePins()
      }
    }
  }, [_vm._v("Validate")]) : _c('button', {
    staticClass: "btn btn-primary pull-left"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Validating Pins")])])]) : (!_vm.newOrg.exists && _vm.newOrg.detailsChecked) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "btn btn-info btn-file pull-left"
  }, [_vm._v("\n                                    Attach File "), _c('input', {
    ref: "uploadedFile",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.readFile()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.uploadedFileName))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10 control-label",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("You will be notified by email once the Department has checked the organisation details.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.registeringOrg) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.orgRequest()
      }
    }
  }, [_vm._v("Submit")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Submitting")])])]) : (_vm.newOrg.exists && !_vm.newOrg.detailsChecked) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "btn btn-info btn-file pull-left"
  }, [_vm._v("\n                                    Attach File "), _c('input', {
    ref: "uploadedFile",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.readFile()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.uploadedFileName))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10 control-label",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("You will be notified by email once the Department has checked the organisation details.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.registeringOrg) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.orgRequest()
      }
    }
  }, [_vm._v("Submit")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Submitting")])])]) : _vm._e()]) : _vm._e()], 2)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('i', [_vm._v("Changes will not update until your next login.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "col-sm-12"
  }, [_vm._v("     Attach a scan of the complete photo page of your passport or the complete photo side of your driver’s licence showing full name, date of birth and photo.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-hourglass-o fa-2x"
  }), _vm._v(" Pending Approval")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                This organisation has not yet been registered with this system. Please upload a letter with an organisation letterhead stating that you are an employee of this organisation."), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                Please upload a letter with an organisation letterhead stating that you are an employee of this organisation."), _c('br')])
}]}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalDash"
    }
  }, [_c('UserDashTable', {
    attrs: {
      "level": "internal",
      "url": _vm.users_url
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-primary"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Headers\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": "#" + _vm.pHeaderBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pHeaderBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": "" + _vm.pHeaderBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.addedHeaders), function(h, hidx) {
    return _c('div', {
      key: ("h_" + hidx)
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_vm._v("  \n                    "), _c('div', {
      staticClass: "col-md-3"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [(hidx == 0) ? _c('i', {
      staticClass: "fa fa-info-circle",
      staticStyle: {
        "cursor": "pointer",
        "color": "crimson"
      },
      attrs: {
        "aria-hidden": "true",
        "title": _vm.colSizeInfoMsg
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [(hidx === 0) ? _c('label', {
      staticClass: "control-label pull-left"
    }, [_vm._v("Add Headers")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (h.label),
        expression: "h.label"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (h.label)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(h, "label", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (h.value),
        expression: "h.value"
      }],
      ref: ("header_answer_type_" + hidx),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "name": ("select-answer-type-" + hidx)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(h, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.answerTypes), function(ha, haidx) {
      return _c('option', {
        domProps: {
          "value": ha.value
        }
      }, [_vm._v(_vm._s(ha.label))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (h.colSize),
        expression: "h.colSize"
      }],
      ref: ("header_col_size_" + hidx),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "name": ("select-col-size-" + hidx)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(h, "colSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.colSizeValues), function(ha, haidx) {
      return _c('option', {
        domProps: {
          "value": ha
        }
      }, [_vm._v(_vm._s(ha))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [(hidx !== 0) ? _c('a', {
      staticClass: "delete-icon fa fa-trash-o",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Delete row"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeHeader(hidx)
        }
      }
    }) : _vm._e(), _vm._v(" "), (hidx === 0) ? _c('button', {
      staticClass: "btn btn-link pull-right",
      attrs: {
        "name": "add_header_link_1"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addHeader()
        }
      }
    }, [_vm._v("[ Add Another ]")]) : _vm._e()])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "profiles"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("My Profiles "), (_vm.is_external) ? _c('small', [_vm._v("View profile details")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "pull-right btn btn-primary",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "/profiles/create"
    }
  }, [_vm._v("Create Profile")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('div', [_vm._v("Profiles let you link multiple email addresses with your account, allowing you to log in with any linked email address.")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "profile_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.profile_options,
      "dtHeaders": _vm.profile_headers
    }
  })], 1)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', _vm._l((_vm.condition_keys), function(condition) {
    return _c('div', [_c('div', {
      class: {
        'hidden': !_vm.isVisible(condition)
      },
      attrs: {
        "id": 'cons_' + _vm.name + '_' + condition
      }
    }, _vm._l((_vm.conditionBlocks(condition)), function(subcomponent, index) {
      return _c('compliance-renderer-block', {
        key: ("condition_" + condition + "_" + index),
        attrs: {
          "component": subcomponent,
          "json_data": _vm.data,
          "instance": _vm.instance
        }
      })
    }), 1)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "externalDash"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ApplicationDashTable', {
    attrs: {
      "level": "external",
      "url": _vm.applications_url
    }
  }), _vm._v(" "), _c('div', [_c('LicenceDashTable', {
    attrs: {
      "level": "external",
      "url": _vm.licences_url
    }
  }), _vm._v(" "), _c('ReturnDashTable', {
    attrs: {
      "level": "external",
      "url": _vm.returns_url
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "well well-sm"
  }, [_c('p', [_vm._v("\n                    Welcome to the Wildlife Licensing online system dashboard."), _c('br'), _c('br'), _vm._v(" Here you can access your existing licences, view any applications in progress, lodge new"), _c('br'), _vm._v(" applications or submit information required to comply with conditions listed\n                    on your licence\n                ")])])])])
}]}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.componentTitle) ? _c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v(_vm._s(_vm.componentTitle))]) : (_vm.displayTitle) ? _c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v(_vm._s(_vm.labelTitle))]) : _vm._e(), _vm._v(" "), (!_vm.personOnly) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": !_vm.isEditable,
      "id": "individual",
      "type": "radio"
    },
    domProps: {
      "value": "individual",
      "checked": _vm._q(_vm.searchType, "individual")
    },
    on: {
      "change": function($event) {
        _vm.searchType = "individual"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "individual"
    }
  }, [_vm._v("Person")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": !_vm.isEditable,
      "id": "organisation",
      "type": "radio"
    },
    domProps: {
      "value": "organisation",
      "checked": _vm._q(_vm.searchType, "organisation")
    },
    on: {
      "change": function($event) {
        _vm.searchType = "organisation"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "organisation"
    }
  }, [_vm._v("Organisation")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    ref: "search_person_org",
    class: _vm.classNames,
    attrs: {
      "id": _vm.elemId,
      "readonly": !_vm.isEditable
    }
  })]), _vm._v(" "), (_vm.showCreateNewPerson) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.isEditable,
      "type": "button",
      "value": "Create New Person"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewPerson()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showClearPerson) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.isEditable,
      "type": "button",
      "value": "Clear Person"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearPerson()
      }
    }
  })]) : (_vm.showCreateNewOrganisation) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.isEditable,
      "type": "button",
      "value": "Create New Organisation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewOrganisation($event)
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.displayUpdateCreatePerson) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('updateCreatePerson', {
    key: _vm.updateCreatePersonBindId,
    ref: "update_create_person",
    attrs: {
      "displayComponent": "",
      "isEditable": _vm.isEditable,
      "personToUpdate": _vm.entity.id
    },
    on: {
      "person-saved": _vm.savePerson
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.displayUpdateCreateOrganisation && !_vm.personOnly) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('updateCreateOrganisation', {
    ref: "update_create_organisation",
    attrs: {
      "displayComponent": ""
    },
    on: {
      "organisation-saved": function($event) {}
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.elementId
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Personal Details\n                    "), _c('span', {
    staticClass: "glyphicon  pull-right",
    class: _vm.isPersonalDetailsOpen ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down',
    on: {
      "click": function($event) {
        _vm.isPersonalDetailsOpen = !_vm.isPersonalDetailsOpen
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [(_vm.objectAlert) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v("test alert")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "personal_form",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errorGivenName
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Given Name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.email_user) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.first_name),
      expression: "email_user.first_name"
    }],
    key: _vm.email_user.id,
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.personalDetailsReadOnly,
      "type": "text",
      "name": "first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.email_user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_user, "first_name", $event.target.value)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errorLastName
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.email_user) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.last_name),
      expression: "email_user.last_name"
    }],
    key: _vm.email_user.id,
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.personalDetailsReadOnly,
      "type": "text",
      "name": "last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.email_user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_user, "last_name", $event.target.value)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.email_user) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errorDob
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    ref: "dobDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.dob),
      expression: "email_user.dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.personalDetailsReadOnly,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.email_user.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_user, "dob", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Address Details\n                "), _c('span', {
    staticClass: "glyphicon  pull-right",
    class: _vm.isAddressDetailsOpen ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down',
    on: {
      "click": function($event) {
        _vm.isAddressDetailsOpen = !_vm.isAddressDetailsOpen
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body in",
    attrs: {
      "id": _vm.adBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.email_user) ? _c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.residential_address.line1),
      expression: "email_user.residential_address.line1"
    }],
    key: _vm.email_user.residential_address.id,
    staticClass: "form-control",
    attrs: {
      "readonly": !_vm.isEditable,
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.email_user.residential_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_user.residential_address, "line1", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.email_user) ? _c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.residential_address.locality),
      expression: "email_user.residential_address.locality"
    }],
    key: _vm.email_user.residential_address.id,
    staticClass: "form-control",
    attrs: {
      "readonly": !_vm.isEditable,
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.email_user.residential_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_user.residential_address, "locality", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [(_vm.email_user) ? _c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.residential_address.state),
      expression: "email_user.residential_address.state"
    }],
    key: _vm.email_user.residential_address.id,
    staticClass: "form-control",
    attrs: {
      "readonly": !_vm.isEditable,
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.email_user.residential_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_user.residential_address, "state", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [(_vm.email_user) ? _c('div', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.residential_address.postcode),
      expression: "email_user.residential_address.postcode"
    }],
    key: _vm.email_user.residential_address.id,
    staticClass: "form-control",
    attrs: {
      "readonly": !_vm.isEditable,
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.email_user.residential_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_user.residential_address, "postcode", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.email_user) ? _c('div', [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.residential_address.country),
      expression: "email_user.residential_address.country"
    }],
    key: _vm.email_user.residential_address.id,
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.isEditable,
      "name": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_user.residential_address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(c) {
    return _c('option', {
      domProps: {
        "value": c.code
      }
    }, [_vm._v(_vm._s(c.name))])
  }), 0)])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Contact Details "), _c('small'), _vm._v(" "), _c('span', {
    staticClass: "glyphicon  pull-right",
    class: _vm.isContactDetailsOpen ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down',
    on: {
      "click": function($event) {
        _vm.isContactDetailsOpen = !_vm.isContactDetailsOpen
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.cdBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.email_user) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.phone_number),
      expression: "email_user.phone_number"
    }],
    key: _vm.email_user.id,
    staticClass: "form-control",
    attrs: {
      "readonly": !_vm.isEditable,
      "type": "text",
      "name": "phone",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.email_user.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_user, "phone_number", $event.target.value)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.email_user) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.mobile_number),
      expression: "email_user.mobile_number"
    }],
    key: _vm.email_user.id,
    staticClass: "form-control",
    attrs: {
      "readonly": !_vm.isEditable,
      "type": "text",
      "name": "mobile",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.email_user.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_user, "mobile_number", $event.target.value)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.email_user) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_user.email),
      expression: "email_user.email"
    }],
    key: _vm.email_user.id,
    staticClass: "form-control",
    attrs: {
      "readonly": !_vm.isEditable,
      "type": "email",
      "name": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.email_user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_user, "email", $event.target.value)
      }
    }
  })]) : _vm._e()])])])])]), _vm._v(" "), _c('input', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": !_vm.saveButtonEnabled,
      "type": "button",
      "value": _vm.saveButtonText
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveData($event)
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
}]}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "PersonOrArtifactModal"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "",
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.legalCaseId) ? _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: _vm.personTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.pTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('pTab')
      }
    }
  }, [_vm._v("Person")])]), _vm._v(" "), _c('li', {
    class: _vm.artifactTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.aTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('aTab')
      }
    }
  }, [_vm._v("Object")])]), _vm._v(" "), _c('li', {
    class: _vm.urlTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.uTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('uTab')
      }
    }
  }, [_vm._v("URL")])])])]) : _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: _vm.artifactTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.aTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('aTab')
      }
    }
  }, [_vm._v("Object")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content ul-top-buffer"
  }, [(_vm.legalCaseId) ? _c('div', {
    class: _vm.personTabClass,
    attrs: {
      "id": _vm.pTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('SearchPersonOrganisation', {
    key: _vm.updateSearchPersonOrganisationBindId,
    ref: "search_person_organisation",
    attrs: {
      "personOnly": "",
      "excludeStaff": true,
      "isEditable": !_vm.readonlyForm,
      "classNames": "form-control",
      "showCreateUpdate": "",
      "addFullName": "",
      "displayTitle": false,
      "entityEdit": _vm.entityEdit
    },
    on: {
      "entity-selected": _vm.entitySelected
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.artifactTabClass,
    attrs: {
      "id": _vm.aTab
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.componentType),
      expression: "componentType"
    }],
    attrs: {
      "type": "radio",
      "id": "document",
      "value": "document"
    },
    domProps: {
      "checked": _vm._q(_vm.componentType, "document")
    },
    on: {
      "change": function($event) {
        _vm.componentType = "document"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "document"
    }
  }, [_vm._v("Document")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.componentType),
      expression: "componentType"
    }],
    attrs: {
      "type": "radio",
      "id": "physical",
      "value": "physical"
    },
    domProps: {
      "checked": _vm._q(_vm.componentType, "physical")
    },
    on: {
      "change": function($event) {
        _vm.componentType = "physical"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "physical"
    }
  }, [_vm._v("Physical Object")])])]), _vm._v(" "), (_vm.showDocumentArtifactComponent) ? _c('div', [_c('DocumentArtifact', {
    key: _vm.updateDocumentArtifactBindId,
    ref: "document_artifact",
    attrs: {
      "parentModal": "",
      "entityEdit": _vm.entityEdit
    },
    on: {
      "entity-selected": _vm.entitySelected,
      "existing-entity-selected": _vm.existingEntitySelected,
      "error-message": _vm.setDocumentArtifactErrorMessage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPhysicalArtifactComponent) ? _c('div', [_c('PhysicalArtifact', {
    key: _vm.updatePhysicalArtifactBindId,
    ref: "physical_artifact",
    attrs: {
      "parentModal": "",
      "entityEdit": _vm.entityEdit
    },
    on: {
      "entity-selected": _vm.entitySelected,
      "existing-entity-selected": _vm.existingEntitySelected
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.legalCaseId) ? _c('div', {
    class: _vm.urlTabClass,
    attrs: {
      "id": _vm.uTab
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.urlProtocol),
      expression: "urlProtocol"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "protocol"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.urlProtocol = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "https"
    }
  }, [_vm._v("https")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "http"
    }
  }, [_vm._v("http")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.urlText),
      expression: "urlText"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputUrl",
      "type": "text"
    },
    domProps: {
      "value": (_vm.urlText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.urlText = $event.target.value
      }
    }
  })])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.isApplicationLoaded && _vm.initialiseAssessmentOptions()) ? [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "showOk": false,
      "title": "Assessment Record",
      "large": ""
    },
    on: {
      "cancel": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Assessment Details\n                                "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.panelBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.panelBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.panelBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "assessment_form",
      "method": "put"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Final Comments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assessment.final_comment),
      expression: "assessment.final_comment"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%",
      "max-width": "100%"
    },
    attrs: {
      "readonly": !_vm.canCompleteAssessment
    },
    domProps: {
      "value": (_vm.assessment.final_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.assessment, "final_comment", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.canCompleteAssessment) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.savingAssessment) ? _c('button', {
    staticClass: "btn btn-primary pull-right assessment-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveAssessment()
      }
    }
  }, [_vm._v("Save Assessment")]) : _vm._e(), _vm._v(" "), (!_vm.savingAssessment) ? _c('button', {
    staticClass: "btn btn-primary pull-right assessment-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.completeAssessment()
      }
    }
  }, [_vm._v("Mark Complete")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Saving")])])]) : _vm._e()])])])])])])]), _vm._v(" "), (_vm.applicationDetailsVisible) ? _c('div', [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tabs-main"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "pill"
    },
    on: {
      "click": function($event) {
        return _vm.selectApplicantTab()
      }
    }
  }, [_vm._v("Applicant")])]), _vm._v(" "), _vm._l((_vm.applicationActivities), function(item1, index) {
    return _c('li', {
      staticClass: "nav-item",
      class: _vm.setAssessorTab(index),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.clearSendToAssessorForm(item1)
        }
      }
    }, [(_vm.isActivityVisible(item1.id)) ? _c('a', {
      staticClass: "nav-link",
      attrs: {
        "data-toggle": "pill",
        "data-target": ("#" + (item1.id))
      }
    }, [_vm._v(_vm._s(item1.name))]) : _vm._e()])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.selectedActivity) ? _c('div', {
    attrs: {
      "id": ("" + (_vm.selectedActivity.id))
    }
  }, [_c('div', [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.isLicensingOfficer ? 'Send to Assessor' : 'Assessments') + "\n                                "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": "#" + (_vm.selectedActivity.id) + _vm.assessorsBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.assessorsBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": "" + (_vm.selectedActivity.id) + _vm.assessorsBody
    }
  }, [(_vm.canSendToAssessor) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-10",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Assessor Group")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAssessor),
      expression: "selectedAssessor"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAssessor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.assessorGroup), function(assessor, idx) {
    return (_vm.isAssessorRelevant(assessor)) ? _c('option', {
      attrs: {
        "id": assessor.id
      },
      domProps: {
        "value": assessor,
        "selected": !_vm.selectedAssessor
      }
    }, [_vm._v(_vm._s(assessor.display_name))]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSendToAssessorButton),
      expression: "showSendToAssessorButton"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "none"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendtoAssessor(_vm.selectedActivity.id)
      }
    }
  }, [_vm._v("Send")])])]) : _vm._e(), _vm._v(" "), (_vm.optionsLoadedForActivity(_vm.selectedActivity)) ? _c('div', {
    key: ("assessor_datatable_" + (_vm.selectedActivity.id)),
    staticClass: "row"
  }, [_c('datatable', {
    ref: "assessorDatatable",
    attrs: {
      "data-index": _vm.selectedActivity.id,
      "id": ((_vm.selectedActivity.id) + "_" + _vm._uid + "assessor_datatable"),
      "dtOptions": _vm.assessors_options[_vm.selectedActivity.id],
      "dtHeaders": _vm.assessors_headers,
      "onMount": _vm.eventListeners
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": ("" + (_vm.selectedActivity.id))
    }
  }, [_c('Conditions', {
    key: ("assessor_condition_" + _vm.selected_activity_tab_id),
    attrs: {
      "final_view_conditions": _vm.final_view_conditions,
      "activity": _vm.selectedActivity
    }
  })], 1)])]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('SendToAssessor', {
    ref: "send_to_assessor",
    on: {
      "refreshFromResponse": _vm.refreshFromResponse
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflowDetails),
      expression: "workflowDetails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add reason",
      "id": "reason"
    },
    domProps: {
      "value": (_vm.workflowDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workflowDetails = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": _vm.offence.commsLogsDocumentUrl
    }
  })], 1)])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Inspection: " + _vm._s(_vm.inspection.number))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Workflow\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.statusDisplay)), _c('br')])]), _vm._v(" "), _c('Assignment', {
    key: _vm.assignmentKey,
    attrs: {
      "user_is_assignee": _vm.inspection.user_is_assignee,
      "allowed_group_ids": _vm.inspection.allowed_groups,
      "user_in_group": _vm.inspection.user_in_group,
      "assigned_to_id": _vm.inspection.assigned_to_id,
      "assign_url": _vm.assign_url
    },
    on: {
      "update-assigned-to-id": _vm.updateAssignedToId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Action\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row action-button"
  }, [(_vm.sendToManagerVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "close",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('send_to_manager')
      }
    }
  }, [_vm._v("\n                              Send to Manager\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row action-button"
  }, [(_vm.endorseVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "close",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('endorse')
      }
    }
  }, [_vm._v("\n                              Endorse\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row action-button"
  }, [(_vm.requestAmendmentVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "close",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('request_amendment')
      }
    }
  }, [_vm._v("\n                              Request Amendment\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row action-button"
  }, [(_vm.offenceVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.open_offence()
      }
    }
  }, [_vm._v("\n                              Offence\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row action-button"
  }, [(_vm.sanctionOutcomeVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.open_sanction_outcome()
      }
    }
  }, [_vm._v("\n                              Sanction Outcome\n                            ")])]) : _vm._e()])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills aho2"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.iTab
    }
  }, [_vm._v("Inspection")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.lTab
    },
    on: {
      "click": _vm.mapTabClicked
    }
  }, [_vm._v("Location")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.cTab
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.oTab
    }
  }, [_vm._v("Outcomes")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.rTab
    }
  }, [_vm._v("Related Items")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.iTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Inspection Details",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Inspection type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.inspection_type_id),
      expression: "inspection.inspection_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.inspection, "inspection_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadSchema]
    }
  }, _vm._l((_vm.inspectionTypes), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.inspection_type) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Title")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.title),
      expression: "inspection.title"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.inspection.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.details),
      expression: "inspection.details"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.inspection.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection, "details", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Planned for (Date)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "plannedForDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.planned_for_date),
      expression: "inspection.planned_for_date"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.inspection.planned_for_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection, "planned_for_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Planned for (Time)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "plannedForTimePicker"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.planned_for_time),
      expression: "inspection.planned_for_time"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.inspection.planned_for_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection, "planned_for_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('SearchPersonOrganisation', {
    key: _vm.updateSearchPersonOrganisationBindId,
    ref: "search_person_organisation",
    attrs: {
      "componentTitle": "Party to be inspected",
      "parentEntity": _vm.inspectedEntity,
      "excludeStaff": true,
      "isEditable": !_vm.readonlyForm,
      "classNames": "form-control",
      "initialSearchType": _vm.inspection.party_inspected,
      "showCreateUpdate": ""
    },
    on: {
      "entity-selected": _vm.entitySelected
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4",
    attrs: {
      "for": "inspection_inform"
    }
  }, [_vm._v("Inform party to be inspected")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.inform_party_being_inspected),
      expression: "inspection.inform_party_being_inspected"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "id": "inspection_inform"
    },
    domProps: {
      "checked": Array.isArray(_vm.inspection.inform_party_being_inspected) ? _vm._i(_vm.inspection.inform_party_being_inspected, null) > -1 : (_vm.inspection.inform_party_being_inspected)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.inspection.inform_party_being_inspected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.inspection, "inform_party_being_inspected", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.inspection, "inform_party_being_inspected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.inspection, "inform_party_being_inspected", $$c)
        }
      }
    }
  })])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Inspection Team",
      "Index": "1"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    ref: "inspectionteam",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    }
  }, _vm._l((_vm.inspection.all_officers), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.full_name) + "\n                                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTeamMember($event)
      }
    }
  }, [_vm._v("Add Member")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.inspection) ? _c('div', [_c('datatable', {
    ref: "inspection_team_table",
    attrs: {
      "id": "inspection-team-table",
      "dtOptions": _vm.dtOptionsInspectionTeam,
      "dtHeaders": _vm.dtHeadersInspectionTeam
    }
  })], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.lTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Location"
    }
  }, [(_vm.inspection.location) ? _c('MapLocation', {
    key: _vm.lTab,
    ref: "mapLocationComponent",
    attrs: {
      "readonly": _vm.readonlyForm,
      "marker_longitude": _vm.inspection.location.geometry.coordinates[0],
      "marker_latitude": _vm.inspection.location.geometry.coordinates[1]
    },
    on: {
      "location-updated": _vm.locationUpdated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inspection.location) ? _c('div', {
    attrs: {
      "id": _vm.idLocationFieldsAddress
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Street")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.street),
      expression: "inspection.location.properties.street"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.inspection.location.properties.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "street", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.town_suburb),
      expression: "inspection.location.properties.town_suburb"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.inspection.location.properties.town_suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "town_suburb", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.state),
      expression: "inspection.location.properties.state"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.inspection.location.properties.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.postcode),
      expression: "inspection.location.properties.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.inspection.location.properties.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.country),
      expression: "inspection.location.properties.country"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.inspection.location.properties.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "country", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.inspection.location) ? _c('div', {
    attrs: {
      "id": _vm.idLocationFieldsDetails
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection.location.properties.details),
      expression: "inspection.location.properties.details"
    }],
    staticClass: "form-control location_address_field",
    domProps: {
      "value": (_vm.inspection.location.properties.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inspection.location.properties, "details", $event.target.value)
      }
    }
  })])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.cTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Checklist"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.current_schema), function(item, index) {
    return (_vm.rendererVisibility) ? _c('div', [_c('compliance-renderer-block', {
      key: ("compliance_renderer_block" + index),
      attrs: {
        "component": item,
        "readonlyForm": _vm.readonlyForm
      }
    })], 1) : _vm._e()
  }), 0)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.oTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Inspection report"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Inspection report")])]), _vm._v(" "), (_vm.inspection.inspectionReportDocumentUrl) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "inspection_report_file",
    attrs: {
      "name": "inspection-report-file",
      "isRepeatable": false,
      "documentActionUrl": _vm.inspection.inspectionReportDocumentUrl,
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-parent": _vm.loadInspectionReport
    }
  })], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.rTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.relatedItemsVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": !_vm.canUserAction
    }
  })], 1) : _vm._e()])])])], 1)])])])]), _vm._v(" "), (_vm.inspection.can_user_action) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('exit')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('noexit')
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.offenceInitialised) ? _c('div', [_c('Offence', {
    key: _vm.offenceBindId,
    ref: "offence",
    attrs: {
      "parent_update_function": _vm.loadInspection,
      "region_id": _vm.inspection.region_id,
      "district_id": _vm.inspection.district_id,
      "allocated_group_id": _vm.inspection.allocated_group_id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sanctionOutcomeInitialised) ? _c('div', [_c('SanctionOutcome', {
    ref: "sanction_outcome",
    attrs: {
      "parent_update_function": _vm.loadInspection
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('InspectionWorkflow', {
    key: _vm.workflowBindId,
    ref: "inspection_workflow",
    attrs: {
      "workflow_type": _vm.workflow_type
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "DataTable"
    }
  }, [_c('table', {
    class: _vm.stylingClass,
    attrs: {
      "cellspacing": "0",
      "width": "100%",
      "id": _vm.id
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.dtHeaders), function(header, i) {
    return _c('th', {
      attrs: {
        "data-class": (i == 0) ? 'expand' : null
      }
    }, [_vm._v(" " + _vm._s(header))])
  }), 0)]), _vm._v(" "), _c('tbody')])])
},staticRenderFns: []}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-9",
    domProps: {
      "innerHTML": _vm._s(_vm.help_text)
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "proposedIssuanceLicence"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.title,
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "licenceForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.applicationSelectedActivitiesForPurposes), function(a, index) {
    return _c('div', {
      key: ("a_" + index),
      staticClass: "col-sm-12"
    }, [(_vm.canAssignOfficerFor(a.licence_activity)) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selected_activity_tab_id === a.licence_activity),
        expression: "selected_activity_tab_id === a.licence_activity"
      }]
    }, _vm._l((a.proposed_purposes), function(p, p_idx) {
      return _c('div', {
        key: ("p_" + p_idx)
      }, [_c('div', {
        staticClass: "panel panel-primary"
      }, [_c('div', {
        staticClass: "panel-heading"
      }, [_c('h4', {
        staticClass: "panel-title"
      }, [_vm._v(_vm._s(p.purpose.short_name) + "\n                                                        "), _c('a', {
        staticClass: "panelClicker",
        attrs: {
          "href": "#" + p_idx + index + _vm.purposeBody,
          "data-toggle": "collapse",
          "data-parent": "#userInfo",
          "expanded": "true",
          "aria-controls": _vm.purposeBody
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-chevron-down pull-right "
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "panel-body panel-collapse collapse",
        attrs: {
          "id": "" + p_idx + index + _vm.purposeBody
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-sm-12"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getPickedPurpose(p.purpose.id).isProposed),
          expression: "getPickedPurpose(p.purpose.id).isProposed"
        }],
        attrs: {
          "type": "radio",
          "id": p.purpose.id
        },
        domProps: {
          "value": true,
          "checked": _vm._q(_vm.getPickedPurpose(p.purpose.id).isProposed, true)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.getPickedPurpose(p.purpose.id), "isProposed", true)
          }
        }
      }), _vm._v(" Issue  \n                                                                "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getPickedPurpose(p.purpose.id).isProposed),
          expression: "getPickedPurpose(p.purpose.id).isProposed"
        }],
        attrs: {
          "type": "radio",
          "id": p.purpose.id
        },
        domProps: {
          "value": false,
          "checked": _vm._q(_vm.getPickedPurpose(p.purpose.id).isProposed, false)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.getPickedPurpose(p.purpose.id), "isProposed", false)
          }
        }
      }), _vm._v(" Decline  \n                                                            ")]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-3"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        ref: ("start_date_" + (p.id)),
        refInFor: true,
        staticClass: "input-group date",
        staticStyle: {
          "width": "100%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.proposed_start_date),
          expression: "p.proposed_start_date"
        }],
        staticClass: "form-control",
        attrs: {
          "readonly": !_vm.canEditLicenceDates && p.proposed_start_date,
          "type": "text",
          "name": ("start_date_" + (p.id)),
          "placeholder": "DD/MM/YYYY"
        },
        domProps: {
          "value": (p.proposed_start_date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "proposed_start_date", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-calendar"
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-3"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        ref: ("end_date_" + (p.id)),
        refInFor: true,
        staticClass: "input-group date",
        staticStyle: {
          "width": "100%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.proposed_end_date),
          expression: "p.proposed_end_date"
        }],
        staticClass: "form-control",
        attrs: {
          "readonly": !_vm.canEditLicenceDates && p.proposed_end_date,
          "type": "text",
          "name": ("end_date_" + (p.id)),
          "placeholder": "DD/MM/YYYY"
        },
        domProps: {
          "value": (p.proposed_end_date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "proposed_end_date", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "input-group-addon"
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-calendar"
      })])]) : _vm._e()])]), _vm._v(" "), (_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-12"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }, [_c('label', {
        staticClass: "control-label pull-left",
        attrs: {
          "for": "Name"
        }
      }, [_vm._v("Additional Fee")])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.additional_fee),
          expression: "p.additional_fee"
        }],
        ref: "licence_fee",
        refInFor: true,
        staticClass: "form-control",
        staticStyle: {
          "width": "20%"
        },
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (p.additional_fee)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "additional_fee", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-12"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }, [_c('label', {
        staticClass: "control-label pull-left",
        attrs: {
          "for": "Name"
        }
      }, [_vm._v("Fee Description 1")])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.additional_fee_text),
          expression: "p.additional_fee_text"
        }],
        ref: "licence_fee_text",
        refInFor: true,
        staticClass: "form-control",
        staticStyle: {
          "width": "70%"
        },
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (p.additional_fee_text)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "additional_fee_text", $event.target.value)
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _vm._l((p.purpose_species_json), function(free_text, pt_idx) {
        return _c('div', {
          key: ("pt_" + pt_idx)
        }, [_c('br'), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12"
        }, [_c('div', {
          staticClass: "col-sm-3"
        }, [_c('label', {
          staticClass: "control-label pull-left",
          attrs: {
            "for": "Name"
          }
        }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (free_text.is_additional_info),
            expression: "free_text.is_additional_info"
          }]
        }, [_c('br'), _c('br'), _vm._v(" "), _c('input', {
          attrs: {
            "type": "checkbox",
            "checked": "",
            "disabled": ""
          }
        }), _vm._v(" "), _c('label', [_vm._v("Is additional info")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-9"
        }, [_c('ckeditor', {
          ref: "ap_text_detail",
          refInFor: true,
          attrs: {
            "config": _vm.editorConfig
          },
          model: {
            value: (free_text.details),
            callback: function($$v) {
              _vm.$set(free_text, "details", $$v)
            },
            expression: "free_text.details"
          }
        })], 1)])])
      })], 2)])])])
    }), 0)]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Details for Applicant")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propose_issue.reason),
      expression: "propose_issue.reason"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "name": "licence_details"
    },
    domProps: {
      "value": (_vm.propose_issue.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propose_issue, "reason", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Copy email")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propose_issue.cc_email),
      expression: "propose_issue.cc_email"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "text",
      "name": "licence_cc"
    },
    domProps: {
      "value": (_vm.propose_issue.cc_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propose_issue, "cc_email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Documents for Applicant")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "issuance_documents",
    attrs: {
      "name": "issuance-documents",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document"
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryIssuanceDocumentsCollectionId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Details for Approver")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propose_issue.approver_detail),
      expression: "propose_issue.approver_detail"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "name": "licence_details"
    },
    domProps: {
      "value": (_vm.propose_issue.approver_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propose_issue, "approver_detail", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Documents for Approver")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document"
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryEmailCollectionId
    }
  })], 1)])]), _vm._v(" "), _vm._l((_vm.checkedActivities), function(a, idx) {
    return _c('div', [_c('div', {
      staticClass: "form-group"
    }), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "row"
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "row"
    })])])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.issuingLicence) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Proposing Issue")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Propose Issue")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.component.type === 'tab') ? _c('div', _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('compliance-renderer-block', {
      key: ("subcomponent_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance,
        "readonlyForm": _vm.readonlyForm
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'section') ? _c('FormSection', {
    attrs: {
      "label": _vm.component.label,
      "Index": _vm.component_name,
      "id": _vm.component_name
    }
  }, _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('compliance-renderer-block', {
      key: ("section_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance,
        "readonlyForm": _vm.readonlyForm
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'group') ? _c('Group', {
    attrs: {
      "label": _vm.component.label,
      "name": _vm.component_name,
      "id": _vm.element_id(),
      "help_text": _vm.help_text,
      "help_text_url": _vm.help_text_url,
      "isRemovable": true
    }
  }, _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('compliance-renderer-block', {
      key: ("group_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance,
        "readonlyForm": _vm.readonlyForm
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'text') ? _c('TextField', {
    attrs: {
      "type": "text",
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'string') ? _c('TextField', {
    attrs: {
      "type": "string",
      "name": _vm.component.name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'number') ? _c('TextField', {
    attrs: {
      "type": "number",
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "min": _vm.component.min,
      "max": _vm.component.max,
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'email') ? _c('TextField', {
    attrs: {
      "type": "email",
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'select') ? _c('div', [_c('SelectBlock', {
    attrs: {
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "options": _vm.component.options,
      "help_text": _vm.help_text,
      "handleChange": _vm.handleComponentChange(_vm.component, true),
      "conditions": _vm.component.conditions,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }), _vm._v(" "), _c('SelectConditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "data": _vm.json_data,
      "id": _vm.element_id(1),
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'multi-select') ? _c('SelectBlock', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "options": _vm.component.options,
      "help_text": _vm.help_text,
      "handleChange": _vm.handleComponentChange(_vm.component, false),
      "readonly": _vm.is_readonly,
      "isMultiple": true,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'text_area') ? _c('TextAreaBlock', {
    attrs: {
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'table') ? _c('TableBlock', {
    attrs: {
      "headers": _vm.component.headers,
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'expander_table') ? _c('ExpanderTable', {
    attrs: {
      "field_data": _vm.value,
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "component": _vm.component,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'label') ? _c('LabelBlock', {
    attrs: {
      "value": _vm.component.label,
      "id": _vm.element_id()
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'radiobuttons') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "inline",
    attrs: {
      "id": _vm.element_id()
    }
  }, [_vm._v(_vm._s(_vm.component.label))]), _vm._v(" "), _c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  }), _vm._v(" "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  }), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.component.label,
      "name": _vm.component_name,
      "field_data": _vm.value
    }
  }), _vm._v(" "), _vm._l((_vm.component.options), function(option, index) {
    return _c('Radio', {
      key: ("radio_" + _vm.component_name + "_" + index),
      attrs: {
        "name": _vm.component_name,
        "label": option.label,
        "value": option.value,
        "isRequired": option.isRequired || _vm.component.isRequired,
        "id": _vm.element_id(1),
        "savedValue": _vm.value,
        "handleChange": _vm.handleComponentChange(_vm.component),
        "conditions": _vm.component.conditions,
        "readonly": _vm.is_readonly
      }
    })
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.json_data,
      "id": _vm.element_id(2),
      "readonly": _vm.is_readonly
    }
  })], 2) : _vm._e(), _vm._v(" "), (_vm.component.type === 'checkbox') ? _c('div', {
    staticClass: "form-group"
  }, [_c('Checkbox', {
    attrs: {
      "group": _vm.component.group,
      "name": _vm.component_name,
      "label": _vm.component.label,
      "id": _vm.element_id(1),
      "help_text": _vm.help_text,
      "help_text_url": _vm.help_text_url,
      "field_data": _vm.value,
      "handleChange": _vm.handleComponentChange(_vm.component),
      "conditions": _vm.component.conditions,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired
    }
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.json_data,
      "id": _vm.element_id(2),
      "isRequired": _vm.component.isRequired
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'declaration') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.component.label))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "help_text": _vm.component.help_text,
      "handleChange": _vm.handleComponentChange(_vm.component),
      "conditions": _vm.component.conditions
    }
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.value
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'file' && _vm.parent_id) ? _c('File', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "isRepeatable": _vm.strToBool(_vm.component.isRepeatable),
      "readonly": _vm.is_readonly,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "documentActionUrl": _vm.documentActionUrl,
      "help_text_url": _vm.help_text_url
    }
  }) : (_vm.component.type === 'file' && !_vm.parent_id) ? _c('File', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "isRepeatable": _vm.strToBool(_vm.component.isRepeatable),
      "readonly": _vm.is_readonly,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "documentActionUrl": "temporary_document",
      "help_text_url": _vm.help_text_url
    },
    on: {
      "update-temp-doc-coll-id": _vm.addToTemporaryDocumentCollectionList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'date') ? _c('DateField', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "readonly": _vm.is_readonly,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'grid') ? _c('GridBlock', {
    attrs: {
      "name": _vm.component.name,
      "headers": _vm.component.headers,
      "field_data": _vm.component.data,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Call/Email: " + _vm._s(_vm.call_email.number))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 pull-right"
  }, [(_vm.call_email.user_is_volunteer) ? _c('input', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Create Duplicate Call/Email"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.duplicate($event)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Workflow \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.statusDisplay)), _c('br')])]), _vm._v(" "), (_vm.assignToVisible) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.assigned_to_id),
      expression: "call_email.assigned_to_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.call_email.user_in_group
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.call_email, "assigned_to_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateAssignedToId()
      }]
    }
  }, _vm._l((_vm.call_email.allocated_group), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.full_name) + " \n                            ")])
  }), 0)])]), _vm._v(" "), (_vm.call_email.user_in_group) ? _c('div', [_c('a', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        return _vm.updateAssignedToId('current_user')
      }
    }
  }, [_vm._v("\n                              Assign to me\n                          ")])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Action \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [(_vm.statusId === 'draft' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "forwardToWildlifeProtectionBranch",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('forward_to_wildlife_protection_branch')
      }
    }
  }, [_vm._v("\n                              Forward to Wildlife Protection Branch\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'draft' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "forwardToRegions",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('forward_to_regions')
      }
    }
  }, [_vm._v("\n                              Forward to Regions\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'open_followup' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.openOffence()
      }
    }
  }, [_vm._v("\n                              Offence\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'open_followup' && _vm.canUserAction && this.offenceExists) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.openSanctionOutcome()
      }
    }
  }, [_vm._v("\n                              Sanction Outcome\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'open' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "allocateForFollowUp",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('allocate_for_follow_up')
      }
    }
  }, [_vm._v("\n                              Allocate for Follow Up\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'open' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "allocateForInspection",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.allocateForInspection()
      }
    }
  }, [_vm._v("\n                              Allocate for Inspection\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.statusId === 'open' && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "allocateForLegalCase",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.allocateForLegalCase()
      }
    }
  }, [_vm._v("\n                              Allocate for Case\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.closeButtonVisibility && _vm.canUserAction) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    ref: "close",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('close')
      }
    }
  }, [_vm._v("\n                              Close\n                            ")])])]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills aho2"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.cTab
    }
  }, [_vm._v("Call/Email")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.rTab
    }
  }, [_vm._v("Related Items")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.cTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Caller",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 form-group"
  }, [_c('label', {
    staticClass: "col-sm-12"
  }, [_vm._v("Caller name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.caller),
      expression: "call_email.caller"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.call_email.caller)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "caller", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-12"
  }, [_vm._v("Caller contact information")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.caller_phone_number),
      expression: "call_email.caller_phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.call_email.caller_phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "caller_phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Anonymous call?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.anonymous_call),
      expression: "call_email.anonymous_call"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "anon_yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.call_email.anonymous_call, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "anonymous_call", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "anon_yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.anonymous_call),
      expression: "call_email.anonymous_call"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "anon_no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.call_email.anonymous_call, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "anonymous_call", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "anon_no"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusId !== 'draft'),
      expression: "statusId !=='draft'"
    }]
  }, [_c('SearchPersonOrganisation', {
    key: _vm.updateSearchPersonOrganisationBindId,
    ref: "search_person_organisation",
    attrs: {
      "parentEntity": _vm.callerEntity,
      "isEditable": _vm.personSearchVisibility,
      "classNames": "form-control",
      "initialSearchType": "individual",
      "showCreateUpdate": "",
      "personOnly": ""
    },
    on: {
      "entity-selected": _vm.entitySelected
    }
  })], 1)]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Location *",
      "Index": "1"
    }
  }, [(_vm.call_email.location) ? _c('div', [_c('MapLocation', {
    key: _vm.call_email.location.id,
    attrs: {
      "isReadonly": _vm.readonlyForm
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Details",
      "Index": "2"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Date of call")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "dateOfCallPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.date_of_call),
      expression: "call_email.date_of_call"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.call_email.date_of_call)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "date_of_call", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Time of call")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "timeOfCallPicker"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.time_of_call),
      expression: "call_email.time_of_call"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.call_email.time_of_call)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "time_of_call", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Volunteer")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.volunteer_id),
      expression: "call_email.volunteer_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.call_email, "volunteer_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.call_email.volunteer_list), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.full_name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Use occurrence from/to")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_from_to),
      expression: "call_email.occurrence_from_to"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "radio",
      "id": "occurenceYes"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.call_email.occurrence_from_to, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "occurrence_from_to", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "occurenceYes"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_from_to),
      expression: "call_email.occurrence_from_to"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "radio",
      "id": "occurenceNo"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.call_email.occurrence_from_to, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "occurrence_from_to", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "occurenceNo"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.occurrenceDateLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    ref: "occurrenceDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_date_from),
      expression: "call_email.occurrence_date_from"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.call_email.occurrence_date_from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "occurrence_date_from", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.call_email.occurrence_from_to),
      expression: "call_email.occurrence_from_to"
    }]
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    ref: "occurrenceDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_date_to),
      expression: "call_email.occurrence_date_to"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.call_email.occurrence_date_to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "occurrence_date_to", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.occurrenceTimeLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "occurrenceTimeStartPicker"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_time_start),
      expression: "call_email.occurrence_time_start"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.call_email.occurrence_time_start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "occurrence_time_start", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.call_email.occurrence_from_to),
      expression: "call_email.occurrence_from_to"
    }]
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Occurrence time to")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "occurrenceTimeEndPicker"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.occurrence_time_end),
      expression: "call_email.occurrence_time_end"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.call_email.occurrence_time_end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "occurrence_time_end", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Classification *")]), _vm._v(" "), _c('div', _vm._l((_vm.classification_types), function(option) {
    return _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.classification_id),
        expression: "call_email.classification_id"
      }],
      key: option.id,
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "radio",
        "id": 'classification_' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": _vm._q(_vm.call_email.classification_id, option.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.call_email, "classification_id", option.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'classification_' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Call Type *")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, _vm._l((_vm.call_types), function(option) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.call_type_id),
        expression: "call_email.call_type_id"
      }],
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "radio",
        "id": 'call_type_' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": _vm._q(_vm.call_email.call_type_id, option.id)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.call_email, "call_type_id", option.id)
        }, function($event) {
          return _vm.filterWildcareSpeciesType($event, option.all_wildcare_species)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'call_type_' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Wildcare Species Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.wildcare_species_type_id),
      expression: "call_email.wildcare_species_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.call_email, "wildcare_species_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.filterWildcareSpeciesSubType()
      }]
    }
  }, _vm._l((_vm.filter_wildcare_species_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.display) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Wildcare Species Sub Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.wildcare_species_sub_type_id),
      expression: "call_email.wildcare_species_sub_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.speciesSubTypeDisabled
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.call_email, "wildcare_species_sub_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.filter_wildcare_species_sub_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.display) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Age")]), _vm._v(" "), _c('div', _vm._l((_vm.age_choices), function(option) {
    return _c('div', {
      staticClass: "col-sm-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.age),
        expression: "call_email.age"
      }],
      key: option.id,
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox",
        "id": 'age_' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": Array.isArray(_vm.call_email.age) ? _vm._i(_vm.call_email.age, option.id) > -1 : (_vm.call_email.age)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.call_email.age,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.call_email, "age", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.call_email, "age", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.call_email, "age", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'age_' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Dead")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.dead),
      expression: "call_email.dead"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "deadYes",
      "type": "radio",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.call_email.dead, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "dead", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "deadYes"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.dead),
      expression: "call_email.dead"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "deadNo",
      "type": "radio",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.call_email.dead, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "dead", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "deadNo"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Euthanise")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.euthanise),
      expression: "call_email.euthanise"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "euthaniseYes",
      "type": "radio",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.call_email.euthanise, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "euthanise", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "euthaniseYes"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.euthanise),
      expression: "call_email.euthanise"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "euthaniseNo",
      "type": "radio",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.call_email.euthanise, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.call_email, "euthanise", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "euthaniseNo"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Female / Male")]), _vm._v(" "), _c('div', _vm._l((_vm.gender_choices), function(option) {
    return _c('div', {
      staticClass: "col-sm-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.gender),
        expression: "call_email.gender"
      }],
      key: option.id,
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox",
        "id": 'gender_' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": Array.isArray(_vm.call_email.gender) ? _vm._i(_vm.call_email.gender, option.id) > -1 : (_vm.call_email.gender)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.call_email.gender,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.call_email, "gender", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.call_email, "gender", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.call_email, "gender", $$c)
          }
        }, _vm.checkFemalePinkyJoey]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'gender_' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]), _vm._v(" "), (_vm.isFemalePinkyJoey) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Pinky / Joey")]), _vm._v(" "), _c('div', _vm._l((_vm.baby_kangaroo_choices), function(option) {
    return _c('div', {
      staticClass: "col-sm-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.baby_kangaroo),
        expression: "call_email.baby_kangaroo"
      }],
      key: option.id,
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox",
        "id": 'babyKangaroo' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": Array.isArray(_vm.call_email.baby_kangaroo) ? _vm._i(_vm.call_email.baby_kangaroo, option.id) > -1 : (_vm.call_email.baby_kangaroo)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.call_email.baby_kangaroo,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.call_email, "baby_kangaroo", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.call_email, "baby_kangaroo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.call_email, "baby_kangaroo", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'babyKangaroo' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Number of Animals")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.number_of_animals),
      expression: "call_email.number_of_animals"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.call_email.number_of_animals)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "number_of_animals", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Brief nature of call *")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.brief_nature_of_call),
      expression: "call_email.brief_nature_of_call"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.call_email.brief_nature_of_call)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "brief_nature_of_call", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Entangled")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8",
    staticStyle: {
      "padding": "0px"
    }
  }, _vm._l((_vm.entangled_choices), function(option) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.call_email.entangled),
        expression: "call_email.entangled"
      }],
      key: option.id,
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox",
        "id": 'entangled_' + option.id
      },
      domProps: {
        "value": option.id,
        "checked": Array.isArray(_vm.call_email.entangled) ? _vm._i(_vm.call_email.entangled, option.id) > -1 : (_vm.call_email.entangled)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.call_email.entangled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.call_email, "entangled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.call_email, "entangled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.call_email, "entangled", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'entangled_' + option.id
      }
    }, [_vm._v(_vm._s(option.display))])])
  }), 0)])]), _vm._v(" "), (_vm.isEntangledOther) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Entangled Other")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.entangled_other),
      expression: "call_email.entangled_other"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.call_email.entangled_other)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "entangled_other", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.current_schema), function(item, index) {
    return (_vm.rendererVisibility) ? _c('div', [_c('compliance-renderer-block', {
      key: ("compliance_renderer_block_" + index),
      attrs: {
        "component": item,
        "readonlyForm": _vm.readonlyForm
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), ((_vm.call_email.referrer && _vm.call_email.referrer.length > 0) || _vm.call_email.advice_details) ? _c('FormSection', {
    attrs: {
      "formCollapse": true,
      "label": "Outcome",
      "Index": "3"
    }
  }, [(_vm.call_email.referrer && _vm.call_email.referrer.length > 0) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Referred To")]), _vm._v(" "), _c('select', {
    ref: "referrerList",
    staticClass: "form-control input-sm",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "multiple": "multiple"
    }
  }, _vm._l((_vm.call_email.referrer), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                " + _vm._s(option.name) + " \n                              ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.call_email.advice_details) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Advice details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.advice_details),
      expression: "call_email.advice_details"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": true,
      "rows": "5"
    },
    domProps: {
      "value": (_vm.call_email.advice_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email, "advice_details", $event.target.value)
      }
    }
  })])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.rTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.relatedItemsVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": !_vm.canUserAction
    }
  })], 1) : _vm._e()])])])], 1)])])])]), _vm._v(" "), (_vm.call_email.can_user_action) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('exit')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('noexit')
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.workflow_type) ? _c('div', [_c('CallWorkflow', {
    key: _vm.workflowBindId,
    ref: "add_workflow",
    attrs: {
      "workflow_type": _vm.workflow_type
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Offence', {
    key: _vm.offenceBindId,
    ref: "offence",
    attrs: {
      "region_id": _vm.call_email.region_id,
      "district_id": _vm.call_email.district_id,
      "allocated_group_id": _vm.call_email.allocated_group_id
    }
  }), _vm._v(" "), (_vm.sanctionOutcomeInitialised) ? _c('div', [_c('SanctionOutcome', {
    ref: "sanction_outcome"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.inspectionInitialised) ? _c('div', [_c('Inspection', {
    ref: "inspection"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.legalCaseInitialised) ? _c('div', [_c('CreateLegalCaseModal', {
    ref: "legal_case"
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Currently assigned to")]), _c('br')])])
}]}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalDash"
    }
  }, [_c('LicenceDashTable', {
    attrs: {
      "level": "internal",
      "url": _vm.licences_url
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CreateLegalCase"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Create New Case",
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Region")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.region_id),
      expression: "region_id"
    }],
    staticClass: "form-control col-sm-9",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.region_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.preventDefault();
        return _vm.updateDistricts()
      }]
    }
  }, _vm._l((_vm.regions), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("District")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.district_id),
      expression: "district_id"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.district_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.preventDefault();
        return _vm.updateAllocatedGroup()
      }]
    }
  }, _vm._l((_vm.availableDistricts), function(option) {
    return _c('option', {
      key: option.district_id,
      domProps: {
        "value": option.district_id
      }
    }, [_vm._v("\n                              " + _vm._s(option.district_name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Allocate to")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assigned_to_id),
      expression: "assigned_to_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assigned_to_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allocatedGroup), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.full_name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Title")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legalCaseTitle),
      expression: "legalCaseTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.legalCaseTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.legalCaseTitle = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Case priority")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legal_case_priority_id),
      expression: "legal_case_priority_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.legal_case_priority_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.legalCasePriorities), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.case_priority) + "\n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legalCaseDetails),
      expression: "legalCaseDetails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add details",
      "id": "details"
    },
    domProps: {
      "value": (_vm.legalCaseDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.legalCaseDetails = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document"
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryDocumentCollectionId
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }, [_vm._v(_vm._s(_vm.errorResponse))])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Sanction Outcomes "), (_vm.is_external) ? _c('small', [_vm._v("View any sanction outcome issued to you, pay any infringement notice and follow up on any remediation action")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterType),
      expression: "filterType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sanction_outcome_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                    " + _vm._s(option.display) + "\n                                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sanction_outcome_statuses), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                    " + _vm._s(option.display) + "\n                                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Payment status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterPaymentStatus),
      expression: "filterPaymentStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterPaymentStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sanction_outcome_payment_statuses), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                    " + _vm._s(option.display) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Issue date from")]), _vm._v(" "), _c('div', {
    ref: "issueDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateFrom),
      expression: "filterDateFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Issue date to")]), _vm._v(" "), _c('div', {
    ref: "issueDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateTo),
      expression: "filterDateTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateTo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "sanction_outcome_table",
    attrs: {
      "id": "datatable_id",
      "dtOptions": _vm.table_options,
      "dtHeaders": _vm.table_headers
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
}]}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("FER Case Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ferCaseNumber1st),
      expression: "ferCaseNumber1st"
    }],
    staticClass: "form-control case_number_1",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "fer_case_number_1st",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.ferCaseNumber1st)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ferCaseNumber1st = $event.target.value
      }
    }
  }), _vm._v(" / \n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ferCaseNumber2nd),
      expression: "ferCaseNumber2nd"
    }],
    staticClass: "form-control case_number_2",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "fer_case_number_2nd",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.ferCaseNumber2nd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ferCaseNumber2nd = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorResponse)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processingDetails) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : (_vm.fieldsFilled) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalInspectionDash"
    }
  }, [_c('FormSection', {
    attrs: {
      "label": "Inspection",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterInspectionType),
      expression: "filterInspectionType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterInspectionType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.inspectionTypes), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.inspection_type
      }
    }, [_vm._v("\n                        " + _vm._s(option.inspection_type) + " \n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statusChoices), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.display
      }
    }, [_vm._v("\n                        " + _vm._s(option.display) + "\n                    ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Planned From")]), _vm._v(" "), _c('div', {
    ref: "plannedDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterPlannedFrom),
      expression: "filterPlannedFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterPlannedFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterPlannedFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Planned To")]), _vm._v(" "), _c('div', {
    ref: "plannedDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterPlannedTo),
      expression: "filterPlannedTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterPlannedTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterPlannedTo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 pull-right"
  }, [(_vm.visibilityCreateNewButton) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createInspection($event)
      }
    }
  }, [_vm._v("New Inspection")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "inspection_table",
    attrs: {
      "id": "inspection-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "label": "Location",
      "Index": "1"
    }
  }, [_c('MapLocations')], 1), _vm._v(" "), (_vm.inspectionInitialised) ? _c('div', [_c('InspectionModal', {
    key: _vm.createInspectionBindId,
    ref: "add_inspection"
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "access-menu"
    }
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Submission")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Submitted by")]), _c('br'), _vm._v("\n                        " + _vm._s(_vm.showSubmitter) + "\n                    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Lodged on")]), _c('br'), _vm._v("\n                        " + _vm._s(_vm._f("formatDate")(_vm.returns.lodgement_date)) + "\n                    ")]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Workflow")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                        " + _vm._s(_vm.returns.processing_status) + "\n                    ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssignToList),
      expression: "showAssignToList"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Assigned Officer")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [
    [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.returns.assigned_to),
        expression: "returns.assigned_to"
      }],
      ref: "assigned_to",
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.returns, "assigned_to", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.returns.activity_curators), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))])
    }), 0), _vm._v(" "), _c('a', {
      staticClass: "actionBtn pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.assignToMe()
        }
      }
    }, [_vm._v("Assign to me")])]
  ], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAssignToList),
      expression: "!showAssignToList"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showActionButtons),
      expression: "showActionButtons"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Action")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "255px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptReturn()
      }
    }
  }, [_vm._v("Accept")]), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-md",
    staticStyle: {
      "width": "255px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.amendmentRequest()
      }
    }
  }, [_vm._v("Request Amendment")]), _vm._v(" "), _c('br'), _c('br')])])])])]), _vm._v(" "), _c('AmendmentRequest', {
    ref: "amendment_request"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('table', {
    staticClass: "table small-table"
  }, [_c('tr', [_c('th', [_vm._v("Lodgement")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('br')])
}]}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "entity-selector"
    }
  }, [_vm._v("Select entity")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedEntity),
      expression: "selectedEntity"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "entity-selector"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedEntity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "call_email"
    }
  }, [_vm._v("Call / Email")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inspection"
    }
  }, [_vm._v("Inspection")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "offence"
    }
  }, [_vm._v("Offence")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sanction_outcome"
    }
  }, [_vm._v("Sanction Outcome")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "legal_case"
    }
  }, [_vm._v("Case")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    ref: "elemId",
    staticClass: "form-control no-label",
    attrs: {
      "id": _vm.elemId,
      "readonly": _vm.readonlyForm,
      "placeholder": "Begin typing to search"
    }
  })]), _vm._v(" "), (!_vm.readonlyForm) ? _c('div', {
    staticClass: "col-sm-3 no-label"
  }, [_c('a', {
    ref: "add_weak_link",
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.callCreateWeakLink
    }
  }, [_vm._v("Add")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('label', {
    attrs: {
      "for": "comment"
    }
  }, [_vm._v("Add comment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    ref: "comment",
    staticClass: "form-control",
    attrs: {
      "id": "comment",
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "id": _vm.id
    }
  }, [_c('input', {
    ref: "Checkbox",
    attrs: {
      "name": _vm.name,
      "type": "checkbox",
      "data-parsley-required": "",
      "required": _vm.isRequired
    },
    domProps: {
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleDeclaration
    }
  }), _vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), (_vm.help_text) ? [_c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.help_text))])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "RunningSheetHistory"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('datatable', {
    ref: "running_sheet_hist_instance",
    attrs: {
      "id": "running-sheet-hist-instance",
      "dtOptions": _vm.dtOptionsRunningSheetHistory,
      "dtHeaders": _vm.dtHeadersRunningSheetHistory,
      "parentStyle": " "
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }, [_vm._v(_vm._s(_vm.errorResponse))])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    class: _vm.componentClass
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.legalCaseExists) ? _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  })]) : _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.newTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('objectTab')
      }
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.existingTab
    }
  }, [_vm._v("Existing")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.newTab
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: _vm.objectTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.objectTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('objectTab')
      }
    }
  }, [_vm._v("Object")])]), _vm._v(" "), _c('li', {
    class: _vm.detailsTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.detailsTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('detailsTab')
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
    class: _vm.storageTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.storageTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('storageTab')
      }
    }
  }, [_vm._v("Storage")])]), _vm._v(" "), _c('li', {
    class: _vm.disposalTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.disposalTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('disposalTab')
      }
    }
  }, [_vm._v("Disposal")])]), _vm._v(" "), (!_vm.parentModal) ? _c('li', {
    class: _vm.relatedItemsTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.relatedItemsTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('relatedItemsTab')
      }
    }
  }, [_vm._v("Related Items")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    class: _vm.objectTabClass,
    attrs: {
      "id": _vm.objectTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": _vm.artifactTypeDisplay,
      "Index": "0",
      "hideHeader": !_vm.physicalArtifactIdExists
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Physical Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.physical_artifact_type_id),
      expression: "physical_artifact.physical_artifact_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.physical_artifact, "physical_artifact_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadSchema]
    }
  }, _vm._l((_vm.physicalArtifactTypes), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                                  " + _vm._s(option.artifact_type_display) + "\n                                                ")])
  }), 0)])])])]), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-6"
  }, [_vm._v("Object used within this case?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.used_within_case),
      expression: "physical_artifact.used_within_case"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.physical_artifact.used_within_case, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.physical_artifact, "used_within_case", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.used_within_case),
      expression: "physical_artifact.used_within_case"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.physical_artifact.used_within_case, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.physical_artifact, "used_within_case", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "no"
    }
  }, [_vm._v("No")])])]) : _vm._e(), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-6"
  }, [_vm._v("Object is sensitive / non-disclosable?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.sensitive_non_disclosable),
      expression: "physical_artifact.sensitive_non_disclosable"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.physical_artifact.sensitive_non_disclosable, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.physical_artifact, "sensitive_non_disclosable", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.sensitive_non_disclosable),
      expression: "physical_artifact.sensitive_non_disclosable"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.physical_artifact.sensitive_non_disclosable, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.physical_artifact, "sensitive_non_disclosable", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "no"
    }
  }, [_vm._v("No")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.identifier),
      expression: "physical_artifact.identifier"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.physical_artifact.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "identifier", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Officer")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    ref: "physical_artifact_officers",
    staticClass: "form-control",
    attrs: {
      "id": "physical_artifact_officers",
      "name": "physical_artifact_officers"
    }
  })])])]), _vm._v(" "), (_vm.statementVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Statement")])]), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.statement_id),
      expression: "physical_artifact.statement_id"
    }],
    ref: "setStatement",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.physical_artifact, "statement_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.legal_case.statement_artifacts), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                                " + _vm._s(option.document_type_display) + ": " + _vm._s(option.identifier) + "\n                                                ")])
  }), 0)]) : _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.statement_id),
      expression: "physical_artifact.statement_id"
    }],
    ref: "setStatement",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.physical_artifact, "statement_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.physical_artifact.available_statement_artifacts), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                                " + _vm._s(option.document_type_display) + ": " + _vm._s(option.identifier) + "\n                                                ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.custodianVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Custodian")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_vm._v("\n                                                        " + _vm._s(_vm.selectedStatementArtifact.custodian) + "\n                                                ")])])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Custodian")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    ref: "physical_artifact_custodians",
    staticClass: "form-control",
    attrs: {
      "id": "physical_artifact_custodians",
      "name": "physical_artifact_custodians"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "artifactDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.artifact_date),
      expression: "physical_artifact.artifact_date"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.physical_artifact.artifact_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "artifact_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "artifactTimePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.artifact_time),
      expression: "physical_artifact.artifact_time"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.physical_artifact.artifact_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "artifact_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.description),
      expression: "physical_artifact.description"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.physical_artifact.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.siezureNoticeVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Seizure Notice")])]), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "default_document",
    attrs: {
      "name": "default_document",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document",
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-temp-doc-coll-id": _vm.addToTemporaryDocumentCollectionList
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "physical_artifact_documents",
    attrs: {
      "name": "physical-artifact-documents",
      "isRepeatable": true,
      "documentActionUrl": _vm.physical_artifact.defaultDocumentUrl,
      "readonly": _vm.readonlyForm
    }
  })], 1)])]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    key: _vm.artifactType,
    class: _vm.detailsTabClass,
    attrs: {
      "id": _vm.detailsTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.detailsSchema), function(item, index) {
    return (_vm.detailsSchemaVisibility) ? _c('div', [_c('compliance-renderer-block', {
      key: ("compliance_renderer_block" + index),
      attrs: {
        "component": item,
        "readonlyForm": _vm.readonlyForm
      },
      on: {
        "update-temp-doc-coll-id": _vm.addToTemporaryDocumentCollectionList
      }
    })], 1) : _vm._e()
  }), 0)])])], 1), _vm._v(" "), _c('div', {
    class: _vm.storageTabClass,
    attrs: {
      "id": _vm.storageTab
    }
  }, [_c('FormSection', {
    key: _vm.artifactType,
    attrs: {
      "formCollapse": false,
      "label": "Storage"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.storageSchema), function(item, index) {
    return (_vm.storageSchemaVisibility) ? _c('div', [_c('compliance-renderer-block', {
      key: ("compliance_renderer_block" + index),
      attrs: {
        "component": item,
        "readonlyForm": _vm.readonlyForm
      }
    })], 1) : _vm._e()
  }), 0)])])], 1), _vm._v(" "), _c('div', {
    class: _vm.disposalTabClass,
    attrs: {
      "id": _vm.disposalTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Disposal"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Disposal Method")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.disposal_method),
      expression: "physical_artifact.disposal_method"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.physical_artifact, "disposal_method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.disposalMethods), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                                              " + _vm._s(option.disposal_method) + "\n                                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "disposalDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.disposal_date),
      expression: "physical_artifact.disposal_date"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.physical_artifact.disposal_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "disposal_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Disposal details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.disposal_details),
      expression: "physical_artifact.disposal_details"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.physical_artifact.disposal_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "disposal_details", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), (!_vm.parentModal) ? _c('div', {
    class: _vm.relatedItemsTabClass,
    attrs: {
      "id": _vm.relatedItemsTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.relatedItemsVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": _vm.readonlyForm,
      "parentComponentName": "physical_artifact"
    }
  })], 1) : _vm._e()])])])], 1) : _vm._e()])]), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "tab-pane fade in li-top-buffer",
    attrs: {
      "id": _vm.existingTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "existing_artifact_table",
    attrs: {
      "id": "existing-artifact-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "inline",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "readonly": "readonly",
      "rows": "5",
      "name": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.field_data.value))]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "content-editable-table"
  }, [_c('table', {
    staticClass: "table table-striped editable-table"
  }, [(_vm.table.thead.length) ? _c('thead', [_c('tr', _vm._l((_vm.table.thead), function(heading, index) {
    return _c('th', [_vm._v("\n                  " + _vm._s(_vm.table.thead[index]) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('tbody', [_vm._l((_vm.table.tbody), function(row) {
    return _c('tr', [_vm._l((row), function(value, index) {
      return _c('td', [((_vm.col_types[index]) === 'checkbox') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row[index]),
          expression: "row[index]"
        }],
        staticClass: "tbl_input",
        attrs: {
          "readonly": _vm.readonly,
          "min": "0",
          "required": _vm.isRequired,
          "onclick": _vm.isClickable,
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(row[index]) ? _vm._i(row[index], null) > -1 : (row[index])
        },
        on: {
          "change": function($event) {
            var $$a = row[index],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(row, index, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(row, index, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(row, index, $$c)
            }
          }
        }
      }) : ((_vm.col_types[index]) === 'radio') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row[index]),
          expression: "row[index]"
        }],
        staticClass: "tbl_input",
        attrs: {
          "readonly": _vm.readonly,
          "min": "0",
          "required": _vm.isRequired,
          "onclick": _vm.isClickable,
          "type": "radio"
        },
        domProps: {
          "checked": _vm._q(row[index], null)
        },
        on: {
          "change": function($event) {
            return _vm.$set(row, index, null)
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (row[index]),
          expression: "row[index]"
        }],
        staticClass: "tbl_input",
        attrs: {
          "readonly": _vm.readonly,
          "min": "0",
          "required": _vm.isRequired,
          "onclick": _vm.isClickable,
          "type": _vm.col_types[index]
        },
        domProps: {
          "value": (row[index])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(row, index, $event.target.value)
          }
        }
      })])
    }), _vm._v(" "), (!_vm.readonly) ? _c('td', [_c('a', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Delete row"
      },
      on: {
        "click": function($event) {
          return _vm.deleteRow(row)
        }
      }
    })]) : _vm._e()], 2)
  }), _vm._v(" "), _c('tr', [(!_vm.readonly) ? _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Add Row"
    },
    on: {
      "click": function($event) {
        return _vm.addRow()
      }
    }
  }, [_vm._v("+")])]) : _vm._e()])], 2)])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalOrgInfo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h3', [_vm._v(_vm._s(_vm.org.name) + " - " + _vm._s(_vm.org.abn))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": "test"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "pills-details",
      "role": "tabpanel",
      "aria-labelledby": "pills-details-tab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Organisation Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "personal_form",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.name),
      expression: "org.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.abn),
      expression: "org.abn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "name": "last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.abn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org, "abn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingDetails) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateDetails()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Address Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.adBody,
      "data-toggle": "collapse",
      "expanded": "false",
      "data-parent": "#userInfo",
      "aria-controls": _vm.adBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), (_vm.loading.length == 0) ? _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.adBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.address.line1),
      expression: "org.address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org.address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.address.locality),
      expression: "org.address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org.address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.address.state),
      expression: "org.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org.address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.address.postcode),
      expression: "org.address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org.address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.address.country),
      expression: "org.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.org.address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(c) {
    return _c('option', {
      key: ("code_" + (c.code)),
      domProps: {
        "value": c.code
      }
    }, [_vm._v(_vm._s(c.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingAddress) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateAddress()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Contact Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.cdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.cdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.cdBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addContact()
      }
    }
  }, [_vm._v("Add Contact")])]), _vm._v(" "), _c('datatable', {
    ref: "contacts_datatable",
    attrs: {
      "id": "organisation_contacts_datatable",
      "dtOptions": _vm.contacts_options,
      "dtHeaders": _vm.contacts_headers
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Linked Persons"), _c('small', [_vm._v(" - Manage the user accounts linked to the organisation")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.oBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.oBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.oBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v(" Organisation User Pin Code 1:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.org.pins ? _vm.org.pins.three : ' '))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organisation User Pin Code 2:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.org.pins ? _vm.org.pins.four : ' '))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v(" Organisation Administrator Pin Code 1:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.org.pins ? _vm.org.pins.one : ' '))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organisation Administrator Pin Code 2:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.org.pins ? _vm.org.pins.two : ' '))])])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_c('datatable', {
    ref: "contacts_datatable_user",
    attrs: {
      "id": "organisation_contacts_datatable_ref",
      "dtOptions": _vm.contacts_options_ref,
      "dtHeaders": _vm.contacts_headers_ref
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "pills-licensing",
      "role": "tabpanel",
      "aria-labelledby": "pills-licensing-tab"
    }
  }, [_c('ApplicationDashTable', {
    ref: "applications_table",
    attrs: {
      "level": "internal",
      "url": _vm.applications_url
    }
  }), _vm._v(" "), _c('LicenceDashTable', {
    ref: "licences_table",
    attrs: {
      "level": "internal",
      "url": _vm.licences_url
    }
  }), _vm._v(" "), _c('ReturnDashTable', {
    ref: "returns_table",
    attrs: {
      "level": "internal",
      "url": _vm.returns_url
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "pills-compliance",
      "role": "tabpanel",
      "aria-labelledby": "pills-compliance-tab"
    }
  }, [(_vm.org.id) ? _c('SanctionOutcomePersonOrgDashTable', {
    ref: "sanction_outcome_person_org_table",
    attrs: {
      "level": "internal",
      "entity_id": _vm.org.id,
      "entity_type": "org"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.org.id) ? _c('IntelligenceInformation', {
    ref: "intelligence_information",
    attrs: {
      "entity_id": _vm.org.id,
      "entity_type": "org"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('AddContact', {
    ref: "add_contact",
    attrs: {
      "org_id": _vm.org.id
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "pills-tab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "id": "pills-details-tab",
      "data-toggle": "pill",
      "href": "#pills-details",
      "role": "tab",
      "aria-controls": "pills-details",
      "aria-selected": "true"
    }
  }, [_vm._v("\n                        Details\n                    ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "pills-licensing-tab",
      "data-toggle": "pill",
      "href": "#pills-licensing",
      "role": "tab",
      "aria-controls": "pills-licensing",
      "aria-selected": "false"
    }
  }, [_vm._v("\n                        Licensing\n                    ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "pills-compliance-tab",
      "data-toggle": "pill",
      "href": "#pills-compliance",
      "role": "tab",
      "aria-controls": "pills-compliance",
      "aria-selected": "false"
    }
  }, [_vm._v("\n                        Compliance\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Persons linked to the organisation are controlled by the organisation. The Department cannot manage this list of people.")])])])])])
}]}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), (_vm.isTableField) ? _c('div', {
    staticClass: "date date-class"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readonly,
      "name": _vm.name,
      "placeholder": "DD/MM/YYYY",
      "required": _vm.isRequired,
      "title": _vm.value
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readonly,
      "name": _vm.name,
      "placeholder": "DD/MM/YYYY",
      "required": _vm.isRequired,
      "title": _vm.value
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
}]}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Return\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [(_vm.isReturnsLoaded) ? _c('div', {
    staticClass: "col-sm-offset-3 col-sm-6 borderDecoration"
  }, [_c('strong', [_vm._v("Your Return has been submitted successfully.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.returns.lodgement_number))])])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('strong', [_vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.returns.lodgement_date)))])])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": _vm.returns.invoice_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    staticStyle: {
      "color": "red"
    }
  })])])])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to dashboard")])]) : _c('div', {
    staticClass: "col-sm-offset-3 col-sm-6 borderDecoration"
  }, [_c('strong', [_vm._v("Sorry it looks like there isn't any details currently in your session.")]), _vm._v(" "), _c('br'), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to dashboard")])])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "table_name"
    },
    domProps: {
      "value": _vm.returns.table[0].name
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Reference number: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Lodgement date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Invoice:")])])
}]}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "expander-label",
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), (_vm.help_text_url) ? [_c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row header-titles-row"
  }, _vm._l((_vm.component.header), function(header, index) {
    return _c('div', {
      key: ("expander_header_" + (_vm.component.name) + "_" + index),
      class: ("col-xs-" + (Math.floor(12 / _vm.component.header.length)))
    }, [_vm._v("\n                " + _vm._s(header.label) + "\n        ")])
  }), 0), _vm._v(" "), _vm._l((_vm.expanderTables), function(table, tableIdx) {
    return _c('div', {
      staticClass: "expander-table"
    }, [_c('div', {
      staticClass: "row header-row"
    }, _vm._l((_vm.component.header), function(header, index) {
      return _c('div', {
        key: ("expander_header_" + (_vm.component.name) + "_" + index),
        class: ("col-xs-" + (Math.floor(12 / _vm.component.header.length)))
      }, [(!index) ? _c('span', {
        class: ("expand-icon " + (_vm.isExpanded(table) ? 'collapse' : '')),
        on: {
          "click": function($event) {
            return _vm.toggleTableVisibility(table)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "header-contents"
      }, [_c('compliance-renderer-block', {
        key: ("expander_header_contents_" + (_vm.component.name) + "_" + index),
        attrs: {
          "component": _vm.removeLabel(header),
          "json_data": _vm.value,
          "instance": table,
          "readonlyForm": _vm.readonly
        }
      })], 1), _vm._v(" "), (tableIdx && index == _vm.component.header.length - 1 && !_vm.readonly) ? _c('a', {
        staticClass: "delete-icon fa fa-trash-o",
        attrs: {
          "title": "Delete row"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeTable(table)
          }
        }
      }) : _vm._e()])
    }), 0), _vm._v(" "), _c('div', {
      class: {
        'hidden': !_vm.isExpanded(table)
      }
    }, _vm._l((_vm.component.expander), function(subcomponent, index) {
      return _c('div', {
        key: ("expander_row_" + (_vm.component.name) + "_" + index),
        staticClass: "row expander-row"
      }, [_c('div', {
        staticClass: "col-xs-12"
      }, [_c('compliance-renderer-block', {
        key: ("expander_contents_" + (_vm.component.name) + "_" + index),
        attrs: {
          "component": subcomponent,
          "json_data": _vm.value,
          "instance": table,
          "readonlyForm": _vm.readonly
        }
      })], 1)])
    }), 0)])
  }), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "row"
  }, [_c('input', {
    staticClass: "btn btn-primary add-new-button",
    attrs: {
      "type": "button",
      "value": "Add New"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewTable($event)
      }
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.help_text) ? _c('span', [(!_vm.showingHelpText) ? [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleHelpText($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" ")])])] : _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleHelpText($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('HelpTextDisplay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingHelpText),
      expression: "showingHelpText"
    }],
    attrs: {
      "help_text": _vm.help_text
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "inline",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), (_vm.readonly) ? [(!_vm.isMultiple) ? _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "id": _vm.selectid,
      "name": _vm.name,
      "data-conditions": _vm.cons
    }
  }, _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      domProps: {
        "value": op.value,
        "selected": op.value == _vm.value
      },
      on: {
        "change": _vm.handleChange
      }
    }, [_vm._v(_vm._s(op.label))])
  }), 0) : _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "id": _vm.selectid,
      "multiple": ""
    }
  }, _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      domProps: {
        "value": op.value,
        "selected": _vm.multipleSelection(op.value)
      }
    }, [_vm._v(_vm._s(op.label))])
  }), 0), _vm._v(" "), (_vm.isMultiple) ? _vm._l((_vm.value), function(v, idx2) {
    return _c('input', {
      key: ("value_" + v + "_" + idx2),
      attrs: {
        "input": "",
        "type": "hidden",
        "name": _vm.name,
        "required": _vm.isRequired
      },
      domProps: {
        "value": v
      }
    })
  }) : [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name,
      "required": _vm.isRequired
    },
    domProps: {
      "value": _vm.value
    }
  })]] : [(!_vm.isMultiple) ? _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.selectid,
      "name": _vm.name,
      "data-conditions": _vm.cons,
      "required": _vm.isRequired
    }
  }, _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      attrs: {
        "selected": "selected"
      },
      domProps: {
        "value": op.value
      }
    }, [_vm._v(_vm._s(op.label))])
  }), 0) : _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.selectid,
      "name": _vm.name,
      "multiple": "",
      "required": _vm.isRequired
    }
  }, _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      attrs: {
        "selected": "selected"
      },
      domProps: {
        "value": op.value
      }
    }, [_vm._v(_vm._s(op.label))])
  }), 0)]], 2)])
},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isApplicationLoaded && !_vm.application_readonly && _vm.isVisible) ? _c('div', [(_vm.visibleRequests.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "red"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 pull-right"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("An amendment has been requested for this Application\n                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#pBody',
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": 'pBody'
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": 'pBody'
    }
  }, _vm._l((_vm.visibleRequests), function(a) {
    return _c('div', [_c('p', [_c('b', [_vm._v("Activity:")]), _vm._v(" " + _vm._s(a.licence_activity.name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Reason:")]), _vm._v(" " + _vm._s(a.reason.name))]), _vm._v(" "), (a.text) ? _c('p', [_c('b', [_vm._v("Details:")])]) : _vm._e(), _vm._l((_vm.splitText(a.text)), function(t) {
      return _c('div', [_vm._v(_vm._s(t)), _c('br')])
    }), _c('p')], 2)
  }), 0)])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isApplicationLoaded) ? _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalApplication"
    }
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                " + _vm._s(error.label) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.headerLabel) + ": " + _vm._s(_vm.application.lodgement_number))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                   Submission \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Submitted by")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.application.submitter.first_name) + " " + _vm._s(_vm.application.submitter.last_name) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Lodged on")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm._f("formatDate")(_vm.application.lodgement_date)) + "\n                        ")]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Workflow \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.application.processing_status.name) + " " + _vm._s(_vm.hasCurrentLicence ? '' : '(attn: No Active License)') + " "), _c('br'), _vm._v(" "), _vm._l((_vm.licence_type_data), function(item) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, _vm._l((item), function(item1) {
      return _c('div', [(item1.name) ? _c('div', [_c('strong', [_vm._v(_vm._s(item1.name) + ": ")]), _vm._v(_vm._s(item1.processing_status.name) + "\n                                    ")]) : _vm._e()])
    }), 0)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssignToOfficer),
      expression: "showAssignToOfficer"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Assigned Officer")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [
    [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedActivity.assigned_officer),
        expression: "selectedActivity.assigned_officer"
      }],
      ref: "assigned_officer",
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selectedActivity, "assigned_officer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.selectedActivity.licensing_officers), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))])
    }), 0), _vm._v(" "), _c('a', {
      staticClass: "actionBtn pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.assignToMe()
        }
      }
    }, [_vm._v("Assign to me")])]
  ], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssignToApprover && !_vm.application_workflow_state),
      expression: "showAssignToApprover && !application_workflow_state"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Assigned Approver")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [
    [_c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedActivity.assigned_approver),
        expression: "selectedActivity.assigned_approver"
      }],
      ref: "assigned_approver",
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selectedActivity, "assigned_approver", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.selectedActivity.issuing_officers), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))])
    }), 0), _vm._v(" "), _c('a', {
      staticClass: "actionBtn pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.makeMeApprover()
        }
      }
    }, [_vm._v("Assign to me")])])]
  ], 2)]), _vm._v(" "), (_vm.isFinalised) ? [_c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Application")]), _c('br'), _vm._v(" "), (_vm.showingApplication && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: false
        })
      }
    }
  }, [_vm._v("Hide Application")]) : (!_vm.showingApplication && _vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleConditions({
          show: false,
          showFinalised: true
        })
      }
    }
  }, [_vm._v("Hide Conditions")]) : _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: true,
          showFinalised: true
        })
      }
    }
  }, [_vm._v("Show Application")]), _c('br'), _vm._v(" "), ((!_vm.showingApplication || !this.unfinishedActivities.length) && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleConditions({
          show: true
        })
      }
    }
  }, [_vm._v("Show Conditions")]) : _vm._e()])])] : _vm._e(), _vm._v(" "), (_vm.isFinalised) ? [_vm._m(2)] : _vm._e(), _vm._v(" "), ((_vm.canIssueDecline && _vm.approvingApplication && !_vm.application_workflow_state) || _vm.notOfficerWorkflow) ? [_c('div', [_vm._m(3), _vm._v(" "), (_vm.notOfficerWorkflow) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Application")]), _c('br'), _vm._v(" "), (!_vm.showingApplication && _vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicationLink()
      }
    }
  }, [_vm._v("Show Application")]) : (_vm.showingApplication && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicationLink()
      }
    }
  }, [_vm._v("Hide Application2")]) : _vm._e(), _c('br')]) : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Application")]), _c('br'), _vm._v(" "), (!_vm.showingApplication && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicationLink()
      }
    }
  }, [_vm._v("Show Application")]) : (!_vm.showingApplication && _vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionConditionLink()
      }
    }
  }, [_vm._v("Hide Conditions")]) : (_vm.showingApplication && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicationLink()
      }
    }
  }, [_vm._v("Hide Application")]) : _vm._e(), _c('br'), _vm._v(" "), (!_vm.showingApplication && !_vm.showingConditions) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionConditionLink()
      }
    }
  }, [_vm._v("Show Conditions")]) : _vm._e()])])] : _vm._e(), _vm._v(" "), ((_vm.canIssueDecline && _vm.approvingApplication && !_vm.application_workflow_state) || _vm.notOfficerWorkflow) ? [_vm._m(4)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [(_vm.showingApplication) ? [_vm._m(5), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRequestAmendmentButton && !_vm.application_workflow_state),
      expression: "showRequestAmendmentButton && !application_workflow_state"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.showRequestSpinner && _vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Request Amendment")]) : (!_vm.showRequestSpinner && _vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    attrs: {
      "disabled": "",
      "type": "button"
    }
  }, [_vm._v("Request Amendment")]) : _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicantReturnButton()
      }
    }
  }, [_vm._v("Request Amendment")]), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssessmentConditionButton && !_vm.application_workflow_state),
      expression: "showAssessmentConditionButton && !application_workflow_state"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.showConditionSpinner && _vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Assessments & Conditions")]) : (!_vm.showConditionSpinner && _vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    attrs: {
      "disabled": "",
      "type": "button"
    }
  }, [_vm._v("Assessments & Conditions")]) : _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionConditionButton()
      }
    }
  }, [_vm._v("Assessments & Conditions")]), _c('br')])])] : [_vm._m(6), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackToProcessingButton && !_vm.application_workflow_state),
      expression: "showBackToProcessingButton && !application_workflow_state"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionApplicationButton()
      }
    }
  }, [_vm._v("Back to Processing")]), _c('br')])]), _vm._v(" "), (_vm.canReturnToConditions && !_vm.application_workflow_state) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.actionOfficerReturnButton()
      }
    }
  }, [_vm._v("Return to Officer - Conditions")])])]) : _vm._e(), _vm._v(" "), (_vm.canProposeIssueOrDecline && (_vm.isSendingToAssessor || _vm.showingConditions) && !_vm.application_workflow_state) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.proposedLicence()
      }
    }
  }, [_vm._v("Propose Issue")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.proposedDecline()
      }
    }
  }, [_vm._v("Propose Decline")])])]) : _vm._e(), _vm._v(" "), (_vm.canProposeToOnlyDecline && (_vm.isSendingToAssessor || _vm.showingConditions) && !_vm.application_workflow_state) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.proposedDecline()
      }
    }
  }, [_vm._v("Propose Decline")])])]) : _vm._e()]], 2)], 2)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.canIssueDecline && _vm.isofficerfinalisation) ? [_c('IssueLicence', {
    attrs: {
      "application": _vm.application,
      "licence_activity_tab": _vm.selected_activity_tab_id,
      "applicantType": _vm.applicantType
    },
    on: {
      "action-tab": _vm.actionTabListener
    }
  })] : _vm._e(), _vm._v(" "), (_vm.isSendingToAssessor || _vm.showingConditions) ? _c('ApplicationAssessments', {
    on: {
      "action-tab": _vm.actionTabListener
    }
  }) : _vm._e(), _vm._v(" "), (_vm.applicationDetailsVisible && _vm.showingApplication) ? [_c('div', [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tabs-main",
      "data-tabs": "tabs"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    ref: "applicantTab",
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "pill",
      "href": '#' + _vm.applicantTab
    },
    on: {
      "click": function($event) {
        return _vm.selectApplicantTab()
      }
    }
  }, [_vm._v("Applicant")])]), _vm._v(" "), _vm._l((_vm.allCurrentActivities), function(activity, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [_c('a', {
      class: {
        'nav-link amendment-highlight': _vm.application.has_amendment
      },
      attrs: {
        "data-toggle": "pill",
        "href": '#' + _vm.activityTab
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(activity)
        }
      }
    }, [_vm._v(_vm._s(activity.label))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.applicantTab
    }
  }, [(_vm.showingApplicant) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Applicant\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.detailsBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.detailsBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), (_vm.applicantType == 'org') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.detailsBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.name),
      expression: "application.org_applicant.name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantName",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.abn),
      expression: "application.org_applicant.abn"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantABN",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.abn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant, "abn", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'proxy') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.detailsBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Given Name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.first_name),
      expression: "application.proxy_applicant.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantName",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Surname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.last_name),
      expression: "application.proxy_applicant.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantName",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.dob),
      expression: "application.proxy_applicant.dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantABN",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "dob", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'submitter') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.detailsBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Given Name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.first_name),
      expression: "application.submitter.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantName",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Surname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.last_name),
      expression: "application.submitter.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantName",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.dob),
      expression: "application.submitter.dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantABN",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "dob", $event.target.value)
      }
    }
  })])])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Identification\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.identificationBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.identificationBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), (_vm.applicantType == 'org' && _vm.application.org_applicant.organisation.identification) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.identificationBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "name": "applicantIdentification",
      "src": _vm.application.org_applicant.organisation.identification
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'proxy' && _vm.application.proxy_applicant.identification2) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.identificationBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "name": "applicantIdentification",
      "src": _vm.application.proxy_applicant.identification2
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'submitter' && _vm.application.submitter.identification2) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.identificationBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "btn btn-link btn-file pull-left"
  }, [_c('SecureBaseLink', {
    attrs: {
      "link_name": "Uploaded Photo ID",
      "link_data": {
        'customer_id': _vm.application.submitter.id
      }
    }
  })], 1)])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Address Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.addressBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.addressBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), (_vm.applicantType == 'org' && _vm.application.org_applicant.address) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.addressBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.address.line1),
      expression: "application.org_applicant.address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant.address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.address.locality),
      expression: "application.org_applicant.address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant.address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.address.state),
      expression: "application.org_applicant.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant.address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.address.postcode),
      expression: "application.org_applicant.address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.org_applicant.address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant.address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org_applicant.address.country),
      expression: "application.org_applicant.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country"
    },
    domProps: {
      "value": (_vm.application.org_applicant.address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.org_applicant.address, "country", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'proxy' && _vm.application.proxy_applicant.residential_address) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.addressBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.residential_address.line1),
      expression: "application.proxy_applicant.residential_address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.residential_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant.residential_address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.residential_address.locality),
      expression: "application.proxy_applicant.residential_address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.residential_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant.residential_address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.residential_address.state),
      expression: "application.proxy_applicant.residential_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.residential_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant.residential_address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.residential_address.postcode),
      expression: "application.proxy_applicant.residential_address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.residential_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant.residential_address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.residential_address.country),
      expression: "application.proxy_applicant.residential_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country"
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.residential_address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant.residential_address, "country", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'submitter' && _vm.application.submitter.residential_address) ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.addressBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.residential_address.line1),
      expression: "application.submitter.residential_address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.residential_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter.residential_address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.residential_address.locality),
      expression: "application.submitter.residential_address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.residential_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter.residential_address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.residential_address.state),
      expression: "application.submitter.residential_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.residential_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter.residential_address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.residential_address.postcode),
      expression: "application.submitter.residential_address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.residential_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter.residential_address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.residential_address.country),
      expression: "application.submitter.residential_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "country"
    },
    domProps: {
      "value": (_vm.application.submitter.residential_address.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter.residential_address, "country", $event.target.value)
      }
    }
  })])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Contact Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.contactsBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.contactsBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), (_vm.applicantType == 'org') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.contactsBody
    }
  }, [_c('table', {
    ref: "contacts_datatable",
    staticClass: "hover table table-striped table-bordered dt-responsive",
    attrs: {
      "id": _vm.contacts_table_id,
      "cellspacing": "0",
      "width": "100%"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'proxy') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.contactsBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.phone_number),
      expression: "application.proxy_applicant.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantPhoneNumber",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.mobile_number),
      expression: "application.proxy_applicant.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantMobileNumber",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "mobile_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.proxy_applicant.email),
      expression: "application.proxy_applicant.email"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantEmail",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.proxy_applicant.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.proxy_applicant, "email", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.applicantType == 'submitter') ? _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.contactsBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.phone_number),
      expression: "application.submitter.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantPhoneNumber",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.mobile_number),
      expression: "application.submitter.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantMobileNumber",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "mobile_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.submitter.email),
      expression: "application.submitter.email"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "applicantEmail",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.application.submitter.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application.submitter, "email", $event.target.value)
      }
    }
  })])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Check List\n                                "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.checksBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.checksBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.checksBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("ID Check")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.isIdNotChecked || _vm.isIdCheckUpdated) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptIdRequest()
      }
    }
  }, [_vm._v("Accept")]) : _vm._e(), _vm._v(" "), (_vm.isIdCheckAccepted) ? _c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")]) : _vm._e(), _vm._v(" "), (_vm.isIdCheckRequested) ? _c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Awaiting Update")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.isIdNotChecked) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.application.proxy_applicant
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIdRequest()
      }
    }
  }, [_vm._v("Request Update")]) : _vm._e(), _vm._v(" "), (_vm.isIdCheckUpdated) ? _c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Request updated")]) : _vm._e(), _vm._v(" "), (_vm.isIdCheckAccepted || _vm.isIdCheckRequested) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetIdRequest()
      }
    }
  }, [_vm._v("Reset")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Character Check")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(!_vm.isCharacterCheckAccepted) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptCharacterRequest()
      }
    }
  }, [_vm._v("Accept")]) : _vm._e(), _vm._v(" "), (_vm.isCharacterCheckAccepted) ? _c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.isCharacterCheckAccepted) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetCharacterRequest()
      }
    }
  }, [_vm._v("Reset")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Returns Check")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReturnCheckButton),
      expression: "showReturnCheckButton"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptReturnRequest()
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showReturnCheckButton),
      expression: "!showReturnCheckButton"
    }],
    staticClass: "btn btn-light",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showReturnCheckButton),
      expression: "!showReturnCheckButton"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetReturnRequest()
      }
    }
  }, [_vm._v("Reset")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": _vm.activityTab
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "action": _vm.application_form_url,
      "method": "post",
      "name": "new_application",
      "enctype": "multipart/form-data"
    }
  }, [(_vm.isApplicationLoaded && !_vm.showingApplicant) ? _c('Application', {
    attrs: {
      "form_width": "inherit",
      "withSectionsSelector": false
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "csrfmiddlewaretoken"
    },
    domProps: {
      "value": _vm.csrf_token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "schema"
    },
    domProps: {
      "value": JSON.stringify(_vm.application)
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "application_id"
    },
    domProps: {
      "value": 1
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_activity_tab_id),
      expression: "selected_activity_tab_id"
    }],
    attrs: {
      "type": "hidden",
      "id": "selected_activity_tab_id"
    },
    domProps: {
      "value": (_vm.selected_activity_tab_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected_activity_tab_id = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.allCurrentActivities), function(activity, index) {
    return _c('div', [_c('AmendmentRequestDetails', {
      attrs: {
        "activity_id": activity.id
      }
    }), _vm._v(" "), (activity.id == _vm.selected_activity_tab_id) ? _c('renderer-block', {
      key: ("renderer_block_" + index),
      attrs: {
        "component": activity
      }
    }) : _vm._e()], 1)
  }), _vm._v("\n                                " + _vm._s(this.$slots.default) + "\n\n                                "), (_vm.showNavBarBottom) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.updatedFee) ? _c('span', {
    staticStyle: {
      "margin-right": "5px",
      "font-size": "18px",
      "display": "block"
    }
  }, [_c('strong', [_vm._v("Updated application fee: " + _vm._s(_vm._f("toCurrency")(_vm.application.application_fee)))]), _vm._v(" "), _c('strong', [_vm._v("licence fee: " + _vm._s(_vm._f("toCurrency")(_vm.application.licence_fee)))])]) : _vm._e(), _vm._v(" "), (_vm.showSpinner && _vm.showRequestSpinner) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("Save Changes")]) : (_vm.showSpinner && !_vm.showRequestSpinner) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Saving")]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save_button()
      }
    }
  }, [_vm._v("Save Changes")])])])])])]) : _vm._e()], 2) : _vm._e()], 1)])])])])])] : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFinalDecision),
      expression: "showFinalDecision"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.application.processing_status.name === 'Approved') ? _c('div', {
    staticClass: "col-md-12 alert alert-success"
  }, [_c('p', [_vm._v("The licence has been issued and has been emailed to " + _vm._s(_vm.application.applicant) + ".")]), _vm._v(" "), _c('p', [_vm._v("Licence: "), _c('a', {
    attrs: {
      "href": _vm.application.permit,
      "target": "_blank"
    }
  }, [_vm._v("licence.pdf")])])]) : _vm._e(), _vm._v(" "), (_vm.application.processing_status.name !== 'Approved') ? _c('div', {
    staticClass: "col-md-12 alert alert-danger"
  }, [_c('p', [_vm._v("The application is not approved. An update to the status was emailed to " + _vm._s(_vm.application.applicant))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Decision\n                            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.decisionBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.decisionBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": _vm.decisionBody
    }
  }, _vm._l((_vm.application.activities.filter(function (activity) { return ['issue_refund', 'issued'].includes(activity.decision_action); })), function(activity) {
    return _c('div', [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('strong', [_vm._v(" ")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Licence Activity: " + _vm._s(activity.activity_name_str))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Decision: " + _vm._s(activity.processing_status.id === 'declined' ? activity.processing_status.name : activity.decision_action))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Start date: " + _vm._s(_vm._f("formatDateNoTime")(activity.processing_status.id === 'declined' ? '' : activity.start_date)))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Expiry date: " + _vm._s(_vm._f("formatDateNoTime")(activity.processing_status.id === 'declined' ? '' : activity.expiry_date)))])])])
  }), 0)])])])])])], 2)])]), _vm._v(" "), _c('ProposedDecline', {
    ref: "proposed_decline",
    on: {
      "refreshFromResponse": _vm.refreshFromResponse
    }
  }), _vm._v(" "), _c('AmendmentRequest', {
    ref: "amendment_request",
    on: {
      "refreshFromResponse": _vm.refreshFromResponse
    }
  }), _vm._v(" "), _c('ProposedLicence', {
    ref: "proposed_licence",
    attrs: {
      "can_view_richtext_src": _vm.application.can_view_richtext_src
    },
    on: {
      "refreshFromResponse": _vm.refreshFromResponse
    }
  })], 1) : _c('div', [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('center', [_c('i', {
    staticClass: "fa fa-4x fa-spinner fa-spin"
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('table', {
    staticClass: "table small-table"
  }, [_c('tr', [_c('th', [_vm._v("Lodgement")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Action")]), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Action")]), _c('br')])])
}]}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), (_vm.readonly) ? [(!_vm.isMultiple) ? _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "id": _vm.selectid,
      "name": _vm.name,
      "data-conditions": _vm.cons
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      domProps: {
        "value": op.value,
        "selected": op.value == _vm.value
      },
      on: {
        "change": _vm.handleChange
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2) : _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "id": _vm.selectid,
      "multiple": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      domProps: {
        "value": op.value,
        "selected": _vm.multipleSelection(op.value)
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2), _vm._v(" "), (_vm.isMultiple) ? _vm._l((_vm.value), function(v, idx2) {
    return _c('input', {
      key: ("value_" + v + "_" + idx2),
      attrs: {
        "input": "",
        "type": "hidden",
        "name": _vm.name,
        "required": _vm.isRequired
      },
      domProps: {
        "value": v
      }
    })
  }) : [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name,
      "required": _vm.isRequired
    },
    domProps: {
      "value": _vm.value
    }
  })]] : [(!_vm.isMultiple) ? _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.selectid,
      "name": _vm.name,
      "data-conditions": _vm.cons,
      "required": _vm.isRequired
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      domProps: {
        "value": op.value,
        "selected": op.value == _vm.value
      },
      on: {
        "change": _vm.handleChange
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2) : _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.selectid,
      "name": _vm.name,
      "multiple": "",
      "required": _vm.isRequired
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      domProps: {
        "value": op.value,
        "selected": _vm.multipleSelection(op.value)
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2)]], 2)])
},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    attrs: {
      "id": "map-filter"
    }
  }, [_c('div', [_c('label', {}, [_vm._v("Call/Email Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.status_choices), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.display) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', [_c('label', {}, [_vm._v("Call/Email Classification")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterClassification),
      expression: "filterClassification"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterClassification = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.classification_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.name) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', [_c('label', {}, [_vm._v("Lodged From")]), _vm._v(" "), _c('div', {
    ref: "lodgementDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLodgedFrom),
      expression: "filterLodgedFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterLodgedFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterLodgedFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', [_c('label', {}, [_vm._v("Lodged To")]), _vm._v(" "), _c('div', {
    ref: "lodgementDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLodgedTo),
      expression: "filterLodgedTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterLodgedTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterLodgedTo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "map-wrapper"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapLeaf"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "basemap-button"
    }
  }, [_c('img', {
    attrs: {
      "id": "basemap_sat",
      "src": __webpack_require__(57)
    },
    on: {
      "click": function($event) {
        return _vm.setBaseLayer('sat')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "id": "basemap_osm",
      "src": __webpack_require__(56)
    },
    on: {
      "click": function($event) {
        return _vm.setBaseLayer('osm')
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cursor-location"
    }
  }, [(_vm.cursor_location) ? _c('div', [_c('span', {
    attrs: {
      "id": "cursor-location-lat"
    }
  }, [_vm._v(_vm._s(_vm.cursor_location.lat.toFixed(5)) + ", " + _vm._s(_vm.cursor_location.lng.toFixed(5)))])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search-box"
    }
  }, [_c('input', {
    attrs: {
      "id": "search-input"
    }
  })])
}]}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "expander-label",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.tableClass
  }, [_c('div', {
    staticClass: "row header-titles-row"
  }, _vm._l((_vm.component.header), function(header, index) {
    return _c('div', {
      key: ("expander_header_" + (_vm.component.name) + "_" + index),
      class: ("col-xs-" + (_vm.getColXSValue(header.colSize)) + " truncate-text")
    }, [_vm._v("\n                    " + _vm._s(header.label) + "\n            ")])
  }), 0), _vm._v(" "), _vm._l((_vm.expanderTables), function(table, tableIdx) {
    return _c('div', {
      staticClass: "expander-table"
    }, [_c('div', {
      staticClass: "row header-row"
    }, _vm._l((_vm.component.header), function(header, index) {
      return _c('div', {
        key: ("expander_header_" + (_vm.component.name) + "_" + index),
        class: ("col-xs-" + (_vm.getColXSValue(header.colSize)))
      }, [(index === 0 && _vm.component.expander && _vm.component.expander.length > 0) ? _c('span', {
        class: ("expand-icon " + (_vm.isExpanded(table) ? 'collapse' : '')),
        on: {
          "click": function($event) {
            return _vm.toggleTableVisibility(table)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "header-contents",
        attrs: {
          "title": _vm.value.toString()
        }
      }, [_c('renderer-block', {
        key: ("expander_header_contents_" + (_vm.component.name) + "_" + index),
        attrs: {
          "component": _vm.removeLabel(header),
          "json_data": _vm.value,
          "instance": table,
          "isTableField": true
        }
      })], 1), _vm._v(" "), (tableIdx && index == _vm.component.header.length - 1 && !_vm.readonly) ? _c('a', {
        staticClass: "delete-icon fa fa-trash-o",
        attrs: {
          "title": "Delete row"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeTable(table)
          }
        }
      }) : _vm._e()])
    }), 0), _vm._v(" "), _c('div', {
      class: {
        'hidden': !_vm.isExpanded(table)
      }
    }, _vm._l((_vm.component.expander), function(subcomponent, index) {
      return _c('div', {
        key: ("expander_row_" + (_vm.component.name) + "_" + index),
        staticClass: "row expander-row"
      }, [_c('div', {
        staticClass: "col-xs-12"
      }, [_c('renderer-block', {
        key: ("expander_contents_" + (_vm.component.name) + "_" + index),
        attrs: {
          "component": subcomponent,
          "json_data": _vm.value,
          "instance": table
        }
      })], 1)])
    }), 0)])
  })], 2), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "row"
  }, [_c('input', {
    staticClass: "btn btn-primary add-new-button",
    attrs: {
      "type": "button",
      "value": "Add New"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewTable($event)
      }
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "inline",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "config": _vm.editorConfig,
      "read-only": _vm.readonly,
      "name": _vm.name,
      "required": _vm.isRequired
    },
    model: {
      value: (_vm.field_data.value),
      callback: function($$v) {
        _vm.$set(_vm.field_data, "value", $$v)
      },
      expression: "field_data.value"
    }
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "externalDash"
    }
  }, [_c('SanctionOutcomeDashTable', {
    attrs: {
      "level": "external",
      "url": _vm.sanction_outcome_url
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tabs-main",
      "data-tabs": "tabs"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "pill"
    },
    on: {
      "click": function($event) {
        return _vm.selectApplicantTab()
      }
    }
  }, [_vm._v("Applicant")])]), _vm._v(" "), _vm._l((_vm.visibleLicenceActivities), function(activity, index) {
    return _c('li', {
      key: ("issue_activity_tab_" + index),
      staticClass: "nav-item"
    }, [_c('a', {
      staticClass: "nav-link",
      attrs: {
        "data-toggle": "pill"
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(activity)
        }
      }
    }, [_vm._v(_vm._s(activity.name))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, _vm._l((_vm.selectedActivity), function(item, index) {
    return _c('div', {
      key: ("issue_activity_content_" + index),
      staticClass: "row"
    }, [_c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h3', {
      staticClass: "panel-title"
    }, [_vm._v("Issue/Decline - " + _vm._s(item.name) + "\n                        "), _c('a', {
      staticClass: "panelClicker",
      attrs: {
        "href": '#' + _vm.panelBody,
        "data-toggle": "collapse",
        "data-parent": "#userInfo",
        "expanded": "false",
        "aria-controls": _vm.panelBody
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-chevron-down pull-right "
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body panel-collapse collapse in",
      attrs: {
        "id": _vm.panelBody
      }
    }, [_c('form', {
      staticClass: "form-horizontal",
      attrs: {
        "action": "index.html",
        "method": "post"
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(0, true), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, _vm._l((_vm.applicationSelectedActivitiesForPurposes), function(p, index) {
      return _c('div', {
        key: ("p_" + index)
      }, [_c('div', {
        staticClass: "panel panel-primary"
      }, [_c('div', {
        staticClass: "panel-heading"
      }, [_c('h4', {
        staticClass: "panel-title"
      }, [_vm._v(_vm._s(p.purpose.short_name) + "\n                                                        "), _c('a', {
        staticClass: "panelClicker",
        attrs: {
          "href": "#" + index + _vm.purposeBody,
          "data-toggle": "collapse",
          "data-parent": "#userInfo",
          "expanded": "true",
          "aria-controls": _vm.purposeBody
        }
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-chevron-down pull-right "
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "panel-body panel-collapse collapse",
        attrs: {
          "id": "" + index + _vm.purposeBody
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-sm-12"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getPickedPurpose(p.purpose.id).isProposed),
          expression: "getPickedPurpose(p.purpose.id).isProposed"
        }],
        attrs: {
          "type": "radio",
          "id": p.purpose.id
        },
        domProps: {
          "value": true,
          "checked": _vm._q(_vm.getPickedPurpose(p.purpose.id).isProposed, true)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.getPickedPurpose(p.purpose.id), "isProposed", true)
          }
        }
      }), _vm._v(" Issue  \n                                                                "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getPickedPurpose(p.purpose.id).isProposed),
          expression: "getPickedPurpose(p.purpose.id).isProposed"
        }],
        attrs: {
          "type": "radio",
          "id": p.purpose.id
        },
        domProps: {
          "value": false,
          "checked": _vm._q(_vm.getPickedPurpose(p.purpose.id).isProposed, false)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.getPickedPurpose(p.purpose.id), "isProposed", false)
          }
        }
      }), _vm._v(" Decline  \n                                                            ")]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-3"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        ref: ("start_date_" + (p.id)),
        refInFor: true,
        staticClass: "input-group date",
        staticStyle: {
          "width": "100%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.proposed_start_date),
          expression: "p.proposed_start_date"
        }],
        staticClass: "form-control",
        attrs: {
          "readonly": p.processing_status !== 'reissue' && (!_vm.canEditLicenceDates && p.proposed_end_date),
          "type": "text",
          "name": ("start_date_" + (p.id)),
          "placeholder": "DD/MM/YYYY"
        },
        domProps: {
          "value": (p.proposed_start_date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "proposed_start_date", $event.target.value)
          }
        }
      }), _vm._v(" "), _vm._m(2, true)]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-3"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        ref: ("end_date_" + (p.id)),
        refInFor: true,
        staticClass: "input-group date",
        staticStyle: {
          "width": "100%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.proposed_end_date),
          expression: "p.proposed_end_date"
        }],
        staticClass: "form-control",
        attrs: {
          "readonly": p.processing_status !== 'reissue' && (!_vm.canEditLicenceDates && p.proposed_end_date),
          "type": "text",
          "name": ("end_date_" + (p.id)),
          "placeholder": "DD/MM/YYYY"
        },
        domProps: {
          "value": (p.proposed_end_date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "proposed_end_date", $event.target.value)
          }
        }
      }), _vm._v(" "), _vm._m(3, true)]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-3"
      }, [_c('label', {
        staticClass: "control-label pull-left",
        attrs: {
          "for": "Name"
        }
      }, [_vm._v("Additional Fee")])]) : _vm._e(), _vm._v(" "), (_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.additional_fee),
          expression: "p.additional_fee"
        }],
        ref: "licence_fee",
        refInFor: true,
        staticClass: "form-control",
        staticStyle: {
          "width": "50%"
        },
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (p.additional_fee)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "additional_fee", $event.target.value)
          }
        }
      })]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-12"
      }, [(_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-3"
      }, [_c('label', {
        staticClass: "control-label pull-left",
        attrs: {
          "for": "Name"
        }
      }, [_vm._v("Fee Description")])]) : _vm._e(), _vm._v(" "), (_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.additional_fee_text),
          expression: "p.additional_fee_text"
        }],
        staticClass: "form-control",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "type": "text",
          "name": "licence_fee_text_" + index
        },
        domProps: {
          "value": (p.additional_fee_text)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(p, "additional_fee_text", $event.target.value)
          }
        }
      })]) : _vm._e()]), _vm._v(" "), _vm._l((p.purpose_species_json), function(free_text, pt_idx) {
        return _c('div', {
          key: ("pt_" + pt_idx)
        }, [_c('br'), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12"
        }, [_c('div', {
          staticClass: "col-sm-3"
        }, [_c('label', {
          staticClass: "control-label pull-left",
          attrs: {
            "for": "Name"
          }
        }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (free_text.is_additional_info),
            expression: "free_text.is_additional_info"
          }]
        }, [_c('br'), _c('br'), _vm._v(" "), _c('input', {
          attrs: {
            "type": "checkbox",
            "checked": "",
            "disabled": ""
          }
        }), _vm._v(" "), _c('label', [_vm._v("Is additional info")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-9"
        }, [_c('ckeditor', {
          ref: "ap_text_detail",
          refInFor: true,
          attrs: {
            "config": _vm.editorConfig
          },
          model: {
            value: (free_text.details),
            callback: function($$v) {
              _vm.$set(free_text, "details", $$v)
            },
            expression: "free_text.details"
          }
        })], 1)])])
      }), _vm._v(" "), (!_vm.getPickedPurpose(p.purpose.id).isProposed) ? _c('div', {
        staticClass: "col-sm-12"
      }, [_vm._v("                                                        \n                                                             \n                                                        ")]) : _vm._e()], 2)])])])
    }), 0)]), _vm._v(" "), _vm._m(4, true), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    })])])])])]), _vm._v(" "), _c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h3', {
      staticClass: "panel-title"
    }, [_vm._v("Emailing\n                        "), _c('a', {
      staticClass: "panelClicker",
      attrs: {
        "href": '#' + _vm.emailPanelBody,
        "data-toggle": "collapse",
        "data-parent": "#userInfo",
        "expanded": "false",
        "aria-controls": _vm.emailPanelBody
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-chevron-down pull-right "
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body panel-collapse collapse in",
      attrs: {
        "id": _vm.emailPanelBody
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-9"
    }, [_c('div', {
      ref: "details",
      refInFor: true,
      staticClass: "input-group date",
      staticStyle: {
        "width": "70%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.getActivity(item.id).reason),
        expression: "getActivity(item.id).reason"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": "details"
      },
      domProps: {
        "value": (_vm.getActivity(item.id).reason)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.getActivity(item.id), "reason", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-9"
    }, [_c('div', {
      ref: "cc_email",
      refInFor: true,
      staticClass: "input-group date",
      staticStyle: {
        "width": "70%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.getActivity(item.id).cc_email),
        expression: "getActivity(item.id).cc_email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": "cc_email"
      },
      domProps: {
        "value": (_vm.getActivity(item.id).cc_email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.getActivity(item.id), "cc_email", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-9"
    }, [_c('filefield', {
      ref: "issuance_documents",
      refInFor: true,
      attrs: {
        "name": "issuance-documents",
        "isRepeatable": true,
        "documentActionUrl": _vm.applicationIssuanceDocumentUrl
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), (_vm.licence.activity.some(function (activity) { return activity.final_status === 'issued'; })) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Issue\n                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.issuePanelBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.issuePanelBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.issuePanelBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.isIdCheckAccepted) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")]) : _vm._e(), _vm._v(" "), (_vm.isIdCheckAwaitingUpdate) ? _c('label', [_vm._v("Awaiting update. Override to Issue:  ")]) : _vm._e(), _vm._v(" "), (_vm.isIdNotChecked) ? _c('label', [_vm._v("Has not been accepted. Override to Issue:  ")]) : _vm._e(), _vm._v(" "), (_vm.isIdNotChecked || _vm.isIdCheckAwaitingUpdate) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getCheckedItem('id_check').isChecked),
      expression: "getCheckedItem('id_check').isChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.getCheckedItem('id_check').isChecked) ? _vm._i(_vm.getCheckedItem('id_check').isChecked, true) > -1 : (_vm.getCheckedItem('id_check').isChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.getCheckedItem('id_check').isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.getCheckedItem('id_check'), "isChecked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.getCheckedItem('id_check'), "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.getCheckedItem('id_check'), "isChecked", $$c)
        }
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.isCharacterCheckAccepted) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")]) : _vm._e(), _vm._v(" "), (_vm.isCharacterNotChecked) ? _c('label', [_vm._v("Has not been accepted. Override to Issue:  ")]) : _vm._e(), _vm._v(" "), (_vm.isCharacterNotChecked) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getCheckedItem('character_check').isChecked),
      expression: "getCheckedItem('character_check').isChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.getCheckedItem('character_check').isChecked) ? _vm._i(_vm.getCheckedItem('character_check').isChecked, true) > -1 : (_vm.getCheckedItem('character_check').isChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.getCheckedItem('character_check').isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.getCheckedItem('character_check'), "isChecked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.getCheckedItem('character_check'), "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.getCheckedItem('character_check'), "isChecked", $$c)
        }
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.isReturnCheckAccepted) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accepted")]) : _vm._e(), _vm._v(" "), (_vm.isReturnCheckAwaitingReturns) ? _c('label', [_vm._v("Awaiting return. Override to Issue:  ")]) : _vm._e(), _vm._v(" "), (_vm.isReturnNotChecked) ? _c('label', [_vm._v("Has not been accepted. Override to Issue:  ")]) : _vm._e(), _vm._v(" "), (_vm.isReturnNotChecked || _vm.isReturnCheckAwaitingReturns) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getCheckedItem('return_check').isChecked),
      expression: "getCheckedItem('return_check').isChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.getCheckedItem('return_check').isChecked) ? _vm._i(_vm.getCheckedItem('return_check').isChecked, true) > -1 : (_vm.getCheckedItem('return_check').isChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.getCheckedItem('return_check').isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.getCheckedItem('return_check'), "isChecked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.getCheckedItem('return_check'), "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.getCheckedItem('return_check'), "isChecked", $$c)
        }
      }
    }
  }) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), ((_vm.applicantType == 'org' && _vm.application.org_applicant.address) ||
    (_vm.applicantType == 'proxy' && _vm.application.proxy_applicant.residential_address) ||
    (_vm.applicantType == 'submitter' && _vm.application.submitter.residential_address)) ? _c('p', [_vm._v("Click "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.preview()
      }
    }
  }, [_vm._v("here")]), _vm._v(" to preview the licence document.")]) : _c('p', [_vm._v("Preview not available - applicant address not set")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [(_vm.canIssueOrDecline) ? _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Issue/Decline")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ok()
      }
    }
  }, [_vm._v("Issue/Decline")])])]) : _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ok()
      }
    }
  }, [_vm._v("Issue/Decline")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Proposed Purposes:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("CC Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Files to be attached to email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("ID Check")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Character Check")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Return Check")])])
}]}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "AddComms"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Communication log - Add entry",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "commsForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("To")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comms.to),
      expression: "comms.to"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "to"
    },
    domProps: {
      "value": (_vm.comms.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comms, "to", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("From")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comms.fromm),
      expression: "comms.fromm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "fromm"
    },
    domProps: {
      "value": (_vm.comms.fromm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comms, "fromm", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comms.log_type),
      expression: "comms.log_type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.comms, "log_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "file_note"
    }
  }, [_vm._v("File Note")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mail"
    }
  }, [_vm._v("Mail")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "person"
    }
  }, [_vm._v("Person")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Subject/Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comms.subject),
      expression: "comms.subject"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "text",
      "name": "subject"
    },
    domProps: {
      "value": (_vm.comms.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comms, "subject", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Text")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comms.text),
      expression: "comms.text"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "name": "text"
    },
    domProps: {
      "value": (_vm.comms.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.comms, "text", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_vm._l((_vm.files), function(f, i) {
    return [_c('div', {
      class: 'row top-buffer file-row-' + i
    }, [_c('div', {
      staticClass: "col-sm-4"
    }, [(f.file == null) ? _c('span', {
      staticClass: "btn btn-info btn-file pull-left"
    }, [_vm._v("\n                                                    Atttach File "), _c('input', {
      class: 'file-upload-' + i,
      attrs: {
        "type": "file",
        "name": 'file-upload-' + i
      },
      on: {
        "change": function($event) {
          return _vm.uploadFile('file-upload-' + i, f)
        }
      }
    })]) : _c('span', {
      staticClass: "btn btn-info btn-file pull-left"
    }, [_vm._v("\n                                                    Update File "), _c('input', {
      class: 'file-upload-' + i,
      attrs: {
        "type": "file",
        "name": 'file-upload-' + i
      },
      on: {
        "change": function($event) {
          return _vm.uploadFile('file-upload-' + i, f)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('span', [_vm._v(_vm._s(f.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeFile(i)
        }
      }
    }, [_vm._v("Remove")])])])]
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.attachAnother($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus top-buffer-2x"
  })])], 2)])])])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.addingComms) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "schemaMasterlist"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Schema Masterlist Questions\n                      "), _c('a', {
    attrs: {
      "href": '#' + _vm.pMasterListBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pMasterListBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pMasterListBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "name": "add-masterlist"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTableEntry()
      }
    }
  }, [_vm._v("New Question")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datatable', {
    ref: "schema_masterlist_table",
    attrs: {
      "id": _vm.schema_masterlist_id,
      "dtOptions": _vm.dtOptionsSchemaMasterlist,
      "dtHeaders": _vm.dtHeadersSchemaMasterlist
    }
  })], 1)])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Schema Masterlist Question",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                      " + _vm._s(error.label) + "\n                  ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "schema_masterlist"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Question")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.masterlist.question),
      expression: "masterlist.question"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "question"
    },
    domProps: {
      "value": (_vm.masterlist.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.masterlist, "question", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Answer Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.masterlist.answer_type),
      expression: "masterlist.answer_type"
    }],
    ref: "select_answer_type",
    staticClass: "form-control",
    attrs: {
      "name": "select-answer-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.masterlist, "answer_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.answerTypes), function(a) {
    return _c('option', {
      domProps: {
        "value": a.value
      }
    }, [_vm._v(_vm._s(a.label))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")])]), _vm._v(" "), (_vm.showOptions) ? _c('div', {
    staticClass: "row"
  }, [_c('SchemaOption', {
    ref: "schema_option",
    attrs: {
      "addedOptions": _vm.addedOptions,
      "canAddMore": true
    }
  })], 1) : (_vm.showTables) ? _c('div', {
    staticClass: "row"
  }, [_c('SchemaHeader', {
    attrs: {
      "addedHeaders": _vm.addedHeaders,
      "answerTypes": _vm.answerTypes,
      "canAddMore": true
    }
  }), _vm._v(" "), _c('SchemaExpander', {
    attrs: {
      "addedExpanders": _vm.addedExpanders,
      "answerTypes": _vm.answerTypes,
      "canAddMore": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Help text url")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.masterlist.help_text_url),
      expression: "masterlist.help_text_url"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "help_text_url"
    },
    domProps: {
      "value": (_vm.masterlist.help_text_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.masterlist, "help_text_url", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveMasterlist()
      }
    }
  }, [_vm._v("Save")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br')])
}]}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Applications referred to me\n                    "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicationLicenceType),
      expression: "filterApplicationLicenceType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterApplicationLicenceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.application_licence_types), function(lt) {
    return _c('option', {
      key: ("licence_type_" + lt),
      domProps: {
        "value": lt
      }
    }, [_vm._v(_vm._s(lt))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicationStatus),
      expression: "filterApplicationStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterApplicationStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.application_status), function(s) {
    return _c('option', {
      key: ("status_" + (s.id)),
      domProps: {
        "value": s
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Submitter")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicationSubmitter),
      expression: "filterApplicationSubmitter"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterApplicationSubmitter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.application_submitters), function(s) {
    return _c('option', {
      key: ("s_email_" + (s.email)),
      domProps: {
        "value": s.email
      }
    }, [_vm._v(_vm._s(s.search_term))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Lodged From")]), _vm._v(" "), _c('div', {
    ref: "applicationDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicationLodgedFrom),
      expression: "filterApplicationLodgedFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterApplicationLodgedFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterApplicationLodgedFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Lodged To")]), _vm._v(" "), _c('div', {
    ref: "applicationDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicationLodgedTo),
      expression: "filterApplicationLodgedTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterApplicationLodgedTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterApplicationLodgedTo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "assessment_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.assessment_options,
      "dtHeaders": _vm.assessment_headers
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br')])
}]}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-primary"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Expanders\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": "#" + _vm.pExpanderBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pExpanderBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse",
    attrs: {
      "id": "" + _vm.pExpanderBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.addedExpanders), function(e, eidx) {
    return _c('div', {
      key: ("e_" + eidx)
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_vm._v("  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [(eidx === 0) ? _c('label', {
      staticClass: "control-label pull-left"
    }, [_vm._v("Add Expanders")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (e.label),
        expression: "e.label"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (e.label)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(e, "label", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (e.value),
        expression: "e.value"
      }],
      ref: ("expander_answer_type_" + eidx),
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "name": ("select-answer-type-" + eidx)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(e, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.answerTypes), function(ea, eaidx) {
      return _c('option', {
        domProps: {
          "value": ea.value
        }
      }, [_vm._v(_vm._s(ea.label))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [(eidx !== 0) ? _c('a', {
      staticClass: "delete-icon fa fa-trash-o",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Delete row"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeExpander(eidx)
        }
      }
    }) : _vm._e(), _vm._v(" "), (eidx === 0) ? _c('button', {
      staticClass: "btn btn-link pull-right",
      attrs: {
        "name": "add_expander_link_1"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addExpander()
        }
      }
    }, [_vm._v("[ Add Another ]")]) : _vm._e()])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Statement of Facts"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Statement of facts\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.statement_of_facts),
      expression: "briefOfEvidence.statement_of_facts"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.statement_of_facts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "statement_of_facts", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Case Information Form"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.victim_impact_statement_taken),
      expression: "briefOfEvidence.victim_impact_statement_taken"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.victim_impact_statement_taken) ? _vm._i(_vm.briefOfEvidence.victim_impact_statement_taken, null) > -1 : (_vm.briefOfEvidence.victim_impact_statement_taken)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.victim_impact_statement_taken,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "victim_impact_statement_taken", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "victim_impact_statement_taken", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "victim_impact_statement_taken", $$c)
        }
      }
    }
  }), _vm._v("\n                Victim impact statement to be taken?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.victim_impact_statement_taken) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.victim_impact_statement_taken_details),
      expression: "briefOfEvidence.victim_impact_statement_taken_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.victim_impact_statement_taken_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "victim_impact_statement_taken_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.statements_pending),
      expression: "briefOfEvidence.statements_pending"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.statements_pending) ? _vm._i(_vm.briefOfEvidence.statements_pending, null) > -1 : (_vm.briefOfEvidence.statements_pending)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.statements_pending,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "statements_pending", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "statements_pending", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "statements_pending", $$c)
        }
      }
    }
  }), _vm._v("\n                Witness (including expert statements) still to be taken?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.statements_pending) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.statements_pending_details),
      expression: "briefOfEvidence.statements_pending_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.statements_pending_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "statements_pending_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.vulnerable_hostile_witnesses),
      expression: "briefOfEvidence.vulnerable_hostile_witnesses"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.vulnerable_hostile_witnesses) ? _vm._i(_vm.briefOfEvidence.vulnerable_hostile_witnesses, null) > -1 : (_vm.briefOfEvidence.vulnerable_hostile_witnesses)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.vulnerable_hostile_witnesses,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "vulnerable_hostile_witnesses", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "vulnerable_hostile_witnesses", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "vulnerable_hostile_witnesses", $$c)
        }
      }
    }
  }), _vm._v("\n                Vulnerable / hostile witnesses?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.vulnerable_hostile_witnesses) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.vulnerable_hostile_witnesses_details),
      expression: "briefOfEvidence.vulnerable_hostile_witnesses_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.vulnerable_hostile_witnesses_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "vulnerable_hostile_witnesses_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.witness_refusing_statement),
      expression: "briefOfEvidence.witness_refusing_statement"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.witness_refusing_statement) ? _vm._i(_vm.briefOfEvidence.witness_refusing_statement, null) > -1 : (_vm.briefOfEvidence.witness_refusing_statement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.witness_refusing_statement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "witness_refusing_statement", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "witness_refusing_statement", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "witness_refusing_statement", $$c)
        }
      }
    }
  }), _vm._v("\n                Witnesses refusing to make statements?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.witness_refusing_statement) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.witness_refusing_statement_details),
      expression: "briefOfEvidence.witness_refusing_statement_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.witness_refusing_statement_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "witness_refusing_statement_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.problems_needs_prosecution_witnesses),
      expression: "briefOfEvidence.problems_needs_prosecution_witnesses"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.problems_needs_prosecution_witnesses) ? _vm._i(_vm.briefOfEvidence.problems_needs_prosecution_witnesses, null) > -1 : (_vm.briefOfEvidence.problems_needs_prosecution_witnesses)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.problems_needs_prosecution_witnesses,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "problems_needs_prosecution_witnesses", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "problems_needs_prosecution_witnesses", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "problems_needs_prosecution_witnesses", $$c)
        }
      }
    }
  }), _vm._v("\n                Specific problems / needs of prosecution witnesses, e.g. interpreters?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.problems_needs_prosecution_witnesses) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.problems_needs_prosecution_witnesses),
      expression: "briefOfEvidence.problems_needs_prosecution_witnesses"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.problems_needs_prosecution_witnesses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "problems_needs_prosecution_witnesses", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.accused_bad_character),
      expression: "briefOfEvidence.accused_bad_character"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.accused_bad_character) ? _vm._i(_vm.briefOfEvidence.accused_bad_character, null) > -1 : (_vm.briefOfEvidence.accused_bad_character)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.accused_bad_character,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "accused_bad_character", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "accused_bad_character", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "accused_bad_character", $$c)
        }
      }
    }
  }), _vm._v("\n                History of bad character / propensity (similar fact) evidence involving accused?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.accused_bad_character) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.accused_bad_character_details),
      expression: "briefOfEvidence.accused_bad_character_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.accused_bad_character_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "accused_bad_character_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.further_persons_interviews_pending),
      expression: "briefOfEvidence.further_persons_interviews_pending"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.further_persons_interviews_pending) ? _vm._i(_vm.briefOfEvidence.further_persons_interviews_pending, null) > -1 : (_vm.briefOfEvidence.further_persons_interviews_pending)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.further_persons_interviews_pending,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "further_persons_interviews_pending", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "further_persons_interviews_pending", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "further_persons_interviews_pending", $$c)
        }
      }
    }
  }), _vm._v("\n                Further persons (witness or suspect) to be interviewed?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.further_persons_interviews_pending) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.further_persons_interviews_pending_details),
      expression: "briefOfEvidence.further_persons_interviews_pending_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.further_persons_interviews_pending_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "further_persons_interviews_pending_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_interviews),
      expression: "briefOfEvidence.other_interviews"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.other_interviews) ? _vm._i(_vm.briefOfEvidence.other_interviews, null) > -1 : (_vm.briefOfEvidence.other_interviews)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.other_interviews,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "other_interviews", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "other_interviews", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "other_interviews", $$c)
        }
      }
    }
  }), _vm._v("\n                Other persons whose details do not appear on this brief who have been interviewed?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.other_interviews) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_interviews_details),
      expression: "briefOfEvidence.other_interviews_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.other_interviews_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "other_interviews_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.relevant_persons_pending_charges),
      expression: "briefOfEvidence.relevant_persons_pending_charges"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.relevant_persons_pending_charges) ? _vm._i(_vm.briefOfEvidence.relevant_persons_pending_charges, null) > -1 : (_vm.briefOfEvidence.relevant_persons_pending_charges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.relevant_persons_pending_charges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "relevant_persons_pending_charges", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "relevant_persons_pending_charges", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "relevant_persons_pending_charges", $$c)
        }
      }
    }
  }), _vm._v("\n                Other relevant persons charged or yet to be charged?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.relevant_persons_pending_charges) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.relevant_persons_pending_charges_details),
      expression: "briefOfEvidence.relevant_persons_pending_charges_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.relevant_persons_pending_charges_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "relevant_persons_pending_charges_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_persons_receiving_sanction_outcome),
      expression: "briefOfEvidence.other_persons_receiving_sanction_outcome"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.other_persons_receiving_sanction_outcome) ? _vm._i(_vm.briefOfEvidence.other_persons_receiving_sanction_outcome, null) > -1 : (_vm.briefOfEvidence.other_persons_receiving_sanction_outcome)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.other_persons_receiving_sanction_outcome,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "other_persons_receiving_sanction_outcome", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "other_persons_receiving_sanction_outcome", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "other_persons_receiving_sanction_outcome", $$c)
        }
      }
    }
  }), _vm._v("\n                Others receiving Infringement / Warning arising out of the same incident?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.other_persons_receiving_sanction_outcome) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_persons_receiving_sanction_outcome_details),
      expression: "briefOfEvidence.other_persons_receiving_sanction_outcome_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.other_persons_receiving_sanction_outcome_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "other_persons_receiving_sanction_outcome_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.local_public_interest),
      expression: "briefOfEvidence.local_public_interest"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.local_public_interest) ? _vm._i(_vm.briefOfEvidence.local_public_interest, null) > -1 : (_vm.briefOfEvidence.local_public_interest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.local_public_interest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "local_public_interest", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "local_public_interest", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "local_public_interest", $$c)
        }
      }
    }
  }), _vm._v("\n                Matters of local / public interest?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.local_public_interest) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.local_public_interest_details),
      expression: "briefOfEvidence.local_public_interest_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.local_public_interest_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "local_public_interest_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.applications_orders_requests),
      expression: "briefOfEvidence.applications_orders_requests"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.applications_orders_requests) ? _vm._i(_vm.briefOfEvidence.applications_orders_requests, null) > -1 : (_vm.briefOfEvidence.applications_orders_requests)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.applications_orders_requests,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "applications_orders_requests", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "applications_orders_requests", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "applications_orders_requests", $$c)
        }
      }
    }
  }), _vm._v("\n                Other applications / orders on conviction requests?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.applications_orders_requests) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.applications_orders_requests_details),
      expression: "briefOfEvidence.applications_orders_requests_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.applications_orders_requests_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "applications_orders_requests_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.applications_orders_required),
      expression: "briefOfEvidence.applications_orders_required"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.applications_orders_required) ? _vm._i(_vm.briefOfEvidence.applications_orders_required, null) > -1 : (_vm.briefOfEvidence.applications_orders_required)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.applications_orders_required,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "applications_orders_required", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "applications_orders_required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "applications_orders_required", $$c)
        }
      }
    }
  }), _vm._v("\n                Are there any other applications / orders on conviction required?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.applications_orders_required) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.applications_orders_required_details),
      expression: "briefOfEvidence.applications_orders_required_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.applications_orders_required_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "applications_orders_required_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_legal_matters),
      expression: "briefOfEvidence.other_legal_matters"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.other_legal_matters) ? _vm._i(_vm.briefOfEvidence.other_legal_matters, null) > -1 : (_vm.briefOfEvidence.other_legal_matters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.other_legal_matters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "other_legal_matters", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "other_legal_matters", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "other_legal_matters", $$c)
        }
      }
    }
  }), _vm._v("\n                Is there any statutory notice, DEC licence, ministerial statement or policy etc. re the matter, premise or person subject to this brief?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.other_legal_matters) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_legal_matters_details),
      expression: "briefOfEvidence.other_legal_matters_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.other_legal_matters_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "other_legal_matters_details", $event.target.value)
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Offences, Offenders and Records of Interview",
      "treeHeight": "yes"
    }
  }, [(_vm.boeRoiExist) ? _c('div', [(_vm.boeRoiVisibility) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('TreeSelect', {
    ref: "boe_record_of_interview_tree",
    attrs: {
      "id": "boe-record-of-interview-tree",
      "value": _vm.boeRoiTicked,
      "options": _vm.boeRoiOptions,
      "default-expand-level": Infinity,
      "multiple": "",
      "value-consists-of": "LEAF_PRIORITY",
      "alwaysOpen": "",
      "searchable": false
    },
    on: {
      "input": _vm.setBoeRoiTicked
    }
  })], 1)]) : _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.boeRoiOptions), function(record) {
    return _c('div', [(record.show) ? _c('span', [_c('a', {
      attrs: {
        "href": record.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(record.label))])]) : _vm._e(), _vm._v(" "), _vm._l((record.children), function(child) {
      return _c('span', [(child.show) ? _c('span', [_vm._v("\n                                ; "), _c('a', {
        attrs: {
          "href": child.hyperlink,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.label))])]) : _vm._e(), _vm._v(" "), _vm._l((child.children), function(grandchild) {
        return _c('span', [(grandchild.show) ? _c('span', [_vm._v("\n                                    ; "), _c('a', {
          attrs: {
            "href": grandchild.hyperlink,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(grandchild.label))])]) : _vm._e(), _vm._v(" "), _vm._l((grandchild.children), function(greatgrandchild) {
          return _c('span', [(greatgrandchild.show) ? _c('span', [_vm._v("\n                                        ; "), _c('a', {
            attrs: {
              "href": greatgrandchild.hyperlink,
              "target": "_blank"
            }
          }, [_vm._v(_vm._s(greatgrandchild.label))])]) : _vm._e()])
        })], 2)
      })], 2)
    })], 2)
  }), 0)])]) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No Offences, Offenders or Records of Interview")])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Witness Statements, Officer Statements, Expert Statements",
      "treeHeight": "yes"
    }
  }, [(_vm.boeOtherStatementsExist) ? _c('div', [(_vm.boeOtherStatementsVisibility) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('TreeSelect', {
    ref: "boe_other_statements_tree",
    attrs: {
      "id": "boe-other-statements-tree",
      "value": _vm.boeOtherStatementsTicked,
      "options": _vm.boeOtherStatementsOptions,
      "default-expand-level": Infinity,
      "multiple": "",
      "value-consists-of": "LEAF_PRIORITY",
      "alwaysOpen": "",
      "searchable": false
    },
    on: {
      "input": _vm.setBoeOtherStatementsTicked
    }
  })], 1)]) : _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.boeOtherStatementsOptions), function(record) {
    return _c('div', [(record.show) ? _c('span', [_c('a', {
      attrs: {
        "href": record.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(record.label))])]) : _vm._e(), _vm._v(" "), _vm._l((record.children), function(child) {
      return _c('span', [(child.show) ? _c('span', [_vm._v("\n                                ; "), _c('a', {
        attrs: {
          "href": child.hyperlink,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.label))])]) : _vm._e(), _vm._v(" "), _vm._l((child.children), function(grandchild) {
        return _c('span', [(grandchild.show) ? _c('span', [_vm._v("\n                                    ; "), _c('a', {
          attrs: {
            "href": grandchild.hyperlink,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(grandchild.label))])]) : _vm._e()])
      })], 2)
    })], 2)
  }), 0)])]) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No Witness Statements, Officer Statements or Expert Statements")])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "id": "physical-artifacts-tree",
      "formCollapse": false,
      "label": "List of Exhibits, Sensitive Unused and Non-Sensitive Unused Materials",
      "treeHeight": "yes"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Select the objects to be included on the list of exhibits")]), _vm._v(" "), (_vm.physicalArtifactsUsedVisibility) ? _c('div', {
    staticClass: "col-sm-10",
    attrs: {
      "class": "col-sm-10"
    }
  }, _vm._l((_vm.physicalArtifactsUsed), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))])])
  }), 0) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No objects on the list of exhibits")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Select the objects to be included on the sensitive unused list of materials")]), _vm._v(" "), (_vm.physicalArtifactsSensitiveUnusedVisibility) ? _c('div', {
    staticClass: "col-sm-10"
  }, _vm._l((_vm.physicalArtifactsSensitiveUnused), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "id": 'tickbox_' + artifact.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))]), _vm._v(" "), (artifact.ticked) ? _c('div', [_c('label', {
      staticClass: "col-sm-3"
    }, [_vm._v("Reason for sensitivity / non-disclosure")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-5"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.reason_sensitive_non_disclosable),
        expression: "artifact.reason_sensitive_non_disclosable"
      }],
      staticClass: "form-control",
      attrs: {
        "id": 'reason_' + artifact.physical_artifact_id,
        "readonly": _vm.readonlyForm
      },
      domProps: {
        "value": (artifact.reason_sensitive_non_disclosable)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(artifact, "reason_sensitive_non_disclosable", $event.target.value)
        }
      }
    })])]) : _vm._e()])
  }), 0) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No objects on the sensitive unused list of materials")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Select the objects to be included on the non-sensitive unused list of materials")]), _vm._v(" "), (_vm.physicalArtifactsNonSensitiveUnusedVisibility) ? _c('div', {
    staticClass: "col-sm-10"
  }, _vm._l((_vm.physicalArtifactsNonSensitiveUnused), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))])])
  }), 0) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No objects on the non-sensitive unused list of materials")])])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "List of Photographic, Video and Sound Exhibits"
    }
  }, [(_vm.documentArtifactsVisibility) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.documentArtifacts), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 form-group document-artifact-file"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((artifact.attachments), function(document) {
      return _c('div', [_c('label', [_vm._v(" " + _vm._s(document.name) + "\n                                "), (['png', 'jpg'].includes(document.type)) ? _c('div', [_c('img', {
        staticClass: "col-sm-4",
        attrs: {
          "src": document.file,
          "alt": "image file"
        }
      })]) : (['mp4'].includes(document.type)) ? _c('div', [_c('video', {
        attrs: {
          "width": "82",
          "height": "82",
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": document.file,
          "type": "video/mp4"
        }
      })])]) : _vm._e()])])
    }), 0)])])
  }), 0)]) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No Photographic, Video or Sound Exhibits")])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Additional Documents"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('filefield', {
    key: _vm.legal_case.briefOfEvidenceDocumentUrl,
    ref: "brief_of_evidence_documents",
    attrs: {
      "name": "brief-of-evidence-documents",
      "isRepeatable": true,
      "documentActionUrl": _vm.legal_case.briefOfEvidenceDocumentUrl,
      "readonly": _vm.readonlyForm
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details),
      expression: "details"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add reason",
      "id": "reason"
    },
    domProps: {
      "value": (_vm.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": _vm.sanction_outcome.commsLogsDocumentUrl
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorResponse)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processingDetails) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : (_vm.fieldsFilled) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3",
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control deficiency",
    attrs: {
      "readonly": _vm.readonly,
      "data-question": _vm.question,
      "name": _vm.name,
      "required": _vm.isRequired
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "InspectionWorkflow"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflowDetails),
      expression: "workflowDetails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add details",
      "id": "details"
    },
    domProps: {
      "value": (_vm.workflowDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workflowDetails = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": _vm.inspection.commsLogsDocumentUrl
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Error: " + _vm._s(_vm.errorResponse))])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Offence: " + _vm._s(_vm.displayLodgementNumber))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                        Workflow\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                                " + _vm._s(_vm.statusDisplay)), _c('br')])]), _vm._v(" "), _c('Assignment', {
    key: _vm.assignmentKey,
    attrs: {
      "user_is_assignee": _vm.offence.user_is_assignee,
      "allowed_group_ids": _vm.offence.allowed_groups,
      "user_in_group": _vm.offence.user_in_group,
      "assigned_to_id": _vm.offence.assigned_to_id,
      "assign_url": _vm.assign_url
    },
    on: {
      "update-assigned-to-id": _vm.updateAssignedToId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                        Action\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [(_vm.visibilitySanctionOutcomeButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.openSanctionOutcome()
      }
    }
  }, [_vm._v("\n                                    Sanction Outcome\n                                ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityCloseButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('close')
      }
    }
  }, [_vm._v("\n                                    Close\n                                ")])])]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills aho2"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.offenceTab
    }
  }, [_vm._v("Offence")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.detailsTab
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.offenderTab
    }
  }, [_vm._v("Offender(s)")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.locationTab
    },
    on: {
      "click": _vm.mapOffenceClicked
    }
  }, [_vm._v("Location")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.relatedItemsTab
    }
  }, [_vm._v("Related Items")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.offenceTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Offence",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "offence-identifier"
    }
  }, [_vm._v("Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.offence) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.identifier),
      expression: "offence.identifier"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readonlyForm,
      "name": "identifier"
    },
    domProps: {
      "value": (_vm.offence.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence, "identifier", $event.target.value)
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Use occurrence from/to")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.occurrence_from_to),
      expression: "offence.occurrence_from_to"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "occurrence_from_to_true",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.offence.occurrence_from_to, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.offence, "occurrence_from_to", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "occurrence_from_to_true"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.occurrence_from_to),
      expression: "offence.occurrence_from_to"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "occurrence_from_to_false",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.offence.occurrence_from_to, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.offence, "occurrence_from_to", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "occurrence_from_to_false"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.occurrenceDateLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "occurrenceDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": _vm.date_from
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.offence.occurrence_from_to),
      expression: "offence.occurrence_from_to"
    }]
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "occurrenceDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": _vm.date_to
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.occurrenceTimeLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "occurrenceTimeFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": _vm.time_from
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.offence.occurrence_from_to),
      expression: "offence.occurrence_from_to"
    }]
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "occurrenceTimeToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": _vm.time_to
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Alleged Offence")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonlyForm),
      expression: "!readonlyForm"
    }]
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "alleged-offence"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Add"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addAllegedOffenceClicked()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "alleged_offence_table",
    attrs: {
      "parentStyle": " ",
      "id": "alleged-offence-table",
      "dtOptions": _vm.dtOptionsAllegedOffence,
      "dtHeaders": _vm.dtHeadersAllegedOffence
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane face in",
    attrs: {
      "id": _vm.detailsTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Details",
      "Index": "1"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.details),
      expression: "offence.details"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm,
      "placeholder": "add details"
    },
    domProps: {
      "value": (_vm.offence.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence, "details", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane face in",
    attrs: {
      "id": _vm.documentTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Document",
      "Index": "1.5"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane face in",
    attrs: {
      "id": _vm.offenderTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Offender(s)",
      "Index": "2"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-2"
  }, [_vm._v("Offender")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonlyForm),
      expression: "!readonlyForm"
    }]
  }, [_c('div', [_c('SearchPersonOrganisation', {
    key: _vm.updateSearchPersonOrganisationBindId,
    ref: "search_offender",
    attrs: {
      "excludeStaff": true,
      "personOnly": true,
      "classNames": "form-control",
      "showCreateUpdate": "",
      "domIdHelper": "offender"
    },
    on: {
      "entity-selected": _vm.personSelected
    }
  })], 1), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Add to Offender List"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addOffenderClicked()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "offender_table",
    attrs: {
      "id": "offender-table",
      "dtOptions": _vm.dtOptionsOffender,
      "dtHeaders": _vm.dtHeadersOffender
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane face in",
    attrs: {
      "id": _vm.locationTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Location",
      "Index": "3"
    }
  }, [(_vm.offence.location) ? _c('MapLocation', {
    key: _vm.locationTab,
    ref: "mapLocationComponent",
    attrs: {
      "readonly": _vm.readonlyForm,
      "marker_longitude": _vm.offence.location.geometry.coordinates[0],
      "marker_latitude": _vm.offence.location.geometry.coordinates[1]
    },
    on: {
      "location-updated": _vm.locationUpdated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.offence.location) ? _c('div', {
    attrs: {
      "id": _vm.idLocationFieldsAddress
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Street")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.street),
      expression: "offence.location.properties.street"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.offence.location.properties.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "street", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.town_suburb),
      expression: "offence.location.properties.town_suburb"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.offence.location.properties.town_suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "town_suburb", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.state),
      expression: "offence.location.properties.state"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.offence.location.properties.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.postcode),
      expression: "offence.location.properties.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.offence.location.properties.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.country),
      expression: "offence.location.properties.country"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.offence.location.properties.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "country", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.offence.location) ? _c('div', {
    attrs: {
      "id": _vm.idLocationFieldsDetails
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.details),
      expression: "offence.location.properties.details"
    }],
    staticClass: "form-control location_address_field",
    domProps: {
      "value": (_vm.offence.location.properties.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "details", $event.target.value)
      }
    }
  })])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane face in",
    attrs: {
      "id": _vm.relatedItemsTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items",
      "Index": "4"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": _vm.readonlyForm
    }
  })], 1)])])])], 1)])])])])]), _vm._v(" "), (_vm.visibilitySaveButton) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.workflow_type) ? _c('div', [_c('OffenceWorkflow', {
    key: _vm.workflowBindId,
    ref: "add_workflow",
    attrs: {
      "workflow_type": _vm.workflow_type
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sanctionOutcomeInitialised) ? _c('div', [_c('SanctionOutcome', {
    ref: "sanction_outcome",
    attrs: {
      "parent_update_function": _vm.constructOffenceDedicatedPage
    },
    on: {
      "sanction_outcome_created": _vm.constructOffenceDedicatedPage
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.box_view),
      expression: "box_view"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3",
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "type": _vm.type,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.value
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("People "), (_vm.is_external) ? _c('small', [_vm._v("View people details")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#peopleInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Character Flagged")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterCharacterFlagged),
      expression: "filterCharacterFlagged"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterCharacterFlagged = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.character_flagged_options), function(c) {
    return _c('option', {
      domProps: {
        "value": c
      }
    }, [_vm._v(_vm._s(c))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    ref: "filterDateOfBirthPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateOfBirth),
      expression: "filterDateOfBirth"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateOfBirth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateOfBirth = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "user_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.user_options,
      "dtHeaders": _vm.user_headers
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
}]}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Returns "), (_vm.is_external) ? _c('small', [_vm._v("View submitted returns and submit new ones")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterReturnStatus),
      expression: "filterReturnStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterReturnStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.return_statusTitles), function(s) {
    return _c('option', {
      key: ("return_status_" + s),
      domProps: {
        "value": s
      }
    }, [_vm._v(_vm._s(s))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Due Date From")]), _vm._v(" "), _c('div', {
    ref: "dueDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDueDateFrom),
      expression: "filterDueDateFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDueDateFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDueDateFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Due Date To")]), _vm._v(" "), _c('div', {
    ref: "dueDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDueDateTo),
      expression: "filterDueDateTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDueDateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDueDateTo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "return_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.table_options,
      "dtHeaders": _vm.table_headers
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
}]}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.post_and_redirect()
      }
    }
  }, [_vm._v(_vm._s(_vm.link_name))])])])
},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-buffer bottom-buffer"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('label', {
    staticClass: "inline",
    attrs: {
      "id": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), (_vm.help_text_url) ? [_c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })] : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "collapse-link-top pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.expand($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "children-anchor-point collapse in",
    staticStyle: {
      "padding-left": "0px"
    }
  }), _vm._v(" "), (_vm.isPreviewMode) ? _c('span', {
    class: {
      'hidden': _vm.isRemovable
    }
  }, [_c('a', {
    attrs: {
      "id": 'remove_' + _vm.name
    }
  }, [_vm._v("Remove " + _vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "collapse-link-bottom pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.minimize($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up"
  })]), _vm._v(" "), _c('div', {
    class: {
      'row': true, 'collapse': true, 'in': _vm.isExpanded
    },
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._t("default")], 2)])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CallWorkflow"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.regionVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Region")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionId),
      expression: "regionId"
    }],
    staticClass: "form-control col-sm-9",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.regionId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.preventDefault();
        return _vm.updateDistricts($event)
      }]
    }
  }, _vm._l((_vm.regions), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.name) + " \n                                ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.regionVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("District")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.districtId),
      expression: "districtId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.districtId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.preventDefault();
        return _vm.updateAllocatedGroup()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.availableDistricts), function(option) {
    return _c('option', {
      key: option.district_id,
      domProps: {
        "value": option.district_id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.district_name) + " \n                                ")])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.allocateToVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Allocate to")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assigned_to_id),
      expression: "assigned_to_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assigned_to_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allocatedGroup), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.full_name) + " \n                                ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.workflow_type === 'close') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Referred To")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    ref: "referrerList",
    staticClass: "form-control input-sm",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": ""
    }
  }, _vm._l((_vm.referrers), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                        " + _vm._s(option.name) + " \n                                    ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.workflow_type === 'close') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.advice_details),
      expression: "advice_details"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add details",
      "id": "details"
    },
    domProps: {
      "value": (_vm.advice_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.advice_details = $event.target.value
      }
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflowDetails),
      expression: "workflowDetails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add details",
      "id": "details"
    },
    domProps: {
      "value": (_vm.workflowDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workflowDetails = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": _vm.call_email.commsLogsDocumentUrl
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }, [_vm._v(_vm._s(_vm.errorResponse))])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "profile_form",
      "method": "post"
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profile Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.name),
      expression: "profile.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Institution")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.institution),
      expression: "profile.institution"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "institution",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.institution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "institution", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Line 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.line1),
      expression: "profile.postal_address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "line1",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Line 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.line2),
      expression: "profile.postal_address.line2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "line2",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.line2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "line2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Line 3")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.line3),
      expression: "profile.postal_address.line3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "line3",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.line3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "line3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Suburb/Town (Locality)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.locality),
      expression: "profile.postal_address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "locality",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.state),
      expression: "profile.postal_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "state",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.country),
      expression: "profile.postal_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "country",
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile.postal_address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(c) {
    return _c('option', {
      domProps: {
        "value": c.code
      }
    }, [_vm._v(_vm._s(c.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.postcode),
      expression: "profile.postal_address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "postcode", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.creatingProfile) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createProfile()
      }
    }
  }, [_vm._v("Create")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Creating")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Create Profile\n                ")])])
}]}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n            Logs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Communications")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('a', {
    ref: "showCommsBtn",
    staticClass: "actionBtn"
  }, [_vm._v("Show")])]), _vm._v(" "), (!_vm.disable_add_entry) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('a', {
    ref: "addCommsBtn",
    staticClass: "actionBtn pull-right",
    on: {
      "click": function($event) {
        return _vm.addComm()
      }
    }
  }, [_vm._v("Add Entry")])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Actions")]), _c('br'), _vm._v(" "), _c('a', {
    ref: "showActionBtn",
    staticClass: "actionBtn",
    attrs: {
      "tabindex": "2"
    }
  }, [_vm._v("Show")])])])])]), _vm._v(" "), _c('AddCommLog', {
    ref: "add_comm",
    attrs: {
      "url": _vm.comms_add_url
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1"
  }, [_c('span', [_vm._v("|")])])
}]}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Applications "), (_vm.is_external) ? _c('small', [_vm._v("View existing applications and lodge new ones")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicationLicenceType),
      expression: "filterApplicationLicenceType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterApplicationLicenceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.application_licence_types), function(lt) {
    return _c('option', {
      key: ("licence_type_" + (lt.id)),
      domProps: {
        "value": lt.name
      }
    }, [_vm._v(_vm._s(lt.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicationStatus),
      expression: "filterApplicationStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterApplicationStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.application_status), function(s) {
    return _c('option', {
      key: ("status_" + (s.id)),
      domProps: {
        "value": s
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Activity")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicationActivity),
      expression: "filterApplicationActivity"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterApplicationActivity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.application_activities), function(a) {
    return _c('option', {
      key: ("activity_" + (a.value)),
      domProps: {
        "value": a.value
      }
    }, [_vm._v(_vm._s(a.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "to": {
        name: 'apply_application_organisation'
      }
    }
  }, [_vm._v("New Application")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Lodged From")]), _vm._v(" "), _c('div', {
    ref: "applicationDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicationLodgedFrom),
      expression: "filterApplicationLodgedFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterApplicationLodgedFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterApplicationLodgedFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Lodged To")]), _vm._v(" "), _c('div', {
    ref: "applicationDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicationLodgedTo),
      expression: "filterApplicationLodgedTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterApplicationLodgedTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterApplicationLodgedTo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.level == 'external') ? _c('datatable', {
    ref: "external_application_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.application_ex_options,
      "dtHeaders": _vm.application_ex_headers
    }
  }) : _c('datatable', {
    ref: "application_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.application_options,
      "dtHeaders": _vm.application_headers
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br')])
}]}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalCallEmailDash"
    }
  }, [_c('FormSection', {
    attrs: {
      "label": "Call/Emails",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Call/Email Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.status_choices), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.display
      }
    }, [_vm._v("\n                        " + _vm._s(option.display) + "\n                    ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Call/Email Classification")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterClassification),
      expression: "filterClassification"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterClassification = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.classification_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.display
      }
    }, [_vm._v("\n                        " + _vm._s(option.display) + " \n                    ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Lodged From")]), _vm._v(" "), _c('div', {
    ref: "lodgementDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLodgedFrom),
      expression: "filterLodgedFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterLodgedFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterLodgedFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Lodged To")]), _vm._v(" "), _c('div', {
    ref: "lodgementDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLodgedTo),
      expression: "filterLodgedTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterLodgedTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterLodgedTo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]), _vm._v(" "), (_vm.newCallEmailVisibility) ? _c('div', {
    staticClass: "col-md-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCallEmailUrl($event)
      }
    }
  }, [_vm._v("New Call/Email")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "call_email_table",
    attrs: {
      "id": "call-email-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders,
      "parentStyle": "wrap"
    }
  })], 1)])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "label": "Location",
      "Index": "1"
    }
  }, [_c('MapLocations')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "method": "POST",
      "name": "internal_returns_form",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalReturn"
    }
  }, [(_vm.isReturnsLoaded) ? _c('Returns', [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [
    [_c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h3', {
      staticClass: "panel-title"
    }, [_vm._v("Condition Details\n                    "), _c('a', {
      staticClass: "panelClicker",
      attrs: {
        "href": '#' + _vm.pdBody,
        "data-toggle": "collapse",
        "data-parent": "#userInfo",
        "expanded": "true",
        "aria-controls": _vm.pdBody
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-chevron-up pull-right "
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body panel-collapse in",
      attrs: {
        "id": _vm.pdBody
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('form', {
      staticClass: "form-horizontal",
      attrs: {
        "name": "return_form"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-3 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Licence Activity")]), _vm._v(" "), (_vm.returns.condition) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_vm._v("\n                                " + _vm._s(_vm.returns.condition.licence_activity.name) + "\n                            ")]) : _c('div', {
      staticClass: "col-sm-6"
    }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-3 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Condition")]), _vm._v(" "), (_vm.returns.condition) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.returns.condition.condition),
        expression: "returns.condition.condition"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": "",
        "name": "details",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.returns.condition.condition)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.returns.condition, "condition", $event.target.value)
        }
      }
    })]) : _c('div', {
      staticClass: "col-sm-6"
    }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-3 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Due Date")]), _vm._v(" "), (_vm.returns.condition) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_vm._v("\n                                " + _vm._s(_vm.returns.condition.due_date) + "\n                            ")]) : _c('div', {
      staticClass: "col-sm-6"
    }, [_vm._v("  ")])])])])])])], _vm._v(" "), (_vm.returns.format === 'sheet') ? _c('ReturnSheet') : _vm._e(), _vm._v(" "), (_vm.returns.format === 'question') ? _c('ReturnQuestion') : _vm._e(), _vm._v(" "), (_vm.returns.format === 'data') ? _c('ReturnData') : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showSaveAndContinueButton),
        expression: "showSaveAndContinueButton"
      }],
      staticClass: "row",
      staticStyle: {
        "margin-bottom": "50px"
      }
    }, [_c('div', {
      staticClass: "navbar navbar-fixed-bottom",
      staticStyle: {
        "background-color": "#f5f5f5"
      }
    }, [_c('div', {
      staticClass: "navbar-inner"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('p', {
      staticClass: "pull-right",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [(_vm.spinner_exit) ? _c('button', {
      staticClass: "btn btn-primary btn-md",
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-spin fa-spinner"
    }), _vm._v(" Saving")]) : (!_vm.spinner_exit && _vm.disable_exit) ? _c('button', {
      staticClass: "btn btn-primary btn-md",
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "disabled": "",
        "name": "save_exit"
      }
    }, [_vm._v("Save and Exit")]) : _c('button', {
      staticClass: "btn btn-primary btn-md",
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "name": "save_exit"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.saveandcontinue(false)
        }
      }
    }, [_vm._v("Save and Exit")]), _vm._v(" "), (_vm.spinner_continue) ? _c('button', {
      staticClass: "btn btn-primary btn-md",
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "disabled": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-spin fa-spinner"
    }), _vm._v(" Saving")]) : (!_vm.spinner_continue && _vm.disable_continue) ? _c('button', {
      staticClass: "btn btn-primary btn-md",
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "disabled": "",
        "name": "save_continue"
      }
    }, [_vm._v("Save and Continue")]) : _c('button', {
      staticClass: "btn btn-primary btn-md",
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "name": "save_continue"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.saveandcontinue(true)
        }
      }
    }, [_vm._v("Save and Continue")])])])])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showSaveButton),
        expression: "showSaveButton"
      }],
      staticClass: "row",
      staticStyle: {
        "margin-bottom": "50px"
      }
    }, [_c('div', {
      staticClass: "navbar navbar-fixed-bottom",
      staticStyle: {
        "background-color": "#f5f5f5"
      }
    }, [_c('div', {
      staticClass: "navbar-inner"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('p', {
      staticClass: "pull-right",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [(_vm.showSpinner) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-spin"
    }), _vm._v("Saving")]) : _c('button', {
      staticClass: "btn btn-primary btn-md",
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "name": "save_exit"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.save()
        }
      }
    }, [_vm._v("Save Changes")])])])])])])
  ], 2)]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row panel panel-default confirmation-box"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Your Remediation Action has been submitted successfully.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                    Reference number:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                    " + _vm._s(_vm.remediation_action.remediation_action_id) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                    Lodgement date:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                    " + _vm._s(_vm.lodgement_date) + "\n                ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Apply on behalf of\n                        "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "personal_form",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org_applicant),
      expression: "org_applicant"
    }],
    attrs: {
      "type": "radio",
      "name": "behalf_of_org",
      "value": ""
    },
    domProps: {
      "checked": _vm._q(_vm.org_applicant, "")
    },
    on: {
      "change": function($event) {
        _vm.org_applicant = ""
      }
    }
  }), _vm._v(" On behalf of yourself\n                                    ")])]), _vm._v(" "), _vm._l((_vm.current_user.wildlifecompliance_organisations), function(org) {
    return _c('div', {
      staticClass: "radio"
    }, [(!org.is_consultant) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.org_applicant),
        expression: "org_applicant"
      }],
      attrs: {
        "type": "radio",
        "name": "behalf_of_org"
      },
      domProps: {
        "value": org.id,
        "checked": _vm._q(_vm.org_applicant, org.id)
      },
      on: {
        "change": function($event) {
          _vm.org_applicant = org.id
        }
      }
    }), _vm._v(" On behalf of " + _vm._s(org.name) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (org.is_consultant) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.org_applicant),
        expression: "org_applicant"
      }],
      attrs: {
        "type": "radio",
        "name": "behalf_of_org"
      },
      domProps: {
        "value": org.id,
        "checked": _vm._q(_vm.org_applicant, org.id)
      },
      on: {
        "change": function($event) {
          _vm.org_applicant = org.id
        }
      }
    }), _vm._v(" On behalf of " + _vm._s(org.name) + " (as a Consultant)\n                                    ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.org_applicant === null
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Continue")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.help_text_url) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.help_text_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(" ")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalUserInfo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h3', [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name) + " - " + _vm._s(_vm.user.dob) + " (" + _vm._s(_vm.user.email) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": "test"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "pills-tabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "pills-details",
      "role": "tabpanel",
      "aria-labelledby": "pills-details-tab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Personal Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "personal_form",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Given Name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    ref: "dob",
    staticClass: "input-group date",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.dob),
      expression: "user.dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "dob",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.user.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "dob", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verified Given Name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.legal_first_name),
      expression: "user.legal_first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.legal_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "legal_first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verified Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.legal_last_name),
      expression: "user.legal_last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.legal_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "legal_last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verified Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    ref: "dob",
    staticClass: "input-group date",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.legal_dob),
      expression: "user.legal_dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "dob",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.user.legal_dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "legal_dob", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b', [_vm._v("To update this account please "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "target": "_blank",
      "href": _vm.user.acc_mgmt_url
    }
  }, [_vm._v("click here")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Identification\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.idBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.idBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.idBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "id_form",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.uploadedID) ? _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_c('SecureBaseLink', {
    attrs: {
      "link_name": "Uploaded Photo ID",
      "link_data": {
        'customer_id': _vm.user.id
      }
    }
  })], 1) : (!_vm.uploadedID) ? _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_vm._v("Attach Photo ID"), _c('input', {
    ref: "uploadedID",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.readFileID()
      }
    }
  })]) : _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_vm._v(" Uploading...")]), _vm._v(" "), (_vm.uploadedID) ? _c('span', {
    staticClass: "btn btn-link btn-file pull-left"
  }, [_c('a', {
    staticClass: "fa fa-trash-o",
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    attrs: {
      "title": "Remove file"
    },
    on: {
      "click": function($event) {
        return _vm.removeID()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Address Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.adBody,
      "data-toggle": "collapse",
      "expanded": "false",
      "data-parent": "#userInfo",
      "aria-controls": _vm.adBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), (_vm.loading.length == 0) ? _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.adBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.residential_address.line1),
      expression: "user.residential_address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.residential_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.residential_address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.residential_address.locality),
      expression: "user.residential_address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.residential_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.residential_address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.residential_address.state),
      expression: "user.residential_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.residential_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.residential_address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.residential_address.postcode),
      expression: "user.residential_address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.residential_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.residential_address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.residential_address.country),
      expression: "user.residential_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.residential_address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(c) {
    return _c('option', {
      key: c.code,
      domProps: {
        "value": c.code
      }
    }, [_vm._v(_vm._s(c.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingAddress) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateAddress()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Contact Details "), _c('small'), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.cdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.cdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.cdBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone_number),
      expression: "user.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.mobile_number),
      expression: "user.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "mobile",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "mobile_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "disabled": "disabled",
      "name": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingContact) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateContact()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Organisations "), _c('small'), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.odBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.odBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.odBody
    }
  }, [_vm._l((_vm.user.wildlifecompliance_organisations), function(org) {
    return _c('div', {
      key: org.id
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (org.name),
        expression: "org.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (org.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(org, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (org.abn),
        expression: "org.abn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (org.abn)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(org, "abn", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.unlinkUser(org)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chain-broken fa-2x"
    }), _vm._v(" Unlink")])])])
  }), _vm._v(" "), _vm._l((_vm.orgRequest_pending), function(orgReq) {
    return _c('div', {
      key: orgReq.id
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.name),
        expression: "orgReq.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.abn),
        expression: "orgReq.abn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.abn)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "abn", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', [_vm._v("Pending for Approval (#" + _vm._s(orgReq.id) + ")")])])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "pills-licensing",
      "role": "tabpanel",
      "aria-labelledby": "pills-licensing-tab"
    }
  }, [_c('ApplicationDashTable', {
    ref: "applications_table",
    attrs: {
      "level": "internal",
      "url": _vm.applications_url
    }
  }), _vm._v(" "), _c('LicenceDashTable', {
    ref: "licences_table",
    attrs: {
      "level": "internal",
      "url": _vm.licences_url
    }
  }), _vm._v(" "), _c('ReturnDashTable', {
    ref: "returns_table",
    attrs: {
      "level": "internal",
      "url": _vm.returns_url
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "pills-compliance",
      "role": "tabpanel",
      "aria-labelledby": "pills-compliance-tab"
    }
  }, [(_vm.user.id) ? _c('SanctionOutcomePersonOrgDashTable', {
    ref: "sanction_outcome_person_org_table",
    attrs: {
      "level": "internal",
      "entity_id": _vm.user.id,
      "entity_type": "person"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.id) ? _c('LegalCasePersonOrgDashTable', {
    ref: "legal_case_person_org_table",
    attrs: {
      "level": "internal",
      "entity_id": _vm.user.id,
      "entity_type": "person"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.id) ? _c('IntelligenceInformation', {
    ref: "intelligence_information",
    attrs: {
      "entity_id": _vm.user.id,
      "entity_type": "person"
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "pills-tab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "id": "pills-details-tab",
      "data-toggle": "pill",
      "href": "#pills-details",
      "role": "tab",
      "aria-controls": "pills-details",
      "aria-selected": "true"
    }
  }, [_vm._v("\n                        Details\n                    ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "pills-licensing-tab",
      "data-toggle": "pill",
      "href": "#pills-licensing",
      "role": "tab",
      "aria-controls": "pills-licensing",
      "aria-selected": "false"
    }
  }, [_vm._v("\n                        Licensing\n                    ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "pills-compliance-tab",
      "data-toggle": "pill",
      "href": "#pills-compliance",
      "role": "tab",
      "aria-controls": "pills-compliance",
      "aria-selected": "false"
    }
  }, [_vm._v("\n                        Compliance\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  })])
}]}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "intelligenceInformation"
    }
  }, [_c('FormSection', {
    attrs: {
      "label": "Intelligence Information",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.intelligenceText),
      expression: "intelligenceText"
    }],
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "value": (_vm.intelligenceText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.intelligenceText = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.saving) ? _c('div', {
    staticClass: "col-lg-2"
  }, [(_vm.show_spinner) ? _c('div', [_c('i', {
    staticClass: "fa fa-2x fa-spinner fa-spin"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveIntelligence($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('filefield', {
    ref: "intelligence_information",
    attrs: {
      "name": "intelligence-information-file",
      "isRepeatable": true,
      "documentActionUrl": _vm.documentActionUrl
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isApplicationLoaded) ? _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalApplicationAssessment"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "showOk": true,
      "okClass": "btn btn-primary",
      "closeWhenOk": true,
      "okText": "Mark Complete",
      "cancelClass": "btn btn-primary",
      "title": "Assessment Records",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.completeAssessmentsToMe()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body panel-collapse collapse in"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "assessment_form",
      "method": "put"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Select licensed activities with assessment for completion")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.activitiesWithAssessment), function(a, index) {
    return _c('div', {
      key: ("a_" + index),
      staticClass: "col-sm-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedActivities),
        expression: "checkedActivities"
      }],
      attrs: {
        "type": "checkbox",
        "name": "licence_activity",
        "id": a.licence_activity
      },
      domProps: {
        "value": a.licence_activity,
        "checked": Array.isArray(_vm.checkedActivities) ? _vm._i(_vm.checkedActivities, a.licence_activity) > -1 : (_vm.checkedActivities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedActivities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = a.licence_activity,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedActivities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedActivities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedActivities = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(a.activity_name_str) + "\n                                            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Final Comments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.final_comment),
      expression: "final_comment"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%",
      "max-width": "100%"
    },
    attrs: {
      "readonly": !_vm.canCompleteAssessment
    },
    domProps: {
      "value": (_vm.final_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.final_comment = $event.target.value
      }
    }
  })])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.headerLabel) + ": " + _vm._s(_vm.application.lodgement_number))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                       Submission \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Submitted by")]), _c('br'), _vm._v("\n                                " + _vm._s(_vm.application.submitter.first_name) + " " + _vm._s(_vm.application.submitter.last_name) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Lodged on")]), _c('br'), _vm._v("\n                                " + _vm._s(_vm._f("formatDate")(_vm.application.lodgement_date)) + "\n                            ")]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                        Workflow \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                                " + _vm._s(_vm.application.processing_status.name)), _c('br'), _vm._v(" "), _vm._l((_vm.licence_type_data), function(item) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, _vm._l((item), function(item1) {
      return _c('div', [(item1.name) ? _c('div', [_c('strong', [_vm._v(_vm._s(item1.name) + ": ")]), _vm._v(_vm._s(item1.processing_status.name) + "\n                                        ")]) : _vm._e()])
    }), 0)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssignToAssessor),
      expression: "showAssignToAssessor"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Assigned Assessors")]), _c('br'), _vm._v(" "), _vm._l((_vm.activeAssessments), function(activity_assessment) {
    return _c('div', [(activity_assessment.assessor_group.name) ? _c('div', [_c('div', [_vm._v("Assessment for " + _vm._s(activity_assessment.assessor_group.name.split('Wildlife Compliance - Assessors:')[1]))]), _vm._v(" "), [(activity_assessment.assigned_assessor != null) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (activity_assessment.assigned_assessor.id),
        expression: "activity_assessment.assigned_assessor.id"
      }],
      ref: "assigned_assessor",
      refInFor: true,
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(activity_assessment.assigned_assessor, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }), _vm._v(" "), _vm._l((activity_assessment.assessors), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))])
    })], 2) : _vm._e(), _vm._v(" "), (activity_assessment.assigned_assessor == null) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (activity_assessment.assigned_assessor_id),
        expression: "activity_assessment.assigned_assessor_id"
      }],
      ref: "assigned_assessor",
      refInFor: true,
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(activity_assessment, "assigned_assessor_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }), _vm._v(" "), _vm._l((activity_assessment.assessors), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))])
    })], 2) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "actionBtn pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.makeMeAssessor(activity_assessment)
        }
      }
    }, [_vm._v("Assign to me")])]], 2) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.isFinalised) ? [_c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Application")]), _c('br'), _vm._v(" "), (!_vm.showingApplication || !this.unfinishedActivities.length) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: true,
          showFinalised: true
        })
      }
    }
  }, [_vm._v("Show Application")]) : _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: false
        })
      }
    }
  }, [_vm._v("Hide Application")])]), _vm._v(" "), _vm._m(1)])] : _vm._e(), _vm._v(" "), (_vm.isFinalised) ? [_vm._m(2)] : _vm._e(), _vm._v(" "), (!_vm.showBackToProcessingButton) ? [_c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Application")]), _c('br'), _vm._v(" "), (!_vm.showingApplication) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: true,
          showFinalised: false
        })
      }
    }
  }, [_vm._v("Show Application")]) : _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: false,
          showFinalised: false
        })
      }
    }
  }, [_vm._v("Hide Application")]), _c('br')])])] : _vm._e(), _vm._v(" "), (!_vm.showBackToProcessingButton) ? [_vm._m(4)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [(_vm.showingApplication) ? [_vm._m(5), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssessmentConditionButton),
      expression: "showAssessmentConditionButton"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleAssessments()
      }
    }
  }, [_vm._v("Assessments & Conditions")]), _c('br')])])] : [_vm._m(6), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackToProcessingButton),
      expression: "showBackToProcessingButton"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.backToProcessing()
      }
    }
  }, [_vm._v("Back to Processing")]), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRequestInspectionButton),
      expression: "showRequestInspectionButton"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleRequestInspection()
      }
    }
  }, [_vm._v("Request Inspection")]), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCompleteAssessmentsButton),
      expression: "showCompleteAssessmentsButton"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAssessmentModal()
      }
    }
  }, [_vm._v("Complete Assessments")]), _c('br')])])]], 2)], 2)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.applicationDetailsVisible) ? _c('ApplicationAssessments') : _vm._e(), _vm._v(" "), (_vm.applicationDetailsVisible) ? [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tabs-main"
    }
  }, _vm._l((_vm.allCurrentActivities), function(activity, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [_c('a', {
      class: {
        'nav-link amendment-highlight': _vm.application.has_amendment
      },
      attrs: {
        "data-toggle": "pill",
        "href": '#' + _vm.activityTab
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(activity)
        }
      }
    }, [_vm._v(_vm._s(activity.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.activityTab
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "action": _vm.application_form_url,
      "method": "post",
      "name": "new_application",
      "enctype": "multipart/form-data"
    }
  }, [(_vm.isApplicationLoaded) ? _c('Application', {
    attrs: {
      "form_width": "inherit",
      "withSectionsSelector": false
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "csrfmiddlewaretoken"
    },
    domProps: {
      "value": _vm.csrf_token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "schema"
    },
    domProps: {
      "value": JSON.stringify(_vm.application)
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "application_id"
    },
    domProps: {
      "value": 1
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_activity_tab_id),
      expression: "selected_activity_tab_id"
    }],
    attrs: {
      "type": "hidden",
      "id": "selected_activity_tab_id"
    },
    domProps: {
      "value": (_vm.selected_activity_tab_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected_activity_tab_id = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.allCurrentActivities), function(activity, index) {
    return _c('div', [(activity.id == _vm.selected_activity_tab_id) ? _c('renderer-block', {
      key: ("renderer_block_" + index),
      attrs: {
        "component": activity
      }
    }) : _vm._e()], 1)
  }), _vm._v("\n                                            " + _vm._s(this.$slots.default) + "\n\n                                            "), (_vm.showNavBarBottom) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(!_vm.applicationIsDraft && _vm.canSaveApplication) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save Changes")]) : _vm._e()])])])])]) : _vm._e()], 2) : _vm._e()], 1)])])])])] : _vm._e(), _vm._v(" "), _c('InspectionRequest', {
    ref: "inspection",
    on: {
      "inspection-created": _vm.requestedInspection
    }
  })], 2)])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('table', {
    staticClass: "table small-table"
  }, [_c('tr', [_c('th', [_vm._v("Lodgement")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Action")]), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Action")]), _c('br')])])
}]}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalOrgAccess"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Organisation Access Request " + _vm._s(_vm.access.id))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": "test"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                       Submission \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Submitted by")]), _c('br'), _vm._v("\n                                " + _vm._s(_vm.access.requester.full_name) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Lodged on")]), _c('br'), _vm._v("\n                                " + _vm._s(_vm._f("formatDate")(_vm.access.lodgement_date)) + "\n                            ")]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                        Workflow \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                                " + _vm._s(_vm.access.status.name) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Assigned Officer")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [
    [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.access.assigned_officer),
        expression: "access.assigned_officer"
      }],
      ref: "assigned_officer",
      staticClass: "form-control",
      attrs: {
        "disabled": !_vm.officerCanProcess
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.access, "assigned_officer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.organisation_access_group_members), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.name))])
    }), 0), _vm._v(" "), (_vm.officerCanProcess) ? _c('a', {
      staticClass: "actionBtn pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.assignToMe()
        }
      }
    }, [_vm._v("Assign to me")]) : _vm._e()]
  ], 2)]), _vm._v(" "), (_vm.officerCanProcess) ? _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Action")]), _c('br'), _vm._v(" "), (!_vm.isAmendmentRequested) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptRequest()
      }
    }
  }, [_vm._v("Accept")]) : _vm._e(), _vm._v(" "), (_vm.isAmendmentRequested) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Accept")]) : _vm._e(), _c('br'), _vm._v(" "), (!_vm.isAmendmentRequested) ? _c('button', {
    staticClass: "btn btn-primary top-buffer-s",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.amendmentRequest()
      }
    }
  }, [_vm._v("Request Amendment")]) : _vm._e(), _vm._v(" "), (_vm.isAmendmentRequested) ? _c('button', {
    staticClass: "btn btn-primary top-buffer-s",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Amendment Requested")]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary top-buffer-s",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.declineRequest()
      }
    }
  }, [_vm._v("Decline")])]) : _vm._e()])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', [_vm._v("Organisation Access Request " + _vm._s(_vm.requestType))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "access_form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.access.name),
      expression: "access.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "name": "name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.access.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.access, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.access.abn),
      expression: "access.abn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "name": "abn",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.access.abn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.access, "abn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Letter")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.access.identification
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Organisation Proof Document")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.access.requester.phone_number),
      expression: "access.requester.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "name": "phone",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.access.requester.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.access.requester, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.access.requester.mobile_number),
      expression: "access.requester.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "name": "mobile",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.access.requester.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.access.requester, "mobile_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.access.requester.email),
      expression: "access.requester.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "name": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.access.requester.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.access.requester, "email", $event.target.value)
      }
    }
  })])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('table', {
    staticClass: "table small-table"
  }, [_c('tr', [_c('th', [_vm._v("Lodgment")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])])
}]}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "related_items_table",
    attrs: {
      "parentStyle": " ",
      "id": "related-items-table",
      "dtOptions": _vm.dtOptionsRelatedItems,
      "dtHeaders": _vm.dtHeadersRelatedItems
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('WeakLinks', {
    ref: "weak_links_lookup",
    attrs: {
      "readonlyForm": _vm.readonlyForm,
      "displayedEntityType": _vm.displayedEntityType,
      "displayedEntityId": _vm.displayedEntityId
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalDash"
    }
  }, [_c('ReturnDashTable', {
    attrs: {
      "level": "internal",
      "url": _vm.returns_url
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_vm._v("\n                        Are you sure you want to accept the remediation action?\n                    ")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorResponse)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processingDetails) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : (_vm.fieldsFilled) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Sanction Outcome: " + _vm._s(_vm.displayLodgementNumber))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                            Workflow\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                                    " + _vm._s(_vm.statusDisplay)), _c('br')])]), _vm._v(" "), _c('Assignment', {
    key: _vm.assignmentKey,
    attrs: {
      "user_is_assignee": _vm.sanction_outcome.user_is_assignee,
      "allowed_group_ids": _vm.sanction_outcome.allowed_groups,
      "user_in_group": _vm.sanction_outcome.user_in_group,
      "assigned_to_id": _vm.sanction_outcome.assigned_to_id,
      "assign_url": _vm.assign_url
    },
    on: {
      "update-assigned-to-id": _vm.updateAssignedToId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                            Action\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [(_vm.visibilityExtendDueDateButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.extendDueDate('')
      }
    }
  }, [_vm._v("\n                                        Extend Due Date\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityEscalateForWithdrawalButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('escalate_for_withdrawal')
      }
    }
  }, [_vm._v("\n                                        Escalate for Withdrawal\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilitySendParkingInfringementButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.sendParkingInfringement()
      }
    }
  }, [_vm._v("\n                                        Endorse Parking Infringement\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityRecordFerCaseNumberButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.recordFerCaseNumber('')
      }
    }
  }, [_vm._v("\n                                        Record FER Case Number\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityReturnToInfringementNoticeCoordinatorButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('return_to_infringement_notice_coordinator')
      }
    }
  }, [_vm._v("\n                                        Return to"), _c('br'), _vm._v("Infringement Notice Coordinator\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityWithdrawByBranchManagerButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('withdraw_by_branch_manager')
      }
    }
  }, [_vm._v("\n                                        Withdraw\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityWithdrawButtonForManager) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('withdraw_by_manager')
      }
    }
  }, [_vm._v("\n                                        Withdraw\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityEndorseButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('endorse')
      }
    }
  }, [_vm._v("\n                                        Endorse\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityDeclineButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('decline')
      }
    }
  }, [_vm._v("\n                                        Decline\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityReturnToOfficerButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('return_to_officer')
      }
    }
  }, [_vm._v("\n                                        Return to Officer\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilitySendToManagerButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('send_to_manager')
      }
    }
  }, [_vm._v("\n                                        Send to Manager\n                                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.visibilityMarkDocumentPostedButton) ? _c('div', {
    staticClass: "row action-button"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('mark_document_posted')
      }
    }
  }, [_vm._v("\n                                        Mark Document Posted\n                                    ")])])]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills aho2"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.soTab
    }
  }, [_vm._v(_vm._s(_vm.typeDisplay))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayRemediationActions),
      expression: "displayRemediationActions"
    }],
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.raTab
    }
  }, [_vm._v("Remediation Actions")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.deTab
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.reTab
    }
  }, [_vm._v("Related Items")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.soTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": _vm.typeDisplay,
      "Index": "1"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.identifier),
      expression: "sanction_outcome.identifier"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.sanction_outcome.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "identifier", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Offence")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayOffence),
      expression: "displayOffence"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.displayOffence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayOffence = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Offender")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.sanction_outcome && _vm.sanction_outcome.offence && _vm.sanction_outcome.offence.offenders) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.offender),
      expression: "sanction_outcome.offender"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sanction_outcome, "offender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.sanction_outcome.offence.offenders), function(offender) {
    return _c('option', {
      key: offender.id,
      domProps: {
        "value": offender
      }
    }, [(offender.person) ? _c('span', [_vm._v("\n                                                            " + _vm._s(offender.person.first_name + ' ' + offender.person.last_name + ', DOB:' + offender.person.dob) + "\n                                                        ")]) : (offender.organisation) ? _c('span', [_vm._v("\n                                                            " + _vm._s(offender.organisation.name + ', ABN: ' + offender.organisation.abn) + "\n                                                        ")]) : _vm._e()])
  })], 2)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Vehicle Registration Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.registration_number),
      expression: "sanction_outcome.registration_number"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.sanction_outcome.registration_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "registration_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', [_vm._v("Alleged committed offence")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "alleged_committed_offence_table",
    attrs: {
      "id": "alleged-committed-offence-table",
      "dtOptions": _vm.dtOptionsAllegedOffence,
      "dtHeaders": _vm.dtHeadersAllegedOffence
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Issued on paper?")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.issued_on_paper),
      expression: "sanction_outcome.issued_on_paper"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "issued_on_paper_yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.sanction_outcome.issued_on_paper, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.sanction_outcome, "issued_on_paper", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "issued_on_paper_yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.issued_on_paper),
      expression: "sanction_outcome.issued_on_paper"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "issued_on_paper_no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.sanction_outcome.issued_on_paper, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.sanction_outcome, "issued_on_paper", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "issued_on_paper_no"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Paper ID")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.paper_id),
      expression: "sanction_outcome.paper_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.readonlyForm,
      "name": "paper_id",
      "placeholder": "",
      "disabled": !_vm.sanction_outcome.issued_on_paper
    },
    domProps: {
      "value": (_vm.sanction_outcome.paper_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "paper_id", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Paper notice")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "paper_id_notice"
    }
  }, [(_vm.sanction_outcome.issued_on_paper) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_c('filefield', {
    ref: "sanction_outcome_file",
    attrs: {
      "name": "sanction-outcome-file",
      "documentActionUrl": _vm.sanction_outcome.sanctionOutcomeDocumentUrl,
      "isRepeatable": true,
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-parent": _vm.sanctionOutcomeDocumentUploaded
    }
  })], 1) : _vm._e()])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.raTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Remediation Actions",
      "Index": "2"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Remediation Actions")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "tbl_remediation_actions",
    attrs: {
      "id": "tbl_remediation_actions",
      "dtOptions": _vm.dtOptionsRemediationActions,
      "dtHeaders": _vm.dtHeadersRemediationActions
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.deTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Details",
      "Index": "3"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.description),
      expression: "sanction_outcome.description"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "placeholder": "add description",
      "id": "sanction-outcome-description"
    },
    domProps: {
      "value": (_vm.sanction_outcome.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Date of Issue")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "dateOfIssuePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.date_of_issue),
      expression: "sanction_outcome.date_of_issue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY",
      "disabled": !_vm.sanction_outcome.issued_on_paper || _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.sanction_outcome.date_of_issue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "date_of_issue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Time of Issue")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "timeOfIssuePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.time_of_issue),
      expression: "sanction_outcome.time_of_issue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "HH:MM",
      "disabled": !_vm.sanction_outcome.issued_on_paper || _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.sanction_outcome.time_of_issue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "time_of_issue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])]), _vm._v(" "), (_vm.visibilityParkingInfringementSection) ? _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Further Offender Details",
      "Index": "4"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Registration Holder:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('RegistrationHolder', {
    key: _vm.registrationHolderBindId,
    ref: "search_registration_holder",
    attrs: {
      "showClearPerson": true,
      "excludeStaff": true,
      "personOnly": true,
      "displayTitle": false,
      "isEditable": _vm.canUserEditParkingDetails,
      "parentEntity": _vm.registrationHolder,
      "classNames": "form-control",
      "showCreateUpdate": "",
      "domIdHelper": "registration_holder"
    },
    on: {
      "entity-selected": _vm.registrationHolderSelected,
      "clear-person": _vm.clearRegistrationHolder
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Driver:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('Driver', {
    key: _vm.updateDriverBindId,
    ref: "search_driver",
    attrs: {
      "showClearPerson": true,
      "excludeStaff": true,
      "personOnly": true,
      "displayTitle": false,
      "isEditable": _vm.canUserEditParkingDetails,
      "parentEntity": _vm.driver,
      "classNames": "form-control",
      "showCreateUpdate": "",
      "domIdHelper": "driver"
    },
    on: {
      "entity-selected": _vm.driverSelected,
      "clear-person": _vm.clearDriver
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.sanction_outcome.due_dates && _vm.sanction_outcome.due_dates.length > 0) ? _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Due Date",
      "Index": "5"
    }
  }, _vm._l((_vm.sanction_outcome.due_dates), function(item) {
    return _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('label', [_vm._v("Payment due date:")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatDate(item.due_date_applied)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Reason:")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_vm._v("\n                                                " + _vm._s(item.reason_for_extension) + "\n                                            ")])])])])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.reTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items",
      "Index": "6"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": _vm.readonlyForm
    }
  })], 1)])])])], 1)])])])])]), _vm._v(" "), (_vm.visibilitySaveButton) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.workflow_type) ? _c('div', [_c('SanctionOutcomeWorkflow', {
    key: _vm.workflowBindId,
    ref: "add_workflow",
    attrs: {
      "workflow_type": _vm.workflow_type
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.extendPaymentDueDateInitialized) ? _c('div', [_c('ExtendPaymentDueDate', {
    key: _vm.extendDueDateBindId,
    ref: "extend_payment_due_date",
    attrs: {
      "due_date_1st": _vm.last_due_date_1st,
      "due_date_2nd": _vm.last_due_date_2nd,
      "due_date_max": _vm.sanction_outcome.due_date_extended_max
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.recordFerCaseNumberInitialized) ? _c('div', [_c('RecordFerCaseNumber', {
    key: _vm.recordFerCaseNumberBindId,
    ref: "record_fer_case_number"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sendParkingInfringementInitialized) ? _c('div', [_c('SendParkingInfringement', {
    key: _vm.sendParkingInfringementBindId,
    ref: "send_parking_infringement"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.acceptRemediationActionInitialized) ? _c('div', [_c('AcceptRemediationAction', {
    key: _vm.acceptRemediationActionBindId,
    ref: "accept_remediation_action",
    attrs: {
      "remediation_action_id": _vm.remediation_action_id
    },
    on: {
      "remediation_action_accepted": _vm.onRemediationActionUpdated
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.requestAmendmentRemediationAction) ? _c('div', [_c('RequestAmendmentRemediationAction', {
    key: _vm.requestAmendmentRemediationActionBindId,
    ref: "request_amendment_remediation_action",
    attrs: {
      "remediation_action_id": _vm.remediation_action_id
    },
    on: {
      "remediation_action_updated": _vm.onRemediationActionUpdated
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "flexContainer"
  }, [_c('label', {
    staticClass: "flexItemTitleDatetime"
  }, [_vm._v("Court")]), _vm._v(" "), (_vm.courts.length > 0) ? _c('div', {
    staticClass: "flexItemDatetime"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.court_location),
      expression: "court_location"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.court_location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.emitEvent()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.courts), function(co) {
    return _c('option', {
      key: co.id,
      domProps: {
        "value": co
      }
    }, [_vm._v("\n                    " + _vm._s(co.identifier) + "\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.court_location) ? _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.court_location.location
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer"
  }, [_c('label', {
    staticClass: "flexItemTitleDatetime"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "flexItemDatetime"
  }, [_c('div', {
    ref: "courtDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm,
      "type": "text"
    },
    domProps: {
      "value": _vm.court_date
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('label', {
    staticClass: "flexItemTitleDatetime"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "flexItemDatetime"
  }, [_c('div', {
    ref: "courtTimePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm,
      "type": "text"
    },
    domProps: {
      "value": _vm.court_time
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('label', {
    staticClass: "flexItemTitleComments"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('div', {
    staticClass: "flexItemComments"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.court_comments),
      expression: "court_comments"
    }],
    ref: "courtComments",
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm,
      "type": "text"
    },
    domProps: {
      "value": (_vm.court_comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.court_comments = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
}]}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Statement of Facts"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Statement of facts\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.statement_of_facts),
      expression: "prosecutionBrief.statement_of_facts"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.statement_of_facts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "statement_of_facts", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Case Information Form"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.victim_impact_statement_taken),
      expression: "prosecutionBrief.victim_impact_statement_taken"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.victim_impact_statement_taken) ? _vm._i(_vm.prosecutionBrief.victim_impact_statement_taken, null) > -1 : (_vm.prosecutionBrief.victim_impact_statement_taken)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.victim_impact_statement_taken,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "victim_impact_statement_taken", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "victim_impact_statement_taken", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "victim_impact_statement_taken", $$c)
        }
      }
    }
  }), _vm._v("\n                Victim impact statement to be taken?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.victim_impact_statement_taken) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.victim_impact_statement_taken_details),
      expression: "prosecutionBrief.victim_impact_statement_taken_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.victim_impact_statement_taken_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "victim_impact_statement_taken_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.statements_pending),
      expression: "prosecutionBrief.statements_pending"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.statements_pending) ? _vm._i(_vm.prosecutionBrief.statements_pending, null) > -1 : (_vm.prosecutionBrief.statements_pending)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.statements_pending,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "statements_pending", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "statements_pending", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "statements_pending", $$c)
        }
      }
    }
  }), _vm._v("\n                Witness (including expert statements) still to be taken?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.statements_pending) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.statements_pending_details),
      expression: "prosecutionBrief.statements_pending_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.statements_pending_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "statements_pending_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.vulnerable_hostile_witnesses),
      expression: "prosecutionBrief.vulnerable_hostile_witnesses"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.vulnerable_hostile_witnesses) ? _vm._i(_vm.prosecutionBrief.vulnerable_hostile_witnesses, null) > -1 : (_vm.prosecutionBrief.vulnerable_hostile_witnesses)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.vulnerable_hostile_witnesses,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "vulnerable_hostile_witnesses", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "vulnerable_hostile_witnesses", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "vulnerable_hostile_witnesses", $$c)
        }
      }
    }
  }), _vm._v("\n                Vulnerable / hostile witnesses?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.vulnerable_hostile_witnesses) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.vulnerable_hostile_witnesses_details),
      expression: "prosecutionBrief.vulnerable_hostile_witnesses_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.vulnerable_hostile_witnesses_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "vulnerable_hostile_witnesses_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.witness_refusing_statement),
      expression: "prosecutionBrief.witness_refusing_statement"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.witness_refusing_statement) ? _vm._i(_vm.prosecutionBrief.witness_refusing_statement, null) > -1 : (_vm.prosecutionBrief.witness_refusing_statement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.witness_refusing_statement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "witness_refusing_statement", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "witness_refusing_statement", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "witness_refusing_statement", $$c)
        }
      }
    }
  }), _vm._v("\n                Witnesses refusing to make statements?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.witness_refusing_statement) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.witness_refusing_statement_details),
      expression: "prosecutionBrief.witness_refusing_statement_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.witness_refusing_statement_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "witness_refusing_statement_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.problems_needs_prosecution_witnesses),
      expression: "prosecutionBrief.problems_needs_prosecution_witnesses"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.problems_needs_prosecution_witnesses) ? _vm._i(_vm.prosecutionBrief.problems_needs_prosecution_witnesses, null) > -1 : (_vm.prosecutionBrief.problems_needs_prosecution_witnesses)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.problems_needs_prosecution_witnesses,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "problems_needs_prosecution_witnesses", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "problems_needs_prosecution_witnesses", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "problems_needs_prosecution_witnesses", $$c)
        }
      }
    }
  }), _vm._v("\n                Specific problems / needs of prosecution witnesses, e.g. interpreters?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.problems_needs_prosecution_witnesses) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.problems_needs_prosecution_witnesses),
      expression: "prosecutionBrief.problems_needs_prosecution_witnesses"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.problems_needs_prosecution_witnesses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "problems_needs_prosecution_witnesses", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.accused_bad_character),
      expression: "prosecutionBrief.accused_bad_character"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.accused_bad_character) ? _vm._i(_vm.prosecutionBrief.accused_bad_character, null) > -1 : (_vm.prosecutionBrief.accused_bad_character)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.accused_bad_character,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "accused_bad_character", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "accused_bad_character", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "accused_bad_character", $$c)
        }
      }
    }
  }), _vm._v("\n                History of bad character / propensity (similar fact) evidence involving accused?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.accused_bad_character) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.accused_bad_character_details),
      expression: "prosecutionBrief.accused_bad_character_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.accused_bad_character_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "accused_bad_character_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.further_persons_interviews_pending),
      expression: "prosecutionBrief.further_persons_interviews_pending"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.further_persons_interviews_pending) ? _vm._i(_vm.prosecutionBrief.further_persons_interviews_pending, null) > -1 : (_vm.prosecutionBrief.further_persons_interviews_pending)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.further_persons_interviews_pending,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "further_persons_interviews_pending", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "further_persons_interviews_pending", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "further_persons_interviews_pending", $$c)
        }
      }
    }
  }), _vm._v("\n                Further persons (witness or suspect) to be interviewed?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.further_persons_interviews_pending) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.further_persons_interviews_pending_details),
      expression: "prosecutionBrief.further_persons_interviews_pending_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.further_persons_interviews_pending_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "further_persons_interviews_pending_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.other_interviews),
      expression: "prosecutionBrief.other_interviews"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.other_interviews) ? _vm._i(_vm.prosecutionBrief.other_interviews, null) > -1 : (_vm.prosecutionBrief.other_interviews)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.other_interviews,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "other_interviews", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "other_interviews", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "other_interviews", $$c)
        }
      }
    }
  }), _vm._v("\n                Other persons whose details do not appear on this brief who have been interviewed?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.other_interviews) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.other_interviews_details),
      expression: "prosecutionBrief.other_interviews_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.other_interviews_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "other_interviews_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.relevant_persons_pending_charges),
      expression: "prosecutionBrief.relevant_persons_pending_charges"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.relevant_persons_pending_charges) ? _vm._i(_vm.prosecutionBrief.relevant_persons_pending_charges, null) > -1 : (_vm.prosecutionBrief.relevant_persons_pending_charges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.relevant_persons_pending_charges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "relevant_persons_pending_charges", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "relevant_persons_pending_charges", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "relevant_persons_pending_charges", $$c)
        }
      }
    }
  }), _vm._v("\n                Other relevant persons charged or yet to be charged?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.relevant_persons_pending_charges) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.relevant_persons_pending_charges_details),
      expression: "prosecutionBrief.relevant_persons_pending_charges_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.relevant_persons_pending_charges_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "relevant_persons_pending_charges_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.other_persons_receiving_sanction_outcome),
      expression: "prosecutionBrief.other_persons_receiving_sanction_outcome"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.other_persons_receiving_sanction_outcome) ? _vm._i(_vm.prosecutionBrief.other_persons_receiving_sanction_outcome, null) > -1 : (_vm.prosecutionBrief.other_persons_receiving_sanction_outcome)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.other_persons_receiving_sanction_outcome,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "other_persons_receiving_sanction_outcome", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "other_persons_receiving_sanction_outcome", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "other_persons_receiving_sanction_outcome", $$c)
        }
      }
    }
  }), _vm._v("\n                Others receiving Infringement / Warning arising out of the same incident?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.other_persons_receiving_sanction_outcome) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.other_persons_receiving_sanction_outcome_details),
      expression: "prosecutionBrief.other_persons_receiving_sanction_outcome_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.other_persons_receiving_sanction_outcome_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "other_persons_receiving_sanction_outcome_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.local_public_interest),
      expression: "prosecutionBrief.local_public_interest"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.local_public_interest) ? _vm._i(_vm.prosecutionBrief.local_public_interest, null) > -1 : (_vm.prosecutionBrief.local_public_interest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.local_public_interest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "local_public_interest", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "local_public_interest", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "local_public_interest", $$c)
        }
      }
    }
  }), _vm._v("\n                Matters of local / public interest?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.local_public_interest) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.local_public_interest_details),
      expression: "prosecutionBrief.local_public_interest_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.local_public_interest_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "local_public_interest_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.applications_orders_requests),
      expression: "prosecutionBrief.applications_orders_requests"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.applications_orders_requests) ? _vm._i(_vm.prosecutionBrief.applications_orders_requests, null) > -1 : (_vm.prosecutionBrief.applications_orders_requests)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.applications_orders_requests,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "applications_orders_requests", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "applications_orders_requests", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "applications_orders_requests", $$c)
        }
      }
    }
  }), _vm._v("\n                Other applications / orders on conviction requests?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.applications_orders_requests) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.applications_orders_requests_details),
      expression: "prosecutionBrief.applications_orders_requests_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.applications_orders_requests_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "applications_orders_requests_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.applications_orders_required),
      expression: "prosecutionBrief.applications_orders_required"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.applications_orders_required) ? _vm._i(_vm.prosecutionBrief.applications_orders_required, null) > -1 : (_vm.prosecutionBrief.applications_orders_required)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.applications_orders_required,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "applications_orders_required", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "applications_orders_required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "applications_orders_required", $$c)
        }
      }
    }
  }), _vm._v("\n                Are there any other applications / orders on conviction required?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.applications_orders_required) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.applications_orders_required_details),
      expression: "prosecutionBrief.applications_orders_required_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.applications_orders_required_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "applications_orders_required_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.other_legal_matters),
      expression: "prosecutionBrief.other_legal_matters"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.prosecutionBrief.other_legal_matters) ? _vm._i(_vm.prosecutionBrief.other_legal_matters, null) > -1 : (_vm.prosecutionBrief.other_legal_matters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.prosecutionBrief.other_legal_matters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.prosecutionBrief, "other_legal_matters", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.prosecutionBrief, "other_legal_matters", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.prosecutionBrief, "other_legal_matters", $$c)
        }
      }
    }
  }), _vm._v("\n                Is there any statutory notice, DEC licence, ministerial statement or policy etc. re the matter, premise or person subject to this brief?\n                ")]), _vm._v(" "), (_vm.prosecutionBrief.other_legal_matters) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prosecutionBrief.other_legal_matters_details),
      expression: "prosecutionBrief.other_legal_matters_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.prosecutionBrief.other_legal_matters_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prosecutionBrief, "other_legal_matters_details", $event.target.value)
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Offences, Offenders and Records of Interview",
      "treeHeight": "yes"
    }
  }, [(_vm.pbRoiExist) ? _c('div', [(_vm.pbRoiVisibility) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('TreeSelect', {
    ref: "pb_record_of_interview_tree",
    attrs: {
      "id": "pb-record-of-interview-tree",
      "value": _vm.pbRoiTicked,
      "options": _vm.pbRoiOptions,
      "default-expand-level": Infinity,
      "multiple": "",
      "value-consists-of": "LEAF_PRIORITY",
      "alwaysOpen": "",
      "searchable": false
    },
    on: {
      "input": _vm.setPbRoiTicked
    }
  })], 1)]) : _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.pbRoiOptions), function(record) {
    return _c('div', [(record.show) ? _c('span', [_c('a', {
      attrs: {
        "href": record.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(record.label))])]) : _vm._e(), _vm._v(" "), _vm._l((record.children), function(child) {
      return _c('span', [(child.show) ? _c('span', [_vm._v("\n                                ; "), _c('a', {
        attrs: {
          "href": child.hyperlink,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.label))])]) : _vm._e(), _vm._v(" "), _vm._l((child.children), function(grandchild) {
        return _c('span', [(grandchild.show) ? _c('span', [_vm._v("\n                                    ; "), _c('a', {
          attrs: {
            "href": grandchild.hyperlink,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(grandchild.label))])]) : _vm._e(), _vm._v(" "), _vm._l((grandchild.children), function(greatgrandchild) {
          return _c('span', [(greatgrandchild.show) ? _c('span', [_vm._v("\n                                        ; "), _c('a', {
            attrs: {
              "href": greatgrandchild.hyperlink,
              "target": "_blank"
            }
          }, [_vm._v(_vm._s(greatgrandchild.label))])]) : _vm._e()])
        })], 2)
      })], 2)
    })], 2)
  }), 0)])]) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No Offences, Offenders or Records of Interview")])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Witness Statements, Officer Statements, Expert Statements",
      "treeHeight": "yes"
    }
  }, [(_vm.pbOtherStatementsExist) ? _c('div', [(_vm.pbOtherStatementsVisibility) ? _c('div', {
    staticClass: "col-sm-11 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('TreeSelect', {
    ref: "pb_other_statements_tree",
    attrs: {
      "id": "pb-other-statements-tree",
      "value": _vm.pbOtherStatementsTicked,
      "options": _vm.pbOtherStatementsOptions,
      "default-expand-level": Infinity,
      "multiple": "",
      "value-consists-of": "LEAF_PRIORITY",
      "alwaysOpen": "",
      "searchable": false
    },
    on: {
      "input": _vm.setPbOtherStatementsTicked
    }
  })], 1)]) : _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.pbOtherStatementsOptions), function(record) {
    return _c('div', [(record.show) ? _c('span', [_c('a', {
      attrs: {
        "href": record.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(record.label))])]) : _vm._e(), _vm._v(" "), _vm._l((record.children), function(child) {
      return _c('span', [(child.show) ? _c('span', [_vm._v("\n                                ; "), _c('a', {
        attrs: {
          "href": child.hyperlink,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.label))])]) : _vm._e(), _vm._v(" "), _vm._l((child.children), function(grandchild) {
        return _c('span', [(grandchild.show) ? _c('span', [_vm._v("\n                                    ; "), _c('a', {
          attrs: {
            "href": grandchild.hyperlink,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(grandchild.label))])]) : _vm._e()])
      })], 2)
    })], 2)
  }), 0)])]) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No Witness Statements, Officer Statements or Expert Statements")])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "id": "physical-artifacts-tree",
      "formCollapse": false,
      "label": "List of Exhibits, Sensitive Unused and Non-Sensitive Unused Materials",
      "treeHeight": "yes"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Select the objects to be included on the list of exhibits")]), _vm._v(" "), (_vm.physicalArtifactsUsedVisibility) ? _c('div', {
    staticClass: "col-sm-10"
  }, _vm._l((_vm.physicalArtifactsUsed), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))])])
  }), 0) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No objects on the list of exhibits")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Select the objects to be included on the sensitive unused list of materials")]), _vm._v(" "), (_vm.physicalArtifactsSensitiveUnusedVisibility) ? _c('div', {
    staticClass: "col-sm-10"
  }, _vm._l((_vm.physicalArtifactsSensitiveUnused), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "id": 'tickbox_' + artifact.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))]), _vm._v(" "), (artifact.ticked) ? _c('div', [_c('label', {
      staticClass: "col-sm-3"
    }, [_vm._v("Reason for sensitivity / non-disclosure")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-5"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.reason_sensitive_non_disclosable),
        expression: "artifact.reason_sensitive_non_disclosable"
      }],
      staticClass: "form-control col-sm-6",
      attrs: {
        "id": 'reason_' + artifact.physical_artifact_id,
        "readonly": _vm.readonlyForm
      },
      domProps: {
        "value": (artifact.reason_sensitive_non_disclosable)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(artifact, "reason_sensitive_non_disclosable", $event.target.value)
        }
      }
    })])]) : _vm._e()])
  }), 0) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No objects on the sensitive unused list of materials")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Select the objects to be included on the non-sensitive unused list of materials")]), _vm._v(" "), (_vm.physicalArtifactsNonSensitiveUnusedVisibility) ? _c('div', {
    staticClass: "col-sm-10"
  }, _vm._l((_vm.physicalArtifactsNonSensitiveUnused), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))])])
  }), 0) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No objects on the non-sensitive unused list of materials")])])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "List of Photographic, Video and Sound Exhibits",
      "treeHeight": "yes"
    }
  }, [(_vm.documentArtifactsVisibility) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.documentArtifacts), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 form-group document-artifact-file"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((artifact.attachments), function(document) {
      return _c('div', [_c('label', [_vm._v(" " + _vm._s(document.name) + "\n                                "), (['png', 'jpg'].includes(document.type)) ? _c('div', [_c('img', {
        staticClass: "col-sm-4",
        attrs: {
          "src": document.file,
          "alt": "image file"
        }
      })]) : (['mp4'].includes(document.type)) ? _c('div', [_c('video', {
        attrs: {
          "width": "82",
          "height": "82",
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": document.file,
          "type": "video/mp4"
        }
      })])]) : _vm._e()])])
    }), 0)])])
  }), 0)]) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No Photographic, Video or Sound Exhibits")])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Additional Documents"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('filefield', {
    key: _vm.legal_case.prosecutionBriefDocumentUrl,
    ref: "prosecution_brief_documents",
    attrs: {
      "name": "prosecution-brief-documents",
      "isRepeatable": true,
      "documentActionUrl": _vm.legal_case.prosecutionBriefDocumentUrl,
      "readonly": _vm.readonlyForm
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Court Dates"
    }
  }, [_c('div', {
    staticClass: "row file-upload-container"
  }, [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Prosecution Notice")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file-pdf-o col-md-1",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "prosecution-notice-icon"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Attach signed file ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('filefield', {
    ref: "prosecution_notice_document",
    attrs: {
      "name": "prosecution-notice-document",
      "documentActionUrl": _vm.legal_case.prosecutionNoticeDocumentUrl,
      "isRepeatable": false,
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-parent": _vm.courtOutcomeDocumentUploaded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row file-upload-container"
  }, [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Court Hearing Notice")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file-pdf-o col-md-1",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "court-hearing-notice-icon"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Attach signed file ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('filefield', {
    ref: "court_hearing_notice_document",
    attrs: {
      "name": "court-hearing-notice-document",
      "documentActionUrl": _vm.legal_case.courtHearingNoticeDocumentUrl,
      "isRepeatable": false,
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-parent": _vm.courtOutcomeDocumentUploaded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.legal_case.court_proceedings.court_dates), function(court_date_obj) {
    return [(court_date_obj.court_datetime) ? [_c('CourtDate', {
      attrs: {
        "court_datetime": new Date(court_date_obj.court_datetime),
        "comments": court_date_obj.comments,
        "court": court_date_obj.court,
        "court_date_id": court_date_obj.id,
        "court_in_future": court_date_obj.court_in_future,
        "Key": court_date_obj.id
      },
      on: {
        "data_changed": _vm.dataChanged
      }
    })] : [_c('CourtDate', {
      attrs: {
        "comments": court_date_obj.comments,
        "court": court_date_obj.court,
        "court_date_id": court_date_obj.id,
        "court_in_future": court_date_obj.court_in_future,
        "Key": court_date_obj.id
      },
      on: {
        "data_changed": _vm.dataChanged
      }
    })]]
  }), _vm._v(" "), _c('CourtDate', {
    on: {
      "data_changed": _vm.dataChanged
    }
  })], 2)])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Court Journal"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row action-button"
  }, [(!_vm.readonlyForm) ? _c('div', [_c('a', {
    staticClass: "btn btn-primary pull-right new-row-button",
    on: {
      "click": function($event) {
        return _vm.createNewCourtProceedingsEntry()
      }
    }
  }, [_vm._v("\n                              New Row\n                          ")])]) : _c('div', [_c('a', {
    staticClass: "btn btn-primary pull-right new-row-button",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                              New Row\n                          ")])])]), _vm._v(" "), _c('datatable', {
    ref: "court_proceedings_table",
    attrs: {
      "id": "court-proceedings-table",
      "dtOptions": _vm.dtOptionsCourtProceedings,
      "dtHeaders": _vm.dtHeadersCourtProceedings,
      "parentStyle": " "
    }
  })], 1)])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Court Outcome"
    }
  }, [(_vm.hasCourtProceedings) ? [(_vm.court_outcome_types.length > 0) ? _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legal_case.court_proceedings.court_outcome_type),
      expression: "legal_case.court_proceedings.court_outcome_type"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.legal_case.court_proceedings, "court_outcome_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.court_outcome_types), function(type) {
    return _c('option', {
      key: type.id,
      domProps: {
        "value": type
      }
    }, [_vm._v("\n                                " + _vm._s(type.identifier) + "\n                            ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Court outcome")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('filefield', {
    ref: "court_outcome_document",
    attrs: {
      "name": "court-outcome-document",
      "documentActionUrl": _vm.legal_case.processCourtOutcomeDocumentUrl,
      "isRepeatable": true,
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-parent": _vm.courtOutcomeDocumentUploaded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legal_case.court_proceedings.court_outcome_details),
      expression: "legal_case.court_proceedings.court_outcome_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.legal_case.court_proceedings.court_outcome_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.legal_case.court_proceedings, "court_outcome_details", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Fines")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legal_case.court_proceedings.court_outcome_fines),
      expression: "legal_case.court_proceedings.court_outcome_fines"
    }],
    staticClass: "form-control currency",
    attrs: {
      "readonly": _vm.readonlyForm,
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.legal_case.court_proceedings.court_outcome_fines)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.legal_case.court_proceedings, "court_outcome_fines", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Costs")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legal_case.court_proceedings.court_outcome_costs),
      expression: "legal_case.court_proceedings.court_outcome_costs"
    }],
    staticClass: "form-control currency",
    attrs: {
      "readonly": _vm.readonlyForm,
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.legal_case.court_proceedings.court_outcome_costs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.legal_case.court_proceedings, "court_outcome_costs", $event.target.value)
      }
    }
  })])])] : _vm._e()], 2), _vm._v(" "), (_vm.courtProceedingsHistoryEntryBindId) ? _c('div', [_c('JournalHistory', {
    key: _vm.courtProceedingsHistoryEntryBindId,
    ref: "journal_history",
    attrs: {
      "journalHistoryEntryInstance": _vm.journalHistoryEntryInstance
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Return\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [_c('div', {
    staticClass: "col-sm-16"
  }, [_c('div', [_c('AmendmentRequestDetails', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_external),
      expression: "is_external"
    }]
  }), _vm._v(" "), _vm._l((_vm.returns.table), function(item) {
    return _c('div', {
      key: ("headers_" + (item.headers))
    }, _vm._l((item.headers), function(question, key) {
      return _c('renderer-block', {
        key: ("q_" + key),
        attrs: {
          "component": question
        }
      })
    }), 1)
  })], 2)])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "table_name"
    },
    domProps: {
      "value": _vm.returns.table[0].name
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "schema-question"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Schema Section Question\n                      "), _c('a', {
    attrs: {
      "href": '#' + _vm.pQuestionBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pQuestionBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pQuestionBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Purpose")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterTablePurpose),
      expression: "filterTablePurpose"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterTablePurpose = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.schemaPurposes), function(p, pid) {
    return _c('option', {
      key: ("purpose_" + pid),
      domProps: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "name": "add_purpose"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTableEntry()
      }
    }
  }, [_vm._v("New Question")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Section")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterTableSection),
      expression: "filterTableSection"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterTableSection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.schemaSections), function(s, sid) {
    return _c('option', {
      key: ("section_" + sid),
      domProps: {
        "value": s.value
      }
    }, [_vm._v(_vm._s(s.label))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Group")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterTableGroup),
      expression: "filterTableGroup"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterTableGroup = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.schemaGroups), function(g, gid) {
    return _c('option', {
      key: ("group_" + gid),
      domProps: {
        "value": g.value
      }
    }, [_vm._v(_vm._s(g.label))])
  })], 2)])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datatable', {
    ref: "schema_question_table",
    attrs: {
      "id": _vm.schema_question_id,
      "dtOptions": _vm.dtOptionsSchemaQuestion,
      "dtHeaders": _vm.dtHeadersSchemaQuestion
    }
  })], 1)])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Schema Section Question",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                      " + _vm._s(error.label) + "\n                  ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "schema_question"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Licence Purpose")])]), _vm._v(" "), (_vm.isNewEntry) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterQuestionPurpose),
      expression: "filterQuestionPurpose"
    }],
    ref: "select_purpose",
    staticClass: "form-control",
    attrs: {
      "name": "select-purpose"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterQuestionPurpose = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.schemaPurposes), function(p, pid) {
    return _c('option', {
      key: ("purpose_" + pid),
      domProps: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.label))])
  })], 2)]) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterQuestionPurpose),
      expression: "filterQuestionPurpose"
    }],
    ref: "select_purpose",
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "name": "select-purpose"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterQuestionPurpose = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.schemaPurposes), function(p, pid) {
    return _c('option', {
      key: ("purpose_" + pid),
      domProps: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.label))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Section")])]), _vm._v(" "), (_vm.isNewEntry) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterQuestionSection),
      expression: "filterQuestionSection"
    }],
    ref: "select_section",
    staticClass: "form-control",
    attrs: {
      "name": "select-section"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterQuestionSection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.schemaSections), function(s, sid) {
    return _c('option', {
      key: ("section_" + sid),
      domProps: {
        "value": s.value
      }
    }, [_vm._v(_vm._s(s.label))])
  })], 2)]) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterQuestionSection),
      expression: "filterQuestionSection"
    }],
    ref: "select_section",
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "name": "select-section"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterQuestionSection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.schemaSections), function(s, sid) {
    return _c('option', {
      key: ("section_" + sid),
      domProps: {
        "value": s.value
      }
    }, [_vm._v(_vm._s(s.label))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Question")])]), _vm._v(" "), (_vm.isNewEntry) ? _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionQuestion.question),
      expression: "sectionQuestion.question"
    }],
    ref: "select_question",
    staticClass: "form-control",
    attrs: {
      "name": "select-question"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sectionQuestion, "question", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.masterlist), function(m, mid) {
    return _c('option', {
      key: ("question_" + mid),
      domProps: {
        "value": m.id
      }
    }, [_vm._v(_vm._s(m.question))])
  }), 0)]) : _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionQuestion.question),
      expression: "sectionQuestion.question"
    }],
    ref: "select_question",
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "name": "select-question"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sectionQuestion, "question", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.masterlist), function(m, mid) {
    return _c('option', {
      key: ("question_" + mid),
      domProps: {
        "value": m.id
      }
    }, [_vm._v(_vm._s(m.question))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), (_vm.showOptions) ? _c('div', {
    staticClass: "row"
  }, [_c('SchemaOption', {
    ref: "schema_option",
    attrs: {
      "addedOptions": _vm.addedOptions,
      "canAddMore": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getCheckedTag('isRepeatable').isChecked),
      expression: "getCheckedTag('isRepeatable').isChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.getCheckedTag('isRepeatable').isChecked) ? _vm._i(_vm.getCheckedTag('isRepeatable').isChecked, true) > -1 : (_vm.getCheckedTag('isRepeatable').isChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.getCheckedTag('isRepeatable').isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.getCheckedTag('isRepeatable'), "isChecked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.getCheckedTag('isRepeatable'), "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.getCheckedTag('isRepeatable'), "isChecked", $$c)
        }
      }
    }
  }), _vm._v("   "), _c('label', [_vm._v("isRepeatable")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getCheckedTag('isRequired').isChecked),
      expression: "getCheckedTag('isRequired').isChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.getCheckedTag('isRequired').isChecked) ? _vm._i(_vm.getCheckedTag('isRequired').isChecked, true) > -1 : (_vm.getCheckedTag('isRequired').isChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.getCheckedTag('isRequired').isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.getCheckedTag('isRequired'), "isChecked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.getCheckedTag('isRequired'), "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.getCheckedTag('isRequired'), "isChecked", $$c)
        }
      }
    }
  }), _vm._v("   "), _c('label', [_vm._v("isRequired")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Parent Question")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.filterQuestionParent(_vm.sectionQuestion.parent_question)) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionQuestion.parent_question),
      expression: "sectionQuestion.parent_question"
    }],
    ref: "select_parent",
    staticClass: "form-control",
    attrs: {
      "name": "select-parent"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sectionQuestion, "parent_question", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.parentList), function(qp, qpid) {
    return _c('option', {
      key: ("qparent_" + qpid),
      domProps: {
        "value": qp.value
      }
    }, [_vm._v(_vm._s(qp.label))])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Parent Answer")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionQuestion.parent_answer),
      expression: "sectionQuestion.parent_answer"
    }],
    ref: "select_answer",
    staticClass: "form-control",
    attrs: {
      "name": "select-answer"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sectionQuestion, "parent_answer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.answerList), function(an, anid) {
    return _c('option', {
      key: ("an_" + anid),
      domProps: {
        "value": an.value
      }
    }, [_vm._v(_vm._s(an.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Group")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.filterQuestionGroup(_vm.sectionQuestion.section_group)) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionQuestion.section_group),
      expression: "sectionQuestion.section_group"
    }],
    ref: "select_groupp",
    staticClass: "form-control",
    attrs: {
      "name": "select-groupp"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sectionQuestion, "section_group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.schemaGroups), function(g, gid) {
    return _c('option', {
      key: ("g_" + gid),
      domProps: {
        "value": g.value
      }
    }, [_vm._v(_vm._s(g.label))])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionQuestion.order),
      expression: "sectionQuestion.order"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sectionQuestion.order)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sectionQuestion, "order", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveQuestion
    }
  }, [_vm._v("Save")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br')])
}]}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Sanction Outcomes\n                    "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "sanction_outcome_table",
    attrs: {
      "id": "datatable_id",
      "dtOptions": _vm.table_options,
      "dtHeaders": _vm.table_headers
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "schema-purpose"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Schema Purpose Section\n                      "), _c('a', {
    attrs: {
      "href": '#' + _vm.pPurposeBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pPurposeBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pPurposeBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Purpose")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterTablePurpose),
      expression: "filterTablePurpose"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterTablePurpose = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.schemaPurposes), function(p, pid) {
    return _c('option', {
      key: ("purpose_" + pid),
      domProps: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "name": "add_purpose"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTableEntry()
      }
    }
  }, [_vm._v("New Section")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datatable', {
    ref: "schema_purpose_table",
    attrs: {
      "id": _vm.schema_purpose_id,
      "dtOptions": _vm.dtOptionsSchemaPurpose,
      "dtHeaders": _vm.dtHeadersSchemaPurpose
    }
  })], 1)])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Schema Purpose Section",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                      " + _vm._s(error.label) + "\n                  ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "schema_purpose"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Licence Purpose")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionPurpose.licence_purpose),
      expression: "sectionPurpose.licence_purpose"
    }],
    ref: "select_purpose",
    staticClass: "form-control",
    attrs: {
      "name": "select-purpose"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sectionPurpose, "licence_purpose", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.schemaPurposes), function(p, pid) {
    return _c('option', {
      key: ("purpose_" + pid),
      domProps: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Section Label")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionPurpose.section_label),
      expression: "sectionPurpose.section_label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sectionPurpose.section_label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sectionPurpose, "section_label", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Section Index")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionPurpose.index),
      expression: "sectionPurpose.index"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sectionPurpose.index)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sectionPurpose, "index", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.savePurpose()
      }
    }
  }, [_vm._v("Save")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br')])
}]}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.oTab
    }
  }, [_vm._v("Offence")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.dTab
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.documentTab
    }
  }, [_vm._v("Document")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.pTab
    }
  }, [_vm._v("Offender(s)")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.lTab
    },
    on: {
      "click": _vm.mapOffenceClicked
    }
  }, [_vm._v("Location")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.oTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "offence-identifier"
    }
  }, [_vm._v("Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.offence) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.identifier),
      expression: "offence.identifier"
    }],
    key: _vm.offence.id,
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "identifier",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.offence.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence, "identifier", $event.target.value)
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Region")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    staticClass: "form-control col-sm-9",
    domProps: {
      "value": _vm.offence.region_id
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        _vm.offence.region_id = $event.target.value;
        _vm.updateDistricts('updateFromUI')
      }
    }
  }, _vm._l((_vm.regions), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.name) + " \n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("District")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.district_id),
      expression: "offence.district_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.offence, "district_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.availableDistricts), function(option) {
    return _c('option', {
      key: option.district_id,
      domProps: {
        "value": option.district_id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.district_name) + " \n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Use occurrence from/to")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.occurrence_from_to),
      expression: "offence.occurrence_from_to"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "id": "occurrence_from_to_true",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.offence.occurrence_from_to, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.offence, "occurrence_from_to", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "occurrence_from_to_true"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.occurrence_from_to),
      expression: "offence.occurrence_from_to"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "id": "occurrence_from_to_false",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.offence.occurrence_from_to, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.offence, "occurrence_from_to", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "occurrence_from_to_false"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.occurrenceDateLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "occurrenceDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.occurrence_date_from),
      expression: "offence.occurrence_date_from"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.offence.occurrence_date_from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence, "occurrence_date_from", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.offence.occurrence_from_to),
      expression: "offence.occurrence_from_to"
    }],
    staticClass: "col-sm-1"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.offence.occurrence_from_to),
      expression: "offence.occurrence_from_to"
    }]
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "occurrenceDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.occurrence_date_to),
      expression: "offence.occurrence_date_to"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.offence.occurrence_date_to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence, "occurrence_date_to", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.occurrenceTimeLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "occurrenceTimeFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.occurrence_time_from),
      expression: "offence.occurrence_time_from"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.offence.occurrence_time_from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence, "occurrence_time_from", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.offence.occurrence_from_to),
      expression: "offence.occurrence_from_to"
    }],
    staticClass: "col-sm-1"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.offence.occurrence_from_to),
      expression: "offence.occurrence_from_to"
    }]
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "occurrenceTimeToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.occurrence_time_to),
      expression: "offence.occurrence_time_to"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.offence.occurrence_time_to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence, "occurrence_time_to", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Alleged Offence")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "alleged-offence"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Add"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addAllegedOffenceClicked()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "alleged_offence_table",
    attrs: {
      "id": "alleged-offence-table",
      "dtOptions": _vm.dtOptionsAllegedOffence,
      "dtHeaders": _vm.dtHeadersAllegedOffence
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.dTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "offence-details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.offence) ? _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.details),
      expression: "offence.details"
    }],
    key: _vm.offence.id,
    staticClass: "form-control",
    attrs: {
      "placeholder": "add details",
      "id": "offence-details"
    },
    domProps: {
      "value": (_vm.offence.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence, "details", $event.target.value)
      }
    }
  })]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane face in",
    attrs: {
      "id": _vm.documentTab
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('FileField', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document"
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryDocumentCollectionId
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.pTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('label', [_vm._v("Offender")])])]), _vm._v(" "), _c('div', [_c('SearchPersonOrganisation', {
    key: _vm.updateSearchPersonOrganisationBindId,
    ref: "search_offender",
    attrs: {
      "excludeStaff": true,
      "personOnly": true,
      "classNames": "form-control",
      "showCreateUpdate": "",
      "domIdHelper": "offender"
    },
    on: {
      "entity-selected": _vm.personSelected
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Add to Offender List"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addOffenderClicked()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "offender_table",
    attrs: {
      "id": "offender-table",
      "dtOptions": _vm.dtOptionsOffender,
      "dtHeaders": _vm.dtHeadersOffender
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.lTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [(_vm.offence.location) ? _c('div', [_c('MapLocationOffence', {
    key: _vm.lTab,
    ref: "mapOffenceComponent",
    attrs: {
      "id": _vm.lTab
    }
  })], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorResponse)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processingDetails) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Case: " + _vm._s(_vm.legal_case.number))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Workflow\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.statusDisplay)), _c('br')])]), _vm._v(" "), _c('Assignment', {
    key: _vm.assignmentKey,
    attrs: {
      "user_is_assignee": _vm.legal_case.user_is_assignee,
      "allowed_group_ids": _vm.legal_case.allowed_groups,
      "user_in_group": _vm.legal_case.user_in_group,
      "assigned_to_id": _vm.legal_case.assigned_to_id,
      "assign_url": _vm.assign_url
    },
    on: {
      "update-assigned-to-id": _vm.updateAssignedToId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Action\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.openStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.openInspection()
      }
    }
  }, [_vm._v("\n                                Inspection\n                              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.openStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.openOffence()
      }
    }
  }, [_vm._v("\n                              Offence\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.openStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "disabled": !_vm.sanctionOutcomeVisibility,
      "type": "button",
      "value": "Sanction Outcome"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSanctionOutcome()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.openStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('brief_of_evidence')
      }
    }
  }, [_vm._v("\n                              Brief of Evidence\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.briefOfEvidenceStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('back_to_case')
      }
    }
  }, [_vm._v("\n                              Back To Case\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.briefOfEvidenceVisibility) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.printDocument('brief_of_evidence')
      }
    }
  }, [_vm._v("\n                              Print Brief of Evidence\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.briefOfEvidenceStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('send_to_manager')
      }
    }
  }, [_vm._v("\n                              Send To Manager\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.backToOfficerVisibility) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('back_to_officer')
      }
    }
  }, [_vm._v("\n                              Back To Officer\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withManagerStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('approve_brief_of_evidence')
      }
    }
  }, [_vm._v("\n                              Approve\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionCoordinatorStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('prosecution_brief')
      }
    }
  }, [_vm._v("\n                              Prosecution Brief\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionCoordinatorProsecutionBriefStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('send_to_prosecution_council')
      }
    }
  }, [_vm._v("\n                              Send To Prosecution Council\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.prosecutionBriefVisibility) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.printDocument('prosecution_brief')
      }
    }
  }, [_vm._v("\n                              Print Prosecution Brief\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionCouncilStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('back_to_prosecution_coordinator')
      }
    }
  }, [_vm._v("\n                              Back to Prosecution Coordinator\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionCouncilStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('endorse_prosecution_brief')
      }
    }
  }, [_vm._v("\n                              Endorse Prosecution Brief\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionManagerStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('approve_for_court')
      }
    }
  }, [_vm._v("\n                              Approve for Court\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canUserAction && _vm.withProsecutionManagerStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('back_to_prosecution_council')
      }
    }
  }, [_vm._v("\n                              Back to Prosecution Council\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "close-button"
    }
  }, [(_vm.canUserAction && !_vm.closedStatus) ? _c('div', {
    staticClass: "col-sm-12 action-button"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": function($event) {
        return _vm.addWorkflow('close')
      }
    }
  }, [_vm._v("\n                              Close\n                            ")])]) : _vm._e()])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.runTab
    }
  }, [_vm._v("Running Sheet")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.cTab
    }
  }, [_vm._v("Case Details")])]), _vm._v(" "), (_vm.briefOfEvidenceVisibility) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.bTab
    }
  }, [_vm._v("Brief of Evidence")])]) : _vm._e(), _vm._v(" "), (_vm.prosecutionBriefVisibility) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.pTab
    }
  }, [_vm._v("Prosecution Brief")])]) : _vm._e(), _vm._v(" "), (_vm.courtProceedingsVisibility) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.cpTab
    }
  }, [_vm._v("Court Proceedings")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.rTab
    }
  }, [_vm._v("Related Items")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.runTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Running Sheet",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "row action-button"
  }, [(!_vm.readonlyRunningSheet) ? _c('div', [_c('a', {
    staticClass: "btn btn-primary pull-right new-row-button",
    on: {
      "click": function($event) {
        return _vm.createNewRunningSheetEntry()
      }
    }
  }, [_vm._v("\n                                            New Row\n                                          ")])]) : _c('div', [_c('a', {
    staticClass: "btn btn-primary pull-right new-row-button",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                                            New Row\n                                          ")])])]), _vm._v(" "), _c('datatable', {
    ref: "running_sheet_table",
    attrs: {
      "id": "running-sheet-table",
      "dtOptions": _vm.dtOptionsRunningSheet,
      "dtHeaders": _vm.dtHeadersRunningSheet,
      "parentStyle": " "
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.cTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Case Details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Title\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legal_case.title),
      expression: "legal_case.title"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm,
      "type": "text"
    },
    domProps: {
      "value": (_vm.legal_case.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.legal_case, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.legal_case.details),
      expression: "legal_case.details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.legal_case.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.legal_case, "details", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.legal_case.defaultDocumentUrl) ? _c('div', [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Documents\n                                        "), _c('filefield', {
    ref: "legal_case_documents",
    attrs: {
      "name": "legal-case-documents",
      "isRepeatable": true,
      "documentActionUrl": _vm.legal_case.defaultDocumentUrl,
      "readonly": _vm.readonlyForm
    }
  })], 1)]) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.bTab
    }
  }, [_c('BriefOfEvidence', {
    ref: "brief_of_evidence",
    attrs: {
      "readonly": _vm.briefOfEvidenceReadonly
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.pTab
    }
  }, [_c('ProsecutionBrief', {
    ref: "prosecution_brief",
    attrs: {
      "readonly": _vm.prosecutionBriefReadonly
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.cpTab
    }
  }, [(_vm.legal_case.court_proceedings) ? _c('CourtProceedings') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.rTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.relatedItemsVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": _vm.readonlyForm,
      "parentComponentName": "legal_case"
    }
  })], 1) : _vm._e()])])])], 1)])])])]), _vm._v(" "), (_vm.canUserAction) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.showSpinner && _vm.showExit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('exit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Saving")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit()
      }
    }
  }, [_vm._v("Save and Exit")]), _vm._v(" "), (_vm.showSpinner && !_vm.showExit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('noexit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Saving")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save and Continue")])])])])]) : _vm._e(), _vm._v(" "), (_vm.offenceInitialised) ? _c('div', [_c('Offence', {
    key: _vm.offenceBindId,
    ref: "offence",
    attrs: {
      "parent_update_function": _vm.loadLegalCase,
      "region_id": _vm.legal_case.region_id,
      "district_id": _vm.legal_case.district_id,
      "allocated_group_id": _vm.legal_case.allocated_group_id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sanctionOutcomeInitialised) ? _c('div', [_c('SanctionOutcome', {
    key: _vm.sanctionOutcomeBindId,
    ref: "sanction_outcome",
    attrs: {
      "parent_update_function": _vm.loadLegalCase
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.inspectionInitialised) ? _c('div', [_c('Inspection', {
    key: _vm.inspectionBindId,
    ref: "inspection",
    attrs: {
      "parent_update_function": _vm.loadLegalCase
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Magic', {
    ref: "magic"
  }), _vm._v(" "), (_vm.personOrArtifactInitialised) ? _c('div', [_c('PersonOrArtifactModal', {
    key: _vm.personOrArtifactBindId,
    ref: "person_or_artifact_modal",
    attrs: {
      "readonlyForm": _vm.readonlyForm,
      "rowNumberSelected": _vm.rowNumberSelected,
      "initialTabSelected": _vm.tabSelected,
      "entityEdit": _vm.entityEdit
    },
    on: {
      "modal-action": _vm.receivePersonOrArtifactEntity
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.runningSheetHistoryEntryBindId) ? _c('div', [_c('RunningSheetHistory', {
    key: _vm.runningSheetHistoryEntryBindId,
    ref: "running_sheet_history",
    attrs: {
      "runningSheetHistoryEntryInstance": _vm.runningSheetHistoryEntryInstance
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.legalCaseWorkflowBindId) ? _c('div', [_c('LegalCaseWorkflow', {
    key: _vm.legalCaseWorkflowBindId,
    ref: "legal_case_workflow",
    attrs: {
      "workflow_type": _vm.workflow_type
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.generateDocumentBindId) ? _c('div', [_c('GenerateDocument', {
    key: _vm.generateDocumentBindId,
    ref: "generate_document",
    attrs: {
      "document_type": _vm.documentTypeToGenerate
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assigned_to_id),
      expression: "assigned_to_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.user_in_group
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assigned_to_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateAssignedToId()
      }]
    }
  }, _vm._l((_vm.allowed_groups), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id,
        "selected": option.id == _vm.assigned_to_id
      }
    }, [_vm._v("\n                " + _vm._s(option.full_name) + "\n            ")])
  }), 0)])])]), _vm._v(" "), (_vm.user_in_group && !_vm.user_is_assignee) ? _c('div', [_c('a', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        return _vm.updateAssignedToId('current_user')
      }
    }
  }, [_vm._v("\n            Assign to me\n        ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Currently assigned to")]), _c('br')])])
}]}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "internalOrgInfo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Organisation Details\n                     "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organisation.name),
      expression: "organisation.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.organisation.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organisation, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organisation.abn),
      expression: "organisation.abn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.organisation.abn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organisation, "abn", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Address Details\n                     "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.adBody,
      "data-toggle": "collapse",
      "expanded": "false",
      "data-parent": "#userInfo",
      "aria-controls": _vm.adBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse ",
    attrs: {
      "id": _vm.adBody
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organisation.address.line1),
      expression: "organisation.address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.organisation.address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organisation.address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organisation.address.locality),
      expression: "organisation.address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.organisation.address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organisation.address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organisation.address.state),
      expression: "organisation.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.organisation.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organisation.address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organisation.address.postcode),
      expression: "organisation.address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.organisation.address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organisation.address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organisation.address.country),
      expression: "organisation.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.organisation.address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(c) {
    return _c('option', {
      domProps: {
        "value": c.code
      }
    }, [_vm._v(_vm._s(c.name))])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.show_spinner) ? _c('div', [_c('i', {
    staticClass: "fa fa-2x fa-spinner fa-spin pull-right"
  })]) : _c('div', [_c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save Organisation")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "schema-manager"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('SchemaTabs', {
    attrs: {
      "tabs": _vm.tabs,
      "initialTab": _vm.initialTab
    }
  }, [_c('template', {
    slot: "tab-panel-question"
  }, [_c('SchemaQuestion')], 1), _vm._v(" "), _c('template', {
    slot: "tab-panel-masterlist"
  }, [_c('SchemaMasterlist')], 1), _vm._v(" "), _c('template', {
    slot: "tab-panel-purpose"
  }, [_c('SchemaPurpose')], 1), _vm._v(" "), _c('template', {
    slot: "tab-panel-group"
  }, [_c('SchemaGroup')], 1)], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "change-contact"
    }
  }, [_c('modal', {
    attrs: {
      "title": "Add Contact",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "addContactForm"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Given Name(s): ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.first_name),
      expression: "contact.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.contact.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "first_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Surname: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.last_name),
      expression: "contact.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.contact.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "last_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Phone"
    }
  }, [_vm._v("Phone: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.phone_number),
      expression: "contact.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.contact.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "phone_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Mobile"
    }
  }, [_vm._v("Mobile: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.mobile_number),
      expression: "contact.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "mobile"
    },
    domProps: {
      "value": (_vm.contact.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "mobile_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Fax"
    }
  }, [_vm._v("Fax: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.fax_number),
      expression: "contact.fax_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "fax"
    },
    domProps: {
      "value": (_vm.contact.fax_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "fax_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label pull-left",
    attrs: {
      "for": "Email"
    }
  }, [_vm._v("Email: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "email", $event.target.value)
      }
    }
  })])])])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLicenceHistory),
      expression: "showLicenceHistory"
    }],
    attrs: {
      "id": "historyDetail"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Licence History",
      "large": "",
      "force": ""
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "licenceHistoryForm"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "licence_history_table",
    attrs: {
      "id": "licence-history-table",
      "dtOptions": _vm.dtOptionsLicenceHistory,
      "dtHeaders": _vm.dtHeadersLicenceHistory
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id,
      "num_files": _vm.num_documents()
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), (_vm.files) ? _c('div', {
    class: _vm.getClass
  }, [_vm._l((_vm.documents), function(v) {
    return _c('div', [_c('p', [_vm._v("\n                    File: "), _c('a', {
      attrs: {
        "href": v.file,
        "target": "_blank",
        "title": v.name.toString()
      }
    }, [_vm._v(_vm._s(_vm.truncatedName(v.name)))]), _vm._v(" "), (!_vm.readonly && v.can_delete) ? _c('span', [_c('a', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Remove file",
        "filename": v.name
      },
      on: {
        "click": function($event) {
          return _vm.delete_document(v)
        }
      }
    })]) : _c('span', [_c('i', {
      staticClass: "fa fa-info-circle",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Previously submitted documents cannot be deleted"
      }
    })])])])
  }), _vm._v(" "), (_vm.show_spinner) ? _c('span', [_c('i', {
    staticClass: "fa fa-2x fa-spinner fa-spin"
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.repeat), function(n) {
    return (!_vm.readonly) ? _c('div', [(_vm.isRepeatable || (!_vm.isRepeatable && _vm.num_documents() == 0)) ? _c('div', [_c('input', {
      staticClass: "form-control",
      attrs: {
        "name": _vm.name,
        "type": "file",
        "data-que": n,
        "accept": _vm.fileTypes,
        "required": _vm.isRequired
      },
      on: {
        "change": _vm.handleChange
      }
    })]) : _vm._e()]) : _vm._e()
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-buffer bottom-buffer"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('label', {
    staticClass: "inline",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "collapse-link-top pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.expand($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "children-anchor-point collapse in",
    staticStyle: {
      "padding-left": "0px"
    }
  }), _vm._v(" "), (_vm.isPreviewMode) ? _c('span', {
    class: {
      'hidden': _vm.isRemovable
    }
  }, [_c('a', {
    attrs: {
      "id": 'remove_' + _vm.name
    }
  }, [_vm._v("Remove " + _vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "collapse-link-bottom pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.minimize($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up"
  })]), _vm._v(" "), _c('div', {
    class: {
      'row': true, 'collapse': true, 'in': _vm.isExpanded
    },
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._t("default")], 2)])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.readonly) ? _c('div', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "id": _vm.id
    }
  }, [_c('input', {
    ref: "radioB",
    attrs: {
      "name": _vm.name,
      "disabled": "",
      "type": "radio",
      "required": _vm.isRequired,
      "data-conditions": _vm.options
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(_vm._s(_vm.label) + "\n        ")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.savedValue.value
    }
  })]) : _c('div', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "id": _vm.id
    }
  }, [_c('input', {
    ref: "radioB",
    attrs: {
      "name": _vm.name,
      "type": "radio",
      "required": _vm.isRequired,
      "data-conditions": _vm.options
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(_vm._s(_vm.label) + "\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalDash"
    }
  }, [_c('ApplicationDashTable', {
    attrs: {
      "level": "internal",
      "url": _vm.applications_url
    }
  }), _vm._v(" "), _c('AssessmentDashTable')], 1)
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "applicationConditionDetail"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Condition",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "conditionForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.standard),
      expression: "condition.standard"
    }],
    attrs: {
      "type": "radio",
      "name": "conditionType"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.condition.standard, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.condition, "standard", true)
      }
    }
  }), _vm._v("Standard Condition")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.standard),
      expression: "condition.standard"
    }],
    attrs: {
      "type": "radio",
      "name": "conditionType"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.condition.standard, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.condition, "standard", false)
      }
    }
  }), _vm._v("Free Text Condition")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Purpose")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticStyle: {
      "width": "70% !important"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.licence_purpose),
      expression: "condition.licence_purpose"
    }],
    ref: "select_purpose",
    staticClass: "form-control",
    attrs: {
      "name": "purpose"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.condition, "licence_purpose", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.purposes), function(p) {
    return _c('option', {
      domProps: {
        "value": p.id
      }
    }, [_vm._v(_vm._s(p.short_name))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Condition")])]), _vm._v(" "), (_vm.condition.standard) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticStyle: {
      "width": "70% !important"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.standard_condition),
      expression: "condition.standard_condition"
    }],
    ref: "standard_req",
    staticClass: "form-control",
    attrs: {
      "name": "standard_condition"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.condition, "standard_condition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.conditions), function(r) {
    return _c('option', {
      domProps: {
        "value": r.id
      }
    }, [_vm._v(_vm._s(r.short_description))])
  }), 0)])]) : _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.free_condition),
      expression: "condition.free_condition"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "name": "free_condition"
    },
    domProps: {
      "value": (_vm.condition.free_condition)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "free_condition", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.condition.standard || _vm.showDueDate) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Due Date")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    ref: "due_date",
    staticClass: "input-group date",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.due_date),
      expression: "condition.due_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "due_date",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.condition.due_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "due_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]) : _vm._e()]), _vm._v(" "), (!_vm.condition.standard && _vm.validDate) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Return Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticStyle: {
      "width": "70% !important"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.return_type),
      expression: "condition.return_type"
    }],
    ref: "return_types_select",
    staticClass: "form-control",
    attrs: {
      "name": "return_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.condition, "return_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.return_types), function(r) {
    return _c('option', {
      domProps: {
        "value": r.id
      }
    }, [_vm._v(_vm._s(r.name))])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.showDueDate && _vm.validDate) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Recurrence")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.recurrence),
      expression: "condition.recurrence"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.condition.recurrence) ? _vm._i(_vm.condition.recurrence, null) > -1 : (_vm.condition.recurrence)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.condition.recurrence,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.condition, "recurrence", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.condition, "recurrence", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.condition, "recurrence", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), (_vm.condition.recurrence) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Recurrence pattern")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.recurrence_pattern),
      expression: "condition.recurrence_pattern"
    }],
    attrs: {
      "type": "radio",
      "name": "recurrenceSchedule",
      "value": "weekly"
    },
    domProps: {
      "checked": _vm._q(_vm.condition.recurrence_pattern, "weekly")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.condition, "recurrence_pattern", "weekly")
      }
    }
  }), _vm._v("Weekly")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.recurrence_pattern),
      expression: "condition.recurrence_pattern"
    }],
    attrs: {
      "type": "radio",
      "name": "recurrenceSchedule",
      "value": "monthly"
    },
    domProps: {
      "checked": _vm._q(_vm.condition.recurrence_pattern, "monthly")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.condition, "recurrence_pattern", "monthly")
      }
    }
  }), _vm._v("Monthly")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.recurrence_pattern),
      expression: "condition.recurrence_pattern"
    }],
    attrs: {
      "type": "radio",
      "name": "recurrenceSchedule",
      "value": "yearly"
    },
    domProps: {
      "checked": _vm._q(_vm.condition.recurrence_pattern, "yearly")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.condition, "recurrence_pattern", "yearly")
      }
    }
  }), _vm._v("Yearly")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "Name"
    }
  }, [_c('strong', {
    staticClass: "pull-left"
  }, [_vm._v("Recur every")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.recurrence_schedule),
      expression: "condition.recurrence_schedule"
    }],
    staticClass: "pull-left",
    staticStyle: {
      "width": "10%",
      "margin-left": "10px"
    },
    attrs: {
      "type": "number",
      "name": "schedule"
    },
    domProps: {
      "value": (_vm.condition.recurrence_schedule)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "recurrence_schedule", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.condition.recurrence_pattern == 'weekly') ? _c('strong', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("week(s)")]) : (_vm.condition.recurrence_pattern == 'monthly') ? _c('strong', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("month(s)")]) : (_vm.condition.recurrence_pattern == 'yearly') ? _c('strong', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("year(s)")]) : _vm._e()])])])])] : _vm._e()] : _vm._e()], 2)], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.condition.id) ? [(_vm.updatingCondition) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinnner fa-spin"
  }), _vm._v(" Updating")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Update")])] : [(_vm.addingCondition) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Add")])], _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    class: _vm.componentClass
  }, [(!_vm.legalCaseExists || !_vm.parentModal) ? _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.newTab
    }
  }, [_vm._v("Object")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.rTab
    }
  }, [_vm._v("Related Items")])])])]) : _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.newTab
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.existingTab
    }
  }, [_vm._v("Existing")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.newTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": _vm.artifactTypeDisplay,
      "Index": "0",
      "hideHeader": !_vm.documentArtifactIdExists
    }
  }, [_c('div', {
    staticClass: "tab-pane fade in active li-top-buffer",
    attrs: {
      "id": _vm.objectTab
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Document Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.document_type),
      expression: "document_artifact.document_type"
    }],
    ref: "setArtifactType",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document_artifact, "document_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.documentArtifactTypes), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                              " + _vm._s(option.display) + "\n                                            ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Document")])]), _vm._v(" "), (!_vm.documentArtifactId) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "default_document",
    attrs: {
      "name": "default-document",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document"
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryDocumentCollectionId
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    key: _vm.documentArtifactId,
    ref: "document_artifact_documents",
    attrs: {
      "name": "document-artifact-documents",
      "isRepeatable": true,
      "documentActionUrl": _vm.document_artifact.defaultDocumentUrl,
      "readonly": _vm.readonlyForm
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.identifier),
      expression: "document_artifact.identifier"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.document_artifact.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document_artifact, "identifier", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.statementVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Statement")])]), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.statement_id),
      expression: "document_artifact.statement_id"
    }],
    ref: "setStatement",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document_artifact, "statement_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.legal_case.statement_artifacts), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                            " + _vm._s(option.document_type_display) + ": " + _vm._s(option.identifier) + "\n                                            ")])
  }), 0)]) : _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.statement_id),
      expression: "document_artifact.statement_id"
    }],
    ref: "setStatement",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document_artifact, "statement_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.document_artifact.available_statement_artifacts), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                            " + _vm._s(option.document_type_display) + ": " + _vm._s(option.identifier) + "\n                                            ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.offenceVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Offence")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.offence_id),
      expression: "document_artifact.offence_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document_artifact, "offence_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        $event.preventDefault();
        return _vm.setOffenderId(null)
      }]
    }
  }, _vm._l((_vm.legal_case.offence_list), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [(option.id) ? _c('div', [_vm._v("\n                                                    " + _vm._s(option.lodgement_number) + ": " + _vm._s(option.identifier) + "\n                                                ")]) : _vm._e()])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.offenceVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Offender")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.offender_id),
      expression: "document_artifact.offender_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document_artifact, "offender_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.offenderList), function(option) {
    return _c('option', {
      key: option.offender_id,
      domProps: {
        "value": option.offender_id
      }
    }, [(option.id) ? _c('div', [_vm._v("\n                                                " + _vm._s(option.full_name) + ": " + _vm._s(option.email) + "\n                                            ")]) : _vm._e()])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.description),
      expression: "document_artifact.description"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.document_artifact.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document_artifact, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.personProvidingStatementVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.personProvidingStatementLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('SearchPersonOrganisation', {
    key: _vm.updateSearchPersonOrganisationBindId,
    ref: "document_artifact_search_person_organisation",
    attrs: {
      "parentEntity": _vm.personProvidingStatementEntity,
      "personOnly": "",
      "isEditable": !_vm.readonlyForm,
      "classNames": "form-control",
      "showCreateUpdate": "",
      "addFullName": "",
      "displayTitle": false,
      "domIdHelper": "document_artifact",
      "departmentalStaff": ""
    },
    on: {
      "entity-selected": _vm.setPersonProvidingStatement
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.interviewerVisibility),
      expression: "interviewerVisibility"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.interviewerLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    ref: "document_artifact_interviewer",
    staticClass: "form-control",
    attrs: {
      "id": "document_artifact_interviewer",
      "name": "document_artifact_interviewer"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "artifactDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.artifact_date),
      expression: "document_artifact.artifact_date"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.document_artifact.artifact_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document_artifact, "artifact_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "artifactTimePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.artifact_time),
      expression: "document_artifact.artifact_time"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.document_artifact.artifact_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document_artifact, "artifact_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])])])])], 1), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "tab-pane fade in li-top-buffer",
    attrs: {
      "id": _vm.existingTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "existing_artifact_table",
    attrs: {
      "id": "existing-artifact-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.parentModal) ? _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.rTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.relatedItemsVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": _vm.readonlyForm,
      "parentComponentName": "document_artifact"
    }
  })], 1) : _vm._e()])])])], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalInspectionDash"
    }
  }, [_c('FormSection', {
    attrs: {
      "label": "Case",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statusChoices), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.display
      }
    }, [_vm._v("\n                        " + _vm._s(option.display) + "\n                    ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Planned From")]), _vm._v(" "), _c('div', {
    ref: "caseCreatedDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterCaseCreatedFrom),
      expression: "filterCaseCreatedFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterCaseCreatedFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterCaseCreatedFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Planned To")]), _vm._v(" "), _c('div', {
    ref: "caseCreatedDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterCaseCreatedTo),
      expression: "filterCaseCreatedTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterCaseCreatedTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterCaseCreatedTo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createLegalCase($event)
      }
    }
  }, [_vm._v("New Case")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "legal_case_table",
    attrs: {
      "id": "legal-case-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])]), _vm._v(" "), (_vm.legalCaseInitialised) ? _c('div', [_c('CreateLegalCaseModal', {
    key: _vm.createLegalCaseBindId,
    ref: "add_legal_case"
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "LegalCaseWorkflow"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }, _vm.setSelectAll]
    }
  }), _vm._v("\n            Select All\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeStatementOfFacts),
      expression: "includeStatementOfFacts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeStatementOfFacts) ? _vm._i(_vm.includeStatementOfFacts, null) > -1 : (_vm.includeStatementOfFacts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeStatementOfFacts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeStatementOfFacts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeStatementOfFacts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeStatementOfFacts = $$c
        }
      }
    }
  }), _vm._v("\n            Statement of Facts\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeCaseInformationForm),
      expression: "includeCaseInformationForm"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeCaseInformationForm) ? _vm._i(_vm.includeCaseInformationForm, null) > -1 : (_vm.includeCaseInformationForm)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeCaseInformationForm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeCaseInformationForm = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeCaseInformationForm = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeCaseInformationForm = $$c
        }
      }
    }
  }), _vm._v("\n            Case Information Form\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeOffencesOffendersRoi),
      expression: "includeOffencesOffendersRoi"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeOffencesOffendersRoi) ? _vm._i(_vm.includeOffencesOffendersRoi, null) > -1 : (_vm.includeOffencesOffendersRoi)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeOffencesOffendersRoi,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeOffencesOffendersRoi = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeOffencesOffendersRoi = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeOffencesOffendersRoi = $$c
        }
      }
    }
  }), _vm._v("\n            Offences, Offenders and Records of Interview\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeWitnessOfficerOtherStatements),
      expression: "includeWitnessOfficerOtherStatements"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeWitnessOfficerOtherStatements) ? _vm._i(_vm.includeWitnessOfficerOtherStatements, null) > -1 : (_vm.includeWitnessOfficerOtherStatements)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeWitnessOfficerOtherStatements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeWitnessOfficerOtherStatements = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeWitnessOfficerOtherStatements = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeWitnessOfficerOtherStatements = $$c
        }
      }
    }
  }), _vm._v("\n            Witness Statements, Officer Statements, Expert Statements\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includePhysicalArtifacts),
      expression: "includePhysicalArtifacts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includePhysicalArtifacts) ? _vm._i(_vm.includePhysicalArtifacts, null) > -1 : (_vm.includePhysicalArtifacts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includePhysicalArtifacts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includePhysicalArtifacts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includePhysicalArtifacts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includePhysicalArtifacts = $$c
        }
      }
    }
  }), _vm._v("\n            List of Exhibits, Sensitive Unused and Non-Sensitive Unused Materials\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeDocumentArtifacts),
      expression: "includeDocumentArtifacts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeDocumentArtifacts) ? _vm._i(_vm.includeDocumentArtifacts, null) > -1 : (_vm.includeDocumentArtifacts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeDocumentArtifacts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeDocumentArtifacts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeDocumentArtifacts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeDocumentArtifacts = $$c
        }
      }
    }
  }), _vm._v("\n            List of Photographic Exhibits\n            ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Error: " + _vm._s(_vm.errorResponse))])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.withSectionsSelector) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', [_vm._v("Application " + _vm._s(_vm.application.id) + ": " + _vm._s(_vm.application.licence_type_short_name))])]) : _vm._e(), _vm._v(" "), (_vm.withSectionsSelector) ? _c('div', {
    staticClass: "col-md-3 sections-dropdown"
  }, [_c('affix', {
    staticClass: "sections-menu",
    attrs: {
      "relative-element-selector": "#tabs"
    }
  }, [_c('div', {
    staticClass: "panel panel-default fixed"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "open"
  }, [_c('h5', [_vm._v("Sections")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-panel"
  }, _vm._l((_vm.renderer_tabs), function(tab, tab_idx) {
    return _c('li', {
      staticClass: "dropdown-submenu"
    }, [_c('a', {
      staticClass: "section-menu",
      attrs: {
        "tabindex": "-1"
      },
      on: {
        "click": function($event) {
          return _vm.sectionClick(tab)
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(tab.name) + "\n                                        "), _c('span', {
      class: ("fa fa-caret-" + (tab.id == _vm.section_tab_id ? 'up': 'down'))
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu-right section-list",
      attrs: {
        "id": "section-submenu"
      }
    }, _vm._l((_vm.getSections(tab.id)), function(section, section_idx) {
      return _c('div', {
        directives: [{
          name: "scroll-to",
          rawName: "v-scroll-to",
          value: (("#" + (section.name))),
          expression: "`#${section.name}`"
        }],
        staticClass: "menu-row",
        on: {
          "click": function($event) {
            return _vm.selectTab(tab)
          }
        }
      }, [_c('div', [_c('i', {
        staticClass: "fa fa-circle"
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(section.label))])])])
    }), 0)])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "0"
    }
  })])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "inline",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field_data.value),
      expression: "field_data.value"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "rows": "5",
      "name": _vm.name,
      "required": _vm.isRequired
    },
    domProps: {
      "value": (_vm.field_data.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.field_data, "value", $event.target.value)
      }
    }
  }), _c('br')], 2)])
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "internal-return-amend"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Amendment Request",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "amendForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Request Amendment for the Return")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Reason")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amendment.reason),
      expression: "amendment.reason"
    }],
    ref: "reason",
    staticClass: "form-control",
    attrs: {
      "name": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.amendment, "reason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.reason_choices), function(item) {
    return _c('option', {
      domProps: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Comments to User")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amendment.text),
      expression: "amendment.text"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "text"
    },
    domProps: {
      "value": (_vm.amendment.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.amendment, "text", $event.target.value)
      }
    }
  })])])])])], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    attrs: {
      "id": "map-filter"
    }
  }, [_c('div', [_c('label', {}, [_vm._v("Sanction Outcome Types")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterSanctionOutcomeType),
      expression: "filterSanctionOutcomeType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterSanctionOutcomeType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sanction_outcome_type_choices), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.display) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', [_c('label', {}, [_vm._v("Offence Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.status_choices), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.display) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', [_c('label', {}, [_vm._v("Date From")]), _vm._v(" "), _c('div', {
    ref: "lodgementDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateFrom),
      expression: "filterDateFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', [_c('label', {}, [_vm._v("Date To")]), _vm._v(" "), _c('div', {
    ref: "lodgementDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateTo),
      expression: "filterDateTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateTo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "map-wrapper"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapLeaf"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "basemap-button"
    }
  }, [_c('img', {
    attrs: {
      "id": "basemap_sat",
      "src": __webpack_require__(57)
    },
    on: {
      "click": function($event) {
        return _vm.setBaseLayer('sat')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "id": "basemap_osm",
      "src": __webpack_require__(56)
    },
    on: {
      "click": function($event) {
        return _vm.setBaseLayer('osm')
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cursor-location"
    }
  }, [(_vm.cursor_location) ? _c('div', [_c('span', {
    attrs: {
      "id": "cursor-location-lat"
    }
  }, [_vm._v(_vm._s(_vm.cursor_location.lat.toFixed(5)) + ", " + _vm._s(_vm.cursor_location.lng.toFixed(5)))])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search-box"
    }
  }, [_c('input', {
    attrs: {
      "id": "search-input"
    }
  })])
}]}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalSearch"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Person and Organisation Search\n                        "), _c('a', {
    attrs: {
      "href": '#' + _vm.rBody,
      "data-toggle": "collapse",
      "data-parent": "#personOrgSearch",
      "expanded": "true",
      "aria-controls": _vm.rBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.kBody
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check form-check-inline col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_option),
      expression: "search_option"
    }],
    attrs: {
      "type": "radio",
      "value": "starts_with"
    },
    domProps: {
      "checked": _vm._q(_vm.search_option, "starts_with")
    },
    on: {
      "change": function($event) {
        _vm.search_option = "starts_with"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Starts with")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_option),
      expression: "search_option"
    }],
    attrs: {
      "type": "radio",
      "value": "ends_with"
    },
    domProps: {
      "checked": _vm._q(_vm.search_option, "ends_with")
    },
    on: {
      "change": function($event) {
        _vm.search_option = "ends_with"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Ends with")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_option),
      expression: "search_option"
    }],
    attrs: {
      "type": "radio",
      "value": "contains"
    },
    domProps: {
      "checked": _vm._q(_vm.search_option, "contains")
    },
    on: {
      "change": function($event) {
        _vm.search_option = "contains"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Contains")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    ref: "person_lookup",
    staticClass: "form-control",
    attrs: {
      "id": "person_lookup",
      "name": "person_lookup"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "View Details"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.personOrganisationSearch($event)
      }
    }
  })])])])])])])]), _vm._v(" "), (_vm.showSearchKeywords) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Keywords\n                        "), _c('a', {
    attrs: {
      "href": '#' + _vm.kBody,
      "data-toggle": "collapse",
      "data-parent": "#keywordInfo",
      "expanded": "true",
      "aria-controls": _vm.kBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.kBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-lg-12",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Filter")]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchApplication),
      expression: "searchApplication"
    }],
    ref: "searchApplication",
    staticClass: "form-check-input",
    attrs: {
      "id": "searchApplication",
      "name": "searchApplication",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.searchApplication) ? _vm._i(_vm.searchApplication, null) > -1 : (_vm.searchApplication)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.searchApplication,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.searchApplication = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.searchApplication = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.searchApplication = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "searchApplication"
    }
  }, [_vm._v("Application")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchLicence),
      expression: "searchLicence"
    }],
    ref: "searchLicence",
    staticClass: "form-check-input",
    attrs: {
      "id": "searchLicence",
      "name": "searchLicence",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.searchLicence) ? _vm._i(_vm.searchLicence, null) > -1 : (_vm.searchLicence)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.searchLicence,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.searchLicence = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.searchLicence = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.searchLicence = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "searchLicence"
    }
  }, [_vm._v("Licence")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchReturn),
      expression: "searchReturn"
    }],
    ref: "searchReturn",
    staticClass: "form-check-input",
    attrs: {
      "id": "searchReturn",
      "name": "searchReturn",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.searchReturn) ? _vm._i(_vm.searchReturn, null) > -1 : (_vm.searchReturn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.searchReturn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.searchReturn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.searchReturn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.searchReturn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "searchReturn"
    }
  }, [_vm._v("Return with requirements")])]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-lg-12",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Keyword")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWord),
      expression: "keyWord"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "search",
      "name": "details",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.keyWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWord = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Add"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addKeyword($event)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('ul', {
    staticClass: "list-inline",
    staticStyle: {
      "display": "inline",
      "width": "auto"
    }
  }, _vm._l((_vm.searchKeywords), function(item, i) {
    return _c('li', {
      staticClass: "list-inline-item"
    }, [_c('button', {
      staticClass: "btn btn-light",
      staticStyle: {
        "margin-top": "5px",
        "margin-bottom": "5px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_vm._v(_vm._s(item))]), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeKeyword(i)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove "
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', [(_vm.searching) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button",
      "value": "Search",
      "disabled": ""
    }
  }, [_vm._v("\n                            Search"), _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  })]) : _c('input', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button",
      "value": "Search",
      "disabled": !_vm.hasSearchKeywords
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchKeyword($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "reset",
      "value": "Clear"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearKeywordSearch($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "keyword_search_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.keyword_search_options,
      "dtHeaders": _vm.keyword_search_headers
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Reference Number\n                        "), _c('a', {
    attrs: {
      "href": '#' + _vm.rBody,
      "data-toggle": "collapse",
      "data-parent": "#referenceNumberInfo",
      "expanded": "true",
      "aria-controls": _vm.rBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.rBody
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label col-lg-12",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Reference Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceWord),
      expression: "referenceWord"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "search",
      "name": "referenceWord",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.referenceWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referenceWord = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showSpinner) ? _c('div', [_c('i', {
    staticClass: "fa fa-2x fa-spinner fa-spin"
  })]) : _c('div', [_c('input', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button",
      "value": "Search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.search_reference($event)
      }
    }
  })]), _vm._v(" "), _c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('span', [_vm._v("Search on the following items via Reference Number:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Applications (e.g. A000001)")]), _vm._v(" "), _c('li', [_vm._v("Licences (e.g. L000001)")]), _vm._v(" "), _c('li', [_vm._v("Returns (e.g. R000001)")]), _vm._v(" "), _c('li', [_vm._v("Tag Purchases (e.g. T000001)")]), _vm._v(" "), _c('li', [_vm._v("Organisation Access Requests (e.g. OAR000001)")]), _vm._v(" "), _c('li', [_vm._v("Advices to CEO (e.g. AD000001)")]), _vm._v(" "), _c('li', [_vm._v("Endorsement Applications (e.g. E000001)")]), _vm._v(" "), _c('li', [_vm._v("Lawful Authority Applications (e.g. LAA000001)")]), _vm._v(" "), _c('li', [_vm._v("Lawful Authorities (e.g. LA000001)")]), _vm._v(" "), _c('li', [_vm._v("Calls/Emails (e.g. C000001)")]), _vm._v(" "), _c('li', [_vm._v("Offences (e.g. OF000001)")]), _vm._v(" "), _c('li', [_vm._v("Inspections (e.g. IN000001)")]), _vm._v(" "), _c('li', [_vm._v("Sanction Outcomes (e.g. IF000001)")]), _vm._v(" "), _c('li', [_vm._v("Legal Cases (e.g. CS000001)")]), _vm._v(" "), _c('li', [_vm._v("Objects (e.g. OB000001)")])])])
}]}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "inline",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), (_vm.min != '' || _vm.max != '') ? _c('span', [((_vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field_data.value),
      expression: "field_data.value"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "min": _vm.min,
      "max": _vm.max,
      "name": _vm.name,
      "required": _vm.isRequired,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.field_data.value) ? _vm._i(_vm.field_data.value, null) > -1 : (_vm.field_data.value)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.field_data.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.field_data, "value", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.field_data, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.field_data, "value", $$c)
        }
      }
    }
  }) : ((_vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field_data.value),
      expression: "field_data.value"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "min": _vm.min,
      "max": _vm.max,
      "name": _vm.name,
      "required": _vm.isRequired,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.field_data.value, null)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.field_data, "value", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field_data.value),
      expression: "field_data.value"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "min": _vm.min,
      "max": _vm.max,
      "name": _vm.name,
      "required": _vm.isRequired,
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.field_data.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.field_data, "value", $event.target.value)
      }
    }
  })]) : _c('span', [((_vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "name": _vm.name,
      "required": _vm.isRequired,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.value) ? _vm._i(_vm.value, null) > -1 : (_vm.value)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.value = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.value = $$c
        }
      }
    }
  }) : ((_vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "name": _vm.name,
      "required": _vm.isRequired,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.value, null)
    },
    on: {
      "change": function($event) {
        _vm.value = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "name": _vm.name,
      "required": _vm.isRequired,
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h3', [_vm._v("Remediation Action: " + _vm._s(_vm.remediation_action.remediation_action_id))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav nav-pills aho2"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.reTab
    }
  }, [_vm._v("Remediation Action")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.coTab
    }
  }, [_vm._v("Confirmation")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.reTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Remediation Action",
      "Index": "1"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Action Required")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._v("\n                                        " + _vm._s(_vm.remediation_action.action) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Due Date")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._v("\n                                        " + _vm._s(_vm.remediation_action.due_date) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Details of your compliance")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remediation_action.action_taken),
      expression: "remediation_action.action_taken"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.remediation_action.action_taken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remediation_action, "action_taken", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Any photographic evidence")])]), _vm._v(" "), (_vm.remediation_action) ? _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.remediation_action.remediationActionDocumentUrl) ? _c('filefield', {
    ref: "remediation_action_file",
    attrs: {
      "name": "remediation_action-file",
      "documentActionUrl": _vm.remediation_action.remediationActionDocumentUrl,
      "isRepeatable": true,
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-parent": _vm.remediationActionDocumentUploaded
    }
  }) : _vm._e()], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.coTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Confirmation",
      "Index": "2"
    }
  })], 1)]), _vm._v(" "), (_vm.canSaveSubmit) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary pull-right button-gap",
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary pull-right button-gap",
    attrs: {
      "type": "button",
      "value": "Save and Continue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary pull-right button-gap",
    attrs: {
      "type": "button",
      "value": "Save and Exit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit($event)
      }
    }
  })])])])]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('AmendmentRequestDetails', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_external),
      expression: "is_external"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Return\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [(_vm.returns.has_species) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Species Available:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returns.species),
      expression: "returns.species"
    }],
    ref: "selected_species",
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.returns, "species", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.returns.species_list), function(specie, s_idx) {
    return _c('option', {
      key: ("specie_" + s_idx),
      staticClass: "change-species",
      attrs: {
        "species_id": s_idx
      },
      domProps: {
        "value": s_idx
      }
    }, [_vm._v(_vm._s(specie))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Do you want to Lodge a nil Return?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returns.nil_return),
      expression: "returns.nil_return"
    }],
    attrs: {
      "type": "radio",
      "id": "nilYes",
      "name": "nilYes",
      "value": "yes",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.returns.nil_return, "yes")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.returns, "nil_return", "yes")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "nilYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returns.nil_return),
      expression: "returns.nil_return"
    }],
    attrs: {
      "type": "radio",
      "id": "nilNo",
      "name": "nilNo",
      "value": "no",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.returns.nil_return, "no")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.returns, "nil_return", "no")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "nilNo"
    }
  }, [_vm._v("No")])]), _vm._v(" "), (_vm.nilReturn === 'yes') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Reason for providing a Nil return.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returns.nilReason),
      expression: "returns.nilReason"
    }],
    attrs: {
      "type": "textarea",
      "name": "nilReason"
    },
    domProps: {
      "value": (_vm.returns.nilReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.returns, "nilReason", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.nilReturn === 'no') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Do you want to upload spreadsheet with Return data?"), _c('br'), _vm._v("(Download "), _c('a', {
    attrs: {
      "href": _vm.returns.template
    }
  }, [_vm._v("spreadsheet template")]), _vm._v(")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spreadsheetReturn),
      expression: "spreadsheetReturn"
    }],
    attrs: {
      "type": "radio",
      "name": "SpreadsheetYes",
      "value": "yes",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.spreadsheetReturn, "yes")
    },
    on: {
      "change": function($event) {
        _vm.spreadsheetReturn = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "SpreadsheetYes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spreadsheetReturn),
      expression: "spreadsheetReturn"
    }],
    attrs: {
      "type": "radio",
      "name": "SpreadsheetNo",
      "value": "no",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.spreadsheetReturn, "no")
    },
    on: {
      "change": function($event) {
        _vm.spreadsheetReturn = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "SpreadsheetNo"
    }
  }, [_vm._v("No")])]) : _vm._e(), _vm._v(" "), (_vm.nilReturn === 'no' && _vm.spreadsheetReturn === 'yes') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Do you want to add to existing data or replace existing data?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replaceReturn),
      expression: "replaceReturn"
    }],
    attrs: {
      "type": "radio",
      "name": "ReplaceYes",
      "value": "yes",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.replaceReturn, "yes")
    },
    on: {
      "change": function($event) {
        _vm.replaceReturn = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "ReplaceYes"
    }
  }, [_vm._v("Replace")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replaceReturn),
      expression: "replaceReturn"
    }],
    attrs: {
      "type": "radio",
      "name": "ReplaceNo",
      "value": "no",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm._q(_vm.replaceReturn, "no")
    },
    on: {
      "change": function($event) {
        _vm.replaceReturn = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "for": "ReplaceNo"
    }
  }, [_vm._v("Add to")])]) : _vm._e(), _vm._v(" "), (_vm.nilReturn === 'no' && _vm.spreadsheetReturn === 'yes') ? _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "btn btn-primary btn-file pull-left"
  }, [_vm._v("Upload File\n                    "), _c('input', {
    ref: "spreadsheet",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.uploadFile()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.uploadedFileName))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), (_vm.refreshGrid && _vm.nilReturn === 'no') ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.returns.table), function(data, key) {
    return _c('renderer-block', {
      key: ("returns-grid-data_" + key),
      attrs: {
        "component": data
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-left-20"
  })])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "table_name"
    },
    domProps: {
      "value": _vm.returns.table[0].name
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-wrapper"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('input', {
    staticClass: "search-input",
    attrs: {
      "id": _vm.idSearchInput
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mapLeaf",
    attrs: {
      "id": _vm.idMap
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "basemap-button"
  }, [_c('img', {
    staticClass: "basemap-button-img",
    attrs: {
      "id": _vm.idBasemapSat,
      "src": __webpack_require__(57)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setBaseLayer('sat')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "basemap-button-img",
    attrs: {
      "id": _vm.idBasemapOsm,
      "src": __webpack_require__(56)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setBaseLayer('osm')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cursor-location"
  }, [(_vm.cursor_location) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.cursor_location.lat.toFixed(5)) + ", " + _vm._s(_vm.cursor_location.lng.toFixed(5)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "centre_marker",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setMarkerCentre()
      }
    }
  }, [_vm._v("\n            CenterMarker\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Latitude:")]), _vm._v(" "), (_vm.call_email.location) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.call_email.location.geometry.coordinates[1]),
      expression: "call_email.location.geometry.coordinates[1]",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.isReadonly,
      "type": "number",
      "min": "-90",
      "max": "90"
    },
    domProps: {
      "value": (_vm.call_email.location.geometry.coordinates[1])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email.location.geometry.coordinates, 1, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Longitude:")]), _vm._v(" "), (_vm.call_email.location) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.call_email.location.geometry.coordinates[0]),
      expression: "call_email.location.geometry.coordinates[0]",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.isReadonly,
      "type": "number",
      "min": "-180",
      "max": "180"
    },
    domProps: {
      "value": (_vm.call_email.location.geometry.coordinates[0])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email.location.geometry.coordinates, 0, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-6"
  }, [_vm._v("BEN Number:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.location.properties.ben_number),
      expression: "call_email.location.properties.ben_number"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.isReadonly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.call_email.location.properties.ben_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email.location.properties, "ben_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.idLocationFieldsAddress
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Street")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.location.properties.street),
      expression: "call_email.location.properties.street"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.isReadonly,
      "readonly": ""
    },
    domProps: {
      "value": (_vm.call_email.location.properties.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email.location.properties, "street", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.location.properties.town_suburb),
      expression: "call_email.location.properties.town_suburb"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.isReadonly,
      "readonly": ""
    },
    domProps: {
      "value": (_vm.call_email.location.properties.town_suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email.location.properties, "town_suburb", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.location.properties.state),
      expression: "call_email.location.properties.state"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.isReadonly,
      "readonly": ""
    },
    domProps: {
      "value": (_vm.call_email.location.properties.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email.location.properties, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.location.properties.postcode),
      expression: "call_email.location.properties.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.isReadonly,
      "readonly": ""
    },
    domProps: {
      "value": (_vm.call_email.location.properties.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email.location.properties, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.location.properties.country),
      expression: "call_email.location.properties.country"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.isReadonly,
      "readonly": ""
    },
    domProps: {
      "value": (_vm.call_email.location.properties.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email.location.properties, "country", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.idLocationFieldsDetails
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.call_email.location.properties.details),
      expression: "call_email.location.properties.details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.isReadonly
    },
    domProps: {
      "value": (_vm.call_email.location.properties.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.call_email.location.properties, "details", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.application && _vm.application.id) ? _c('div', {
    staticClass: "col-sm-offset-3 col-sm-6 borderDecoration"
  }, [_c('strong', [_vm._v("Your application has been successfully submitted.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.application.lodgement_number))])])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('strong', [_vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.application.lodgement_date)))])])])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to dashboard")])]) : _c('div', {
    staticClass: "col-sm-offset-3 col-sm-6 borderDecoration"
  }, [_c('strong', [_vm._v("Proxy application has been successfully submitted.")]), _vm._v(" "), _c('br'), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to dashboard")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Application: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Date:")])])
}]}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.displayable_number))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('MenuAccess', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_external),
      expression: "!is_external"
    }],
    ref: "menu_access"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayable_tabs),
      expression: "displayable_tabs"
    }],
    attrs: {
      "id": "tabs"
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tab-section",
      "data-tabs": "tabs"
    }
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "0",
      "data-toggle": "pill"
    },
    on: {
      "click": function($event) {
        return _vm.selectReturnsTab(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.tabs[0]))])]), _vm._v(" "), (_vm.returns.has_payment) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "1",
      "data-toggle": "pill"
    },
    on: {
      "click": function($event) {
        return _vm.selectReturnsTab(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.tabs[1]))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._v("\n          " + _vm._s(this.$slots.default) + "\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "change-contact"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.title,
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "declineForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Provide Reason for the proposed decline ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propose_decline.reason),
      expression: "propose_decline.reason"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "name": "reason"
    },
    domProps: {
      "value": (_vm.propose_decline.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propose_decline, "reason", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Proposed CC email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propose_decline.cc_email),
      expression: "propose_decline.cc_email"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "text",
      "name": "cc_email"
    },
    domProps: {
      "value": (_vm.propose_decline.cc_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propose_decline, "cc_email", $event.target.value)
      }
    }
  })])])])])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.decliningApplication) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Proposing Decline")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Propose Decline")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isReturnsLoaded) ? _c('div', [(_vm.visibleRequests.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "red"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 pull-right"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("An amendment has been requested for this Return\n                        "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.returnsAmendBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.returnsAmendBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse collapse in",
    attrs: {
      "id": _vm.returnsAmendBody
    }
  }, _vm._l((_vm.visibleRequests), function(a, a_idx) {
    return _c('div', {
      key: ("ret_amend_" + a_idx)
    }, [(a.text) ? _c('p', [_c('b', [_vm._v("Details:")])]) : _vm._e(), _vm._l((_vm.splitText(a.text)), function(t, t_idx) {
      return _c('div', {
        key: ("ret_text_" + t_idx)
      }, [_vm._v(_vm._s(t)), _c('br')])
    }), _vm._v(" "), _c('p')], 2)
  }), 0)])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("New due date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "newDueDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_due_date),
      expression: "new_due_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.new_due_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_due_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v("\n                    current due date: " + _vm._s(_vm.comingDueDateDisplay) + " "), _c('br'), _vm._v("\n                    (New due date: " + _vm._s(_vm.extendMinDateDisplay) + " --- " + _vm._s(_vm.extendMaxDateDisplay) + ")\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reasonForExtension),
      expression: "reasonForExtension"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add reason",
      "id": "reason"
    },
    domProps: {
      "value": (_vm.reasonForExtension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reasonForExtension = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": _vm.sanction_outcome.commsLogsDocumentUrl
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorResponse)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processingDetails) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "internal-application-sendAssessor"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Send to Assessor",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "assessorForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assessment.assessor_group_name),
      expression: "assessment.assessor_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.assessment.assessor_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.assessment, "assessor_group_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assessment.text),
      expression: "assessment.text"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name"
    },
    domProps: {
      "value": (_vm.assessment.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.assessment, "text", $event.target.value)
      }
    }
  })])])])])], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "userInfo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "profile_form",
      "method": "post"
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profile Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.name),
      expression: "profile.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Institution")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.institution),
      expression: "profile.institution"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "institution",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.institution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "institution", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Line 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.line1),
      expression: "profile.postal_address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "line1",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Line 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.line2),
      expression: "profile.postal_address.line2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "line2",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.line2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "line2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Line 3")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.line3),
      expression: "profile.postal_address.line3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "line3",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.line3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "line3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Suburb/Town (Locality)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.locality),
      expression: "profile.postal_address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "locality",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.state),
      expression: "profile.postal_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "state",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.country),
      expression: "profile.postal_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "country",
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile.postal_address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(c) {
    return _c('option', {
      domProps: {
        "value": c.code
      }
    }, [_vm._v(_vm._s(c.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.postal_address.postcode),
      expression: "profile.postal_address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.profile.postal_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.postal_address, "postcode", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingProfile) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateProfile()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Edit Profile\n                ")])])
}]}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-buffer bottom-buffer"
  }, [(_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), (_vm.help_text_url) ? [_c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })] : _vm._e(), _vm._v(" "), _vm._l((_vm.repeatableGroups), function(group, groupIdx) {
    return _c('div', {
      key: ("repeatable_group_" + (_vm.component.name) + "_" + groupIdx),
      staticClass: "repeatable-group",
      attrs: {
        "id": ("repeatable_group_" + (_vm.component.name) + "_" + groupIdx)
      }
    }, [_c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('label', {
      staticClass: "inline",
      attrs: {
        "id": (_vm.id + "_" + groupIdx)
      }
    }, [_vm._v(_vm._s(_vm.label) + " " + _vm._s(_vm.add_1(groupIdx)))]), _vm._v(" "), _c('a', {
      staticClass: "collapse-link-top pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleGroupVisibility(group)
        }
      }
    }, [(_vm.isExpanded(group)) ? _c('span', {
      staticClass: "glyphicon glyphicon-chevron-down"
    }) : _c('span', {
      staticClass: "glyphicon glyphicon-chevron-up"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      class: {
        'collapse': true, 'in': !_vm.isExpanded(group)
      },
      staticStyle: {
        "margin-top": "10px"
      }
    }, _vm._l((_vm.components[group].children), function(subcomponent, index) {
      return _c('div', {
        key: ("repeatable_group_subcomponent_" + (subcomponent.name) + "_" + index)
      }, [_c('renderer-block', {
        key: ("repeatable_group_subcomponent_contents_" + (subcomponent.name) + "_" + index),
        attrs: {
          "component": subcomponent,
          "json_data": _vm.value
        }
      }), _vm._v(" "), _c('div', [(_vm.num_groups() > 1 && index == _vm.component.children.length - 1 && !_vm.readonly) ? _c('button', {
        staticClass: "btn btn-danger",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeGroup(group)
          }
        }
      }, [_vm._v("Delete " + _vm._s(_vm.label))]) : _vm._e()])], 1)
    }), 0)])])])
  }), _vm._v(" "), (_vm.component.isRepeatable && !_vm.readonly) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary add-new-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewGroup($event)
      }
    }
  }, [_vm._v("Add " + _vm._s(_vm.label))])]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-wrapper"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('input', {
    staticClass: "search-input",
    attrs: {
      "id": _vm.idSearchInput
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mapLeaf",
    attrs: {
      "id": _vm.idMap
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "basemap-button"
  }, [_c('img', {
    staticClass: "basemap-button-img",
    attrs: {
      "id": _vm.idBasemapSat,
      "src": __webpack_require__(57)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setBaseLayer('sat')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "basemap-button-img",
    attrs: {
      "id": _vm.idBasemapOsm,
      "src": __webpack_require__(56)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setBaseLayer('osm')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cursor-location"
  }, [(_vm.cursor_location) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.cursor_location.lat.toFixed(5)) + ", " + _vm._s(_vm.cursor_location.lng.toFixed(5)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "centre_marker",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setMarkerCentre()
      }
    }
  }, [_vm._v("\n            CenterMarker\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Latitude:")]), _vm._v(" "), (_vm.marker_lat) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.marker_lat),
      expression: "marker_lat",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "type": "number",
      "min": "-90",
      "max": "90"
    },
    domProps: {
      "value": (_vm.marker_lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.marker_lat = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Longitude:")]), _vm._v(" "), (_vm.marker_lng) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.marker_lng),
      expression: "marker_lng",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonly,
      "type": "number",
      "min": "-180",
      "max": "180"
    },
    domProps: {
      "value": (_vm.marker_lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.marker_lng = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalOrgAccessDash"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organisation")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterOrganisation),
      expression: "filterOrganisation"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterOrganisation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.organisationChoices), function(o) {
    return _c('option', {
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Applicant")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterApplicant),
      expression: "filterApplicant"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterApplicant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.applicantChoices), function(a) {
    return _c('option', {
      domProps: {
        "value": a
      }
    }, [_vm._v(_vm._s(a))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Role")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterRole),
      expression: "filterRole"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterRole = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.roleChoices), function(r) {
    return _c('option', {
      domProps: {
        "value": r
      }
    }, [_vm._v(_vm._s(r))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.statusChoices), function(s) {
    return _c('option', {
      domProps: {
        "value": s
      }
    }, [_vm._v(_vm._s(s))])
  })], 2)])])]), _vm._v(" "), _c('datatable', {
    ref: "org_access_table",
    attrs: {
      "id": "org-access-table",
      "dtOptions": _vm.org_access_request_options,
      "dtHeaders": _vm.org_access_request_headers
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CreateInspection"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Create New Inspection",
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Region")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.region_id),
      expression: "region_id"
    }],
    staticClass: "form-control col-sm-9",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.region_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.preventDefault();
        return _vm.updateDistricts()
      }]
    }
  }, _vm._l((_vm.regions), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("District")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.district_id),
      expression: "district_id"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.district_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.preventDefault();
        return _vm.updateAllocatedGroup()
      }]
    }
  }, _vm._l((_vm.availableDistricts), function(option) {
    return _c('option', {
      key: option.district_id,
      domProps: {
        "value": option.district_id
      }
    }, [_vm._v("\n                              " + _vm._s(option.district_name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Allocate to")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assigned_to_id),
      expression: "assigned_to_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assigned_to_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allocatedGroup), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.full_name) + " \n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Inspection Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspection_type_id),
      expression: "inspection_type_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.inspection_type_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.inspectionTypes), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                              " + _vm._s(option.inspection_type) + "\n                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inspectionDetails),
      expression: "inspectionDetails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add details",
      "id": "details"
    },
    domProps: {
      "value": (_vm.inspectionDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inspectionDetails = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document"
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryDocumentCollectionId
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }, [_vm._v(_vm._s(_vm.errorResponse))])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.org) ? _c('div', {
    staticClass: "container",
    attrs: {
      "id": "userInfo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Organisation Details"), _c('small', [_vm._v(" View and update the organisation's details")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "personal_form",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.name),
      expression: "org.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": !_vm.myorgperms.is_admin,
      "name": "first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.abn),
      expression: "org.abn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "name": "last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.abn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org, "abn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingDetails) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateDetails()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Address Details"), _c('small', [_vm._v(" View and update the organisation's address details")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.adBody,
      "data-toggle": "collapse",
      "expanded": "false",
      "data-parent": "#userInfo",
      "aria-controls": _vm.adBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), (_vm.loading.length == 0) ? _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.adBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.address.line1),
      expression: "org.address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org.address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.address.locality),
      expression: "org.address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org.address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.address.state),
      expression: "org.address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org.address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.address.postcode),
      expression: "org.address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.org.address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.org.address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.address.country),
      expression: "org.address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.org.address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(c) {
    return _c('option', {
      domProps: {
        "value": c.code
      }
    }, [_vm._v(_vm._s(c.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingAddress) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateAddress()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Contact Details"), _c('small', [_vm._v(" View and update the organisation's contact details")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.cBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.cBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.cBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addContact()
      }
    }
  }, [_vm._v("Add Contact")])]), _vm._v(" "), _c('datatable', {
    ref: "contacts_datatable",
    attrs: {
      "id": "organisation_contacts_datatable",
      "dtOptions": _vm.contacts_options,
      "dtHeaders": _vm.contacts_headers
    }
  })], 1)])])])]), _vm._v(" "), (_vm.myorgperms.is_admin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Linked Persons"), _c('small', [_vm._v(" Manage the user accounts linked to the organisation")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.oBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.oBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.oBody
    }
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "col-sm-6 row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v(" Organisation User Pin Code 1:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.org.pins.three))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organisation User Pin Code 2:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.org.pins.four))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 row"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "disabled": !_vm.myorgperms.is_admin
    }
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v(" Organisation Administrator Pin Code 1:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.org.pins.one))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "disabled": !_vm.myorgperms.is_admin
    }
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organisation Administrator Pin Code 2:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.org.pins.two))])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('datatable', {
    ref: "contacts_datatable_user",
    attrs: {
      "id": "organisation_contacts_datatable_ref",
      "dtOptions": _vm.contacts_options_ref,
      "dtHeaders": _vm.contacts_headers_ref
    },
    model: {
      value: (_vm.filterOrgContactStatus),
      callback: function($$v) {
        _vm.filterOrgContactStatus = $$v
      },
      expression: "filterOrgContactStatus"
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), _c('AddContact', {
    ref: "add_contact",
    attrs: {
      "org_id": _vm.org.id
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 row"
  }, [_c('h6', [_vm._v("Use the Organisation Administrator pin codes if you want the new user to be linked as organisation administrator."), _c('br'), _vm._v(" Use the Organisation User pin codes if you want the new user to be linked as organisation user.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Persons linked to the organisation are controlled by the organisation. The Department cannot manage this list of people.")])])])])])
}]}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflowDetails),
      expression: "workflowDetails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add reason",
      "id": "reason"
    },
    domProps: {
      "value": (_vm.workflowDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workflowDetails = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": _vm.sanction_outcome.commsLogsDocumentUrl
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorResponse)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processingDetails) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "actionLicencePurpose"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.title,
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "actionPurposeForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.hasActionableLicencePurposes) ? _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.actionableLicencePurposes), function(purpose, index) {
    return _c('div', {
      key: ("purpose_" + index)
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.action_licence.purpose_ids_list),
        expression: "action_licence.purpose_ids_list"
      }],
      attrs: {
        "type": "checkbox",
        "id": purpose.purpose.id
      },
      domProps: {
        "value": purpose.purpose.id,
        "checked": Array.isArray(_vm.action_licence.purpose_ids_list) ? _vm._i(_vm.action_licence.purpose_ids_list, purpose.purpose.id) > -1 : (_vm.action_licence.purpose_ids_list)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.action_licence.purpose_ids_list,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = purpose.purpose.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.action_licence, "purpose_ids_list", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.action_licence, "purpose_ids_list", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.action_licence, "purpose_ids_list", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(purpose.name) + "\n                                        ")])])
  }), 0) : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', [_vm._v("You cannot apply this action to any purposes. This may be due to open applications that have yet to be processed.")])])])])])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.actioningPurposes) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(_vm._s(_vm.actioning_text) + " Purpose(s)")]) : _vm._e(), _vm._v(" "), (_vm.hasActionableLicencePurposes && !_vm.actioningPurposes) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.action_text) + " Purpose(s)")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Close")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "RunningSheetHistory"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('datatable', {
    ref: "running_sheet_hist_instance",
    attrs: {
      "id": "running-sheet-hist-instance",
      "dtOptions": _vm.dtOptionsRunningSheetHistory,
      "dtHeaders": _vm.dtHeadersRunningSheetHistory,
      "parentStyle": " "
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    }
  }, [_vm._v(_vm._s(_vm.errorResponse))])])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "LegalCaseWorkflow"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.workflow_type === 'brief_of_evidence') ? _c('div', {
    staticClass: "row"
  }, [_c('strong', [_vm._v("Are you sure you want to generate the Brief of Evidence?\n                "), _c('br'), _vm._v("( This will make the Case read-only and no further changes can be made)\n            ")])]) : (_vm.workflow_type === 'prosecution_brief') ? _c('div', {
    staticClass: "row"
  }, [_c('strong', [_vm._v("Are you sure you want to generate the Prosecution Brief?\n            ")])]) : (_vm.workflow_type === 'back_to_case') ? _c('div', {
    staticClass: "row"
  }, [_c('strong', [_vm._v("Are you sure you want to re-open the Case?\n            ")])]) : _c('div', {
    staticClass: "row"
  }, [(_vm.workflow_type === 'approve_brief_of_evidence') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('strong', [_vm._v("\n                              This will forward the Case for possible legal action\n                          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflowDetails),
      expression: "workflowDetails"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add details",
      "id": "details"
    },
    domProps: {
      "value": (_vm.workflowDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workflowDetails = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Attachments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "comms_log_file",
    attrs: {
      "name": "comms-log-file",
      "isRepeatable": true,
      "documentActionUrl": _vm.legal_case.commsLogsDocumentUrl
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Error: " + _vm._s(_vm.errorResponse))])])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "report-form"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "id": "payments-form",
      "action": "/ledger/payments/api/report"
    }
  }, [_c('div', {
    staticClass: "well"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("Payments Reports")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.region),
      expression: "!region"
    }],
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.generateByAccount()
      }
    }
  }, [_vm._v("Generate Report By Accounts")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 clearfix"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.generateFlatReport()
      }
    }
  }, [_vm._v("Generate Report Flat")])])])])])])]), _vm._v(" "), _c('form', {
    ref: "oracle_form"
  }, [_c('div', {
    staticClass: "well well-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    ref: "oracleDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "oracle_date",
      "placeholder": "DD/MM/YYYY",
      "required": ""
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.runOracleJob()
      }
    }
  }, [_vm._v("Run Job")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oracle_override),
      expression: "oracle_override"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.oracle_override) ? _vm._i(_vm.oracle_override, "") > -1 : (_vm.oracle_override)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.oracle_override,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.oracle_override = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.oracle_override = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.oracle_override = $$c
        }
      }
    }
  }), _vm._v("Override closed period check")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "accountsDateStartPicker"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "start",
      "placeholder": "DD/MM/YYYY",
      "required": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "accountsDateEndPicker"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "end",
      "placeholder": "DD/MM/YYYY",
      "required": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Bank Start Date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "flatDateStartPicker"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "banked_start",
      "placeholder": "DD/MM/YYYY",
      "required": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Bank End Date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group date",
    attrs: {
      "id": "flatDateEndPicker"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "banked_end",
      "placeholder": "DD/MM/YYYY",
      "required": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("Oracle Job")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
}]}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.value) + " "), (_vm.help_text_url) ? _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "schema-group"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Schema Section Groups\n                      "), _c('a', {
    attrs: {
      "href": '#' + _vm.pGroupBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pGroupBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pGroupBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Purpose")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterTablePurpose),
      expression: "filterTablePurpose"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterTablePurpose = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.schemaPurposes), function(p, pid) {
    return _c('option', {
      key: ("group_" + pid),
      domProps: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "name": "add_group"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addTableEntry()
      }
    }
  }, [_vm._v("New Group")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Section")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterTableSection),
      expression: "filterTableSection"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterTableSection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.schemaSections), function(s, sid) {
    return _c('option', {
      key: ("section_" + sid),
      domProps: {
        "value": s.value
      }
    }, [_vm._v(_vm._s(s.label))])
  })], 2)])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('datatable', {
    ref: "schema_group_table",
    attrs: {
      "id": _vm.schema_group_id,
      "dtOptions": _vm.dtOptionsSchemaGroup,
      "dtHeaders": _vm.dtHeadersSchemaGroup
    }
  })], 1)])])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Schema Section Group",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                      " + _vm._s(error.label) + "\n                  ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "schema_group"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Licence Purpose")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterGroupSection),
      expression: "filterGroupSection"
    }],
    ref: "select_purpose",
    staticClass: "form-control",
    attrs: {
      "name": "select-purpose"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterGroupSection = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.schemaPurposes), function(p, pid) {
    return _c('option', {
      key: ("purpose_" + pid),
      domProps: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Section")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionGroup.section),
      expression: "sectionGroup.section"
    }],
    ref: "select_section",
    staticClass: "form-control",
    attrs: {
      "name": "select-section"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sectionGroup, "section", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.schemaSections), function(s, sid) {
    return _c('option', {
      key: ("section_" + sid),
      domProps: {
        "value": s.value
      }
    }, [_vm._v(_vm._s(s.label))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("  ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Group Label")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sectionGroup.group_label),
      expression: "sectionGroup.group_label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sectionGroup.group_label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sectionGroup, "group_label", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getCheckedRepeatable('isRepeatable').isChecked),
      expression: "getCheckedRepeatable('isRepeatable').isChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.getCheckedRepeatable('isRepeatable').isChecked) ? _vm._i(_vm.getCheckedRepeatable('isRepeatable').isChecked, true) > -1 : (_vm.getCheckedRepeatable('isRepeatable').isChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.getCheckedRepeatable('isRepeatable').isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.getCheckedRepeatable('isRepeatable'), "isChecked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.getCheckedRepeatable('isRepeatable'), "isChecked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.getCheckedRepeatable('isRepeatable'), "isChecked", $$c)
        }
      }
    }
  }), _vm._v("   "), _c('label', [_vm._v("isRepeatable")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveGroup
    }
  }, [_vm._v("Save")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br')])
}]}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalSanctionOutcomeDash"
    }
  }, [_c('FormSection', {
    attrs: {
      "label": "Sanction Outcome",
      "Index": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterType),
      expression: "filterType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sanction_outcome_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.display) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Status:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sanction_outcome_statuses), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.display) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Payment status:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterPaymentStatus),
      expression: "filterPaymentStatus"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterPaymentStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sanction_outcome_payment_statuses), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                    " + _vm._s(option.display) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Issue date from:")]), _vm._v(" "), _c('div', {
    ref: "issueDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateFromPicker),
      expression: "filterDateFromPicker"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateFromPicker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateFromPicker = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Issue date to:")]), _vm._v(" "), _c('div', {
    ref: "issueDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDateToPicker),
      expression: "filterDateToPicker"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterDateToPicker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterDateToPicker = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("Region:")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.filterRegionId
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        _vm.filterRegionId = $event.target.value;
        _vm.updateDistricts(_vm.updateFromUI)
      }
    }
  }, _vm._l((_vm.sanction_outcome_regions), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                        " + _vm._s(option.name) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {}, [_vm._v("District:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterDistrictId),
      expression: "filterDistrictId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterDistrictId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sanction_outcome_availableDistricts), function(option) {
    return _c('option', {
      key: option.district_id,
      domProps: {
        "value": option.district_id
      }
    }, [_vm._v("\n                    " + _vm._s(option.district_name) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "sanction_outcome_table",
    attrs: {
      "id": "sanction_outcome-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-wrapper"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('input', {
    staticClass: "search-input",
    attrs: {
      "id": _vm.idSearchInput
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mapLeaf",
    attrs: {
      "id": _vm.idMap
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "basemap-button"
  }, [_c('img', {
    staticClass: "basemap-button-img",
    attrs: {
      "id": _vm.idBasemapSat,
      "src": __webpack_require__(57)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setBaseLayer('sat')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "basemap-button-img",
    attrs: {
      "id": _vm.idBasemapOsm,
      "src": __webpack_require__(56)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setBaseLayer('osm')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cursor-location"
  }, [(_vm.cursor_location) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.cursor_location.lat.toFixed(5)) + ", " + _vm._s(_vm.cursor_location.lng.toFixed(5)))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "centre_marker",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setMarkerCentre()
      }
    }
  }, [_vm._v("\n            CenterMarker\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Latitude:")]), _vm._v(" "), (_vm.offence.location) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.offence.location.geometry.coordinates[1]),
      expression: "offence.location.geometry.coordinates[1]",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "-90",
      "max": "90"
    },
    domProps: {
      "value": (_vm.offence.location.geometry.coordinates[1])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.geometry.coordinates, 1, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Longitude:")]), _vm._v(" "), (_vm.offence.location) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.offence.location.geometry.coordinates[0]),
      expression: "offence.location.geometry.coordinates[0]",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "-180",
      "max": "180"
    },
    domProps: {
      "value": (_vm.offence.location.geometry.coordinates[0])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.geometry.coordinates, 0, _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.idLocationFieldsAddress
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Street")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.street),
      expression: "offence.location.properties.street"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.offence.location.properties.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "street", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.town_suburb),
      expression: "offence.location.properties.town_suburb"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.offence.location.properties.town_suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "town_suburb", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.state),
      expression: "offence.location.properties.state"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.offence.location.properties.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "state", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.postcode),
      expression: "offence.location.properties.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.offence.location.properties.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.country),
      expression: "offence.location.properties.country"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.offence.location.properties.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "country", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.idLocationFieldsDetails
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.offence.location.properties.details),
      expression: "offence.location.properties.details"
    }],
    staticClass: "form-control location_address_field",
    domProps: {
      "value": (_vm.offence.location.properties.details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.offence.location.properties, "details", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CreateInspection"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Shibaken",
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', [_c('img', {
    staticClass: "modal-content",
    attrs: {
      "src": __webpack_require__(311)
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.component.type === 'tab') ? _c('div', _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('renderer-block', {
      key: ("subcomponent_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'section') ? _c('FormSection', {
    attrs: {
      "label": _vm.component.label,
      "Index": _vm.component_name,
      "id": _vm.component_name
    }
  }, _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('renderer-block', {
      key: ("section_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'group') ? _c('Group', {
    attrs: {
      "field_data": _vm.value,
      "label": _vm.component.label,
      "name": _vm.component_name,
      "id": _vm.element_id(),
      "help_text": _vm.help_text,
      "help_text_url": _vm.help_text_url,
      "isRemovable": true
    }
  }, _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('renderer-block', {
      key: ("group_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'group2') ? _c('Group2', {
    attrs: {
      "field_data": _vm.value,
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "component": _vm.component,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'richtext') ? _c('RichTextField', {
    attrs: {
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "can_view_richtext_src": _vm.can_view_richtext_src,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'text') ? _c('TextField', {
    attrs: {
      "type": "text",
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'string') ? _c('TextField', {
    attrs: {
      "type": "string",
      "name": _vm.component.name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'number') ? _c('TextField', {
    attrs: {
      "type": "number",
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "min": _vm.component.min,
      "max": _vm.component.max,
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'email') ? _c('TextField', {
    attrs: {
      "type": "email",
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'select') ? _c('div', [_c('SelectBlock', {
    attrs: {
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "options": _vm.component.options,
      "help_text": _vm.help_text,
      "handleChange": _vm.handleComponentChange(_vm.component, true),
      "conditions": _vm.component.conditions,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.json_data,
      "id": _vm.element_id(1),
      "readonly": _vm.is_readonly
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'multi-select') ? _c('SelectBlock', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "options": _vm.component.options,
      "help_text": _vm.help_text,
      "handleChange": _vm.handleComponentChange(_vm.component, false),
      "readonly": _vm.is_readonly,
      "isMultiple": true,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'text_area') ? _c('TextAreaBlock', {
    attrs: {
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'table') ? _c('TableBlock', {
    attrs: {
      "headers": _vm.component.headers,
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'expander_table') ? _c('ExpanderTable', {
    attrs: {
      "field_data": _vm.value,
      "readonly": _vm.is_readonly,
      "name": _vm.component_name,
      "component": _vm.component,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'label') ? _c('LabelBlock', {
    attrs: {
      "value": _vm.component.label,
      "id": _vm.element_id(),
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'radiobuttons') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "inline",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.element_id()
    }
  }, [_vm._v(_vm._s(_vm.component.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.component.label,
      "name": _vm.component_name,
      "field_data": _vm.value
    }
  }), _vm._v(" "), _vm._l((_vm.component.options), function(option, index) {
    return _c('Radio', {
      key: ("radio_" + _vm.component_name + "_" + index),
      attrs: {
        "name": _vm.component_name,
        "label": option.label,
        "value": option.value,
        "isRequired": option.isRequired || _vm.component.isRequired,
        "id": _vm.element_id(1),
        "savedValue": _vm.value,
        "handleChange": _vm.handleComponentChange(_vm.component),
        "conditions": _vm.component.conditions,
        "readonly": _vm.is_readonly
      }
    })
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.json_data,
      "id": _vm.element_id(2),
      "readonly": _vm.is_readonly
    }
  })], 2) : _vm._e(), _vm._v(" "), (_vm.component.type === 'checkbox') ? _c('div', {
    staticClass: "form-group"
  }, [_c('Checkbox', {
    attrs: {
      "group": _vm.component.group,
      "name": _vm.component_name,
      "label": _vm.component.label,
      "id": _vm.element_id(1),
      "help_text": _vm.help_text,
      "help_text_url": _vm.help_text_url,
      "field_data": _vm.value,
      "handleChange": _vm.handleComponentChange(_vm.component),
      "conditions": _vm.component.conditions,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired
    }
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.json_data,
      "id": _vm.element_id(2),
      "isRequired": _vm.component.isRequired
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'declaration') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.component.label))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "help_text": _vm.component.help_text,
      "handleChange": _vm.handleComponentChange(_vm.component),
      "conditions": _vm.component.conditions
    }
  }), _vm._v(" "), _c('Conditions', {
    attrs: {
      "conditions": _vm.component.conditions,
      "name": _vm.component_name,
      "instance": _vm.instance,
      "data": _vm.value
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'file') ? _c('File', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "isRepeatable": _vm.strToBool(_vm.component.isRepeatable),
      "readonly": _vm.is_readonly,
      "help_text": _vm.help_text,
      "docsUrl": _vm.documents_url,
      "application_id": _vm.application_id,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url,
      "isTableField": _vm.isTableField
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'date') ? _c('DateField', {
    attrs: {
      "name": _vm.component_name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "readonly": _vm.is_readonly,
      "help_text": _vm.help_text,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url,
      "isTableField": _vm.isTableField
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'grid') ? _c('GridBlock', {
    attrs: {
      "name": _vm.component.name,
      "headers": _vm.component.headers,
      "field_data": _vm.component.data,
      "id": _vm.element_id(),
      "label": _vm.component.label,
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'species') ? _c('Species', {
    attrs: {
      "name": _vm.component.name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "options": _vm.component.component_attribute,
      "isMultiple": true,
      "isRepeatable": _vm.strToBool(_vm.component.isRepeatable),
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "handleChange": _vm.handleComponentChange(_vm.component, true),
      "help_text_url": _vm.help_text_url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.component.type === 'species-group') ? _c('SpeciesGroup', {
    attrs: {
      "label": _vm.component.label,
      "name": _vm.component_name,
      "id": _vm.element_id(),
      "help_text": _vm.help_text,
      "help_text_url": _vm.help_text_url,
      "isRemovable": true
    }
  }, _vm._l((_vm.component.children), function(subcomponent, index) {
    return _c('renderer-block', {
      key: ("species-group_" + index),
      attrs: {
        "component": subcomponent,
        "instance": _vm.instance
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.component.type === 'species-all') ? _c('SpeciesFiltered', {
    attrs: {
      "name": _vm.component.name,
      "label": _vm.component.label,
      "field_data": _vm.value,
      "id": _vm.element_id(),
      "options": _vm.component.component_attribute,
      "isMultiple": false,
      "isRepeatable": _vm.strToBool(_vm.component.isRepeatable),
      "help_text": _vm.help_text,
      "readonly": _vm.is_readonly,
      "isRequired": _vm.component.isRequired,
      "handleChange": _vm.handleComponentChange(_vm.component, true),
      "help_text_url": _vm.help_text_url,
      "filtered_list_url": _vm.application_url(_vm.component)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Organisations\n                    "), _c('a', {
    attrs: {
      "href": '#' + _vm.oBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.oBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.oBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "organisation_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.organisation_options,
      "dtHeaders": _vm.organisation_headers
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pill-tabs"
    }
  }, [_c('div', {
    staticClass: "tab-header",
    attrs: {
      "id": "tabs"
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tab-section",
      "data-tabs": "tabs"
    }
  }, _vm._l((_vm.tabs), function(tab, idx) {
    return _c('li', {
      key: idx,
      staticClass: "nav-item",
      class: {
        'nav-item active': _vm.activeTab === Object.keys(tab)[0]
      }
    }, [_c('a', {
      staticClass: "nav-link",
      attrs: {
        "id": idx,
        "data-toggle": "pill"
      },
      on: {
        "click": function($event) {
          _vm.switchTab(Object.keys(tab)[0])
        }
      }
    }, [_vm._t(_vm.tabHeadSlotName(Object.keys(tab)[0]), [_vm._v(_vm._s(Object.values(tab)[0]))])], 2)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t(_vm.tabPanelSlotName)], 2)])
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canViewComments && _vm.canEditOfficerComments) ? _c('div', {
    staticClass: "inline-block"
  }, [(!_vm.showingComment(_vm.COMMENT_TYPE_OFFICER)) ? _c('div', [(_vm.field_data.officer_comment) ? _c('a', {
    attrs: {
      "href": "",
      "title": "Officer Comments"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_OFFICER)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" ")])]) : _c('a', {
    attrs: {
      "href": "",
      "title": "Officer Comments"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_OFFICER)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  }, [_vm._v(" ")])])]) : _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_OFFICER)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }, [_vm._v(" ")])])]) : _vm._e(), _vm._v(" "), (_vm.canViewComments && !_vm.canEditOfficerComments && _vm.field_data.officer_comment) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.field_data.officer_comment))])]) : _vm._e(), _vm._v(" "), (_vm.canViewDeficiencies && _vm.canEditDeficiencies) ? _c('div', {
    staticClass: "inline-block"
  }, [(!_vm.showingComment(_vm.COMMENT_TYPE_DEFICIENCY)) ? _c('div', [(_vm.field_data.deficiency_value) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_DEFICIENCY)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "title": "Deficiencies"
    }
  }, [_vm._v(" ")])]) : _c('a', {
    attrs: {
      "href": "",
      "title": "Deficiencies"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_DEFICIENCY)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }, [_vm._v(" ")])])]) : _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_DEFICIENCY)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }, [_vm._v(" ")])])]) : _vm._e(), _vm._v(" "), (_vm.canViewDeficiencies && !_vm.canEditDeficiencies && _vm.field_data.deficiency_value) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.field_data.deficiency_value))])]) : _vm._e(), _vm._v(" "), (_vm.canViewComments && _vm.canEditAssessorComments) ? _c('div', {
    staticClass: "inline-block"
  }, [(!_vm.showingComment(_vm.COMMENT_TYPE_ASSESSOR)) ? _c('div', [(_vm.field_data.assessor_comment) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_ASSESSOR)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "title": "Assessor Comments"
    }
  }, [_vm._v(" ")])]) : _c('a', {
    attrs: {
      "href": "",
      "title": "Assessor Comments"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_ASSESSOR)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  }, [_vm._v(" ")])])]) : _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComment(_vm.COMMENT_TYPE_ASSESSOR)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }, [_vm._v(" ")])])]) : (_vm.canViewComments && _vm.field_data.assessor_comment) ? _c('div', {
    staticClass: "inline-block",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.field_data.assessor_comment))])]) : _vm._e(), _vm._v(" "), _c('Comment', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingComment(_vm.COMMENT_TYPE_OFFICER)),
      expression: "showingComment(COMMENT_TYPE_OFFICER)"
    }],
    attrs: {
      "question": _vm.label ? _vm.label : _vm.name,
      "name": _vm.name + '-officer-comment-field',
      "field_data": _vm.field_data,
      "commentType": _vm.COMMENT_TYPE_OFFICER
    }
  }), _vm._v(" "), _c('Comment', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingComment(_vm.COMMENT_TYPE_ASSESSOR)),
      expression: "showingComment(COMMENT_TYPE_ASSESSOR)"
    }],
    attrs: {
      "question": _vm.label ? _vm.label : _vm.name,
      "name": _vm.name + '-assessor-comment-field',
      "field_data": _vm.field_data,
      "commentType": _vm.COMMENT_TYPE_ASSESSOR
    }
  }), _vm._v(" "), _c('Comment', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingComment(_vm.COMMENT_TYPE_DEFICIENCY)),
      expression: "showingComment(COMMENT_TYPE_DEFICIENCY)"
    }],
    attrs: {
      "question": _vm.label ? _vm.label : _vm.name,
      "name": _vm.name + '-deficiency-field',
      "field_data": _vm.field_data,
      "commentType": _vm.COMMENT_TYPE_DEFICIENCY
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "externalReturnSheetEntry"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.title,
      "large": ""
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                        " + _vm._s(error.label) + "\n                    ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.incorrect_entry.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Error in Quantity")]), _vm._v(" "), _c('ul', _vm._l((_vm.incorrect_entry), function(error) {
    return _c('li', [_vm._v("\n                        " + _vm._s(error.message) + "\n                    ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "sheetEntryForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Activity:")])]), _vm._v(" "), (_vm.isStockEntry) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.activityList[_vm.entryActivity]['label']))])]) : _vm._e(), _vm._v(" "), (_vm.isAddEntry && !_vm.isStockEntry) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryActivity),
      expression: "entryActivity"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.entryActivity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.filteredActivityList), function(activity, activityId) {
    return (activity['auto'] == 'false') ? _c('option', {
      domProps: {
        "value": activityId
      }
    }, [_vm._v(_vm._s(activity['label']))]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isChangeEntry && !_vm.isStockEntry) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.filteredActivityList[_vm.entryActivity]['label']) + " ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Activity Date:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    ref: "activityDateToPicker",
    staticClass: "input-group date",
    attrs: {
      "name": "activityDateToPicker",
      "required": "true"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryActivityDate),
      expression: "entryActivityDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY",
      "id": "entryActivityDate"
    },
    domProps: {
      "value": (_vm.entryActivityDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryActivityDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Quantity:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryQty),
      expression: "entryQty"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.entryQty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryQty = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Total Number:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryTotal),
      expression: "entryTotal"
    }],
    attrs: {
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.entryTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryTotal = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.isLicenceRequired) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Receiving licence:")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Name of")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Supplier/Recipient:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entrySupplier),
      expression: "entrySupplier"
    }],
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.entrySupplier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entrySupplier = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Keeper, Import or Export")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Licence number:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryLicence),
      expression: "entryLicence"
    }],
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.entryLicence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryLicence = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Comments:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryComment),
      expression: "entryComment"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "name": "entry_comments"
    },
    domProps: {
      "value": (_vm.entryComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryComment = $event.target.value
      }
    }
  })])])])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPayable),
      expression: "!isPayable"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update()
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPayable),
      expression: "isPayable"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.check_and_pay()
      }
    }
  }, [_vm._v("Pay")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-1"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.type),
      expression: "sanction_outcome.type"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sanction_outcome, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.typeChanged()
      }]
    }
  }, _vm._l((_vm.options_for_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                            " + _vm._s(option.display) + "\n                        ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayTabs),
      expression: "displayTabs"
    }]
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.nTab
    }
  }, [_vm._v(_vm._s(_vm.firstTabTitle))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayRemediationActions),
      expression: "displayRemediationActions"
    }],
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.aTab
    }
  }, [_vm._v("Remediation Actions")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.dTab
    }
  }, [_vm._v("Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.nTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "identifier"
    }
  }, [_vm._v("Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sanction_outcome),
      expression: "sanction_outcome"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.identifier),
      expression: "sanction_outcome.identifier"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "identifier",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.sanction_outcome.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "identifier", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Region")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    staticClass: "form-control col-sm-9",
    domProps: {
      "value": _vm.sanction_outcome.region_id
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        _vm.sanction_outcome.region_id = $event.target.value;
        _vm.updateDistricts('updatefromUI')
      }
    }
  }, _vm._l((_vm.regions), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.name) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("District")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.district_id),
      expression: "sanction_outcome.district_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sanction_outcome, "district_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.availableDistricts), function(option) {
    return _c('option', {
      key: option.district_id,
      domProps: {
        "value": option.district_id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.district_name) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Offence")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sanction_outcome),
      expression: "sanction_outcome"
    }]
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.current_offence),
      expression: "sanction_outcome.current_offence"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.offenceReadonly
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sanction_outcome, "current_offence", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.currentOffenceChanged()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.options_for_offences), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                                            " + _vm._s(option.lodgement_number + ': ' + option.identifier) + "\n                                        ")])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Offender")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.sanction_outcome && _vm.sanction_outcome.current_offence && _vm.sanction_outcome.current_offence.offenders) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.current_offender),
      expression: "sanction_outcome.current_offender"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sanction_outcome, "current_offender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.currentOffenderChanged()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.sanction_outcome.current_offence.offenders), function(offender) {
    return _c('option', {
      key: offender.id,
      domProps: {
        "value": offender
      }
    }, [(offender.person) ? _c('span', [_vm._v("\n                                                " + _vm._s(offender.person.first_name + ' ' + offender.person.last_name + ', DOB:' + offender.person.dob) + "\n                                            ")]) : (offender.organisation) ? _c('span', [_vm._v("\n                                                " + _vm._s(offender.organisation.name + ', ABN: ' + offender.organisation.abn) + "\n                                            ")]) : _vm._e()])
  })], 2)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Vehicle Registration Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.registration_number),
      expression: "sanction_outcome.registration_number"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.is_parking_offence,
      "type": "text",
      "name": "registration_number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.sanction_outcome.registration_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "registration_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Alleged committed offences")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "tbl_alleged_offence",
    attrs: {
      "id": "tbl_alleged_offence",
      "dtOptions": _vm.dtOptionsAllegedOffence,
      "dtHeaders": _vm.dtHeadersAllegedOffence
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Issued on paper?")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.issued_on_paper),
      expression: "sanction_outcome.issued_on_paper"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "id": "issued_on_paper_yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.sanction_outcome.issued_on_paper, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.sanction_outcome, "issued_on_paper", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "issued_on_paper_yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.issued_on_paper),
      expression: "sanction_outcome.issued_on_paper"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "id": "issued_on_paper_no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.sanction_outcome.issued_on_paper, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.sanction_outcome, "issued_on_paper", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "issued_on_paper_no"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Paper ID")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.paper_id),
      expression: "sanction_outcome.paper_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "paper_id",
      "placeholder": "",
      "disabled": !_vm.sanction_outcome.issued_on_paper
    },
    domProps: {
      "value": (_vm.sanction_outcome.paper_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "paper_id", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Paper notice")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "paper_id_notice"
    }
  }, [(_vm.sanction_outcome.issued_on_paper) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_c('filefield', {
    ref: "sanction_outcome_file",
    attrs: {
      "name": "sanction-outcome-file",
      "documentActionUrl": "temporary_document",
      "isRepeatable": true,
      "disabled": !_vm.sanction_outcome.issued_on_paper
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryDocumentCollectionId
    }
  })], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.aTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Action")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_remediation_action.action),
      expression: "current_remediation_action.action"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add description",
      "id": "sanction-outcome-description"
    },
    domProps: {
      "value": (_vm.current_remediation_action.action)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_remediation_action, "action", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Due Date")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "dueDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": _vm.current_remediation_action.due_date
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": !_vm.enableAddActionButton,
      "type": "button",
      "value": "Add"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addRemediationActionClicked()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Remediation Actions")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "tbl_remediation_actions",
    attrs: {
      "id": "tbl_remediation_actions",
      "dtOptions": _vm.dtOptionsRemediationActions,
      "dtHeaders": _vm.dtHeadersRemediationActions
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.dTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.description),
      expression: "sanction_outcome.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add description",
      "id": "sanction-outcome-description"
    },
    domProps: {
      "value": (_vm.sanction_outcome.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Date of Issue")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "dateOfIssuePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.date_of_issue),
      expression: "sanction_outcome.date_of_issue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY",
      "disabled": !_vm.sanction_outcome.issued_on_paper
    },
    domProps: {
      "value": (_vm.sanction_outcome.date_of_issue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "date_of_issue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Time of Issue")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "timeOfIssuePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.time_of_issue),
      expression: "sanction_outcome.time_of_issue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "HH:MM",
      "disabled": !_vm.sanction_outcome.issued_on_paper
    },
    domProps: {
      "value": (_vm.sanction_outcome.time_of_issue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "time_of_issue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorResponse)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processingDetails) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : _c('span', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.displaySendToManagerButton
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Send to Manager")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "internal-application-amend"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Amendment Request",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "amendForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Request Amendment for the application")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Select licensed activities to amend")]), _vm._v(" "), _vm._l((_vm.amendableActivities), function(activity) {
    return _c('div', [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.amendment.activity_list),
        expression: "amendment.activity_list"
      }],
      attrs: {
        "type": "checkbox",
        "name": activity.name,
        "id": activity.id
      },
      domProps: {
        "value": activity.id,
        "checked": Array.isArray(_vm.amendment.activity_list) ? _vm._i(_vm.amendment.activity_list, activity.id) > -1 : (_vm.amendment.activity_list)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.amendment.activity_list,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = activity.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.amendment, "activity_list", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.amendment, "activity_list", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.amendment, "activity_list", $$c)
          }
        }
      }
    }), _vm._v(_vm._s(activity.name) + "\n                                        ")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Reason")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amendment.reason),
      expression: "amendment.reason"
    }],
    ref: "reason",
    staticClass: "form-control",
    attrs: {
      "name": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.amendment, "reason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.reason_choices), function(item) {
    return _c('option', {
      domProps: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Additional Comments to User")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amendment.text),
      expression: "amendment.text"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name"
    },
    domProps: {
      "value": (_vm.amendment.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.amendment, "text", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.amendment.text))])])])])])], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.application) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("New Application for\n                        "), (_vm.selected_apply_org_id) ? _c('span', [_vm._v(_vm._s(_vm.selected_apply_org_id_details.name) + " (" + _vm._s(_vm.selected_apply_org_id_details.abn) + ")")]) : _vm._e(), _vm._v(" "), (_vm.selected_apply_proxy_id) ? _c('span', [_vm._v(_vm._s(_vm.selected_apply_proxy_id_details.first_name) + " " + _vm._s(_vm.selected_apply_proxy_id_details.last_name) + " (" + _vm._s(_vm.selected_apply_proxy_id_details.email) + ")")]) : _vm._e(), _vm._v(" "), (!_vm.selected_apply_org_id && !_vm.selected_apply_proxy_id) ? _c('span', [_vm._v("yourself")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "orgForm",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licence_select),
      expression: "licence_select"
    }],
    attrs: {
      "type": "radio",
      "name": "select_licence",
      "value": "new_licence"
    },
    domProps: {
      "checked": _vm._q(_vm.licence_select, "new_licence")
    },
    on: {
      "change": function($event) {
        _vm.licence_select = "new_licence"
      }
    }
  }), _vm._v(" apply for a new licence?\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licence_select),
      expression: "licence_select"
    }],
    attrs: {
      "type": "radio",
      "name": "select_licence",
      "value": "new_activity"
    },
    domProps: {
      "checked": _vm._q(_vm.licence_select, "new_activity")
    },
    on: {
      "change": function($event) {
        _vm.licence_select = "new_activity"
      }
    }
  }), _vm._v(" apply for a new licensed activity or new licensed purpose on your existing licence?\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Continue")])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4"
  }, [_vm._v("Do you want to:")])])
}]}

/***/ }),
/* 1068 */,
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(622);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(68)("26ff9f28", content, true);

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(68)("6799dfb9", content, true);

/***/ }),
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = (function (element, listener) {
	var expand = document.createElement('_');
	var shrink = expand.appendChild(document.createElement('_'));
	var expandChild = expand.appendChild(document.createElement('_'));
	var shrinkChild = shrink.appendChild(document.createElement('_'));

	var lastWidth = void 0,
	    lastHeight = void 0;

	shrink.style.cssText = expand.style.cssText = 'height:100%;left:0;opacity:0;overflow:hidden;pointer-events:none;position:absolute;top:0;transition:0s;width:100%;z-index:-1';
	shrinkChild.style.cssText = expandChild.style.cssText = 'display:block;height:100%;transition:0s;width:100%';
	shrinkChild.style.width = shrinkChild.style.height = '200%';

	element.appendChild(expand);

	test();

	return stop;

	function test() {
		unbind();

		var width = element.offsetWidth;
		var height = element.offsetHeight;

		if (width !== lastWidth || height !== lastHeight) {
			lastWidth = width;
			lastHeight = height;

			expandChild.style.width = width * 2 + 'px';
			expandChild.style.height = height * 2 + 'px';

			expand.scrollLeft = expand.scrollWidth;
			expand.scrollTop = expand.scrollHeight;
			shrink.scrollLeft = shrink.scrollWidth;
			shrink.scrollTop = shrink.scrollHeight;

			listener({ width: width, height: height });
		}

		shrink.addEventListener('scroll', test);
		expand.addEventListener('scroll', test);
	}

	function unbind() {
		shrink.removeEventListener('scroll', test);
		expand.removeEventListener('scroll', test);
	}

	function stop() {
		unbind();

		element.removeChild(expand);
	}
});

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 1097 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[537]);


// WEBPACK FOOTER //
// wildlifecompliance_vue/js/app.js